/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date (isoformat) */
  Date: any;
  /** Date with time (isoformat) */
  DateTime: any;
  /** Raw JSON value */
  Json: any;
  /** The Long scalar type represents non-fractional signed whole numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** Slate-compatible RichText AST */
  RichTextAST: any;
  accounttype: any;
  bigint: any;
  bytea: any;
  contractchangerequest: any;
  date: any;
  ehrtype: any;
  emailcontacttype: any;
  emailenvelopetype: any;
  emaileventtype: any;
  emailpointertype: any;
  experiencelevel: any;
  favoritetype: any;
  fieldtype: any;
  float8: any;
  geography: any;
  geometry: any;
  interval: any;
  jsonb: any;
  moderationstatus: any;
  ownershipstructure: any;
  paymentrateperiod: any;
  placeboundaryprecision: any;
  placeboundarytype: any;
  platform: any;
  profession: any;
  professionaldegree: any;
  reviewreporttype: any;
  role: any;
  strokecertlevel: any;
  timestamp: any;
  trainingsurveystatus: any;
  trainingtype: any;
  tsvector: any;
  uuid: any;
  workerclassification: any;
  workschedule: any;
  workterm: any;
};

/** columns and relationships of "AS20DEM" */
export type As20Dem = {
  __typename?: 'AS20DEM';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDPY: Maybe<Scalars['String']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['Int']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNDOTH: Maybe<Scalars['String']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINNP: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IINSPT: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPNP: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MEDNP: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCNP: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP1P: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPNG: Maybe<Scalars['float8']>;
  MSSPT1: Maybe<Scalars['float8']>;
  MSSPT2: Maybe<Scalars['float8']>;
  MSSPT3: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGNP: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  OTHINP: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  PHYGP: Maybe<Scalars['String']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGPNP: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPLAN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
  /** An object relationship */
  svc1: Maybe<As20Svc1>;
  /** An object relationship */
  svc2: Maybe<As20Svc2>;
  /** An object relationship */
  svc3: Maybe<As20Svc3>;
  /** An object relationship */
  util1: Maybe<As20Util1>;
  /** An object relationship */
  util2: Maybe<As20Util2>;
};

/** aggregated selection of "AS20DEM" */
export type As20Dem_Aggregate = {
  __typename?: 'AS20DEM_aggregate';
  aggregate: Maybe<As20Dem_Aggregate_Fields>;
  nodes: Array<As20Dem>;
};

/** aggregate fields of "AS20DEM" */
export type As20Dem_Aggregate_Fields = {
  __typename?: 'AS20DEM_aggregate_fields';
  avg: Maybe<As20Dem_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As20Dem_Max_Fields>;
  min: Maybe<As20Dem_Min_Fields>;
  stddev: Maybe<As20Dem_Stddev_Fields>;
  stddev_pop: Maybe<As20Dem_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As20Dem_Stddev_Samp_Fields>;
  sum: Maybe<As20Dem_Sum_Fields>;
  var_pop: Maybe<As20Dem_Var_Pop_Fields>;
  var_samp: Maybe<As20Dem_Var_Samp_Fields>;
  variance: Maybe<As20Dem_Variance_Fields>;
};


/** aggregate fields of "AS20DEM" */
export type As20Dem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As20Dem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As20Dem_Avg_Fields = {
  __typename?: 'AS20DEM_avg_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS20DEM". All fields are combined with a logical 'AND'. */
export type As20Dem_Bool_Exp = {
  ACOCN?: InputMaybe<Float8_Comparison_Exp>;
  ACOORG?: InputMaybe<String_Comparison_Exp>;
  ACOPCT?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPAD?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPCI?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPMD?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPT?: InputMaybe<Float8_Comparison_Exp>;
  AHAMBR?: InputMaybe<String_Comparison_Exp>;
  AREA?: InputMaybe<String_Comparison_Exp>;
  BDPY?: InputMaybe<String_Comparison_Exp>;
  BNDPAY?: InputMaybe<String_Comparison_Exp>;
  BNDPCT?: InputMaybe<Float8_Comparison_Exp>;
  BNDRSK?: InputMaybe<String_Comparison_Exp>;
  BSC?: InputMaybe<String_Comparison_Exp>;
  CAPCON94?: InputMaybe<String_Comparison_Exp>;
  CAPRSK?: InputMaybe<Float8_Comparison_Exp>;
  CBSACODE?: InputMaybe<String_Comparison_Exp>;
  CBSANAME?: InputMaybe<String_Comparison_Exp>;
  CBSATYPE?: InputMaybe<String_Comparison_Exp>;
  CHC?: InputMaybe<String_Comparison_Exp>;
  CITYRK?: InputMaybe<String_Comparison_Exp>;
  CLUSTER?: InputMaybe<Int_Comparison_Exp>;
  CMRPAY?: InputMaybe<String_Comparison_Exp>;
  CNDOTH?: InputMaybe<String_Comparison_Exp>;
  CNDTYPCV?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPGI?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPHM?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPID?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPNG?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPON?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPOR?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPOS?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPPM?: InputMaybe<Float8_Comparison_Exp>;
  CNTRL?: InputMaybe<String_Comparison_Exp>;
  CNTYNAME?: InputMaybe<String_Comparison_Exp>;
  COHSP?: InputMaybe<String_Comparison_Exp>;
  COLLCLI?: InputMaybe<String_Comparison_Exp>;
  COLLCNA?: InputMaybe<String_Comparison_Exp>;
  COLLNI?: InputMaybe<String_Comparison_Exp>;
  COLLPSN?: InputMaybe<String_Comparison_Exp>;
  COMMTY?: InputMaybe<String_Comparison_Exp>;
  COTYCAN?: InputMaybe<Float8_Comparison_Exp>;
  COTYCAR?: InputMaybe<Float8_Comparison_Exp>;
  COTYDESC?: InputMaybe<String_Comparison_Exp>;
  COTYORT?: InputMaybe<Float8_Comparison_Exp>;
  COTYOTH?: InputMaybe<Float8_Comparison_Exp>;
  COTYPED?: InputMaybe<Float8_Comparison_Exp>;
  COTYPSY?: InputMaybe<Float8_Comparison_Exp>;
  COTYSUR?: InputMaybe<Float8_Comparison_Exp>;
  CPPCT?: InputMaybe<Float8_Comparison_Exp>;
  CSACODE?: InputMaybe<String_Comparison_Exp>;
  CSANAME?: InputMaybe<String_Comparison_Exp>;
  DCOV?: InputMaybe<Float8_Comparison_Exp>;
  DIVCODE?: InputMaybe<String_Comparison_Exp>;
  DIVNAME?: InputMaybe<String_Comparison_Exp>;
  DTBEG?: InputMaybe<Timestamp_Comparison_Exp>;
  DTEND?: InputMaybe<Timestamp_Comparison_Exp>;
  FAMADV?: InputMaybe<String_Comparison_Exp>;
  FBORCLI?: InputMaybe<String_Comparison_Exp>;
  FBORCNA?: InputMaybe<String_Comparison_Exp>;
  FBORNI?: InputMaybe<String_Comparison_Exp>;
  FBORPSN?: InputMaybe<String_Comparison_Exp>;
  FCNTYCD?: InputMaybe<String_Comparison_Exp>;
  FCOUNTY?: InputMaybe<String_Comparison_Exp>;
  FISYR?: InputMaybe<Timestamp_Comparison_Exp>;
  FNDBN?: InputMaybe<String_Comparison_Exp>;
  FSTCD?: InputMaybe<String_Comparison_Exp>;
  FYR?: InputMaybe<String_Comparison_Exp>;
  GPOCITY?: InputMaybe<String_Comparison_Exp>;
  GPONAME?: InputMaybe<String_Comparison_Exp>;
  GPOST?: InputMaybe<String_Comparison_Exp>;
  GROUP?: InputMaybe<String_Comparison_Exp>;
  HCOCCLI?: InputMaybe<String_Comparison_Exp>;
  HCOCCNA?: InputMaybe<String_Comparison_Exp>;
  HCOCNI?: InputMaybe<String_Comparison_Exp>;
  HCOCPSN?: InputMaybe<String_Comparison_Exp>;
  HHPLAN?: InputMaybe<String_Comparison_Exp>;
  HICOCCLI?: InputMaybe<String_Comparison_Exp>;
  HICOCCNA?: InputMaybe<String_Comparison_Exp>;
  HICOCNI?: InputMaybe<String_Comparison_Exp>;
  HICOCPSN?: InputMaybe<String_Comparison_Exp>;
  HLINDK?: InputMaybe<String_Comparison_Exp>;
  HLINHOS?: InputMaybe<String_Comparison_Exp>;
  HLINN?: InputMaybe<String_Comparison_Exp>;
  HLINNP?: InputMaybe<String_Comparison_Exp>;
  HLINSYS?: InputMaybe<String_Comparison_Exp>;
  HLINVEN?: InputMaybe<String_Comparison_Exp>;
  HRRCODE?: InputMaybe<Int_Comparison_Exp>;
  HRRNAME?: InputMaybe<String_Comparison_Exp>;
  HSACODE?: InputMaybe<Int_Comparison_Exp>;
  HSANAME?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IINSPT?: InputMaybe<String_Comparison_Exp>;
  KSCHCLI?: InputMaybe<String_Comparison_Exp>;
  KSCHCNA?: InputMaybe<String_Comparison_Exp>;
  KSCHNI?: InputMaybe<String_Comparison_Exp>;
  KSCHPSN?: InputMaybe<String_Comparison_Exp>;
  LAT?: InputMaybe<String_Comparison_Exp>;
  LGRPDK?: InputMaybe<String_Comparison_Exp>;
  LGRPHOS?: InputMaybe<String_Comparison_Exp>;
  LGRPN?: InputMaybe<String_Comparison_Exp>;
  LGRPNP?: InputMaybe<String_Comparison_Exp>;
  LGRPSYS?: InputMaybe<String_Comparison_Exp>;
  LGRPVEN?: InputMaybe<String_Comparison_Exp>;
  LOCFCLI?: InputMaybe<String_Comparison_Exp>;
  LOCFCNA?: InputMaybe<String_Comparison_Exp>;
  LOCFNI?: InputMaybe<String_Comparison_Exp>;
  LOCFPSN?: InputMaybe<String_Comparison_Exp>;
  LOCHSCLI?: InputMaybe<String_Comparison_Exp>;
  LOCHSCNA?: InputMaybe<String_Comparison_Exp>;
  LOCHSNI?: InputMaybe<String_Comparison_Exp>;
  LOCHSPSN?: InputMaybe<String_Comparison_Exp>;
  LOCLGCLI?: InputMaybe<String_Comparison_Exp>;
  LOCLGCNA?: InputMaybe<String_Comparison_Exp>;
  LOCLGNI?: InputMaybe<String_Comparison_Exp>;
  LOCLGPSN?: InputMaybe<String_Comparison_Exp>;
  LOCOCCLI?: InputMaybe<String_Comparison_Exp>;
  LOCOCCNA?: InputMaybe<String_Comparison_Exp>;
  LOCOCNI?: InputMaybe<String_Comparison_Exp>;
  LOCOCPSN?: InputMaybe<String_Comparison_Exp>;
  LOCTRCLI?: InputMaybe<String_Comparison_Exp>;
  LOCTRCNA?: InputMaybe<String_Comparison_Exp>;
  LOCTRNI?: InputMaybe<String_Comparison_Exp>;
  LOCTRPSN?: InputMaybe<String_Comparison_Exp>;
  LONG?: InputMaybe<String_Comparison_Exp>;
  LORGCLI?: InputMaybe<String_Comparison_Exp>;
  LORGCNA?: InputMaybe<String_Comparison_Exp>;
  LORGNI?: InputMaybe<String_Comparison_Exp>;
  LORGPSN?: InputMaybe<String_Comparison_Exp>;
  LOS?: InputMaybe<String_Comparison_Exp>;
  LTCHC?: InputMaybe<String_Comparison_Exp>;
  LTCHF?: InputMaybe<String_Comparison_Exp>;
  LTCT?: InputMaybe<String_Comparison_Exp>;
  LTNM?: InputMaybe<String_Comparison_Exp>;
  LTST?: InputMaybe<String_Comparison_Exp>;
  MADMIN?: InputMaybe<String_Comparison_Exp>;
  MAPP1?: InputMaybe<String_Comparison_Exp>;
  MAPP2?: InputMaybe<String_Comparison_Exp>;
  MAPP3?: InputMaybe<String_Comparison_Exp>;
  MAPP5?: InputMaybe<String_Comparison_Exp>;
  MAPP7?: InputMaybe<String_Comparison_Exp>;
  MAPP8?: InputMaybe<String_Comparison_Exp>;
  MAPP10?: InputMaybe<String_Comparison_Exp>;
  MAPP11?: InputMaybe<String_Comparison_Exp>;
  MAPP16?: InputMaybe<String_Comparison_Exp>;
  MAPP18?: InputMaybe<String_Comparison_Exp>;
  MAPP19?: InputMaybe<String_Comparison_Exp>;
  MAPP20?: InputMaybe<String_Comparison_Exp>;
  MAPP21?: InputMaybe<String_Comparison_Exp>;
  MAPP22?: InputMaybe<String_Comparison_Exp>;
  MCNTYCD?: InputMaybe<String_Comparison_Exp>;
  MCRNUM?: InputMaybe<String_Comparison_Exp>;
  MEDADDK?: InputMaybe<String_Comparison_Exp>;
  MEDADHOS?: InputMaybe<String_Comparison_Exp>;
  MEDADN?: InputMaybe<String_Comparison_Exp>;
  MEDADSYS?: InputMaybe<String_Comparison_Exp>;
  MEDADVEN?: InputMaybe<String_Comparison_Exp>;
  MEDHME?: InputMaybe<String_Comparison_Exp>;
  MEDHSE?: InputMaybe<String_Comparison_Exp>;
  MEDNP?: InputMaybe<String_Comparison_Exp>;
  MHSMEMB?: InputMaybe<String_Comparison_Exp>;
  MLOCADDR?: InputMaybe<String_Comparison_Exp>;
  MLOCCITY?: InputMaybe<String_Comparison_Exp>;
  MLOCSTCD?: InputMaybe<String_Comparison_Exp>;
  MLOCZIP?: InputMaybe<String_Comparison_Exp>;
  MMCDK?: InputMaybe<String_Comparison_Exp>;
  MMCHOS?: InputMaybe<String_Comparison_Exp>;
  MMCN?: InputMaybe<String_Comparison_Exp>;
  MMCNP?: InputMaybe<String_Comparison_Exp>;
  MMCSYS?: InputMaybe<String_Comparison_Exp>;
  MMCVEN?: InputMaybe<String_Comparison_Exp>;
  MNAME?: InputMaybe<String_Comparison_Exp>;
  MNGT?: InputMaybe<String_Comparison_Exp>;
  MNGTCITY?: InputMaybe<String_Comparison_Exp>;
  MNGTNAME?: InputMaybe<String_Comparison_Exp>;
  MNGTSTCD?: InputMaybe<String_Comparison_Exp>;
  MSSP1P?: InputMaybe<Float8_Comparison_Exp>;
  MSSPCE?: InputMaybe<Float8_Comparison_Exp>;
  MSSPNG?: InputMaybe<Float8_Comparison_Exp>;
  MSSPT1?: InputMaybe<Float8_Comparison_Exp>;
  MSSPT2?: InputMaybe<Float8_Comparison_Exp>;
  MSSPT3?: InputMaybe<Float8_Comparison_Exp>;
  MSTATE?: InputMaybe<String_Comparison_Exp>;
  OSMGDK?: InputMaybe<String_Comparison_Exp>;
  OSMGHOS?: InputMaybe<String_Comparison_Exp>;
  OSMGN?: InputMaybe<String_Comparison_Exp>;
  OSMGNP?: InputMaybe<String_Comparison_Exp>;
  OSMGOTH?: InputMaybe<String_Comparison_Exp>;
  OSMGSYS?: InputMaybe<String_Comparison_Exp>;
  OSMGVEN?: InputMaybe<String_Comparison_Exp>;
  OTCOMCLI?: InputMaybe<String_Comparison_Exp>;
  OTCOMCNA?: InputMaybe<String_Comparison_Exp>;
  OTCOMNI?: InputMaybe<String_Comparison_Exp>;
  OTCOMPSN?: InputMaybe<String_Comparison_Exp>;
  OTHIMDK?: InputMaybe<String_Comparison_Exp>;
  OTHIMHOS?: InputMaybe<String_Comparison_Exp>;
  OTHIMN?: InputMaybe<String_Comparison_Exp>;
  OTHIMSYS?: InputMaybe<String_Comparison_Exp>;
  OTHIMVEN?: InputMaybe<String_Comparison_Exp>;
  OTHINP?: InputMaybe<String_Comparison_Exp>;
  OTLSCLI?: InputMaybe<String_Comparison_Exp>;
  OTLSCNA?: InputMaybe<String_Comparison_Exp>;
  OTLSNI?: InputMaybe<String_Comparison_Exp>;
  OTLSPSN?: InputMaybe<String_Comparison_Exp>;
  PAYTYAD?: InputMaybe<Float8_Comparison_Exp>;
  PAYTYPCI?: InputMaybe<Float8_Comparison_Exp>;
  PAYTYPMD?: InputMaybe<Float8_Comparison_Exp>;
  PAYTYPTM?: InputMaybe<Float8_Comparison_Exp>;
  PHYGP?: InputMaybe<String_Comparison_Exp>;
  PLCECLI?: InputMaybe<String_Comparison_Exp>;
  PLCECNA?: InputMaybe<String_Comparison_Exp>;
  PLCENI?: InputMaybe<String_Comparison_Exp>;
  PLCEPSN?: InputMaybe<String_Comparison_Exp>;
  RADMCHI?: InputMaybe<String_Comparison_Exp>;
  RESP?: InputMaybe<String_Comparison_Exp>;
  SERV?: InputMaybe<String_Comparison_Exp>;
  SERVOTH?: InputMaybe<String_Comparison_Exp>;
  SLFPLN?: InputMaybe<String_Comparison_Exp>;
  SMGPDK?: InputMaybe<String_Comparison_Exp>;
  SMGPNP?: InputMaybe<String_Comparison_Exp>;
  SMGRPHOS?: InputMaybe<String_Comparison_Exp>;
  SMGRPN?: InputMaybe<String_Comparison_Exp>;
  SMGRPSYS?: InputMaybe<String_Comparison_Exp>;
  SMGRPVEN?: InputMaybe<String_Comparison_Exp>;
  SPLAN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUBS?: InputMaybe<String_Comparison_Exp>;
  SUNITS?: InputMaybe<String_Comparison_Exp>;
  SUPLY?: InputMaybe<String_Comparison_Exp>;
  SUPNM?: InputMaybe<String_Comparison_Exp>;
  SYSADDR?: InputMaybe<String_Comparison_Exp>;
  SYSAREA?: InputMaybe<String_Comparison_Exp>;
  SYSCITY?: InputMaybe<String_Comparison_Exp>;
  SYSID?: InputMaybe<String_Comparison_Exp>;
  SYSNAME?: InputMaybe<String_Comparison_Exp>;
  SYSST?: InputMaybe<String_Comparison_Exp>;
  SYSTELN?: InputMaybe<String_Comparison_Exp>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<String_Comparison_Exp>;
  SYSTITLE?: InputMaybe<String_Comparison_Exp>;
  SYSZIP?: InputMaybe<String_Comparison_Exp>;
  TELNO?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As20Dem_Bool_Exp>>;
  _not?: InputMaybe<As20Dem_Bool_Exp>;
  _or?: InputMaybe<Array<As20Dem_Bool_Exp>>;
  svc1?: InputMaybe<As20Svc1_Bool_Exp>;
  svc2?: InputMaybe<As20Svc2_Bool_Exp>;
  svc3?: InputMaybe<As20Svc3_Bool_Exp>;
  util1?: InputMaybe<As20Util1_Bool_Exp>;
  util2?: InputMaybe<As20Util2_Bool_Exp>;
};

/** unique or primary key constraints on table "AS20DEM" */
export enum As20Dem_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs20Dem = 'pk_AS20DEM'
}

/** input type for incrementing numeric columns in table "AS20DEM" */
export type As20Dem_Inc_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CLUSTER?: InputMaybe<Scalars['Int']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  MSSP1P?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPNG?: InputMaybe<Scalars['float8']>;
  MSSPT1?: InputMaybe<Scalars['float8']>;
  MSSPT2?: InputMaybe<Scalars['float8']>;
  MSSPT3?: InputMaybe<Scalars['float8']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS20DEM" */
export type As20Dem_Insert_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDPY?: InputMaybe<Scalars['String']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['Int']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNDOTH?: InputMaybe<Scalars['String']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINNP?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPNP?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MEDNP?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCNP?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP1P?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPNG?: InputMaybe<Scalars['float8']>;
  MSSPT1?: InputMaybe<Scalars['float8']>;
  MSSPT2?: InputMaybe<Scalars['float8']>;
  MSSPT3?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGNP?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  OTHINP?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGPNP?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
  svc1?: InputMaybe<As20Svc1_Obj_Rel_Insert_Input>;
  svc2?: InputMaybe<As20Svc2_Obj_Rel_Insert_Input>;
  svc3?: InputMaybe<As20Svc3_Obj_Rel_Insert_Input>;
  util1?: InputMaybe<As20Util1_Obj_Rel_Insert_Input>;
  util2?: InputMaybe<As20Util2_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type As20Dem_Max_Fields = {
  __typename?: 'AS20DEM_max_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDPY: Maybe<Scalars['String']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['Int']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNDOTH: Maybe<Scalars['String']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINNP: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IINSPT: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPNP: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MEDNP: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCNP: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP1P: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPNG: Maybe<Scalars['float8']>;
  MSSPT1: Maybe<Scalars['float8']>;
  MSSPT2: Maybe<Scalars['float8']>;
  MSSPT3: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGNP: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  OTHINP: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  PHYGP: Maybe<Scalars['String']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGPNP: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPLAN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As20Dem_Min_Fields = {
  __typename?: 'AS20DEM_min_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDPY: Maybe<Scalars['String']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['Int']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNDOTH: Maybe<Scalars['String']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINNP: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IINSPT: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPNP: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MEDNP: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCNP: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP1P: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPNG: Maybe<Scalars['float8']>;
  MSSPT1: Maybe<Scalars['float8']>;
  MSSPT2: Maybe<Scalars['float8']>;
  MSSPT3: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGNP: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  OTHINP: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  PHYGP: Maybe<Scalars['String']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGPNP: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPLAN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS20DEM" */
export type As20Dem_Mutation_Response = {
  __typename?: 'AS20DEM_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As20Dem>;
};

/** input type for inserting object relation for remote table "AS20DEM" */
export type As20Dem_Obj_Rel_Insert_Input = {
  data: As20Dem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As20Dem_On_Conflict>;
};

/** on_conflict condition type for table "AS20DEM" */
export type As20Dem_On_Conflict = {
  constraint: As20Dem_Constraint;
  update_columns?: Array<As20Dem_Update_Column>;
  where?: InputMaybe<As20Dem_Bool_Exp>;
};

/** Ordering options when selecting data from "AS20DEM". */
export type As20Dem_Order_By = {
  ACOCN?: InputMaybe<Order_By>;
  ACOORG?: InputMaybe<Order_By>;
  ACOPCT?: InputMaybe<Order_By>;
  ACOTYPAD?: InputMaybe<Order_By>;
  ACOTYPCI?: InputMaybe<Order_By>;
  ACOTYPMD?: InputMaybe<Order_By>;
  ACOTYPT?: InputMaybe<Order_By>;
  AHAMBR?: InputMaybe<Order_By>;
  AREA?: InputMaybe<Order_By>;
  BDPY?: InputMaybe<Order_By>;
  BNDPAY?: InputMaybe<Order_By>;
  BNDPCT?: InputMaybe<Order_By>;
  BNDRSK?: InputMaybe<Order_By>;
  BSC?: InputMaybe<Order_By>;
  CAPCON94?: InputMaybe<Order_By>;
  CAPRSK?: InputMaybe<Order_By>;
  CBSACODE?: InputMaybe<Order_By>;
  CBSANAME?: InputMaybe<Order_By>;
  CBSATYPE?: InputMaybe<Order_By>;
  CHC?: InputMaybe<Order_By>;
  CITYRK?: InputMaybe<Order_By>;
  CLUSTER?: InputMaybe<Order_By>;
  CMRPAY?: InputMaybe<Order_By>;
  CNDOTH?: InputMaybe<Order_By>;
  CNDTYPCV?: InputMaybe<Order_By>;
  CNDTYPGI?: InputMaybe<Order_By>;
  CNDTYPHM?: InputMaybe<Order_By>;
  CNDTYPID?: InputMaybe<Order_By>;
  CNDTYPNG?: InputMaybe<Order_By>;
  CNDTYPON?: InputMaybe<Order_By>;
  CNDTYPOR?: InputMaybe<Order_By>;
  CNDTYPOS?: InputMaybe<Order_By>;
  CNDTYPPM?: InputMaybe<Order_By>;
  CNTRL?: InputMaybe<Order_By>;
  CNTYNAME?: InputMaybe<Order_By>;
  COHSP?: InputMaybe<Order_By>;
  COLLCLI?: InputMaybe<Order_By>;
  COLLCNA?: InputMaybe<Order_By>;
  COLLNI?: InputMaybe<Order_By>;
  COLLPSN?: InputMaybe<Order_By>;
  COMMTY?: InputMaybe<Order_By>;
  COTYCAN?: InputMaybe<Order_By>;
  COTYCAR?: InputMaybe<Order_By>;
  COTYDESC?: InputMaybe<Order_By>;
  COTYORT?: InputMaybe<Order_By>;
  COTYOTH?: InputMaybe<Order_By>;
  COTYPED?: InputMaybe<Order_By>;
  COTYPSY?: InputMaybe<Order_By>;
  COTYSUR?: InputMaybe<Order_By>;
  CPPCT?: InputMaybe<Order_By>;
  CSACODE?: InputMaybe<Order_By>;
  CSANAME?: InputMaybe<Order_By>;
  DCOV?: InputMaybe<Order_By>;
  DIVCODE?: InputMaybe<Order_By>;
  DIVNAME?: InputMaybe<Order_By>;
  DTBEG?: InputMaybe<Order_By>;
  DTEND?: InputMaybe<Order_By>;
  FAMADV?: InputMaybe<Order_By>;
  FBORCLI?: InputMaybe<Order_By>;
  FBORCNA?: InputMaybe<Order_By>;
  FBORNI?: InputMaybe<Order_By>;
  FBORPSN?: InputMaybe<Order_By>;
  FCNTYCD?: InputMaybe<Order_By>;
  FCOUNTY?: InputMaybe<Order_By>;
  FISYR?: InputMaybe<Order_By>;
  FNDBN?: InputMaybe<Order_By>;
  FSTCD?: InputMaybe<Order_By>;
  FYR?: InputMaybe<Order_By>;
  GPOCITY?: InputMaybe<Order_By>;
  GPONAME?: InputMaybe<Order_By>;
  GPOST?: InputMaybe<Order_By>;
  GROUP?: InputMaybe<Order_By>;
  HCOCCLI?: InputMaybe<Order_By>;
  HCOCCNA?: InputMaybe<Order_By>;
  HCOCNI?: InputMaybe<Order_By>;
  HCOCPSN?: InputMaybe<Order_By>;
  HHPLAN?: InputMaybe<Order_By>;
  HICOCCLI?: InputMaybe<Order_By>;
  HICOCCNA?: InputMaybe<Order_By>;
  HICOCNI?: InputMaybe<Order_By>;
  HICOCPSN?: InputMaybe<Order_By>;
  HLINDK?: InputMaybe<Order_By>;
  HLINHOS?: InputMaybe<Order_By>;
  HLINN?: InputMaybe<Order_By>;
  HLINNP?: InputMaybe<Order_By>;
  HLINSYS?: InputMaybe<Order_By>;
  HLINVEN?: InputMaybe<Order_By>;
  HRRCODE?: InputMaybe<Order_By>;
  HRRNAME?: InputMaybe<Order_By>;
  HSACODE?: InputMaybe<Order_By>;
  HSANAME?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IINSPT?: InputMaybe<Order_By>;
  KSCHCLI?: InputMaybe<Order_By>;
  KSCHCNA?: InputMaybe<Order_By>;
  KSCHNI?: InputMaybe<Order_By>;
  KSCHPSN?: InputMaybe<Order_By>;
  LAT?: InputMaybe<Order_By>;
  LGRPDK?: InputMaybe<Order_By>;
  LGRPHOS?: InputMaybe<Order_By>;
  LGRPN?: InputMaybe<Order_By>;
  LGRPNP?: InputMaybe<Order_By>;
  LGRPSYS?: InputMaybe<Order_By>;
  LGRPVEN?: InputMaybe<Order_By>;
  LOCFCLI?: InputMaybe<Order_By>;
  LOCFCNA?: InputMaybe<Order_By>;
  LOCFNI?: InputMaybe<Order_By>;
  LOCFPSN?: InputMaybe<Order_By>;
  LOCHSCLI?: InputMaybe<Order_By>;
  LOCHSCNA?: InputMaybe<Order_By>;
  LOCHSNI?: InputMaybe<Order_By>;
  LOCHSPSN?: InputMaybe<Order_By>;
  LOCLGCLI?: InputMaybe<Order_By>;
  LOCLGCNA?: InputMaybe<Order_By>;
  LOCLGNI?: InputMaybe<Order_By>;
  LOCLGPSN?: InputMaybe<Order_By>;
  LOCOCCLI?: InputMaybe<Order_By>;
  LOCOCCNA?: InputMaybe<Order_By>;
  LOCOCNI?: InputMaybe<Order_By>;
  LOCOCPSN?: InputMaybe<Order_By>;
  LOCTRCLI?: InputMaybe<Order_By>;
  LOCTRCNA?: InputMaybe<Order_By>;
  LOCTRNI?: InputMaybe<Order_By>;
  LOCTRPSN?: InputMaybe<Order_By>;
  LONG?: InputMaybe<Order_By>;
  LORGCLI?: InputMaybe<Order_By>;
  LORGCNA?: InputMaybe<Order_By>;
  LORGNI?: InputMaybe<Order_By>;
  LORGPSN?: InputMaybe<Order_By>;
  LOS?: InputMaybe<Order_By>;
  LTCHC?: InputMaybe<Order_By>;
  LTCHF?: InputMaybe<Order_By>;
  LTCT?: InputMaybe<Order_By>;
  LTNM?: InputMaybe<Order_By>;
  LTST?: InputMaybe<Order_By>;
  MADMIN?: InputMaybe<Order_By>;
  MAPP1?: InputMaybe<Order_By>;
  MAPP2?: InputMaybe<Order_By>;
  MAPP3?: InputMaybe<Order_By>;
  MAPP5?: InputMaybe<Order_By>;
  MAPP7?: InputMaybe<Order_By>;
  MAPP8?: InputMaybe<Order_By>;
  MAPP10?: InputMaybe<Order_By>;
  MAPP11?: InputMaybe<Order_By>;
  MAPP16?: InputMaybe<Order_By>;
  MAPP18?: InputMaybe<Order_By>;
  MAPP19?: InputMaybe<Order_By>;
  MAPP20?: InputMaybe<Order_By>;
  MAPP21?: InputMaybe<Order_By>;
  MAPP22?: InputMaybe<Order_By>;
  MCNTYCD?: InputMaybe<Order_By>;
  MCRNUM?: InputMaybe<Order_By>;
  MEDADDK?: InputMaybe<Order_By>;
  MEDADHOS?: InputMaybe<Order_By>;
  MEDADN?: InputMaybe<Order_By>;
  MEDADSYS?: InputMaybe<Order_By>;
  MEDADVEN?: InputMaybe<Order_By>;
  MEDHME?: InputMaybe<Order_By>;
  MEDHSE?: InputMaybe<Order_By>;
  MEDNP?: InputMaybe<Order_By>;
  MHSMEMB?: InputMaybe<Order_By>;
  MLOCADDR?: InputMaybe<Order_By>;
  MLOCCITY?: InputMaybe<Order_By>;
  MLOCSTCD?: InputMaybe<Order_By>;
  MLOCZIP?: InputMaybe<Order_By>;
  MMCDK?: InputMaybe<Order_By>;
  MMCHOS?: InputMaybe<Order_By>;
  MMCN?: InputMaybe<Order_By>;
  MMCNP?: InputMaybe<Order_By>;
  MMCSYS?: InputMaybe<Order_By>;
  MMCVEN?: InputMaybe<Order_By>;
  MNAME?: InputMaybe<Order_By>;
  MNGT?: InputMaybe<Order_By>;
  MNGTCITY?: InputMaybe<Order_By>;
  MNGTNAME?: InputMaybe<Order_By>;
  MNGTSTCD?: InputMaybe<Order_By>;
  MSSP1P?: InputMaybe<Order_By>;
  MSSPCE?: InputMaybe<Order_By>;
  MSSPNG?: InputMaybe<Order_By>;
  MSSPT1?: InputMaybe<Order_By>;
  MSSPT2?: InputMaybe<Order_By>;
  MSSPT3?: InputMaybe<Order_By>;
  MSTATE?: InputMaybe<Order_By>;
  OSMGDK?: InputMaybe<Order_By>;
  OSMGHOS?: InputMaybe<Order_By>;
  OSMGN?: InputMaybe<Order_By>;
  OSMGNP?: InputMaybe<Order_By>;
  OSMGOTH?: InputMaybe<Order_By>;
  OSMGSYS?: InputMaybe<Order_By>;
  OSMGVEN?: InputMaybe<Order_By>;
  OTCOMCLI?: InputMaybe<Order_By>;
  OTCOMCNA?: InputMaybe<Order_By>;
  OTCOMNI?: InputMaybe<Order_By>;
  OTCOMPSN?: InputMaybe<Order_By>;
  OTHIMDK?: InputMaybe<Order_By>;
  OTHIMHOS?: InputMaybe<Order_By>;
  OTHIMN?: InputMaybe<Order_By>;
  OTHIMSYS?: InputMaybe<Order_By>;
  OTHIMVEN?: InputMaybe<Order_By>;
  OTHINP?: InputMaybe<Order_By>;
  OTLSCLI?: InputMaybe<Order_By>;
  OTLSCNA?: InputMaybe<Order_By>;
  OTLSNI?: InputMaybe<Order_By>;
  OTLSPSN?: InputMaybe<Order_By>;
  PAYTYAD?: InputMaybe<Order_By>;
  PAYTYPCI?: InputMaybe<Order_By>;
  PAYTYPMD?: InputMaybe<Order_By>;
  PAYTYPTM?: InputMaybe<Order_By>;
  PHYGP?: InputMaybe<Order_By>;
  PLCECLI?: InputMaybe<Order_By>;
  PLCECNA?: InputMaybe<Order_By>;
  PLCENI?: InputMaybe<Order_By>;
  PLCEPSN?: InputMaybe<Order_By>;
  RADMCHI?: InputMaybe<Order_By>;
  RESP?: InputMaybe<Order_By>;
  SERV?: InputMaybe<Order_By>;
  SERVOTH?: InputMaybe<Order_By>;
  SLFPLN?: InputMaybe<Order_By>;
  SMGPDK?: InputMaybe<Order_By>;
  SMGPNP?: InputMaybe<Order_By>;
  SMGRPHOS?: InputMaybe<Order_By>;
  SMGRPN?: InputMaybe<Order_By>;
  SMGRPSYS?: InputMaybe<Order_By>;
  SMGRPVEN?: InputMaybe<Order_By>;
  SPLAN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUBS?: InputMaybe<Order_By>;
  SUNITS?: InputMaybe<Order_By>;
  SUPLY?: InputMaybe<Order_By>;
  SUPNM?: InputMaybe<Order_By>;
  SYSADDR?: InputMaybe<Order_By>;
  SYSAREA?: InputMaybe<Order_By>;
  SYSCITY?: InputMaybe<Order_By>;
  SYSID?: InputMaybe<Order_By>;
  SYSNAME?: InputMaybe<Order_By>;
  SYSST?: InputMaybe<Order_By>;
  SYSTELN?: InputMaybe<Order_By>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Order_By>;
  SYSTITLE?: InputMaybe<Order_By>;
  SYSZIP?: InputMaybe<Order_By>;
  TELNO?: InputMaybe<Order_By>;
  svc1?: InputMaybe<As20Svc1_Order_By>;
  svc2?: InputMaybe<As20Svc2_Order_By>;
  svc3?: InputMaybe<As20Svc3_Order_By>;
  util1?: InputMaybe<As20Util1_Order_By>;
  util2?: InputMaybe<As20Util2_Order_By>;
};

/** primary key columns input for table: AS20DEM */
export type As20Dem_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS20DEM" */
export enum As20Dem_Select_Column {
  /** column name */
  Acocn = 'ACOCN',
  /** column name */
  Acoorg = 'ACOORG',
  /** column name */
  Acopct = 'ACOPCT',
  /** column name */
  Acotypad = 'ACOTYPAD',
  /** column name */
  Acotypci = 'ACOTYPCI',
  /** column name */
  Acotypmd = 'ACOTYPMD',
  /** column name */
  Acotypt = 'ACOTYPT',
  /** column name */
  Ahambr = 'AHAMBR',
  /** column name */
  Area = 'AREA',
  /** column name */
  Bdpy = 'BDPY',
  /** column name */
  Bndpay = 'BNDPAY',
  /** column name */
  Bndpct = 'BNDPCT',
  /** column name */
  Bndrsk = 'BNDRSK',
  /** column name */
  Bsc = 'BSC',
  /** column name */
  Capcon94 = 'CAPCON94',
  /** column name */
  Caprsk = 'CAPRSK',
  /** column name */
  Cbsacode = 'CBSACODE',
  /** column name */
  Cbsaname = 'CBSANAME',
  /** column name */
  Cbsatype = 'CBSATYPE',
  /** column name */
  Chc = 'CHC',
  /** column name */
  Cityrk = 'CITYRK',
  /** column name */
  Cluster = 'CLUSTER',
  /** column name */
  Cmrpay = 'CMRPAY',
  /** column name */
  Cndoth = 'CNDOTH',
  /** column name */
  Cndtypcv = 'CNDTYPCV',
  /** column name */
  Cndtypgi = 'CNDTYPGI',
  /** column name */
  Cndtyphm = 'CNDTYPHM',
  /** column name */
  Cndtypid = 'CNDTYPID',
  /** column name */
  Cndtypng = 'CNDTYPNG',
  /** column name */
  Cndtypon = 'CNDTYPON',
  /** column name */
  Cndtypor = 'CNDTYPOR',
  /** column name */
  Cndtypos = 'CNDTYPOS',
  /** column name */
  Cndtyppm = 'CNDTYPPM',
  /** column name */
  Cntrl = 'CNTRL',
  /** column name */
  Cntyname = 'CNTYNAME',
  /** column name */
  Cohsp = 'COHSP',
  /** column name */
  Collcli = 'COLLCLI',
  /** column name */
  Collcna = 'COLLCNA',
  /** column name */
  Collni = 'COLLNI',
  /** column name */
  Collpsn = 'COLLPSN',
  /** column name */
  Commty = 'COMMTY',
  /** column name */
  Cotycan = 'COTYCAN',
  /** column name */
  Cotycar = 'COTYCAR',
  /** column name */
  Cotydesc = 'COTYDESC',
  /** column name */
  Cotyort = 'COTYORT',
  /** column name */
  Cotyoth = 'COTYOTH',
  /** column name */
  Cotyped = 'COTYPED',
  /** column name */
  Cotypsy = 'COTYPSY',
  /** column name */
  Cotysur = 'COTYSUR',
  /** column name */
  Cppct = 'CPPCT',
  /** column name */
  Csacode = 'CSACODE',
  /** column name */
  Csaname = 'CSANAME',
  /** column name */
  Dcov = 'DCOV',
  /** column name */
  Divcode = 'DIVCODE',
  /** column name */
  Divname = 'DIVNAME',
  /** column name */
  Dtbeg = 'DTBEG',
  /** column name */
  Dtend = 'DTEND',
  /** column name */
  Famadv = 'FAMADV',
  /** column name */
  Fborcli = 'FBORCLI',
  /** column name */
  Fborcna = 'FBORCNA',
  /** column name */
  Fborni = 'FBORNI',
  /** column name */
  Fborpsn = 'FBORPSN',
  /** column name */
  Fcntycd = 'FCNTYCD',
  /** column name */
  Fcounty = 'FCOUNTY',
  /** column name */
  Fisyr = 'FISYR',
  /** column name */
  Fndbn = 'FNDBN',
  /** column name */
  Fstcd = 'FSTCD',
  /** column name */
  Fyr = 'FYR',
  /** column name */
  Gpocity = 'GPOCITY',
  /** column name */
  Gponame = 'GPONAME',
  /** column name */
  Gpost = 'GPOST',
  /** column name */
  Group = 'GROUP',
  /** column name */
  Hcoccli = 'HCOCCLI',
  /** column name */
  Hcoccna = 'HCOCCNA',
  /** column name */
  Hcocni = 'HCOCNI',
  /** column name */
  Hcocpsn = 'HCOCPSN',
  /** column name */
  Hhplan = 'HHPLAN',
  /** column name */
  Hicoccli = 'HICOCCLI',
  /** column name */
  Hicoccna = 'HICOCCNA',
  /** column name */
  Hicocni = 'HICOCNI',
  /** column name */
  Hicocpsn = 'HICOCPSN',
  /** column name */
  Hlindk = 'HLINDK',
  /** column name */
  Hlinhos = 'HLINHOS',
  /** column name */
  Hlinn = 'HLINN',
  /** column name */
  Hlinnp = 'HLINNP',
  /** column name */
  Hlinsys = 'HLINSYS',
  /** column name */
  Hlinven = 'HLINVEN',
  /** column name */
  Hrrcode = 'HRRCODE',
  /** column name */
  Hrrname = 'HRRNAME',
  /** column name */
  Hsacode = 'HSACODE',
  /** column name */
  Hsaname = 'HSANAME',
  /** column name */
  Id = 'ID',
  /** column name */
  Iinspt = 'IINSPT',
  /** column name */
  Kschcli = 'KSCHCLI',
  /** column name */
  Kschcna = 'KSCHCNA',
  /** column name */
  Kschni = 'KSCHNI',
  /** column name */
  Kschpsn = 'KSCHPSN',
  /** column name */
  Lat = 'LAT',
  /** column name */
  Lgrpdk = 'LGRPDK',
  /** column name */
  Lgrphos = 'LGRPHOS',
  /** column name */
  Lgrpn = 'LGRPN',
  /** column name */
  Lgrpnp = 'LGRPNP',
  /** column name */
  Lgrpsys = 'LGRPSYS',
  /** column name */
  Lgrpven = 'LGRPVEN',
  /** column name */
  Locfcli = 'LOCFCLI',
  /** column name */
  Locfcna = 'LOCFCNA',
  /** column name */
  Locfni = 'LOCFNI',
  /** column name */
  Locfpsn = 'LOCFPSN',
  /** column name */
  Lochscli = 'LOCHSCLI',
  /** column name */
  Lochscna = 'LOCHSCNA',
  /** column name */
  Lochsni = 'LOCHSNI',
  /** column name */
  Lochspsn = 'LOCHSPSN',
  /** column name */
  Loclgcli = 'LOCLGCLI',
  /** column name */
  Loclgcna = 'LOCLGCNA',
  /** column name */
  Loclgni = 'LOCLGNI',
  /** column name */
  Loclgpsn = 'LOCLGPSN',
  /** column name */
  Lococcli = 'LOCOCCLI',
  /** column name */
  Lococcna = 'LOCOCCNA',
  /** column name */
  Lococni = 'LOCOCNI',
  /** column name */
  Lococpsn = 'LOCOCPSN',
  /** column name */
  Loctrcli = 'LOCTRCLI',
  /** column name */
  Loctrcna = 'LOCTRCNA',
  /** column name */
  Loctrni = 'LOCTRNI',
  /** column name */
  Loctrpsn = 'LOCTRPSN',
  /** column name */
  Long = 'LONG',
  /** column name */
  Lorgcli = 'LORGCLI',
  /** column name */
  Lorgcna = 'LORGCNA',
  /** column name */
  Lorgni = 'LORGNI',
  /** column name */
  Lorgpsn = 'LORGPSN',
  /** column name */
  Los = 'LOS',
  /** column name */
  Ltchc = 'LTCHC',
  /** column name */
  Ltchf = 'LTCHF',
  /** column name */
  Ltct = 'LTCT',
  /** column name */
  Ltnm = 'LTNM',
  /** column name */
  Ltst = 'LTST',
  /** column name */
  Madmin = 'MADMIN',
  /** column name */
  Mapp1 = 'MAPP1',
  /** column name */
  Mapp2 = 'MAPP2',
  /** column name */
  Mapp3 = 'MAPP3',
  /** column name */
  Mapp5 = 'MAPP5',
  /** column name */
  Mapp7 = 'MAPP7',
  /** column name */
  Mapp8 = 'MAPP8',
  /** column name */
  Mapp10 = 'MAPP10',
  /** column name */
  Mapp11 = 'MAPP11',
  /** column name */
  Mapp16 = 'MAPP16',
  /** column name */
  Mapp18 = 'MAPP18',
  /** column name */
  Mapp19 = 'MAPP19',
  /** column name */
  Mapp20 = 'MAPP20',
  /** column name */
  Mapp21 = 'MAPP21',
  /** column name */
  Mapp22 = 'MAPP22',
  /** column name */
  Mcntycd = 'MCNTYCD',
  /** column name */
  Mcrnum = 'MCRNUM',
  /** column name */
  Medaddk = 'MEDADDK',
  /** column name */
  Medadhos = 'MEDADHOS',
  /** column name */
  Medadn = 'MEDADN',
  /** column name */
  Medadsys = 'MEDADSYS',
  /** column name */
  Medadven = 'MEDADVEN',
  /** column name */
  Medhme = 'MEDHME',
  /** column name */
  Medhse = 'MEDHSE',
  /** column name */
  Mednp = 'MEDNP',
  /** column name */
  Mhsmemb = 'MHSMEMB',
  /** column name */
  Mlocaddr = 'MLOCADDR',
  /** column name */
  Mloccity = 'MLOCCITY',
  /** column name */
  Mlocstcd = 'MLOCSTCD',
  /** column name */
  Mloczip = 'MLOCZIP',
  /** column name */
  Mmcdk = 'MMCDK',
  /** column name */
  Mmchos = 'MMCHOS',
  /** column name */
  Mmcn = 'MMCN',
  /** column name */
  Mmcnp = 'MMCNP',
  /** column name */
  Mmcsys = 'MMCSYS',
  /** column name */
  Mmcven = 'MMCVEN',
  /** column name */
  Mname = 'MNAME',
  /** column name */
  Mngt = 'MNGT',
  /** column name */
  Mngtcity = 'MNGTCITY',
  /** column name */
  Mngtname = 'MNGTNAME',
  /** column name */
  Mngtstcd = 'MNGTSTCD',
  /** column name */
  Mssp1P = 'MSSP1P',
  /** column name */
  Msspce = 'MSSPCE',
  /** column name */
  Msspng = 'MSSPNG',
  /** column name */
  Msspt1 = 'MSSPT1',
  /** column name */
  Msspt2 = 'MSSPT2',
  /** column name */
  Msspt3 = 'MSSPT3',
  /** column name */
  Mstate = 'MSTATE',
  /** column name */
  Osmgdk = 'OSMGDK',
  /** column name */
  Osmghos = 'OSMGHOS',
  /** column name */
  Osmgn = 'OSMGN',
  /** column name */
  Osmgnp = 'OSMGNP',
  /** column name */
  Osmgoth = 'OSMGOTH',
  /** column name */
  Osmgsys = 'OSMGSYS',
  /** column name */
  Osmgven = 'OSMGVEN',
  /** column name */
  Otcomcli = 'OTCOMCLI',
  /** column name */
  Otcomcna = 'OTCOMCNA',
  /** column name */
  Otcomni = 'OTCOMNI',
  /** column name */
  Otcompsn = 'OTCOMPSN',
  /** column name */
  Othimdk = 'OTHIMDK',
  /** column name */
  Othimhos = 'OTHIMHOS',
  /** column name */
  Othimn = 'OTHIMN',
  /** column name */
  Othimsys = 'OTHIMSYS',
  /** column name */
  Othimven = 'OTHIMVEN',
  /** column name */
  Othinp = 'OTHINP',
  /** column name */
  Otlscli = 'OTLSCLI',
  /** column name */
  Otlscna = 'OTLSCNA',
  /** column name */
  Otlsni = 'OTLSNI',
  /** column name */
  Otlspsn = 'OTLSPSN',
  /** column name */
  Paytyad = 'PAYTYAD',
  /** column name */
  Paytypci = 'PAYTYPCI',
  /** column name */
  Paytypmd = 'PAYTYPMD',
  /** column name */
  Paytyptm = 'PAYTYPTM',
  /** column name */
  Phygp = 'PHYGP',
  /** column name */
  Plcecli = 'PLCECLI',
  /** column name */
  Plcecna = 'PLCECNA',
  /** column name */
  Plceni = 'PLCENI',
  /** column name */
  Plcepsn = 'PLCEPSN',
  /** column name */
  Radmchi = 'RADMCHI',
  /** column name */
  Resp = 'RESP',
  /** column name */
  Serv = 'SERV',
  /** column name */
  Servoth = 'SERVOTH',
  /** column name */
  Slfpln = 'SLFPLN',
  /** column name */
  Smgpdk = 'SMGPDK',
  /** column name */
  Smgpnp = 'SMGPNP',
  /** column name */
  Smgrphos = 'SMGRPHOS',
  /** column name */
  Smgrpn = 'SMGRPN',
  /** column name */
  Smgrpsys = 'SMGRPSYS',
  /** column name */
  Smgrpven = 'SMGRPVEN',
  /** column name */
  Splan = 'SPLAN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Subs = 'SUBS',
  /** column name */
  Sunits = 'SUNITS',
  /** column name */
  Suply = 'SUPLY',
  /** column name */
  Supnm = 'SUPNM',
  /** column name */
  Sysaddr = 'SYSADDR',
  /** column name */
  Sysarea = 'SYSAREA',
  /** column name */
  Syscity = 'SYSCITY',
  /** column name */
  Sysid = 'SYSID',
  /** column name */
  Sysname = 'SYSNAME',
  /** column name */
  Sysst = 'SYSST',
  /** column name */
  Systeln = 'SYSTELN',
  /** column name */
  SystemPrimaryContact = 'SYSTEM_PRIMARY_CONTACT',
  /** column name */
  Systitle = 'SYSTITLE',
  /** column name */
  Syszip = 'SYSZIP',
  /** column name */
  Telno = 'TELNO'
}

/** input type for updating data in table "AS20DEM" */
export type As20Dem_Set_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDPY?: InputMaybe<Scalars['String']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['Int']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNDOTH?: InputMaybe<Scalars['String']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINNP?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPNP?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MEDNP?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCNP?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP1P?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPNG?: InputMaybe<Scalars['float8']>;
  MSSPT1?: InputMaybe<Scalars['float8']>;
  MSSPT2?: InputMaybe<Scalars['float8']>;
  MSSPT3?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGNP?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  OTHINP?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGPNP?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As20Dem_Stddev_Fields = {
  __typename?: 'AS20DEM_stddev_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As20Dem_Stddev_Pop_Fields = {
  __typename?: 'AS20DEM_stddev_pop_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As20Dem_Stddev_Samp_Fields = {
  __typename?: 'AS20DEM_stddev_samp_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS20DEM" */
export type As20Dem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As20Dem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As20Dem_Stream_Cursor_Value_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDPY?: InputMaybe<Scalars['String']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['Int']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNDOTH?: InputMaybe<Scalars['String']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINNP?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPNP?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MEDNP?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCNP?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP1P?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPNG?: InputMaybe<Scalars['float8']>;
  MSSPT1?: InputMaybe<Scalars['float8']>;
  MSSPT2?: InputMaybe<Scalars['float8']>;
  MSSPT3?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGNP?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  OTHINP?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGPNP?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As20Dem_Sum_Fields = {
  __typename?: 'AS20DEM_sum_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  BNDPCT: Maybe<Scalars['float8']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CLUSTER: Maybe<Scalars['Int']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  DCOV: Maybe<Scalars['float8']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HSACODE: Maybe<Scalars['Int']>;
  MSSP1P: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPNG: Maybe<Scalars['float8']>;
  MSSPT1: Maybe<Scalars['float8']>;
  MSSPT2: Maybe<Scalars['float8']>;
  MSSPT3: Maybe<Scalars['float8']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
};

/** update columns of table "AS20DEM" */
export enum As20Dem_Update_Column {
  /** column name */
  Acocn = 'ACOCN',
  /** column name */
  Acoorg = 'ACOORG',
  /** column name */
  Acopct = 'ACOPCT',
  /** column name */
  Acotypad = 'ACOTYPAD',
  /** column name */
  Acotypci = 'ACOTYPCI',
  /** column name */
  Acotypmd = 'ACOTYPMD',
  /** column name */
  Acotypt = 'ACOTYPT',
  /** column name */
  Ahambr = 'AHAMBR',
  /** column name */
  Area = 'AREA',
  /** column name */
  Bdpy = 'BDPY',
  /** column name */
  Bndpay = 'BNDPAY',
  /** column name */
  Bndpct = 'BNDPCT',
  /** column name */
  Bndrsk = 'BNDRSK',
  /** column name */
  Bsc = 'BSC',
  /** column name */
  Capcon94 = 'CAPCON94',
  /** column name */
  Caprsk = 'CAPRSK',
  /** column name */
  Cbsacode = 'CBSACODE',
  /** column name */
  Cbsaname = 'CBSANAME',
  /** column name */
  Cbsatype = 'CBSATYPE',
  /** column name */
  Chc = 'CHC',
  /** column name */
  Cityrk = 'CITYRK',
  /** column name */
  Cluster = 'CLUSTER',
  /** column name */
  Cmrpay = 'CMRPAY',
  /** column name */
  Cndoth = 'CNDOTH',
  /** column name */
  Cndtypcv = 'CNDTYPCV',
  /** column name */
  Cndtypgi = 'CNDTYPGI',
  /** column name */
  Cndtyphm = 'CNDTYPHM',
  /** column name */
  Cndtypid = 'CNDTYPID',
  /** column name */
  Cndtypng = 'CNDTYPNG',
  /** column name */
  Cndtypon = 'CNDTYPON',
  /** column name */
  Cndtypor = 'CNDTYPOR',
  /** column name */
  Cndtypos = 'CNDTYPOS',
  /** column name */
  Cndtyppm = 'CNDTYPPM',
  /** column name */
  Cntrl = 'CNTRL',
  /** column name */
  Cntyname = 'CNTYNAME',
  /** column name */
  Cohsp = 'COHSP',
  /** column name */
  Collcli = 'COLLCLI',
  /** column name */
  Collcna = 'COLLCNA',
  /** column name */
  Collni = 'COLLNI',
  /** column name */
  Collpsn = 'COLLPSN',
  /** column name */
  Commty = 'COMMTY',
  /** column name */
  Cotycan = 'COTYCAN',
  /** column name */
  Cotycar = 'COTYCAR',
  /** column name */
  Cotydesc = 'COTYDESC',
  /** column name */
  Cotyort = 'COTYORT',
  /** column name */
  Cotyoth = 'COTYOTH',
  /** column name */
  Cotyped = 'COTYPED',
  /** column name */
  Cotypsy = 'COTYPSY',
  /** column name */
  Cotysur = 'COTYSUR',
  /** column name */
  Cppct = 'CPPCT',
  /** column name */
  Csacode = 'CSACODE',
  /** column name */
  Csaname = 'CSANAME',
  /** column name */
  Dcov = 'DCOV',
  /** column name */
  Divcode = 'DIVCODE',
  /** column name */
  Divname = 'DIVNAME',
  /** column name */
  Dtbeg = 'DTBEG',
  /** column name */
  Dtend = 'DTEND',
  /** column name */
  Famadv = 'FAMADV',
  /** column name */
  Fborcli = 'FBORCLI',
  /** column name */
  Fborcna = 'FBORCNA',
  /** column name */
  Fborni = 'FBORNI',
  /** column name */
  Fborpsn = 'FBORPSN',
  /** column name */
  Fcntycd = 'FCNTYCD',
  /** column name */
  Fcounty = 'FCOUNTY',
  /** column name */
  Fisyr = 'FISYR',
  /** column name */
  Fndbn = 'FNDBN',
  /** column name */
  Fstcd = 'FSTCD',
  /** column name */
  Fyr = 'FYR',
  /** column name */
  Gpocity = 'GPOCITY',
  /** column name */
  Gponame = 'GPONAME',
  /** column name */
  Gpost = 'GPOST',
  /** column name */
  Group = 'GROUP',
  /** column name */
  Hcoccli = 'HCOCCLI',
  /** column name */
  Hcoccna = 'HCOCCNA',
  /** column name */
  Hcocni = 'HCOCNI',
  /** column name */
  Hcocpsn = 'HCOCPSN',
  /** column name */
  Hhplan = 'HHPLAN',
  /** column name */
  Hicoccli = 'HICOCCLI',
  /** column name */
  Hicoccna = 'HICOCCNA',
  /** column name */
  Hicocni = 'HICOCNI',
  /** column name */
  Hicocpsn = 'HICOCPSN',
  /** column name */
  Hlindk = 'HLINDK',
  /** column name */
  Hlinhos = 'HLINHOS',
  /** column name */
  Hlinn = 'HLINN',
  /** column name */
  Hlinnp = 'HLINNP',
  /** column name */
  Hlinsys = 'HLINSYS',
  /** column name */
  Hlinven = 'HLINVEN',
  /** column name */
  Hrrcode = 'HRRCODE',
  /** column name */
  Hrrname = 'HRRNAME',
  /** column name */
  Hsacode = 'HSACODE',
  /** column name */
  Hsaname = 'HSANAME',
  /** column name */
  Id = 'ID',
  /** column name */
  Iinspt = 'IINSPT',
  /** column name */
  Kschcli = 'KSCHCLI',
  /** column name */
  Kschcna = 'KSCHCNA',
  /** column name */
  Kschni = 'KSCHNI',
  /** column name */
  Kschpsn = 'KSCHPSN',
  /** column name */
  Lat = 'LAT',
  /** column name */
  Lgrpdk = 'LGRPDK',
  /** column name */
  Lgrphos = 'LGRPHOS',
  /** column name */
  Lgrpn = 'LGRPN',
  /** column name */
  Lgrpnp = 'LGRPNP',
  /** column name */
  Lgrpsys = 'LGRPSYS',
  /** column name */
  Lgrpven = 'LGRPVEN',
  /** column name */
  Locfcli = 'LOCFCLI',
  /** column name */
  Locfcna = 'LOCFCNA',
  /** column name */
  Locfni = 'LOCFNI',
  /** column name */
  Locfpsn = 'LOCFPSN',
  /** column name */
  Lochscli = 'LOCHSCLI',
  /** column name */
  Lochscna = 'LOCHSCNA',
  /** column name */
  Lochsni = 'LOCHSNI',
  /** column name */
  Lochspsn = 'LOCHSPSN',
  /** column name */
  Loclgcli = 'LOCLGCLI',
  /** column name */
  Loclgcna = 'LOCLGCNA',
  /** column name */
  Loclgni = 'LOCLGNI',
  /** column name */
  Loclgpsn = 'LOCLGPSN',
  /** column name */
  Lococcli = 'LOCOCCLI',
  /** column name */
  Lococcna = 'LOCOCCNA',
  /** column name */
  Lococni = 'LOCOCNI',
  /** column name */
  Lococpsn = 'LOCOCPSN',
  /** column name */
  Loctrcli = 'LOCTRCLI',
  /** column name */
  Loctrcna = 'LOCTRCNA',
  /** column name */
  Loctrni = 'LOCTRNI',
  /** column name */
  Loctrpsn = 'LOCTRPSN',
  /** column name */
  Long = 'LONG',
  /** column name */
  Lorgcli = 'LORGCLI',
  /** column name */
  Lorgcna = 'LORGCNA',
  /** column name */
  Lorgni = 'LORGNI',
  /** column name */
  Lorgpsn = 'LORGPSN',
  /** column name */
  Los = 'LOS',
  /** column name */
  Ltchc = 'LTCHC',
  /** column name */
  Ltchf = 'LTCHF',
  /** column name */
  Ltct = 'LTCT',
  /** column name */
  Ltnm = 'LTNM',
  /** column name */
  Ltst = 'LTST',
  /** column name */
  Madmin = 'MADMIN',
  /** column name */
  Mapp1 = 'MAPP1',
  /** column name */
  Mapp2 = 'MAPP2',
  /** column name */
  Mapp3 = 'MAPP3',
  /** column name */
  Mapp5 = 'MAPP5',
  /** column name */
  Mapp7 = 'MAPP7',
  /** column name */
  Mapp8 = 'MAPP8',
  /** column name */
  Mapp10 = 'MAPP10',
  /** column name */
  Mapp11 = 'MAPP11',
  /** column name */
  Mapp16 = 'MAPP16',
  /** column name */
  Mapp18 = 'MAPP18',
  /** column name */
  Mapp19 = 'MAPP19',
  /** column name */
  Mapp20 = 'MAPP20',
  /** column name */
  Mapp21 = 'MAPP21',
  /** column name */
  Mapp22 = 'MAPP22',
  /** column name */
  Mcntycd = 'MCNTYCD',
  /** column name */
  Mcrnum = 'MCRNUM',
  /** column name */
  Medaddk = 'MEDADDK',
  /** column name */
  Medadhos = 'MEDADHOS',
  /** column name */
  Medadn = 'MEDADN',
  /** column name */
  Medadsys = 'MEDADSYS',
  /** column name */
  Medadven = 'MEDADVEN',
  /** column name */
  Medhme = 'MEDHME',
  /** column name */
  Medhse = 'MEDHSE',
  /** column name */
  Mednp = 'MEDNP',
  /** column name */
  Mhsmemb = 'MHSMEMB',
  /** column name */
  Mlocaddr = 'MLOCADDR',
  /** column name */
  Mloccity = 'MLOCCITY',
  /** column name */
  Mlocstcd = 'MLOCSTCD',
  /** column name */
  Mloczip = 'MLOCZIP',
  /** column name */
  Mmcdk = 'MMCDK',
  /** column name */
  Mmchos = 'MMCHOS',
  /** column name */
  Mmcn = 'MMCN',
  /** column name */
  Mmcnp = 'MMCNP',
  /** column name */
  Mmcsys = 'MMCSYS',
  /** column name */
  Mmcven = 'MMCVEN',
  /** column name */
  Mname = 'MNAME',
  /** column name */
  Mngt = 'MNGT',
  /** column name */
  Mngtcity = 'MNGTCITY',
  /** column name */
  Mngtname = 'MNGTNAME',
  /** column name */
  Mngtstcd = 'MNGTSTCD',
  /** column name */
  Mssp1P = 'MSSP1P',
  /** column name */
  Msspce = 'MSSPCE',
  /** column name */
  Msspng = 'MSSPNG',
  /** column name */
  Msspt1 = 'MSSPT1',
  /** column name */
  Msspt2 = 'MSSPT2',
  /** column name */
  Msspt3 = 'MSSPT3',
  /** column name */
  Mstate = 'MSTATE',
  /** column name */
  Osmgdk = 'OSMGDK',
  /** column name */
  Osmghos = 'OSMGHOS',
  /** column name */
  Osmgn = 'OSMGN',
  /** column name */
  Osmgnp = 'OSMGNP',
  /** column name */
  Osmgoth = 'OSMGOTH',
  /** column name */
  Osmgsys = 'OSMGSYS',
  /** column name */
  Osmgven = 'OSMGVEN',
  /** column name */
  Otcomcli = 'OTCOMCLI',
  /** column name */
  Otcomcna = 'OTCOMCNA',
  /** column name */
  Otcomni = 'OTCOMNI',
  /** column name */
  Otcompsn = 'OTCOMPSN',
  /** column name */
  Othimdk = 'OTHIMDK',
  /** column name */
  Othimhos = 'OTHIMHOS',
  /** column name */
  Othimn = 'OTHIMN',
  /** column name */
  Othimsys = 'OTHIMSYS',
  /** column name */
  Othimven = 'OTHIMVEN',
  /** column name */
  Othinp = 'OTHINP',
  /** column name */
  Otlscli = 'OTLSCLI',
  /** column name */
  Otlscna = 'OTLSCNA',
  /** column name */
  Otlsni = 'OTLSNI',
  /** column name */
  Otlspsn = 'OTLSPSN',
  /** column name */
  Paytyad = 'PAYTYAD',
  /** column name */
  Paytypci = 'PAYTYPCI',
  /** column name */
  Paytypmd = 'PAYTYPMD',
  /** column name */
  Paytyptm = 'PAYTYPTM',
  /** column name */
  Phygp = 'PHYGP',
  /** column name */
  Plcecli = 'PLCECLI',
  /** column name */
  Plcecna = 'PLCECNA',
  /** column name */
  Plceni = 'PLCENI',
  /** column name */
  Plcepsn = 'PLCEPSN',
  /** column name */
  Radmchi = 'RADMCHI',
  /** column name */
  Resp = 'RESP',
  /** column name */
  Serv = 'SERV',
  /** column name */
  Servoth = 'SERVOTH',
  /** column name */
  Slfpln = 'SLFPLN',
  /** column name */
  Smgpdk = 'SMGPDK',
  /** column name */
  Smgpnp = 'SMGPNP',
  /** column name */
  Smgrphos = 'SMGRPHOS',
  /** column name */
  Smgrpn = 'SMGRPN',
  /** column name */
  Smgrpsys = 'SMGRPSYS',
  /** column name */
  Smgrpven = 'SMGRPVEN',
  /** column name */
  Splan = 'SPLAN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Subs = 'SUBS',
  /** column name */
  Sunits = 'SUNITS',
  /** column name */
  Suply = 'SUPLY',
  /** column name */
  Supnm = 'SUPNM',
  /** column name */
  Sysaddr = 'SYSADDR',
  /** column name */
  Sysarea = 'SYSAREA',
  /** column name */
  Syscity = 'SYSCITY',
  /** column name */
  Sysid = 'SYSID',
  /** column name */
  Sysname = 'SYSNAME',
  /** column name */
  Sysst = 'SYSST',
  /** column name */
  Systeln = 'SYSTELN',
  /** column name */
  SystemPrimaryContact = 'SYSTEM_PRIMARY_CONTACT',
  /** column name */
  Systitle = 'SYSTITLE',
  /** column name */
  Syszip = 'SYSZIP',
  /** column name */
  Telno = 'TELNO'
}

export type As20Dem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As20Dem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As20Dem_Set_Input>;
  /** filter the rows which have to be updated */
  where: As20Dem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As20Dem_Var_Pop_Fields = {
  __typename?: 'AS20DEM_var_pop_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As20Dem_Var_Samp_Fields = {
  __typename?: 'AS20DEM_var_samp_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As20Dem_Variance_Fields = {
  __typename?: 'AS20DEM_variance_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP1P: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPNG: Maybe<Scalars['Float']>;
  MSSPT1: Maybe<Scalars['Float']>;
  MSSPT2: Maybe<Scalars['Float']>;
  MSSPT3: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS20SVC1" */
export type As20Svc1 = {
  __typename?: 'AS20SVC1';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS20SVC1" */
export type As20Svc1_Aggregate = {
  __typename?: 'AS20SVC1_aggregate';
  aggregate: Maybe<As20Svc1_Aggregate_Fields>;
  nodes: Array<As20Svc1>;
};

/** aggregate fields of "AS20SVC1" */
export type As20Svc1_Aggregate_Fields = {
  __typename?: 'AS20SVC1_aggregate_fields';
  avg: Maybe<As20Svc1_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As20Svc1_Max_Fields>;
  min: Maybe<As20Svc1_Min_Fields>;
  stddev: Maybe<As20Svc1_Stddev_Fields>;
  stddev_pop: Maybe<As20Svc1_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As20Svc1_Stddev_Samp_Fields>;
  sum: Maybe<As20Svc1_Sum_Fields>;
  var_pop: Maybe<As20Svc1_Var_Pop_Fields>;
  var_samp: Maybe<As20Svc1_Var_Samp_Fields>;
  variance: Maybe<As20Svc1_Variance_Fields>;
};


/** aggregate fields of "AS20SVC1" */
export type As20Svc1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As20Svc1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As20Svc1_Avg_Fields = {
  __typename?: 'AS20SVC1_avg_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS20SVC1". All fields are combined with a logical 'AND'. */
export type As20Svc1_Bool_Exp = {
  ACARDHOS?: InputMaybe<String_Comparison_Exp>;
  ACARDSYS?: InputMaybe<String_Comparison_Exp>;
  ACARDVEN?: InputMaybe<String_Comparison_Exp>;
  ACLABHOS?: InputMaybe<String_Comparison_Exp>;
  ACLABSYS?: InputMaybe<String_Comparison_Exp>;
  ACLABVEN?: InputMaybe<String_Comparison_Exp>;
  ACUHOS?: InputMaybe<String_Comparison_Exp>;
  ACULTBD?: InputMaybe<Float8_Comparison_Exp>;
  ACUSYS?: InputMaybe<String_Comparison_Exp>;
  ACUVEN?: InputMaybe<String_Comparison_Exp>;
  ADTCHOS?: InputMaybe<String_Comparison_Exp>;
  ADTCSYS?: InputMaybe<String_Comparison_Exp>;
  ADTCVEN?: InputMaybe<String_Comparison_Exp>;
  ADTEHOS?: InputMaybe<String_Comparison_Exp>;
  ADTESYS?: InputMaybe<String_Comparison_Exp>;
  ADTEVEN?: InputMaybe<String_Comparison_Exp>;
  ADULTHOS?: InputMaybe<String_Comparison_Exp>;
  ADULTSYS?: InputMaybe<String_Comparison_Exp>;
  ADULTVEN?: InputMaybe<String_Comparison_Exp>;
  AIRBHOS?: InputMaybe<String_Comparison_Exp>;
  AIRBROOM?: InputMaybe<Float8_Comparison_Exp>;
  AIRBSYS?: InputMaybe<String_Comparison_Exp>;
  AIRBVEN?: InputMaybe<String_Comparison_Exp>;
  ALCHBD?: InputMaybe<Float8_Comparison_Exp>;
  ALCHHOS?: InputMaybe<String_Comparison_Exp>;
  ALCHSYS?: InputMaybe<String_Comparison_Exp>;
  ALCHVEN?: InputMaybe<String_Comparison_Exp>;
  ALZHOS?: InputMaybe<String_Comparison_Exp>;
  ALZSYS?: InputMaybe<String_Comparison_Exp>;
  ALZVEN?: InputMaybe<String_Comparison_Exp>;
  AMBAHOS?: InputMaybe<String_Comparison_Exp>;
  AMBASYS?: InputMaybe<String_Comparison_Exp>;
  AMBAVEN?: InputMaybe<String_Comparison_Exp>;
  AMBHOS?: InputMaybe<String_Comparison_Exp>;
  AMBSHOS?: InputMaybe<String_Comparison_Exp>;
  AMBSSYS?: InputMaybe<String_Comparison_Exp>;
  AMBSVEN?: InputMaybe<String_Comparison_Exp>;
  AMBSYS?: InputMaybe<String_Comparison_Exp>;
  AMBVEN?: InputMaybe<String_Comparison_Exp>;
  ARTHCHOS?: InputMaybe<String_Comparison_Exp>;
  ARTHCSYS?: InputMaybe<String_Comparison_Exp>;
  ARTHCVEN?: InputMaybe<String_Comparison_Exp>;
  AUXHOS?: InputMaybe<String_Comparison_Exp>;
  AUXSYS?: InputMaybe<String_Comparison_Exp>;
  AUXVEN?: InputMaybe<String_Comparison_Exp>;
  BLDOHOS?: InputMaybe<String_Comparison_Exp>;
  BLDOSYS?: InputMaybe<String_Comparison_Exp>;
  BLDOVEN?: InputMaybe<String_Comparison_Exp>;
  BRNBD?: InputMaybe<Float8_Comparison_Exp>;
  BRNHOS?: InputMaybe<String_Comparison_Exp>;
  BRNSYS?: InputMaybe<String_Comparison_Exp>;
  BRNVEN?: InputMaybe<String_Comparison_Exp>;
  BROOMHOS?: InputMaybe<String_Comparison_Exp>;
  BROOMSYS?: InputMaybe<String_Comparison_Exp>;
  BROOMVEN?: InputMaybe<String_Comparison_Exp>;
  BWHTHOS?: InputMaybe<String_Comparison_Exp>;
  BWHTSYS?: InputMaybe<String_Comparison_Exp>;
  BWHTVEN?: InputMaybe<String_Comparison_Exp>;
  CAOSHOS?: InputMaybe<String_Comparison_Exp>;
  CAOSSYS?: InputMaybe<String_Comparison_Exp>;
  CAOSVEN?: InputMaybe<String_Comparison_Exp>;
  CHABHOS?: InputMaybe<String_Comparison_Exp>;
  CHABSYS?: InputMaybe<String_Comparison_Exp>;
  CHABVEN?: InputMaybe<String_Comparison_Exp>;
  CHAPHOS?: InputMaybe<String_Comparison_Exp>;
  CHAPSYS?: InputMaybe<String_Comparison_Exp>;
  CHAPVEN?: InputMaybe<String_Comparison_Exp>;
  CHIHOS?: InputMaybe<String_Comparison_Exp>;
  CHISYS?: InputMaybe<String_Comparison_Exp>;
  CHIVEN?: InputMaybe<String_Comparison_Exp>;
  CHTHHOS?: InputMaybe<String_Comparison_Exp>;
  CHTHSYS?: InputMaybe<String_Comparison_Exp>;
  CHTHVEN?: InputMaybe<String_Comparison_Exp>;
  CICBD?: InputMaybe<Float8_Comparison_Exp>;
  CICHOS?: InputMaybe<String_Comparison_Exp>;
  CICSYS?: InputMaybe<String_Comparison_Exp>;
  CICVEN?: InputMaybe<String_Comparison_Exp>;
  CMNGTHOS?: InputMaybe<String_Comparison_Exp>;
  CMNGTSYS?: InputMaybe<String_Comparison_Exp>;
  CMNGTVEN?: InputMaybe<String_Comparison_Exp>;
  COMPHOS?: InputMaybe<String_Comparison_Exp>;
  COMPSYS?: InputMaybe<String_Comparison_Exp>;
  COMPVEN?: InputMaybe<String_Comparison_Exp>;
  COUTRHOS?: InputMaybe<String_Comparison_Exp>;
  COUTRSYS?: InputMaybe<String_Comparison_Exp>;
  COUTRVEN?: InputMaybe<String_Comparison_Exp>;
  CPREVHOS?: InputMaybe<String_Comparison_Exp>;
  CPREVSYS?: InputMaybe<String_Comparison_Exp>;
  CPREVVEN?: InputMaybe<String_Comparison_Exp>;
  CWELLHOS?: InputMaybe<String_Comparison_Exp>;
  CWELLSYS?: InputMaybe<String_Comparison_Exp>;
  CWELLVEN?: InputMaybe<String_Comparison_Exp>;
  DENTSHOS?: InputMaybe<String_Comparison_Exp>;
  DENTSSYS?: InputMaybe<String_Comparison_Exp>;
  DENTSVEN?: InputMaybe<String_Comparison_Exp>;
  DPPHOS?: InputMaybe<String_Comparison_Exp>;
  DPPSYS?: InputMaybe<String_Comparison_Exp>;
  DPPVEN?: InputMaybe<String_Comparison_Exp>;
  EMDEPHOS?: InputMaybe<String_Comparison_Exp>;
  EMDEPSYS?: InputMaybe<String_Comparison_Exp>;
  EMDEPVEN?: InputMaybe<String_Comparison_Exp>;
  EMSSHOS?: InputMaybe<String_Comparison_Exp>;
  EMSSSYS?: InputMaybe<String_Comparison_Exp>;
  EMSSVEN?: InputMaybe<String_Comparison_Exp>;
  ENBHOS?: InputMaybe<String_Comparison_Exp>;
  ENBSYS?: InputMaybe<String_Comparison_Exp>;
  ENBVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOAHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOASYS?: InputMaybe<String_Comparison_Exp>;
  ENDOAVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOCHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOCSYS?: InputMaybe<String_Comparison_Exp>;
  ENDOCVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOEHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOESYS?: InputMaybe<String_Comparison_Exp>;
  ENDOEVEN?: InputMaybe<String_Comparison_Exp>;
  ENDORHOS?: InputMaybe<String_Comparison_Exp>;
  ENDORSYS?: InputMaybe<String_Comparison_Exp>;
  ENDORVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOUHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOUSYS?: InputMaybe<String_Comparison_Exp>;
  ENDOUVEN?: InputMaybe<String_Comparison_Exp>;
  ENRHOS?: InputMaybe<String_Comparison_Exp>;
  ENRSYS?: InputMaybe<String_Comparison_Exp>;
  ENRVEN?: InputMaybe<String_Comparison_Exp>;
  ESWLHOS?: InputMaybe<String_Comparison_Exp>;
  ESWLSYS?: InputMaybe<String_Comparison_Exp>;
  ESWLVEN?: InputMaybe<String_Comparison_Exp>;
  FITCHOS?: InputMaybe<String_Comparison_Exp>;
  FITCSYS?: InputMaybe<String_Comparison_Exp>;
  FITCVEN?: InputMaybe<String_Comparison_Exp>;
  FRTCHOS?: InputMaybe<String_Comparison_Exp>;
  FRTCSYS?: InputMaybe<String_Comparison_Exp>;
  FRTCVEN?: InputMaybe<String_Comparison_Exp>;
  FSERHOS?: InputMaybe<String_Comparison_Exp>;
  FSERSYS?: InputMaybe<String_Comparison_Exp>;
  FSERVEN?: InputMaybe<String_Comparison_Exp>;
  GENBD?: InputMaybe<Float8_Comparison_Exp>;
  GENHOS?: InputMaybe<String_Comparison_Exp>;
  GENSYS?: InputMaybe<String_Comparison_Exp>;
  GENVEN?: InputMaybe<String_Comparison_Exp>;
  GERSVHOS?: InputMaybe<String_Comparison_Exp>;
  GERSVSYS?: InputMaybe<String_Comparison_Exp>;
  GERSVVEN?: InputMaybe<String_Comparison_Exp>;
  HOSPBD?: InputMaybe<Float8_Comparison_Exp>;
  ICFBD88?: InputMaybe<Float8_Comparison_Exp>;
  ICFHOS?: InputMaybe<String_Comparison_Exp>;
  ICFSYS?: InputMaybe<String_Comparison_Exp>;
  ICFVEN?: InputMaybe<String_Comparison_Exp>;
  ICLABHOS?: InputMaybe<String_Comparison_Exp>;
  ICLABSYS?: InputMaybe<String_Comparison_Exp>;
  ICLABVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  MAMMSHOS?: InputMaybe<String_Comparison_Exp>;
  MAMMSSYS?: InputMaybe<String_Comparison_Exp>;
  MAMMSVEN?: InputMaybe<String_Comparison_Exp>;
  MSICBD?: InputMaybe<Float8_Comparison_Exp>;
  MSICHOS?: InputMaybe<String_Comparison_Exp>;
  MSICSYS?: InputMaybe<String_Comparison_Exp>;
  MSICVEN?: InputMaybe<String_Comparison_Exp>;
  NICBD?: InputMaybe<Float8_Comparison_Exp>;
  NICHOS?: InputMaybe<String_Comparison_Exp>;
  NICSYS?: InputMaybe<String_Comparison_Exp>;
  NICVEN?: InputMaybe<String_Comparison_Exp>;
  NINTBD?: InputMaybe<Float8_Comparison_Exp>;
  NINTHOS?: InputMaybe<String_Comparison_Exp>;
  NINTSYS?: InputMaybe<String_Comparison_Exp>;
  NINTVEN?: InputMaybe<String_Comparison_Exp>;
  OBBD?: InputMaybe<Float8_Comparison_Exp>;
  OBHOS?: InputMaybe<String_Comparison_Exp>;
  OBLEV?: InputMaybe<String_Comparison_Exp>;
  OBSYS?: InputMaybe<String_Comparison_Exp>;
  OBVEN?: InputMaybe<String_Comparison_Exp>;
  OPCENHOS?: InputMaybe<String_Comparison_Exp>;
  OPCENSYS?: InputMaybe<String_Comparison_Exp>;
  OPCENVEN?: InputMaybe<String_Comparison_Exp>;
  OSPOTH?: InputMaybe<String_Comparison_Exp>;
  OTHBD94?: InputMaybe<Float8_Comparison_Exp>;
  OTHCRHOS?: InputMaybe<String_Comparison_Exp>;
  OTHCRSYS?: InputMaybe<String_Comparison_Exp>;
  OTHCRVEN?: InputMaybe<String_Comparison_Exp>;
  OTHIC?: InputMaybe<String_Comparison_Exp>;
  OTHICBD?: InputMaybe<Float8_Comparison_Exp>;
  OTHIHOS?: InputMaybe<String_Comparison_Exp>;
  OTHISYS?: InputMaybe<String_Comparison_Exp>;
  OTHIVEN?: InputMaybe<String_Comparison_Exp>;
  OTHLBD94?: InputMaybe<Float8_Comparison_Exp>;
  OTHLTHOS?: InputMaybe<String_Comparison_Exp>;
  OTHLTSYS?: InputMaybe<String_Comparison_Exp>;
  OTHLTVEN?: InputMaybe<String_Comparison_Exp>;
  OTHOTH?: InputMaybe<String_Comparison_Exp>;
  PCARDHOS?: InputMaybe<String_Comparison_Exp>;
  PCARDSYS?: InputMaybe<String_Comparison_Exp>;
  PCARDVEN?: InputMaybe<String_Comparison_Exp>;
  PCLABHOS?: InputMaybe<String_Comparison_Exp>;
  PCLABSYS?: InputMaybe<String_Comparison_Exp>;
  PCLABVEN?: InputMaybe<String_Comparison_Exp>;
  PEDBD?: InputMaybe<Float8_Comparison_Exp>;
  PEDCSHOS?: InputMaybe<String_Comparison_Exp>;
  PEDCSSYS?: InputMaybe<String_Comparison_Exp>;
  PEDCSVEN?: InputMaybe<String_Comparison_Exp>;
  PEDEHOS?: InputMaybe<String_Comparison_Exp>;
  PEDESYS?: InputMaybe<String_Comparison_Exp>;
  PEDEVEN?: InputMaybe<String_Comparison_Exp>;
  PEDHOS?: InputMaybe<String_Comparison_Exp>;
  PEDICBD?: InputMaybe<Float8_Comparison_Exp>;
  PEDICHOS?: InputMaybe<String_Comparison_Exp>;
  PEDICSYS?: InputMaybe<String_Comparison_Exp>;
  PEDICVEN?: InputMaybe<String_Comparison_Exp>;
  PEDSYS?: InputMaybe<String_Comparison_Exp>;
  PEDVEN?: InputMaybe<String_Comparison_Exp>;
  PELABHOS?: InputMaybe<String_Comparison_Exp>;
  PELABSYS?: InputMaybe<String_Comparison_Exp>;
  PELABVEN?: InputMaybe<String_Comparison_Exp>;
  PEMERHOS?: InputMaybe<String_Comparison_Exp>;
  PEMERSYS?: InputMaybe<String_Comparison_Exp>;
  PEMERVEN?: InputMaybe<String_Comparison_Exp>;
  PSYBD?: InputMaybe<Float8_Comparison_Exp>;
  PSYHOS?: InputMaybe<String_Comparison_Exp>;
  PSYSYS?: InputMaybe<String_Comparison_Exp>;
  PSYVEN?: InputMaybe<String_Comparison_Exp>;
  REHABBD?: InputMaybe<Float8_Comparison_Exp>;
  REHABHOS?: InputMaybe<String_Comparison_Exp>;
  REHABSYS?: InputMaybe<String_Comparison_Exp>;
  REHABVEN?: InputMaybe<String_Comparison_Exp>;
  SNBD88?: InputMaybe<Float8_Comparison_Exp>;
  SNHOS?: InputMaybe<String_Comparison_Exp>;
  SNSYS?: InputMaybe<String_Comparison_Exp>;
  SNVEN?: InputMaybe<String_Comparison_Exp>;
  SPCICBD?: InputMaybe<Float8_Comparison_Exp>;
  SPCICHOS?: InputMaybe<String_Comparison_Exp>;
  SPCICSYS?: InputMaybe<String_Comparison_Exp>;
  SPCICVEN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  TRAUMHOS?: InputMaybe<String_Comparison_Exp>;
  TRAUML90?: InputMaybe<String_Comparison_Exp>;
  TRAUMSYS?: InputMaybe<String_Comparison_Exp>;
  TRAUMVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As20Svc1_Bool_Exp>>;
  _not?: InputMaybe<As20Svc1_Bool_Exp>;
  _or?: InputMaybe<Array<As20Svc1_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS20SVC1" */
export enum As20Svc1_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs20Svc1 = 'pk_AS20SVC1'
}

/** input type for incrementing numeric columns in table "AS20SVC1" */
export type As20Svc1_Inc_Input = {
  ACULTBD?: InputMaybe<Scalars['float8']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS20SVC1" */
export type As20Svc1_Insert_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As20Svc1_Max_Fields = {
  __typename?: 'AS20SVC1_max_fields';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As20Svc1_Min_Fields = {
  __typename?: 'AS20SVC1_min_fields';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS20SVC1" */
export type As20Svc1_Mutation_Response = {
  __typename?: 'AS20SVC1_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As20Svc1>;
};

/** input type for inserting object relation for remote table "AS20SVC1" */
export type As20Svc1_Obj_Rel_Insert_Input = {
  data: As20Svc1_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As20Svc1_On_Conflict>;
};

/** on_conflict condition type for table "AS20SVC1" */
export type As20Svc1_On_Conflict = {
  constraint: As20Svc1_Constraint;
  update_columns?: Array<As20Svc1_Update_Column>;
  where?: InputMaybe<As20Svc1_Bool_Exp>;
};

/** Ordering options when selecting data from "AS20SVC1". */
export type As20Svc1_Order_By = {
  ACARDHOS?: InputMaybe<Order_By>;
  ACARDSYS?: InputMaybe<Order_By>;
  ACARDVEN?: InputMaybe<Order_By>;
  ACLABHOS?: InputMaybe<Order_By>;
  ACLABSYS?: InputMaybe<Order_By>;
  ACLABVEN?: InputMaybe<Order_By>;
  ACUHOS?: InputMaybe<Order_By>;
  ACULTBD?: InputMaybe<Order_By>;
  ACUSYS?: InputMaybe<Order_By>;
  ACUVEN?: InputMaybe<Order_By>;
  ADTCHOS?: InputMaybe<Order_By>;
  ADTCSYS?: InputMaybe<Order_By>;
  ADTCVEN?: InputMaybe<Order_By>;
  ADTEHOS?: InputMaybe<Order_By>;
  ADTESYS?: InputMaybe<Order_By>;
  ADTEVEN?: InputMaybe<Order_By>;
  ADULTHOS?: InputMaybe<Order_By>;
  ADULTSYS?: InputMaybe<Order_By>;
  ADULTVEN?: InputMaybe<Order_By>;
  AIRBHOS?: InputMaybe<Order_By>;
  AIRBROOM?: InputMaybe<Order_By>;
  AIRBSYS?: InputMaybe<Order_By>;
  AIRBVEN?: InputMaybe<Order_By>;
  ALCHBD?: InputMaybe<Order_By>;
  ALCHHOS?: InputMaybe<Order_By>;
  ALCHSYS?: InputMaybe<Order_By>;
  ALCHVEN?: InputMaybe<Order_By>;
  ALZHOS?: InputMaybe<Order_By>;
  ALZSYS?: InputMaybe<Order_By>;
  ALZVEN?: InputMaybe<Order_By>;
  AMBAHOS?: InputMaybe<Order_By>;
  AMBASYS?: InputMaybe<Order_By>;
  AMBAVEN?: InputMaybe<Order_By>;
  AMBHOS?: InputMaybe<Order_By>;
  AMBSHOS?: InputMaybe<Order_By>;
  AMBSSYS?: InputMaybe<Order_By>;
  AMBSVEN?: InputMaybe<Order_By>;
  AMBSYS?: InputMaybe<Order_By>;
  AMBVEN?: InputMaybe<Order_By>;
  ARTHCHOS?: InputMaybe<Order_By>;
  ARTHCSYS?: InputMaybe<Order_By>;
  ARTHCVEN?: InputMaybe<Order_By>;
  AUXHOS?: InputMaybe<Order_By>;
  AUXSYS?: InputMaybe<Order_By>;
  AUXVEN?: InputMaybe<Order_By>;
  BLDOHOS?: InputMaybe<Order_By>;
  BLDOSYS?: InputMaybe<Order_By>;
  BLDOVEN?: InputMaybe<Order_By>;
  BRNBD?: InputMaybe<Order_By>;
  BRNHOS?: InputMaybe<Order_By>;
  BRNSYS?: InputMaybe<Order_By>;
  BRNVEN?: InputMaybe<Order_By>;
  BROOMHOS?: InputMaybe<Order_By>;
  BROOMSYS?: InputMaybe<Order_By>;
  BROOMVEN?: InputMaybe<Order_By>;
  BWHTHOS?: InputMaybe<Order_By>;
  BWHTSYS?: InputMaybe<Order_By>;
  BWHTVEN?: InputMaybe<Order_By>;
  CAOSHOS?: InputMaybe<Order_By>;
  CAOSSYS?: InputMaybe<Order_By>;
  CAOSVEN?: InputMaybe<Order_By>;
  CHABHOS?: InputMaybe<Order_By>;
  CHABSYS?: InputMaybe<Order_By>;
  CHABVEN?: InputMaybe<Order_By>;
  CHAPHOS?: InputMaybe<Order_By>;
  CHAPSYS?: InputMaybe<Order_By>;
  CHAPVEN?: InputMaybe<Order_By>;
  CHIHOS?: InputMaybe<Order_By>;
  CHISYS?: InputMaybe<Order_By>;
  CHIVEN?: InputMaybe<Order_By>;
  CHTHHOS?: InputMaybe<Order_By>;
  CHTHSYS?: InputMaybe<Order_By>;
  CHTHVEN?: InputMaybe<Order_By>;
  CICBD?: InputMaybe<Order_By>;
  CICHOS?: InputMaybe<Order_By>;
  CICSYS?: InputMaybe<Order_By>;
  CICVEN?: InputMaybe<Order_By>;
  CMNGTHOS?: InputMaybe<Order_By>;
  CMNGTSYS?: InputMaybe<Order_By>;
  CMNGTVEN?: InputMaybe<Order_By>;
  COMPHOS?: InputMaybe<Order_By>;
  COMPSYS?: InputMaybe<Order_By>;
  COMPVEN?: InputMaybe<Order_By>;
  COUTRHOS?: InputMaybe<Order_By>;
  COUTRSYS?: InputMaybe<Order_By>;
  COUTRVEN?: InputMaybe<Order_By>;
  CPREVHOS?: InputMaybe<Order_By>;
  CPREVSYS?: InputMaybe<Order_By>;
  CPREVVEN?: InputMaybe<Order_By>;
  CWELLHOS?: InputMaybe<Order_By>;
  CWELLSYS?: InputMaybe<Order_By>;
  CWELLVEN?: InputMaybe<Order_By>;
  DENTSHOS?: InputMaybe<Order_By>;
  DENTSSYS?: InputMaybe<Order_By>;
  DENTSVEN?: InputMaybe<Order_By>;
  DPPHOS?: InputMaybe<Order_By>;
  DPPSYS?: InputMaybe<Order_By>;
  DPPVEN?: InputMaybe<Order_By>;
  EMDEPHOS?: InputMaybe<Order_By>;
  EMDEPSYS?: InputMaybe<Order_By>;
  EMDEPVEN?: InputMaybe<Order_By>;
  EMSSHOS?: InputMaybe<Order_By>;
  EMSSSYS?: InputMaybe<Order_By>;
  EMSSVEN?: InputMaybe<Order_By>;
  ENBHOS?: InputMaybe<Order_By>;
  ENBSYS?: InputMaybe<Order_By>;
  ENBVEN?: InputMaybe<Order_By>;
  ENDOAHOS?: InputMaybe<Order_By>;
  ENDOASYS?: InputMaybe<Order_By>;
  ENDOAVEN?: InputMaybe<Order_By>;
  ENDOCHOS?: InputMaybe<Order_By>;
  ENDOCSYS?: InputMaybe<Order_By>;
  ENDOCVEN?: InputMaybe<Order_By>;
  ENDOEHOS?: InputMaybe<Order_By>;
  ENDOESYS?: InputMaybe<Order_By>;
  ENDOEVEN?: InputMaybe<Order_By>;
  ENDORHOS?: InputMaybe<Order_By>;
  ENDORSYS?: InputMaybe<Order_By>;
  ENDORVEN?: InputMaybe<Order_By>;
  ENDOUHOS?: InputMaybe<Order_By>;
  ENDOUSYS?: InputMaybe<Order_By>;
  ENDOUVEN?: InputMaybe<Order_By>;
  ENRHOS?: InputMaybe<Order_By>;
  ENRSYS?: InputMaybe<Order_By>;
  ENRVEN?: InputMaybe<Order_By>;
  ESWLHOS?: InputMaybe<Order_By>;
  ESWLSYS?: InputMaybe<Order_By>;
  ESWLVEN?: InputMaybe<Order_By>;
  FITCHOS?: InputMaybe<Order_By>;
  FITCSYS?: InputMaybe<Order_By>;
  FITCVEN?: InputMaybe<Order_By>;
  FRTCHOS?: InputMaybe<Order_By>;
  FRTCSYS?: InputMaybe<Order_By>;
  FRTCVEN?: InputMaybe<Order_By>;
  FSERHOS?: InputMaybe<Order_By>;
  FSERSYS?: InputMaybe<Order_By>;
  FSERVEN?: InputMaybe<Order_By>;
  GENBD?: InputMaybe<Order_By>;
  GENHOS?: InputMaybe<Order_By>;
  GENSYS?: InputMaybe<Order_By>;
  GENVEN?: InputMaybe<Order_By>;
  GERSVHOS?: InputMaybe<Order_By>;
  GERSVSYS?: InputMaybe<Order_By>;
  GERSVVEN?: InputMaybe<Order_By>;
  HOSPBD?: InputMaybe<Order_By>;
  ICFBD88?: InputMaybe<Order_By>;
  ICFHOS?: InputMaybe<Order_By>;
  ICFSYS?: InputMaybe<Order_By>;
  ICFVEN?: InputMaybe<Order_By>;
  ICLABHOS?: InputMaybe<Order_By>;
  ICLABSYS?: InputMaybe<Order_By>;
  ICLABVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  MAMMSHOS?: InputMaybe<Order_By>;
  MAMMSSYS?: InputMaybe<Order_By>;
  MAMMSVEN?: InputMaybe<Order_By>;
  MSICBD?: InputMaybe<Order_By>;
  MSICHOS?: InputMaybe<Order_By>;
  MSICSYS?: InputMaybe<Order_By>;
  MSICVEN?: InputMaybe<Order_By>;
  NICBD?: InputMaybe<Order_By>;
  NICHOS?: InputMaybe<Order_By>;
  NICSYS?: InputMaybe<Order_By>;
  NICVEN?: InputMaybe<Order_By>;
  NINTBD?: InputMaybe<Order_By>;
  NINTHOS?: InputMaybe<Order_By>;
  NINTSYS?: InputMaybe<Order_By>;
  NINTVEN?: InputMaybe<Order_By>;
  OBBD?: InputMaybe<Order_By>;
  OBHOS?: InputMaybe<Order_By>;
  OBLEV?: InputMaybe<Order_By>;
  OBSYS?: InputMaybe<Order_By>;
  OBVEN?: InputMaybe<Order_By>;
  OPCENHOS?: InputMaybe<Order_By>;
  OPCENSYS?: InputMaybe<Order_By>;
  OPCENVEN?: InputMaybe<Order_By>;
  OSPOTH?: InputMaybe<Order_By>;
  OTHBD94?: InputMaybe<Order_By>;
  OTHCRHOS?: InputMaybe<Order_By>;
  OTHCRSYS?: InputMaybe<Order_By>;
  OTHCRVEN?: InputMaybe<Order_By>;
  OTHIC?: InputMaybe<Order_By>;
  OTHICBD?: InputMaybe<Order_By>;
  OTHIHOS?: InputMaybe<Order_By>;
  OTHISYS?: InputMaybe<Order_By>;
  OTHIVEN?: InputMaybe<Order_By>;
  OTHLBD94?: InputMaybe<Order_By>;
  OTHLTHOS?: InputMaybe<Order_By>;
  OTHLTSYS?: InputMaybe<Order_By>;
  OTHLTVEN?: InputMaybe<Order_By>;
  OTHOTH?: InputMaybe<Order_By>;
  PCARDHOS?: InputMaybe<Order_By>;
  PCARDSYS?: InputMaybe<Order_By>;
  PCARDVEN?: InputMaybe<Order_By>;
  PCLABHOS?: InputMaybe<Order_By>;
  PCLABSYS?: InputMaybe<Order_By>;
  PCLABVEN?: InputMaybe<Order_By>;
  PEDBD?: InputMaybe<Order_By>;
  PEDCSHOS?: InputMaybe<Order_By>;
  PEDCSSYS?: InputMaybe<Order_By>;
  PEDCSVEN?: InputMaybe<Order_By>;
  PEDEHOS?: InputMaybe<Order_By>;
  PEDESYS?: InputMaybe<Order_By>;
  PEDEVEN?: InputMaybe<Order_By>;
  PEDHOS?: InputMaybe<Order_By>;
  PEDICBD?: InputMaybe<Order_By>;
  PEDICHOS?: InputMaybe<Order_By>;
  PEDICSYS?: InputMaybe<Order_By>;
  PEDICVEN?: InputMaybe<Order_By>;
  PEDSYS?: InputMaybe<Order_By>;
  PEDVEN?: InputMaybe<Order_By>;
  PELABHOS?: InputMaybe<Order_By>;
  PELABSYS?: InputMaybe<Order_By>;
  PELABVEN?: InputMaybe<Order_By>;
  PEMERHOS?: InputMaybe<Order_By>;
  PEMERSYS?: InputMaybe<Order_By>;
  PEMERVEN?: InputMaybe<Order_By>;
  PSYBD?: InputMaybe<Order_By>;
  PSYHOS?: InputMaybe<Order_By>;
  PSYSYS?: InputMaybe<Order_By>;
  PSYVEN?: InputMaybe<Order_By>;
  REHABBD?: InputMaybe<Order_By>;
  REHABHOS?: InputMaybe<Order_By>;
  REHABSYS?: InputMaybe<Order_By>;
  REHABVEN?: InputMaybe<Order_By>;
  SNBD88?: InputMaybe<Order_By>;
  SNHOS?: InputMaybe<Order_By>;
  SNSYS?: InputMaybe<Order_By>;
  SNVEN?: InputMaybe<Order_By>;
  SPCICBD?: InputMaybe<Order_By>;
  SPCICHOS?: InputMaybe<Order_By>;
  SPCICSYS?: InputMaybe<Order_By>;
  SPCICVEN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  TRAUMHOS?: InputMaybe<Order_By>;
  TRAUML90?: InputMaybe<Order_By>;
  TRAUMSYS?: InputMaybe<Order_By>;
  TRAUMVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS20SVC1 */
export type As20Svc1_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS20SVC1" */
export enum As20Svc1_Select_Column {
  /** column name */
  Acardhos = 'ACARDHOS',
  /** column name */
  Acardsys = 'ACARDSYS',
  /** column name */
  Acardven = 'ACARDVEN',
  /** column name */
  Aclabhos = 'ACLABHOS',
  /** column name */
  Aclabsys = 'ACLABSYS',
  /** column name */
  Aclabven = 'ACLABVEN',
  /** column name */
  Acuhos = 'ACUHOS',
  /** column name */
  Acultbd = 'ACULTBD',
  /** column name */
  Acusys = 'ACUSYS',
  /** column name */
  Acuven = 'ACUVEN',
  /** column name */
  Adtchos = 'ADTCHOS',
  /** column name */
  Adtcsys = 'ADTCSYS',
  /** column name */
  Adtcven = 'ADTCVEN',
  /** column name */
  Adtehos = 'ADTEHOS',
  /** column name */
  Adtesys = 'ADTESYS',
  /** column name */
  Adteven = 'ADTEVEN',
  /** column name */
  Adulthos = 'ADULTHOS',
  /** column name */
  Adultsys = 'ADULTSYS',
  /** column name */
  Adultven = 'ADULTVEN',
  /** column name */
  Airbhos = 'AIRBHOS',
  /** column name */
  Airbroom = 'AIRBROOM',
  /** column name */
  Airbsys = 'AIRBSYS',
  /** column name */
  Airbven = 'AIRBVEN',
  /** column name */
  Alchbd = 'ALCHBD',
  /** column name */
  Alchhos = 'ALCHHOS',
  /** column name */
  Alchsys = 'ALCHSYS',
  /** column name */
  Alchven = 'ALCHVEN',
  /** column name */
  Alzhos = 'ALZHOS',
  /** column name */
  Alzsys = 'ALZSYS',
  /** column name */
  Alzven = 'ALZVEN',
  /** column name */
  Ambahos = 'AMBAHOS',
  /** column name */
  Ambasys = 'AMBASYS',
  /** column name */
  Ambaven = 'AMBAVEN',
  /** column name */
  Ambhos = 'AMBHOS',
  /** column name */
  Ambshos = 'AMBSHOS',
  /** column name */
  Ambssys = 'AMBSSYS',
  /** column name */
  Ambsven = 'AMBSVEN',
  /** column name */
  Ambsys = 'AMBSYS',
  /** column name */
  Ambven = 'AMBVEN',
  /** column name */
  Arthchos = 'ARTHCHOS',
  /** column name */
  Arthcsys = 'ARTHCSYS',
  /** column name */
  Arthcven = 'ARTHCVEN',
  /** column name */
  Auxhos = 'AUXHOS',
  /** column name */
  Auxsys = 'AUXSYS',
  /** column name */
  Auxven = 'AUXVEN',
  /** column name */
  Bldohos = 'BLDOHOS',
  /** column name */
  Bldosys = 'BLDOSYS',
  /** column name */
  Bldoven = 'BLDOVEN',
  /** column name */
  Brnbd = 'BRNBD',
  /** column name */
  Brnhos = 'BRNHOS',
  /** column name */
  Brnsys = 'BRNSYS',
  /** column name */
  Brnven = 'BRNVEN',
  /** column name */
  Broomhos = 'BROOMHOS',
  /** column name */
  Broomsys = 'BROOMSYS',
  /** column name */
  Broomven = 'BROOMVEN',
  /** column name */
  Bwhthos = 'BWHTHOS',
  /** column name */
  Bwhtsys = 'BWHTSYS',
  /** column name */
  Bwhtven = 'BWHTVEN',
  /** column name */
  Caoshos = 'CAOSHOS',
  /** column name */
  Caossys = 'CAOSSYS',
  /** column name */
  Caosven = 'CAOSVEN',
  /** column name */
  Chabhos = 'CHABHOS',
  /** column name */
  Chabsys = 'CHABSYS',
  /** column name */
  Chabven = 'CHABVEN',
  /** column name */
  Chaphos = 'CHAPHOS',
  /** column name */
  Chapsys = 'CHAPSYS',
  /** column name */
  Chapven = 'CHAPVEN',
  /** column name */
  Chihos = 'CHIHOS',
  /** column name */
  Chisys = 'CHISYS',
  /** column name */
  Chiven = 'CHIVEN',
  /** column name */
  Chthhos = 'CHTHHOS',
  /** column name */
  Chthsys = 'CHTHSYS',
  /** column name */
  Chthven = 'CHTHVEN',
  /** column name */
  Cicbd = 'CICBD',
  /** column name */
  Cichos = 'CICHOS',
  /** column name */
  Cicsys = 'CICSYS',
  /** column name */
  Cicven = 'CICVEN',
  /** column name */
  Cmngthos = 'CMNGTHOS',
  /** column name */
  Cmngtsys = 'CMNGTSYS',
  /** column name */
  Cmngtven = 'CMNGTVEN',
  /** column name */
  Comphos = 'COMPHOS',
  /** column name */
  Compsys = 'COMPSYS',
  /** column name */
  Compven = 'COMPVEN',
  /** column name */
  Coutrhos = 'COUTRHOS',
  /** column name */
  Coutrsys = 'COUTRSYS',
  /** column name */
  Coutrven = 'COUTRVEN',
  /** column name */
  Cprevhos = 'CPREVHOS',
  /** column name */
  Cprevsys = 'CPREVSYS',
  /** column name */
  Cprevven = 'CPREVVEN',
  /** column name */
  Cwellhos = 'CWELLHOS',
  /** column name */
  Cwellsys = 'CWELLSYS',
  /** column name */
  Cwellven = 'CWELLVEN',
  /** column name */
  Dentshos = 'DENTSHOS',
  /** column name */
  Dentssys = 'DENTSSYS',
  /** column name */
  Dentsven = 'DENTSVEN',
  /** column name */
  Dpphos = 'DPPHOS',
  /** column name */
  Dppsys = 'DPPSYS',
  /** column name */
  Dppven = 'DPPVEN',
  /** column name */
  Emdephos = 'EMDEPHOS',
  /** column name */
  Emdepsys = 'EMDEPSYS',
  /** column name */
  Emdepven = 'EMDEPVEN',
  /** column name */
  Emsshos = 'EMSSHOS',
  /** column name */
  Emsssys = 'EMSSSYS',
  /** column name */
  Emssven = 'EMSSVEN',
  /** column name */
  Enbhos = 'ENBHOS',
  /** column name */
  Enbsys = 'ENBSYS',
  /** column name */
  Enbven = 'ENBVEN',
  /** column name */
  Endoahos = 'ENDOAHOS',
  /** column name */
  Endoasys = 'ENDOASYS',
  /** column name */
  Endoaven = 'ENDOAVEN',
  /** column name */
  Endochos = 'ENDOCHOS',
  /** column name */
  Endocsys = 'ENDOCSYS',
  /** column name */
  Endocven = 'ENDOCVEN',
  /** column name */
  Endoehos = 'ENDOEHOS',
  /** column name */
  Endoesys = 'ENDOESYS',
  /** column name */
  Endoeven = 'ENDOEVEN',
  /** column name */
  Endorhos = 'ENDORHOS',
  /** column name */
  Endorsys = 'ENDORSYS',
  /** column name */
  Endorven = 'ENDORVEN',
  /** column name */
  Endouhos = 'ENDOUHOS',
  /** column name */
  Endousys = 'ENDOUSYS',
  /** column name */
  Endouven = 'ENDOUVEN',
  /** column name */
  Enrhos = 'ENRHOS',
  /** column name */
  Enrsys = 'ENRSYS',
  /** column name */
  Enrven = 'ENRVEN',
  /** column name */
  Eswlhos = 'ESWLHOS',
  /** column name */
  Eswlsys = 'ESWLSYS',
  /** column name */
  Eswlven = 'ESWLVEN',
  /** column name */
  Fitchos = 'FITCHOS',
  /** column name */
  Fitcsys = 'FITCSYS',
  /** column name */
  Fitcven = 'FITCVEN',
  /** column name */
  Frtchos = 'FRTCHOS',
  /** column name */
  Frtcsys = 'FRTCSYS',
  /** column name */
  Frtcven = 'FRTCVEN',
  /** column name */
  Fserhos = 'FSERHOS',
  /** column name */
  Fsersys = 'FSERSYS',
  /** column name */
  Fserven = 'FSERVEN',
  /** column name */
  Genbd = 'GENBD',
  /** column name */
  Genhos = 'GENHOS',
  /** column name */
  Gensys = 'GENSYS',
  /** column name */
  Genven = 'GENVEN',
  /** column name */
  Gersvhos = 'GERSVHOS',
  /** column name */
  Gersvsys = 'GERSVSYS',
  /** column name */
  Gersvven = 'GERSVVEN',
  /** column name */
  Hospbd = 'HOSPBD',
  /** column name */
  Icfbd88 = 'ICFBD88',
  /** column name */
  Icfhos = 'ICFHOS',
  /** column name */
  Icfsys = 'ICFSYS',
  /** column name */
  Icfven = 'ICFVEN',
  /** column name */
  Iclabhos = 'ICLABHOS',
  /** column name */
  Iclabsys = 'ICLABSYS',
  /** column name */
  Iclabven = 'ICLABVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Mammshos = 'MAMMSHOS',
  /** column name */
  Mammssys = 'MAMMSSYS',
  /** column name */
  Mammsven = 'MAMMSVEN',
  /** column name */
  Msicbd = 'MSICBD',
  /** column name */
  Msichos = 'MSICHOS',
  /** column name */
  Msicsys = 'MSICSYS',
  /** column name */
  Msicven = 'MSICVEN',
  /** column name */
  Nicbd = 'NICBD',
  /** column name */
  Nichos = 'NICHOS',
  /** column name */
  Nicsys = 'NICSYS',
  /** column name */
  Nicven = 'NICVEN',
  /** column name */
  Nintbd = 'NINTBD',
  /** column name */
  Ninthos = 'NINTHOS',
  /** column name */
  Nintsys = 'NINTSYS',
  /** column name */
  Nintven = 'NINTVEN',
  /** column name */
  Obbd = 'OBBD',
  /** column name */
  Obhos = 'OBHOS',
  /** column name */
  Oblev = 'OBLEV',
  /** column name */
  Obsys = 'OBSYS',
  /** column name */
  Obven = 'OBVEN',
  /** column name */
  Opcenhos = 'OPCENHOS',
  /** column name */
  Opcensys = 'OPCENSYS',
  /** column name */
  Opcenven = 'OPCENVEN',
  /** column name */
  Ospoth = 'OSPOTH',
  /** column name */
  Othbd94 = 'OTHBD94',
  /** column name */
  Othcrhos = 'OTHCRHOS',
  /** column name */
  Othcrsys = 'OTHCRSYS',
  /** column name */
  Othcrven = 'OTHCRVEN',
  /** column name */
  Othic = 'OTHIC',
  /** column name */
  Othicbd = 'OTHICBD',
  /** column name */
  Othihos = 'OTHIHOS',
  /** column name */
  Othisys = 'OTHISYS',
  /** column name */
  Othiven = 'OTHIVEN',
  /** column name */
  Othlbd94 = 'OTHLBD94',
  /** column name */
  Othlthos = 'OTHLTHOS',
  /** column name */
  Othltsys = 'OTHLTSYS',
  /** column name */
  Othltven = 'OTHLTVEN',
  /** column name */
  Othoth = 'OTHOTH',
  /** column name */
  Pcardhos = 'PCARDHOS',
  /** column name */
  Pcardsys = 'PCARDSYS',
  /** column name */
  Pcardven = 'PCARDVEN',
  /** column name */
  Pclabhos = 'PCLABHOS',
  /** column name */
  Pclabsys = 'PCLABSYS',
  /** column name */
  Pclabven = 'PCLABVEN',
  /** column name */
  Pedbd = 'PEDBD',
  /** column name */
  Pedcshos = 'PEDCSHOS',
  /** column name */
  Pedcssys = 'PEDCSSYS',
  /** column name */
  Pedcsven = 'PEDCSVEN',
  /** column name */
  Pedehos = 'PEDEHOS',
  /** column name */
  Pedesys = 'PEDESYS',
  /** column name */
  Pedeven = 'PEDEVEN',
  /** column name */
  Pedhos = 'PEDHOS',
  /** column name */
  Pedicbd = 'PEDICBD',
  /** column name */
  Pedichos = 'PEDICHOS',
  /** column name */
  Pedicsys = 'PEDICSYS',
  /** column name */
  Pedicven = 'PEDICVEN',
  /** column name */
  Pedsys = 'PEDSYS',
  /** column name */
  Pedven = 'PEDVEN',
  /** column name */
  Pelabhos = 'PELABHOS',
  /** column name */
  Pelabsys = 'PELABSYS',
  /** column name */
  Pelabven = 'PELABVEN',
  /** column name */
  Pemerhos = 'PEMERHOS',
  /** column name */
  Pemersys = 'PEMERSYS',
  /** column name */
  Pemerven = 'PEMERVEN',
  /** column name */
  Psybd = 'PSYBD',
  /** column name */
  Psyhos = 'PSYHOS',
  /** column name */
  Psysys = 'PSYSYS',
  /** column name */
  Psyven = 'PSYVEN',
  /** column name */
  Rehabbd = 'REHABBD',
  /** column name */
  Rehabhos = 'REHABHOS',
  /** column name */
  Rehabsys = 'REHABSYS',
  /** column name */
  Rehabven = 'REHABVEN',
  /** column name */
  Snbd88 = 'SNBD88',
  /** column name */
  Snhos = 'SNHOS',
  /** column name */
  Snsys = 'SNSYS',
  /** column name */
  Snven = 'SNVEN',
  /** column name */
  Spcicbd = 'SPCICBD',
  /** column name */
  Spcichos = 'SPCICHOS',
  /** column name */
  Spcicsys = 'SPCICSYS',
  /** column name */
  Spcicven = 'SPCICVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Traumhos = 'TRAUMHOS',
  /** column name */
  Trauml90 = 'TRAUML90',
  /** column name */
  Traumsys = 'TRAUMSYS',
  /** column name */
  Traumven = 'TRAUMVEN'
}

/** input type for updating data in table "AS20SVC1" */
export type As20Svc1_Set_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As20Svc1_Stddev_Fields = {
  __typename?: 'AS20SVC1_stddev_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As20Svc1_Stddev_Pop_Fields = {
  __typename?: 'AS20SVC1_stddev_pop_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As20Svc1_Stddev_Samp_Fields = {
  __typename?: 'AS20SVC1_stddev_samp_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS20SVC1" */
export type As20Svc1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As20Svc1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As20Svc1_Stream_Cursor_Value_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As20Svc1_Sum_Fields = {
  __typename?: 'AS20SVC1_sum_fields';
  ACULTBD: Maybe<Scalars['float8']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  ALCHBD: Maybe<Scalars['float8']>;
  BRNBD: Maybe<Scalars['float8']>;
  CICBD: Maybe<Scalars['float8']>;
  GENBD: Maybe<Scalars['float8']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  MSICBD: Maybe<Scalars['float8']>;
  NICBD: Maybe<Scalars['float8']>;
  NINTBD: Maybe<Scalars['float8']>;
  OBBD: Maybe<Scalars['float8']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PSYBD: Maybe<Scalars['float8']>;
  REHABBD: Maybe<Scalars['float8']>;
  SNBD88: Maybe<Scalars['float8']>;
  SPCICBD: Maybe<Scalars['float8']>;
};

/** update columns of table "AS20SVC1" */
export enum As20Svc1_Update_Column {
  /** column name */
  Acardhos = 'ACARDHOS',
  /** column name */
  Acardsys = 'ACARDSYS',
  /** column name */
  Acardven = 'ACARDVEN',
  /** column name */
  Aclabhos = 'ACLABHOS',
  /** column name */
  Aclabsys = 'ACLABSYS',
  /** column name */
  Aclabven = 'ACLABVEN',
  /** column name */
  Acuhos = 'ACUHOS',
  /** column name */
  Acultbd = 'ACULTBD',
  /** column name */
  Acusys = 'ACUSYS',
  /** column name */
  Acuven = 'ACUVEN',
  /** column name */
  Adtchos = 'ADTCHOS',
  /** column name */
  Adtcsys = 'ADTCSYS',
  /** column name */
  Adtcven = 'ADTCVEN',
  /** column name */
  Adtehos = 'ADTEHOS',
  /** column name */
  Adtesys = 'ADTESYS',
  /** column name */
  Adteven = 'ADTEVEN',
  /** column name */
  Adulthos = 'ADULTHOS',
  /** column name */
  Adultsys = 'ADULTSYS',
  /** column name */
  Adultven = 'ADULTVEN',
  /** column name */
  Airbhos = 'AIRBHOS',
  /** column name */
  Airbroom = 'AIRBROOM',
  /** column name */
  Airbsys = 'AIRBSYS',
  /** column name */
  Airbven = 'AIRBVEN',
  /** column name */
  Alchbd = 'ALCHBD',
  /** column name */
  Alchhos = 'ALCHHOS',
  /** column name */
  Alchsys = 'ALCHSYS',
  /** column name */
  Alchven = 'ALCHVEN',
  /** column name */
  Alzhos = 'ALZHOS',
  /** column name */
  Alzsys = 'ALZSYS',
  /** column name */
  Alzven = 'ALZVEN',
  /** column name */
  Ambahos = 'AMBAHOS',
  /** column name */
  Ambasys = 'AMBASYS',
  /** column name */
  Ambaven = 'AMBAVEN',
  /** column name */
  Ambhos = 'AMBHOS',
  /** column name */
  Ambshos = 'AMBSHOS',
  /** column name */
  Ambssys = 'AMBSSYS',
  /** column name */
  Ambsven = 'AMBSVEN',
  /** column name */
  Ambsys = 'AMBSYS',
  /** column name */
  Ambven = 'AMBVEN',
  /** column name */
  Arthchos = 'ARTHCHOS',
  /** column name */
  Arthcsys = 'ARTHCSYS',
  /** column name */
  Arthcven = 'ARTHCVEN',
  /** column name */
  Auxhos = 'AUXHOS',
  /** column name */
  Auxsys = 'AUXSYS',
  /** column name */
  Auxven = 'AUXVEN',
  /** column name */
  Bldohos = 'BLDOHOS',
  /** column name */
  Bldosys = 'BLDOSYS',
  /** column name */
  Bldoven = 'BLDOVEN',
  /** column name */
  Brnbd = 'BRNBD',
  /** column name */
  Brnhos = 'BRNHOS',
  /** column name */
  Brnsys = 'BRNSYS',
  /** column name */
  Brnven = 'BRNVEN',
  /** column name */
  Broomhos = 'BROOMHOS',
  /** column name */
  Broomsys = 'BROOMSYS',
  /** column name */
  Broomven = 'BROOMVEN',
  /** column name */
  Bwhthos = 'BWHTHOS',
  /** column name */
  Bwhtsys = 'BWHTSYS',
  /** column name */
  Bwhtven = 'BWHTVEN',
  /** column name */
  Caoshos = 'CAOSHOS',
  /** column name */
  Caossys = 'CAOSSYS',
  /** column name */
  Caosven = 'CAOSVEN',
  /** column name */
  Chabhos = 'CHABHOS',
  /** column name */
  Chabsys = 'CHABSYS',
  /** column name */
  Chabven = 'CHABVEN',
  /** column name */
  Chaphos = 'CHAPHOS',
  /** column name */
  Chapsys = 'CHAPSYS',
  /** column name */
  Chapven = 'CHAPVEN',
  /** column name */
  Chihos = 'CHIHOS',
  /** column name */
  Chisys = 'CHISYS',
  /** column name */
  Chiven = 'CHIVEN',
  /** column name */
  Chthhos = 'CHTHHOS',
  /** column name */
  Chthsys = 'CHTHSYS',
  /** column name */
  Chthven = 'CHTHVEN',
  /** column name */
  Cicbd = 'CICBD',
  /** column name */
  Cichos = 'CICHOS',
  /** column name */
  Cicsys = 'CICSYS',
  /** column name */
  Cicven = 'CICVEN',
  /** column name */
  Cmngthos = 'CMNGTHOS',
  /** column name */
  Cmngtsys = 'CMNGTSYS',
  /** column name */
  Cmngtven = 'CMNGTVEN',
  /** column name */
  Comphos = 'COMPHOS',
  /** column name */
  Compsys = 'COMPSYS',
  /** column name */
  Compven = 'COMPVEN',
  /** column name */
  Coutrhos = 'COUTRHOS',
  /** column name */
  Coutrsys = 'COUTRSYS',
  /** column name */
  Coutrven = 'COUTRVEN',
  /** column name */
  Cprevhos = 'CPREVHOS',
  /** column name */
  Cprevsys = 'CPREVSYS',
  /** column name */
  Cprevven = 'CPREVVEN',
  /** column name */
  Cwellhos = 'CWELLHOS',
  /** column name */
  Cwellsys = 'CWELLSYS',
  /** column name */
  Cwellven = 'CWELLVEN',
  /** column name */
  Dentshos = 'DENTSHOS',
  /** column name */
  Dentssys = 'DENTSSYS',
  /** column name */
  Dentsven = 'DENTSVEN',
  /** column name */
  Dpphos = 'DPPHOS',
  /** column name */
  Dppsys = 'DPPSYS',
  /** column name */
  Dppven = 'DPPVEN',
  /** column name */
  Emdephos = 'EMDEPHOS',
  /** column name */
  Emdepsys = 'EMDEPSYS',
  /** column name */
  Emdepven = 'EMDEPVEN',
  /** column name */
  Emsshos = 'EMSSHOS',
  /** column name */
  Emsssys = 'EMSSSYS',
  /** column name */
  Emssven = 'EMSSVEN',
  /** column name */
  Enbhos = 'ENBHOS',
  /** column name */
  Enbsys = 'ENBSYS',
  /** column name */
  Enbven = 'ENBVEN',
  /** column name */
  Endoahos = 'ENDOAHOS',
  /** column name */
  Endoasys = 'ENDOASYS',
  /** column name */
  Endoaven = 'ENDOAVEN',
  /** column name */
  Endochos = 'ENDOCHOS',
  /** column name */
  Endocsys = 'ENDOCSYS',
  /** column name */
  Endocven = 'ENDOCVEN',
  /** column name */
  Endoehos = 'ENDOEHOS',
  /** column name */
  Endoesys = 'ENDOESYS',
  /** column name */
  Endoeven = 'ENDOEVEN',
  /** column name */
  Endorhos = 'ENDORHOS',
  /** column name */
  Endorsys = 'ENDORSYS',
  /** column name */
  Endorven = 'ENDORVEN',
  /** column name */
  Endouhos = 'ENDOUHOS',
  /** column name */
  Endousys = 'ENDOUSYS',
  /** column name */
  Endouven = 'ENDOUVEN',
  /** column name */
  Enrhos = 'ENRHOS',
  /** column name */
  Enrsys = 'ENRSYS',
  /** column name */
  Enrven = 'ENRVEN',
  /** column name */
  Eswlhos = 'ESWLHOS',
  /** column name */
  Eswlsys = 'ESWLSYS',
  /** column name */
  Eswlven = 'ESWLVEN',
  /** column name */
  Fitchos = 'FITCHOS',
  /** column name */
  Fitcsys = 'FITCSYS',
  /** column name */
  Fitcven = 'FITCVEN',
  /** column name */
  Frtchos = 'FRTCHOS',
  /** column name */
  Frtcsys = 'FRTCSYS',
  /** column name */
  Frtcven = 'FRTCVEN',
  /** column name */
  Fserhos = 'FSERHOS',
  /** column name */
  Fsersys = 'FSERSYS',
  /** column name */
  Fserven = 'FSERVEN',
  /** column name */
  Genbd = 'GENBD',
  /** column name */
  Genhos = 'GENHOS',
  /** column name */
  Gensys = 'GENSYS',
  /** column name */
  Genven = 'GENVEN',
  /** column name */
  Gersvhos = 'GERSVHOS',
  /** column name */
  Gersvsys = 'GERSVSYS',
  /** column name */
  Gersvven = 'GERSVVEN',
  /** column name */
  Hospbd = 'HOSPBD',
  /** column name */
  Icfbd88 = 'ICFBD88',
  /** column name */
  Icfhos = 'ICFHOS',
  /** column name */
  Icfsys = 'ICFSYS',
  /** column name */
  Icfven = 'ICFVEN',
  /** column name */
  Iclabhos = 'ICLABHOS',
  /** column name */
  Iclabsys = 'ICLABSYS',
  /** column name */
  Iclabven = 'ICLABVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Mammshos = 'MAMMSHOS',
  /** column name */
  Mammssys = 'MAMMSSYS',
  /** column name */
  Mammsven = 'MAMMSVEN',
  /** column name */
  Msicbd = 'MSICBD',
  /** column name */
  Msichos = 'MSICHOS',
  /** column name */
  Msicsys = 'MSICSYS',
  /** column name */
  Msicven = 'MSICVEN',
  /** column name */
  Nicbd = 'NICBD',
  /** column name */
  Nichos = 'NICHOS',
  /** column name */
  Nicsys = 'NICSYS',
  /** column name */
  Nicven = 'NICVEN',
  /** column name */
  Nintbd = 'NINTBD',
  /** column name */
  Ninthos = 'NINTHOS',
  /** column name */
  Nintsys = 'NINTSYS',
  /** column name */
  Nintven = 'NINTVEN',
  /** column name */
  Obbd = 'OBBD',
  /** column name */
  Obhos = 'OBHOS',
  /** column name */
  Oblev = 'OBLEV',
  /** column name */
  Obsys = 'OBSYS',
  /** column name */
  Obven = 'OBVEN',
  /** column name */
  Opcenhos = 'OPCENHOS',
  /** column name */
  Opcensys = 'OPCENSYS',
  /** column name */
  Opcenven = 'OPCENVEN',
  /** column name */
  Ospoth = 'OSPOTH',
  /** column name */
  Othbd94 = 'OTHBD94',
  /** column name */
  Othcrhos = 'OTHCRHOS',
  /** column name */
  Othcrsys = 'OTHCRSYS',
  /** column name */
  Othcrven = 'OTHCRVEN',
  /** column name */
  Othic = 'OTHIC',
  /** column name */
  Othicbd = 'OTHICBD',
  /** column name */
  Othihos = 'OTHIHOS',
  /** column name */
  Othisys = 'OTHISYS',
  /** column name */
  Othiven = 'OTHIVEN',
  /** column name */
  Othlbd94 = 'OTHLBD94',
  /** column name */
  Othlthos = 'OTHLTHOS',
  /** column name */
  Othltsys = 'OTHLTSYS',
  /** column name */
  Othltven = 'OTHLTVEN',
  /** column name */
  Othoth = 'OTHOTH',
  /** column name */
  Pcardhos = 'PCARDHOS',
  /** column name */
  Pcardsys = 'PCARDSYS',
  /** column name */
  Pcardven = 'PCARDVEN',
  /** column name */
  Pclabhos = 'PCLABHOS',
  /** column name */
  Pclabsys = 'PCLABSYS',
  /** column name */
  Pclabven = 'PCLABVEN',
  /** column name */
  Pedbd = 'PEDBD',
  /** column name */
  Pedcshos = 'PEDCSHOS',
  /** column name */
  Pedcssys = 'PEDCSSYS',
  /** column name */
  Pedcsven = 'PEDCSVEN',
  /** column name */
  Pedehos = 'PEDEHOS',
  /** column name */
  Pedesys = 'PEDESYS',
  /** column name */
  Pedeven = 'PEDEVEN',
  /** column name */
  Pedhos = 'PEDHOS',
  /** column name */
  Pedicbd = 'PEDICBD',
  /** column name */
  Pedichos = 'PEDICHOS',
  /** column name */
  Pedicsys = 'PEDICSYS',
  /** column name */
  Pedicven = 'PEDICVEN',
  /** column name */
  Pedsys = 'PEDSYS',
  /** column name */
  Pedven = 'PEDVEN',
  /** column name */
  Pelabhos = 'PELABHOS',
  /** column name */
  Pelabsys = 'PELABSYS',
  /** column name */
  Pelabven = 'PELABVEN',
  /** column name */
  Pemerhos = 'PEMERHOS',
  /** column name */
  Pemersys = 'PEMERSYS',
  /** column name */
  Pemerven = 'PEMERVEN',
  /** column name */
  Psybd = 'PSYBD',
  /** column name */
  Psyhos = 'PSYHOS',
  /** column name */
  Psysys = 'PSYSYS',
  /** column name */
  Psyven = 'PSYVEN',
  /** column name */
  Rehabbd = 'REHABBD',
  /** column name */
  Rehabhos = 'REHABHOS',
  /** column name */
  Rehabsys = 'REHABSYS',
  /** column name */
  Rehabven = 'REHABVEN',
  /** column name */
  Snbd88 = 'SNBD88',
  /** column name */
  Snhos = 'SNHOS',
  /** column name */
  Snsys = 'SNSYS',
  /** column name */
  Snven = 'SNVEN',
  /** column name */
  Spcicbd = 'SPCICBD',
  /** column name */
  Spcichos = 'SPCICHOS',
  /** column name */
  Spcicsys = 'SPCICSYS',
  /** column name */
  Spcicven = 'SPCICVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Traumhos = 'TRAUMHOS',
  /** column name */
  Trauml90 = 'TRAUML90',
  /** column name */
  Traumsys = 'TRAUMSYS',
  /** column name */
  Traumven = 'TRAUMVEN'
}

export type As20Svc1_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As20Svc1_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As20Svc1_Set_Input>;
  /** filter the rows which have to be updated */
  where: As20Svc1_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As20Svc1_Var_Pop_Fields = {
  __typename?: 'AS20SVC1_var_pop_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As20Svc1_Var_Samp_Fields = {
  __typename?: 'AS20SVC1_var_samp_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As20Svc1_Variance_Fields = {
  __typename?: 'AS20SVC1_variance_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS20SVC2" */
export type As20Svc2 = {
  __typename?: 'AS20SVC2';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS20SVC2" */
export type As20Svc2_Aggregate = {
  __typename?: 'AS20SVC2_aggregate';
  aggregate: Maybe<As20Svc2_Aggregate_Fields>;
  nodes: Array<As20Svc2>;
};

/** aggregate fields of "AS20SVC2" */
export type As20Svc2_Aggregate_Fields = {
  __typename?: 'AS20SVC2_aggregate_fields';
  avg: Maybe<As20Svc2_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As20Svc2_Max_Fields>;
  min: Maybe<As20Svc2_Min_Fields>;
  stddev: Maybe<As20Svc2_Stddev_Fields>;
  stddev_pop: Maybe<As20Svc2_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As20Svc2_Stddev_Samp_Fields>;
  sum: Maybe<As20Svc2_Sum_Fields>;
  var_pop: Maybe<As20Svc2_Var_Pop_Fields>;
  var_samp: Maybe<As20Svc2_Var_Samp_Fields>;
  variance: Maybe<As20Svc2_Variance_Fields>;
};


/** aggregate fields of "AS20SVC2" */
export type As20Svc2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As20Svc2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As20Svc2_Avg_Fields = {
  __typename?: 'AS20SVC2_avg_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS20SVC2". All fields are combined with a logical 'AND'. */
export type As20Svc2_Bool_Exp = {
  AIDSSHOS?: InputMaybe<String_Comparison_Exp>;
  AIDSSSYS?: InputMaybe<String_Comparison_Exp>;
  AIDSSVEN?: InputMaybe<String_Comparison_Exp>;
  ASSTLHOS?: InputMaybe<String_Comparison_Exp>;
  ASSTLSYS?: InputMaybe<String_Comparison_Exp>;
  ASSTLVEN?: InputMaybe<String_Comparison_Exp>;
  BEAMHOS?: InputMaybe<String_Comparison_Exp>;
  BEAMSYS?: InputMaybe<String_Comparison_Exp>;
  BEAMVEN?: InputMaybe<String_Comparison_Exp>;
  BRADHOS?: InputMaybe<String_Comparison_Exp>;
  BRADSYS?: InputMaybe<String_Comparison_Exp>;
  BRADVEN?: InputMaybe<String_Comparison_Exp>;
  CTSCNHOS?: InputMaybe<String_Comparison_Exp>;
  CTSCNSYS?: InputMaybe<String_Comparison_Exp>;
  CTSCNVEN?: InputMaybe<String_Comparison_Exp>;
  DRADFHOS?: InputMaybe<String_Comparison_Exp>;
  DRADFSYS?: InputMaybe<String_Comparison_Exp>;
  DRADFVEN?: InputMaybe<String_Comparison_Exp>;
  EBCTHOS?: InputMaybe<String_Comparison_Exp>;
  EBCTSYS?: InputMaybe<String_Comparison_Exp>;
  EBCTVEN?: InputMaybe<String_Comparison_Exp>;
  FFDMHOS?: InputMaybe<String_Comparison_Exp>;
  FFDMSYS?: InputMaybe<String_Comparison_Exp>;
  FFDMVEN?: InputMaybe<String_Comparison_Exp>;
  GNTCHOS?: InputMaybe<String_Comparison_Exp>;
  GNTCSYS?: InputMaybe<String_Comparison_Exp>;
  GNTCVEN?: InputMaybe<String_Comparison_Exp>;
  HEMOHOS?: InputMaybe<String_Comparison_Exp>;
  HEMOSYS?: InputMaybe<String_Comparison_Exp>;
  HEMOVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHCHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHCSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHCVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHFHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHFSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHFVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHSHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHSSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHSVEN?: InputMaybe<String_Comparison_Exp>;
  HLTRHOS?: InputMaybe<String_Comparison_Exp>;
  HLTRSYS?: InputMaybe<String_Comparison_Exp>;
  HLTRVEN?: InputMaybe<String_Comparison_Exp>;
  HOMEHHOS?: InputMaybe<String_Comparison_Exp>;
  HOMEHSYS?: InputMaybe<String_Comparison_Exp>;
  HOMEHVEN?: InputMaybe<String_Comparison_Exp>;
  HOSPCHOS?: InputMaybe<String_Comparison_Exp>;
  HOSPCSYS?: InputMaybe<String_Comparison_Exp>;
  HOSPCVEN?: InputMaybe<String_Comparison_Exp>;
  ICARHOS?: InputMaybe<String_Comparison_Exp>;
  ICARSYS?: InputMaybe<String_Comparison_Exp>;
  ICARVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IGRTHOS?: InputMaybe<String_Comparison_Exp>;
  IGRTSYS?: InputMaybe<String_Comparison_Exp>;
  IGRTVEN?: InputMaybe<String_Comparison_Exp>;
  IMPRHOS?: InputMaybe<String_Comparison_Exp>;
  IMPRSYS?: InputMaybe<String_Comparison_Exp>;
  IMPRVEN?: InputMaybe<String_Comparison_Exp>;
  IMRIHOS?: InputMaybe<String_Comparison_Exp>;
  IMRISYS?: InputMaybe<String_Comparison_Exp>;
  IMRIVEN?: InputMaybe<String_Comparison_Exp>;
  IMRTHOS?: InputMaybe<String_Comparison_Exp>;
  IMRTSYS?: InputMaybe<String_Comparison_Exp>;
  IMRTVEN?: InputMaybe<String_Comparison_Exp>;
  IPALHOS?: InputMaybe<String_Comparison_Exp>;
  IPALSYS?: InputMaybe<String_Comparison_Exp>;
  IPALVEN?: InputMaybe<String_Comparison_Exp>;
  LINGHOS?: InputMaybe<String_Comparison_Exp>;
  LINGSYS?: InputMaybe<String_Comparison_Exp>;
  LINGVEN?: InputMaybe<String_Comparison_Exp>;
  MEALSHOS?: InputMaybe<String_Comparison_Exp>;
  MEALSSYS?: InputMaybe<String_Comparison_Exp>;
  MEALSVEN?: InputMaybe<String_Comparison_Exp>;
  MEGHOS?: InputMaybe<String_Comparison_Exp>;
  MEGSYS?: InputMaybe<String_Comparison_Exp>;
  MEGVEN?: InputMaybe<String_Comparison_Exp>;
  MOHSHOS?: InputMaybe<String_Comparison_Exp>;
  MOHSSYS?: InputMaybe<String_Comparison_Exp>;
  MOHSVEN?: InputMaybe<String_Comparison_Exp>;
  MRIHOS?: InputMaybe<String_Comparison_Exp>;
  MRISYS?: InputMaybe<String_Comparison_Exp>;
  MRIVEN?: InputMaybe<String_Comparison_Exp>;
  MSCTGHOS?: InputMaybe<String_Comparison_Exp>;
  MSCTGSYS?: InputMaybe<String_Comparison_Exp>;
  MSCTGVEN?: InputMaybe<String_Comparison_Exp>;
  MSCTHOS?: InputMaybe<String_Comparison_Exp>;
  MSCTSYS?: InputMaybe<String_Comparison_Exp>;
  MSCTVEN?: InputMaybe<String_Comparison_Exp>;
  NEROHOS?: InputMaybe<String_Comparison_Exp>;
  NEROSYS?: InputMaybe<String_Comparison_Exp>;
  NEROVEN?: InputMaybe<String_Comparison_Exp>;
  NUTRPHOS?: InputMaybe<String_Comparison_Exp>;
  NUTRPSYS?: InputMaybe<String_Comparison_Exp>;
  NUTRPVEN?: InputMaybe<String_Comparison_Exp>;
  OCCHSHOS?: InputMaybe<String_Comparison_Exp>;
  OCCHSSYS?: InputMaybe<String_Comparison_Exp>;
  OCCHSVEN?: InputMaybe<String_Comparison_Exp>;
  ONCOLHOS?: InputMaybe<String_Comparison_Exp>;
  ONCOLSYS?: InputMaybe<String_Comparison_Exp>;
  ONCOLVEN?: InputMaybe<String_Comparison_Exp>;
  OPHOSHOS?: InputMaybe<String_Comparison_Exp>;
  OPHOSSYS?: InputMaybe<String_Comparison_Exp>;
  OPHOSVEN?: InputMaybe<String_Comparison_Exp>;
  OPSRGHOS?: InputMaybe<String_Comparison_Exp>;
  OPSRGSYS?: InputMaybe<String_Comparison_Exp>;
  OPSRGVEN?: InputMaybe<String_Comparison_Exp>;
  ORTOHOS?: InputMaybe<String_Comparison_Exp>;
  ORTOSYS?: InputMaybe<String_Comparison_Exp>;
  ORTOVEN?: InputMaybe<String_Comparison_Exp>;
  PAINHOS?: InputMaybe<String_Comparison_Exp>;
  PAINSYS?: InputMaybe<String_Comparison_Exp>;
  PAINVEN?: InputMaybe<String_Comparison_Exp>;
  PALHOS?: InputMaybe<String_Comparison_Exp>;
  PALSYS?: InputMaybe<String_Comparison_Exp>;
  PALVEN?: InputMaybe<String_Comparison_Exp>;
  PATEDHOS?: InputMaybe<String_Comparison_Exp>;
  PATEDSYS?: InputMaybe<String_Comparison_Exp>;
  PATEDVEN?: InputMaybe<String_Comparison_Exp>;
  PATRPHOS?: InputMaybe<String_Comparison_Exp>;
  PATRPSYS?: InputMaybe<String_Comparison_Exp>;
  PATRPVEN?: InputMaybe<String_Comparison_Exp>;
  PCAHOS?: InputMaybe<String_Comparison_Exp>;
  PCASYS?: InputMaybe<String_Comparison_Exp>;
  PCAVEN?: InputMaybe<String_Comparison_Exp>;
  PCDEPHOS?: InputMaybe<String_Comparison_Exp>;
  PCDEPSYS?: InputMaybe<String_Comparison_Exp>;
  PCDEPVEN?: InputMaybe<String_Comparison_Exp>;
  PETCTHOS?: InputMaybe<String_Comparison_Exp>;
  PETCTSYS?: InputMaybe<String_Comparison_Exp>;
  PETCTVEN?: InputMaybe<String_Comparison_Exp>;
  PETHOS?: InputMaybe<String_Comparison_Exp>;
  PETSYS?: InputMaybe<String_Comparison_Exp>;
  PETVEN?: InputMaybe<String_Comparison_Exp>;
  PPNHOS?: InputMaybe<String_Comparison_Exp>;
  PPNSYS?: InputMaybe<String_Comparison_Exp>;
  PPNVEN?: InputMaybe<String_Comparison_Exp>;
  PSCBD?: InputMaybe<Float8_Comparison_Exp>;
  PSCISHOS?: InputMaybe<String_Comparison_Exp>;
  PSCISSYS?: InputMaybe<String_Comparison_Exp>;
  PSCISVEN?: InputMaybe<String_Comparison_Exp>;
  PSGBD?: InputMaybe<Float8_Comparison_Exp>;
  PSPIHOS?: InputMaybe<String_Comparison_Exp>;
  PSPISYS?: InputMaybe<String_Comparison_Exp>;
  PSPIVEN?: InputMaybe<String_Comparison_Exp>;
  PSSOCHOS?: InputMaybe<String_Comparison_Exp>;
  PSSOCSYS?: InputMaybe<String_Comparison_Exp>;
  PSSOCVEN?: InputMaybe<String_Comparison_Exp>;
  PSYCAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYCASYS?: InputMaybe<String_Comparison_Exp>;
  PSYCAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYEDHOS?: InputMaybe<String_Comparison_Exp>;
  PSYEDSYS?: InputMaybe<String_Comparison_Exp>;
  PSYEDVEN?: InputMaybe<String_Comparison_Exp>;
  PSYEMHOS?: InputMaybe<String_Comparison_Exp>;
  PSYEMSYS?: InputMaybe<String_Comparison_Exp>;
  PSYEMVEN?: InputMaybe<String_Comparison_Exp>;
  PSYGRHOS?: InputMaybe<String_Comparison_Exp>;
  PSYGRSYS?: InputMaybe<String_Comparison_Exp>;
  PSYGRVEN?: InputMaybe<String_Comparison_Exp>;
  PSYLSHOS?: InputMaybe<String_Comparison_Exp>;
  PSYLSSYS?: InputMaybe<String_Comparison_Exp>;
  PSYLSVEN?: InputMaybe<String_Comparison_Exp>;
  PSYOIHOS?: InputMaybe<String_Comparison_Exp>;
  PSYOISYS?: InputMaybe<String_Comparison_Exp>;
  PSYOIVEN?: InputMaybe<String_Comparison_Exp>;
  PSYOPHOS?: InputMaybe<String_Comparison_Exp>;
  PSYOPSYS?: InputMaybe<String_Comparison_Exp>;
  PSYOPVEN?: InputMaybe<String_Comparison_Exp>;
  PSYPHAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYPHASYS?: InputMaybe<String_Comparison_Exp>;
  PSYPHAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYPHCHOS?: InputMaybe<String_Comparison_Exp>;
  PSYPHCSYS?: InputMaybe<String_Comparison_Exp>;
  PSYPHCVEN?: InputMaybe<String_Comparison_Exp>;
  PSYTRAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYTRASYS?: InputMaybe<String_Comparison_Exp>;
  PSYTRAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYTRPHOS?: InputMaybe<String_Comparison_Exp>;
  PSYTRPSYS?: InputMaybe<String_Comparison_Exp>;
  PSYTRPVEN?: InputMaybe<String_Comparison_Exp>;
  PTONHOS?: InputMaybe<String_Comparison_Exp>;
  PTONSYS?: InputMaybe<String_Comparison_Exp>;
  PTONVEN?: InputMaybe<String_Comparison_Exp>;
  RASTHOS?: InputMaybe<String_Comparison_Exp>;
  RASTSYS?: InputMaybe<String_Comparison_Exp>;
  RASTVEN?: InputMaybe<String_Comparison_Exp>;
  RBOTHOS?: InputMaybe<String_Comparison_Exp>;
  RBOTSYS?: InputMaybe<String_Comparison_Exp>;
  RBOTVEN?: InputMaybe<String_Comparison_Exp>;
  REDSHOS?: InputMaybe<String_Comparison_Exp>;
  REDSSYS?: InputMaybe<String_Comparison_Exp>;
  REDSVEN?: InputMaybe<String_Comparison_Exp>;
  RETIRHOS?: InputMaybe<String_Comparison_Exp>;
  RETIRSYS?: InputMaybe<String_Comparison_Exp>;
  RETIRVEN?: InputMaybe<String_Comparison_Exp>;
  RHBOPHOS?: InputMaybe<String_Comparison_Exp>;
  RHBOPSYS?: InputMaybe<String_Comparison_Exp>;
  RHBOPVEN?: InputMaybe<String_Comparison_Exp>;
  ROBOHOS?: InputMaybe<String_Comparison_Exp>;
  ROBOSYS?: InputMaybe<String_Comparison_Exp>;
  ROBOVEN?: InputMaybe<String_Comparison_Exp>;
  RPRSHOS?: InputMaybe<String_Comparison_Exp>;
  RPRSSYS?: InputMaybe<String_Comparison_Exp>;
  RPRSVEN?: InputMaybe<String_Comparison_Exp>;
  RSIMHOS?: InputMaybe<String_Comparison_Exp>;
  RSIMSYS?: InputMaybe<String_Comparison_Exp>;
  RSIMVEN?: InputMaybe<String_Comparison_Exp>;
  SPECTHOS?: InputMaybe<String_Comparison_Exp>;
  SPECTSYS?: InputMaybe<String_Comparison_Exp>;
  SPECTVEN?: InputMaybe<String_Comparison_Exp>;
  SPHSHOS?: InputMaybe<String_Comparison_Exp>;
  SPHSSYS?: InputMaybe<String_Comparison_Exp>;
  SPHSVEN?: InputMaybe<String_Comparison_Exp>;
  SRADHOS?: InputMaybe<String_Comparison_Exp>;
  SRADSYS?: InputMaybe<String_Comparison_Exp>;
  SRADVEN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  ULTSNHOS?: InputMaybe<String_Comparison_Exp>;
  ULTSNSYS?: InputMaybe<String_Comparison_Exp>;
  ULTSNVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As20Svc2_Bool_Exp>>;
  _not?: InputMaybe<As20Svc2_Bool_Exp>;
  _or?: InputMaybe<Array<As20Svc2_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS20SVC2" */
export enum As20Svc2_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs20Svc2 = 'pk_AS20SVC2'
}

/** input type for incrementing numeric columns in table "AS20SVC2" */
export type As20Svc2_Inc_Input = {
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS20SVC2" */
export type As20Svc2_Insert_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As20Svc2_Max_Fields = {
  __typename?: 'AS20SVC2_max_fields';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As20Svc2_Min_Fields = {
  __typename?: 'AS20SVC2_min_fields';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS20SVC2" */
export type As20Svc2_Mutation_Response = {
  __typename?: 'AS20SVC2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As20Svc2>;
};

/** input type for inserting object relation for remote table "AS20SVC2" */
export type As20Svc2_Obj_Rel_Insert_Input = {
  data: As20Svc2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As20Svc2_On_Conflict>;
};

/** on_conflict condition type for table "AS20SVC2" */
export type As20Svc2_On_Conflict = {
  constraint: As20Svc2_Constraint;
  update_columns?: Array<As20Svc2_Update_Column>;
  where?: InputMaybe<As20Svc2_Bool_Exp>;
};

/** Ordering options when selecting data from "AS20SVC2". */
export type As20Svc2_Order_By = {
  AIDSSHOS?: InputMaybe<Order_By>;
  AIDSSSYS?: InputMaybe<Order_By>;
  AIDSSVEN?: InputMaybe<Order_By>;
  ASSTLHOS?: InputMaybe<Order_By>;
  ASSTLSYS?: InputMaybe<Order_By>;
  ASSTLVEN?: InputMaybe<Order_By>;
  BEAMHOS?: InputMaybe<Order_By>;
  BEAMSYS?: InputMaybe<Order_By>;
  BEAMVEN?: InputMaybe<Order_By>;
  BRADHOS?: InputMaybe<Order_By>;
  BRADSYS?: InputMaybe<Order_By>;
  BRADVEN?: InputMaybe<Order_By>;
  CTSCNHOS?: InputMaybe<Order_By>;
  CTSCNSYS?: InputMaybe<Order_By>;
  CTSCNVEN?: InputMaybe<Order_By>;
  DRADFHOS?: InputMaybe<Order_By>;
  DRADFSYS?: InputMaybe<Order_By>;
  DRADFVEN?: InputMaybe<Order_By>;
  EBCTHOS?: InputMaybe<Order_By>;
  EBCTSYS?: InputMaybe<Order_By>;
  EBCTVEN?: InputMaybe<Order_By>;
  FFDMHOS?: InputMaybe<Order_By>;
  FFDMSYS?: InputMaybe<Order_By>;
  FFDMVEN?: InputMaybe<Order_By>;
  GNTCHOS?: InputMaybe<Order_By>;
  GNTCSYS?: InputMaybe<Order_By>;
  GNTCVEN?: InputMaybe<Order_By>;
  HEMOHOS?: InputMaybe<Order_By>;
  HEMOSYS?: InputMaybe<Order_By>;
  HEMOVEN?: InputMaybe<Order_By>;
  HLTHCHOS?: InputMaybe<Order_By>;
  HLTHCSYS?: InputMaybe<Order_By>;
  HLTHCVEN?: InputMaybe<Order_By>;
  HLTHFHOS?: InputMaybe<Order_By>;
  HLTHFSYS?: InputMaybe<Order_By>;
  HLTHFVEN?: InputMaybe<Order_By>;
  HLTHSHOS?: InputMaybe<Order_By>;
  HLTHSSYS?: InputMaybe<Order_By>;
  HLTHSVEN?: InputMaybe<Order_By>;
  HLTRHOS?: InputMaybe<Order_By>;
  HLTRSYS?: InputMaybe<Order_By>;
  HLTRVEN?: InputMaybe<Order_By>;
  HOMEHHOS?: InputMaybe<Order_By>;
  HOMEHSYS?: InputMaybe<Order_By>;
  HOMEHVEN?: InputMaybe<Order_By>;
  HOSPCHOS?: InputMaybe<Order_By>;
  HOSPCSYS?: InputMaybe<Order_By>;
  HOSPCVEN?: InputMaybe<Order_By>;
  ICARHOS?: InputMaybe<Order_By>;
  ICARSYS?: InputMaybe<Order_By>;
  ICARVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IGRTHOS?: InputMaybe<Order_By>;
  IGRTSYS?: InputMaybe<Order_By>;
  IGRTVEN?: InputMaybe<Order_By>;
  IMPRHOS?: InputMaybe<Order_By>;
  IMPRSYS?: InputMaybe<Order_By>;
  IMPRVEN?: InputMaybe<Order_By>;
  IMRIHOS?: InputMaybe<Order_By>;
  IMRISYS?: InputMaybe<Order_By>;
  IMRIVEN?: InputMaybe<Order_By>;
  IMRTHOS?: InputMaybe<Order_By>;
  IMRTSYS?: InputMaybe<Order_By>;
  IMRTVEN?: InputMaybe<Order_By>;
  IPALHOS?: InputMaybe<Order_By>;
  IPALSYS?: InputMaybe<Order_By>;
  IPALVEN?: InputMaybe<Order_By>;
  LINGHOS?: InputMaybe<Order_By>;
  LINGSYS?: InputMaybe<Order_By>;
  LINGVEN?: InputMaybe<Order_By>;
  MEALSHOS?: InputMaybe<Order_By>;
  MEALSSYS?: InputMaybe<Order_By>;
  MEALSVEN?: InputMaybe<Order_By>;
  MEGHOS?: InputMaybe<Order_By>;
  MEGSYS?: InputMaybe<Order_By>;
  MEGVEN?: InputMaybe<Order_By>;
  MOHSHOS?: InputMaybe<Order_By>;
  MOHSSYS?: InputMaybe<Order_By>;
  MOHSVEN?: InputMaybe<Order_By>;
  MRIHOS?: InputMaybe<Order_By>;
  MRISYS?: InputMaybe<Order_By>;
  MRIVEN?: InputMaybe<Order_By>;
  MSCTGHOS?: InputMaybe<Order_By>;
  MSCTGSYS?: InputMaybe<Order_By>;
  MSCTGVEN?: InputMaybe<Order_By>;
  MSCTHOS?: InputMaybe<Order_By>;
  MSCTSYS?: InputMaybe<Order_By>;
  MSCTVEN?: InputMaybe<Order_By>;
  NEROHOS?: InputMaybe<Order_By>;
  NEROSYS?: InputMaybe<Order_By>;
  NEROVEN?: InputMaybe<Order_By>;
  NUTRPHOS?: InputMaybe<Order_By>;
  NUTRPSYS?: InputMaybe<Order_By>;
  NUTRPVEN?: InputMaybe<Order_By>;
  OCCHSHOS?: InputMaybe<Order_By>;
  OCCHSSYS?: InputMaybe<Order_By>;
  OCCHSVEN?: InputMaybe<Order_By>;
  ONCOLHOS?: InputMaybe<Order_By>;
  ONCOLSYS?: InputMaybe<Order_By>;
  ONCOLVEN?: InputMaybe<Order_By>;
  OPHOSHOS?: InputMaybe<Order_By>;
  OPHOSSYS?: InputMaybe<Order_By>;
  OPHOSVEN?: InputMaybe<Order_By>;
  OPSRGHOS?: InputMaybe<Order_By>;
  OPSRGSYS?: InputMaybe<Order_By>;
  OPSRGVEN?: InputMaybe<Order_By>;
  ORTOHOS?: InputMaybe<Order_By>;
  ORTOSYS?: InputMaybe<Order_By>;
  ORTOVEN?: InputMaybe<Order_By>;
  PAINHOS?: InputMaybe<Order_By>;
  PAINSYS?: InputMaybe<Order_By>;
  PAINVEN?: InputMaybe<Order_By>;
  PALHOS?: InputMaybe<Order_By>;
  PALSYS?: InputMaybe<Order_By>;
  PALVEN?: InputMaybe<Order_By>;
  PATEDHOS?: InputMaybe<Order_By>;
  PATEDSYS?: InputMaybe<Order_By>;
  PATEDVEN?: InputMaybe<Order_By>;
  PATRPHOS?: InputMaybe<Order_By>;
  PATRPSYS?: InputMaybe<Order_By>;
  PATRPVEN?: InputMaybe<Order_By>;
  PCAHOS?: InputMaybe<Order_By>;
  PCASYS?: InputMaybe<Order_By>;
  PCAVEN?: InputMaybe<Order_By>;
  PCDEPHOS?: InputMaybe<Order_By>;
  PCDEPSYS?: InputMaybe<Order_By>;
  PCDEPVEN?: InputMaybe<Order_By>;
  PETCTHOS?: InputMaybe<Order_By>;
  PETCTSYS?: InputMaybe<Order_By>;
  PETCTVEN?: InputMaybe<Order_By>;
  PETHOS?: InputMaybe<Order_By>;
  PETSYS?: InputMaybe<Order_By>;
  PETVEN?: InputMaybe<Order_By>;
  PPNHOS?: InputMaybe<Order_By>;
  PPNSYS?: InputMaybe<Order_By>;
  PPNVEN?: InputMaybe<Order_By>;
  PSCBD?: InputMaybe<Order_By>;
  PSCISHOS?: InputMaybe<Order_By>;
  PSCISSYS?: InputMaybe<Order_By>;
  PSCISVEN?: InputMaybe<Order_By>;
  PSGBD?: InputMaybe<Order_By>;
  PSPIHOS?: InputMaybe<Order_By>;
  PSPISYS?: InputMaybe<Order_By>;
  PSPIVEN?: InputMaybe<Order_By>;
  PSSOCHOS?: InputMaybe<Order_By>;
  PSSOCSYS?: InputMaybe<Order_By>;
  PSSOCVEN?: InputMaybe<Order_By>;
  PSYCAHOS?: InputMaybe<Order_By>;
  PSYCASYS?: InputMaybe<Order_By>;
  PSYCAVEN?: InputMaybe<Order_By>;
  PSYEDHOS?: InputMaybe<Order_By>;
  PSYEDSYS?: InputMaybe<Order_By>;
  PSYEDVEN?: InputMaybe<Order_By>;
  PSYEMHOS?: InputMaybe<Order_By>;
  PSYEMSYS?: InputMaybe<Order_By>;
  PSYEMVEN?: InputMaybe<Order_By>;
  PSYGRHOS?: InputMaybe<Order_By>;
  PSYGRSYS?: InputMaybe<Order_By>;
  PSYGRVEN?: InputMaybe<Order_By>;
  PSYLSHOS?: InputMaybe<Order_By>;
  PSYLSSYS?: InputMaybe<Order_By>;
  PSYLSVEN?: InputMaybe<Order_By>;
  PSYOIHOS?: InputMaybe<Order_By>;
  PSYOISYS?: InputMaybe<Order_By>;
  PSYOIVEN?: InputMaybe<Order_By>;
  PSYOPHOS?: InputMaybe<Order_By>;
  PSYOPSYS?: InputMaybe<Order_By>;
  PSYOPVEN?: InputMaybe<Order_By>;
  PSYPHAHOS?: InputMaybe<Order_By>;
  PSYPHASYS?: InputMaybe<Order_By>;
  PSYPHAVEN?: InputMaybe<Order_By>;
  PSYPHCHOS?: InputMaybe<Order_By>;
  PSYPHCSYS?: InputMaybe<Order_By>;
  PSYPHCVEN?: InputMaybe<Order_By>;
  PSYTRAHOS?: InputMaybe<Order_By>;
  PSYTRASYS?: InputMaybe<Order_By>;
  PSYTRAVEN?: InputMaybe<Order_By>;
  PSYTRPHOS?: InputMaybe<Order_By>;
  PSYTRPSYS?: InputMaybe<Order_By>;
  PSYTRPVEN?: InputMaybe<Order_By>;
  PTONHOS?: InputMaybe<Order_By>;
  PTONSYS?: InputMaybe<Order_By>;
  PTONVEN?: InputMaybe<Order_By>;
  RASTHOS?: InputMaybe<Order_By>;
  RASTSYS?: InputMaybe<Order_By>;
  RASTVEN?: InputMaybe<Order_By>;
  RBOTHOS?: InputMaybe<Order_By>;
  RBOTSYS?: InputMaybe<Order_By>;
  RBOTVEN?: InputMaybe<Order_By>;
  REDSHOS?: InputMaybe<Order_By>;
  REDSSYS?: InputMaybe<Order_By>;
  REDSVEN?: InputMaybe<Order_By>;
  RETIRHOS?: InputMaybe<Order_By>;
  RETIRSYS?: InputMaybe<Order_By>;
  RETIRVEN?: InputMaybe<Order_By>;
  RHBOPHOS?: InputMaybe<Order_By>;
  RHBOPSYS?: InputMaybe<Order_By>;
  RHBOPVEN?: InputMaybe<Order_By>;
  ROBOHOS?: InputMaybe<Order_By>;
  ROBOSYS?: InputMaybe<Order_By>;
  ROBOVEN?: InputMaybe<Order_By>;
  RPRSHOS?: InputMaybe<Order_By>;
  RPRSSYS?: InputMaybe<Order_By>;
  RPRSVEN?: InputMaybe<Order_By>;
  RSIMHOS?: InputMaybe<Order_By>;
  RSIMSYS?: InputMaybe<Order_By>;
  RSIMVEN?: InputMaybe<Order_By>;
  SPECTHOS?: InputMaybe<Order_By>;
  SPECTSYS?: InputMaybe<Order_By>;
  SPECTVEN?: InputMaybe<Order_By>;
  SPHSHOS?: InputMaybe<Order_By>;
  SPHSSYS?: InputMaybe<Order_By>;
  SPHSVEN?: InputMaybe<Order_By>;
  SRADHOS?: InputMaybe<Order_By>;
  SRADSYS?: InputMaybe<Order_By>;
  SRADVEN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  ULTSNHOS?: InputMaybe<Order_By>;
  ULTSNSYS?: InputMaybe<Order_By>;
  ULTSNVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS20SVC2 */
export type As20Svc2_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS20SVC2" */
export enum As20Svc2_Select_Column {
  /** column name */
  Aidsshos = 'AIDSSHOS',
  /** column name */
  Aidsssys = 'AIDSSSYS',
  /** column name */
  Aidssven = 'AIDSSVEN',
  /** column name */
  Asstlhos = 'ASSTLHOS',
  /** column name */
  Asstlsys = 'ASSTLSYS',
  /** column name */
  Asstlven = 'ASSTLVEN',
  /** column name */
  Beamhos = 'BEAMHOS',
  /** column name */
  Beamsys = 'BEAMSYS',
  /** column name */
  Beamven = 'BEAMVEN',
  /** column name */
  Bradhos = 'BRADHOS',
  /** column name */
  Bradsys = 'BRADSYS',
  /** column name */
  Bradven = 'BRADVEN',
  /** column name */
  Ctscnhos = 'CTSCNHOS',
  /** column name */
  Ctscnsys = 'CTSCNSYS',
  /** column name */
  Ctscnven = 'CTSCNVEN',
  /** column name */
  Dradfhos = 'DRADFHOS',
  /** column name */
  Dradfsys = 'DRADFSYS',
  /** column name */
  Dradfven = 'DRADFVEN',
  /** column name */
  Ebcthos = 'EBCTHOS',
  /** column name */
  Ebctsys = 'EBCTSYS',
  /** column name */
  Ebctven = 'EBCTVEN',
  /** column name */
  Ffdmhos = 'FFDMHOS',
  /** column name */
  Ffdmsys = 'FFDMSYS',
  /** column name */
  Ffdmven = 'FFDMVEN',
  /** column name */
  Gntchos = 'GNTCHOS',
  /** column name */
  Gntcsys = 'GNTCSYS',
  /** column name */
  Gntcven = 'GNTCVEN',
  /** column name */
  Hemohos = 'HEMOHOS',
  /** column name */
  Hemosys = 'HEMOSYS',
  /** column name */
  Hemoven = 'HEMOVEN',
  /** column name */
  Hlthchos = 'HLTHCHOS',
  /** column name */
  Hlthcsys = 'HLTHCSYS',
  /** column name */
  Hlthcven = 'HLTHCVEN',
  /** column name */
  Hlthfhos = 'HLTHFHOS',
  /** column name */
  Hlthfsys = 'HLTHFSYS',
  /** column name */
  Hlthfven = 'HLTHFVEN',
  /** column name */
  Hlthshos = 'HLTHSHOS',
  /** column name */
  Hlthssys = 'HLTHSSYS',
  /** column name */
  Hlthsven = 'HLTHSVEN',
  /** column name */
  Hltrhos = 'HLTRHOS',
  /** column name */
  Hltrsys = 'HLTRSYS',
  /** column name */
  Hltrven = 'HLTRVEN',
  /** column name */
  Homehhos = 'HOMEHHOS',
  /** column name */
  Homehsys = 'HOMEHSYS',
  /** column name */
  Homehven = 'HOMEHVEN',
  /** column name */
  Hospchos = 'HOSPCHOS',
  /** column name */
  Hospcsys = 'HOSPCSYS',
  /** column name */
  Hospcven = 'HOSPCVEN',
  /** column name */
  Icarhos = 'ICARHOS',
  /** column name */
  Icarsys = 'ICARSYS',
  /** column name */
  Icarven = 'ICARVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Igrthos = 'IGRTHOS',
  /** column name */
  Igrtsys = 'IGRTSYS',
  /** column name */
  Igrtven = 'IGRTVEN',
  /** column name */
  Imprhos = 'IMPRHOS',
  /** column name */
  Imprsys = 'IMPRSYS',
  /** column name */
  Imprven = 'IMPRVEN',
  /** column name */
  Imrihos = 'IMRIHOS',
  /** column name */
  Imrisys = 'IMRISYS',
  /** column name */
  Imriven = 'IMRIVEN',
  /** column name */
  Imrthos = 'IMRTHOS',
  /** column name */
  Imrtsys = 'IMRTSYS',
  /** column name */
  Imrtven = 'IMRTVEN',
  /** column name */
  Ipalhos = 'IPALHOS',
  /** column name */
  Ipalsys = 'IPALSYS',
  /** column name */
  Ipalven = 'IPALVEN',
  /** column name */
  Linghos = 'LINGHOS',
  /** column name */
  Lingsys = 'LINGSYS',
  /** column name */
  Lingven = 'LINGVEN',
  /** column name */
  Mealshos = 'MEALSHOS',
  /** column name */
  Mealssys = 'MEALSSYS',
  /** column name */
  Mealsven = 'MEALSVEN',
  /** column name */
  Meghos = 'MEGHOS',
  /** column name */
  Megsys = 'MEGSYS',
  /** column name */
  Megven = 'MEGVEN',
  /** column name */
  Mohshos = 'MOHSHOS',
  /** column name */
  Mohssys = 'MOHSSYS',
  /** column name */
  Mohsven = 'MOHSVEN',
  /** column name */
  Mrihos = 'MRIHOS',
  /** column name */
  Mrisys = 'MRISYS',
  /** column name */
  Mriven = 'MRIVEN',
  /** column name */
  Msctghos = 'MSCTGHOS',
  /** column name */
  Msctgsys = 'MSCTGSYS',
  /** column name */
  Msctgven = 'MSCTGVEN',
  /** column name */
  Mscthos = 'MSCTHOS',
  /** column name */
  Msctsys = 'MSCTSYS',
  /** column name */
  Msctven = 'MSCTVEN',
  /** column name */
  Nerohos = 'NEROHOS',
  /** column name */
  Nerosys = 'NEROSYS',
  /** column name */
  Neroven = 'NEROVEN',
  /** column name */
  Nutrphos = 'NUTRPHOS',
  /** column name */
  Nutrpsys = 'NUTRPSYS',
  /** column name */
  Nutrpven = 'NUTRPVEN',
  /** column name */
  Occhshos = 'OCCHSHOS',
  /** column name */
  Occhssys = 'OCCHSSYS',
  /** column name */
  Occhsven = 'OCCHSVEN',
  /** column name */
  Oncolhos = 'ONCOLHOS',
  /** column name */
  Oncolsys = 'ONCOLSYS',
  /** column name */
  Oncolven = 'ONCOLVEN',
  /** column name */
  Ophoshos = 'OPHOSHOS',
  /** column name */
  Ophossys = 'OPHOSSYS',
  /** column name */
  Ophosven = 'OPHOSVEN',
  /** column name */
  Opsrghos = 'OPSRGHOS',
  /** column name */
  Opsrgsys = 'OPSRGSYS',
  /** column name */
  Opsrgven = 'OPSRGVEN',
  /** column name */
  Ortohos = 'ORTOHOS',
  /** column name */
  Ortosys = 'ORTOSYS',
  /** column name */
  Ortoven = 'ORTOVEN',
  /** column name */
  Painhos = 'PAINHOS',
  /** column name */
  Painsys = 'PAINSYS',
  /** column name */
  Painven = 'PAINVEN',
  /** column name */
  Palhos = 'PALHOS',
  /** column name */
  Palsys = 'PALSYS',
  /** column name */
  Palven = 'PALVEN',
  /** column name */
  Patedhos = 'PATEDHOS',
  /** column name */
  Patedsys = 'PATEDSYS',
  /** column name */
  Patedven = 'PATEDVEN',
  /** column name */
  Patrphos = 'PATRPHOS',
  /** column name */
  Patrpsys = 'PATRPSYS',
  /** column name */
  Patrpven = 'PATRPVEN',
  /** column name */
  Pcahos = 'PCAHOS',
  /** column name */
  Pcasys = 'PCASYS',
  /** column name */
  Pcaven = 'PCAVEN',
  /** column name */
  Pcdephos = 'PCDEPHOS',
  /** column name */
  Pcdepsys = 'PCDEPSYS',
  /** column name */
  Pcdepven = 'PCDEPVEN',
  /** column name */
  Petcthos = 'PETCTHOS',
  /** column name */
  Petctsys = 'PETCTSYS',
  /** column name */
  Petctven = 'PETCTVEN',
  /** column name */
  Pethos = 'PETHOS',
  /** column name */
  Petsys = 'PETSYS',
  /** column name */
  Petven = 'PETVEN',
  /** column name */
  Ppnhos = 'PPNHOS',
  /** column name */
  Ppnsys = 'PPNSYS',
  /** column name */
  Ppnven = 'PPNVEN',
  /** column name */
  Pscbd = 'PSCBD',
  /** column name */
  Pscishos = 'PSCISHOS',
  /** column name */
  Pscissys = 'PSCISSYS',
  /** column name */
  Pscisven = 'PSCISVEN',
  /** column name */
  Psgbd = 'PSGBD',
  /** column name */
  Pspihos = 'PSPIHOS',
  /** column name */
  Pspisys = 'PSPISYS',
  /** column name */
  Pspiven = 'PSPIVEN',
  /** column name */
  Pssochos = 'PSSOCHOS',
  /** column name */
  Pssocsys = 'PSSOCSYS',
  /** column name */
  Pssocven = 'PSSOCVEN',
  /** column name */
  Psycahos = 'PSYCAHOS',
  /** column name */
  Psycasys = 'PSYCASYS',
  /** column name */
  Psycaven = 'PSYCAVEN',
  /** column name */
  Psyedhos = 'PSYEDHOS',
  /** column name */
  Psyedsys = 'PSYEDSYS',
  /** column name */
  Psyedven = 'PSYEDVEN',
  /** column name */
  Psyemhos = 'PSYEMHOS',
  /** column name */
  Psyemsys = 'PSYEMSYS',
  /** column name */
  Psyemven = 'PSYEMVEN',
  /** column name */
  Psygrhos = 'PSYGRHOS',
  /** column name */
  Psygrsys = 'PSYGRSYS',
  /** column name */
  Psygrven = 'PSYGRVEN',
  /** column name */
  Psylshos = 'PSYLSHOS',
  /** column name */
  Psylssys = 'PSYLSSYS',
  /** column name */
  Psylsven = 'PSYLSVEN',
  /** column name */
  Psyoihos = 'PSYOIHOS',
  /** column name */
  Psyoisys = 'PSYOISYS',
  /** column name */
  Psyoiven = 'PSYOIVEN',
  /** column name */
  Psyophos = 'PSYOPHOS',
  /** column name */
  Psyopsys = 'PSYOPSYS',
  /** column name */
  Psyopven = 'PSYOPVEN',
  /** column name */
  Psyphahos = 'PSYPHAHOS',
  /** column name */
  Psyphasys = 'PSYPHASYS',
  /** column name */
  Psyphaven = 'PSYPHAVEN',
  /** column name */
  Psyphchos = 'PSYPHCHOS',
  /** column name */
  Psyphcsys = 'PSYPHCSYS',
  /** column name */
  Psyphcven = 'PSYPHCVEN',
  /** column name */
  Psytrahos = 'PSYTRAHOS',
  /** column name */
  Psytrasys = 'PSYTRASYS',
  /** column name */
  Psytraven = 'PSYTRAVEN',
  /** column name */
  Psytrphos = 'PSYTRPHOS',
  /** column name */
  Psytrpsys = 'PSYTRPSYS',
  /** column name */
  Psytrpven = 'PSYTRPVEN',
  /** column name */
  Ptonhos = 'PTONHOS',
  /** column name */
  Ptonsys = 'PTONSYS',
  /** column name */
  Ptonven = 'PTONVEN',
  /** column name */
  Rasthos = 'RASTHOS',
  /** column name */
  Rastsys = 'RASTSYS',
  /** column name */
  Rastven = 'RASTVEN',
  /** column name */
  Rbothos = 'RBOTHOS',
  /** column name */
  Rbotsys = 'RBOTSYS',
  /** column name */
  Rbotven = 'RBOTVEN',
  /** column name */
  Redshos = 'REDSHOS',
  /** column name */
  Redssys = 'REDSSYS',
  /** column name */
  Redsven = 'REDSVEN',
  /** column name */
  Retirhos = 'RETIRHOS',
  /** column name */
  Retirsys = 'RETIRSYS',
  /** column name */
  Retirven = 'RETIRVEN',
  /** column name */
  Rhbophos = 'RHBOPHOS',
  /** column name */
  Rhbopsys = 'RHBOPSYS',
  /** column name */
  Rhbopven = 'RHBOPVEN',
  /** column name */
  Robohos = 'ROBOHOS',
  /** column name */
  Robosys = 'ROBOSYS',
  /** column name */
  Roboven = 'ROBOVEN',
  /** column name */
  Rprshos = 'RPRSHOS',
  /** column name */
  Rprssys = 'RPRSSYS',
  /** column name */
  Rprsven = 'RPRSVEN',
  /** column name */
  Rsimhos = 'RSIMHOS',
  /** column name */
  Rsimsys = 'RSIMSYS',
  /** column name */
  Rsimven = 'RSIMVEN',
  /** column name */
  Specthos = 'SPECTHOS',
  /** column name */
  Spectsys = 'SPECTSYS',
  /** column name */
  Spectven = 'SPECTVEN',
  /** column name */
  Sphshos = 'SPHSHOS',
  /** column name */
  Sphssys = 'SPHSSYS',
  /** column name */
  Sphsven = 'SPHSVEN',
  /** column name */
  Sradhos = 'SRADHOS',
  /** column name */
  Sradsys = 'SRADSYS',
  /** column name */
  Sradven = 'SRADVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Ultsnhos = 'ULTSNHOS',
  /** column name */
  Ultsnsys = 'ULTSNSYS',
  /** column name */
  Ultsnven = 'ULTSNVEN'
}

/** input type for updating data in table "AS20SVC2" */
export type As20Svc2_Set_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As20Svc2_Stddev_Fields = {
  __typename?: 'AS20SVC2_stddev_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As20Svc2_Stddev_Pop_Fields = {
  __typename?: 'AS20SVC2_stddev_pop_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As20Svc2_Stddev_Samp_Fields = {
  __typename?: 'AS20SVC2_stddev_samp_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS20SVC2" */
export type As20Svc2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As20Svc2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As20Svc2_Stream_Cursor_Value_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As20Svc2_Sum_Fields = {
  __typename?: 'AS20SVC2_sum_fields';
  PSCBD: Maybe<Scalars['float8']>;
  PSGBD: Maybe<Scalars['float8']>;
};

/** update columns of table "AS20SVC2" */
export enum As20Svc2_Update_Column {
  /** column name */
  Aidsshos = 'AIDSSHOS',
  /** column name */
  Aidsssys = 'AIDSSSYS',
  /** column name */
  Aidssven = 'AIDSSVEN',
  /** column name */
  Asstlhos = 'ASSTLHOS',
  /** column name */
  Asstlsys = 'ASSTLSYS',
  /** column name */
  Asstlven = 'ASSTLVEN',
  /** column name */
  Beamhos = 'BEAMHOS',
  /** column name */
  Beamsys = 'BEAMSYS',
  /** column name */
  Beamven = 'BEAMVEN',
  /** column name */
  Bradhos = 'BRADHOS',
  /** column name */
  Bradsys = 'BRADSYS',
  /** column name */
  Bradven = 'BRADVEN',
  /** column name */
  Ctscnhos = 'CTSCNHOS',
  /** column name */
  Ctscnsys = 'CTSCNSYS',
  /** column name */
  Ctscnven = 'CTSCNVEN',
  /** column name */
  Dradfhos = 'DRADFHOS',
  /** column name */
  Dradfsys = 'DRADFSYS',
  /** column name */
  Dradfven = 'DRADFVEN',
  /** column name */
  Ebcthos = 'EBCTHOS',
  /** column name */
  Ebctsys = 'EBCTSYS',
  /** column name */
  Ebctven = 'EBCTVEN',
  /** column name */
  Ffdmhos = 'FFDMHOS',
  /** column name */
  Ffdmsys = 'FFDMSYS',
  /** column name */
  Ffdmven = 'FFDMVEN',
  /** column name */
  Gntchos = 'GNTCHOS',
  /** column name */
  Gntcsys = 'GNTCSYS',
  /** column name */
  Gntcven = 'GNTCVEN',
  /** column name */
  Hemohos = 'HEMOHOS',
  /** column name */
  Hemosys = 'HEMOSYS',
  /** column name */
  Hemoven = 'HEMOVEN',
  /** column name */
  Hlthchos = 'HLTHCHOS',
  /** column name */
  Hlthcsys = 'HLTHCSYS',
  /** column name */
  Hlthcven = 'HLTHCVEN',
  /** column name */
  Hlthfhos = 'HLTHFHOS',
  /** column name */
  Hlthfsys = 'HLTHFSYS',
  /** column name */
  Hlthfven = 'HLTHFVEN',
  /** column name */
  Hlthshos = 'HLTHSHOS',
  /** column name */
  Hlthssys = 'HLTHSSYS',
  /** column name */
  Hlthsven = 'HLTHSVEN',
  /** column name */
  Hltrhos = 'HLTRHOS',
  /** column name */
  Hltrsys = 'HLTRSYS',
  /** column name */
  Hltrven = 'HLTRVEN',
  /** column name */
  Homehhos = 'HOMEHHOS',
  /** column name */
  Homehsys = 'HOMEHSYS',
  /** column name */
  Homehven = 'HOMEHVEN',
  /** column name */
  Hospchos = 'HOSPCHOS',
  /** column name */
  Hospcsys = 'HOSPCSYS',
  /** column name */
  Hospcven = 'HOSPCVEN',
  /** column name */
  Icarhos = 'ICARHOS',
  /** column name */
  Icarsys = 'ICARSYS',
  /** column name */
  Icarven = 'ICARVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Igrthos = 'IGRTHOS',
  /** column name */
  Igrtsys = 'IGRTSYS',
  /** column name */
  Igrtven = 'IGRTVEN',
  /** column name */
  Imprhos = 'IMPRHOS',
  /** column name */
  Imprsys = 'IMPRSYS',
  /** column name */
  Imprven = 'IMPRVEN',
  /** column name */
  Imrihos = 'IMRIHOS',
  /** column name */
  Imrisys = 'IMRISYS',
  /** column name */
  Imriven = 'IMRIVEN',
  /** column name */
  Imrthos = 'IMRTHOS',
  /** column name */
  Imrtsys = 'IMRTSYS',
  /** column name */
  Imrtven = 'IMRTVEN',
  /** column name */
  Ipalhos = 'IPALHOS',
  /** column name */
  Ipalsys = 'IPALSYS',
  /** column name */
  Ipalven = 'IPALVEN',
  /** column name */
  Linghos = 'LINGHOS',
  /** column name */
  Lingsys = 'LINGSYS',
  /** column name */
  Lingven = 'LINGVEN',
  /** column name */
  Mealshos = 'MEALSHOS',
  /** column name */
  Mealssys = 'MEALSSYS',
  /** column name */
  Mealsven = 'MEALSVEN',
  /** column name */
  Meghos = 'MEGHOS',
  /** column name */
  Megsys = 'MEGSYS',
  /** column name */
  Megven = 'MEGVEN',
  /** column name */
  Mohshos = 'MOHSHOS',
  /** column name */
  Mohssys = 'MOHSSYS',
  /** column name */
  Mohsven = 'MOHSVEN',
  /** column name */
  Mrihos = 'MRIHOS',
  /** column name */
  Mrisys = 'MRISYS',
  /** column name */
  Mriven = 'MRIVEN',
  /** column name */
  Msctghos = 'MSCTGHOS',
  /** column name */
  Msctgsys = 'MSCTGSYS',
  /** column name */
  Msctgven = 'MSCTGVEN',
  /** column name */
  Mscthos = 'MSCTHOS',
  /** column name */
  Msctsys = 'MSCTSYS',
  /** column name */
  Msctven = 'MSCTVEN',
  /** column name */
  Nerohos = 'NEROHOS',
  /** column name */
  Nerosys = 'NEROSYS',
  /** column name */
  Neroven = 'NEROVEN',
  /** column name */
  Nutrphos = 'NUTRPHOS',
  /** column name */
  Nutrpsys = 'NUTRPSYS',
  /** column name */
  Nutrpven = 'NUTRPVEN',
  /** column name */
  Occhshos = 'OCCHSHOS',
  /** column name */
  Occhssys = 'OCCHSSYS',
  /** column name */
  Occhsven = 'OCCHSVEN',
  /** column name */
  Oncolhos = 'ONCOLHOS',
  /** column name */
  Oncolsys = 'ONCOLSYS',
  /** column name */
  Oncolven = 'ONCOLVEN',
  /** column name */
  Ophoshos = 'OPHOSHOS',
  /** column name */
  Ophossys = 'OPHOSSYS',
  /** column name */
  Ophosven = 'OPHOSVEN',
  /** column name */
  Opsrghos = 'OPSRGHOS',
  /** column name */
  Opsrgsys = 'OPSRGSYS',
  /** column name */
  Opsrgven = 'OPSRGVEN',
  /** column name */
  Ortohos = 'ORTOHOS',
  /** column name */
  Ortosys = 'ORTOSYS',
  /** column name */
  Ortoven = 'ORTOVEN',
  /** column name */
  Painhos = 'PAINHOS',
  /** column name */
  Painsys = 'PAINSYS',
  /** column name */
  Painven = 'PAINVEN',
  /** column name */
  Palhos = 'PALHOS',
  /** column name */
  Palsys = 'PALSYS',
  /** column name */
  Palven = 'PALVEN',
  /** column name */
  Patedhos = 'PATEDHOS',
  /** column name */
  Patedsys = 'PATEDSYS',
  /** column name */
  Patedven = 'PATEDVEN',
  /** column name */
  Patrphos = 'PATRPHOS',
  /** column name */
  Patrpsys = 'PATRPSYS',
  /** column name */
  Patrpven = 'PATRPVEN',
  /** column name */
  Pcahos = 'PCAHOS',
  /** column name */
  Pcasys = 'PCASYS',
  /** column name */
  Pcaven = 'PCAVEN',
  /** column name */
  Pcdephos = 'PCDEPHOS',
  /** column name */
  Pcdepsys = 'PCDEPSYS',
  /** column name */
  Pcdepven = 'PCDEPVEN',
  /** column name */
  Petcthos = 'PETCTHOS',
  /** column name */
  Petctsys = 'PETCTSYS',
  /** column name */
  Petctven = 'PETCTVEN',
  /** column name */
  Pethos = 'PETHOS',
  /** column name */
  Petsys = 'PETSYS',
  /** column name */
  Petven = 'PETVEN',
  /** column name */
  Ppnhos = 'PPNHOS',
  /** column name */
  Ppnsys = 'PPNSYS',
  /** column name */
  Ppnven = 'PPNVEN',
  /** column name */
  Pscbd = 'PSCBD',
  /** column name */
  Pscishos = 'PSCISHOS',
  /** column name */
  Pscissys = 'PSCISSYS',
  /** column name */
  Pscisven = 'PSCISVEN',
  /** column name */
  Psgbd = 'PSGBD',
  /** column name */
  Pspihos = 'PSPIHOS',
  /** column name */
  Pspisys = 'PSPISYS',
  /** column name */
  Pspiven = 'PSPIVEN',
  /** column name */
  Pssochos = 'PSSOCHOS',
  /** column name */
  Pssocsys = 'PSSOCSYS',
  /** column name */
  Pssocven = 'PSSOCVEN',
  /** column name */
  Psycahos = 'PSYCAHOS',
  /** column name */
  Psycasys = 'PSYCASYS',
  /** column name */
  Psycaven = 'PSYCAVEN',
  /** column name */
  Psyedhos = 'PSYEDHOS',
  /** column name */
  Psyedsys = 'PSYEDSYS',
  /** column name */
  Psyedven = 'PSYEDVEN',
  /** column name */
  Psyemhos = 'PSYEMHOS',
  /** column name */
  Psyemsys = 'PSYEMSYS',
  /** column name */
  Psyemven = 'PSYEMVEN',
  /** column name */
  Psygrhos = 'PSYGRHOS',
  /** column name */
  Psygrsys = 'PSYGRSYS',
  /** column name */
  Psygrven = 'PSYGRVEN',
  /** column name */
  Psylshos = 'PSYLSHOS',
  /** column name */
  Psylssys = 'PSYLSSYS',
  /** column name */
  Psylsven = 'PSYLSVEN',
  /** column name */
  Psyoihos = 'PSYOIHOS',
  /** column name */
  Psyoisys = 'PSYOISYS',
  /** column name */
  Psyoiven = 'PSYOIVEN',
  /** column name */
  Psyophos = 'PSYOPHOS',
  /** column name */
  Psyopsys = 'PSYOPSYS',
  /** column name */
  Psyopven = 'PSYOPVEN',
  /** column name */
  Psyphahos = 'PSYPHAHOS',
  /** column name */
  Psyphasys = 'PSYPHASYS',
  /** column name */
  Psyphaven = 'PSYPHAVEN',
  /** column name */
  Psyphchos = 'PSYPHCHOS',
  /** column name */
  Psyphcsys = 'PSYPHCSYS',
  /** column name */
  Psyphcven = 'PSYPHCVEN',
  /** column name */
  Psytrahos = 'PSYTRAHOS',
  /** column name */
  Psytrasys = 'PSYTRASYS',
  /** column name */
  Psytraven = 'PSYTRAVEN',
  /** column name */
  Psytrphos = 'PSYTRPHOS',
  /** column name */
  Psytrpsys = 'PSYTRPSYS',
  /** column name */
  Psytrpven = 'PSYTRPVEN',
  /** column name */
  Ptonhos = 'PTONHOS',
  /** column name */
  Ptonsys = 'PTONSYS',
  /** column name */
  Ptonven = 'PTONVEN',
  /** column name */
  Rasthos = 'RASTHOS',
  /** column name */
  Rastsys = 'RASTSYS',
  /** column name */
  Rastven = 'RASTVEN',
  /** column name */
  Rbothos = 'RBOTHOS',
  /** column name */
  Rbotsys = 'RBOTSYS',
  /** column name */
  Rbotven = 'RBOTVEN',
  /** column name */
  Redshos = 'REDSHOS',
  /** column name */
  Redssys = 'REDSSYS',
  /** column name */
  Redsven = 'REDSVEN',
  /** column name */
  Retirhos = 'RETIRHOS',
  /** column name */
  Retirsys = 'RETIRSYS',
  /** column name */
  Retirven = 'RETIRVEN',
  /** column name */
  Rhbophos = 'RHBOPHOS',
  /** column name */
  Rhbopsys = 'RHBOPSYS',
  /** column name */
  Rhbopven = 'RHBOPVEN',
  /** column name */
  Robohos = 'ROBOHOS',
  /** column name */
  Robosys = 'ROBOSYS',
  /** column name */
  Roboven = 'ROBOVEN',
  /** column name */
  Rprshos = 'RPRSHOS',
  /** column name */
  Rprssys = 'RPRSSYS',
  /** column name */
  Rprsven = 'RPRSVEN',
  /** column name */
  Rsimhos = 'RSIMHOS',
  /** column name */
  Rsimsys = 'RSIMSYS',
  /** column name */
  Rsimven = 'RSIMVEN',
  /** column name */
  Specthos = 'SPECTHOS',
  /** column name */
  Spectsys = 'SPECTSYS',
  /** column name */
  Spectven = 'SPECTVEN',
  /** column name */
  Sphshos = 'SPHSHOS',
  /** column name */
  Sphssys = 'SPHSSYS',
  /** column name */
  Sphsven = 'SPHSVEN',
  /** column name */
  Sradhos = 'SRADHOS',
  /** column name */
  Sradsys = 'SRADSYS',
  /** column name */
  Sradven = 'SRADVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Ultsnhos = 'ULTSNHOS',
  /** column name */
  Ultsnsys = 'ULTSNSYS',
  /** column name */
  Ultsnven = 'ULTSNVEN'
}

export type As20Svc2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As20Svc2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As20Svc2_Set_Input>;
  /** filter the rows which have to be updated */
  where: As20Svc2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As20Svc2_Var_Pop_Fields = {
  __typename?: 'AS20SVC2_var_pop_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As20Svc2_Var_Samp_Fields = {
  __typename?: 'AS20SVC2_var_samp_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As20Svc2_Variance_Fields = {
  __typename?: 'AS20SVC2_variance_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS20SVC3" */
export type As20Svc3 = {
  __typename?: 'AS20SVC3';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHACAR: Maybe<Scalars['String']>;
  BHER: Maybe<Scalars['String']>;
  BHLTA: Maybe<Scalars['String']>;
  BHPCS: Maybe<Scalars['String']>;
  BHXCAR: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDBDCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IICUBD: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISOCHG: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS20SVC3" */
export type As20Svc3_Aggregate = {
  __typename?: 'AS20SVC3_aggregate';
  aggregate: Maybe<As20Svc3_Aggregate_Fields>;
  nodes: Array<As20Svc3>;
};

/** aggregate fields of "AS20SVC3" */
export type As20Svc3_Aggregate_Fields = {
  __typename?: 'AS20SVC3_aggregate_fields';
  avg: Maybe<As20Svc3_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As20Svc3_Max_Fields>;
  min: Maybe<As20Svc3_Min_Fields>;
  stddev: Maybe<As20Svc3_Stddev_Fields>;
  stddev_pop: Maybe<As20Svc3_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As20Svc3_Stddev_Samp_Fields>;
  sum: Maybe<As20Svc3_Sum_Fields>;
  var_pop: Maybe<As20Svc3_Var_Pop_Fields>;
  var_samp: Maybe<As20Svc3_Var_Samp_Fields>;
  variance: Maybe<As20Svc3_Variance_Fields>;
};


/** aggregate fields of "AS20SVC3" */
export type As20Svc3_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As20Svc3_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As20Svc3_Avg_Fields = {
  __typename?: 'AS20SVC3_avg_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS20SVC3". All fields are combined with a logical 'AND'. */
export type As20Svc3_Bool_Exp = {
  ADTRTHOS?: InputMaybe<String_Comparison_Exp>;
  ADTRTSYS?: InputMaybe<String_Comparison_Exp>;
  ADTRTVEN?: InputMaybe<String_Comparison_Exp>;
  ALCOPHOS?: InputMaybe<String_Comparison_Exp>;
  ALCOPSYS?: InputMaybe<String_Comparison_Exp>;
  ALCOPVEN?: InputMaybe<String_Comparison_Exp>;
  ALCPDHOS?: InputMaybe<String_Comparison_Exp>;
  ALCPDSYS?: InputMaybe<String_Comparison_Exp>;
  ALCPDVEN?: InputMaybe<String_Comparison_Exp>;
  ALCPRHOS?: InputMaybe<String_Comparison_Exp>;
  ALCPRSYS?: InputMaybe<String_Comparison_Exp>;
  ALCPRVEN?: InputMaybe<String_Comparison_Exp>;
  ALDBD?: InputMaybe<Float8_Comparison_Exp>;
  BAIMV?: InputMaybe<Float8_Comparison_Exp>;
  BHACAR?: InputMaybe<String_Comparison_Exp>;
  BHER?: InputMaybe<String_Comparison_Exp>;
  BHLTA?: InputMaybe<String_Comparison_Exp>;
  BHPCS?: InputMaybe<String_Comparison_Exp>;
  BHXCAR?: InputMaybe<String_Comparison_Exp>;
  BPIMV?: InputMaybe<Float8_Comparison_Exp>;
  CHCARHOS?: InputMaybe<String_Comparison_Exp>;
  CHCARSYS?: InputMaybe<String_Comparison_Exp>;
  CHCARVEN?: InputMaybe<String_Comparison_Exp>;
  COFVHOS?: InputMaybe<String_Comparison_Exp>;
  COFVSYS?: InputMaybe<String_Comparison_Exp>;
  COFVVEN?: InputMaybe<String_Comparison_Exp>;
  COVIDU?: InputMaybe<String_Comparison_Exp>;
  CPHCOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHHOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHIOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHOHOS?: InputMaybe<String_Comparison_Exp>;
  CPHOSYS?: InputMaybe<String_Comparison_Exp>;
  CPHP?: InputMaybe<Float8_Comparison_Exp>;
  CPHPOS?: InputMaybe<Float8_Comparison_Exp>;
  DECHC?: InputMaybe<String_Comparison_Exp>;
  DECUTLA?: InputMaybe<String_Comparison_Exp>;
  EAIMV?: InputMaybe<Float8_Comparison_Exp>;
  EDBDCHG?: InputMaybe<String_Comparison_Exp>;
  EICUHOS?: InputMaybe<String_Comparison_Exp>;
  EICUSYS?: InputMaybe<String_Comparison_Exp>;
  EICUVEN?: InputMaybe<String_Comparison_Exp>;
  EPIMV?: InputMaybe<Float8_Comparison_Exp>;
  EQMCOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMHOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMIOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMODHOS?: InputMaybe<String_Comparison_Exp>;
  EQMODSYS?: InputMaybe<String_Comparison_Exp>;
  EQMP?: InputMaybe<Float8_Comparison_Exp>;
  EQMPOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDCOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDHOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDIOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDP?: InputMaybe<Float8_Comparison_Exp>;
  FNDPOS?: InputMaybe<Float8_Comparison_Exp>;
  FOUNDHOS?: InputMaybe<String_Comparison_Exp>;
  FOUNDSYS?: InputMaybe<String_Comparison_Exp>;
  FTMT?: InputMaybe<Float8_Comparison_Exp>;
  GPWCOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWHOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWIOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWP?: InputMaybe<Float8_Comparison_Exp>;
  GPWPOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWWHOS?: InputMaybe<String_Comparison_Exp>;
  GPWWSYS?: InputMaybe<String_Comparison_Exp>;
  HARTHOS?: InputMaybe<String_Comparison_Exp>;
  HARTSYS?: InputMaybe<String_Comparison_Exp>;
  HARTVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IICUBD?: InputMaybe<String_Comparison_Exp>;
  IISMHOS?: InputMaybe<Float8_Comparison_Exp>;
  IMPSTAT?: InputMaybe<String_Comparison_Exp>;
  IPACOS?: InputMaybe<Float8_Comparison_Exp>;
  IPAHOS?: InputMaybe<String_Comparison_Exp>;
  IPAIOS?: InputMaybe<Float8_Comparison_Exp>;
  IPAP?: InputMaybe<Float8_Comparison_Exp>;
  IPAPOS?: InputMaybe<Float8_Comparison_Exp>;
  IPASYS?: InputMaybe<String_Comparison_Exp>;
  IPPAHOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMCOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMHOS?: InputMaybe<String_Comparison_Exp>;
  ISMIOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMP?: InputMaybe<Float8_Comparison_Exp>;
  ISMPOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMSYS?: InputMaybe<String_Comparison_Exp>;
  ISOCHG?: InputMaybe<String_Comparison_Exp>;
  ISORMB?: InputMaybe<Float8_Comparison_Exp>;
  ISORMC?: InputMaybe<Float8_Comparison_Exp>;
  ISORME?: InputMaybe<Float8_Comparison_Exp>;
  JNLS?: InputMaybe<String_Comparison_Exp>;
  JNTAMB?: InputMaybe<String_Comparison_Exp>;
  JNTCTR?: InputMaybe<String_Comparison_Exp>;
  JNTLSC?: InputMaybe<String_Comparison_Exp>;
  JNTLSO?: InputMaybe<String_Comparison_Exp>;
  JNTLSS?: InputMaybe<String_Comparison_Exp>;
  JNTLST?: InputMaybe<String_Comparison_Exp>;
  JNTMD?: InputMaybe<String_Comparison_Exp>;
  JNTOTH?: InputMaybe<String_Comparison_Exp>;
  JNTPH?: InputMaybe<String_Comparison_Exp>;
  JNTTXT?: InputMaybe<String_Comparison_Exp>;
  KDNYHOS?: InputMaybe<String_Comparison_Exp>;
  KDNYSYS?: InputMaybe<String_Comparison_Exp>;
  KDNYVEN?: InputMaybe<String_Comparison_Exp>;
  LIVRHOS?: InputMaybe<String_Comparison_Exp>;
  LIVRSYS?: InputMaybe<String_Comparison_Exp>;
  LIVRVEN?: InputMaybe<String_Comparison_Exp>;
  LSHTXT?: InputMaybe<String_Comparison_Exp>;
  LUNGHOS?: InputMaybe<String_Comparison_Exp>;
  LUNGSYS?: InputMaybe<String_Comparison_Exp>;
  LUNGVEN?: InputMaybe<String_Comparison_Exp>;
  MEDOPHOS?: InputMaybe<String_Comparison_Exp>;
  MEDOPSYS?: InputMaybe<String_Comparison_Exp>;
  MEDOPVEN?: InputMaybe<String_Comparison_Exp>;
  MEDSUBHOS?: InputMaybe<String_Comparison_Exp>;
  MEDSUBSYS?: InputMaybe<String_Comparison_Exp>;
  MEDSUBVEN?: InputMaybe<String_Comparison_Exp>;
  MMSOHOS?: InputMaybe<Float8_Comparison_Exp>;
  MSGRP?: InputMaybe<Float8_Comparison_Exp>;
  MSGRPN?: InputMaybe<Float8_Comparison_Exp>;
  MSOCOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOHOS?: InputMaybe<String_Comparison_Exp>;
  MSOIOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOP?: InputMaybe<Float8_Comparison_Exp>;
  MSOPOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOSYS?: InputMaybe<String_Comparison_Exp>;
  OPHCOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHHOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHIOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHOHOS?: InputMaybe<String_Comparison_Exp>;
  OPHOSYS?: InputMaybe<String_Comparison_Exp>;
  OPHP?: InputMaybe<Float8_Comparison_Exp>;
  OPHPOS?: InputMaybe<Float8_Comparison_Exp>;
  ORPMHOS?: InputMaybe<String_Comparison_Exp>;
  ORPMSYS?: InputMaybe<String_Comparison_Exp>;
  ORPMVEN?: InputMaybe<String_Comparison_Exp>;
  OTBONHOS?: InputMaybe<String_Comparison_Exp>;
  OTBONSYS?: InputMaybe<String_Comparison_Exp>;
  OTBONVEN?: InputMaybe<String_Comparison_Exp>;
  OTHTHOS?: InputMaybe<String_Comparison_Exp>;
  OTHTSYS?: InputMaybe<String_Comparison_Exp>;
  OTHTVEN?: InputMaybe<String_Comparison_Exp>;
  OTOTHHOS?: InputMaybe<String_Comparison_Exp>;
  OTOTHSYS?: InputMaybe<String_Comparison_Exp>;
  OTOTHVEN?: InputMaybe<String_Comparison_Exp>;
  OUTMTX?: InputMaybe<String_Comparison_Exp>;
  PDISHOS?: InputMaybe<String_Comparison_Exp>;
  PDISSYS?: InputMaybe<String_Comparison_Exp>;
  PDISVEN?: InputMaybe<String_Comparison_Exp>;
  PHACAR?: InputMaybe<String_Comparison_Exp>;
  PHER?: InputMaybe<String_Comparison_Exp>;
  PHPCS?: InputMaybe<String_Comparison_Exp>;
  PHXCAR?: InputMaybe<String_Comparison_Exp>;
  PHYCOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYCPT?: InputMaybe<Float8_Comparison_Exp>;
  PHYHOS?: InputMaybe<String_Comparison_Exp>;
  PHYIOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYOCPT?: InputMaybe<Float8_Comparison_Exp>;
  PHYOTH?: InputMaybe<String_Comparison_Exp>;
  PHYP?: InputMaybe<Float8_Comparison_Exp>;
  PHYPOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYPR?: InputMaybe<Float8_Comparison_Exp>;
  PHYPRN?: InputMaybe<Float8_Comparison_Exp>;
  PHYSYS?: InputMaybe<String_Comparison_Exp>;
  PPHYHOS?: InputMaybe<Float8_Comparison_Exp>;
  RURLHOS?: InputMaybe<String_Comparison_Exp>;
  RURLSYS?: InputMaybe<String_Comparison_Exp>;
  RURLVEN?: InputMaybe<String_Comparison_Exp>;
  SCBH?: InputMaybe<String_Comparison_Exp>;
  SCEDL?: InputMaybe<String_Comparison_Exp>;
  SCFOD?: InputMaybe<String_Comparison_Exp>;
  SCHSE?: InputMaybe<String_Comparison_Exp>;
  SCIOS?: InputMaybe<String_Comparison_Exp>;
  SCNED?: InputMaybe<String_Comparison_Exp>;
  SCOTH?: InputMaybe<String_Comparison_Exp>;
  SCROT?: InputMaybe<String_Comparison_Exp>;
  SCSTAT?: InputMaybe<String_Comparison_Exp>;
  SCTRN?: InputMaybe<String_Comparison_Exp>;
  SCUND?: InputMaybe<String_Comparison_Exp>;
  SCV?: InputMaybe<String_Comparison_Exp>;
  SHACAR?: InputMaybe<String_Comparison_Exp>;
  SHER?: InputMaybe<String_Comparison_Exp>;
  SHPCS?: InputMaybe<String_Comparison_Exp>;
  SHXCAR?: InputMaybe<String_Comparison_Exp>;
  SLEPHOS?: InputMaybe<String_Comparison_Exp>;
  SLEPSYS?: InputMaybe<String_Comparison_Exp>;
  SLEPVEN?: InputMaybe<String_Comparison_Exp>;
  SOCBH?: InputMaybe<String_Comparison_Exp>;
  SOCED?: InputMaybe<String_Comparison_Exp>;
  SOCEHR?: InputMaybe<String_Comparison_Exp>;
  SOCFOD?: InputMaybe<String_Comparison_Exp>;
  SOCHSE?: InputMaybe<String_Comparison_Exp>;
  SOCINC?: InputMaybe<String_Comparison_Exp>;
  SOCIOS?: InputMaybe<String_Comparison_Exp>;
  SOCNED?: InputMaybe<String_Comparison_Exp>;
  SOCOT?: InputMaybe<String_Comparison_Exp>;
  SOCOTH?: InputMaybe<String_Comparison_Exp>;
  SOCTRN?: InputMaybe<String_Comparison_Exp>;
  SOCV?: InputMaybe<String_Comparison_Exp>;
  SOCWKHOS?: InputMaybe<String_Comparison_Exp>;
  SOCWKSYS?: InputMaybe<String_Comparison_Exp>;
  SOCWKVEN?: InputMaybe<String_Comparison_Exp>;
  SPORTHOS?: InputMaybe<String_Comparison_Exp>;
  SPORTSYS?: InputMaybe<String_Comparison_Exp>;
  SPORTVEN?: InputMaybe<String_Comparison_Exp>;
  SSGRP?: InputMaybe<Float8_Comparison_Exp>;
  SSGRPN?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  STRCHOS?: InputMaybe<String_Comparison_Exp>;
  STRCSYS?: InputMaybe<String_Comparison_Exp>;
  STRCVEN?: InputMaybe<String_Comparison_Exp>;
  SUPPGHOS?: InputMaybe<String_Comparison_Exp>;
  SUPPGSYS?: InputMaybe<String_Comparison_Exp>;
  SUPPGVEN?: InputMaybe<String_Comparison_Exp>;
  SWBDHOS?: InputMaybe<String_Comparison_Exp>;
  SWBDSYS?: InputMaybe<String_Comparison_Exp>;
  SWBDVEN?: InputMaybe<String_Comparison_Exp>;
  TEENSHOS?: InputMaybe<String_Comparison_Exp>;
  TEENSSYS?: InputMaybe<String_Comparison_Exp>;
  TEENSVEN?: InputMaybe<String_Comparison_Exp>;
  TISUHOS?: InputMaybe<String_Comparison_Exp>;
  TISUSYS?: InputMaybe<String_Comparison_Exp>;
  TISUVEN?: InputMaybe<String_Comparison_Exp>;
  TOBHOS?: InputMaybe<String_Comparison_Exp>;
  TOBSYS?: InputMaybe<String_Comparison_Exp>;
  TOBVEN?: InputMaybe<String_Comparison_Exp>;
  TPORTHOS?: InputMaybe<String_Comparison_Exp>;
  TPORTSYS?: InputMaybe<String_Comparison_Exp>;
  TPORTVEN?: InputMaybe<String_Comparison_Exp>;
  URGCCHOS?: InputMaybe<String_Comparison_Exp>;
  URGCCSYS?: InputMaybe<String_Comparison_Exp>;
  URGCCVEN?: InputMaybe<String_Comparison_Exp>;
  VCMMHOS?: InputMaybe<String_Comparison_Exp>;
  VCMMSYS?: InputMaybe<String_Comparison_Exp>;
  VCMMVEN?: InputMaybe<String_Comparison_Exp>;
  VOLSVHOS?: InputMaybe<String_Comparison_Exp>;
  VOLSVSYS?: InputMaybe<String_Comparison_Exp>;
  VOLSVVEN?: InputMaybe<String_Comparison_Exp>;
  VRCSHOS?: InputMaybe<String_Comparison_Exp>;
  VRCSSYS?: InputMaybe<String_Comparison_Exp>;
  VRCSVEN?: InputMaybe<String_Comparison_Exp>;
  VWRKHOS?: InputMaybe<String_Comparison_Exp>;
  VWRKSYS?: InputMaybe<String_Comparison_Exp>;
  VWRKVEN?: InputMaybe<String_Comparison_Exp>;
  WMGTHOS?: InputMaybe<String_Comparison_Exp>;
  WMGTSYS?: InputMaybe<String_Comparison_Exp>;
  WMGTVEN?: InputMaybe<String_Comparison_Exp>;
  WOMHCHOS?: InputMaybe<String_Comparison_Exp>;
  WOMHCSYS?: InputMaybe<String_Comparison_Exp>;
  WOMHCVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As20Svc3_Bool_Exp>>;
  _not?: InputMaybe<As20Svc3_Bool_Exp>;
  _or?: InputMaybe<Array<As20Svc3_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS20SVC3" */
export enum As20Svc3_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs20Svc3 = 'pk_AS20SVC3'
}

/** input type for incrementing numeric columns in table "AS20SVC3" */
export type As20Svc3_Inc_Input = {
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS20SVC3" */
export type As20Svc3_Insert_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHACAR?: InputMaybe<Scalars['String']>;
  BHER?: InputMaybe<Scalars['String']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BHPCS?: InputMaybe<Scalars['String']>;
  BHXCAR?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDBDCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IICUBD?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISOCHG?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As20Svc3_Max_Fields = {
  __typename?: 'AS20SVC3_max_fields';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHACAR: Maybe<Scalars['String']>;
  BHER: Maybe<Scalars['String']>;
  BHLTA: Maybe<Scalars['String']>;
  BHPCS: Maybe<Scalars['String']>;
  BHXCAR: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDBDCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IICUBD: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISOCHG: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As20Svc3_Min_Fields = {
  __typename?: 'AS20SVC3_min_fields';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHACAR: Maybe<Scalars['String']>;
  BHER: Maybe<Scalars['String']>;
  BHLTA: Maybe<Scalars['String']>;
  BHPCS: Maybe<Scalars['String']>;
  BHXCAR: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDBDCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IICUBD: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISOCHG: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS20SVC3" */
export type As20Svc3_Mutation_Response = {
  __typename?: 'AS20SVC3_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As20Svc3>;
};

/** input type for inserting object relation for remote table "AS20SVC3" */
export type As20Svc3_Obj_Rel_Insert_Input = {
  data: As20Svc3_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As20Svc3_On_Conflict>;
};

/** on_conflict condition type for table "AS20SVC3" */
export type As20Svc3_On_Conflict = {
  constraint: As20Svc3_Constraint;
  update_columns?: Array<As20Svc3_Update_Column>;
  where?: InputMaybe<As20Svc3_Bool_Exp>;
};

/** Ordering options when selecting data from "AS20SVC3". */
export type As20Svc3_Order_By = {
  ADTRTHOS?: InputMaybe<Order_By>;
  ADTRTSYS?: InputMaybe<Order_By>;
  ADTRTVEN?: InputMaybe<Order_By>;
  ALCOPHOS?: InputMaybe<Order_By>;
  ALCOPSYS?: InputMaybe<Order_By>;
  ALCOPVEN?: InputMaybe<Order_By>;
  ALCPDHOS?: InputMaybe<Order_By>;
  ALCPDSYS?: InputMaybe<Order_By>;
  ALCPDVEN?: InputMaybe<Order_By>;
  ALCPRHOS?: InputMaybe<Order_By>;
  ALCPRSYS?: InputMaybe<Order_By>;
  ALCPRVEN?: InputMaybe<Order_By>;
  ALDBD?: InputMaybe<Order_By>;
  BAIMV?: InputMaybe<Order_By>;
  BHACAR?: InputMaybe<Order_By>;
  BHER?: InputMaybe<Order_By>;
  BHLTA?: InputMaybe<Order_By>;
  BHPCS?: InputMaybe<Order_By>;
  BHXCAR?: InputMaybe<Order_By>;
  BPIMV?: InputMaybe<Order_By>;
  CHCARHOS?: InputMaybe<Order_By>;
  CHCARSYS?: InputMaybe<Order_By>;
  CHCARVEN?: InputMaybe<Order_By>;
  COFVHOS?: InputMaybe<Order_By>;
  COFVSYS?: InputMaybe<Order_By>;
  COFVVEN?: InputMaybe<Order_By>;
  COVIDU?: InputMaybe<Order_By>;
  CPHCOS?: InputMaybe<Order_By>;
  CPHHOS?: InputMaybe<Order_By>;
  CPHIOS?: InputMaybe<Order_By>;
  CPHOHOS?: InputMaybe<Order_By>;
  CPHOSYS?: InputMaybe<Order_By>;
  CPHP?: InputMaybe<Order_By>;
  CPHPOS?: InputMaybe<Order_By>;
  DECHC?: InputMaybe<Order_By>;
  DECUTLA?: InputMaybe<Order_By>;
  EAIMV?: InputMaybe<Order_By>;
  EDBDCHG?: InputMaybe<Order_By>;
  EICUHOS?: InputMaybe<Order_By>;
  EICUSYS?: InputMaybe<Order_By>;
  EICUVEN?: InputMaybe<Order_By>;
  EPIMV?: InputMaybe<Order_By>;
  EQMCOS?: InputMaybe<Order_By>;
  EQMHOS?: InputMaybe<Order_By>;
  EQMIOS?: InputMaybe<Order_By>;
  EQMODHOS?: InputMaybe<Order_By>;
  EQMODSYS?: InputMaybe<Order_By>;
  EQMP?: InputMaybe<Order_By>;
  EQMPOS?: InputMaybe<Order_By>;
  FNDCOS?: InputMaybe<Order_By>;
  FNDHOS?: InputMaybe<Order_By>;
  FNDIOS?: InputMaybe<Order_By>;
  FNDP?: InputMaybe<Order_By>;
  FNDPOS?: InputMaybe<Order_By>;
  FOUNDHOS?: InputMaybe<Order_By>;
  FOUNDSYS?: InputMaybe<Order_By>;
  FTMT?: InputMaybe<Order_By>;
  GPWCOS?: InputMaybe<Order_By>;
  GPWHOS?: InputMaybe<Order_By>;
  GPWIOS?: InputMaybe<Order_By>;
  GPWP?: InputMaybe<Order_By>;
  GPWPOS?: InputMaybe<Order_By>;
  GPWWHOS?: InputMaybe<Order_By>;
  GPWWSYS?: InputMaybe<Order_By>;
  HARTHOS?: InputMaybe<Order_By>;
  HARTSYS?: InputMaybe<Order_By>;
  HARTVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IICUBD?: InputMaybe<Order_By>;
  IISMHOS?: InputMaybe<Order_By>;
  IMPSTAT?: InputMaybe<Order_By>;
  IPACOS?: InputMaybe<Order_By>;
  IPAHOS?: InputMaybe<Order_By>;
  IPAIOS?: InputMaybe<Order_By>;
  IPAP?: InputMaybe<Order_By>;
  IPAPOS?: InputMaybe<Order_By>;
  IPASYS?: InputMaybe<Order_By>;
  IPPAHOS?: InputMaybe<Order_By>;
  ISMCOS?: InputMaybe<Order_By>;
  ISMHOS?: InputMaybe<Order_By>;
  ISMIOS?: InputMaybe<Order_By>;
  ISMP?: InputMaybe<Order_By>;
  ISMPOS?: InputMaybe<Order_By>;
  ISMSYS?: InputMaybe<Order_By>;
  ISOCHG?: InputMaybe<Order_By>;
  ISORMB?: InputMaybe<Order_By>;
  ISORMC?: InputMaybe<Order_By>;
  ISORME?: InputMaybe<Order_By>;
  JNLS?: InputMaybe<Order_By>;
  JNTAMB?: InputMaybe<Order_By>;
  JNTCTR?: InputMaybe<Order_By>;
  JNTLSC?: InputMaybe<Order_By>;
  JNTLSO?: InputMaybe<Order_By>;
  JNTLSS?: InputMaybe<Order_By>;
  JNTLST?: InputMaybe<Order_By>;
  JNTMD?: InputMaybe<Order_By>;
  JNTOTH?: InputMaybe<Order_By>;
  JNTPH?: InputMaybe<Order_By>;
  JNTTXT?: InputMaybe<Order_By>;
  KDNYHOS?: InputMaybe<Order_By>;
  KDNYSYS?: InputMaybe<Order_By>;
  KDNYVEN?: InputMaybe<Order_By>;
  LIVRHOS?: InputMaybe<Order_By>;
  LIVRSYS?: InputMaybe<Order_By>;
  LIVRVEN?: InputMaybe<Order_By>;
  LSHTXT?: InputMaybe<Order_By>;
  LUNGHOS?: InputMaybe<Order_By>;
  LUNGSYS?: InputMaybe<Order_By>;
  LUNGVEN?: InputMaybe<Order_By>;
  MEDOPHOS?: InputMaybe<Order_By>;
  MEDOPSYS?: InputMaybe<Order_By>;
  MEDOPVEN?: InputMaybe<Order_By>;
  MEDSUBHOS?: InputMaybe<Order_By>;
  MEDSUBSYS?: InputMaybe<Order_By>;
  MEDSUBVEN?: InputMaybe<Order_By>;
  MMSOHOS?: InputMaybe<Order_By>;
  MSGRP?: InputMaybe<Order_By>;
  MSGRPN?: InputMaybe<Order_By>;
  MSOCOS?: InputMaybe<Order_By>;
  MSOHOS?: InputMaybe<Order_By>;
  MSOIOS?: InputMaybe<Order_By>;
  MSOP?: InputMaybe<Order_By>;
  MSOPOS?: InputMaybe<Order_By>;
  MSOSYS?: InputMaybe<Order_By>;
  OPHCOS?: InputMaybe<Order_By>;
  OPHHOS?: InputMaybe<Order_By>;
  OPHIOS?: InputMaybe<Order_By>;
  OPHOHOS?: InputMaybe<Order_By>;
  OPHOSYS?: InputMaybe<Order_By>;
  OPHP?: InputMaybe<Order_By>;
  OPHPOS?: InputMaybe<Order_By>;
  ORPMHOS?: InputMaybe<Order_By>;
  ORPMSYS?: InputMaybe<Order_By>;
  ORPMVEN?: InputMaybe<Order_By>;
  OTBONHOS?: InputMaybe<Order_By>;
  OTBONSYS?: InputMaybe<Order_By>;
  OTBONVEN?: InputMaybe<Order_By>;
  OTHTHOS?: InputMaybe<Order_By>;
  OTHTSYS?: InputMaybe<Order_By>;
  OTHTVEN?: InputMaybe<Order_By>;
  OTOTHHOS?: InputMaybe<Order_By>;
  OTOTHSYS?: InputMaybe<Order_By>;
  OTOTHVEN?: InputMaybe<Order_By>;
  OUTMTX?: InputMaybe<Order_By>;
  PDISHOS?: InputMaybe<Order_By>;
  PDISSYS?: InputMaybe<Order_By>;
  PDISVEN?: InputMaybe<Order_By>;
  PHACAR?: InputMaybe<Order_By>;
  PHER?: InputMaybe<Order_By>;
  PHPCS?: InputMaybe<Order_By>;
  PHXCAR?: InputMaybe<Order_By>;
  PHYCOS?: InputMaybe<Order_By>;
  PHYCPT?: InputMaybe<Order_By>;
  PHYHOS?: InputMaybe<Order_By>;
  PHYIOS?: InputMaybe<Order_By>;
  PHYOCPT?: InputMaybe<Order_By>;
  PHYOTH?: InputMaybe<Order_By>;
  PHYP?: InputMaybe<Order_By>;
  PHYPOS?: InputMaybe<Order_By>;
  PHYPR?: InputMaybe<Order_By>;
  PHYPRN?: InputMaybe<Order_By>;
  PHYSYS?: InputMaybe<Order_By>;
  PPHYHOS?: InputMaybe<Order_By>;
  RURLHOS?: InputMaybe<Order_By>;
  RURLSYS?: InputMaybe<Order_By>;
  RURLVEN?: InputMaybe<Order_By>;
  SCBH?: InputMaybe<Order_By>;
  SCEDL?: InputMaybe<Order_By>;
  SCFOD?: InputMaybe<Order_By>;
  SCHSE?: InputMaybe<Order_By>;
  SCIOS?: InputMaybe<Order_By>;
  SCNED?: InputMaybe<Order_By>;
  SCOTH?: InputMaybe<Order_By>;
  SCROT?: InputMaybe<Order_By>;
  SCSTAT?: InputMaybe<Order_By>;
  SCTRN?: InputMaybe<Order_By>;
  SCUND?: InputMaybe<Order_By>;
  SCV?: InputMaybe<Order_By>;
  SHACAR?: InputMaybe<Order_By>;
  SHER?: InputMaybe<Order_By>;
  SHPCS?: InputMaybe<Order_By>;
  SHXCAR?: InputMaybe<Order_By>;
  SLEPHOS?: InputMaybe<Order_By>;
  SLEPSYS?: InputMaybe<Order_By>;
  SLEPVEN?: InputMaybe<Order_By>;
  SOCBH?: InputMaybe<Order_By>;
  SOCED?: InputMaybe<Order_By>;
  SOCEHR?: InputMaybe<Order_By>;
  SOCFOD?: InputMaybe<Order_By>;
  SOCHSE?: InputMaybe<Order_By>;
  SOCINC?: InputMaybe<Order_By>;
  SOCIOS?: InputMaybe<Order_By>;
  SOCNED?: InputMaybe<Order_By>;
  SOCOT?: InputMaybe<Order_By>;
  SOCOTH?: InputMaybe<Order_By>;
  SOCTRN?: InputMaybe<Order_By>;
  SOCV?: InputMaybe<Order_By>;
  SOCWKHOS?: InputMaybe<Order_By>;
  SOCWKSYS?: InputMaybe<Order_By>;
  SOCWKVEN?: InputMaybe<Order_By>;
  SPORTHOS?: InputMaybe<Order_By>;
  SPORTSYS?: InputMaybe<Order_By>;
  SPORTVEN?: InputMaybe<Order_By>;
  SSGRP?: InputMaybe<Order_By>;
  SSGRPN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  STRCHOS?: InputMaybe<Order_By>;
  STRCSYS?: InputMaybe<Order_By>;
  STRCVEN?: InputMaybe<Order_By>;
  SUPPGHOS?: InputMaybe<Order_By>;
  SUPPGSYS?: InputMaybe<Order_By>;
  SUPPGVEN?: InputMaybe<Order_By>;
  SWBDHOS?: InputMaybe<Order_By>;
  SWBDSYS?: InputMaybe<Order_By>;
  SWBDVEN?: InputMaybe<Order_By>;
  TEENSHOS?: InputMaybe<Order_By>;
  TEENSSYS?: InputMaybe<Order_By>;
  TEENSVEN?: InputMaybe<Order_By>;
  TISUHOS?: InputMaybe<Order_By>;
  TISUSYS?: InputMaybe<Order_By>;
  TISUVEN?: InputMaybe<Order_By>;
  TOBHOS?: InputMaybe<Order_By>;
  TOBSYS?: InputMaybe<Order_By>;
  TOBVEN?: InputMaybe<Order_By>;
  TPORTHOS?: InputMaybe<Order_By>;
  TPORTSYS?: InputMaybe<Order_By>;
  TPORTVEN?: InputMaybe<Order_By>;
  URGCCHOS?: InputMaybe<Order_By>;
  URGCCSYS?: InputMaybe<Order_By>;
  URGCCVEN?: InputMaybe<Order_By>;
  VCMMHOS?: InputMaybe<Order_By>;
  VCMMSYS?: InputMaybe<Order_By>;
  VCMMVEN?: InputMaybe<Order_By>;
  VOLSVHOS?: InputMaybe<Order_By>;
  VOLSVSYS?: InputMaybe<Order_By>;
  VOLSVVEN?: InputMaybe<Order_By>;
  VRCSHOS?: InputMaybe<Order_By>;
  VRCSSYS?: InputMaybe<Order_By>;
  VRCSVEN?: InputMaybe<Order_By>;
  VWRKHOS?: InputMaybe<Order_By>;
  VWRKSYS?: InputMaybe<Order_By>;
  VWRKVEN?: InputMaybe<Order_By>;
  WMGTHOS?: InputMaybe<Order_By>;
  WMGTSYS?: InputMaybe<Order_By>;
  WMGTVEN?: InputMaybe<Order_By>;
  WOMHCHOS?: InputMaybe<Order_By>;
  WOMHCSYS?: InputMaybe<Order_By>;
  WOMHCVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS20SVC3 */
export type As20Svc3_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS20SVC3" */
export enum As20Svc3_Select_Column {
  /** column name */
  Adtrthos = 'ADTRTHOS',
  /** column name */
  Adtrtsys = 'ADTRTSYS',
  /** column name */
  Adtrtven = 'ADTRTVEN',
  /** column name */
  Alcophos = 'ALCOPHOS',
  /** column name */
  Alcopsys = 'ALCOPSYS',
  /** column name */
  Alcopven = 'ALCOPVEN',
  /** column name */
  Alcpdhos = 'ALCPDHOS',
  /** column name */
  Alcpdsys = 'ALCPDSYS',
  /** column name */
  Alcpdven = 'ALCPDVEN',
  /** column name */
  Alcprhos = 'ALCPRHOS',
  /** column name */
  Alcprsys = 'ALCPRSYS',
  /** column name */
  Alcprven = 'ALCPRVEN',
  /** column name */
  Aldbd = 'ALDBD',
  /** column name */
  Baimv = 'BAIMV',
  /** column name */
  Bhacar = 'BHACAR',
  /** column name */
  Bher = 'BHER',
  /** column name */
  Bhlta = 'BHLTA',
  /** column name */
  Bhpcs = 'BHPCS',
  /** column name */
  Bhxcar = 'BHXCAR',
  /** column name */
  Bpimv = 'BPIMV',
  /** column name */
  Chcarhos = 'CHCARHOS',
  /** column name */
  Chcarsys = 'CHCARSYS',
  /** column name */
  Chcarven = 'CHCARVEN',
  /** column name */
  Cofvhos = 'COFVHOS',
  /** column name */
  Cofvsys = 'COFVSYS',
  /** column name */
  Cofvven = 'COFVVEN',
  /** column name */
  Covidu = 'COVIDU',
  /** column name */
  Cphcos = 'CPHCOS',
  /** column name */
  Cphhos = 'CPHHOS',
  /** column name */
  Cphios = 'CPHIOS',
  /** column name */
  Cphohos = 'CPHOHOS',
  /** column name */
  Cphosys = 'CPHOSYS',
  /** column name */
  Cphp = 'CPHP',
  /** column name */
  Cphpos = 'CPHPOS',
  /** column name */
  Dechc = 'DECHC',
  /** column name */
  Decutla = 'DECUTLA',
  /** column name */
  Eaimv = 'EAIMV',
  /** column name */
  Edbdchg = 'EDBDCHG',
  /** column name */
  Eicuhos = 'EICUHOS',
  /** column name */
  Eicusys = 'EICUSYS',
  /** column name */
  Eicuven = 'EICUVEN',
  /** column name */
  Epimv = 'EPIMV',
  /** column name */
  Eqmcos = 'EQMCOS',
  /** column name */
  Eqmhos = 'EQMHOS',
  /** column name */
  Eqmios = 'EQMIOS',
  /** column name */
  Eqmodhos = 'EQMODHOS',
  /** column name */
  Eqmodsys = 'EQMODSYS',
  /** column name */
  Eqmp = 'EQMP',
  /** column name */
  Eqmpos = 'EQMPOS',
  /** column name */
  Fndcos = 'FNDCOS',
  /** column name */
  Fndhos = 'FNDHOS',
  /** column name */
  Fndios = 'FNDIOS',
  /** column name */
  Fndp = 'FNDP',
  /** column name */
  Fndpos = 'FNDPOS',
  /** column name */
  Foundhos = 'FOUNDHOS',
  /** column name */
  Foundsys = 'FOUNDSYS',
  /** column name */
  Ftmt = 'FTMT',
  /** column name */
  Gpwcos = 'GPWCOS',
  /** column name */
  Gpwhos = 'GPWHOS',
  /** column name */
  Gpwios = 'GPWIOS',
  /** column name */
  Gpwp = 'GPWP',
  /** column name */
  Gpwpos = 'GPWPOS',
  /** column name */
  Gpwwhos = 'GPWWHOS',
  /** column name */
  Gpwwsys = 'GPWWSYS',
  /** column name */
  Harthos = 'HARTHOS',
  /** column name */
  Hartsys = 'HARTSYS',
  /** column name */
  Hartven = 'HARTVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Iicubd = 'IICUBD',
  /** column name */
  Iismhos = 'IISMHOS',
  /** column name */
  Impstat = 'IMPSTAT',
  /** column name */
  Ipacos = 'IPACOS',
  /** column name */
  Ipahos = 'IPAHOS',
  /** column name */
  Ipaios = 'IPAIOS',
  /** column name */
  Ipap = 'IPAP',
  /** column name */
  Ipapos = 'IPAPOS',
  /** column name */
  Ipasys = 'IPASYS',
  /** column name */
  Ippahos = 'IPPAHOS',
  /** column name */
  Ismcos = 'ISMCOS',
  /** column name */
  Ismhos = 'ISMHOS',
  /** column name */
  Ismios = 'ISMIOS',
  /** column name */
  Ismp = 'ISMP',
  /** column name */
  Ismpos = 'ISMPOS',
  /** column name */
  Ismsys = 'ISMSYS',
  /** column name */
  Isochg = 'ISOCHG',
  /** column name */
  Isormb = 'ISORMB',
  /** column name */
  Isormc = 'ISORMC',
  /** column name */
  Isorme = 'ISORME',
  /** column name */
  Jnls = 'JNLS',
  /** column name */
  Jntamb = 'JNTAMB',
  /** column name */
  Jntctr = 'JNTCTR',
  /** column name */
  Jntlsc = 'JNTLSC',
  /** column name */
  Jntlso = 'JNTLSO',
  /** column name */
  Jntlss = 'JNTLSS',
  /** column name */
  Jntlst = 'JNTLST',
  /** column name */
  Jntmd = 'JNTMD',
  /** column name */
  Jntoth = 'JNTOTH',
  /** column name */
  Jntph = 'JNTPH',
  /** column name */
  Jnttxt = 'JNTTXT',
  /** column name */
  Kdnyhos = 'KDNYHOS',
  /** column name */
  Kdnysys = 'KDNYSYS',
  /** column name */
  Kdnyven = 'KDNYVEN',
  /** column name */
  Livrhos = 'LIVRHOS',
  /** column name */
  Livrsys = 'LIVRSYS',
  /** column name */
  Livrven = 'LIVRVEN',
  /** column name */
  Lshtxt = 'LSHTXT',
  /** column name */
  Lunghos = 'LUNGHOS',
  /** column name */
  Lungsys = 'LUNGSYS',
  /** column name */
  Lungven = 'LUNGVEN',
  /** column name */
  Medophos = 'MEDOPHOS',
  /** column name */
  Medopsys = 'MEDOPSYS',
  /** column name */
  Medopven = 'MEDOPVEN',
  /** column name */
  Medsubhos = 'MEDSUBHOS',
  /** column name */
  Medsubsys = 'MEDSUBSYS',
  /** column name */
  Medsubven = 'MEDSUBVEN',
  /** column name */
  Mmsohos = 'MMSOHOS',
  /** column name */
  Msgrp = 'MSGRP',
  /** column name */
  Msgrpn = 'MSGRPN',
  /** column name */
  Msocos = 'MSOCOS',
  /** column name */
  Msohos = 'MSOHOS',
  /** column name */
  Msoios = 'MSOIOS',
  /** column name */
  Msop = 'MSOP',
  /** column name */
  Msopos = 'MSOPOS',
  /** column name */
  Msosys = 'MSOSYS',
  /** column name */
  Ophcos = 'OPHCOS',
  /** column name */
  Ophhos = 'OPHHOS',
  /** column name */
  Ophios = 'OPHIOS',
  /** column name */
  Ophohos = 'OPHOHOS',
  /** column name */
  Ophosys = 'OPHOSYS',
  /** column name */
  Ophp = 'OPHP',
  /** column name */
  Ophpos = 'OPHPOS',
  /** column name */
  Orpmhos = 'ORPMHOS',
  /** column name */
  Orpmsys = 'ORPMSYS',
  /** column name */
  Orpmven = 'ORPMVEN',
  /** column name */
  Otbonhos = 'OTBONHOS',
  /** column name */
  Otbonsys = 'OTBONSYS',
  /** column name */
  Otbonven = 'OTBONVEN',
  /** column name */
  Oththos = 'OTHTHOS',
  /** column name */
  Othtsys = 'OTHTSYS',
  /** column name */
  Othtven = 'OTHTVEN',
  /** column name */
  Otothhos = 'OTOTHHOS',
  /** column name */
  Otothsys = 'OTOTHSYS',
  /** column name */
  Otothven = 'OTOTHVEN',
  /** column name */
  Outmtx = 'OUTMTX',
  /** column name */
  Pdishos = 'PDISHOS',
  /** column name */
  Pdissys = 'PDISSYS',
  /** column name */
  Pdisven = 'PDISVEN',
  /** column name */
  Phacar = 'PHACAR',
  /** column name */
  Pher = 'PHER',
  /** column name */
  Phpcs = 'PHPCS',
  /** column name */
  Phxcar = 'PHXCAR',
  /** column name */
  Phycos = 'PHYCOS',
  /** column name */
  Phycpt = 'PHYCPT',
  /** column name */
  Phyhos = 'PHYHOS',
  /** column name */
  Phyios = 'PHYIOS',
  /** column name */
  Phyocpt = 'PHYOCPT',
  /** column name */
  Phyoth = 'PHYOTH',
  /** column name */
  Phyp = 'PHYP',
  /** column name */
  Phypos = 'PHYPOS',
  /** column name */
  Phypr = 'PHYPR',
  /** column name */
  Phyprn = 'PHYPRN',
  /** column name */
  Physys = 'PHYSYS',
  /** column name */
  Pphyhos = 'PPHYHOS',
  /** column name */
  Rurlhos = 'RURLHOS',
  /** column name */
  Rurlsys = 'RURLSYS',
  /** column name */
  Rurlven = 'RURLVEN',
  /** column name */
  Scbh = 'SCBH',
  /** column name */
  Scedl = 'SCEDL',
  /** column name */
  Scfod = 'SCFOD',
  /** column name */
  Schse = 'SCHSE',
  /** column name */
  Scios = 'SCIOS',
  /** column name */
  Scned = 'SCNED',
  /** column name */
  Scoth = 'SCOTH',
  /** column name */
  Scrot = 'SCROT',
  /** column name */
  Scstat = 'SCSTAT',
  /** column name */
  Sctrn = 'SCTRN',
  /** column name */
  Scund = 'SCUND',
  /** column name */
  Scv = 'SCV',
  /** column name */
  Shacar = 'SHACAR',
  /** column name */
  Sher = 'SHER',
  /** column name */
  Shpcs = 'SHPCS',
  /** column name */
  Shxcar = 'SHXCAR',
  /** column name */
  Slephos = 'SLEPHOS',
  /** column name */
  Slepsys = 'SLEPSYS',
  /** column name */
  Slepven = 'SLEPVEN',
  /** column name */
  Socbh = 'SOCBH',
  /** column name */
  Soced = 'SOCED',
  /** column name */
  Socehr = 'SOCEHR',
  /** column name */
  Socfod = 'SOCFOD',
  /** column name */
  Sochse = 'SOCHSE',
  /** column name */
  Socinc = 'SOCINC',
  /** column name */
  Socios = 'SOCIOS',
  /** column name */
  Socned = 'SOCNED',
  /** column name */
  Socot = 'SOCOT',
  /** column name */
  Socoth = 'SOCOTH',
  /** column name */
  Soctrn = 'SOCTRN',
  /** column name */
  Socv = 'SOCV',
  /** column name */
  Socwkhos = 'SOCWKHOS',
  /** column name */
  Socwksys = 'SOCWKSYS',
  /** column name */
  Socwkven = 'SOCWKVEN',
  /** column name */
  Sporthos = 'SPORTHOS',
  /** column name */
  Sportsys = 'SPORTSYS',
  /** column name */
  Sportven = 'SPORTVEN',
  /** column name */
  Ssgrp = 'SSGRP',
  /** column name */
  Ssgrpn = 'SSGRPN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Strchos = 'STRCHOS',
  /** column name */
  Strcsys = 'STRCSYS',
  /** column name */
  Strcven = 'STRCVEN',
  /** column name */
  Suppghos = 'SUPPGHOS',
  /** column name */
  Suppgsys = 'SUPPGSYS',
  /** column name */
  Suppgven = 'SUPPGVEN',
  /** column name */
  Swbdhos = 'SWBDHOS',
  /** column name */
  Swbdsys = 'SWBDSYS',
  /** column name */
  Swbdven = 'SWBDVEN',
  /** column name */
  Teenshos = 'TEENSHOS',
  /** column name */
  Teenssys = 'TEENSSYS',
  /** column name */
  Teensven = 'TEENSVEN',
  /** column name */
  Tisuhos = 'TISUHOS',
  /** column name */
  Tisusys = 'TISUSYS',
  /** column name */
  Tisuven = 'TISUVEN',
  /** column name */
  Tobhos = 'TOBHOS',
  /** column name */
  Tobsys = 'TOBSYS',
  /** column name */
  Tobven = 'TOBVEN',
  /** column name */
  Tporthos = 'TPORTHOS',
  /** column name */
  Tportsys = 'TPORTSYS',
  /** column name */
  Tportven = 'TPORTVEN',
  /** column name */
  Urgcchos = 'URGCCHOS',
  /** column name */
  Urgccsys = 'URGCCSYS',
  /** column name */
  Urgccven = 'URGCCVEN',
  /** column name */
  Vcmmhos = 'VCMMHOS',
  /** column name */
  Vcmmsys = 'VCMMSYS',
  /** column name */
  Vcmmven = 'VCMMVEN',
  /** column name */
  Volsvhos = 'VOLSVHOS',
  /** column name */
  Volsvsys = 'VOLSVSYS',
  /** column name */
  Volsvven = 'VOLSVVEN',
  /** column name */
  Vrcshos = 'VRCSHOS',
  /** column name */
  Vrcssys = 'VRCSSYS',
  /** column name */
  Vrcsven = 'VRCSVEN',
  /** column name */
  Vwrkhos = 'VWRKHOS',
  /** column name */
  Vwrksys = 'VWRKSYS',
  /** column name */
  Vwrkven = 'VWRKVEN',
  /** column name */
  Wmgthos = 'WMGTHOS',
  /** column name */
  Wmgtsys = 'WMGTSYS',
  /** column name */
  Wmgtven = 'WMGTVEN',
  /** column name */
  Womhchos = 'WOMHCHOS',
  /** column name */
  Womhcsys = 'WOMHCSYS',
  /** column name */
  Womhcven = 'WOMHCVEN'
}

/** input type for updating data in table "AS20SVC3" */
export type As20Svc3_Set_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHACAR?: InputMaybe<Scalars['String']>;
  BHER?: InputMaybe<Scalars['String']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BHPCS?: InputMaybe<Scalars['String']>;
  BHXCAR?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDBDCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IICUBD?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISOCHG?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As20Svc3_Stddev_Fields = {
  __typename?: 'AS20SVC3_stddev_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As20Svc3_Stddev_Pop_Fields = {
  __typename?: 'AS20SVC3_stddev_pop_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As20Svc3_Stddev_Samp_Fields = {
  __typename?: 'AS20SVC3_stddev_samp_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS20SVC3" */
export type As20Svc3_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As20Svc3_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As20Svc3_Stream_Cursor_Value_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHACAR?: InputMaybe<Scalars['String']>;
  BHER?: InputMaybe<Scalars['String']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BHPCS?: InputMaybe<Scalars['String']>;
  BHXCAR?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDBDCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IICUBD?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISOCHG?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As20Svc3_Sum_Fields = {
  __typename?: 'AS20SVC3_sum_fields';
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BPIMV: Maybe<Scalars['float8']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  EAIMV: Maybe<Scalars['float8']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
};

/** update columns of table "AS20SVC3" */
export enum As20Svc3_Update_Column {
  /** column name */
  Adtrthos = 'ADTRTHOS',
  /** column name */
  Adtrtsys = 'ADTRTSYS',
  /** column name */
  Adtrtven = 'ADTRTVEN',
  /** column name */
  Alcophos = 'ALCOPHOS',
  /** column name */
  Alcopsys = 'ALCOPSYS',
  /** column name */
  Alcopven = 'ALCOPVEN',
  /** column name */
  Alcpdhos = 'ALCPDHOS',
  /** column name */
  Alcpdsys = 'ALCPDSYS',
  /** column name */
  Alcpdven = 'ALCPDVEN',
  /** column name */
  Alcprhos = 'ALCPRHOS',
  /** column name */
  Alcprsys = 'ALCPRSYS',
  /** column name */
  Alcprven = 'ALCPRVEN',
  /** column name */
  Aldbd = 'ALDBD',
  /** column name */
  Baimv = 'BAIMV',
  /** column name */
  Bhacar = 'BHACAR',
  /** column name */
  Bher = 'BHER',
  /** column name */
  Bhlta = 'BHLTA',
  /** column name */
  Bhpcs = 'BHPCS',
  /** column name */
  Bhxcar = 'BHXCAR',
  /** column name */
  Bpimv = 'BPIMV',
  /** column name */
  Chcarhos = 'CHCARHOS',
  /** column name */
  Chcarsys = 'CHCARSYS',
  /** column name */
  Chcarven = 'CHCARVEN',
  /** column name */
  Cofvhos = 'COFVHOS',
  /** column name */
  Cofvsys = 'COFVSYS',
  /** column name */
  Cofvven = 'COFVVEN',
  /** column name */
  Covidu = 'COVIDU',
  /** column name */
  Cphcos = 'CPHCOS',
  /** column name */
  Cphhos = 'CPHHOS',
  /** column name */
  Cphios = 'CPHIOS',
  /** column name */
  Cphohos = 'CPHOHOS',
  /** column name */
  Cphosys = 'CPHOSYS',
  /** column name */
  Cphp = 'CPHP',
  /** column name */
  Cphpos = 'CPHPOS',
  /** column name */
  Dechc = 'DECHC',
  /** column name */
  Decutla = 'DECUTLA',
  /** column name */
  Eaimv = 'EAIMV',
  /** column name */
  Edbdchg = 'EDBDCHG',
  /** column name */
  Eicuhos = 'EICUHOS',
  /** column name */
  Eicusys = 'EICUSYS',
  /** column name */
  Eicuven = 'EICUVEN',
  /** column name */
  Epimv = 'EPIMV',
  /** column name */
  Eqmcos = 'EQMCOS',
  /** column name */
  Eqmhos = 'EQMHOS',
  /** column name */
  Eqmios = 'EQMIOS',
  /** column name */
  Eqmodhos = 'EQMODHOS',
  /** column name */
  Eqmodsys = 'EQMODSYS',
  /** column name */
  Eqmp = 'EQMP',
  /** column name */
  Eqmpos = 'EQMPOS',
  /** column name */
  Fndcos = 'FNDCOS',
  /** column name */
  Fndhos = 'FNDHOS',
  /** column name */
  Fndios = 'FNDIOS',
  /** column name */
  Fndp = 'FNDP',
  /** column name */
  Fndpos = 'FNDPOS',
  /** column name */
  Foundhos = 'FOUNDHOS',
  /** column name */
  Foundsys = 'FOUNDSYS',
  /** column name */
  Ftmt = 'FTMT',
  /** column name */
  Gpwcos = 'GPWCOS',
  /** column name */
  Gpwhos = 'GPWHOS',
  /** column name */
  Gpwios = 'GPWIOS',
  /** column name */
  Gpwp = 'GPWP',
  /** column name */
  Gpwpos = 'GPWPOS',
  /** column name */
  Gpwwhos = 'GPWWHOS',
  /** column name */
  Gpwwsys = 'GPWWSYS',
  /** column name */
  Harthos = 'HARTHOS',
  /** column name */
  Hartsys = 'HARTSYS',
  /** column name */
  Hartven = 'HARTVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Iicubd = 'IICUBD',
  /** column name */
  Iismhos = 'IISMHOS',
  /** column name */
  Impstat = 'IMPSTAT',
  /** column name */
  Ipacos = 'IPACOS',
  /** column name */
  Ipahos = 'IPAHOS',
  /** column name */
  Ipaios = 'IPAIOS',
  /** column name */
  Ipap = 'IPAP',
  /** column name */
  Ipapos = 'IPAPOS',
  /** column name */
  Ipasys = 'IPASYS',
  /** column name */
  Ippahos = 'IPPAHOS',
  /** column name */
  Ismcos = 'ISMCOS',
  /** column name */
  Ismhos = 'ISMHOS',
  /** column name */
  Ismios = 'ISMIOS',
  /** column name */
  Ismp = 'ISMP',
  /** column name */
  Ismpos = 'ISMPOS',
  /** column name */
  Ismsys = 'ISMSYS',
  /** column name */
  Isochg = 'ISOCHG',
  /** column name */
  Isormb = 'ISORMB',
  /** column name */
  Isormc = 'ISORMC',
  /** column name */
  Isorme = 'ISORME',
  /** column name */
  Jnls = 'JNLS',
  /** column name */
  Jntamb = 'JNTAMB',
  /** column name */
  Jntctr = 'JNTCTR',
  /** column name */
  Jntlsc = 'JNTLSC',
  /** column name */
  Jntlso = 'JNTLSO',
  /** column name */
  Jntlss = 'JNTLSS',
  /** column name */
  Jntlst = 'JNTLST',
  /** column name */
  Jntmd = 'JNTMD',
  /** column name */
  Jntoth = 'JNTOTH',
  /** column name */
  Jntph = 'JNTPH',
  /** column name */
  Jnttxt = 'JNTTXT',
  /** column name */
  Kdnyhos = 'KDNYHOS',
  /** column name */
  Kdnysys = 'KDNYSYS',
  /** column name */
  Kdnyven = 'KDNYVEN',
  /** column name */
  Livrhos = 'LIVRHOS',
  /** column name */
  Livrsys = 'LIVRSYS',
  /** column name */
  Livrven = 'LIVRVEN',
  /** column name */
  Lshtxt = 'LSHTXT',
  /** column name */
  Lunghos = 'LUNGHOS',
  /** column name */
  Lungsys = 'LUNGSYS',
  /** column name */
  Lungven = 'LUNGVEN',
  /** column name */
  Medophos = 'MEDOPHOS',
  /** column name */
  Medopsys = 'MEDOPSYS',
  /** column name */
  Medopven = 'MEDOPVEN',
  /** column name */
  Medsubhos = 'MEDSUBHOS',
  /** column name */
  Medsubsys = 'MEDSUBSYS',
  /** column name */
  Medsubven = 'MEDSUBVEN',
  /** column name */
  Mmsohos = 'MMSOHOS',
  /** column name */
  Msgrp = 'MSGRP',
  /** column name */
  Msgrpn = 'MSGRPN',
  /** column name */
  Msocos = 'MSOCOS',
  /** column name */
  Msohos = 'MSOHOS',
  /** column name */
  Msoios = 'MSOIOS',
  /** column name */
  Msop = 'MSOP',
  /** column name */
  Msopos = 'MSOPOS',
  /** column name */
  Msosys = 'MSOSYS',
  /** column name */
  Ophcos = 'OPHCOS',
  /** column name */
  Ophhos = 'OPHHOS',
  /** column name */
  Ophios = 'OPHIOS',
  /** column name */
  Ophohos = 'OPHOHOS',
  /** column name */
  Ophosys = 'OPHOSYS',
  /** column name */
  Ophp = 'OPHP',
  /** column name */
  Ophpos = 'OPHPOS',
  /** column name */
  Orpmhos = 'ORPMHOS',
  /** column name */
  Orpmsys = 'ORPMSYS',
  /** column name */
  Orpmven = 'ORPMVEN',
  /** column name */
  Otbonhos = 'OTBONHOS',
  /** column name */
  Otbonsys = 'OTBONSYS',
  /** column name */
  Otbonven = 'OTBONVEN',
  /** column name */
  Oththos = 'OTHTHOS',
  /** column name */
  Othtsys = 'OTHTSYS',
  /** column name */
  Othtven = 'OTHTVEN',
  /** column name */
  Otothhos = 'OTOTHHOS',
  /** column name */
  Otothsys = 'OTOTHSYS',
  /** column name */
  Otothven = 'OTOTHVEN',
  /** column name */
  Outmtx = 'OUTMTX',
  /** column name */
  Pdishos = 'PDISHOS',
  /** column name */
  Pdissys = 'PDISSYS',
  /** column name */
  Pdisven = 'PDISVEN',
  /** column name */
  Phacar = 'PHACAR',
  /** column name */
  Pher = 'PHER',
  /** column name */
  Phpcs = 'PHPCS',
  /** column name */
  Phxcar = 'PHXCAR',
  /** column name */
  Phycos = 'PHYCOS',
  /** column name */
  Phycpt = 'PHYCPT',
  /** column name */
  Phyhos = 'PHYHOS',
  /** column name */
  Phyios = 'PHYIOS',
  /** column name */
  Phyocpt = 'PHYOCPT',
  /** column name */
  Phyoth = 'PHYOTH',
  /** column name */
  Phyp = 'PHYP',
  /** column name */
  Phypos = 'PHYPOS',
  /** column name */
  Phypr = 'PHYPR',
  /** column name */
  Phyprn = 'PHYPRN',
  /** column name */
  Physys = 'PHYSYS',
  /** column name */
  Pphyhos = 'PPHYHOS',
  /** column name */
  Rurlhos = 'RURLHOS',
  /** column name */
  Rurlsys = 'RURLSYS',
  /** column name */
  Rurlven = 'RURLVEN',
  /** column name */
  Scbh = 'SCBH',
  /** column name */
  Scedl = 'SCEDL',
  /** column name */
  Scfod = 'SCFOD',
  /** column name */
  Schse = 'SCHSE',
  /** column name */
  Scios = 'SCIOS',
  /** column name */
  Scned = 'SCNED',
  /** column name */
  Scoth = 'SCOTH',
  /** column name */
  Scrot = 'SCROT',
  /** column name */
  Scstat = 'SCSTAT',
  /** column name */
  Sctrn = 'SCTRN',
  /** column name */
  Scund = 'SCUND',
  /** column name */
  Scv = 'SCV',
  /** column name */
  Shacar = 'SHACAR',
  /** column name */
  Sher = 'SHER',
  /** column name */
  Shpcs = 'SHPCS',
  /** column name */
  Shxcar = 'SHXCAR',
  /** column name */
  Slephos = 'SLEPHOS',
  /** column name */
  Slepsys = 'SLEPSYS',
  /** column name */
  Slepven = 'SLEPVEN',
  /** column name */
  Socbh = 'SOCBH',
  /** column name */
  Soced = 'SOCED',
  /** column name */
  Socehr = 'SOCEHR',
  /** column name */
  Socfod = 'SOCFOD',
  /** column name */
  Sochse = 'SOCHSE',
  /** column name */
  Socinc = 'SOCINC',
  /** column name */
  Socios = 'SOCIOS',
  /** column name */
  Socned = 'SOCNED',
  /** column name */
  Socot = 'SOCOT',
  /** column name */
  Socoth = 'SOCOTH',
  /** column name */
  Soctrn = 'SOCTRN',
  /** column name */
  Socv = 'SOCV',
  /** column name */
  Socwkhos = 'SOCWKHOS',
  /** column name */
  Socwksys = 'SOCWKSYS',
  /** column name */
  Socwkven = 'SOCWKVEN',
  /** column name */
  Sporthos = 'SPORTHOS',
  /** column name */
  Sportsys = 'SPORTSYS',
  /** column name */
  Sportven = 'SPORTVEN',
  /** column name */
  Ssgrp = 'SSGRP',
  /** column name */
  Ssgrpn = 'SSGRPN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Strchos = 'STRCHOS',
  /** column name */
  Strcsys = 'STRCSYS',
  /** column name */
  Strcven = 'STRCVEN',
  /** column name */
  Suppghos = 'SUPPGHOS',
  /** column name */
  Suppgsys = 'SUPPGSYS',
  /** column name */
  Suppgven = 'SUPPGVEN',
  /** column name */
  Swbdhos = 'SWBDHOS',
  /** column name */
  Swbdsys = 'SWBDSYS',
  /** column name */
  Swbdven = 'SWBDVEN',
  /** column name */
  Teenshos = 'TEENSHOS',
  /** column name */
  Teenssys = 'TEENSSYS',
  /** column name */
  Teensven = 'TEENSVEN',
  /** column name */
  Tisuhos = 'TISUHOS',
  /** column name */
  Tisusys = 'TISUSYS',
  /** column name */
  Tisuven = 'TISUVEN',
  /** column name */
  Tobhos = 'TOBHOS',
  /** column name */
  Tobsys = 'TOBSYS',
  /** column name */
  Tobven = 'TOBVEN',
  /** column name */
  Tporthos = 'TPORTHOS',
  /** column name */
  Tportsys = 'TPORTSYS',
  /** column name */
  Tportven = 'TPORTVEN',
  /** column name */
  Urgcchos = 'URGCCHOS',
  /** column name */
  Urgccsys = 'URGCCSYS',
  /** column name */
  Urgccven = 'URGCCVEN',
  /** column name */
  Vcmmhos = 'VCMMHOS',
  /** column name */
  Vcmmsys = 'VCMMSYS',
  /** column name */
  Vcmmven = 'VCMMVEN',
  /** column name */
  Volsvhos = 'VOLSVHOS',
  /** column name */
  Volsvsys = 'VOLSVSYS',
  /** column name */
  Volsvven = 'VOLSVVEN',
  /** column name */
  Vrcshos = 'VRCSHOS',
  /** column name */
  Vrcssys = 'VRCSSYS',
  /** column name */
  Vrcsven = 'VRCSVEN',
  /** column name */
  Vwrkhos = 'VWRKHOS',
  /** column name */
  Vwrksys = 'VWRKSYS',
  /** column name */
  Vwrkven = 'VWRKVEN',
  /** column name */
  Wmgthos = 'WMGTHOS',
  /** column name */
  Wmgtsys = 'WMGTSYS',
  /** column name */
  Wmgtven = 'WMGTVEN',
  /** column name */
  Womhchos = 'WOMHCHOS',
  /** column name */
  Womhcsys = 'WOMHCSYS',
  /** column name */
  Womhcven = 'WOMHCVEN'
}

export type As20Svc3_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As20Svc3_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As20Svc3_Set_Input>;
  /** filter the rows which have to be updated */
  where: As20Svc3_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As20Svc3_Var_Pop_Fields = {
  __typename?: 'AS20SVC3_var_pop_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As20Svc3_Var_Samp_Fields = {
  __typename?: 'AS20SVC3_var_samp_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As20Svc3_Variance_Fields = {
  __typename?: 'AS20SVC3_variance_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS20UTIL1" */
export type As20Util1 = {
  __typename?: 'AS20UTIL1';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Scalars['String'];
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** aggregated selection of "AS20UTIL1" */
export type As20Util1_Aggregate = {
  __typename?: 'AS20UTIL1_aggregate';
  aggregate: Maybe<As20Util1_Aggregate_Fields>;
  nodes: Array<As20Util1>;
};

/** aggregate fields of "AS20UTIL1" */
export type As20Util1_Aggregate_Fields = {
  __typename?: 'AS20UTIL1_aggregate_fields';
  avg: Maybe<As20Util1_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As20Util1_Max_Fields>;
  min: Maybe<As20Util1_Min_Fields>;
  stddev: Maybe<As20Util1_Stddev_Fields>;
  stddev_pop: Maybe<As20Util1_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As20Util1_Stddev_Samp_Fields>;
  sum: Maybe<As20Util1_Sum_Fields>;
  var_pop: Maybe<As20Util1_Var_Pop_Fields>;
  var_samp: Maybe<As20Util1_Var_Samp_Fields>;
  variance: Maybe<As20Util1_Variance_Fields>;
};


/** aggregate fields of "AS20UTIL1" */
export type As20Util1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As20Util1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As20Util1_Avg_Fields = {
  __typename?: 'AS20UTIL1_avg_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS20UTIL1". All fields are combined with a logical 'AND'. */
export type As20Util1_Bool_Exp = {
  ADC?: InputMaybe<Float8_Comparison_Exp>;
  ADJADC?: InputMaybe<Float8_Comparison_Exp>;
  ADJADCH?: InputMaybe<Float8_Comparison_Exp>;
  ADJADM?: InputMaybe<Float8_Comparison_Exp>;
  ADJPD?: InputMaybe<Float8_Comparison_Exp>;
  ADJPDH?: InputMaybe<Float8_Comparison_Exp>;
  ADMH?: InputMaybe<Float8_Comparison_Exp>;
  ADMLT?: InputMaybe<Float8_Comparison_Exp>;
  ADMTOT?: InputMaybe<Float8_Comparison_Exp>;
  BASSIN?: InputMaybe<Float8_Comparison_Exp>;
  BDH?: InputMaybe<Float8_Comparison_Exp>;
  BDLT?: InputMaybe<Float8_Comparison_Exp>;
  BDTOT?: InputMaybe<Float8_Comparison_Exp>;
  BIRTHS?: InputMaybe<Float8_Comparison_Exp>;
  DPEXA?: InputMaybe<Float8_Comparison_Exp>;
  EADMH?: InputMaybe<String_Comparison_Exp>;
  EADMLT?: InputMaybe<String_Comparison_Exp>;
  EADMTOT?: InputMaybe<String_Comparison_Exp>;
  EBIRTHS?: InputMaybe<String_Comparison_Exp>;
  EEXPTOT?: InputMaybe<String_Comparison_Exp>;
  EFTAST?: InputMaybe<String_Comparison_Exp>;
  EFTLAB?: InputMaybe<String_Comparison_Exp>;
  EFTLPNTF?: InputMaybe<String_Comparison_Exp>;
  EFTMDTF?: InputMaybe<String_Comparison_Exp>;
  EFTOTHTF?: InputMaybe<String_Comparison_Exp>;
  EFTPHR?: InputMaybe<String_Comparison_Exp>;
  EFTPHT?: InputMaybe<String_Comparison_Exp>;
  EFTRAD?: InputMaybe<String_Comparison_Exp>;
  EFTRES?: InputMaybe<String_Comparison_Exp>;
  EFTRESP?: InputMaybe<String_Comparison_Exp>;
  EFTRNTF?: InputMaybe<String_Comparison_Exp>;
  EFTTOT?: InputMaybe<String_Comparison_Exp>;
  EFTTOTH?: InputMaybe<String_Comparison_Exp>;
  EFTTOTLT?: InputMaybe<String_Comparison_Exp>;
  EFTTRN84?: InputMaybe<String_Comparison_Exp>;
  EIPDH?: InputMaybe<String_Comparison_Exp>;
  EIPDLT?: InputMaybe<String_Comparison_Exp>;
  EIPDTOT?: InputMaybe<String_Comparison_Exp>;
  EMCDDC?: InputMaybe<String_Comparison_Exp>;
  EMCDDCH?: InputMaybe<String_Comparison_Exp>;
  EMCDDCLT?: InputMaybe<String_Comparison_Exp>;
  EMCDIPD?: InputMaybe<String_Comparison_Exp>;
  EMCDIPDH?: InputMaybe<String_Comparison_Exp>;
  EMCDPDLT?: InputMaybe<String_Comparison_Exp>;
  EMCRDC?: InputMaybe<String_Comparison_Exp>;
  EMCRDCH?: InputMaybe<String_Comparison_Exp>;
  EMCRDCLT?: InputMaybe<String_Comparison_Exp>;
  EMCRIPD?: InputMaybe<String_Comparison_Exp>;
  EMCRIPDH?: InputMaybe<String_Comparison_Exp>;
  EMCRPDLT?: InputMaybe<String_Comparison_Exp>;
  ENPAYBEN?: InputMaybe<String_Comparison_Exp>;
  ENPBENLT?: InputMaybe<String_Comparison_Exp>;
  ENPYBENH?: InputMaybe<String_Comparison_Exp>;
  EPAYTOT?: InputMaybe<String_Comparison_Exp>;
  EPAYTOTH?: InputMaybe<String_Comparison_Exp>;
  EPTAST?: InputMaybe<String_Comparison_Exp>;
  EPTLAB?: InputMaybe<String_Comparison_Exp>;
  EPTLPNTF?: InputMaybe<String_Comparison_Exp>;
  EPTMDTF?: InputMaybe<String_Comparison_Exp>;
  EPTOTHTF?: InputMaybe<String_Comparison_Exp>;
  EPTPHR?: InputMaybe<String_Comparison_Exp>;
  EPTPHT?: InputMaybe<String_Comparison_Exp>;
  EPTRAD?: InputMaybe<String_Comparison_Exp>;
  EPTRES?: InputMaybe<String_Comparison_Exp>;
  EPTRESP?: InputMaybe<String_Comparison_Exp>;
  EPTRNTF?: InputMaybe<String_Comparison_Exp>;
  EPTTOT?: InputMaybe<String_Comparison_Exp>;
  EPTTOTH?: InputMaybe<String_Comparison_Exp>;
  EPTTOTLT?: InputMaybe<String_Comparison_Exp>;
  EPTTRN84?: InputMaybe<String_Comparison_Exp>;
  EPYTOTLT?: InputMaybe<String_Comparison_Exp>;
  ERNFTE?: InputMaybe<Float8_Comparison_Exp>;
  ESUROPIP?: InputMaybe<String_Comparison_Exp>;
  ESUROPOP?: InputMaybe<String_Comparison_Exp>;
  ESUROPTO?: InputMaybe<String_Comparison_Exp>;
  EVEM?: InputMaybe<String_Comparison_Exp>;
  EVOTH?: InputMaybe<String_Comparison_Exp>;
  EVTOT?: InputMaybe<String_Comparison_Exp>;
  EXPTHA?: InputMaybe<Float8_Comparison_Exp>;
  EXPTHB?: InputMaybe<String_Comparison_Exp>;
  EXPTLA?: InputMaybe<Float8_Comparison_Exp>;
  EXPTLB?: InputMaybe<String_Comparison_Exp>;
  EXPTOT?: InputMaybe<Float8_Comparison_Exp>;
  FTAST?: InputMaybe<Float8_Comparison_Exp>;
  FTE?: InputMaybe<Float8_Comparison_Exp>;
  FTEAP?: InputMaybe<Float8_Comparison_Exp>;
  FTECAP?: InputMaybe<Float8_Comparison_Exp>;
  FTECLAB?: InputMaybe<Float8_Comparison_Exp>;
  FTECPH?: InputMaybe<Float8_Comparison_Exp>;
  FTECPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTECRAD?: InputMaybe<Float8_Comparison_Exp>;
  FTECRESP?: InputMaybe<Float8_Comparison_Exp>;
  FTED?: InputMaybe<Float8_Comparison_Exp>;
  FTEH?: InputMaybe<Float8_Comparison_Exp>;
  FTELAB?: InputMaybe<Float8_Comparison_Exp>;
  FTELPN?: InputMaybe<Float8_Comparison_Exp>;
  FTEMD?: InputMaybe<Float8_Comparison_Exp>;
  FTEN?: InputMaybe<Float8_Comparison_Exp>;
  FTENH?: InputMaybe<Float8_Comparison_Exp>;
  FTEO?: InputMaybe<Float8_Comparison_Exp>;
  FTEOTH94?: InputMaybe<Float8_Comparison_Exp>;
  FTEP?: InputMaybe<Float8_Comparison_Exp>;
  FTEPH?: InputMaybe<Float8_Comparison_Exp>;
  FTEPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTER?: InputMaybe<Float8_Comparison_Exp>;
  FTERAD?: InputMaybe<Float8_Comparison_Exp>;
  FTERES?: InputMaybe<Float8_Comparison_Exp>;
  FTERESP?: InputMaybe<Float8_Comparison_Exp>;
  FTERN?: InputMaybe<Float8_Comparison_Exp>;
  FTERNH?: InputMaybe<Float8_Comparison_Exp>;
  FTERNLT?: InputMaybe<Float8_Comparison_Exp>;
  FTET?: InputMaybe<Float8_Comparison_Exp>;
  FTETF?: InputMaybe<Float8_Comparison_Exp>;
  FTETRAN?: InputMaybe<Float8_Comparison_Exp>;
  FTETTRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEU?: InputMaybe<Float8_Comparison_Exp>;
  FTLAB?: InputMaybe<Float8_Comparison_Exp>;
  FTLPNTF?: InputMaybe<Float8_Comparison_Exp>;
  FTMDTF?: InputMaybe<Float8_Comparison_Exp>;
  FTOTHTF?: InputMaybe<Float8_Comparison_Exp>;
  FTPHR?: InputMaybe<Float8_Comparison_Exp>;
  FTPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTRAD?: InputMaybe<Float8_Comparison_Exp>;
  FTRES?: InputMaybe<Float8_Comparison_Exp>;
  FTRESP?: InputMaybe<Float8_Comparison_Exp>;
  FTRNLT?: InputMaybe<Float8_Comparison_Exp>;
  FTRNTF?: InputMaybe<Float8_Comparison_Exp>;
  FTTOT?: InputMaybe<Float8_Comparison_Exp>;
  FTTOTH?: InputMaybe<Float8_Comparison_Exp>;
  FTTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  FTTRAN84?: InputMaybe<Float8_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  INTEXA?: InputMaybe<Float8_Comparison_Exp>;
  IPDH?: InputMaybe<Float8_Comparison_Exp>;
  IPDLT?: InputMaybe<Float8_Comparison_Exp>;
  IPDTOT?: InputMaybe<Float8_Comparison_Exp>;
  LBEDLA?: InputMaybe<Float8_Comparison_Exp>;
  LBEDSA?: InputMaybe<Float8_Comparison_Exp>;
  MCDDC?: InputMaybe<Float8_Comparison_Exp>;
  MCDDCH?: InputMaybe<Float8_Comparison_Exp>;
  MCDDCLT?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPD?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPDH?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  MCRDC?: InputMaybe<Float8_Comparison_Exp>;
  MCRDCH?: InputMaybe<Float8_Comparison_Exp>;
  MCRDCLT?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPD?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPDH?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBEN?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBENH?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBENL?: InputMaybe<Float8_Comparison_Exp>;
  OPRA?: InputMaybe<Float8_Comparison_Exp>;
  OTHEXPA?: InputMaybe<Float8_Comparison_Exp>;
  OTHPCR?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOT?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOTH?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  PCMRES?: InputMaybe<Float8_Comparison_Exp>;
  PHREXA?: InputMaybe<Float8_Comparison_Exp>;
  PTAST?: InputMaybe<Float8_Comparison_Exp>;
  PTLAB?: InputMaybe<Float8_Comparison_Exp>;
  PTLPNTF?: InputMaybe<Float8_Comparison_Exp>;
  PTMDTF?: InputMaybe<Float8_Comparison_Exp>;
  PTOTHTF?: InputMaybe<Float8_Comparison_Exp>;
  PTPHR?: InputMaybe<Float8_Comparison_Exp>;
  PTPHT?: InputMaybe<Float8_Comparison_Exp>;
  PTRAD?: InputMaybe<Float8_Comparison_Exp>;
  PTRES?: InputMaybe<Float8_Comparison_Exp>;
  PTRESP?: InputMaybe<Float8_Comparison_Exp>;
  PTRNLT?: InputMaybe<Float8_Comparison_Exp>;
  PTRNTF?: InputMaybe<Float8_Comparison_Exp>;
  PTTOT?: InputMaybe<Float8_Comparison_Exp>;
  PTTOTH?: InputMaybe<Float8_Comparison_Exp>;
  PTTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  PTTRAN84?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUPEXA?: InputMaybe<Float8_Comparison_Exp>;
  SUROPIP?: InputMaybe<Float8_Comparison_Exp>;
  SUROPOP?: InputMaybe<Float8_Comparison_Exp>;
  SUROPTOT?: InputMaybe<Float8_Comparison_Exp>;
  VAST?: InputMaybe<Float8_Comparison_Exp>;
  VEM?: InputMaybe<Float8_Comparison_Exp>;
  VLAB?: InputMaybe<Float8_Comparison_Exp>;
  VLPN?: InputMaybe<Float8_Comparison_Exp>;
  VMD?: InputMaybe<Float8_Comparison_Exp>;
  VOTH?: InputMaybe<Float8_Comparison_Exp>;
  VOTHL?: InputMaybe<Float8_Comparison_Exp>;
  VPHR?: InputMaybe<Float8_Comparison_Exp>;
  VPHT?: InputMaybe<Float8_Comparison_Exp>;
  VRAD?: InputMaybe<Float8_Comparison_Exp>;
  VRES?: InputMaybe<Float8_Comparison_Exp>;
  VRN?: InputMaybe<Float8_Comparison_Exp>;
  VRNH?: InputMaybe<Float8_Comparison_Exp>;
  VRSP?: InputMaybe<Float8_Comparison_Exp>;
  VTNH?: InputMaybe<Float8_Comparison_Exp>;
  VTOT?: InputMaybe<Float8_Comparison_Exp>;
  VTOTL?: InputMaybe<Float8_Comparison_Exp>;
  VTTRN?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<As20Util1_Bool_Exp>>;
  _not?: InputMaybe<As20Util1_Bool_Exp>;
  _or?: InputMaybe<Array<As20Util1_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS20UTIL1" */
export enum As20Util1_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs20Util1 = 'pk_AS20UTIL1'
}

/** input type for incrementing numeric columns in table "AS20UTIL1" */
export type As20Util1_Inc_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS20UTIL1" */
export type As20Util1_Insert_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type As20Util1_Max_Fields = {
  __typename?: 'AS20UTIL1_max_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Maybe<Scalars['String']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type As20Util1_Min_Fields = {
  __typename?: 'AS20UTIL1_min_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Maybe<Scalars['String']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "AS20UTIL1" */
export type As20Util1_Mutation_Response = {
  __typename?: 'AS20UTIL1_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As20Util1>;
};

/** input type for inserting object relation for remote table "AS20UTIL1" */
export type As20Util1_Obj_Rel_Insert_Input = {
  data: As20Util1_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As20Util1_On_Conflict>;
};

/** on_conflict condition type for table "AS20UTIL1" */
export type As20Util1_On_Conflict = {
  constraint: As20Util1_Constraint;
  update_columns?: Array<As20Util1_Update_Column>;
  where?: InputMaybe<As20Util1_Bool_Exp>;
};

/** Ordering options when selecting data from "AS20UTIL1". */
export type As20Util1_Order_By = {
  ADC?: InputMaybe<Order_By>;
  ADJADC?: InputMaybe<Order_By>;
  ADJADCH?: InputMaybe<Order_By>;
  ADJADM?: InputMaybe<Order_By>;
  ADJPD?: InputMaybe<Order_By>;
  ADJPDH?: InputMaybe<Order_By>;
  ADMH?: InputMaybe<Order_By>;
  ADMLT?: InputMaybe<Order_By>;
  ADMTOT?: InputMaybe<Order_By>;
  BASSIN?: InputMaybe<Order_By>;
  BDH?: InputMaybe<Order_By>;
  BDLT?: InputMaybe<Order_By>;
  BDTOT?: InputMaybe<Order_By>;
  BIRTHS?: InputMaybe<Order_By>;
  DPEXA?: InputMaybe<Order_By>;
  EADMH?: InputMaybe<Order_By>;
  EADMLT?: InputMaybe<Order_By>;
  EADMTOT?: InputMaybe<Order_By>;
  EBIRTHS?: InputMaybe<Order_By>;
  EEXPTOT?: InputMaybe<Order_By>;
  EFTAST?: InputMaybe<Order_By>;
  EFTLAB?: InputMaybe<Order_By>;
  EFTLPNTF?: InputMaybe<Order_By>;
  EFTMDTF?: InputMaybe<Order_By>;
  EFTOTHTF?: InputMaybe<Order_By>;
  EFTPHR?: InputMaybe<Order_By>;
  EFTPHT?: InputMaybe<Order_By>;
  EFTRAD?: InputMaybe<Order_By>;
  EFTRES?: InputMaybe<Order_By>;
  EFTRESP?: InputMaybe<Order_By>;
  EFTRNTF?: InputMaybe<Order_By>;
  EFTTOT?: InputMaybe<Order_By>;
  EFTTOTH?: InputMaybe<Order_By>;
  EFTTOTLT?: InputMaybe<Order_By>;
  EFTTRN84?: InputMaybe<Order_By>;
  EIPDH?: InputMaybe<Order_By>;
  EIPDLT?: InputMaybe<Order_By>;
  EIPDTOT?: InputMaybe<Order_By>;
  EMCDDC?: InputMaybe<Order_By>;
  EMCDDCH?: InputMaybe<Order_By>;
  EMCDDCLT?: InputMaybe<Order_By>;
  EMCDIPD?: InputMaybe<Order_By>;
  EMCDIPDH?: InputMaybe<Order_By>;
  EMCDPDLT?: InputMaybe<Order_By>;
  EMCRDC?: InputMaybe<Order_By>;
  EMCRDCH?: InputMaybe<Order_By>;
  EMCRDCLT?: InputMaybe<Order_By>;
  EMCRIPD?: InputMaybe<Order_By>;
  EMCRIPDH?: InputMaybe<Order_By>;
  EMCRPDLT?: InputMaybe<Order_By>;
  ENPAYBEN?: InputMaybe<Order_By>;
  ENPBENLT?: InputMaybe<Order_By>;
  ENPYBENH?: InputMaybe<Order_By>;
  EPAYTOT?: InputMaybe<Order_By>;
  EPAYTOTH?: InputMaybe<Order_By>;
  EPTAST?: InputMaybe<Order_By>;
  EPTLAB?: InputMaybe<Order_By>;
  EPTLPNTF?: InputMaybe<Order_By>;
  EPTMDTF?: InputMaybe<Order_By>;
  EPTOTHTF?: InputMaybe<Order_By>;
  EPTPHR?: InputMaybe<Order_By>;
  EPTPHT?: InputMaybe<Order_By>;
  EPTRAD?: InputMaybe<Order_By>;
  EPTRES?: InputMaybe<Order_By>;
  EPTRESP?: InputMaybe<Order_By>;
  EPTRNTF?: InputMaybe<Order_By>;
  EPTTOT?: InputMaybe<Order_By>;
  EPTTOTH?: InputMaybe<Order_By>;
  EPTTOTLT?: InputMaybe<Order_By>;
  EPTTRN84?: InputMaybe<Order_By>;
  EPYTOTLT?: InputMaybe<Order_By>;
  ERNFTE?: InputMaybe<Order_By>;
  ESUROPIP?: InputMaybe<Order_By>;
  ESUROPOP?: InputMaybe<Order_By>;
  ESUROPTO?: InputMaybe<Order_By>;
  EVEM?: InputMaybe<Order_By>;
  EVOTH?: InputMaybe<Order_By>;
  EVTOT?: InputMaybe<Order_By>;
  EXPTHA?: InputMaybe<Order_By>;
  EXPTHB?: InputMaybe<Order_By>;
  EXPTLA?: InputMaybe<Order_By>;
  EXPTLB?: InputMaybe<Order_By>;
  EXPTOT?: InputMaybe<Order_By>;
  FTAST?: InputMaybe<Order_By>;
  FTE?: InputMaybe<Order_By>;
  FTEAP?: InputMaybe<Order_By>;
  FTECAP?: InputMaybe<Order_By>;
  FTECLAB?: InputMaybe<Order_By>;
  FTECPH?: InputMaybe<Order_By>;
  FTECPHT?: InputMaybe<Order_By>;
  FTECRAD?: InputMaybe<Order_By>;
  FTECRESP?: InputMaybe<Order_By>;
  FTED?: InputMaybe<Order_By>;
  FTEH?: InputMaybe<Order_By>;
  FTELAB?: InputMaybe<Order_By>;
  FTELPN?: InputMaybe<Order_By>;
  FTEMD?: InputMaybe<Order_By>;
  FTEN?: InputMaybe<Order_By>;
  FTENH?: InputMaybe<Order_By>;
  FTEO?: InputMaybe<Order_By>;
  FTEOTH94?: InputMaybe<Order_By>;
  FTEP?: InputMaybe<Order_By>;
  FTEPH?: InputMaybe<Order_By>;
  FTEPHT?: InputMaybe<Order_By>;
  FTER?: InputMaybe<Order_By>;
  FTERAD?: InputMaybe<Order_By>;
  FTERES?: InputMaybe<Order_By>;
  FTERESP?: InputMaybe<Order_By>;
  FTERN?: InputMaybe<Order_By>;
  FTERNH?: InputMaybe<Order_By>;
  FTERNLT?: InputMaybe<Order_By>;
  FTET?: InputMaybe<Order_By>;
  FTETF?: InputMaybe<Order_By>;
  FTETRAN?: InputMaybe<Order_By>;
  FTETTRN?: InputMaybe<Order_By>;
  FTEU?: InputMaybe<Order_By>;
  FTLAB?: InputMaybe<Order_By>;
  FTLPNTF?: InputMaybe<Order_By>;
  FTMDTF?: InputMaybe<Order_By>;
  FTOTHTF?: InputMaybe<Order_By>;
  FTPHR?: InputMaybe<Order_By>;
  FTPHT?: InputMaybe<Order_By>;
  FTRAD?: InputMaybe<Order_By>;
  FTRES?: InputMaybe<Order_By>;
  FTRESP?: InputMaybe<Order_By>;
  FTRNLT?: InputMaybe<Order_By>;
  FTRNTF?: InputMaybe<Order_By>;
  FTTOT?: InputMaybe<Order_By>;
  FTTOTH?: InputMaybe<Order_By>;
  FTTOTLT?: InputMaybe<Order_By>;
  FTTRAN84?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  INTEXA?: InputMaybe<Order_By>;
  IPDH?: InputMaybe<Order_By>;
  IPDLT?: InputMaybe<Order_By>;
  IPDTOT?: InputMaybe<Order_By>;
  LBEDLA?: InputMaybe<Order_By>;
  LBEDSA?: InputMaybe<Order_By>;
  MCDDC?: InputMaybe<Order_By>;
  MCDDCH?: InputMaybe<Order_By>;
  MCDDCLT?: InputMaybe<Order_By>;
  MCDIPD?: InputMaybe<Order_By>;
  MCDIPDH?: InputMaybe<Order_By>;
  MCDIPDLT?: InputMaybe<Order_By>;
  MCRDC?: InputMaybe<Order_By>;
  MCRDCH?: InputMaybe<Order_By>;
  MCRDCLT?: InputMaybe<Order_By>;
  MCRIPD?: InputMaybe<Order_By>;
  MCRIPDH?: InputMaybe<Order_By>;
  MCRIPDLT?: InputMaybe<Order_By>;
  NPAYBEN?: InputMaybe<Order_By>;
  NPAYBENH?: InputMaybe<Order_By>;
  NPAYBENL?: InputMaybe<Order_By>;
  OPRA?: InputMaybe<Order_By>;
  OTHEXPA?: InputMaybe<Order_By>;
  OTHPCR?: InputMaybe<Order_By>;
  PAYTOT?: InputMaybe<Order_By>;
  PAYTOTH?: InputMaybe<Order_By>;
  PAYTOTLT?: InputMaybe<Order_By>;
  PCMRES?: InputMaybe<Order_By>;
  PHREXA?: InputMaybe<Order_By>;
  PTAST?: InputMaybe<Order_By>;
  PTLAB?: InputMaybe<Order_By>;
  PTLPNTF?: InputMaybe<Order_By>;
  PTMDTF?: InputMaybe<Order_By>;
  PTOTHTF?: InputMaybe<Order_By>;
  PTPHR?: InputMaybe<Order_By>;
  PTPHT?: InputMaybe<Order_By>;
  PTRAD?: InputMaybe<Order_By>;
  PTRES?: InputMaybe<Order_By>;
  PTRESP?: InputMaybe<Order_By>;
  PTRNLT?: InputMaybe<Order_By>;
  PTRNTF?: InputMaybe<Order_By>;
  PTTOT?: InputMaybe<Order_By>;
  PTTOTH?: InputMaybe<Order_By>;
  PTTOTLT?: InputMaybe<Order_By>;
  PTTRAN84?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUPEXA?: InputMaybe<Order_By>;
  SUROPIP?: InputMaybe<Order_By>;
  SUROPOP?: InputMaybe<Order_By>;
  SUROPTOT?: InputMaybe<Order_By>;
  VAST?: InputMaybe<Order_By>;
  VEM?: InputMaybe<Order_By>;
  VLAB?: InputMaybe<Order_By>;
  VLPN?: InputMaybe<Order_By>;
  VMD?: InputMaybe<Order_By>;
  VOTH?: InputMaybe<Order_By>;
  VOTHL?: InputMaybe<Order_By>;
  VPHR?: InputMaybe<Order_By>;
  VPHT?: InputMaybe<Order_By>;
  VRAD?: InputMaybe<Order_By>;
  VRES?: InputMaybe<Order_By>;
  VRN?: InputMaybe<Order_By>;
  VRNH?: InputMaybe<Order_By>;
  VRSP?: InputMaybe<Order_By>;
  VTNH?: InputMaybe<Order_By>;
  VTOT?: InputMaybe<Order_By>;
  VTOTL?: InputMaybe<Order_By>;
  VTTRN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS20UTIL1 */
export type As20Util1_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS20UTIL1" */
export enum As20Util1_Select_Column {
  /** column name */
  Adc = 'ADC',
  /** column name */
  Adjadc = 'ADJADC',
  /** column name */
  Adjadch = 'ADJADCH',
  /** column name */
  Adjadm = 'ADJADM',
  /** column name */
  Adjpd = 'ADJPD',
  /** column name */
  Adjpdh = 'ADJPDH',
  /** column name */
  Admh = 'ADMH',
  /** column name */
  Admlt = 'ADMLT',
  /** column name */
  Admtot = 'ADMTOT',
  /** column name */
  Bassin = 'BASSIN',
  /** column name */
  Bdh = 'BDH',
  /** column name */
  Bdlt = 'BDLT',
  /** column name */
  Bdtot = 'BDTOT',
  /** column name */
  Births = 'BIRTHS',
  /** column name */
  Dpexa = 'DPEXA',
  /** column name */
  Eadmh = 'EADMH',
  /** column name */
  Eadmlt = 'EADMLT',
  /** column name */
  Eadmtot = 'EADMTOT',
  /** column name */
  Ebirths = 'EBIRTHS',
  /** column name */
  Eexptot = 'EEXPTOT',
  /** column name */
  Eftast = 'EFTAST',
  /** column name */
  Eftlab = 'EFTLAB',
  /** column name */
  Eftlpntf = 'EFTLPNTF',
  /** column name */
  Eftmdtf = 'EFTMDTF',
  /** column name */
  Eftothtf = 'EFTOTHTF',
  /** column name */
  Eftphr = 'EFTPHR',
  /** column name */
  Eftpht = 'EFTPHT',
  /** column name */
  Eftrad = 'EFTRAD',
  /** column name */
  Eftres = 'EFTRES',
  /** column name */
  Eftresp = 'EFTRESP',
  /** column name */
  Eftrntf = 'EFTRNTF',
  /** column name */
  Efttot = 'EFTTOT',
  /** column name */
  Efttoth = 'EFTTOTH',
  /** column name */
  Efttotlt = 'EFTTOTLT',
  /** column name */
  Efttrn84 = 'EFTTRN84',
  /** column name */
  Eipdh = 'EIPDH',
  /** column name */
  Eipdlt = 'EIPDLT',
  /** column name */
  Eipdtot = 'EIPDTOT',
  /** column name */
  Emcddc = 'EMCDDC',
  /** column name */
  Emcddch = 'EMCDDCH',
  /** column name */
  Emcddclt = 'EMCDDCLT',
  /** column name */
  Emcdipd = 'EMCDIPD',
  /** column name */
  Emcdipdh = 'EMCDIPDH',
  /** column name */
  Emcdpdlt = 'EMCDPDLT',
  /** column name */
  Emcrdc = 'EMCRDC',
  /** column name */
  Emcrdch = 'EMCRDCH',
  /** column name */
  Emcrdclt = 'EMCRDCLT',
  /** column name */
  Emcripd = 'EMCRIPD',
  /** column name */
  Emcripdh = 'EMCRIPDH',
  /** column name */
  Emcrpdlt = 'EMCRPDLT',
  /** column name */
  Enpayben = 'ENPAYBEN',
  /** column name */
  Enpbenlt = 'ENPBENLT',
  /** column name */
  Enpybenh = 'ENPYBENH',
  /** column name */
  Epaytot = 'EPAYTOT',
  /** column name */
  Epaytoth = 'EPAYTOTH',
  /** column name */
  Eptast = 'EPTAST',
  /** column name */
  Eptlab = 'EPTLAB',
  /** column name */
  Eptlpntf = 'EPTLPNTF',
  /** column name */
  Eptmdtf = 'EPTMDTF',
  /** column name */
  Eptothtf = 'EPTOTHTF',
  /** column name */
  Eptphr = 'EPTPHR',
  /** column name */
  Eptpht = 'EPTPHT',
  /** column name */
  Eptrad = 'EPTRAD',
  /** column name */
  Eptres = 'EPTRES',
  /** column name */
  Eptresp = 'EPTRESP',
  /** column name */
  Eptrntf = 'EPTRNTF',
  /** column name */
  Epttot = 'EPTTOT',
  /** column name */
  Epttoth = 'EPTTOTH',
  /** column name */
  Epttotlt = 'EPTTOTLT',
  /** column name */
  Epttrn84 = 'EPTTRN84',
  /** column name */
  Epytotlt = 'EPYTOTLT',
  /** column name */
  Ernfte = 'ERNFTE',
  /** column name */
  Esuropip = 'ESUROPIP',
  /** column name */
  Esuropop = 'ESUROPOP',
  /** column name */
  Esuropto = 'ESUROPTO',
  /** column name */
  Evem = 'EVEM',
  /** column name */
  Evoth = 'EVOTH',
  /** column name */
  Evtot = 'EVTOT',
  /** column name */
  Exptha = 'EXPTHA',
  /** column name */
  Expthb = 'EXPTHB',
  /** column name */
  Exptla = 'EXPTLA',
  /** column name */
  Exptlb = 'EXPTLB',
  /** column name */
  Exptot = 'EXPTOT',
  /** column name */
  Ftast = 'FTAST',
  /** column name */
  Fte = 'FTE',
  /** column name */
  Fteap = 'FTEAP',
  /** column name */
  Ftecap = 'FTECAP',
  /** column name */
  Fteclab = 'FTECLAB',
  /** column name */
  Ftecph = 'FTECPH',
  /** column name */
  Ftecpht = 'FTECPHT',
  /** column name */
  Ftecrad = 'FTECRAD',
  /** column name */
  Ftecresp = 'FTECRESP',
  /** column name */
  Fted = 'FTED',
  /** column name */
  Fteh = 'FTEH',
  /** column name */
  Ftelab = 'FTELAB',
  /** column name */
  Ftelpn = 'FTELPN',
  /** column name */
  Ftemd = 'FTEMD',
  /** column name */
  Ften = 'FTEN',
  /** column name */
  Ftenh = 'FTENH',
  /** column name */
  Fteo = 'FTEO',
  /** column name */
  Fteoth94 = 'FTEOTH94',
  /** column name */
  Ftep = 'FTEP',
  /** column name */
  Fteph = 'FTEPH',
  /** column name */
  Ftepht = 'FTEPHT',
  /** column name */
  Fter = 'FTER',
  /** column name */
  Fterad = 'FTERAD',
  /** column name */
  Fteres = 'FTERES',
  /** column name */
  Fteresp = 'FTERESP',
  /** column name */
  Ftern = 'FTERN',
  /** column name */
  Fternh = 'FTERNH',
  /** column name */
  Fternlt = 'FTERNLT',
  /** column name */
  Ftet = 'FTET',
  /** column name */
  Ftetf = 'FTETF',
  /** column name */
  Ftetran = 'FTETRAN',
  /** column name */
  Ftettrn = 'FTETTRN',
  /** column name */
  Fteu = 'FTEU',
  /** column name */
  Ftlab = 'FTLAB',
  /** column name */
  Ftlpntf = 'FTLPNTF',
  /** column name */
  Ftmdtf = 'FTMDTF',
  /** column name */
  Ftothtf = 'FTOTHTF',
  /** column name */
  Ftphr = 'FTPHR',
  /** column name */
  Ftpht = 'FTPHT',
  /** column name */
  Ftrad = 'FTRAD',
  /** column name */
  Ftres = 'FTRES',
  /** column name */
  Ftresp = 'FTRESP',
  /** column name */
  Ftrnlt = 'FTRNLT',
  /** column name */
  Ftrntf = 'FTRNTF',
  /** column name */
  Fttot = 'FTTOT',
  /** column name */
  Fttoth = 'FTTOTH',
  /** column name */
  Fttotlt = 'FTTOTLT',
  /** column name */
  Fttran84 = 'FTTRAN84',
  /** column name */
  Id = 'ID',
  /** column name */
  Intexa = 'INTEXA',
  /** column name */
  Ipdh = 'IPDH',
  /** column name */
  Ipdlt = 'IPDLT',
  /** column name */
  Ipdtot = 'IPDTOT',
  /** column name */
  Lbedla = 'LBEDLA',
  /** column name */
  Lbedsa = 'LBEDSA',
  /** column name */
  Mcddc = 'MCDDC',
  /** column name */
  Mcddch = 'MCDDCH',
  /** column name */
  Mcddclt = 'MCDDCLT',
  /** column name */
  Mcdipd = 'MCDIPD',
  /** column name */
  Mcdipdh = 'MCDIPDH',
  /** column name */
  Mcdipdlt = 'MCDIPDLT',
  /** column name */
  Mcrdc = 'MCRDC',
  /** column name */
  Mcrdch = 'MCRDCH',
  /** column name */
  Mcrdclt = 'MCRDCLT',
  /** column name */
  Mcripd = 'MCRIPD',
  /** column name */
  Mcripdh = 'MCRIPDH',
  /** column name */
  Mcripdlt = 'MCRIPDLT',
  /** column name */
  Npayben = 'NPAYBEN',
  /** column name */
  Npaybenh = 'NPAYBENH',
  /** column name */
  Npaybenl = 'NPAYBENL',
  /** column name */
  Opra = 'OPRA',
  /** column name */
  Othexpa = 'OTHEXPA',
  /** column name */
  Othpcr = 'OTHPCR',
  /** column name */
  Paytot = 'PAYTOT',
  /** column name */
  Paytoth = 'PAYTOTH',
  /** column name */
  Paytotlt = 'PAYTOTLT',
  /** column name */
  Pcmres = 'PCMRES',
  /** column name */
  Phrexa = 'PHREXA',
  /** column name */
  Ptast = 'PTAST',
  /** column name */
  Ptlab = 'PTLAB',
  /** column name */
  Ptlpntf = 'PTLPNTF',
  /** column name */
  Ptmdtf = 'PTMDTF',
  /** column name */
  Ptothtf = 'PTOTHTF',
  /** column name */
  Ptphr = 'PTPHR',
  /** column name */
  Ptpht = 'PTPHT',
  /** column name */
  Ptrad = 'PTRAD',
  /** column name */
  Ptres = 'PTRES',
  /** column name */
  Ptresp = 'PTRESP',
  /** column name */
  Ptrnlt = 'PTRNLT',
  /** column name */
  Ptrntf = 'PTRNTF',
  /** column name */
  Pttot = 'PTTOT',
  /** column name */
  Pttoth = 'PTTOTH',
  /** column name */
  Pttotlt = 'PTTOTLT',
  /** column name */
  Pttran84 = 'PTTRAN84',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Supexa = 'SUPEXA',
  /** column name */
  Suropip = 'SUROPIP',
  /** column name */
  Suropop = 'SUROPOP',
  /** column name */
  Suroptot = 'SUROPTOT',
  /** column name */
  Vast = 'VAST',
  /** column name */
  Vem = 'VEM',
  /** column name */
  Vlab = 'VLAB',
  /** column name */
  Vlpn = 'VLPN',
  /** column name */
  Vmd = 'VMD',
  /** column name */
  Voth = 'VOTH',
  /** column name */
  Vothl = 'VOTHL',
  /** column name */
  Vphr = 'VPHR',
  /** column name */
  Vpht = 'VPHT',
  /** column name */
  Vrad = 'VRAD',
  /** column name */
  Vres = 'VRES',
  /** column name */
  Vrn = 'VRN',
  /** column name */
  Vrnh = 'VRNH',
  /** column name */
  Vrsp = 'VRSP',
  /** column name */
  Vtnh = 'VTNH',
  /** column name */
  Vtot = 'VTOT',
  /** column name */
  Vtotl = 'VTOTL',
  /** column name */
  Vttrn = 'VTTRN'
}

/** input type for updating data in table "AS20UTIL1" */
export type As20Util1_Set_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type As20Util1_Stddev_Fields = {
  __typename?: 'AS20UTIL1_stddev_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As20Util1_Stddev_Pop_Fields = {
  __typename?: 'AS20UTIL1_stddev_pop_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As20Util1_Stddev_Samp_Fields = {
  __typename?: 'AS20UTIL1_stddev_samp_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS20UTIL1" */
export type As20Util1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As20Util1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As20Util1_Stream_Cursor_Value_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type As20Util1_Sum_Fields = {
  __typename?: 'AS20UTIL1_sum_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  ERNFTE: Maybe<Scalars['float8']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** update columns of table "AS20UTIL1" */
export enum As20Util1_Update_Column {
  /** column name */
  Adc = 'ADC',
  /** column name */
  Adjadc = 'ADJADC',
  /** column name */
  Adjadch = 'ADJADCH',
  /** column name */
  Adjadm = 'ADJADM',
  /** column name */
  Adjpd = 'ADJPD',
  /** column name */
  Adjpdh = 'ADJPDH',
  /** column name */
  Admh = 'ADMH',
  /** column name */
  Admlt = 'ADMLT',
  /** column name */
  Admtot = 'ADMTOT',
  /** column name */
  Bassin = 'BASSIN',
  /** column name */
  Bdh = 'BDH',
  /** column name */
  Bdlt = 'BDLT',
  /** column name */
  Bdtot = 'BDTOT',
  /** column name */
  Births = 'BIRTHS',
  /** column name */
  Dpexa = 'DPEXA',
  /** column name */
  Eadmh = 'EADMH',
  /** column name */
  Eadmlt = 'EADMLT',
  /** column name */
  Eadmtot = 'EADMTOT',
  /** column name */
  Ebirths = 'EBIRTHS',
  /** column name */
  Eexptot = 'EEXPTOT',
  /** column name */
  Eftast = 'EFTAST',
  /** column name */
  Eftlab = 'EFTLAB',
  /** column name */
  Eftlpntf = 'EFTLPNTF',
  /** column name */
  Eftmdtf = 'EFTMDTF',
  /** column name */
  Eftothtf = 'EFTOTHTF',
  /** column name */
  Eftphr = 'EFTPHR',
  /** column name */
  Eftpht = 'EFTPHT',
  /** column name */
  Eftrad = 'EFTRAD',
  /** column name */
  Eftres = 'EFTRES',
  /** column name */
  Eftresp = 'EFTRESP',
  /** column name */
  Eftrntf = 'EFTRNTF',
  /** column name */
  Efttot = 'EFTTOT',
  /** column name */
  Efttoth = 'EFTTOTH',
  /** column name */
  Efttotlt = 'EFTTOTLT',
  /** column name */
  Efttrn84 = 'EFTTRN84',
  /** column name */
  Eipdh = 'EIPDH',
  /** column name */
  Eipdlt = 'EIPDLT',
  /** column name */
  Eipdtot = 'EIPDTOT',
  /** column name */
  Emcddc = 'EMCDDC',
  /** column name */
  Emcddch = 'EMCDDCH',
  /** column name */
  Emcddclt = 'EMCDDCLT',
  /** column name */
  Emcdipd = 'EMCDIPD',
  /** column name */
  Emcdipdh = 'EMCDIPDH',
  /** column name */
  Emcdpdlt = 'EMCDPDLT',
  /** column name */
  Emcrdc = 'EMCRDC',
  /** column name */
  Emcrdch = 'EMCRDCH',
  /** column name */
  Emcrdclt = 'EMCRDCLT',
  /** column name */
  Emcripd = 'EMCRIPD',
  /** column name */
  Emcripdh = 'EMCRIPDH',
  /** column name */
  Emcrpdlt = 'EMCRPDLT',
  /** column name */
  Enpayben = 'ENPAYBEN',
  /** column name */
  Enpbenlt = 'ENPBENLT',
  /** column name */
  Enpybenh = 'ENPYBENH',
  /** column name */
  Epaytot = 'EPAYTOT',
  /** column name */
  Epaytoth = 'EPAYTOTH',
  /** column name */
  Eptast = 'EPTAST',
  /** column name */
  Eptlab = 'EPTLAB',
  /** column name */
  Eptlpntf = 'EPTLPNTF',
  /** column name */
  Eptmdtf = 'EPTMDTF',
  /** column name */
  Eptothtf = 'EPTOTHTF',
  /** column name */
  Eptphr = 'EPTPHR',
  /** column name */
  Eptpht = 'EPTPHT',
  /** column name */
  Eptrad = 'EPTRAD',
  /** column name */
  Eptres = 'EPTRES',
  /** column name */
  Eptresp = 'EPTRESP',
  /** column name */
  Eptrntf = 'EPTRNTF',
  /** column name */
  Epttot = 'EPTTOT',
  /** column name */
  Epttoth = 'EPTTOTH',
  /** column name */
  Epttotlt = 'EPTTOTLT',
  /** column name */
  Epttrn84 = 'EPTTRN84',
  /** column name */
  Epytotlt = 'EPYTOTLT',
  /** column name */
  Ernfte = 'ERNFTE',
  /** column name */
  Esuropip = 'ESUROPIP',
  /** column name */
  Esuropop = 'ESUROPOP',
  /** column name */
  Esuropto = 'ESUROPTO',
  /** column name */
  Evem = 'EVEM',
  /** column name */
  Evoth = 'EVOTH',
  /** column name */
  Evtot = 'EVTOT',
  /** column name */
  Exptha = 'EXPTHA',
  /** column name */
  Expthb = 'EXPTHB',
  /** column name */
  Exptla = 'EXPTLA',
  /** column name */
  Exptlb = 'EXPTLB',
  /** column name */
  Exptot = 'EXPTOT',
  /** column name */
  Ftast = 'FTAST',
  /** column name */
  Fte = 'FTE',
  /** column name */
  Fteap = 'FTEAP',
  /** column name */
  Ftecap = 'FTECAP',
  /** column name */
  Fteclab = 'FTECLAB',
  /** column name */
  Ftecph = 'FTECPH',
  /** column name */
  Ftecpht = 'FTECPHT',
  /** column name */
  Ftecrad = 'FTECRAD',
  /** column name */
  Ftecresp = 'FTECRESP',
  /** column name */
  Fted = 'FTED',
  /** column name */
  Fteh = 'FTEH',
  /** column name */
  Ftelab = 'FTELAB',
  /** column name */
  Ftelpn = 'FTELPN',
  /** column name */
  Ftemd = 'FTEMD',
  /** column name */
  Ften = 'FTEN',
  /** column name */
  Ftenh = 'FTENH',
  /** column name */
  Fteo = 'FTEO',
  /** column name */
  Fteoth94 = 'FTEOTH94',
  /** column name */
  Ftep = 'FTEP',
  /** column name */
  Fteph = 'FTEPH',
  /** column name */
  Ftepht = 'FTEPHT',
  /** column name */
  Fter = 'FTER',
  /** column name */
  Fterad = 'FTERAD',
  /** column name */
  Fteres = 'FTERES',
  /** column name */
  Fteresp = 'FTERESP',
  /** column name */
  Ftern = 'FTERN',
  /** column name */
  Fternh = 'FTERNH',
  /** column name */
  Fternlt = 'FTERNLT',
  /** column name */
  Ftet = 'FTET',
  /** column name */
  Ftetf = 'FTETF',
  /** column name */
  Ftetran = 'FTETRAN',
  /** column name */
  Ftettrn = 'FTETTRN',
  /** column name */
  Fteu = 'FTEU',
  /** column name */
  Ftlab = 'FTLAB',
  /** column name */
  Ftlpntf = 'FTLPNTF',
  /** column name */
  Ftmdtf = 'FTMDTF',
  /** column name */
  Ftothtf = 'FTOTHTF',
  /** column name */
  Ftphr = 'FTPHR',
  /** column name */
  Ftpht = 'FTPHT',
  /** column name */
  Ftrad = 'FTRAD',
  /** column name */
  Ftres = 'FTRES',
  /** column name */
  Ftresp = 'FTRESP',
  /** column name */
  Ftrnlt = 'FTRNLT',
  /** column name */
  Ftrntf = 'FTRNTF',
  /** column name */
  Fttot = 'FTTOT',
  /** column name */
  Fttoth = 'FTTOTH',
  /** column name */
  Fttotlt = 'FTTOTLT',
  /** column name */
  Fttran84 = 'FTTRAN84',
  /** column name */
  Id = 'ID',
  /** column name */
  Intexa = 'INTEXA',
  /** column name */
  Ipdh = 'IPDH',
  /** column name */
  Ipdlt = 'IPDLT',
  /** column name */
  Ipdtot = 'IPDTOT',
  /** column name */
  Lbedla = 'LBEDLA',
  /** column name */
  Lbedsa = 'LBEDSA',
  /** column name */
  Mcddc = 'MCDDC',
  /** column name */
  Mcddch = 'MCDDCH',
  /** column name */
  Mcddclt = 'MCDDCLT',
  /** column name */
  Mcdipd = 'MCDIPD',
  /** column name */
  Mcdipdh = 'MCDIPDH',
  /** column name */
  Mcdipdlt = 'MCDIPDLT',
  /** column name */
  Mcrdc = 'MCRDC',
  /** column name */
  Mcrdch = 'MCRDCH',
  /** column name */
  Mcrdclt = 'MCRDCLT',
  /** column name */
  Mcripd = 'MCRIPD',
  /** column name */
  Mcripdh = 'MCRIPDH',
  /** column name */
  Mcripdlt = 'MCRIPDLT',
  /** column name */
  Npayben = 'NPAYBEN',
  /** column name */
  Npaybenh = 'NPAYBENH',
  /** column name */
  Npaybenl = 'NPAYBENL',
  /** column name */
  Opra = 'OPRA',
  /** column name */
  Othexpa = 'OTHEXPA',
  /** column name */
  Othpcr = 'OTHPCR',
  /** column name */
  Paytot = 'PAYTOT',
  /** column name */
  Paytoth = 'PAYTOTH',
  /** column name */
  Paytotlt = 'PAYTOTLT',
  /** column name */
  Pcmres = 'PCMRES',
  /** column name */
  Phrexa = 'PHREXA',
  /** column name */
  Ptast = 'PTAST',
  /** column name */
  Ptlab = 'PTLAB',
  /** column name */
  Ptlpntf = 'PTLPNTF',
  /** column name */
  Ptmdtf = 'PTMDTF',
  /** column name */
  Ptothtf = 'PTOTHTF',
  /** column name */
  Ptphr = 'PTPHR',
  /** column name */
  Ptpht = 'PTPHT',
  /** column name */
  Ptrad = 'PTRAD',
  /** column name */
  Ptres = 'PTRES',
  /** column name */
  Ptresp = 'PTRESP',
  /** column name */
  Ptrnlt = 'PTRNLT',
  /** column name */
  Ptrntf = 'PTRNTF',
  /** column name */
  Pttot = 'PTTOT',
  /** column name */
  Pttoth = 'PTTOTH',
  /** column name */
  Pttotlt = 'PTTOTLT',
  /** column name */
  Pttran84 = 'PTTRAN84',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Supexa = 'SUPEXA',
  /** column name */
  Suropip = 'SUROPIP',
  /** column name */
  Suropop = 'SUROPOP',
  /** column name */
  Suroptot = 'SUROPTOT',
  /** column name */
  Vast = 'VAST',
  /** column name */
  Vem = 'VEM',
  /** column name */
  Vlab = 'VLAB',
  /** column name */
  Vlpn = 'VLPN',
  /** column name */
  Vmd = 'VMD',
  /** column name */
  Voth = 'VOTH',
  /** column name */
  Vothl = 'VOTHL',
  /** column name */
  Vphr = 'VPHR',
  /** column name */
  Vpht = 'VPHT',
  /** column name */
  Vrad = 'VRAD',
  /** column name */
  Vres = 'VRES',
  /** column name */
  Vrn = 'VRN',
  /** column name */
  Vrnh = 'VRNH',
  /** column name */
  Vrsp = 'VRSP',
  /** column name */
  Vtnh = 'VTNH',
  /** column name */
  Vtot = 'VTOT',
  /** column name */
  Vtotl = 'VTOTL',
  /** column name */
  Vttrn = 'VTTRN'
}

export type As20Util1_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As20Util1_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As20Util1_Set_Input>;
  /** filter the rows which have to be updated */
  where: As20Util1_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As20Util1_Var_Pop_Fields = {
  __typename?: 'AS20UTIL1_var_pop_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As20Util1_Var_Samp_Fields = {
  __typename?: 'AS20UTIL1_var_samp_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As20Util1_Variance_Fields = {
  __typename?: 'AS20UTIL1_variance_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS20UTIL2" */
export type As20Util2 = {
  __typename?: 'AS20UTIL2';
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  KOREA: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OSFTE: Maybe<Scalars['float8']>;
  PH: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SALPOC: Maybe<Scalars['float8']>;
  SALPOF: Maybe<Scalars['float8']>;
  SAMOC: Maybe<Scalars['float8']>;
  SAMOF: Maybe<Scalars['float8']>;
  SATOC: Maybe<Scalars['float8']>;
  SATOF: Maybe<Scalars['float8']>;
  SATOTH: Maybe<Scalars['String']>;
  SBLD: Maybe<Scalars['String']>;
  SBLDOC: Maybe<Scalars['float8']>;
  SBLDOF: Maybe<Scalars['float8']>;
  SCARD: Maybe<Scalars['String']>;
  SCAROC: Maybe<Scalars['float8']>;
  SCAROF: Maybe<Scalars['float8']>;
  SDIAG: Maybe<Scalars['String']>;
  SDIGOC: Maybe<Scalars['float8']>;
  SDIGOF: Maybe<Scalars['float8']>;
  SENDO: Maybe<Scalars['String']>;
  SENDOC: Maybe<Scalars['float8']>;
  SENDOF: Maybe<Scalars['float8']>;
  SENT: Maybe<Scalars['String']>;
  SENTOC: Maybe<Scalars['float8']>;
  SENTOF: Maybe<Scalars['float8']>;
  SGEN: Maybe<Scalars['String']>;
  SGENOC: Maybe<Scalars['float8']>;
  SGENOF: Maybe<Scalars['float8']>;
  SGI: Maybe<Scalars['String']>;
  SGIOC: Maybe<Scalars['float8']>;
  SGIOF: Maybe<Scalars['float8']>;
  SGYN: Maybe<Scalars['String']>;
  SGYNOC: Maybe<Scalars['float8']>;
  SGYNOF: Maybe<Scalars['float8']>;
  SLABOC: Maybe<Scalars['float8']>;
  SLABOF: Maybe<Scalars['float8']>;
  SMIN: Maybe<Scalars['String']>;
  SMINOC: Maybe<Scalars['float8']>;
  SMINOF: Maybe<Scalars['float8']>;
  SMRI: Maybe<Scalars['String']>;
  SMRIOC: Maybe<Scalars['float8']>;
  SMRIOF: Maybe<Scalars['float8']>;
  SMUS: Maybe<Scalars['String']>;
  SMUSOC: Maybe<Scalars['float8']>;
  SMUSOF: Maybe<Scalars['float8']>;
  SNRV: Maybe<Scalars['String']>;
  SNRVOC: Maybe<Scalars['float8']>;
  SNRVOF: Maybe<Scalars['float8']>;
  SNTOP: Maybe<Scalars['String']>;
  SONCL: Maybe<Scalars['String']>;
  SONCOC: Maybe<Scalars['float8']>;
  SONCOF: Maybe<Scalars['float8']>;
  SOPH: Maybe<Scalars['String']>;
  SOPHOC: Maybe<Scalars['float8']>;
  SOPHOF: Maybe<Scalars['float8']>;
  SOTHSAT: Maybe<Scalars['String']>;
  SPAHOC: Maybe<Scalars['float8']>;
  SPAHOF: Maybe<Scalars['float8']>;
  SPATH: Maybe<Scalars['String']>;
  SPCOC: Maybe<Scalars['float8']>;
  SPCOF: Maybe<Scalars['float8']>;
  SPSYOC: Maybe<Scalars['float8']>;
  SPSYOF: Maybe<Scalars['float8']>;
  SPSYX: Maybe<Scalars['String']>;
  SRADOC: Maybe<Scalars['float8']>;
  SRADOF: Maybe<Scalars['float8']>;
  SRHBOC: Maybe<Scalars['float8']>;
  SRHBOF: Maybe<Scalars['float8']>;
  SSALOP: Maybe<Scalars['String']>;
  SSAMBS: Maybe<Scalars['String']>;
  SSLAB: Maybe<Scalars['String']>;
  SSNROC: Maybe<Scalars['float8']>;
  SSNROF: Maybe<Scalars['float8']>;
  SSNRR: Maybe<Scalars['String']>;
  SSPCC: Maybe<Scalars['String']>;
  SSRAD: Maybe<Scalars['String']>;
  SSRHB: Maybe<Scalars['String']>;
  SSUCAR: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  SUCOC: Maybe<Scalars['float8']>;
  SUCOF: Maybe<Scalars['float8']>;
  SURO: Maybe<Scalars['String']>;
  SUROOC: Maybe<Scalars['float8']>;
  SUROOF: Maybe<Scalars['float8']>;
  SVAS: Maybe<Scalars['String']>;
  SVASOC: Maybe<Scalars['float8']>;
  SVASOF: Maybe<Scalars['float8']>;
  SVRS: Maybe<Scalars['String']>;
  SVRSOC: Maybe<Scalars['float8']>;
  SVRSOF: Maybe<Scalars['float8']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
};

/** aggregated selection of "AS20UTIL2" */
export type As20Util2_Aggregate = {
  __typename?: 'AS20UTIL2_aggregate';
  aggregate: Maybe<As20Util2_Aggregate_Fields>;
  nodes: Array<As20Util2>;
};

/** aggregate fields of "AS20UTIL2" */
export type As20Util2_Aggregate_Fields = {
  __typename?: 'AS20UTIL2_aggregate_fields';
  avg: Maybe<As20Util2_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As20Util2_Max_Fields>;
  min: Maybe<As20Util2_Min_Fields>;
  stddev: Maybe<As20Util2_Stddev_Fields>;
  stddev_pop: Maybe<As20Util2_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As20Util2_Stddev_Samp_Fields>;
  sum: Maybe<As20Util2_Sum_Fields>;
  var_pop: Maybe<As20Util2_Var_Pop_Fields>;
  var_samp: Maybe<As20Util2_Var_Samp_Fields>;
  variance: Maybe<As20Util2_Variance_Fields>;
};


/** aggregate fields of "AS20UTIL2" */
export type As20Util2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As20Util2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As20Util2_Avg_Fields = {
  __typename?: 'AS20UTIL2_avg_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS20UTIL2". All fields are combined with a logical 'AND'. */
export type As20Util2_Bool_Exp = {
  ADEPRA?: InputMaybe<Float8_Comparison_Exp>;
  AFRICA?: InputMaybe<String_Comparison_Exp>;
  APANES?: InputMaybe<String_Comparison_Exp>;
  APCAR?: InputMaybe<String_Comparison_Exp>;
  APCASE?: InputMaybe<String_Comparison_Exp>;
  APED?: InputMaybe<String_Comparison_Exp>;
  APEMER?: InputMaybe<String_Comparison_Exp>;
  APOTH?: InputMaybe<String_Comparison_Exp>;
  APRN?: InputMaybe<String_Comparison_Exp>;
  APSPC?: InputMaybe<String_Comparison_Exp>;
  ASSNET?: InputMaybe<Float8_Comparison_Exp>;
  AUVZ?: InputMaybe<Float8_Comparison_Exp>;
  CANADA?: InputMaybe<String_Comparison_Exp>;
  CEAMT?: InputMaybe<Float8_Comparison_Exp>;
  CHINA?: InputMaybe<String_Comparison_Exp>;
  CLSCIC?: InputMaybe<String_Comparison_Exp>;
  CLSMSI?: InputMaybe<String_Comparison_Exp>;
  CLSNIC?: InputMaybe<String_Comparison_Exp>;
  CLSOIC?: InputMaybe<String_Comparison_Exp>;
  CLSPIC?: InputMaybe<String_Comparison_Exp>;
  FORNRSA?: InputMaybe<String_Comparison_Exp>;
  FTAPRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEAPN?: InputMaybe<Float8_Comparison_Exp>;
  FTECIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEHSP?: InputMaybe<Float8_Comparison_Exp>;
  FTEINT?: InputMaybe<Float8_Comparison_Exp>;
  FTEMSI?: InputMaybe<Float8_Comparison_Exp>;
  FTENIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEOIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEPHRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEPIC?: InputMaybe<Float8_Comparison_Exp>;
  FTPHRN?: InputMaybe<Float8_Comparison_Exp>;
  GFEET?: InputMaybe<Float8_Comparison_Exp>;
  HSPTL?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  INDIA?: InputMaybe<String_Comparison_Exp>;
  INTCAR?: InputMaybe<String_Comparison_Exp>;
  ITBUGT?: InputMaybe<Float8_Comparison_Exp>;
  ITEXPA?: InputMaybe<Float8_Comparison_Exp>;
  ITFTE?: InputMaybe<Float8_Comparison_Exp>;
  KOREA?: InputMaybe<String_Comparison_Exp>;
  NECAR?: InputMaybe<Float8_Comparison_Exp>;
  NEGST?: InputMaybe<Float8_Comparison_Exp>;
  NEHSP?: InputMaybe<Float8_Comparison_Exp>;
  NEINT?: InputMaybe<Float8_Comparison_Exp>;
  NEMER?: InputMaybe<Float8_Comparison_Exp>;
  NEOB?: InputMaybe<Float8_Comparison_Exp>;
  NEOTH?: InputMaybe<Float8_Comparison_Exp>;
  NETOT?: InputMaybe<Float8_Comparison_Exp>;
  OFRNRS?: InputMaybe<String_Comparison_Exp>;
  OSFTE?: InputMaybe<Float8_Comparison_Exp>;
  PH?: InputMaybe<String_Comparison_Exp>;
  PLNTA?: InputMaybe<Float8_Comparison_Exp>;
  PRPM?: InputMaybe<Float8_Comparison_Exp>;
  PTAPRN?: InputMaybe<Float8_Comparison_Exp>;
  PTPHRN?: InputMaybe<Float8_Comparison_Exp>;
  RNSCH?: InputMaybe<Float8_Comparison_Exp>;
  SALPOC?: InputMaybe<Float8_Comparison_Exp>;
  SALPOF?: InputMaybe<Float8_Comparison_Exp>;
  SAMOC?: InputMaybe<Float8_Comparison_Exp>;
  SAMOF?: InputMaybe<Float8_Comparison_Exp>;
  SATOC?: InputMaybe<Float8_Comparison_Exp>;
  SATOF?: InputMaybe<Float8_Comparison_Exp>;
  SATOTH?: InputMaybe<String_Comparison_Exp>;
  SBLD?: InputMaybe<String_Comparison_Exp>;
  SBLDOC?: InputMaybe<Float8_Comparison_Exp>;
  SBLDOF?: InputMaybe<Float8_Comparison_Exp>;
  SCARD?: InputMaybe<String_Comparison_Exp>;
  SCAROC?: InputMaybe<Float8_Comparison_Exp>;
  SCAROF?: InputMaybe<Float8_Comparison_Exp>;
  SDIAG?: InputMaybe<String_Comparison_Exp>;
  SDIGOC?: InputMaybe<Float8_Comparison_Exp>;
  SDIGOF?: InputMaybe<Float8_Comparison_Exp>;
  SENDO?: InputMaybe<String_Comparison_Exp>;
  SENDOC?: InputMaybe<Float8_Comparison_Exp>;
  SENDOF?: InputMaybe<Float8_Comparison_Exp>;
  SENT?: InputMaybe<String_Comparison_Exp>;
  SENTOC?: InputMaybe<Float8_Comparison_Exp>;
  SENTOF?: InputMaybe<Float8_Comparison_Exp>;
  SGEN?: InputMaybe<String_Comparison_Exp>;
  SGENOC?: InputMaybe<Float8_Comparison_Exp>;
  SGENOF?: InputMaybe<Float8_Comparison_Exp>;
  SGI?: InputMaybe<String_Comparison_Exp>;
  SGIOC?: InputMaybe<Float8_Comparison_Exp>;
  SGIOF?: InputMaybe<Float8_Comparison_Exp>;
  SGYN?: InputMaybe<String_Comparison_Exp>;
  SGYNOC?: InputMaybe<Float8_Comparison_Exp>;
  SGYNOF?: InputMaybe<Float8_Comparison_Exp>;
  SLABOC?: InputMaybe<Float8_Comparison_Exp>;
  SLABOF?: InputMaybe<Float8_Comparison_Exp>;
  SMIN?: InputMaybe<String_Comparison_Exp>;
  SMINOC?: InputMaybe<Float8_Comparison_Exp>;
  SMINOF?: InputMaybe<Float8_Comparison_Exp>;
  SMRI?: InputMaybe<String_Comparison_Exp>;
  SMRIOC?: InputMaybe<Float8_Comparison_Exp>;
  SMRIOF?: InputMaybe<Float8_Comparison_Exp>;
  SMUS?: InputMaybe<String_Comparison_Exp>;
  SMUSOC?: InputMaybe<Float8_Comparison_Exp>;
  SMUSOF?: InputMaybe<Float8_Comparison_Exp>;
  SNRV?: InputMaybe<String_Comparison_Exp>;
  SNRVOC?: InputMaybe<Float8_Comparison_Exp>;
  SNRVOF?: InputMaybe<Float8_Comparison_Exp>;
  SNTOP?: InputMaybe<String_Comparison_Exp>;
  SONCL?: InputMaybe<String_Comparison_Exp>;
  SONCOC?: InputMaybe<Float8_Comparison_Exp>;
  SONCOF?: InputMaybe<Float8_Comparison_Exp>;
  SOPH?: InputMaybe<String_Comparison_Exp>;
  SOPHOC?: InputMaybe<Float8_Comparison_Exp>;
  SOPHOF?: InputMaybe<Float8_Comparison_Exp>;
  SOTHSAT?: InputMaybe<String_Comparison_Exp>;
  SPAHOC?: InputMaybe<Float8_Comparison_Exp>;
  SPAHOF?: InputMaybe<Float8_Comparison_Exp>;
  SPATH?: InputMaybe<String_Comparison_Exp>;
  SPCOC?: InputMaybe<Float8_Comparison_Exp>;
  SPCOF?: InputMaybe<Float8_Comparison_Exp>;
  SPSYOC?: InputMaybe<Float8_Comparison_Exp>;
  SPSYOF?: InputMaybe<Float8_Comparison_Exp>;
  SPSYX?: InputMaybe<String_Comparison_Exp>;
  SRADOC?: InputMaybe<Float8_Comparison_Exp>;
  SRADOF?: InputMaybe<Float8_Comparison_Exp>;
  SRHBOC?: InputMaybe<Float8_Comparison_Exp>;
  SRHBOF?: InputMaybe<Float8_Comparison_Exp>;
  SSALOP?: InputMaybe<String_Comparison_Exp>;
  SSAMBS?: InputMaybe<String_Comparison_Exp>;
  SSLAB?: InputMaybe<String_Comparison_Exp>;
  SSNROC?: InputMaybe<Float8_Comparison_Exp>;
  SSNROF?: InputMaybe<Float8_Comparison_Exp>;
  SSNRR?: InputMaybe<String_Comparison_Exp>;
  SSPCC?: InputMaybe<String_Comparison_Exp>;
  SSRAD?: InputMaybe<String_Comparison_Exp>;
  SSRHB?: InputMaybe<String_Comparison_Exp>;
  SSUCAR?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUCOC?: InputMaybe<Float8_Comparison_Exp>;
  SUCOF?: InputMaybe<Float8_Comparison_Exp>;
  SURO?: InputMaybe<String_Comparison_Exp>;
  SUROOC?: InputMaybe<Float8_Comparison_Exp>;
  SUROOF?: InputMaybe<Float8_Comparison_Exp>;
  SVAS?: InputMaybe<String_Comparison_Exp>;
  SVASOC?: InputMaybe<Float8_Comparison_Exp>;
  SVASOF?: InputMaybe<Float8_Comparison_Exp>;
  SVRS?: InputMaybe<String_Comparison_Exp>;
  SVRSOC?: InputMaybe<Float8_Comparison_Exp>;
  SVRSOF?: InputMaybe<Float8_Comparison_Exp>;
  TCCAR?: InputMaybe<Float8_Comparison_Exp>;
  TCGST?: InputMaybe<Float8_Comparison_Exp>;
  TCHSP?: InputMaybe<Float8_Comparison_Exp>;
  TCINT?: InputMaybe<Float8_Comparison_Exp>;
  TCMER?: InputMaybe<Float8_Comparison_Exp>;
  TCOB?: InputMaybe<Float8_Comparison_Exp>;
  TCOTH?: InputMaybe<Float8_Comparison_Exp>;
  TCTOT?: InputMaybe<Float8_Comparison_Exp>;
  TECAR?: InputMaybe<Float8_Comparison_Exp>;
  TEGST?: InputMaybe<Float8_Comparison_Exp>;
  TEHSP?: InputMaybe<Float8_Comparison_Exp>;
  TEINT?: InputMaybe<Float8_Comparison_Exp>;
  TEMER?: InputMaybe<Float8_Comparison_Exp>;
  TEOB?: InputMaybe<Float8_Comparison_Exp>;
  TEOTH?: InputMaybe<Float8_Comparison_Exp>;
  TETOT?: InputMaybe<Float8_Comparison_Exp>;
  TGCAR?: InputMaybe<Float8_Comparison_Exp>;
  TGGST?: InputMaybe<Float8_Comparison_Exp>;
  TGHSP?: InputMaybe<Float8_Comparison_Exp>;
  TGINT?: InputMaybe<Float8_Comparison_Exp>;
  TGMER?: InputMaybe<Float8_Comparison_Exp>;
  TGOB?: InputMaybe<Float8_Comparison_Exp>;
  TGOTH?: InputMaybe<Float8_Comparison_Exp>;
  TGTOT?: InputMaybe<Float8_Comparison_Exp>;
  TPCAR?: InputMaybe<Float8_Comparison_Exp>;
  TPGST?: InputMaybe<Float8_Comparison_Exp>;
  TPHSP?: InputMaybe<Float8_Comparison_Exp>;
  TPINT?: InputMaybe<Float8_Comparison_Exp>;
  TPMER?: InputMaybe<Float8_Comparison_Exp>;
  TPOB?: InputMaybe<Float8_Comparison_Exp>;
  TPOTH?: InputMaybe<Float8_Comparison_Exp>;
  TPRTOT?: InputMaybe<Float8_Comparison_Exp>;
  VIDVZ?: InputMaybe<Float8_Comparison_Exp>;
  VPSRV?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<As20Util2_Bool_Exp>>;
  _not?: InputMaybe<As20Util2_Bool_Exp>;
  _or?: InputMaybe<Array<As20Util2_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS20UTIL2" */
export enum As20Util2_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs20Util2 = 'pk_AS20UTIL2'
}

/** input type for incrementing numeric columns in table "AS20UTIL2" */
export type As20Util2_Inc_Input = {
  ADEPRA?: InputMaybe<Scalars['float8']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SALPOC?: InputMaybe<Scalars['float8']>;
  SALPOF?: InputMaybe<Scalars['float8']>;
  SAMOC?: InputMaybe<Scalars['float8']>;
  SAMOF?: InputMaybe<Scalars['float8']>;
  SATOC?: InputMaybe<Scalars['float8']>;
  SATOF?: InputMaybe<Scalars['float8']>;
  SBLDOC?: InputMaybe<Scalars['float8']>;
  SBLDOF?: InputMaybe<Scalars['float8']>;
  SCAROC?: InputMaybe<Scalars['float8']>;
  SCAROF?: InputMaybe<Scalars['float8']>;
  SDIGOC?: InputMaybe<Scalars['float8']>;
  SDIGOF?: InputMaybe<Scalars['float8']>;
  SENDOC?: InputMaybe<Scalars['float8']>;
  SENDOF?: InputMaybe<Scalars['float8']>;
  SENTOC?: InputMaybe<Scalars['float8']>;
  SENTOF?: InputMaybe<Scalars['float8']>;
  SGENOC?: InputMaybe<Scalars['float8']>;
  SGENOF?: InputMaybe<Scalars['float8']>;
  SGIOC?: InputMaybe<Scalars['float8']>;
  SGIOF?: InputMaybe<Scalars['float8']>;
  SGYNOC?: InputMaybe<Scalars['float8']>;
  SGYNOF?: InputMaybe<Scalars['float8']>;
  SLABOC?: InputMaybe<Scalars['float8']>;
  SLABOF?: InputMaybe<Scalars['float8']>;
  SMINOC?: InputMaybe<Scalars['float8']>;
  SMINOF?: InputMaybe<Scalars['float8']>;
  SMRIOC?: InputMaybe<Scalars['float8']>;
  SMRIOF?: InputMaybe<Scalars['float8']>;
  SMUSOC?: InputMaybe<Scalars['float8']>;
  SMUSOF?: InputMaybe<Scalars['float8']>;
  SNRVOC?: InputMaybe<Scalars['float8']>;
  SNRVOF?: InputMaybe<Scalars['float8']>;
  SONCOC?: InputMaybe<Scalars['float8']>;
  SONCOF?: InputMaybe<Scalars['float8']>;
  SOPHOC?: InputMaybe<Scalars['float8']>;
  SOPHOF?: InputMaybe<Scalars['float8']>;
  SPAHOC?: InputMaybe<Scalars['float8']>;
  SPAHOF?: InputMaybe<Scalars['float8']>;
  SPCOC?: InputMaybe<Scalars['float8']>;
  SPCOF?: InputMaybe<Scalars['float8']>;
  SPSYOC?: InputMaybe<Scalars['float8']>;
  SPSYOF?: InputMaybe<Scalars['float8']>;
  SRADOC?: InputMaybe<Scalars['float8']>;
  SRADOF?: InputMaybe<Scalars['float8']>;
  SRHBOC?: InputMaybe<Scalars['float8']>;
  SRHBOF?: InputMaybe<Scalars['float8']>;
  SSNROC?: InputMaybe<Scalars['float8']>;
  SSNROF?: InputMaybe<Scalars['float8']>;
  SUCOC?: InputMaybe<Scalars['float8']>;
  SUCOF?: InputMaybe<Scalars['float8']>;
  SUROOC?: InputMaybe<Scalars['float8']>;
  SUROOF?: InputMaybe<Scalars['float8']>;
  SVASOC?: InputMaybe<Scalars['float8']>;
  SVASOF?: InputMaybe<Scalars['float8']>;
  SVRSOC?: InputMaybe<Scalars['float8']>;
  SVRSOF?: InputMaybe<Scalars['float8']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS20UTIL2" */
export type As20Util2_Insert_Input = {
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  KOREA?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  PH?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SALPOC?: InputMaybe<Scalars['float8']>;
  SALPOF?: InputMaybe<Scalars['float8']>;
  SAMOC?: InputMaybe<Scalars['float8']>;
  SAMOF?: InputMaybe<Scalars['float8']>;
  SATOC?: InputMaybe<Scalars['float8']>;
  SATOF?: InputMaybe<Scalars['float8']>;
  SATOTH?: InputMaybe<Scalars['String']>;
  SBLD?: InputMaybe<Scalars['String']>;
  SBLDOC?: InputMaybe<Scalars['float8']>;
  SBLDOF?: InputMaybe<Scalars['float8']>;
  SCARD?: InputMaybe<Scalars['String']>;
  SCAROC?: InputMaybe<Scalars['float8']>;
  SCAROF?: InputMaybe<Scalars['float8']>;
  SDIAG?: InputMaybe<Scalars['String']>;
  SDIGOC?: InputMaybe<Scalars['float8']>;
  SDIGOF?: InputMaybe<Scalars['float8']>;
  SENDO?: InputMaybe<Scalars['String']>;
  SENDOC?: InputMaybe<Scalars['float8']>;
  SENDOF?: InputMaybe<Scalars['float8']>;
  SENT?: InputMaybe<Scalars['String']>;
  SENTOC?: InputMaybe<Scalars['float8']>;
  SENTOF?: InputMaybe<Scalars['float8']>;
  SGEN?: InputMaybe<Scalars['String']>;
  SGENOC?: InputMaybe<Scalars['float8']>;
  SGENOF?: InputMaybe<Scalars['float8']>;
  SGI?: InputMaybe<Scalars['String']>;
  SGIOC?: InputMaybe<Scalars['float8']>;
  SGIOF?: InputMaybe<Scalars['float8']>;
  SGYN?: InputMaybe<Scalars['String']>;
  SGYNOC?: InputMaybe<Scalars['float8']>;
  SGYNOF?: InputMaybe<Scalars['float8']>;
  SLABOC?: InputMaybe<Scalars['float8']>;
  SLABOF?: InputMaybe<Scalars['float8']>;
  SMIN?: InputMaybe<Scalars['String']>;
  SMINOC?: InputMaybe<Scalars['float8']>;
  SMINOF?: InputMaybe<Scalars['float8']>;
  SMRI?: InputMaybe<Scalars['String']>;
  SMRIOC?: InputMaybe<Scalars['float8']>;
  SMRIOF?: InputMaybe<Scalars['float8']>;
  SMUS?: InputMaybe<Scalars['String']>;
  SMUSOC?: InputMaybe<Scalars['float8']>;
  SMUSOF?: InputMaybe<Scalars['float8']>;
  SNRV?: InputMaybe<Scalars['String']>;
  SNRVOC?: InputMaybe<Scalars['float8']>;
  SNRVOF?: InputMaybe<Scalars['float8']>;
  SNTOP?: InputMaybe<Scalars['String']>;
  SONCL?: InputMaybe<Scalars['String']>;
  SONCOC?: InputMaybe<Scalars['float8']>;
  SONCOF?: InputMaybe<Scalars['float8']>;
  SOPH?: InputMaybe<Scalars['String']>;
  SOPHOC?: InputMaybe<Scalars['float8']>;
  SOPHOF?: InputMaybe<Scalars['float8']>;
  SOTHSAT?: InputMaybe<Scalars['String']>;
  SPAHOC?: InputMaybe<Scalars['float8']>;
  SPAHOF?: InputMaybe<Scalars['float8']>;
  SPATH?: InputMaybe<Scalars['String']>;
  SPCOC?: InputMaybe<Scalars['float8']>;
  SPCOF?: InputMaybe<Scalars['float8']>;
  SPSYOC?: InputMaybe<Scalars['float8']>;
  SPSYOF?: InputMaybe<Scalars['float8']>;
  SPSYX?: InputMaybe<Scalars['String']>;
  SRADOC?: InputMaybe<Scalars['float8']>;
  SRADOF?: InputMaybe<Scalars['float8']>;
  SRHBOC?: InputMaybe<Scalars['float8']>;
  SRHBOF?: InputMaybe<Scalars['float8']>;
  SSALOP?: InputMaybe<Scalars['String']>;
  SSAMBS?: InputMaybe<Scalars['String']>;
  SSLAB?: InputMaybe<Scalars['String']>;
  SSNROC?: InputMaybe<Scalars['float8']>;
  SSNROF?: InputMaybe<Scalars['float8']>;
  SSNRR?: InputMaybe<Scalars['String']>;
  SSPCC?: InputMaybe<Scalars['String']>;
  SSRAD?: InputMaybe<Scalars['String']>;
  SSRHB?: InputMaybe<Scalars['String']>;
  SSUCAR?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUCOC?: InputMaybe<Scalars['float8']>;
  SUCOF?: InputMaybe<Scalars['float8']>;
  SURO?: InputMaybe<Scalars['String']>;
  SUROOC?: InputMaybe<Scalars['float8']>;
  SUROOF?: InputMaybe<Scalars['float8']>;
  SVAS?: InputMaybe<Scalars['String']>;
  SVASOC?: InputMaybe<Scalars['float8']>;
  SVASOF?: InputMaybe<Scalars['float8']>;
  SVRS?: InputMaybe<Scalars['String']>;
  SVRSOC?: InputMaybe<Scalars['float8']>;
  SVRSOF?: InputMaybe<Scalars['float8']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type As20Util2_Max_Fields = {
  __typename?: 'AS20UTIL2_max_fields';
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  KOREA: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OSFTE: Maybe<Scalars['float8']>;
  PH: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SALPOC: Maybe<Scalars['float8']>;
  SALPOF: Maybe<Scalars['float8']>;
  SAMOC: Maybe<Scalars['float8']>;
  SAMOF: Maybe<Scalars['float8']>;
  SATOC: Maybe<Scalars['float8']>;
  SATOF: Maybe<Scalars['float8']>;
  SATOTH: Maybe<Scalars['String']>;
  SBLD: Maybe<Scalars['String']>;
  SBLDOC: Maybe<Scalars['float8']>;
  SBLDOF: Maybe<Scalars['float8']>;
  SCARD: Maybe<Scalars['String']>;
  SCAROC: Maybe<Scalars['float8']>;
  SCAROF: Maybe<Scalars['float8']>;
  SDIAG: Maybe<Scalars['String']>;
  SDIGOC: Maybe<Scalars['float8']>;
  SDIGOF: Maybe<Scalars['float8']>;
  SENDO: Maybe<Scalars['String']>;
  SENDOC: Maybe<Scalars['float8']>;
  SENDOF: Maybe<Scalars['float8']>;
  SENT: Maybe<Scalars['String']>;
  SENTOC: Maybe<Scalars['float8']>;
  SENTOF: Maybe<Scalars['float8']>;
  SGEN: Maybe<Scalars['String']>;
  SGENOC: Maybe<Scalars['float8']>;
  SGENOF: Maybe<Scalars['float8']>;
  SGI: Maybe<Scalars['String']>;
  SGIOC: Maybe<Scalars['float8']>;
  SGIOF: Maybe<Scalars['float8']>;
  SGYN: Maybe<Scalars['String']>;
  SGYNOC: Maybe<Scalars['float8']>;
  SGYNOF: Maybe<Scalars['float8']>;
  SLABOC: Maybe<Scalars['float8']>;
  SLABOF: Maybe<Scalars['float8']>;
  SMIN: Maybe<Scalars['String']>;
  SMINOC: Maybe<Scalars['float8']>;
  SMINOF: Maybe<Scalars['float8']>;
  SMRI: Maybe<Scalars['String']>;
  SMRIOC: Maybe<Scalars['float8']>;
  SMRIOF: Maybe<Scalars['float8']>;
  SMUS: Maybe<Scalars['String']>;
  SMUSOC: Maybe<Scalars['float8']>;
  SMUSOF: Maybe<Scalars['float8']>;
  SNRV: Maybe<Scalars['String']>;
  SNRVOC: Maybe<Scalars['float8']>;
  SNRVOF: Maybe<Scalars['float8']>;
  SNTOP: Maybe<Scalars['String']>;
  SONCL: Maybe<Scalars['String']>;
  SONCOC: Maybe<Scalars['float8']>;
  SONCOF: Maybe<Scalars['float8']>;
  SOPH: Maybe<Scalars['String']>;
  SOPHOC: Maybe<Scalars['float8']>;
  SOPHOF: Maybe<Scalars['float8']>;
  SOTHSAT: Maybe<Scalars['String']>;
  SPAHOC: Maybe<Scalars['float8']>;
  SPAHOF: Maybe<Scalars['float8']>;
  SPATH: Maybe<Scalars['String']>;
  SPCOC: Maybe<Scalars['float8']>;
  SPCOF: Maybe<Scalars['float8']>;
  SPSYOC: Maybe<Scalars['float8']>;
  SPSYOF: Maybe<Scalars['float8']>;
  SPSYX: Maybe<Scalars['String']>;
  SRADOC: Maybe<Scalars['float8']>;
  SRADOF: Maybe<Scalars['float8']>;
  SRHBOC: Maybe<Scalars['float8']>;
  SRHBOF: Maybe<Scalars['float8']>;
  SSALOP: Maybe<Scalars['String']>;
  SSAMBS: Maybe<Scalars['String']>;
  SSLAB: Maybe<Scalars['String']>;
  SSNROC: Maybe<Scalars['float8']>;
  SSNROF: Maybe<Scalars['float8']>;
  SSNRR: Maybe<Scalars['String']>;
  SSPCC: Maybe<Scalars['String']>;
  SSRAD: Maybe<Scalars['String']>;
  SSRHB: Maybe<Scalars['String']>;
  SSUCAR: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  SUCOC: Maybe<Scalars['float8']>;
  SUCOF: Maybe<Scalars['float8']>;
  SURO: Maybe<Scalars['String']>;
  SUROOC: Maybe<Scalars['float8']>;
  SUROOF: Maybe<Scalars['float8']>;
  SVAS: Maybe<Scalars['String']>;
  SVASOC: Maybe<Scalars['float8']>;
  SVASOF: Maybe<Scalars['float8']>;
  SVRS: Maybe<Scalars['String']>;
  SVRSOC: Maybe<Scalars['float8']>;
  SVRSOF: Maybe<Scalars['float8']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type As20Util2_Min_Fields = {
  __typename?: 'AS20UTIL2_min_fields';
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  KOREA: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OSFTE: Maybe<Scalars['float8']>;
  PH: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SALPOC: Maybe<Scalars['float8']>;
  SALPOF: Maybe<Scalars['float8']>;
  SAMOC: Maybe<Scalars['float8']>;
  SAMOF: Maybe<Scalars['float8']>;
  SATOC: Maybe<Scalars['float8']>;
  SATOF: Maybe<Scalars['float8']>;
  SATOTH: Maybe<Scalars['String']>;
  SBLD: Maybe<Scalars['String']>;
  SBLDOC: Maybe<Scalars['float8']>;
  SBLDOF: Maybe<Scalars['float8']>;
  SCARD: Maybe<Scalars['String']>;
  SCAROC: Maybe<Scalars['float8']>;
  SCAROF: Maybe<Scalars['float8']>;
  SDIAG: Maybe<Scalars['String']>;
  SDIGOC: Maybe<Scalars['float8']>;
  SDIGOF: Maybe<Scalars['float8']>;
  SENDO: Maybe<Scalars['String']>;
  SENDOC: Maybe<Scalars['float8']>;
  SENDOF: Maybe<Scalars['float8']>;
  SENT: Maybe<Scalars['String']>;
  SENTOC: Maybe<Scalars['float8']>;
  SENTOF: Maybe<Scalars['float8']>;
  SGEN: Maybe<Scalars['String']>;
  SGENOC: Maybe<Scalars['float8']>;
  SGENOF: Maybe<Scalars['float8']>;
  SGI: Maybe<Scalars['String']>;
  SGIOC: Maybe<Scalars['float8']>;
  SGIOF: Maybe<Scalars['float8']>;
  SGYN: Maybe<Scalars['String']>;
  SGYNOC: Maybe<Scalars['float8']>;
  SGYNOF: Maybe<Scalars['float8']>;
  SLABOC: Maybe<Scalars['float8']>;
  SLABOF: Maybe<Scalars['float8']>;
  SMIN: Maybe<Scalars['String']>;
  SMINOC: Maybe<Scalars['float8']>;
  SMINOF: Maybe<Scalars['float8']>;
  SMRI: Maybe<Scalars['String']>;
  SMRIOC: Maybe<Scalars['float8']>;
  SMRIOF: Maybe<Scalars['float8']>;
  SMUS: Maybe<Scalars['String']>;
  SMUSOC: Maybe<Scalars['float8']>;
  SMUSOF: Maybe<Scalars['float8']>;
  SNRV: Maybe<Scalars['String']>;
  SNRVOC: Maybe<Scalars['float8']>;
  SNRVOF: Maybe<Scalars['float8']>;
  SNTOP: Maybe<Scalars['String']>;
  SONCL: Maybe<Scalars['String']>;
  SONCOC: Maybe<Scalars['float8']>;
  SONCOF: Maybe<Scalars['float8']>;
  SOPH: Maybe<Scalars['String']>;
  SOPHOC: Maybe<Scalars['float8']>;
  SOPHOF: Maybe<Scalars['float8']>;
  SOTHSAT: Maybe<Scalars['String']>;
  SPAHOC: Maybe<Scalars['float8']>;
  SPAHOF: Maybe<Scalars['float8']>;
  SPATH: Maybe<Scalars['String']>;
  SPCOC: Maybe<Scalars['float8']>;
  SPCOF: Maybe<Scalars['float8']>;
  SPSYOC: Maybe<Scalars['float8']>;
  SPSYOF: Maybe<Scalars['float8']>;
  SPSYX: Maybe<Scalars['String']>;
  SRADOC: Maybe<Scalars['float8']>;
  SRADOF: Maybe<Scalars['float8']>;
  SRHBOC: Maybe<Scalars['float8']>;
  SRHBOF: Maybe<Scalars['float8']>;
  SSALOP: Maybe<Scalars['String']>;
  SSAMBS: Maybe<Scalars['String']>;
  SSLAB: Maybe<Scalars['String']>;
  SSNROC: Maybe<Scalars['float8']>;
  SSNROF: Maybe<Scalars['float8']>;
  SSNRR: Maybe<Scalars['String']>;
  SSPCC: Maybe<Scalars['String']>;
  SSRAD: Maybe<Scalars['String']>;
  SSRHB: Maybe<Scalars['String']>;
  SSUCAR: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  SUCOC: Maybe<Scalars['float8']>;
  SUCOF: Maybe<Scalars['float8']>;
  SURO: Maybe<Scalars['String']>;
  SUROOC: Maybe<Scalars['float8']>;
  SUROOF: Maybe<Scalars['float8']>;
  SVAS: Maybe<Scalars['String']>;
  SVASOC: Maybe<Scalars['float8']>;
  SVASOF: Maybe<Scalars['float8']>;
  SVRS: Maybe<Scalars['String']>;
  SVRSOC: Maybe<Scalars['float8']>;
  SVRSOF: Maybe<Scalars['float8']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "AS20UTIL2" */
export type As20Util2_Mutation_Response = {
  __typename?: 'AS20UTIL2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As20Util2>;
};

/** input type for inserting object relation for remote table "AS20UTIL2" */
export type As20Util2_Obj_Rel_Insert_Input = {
  data: As20Util2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As20Util2_On_Conflict>;
};

/** on_conflict condition type for table "AS20UTIL2" */
export type As20Util2_On_Conflict = {
  constraint: As20Util2_Constraint;
  update_columns?: Array<As20Util2_Update_Column>;
  where?: InputMaybe<As20Util2_Bool_Exp>;
};

/** Ordering options when selecting data from "AS20UTIL2". */
export type As20Util2_Order_By = {
  ADEPRA?: InputMaybe<Order_By>;
  AFRICA?: InputMaybe<Order_By>;
  APANES?: InputMaybe<Order_By>;
  APCAR?: InputMaybe<Order_By>;
  APCASE?: InputMaybe<Order_By>;
  APED?: InputMaybe<Order_By>;
  APEMER?: InputMaybe<Order_By>;
  APOTH?: InputMaybe<Order_By>;
  APRN?: InputMaybe<Order_By>;
  APSPC?: InputMaybe<Order_By>;
  ASSNET?: InputMaybe<Order_By>;
  AUVZ?: InputMaybe<Order_By>;
  CANADA?: InputMaybe<Order_By>;
  CEAMT?: InputMaybe<Order_By>;
  CHINA?: InputMaybe<Order_By>;
  CLSCIC?: InputMaybe<Order_By>;
  CLSMSI?: InputMaybe<Order_By>;
  CLSNIC?: InputMaybe<Order_By>;
  CLSOIC?: InputMaybe<Order_By>;
  CLSPIC?: InputMaybe<Order_By>;
  FORNRSA?: InputMaybe<Order_By>;
  FTAPRN?: InputMaybe<Order_By>;
  FTEAPN?: InputMaybe<Order_By>;
  FTECIC?: InputMaybe<Order_By>;
  FTEHSP?: InputMaybe<Order_By>;
  FTEINT?: InputMaybe<Order_By>;
  FTEMSI?: InputMaybe<Order_By>;
  FTENIC?: InputMaybe<Order_By>;
  FTEOIC?: InputMaybe<Order_By>;
  FTEPHRN?: InputMaybe<Order_By>;
  FTEPIC?: InputMaybe<Order_By>;
  FTPHRN?: InputMaybe<Order_By>;
  GFEET?: InputMaybe<Order_By>;
  HSPTL?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  INDIA?: InputMaybe<Order_By>;
  INTCAR?: InputMaybe<Order_By>;
  ITBUGT?: InputMaybe<Order_By>;
  ITEXPA?: InputMaybe<Order_By>;
  ITFTE?: InputMaybe<Order_By>;
  KOREA?: InputMaybe<Order_By>;
  NECAR?: InputMaybe<Order_By>;
  NEGST?: InputMaybe<Order_By>;
  NEHSP?: InputMaybe<Order_By>;
  NEINT?: InputMaybe<Order_By>;
  NEMER?: InputMaybe<Order_By>;
  NEOB?: InputMaybe<Order_By>;
  NEOTH?: InputMaybe<Order_By>;
  NETOT?: InputMaybe<Order_By>;
  OFRNRS?: InputMaybe<Order_By>;
  OSFTE?: InputMaybe<Order_By>;
  PH?: InputMaybe<Order_By>;
  PLNTA?: InputMaybe<Order_By>;
  PRPM?: InputMaybe<Order_By>;
  PTAPRN?: InputMaybe<Order_By>;
  PTPHRN?: InputMaybe<Order_By>;
  RNSCH?: InputMaybe<Order_By>;
  SALPOC?: InputMaybe<Order_By>;
  SALPOF?: InputMaybe<Order_By>;
  SAMOC?: InputMaybe<Order_By>;
  SAMOF?: InputMaybe<Order_By>;
  SATOC?: InputMaybe<Order_By>;
  SATOF?: InputMaybe<Order_By>;
  SATOTH?: InputMaybe<Order_By>;
  SBLD?: InputMaybe<Order_By>;
  SBLDOC?: InputMaybe<Order_By>;
  SBLDOF?: InputMaybe<Order_By>;
  SCARD?: InputMaybe<Order_By>;
  SCAROC?: InputMaybe<Order_By>;
  SCAROF?: InputMaybe<Order_By>;
  SDIAG?: InputMaybe<Order_By>;
  SDIGOC?: InputMaybe<Order_By>;
  SDIGOF?: InputMaybe<Order_By>;
  SENDO?: InputMaybe<Order_By>;
  SENDOC?: InputMaybe<Order_By>;
  SENDOF?: InputMaybe<Order_By>;
  SENT?: InputMaybe<Order_By>;
  SENTOC?: InputMaybe<Order_By>;
  SENTOF?: InputMaybe<Order_By>;
  SGEN?: InputMaybe<Order_By>;
  SGENOC?: InputMaybe<Order_By>;
  SGENOF?: InputMaybe<Order_By>;
  SGI?: InputMaybe<Order_By>;
  SGIOC?: InputMaybe<Order_By>;
  SGIOF?: InputMaybe<Order_By>;
  SGYN?: InputMaybe<Order_By>;
  SGYNOC?: InputMaybe<Order_By>;
  SGYNOF?: InputMaybe<Order_By>;
  SLABOC?: InputMaybe<Order_By>;
  SLABOF?: InputMaybe<Order_By>;
  SMIN?: InputMaybe<Order_By>;
  SMINOC?: InputMaybe<Order_By>;
  SMINOF?: InputMaybe<Order_By>;
  SMRI?: InputMaybe<Order_By>;
  SMRIOC?: InputMaybe<Order_By>;
  SMRIOF?: InputMaybe<Order_By>;
  SMUS?: InputMaybe<Order_By>;
  SMUSOC?: InputMaybe<Order_By>;
  SMUSOF?: InputMaybe<Order_By>;
  SNRV?: InputMaybe<Order_By>;
  SNRVOC?: InputMaybe<Order_By>;
  SNRVOF?: InputMaybe<Order_By>;
  SNTOP?: InputMaybe<Order_By>;
  SONCL?: InputMaybe<Order_By>;
  SONCOC?: InputMaybe<Order_By>;
  SONCOF?: InputMaybe<Order_By>;
  SOPH?: InputMaybe<Order_By>;
  SOPHOC?: InputMaybe<Order_By>;
  SOPHOF?: InputMaybe<Order_By>;
  SOTHSAT?: InputMaybe<Order_By>;
  SPAHOC?: InputMaybe<Order_By>;
  SPAHOF?: InputMaybe<Order_By>;
  SPATH?: InputMaybe<Order_By>;
  SPCOC?: InputMaybe<Order_By>;
  SPCOF?: InputMaybe<Order_By>;
  SPSYOC?: InputMaybe<Order_By>;
  SPSYOF?: InputMaybe<Order_By>;
  SPSYX?: InputMaybe<Order_By>;
  SRADOC?: InputMaybe<Order_By>;
  SRADOF?: InputMaybe<Order_By>;
  SRHBOC?: InputMaybe<Order_By>;
  SRHBOF?: InputMaybe<Order_By>;
  SSALOP?: InputMaybe<Order_By>;
  SSAMBS?: InputMaybe<Order_By>;
  SSLAB?: InputMaybe<Order_By>;
  SSNROC?: InputMaybe<Order_By>;
  SSNROF?: InputMaybe<Order_By>;
  SSNRR?: InputMaybe<Order_By>;
  SSPCC?: InputMaybe<Order_By>;
  SSRAD?: InputMaybe<Order_By>;
  SSRHB?: InputMaybe<Order_By>;
  SSUCAR?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUCOC?: InputMaybe<Order_By>;
  SUCOF?: InputMaybe<Order_By>;
  SURO?: InputMaybe<Order_By>;
  SUROOC?: InputMaybe<Order_By>;
  SUROOF?: InputMaybe<Order_By>;
  SVAS?: InputMaybe<Order_By>;
  SVASOC?: InputMaybe<Order_By>;
  SVASOF?: InputMaybe<Order_By>;
  SVRS?: InputMaybe<Order_By>;
  SVRSOC?: InputMaybe<Order_By>;
  SVRSOF?: InputMaybe<Order_By>;
  TCCAR?: InputMaybe<Order_By>;
  TCGST?: InputMaybe<Order_By>;
  TCHSP?: InputMaybe<Order_By>;
  TCINT?: InputMaybe<Order_By>;
  TCMER?: InputMaybe<Order_By>;
  TCOB?: InputMaybe<Order_By>;
  TCOTH?: InputMaybe<Order_By>;
  TCTOT?: InputMaybe<Order_By>;
  TECAR?: InputMaybe<Order_By>;
  TEGST?: InputMaybe<Order_By>;
  TEHSP?: InputMaybe<Order_By>;
  TEINT?: InputMaybe<Order_By>;
  TEMER?: InputMaybe<Order_By>;
  TEOB?: InputMaybe<Order_By>;
  TEOTH?: InputMaybe<Order_By>;
  TETOT?: InputMaybe<Order_By>;
  TGCAR?: InputMaybe<Order_By>;
  TGGST?: InputMaybe<Order_By>;
  TGHSP?: InputMaybe<Order_By>;
  TGINT?: InputMaybe<Order_By>;
  TGMER?: InputMaybe<Order_By>;
  TGOB?: InputMaybe<Order_By>;
  TGOTH?: InputMaybe<Order_By>;
  TGTOT?: InputMaybe<Order_By>;
  TPCAR?: InputMaybe<Order_By>;
  TPGST?: InputMaybe<Order_By>;
  TPHSP?: InputMaybe<Order_By>;
  TPINT?: InputMaybe<Order_By>;
  TPMER?: InputMaybe<Order_By>;
  TPOB?: InputMaybe<Order_By>;
  TPOTH?: InputMaybe<Order_By>;
  TPRTOT?: InputMaybe<Order_By>;
  VIDVZ?: InputMaybe<Order_By>;
  VPSRV?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS20UTIL2 */
export type As20Util2_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS20UTIL2" */
export enum As20Util2_Select_Column {
  /** column name */
  Adepra = 'ADEPRA',
  /** column name */
  Africa = 'AFRICA',
  /** column name */
  Apanes = 'APANES',
  /** column name */
  Apcar = 'APCAR',
  /** column name */
  Apcase = 'APCASE',
  /** column name */
  Aped = 'APED',
  /** column name */
  Apemer = 'APEMER',
  /** column name */
  Apoth = 'APOTH',
  /** column name */
  Aprn = 'APRN',
  /** column name */
  Apspc = 'APSPC',
  /** column name */
  Assnet = 'ASSNET',
  /** column name */
  Auvz = 'AUVZ',
  /** column name */
  Canada = 'CANADA',
  /** column name */
  Ceamt = 'CEAMT',
  /** column name */
  China = 'CHINA',
  /** column name */
  Clscic = 'CLSCIC',
  /** column name */
  Clsmsi = 'CLSMSI',
  /** column name */
  Clsnic = 'CLSNIC',
  /** column name */
  Clsoic = 'CLSOIC',
  /** column name */
  Clspic = 'CLSPIC',
  /** column name */
  Fornrsa = 'FORNRSA',
  /** column name */
  Ftaprn = 'FTAPRN',
  /** column name */
  Fteapn = 'FTEAPN',
  /** column name */
  Ftecic = 'FTECIC',
  /** column name */
  Ftehsp = 'FTEHSP',
  /** column name */
  Fteint = 'FTEINT',
  /** column name */
  Ftemsi = 'FTEMSI',
  /** column name */
  Ftenic = 'FTENIC',
  /** column name */
  Fteoic = 'FTEOIC',
  /** column name */
  Ftephrn = 'FTEPHRN',
  /** column name */
  Ftepic = 'FTEPIC',
  /** column name */
  Ftphrn = 'FTPHRN',
  /** column name */
  Gfeet = 'GFEET',
  /** column name */
  Hsptl = 'HSPTL',
  /** column name */
  Id = 'ID',
  /** column name */
  India = 'INDIA',
  /** column name */
  Intcar = 'INTCAR',
  /** column name */
  Itbugt = 'ITBUGT',
  /** column name */
  Itexpa = 'ITEXPA',
  /** column name */
  Itfte = 'ITFTE',
  /** column name */
  Korea = 'KOREA',
  /** column name */
  Necar = 'NECAR',
  /** column name */
  Negst = 'NEGST',
  /** column name */
  Nehsp = 'NEHSP',
  /** column name */
  Neint = 'NEINT',
  /** column name */
  Nemer = 'NEMER',
  /** column name */
  Neob = 'NEOB',
  /** column name */
  Neoth = 'NEOTH',
  /** column name */
  Netot = 'NETOT',
  /** column name */
  Ofrnrs = 'OFRNRS',
  /** column name */
  Osfte = 'OSFTE',
  /** column name */
  Ph = 'PH',
  /** column name */
  Plnta = 'PLNTA',
  /** column name */
  Prpm = 'PRPM',
  /** column name */
  Ptaprn = 'PTAPRN',
  /** column name */
  Ptphrn = 'PTPHRN',
  /** column name */
  Rnsch = 'RNSCH',
  /** column name */
  Salpoc = 'SALPOC',
  /** column name */
  Salpof = 'SALPOF',
  /** column name */
  Samoc = 'SAMOC',
  /** column name */
  Samof = 'SAMOF',
  /** column name */
  Satoc = 'SATOC',
  /** column name */
  Satof = 'SATOF',
  /** column name */
  Satoth = 'SATOTH',
  /** column name */
  Sbld = 'SBLD',
  /** column name */
  Sbldoc = 'SBLDOC',
  /** column name */
  Sbldof = 'SBLDOF',
  /** column name */
  Scard = 'SCARD',
  /** column name */
  Scaroc = 'SCAROC',
  /** column name */
  Scarof = 'SCAROF',
  /** column name */
  Sdiag = 'SDIAG',
  /** column name */
  Sdigoc = 'SDIGOC',
  /** column name */
  Sdigof = 'SDIGOF',
  /** column name */
  Sendo = 'SENDO',
  /** column name */
  Sendoc = 'SENDOC',
  /** column name */
  Sendof = 'SENDOF',
  /** column name */
  Sent = 'SENT',
  /** column name */
  Sentoc = 'SENTOC',
  /** column name */
  Sentof = 'SENTOF',
  /** column name */
  Sgen = 'SGEN',
  /** column name */
  Sgenoc = 'SGENOC',
  /** column name */
  Sgenof = 'SGENOF',
  /** column name */
  Sgi = 'SGI',
  /** column name */
  Sgioc = 'SGIOC',
  /** column name */
  Sgiof = 'SGIOF',
  /** column name */
  Sgyn = 'SGYN',
  /** column name */
  Sgynoc = 'SGYNOC',
  /** column name */
  Sgynof = 'SGYNOF',
  /** column name */
  Slaboc = 'SLABOC',
  /** column name */
  Slabof = 'SLABOF',
  /** column name */
  Smin = 'SMIN',
  /** column name */
  Sminoc = 'SMINOC',
  /** column name */
  Sminof = 'SMINOF',
  /** column name */
  Smri = 'SMRI',
  /** column name */
  Smrioc = 'SMRIOC',
  /** column name */
  Smriof = 'SMRIOF',
  /** column name */
  Smus = 'SMUS',
  /** column name */
  Smusoc = 'SMUSOC',
  /** column name */
  Smusof = 'SMUSOF',
  /** column name */
  Snrv = 'SNRV',
  /** column name */
  Snrvoc = 'SNRVOC',
  /** column name */
  Snrvof = 'SNRVOF',
  /** column name */
  Sntop = 'SNTOP',
  /** column name */
  Soncl = 'SONCL',
  /** column name */
  Soncoc = 'SONCOC',
  /** column name */
  Soncof = 'SONCOF',
  /** column name */
  Soph = 'SOPH',
  /** column name */
  Sophoc = 'SOPHOC',
  /** column name */
  Sophof = 'SOPHOF',
  /** column name */
  Sothsat = 'SOTHSAT',
  /** column name */
  Spahoc = 'SPAHOC',
  /** column name */
  Spahof = 'SPAHOF',
  /** column name */
  Spath = 'SPATH',
  /** column name */
  Spcoc = 'SPCOC',
  /** column name */
  Spcof = 'SPCOF',
  /** column name */
  Spsyoc = 'SPSYOC',
  /** column name */
  Spsyof = 'SPSYOF',
  /** column name */
  Spsyx = 'SPSYX',
  /** column name */
  Sradoc = 'SRADOC',
  /** column name */
  Sradof = 'SRADOF',
  /** column name */
  Srhboc = 'SRHBOC',
  /** column name */
  Srhbof = 'SRHBOF',
  /** column name */
  Ssalop = 'SSALOP',
  /** column name */
  Ssambs = 'SSAMBS',
  /** column name */
  Sslab = 'SSLAB',
  /** column name */
  Ssnroc = 'SSNROC',
  /** column name */
  Ssnrof = 'SSNROF',
  /** column name */
  Ssnrr = 'SSNRR',
  /** column name */
  Sspcc = 'SSPCC',
  /** column name */
  Ssrad = 'SSRAD',
  /** column name */
  Ssrhb = 'SSRHB',
  /** column name */
  Ssucar = 'SSUCAR',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Sucoc = 'SUCOC',
  /** column name */
  Sucof = 'SUCOF',
  /** column name */
  Suro = 'SURO',
  /** column name */
  Surooc = 'SUROOC',
  /** column name */
  Suroof = 'SUROOF',
  /** column name */
  Svas = 'SVAS',
  /** column name */
  Svasoc = 'SVASOC',
  /** column name */
  Svasof = 'SVASOF',
  /** column name */
  Svrs = 'SVRS',
  /** column name */
  Svrsoc = 'SVRSOC',
  /** column name */
  Svrsof = 'SVRSOF',
  /** column name */
  Tccar = 'TCCAR',
  /** column name */
  Tcgst = 'TCGST',
  /** column name */
  Tchsp = 'TCHSP',
  /** column name */
  Tcint = 'TCINT',
  /** column name */
  Tcmer = 'TCMER',
  /** column name */
  Tcob = 'TCOB',
  /** column name */
  Tcoth = 'TCOTH',
  /** column name */
  Tctot = 'TCTOT',
  /** column name */
  Tecar = 'TECAR',
  /** column name */
  Tegst = 'TEGST',
  /** column name */
  Tehsp = 'TEHSP',
  /** column name */
  Teint = 'TEINT',
  /** column name */
  Temer = 'TEMER',
  /** column name */
  Teob = 'TEOB',
  /** column name */
  Teoth = 'TEOTH',
  /** column name */
  Tetot = 'TETOT',
  /** column name */
  Tgcar = 'TGCAR',
  /** column name */
  Tggst = 'TGGST',
  /** column name */
  Tghsp = 'TGHSP',
  /** column name */
  Tgint = 'TGINT',
  /** column name */
  Tgmer = 'TGMER',
  /** column name */
  Tgob = 'TGOB',
  /** column name */
  Tgoth = 'TGOTH',
  /** column name */
  Tgtot = 'TGTOT',
  /** column name */
  Tpcar = 'TPCAR',
  /** column name */
  Tpgst = 'TPGST',
  /** column name */
  Tphsp = 'TPHSP',
  /** column name */
  Tpint = 'TPINT',
  /** column name */
  Tpmer = 'TPMER',
  /** column name */
  Tpob = 'TPOB',
  /** column name */
  Tpoth = 'TPOTH',
  /** column name */
  Tprtot = 'TPRTOT',
  /** column name */
  Vidvz = 'VIDVZ',
  /** column name */
  Vpsrv = 'VPSRV'
}

/** input type for updating data in table "AS20UTIL2" */
export type As20Util2_Set_Input = {
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  KOREA?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  PH?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SALPOC?: InputMaybe<Scalars['float8']>;
  SALPOF?: InputMaybe<Scalars['float8']>;
  SAMOC?: InputMaybe<Scalars['float8']>;
  SAMOF?: InputMaybe<Scalars['float8']>;
  SATOC?: InputMaybe<Scalars['float8']>;
  SATOF?: InputMaybe<Scalars['float8']>;
  SATOTH?: InputMaybe<Scalars['String']>;
  SBLD?: InputMaybe<Scalars['String']>;
  SBLDOC?: InputMaybe<Scalars['float8']>;
  SBLDOF?: InputMaybe<Scalars['float8']>;
  SCARD?: InputMaybe<Scalars['String']>;
  SCAROC?: InputMaybe<Scalars['float8']>;
  SCAROF?: InputMaybe<Scalars['float8']>;
  SDIAG?: InputMaybe<Scalars['String']>;
  SDIGOC?: InputMaybe<Scalars['float8']>;
  SDIGOF?: InputMaybe<Scalars['float8']>;
  SENDO?: InputMaybe<Scalars['String']>;
  SENDOC?: InputMaybe<Scalars['float8']>;
  SENDOF?: InputMaybe<Scalars['float8']>;
  SENT?: InputMaybe<Scalars['String']>;
  SENTOC?: InputMaybe<Scalars['float8']>;
  SENTOF?: InputMaybe<Scalars['float8']>;
  SGEN?: InputMaybe<Scalars['String']>;
  SGENOC?: InputMaybe<Scalars['float8']>;
  SGENOF?: InputMaybe<Scalars['float8']>;
  SGI?: InputMaybe<Scalars['String']>;
  SGIOC?: InputMaybe<Scalars['float8']>;
  SGIOF?: InputMaybe<Scalars['float8']>;
  SGYN?: InputMaybe<Scalars['String']>;
  SGYNOC?: InputMaybe<Scalars['float8']>;
  SGYNOF?: InputMaybe<Scalars['float8']>;
  SLABOC?: InputMaybe<Scalars['float8']>;
  SLABOF?: InputMaybe<Scalars['float8']>;
  SMIN?: InputMaybe<Scalars['String']>;
  SMINOC?: InputMaybe<Scalars['float8']>;
  SMINOF?: InputMaybe<Scalars['float8']>;
  SMRI?: InputMaybe<Scalars['String']>;
  SMRIOC?: InputMaybe<Scalars['float8']>;
  SMRIOF?: InputMaybe<Scalars['float8']>;
  SMUS?: InputMaybe<Scalars['String']>;
  SMUSOC?: InputMaybe<Scalars['float8']>;
  SMUSOF?: InputMaybe<Scalars['float8']>;
  SNRV?: InputMaybe<Scalars['String']>;
  SNRVOC?: InputMaybe<Scalars['float8']>;
  SNRVOF?: InputMaybe<Scalars['float8']>;
  SNTOP?: InputMaybe<Scalars['String']>;
  SONCL?: InputMaybe<Scalars['String']>;
  SONCOC?: InputMaybe<Scalars['float8']>;
  SONCOF?: InputMaybe<Scalars['float8']>;
  SOPH?: InputMaybe<Scalars['String']>;
  SOPHOC?: InputMaybe<Scalars['float8']>;
  SOPHOF?: InputMaybe<Scalars['float8']>;
  SOTHSAT?: InputMaybe<Scalars['String']>;
  SPAHOC?: InputMaybe<Scalars['float8']>;
  SPAHOF?: InputMaybe<Scalars['float8']>;
  SPATH?: InputMaybe<Scalars['String']>;
  SPCOC?: InputMaybe<Scalars['float8']>;
  SPCOF?: InputMaybe<Scalars['float8']>;
  SPSYOC?: InputMaybe<Scalars['float8']>;
  SPSYOF?: InputMaybe<Scalars['float8']>;
  SPSYX?: InputMaybe<Scalars['String']>;
  SRADOC?: InputMaybe<Scalars['float8']>;
  SRADOF?: InputMaybe<Scalars['float8']>;
  SRHBOC?: InputMaybe<Scalars['float8']>;
  SRHBOF?: InputMaybe<Scalars['float8']>;
  SSALOP?: InputMaybe<Scalars['String']>;
  SSAMBS?: InputMaybe<Scalars['String']>;
  SSLAB?: InputMaybe<Scalars['String']>;
  SSNROC?: InputMaybe<Scalars['float8']>;
  SSNROF?: InputMaybe<Scalars['float8']>;
  SSNRR?: InputMaybe<Scalars['String']>;
  SSPCC?: InputMaybe<Scalars['String']>;
  SSRAD?: InputMaybe<Scalars['String']>;
  SSRHB?: InputMaybe<Scalars['String']>;
  SSUCAR?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUCOC?: InputMaybe<Scalars['float8']>;
  SUCOF?: InputMaybe<Scalars['float8']>;
  SURO?: InputMaybe<Scalars['String']>;
  SUROOC?: InputMaybe<Scalars['float8']>;
  SUROOF?: InputMaybe<Scalars['float8']>;
  SVAS?: InputMaybe<Scalars['String']>;
  SVASOC?: InputMaybe<Scalars['float8']>;
  SVASOF?: InputMaybe<Scalars['float8']>;
  SVRS?: InputMaybe<Scalars['String']>;
  SVRSOC?: InputMaybe<Scalars['float8']>;
  SVRSOF?: InputMaybe<Scalars['float8']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type As20Util2_Stddev_Fields = {
  __typename?: 'AS20UTIL2_stddev_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As20Util2_Stddev_Pop_Fields = {
  __typename?: 'AS20UTIL2_stddev_pop_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As20Util2_Stddev_Samp_Fields = {
  __typename?: 'AS20UTIL2_stddev_samp_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS20UTIL2" */
export type As20Util2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As20Util2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As20Util2_Stream_Cursor_Value_Input = {
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  KOREA?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  PH?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SALPOC?: InputMaybe<Scalars['float8']>;
  SALPOF?: InputMaybe<Scalars['float8']>;
  SAMOC?: InputMaybe<Scalars['float8']>;
  SAMOF?: InputMaybe<Scalars['float8']>;
  SATOC?: InputMaybe<Scalars['float8']>;
  SATOF?: InputMaybe<Scalars['float8']>;
  SATOTH?: InputMaybe<Scalars['String']>;
  SBLD?: InputMaybe<Scalars['String']>;
  SBLDOC?: InputMaybe<Scalars['float8']>;
  SBLDOF?: InputMaybe<Scalars['float8']>;
  SCARD?: InputMaybe<Scalars['String']>;
  SCAROC?: InputMaybe<Scalars['float8']>;
  SCAROF?: InputMaybe<Scalars['float8']>;
  SDIAG?: InputMaybe<Scalars['String']>;
  SDIGOC?: InputMaybe<Scalars['float8']>;
  SDIGOF?: InputMaybe<Scalars['float8']>;
  SENDO?: InputMaybe<Scalars['String']>;
  SENDOC?: InputMaybe<Scalars['float8']>;
  SENDOF?: InputMaybe<Scalars['float8']>;
  SENT?: InputMaybe<Scalars['String']>;
  SENTOC?: InputMaybe<Scalars['float8']>;
  SENTOF?: InputMaybe<Scalars['float8']>;
  SGEN?: InputMaybe<Scalars['String']>;
  SGENOC?: InputMaybe<Scalars['float8']>;
  SGENOF?: InputMaybe<Scalars['float8']>;
  SGI?: InputMaybe<Scalars['String']>;
  SGIOC?: InputMaybe<Scalars['float8']>;
  SGIOF?: InputMaybe<Scalars['float8']>;
  SGYN?: InputMaybe<Scalars['String']>;
  SGYNOC?: InputMaybe<Scalars['float8']>;
  SGYNOF?: InputMaybe<Scalars['float8']>;
  SLABOC?: InputMaybe<Scalars['float8']>;
  SLABOF?: InputMaybe<Scalars['float8']>;
  SMIN?: InputMaybe<Scalars['String']>;
  SMINOC?: InputMaybe<Scalars['float8']>;
  SMINOF?: InputMaybe<Scalars['float8']>;
  SMRI?: InputMaybe<Scalars['String']>;
  SMRIOC?: InputMaybe<Scalars['float8']>;
  SMRIOF?: InputMaybe<Scalars['float8']>;
  SMUS?: InputMaybe<Scalars['String']>;
  SMUSOC?: InputMaybe<Scalars['float8']>;
  SMUSOF?: InputMaybe<Scalars['float8']>;
  SNRV?: InputMaybe<Scalars['String']>;
  SNRVOC?: InputMaybe<Scalars['float8']>;
  SNRVOF?: InputMaybe<Scalars['float8']>;
  SNTOP?: InputMaybe<Scalars['String']>;
  SONCL?: InputMaybe<Scalars['String']>;
  SONCOC?: InputMaybe<Scalars['float8']>;
  SONCOF?: InputMaybe<Scalars['float8']>;
  SOPH?: InputMaybe<Scalars['String']>;
  SOPHOC?: InputMaybe<Scalars['float8']>;
  SOPHOF?: InputMaybe<Scalars['float8']>;
  SOTHSAT?: InputMaybe<Scalars['String']>;
  SPAHOC?: InputMaybe<Scalars['float8']>;
  SPAHOF?: InputMaybe<Scalars['float8']>;
  SPATH?: InputMaybe<Scalars['String']>;
  SPCOC?: InputMaybe<Scalars['float8']>;
  SPCOF?: InputMaybe<Scalars['float8']>;
  SPSYOC?: InputMaybe<Scalars['float8']>;
  SPSYOF?: InputMaybe<Scalars['float8']>;
  SPSYX?: InputMaybe<Scalars['String']>;
  SRADOC?: InputMaybe<Scalars['float8']>;
  SRADOF?: InputMaybe<Scalars['float8']>;
  SRHBOC?: InputMaybe<Scalars['float8']>;
  SRHBOF?: InputMaybe<Scalars['float8']>;
  SSALOP?: InputMaybe<Scalars['String']>;
  SSAMBS?: InputMaybe<Scalars['String']>;
  SSLAB?: InputMaybe<Scalars['String']>;
  SSNROC?: InputMaybe<Scalars['float8']>;
  SSNROF?: InputMaybe<Scalars['float8']>;
  SSNRR?: InputMaybe<Scalars['String']>;
  SSPCC?: InputMaybe<Scalars['String']>;
  SSRAD?: InputMaybe<Scalars['String']>;
  SSRHB?: InputMaybe<Scalars['String']>;
  SSUCAR?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUCOC?: InputMaybe<Scalars['float8']>;
  SUCOF?: InputMaybe<Scalars['float8']>;
  SURO?: InputMaybe<Scalars['String']>;
  SUROOC?: InputMaybe<Scalars['float8']>;
  SUROOF?: InputMaybe<Scalars['float8']>;
  SVAS?: InputMaybe<Scalars['String']>;
  SVASOC?: InputMaybe<Scalars['float8']>;
  SVASOF?: InputMaybe<Scalars['float8']>;
  SVRS?: InputMaybe<Scalars['String']>;
  SVRSOC?: InputMaybe<Scalars['float8']>;
  SVRSOF?: InputMaybe<Scalars['float8']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type As20Util2_Sum_Fields = {
  __typename?: 'AS20UTIL2_sum_fields';
  ADEPRA: Maybe<Scalars['float8']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  CEAMT: Maybe<Scalars['float8']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OSFTE: Maybe<Scalars['float8']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SALPOC: Maybe<Scalars['float8']>;
  SALPOF: Maybe<Scalars['float8']>;
  SAMOC: Maybe<Scalars['float8']>;
  SAMOF: Maybe<Scalars['float8']>;
  SATOC: Maybe<Scalars['float8']>;
  SATOF: Maybe<Scalars['float8']>;
  SBLDOC: Maybe<Scalars['float8']>;
  SBLDOF: Maybe<Scalars['float8']>;
  SCAROC: Maybe<Scalars['float8']>;
  SCAROF: Maybe<Scalars['float8']>;
  SDIGOC: Maybe<Scalars['float8']>;
  SDIGOF: Maybe<Scalars['float8']>;
  SENDOC: Maybe<Scalars['float8']>;
  SENDOF: Maybe<Scalars['float8']>;
  SENTOC: Maybe<Scalars['float8']>;
  SENTOF: Maybe<Scalars['float8']>;
  SGENOC: Maybe<Scalars['float8']>;
  SGENOF: Maybe<Scalars['float8']>;
  SGIOC: Maybe<Scalars['float8']>;
  SGIOF: Maybe<Scalars['float8']>;
  SGYNOC: Maybe<Scalars['float8']>;
  SGYNOF: Maybe<Scalars['float8']>;
  SLABOC: Maybe<Scalars['float8']>;
  SLABOF: Maybe<Scalars['float8']>;
  SMINOC: Maybe<Scalars['float8']>;
  SMINOF: Maybe<Scalars['float8']>;
  SMRIOC: Maybe<Scalars['float8']>;
  SMRIOF: Maybe<Scalars['float8']>;
  SMUSOC: Maybe<Scalars['float8']>;
  SMUSOF: Maybe<Scalars['float8']>;
  SNRVOC: Maybe<Scalars['float8']>;
  SNRVOF: Maybe<Scalars['float8']>;
  SONCOC: Maybe<Scalars['float8']>;
  SONCOF: Maybe<Scalars['float8']>;
  SOPHOC: Maybe<Scalars['float8']>;
  SOPHOF: Maybe<Scalars['float8']>;
  SPAHOC: Maybe<Scalars['float8']>;
  SPAHOF: Maybe<Scalars['float8']>;
  SPCOC: Maybe<Scalars['float8']>;
  SPCOF: Maybe<Scalars['float8']>;
  SPSYOC: Maybe<Scalars['float8']>;
  SPSYOF: Maybe<Scalars['float8']>;
  SRADOC: Maybe<Scalars['float8']>;
  SRADOF: Maybe<Scalars['float8']>;
  SRHBOC: Maybe<Scalars['float8']>;
  SRHBOF: Maybe<Scalars['float8']>;
  SSNROC: Maybe<Scalars['float8']>;
  SSNROF: Maybe<Scalars['float8']>;
  SUCOC: Maybe<Scalars['float8']>;
  SUCOF: Maybe<Scalars['float8']>;
  SUROOC: Maybe<Scalars['float8']>;
  SUROOF: Maybe<Scalars['float8']>;
  SVASOC: Maybe<Scalars['float8']>;
  SVASOF: Maybe<Scalars['float8']>;
  SVRSOC: Maybe<Scalars['float8']>;
  SVRSOF: Maybe<Scalars['float8']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
};

/** update columns of table "AS20UTIL2" */
export enum As20Util2_Update_Column {
  /** column name */
  Adepra = 'ADEPRA',
  /** column name */
  Africa = 'AFRICA',
  /** column name */
  Apanes = 'APANES',
  /** column name */
  Apcar = 'APCAR',
  /** column name */
  Apcase = 'APCASE',
  /** column name */
  Aped = 'APED',
  /** column name */
  Apemer = 'APEMER',
  /** column name */
  Apoth = 'APOTH',
  /** column name */
  Aprn = 'APRN',
  /** column name */
  Apspc = 'APSPC',
  /** column name */
  Assnet = 'ASSNET',
  /** column name */
  Auvz = 'AUVZ',
  /** column name */
  Canada = 'CANADA',
  /** column name */
  Ceamt = 'CEAMT',
  /** column name */
  China = 'CHINA',
  /** column name */
  Clscic = 'CLSCIC',
  /** column name */
  Clsmsi = 'CLSMSI',
  /** column name */
  Clsnic = 'CLSNIC',
  /** column name */
  Clsoic = 'CLSOIC',
  /** column name */
  Clspic = 'CLSPIC',
  /** column name */
  Fornrsa = 'FORNRSA',
  /** column name */
  Ftaprn = 'FTAPRN',
  /** column name */
  Fteapn = 'FTEAPN',
  /** column name */
  Ftecic = 'FTECIC',
  /** column name */
  Ftehsp = 'FTEHSP',
  /** column name */
  Fteint = 'FTEINT',
  /** column name */
  Ftemsi = 'FTEMSI',
  /** column name */
  Ftenic = 'FTENIC',
  /** column name */
  Fteoic = 'FTEOIC',
  /** column name */
  Ftephrn = 'FTEPHRN',
  /** column name */
  Ftepic = 'FTEPIC',
  /** column name */
  Ftphrn = 'FTPHRN',
  /** column name */
  Gfeet = 'GFEET',
  /** column name */
  Hsptl = 'HSPTL',
  /** column name */
  Id = 'ID',
  /** column name */
  India = 'INDIA',
  /** column name */
  Intcar = 'INTCAR',
  /** column name */
  Itbugt = 'ITBUGT',
  /** column name */
  Itexpa = 'ITEXPA',
  /** column name */
  Itfte = 'ITFTE',
  /** column name */
  Korea = 'KOREA',
  /** column name */
  Necar = 'NECAR',
  /** column name */
  Negst = 'NEGST',
  /** column name */
  Nehsp = 'NEHSP',
  /** column name */
  Neint = 'NEINT',
  /** column name */
  Nemer = 'NEMER',
  /** column name */
  Neob = 'NEOB',
  /** column name */
  Neoth = 'NEOTH',
  /** column name */
  Netot = 'NETOT',
  /** column name */
  Ofrnrs = 'OFRNRS',
  /** column name */
  Osfte = 'OSFTE',
  /** column name */
  Ph = 'PH',
  /** column name */
  Plnta = 'PLNTA',
  /** column name */
  Prpm = 'PRPM',
  /** column name */
  Ptaprn = 'PTAPRN',
  /** column name */
  Ptphrn = 'PTPHRN',
  /** column name */
  Rnsch = 'RNSCH',
  /** column name */
  Salpoc = 'SALPOC',
  /** column name */
  Salpof = 'SALPOF',
  /** column name */
  Samoc = 'SAMOC',
  /** column name */
  Samof = 'SAMOF',
  /** column name */
  Satoc = 'SATOC',
  /** column name */
  Satof = 'SATOF',
  /** column name */
  Satoth = 'SATOTH',
  /** column name */
  Sbld = 'SBLD',
  /** column name */
  Sbldoc = 'SBLDOC',
  /** column name */
  Sbldof = 'SBLDOF',
  /** column name */
  Scard = 'SCARD',
  /** column name */
  Scaroc = 'SCAROC',
  /** column name */
  Scarof = 'SCAROF',
  /** column name */
  Sdiag = 'SDIAG',
  /** column name */
  Sdigoc = 'SDIGOC',
  /** column name */
  Sdigof = 'SDIGOF',
  /** column name */
  Sendo = 'SENDO',
  /** column name */
  Sendoc = 'SENDOC',
  /** column name */
  Sendof = 'SENDOF',
  /** column name */
  Sent = 'SENT',
  /** column name */
  Sentoc = 'SENTOC',
  /** column name */
  Sentof = 'SENTOF',
  /** column name */
  Sgen = 'SGEN',
  /** column name */
  Sgenoc = 'SGENOC',
  /** column name */
  Sgenof = 'SGENOF',
  /** column name */
  Sgi = 'SGI',
  /** column name */
  Sgioc = 'SGIOC',
  /** column name */
  Sgiof = 'SGIOF',
  /** column name */
  Sgyn = 'SGYN',
  /** column name */
  Sgynoc = 'SGYNOC',
  /** column name */
  Sgynof = 'SGYNOF',
  /** column name */
  Slaboc = 'SLABOC',
  /** column name */
  Slabof = 'SLABOF',
  /** column name */
  Smin = 'SMIN',
  /** column name */
  Sminoc = 'SMINOC',
  /** column name */
  Sminof = 'SMINOF',
  /** column name */
  Smri = 'SMRI',
  /** column name */
  Smrioc = 'SMRIOC',
  /** column name */
  Smriof = 'SMRIOF',
  /** column name */
  Smus = 'SMUS',
  /** column name */
  Smusoc = 'SMUSOC',
  /** column name */
  Smusof = 'SMUSOF',
  /** column name */
  Snrv = 'SNRV',
  /** column name */
  Snrvoc = 'SNRVOC',
  /** column name */
  Snrvof = 'SNRVOF',
  /** column name */
  Sntop = 'SNTOP',
  /** column name */
  Soncl = 'SONCL',
  /** column name */
  Soncoc = 'SONCOC',
  /** column name */
  Soncof = 'SONCOF',
  /** column name */
  Soph = 'SOPH',
  /** column name */
  Sophoc = 'SOPHOC',
  /** column name */
  Sophof = 'SOPHOF',
  /** column name */
  Sothsat = 'SOTHSAT',
  /** column name */
  Spahoc = 'SPAHOC',
  /** column name */
  Spahof = 'SPAHOF',
  /** column name */
  Spath = 'SPATH',
  /** column name */
  Spcoc = 'SPCOC',
  /** column name */
  Spcof = 'SPCOF',
  /** column name */
  Spsyoc = 'SPSYOC',
  /** column name */
  Spsyof = 'SPSYOF',
  /** column name */
  Spsyx = 'SPSYX',
  /** column name */
  Sradoc = 'SRADOC',
  /** column name */
  Sradof = 'SRADOF',
  /** column name */
  Srhboc = 'SRHBOC',
  /** column name */
  Srhbof = 'SRHBOF',
  /** column name */
  Ssalop = 'SSALOP',
  /** column name */
  Ssambs = 'SSAMBS',
  /** column name */
  Sslab = 'SSLAB',
  /** column name */
  Ssnroc = 'SSNROC',
  /** column name */
  Ssnrof = 'SSNROF',
  /** column name */
  Ssnrr = 'SSNRR',
  /** column name */
  Sspcc = 'SSPCC',
  /** column name */
  Ssrad = 'SSRAD',
  /** column name */
  Ssrhb = 'SSRHB',
  /** column name */
  Ssucar = 'SSUCAR',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Sucoc = 'SUCOC',
  /** column name */
  Sucof = 'SUCOF',
  /** column name */
  Suro = 'SURO',
  /** column name */
  Surooc = 'SUROOC',
  /** column name */
  Suroof = 'SUROOF',
  /** column name */
  Svas = 'SVAS',
  /** column name */
  Svasoc = 'SVASOC',
  /** column name */
  Svasof = 'SVASOF',
  /** column name */
  Svrs = 'SVRS',
  /** column name */
  Svrsoc = 'SVRSOC',
  /** column name */
  Svrsof = 'SVRSOF',
  /** column name */
  Tccar = 'TCCAR',
  /** column name */
  Tcgst = 'TCGST',
  /** column name */
  Tchsp = 'TCHSP',
  /** column name */
  Tcint = 'TCINT',
  /** column name */
  Tcmer = 'TCMER',
  /** column name */
  Tcob = 'TCOB',
  /** column name */
  Tcoth = 'TCOTH',
  /** column name */
  Tctot = 'TCTOT',
  /** column name */
  Tecar = 'TECAR',
  /** column name */
  Tegst = 'TEGST',
  /** column name */
  Tehsp = 'TEHSP',
  /** column name */
  Teint = 'TEINT',
  /** column name */
  Temer = 'TEMER',
  /** column name */
  Teob = 'TEOB',
  /** column name */
  Teoth = 'TEOTH',
  /** column name */
  Tetot = 'TETOT',
  /** column name */
  Tgcar = 'TGCAR',
  /** column name */
  Tggst = 'TGGST',
  /** column name */
  Tghsp = 'TGHSP',
  /** column name */
  Tgint = 'TGINT',
  /** column name */
  Tgmer = 'TGMER',
  /** column name */
  Tgob = 'TGOB',
  /** column name */
  Tgoth = 'TGOTH',
  /** column name */
  Tgtot = 'TGTOT',
  /** column name */
  Tpcar = 'TPCAR',
  /** column name */
  Tpgst = 'TPGST',
  /** column name */
  Tphsp = 'TPHSP',
  /** column name */
  Tpint = 'TPINT',
  /** column name */
  Tpmer = 'TPMER',
  /** column name */
  Tpob = 'TPOB',
  /** column name */
  Tpoth = 'TPOTH',
  /** column name */
  Tprtot = 'TPRTOT',
  /** column name */
  Vidvz = 'VIDVZ',
  /** column name */
  Vpsrv = 'VPSRV'
}

export type As20Util2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As20Util2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As20Util2_Set_Input>;
  /** filter the rows which have to be updated */
  where: As20Util2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As20Util2_Var_Pop_Fields = {
  __typename?: 'AS20UTIL2_var_pop_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As20Util2_Var_Samp_Fields = {
  __typename?: 'AS20UTIL2_var_samp_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As20Util2_Variance_Fields = {
  __typename?: 'AS20UTIL2_variance_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SALPOC: Maybe<Scalars['Float']>;
  SALPOF: Maybe<Scalars['Float']>;
  SAMOC: Maybe<Scalars['Float']>;
  SAMOF: Maybe<Scalars['Float']>;
  SATOC: Maybe<Scalars['Float']>;
  SATOF: Maybe<Scalars['Float']>;
  SBLDOC: Maybe<Scalars['Float']>;
  SBLDOF: Maybe<Scalars['Float']>;
  SCAROC: Maybe<Scalars['Float']>;
  SCAROF: Maybe<Scalars['Float']>;
  SDIGOC: Maybe<Scalars['Float']>;
  SDIGOF: Maybe<Scalars['Float']>;
  SENDOC: Maybe<Scalars['Float']>;
  SENDOF: Maybe<Scalars['Float']>;
  SENTOC: Maybe<Scalars['Float']>;
  SENTOF: Maybe<Scalars['Float']>;
  SGENOC: Maybe<Scalars['Float']>;
  SGENOF: Maybe<Scalars['Float']>;
  SGIOC: Maybe<Scalars['Float']>;
  SGIOF: Maybe<Scalars['Float']>;
  SGYNOC: Maybe<Scalars['Float']>;
  SGYNOF: Maybe<Scalars['Float']>;
  SLABOC: Maybe<Scalars['Float']>;
  SLABOF: Maybe<Scalars['Float']>;
  SMINOC: Maybe<Scalars['Float']>;
  SMINOF: Maybe<Scalars['Float']>;
  SMRIOC: Maybe<Scalars['Float']>;
  SMRIOF: Maybe<Scalars['Float']>;
  SMUSOC: Maybe<Scalars['Float']>;
  SMUSOF: Maybe<Scalars['Float']>;
  SNRVOC: Maybe<Scalars['Float']>;
  SNRVOF: Maybe<Scalars['Float']>;
  SONCOC: Maybe<Scalars['Float']>;
  SONCOF: Maybe<Scalars['Float']>;
  SOPHOC: Maybe<Scalars['Float']>;
  SOPHOF: Maybe<Scalars['Float']>;
  SPAHOC: Maybe<Scalars['Float']>;
  SPAHOF: Maybe<Scalars['Float']>;
  SPCOC: Maybe<Scalars['Float']>;
  SPCOF: Maybe<Scalars['Float']>;
  SPSYOC: Maybe<Scalars['Float']>;
  SPSYOF: Maybe<Scalars['Float']>;
  SRADOC: Maybe<Scalars['Float']>;
  SRADOF: Maybe<Scalars['Float']>;
  SRHBOC: Maybe<Scalars['Float']>;
  SRHBOF: Maybe<Scalars['Float']>;
  SSNROC: Maybe<Scalars['Float']>;
  SSNROF: Maybe<Scalars['Float']>;
  SUCOC: Maybe<Scalars['Float']>;
  SUCOF: Maybe<Scalars['Float']>;
  SUROOC: Maybe<Scalars['Float']>;
  SUROOF: Maybe<Scalars['Float']>;
  SVASOC: Maybe<Scalars['Float']>;
  SVASOF: Maybe<Scalars['Float']>;
  SVRSOC: Maybe<Scalars['Float']>;
  SVRSOF: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS21DEM" */
export type As21Dem = {
  __typename?: 'AS21DEM';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDPY: Maybe<Scalars['String']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNDOTH: Maybe<Scalars['String']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FRTLN: Maybe<Scalars['float8']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINNP: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IINSPT: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPNP: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MEDNP: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCNP: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGNP: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  OTHINP: Maybe<Scalars['String']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  PHYGP: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  RESPTC: Maybe<Scalars['float8']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGPNP: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPAH: Maybe<Scalars['float8']>;
  SPLAN: Maybe<Scalars['String']>;
  SPTC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
  /** An object relationship */
  svc1: Maybe<As21Svc1>;
  /** An object relationship */
  svc2: Maybe<As21Svc2>;
  /** An object relationship */
  svc3: Maybe<As21Svc3>;
  /** An array relationship */
  units: Array<As21Unit>;
  /** An aggregate relationship */
  units_aggregate: As21Unit_Aggregate;
  /** An object relationship */
  util1: Maybe<As21Util>;
  /** An object relationship */
  util2: Maybe<As21Util2>;
};


/** columns and relationships of "AS21DEM" */
export type As21DemUnitsArgs = {
  distinct_on?: InputMaybe<Array<As21Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Unit_Order_By>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};


/** columns and relationships of "AS21DEM" */
export type As21DemUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Unit_Order_By>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};

/** aggregated selection of "AS21DEM" */
export type As21Dem_Aggregate = {
  __typename?: 'AS21DEM_aggregate';
  aggregate: Maybe<As21Dem_Aggregate_Fields>;
  nodes: Array<As21Dem>;
};

/** aggregate fields of "AS21DEM" */
export type As21Dem_Aggregate_Fields = {
  __typename?: 'AS21DEM_aggregate_fields';
  avg: Maybe<As21Dem_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As21Dem_Max_Fields>;
  min: Maybe<As21Dem_Min_Fields>;
  stddev: Maybe<As21Dem_Stddev_Fields>;
  stddev_pop: Maybe<As21Dem_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As21Dem_Stddev_Samp_Fields>;
  sum: Maybe<As21Dem_Sum_Fields>;
  var_pop: Maybe<As21Dem_Var_Pop_Fields>;
  var_samp: Maybe<As21Dem_Var_Samp_Fields>;
  variance: Maybe<As21Dem_Variance_Fields>;
};


/** aggregate fields of "AS21DEM" */
export type As21Dem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Dem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As21Dem_Avg_Fields = {
  __typename?: 'AS21DEM_avg_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS21DEM". All fields are combined with a logical 'AND'. */
export type As21Dem_Bool_Exp = {
  ACOCN?: InputMaybe<Float8_Comparison_Exp>;
  ACOORG?: InputMaybe<String_Comparison_Exp>;
  ACOPCT?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPAD?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPCI?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPMD?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPT?: InputMaybe<Float8_Comparison_Exp>;
  AHAMBR?: InputMaybe<String_Comparison_Exp>;
  AREA?: InputMaybe<String_Comparison_Exp>;
  BDPY?: InputMaybe<String_Comparison_Exp>;
  BNDPAY?: InputMaybe<String_Comparison_Exp>;
  BNDPCT?: InputMaybe<Float8_Comparison_Exp>;
  BNDRSK?: InputMaybe<String_Comparison_Exp>;
  BSC?: InputMaybe<String_Comparison_Exp>;
  CAPCON94?: InputMaybe<String_Comparison_Exp>;
  CAPRSK?: InputMaybe<Float8_Comparison_Exp>;
  CBSACODE?: InputMaybe<String_Comparison_Exp>;
  CBSANAME?: InputMaybe<String_Comparison_Exp>;
  CBSATYPE?: InputMaybe<String_Comparison_Exp>;
  CHC?: InputMaybe<String_Comparison_Exp>;
  CITYRK?: InputMaybe<String_Comparison_Exp>;
  CLUSTER?: InputMaybe<Float8_Comparison_Exp>;
  CMRPAY?: InputMaybe<String_Comparison_Exp>;
  CNDOTH?: InputMaybe<String_Comparison_Exp>;
  CNDTYPCV?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPGI?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPHM?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPID?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPNG?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPON?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPOR?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPOS?: InputMaybe<Float8_Comparison_Exp>;
  CNDTYPPM?: InputMaybe<Float8_Comparison_Exp>;
  CNTRL?: InputMaybe<String_Comparison_Exp>;
  CNTYNAME?: InputMaybe<String_Comparison_Exp>;
  COHSP?: InputMaybe<String_Comparison_Exp>;
  COMMTY?: InputMaybe<String_Comparison_Exp>;
  COTYCAN?: InputMaybe<Float8_Comparison_Exp>;
  COTYCAR?: InputMaybe<Float8_Comparison_Exp>;
  COTYDESC?: InputMaybe<String_Comparison_Exp>;
  COTYORT?: InputMaybe<Float8_Comparison_Exp>;
  COTYOTH?: InputMaybe<Float8_Comparison_Exp>;
  COTYPED?: InputMaybe<Float8_Comparison_Exp>;
  COTYPSY?: InputMaybe<Float8_Comparison_Exp>;
  COTYSUR?: InputMaybe<Float8_Comparison_Exp>;
  CPPCT?: InputMaybe<Float8_Comparison_Exp>;
  CSACODE?: InputMaybe<String_Comparison_Exp>;
  CSANAME?: InputMaybe<String_Comparison_Exp>;
  DCOV?: InputMaybe<Float8_Comparison_Exp>;
  DIVCODE?: InputMaybe<String_Comparison_Exp>;
  DIVNAME?: InputMaybe<String_Comparison_Exp>;
  DTBEG?: InputMaybe<Timestamp_Comparison_Exp>;
  DTEND?: InputMaybe<Timestamp_Comparison_Exp>;
  FAMADV?: InputMaybe<String_Comparison_Exp>;
  FCNTYCD?: InputMaybe<String_Comparison_Exp>;
  FCOUNTY?: InputMaybe<String_Comparison_Exp>;
  FISYR?: InputMaybe<Timestamp_Comparison_Exp>;
  FNDBN?: InputMaybe<String_Comparison_Exp>;
  FRTLN?: InputMaybe<Float8_Comparison_Exp>;
  FSTCD?: InputMaybe<String_Comparison_Exp>;
  FYR?: InputMaybe<String_Comparison_Exp>;
  GPOCITY?: InputMaybe<String_Comparison_Exp>;
  GPONAME?: InputMaybe<String_Comparison_Exp>;
  GPOST?: InputMaybe<String_Comparison_Exp>;
  GROUP?: InputMaybe<String_Comparison_Exp>;
  HHPLAN?: InputMaybe<String_Comparison_Exp>;
  HLINDK?: InputMaybe<String_Comparison_Exp>;
  HLINHOS?: InputMaybe<String_Comparison_Exp>;
  HLINN?: InputMaybe<String_Comparison_Exp>;
  HLINNP?: InputMaybe<String_Comparison_Exp>;
  HLINSYS?: InputMaybe<String_Comparison_Exp>;
  HLINVEN?: InputMaybe<String_Comparison_Exp>;
  HRRCODE?: InputMaybe<Int_Comparison_Exp>;
  HRRNAME?: InputMaybe<String_Comparison_Exp>;
  HSACODE?: InputMaybe<Int_Comparison_Exp>;
  HSANAME?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IINSPT?: InputMaybe<String_Comparison_Exp>;
  LAT?: InputMaybe<String_Comparison_Exp>;
  LGRPDK?: InputMaybe<String_Comparison_Exp>;
  LGRPHOS?: InputMaybe<String_Comparison_Exp>;
  LGRPN?: InputMaybe<String_Comparison_Exp>;
  LGRPNP?: InputMaybe<String_Comparison_Exp>;
  LGRPSYS?: InputMaybe<String_Comparison_Exp>;
  LGRPVEN?: InputMaybe<String_Comparison_Exp>;
  LONG?: InputMaybe<String_Comparison_Exp>;
  LOS?: InputMaybe<String_Comparison_Exp>;
  LTCHC?: InputMaybe<String_Comparison_Exp>;
  LTCHF?: InputMaybe<String_Comparison_Exp>;
  LTCT?: InputMaybe<String_Comparison_Exp>;
  LTNM?: InputMaybe<String_Comparison_Exp>;
  LTST?: InputMaybe<String_Comparison_Exp>;
  MADMIN?: InputMaybe<String_Comparison_Exp>;
  MAPP1?: InputMaybe<String_Comparison_Exp>;
  MAPP2?: InputMaybe<String_Comparison_Exp>;
  MAPP3?: InputMaybe<String_Comparison_Exp>;
  MAPP5?: InputMaybe<String_Comparison_Exp>;
  MAPP7?: InputMaybe<String_Comparison_Exp>;
  MAPP8?: InputMaybe<String_Comparison_Exp>;
  MAPP10?: InputMaybe<String_Comparison_Exp>;
  MAPP11?: InputMaybe<String_Comparison_Exp>;
  MAPP16?: InputMaybe<String_Comparison_Exp>;
  MAPP18?: InputMaybe<String_Comparison_Exp>;
  MAPP19?: InputMaybe<String_Comparison_Exp>;
  MAPP20?: InputMaybe<String_Comparison_Exp>;
  MAPP21?: InputMaybe<String_Comparison_Exp>;
  MAPP22?: InputMaybe<String_Comparison_Exp>;
  MCNTYCD?: InputMaybe<String_Comparison_Exp>;
  MCRNUM?: InputMaybe<String_Comparison_Exp>;
  MEDADDK?: InputMaybe<String_Comparison_Exp>;
  MEDADHOS?: InputMaybe<String_Comparison_Exp>;
  MEDADN?: InputMaybe<String_Comparison_Exp>;
  MEDADSYS?: InputMaybe<String_Comparison_Exp>;
  MEDADVEN?: InputMaybe<String_Comparison_Exp>;
  MEDHME?: InputMaybe<String_Comparison_Exp>;
  MEDHSE?: InputMaybe<String_Comparison_Exp>;
  MEDNP?: InputMaybe<String_Comparison_Exp>;
  MHSMEMB?: InputMaybe<String_Comparison_Exp>;
  MLOCADDR?: InputMaybe<String_Comparison_Exp>;
  MLOCCITY?: InputMaybe<String_Comparison_Exp>;
  MLOCSTCD?: InputMaybe<String_Comparison_Exp>;
  MLOCZIP?: InputMaybe<String_Comparison_Exp>;
  MMCDK?: InputMaybe<String_Comparison_Exp>;
  MMCHOS?: InputMaybe<String_Comparison_Exp>;
  MMCN?: InputMaybe<String_Comparison_Exp>;
  MMCNP?: InputMaybe<String_Comparison_Exp>;
  MMCSYS?: InputMaybe<String_Comparison_Exp>;
  MMCVEN?: InputMaybe<String_Comparison_Exp>;
  MNAME?: InputMaybe<String_Comparison_Exp>;
  MNGT?: InputMaybe<String_Comparison_Exp>;
  MNGTCITY?: InputMaybe<String_Comparison_Exp>;
  MNGTNAME?: InputMaybe<String_Comparison_Exp>;
  MNGTSTCD?: InputMaybe<String_Comparison_Exp>;
  MSSP?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBA?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBB?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBC?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBD?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBE?: InputMaybe<Float8_Comparison_Exp>;
  MSSPCE?: InputMaybe<Float8_Comparison_Exp>;
  MSSPTRK?: InputMaybe<Float8_Comparison_Exp>;
  MSTATE?: InputMaybe<String_Comparison_Exp>;
  OSMGDK?: InputMaybe<String_Comparison_Exp>;
  OSMGHOS?: InputMaybe<String_Comparison_Exp>;
  OSMGN?: InputMaybe<String_Comparison_Exp>;
  OSMGNP?: InputMaybe<String_Comparison_Exp>;
  OSMGOTH?: InputMaybe<String_Comparison_Exp>;
  OSMGSYS?: InputMaybe<String_Comparison_Exp>;
  OSMGVEN?: InputMaybe<String_Comparison_Exp>;
  OTHIMDK?: InputMaybe<String_Comparison_Exp>;
  OTHIMHOS?: InputMaybe<String_Comparison_Exp>;
  OTHIMN?: InputMaybe<String_Comparison_Exp>;
  OTHIMSYS?: InputMaybe<String_Comparison_Exp>;
  OTHIMVEN?: InputMaybe<String_Comparison_Exp>;
  OTHINP?: InputMaybe<String_Comparison_Exp>;
  PAYTYAD?: InputMaybe<Float8_Comparison_Exp>;
  PAYTYPCI?: InputMaybe<Float8_Comparison_Exp>;
  PAYTYPMD?: InputMaybe<Float8_Comparison_Exp>;
  PAYTYPTM?: InputMaybe<Float8_Comparison_Exp>;
  PHYGP?: InputMaybe<String_Comparison_Exp>;
  RADMCHI?: InputMaybe<String_Comparison_Exp>;
  RESP?: InputMaybe<String_Comparison_Exp>;
  RESPTC?: InputMaybe<Float8_Comparison_Exp>;
  SERV?: InputMaybe<String_Comparison_Exp>;
  SERVOTH?: InputMaybe<String_Comparison_Exp>;
  SLFPLN?: InputMaybe<String_Comparison_Exp>;
  SMGPDK?: InputMaybe<String_Comparison_Exp>;
  SMGPNP?: InputMaybe<String_Comparison_Exp>;
  SMGRPHOS?: InputMaybe<String_Comparison_Exp>;
  SMGRPN?: InputMaybe<String_Comparison_Exp>;
  SMGRPSYS?: InputMaybe<String_Comparison_Exp>;
  SMGRPVEN?: InputMaybe<String_Comparison_Exp>;
  SPAH?: InputMaybe<Float8_Comparison_Exp>;
  SPLAN?: InputMaybe<String_Comparison_Exp>;
  SPTC?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUBS?: InputMaybe<String_Comparison_Exp>;
  SUNITS?: InputMaybe<String_Comparison_Exp>;
  SUPLY?: InputMaybe<String_Comparison_Exp>;
  SUPNM?: InputMaybe<String_Comparison_Exp>;
  SYSADDR?: InputMaybe<String_Comparison_Exp>;
  SYSAREA?: InputMaybe<String_Comparison_Exp>;
  SYSCITY?: InputMaybe<String_Comparison_Exp>;
  SYSID?: InputMaybe<String_Comparison_Exp>;
  SYSNAME?: InputMaybe<String_Comparison_Exp>;
  SYSST?: InputMaybe<String_Comparison_Exp>;
  SYSTELN?: InputMaybe<String_Comparison_Exp>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<String_Comparison_Exp>;
  SYSTITLE?: InputMaybe<String_Comparison_Exp>;
  SYSZIP?: InputMaybe<String_Comparison_Exp>;
  TELNO?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Dem_Bool_Exp>>;
  _not?: InputMaybe<As21Dem_Bool_Exp>;
  _or?: InputMaybe<Array<As21Dem_Bool_Exp>>;
  svc1?: InputMaybe<As21Svc1_Bool_Exp>;
  svc2?: InputMaybe<As21Svc2_Bool_Exp>;
  svc3?: InputMaybe<As21Svc3_Bool_Exp>;
  units?: InputMaybe<As21Unit_Bool_Exp>;
  units_aggregate?: InputMaybe<As21Unit_Aggregate_Bool_Exp>;
  util1?: InputMaybe<As21Util_Bool_Exp>;
  util2?: InputMaybe<As21Util2_Bool_Exp>;
};

/** unique or primary key constraints on table "AS21DEM" */
export enum As21Dem_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Dem = 'pk_AS21DEM'
}

/** input type for incrementing numeric columns in table "AS21DEM" */
export type As21Dem_Inc_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPTC?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS21DEM" */
export type As21Dem_Insert_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDPY?: InputMaybe<Scalars['String']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNDOTH?: InputMaybe<Scalars['String']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINNP?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPNP?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MEDNP?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCNP?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGNP?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  OTHINP?: InputMaybe<Scalars['String']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGPNP?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  SPTC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
  svc1?: InputMaybe<As21Svc1_Obj_Rel_Insert_Input>;
  svc2?: InputMaybe<As21Svc2_Obj_Rel_Insert_Input>;
  svc3?: InputMaybe<As21Svc3_Obj_Rel_Insert_Input>;
  units?: InputMaybe<As21Unit_Arr_Rel_Insert_Input>;
  util1?: InputMaybe<As21Util_Obj_Rel_Insert_Input>;
  util2?: InputMaybe<As21Util2_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type As21Dem_Max_Fields = {
  __typename?: 'AS21DEM_max_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDPY: Maybe<Scalars['String']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNDOTH: Maybe<Scalars['String']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FRTLN: Maybe<Scalars['float8']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINNP: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IINSPT: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPNP: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MEDNP: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCNP: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGNP: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  OTHINP: Maybe<Scalars['String']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  PHYGP: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  RESPTC: Maybe<Scalars['float8']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGPNP: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPAH: Maybe<Scalars['float8']>;
  SPLAN: Maybe<Scalars['String']>;
  SPTC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As21Dem_Min_Fields = {
  __typename?: 'AS21DEM_min_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDPY: Maybe<Scalars['String']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNDOTH: Maybe<Scalars['String']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FRTLN: Maybe<Scalars['float8']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINNP: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IINSPT: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPNP: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MEDNP: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCNP: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGNP: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  OTHINP: Maybe<Scalars['String']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  PHYGP: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  RESPTC: Maybe<Scalars['float8']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGPNP: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPAH: Maybe<Scalars['float8']>;
  SPLAN: Maybe<Scalars['String']>;
  SPTC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS21DEM" */
export type As21Dem_Mutation_Response = {
  __typename?: 'AS21DEM_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Dem>;
};

/** input type for inserting object relation for remote table "AS21DEM" */
export type As21Dem_Obj_Rel_Insert_Input = {
  data: As21Dem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Dem_On_Conflict>;
};

/** on_conflict condition type for table "AS21DEM" */
export type As21Dem_On_Conflict = {
  constraint: As21Dem_Constraint;
  update_columns?: Array<As21Dem_Update_Column>;
  where?: InputMaybe<As21Dem_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21DEM". */
export type As21Dem_Order_By = {
  ACOCN?: InputMaybe<Order_By>;
  ACOORG?: InputMaybe<Order_By>;
  ACOPCT?: InputMaybe<Order_By>;
  ACOTYPAD?: InputMaybe<Order_By>;
  ACOTYPCI?: InputMaybe<Order_By>;
  ACOTYPMD?: InputMaybe<Order_By>;
  ACOTYPT?: InputMaybe<Order_By>;
  AHAMBR?: InputMaybe<Order_By>;
  AREA?: InputMaybe<Order_By>;
  BDPY?: InputMaybe<Order_By>;
  BNDPAY?: InputMaybe<Order_By>;
  BNDPCT?: InputMaybe<Order_By>;
  BNDRSK?: InputMaybe<Order_By>;
  BSC?: InputMaybe<Order_By>;
  CAPCON94?: InputMaybe<Order_By>;
  CAPRSK?: InputMaybe<Order_By>;
  CBSACODE?: InputMaybe<Order_By>;
  CBSANAME?: InputMaybe<Order_By>;
  CBSATYPE?: InputMaybe<Order_By>;
  CHC?: InputMaybe<Order_By>;
  CITYRK?: InputMaybe<Order_By>;
  CLUSTER?: InputMaybe<Order_By>;
  CMRPAY?: InputMaybe<Order_By>;
  CNDOTH?: InputMaybe<Order_By>;
  CNDTYPCV?: InputMaybe<Order_By>;
  CNDTYPGI?: InputMaybe<Order_By>;
  CNDTYPHM?: InputMaybe<Order_By>;
  CNDTYPID?: InputMaybe<Order_By>;
  CNDTYPNG?: InputMaybe<Order_By>;
  CNDTYPON?: InputMaybe<Order_By>;
  CNDTYPOR?: InputMaybe<Order_By>;
  CNDTYPOS?: InputMaybe<Order_By>;
  CNDTYPPM?: InputMaybe<Order_By>;
  CNTRL?: InputMaybe<Order_By>;
  CNTYNAME?: InputMaybe<Order_By>;
  COHSP?: InputMaybe<Order_By>;
  COMMTY?: InputMaybe<Order_By>;
  COTYCAN?: InputMaybe<Order_By>;
  COTYCAR?: InputMaybe<Order_By>;
  COTYDESC?: InputMaybe<Order_By>;
  COTYORT?: InputMaybe<Order_By>;
  COTYOTH?: InputMaybe<Order_By>;
  COTYPED?: InputMaybe<Order_By>;
  COTYPSY?: InputMaybe<Order_By>;
  COTYSUR?: InputMaybe<Order_By>;
  CPPCT?: InputMaybe<Order_By>;
  CSACODE?: InputMaybe<Order_By>;
  CSANAME?: InputMaybe<Order_By>;
  DCOV?: InputMaybe<Order_By>;
  DIVCODE?: InputMaybe<Order_By>;
  DIVNAME?: InputMaybe<Order_By>;
  DTBEG?: InputMaybe<Order_By>;
  DTEND?: InputMaybe<Order_By>;
  FAMADV?: InputMaybe<Order_By>;
  FCNTYCD?: InputMaybe<Order_By>;
  FCOUNTY?: InputMaybe<Order_By>;
  FISYR?: InputMaybe<Order_By>;
  FNDBN?: InputMaybe<Order_By>;
  FRTLN?: InputMaybe<Order_By>;
  FSTCD?: InputMaybe<Order_By>;
  FYR?: InputMaybe<Order_By>;
  GPOCITY?: InputMaybe<Order_By>;
  GPONAME?: InputMaybe<Order_By>;
  GPOST?: InputMaybe<Order_By>;
  GROUP?: InputMaybe<Order_By>;
  HHPLAN?: InputMaybe<Order_By>;
  HLINDK?: InputMaybe<Order_By>;
  HLINHOS?: InputMaybe<Order_By>;
  HLINN?: InputMaybe<Order_By>;
  HLINNP?: InputMaybe<Order_By>;
  HLINSYS?: InputMaybe<Order_By>;
  HLINVEN?: InputMaybe<Order_By>;
  HRRCODE?: InputMaybe<Order_By>;
  HRRNAME?: InputMaybe<Order_By>;
  HSACODE?: InputMaybe<Order_By>;
  HSANAME?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IINSPT?: InputMaybe<Order_By>;
  LAT?: InputMaybe<Order_By>;
  LGRPDK?: InputMaybe<Order_By>;
  LGRPHOS?: InputMaybe<Order_By>;
  LGRPN?: InputMaybe<Order_By>;
  LGRPNP?: InputMaybe<Order_By>;
  LGRPSYS?: InputMaybe<Order_By>;
  LGRPVEN?: InputMaybe<Order_By>;
  LONG?: InputMaybe<Order_By>;
  LOS?: InputMaybe<Order_By>;
  LTCHC?: InputMaybe<Order_By>;
  LTCHF?: InputMaybe<Order_By>;
  LTCT?: InputMaybe<Order_By>;
  LTNM?: InputMaybe<Order_By>;
  LTST?: InputMaybe<Order_By>;
  MADMIN?: InputMaybe<Order_By>;
  MAPP1?: InputMaybe<Order_By>;
  MAPP2?: InputMaybe<Order_By>;
  MAPP3?: InputMaybe<Order_By>;
  MAPP5?: InputMaybe<Order_By>;
  MAPP7?: InputMaybe<Order_By>;
  MAPP8?: InputMaybe<Order_By>;
  MAPP10?: InputMaybe<Order_By>;
  MAPP11?: InputMaybe<Order_By>;
  MAPP16?: InputMaybe<Order_By>;
  MAPP18?: InputMaybe<Order_By>;
  MAPP19?: InputMaybe<Order_By>;
  MAPP20?: InputMaybe<Order_By>;
  MAPP21?: InputMaybe<Order_By>;
  MAPP22?: InputMaybe<Order_By>;
  MCNTYCD?: InputMaybe<Order_By>;
  MCRNUM?: InputMaybe<Order_By>;
  MEDADDK?: InputMaybe<Order_By>;
  MEDADHOS?: InputMaybe<Order_By>;
  MEDADN?: InputMaybe<Order_By>;
  MEDADSYS?: InputMaybe<Order_By>;
  MEDADVEN?: InputMaybe<Order_By>;
  MEDHME?: InputMaybe<Order_By>;
  MEDHSE?: InputMaybe<Order_By>;
  MEDNP?: InputMaybe<Order_By>;
  MHSMEMB?: InputMaybe<Order_By>;
  MLOCADDR?: InputMaybe<Order_By>;
  MLOCCITY?: InputMaybe<Order_By>;
  MLOCSTCD?: InputMaybe<Order_By>;
  MLOCZIP?: InputMaybe<Order_By>;
  MMCDK?: InputMaybe<Order_By>;
  MMCHOS?: InputMaybe<Order_By>;
  MMCN?: InputMaybe<Order_By>;
  MMCNP?: InputMaybe<Order_By>;
  MMCSYS?: InputMaybe<Order_By>;
  MMCVEN?: InputMaybe<Order_By>;
  MNAME?: InputMaybe<Order_By>;
  MNGT?: InputMaybe<Order_By>;
  MNGTCITY?: InputMaybe<Order_By>;
  MNGTNAME?: InputMaybe<Order_By>;
  MNGTSTCD?: InputMaybe<Order_By>;
  MSSP?: InputMaybe<Order_By>;
  MSSPBA?: InputMaybe<Order_By>;
  MSSPBB?: InputMaybe<Order_By>;
  MSSPBC?: InputMaybe<Order_By>;
  MSSPBD?: InputMaybe<Order_By>;
  MSSPBE?: InputMaybe<Order_By>;
  MSSPCE?: InputMaybe<Order_By>;
  MSSPTRK?: InputMaybe<Order_By>;
  MSTATE?: InputMaybe<Order_By>;
  OSMGDK?: InputMaybe<Order_By>;
  OSMGHOS?: InputMaybe<Order_By>;
  OSMGN?: InputMaybe<Order_By>;
  OSMGNP?: InputMaybe<Order_By>;
  OSMGOTH?: InputMaybe<Order_By>;
  OSMGSYS?: InputMaybe<Order_By>;
  OSMGVEN?: InputMaybe<Order_By>;
  OTHIMDK?: InputMaybe<Order_By>;
  OTHIMHOS?: InputMaybe<Order_By>;
  OTHIMN?: InputMaybe<Order_By>;
  OTHIMSYS?: InputMaybe<Order_By>;
  OTHIMVEN?: InputMaybe<Order_By>;
  OTHINP?: InputMaybe<Order_By>;
  PAYTYAD?: InputMaybe<Order_By>;
  PAYTYPCI?: InputMaybe<Order_By>;
  PAYTYPMD?: InputMaybe<Order_By>;
  PAYTYPTM?: InputMaybe<Order_By>;
  PHYGP?: InputMaybe<Order_By>;
  RADMCHI?: InputMaybe<Order_By>;
  RESP?: InputMaybe<Order_By>;
  RESPTC?: InputMaybe<Order_By>;
  SERV?: InputMaybe<Order_By>;
  SERVOTH?: InputMaybe<Order_By>;
  SLFPLN?: InputMaybe<Order_By>;
  SMGPDK?: InputMaybe<Order_By>;
  SMGPNP?: InputMaybe<Order_By>;
  SMGRPHOS?: InputMaybe<Order_By>;
  SMGRPN?: InputMaybe<Order_By>;
  SMGRPSYS?: InputMaybe<Order_By>;
  SMGRPVEN?: InputMaybe<Order_By>;
  SPAH?: InputMaybe<Order_By>;
  SPLAN?: InputMaybe<Order_By>;
  SPTC?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUBS?: InputMaybe<Order_By>;
  SUNITS?: InputMaybe<Order_By>;
  SUPLY?: InputMaybe<Order_By>;
  SUPNM?: InputMaybe<Order_By>;
  SYSADDR?: InputMaybe<Order_By>;
  SYSAREA?: InputMaybe<Order_By>;
  SYSCITY?: InputMaybe<Order_By>;
  SYSID?: InputMaybe<Order_By>;
  SYSNAME?: InputMaybe<Order_By>;
  SYSST?: InputMaybe<Order_By>;
  SYSTELN?: InputMaybe<Order_By>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Order_By>;
  SYSTITLE?: InputMaybe<Order_By>;
  SYSZIP?: InputMaybe<Order_By>;
  TELNO?: InputMaybe<Order_By>;
  svc1?: InputMaybe<As21Svc1_Order_By>;
  svc2?: InputMaybe<As21Svc2_Order_By>;
  svc3?: InputMaybe<As21Svc3_Order_By>;
  units_aggregate?: InputMaybe<As21Unit_Aggregate_Order_By>;
  util1?: InputMaybe<As21Util_Order_By>;
  util2?: InputMaybe<As21Util2_Order_By>;
};

/** primary key columns input for table: AS21DEM */
export type As21Dem_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21DEM" */
export enum As21Dem_Select_Column {
  /** column name */
  Acocn = 'ACOCN',
  /** column name */
  Acoorg = 'ACOORG',
  /** column name */
  Acopct = 'ACOPCT',
  /** column name */
  Acotypad = 'ACOTYPAD',
  /** column name */
  Acotypci = 'ACOTYPCI',
  /** column name */
  Acotypmd = 'ACOTYPMD',
  /** column name */
  Acotypt = 'ACOTYPT',
  /** column name */
  Ahambr = 'AHAMBR',
  /** column name */
  Area = 'AREA',
  /** column name */
  Bdpy = 'BDPY',
  /** column name */
  Bndpay = 'BNDPAY',
  /** column name */
  Bndpct = 'BNDPCT',
  /** column name */
  Bndrsk = 'BNDRSK',
  /** column name */
  Bsc = 'BSC',
  /** column name */
  Capcon94 = 'CAPCON94',
  /** column name */
  Caprsk = 'CAPRSK',
  /** column name */
  Cbsacode = 'CBSACODE',
  /** column name */
  Cbsaname = 'CBSANAME',
  /** column name */
  Cbsatype = 'CBSATYPE',
  /** column name */
  Chc = 'CHC',
  /** column name */
  Cityrk = 'CITYRK',
  /** column name */
  Cluster = 'CLUSTER',
  /** column name */
  Cmrpay = 'CMRPAY',
  /** column name */
  Cndoth = 'CNDOTH',
  /** column name */
  Cndtypcv = 'CNDTYPCV',
  /** column name */
  Cndtypgi = 'CNDTYPGI',
  /** column name */
  Cndtyphm = 'CNDTYPHM',
  /** column name */
  Cndtypid = 'CNDTYPID',
  /** column name */
  Cndtypng = 'CNDTYPNG',
  /** column name */
  Cndtypon = 'CNDTYPON',
  /** column name */
  Cndtypor = 'CNDTYPOR',
  /** column name */
  Cndtypos = 'CNDTYPOS',
  /** column name */
  Cndtyppm = 'CNDTYPPM',
  /** column name */
  Cntrl = 'CNTRL',
  /** column name */
  Cntyname = 'CNTYNAME',
  /** column name */
  Cohsp = 'COHSP',
  /** column name */
  Commty = 'COMMTY',
  /** column name */
  Cotycan = 'COTYCAN',
  /** column name */
  Cotycar = 'COTYCAR',
  /** column name */
  Cotydesc = 'COTYDESC',
  /** column name */
  Cotyort = 'COTYORT',
  /** column name */
  Cotyoth = 'COTYOTH',
  /** column name */
  Cotyped = 'COTYPED',
  /** column name */
  Cotypsy = 'COTYPSY',
  /** column name */
  Cotysur = 'COTYSUR',
  /** column name */
  Cppct = 'CPPCT',
  /** column name */
  Csacode = 'CSACODE',
  /** column name */
  Csaname = 'CSANAME',
  /** column name */
  Dcov = 'DCOV',
  /** column name */
  Divcode = 'DIVCODE',
  /** column name */
  Divname = 'DIVNAME',
  /** column name */
  Dtbeg = 'DTBEG',
  /** column name */
  Dtend = 'DTEND',
  /** column name */
  Famadv = 'FAMADV',
  /** column name */
  Fcntycd = 'FCNTYCD',
  /** column name */
  Fcounty = 'FCOUNTY',
  /** column name */
  Fisyr = 'FISYR',
  /** column name */
  Fndbn = 'FNDBN',
  /** column name */
  Frtln = 'FRTLN',
  /** column name */
  Fstcd = 'FSTCD',
  /** column name */
  Fyr = 'FYR',
  /** column name */
  Gpocity = 'GPOCITY',
  /** column name */
  Gponame = 'GPONAME',
  /** column name */
  Gpost = 'GPOST',
  /** column name */
  Group = 'GROUP',
  /** column name */
  Hhplan = 'HHPLAN',
  /** column name */
  Hlindk = 'HLINDK',
  /** column name */
  Hlinhos = 'HLINHOS',
  /** column name */
  Hlinn = 'HLINN',
  /** column name */
  Hlinnp = 'HLINNP',
  /** column name */
  Hlinsys = 'HLINSYS',
  /** column name */
  Hlinven = 'HLINVEN',
  /** column name */
  Hrrcode = 'HRRCODE',
  /** column name */
  Hrrname = 'HRRNAME',
  /** column name */
  Hsacode = 'HSACODE',
  /** column name */
  Hsaname = 'HSANAME',
  /** column name */
  Id = 'ID',
  /** column name */
  Iinspt = 'IINSPT',
  /** column name */
  Lat = 'LAT',
  /** column name */
  Lgrpdk = 'LGRPDK',
  /** column name */
  Lgrphos = 'LGRPHOS',
  /** column name */
  Lgrpn = 'LGRPN',
  /** column name */
  Lgrpnp = 'LGRPNP',
  /** column name */
  Lgrpsys = 'LGRPSYS',
  /** column name */
  Lgrpven = 'LGRPVEN',
  /** column name */
  Long = 'LONG',
  /** column name */
  Los = 'LOS',
  /** column name */
  Ltchc = 'LTCHC',
  /** column name */
  Ltchf = 'LTCHF',
  /** column name */
  Ltct = 'LTCT',
  /** column name */
  Ltnm = 'LTNM',
  /** column name */
  Ltst = 'LTST',
  /** column name */
  Madmin = 'MADMIN',
  /** column name */
  Mapp1 = 'MAPP1',
  /** column name */
  Mapp2 = 'MAPP2',
  /** column name */
  Mapp3 = 'MAPP3',
  /** column name */
  Mapp5 = 'MAPP5',
  /** column name */
  Mapp7 = 'MAPP7',
  /** column name */
  Mapp8 = 'MAPP8',
  /** column name */
  Mapp10 = 'MAPP10',
  /** column name */
  Mapp11 = 'MAPP11',
  /** column name */
  Mapp16 = 'MAPP16',
  /** column name */
  Mapp18 = 'MAPP18',
  /** column name */
  Mapp19 = 'MAPP19',
  /** column name */
  Mapp20 = 'MAPP20',
  /** column name */
  Mapp21 = 'MAPP21',
  /** column name */
  Mapp22 = 'MAPP22',
  /** column name */
  Mcntycd = 'MCNTYCD',
  /** column name */
  Mcrnum = 'MCRNUM',
  /** column name */
  Medaddk = 'MEDADDK',
  /** column name */
  Medadhos = 'MEDADHOS',
  /** column name */
  Medadn = 'MEDADN',
  /** column name */
  Medadsys = 'MEDADSYS',
  /** column name */
  Medadven = 'MEDADVEN',
  /** column name */
  Medhme = 'MEDHME',
  /** column name */
  Medhse = 'MEDHSE',
  /** column name */
  Mednp = 'MEDNP',
  /** column name */
  Mhsmemb = 'MHSMEMB',
  /** column name */
  Mlocaddr = 'MLOCADDR',
  /** column name */
  Mloccity = 'MLOCCITY',
  /** column name */
  Mlocstcd = 'MLOCSTCD',
  /** column name */
  Mloczip = 'MLOCZIP',
  /** column name */
  Mmcdk = 'MMCDK',
  /** column name */
  Mmchos = 'MMCHOS',
  /** column name */
  Mmcn = 'MMCN',
  /** column name */
  Mmcnp = 'MMCNP',
  /** column name */
  Mmcsys = 'MMCSYS',
  /** column name */
  Mmcven = 'MMCVEN',
  /** column name */
  Mname = 'MNAME',
  /** column name */
  Mngt = 'MNGT',
  /** column name */
  Mngtcity = 'MNGTCITY',
  /** column name */
  Mngtname = 'MNGTNAME',
  /** column name */
  Mngtstcd = 'MNGTSTCD',
  /** column name */
  Mssp = 'MSSP',
  /** column name */
  Msspba = 'MSSPBA',
  /** column name */
  Msspbb = 'MSSPBB',
  /** column name */
  Msspbc = 'MSSPBC',
  /** column name */
  Msspbd = 'MSSPBD',
  /** column name */
  Msspbe = 'MSSPBE',
  /** column name */
  Msspce = 'MSSPCE',
  /** column name */
  Mssptrk = 'MSSPTRK',
  /** column name */
  Mstate = 'MSTATE',
  /** column name */
  Osmgdk = 'OSMGDK',
  /** column name */
  Osmghos = 'OSMGHOS',
  /** column name */
  Osmgn = 'OSMGN',
  /** column name */
  Osmgnp = 'OSMGNP',
  /** column name */
  Osmgoth = 'OSMGOTH',
  /** column name */
  Osmgsys = 'OSMGSYS',
  /** column name */
  Osmgven = 'OSMGVEN',
  /** column name */
  Othimdk = 'OTHIMDK',
  /** column name */
  Othimhos = 'OTHIMHOS',
  /** column name */
  Othimn = 'OTHIMN',
  /** column name */
  Othimsys = 'OTHIMSYS',
  /** column name */
  Othimven = 'OTHIMVEN',
  /** column name */
  Othinp = 'OTHINP',
  /** column name */
  Paytyad = 'PAYTYAD',
  /** column name */
  Paytypci = 'PAYTYPCI',
  /** column name */
  Paytypmd = 'PAYTYPMD',
  /** column name */
  Paytyptm = 'PAYTYPTM',
  /** column name */
  Phygp = 'PHYGP',
  /** column name */
  Radmchi = 'RADMCHI',
  /** column name */
  Resp = 'RESP',
  /** column name */
  Resptc = 'RESPTC',
  /** column name */
  Serv = 'SERV',
  /** column name */
  Servoth = 'SERVOTH',
  /** column name */
  Slfpln = 'SLFPLN',
  /** column name */
  Smgpdk = 'SMGPDK',
  /** column name */
  Smgpnp = 'SMGPNP',
  /** column name */
  Smgrphos = 'SMGRPHOS',
  /** column name */
  Smgrpn = 'SMGRPN',
  /** column name */
  Smgrpsys = 'SMGRPSYS',
  /** column name */
  Smgrpven = 'SMGRPVEN',
  /** column name */
  Spah = 'SPAH',
  /** column name */
  Splan = 'SPLAN',
  /** column name */
  Sptc = 'SPTC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Subs = 'SUBS',
  /** column name */
  Sunits = 'SUNITS',
  /** column name */
  Suply = 'SUPLY',
  /** column name */
  Supnm = 'SUPNM',
  /** column name */
  Sysaddr = 'SYSADDR',
  /** column name */
  Sysarea = 'SYSAREA',
  /** column name */
  Syscity = 'SYSCITY',
  /** column name */
  Sysid = 'SYSID',
  /** column name */
  Sysname = 'SYSNAME',
  /** column name */
  Sysst = 'SYSST',
  /** column name */
  Systeln = 'SYSTELN',
  /** column name */
  SystemPrimaryContact = 'SYSTEM_PRIMARY_CONTACT',
  /** column name */
  Systitle = 'SYSTITLE',
  /** column name */
  Syszip = 'SYSZIP',
  /** column name */
  Telno = 'TELNO'
}

/** input type for updating data in table "AS21DEM" */
export type As21Dem_Set_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDPY?: InputMaybe<Scalars['String']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNDOTH?: InputMaybe<Scalars['String']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINNP?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPNP?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MEDNP?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCNP?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGNP?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  OTHINP?: InputMaybe<Scalars['String']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGPNP?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  SPTC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As21Dem_Stddev_Fields = {
  __typename?: 'AS21DEM_stddev_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As21Dem_Stddev_Pop_Fields = {
  __typename?: 'AS21DEM_stddev_pop_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As21Dem_Stddev_Samp_Fields = {
  __typename?: 'AS21DEM_stddev_samp_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS21DEM" */
export type As21Dem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Dem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Dem_Stream_Cursor_Value_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDPY?: InputMaybe<Scalars['String']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNDOTH?: InputMaybe<Scalars['String']>;
  CNDTYPCV?: InputMaybe<Scalars['float8']>;
  CNDTYPGI?: InputMaybe<Scalars['float8']>;
  CNDTYPHM?: InputMaybe<Scalars['float8']>;
  CNDTYPID?: InputMaybe<Scalars['float8']>;
  CNDTYPNG?: InputMaybe<Scalars['float8']>;
  CNDTYPON?: InputMaybe<Scalars['float8']>;
  CNDTYPOR?: InputMaybe<Scalars['float8']>;
  CNDTYPOS?: InputMaybe<Scalars['float8']>;
  CNDTYPPM?: InputMaybe<Scalars['float8']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINNP?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPNP?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MEDNP?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCNP?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGNP?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  OTHINP?: InputMaybe<Scalars['String']>;
  PAYTYAD?: InputMaybe<Scalars['float8']>;
  PAYTYPCI?: InputMaybe<Scalars['float8']>;
  PAYTYPMD?: InputMaybe<Scalars['float8']>;
  PAYTYPTM?: InputMaybe<Scalars['float8']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGPNP?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  SPTC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As21Dem_Sum_Fields = {
  __typename?: 'AS21DEM_sum_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  BNDPCT: Maybe<Scalars['float8']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CNDTYPCV: Maybe<Scalars['float8']>;
  CNDTYPGI: Maybe<Scalars['float8']>;
  CNDTYPHM: Maybe<Scalars['float8']>;
  CNDTYPID: Maybe<Scalars['float8']>;
  CNDTYPNG: Maybe<Scalars['float8']>;
  CNDTYPON: Maybe<Scalars['float8']>;
  CNDTYPOR: Maybe<Scalars['float8']>;
  CNDTYPOS: Maybe<Scalars['float8']>;
  CNDTYPPM: Maybe<Scalars['float8']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  DCOV: Maybe<Scalars['float8']>;
  FRTLN: Maybe<Scalars['float8']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HSACODE: Maybe<Scalars['Int']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  PAYTYAD: Maybe<Scalars['float8']>;
  PAYTYPCI: Maybe<Scalars['float8']>;
  PAYTYPMD: Maybe<Scalars['float8']>;
  PAYTYPTM: Maybe<Scalars['float8']>;
  RESPTC: Maybe<Scalars['float8']>;
  SPAH: Maybe<Scalars['float8']>;
  SPTC: Maybe<Scalars['float8']>;
};

/** update columns of table "AS21DEM" */
export enum As21Dem_Update_Column {
  /** column name */
  Acocn = 'ACOCN',
  /** column name */
  Acoorg = 'ACOORG',
  /** column name */
  Acopct = 'ACOPCT',
  /** column name */
  Acotypad = 'ACOTYPAD',
  /** column name */
  Acotypci = 'ACOTYPCI',
  /** column name */
  Acotypmd = 'ACOTYPMD',
  /** column name */
  Acotypt = 'ACOTYPT',
  /** column name */
  Ahambr = 'AHAMBR',
  /** column name */
  Area = 'AREA',
  /** column name */
  Bdpy = 'BDPY',
  /** column name */
  Bndpay = 'BNDPAY',
  /** column name */
  Bndpct = 'BNDPCT',
  /** column name */
  Bndrsk = 'BNDRSK',
  /** column name */
  Bsc = 'BSC',
  /** column name */
  Capcon94 = 'CAPCON94',
  /** column name */
  Caprsk = 'CAPRSK',
  /** column name */
  Cbsacode = 'CBSACODE',
  /** column name */
  Cbsaname = 'CBSANAME',
  /** column name */
  Cbsatype = 'CBSATYPE',
  /** column name */
  Chc = 'CHC',
  /** column name */
  Cityrk = 'CITYRK',
  /** column name */
  Cluster = 'CLUSTER',
  /** column name */
  Cmrpay = 'CMRPAY',
  /** column name */
  Cndoth = 'CNDOTH',
  /** column name */
  Cndtypcv = 'CNDTYPCV',
  /** column name */
  Cndtypgi = 'CNDTYPGI',
  /** column name */
  Cndtyphm = 'CNDTYPHM',
  /** column name */
  Cndtypid = 'CNDTYPID',
  /** column name */
  Cndtypng = 'CNDTYPNG',
  /** column name */
  Cndtypon = 'CNDTYPON',
  /** column name */
  Cndtypor = 'CNDTYPOR',
  /** column name */
  Cndtypos = 'CNDTYPOS',
  /** column name */
  Cndtyppm = 'CNDTYPPM',
  /** column name */
  Cntrl = 'CNTRL',
  /** column name */
  Cntyname = 'CNTYNAME',
  /** column name */
  Cohsp = 'COHSP',
  /** column name */
  Commty = 'COMMTY',
  /** column name */
  Cotycan = 'COTYCAN',
  /** column name */
  Cotycar = 'COTYCAR',
  /** column name */
  Cotydesc = 'COTYDESC',
  /** column name */
  Cotyort = 'COTYORT',
  /** column name */
  Cotyoth = 'COTYOTH',
  /** column name */
  Cotyped = 'COTYPED',
  /** column name */
  Cotypsy = 'COTYPSY',
  /** column name */
  Cotysur = 'COTYSUR',
  /** column name */
  Cppct = 'CPPCT',
  /** column name */
  Csacode = 'CSACODE',
  /** column name */
  Csaname = 'CSANAME',
  /** column name */
  Dcov = 'DCOV',
  /** column name */
  Divcode = 'DIVCODE',
  /** column name */
  Divname = 'DIVNAME',
  /** column name */
  Dtbeg = 'DTBEG',
  /** column name */
  Dtend = 'DTEND',
  /** column name */
  Famadv = 'FAMADV',
  /** column name */
  Fcntycd = 'FCNTYCD',
  /** column name */
  Fcounty = 'FCOUNTY',
  /** column name */
  Fisyr = 'FISYR',
  /** column name */
  Fndbn = 'FNDBN',
  /** column name */
  Frtln = 'FRTLN',
  /** column name */
  Fstcd = 'FSTCD',
  /** column name */
  Fyr = 'FYR',
  /** column name */
  Gpocity = 'GPOCITY',
  /** column name */
  Gponame = 'GPONAME',
  /** column name */
  Gpost = 'GPOST',
  /** column name */
  Group = 'GROUP',
  /** column name */
  Hhplan = 'HHPLAN',
  /** column name */
  Hlindk = 'HLINDK',
  /** column name */
  Hlinhos = 'HLINHOS',
  /** column name */
  Hlinn = 'HLINN',
  /** column name */
  Hlinnp = 'HLINNP',
  /** column name */
  Hlinsys = 'HLINSYS',
  /** column name */
  Hlinven = 'HLINVEN',
  /** column name */
  Hrrcode = 'HRRCODE',
  /** column name */
  Hrrname = 'HRRNAME',
  /** column name */
  Hsacode = 'HSACODE',
  /** column name */
  Hsaname = 'HSANAME',
  /** column name */
  Id = 'ID',
  /** column name */
  Iinspt = 'IINSPT',
  /** column name */
  Lat = 'LAT',
  /** column name */
  Lgrpdk = 'LGRPDK',
  /** column name */
  Lgrphos = 'LGRPHOS',
  /** column name */
  Lgrpn = 'LGRPN',
  /** column name */
  Lgrpnp = 'LGRPNP',
  /** column name */
  Lgrpsys = 'LGRPSYS',
  /** column name */
  Lgrpven = 'LGRPVEN',
  /** column name */
  Long = 'LONG',
  /** column name */
  Los = 'LOS',
  /** column name */
  Ltchc = 'LTCHC',
  /** column name */
  Ltchf = 'LTCHF',
  /** column name */
  Ltct = 'LTCT',
  /** column name */
  Ltnm = 'LTNM',
  /** column name */
  Ltst = 'LTST',
  /** column name */
  Madmin = 'MADMIN',
  /** column name */
  Mapp1 = 'MAPP1',
  /** column name */
  Mapp2 = 'MAPP2',
  /** column name */
  Mapp3 = 'MAPP3',
  /** column name */
  Mapp5 = 'MAPP5',
  /** column name */
  Mapp7 = 'MAPP7',
  /** column name */
  Mapp8 = 'MAPP8',
  /** column name */
  Mapp10 = 'MAPP10',
  /** column name */
  Mapp11 = 'MAPP11',
  /** column name */
  Mapp16 = 'MAPP16',
  /** column name */
  Mapp18 = 'MAPP18',
  /** column name */
  Mapp19 = 'MAPP19',
  /** column name */
  Mapp20 = 'MAPP20',
  /** column name */
  Mapp21 = 'MAPP21',
  /** column name */
  Mapp22 = 'MAPP22',
  /** column name */
  Mcntycd = 'MCNTYCD',
  /** column name */
  Mcrnum = 'MCRNUM',
  /** column name */
  Medaddk = 'MEDADDK',
  /** column name */
  Medadhos = 'MEDADHOS',
  /** column name */
  Medadn = 'MEDADN',
  /** column name */
  Medadsys = 'MEDADSYS',
  /** column name */
  Medadven = 'MEDADVEN',
  /** column name */
  Medhme = 'MEDHME',
  /** column name */
  Medhse = 'MEDHSE',
  /** column name */
  Mednp = 'MEDNP',
  /** column name */
  Mhsmemb = 'MHSMEMB',
  /** column name */
  Mlocaddr = 'MLOCADDR',
  /** column name */
  Mloccity = 'MLOCCITY',
  /** column name */
  Mlocstcd = 'MLOCSTCD',
  /** column name */
  Mloczip = 'MLOCZIP',
  /** column name */
  Mmcdk = 'MMCDK',
  /** column name */
  Mmchos = 'MMCHOS',
  /** column name */
  Mmcn = 'MMCN',
  /** column name */
  Mmcnp = 'MMCNP',
  /** column name */
  Mmcsys = 'MMCSYS',
  /** column name */
  Mmcven = 'MMCVEN',
  /** column name */
  Mname = 'MNAME',
  /** column name */
  Mngt = 'MNGT',
  /** column name */
  Mngtcity = 'MNGTCITY',
  /** column name */
  Mngtname = 'MNGTNAME',
  /** column name */
  Mngtstcd = 'MNGTSTCD',
  /** column name */
  Mssp = 'MSSP',
  /** column name */
  Msspba = 'MSSPBA',
  /** column name */
  Msspbb = 'MSSPBB',
  /** column name */
  Msspbc = 'MSSPBC',
  /** column name */
  Msspbd = 'MSSPBD',
  /** column name */
  Msspbe = 'MSSPBE',
  /** column name */
  Msspce = 'MSSPCE',
  /** column name */
  Mssptrk = 'MSSPTRK',
  /** column name */
  Mstate = 'MSTATE',
  /** column name */
  Osmgdk = 'OSMGDK',
  /** column name */
  Osmghos = 'OSMGHOS',
  /** column name */
  Osmgn = 'OSMGN',
  /** column name */
  Osmgnp = 'OSMGNP',
  /** column name */
  Osmgoth = 'OSMGOTH',
  /** column name */
  Osmgsys = 'OSMGSYS',
  /** column name */
  Osmgven = 'OSMGVEN',
  /** column name */
  Othimdk = 'OTHIMDK',
  /** column name */
  Othimhos = 'OTHIMHOS',
  /** column name */
  Othimn = 'OTHIMN',
  /** column name */
  Othimsys = 'OTHIMSYS',
  /** column name */
  Othimven = 'OTHIMVEN',
  /** column name */
  Othinp = 'OTHINP',
  /** column name */
  Paytyad = 'PAYTYAD',
  /** column name */
  Paytypci = 'PAYTYPCI',
  /** column name */
  Paytypmd = 'PAYTYPMD',
  /** column name */
  Paytyptm = 'PAYTYPTM',
  /** column name */
  Phygp = 'PHYGP',
  /** column name */
  Radmchi = 'RADMCHI',
  /** column name */
  Resp = 'RESP',
  /** column name */
  Resptc = 'RESPTC',
  /** column name */
  Serv = 'SERV',
  /** column name */
  Servoth = 'SERVOTH',
  /** column name */
  Slfpln = 'SLFPLN',
  /** column name */
  Smgpdk = 'SMGPDK',
  /** column name */
  Smgpnp = 'SMGPNP',
  /** column name */
  Smgrphos = 'SMGRPHOS',
  /** column name */
  Smgrpn = 'SMGRPN',
  /** column name */
  Smgrpsys = 'SMGRPSYS',
  /** column name */
  Smgrpven = 'SMGRPVEN',
  /** column name */
  Spah = 'SPAH',
  /** column name */
  Splan = 'SPLAN',
  /** column name */
  Sptc = 'SPTC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Subs = 'SUBS',
  /** column name */
  Sunits = 'SUNITS',
  /** column name */
  Suply = 'SUPLY',
  /** column name */
  Supnm = 'SUPNM',
  /** column name */
  Sysaddr = 'SYSADDR',
  /** column name */
  Sysarea = 'SYSAREA',
  /** column name */
  Syscity = 'SYSCITY',
  /** column name */
  Sysid = 'SYSID',
  /** column name */
  Sysname = 'SYSNAME',
  /** column name */
  Sysst = 'SYSST',
  /** column name */
  Systeln = 'SYSTELN',
  /** column name */
  SystemPrimaryContact = 'SYSTEM_PRIMARY_CONTACT',
  /** column name */
  Systitle = 'SYSTITLE',
  /** column name */
  Syszip = 'SYSZIP',
  /** column name */
  Telno = 'TELNO'
}

export type As21Dem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As21Dem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Dem_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Dem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As21Dem_Var_Pop_Fields = {
  __typename?: 'AS21DEM_var_pop_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As21Dem_Var_Samp_Fields = {
  __typename?: 'AS21DEM_var_samp_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As21Dem_Variance_Fields = {
  __typename?: 'AS21DEM_variance_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  CNDTYPCV: Maybe<Scalars['Float']>;
  CNDTYPGI: Maybe<Scalars['Float']>;
  CNDTYPHM: Maybe<Scalars['Float']>;
  CNDTYPID: Maybe<Scalars['Float']>;
  CNDTYPNG: Maybe<Scalars['Float']>;
  CNDTYPON: Maybe<Scalars['Float']>;
  CNDTYPOR: Maybe<Scalars['Float']>;
  CNDTYPOS: Maybe<Scalars['Float']>;
  CNDTYPPM: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  PAYTYAD: Maybe<Scalars['Float']>;
  PAYTYPCI: Maybe<Scalars['Float']>;
  PAYTYPMD: Maybe<Scalars['Float']>;
  PAYTYPTM: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS21SVC1" */
export type As21Svc1 = {
  __typename?: 'AS21SVC1';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BIOBD: Maybe<Scalars['float8']>;
  BIOHOS: Maybe<Scalars['String']>;
  BIOSYS: Maybe<Scalars['String']>;
  BIOVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS21SVC1" */
export type As21Svc1_Aggregate = {
  __typename?: 'AS21SVC1_aggregate';
  aggregate: Maybe<As21Svc1_Aggregate_Fields>;
  nodes: Array<As21Svc1>;
};

/** aggregate fields of "AS21SVC1" */
export type As21Svc1_Aggregate_Fields = {
  __typename?: 'AS21SVC1_aggregate_fields';
  avg: Maybe<As21Svc1_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As21Svc1_Max_Fields>;
  min: Maybe<As21Svc1_Min_Fields>;
  stddev: Maybe<As21Svc1_Stddev_Fields>;
  stddev_pop: Maybe<As21Svc1_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As21Svc1_Stddev_Samp_Fields>;
  sum: Maybe<As21Svc1_Sum_Fields>;
  var_pop: Maybe<As21Svc1_Var_Pop_Fields>;
  var_samp: Maybe<As21Svc1_Var_Samp_Fields>;
  variance: Maybe<As21Svc1_Variance_Fields>;
};


/** aggregate fields of "AS21SVC1" */
export type As21Svc1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Svc1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As21Svc1_Avg_Fields = {
  __typename?: 'AS21SVC1_avg_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS21SVC1". All fields are combined with a logical 'AND'. */
export type As21Svc1_Bool_Exp = {
  ACARDHOS?: InputMaybe<String_Comparison_Exp>;
  ACARDSYS?: InputMaybe<String_Comparison_Exp>;
  ACARDVEN?: InputMaybe<String_Comparison_Exp>;
  ACLABHOS?: InputMaybe<String_Comparison_Exp>;
  ACLABSYS?: InputMaybe<String_Comparison_Exp>;
  ACLABVEN?: InputMaybe<String_Comparison_Exp>;
  ACUHOS?: InputMaybe<String_Comparison_Exp>;
  ACULTBD?: InputMaybe<Float8_Comparison_Exp>;
  ACUSYS?: InputMaybe<String_Comparison_Exp>;
  ACUVEN?: InputMaybe<String_Comparison_Exp>;
  ADTCHOS?: InputMaybe<String_Comparison_Exp>;
  ADTCSYS?: InputMaybe<String_Comparison_Exp>;
  ADTCVEN?: InputMaybe<String_Comparison_Exp>;
  ADTEHOS?: InputMaybe<String_Comparison_Exp>;
  ADTESYS?: InputMaybe<String_Comparison_Exp>;
  ADTEVEN?: InputMaybe<String_Comparison_Exp>;
  ADULTHOS?: InputMaybe<String_Comparison_Exp>;
  ADULTSYS?: InputMaybe<String_Comparison_Exp>;
  ADULTVEN?: InputMaybe<String_Comparison_Exp>;
  AIRBHOS?: InputMaybe<String_Comparison_Exp>;
  AIRBROOM?: InputMaybe<Float8_Comparison_Exp>;
  AIRBSYS?: InputMaybe<String_Comparison_Exp>;
  AIRBVEN?: InputMaybe<String_Comparison_Exp>;
  ALCHBD?: InputMaybe<Float8_Comparison_Exp>;
  ALCHHOS?: InputMaybe<String_Comparison_Exp>;
  ALCHSYS?: InputMaybe<String_Comparison_Exp>;
  ALCHVEN?: InputMaybe<String_Comparison_Exp>;
  ALZHOS?: InputMaybe<String_Comparison_Exp>;
  ALZSYS?: InputMaybe<String_Comparison_Exp>;
  ALZVEN?: InputMaybe<String_Comparison_Exp>;
  AMBAHOS?: InputMaybe<String_Comparison_Exp>;
  AMBASYS?: InputMaybe<String_Comparison_Exp>;
  AMBAVEN?: InputMaybe<String_Comparison_Exp>;
  AMBHOS?: InputMaybe<String_Comparison_Exp>;
  AMBSHOS?: InputMaybe<String_Comparison_Exp>;
  AMBSSYS?: InputMaybe<String_Comparison_Exp>;
  AMBSVEN?: InputMaybe<String_Comparison_Exp>;
  AMBSYS?: InputMaybe<String_Comparison_Exp>;
  AMBVEN?: InputMaybe<String_Comparison_Exp>;
  ARTHCHOS?: InputMaybe<String_Comparison_Exp>;
  ARTHCSYS?: InputMaybe<String_Comparison_Exp>;
  ARTHCVEN?: InputMaybe<String_Comparison_Exp>;
  AUXHOS?: InputMaybe<String_Comparison_Exp>;
  AUXSYS?: InputMaybe<String_Comparison_Exp>;
  AUXVEN?: InputMaybe<String_Comparison_Exp>;
  BIOBD?: InputMaybe<Float8_Comparison_Exp>;
  BIOHOS?: InputMaybe<String_Comparison_Exp>;
  BIOSYS?: InputMaybe<String_Comparison_Exp>;
  BIOVEN?: InputMaybe<String_Comparison_Exp>;
  BLDOHOS?: InputMaybe<String_Comparison_Exp>;
  BLDOSYS?: InputMaybe<String_Comparison_Exp>;
  BLDOVEN?: InputMaybe<String_Comparison_Exp>;
  BRNBD?: InputMaybe<Float8_Comparison_Exp>;
  BRNHOS?: InputMaybe<String_Comparison_Exp>;
  BRNSYS?: InputMaybe<String_Comparison_Exp>;
  BRNVEN?: InputMaybe<String_Comparison_Exp>;
  BROOMHOS?: InputMaybe<String_Comparison_Exp>;
  BROOMSYS?: InputMaybe<String_Comparison_Exp>;
  BROOMVEN?: InputMaybe<String_Comparison_Exp>;
  BWHTHOS?: InputMaybe<String_Comparison_Exp>;
  BWHTSYS?: InputMaybe<String_Comparison_Exp>;
  BWHTVEN?: InputMaybe<String_Comparison_Exp>;
  CAOSHOS?: InputMaybe<String_Comparison_Exp>;
  CAOSSYS?: InputMaybe<String_Comparison_Exp>;
  CAOSVEN?: InputMaybe<String_Comparison_Exp>;
  CHABHOS?: InputMaybe<String_Comparison_Exp>;
  CHABSYS?: InputMaybe<String_Comparison_Exp>;
  CHABVEN?: InputMaybe<String_Comparison_Exp>;
  CHAPHOS?: InputMaybe<String_Comparison_Exp>;
  CHAPSYS?: InputMaybe<String_Comparison_Exp>;
  CHAPVEN?: InputMaybe<String_Comparison_Exp>;
  CHIHOS?: InputMaybe<String_Comparison_Exp>;
  CHISYS?: InputMaybe<String_Comparison_Exp>;
  CHIVEN?: InputMaybe<String_Comparison_Exp>;
  CHTHHOS?: InputMaybe<String_Comparison_Exp>;
  CHTHSYS?: InputMaybe<String_Comparison_Exp>;
  CHTHVEN?: InputMaybe<String_Comparison_Exp>;
  CICBD?: InputMaybe<Float8_Comparison_Exp>;
  CICHOS?: InputMaybe<String_Comparison_Exp>;
  CICSYS?: InputMaybe<String_Comparison_Exp>;
  CICVEN?: InputMaybe<String_Comparison_Exp>;
  CMNGTHOS?: InputMaybe<String_Comparison_Exp>;
  CMNGTSYS?: InputMaybe<String_Comparison_Exp>;
  CMNGTVEN?: InputMaybe<String_Comparison_Exp>;
  COMPHOS?: InputMaybe<String_Comparison_Exp>;
  COMPSYS?: InputMaybe<String_Comparison_Exp>;
  COMPVEN?: InputMaybe<String_Comparison_Exp>;
  COUTRHOS?: InputMaybe<String_Comparison_Exp>;
  COUTRSYS?: InputMaybe<String_Comparison_Exp>;
  COUTRVEN?: InputMaybe<String_Comparison_Exp>;
  CPREVHOS?: InputMaybe<String_Comparison_Exp>;
  CPREVSYS?: InputMaybe<String_Comparison_Exp>;
  CPREVVEN?: InputMaybe<String_Comparison_Exp>;
  CWELLHOS?: InputMaybe<String_Comparison_Exp>;
  CWELLSYS?: InputMaybe<String_Comparison_Exp>;
  CWELLVEN?: InputMaybe<String_Comparison_Exp>;
  DENTSHOS?: InputMaybe<String_Comparison_Exp>;
  DENTSSYS?: InputMaybe<String_Comparison_Exp>;
  DENTSVEN?: InputMaybe<String_Comparison_Exp>;
  DPPHOS?: InputMaybe<String_Comparison_Exp>;
  DPPSYS?: InputMaybe<String_Comparison_Exp>;
  DPPVEN?: InputMaybe<String_Comparison_Exp>;
  EMDEPHOS?: InputMaybe<String_Comparison_Exp>;
  EMDEPSYS?: InputMaybe<String_Comparison_Exp>;
  EMDEPVEN?: InputMaybe<String_Comparison_Exp>;
  EMSSHOS?: InputMaybe<String_Comparison_Exp>;
  EMSSSYS?: InputMaybe<String_Comparison_Exp>;
  EMSSVEN?: InputMaybe<String_Comparison_Exp>;
  ENBHOS?: InputMaybe<String_Comparison_Exp>;
  ENBSYS?: InputMaybe<String_Comparison_Exp>;
  ENBVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOAHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOASYS?: InputMaybe<String_Comparison_Exp>;
  ENDOAVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOCHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOCSYS?: InputMaybe<String_Comparison_Exp>;
  ENDOCVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOEHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOESYS?: InputMaybe<String_Comparison_Exp>;
  ENDOEVEN?: InputMaybe<String_Comparison_Exp>;
  ENDORHOS?: InputMaybe<String_Comparison_Exp>;
  ENDORSYS?: InputMaybe<String_Comparison_Exp>;
  ENDORVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOUHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOUSYS?: InputMaybe<String_Comparison_Exp>;
  ENDOUVEN?: InputMaybe<String_Comparison_Exp>;
  ENRHOS?: InputMaybe<String_Comparison_Exp>;
  ENRSYS?: InputMaybe<String_Comparison_Exp>;
  ENRVEN?: InputMaybe<String_Comparison_Exp>;
  ESWLHOS?: InputMaybe<String_Comparison_Exp>;
  ESWLSYS?: InputMaybe<String_Comparison_Exp>;
  ESWLVEN?: InputMaybe<String_Comparison_Exp>;
  FITCHOS?: InputMaybe<String_Comparison_Exp>;
  FITCSYS?: InputMaybe<String_Comparison_Exp>;
  FITCVEN?: InputMaybe<String_Comparison_Exp>;
  FRTCHOS?: InputMaybe<String_Comparison_Exp>;
  FRTCSYS?: InputMaybe<String_Comparison_Exp>;
  FRTCVEN?: InputMaybe<String_Comparison_Exp>;
  FSERHOS?: InputMaybe<String_Comparison_Exp>;
  FSERSYS?: InputMaybe<String_Comparison_Exp>;
  FSERVEN?: InputMaybe<String_Comparison_Exp>;
  GENBD?: InputMaybe<Float8_Comparison_Exp>;
  GENHOS?: InputMaybe<String_Comparison_Exp>;
  GENSYS?: InputMaybe<String_Comparison_Exp>;
  GENVEN?: InputMaybe<String_Comparison_Exp>;
  GERSVHOS?: InputMaybe<String_Comparison_Exp>;
  GERSVSYS?: InputMaybe<String_Comparison_Exp>;
  GERSVVEN?: InputMaybe<String_Comparison_Exp>;
  HOSPBD?: InputMaybe<Float8_Comparison_Exp>;
  ICFBD88?: InputMaybe<Float8_Comparison_Exp>;
  ICFHOS?: InputMaybe<String_Comparison_Exp>;
  ICFSYS?: InputMaybe<String_Comparison_Exp>;
  ICFVEN?: InputMaybe<String_Comparison_Exp>;
  ICLABHOS?: InputMaybe<String_Comparison_Exp>;
  ICLABSYS?: InputMaybe<String_Comparison_Exp>;
  ICLABVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  MAMMSHOS?: InputMaybe<String_Comparison_Exp>;
  MAMMSSYS?: InputMaybe<String_Comparison_Exp>;
  MAMMSVEN?: InputMaybe<String_Comparison_Exp>;
  MSICBD?: InputMaybe<Float8_Comparison_Exp>;
  MSICHOS?: InputMaybe<String_Comparison_Exp>;
  MSICSYS?: InputMaybe<String_Comparison_Exp>;
  MSICVEN?: InputMaybe<String_Comparison_Exp>;
  NICBD?: InputMaybe<Float8_Comparison_Exp>;
  NICHOS?: InputMaybe<String_Comparison_Exp>;
  NICSYS?: InputMaybe<String_Comparison_Exp>;
  NICVEN?: InputMaybe<String_Comparison_Exp>;
  NINTBD?: InputMaybe<Float8_Comparison_Exp>;
  NINTHOS?: InputMaybe<String_Comparison_Exp>;
  NINTSYS?: InputMaybe<String_Comparison_Exp>;
  NINTVEN?: InputMaybe<String_Comparison_Exp>;
  OBBD?: InputMaybe<Float8_Comparison_Exp>;
  OBHOS?: InputMaybe<String_Comparison_Exp>;
  OBLEV?: InputMaybe<String_Comparison_Exp>;
  OBSYS?: InputMaybe<String_Comparison_Exp>;
  OBVEN?: InputMaybe<String_Comparison_Exp>;
  OPCENHOS?: InputMaybe<String_Comparison_Exp>;
  OPCENSYS?: InputMaybe<String_Comparison_Exp>;
  OPCENVEN?: InputMaybe<String_Comparison_Exp>;
  OSPOTH?: InputMaybe<String_Comparison_Exp>;
  OTHBD94?: InputMaybe<Float8_Comparison_Exp>;
  OTHCRHOS?: InputMaybe<String_Comparison_Exp>;
  OTHCRSYS?: InputMaybe<String_Comparison_Exp>;
  OTHCRVEN?: InputMaybe<String_Comparison_Exp>;
  OTHIC?: InputMaybe<String_Comparison_Exp>;
  OTHICBD?: InputMaybe<Float8_Comparison_Exp>;
  OTHIHOS?: InputMaybe<String_Comparison_Exp>;
  OTHISYS?: InputMaybe<String_Comparison_Exp>;
  OTHIVEN?: InputMaybe<String_Comparison_Exp>;
  OTHLBD94?: InputMaybe<Float8_Comparison_Exp>;
  OTHLTHOS?: InputMaybe<String_Comparison_Exp>;
  OTHLTSYS?: InputMaybe<String_Comparison_Exp>;
  OTHLTVEN?: InputMaybe<String_Comparison_Exp>;
  OTHOTH?: InputMaybe<String_Comparison_Exp>;
  PCARDHOS?: InputMaybe<String_Comparison_Exp>;
  PCARDSYS?: InputMaybe<String_Comparison_Exp>;
  PCARDVEN?: InputMaybe<String_Comparison_Exp>;
  PCLABHOS?: InputMaybe<String_Comparison_Exp>;
  PCLABSYS?: InputMaybe<String_Comparison_Exp>;
  PCLABVEN?: InputMaybe<String_Comparison_Exp>;
  PEDBD?: InputMaybe<Float8_Comparison_Exp>;
  PEDCSHOS?: InputMaybe<String_Comparison_Exp>;
  PEDCSSYS?: InputMaybe<String_Comparison_Exp>;
  PEDCSVEN?: InputMaybe<String_Comparison_Exp>;
  PEDEHOS?: InputMaybe<String_Comparison_Exp>;
  PEDESYS?: InputMaybe<String_Comparison_Exp>;
  PEDEVEN?: InputMaybe<String_Comparison_Exp>;
  PEDHOS?: InputMaybe<String_Comparison_Exp>;
  PEDICBD?: InputMaybe<Float8_Comparison_Exp>;
  PEDICHOS?: InputMaybe<String_Comparison_Exp>;
  PEDICSYS?: InputMaybe<String_Comparison_Exp>;
  PEDICVEN?: InputMaybe<String_Comparison_Exp>;
  PEDSYS?: InputMaybe<String_Comparison_Exp>;
  PEDVEN?: InputMaybe<String_Comparison_Exp>;
  PELABHOS?: InputMaybe<String_Comparison_Exp>;
  PELABSYS?: InputMaybe<String_Comparison_Exp>;
  PELABVEN?: InputMaybe<String_Comparison_Exp>;
  PEMERHOS?: InputMaybe<String_Comparison_Exp>;
  PEMERSYS?: InputMaybe<String_Comparison_Exp>;
  PEMERVEN?: InputMaybe<String_Comparison_Exp>;
  PSYBD?: InputMaybe<Float8_Comparison_Exp>;
  PSYHOS?: InputMaybe<String_Comparison_Exp>;
  PSYSYS?: InputMaybe<String_Comparison_Exp>;
  PSYVEN?: InputMaybe<String_Comparison_Exp>;
  REHABBD?: InputMaybe<Float8_Comparison_Exp>;
  REHABHOS?: InputMaybe<String_Comparison_Exp>;
  REHABSYS?: InputMaybe<String_Comparison_Exp>;
  REHABVEN?: InputMaybe<String_Comparison_Exp>;
  SNBD88?: InputMaybe<Float8_Comparison_Exp>;
  SNHOS?: InputMaybe<String_Comparison_Exp>;
  SNSYS?: InputMaybe<String_Comparison_Exp>;
  SNVEN?: InputMaybe<String_Comparison_Exp>;
  SPCICBD?: InputMaybe<Float8_Comparison_Exp>;
  SPCICHOS?: InputMaybe<String_Comparison_Exp>;
  SPCICSYS?: InputMaybe<String_Comparison_Exp>;
  SPCICVEN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  TRAUMHOS?: InputMaybe<String_Comparison_Exp>;
  TRAUML90?: InputMaybe<String_Comparison_Exp>;
  TRAUMSYS?: InputMaybe<String_Comparison_Exp>;
  TRAUMVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Svc1_Bool_Exp>>;
  _not?: InputMaybe<As21Svc1_Bool_Exp>;
  _or?: InputMaybe<Array<As21Svc1_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS21SVC1" */
export enum As21Svc1_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Svc1 = 'pk_AS21SVC1'
}

/** input type for incrementing numeric columns in table "AS21SVC1" */
export type As21Svc1_Inc_Input = {
  ACULTBD?: InputMaybe<Scalars['float8']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS21SVC1" */
export type As21Svc1_Insert_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BIOHOS?: InputMaybe<Scalars['String']>;
  BIOSYS?: InputMaybe<Scalars['String']>;
  BIOVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As21Svc1_Max_Fields = {
  __typename?: 'AS21SVC1_max_fields';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BIOBD: Maybe<Scalars['float8']>;
  BIOHOS: Maybe<Scalars['String']>;
  BIOSYS: Maybe<Scalars['String']>;
  BIOVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As21Svc1_Min_Fields = {
  __typename?: 'AS21SVC1_min_fields';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BIOBD: Maybe<Scalars['float8']>;
  BIOHOS: Maybe<Scalars['String']>;
  BIOSYS: Maybe<Scalars['String']>;
  BIOVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS21SVC1" */
export type As21Svc1_Mutation_Response = {
  __typename?: 'AS21SVC1_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Svc1>;
};

/** input type for inserting object relation for remote table "AS21SVC1" */
export type As21Svc1_Obj_Rel_Insert_Input = {
  data: As21Svc1_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Svc1_On_Conflict>;
};

/** on_conflict condition type for table "AS21SVC1" */
export type As21Svc1_On_Conflict = {
  constraint: As21Svc1_Constraint;
  update_columns?: Array<As21Svc1_Update_Column>;
  where?: InputMaybe<As21Svc1_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21SVC1". */
export type As21Svc1_Order_By = {
  ACARDHOS?: InputMaybe<Order_By>;
  ACARDSYS?: InputMaybe<Order_By>;
  ACARDVEN?: InputMaybe<Order_By>;
  ACLABHOS?: InputMaybe<Order_By>;
  ACLABSYS?: InputMaybe<Order_By>;
  ACLABVEN?: InputMaybe<Order_By>;
  ACUHOS?: InputMaybe<Order_By>;
  ACULTBD?: InputMaybe<Order_By>;
  ACUSYS?: InputMaybe<Order_By>;
  ACUVEN?: InputMaybe<Order_By>;
  ADTCHOS?: InputMaybe<Order_By>;
  ADTCSYS?: InputMaybe<Order_By>;
  ADTCVEN?: InputMaybe<Order_By>;
  ADTEHOS?: InputMaybe<Order_By>;
  ADTESYS?: InputMaybe<Order_By>;
  ADTEVEN?: InputMaybe<Order_By>;
  ADULTHOS?: InputMaybe<Order_By>;
  ADULTSYS?: InputMaybe<Order_By>;
  ADULTVEN?: InputMaybe<Order_By>;
  AIRBHOS?: InputMaybe<Order_By>;
  AIRBROOM?: InputMaybe<Order_By>;
  AIRBSYS?: InputMaybe<Order_By>;
  AIRBVEN?: InputMaybe<Order_By>;
  ALCHBD?: InputMaybe<Order_By>;
  ALCHHOS?: InputMaybe<Order_By>;
  ALCHSYS?: InputMaybe<Order_By>;
  ALCHVEN?: InputMaybe<Order_By>;
  ALZHOS?: InputMaybe<Order_By>;
  ALZSYS?: InputMaybe<Order_By>;
  ALZVEN?: InputMaybe<Order_By>;
  AMBAHOS?: InputMaybe<Order_By>;
  AMBASYS?: InputMaybe<Order_By>;
  AMBAVEN?: InputMaybe<Order_By>;
  AMBHOS?: InputMaybe<Order_By>;
  AMBSHOS?: InputMaybe<Order_By>;
  AMBSSYS?: InputMaybe<Order_By>;
  AMBSVEN?: InputMaybe<Order_By>;
  AMBSYS?: InputMaybe<Order_By>;
  AMBVEN?: InputMaybe<Order_By>;
  ARTHCHOS?: InputMaybe<Order_By>;
  ARTHCSYS?: InputMaybe<Order_By>;
  ARTHCVEN?: InputMaybe<Order_By>;
  AUXHOS?: InputMaybe<Order_By>;
  AUXSYS?: InputMaybe<Order_By>;
  AUXVEN?: InputMaybe<Order_By>;
  BIOBD?: InputMaybe<Order_By>;
  BIOHOS?: InputMaybe<Order_By>;
  BIOSYS?: InputMaybe<Order_By>;
  BIOVEN?: InputMaybe<Order_By>;
  BLDOHOS?: InputMaybe<Order_By>;
  BLDOSYS?: InputMaybe<Order_By>;
  BLDOVEN?: InputMaybe<Order_By>;
  BRNBD?: InputMaybe<Order_By>;
  BRNHOS?: InputMaybe<Order_By>;
  BRNSYS?: InputMaybe<Order_By>;
  BRNVEN?: InputMaybe<Order_By>;
  BROOMHOS?: InputMaybe<Order_By>;
  BROOMSYS?: InputMaybe<Order_By>;
  BROOMVEN?: InputMaybe<Order_By>;
  BWHTHOS?: InputMaybe<Order_By>;
  BWHTSYS?: InputMaybe<Order_By>;
  BWHTVEN?: InputMaybe<Order_By>;
  CAOSHOS?: InputMaybe<Order_By>;
  CAOSSYS?: InputMaybe<Order_By>;
  CAOSVEN?: InputMaybe<Order_By>;
  CHABHOS?: InputMaybe<Order_By>;
  CHABSYS?: InputMaybe<Order_By>;
  CHABVEN?: InputMaybe<Order_By>;
  CHAPHOS?: InputMaybe<Order_By>;
  CHAPSYS?: InputMaybe<Order_By>;
  CHAPVEN?: InputMaybe<Order_By>;
  CHIHOS?: InputMaybe<Order_By>;
  CHISYS?: InputMaybe<Order_By>;
  CHIVEN?: InputMaybe<Order_By>;
  CHTHHOS?: InputMaybe<Order_By>;
  CHTHSYS?: InputMaybe<Order_By>;
  CHTHVEN?: InputMaybe<Order_By>;
  CICBD?: InputMaybe<Order_By>;
  CICHOS?: InputMaybe<Order_By>;
  CICSYS?: InputMaybe<Order_By>;
  CICVEN?: InputMaybe<Order_By>;
  CMNGTHOS?: InputMaybe<Order_By>;
  CMNGTSYS?: InputMaybe<Order_By>;
  CMNGTVEN?: InputMaybe<Order_By>;
  COMPHOS?: InputMaybe<Order_By>;
  COMPSYS?: InputMaybe<Order_By>;
  COMPVEN?: InputMaybe<Order_By>;
  COUTRHOS?: InputMaybe<Order_By>;
  COUTRSYS?: InputMaybe<Order_By>;
  COUTRVEN?: InputMaybe<Order_By>;
  CPREVHOS?: InputMaybe<Order_By>;
  CPREVSYS?: InputMaybe<Order_By>;
  CPREVVEN?: InputMaybe<Order_By>;
  CWELLHOS?: InputMaybe<Order_By>;
  CWELLSYS?: InputMaybe<Order_By>;
  CWELLVEN?: InputMaybe<Order_By>;
  DENTSHOS?: InputMaybe<Order_By>;
  DENTSSYS?: InputMaybe<Order_By>;
  DENTSVEN?: InputMaybe<Order_By>;
  DPPHOS?: InputMaybe<Order_By>;
  DPPSYS?: InputMaybe<Order_By>;
  DPPVEN?: InputMaybe<Order_By>;
  EMDEPHOS?: InputMaybe<Order_By>;
  EMDEPSYS?: InputMaybe<Order_By>;
  EMDEPVEN?: InputMaybe<Order_By>;
  EMSSHOS?: InputMaybe<Order_By>;
  EMSSSYS?: InputMaybe<Order_By>;
  EMSSVEN?: InputMaybe<Order_By>;
  ENBHOS?: InputMaybe<Order_By>;
  ENBSYS?: InputMaybe<Order_By>;
  ENBVEN?: InputMaybe<Order_By>;
  ENDOAHOS?: InputMaybe<Order_By>;
  ENDOASYS?: InputMaybe<Order_By>;
  ENDOAVEN?: InputMaybe<Order_By>;
  ENDOCHOS?: InputMaybe<Order_By>;
  ENDOCSYS?: InputMaybe<Order_By>;
  ENDOCVEN?: InputMaybe<Order_By>;
  ENDOEHOS?: InputMaybe<Order_By>;
  ENDOESYS?: InputMaybe<Order_By>;
  ENDOEVEN?: InputMaybe<Order_By>;
  ENDORHOS?: InputMaybe<Order_By>;
  ENDORSYS?: InputMaybe<Order_By>;
  ENDORVEN?: InputMaybe<Order_By>;
  ENDOUHOS?: InputMaybe<Order_By>;
  ENDOUSYS?: InputMaybe<Order_By>;
  ENDOUVEN?: InputMaybe<Order_By>;
  ENRHOS?: InputMaybe<Order_By>;
  ENRSYS?: InputMaybe<Order_By>;
  ENRVEN?: InputMaybe<Order_By>;
  ESWLHOS?: InputMaybe<Order_By>;
  ESWLSYS?: InputMaybe<Order_By>;
  ESWLVEN?: InputMaybe<Order_By>;
  FITCHOS?: InputMaybe<Order_By>;
  FITCSYS?: InputMaybe<Order_By>;
  FITCVEN?: InputMaybe<Order_By>;
  FRTCHOS?: InputMaybe<Order_By>;
  FRTCSYS?: InputMaybe<Order_By>;
  FRTCVEN?: InputMaybe<Order_By>;
  FSERHOS?: InputMaybe<Order_By>;
  FSERSYS?: InputMaybe<Order_By>;
  FSERVEN?: InputMaybe<Order_By>;
  GENBD?: InputMaybe<Order_By>;
  GENHOS?: InputMaybe<Order_By>;
  GENSYS?: InputMaybe<Order_By>;
  GENVEN?: InputMaybe<Order_By>;
  GERSVHOS?: InputMaybe<Order_By>;
  GERSVSYS?: InputMaybe<Order_By>;
  GERSVVEN?: InputMaybe<Order_By>;
  HOSPBD?: InputMaybe<Order_By>;
  ICFBD88?: InputMaybe<Order_By>;
  ICFHOS?: InputMaybe<Order_By>;
  ICFSYS?: InputMaybe<Order_By>;
  ICFVEN?: InputMaybe<Order_By>;
  ICLABHOS?: InputMaybe<Order_By>;
  ICLABSYS?: InputMaybe<Order_By>;
  ICLABVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  MAMMSHOS?: InputMaybe<Order_By>;
  MAMMSSYS?: InputMaybe<Order_By>;
  MAMMSVEN?: InputMaybe<Order_By>;
  MSICBD?: InputMaybe<Order_By>;
  MSICHOS?: InputMaybe<Order_By>;
  MSICSYS?: InputMaybe<Order_By>;
  MSICVEN?: InputMaybe<Order_By>;
  NICBD?: InputMaybe<Order_By>;
  NICHOS?: InputMaybe<Order_By>;
  NICSYS?: InputMaybe<Order_By>;
  NICVEN?: InputMaybe<Order_By>;
  NINTBD?: InputMaybe<Order_By>;
  NINTHOS?: InputMaybe<Order_By>;
  NINTSYS?: InputMaybe<Order_By>;
  NINTVEN?: InputMaybe<Order_By>;
  OBBD?: InputMaybe<Order_By>;
  OBHOS?: InputMaybe<Order_By>;
  OBLEV?: InputMaybe<Order_By>;
  OBSYS?: InputMaybe<Order_By>;
  OBVEN?: InputMaybe<Order_By>;
  OPCENHOS?: InputMaybe<Order_By>;
  OPCENSYS?: InputMaybe<Order_By>;
  OPCENVEN?: InputMaybe<Order_By>;
  OSPOTH?: InputMaybe<Order_By>;
  OTHBD94?: InputMaybe<Order_By>;
  OTHCRHOS?: InputMaybe<Order_By>;
  OTHCRSYS?: InputMaybe<Order_By>;
  OTHCRVEN?: InputMaybe<Order_By>;
  OTHIC?: InputMaybe<Order_By>;
  OTHICBD?: InputMaybe<Order_By>;
  OTHIHOS?: InputMaybe<Order_By>;
  OTHISYS?: InputMaybe<Order_By>;
  OTHIVEN?: InputMaybe<Order_By>;
  OTHLBD94?: InputMaybe<Order_By>;
  OTHLTHOS?: InputMaybe<Order_By>;
  OTHLTSYS?: InputMaybe<Order_By>;
  OTHLTVEN?: InputMaybe<Order_By>;
  OTHOTH?: InputMaybe<Order_By>;
  PCARDHOS?: InputMaybe<Order_By>;
  PCARDSYS?: InputMaybe<Order_By>;
  PCARDVEN?: InputMaybe<Order_By>;
  PCLABHOS?: InputMaybe<Order_By>;
  PCLABSYS?: InputMaybe<Order_By>;
  PCLABVEN?: InputMaybe<Order_By>;
  PEDBD?: InputMaybe<Order_By>;
  PEDCSHOS?: InputMaybe<Order_By>;
  PEDCSSYS?: InputMaybe<Order_By>;
  PEDCSVEN?: InputMaybe<Order_By>;
  PEDEHOS?: InputMaybe<Order_By>;
  PEDESYS?: InputMaybe<Order_By>;
  PEDEVEN?: InputMaybe<Order_By>;
  PEDHOS?: InputMaybe<Order_By>;
  PEDICBD?: InputMaybe<Order_By>;
  PEDICHOS?: InputMaybe<Order_By>;
  PEDICSYS?: InputMaybe<Order_By>;
  PEDICVEN?: InputMaybe<Order_By>;
  PEDSYS?: InputMaybe<Order_By>;
  PEDVEN?: InputMaybe<Order_By>;
  PELABHOS?: InputMaybe<Order_By>;
  PELABSYS?: InputMaybe<Order_By>;
  PELABVEN?: InputMaybe<Order_By>;
  PEMERHOS?: InputMaybe<Order_By>;
  PEMERSYS?: InputMaybe<Order_By>;
  PEMERVEN?: InputMaybe<Order_By>;
  PSYBD?: InputMaybe<Order_By>;
  PSYHOS?: InputMaybe<Order_By>;
  PSYSYS?: InputMaybe<Order_By>;
  PSYVEN?: InputMaybe<Order_By>;
  REHABBD?: InputMaybe<Order_By>;
  REHABHOS?: InputMaybe<Order_By>;
  REHABSYS?: InputMaybe<Order_By>;
  REHABVEN?: InputMaybe<Order_By>;
  SNBD88?: InputMaybe<Order_By>;
  SNHOS?: InputMaybe<Order_By>;
  SNSYS?: InputMaybe<Order_By>;
  SNVEN?: InputMaybe<Order_By>;
  SPCICBD?: InputMaybe<Order_By>;
  SPCICHOS?: InputMaybe<Order_By>;
  SPCICSYS?: InputMaybe<Order_By>;
  SPCICVEN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  TRAUMHOS?: InputMaybe<Order_By>;
  TRAUML90?: InputMaybe<Order_By>;
  TRAUMSYS?: InputMaybe<Order_By>;
  TRAUMVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS21SVC1 */
export type As21Svc1_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21SVC1" */
export enum As21Svc1_Select_Column {
  /** column name */
  Acardhos = 'ACARDHOS',
  /** column name */
  Acardsys = 'ACARDSYS',
  /** column name */
  Acardven = 'ACARDVEN',
  /** column name */
  Aclabhos = 'ACLABHOS',
  /** column name */
  Aclabsys = 'ACLABSYS',
  /** column name */
  Aclabven = 'ACLABVEN',
  /** column name */
  Acuhos = 'ACUHOS',
  /** column name */
  Acultbd = 'ACULTBD',
  /** column name */
  Acusys = 'ACUSYS',
  /** column name */
  Acuven = 'ACUVEN',
  /** column name */
  Adtchos = 'ADTCHOS',
  /** column name */
  Adtcsys = 'ADTCSYS',
  /** column name */
  Adtcven = 'ADTCVEN',
  /** column name */
  Adtehos = 'ADTEHOS',
  /** column name */
  Adtesys = 'ADTESYS',
  /** column name */
  Adteven = 'ADTEVEN',
  /** column name */
  Adulthos = 'ADULTHOS',
  /** column name */
  Adultsys = 'ADULTSYS',
  /** column name */
  Adultven = 'ADULTVEN',
  /** column name */
  Airbhos = 'AIRBHOS',
  /** column name */
  Airbroom = 'AIRBROOM',
  /** column name */
  Airbsys = 'AIRBSYS',
  /** column name */
  Airbven = 'AIRBVEN',
  /** column name */
  Alchbd = 'ALCHBD',
  /** column name */
  Alchhos = 'ALCHHOS',
  /** column name */
  Alchsys = 'ALCHSYS',
  /** column name */
  Alchven = 'ALCHVEN',
  /** column name */
  Alzhos = 'ALZHOS',
  /** column name */
  Alzsys = 'ALZSYS',
  /** column name */
  Alzven = 'ALZVEN',
  /** column name */
  Ambahos = 'AMBAHOS',
  /** column name */
  Ambasys = 'AMBASYS',
  /** column name */
  Ambaven = 'AMBAVEN',
  /** column name */
  Ambhos = 'AMBHOS',
  /** column name */
  Ambshos = 'AMBSHOS',
  /** column name */
  Ambssys = 'AMBSSYS',
  /** column name */
  Ambsven = 'AMBSVEN',
  /** column name */
  Ambsys = 'AMBSYS',
  /** column name */
  Ambven = 'AMBVEN',
  /** column name */
  Arthchos = 'ARTHCHOS',
  /** column name */
  Arthcsys = 'ARTHCSYS',
  /** column name */
  Arthcven = 'ARTHCVEN',
  /** column name */
  Auxhos = 'AUXHOS',
  /** column name */
  Auxsys = 'AUXSYS',
  /** column name */
  Auxven = 'AUXVEN',
  /** column name */
  Biobd = 'BIOBD',
  /** column name */
  Biohos = 'BIOHOS',
  /** column name */
  Biosys = 'BIOSYS',
  /** column name */
  Bioven = 'BIOVEN',
  /** column name */
  Bldohos = 'BLDOHOS',
  /** column name */
  Bldosys = 'BLDOSYS',
  /** column name */
  Bldoven = 'BLDOVEN',
  /** column name */
  Brnbd = 'BRNBD',
  /** column name */
  Brnhos = 'BRNHOS',
  /** column name */
  Brnsys = 'BRNSYS',
  /** column name */
  Brnven = 'BRNVEN',
  /** column name */
  Broomhos = 'BROOMHOS',
  /** column name */
  Broomsys = 'BROOMSYS',
  /** column name */
  Broomven = 'BROOMVEN',
  /** column name */
  Bwhthos = 'BWHTHOS',
  /** column name */
  Bwhtsys = 'BWHTSYS',
  /** column name */
  Bwhtven = 'BWHTVEN',
  /** column name */
  Caoshos = 'CAOSHOS',
  /** column name */
  Caossys = 'CAOSSYS',
  /** column name */
  Caosven = 'CAOSVEN',
  /** column name */
  Chabhos = 'CHABHOS',
  /** column name */
  Chabsys = 'CHABSYS',
  /** column name */
  Chabven = 'CHABVEN',
  /** column name */
  Chaphos = 'CHAPHOS',
  /** column name */
  Chapsys = 'CHAPSYS',
  /** column name */
  Chapven = 'CHAPVEN',
  /** column name */
  Chihos = 'CHIHOS',
  /** column name */
  Chisys = 'CHISYS',
  /** column name */
  Chiven = 'CHIVEN',
  /** column name */
  Chthhos = 'CHTHHOS',
  /** column name */
  Chthsys = 'CHTHSYS',
  /** column name */
  Chthven = 'CHTHVEN',
  /** column name */
  Cicbd = 'CICBD',
  /** column name */
  Cichos = 'CICHOS',
  /** column name */
  Cicsys = 'CICSYS',
  /** column name */
  Cicven = 'CICVEN',
  /** column name */
  Cmngthos = 'CMNGTHOS',
  /** column name */
  Cmngtsys = 'CMNGTSYS',
  /** column name */
  Cmngtven = 'CMNGTVEN',
  /** column name */
  Comphos = 'COMPHOS',
  /** column name */
  Compsys = 'COMPSYS',
  /** column name */
  Compven = 'COMPVEN',
  /** column name */
  Coutrhos = 'COUTRHOS',
  /** column name */
  Coutrsys = 'COUTRSYS',
  /** column name */
  Coutrven = 'COUTRVEN',
  /** column name */
  Cprevhos = 'CPREVHOS',
  /** column name */
  Cprevsys = 'CPREVSYS',
  /** column name */
  Cprevven = 'CPREVVEN',
  /** column name */
  Cwellhos = 'CWELLHOS',
  /** column name */
  Cwellsys = 'CWELLSYS',
  /** column name */
  Cwellven = 'CWELLVEN',
  /** column name */
  Dentshos = 'DENTSHOS',
  /** column name */
  Dentssys = 'DENTSSYS',
  /** column name */
  Dentsven = 'DENTSVEN',
  /** column name */
  Dpphos = 'DPPHOS',
  /** column name */
  Dppsys = 'DPPSYS',
  /** column name */
  Dppven = 'DPPVEN',
  /** column name */
  Emdephos = 'EMDEPHOS',
  /** column name */
  Emdepsys = 'EMDEPSYS',
  /** column name */
  Emdepven = 'EMDEPVEN',
  /** column name */
  Emsshos = 'EMSSHOS',
  /** column name */
  Emsssys = 'EMSSSYS',
  /** column name */
  Emssven = 'EMSSVEN',
  /** column name */
  Enbhos = 'ENBHOS',
  /** column name */
  Enbsys = 'ENBSYS',
  /** column name */
  Enbven = 'ENBVEN',
  /** column name */
  Endoahos = 'ENDOAHOS',
  /** column name */
  Endoasys = 'ENDOASYS',
  /** column name */
  Endoaven = 'ENDOAVEN',
  /** column name */
  Endochos = 'ENDOCHOS',
  /** column name */
  Endocsys = 'ENDOCSYS',
  /** column name */
  Endocven = 'ENDOCVEN',
  /** column name */
  Endoehos = 'ENDOEHOS',
  /** column name */
  Endoesys = 'ENDOESYS',
  /** column name */
  Endoeven = 'ENDOEVEN',
  /** column name */
  Endorhos = 'ENDORHOS',
  /** column name */
  Endorsys = 'ENDORSYS',
  /** column name */
  Endorven = 'ENDORVEN',
  /** column name */
  Endouhos = 'ENDOUHOS',
  /** column name */
  Endousys = 'ENDOUSYS',
  /** column name */
  Endouven = 'ENDOUVEN',
  /** column name */
  Enrhos = 'ENRHOS',
  /** column name */
  Enrsys = 'ENRSYS',
  /** column name */
  Enrven = 'ENRVEN',
  /** column name */
  Eswlhos = 'ESWLHOS',
  /** column name */
  Eswlsys = 'ESWLSYS',
  /** column name */
  Eswlven = 'ESWLVEN',
  /** column name */
  Fitchos = 'FITCHOS',
  /** column name */
  Fitcsys = 'FITCSYS',
  /** column name */
  Fitcven = 'FITCVEN',
  /** column name */
  Frtchos = 'FRTCHOS',
  /** column name */
  Frtcsys = 'FRTCSYS',
  /** column name */
  Frtcven = 'FRTCVEN',
  /** column name */
  Fserhos = 'FSERHOS',
  /** column name */
  Fsersys = 'FSERSYS',
  /** column name */
  Fserven = 'FSERVEN',
  /** column name */
  Genbd = 'GENBD',
  /** column name */
  Genhos = 'GENHOS',
  /** column name */
  Gensys = 'GENSYS',
  /** column name */
  Genven = 'GENVEN',
  /** column name */
  Gersvhos = 'GERSVHOS',
  /** column name */
  Gersvsys = 'GERSVSYS',
  /** column name */
  Gersvven = 'GERSVVEN',
  /** column name */
  Hospbd = 'HOSPBD',
  /** column name */
  Icfbd88 = 'ICFBD88',
  /** column name */
  Icfhos = 'ICFHOS',
  /** column name */
  Icfsys = 'ICFSYS',
  /** column name */
  Icfven = 'ICFVEN',
  /** column name */
  Iclabhos = 'ICLABHOS',
  /** column name */
  Iclabsys = 'ICLABSYS',
  /** column name */
  Iclabven = 'ICLABVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Mammshos = 'MAMMSHOS',
  /** column name */
  Mammssys = 'MAMMSSYS',
  /** column name */
  Mammsven = 'MAMMSVEN',
  /** column name */
  Msicbd = 'MSICBD',
  /** column name */
  Msichos = 'MSICHOS',
  /** column name */
  Msicsys = 'MSICSYS',
  /** column name */
  Msicven = 'MSICVEN',
  /** column name */
  Nicbd = 'NICBD',
  /** column name */
  Nichos = 'NICHOS',
  /** column name */
  Nicsys = 'NICSYS',
  /** column name */
  Nicven = 'NICVEN',
  /** column name */
  Nintbd = 'NINTBD',
  /** column name */
  Ninthos = 'NINTHOS',
  /** column name */
  Nintsys = 'NINTSYS',
  /** column name */
  Nintven = 'NINTVEN',
  /** column name */
  Obbd = 'OBBD',
  /** column name */
  Obhos = 'OBHOS',
  /** column name */
  Oblev = 'OBLEV',
  /** column name */
  Obsys = 'OBSYS',
  /** column name */
  Obven = 'OBVEN',
  /** column name */
  Opcenhos = 'OPCENHOS',
  /** column name */
  Opcensys = 'OPCENSYS',
  /** column name */
  Opcenven = 'OPCENVEN',
  /** column name */
  Ospoth = 'OSPOTH',
  /** column name */
  Othbd94 = 'OTHBD94',
  /** column name */
  Othcrhos = 'OTHCRHOS',
  /** column name */
  Othcrsys = 'OTHCRSYS',
  /** column name */
  Othcrven = 'OTHCRVEN',
  /** column name */
  Othic = 'OTHIC',
  /** column name */
  Othicbd = 'OTHICBD',
  /** column name */
  Othihos = 'OTHIHOS',
  /** column name */
  Othisys = 'OTHISYS',
  /** column name */
  Othiven = 'OTHIVEN',
  /** column name */
  Othlbd94 = 'OTHLBD94',
  /** column name */
  Othlthos = 'OTHLTHOS',
  /** column name */
  Othltsys = 'OTHLTSYS',
  /** column name */
  Othltven = 'OTHLTVEN',
  /** column name */
  Othoth = 'OTHOTH',
  /** column name */
  Pcardhos = 'PCARDHOS',
  /** column name */
  Pcardsys = 'PCARDSYS',
  /** column name */
  Pcardven = 'PCARDVEN',
  /** column name */
  Pclabhos = 'PCLABHOS',
  /** column name */
  Pclabsys = 'PCLABSYS',
  /** column name */
  Pclabven = 'PCLABVEN',
  /** column name */
  Pedbd = 'PEDBD',
  /** column name */
  Pedcshos = 'PEDCSHOS',
  /** column name */
  Pedcssys = 'PEDCSSYS',
  /** column name */
  Pedcsven = 'PEDCSVEN',
  /** column name */
  Pedehos = 'PEDEHOS',
  /** column name */
  Pedesys = 'PEDESYS',
  /** column name */
  Pedeven = 'PEDEVEN',
  /** column name */
  Pedhos = 'PEDHOS',
  /** column name */
  Pedicbd = 'PEDICBD',
  /** column name */
  Pedichos = 'PEDICHOS',
  /** column name */
  Pedicsys = 'PEDICSYS',
  /** column name */
  Pedicven = 'PEDICVEN',
  /** column name */
  Pedsys = 'PEDSYS',
  /** column name */
  Pedven = 'PEDVEN',
  /** column name */
  Pelabhos = 'PELABHOS',
  /** column name */
  Pelabsys = 'PELABSYS',
  /** column name */
  Pelabven = 'PELABVEN',
  /** column name */
  Pemerhos = 'PEMERHOS',
  /** column name */
  Pemersys = 'PEMERSYS',
  /** column name */
  Pemerven = 'PEMERVEN',
  /** column name */
  Psybd = 'PSYBD',
  /** column name */
  Psyhos = 'PSYHOS',
  /** column name */
  Psysys = 'PSYSYS',
  /** column name */
  Psyven = 'PSYVEN',
  /** column name */
  Rehabbd = 'REHABBD',
  /** column name */
  Rehabhos = 'REHABHOS',
  /** column name */
  Rehabsys = 'REHABSYS',
  /** column name */
  Rehabven = 'REHABVEN',
  /** column name */
  Snbd88 = 'SNBD88',
  /** column name */
  Snhos = 'SNHOS',
  /** column name */
  Snsys = 'SNSYS',
  /** column name */
  Snven = 'SNVEN',
  /** column name */
  Spcicbd = 'SPCICBD',
  /** column name */
  Spcichos = 'SPCICHOS',
  /** column name */
  Spcicsys = 'SPCICSYS',
  /** column name */
  Spcicven = 'SPCICVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Traumhos = 'TRAUMHOS',
  /** column name */
  Trauml90 = 'TRAUML90',
  /** column name */
  Traumsys = 'TRAUMSYS',
  /** column name */
  Traumven = 'TRAUMVEN'
}

/** input type for updating data in table "AS21SVC1" */
export type As21Svc1_Set_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BIOHOS?: InputMaybe<Scalars['String']>;
  BIOSYS?: InputMaybe<Scalars['String']>;
  BIOVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As21Svc1_Stddev_Fields = {
  __typename?: 'AS21SVC1_stddev_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As21Svc1_Stddev_Pop_Fields = {
  __typename?: 'AS21SVC1_stddev_pop_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As21Svc1_Stddev_Samp_Fields = {
  __typename?: 'AS21SVC1_stddev_samp_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS21SVC1" */
export type As21Svc1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Svc1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Svc1_Stream_Cursor_Value_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BIOHOS?: InputMaybe<Scalars['String']>;
  BIOSYS?: InputMaybe<Scalars['String']>;
  BIOVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As21Svc1_Sum_Fields = {
  __typename?: 'AS21SVC1_sum_fields';
  ACULTBD: Maybe<Scalars['float8']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  ALCHBD: Maybe<Scalars['float8']>;
  BIOBD: Maybe<Scalars['float8']>;
  BRNBD: Maybe<Scalars['float8']>;
  CICBD: Maybe<Scalars['float8']>;
  GENBD: Maybe<Scalars['float8']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  MSICBD: Maybe<Scalars['float8']>;
  NICBD: Maybe<Scalars['float8']>;
  NINTBD: Maybe<Scalars['float8']>;
  OBBD: Maybe<Scalars['float8']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PSYBD: Maybe<Scalars['float8']>;
  REHABBD: Maybe<Scalars['float8']>;
  SNBD88: Maybe<Scalars['float8']>;
  SPCICBD: Maybe<Scalars['float8']>;
};

/** update columns of table "AS21SVC1" */
export enum As21Svc1_Update_Column {
  /** column name */
  Acardhos = 'ACARDHOS',
  /** column name */
  Acardsys = 'ACARDSYS',
  /** column name */
  Acardven = 'ACARDVEN',
  /** column name */
  Aclabhos = 'ACLABHOS',
  /** column name */
  Aclabsys = 'ACLABSYS',
  /** column name */
  Aclabven = 'ACLABVEN',
  /** column name */
  Acuhos = 'ACUHOS',
  /** column name */
  Acultbd = 'ACULTBD',
  /** column name */
  Acusys = 'ACUSYS',
  /** column name */
  Acuven = 'ACUVEN',
  /** column name */
  Adtchos = 'ADTCHOS',
  /** column name */
  Adtcsys = 'ADTCSYS',
  /** column name */
  Adtcven = 'ADTCVEN',
  /** column name */
  Adtehos = 'ADTEHOS',
  /** column name */
  Adtesys = 'ADTESYS',
  /** column name */
  Adteven = 'ADTEVEN',
  /** column name */
  Adulthos = 'ADULTHOS',
  /** column name */
  Adultsys = 'ADULTSYS',
  /** column name */
  Adultven = 'ADULTVEN',
  /** column name */
  Airbhos = 'AIRBHOS',
  /** column name */
  Airbroom = 'AIRBROOM',
  /** column name */
  Airbsys = 'AIRBSYS',
  /** column name */
  Airbven = 'AIRBVEN',
  /** column name */
  Alchbd = 'ALCHBD',
  /** column name */
  Alchhos = 'ALCHHOS',
  /** column name */
  Alchsys = 'ALCHSYS',
  /** column name */
  Alchven = 'ALCHVEN',
  /** column name */
  Alzhos = 'ALZHOS',
  /** column name */
  Alzsys = 'ALZSYS',
  /** column name */
  Alzven = 'ALZVEN',
  /** column name */
  Ambahos = 'AMBAHOS',
  /** column name */
  Ambasys = 'AMBASYS',
  /** column name */
  Ambaven = 'AMBAVEN',
  /** column name */
  Ambhos = 'AMBHOS',
  /** column name */
  Ambshos = 'AMBSHOS',
  /** column name */
  Ambssys = 'AMBSSYS',
  /** column name */
  Ambsven = 'AMBSVEN',
  /** column name */
  Ambsys = 'AMBSYS',
  /** column name */
  Ambven = 'AMBVEN',
  /** column name */
  Arthchos = 'ARTHCHOS',
  /** column name */
  Arthcsys = 'ARTHCSYS',
  /** column name */
  Arthcven = 'ARTHCVEN',
  /** column name */
  Auxhos = 'AUXHOS',
  /** column name */
  Auxsys = 'AUXSYS',
  /** column name */
  Auxven = 'AUXVEN',
  /** column name */
  Biobd = 'BIOBD',
  /** column name */
  Biohos = 'BIOHOS',
  /** column name */
  Biosys = 'BIOSYS',
  /** column name */
  Bioven = 'BIOVEN',
  /** column name */
  Bldohos = 'BLDOHOS',
  /** column name */
  Bldosys = 'BLDOSYS',
  /** column name */
  Bldoven = 'BLDOVEN',
  /** column name */
  Brnbd = 'BRNBD',
  /** column name */
  Brnhos = 'BRNHOS',
  /** column name */
  Brnsys = 'BRNSYS',
  /** column name */
  Brnven = 'BRNVEN',
  /** column name */
  Broomhos = 'BROOMHOS',
  /** column name */
  Broomsys = 'BROOMSYS',
  /** column name */
  Broomven = 'BROOMVEN',
  /** column name */
  Bwhthos = 'BWHTHOS',
  /** column name */
  Bwhtsys = 'BWHTSYS',
  /** column name */
  Bwhtven = 'BWHTVEN',
  /** column name */
  Caoshos = 'CAOSHOS',
  /** column name */
  Caossys = 'CAOSSYS',
  /** column name */
  Caosven = 'CAOSVEN',
  /** column name */
  Chabhos = 'CHABHOS',
  /** column name */
  Chabsys = 'CHABSYS',
  /** column name */
  Chabven = 'CHABVEN',
  /** column name */
  Chaphos = 'CHAPHOS',
  /** column name */
  Chapsys = 'CHAPSYS',
  /** column name */
  Chapven = 'CHAPVEN',
  /** column name */
  Chihos = 'CHIHOS',
  /** column name */
  Chisys = 'CHISYS',
  /** column name */
  Chiven = 'CHIVEN',
  /** column name */
  Chthhos = 'CHTHHOS',
  /** column name */
  Chthsys = 'CHTHSYS',
  /** column name */
  Chthven = 'CHTHVEN',
  /** column name */
  Cicbd = 'CICBD',
  /** column name */
  Cichos = 'CICHOS',
  /** column name */
  Cicsys = 'CICSYS',
  /** column name */
  Cicven = 'CICVEN',
  /** column name */
  Cmngthos = 'CMNGTHOS',
  /** column name */
  Cmngtsys = 'CMNGTSYS',
  /** column name */
  Cmngtven = 'CMNGTVEN',
  /** column name */
  Comphos = 'COMPHOS',
  /** column name */
  Compsys = 'COMPSYS',
  /** column name */
  Compven = 'COMPVEN',
  /** column name */
  Coutrhos = 'COUTRHOS',
  /** column name */
  Coutrsys = 'COUTRSYS',
  /** column name */
  Coutrven = 'COUTRVEN',
  /** column name */
  Cprevhos = 'CPREVHOS',
  /** column name */
  Cprevsys = 'CPREVSYS',
  /** column name */
  Cprevven = 'CPREVVEN',
  /** column name */
  Cwellhos = 'CWELLHOS',
  /** column name */
  Cwellsys = 'CWELLSYS',
  /** column name */
  Cwellven = 'CWELLVEN',
  /** column name */
  Dentshos = 'DENTSHOS',
  /** column name */
  Dentssys = 'DENTSSYS',
  /** column name */
  Dentsven = 'DENTSVEN',
  /** column name */
  Dpphos = 'DPPHOS',
  /** column name */
  Dppsys = 'DPPSYS',
  /** column name */
  Dppven = 'DPPVEN',
  /** column name */
  Emdephos = 'EMDEPHOS',
  /** column name */
  Emdepsys = 'EMDEPSYS',
  /** column name */
  Emdepven = 'EMDEPVEN',
  /** column name */
  Emsshos = 'EMSSHOS',
  /** column name */
  Emsssys = 'EMSSSYS',
  /** column name */
  Emssven = 'EMSSVEN',
  /** column name */
  Enbhos = 'ENBHOS',
  /** column name */
  Enbsys = 'ENBSYS',
  /** column name */
  Enbven = 'ENBVEN',
  /** column name */
  Endoahos = 'ENDOAHOS',
  /** column name */
  Endoasys = 'ENDOASYS',
  /** column name */
  Endoaven = 'ENDOAVEN',
  /** column name */
  Endochos = 'ENDOCHOS',
  /** column name */
  Endocsys = 'ENDOCSYS',
  /** column name */
  Endocven = 'ENDOCVEN',
  /** column name */
  Endoehos = 'ENDOEHOS',
  /** column name */
  Endoesys = 'ENDOESYS',
  /** column name */
  Endoeven = 'ENDOEVEN',
  /** column name */
  Endorhos = 'ENDORHOS',
  /** column name */
  Endorsys = 'ENDORSYS',
  /** column name */
  Endorven = 'ENDORVEN',
  /** column name */
  Endouhos = 'ENDOUHOS',
  /** column name */
  Endousys = 'ENDOUSYS',
  /** column name */
  Endouven = 'ENDOUVEN',
  /** column name */
  Enrhos = 'ENRHOS',
  /** column name */
  Enrsys = 'ENRSYS',
  /** column name */
  Enrven = 'ENRVEN',
  /** column name */
  Eswlhos = 'ESWLHOS',
  /** column name */
  Eswlsys = 'ESWLSYS',
  /** column name */
  Eswlven = 'ESWLVEN',
  /** column name */
  Fitchos = 'FITCHOS',
  /** column name */
  Fitcsys = 'FITCSYS',
  /** column name */
  Fitcven = 'FITCVEN',
  /** column name */
  Frtchos = 'FRTCHOS',
  /** column name */
  Frtcsys = 'FRTCSYS',
  /** column name */
  Frtcven = 'FRTCVEN',
  /** column name */
  Fserhos = 'FSERHOS',
  /** column name */
  Fsersys = 'FSERSYS',
  /** column name */
  Fserven = 'FSERVEN',
  /** column name */
  Genbd = 'GENBD',
  /** column name */
  Genhos = 'GENHOS',
  /** column name */
  Gensys = 'GENSYS',
  /** column name */
  Genven = 'GENVEN',
  /** column name */
  Gersvhos = 'GERSVHOS',
  /** column name */
  Gersvsys = 'GERSVSYS',
  /** column name */
  Gersvven = 'GERSVVEN',
  /** column name */
  Hospbd = 'HOSPBD',
  /** column name */
  Icfbd88 = 'ICFBD88',
  /** column name */
  Icfhos = 'ICFHOS',
  /** column name */
  Icfsys = 'ICFSYS',
  /** column name */
  Icfven = 'ICFVEN',
  /** column name */
  Iclabhos = 'ICLABHOS',
  /** column name */
  Iclabsys = 'ICLABSYS',
  /** column name */
  Iclabven = 'ICLABVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Mammshos = 'MAMMSHOS',
  /** column name */
  Mammssys = 'MAMMSSYS',
  /** column name */
  Mammsven = 'MAMMSVEN',
  /** column name */
  Msicbd = 'MSICBD',
  /** column name */
  Msichos = 'MSICHOS',
  /** column name */
  Msicsys = 'MSICSYS',
  /** column name */
  Msicven = 'MSICVEN',
  /** column name */
  Nicbd = 'NICBD',
  /** column name */
  Nichos = 'NICHOS',
  /** column name */
  Nicsys = 'NICSYS',
  /** column name */
  Nicven = 'NICVEN',
  /** column name */
  Nintbd = 'NINTBD',
  /** column name */
  Ninthos = 'NINTHOS',
  /** column name */
  Nintsys = 'NINTSYS',
  /** column name */
  Nintven = 'NINTVEN',
  /** column name */
  Obbd = 'OBBD',
  /** column name */
  Obhos = 'OBHOS',
  /** column name */
  Oblev = 'OBLEV',
  /** column name */
  Obsys = 'OBSYS',
  /** column name */
  Obven = 'OBVEN',
  /** column name */
  Opcenhos = 'OPCENHOS',
  /** column name */
  Opcensys = 'OPCENSYS',
  /** column name */
  Opcenven = 'OPCENVEN',
  /** column name */
  Ospoth = 'OSPOTH',
  /** column name */
  Othbd94 = 'OTHBD94',
  /** column name */
  Othcrhos = 'OTHCRHOS',
  /** column name */
  Othcrsys = 'OTHCRSYS',
  /** column name */
  Othcrven = 'OTHCRVEN',
  /** column name */
  Othic = 'OTHIC',
  /** column name */
  Othicbd = 'OTHICBD',
  /** column name */
  Othihos = 'OTHIHOS',
  /** column name */
  Othisys = 'OTHISYS',
  /** column name */
  Othiven = 'OTHIVEN',
  /** column name */
  Othlbd94 = 'OTHLBD94',
  /** column name */
  Othlthos = 'OTHLTHOS',
  /** column name */
  Othltsys = 'OTHLTSYS',
  /** column name */
  Othltven = 'OTHLTVEN',
  /** column name */
  Othoth = 'OTHOTH',
  /** column name */
  Pcardhos = 'PCARDHOS',
  /** column name */
  Pcardsys = 'PCARDSYS',
  /** column name */
  Pcardven = 'PCARDVEN',
  /** column name */
  Pclabhos = 'PCLABHOS',
  /** column name */
  Pclabsys = 'PCLABSYS',
  /** column name */
  Pclabven = 'PCLABVEN',
  /** column name */
  Pedbd = 'PEDBD',
  /** column name */
  Pedcshos = 'PEDCSHOS',
  /** column name */
  Pedcssys = 'PEDCSSYS',
  /** column name */
  Pedcsven = 'PEDCSVEN',
  /** column name */
  Pedehos = 'PEDEHOS',
  /** column name */
  Pedesys = 'PEDESYS',
  /** column name */
  Pedeven = 'PEDEVEN',
  /** column name */
  Pedhos = 'PEDHOS',
  /** column name */
  Pedicbd = 'PEDICBD',
  /** column name */
  Pedichos = 'PEDICHOS',
  /** column name */
  Pedicsys = 'PEDICSYS',
  /** column name */
  Pedicven = 'PEDICVEN',
  /** column name */
  Pedsys = 'PEDSYS',
  /** column name */
  Pedven = 'PEDVEN',
  /** column name */
  Pelabhos = 'PELABHOS',
  /** column name */
  Pelabsys = 'PELABSYS',
  /** column name */
  Pelabven = 'PELABVEN',
  /** column name */
  Pemerhos = 'PEMERHOS',
  /** column name */
  Pemersys = 'PEMERSYS',
  /** column name */
  Pemerven = 'PEMERVEN',
  /** column name */
  Psybd = 'PSYBD',
  /** column name */
  Psyhos = 'PSYHOS',
  /** column name */
  Psysys = 'PSYSYS',
  /** column name */
  Psyven = 'PSYVEN',
  /** column name */
  Rehabbd = 'REHABBD',
  /** column name */
  Rehabhos = 'REHABHOS',
  /** column name */
  Rehabsys = 'REHABSYS',
  /** column name */
  Rehabven = 'REHABVEN',
  /** column name */
  Snbd88 = 'SNBD88',
  /** column name */
  Snhos = 'SNHOS',
  /** column name */
  Snsys = 'SNSYS',
  /** column name */
  Snven = 'SNVEN',
  /** column name */
  Spcicbd = 'SPCICBD',
  /** column name */
  Spcichos = 'SPCICHOS',
  /** column name */
  Spcicsys = 'SPCICSYS',
  /** column name */
  Spcicven = 'SPCICVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Traumhos = 'TRAUMHOS',
  /** column name */
  Trauml90 = 'TRAUML90',
  /** column name */
  Traumsys = 'TRAUMSYS',
  /** column name */
  Traumven = 'TRAUMVEN'
}

export type As21Svc1_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As21Svc1_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Svc1_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Svc1_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As21Svc1_Var_Pop_Fields = {
  __typename?: 'AS21SVC1_var_pop_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As21Svc1_Var_Samp_Fields = {
  __typename?: 'AS21SVC1_var_samp_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As21Svc1_Variance_Fields = {
  __typename?: 'AS21SVC1_variance_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS21SVC2" */
export type As21Svc2 = {
  __typename?: 'AS21SVC2';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS21SVC2" */
export type As21Svc2_Aggregate = {
  __typename?: 'AS21SVC2_aggregate';
  aggregate: Maybe<As21Svc2_Aggregate_Fields>;
  nodes: Array<As21Svc2>;
};

/** aggregate fields of "AS21SVC2" */
export type As21Svc2_Aggregate_Fields = {
  __typename?: 'AS21SVC2_aggregate_fields';
  avg: Maybe<As21Svc2_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As21Svc2_Max_Fields>;
  min: Maybe<As21Svc2_Min_Fields>;
  stddev: Maybe<As21Svc2_Stddev_Fields>;
  stddev_pop: Maybe<As21Svc2_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As21Svc2_Stddev_Samp_Fields>;
  sum: Maybe<As21Svc2_Sum_Fields>;
  var_pop: Maybe<As21Svc2_Var_Pop_Fields>;
  var_samp: Maybe<As21Svc2_Var_Samp_Fields>;
  variance: Maybe<As21Svc2_Variance_Fields>;
};


/** aggregate fields of "AS21SVC2" */
export type As21Svc2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Svc2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As21Svc2_Avg_Fields = {
  __typename?: 'AS21SVC2_avg_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS21SVC2". All fields are combined with a logical 'AND'. */
export type As21Svc2_Bool_Exp = {
  AIDSSHOS?: InputMaybe<String_Comparison_Exp>;
  AIDSSSYS?: InputMaybe<String_Comparison_Exp>;
  AIDSSVEN?: InputMaybe<String_Comparison_Exp>;
  ASSTLHOS?: InputMaybe<String_Comparison_Exp>;
  ASSTLSYS?: InputMaybe<String_Comparison_Exp>;
  ASSTLVEN?: InputMaybe<String_Comparison_Exp>;
  BEAMHOS?: InputMaybe<String_Comparison_Exp>;
  BEAMSYS?: InputMaybe<String_Comparison_Exp>;
  BEAMVEN?: InputMaybe<String_Comparison_Exp>;
  BRADHOS?: InputMaybe<String_Comparison_Exp>;
  BRADSYS?: InputMaybe<String_Comparison_Exp>;
  BRADVEN?: InputMaybe<String_Comparison_Exp>;
  CTSCNHOS?: InputMaybe<String_Comparison_Exp>;
  CTSCNSYS?: InputMaybe<String_Comparison_Exp>;
  CTSCNVEN?: InputMaybe<String_Comparison_Exp>;
  DRADFHOS?: InputMaybe<String_Comparison_Exp>;
  DRADFSYS?: InputMaybe<String_Comparison_Exp>;
  DRADFVEN?: InputMaybe<String_Comparison_Exp>;
  EBCTHOS?: InputMaybe<String_Comparison_Exp>;
  EBCTSYS?: InputMaybe<String_Comparison_Exp>;
  EBCTVEN?: InputMaybe<String_Comparison_Exp>;
  FFDMHOS?: InputMaybe<String_Comparison_Exp>;
  FFDMSYS?: InputMaybe<String_Comparison_Exp>;
  FFDMVEN?: InputMaybe<String_Comparison_Exp>;
  GNTCHOS?: InputMaybe<String_Comparison_Exp>;
  GNTCSYS?: InputMaybe<String_Comparison_Exp>;
  GNTCVEN?: InputMaybe<String_Comparison_Exp>;
  HEMOHOS?: InputMaybe<String_Comparison_Exp>;
  HEMOSYS?: InputMaybe<String_Comparison_Exp>;
  HEMOVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHCHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHCSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHCVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHFHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHFSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHFVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHSHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHSSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHSVEN?: InputMaybe<String_Comparison_Exp>;
  HLTRHOS?: InputMaybe<String_Comparison_Exp>;
  HLTRSYS?: InputMaybe<String_Comparison_Exp>;
  HLTRVEN?: InputMaybe<String_Comparison_Exp>;
  HOMEHHOS?: InputMaybe<String_Comparison_Exp>;
  HOMEHSYS?: InputMaybe<String_Comparison_Exp>;
  HOMEHVEN?: InputMaybe<String_Comparison_Exp>;
  HOSPCHOS?: InputMaybe<String_Comparison_Exp>;
  HOSPCSYS?: InputMaybe<String_Comparison_Exp>;
  HOSPCVEN?: InputMaybe<String_Comparison_Exp>;
  ICARHOS?: InputMaybe<String_Comparison_Exp>;
  ICARSYS?: InputMaybe<String_Comparison_Exp>;
  ICARVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IGRTHOS?: InputMaybe<String_Comparison_Exp>;
  IGRTSYS?: InputMaybe<String_Comparison_Exp>;
  IGRTVEN?: InputMaybe<String_Comparison_Exp>;
  IMPRHOS?: InputMaybe<String_Comparison_Exp>;
  IMPRSYS?: InputMaybe<String_Comparison_Exp>;
  IMPRVEN?: InputMaybe<String_Comparison_Exp>;
  IMRIHOS?: InputMaybe<String_Comparison_Exp>;
  IMRISYS?: InputMaybe<String_Comparison_Exp>;
  IMRIVEN?: InputMaybe<String_Comparison_Exp>;
  IMRTHOS?: InputMaybe<String_Comparison_Exp>;
  IMRTSYS?: InputMaybe<String_Comparison_Exp>;
  IMRTVEN?: InputMaybe<String_Comparison_Exp>;
  IPALHOS?: InputMaybe<String_Comparison_Exp>;
  IPALSYS?: InputMaybe<String_Comparison_Exp>;
  IPALVEN?: InputMaybe<String_Comparison_Exp>;
  LINGHOS?: InputMaybe<String_Comparison_Exp>;
  LINGSYS?: InputMaybe<String_Comparison_Exp>;
  LINGVEN?: InputMaybe<String_Comparison_Exp>;
  MEALSHOS?: InputMaybe<String_Comparison_Exp>;
  MEALSSYS?: InputMaybe<String_Comparison_Exp>;
  MEALSVEN?: InputMaybe<String_Comparison_Exp>;
  MEGHOS?: InputMaybe<String_Comparison_Exp>;
  MEGSYS?: InputMaybe<String_Comparison_Exp>;
  MEGVEN?: InputMaybe<String_Comparison_Exp>;
  MOHSHOS?: InputMaybe<String_Comparison_Exp>;
  MOHSSYS?: InputMaybe<String_Comparison_Exp>;
  MOHSVEN?: InputMaybe<String_Comparison_Exp>;
  MRIHOS?: InputMaybe<String_Comparison_Exp>;
  MRISYS?: InputMaybe<String_Comparison_Exp>;
  MRIVEN?: InputMaybe<String_Comparison_Exp>;
  MSCTGHOS?: InputMaybe<String_Comparison_Exp>;
  MSCTGSYS?: InputMaybe<String_Comparison_Exp>;
  MSCTGVEN?: InputMaybe<String_Comparison_Exp>;
  MSCTHOS?: InputMaybe<String_Comparison_Exp>;
  MSCTSYS?: InputMaybe<String_Comparison_Exp>;
  MSCTVEN?: InputMaybe<String_Comparison_Exp>;
  NEROHOS?: InputMaybe<String_Comparison_Exp>;
  NEROSYS?: InputMaybe<String_Comparison_Exp>;
  NEROVEN?: InputMaybe<String_Comparison_Exp>;
  NUTRPHOS?: InputMaybe<String_Comparison_Exp>;
  NUTRPSYS?: InputMaybe<String_Comparison_Exp>;
  NUTRPVEN?: InputMaybe<String_Comparison_Exp>;
  OCCHSHOS?: InputMaybe<String_Comparison_Exp>;
  OCCHSSYS?: InputMaybe<String_Comparison_Exp>;
  OCCHSVEN?: InputMaybe<String_Comparison_Exp>;
  ONCOLHOS?: InputMaybe<String_Comparison_Exp>;
  ONCOLSYS?: InputMaybe<String_Comparison_Exp>;
  ONCOLVEN?: InputMaybe<String_Comparison_Exp>;
  OPHOSHOS?: InputMaybe<String_Comparison_Exp>;
  OPHOSSYS?: InputMaybe<String_Comparison_Exp>;
  OPHOSVEN?: InputMaybe<String_Comparison_Exp>;
  OPSRGHOS?: InputMaybe<String_Comparison_Exp>;
  OPSRGSYS?: InputMaybe<String_Comparison_Exp>;
  OPSRGVEN?: InputMaybe<String_Comparison_Exp>;
  ORTOHOS?: InputMaybe<String_Comparison_Exp>;
  ORTOSYS?: InputMaybe<String_Comparison_Exp>;
  ORTOVEN?: InputMaybe<String_Comparison_Exp>;
  PAINHOS?: InputMaybe<String_Comparison_Exp>;
  PAINSYS?: InputMaybe<String_Comparison_Exp>;
  PAINVEN?: InputMaybe<String_Comparison_Exp>;
  PALHOS?: InputMaybe<String_Comparison_Exp>;
  PALSYS?: InputMaybe<String_Comparison_Exp>;
  PALVEN?: InputMaybe<String_Comparison_Exp>;
  PATEDHOS?: InputMaybe<String_Comparison_Exp>;
  PATEDSYS?: InputMaybe<String_Comparison_Exp>;
  PATEDVEN?: InputMaybe<String_Comparison_Exp>;
  PATRPHOS?: InputMaybe<String_Comparison_Exp>;
  PATRPSYS?: InputMaybe<String_Comparison_Exp>;
  PATRPVEN?: InputMaybe<String_Comparison_Exp>;
  PCAHOS?: InputMaybe<String_Comparison_Exp>;
  PCASYS?: InputMaybe<String_Comparison_Exp>;
  PCAVEN?: InputMaybe<String_Comparison_Exp>;
  PCDEPHOS?: InputMaybe<String_Comparison_Exp>;
  PCDEPSYS?: InputMaybe<String_Comparison_Exp>;
  PCDEPVEN?: InputMaybe<String_Comparison_Exp>;
  PETCTHOS?: InputMaybe<String_Comparison_Exp>;
  PETCTSYS?: InputMaybe<String_Comparison_Exp>;
  PETCTVEN?: InputMaybe<String_Comparison_Exp>;
  PETHOS?: InputMaybe<String_Comparison_Exp>;
  PETSYS?: InputMaybe<String_Comparison_Exp>;
  PETVEN?: InputMaybe<String_Comparison_Exp>;
  PPNHOS?: InputMaybe<String_Comparison_Exp>;
  PPNSYS?: InputMaybe<String_Comparison_Exp>;
  PPNVEN?: InputMaybe<String_Comparison_Exp>;
  PSCBD?: InputMaybe<Float8_Comparison_Exp>;
  PSCISHOS?: InputMaybe<String_Comparison_Exp>;
  PSCISSYS?: InputMaybe<String_Comparison_Exp>;
  PSCISVEN?: InputMaybe<String_Comparison_Exp>;
  PSGBD?: InputMaybe<Float8_Comparison_Exp>;
  PSPIHOS?: InputMaybe<String_Comparison_Exp>;
  PSPISYS?: InputMaybe<String_Comparison_Exp>;
  PSPIVEN?: InputMaybe<String_Comparison_Exp>;
  PSSOCHOS?: InputMaybe<String_Comparison_Exp>;
  PSSOCSYS?: InputMaybe<String_Comparison_Exp>;
  PSSOCVEN?: InputMaybe<String_Comparison_Exp>;
  PSYCAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYCASYS?: InputMaybe<String_Comparison_Exp>;
  PSYCAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYEDHOS?: InputMaybe<String_Comparison_Exp>;
  PSYEDSYS?: InputMaybe<String_Comparison_Exp>;
  PSYEDVEN?: InputMaybe<String_Comparison_Exp>;
  PSYEMHOS?: InputMaybe<String_Comparison_Exp>;
  PSYEMSYS?: InputMaybe<String_Comparison_Exp>;
  PSYEMVEN?: InputMaybe<String_Comparison_Exp>;
  PSYGRHOS?: InputMaybe<String_Comparison_Exp>;
  PSYGRSYS?: InputMaybe<String_Comparison_Exp>;
  PSYGRVEN?: InputMaybe<String_Comparison_Exp>;
  PSYLSHOS?: InputMaybe<String_Comparison_Exp>;
  PSYLSSYS?: InputMaybe<String_Comparison_Exp>;
  PSYLSVEN?: InputMaybe<String_Comparison_Exp>;
  PSYOIHOS?: InputMaybe<String_Comparison_Exp>;
  PSYOISYS?: InputMaybe<String_Comparison_Exp>;
  PSYOIVEN?: InputMaybe<String_Comparison_Exp>;
  PSYOPHOS?: InputMaybe<String_Comparison_Exp>;
  PSYOPSYS?: InputMaybe<String_Comparison_Exp>;
  PSYOPVEN?: InputMaybe<String_Comparison_Exp>;
  PSYPHAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYPHASYS?: InputMaybe<String_Comparison_Exp>;
  PSYPHAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYPHCHOS?: InputMaybe<String_Comparison_Exp>;
  PSYPHCSYS?: InputMaybe<String_Comparison_Exp>;
  PSYPHCVEN?: InputMaybe<String_Comparison_Exp>;
  PSYTRAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYTRASYS?: InputMaybe<String_Comparison_Exp>;
  PSYTRAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYTRPHOS?: InputMaybe<String_Comparison_Exp>;
  PSYTRPSYS?: InputMaybe<String_Comparison_Exp>;
  PSYTRPVEN?: InputMaybe<String_Comparison_Exp>;
  PTONHOS?: InputMaybe<String_Comparison_Exp>;
  PTONSYS?: InputMaybe<String_Comparison_Exp>;
  PTONVEN?: InputMaybe<String_Comparison_Exp>;
  RASTHOS?: InputMaybe<String_Comparison_Exp>;
  RASTSYS?: InputMaybe<String_Comparison_Exp>;
  RASTVEN?: InputMaybe<String_Comparison_Exp>;
  RBOTHOS?: InputMaybe<String_Comparison_Exp>;
  RBOTSYS?: InputMaybe<String_Comparison_Exp>;
  RBOTVEN?: InputMaybe<String_Comparison_Exp>;
  REDSHOS?: InputMaybe<String_Comparison_Exp>;
  REDSSYS?: InputMaybe<String_Comparison_Exp>;
  REDSVEN?: InputMaybe<String_Comparison_Exp>;
  RETIRHOS?: InputMaybe<String_Comparison_Exp>;
  RETIRSYS?: InputMaybe<String_Comparison_Exp>;
  RETIRVEN?: InputMaybe<String_Comparison_Exp>;
  RHBOPHOS?: InputMaybe<String_Comparison_Exp>;
  RHBOPSYS?: InputMaybe<String_Comparison_Exp>;
  RHBOPVEN?: InputMaybe<String_Comparison_Exp>;
  ROBOHOS?: InputMaybe<String_Comparison_Exp>;
  ROBOSYS?: InputMaybe<String_Comparison_Exp>;
  ROBOVEN?: InputMaybe<String_Comparison_Exp>;
  RPRSHOS?: InputMaybe<String_Comparison_Exp>;
  RPRSSYS?: InputMaybe<String_Comparison_Exp>;
  RPRSVEN?: InputMaybe<String_Comparison_Exp>;
  RSIMHOS?: InputMaybe<String_Comparison_Exp>;
  RSIMSYS?: InputMaybe<String_Comparison_Exp>;
  RSIMVEN?: InputMaybe<String_Comparison_Exp>;
  SPECTHOS?: InputMaybe<String_Comparison_Exp>;
  SPECTSYS?: InputMaybe<String_Comparison_Exp>;
  SPECTVEN?: InputMaybe<String_Comparison_Exp>;
  SPHSHOS?: InputMaybe<String_Comparison_Exp>;
  SPHSSYS?: InputMaybe<String_Comparison_Exp>;
  SPHSVEN?: InputMaybe<String_Comparison_Exp>;
  SRADHOS?: InputMaybe<String_Comparison_Exp>;
  SRADSYS?: InputMaybe<String_Comparison_Exp>;
  SRADVEN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  ULTSNHOS?: InputMaybe<String_Comparison_Exp>;
  ULTSNSYS?: InputMaybe<String_Comparison_Exp>;
  ULTSNVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Svc2_Bool_Exp>>;
  _not?: InputMaybe<As21Svc2_Bool_Exp>;
  _or?: InputMaybe<Array<As21Svc2_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS21SVC2" */
export enum As21Svc2_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Svc2 = 'pk_AS21SVC2'
}

/** input type for incrementing numeric columns in table "AS21SVC2" */
export type As21Svc2_Inc_Input = {
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS21SVC2" */
export type As21Svc2_Insert_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As21Svc2_Max_Fields = {
  __typename?: 'AS21SVC2_max_fields';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As21Svc2_Min_Fields = {
  __typename?: 'AS21SVC2_min_fields';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS21SVC2" */
export type As21Svc2_Mutation_Response = {
  __typename?: 'AS21SVC2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Svc2>;
};

/** input type for inserting object relation for remote table "AS21SVC2" */
export type As21Svc2_Obj_Rel_Insert_Input = {
  data: As21Svc2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Svc2_On_Conflict>;
};

/** on_conflict condition type for table "AS21SVC2" */
export type As21Svc2_On_Conflict = {
  constraint: As21Svc2_Constraint;
  update_columns?: Array<As21Svc2_Update_Column>;
  where?: InputMaybe<As21Svc2_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21SVC2". */
export type As21Svc2_Order_By = {
  AIDSSHOS?: InputMaybe<Order_By>;
  AIDSSSYS?: InputMaybe<Order_By>;
  AIDSSVEN?: InputMaybe<Order_By>;
  ASSTLHOS?: InputMaybe<Order_By>;
  ASSTLSYS?: InputMaybe<Order_By>;
  ASSTLVEN?: InputMaybe<Order_By>;
  BEAMHOS?: InputMaybe<Order_By>;
  BEAMSYS?: InputMaybe<Order_By>;
  BEAMVEN?: InputMaybe<Order_By>;
  BRADHOS?: InputMaybe<Order_By>;
  BRADSYS?: InputMaybe<Order_By>;
  BRADVEN?: InputMaybe<Order_By>;
  CTSCNHOS?: InputMaybe<Order_By>;
  CTSCNSYS?: InputMaybe<Order_By>;
  CTSCNVEN?: InputMaybe<Order_By>;
  DRADFHOS?: InputMaybe<Order_By>;
  DRADFSYS?: InputMaybe<Order_By>;
  DRADFVEN?: InputMaybe<Order_By>;
  EBCTHOS?: InputMaybe<Order_By>;
  EBCTSYS?: InputMaybe<Order_By>;
  EBCTVEN?: InputMaybe<Order_By>;
  FFDMHOS?: InputMaybe<Order_By>;
  FFDMSYS?: InputMaybe<Order_By>;
  FFDMVEN?: InputMaybe<Order_By>;
  GNTCHOS?: InputMaybe<Order_By>;
  GNTCSYS?: InputMaybe<Order_By>;
  GNTCVEN?: InputMaybe<Order_By>;
  HEMOHOS?: InputMaybe<Order_By>;
  HEMOSYS?: InputMaybe<Order_By>;
  HEMOVEN?: InputMaybe<Order_By>;
  HLTHCHOS?: InputMaybe<Order_By>;
  HLTHCSYS?: InputMaybe<Order_By>;
  HLTHCVEN?: InputMaybe<Order_By>;
  HLTHFHOS?: InputMaybe<Order_By>;
  HLTHFSYS?: InputMaybe<Order_By>;
  HLTHFVEN?: InputMaybe<Order_By>;
  HLTHSHOS?: InputMaybe<Order_By>;
  HLTHSSYS?: InputMaybe<Order_By>;
  HLTHSVEN?: InputMaybe<Order_By>;
  HLTRHOS?: InputMaybe<Order_By>;
  HLTRSYS?: InputMaybe<Order_By>;
  HLTRVEN?: InputMaybe<Order_By>;
  HOMEHHOS?: InputMaybe<Order_By>;
  HOMEHSYS?: InputMaybe<Order_By>;
  HOMEHVEN?: InputMaybe<Order_By>;
  HOSPCHOS?: InputMaybe<Order_By>;
  HOSPCSYS?: InputMaybe<Order_By>;
  HOSPCVEN?: InputMaybe<Order_By>;
  ICARHOS?: InputMaybe<Order_By>;
  ICARSYS?: InputMaybe<Order_By>;
  ICARVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IGRTHOS?: InputMaybe<Order_By>;
  IGRTSYS?: InputMaybe<Order_By>;
  IGRTVEN?: InputMaybe<Order_By>;
  IMPRHOS?: InputMaybe<Order_By>;
  IMPRSYS?: InputMaybe<Order_By>;
  IMPRVEN?: InputMaybe<Order_By>;
  IMRIHOS?: InputMaybe<Order_By>;
  IMRISYS?: InputMaybe<Order_By>;
  IMRIVEN?: InputMaybe<Order_By>;
  IMRTHOS?: InputMaybe<Order_By>;
  IMRTSYS?: InputMaybe<Order_By>;
  IMRTVEN?: InputMaybe<Order_By>;
  IPALHOS?: InputMaybe<Order_By>;
  IPALSYS?: InputMaybe<Order_By>;
  IPALVEN?: InputMaybe<Order_By>;
  LINGHOS?: InputMaybe<Order_By>;
  LINGSYS?: InputMaybe<Order_By>;
  LINGVEN?: InputMaybe<Order_By>;
  MEALSHOS?: InputMaybe<Order_By>;
  MEALSSYS?: InputMaybe<Order_By>;
  MEALSVEN?: InputMaybe<Order_By>;
  MEGHOS?: InputMaybe<Order_By>;
  MEGSYS?: InputMaybe<Order_By>;
  MEGVEN?: InputMaybe<Order_By>;
  MOHSHOS?: InputMaybe<Order_By>;
  MOHSSYS?: InputMaybe<Order_By>;
  MOHSVEN?: InputMaybe<Order_By>;
  MRIHOS?: InputMaybe<Order_By>;
  MRISYS?: InputMaybe<Order_By>;
  MRIVEN?: InputMaybe<Order_By>;
  MSCTGHOS?: InputMaybe<Order_By>;
  MSCTGSYS?: InputMaybe<Order_By>;
  MSCTGVEN?: InputMaybe<Order_By>;
  MSCTHOS?: InputMaybe<Order_By>;
  MSCTSYS?: InputMaybe<Order_By>;
  MSCTVEN?: InputMaybe<Order_By>;
  NEROHOS?: InputMaybe<Order_By>;
  NEROSYS?: InputMaybe<Order_By>;
  NEROVEN?: InputMaybe<Order_By>;
  NUTRPHOS?: InputMaybe<Order_By>;
  NUTRPSYS?: InputMaybe<Order_By>;
  NUTRPVEN?: InputMaybe<Order_By>;
  OCCHSHOS?: InputMaybe<Order_By>;
  OCCHSSYS?: InputMaybe<Order_By>;
  OCCHSVEN?: InputMaybe<Order_By>;
  ONCOLHOS?: InputMaybe<Order_By>;
  ONCOLSYS?: InputMaybe<Order_By>;
  ONCOLVEN?: InputMaybe<Order_By>;
  OPHOSHOS?: InputMaybe<Order_By>;
  OPHOSSYS?: InputMaybe<Order_By>;
  OPHOSVEN?: InputMaybe<Order_By>;
  OPSRGHOS?: InputMaybe<Order_By>;
  OPSRGSYS?: InputMaybe<Order_By>;
  OPSRGVEN?: InputMaybe<Order_By>;
  ORTOHOS?: InputMaybe<Order_By>;
  ORTOSYS?: InputMaybe<Order_By>;
  ORTOVEN?: InputMaybe<Order_By>;
  PAINHOS?: InputMaybe<Order_By>;
  PAINSYS?: InputMaybe<Order_By>;
  PAINVEN?: InputMaybe<Order_By>;
  PALHOS?: InputMaybe<Order_By>;
  PALSYS?: InputMaybe<Order_By>;
  PALVEN?: InputMaybe<Order_By>;
  PATEDHOS?: InputMaybe<Order_By>;
  PATEDSYS?: InputMaybe<Order_By>;
  PATEDVEN?: InputMaybe<Order_By>;
  PATRPHOS?: InputMaybe<Order_By>;
  PATRPSYS?: InputMaybe<Order_By>;
  PATRPVEN?: InputMaybe<Order_By>;
  PCAHOS?: InputMaybe<Order_By>;
  PCASYS?: InputMaybe<Order_By>;
  PCAVEN?: InputMaybe<Order_By>;
  PCDEPHOS?: InputMaybe<Order_By>;
  PCDEPSYS?: InputMaybe<Order_By>;
  PCDEPVEN?: InputMaybe<Order_By>;
  PETCTHOS?: InputMaybe<Order_By>;
  PETCTSYS?: InputMaybe<Order_By>;
  PETCTVEN?: InputMaybe<Order_By>;
  PETHOS?: InputMaybe<Order_By>;
  PETSYS?: InputMaybe<Order_By>;
  PETVEN?: InputMaybe<Order_By>;
  PPNHOS?: InputMaybe<Order_By>;
  PPNSYS?: InputMaybe<Order_By>;
  PPNVEN?: InputMaybe<Order_By>;
  PSCBD?: InputMaybe<Order_By>;
  PSCISHOS?: InputMaybe<Order_By>;
  PSCISSYS?: InputMaybe<Order_By>;
  PSCISVEN?: InputMaybe<Order_By>;
  PSGBD?: InputMaybe<Order_By>;
  PSPIHOS?: InputMaybe<Order_By>;
  PSPISYS?: InputMaybe<Order_By>;
  PSPIVEN?: InputMaybe<Order_By>;
  PSSOCHOS?: InputMaybe<Order_By>;
  PSSOCSYS?: InputMaybe<Order_By>;
  PSSOCVEN?: InputMaybe<Order_By>;
  PSYCAHOS?: InputMaybe<Order_By>;
  PSYCASYS?: InputMaybe<Order_By>;
  PSYCAVEN?: InputMaybe<Order_By>;
  PSYEDHOS?: InputMaybe<Order_By>;
  PSYEDSYS?: InputMaybe<Order_By>;
  PSYEDVEN?: InputMaybe<Order_By>;
  PSYEMHOS?: InputMaybe<Order_By>;
  PSYEMSYS?: InputMaybe<Order_By>;
  PSYEMVEN?: InputMaybe<Order_By>;
  PSYGRHOS?: InputMaybe<Order_By>;
  PSYGRSYS?: InputMaybe<Order_By>;
  PSYGRVEN?: InputMaybe<Order_By>;
  PSYLSHOS?: InputMaybe<Order_By>;
  PSYLSSYS?: InputMaybe<Order_By>;
  PSYLSVEN?: InputMaybe<Order_By>;
  PSYOIHOS?: InputMaybe<Order_By>;
  PSYOISYS?: InputMaybe<Order_By>;
  PSYOIVEN?: InputMaybe<Order_By>;
  PSYOPHOS?: InputMaybe<Order_By>;
  PSYOPSYS?: InputMaybe<Order_By>;
  PSYOPVEN?: InputMaybe<Order_By>;
  PSYPHAHOS?: InputMaybe<Order_By>;
  PSYPHASYS?: InputMaybe<Order_By>;
  PSYPHAVEN?: InputMaybe<Order_By>;
  PSYPHCHOS?: InputMaybe<Order_By>;
  PSYPHCSYS?: InputMaybe<Order_By>;
  PSYPHCVEN?: InputMaybe<Order_By>;
  PSYTRAHOS?: InputMaybe<Order_By>;
  PSYTRASYS?: InputMaybe<Order_By>;
  PSYTRAVEN?: InputMaybe<Order_By>;
  PSYTRPHOS?: InputMaybe<Order_By>;
  PSYTRPSYS?: InputMaybe<Order_By>;
  PSYTRPVEN?: InputMaybe<Order_By>;
  PTONHOS?: InputMaybe<Order_By>;
  PTONSYS?: InputMaybe<Order_By>;
  PTONVEN?: InputMaybe<Order_By>;
  RASTHOS?: InputMaybe<Order_By>;
  RASTSYS?: InputMaybe<Order_By>;
  RASTVEN?: InputMaybe<Order_By>;
  RBOTHOS?: InputMaybe<Order_By>;
  RBOTSYS?: InputMaybe<Order_By>;
  RBOTVEN?: InputMaybe<Order_By>;
  REDSHOS?: InputMaybe<Order_By>;
  REDSSYS?: InputMaybe<Order_By>;
  REDSVEN?: InputMaybe<Order_By>;
  RETIRHOS?: InputMaybe<Order_By>;
  RETIRSYS?: InputMaybe<Order_By>;
  RETIRVEN?: InputMaybe<Order_By>;
  RHBOPHOS?: InputMaybe<Order_By>;
  RHBOPSYS?: InputMaybe<Order_By>;
  RHBOPVEN?: InputMaybe<Order_By>;
  ROBOHOS?: InputMaybe<Order_By>;
  ROBOSYS?: InputMaybe<Order_By>;
  ROBOVEN?: InputMaybe<Order_By>;
  RPRSHOS?: InputMaybe<Order_By>;
  RPRSSYS?: InputMaybe<Order_By>;
  RPRSVEN?: InputMaybe<Order_By>;
  RSIMHOS?: InputMaybe<Order_By>;
  RSIMSYS?: InputMaybe<Order_By>;
  RSIMVEN?: InputMaybe<Order_By>;
  SPECTHOS?: InputMaybe<Order_By>;
  SPECTSYS?: InputMaybe<Order_By>;
  SPECTVEN?: InputMaybe<Order_By>;
  SPHSHOS?: InputMaybe<Order_By>;
  SPHSSYS?: InputMaybe<Order_By>;
  SPHSVEN?: InputMaybe<Order_By>;
  SRADHOS?: InputMaybe<Order_By>;
  SRADSYS?: InputMaybe<Order_By>;
  SRADVEN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  ULTSNHOS?: InputMaybe<Order_By>;
  ULTSNSYS?: InputMaybe<Order_By>;
  ULTSNVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS21SVC2 */
export type As21Svc2_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21SVC2" */
export enum As21Svc2_Select_Column {
  /** column name */
  Aidsshos = 'AIDSSHOS',
  /** column name */
  Aidsssys = 'AIDSSSYS',
  /** column name */
  Aidssven = 'AIDSSVEN',
  /** column name */
  Asstlhos = 'ASSTLHOS',
  /** column name */
  Asstlsys = 'ASSTLSYS',
  /** column name */
  Asstlven = 'ASSTLVEN',
  /** column name */
  Beamhos = 'BEAMHOS',
  /** column name */
  Beamsys = 'BEAMSYS',
  /** column name */
  Beamven = 'BEAMVEN',
  /** column name */
  Bradhos = 'BRADHOS',
  /** column name */
  Bradsys = 'BRADSYS',
  /** column name */
  Bradven = 'BRADVEN',
  /** column name */
  Ctscnhos = 'CTSCNHOS',
  /** column name */
  Ctscnsys = 'CTSCNSYS',
  /** column name */
  Ctscnven = 'CTSCNVEN',
  /** column name */
  Dradfhos = 'DRADFHOS',
  /** column name */
  Dradfsys = 'DRADFSYS',
  /** column name */
  Dradfven = 'DRADFVEN',
  /** column name */
  Ebcthos = 'EBCTHOS',
  /** column name */
  Ebctsys = 'EBCTSYS',
  /** column name */
  Ebctven = 'EBCTVEN',
  /** column name */
  Ffdmhos = 'FFDMHOS',
  /** column name */
  Ffdmsys = 'FFDMSYS',
  /** column name */
  Ffdmven = 'FFDMVEN',
  /** column name */
  Gntchos = 'GNTCHOS',
  /** column name */
  Gntcsys = 'GNTCSYS',
  /** column name */
  Gntcven = 'GNTCVEN',
  /** column name */
  Hemohos = 'HEMOHOS',
  /** column name */
  Hemosys = 'HEMOSYS',
  /** column name */
  Hemoven = 'HEMOVEN',
  /** column name */
  Hlthchos = 'HLTHCHOS',
  /** column name */
  Hlthcsys = 'HLTHCSYS',
  /** column name */
  Hlthcven = 'HLTHCVEN',
  /** column name */
  Hlthfhos = 'HLTHFHOS',
  /** column name */
  Hlthfsys = 'HLTHFSYS',
  /** column name */
  Hlthfven = 'HLTHFVEN',
  /** column name */
  Hlthshos = 'HLTHSHOS',
  /** column name */
  Hlthssys = 'HLTHSSYS',
  /** column name */
  Hlthsven = 'HLTHSVEN',
  /** column name */
  Hltrhos = 'HLTRHOS',
  /** column name */
  Hltrsys = 'HLTRSYS',
  /** column name */
  Hltrven = 'HLTRVEN',
  /** column name */
  Homehhos = 'HOMEHHOS',
  /** column name */
  Homehsys = 'HOMEHSYS',
  /** column name */
  Homehven = 'HOMEHVEN',
  /** column name */
  Hospchos = 'HOSPCHOS',
  /** column name */
  Hospcsys = 'HOSPCSYS',
  /** column name */
  Hospcven = 'HOSPCVEN',
  /** column name */
  Icarhos = 'ICARHOS',
  /** column name */
  Icarsys = 'ICARSYS',
  /** column name */
  Icarven = 'ICARVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Igrthos = 'IGRTHOS',
  /** column name */
  Igrtsys = 'IGRTSYS',
  /** column name */
  Igrtven = 'IGRTVEN',
  /** column name */
  Imprhos = 'IMPRHOS',
  /** column name */
  Imprsys = 'IMPRSYS',
  /** column name */
  Imprven = 'IMPRVEN',
  /** column name */
  Imrihos = 'IMRIHOS',
  /** column name */
  Imrisys = 'IMRISYS',
  /** column name */
  Imriven = 'IMRIVEN',
  /** column name */
  Imrthos = 'IMRTHOS',
  /** column name */
  Imrtsys = 'IMRTSYS',
  /** column name */
  Imrtven = 'IMRTVEN',
  /** column name */
  Ipalhos = 'IPALHOS',
  /** column name */
  Ipalsys = 'IPALSYS',
  /** column name */
  Ipalven = 'IPALVEN',
  /** column name */
  Linghos = 'LINGHOS',
  /** column name */
  Lingsys = 'LINGSYS',
  /** column name */
  Lingven = 'LINGVEN',
  /** column name */
  Mealshos = 'MEALSHOS',
  /** column name */
  Mealssys = 'MEALSSYS',
  /** column name */
  Mealsven = 'MEALSVEN',
  /** column name */
  Meghos = 'MEGHOS',
  /** column name */
  Megsys = 'MEGSYS',
  /** column name */
  Megven = 'MEGVEN',
  /** column name */
  Mohshos = 'MOHSHOS',
  /** column name */
  Mohssys = 'MOHSSYS',
  /** column name */
  Mohsven = 'MOHSVEN',
  /** column name */
  Mrihos = 'MRIHOS',
  /** column name */
  Mrisys = 'MRISYS',
  /** column name */
  Mriven = 'MRIVEN',
  /** column name */
  Msctghos = 'MSCTGHOS',
  /** column name */
  Msctgsys = 'MSCTGSYS',
  /** column name */
  Msctgven = 'MSCTGVEN',
  /** column name */
  Mscthos = 'MSCTHOS',
  /** column name */
  Msctsys = 'MSCTSYS',
  /** column name */
  Msctven = 'MSCTVEN',
  /** column name */
  Nerohos = 'NEROHOS',
  /** column name */
  Nerosys = 'NEROSYS',
  /** column name */
  Neroven = 'NEROVEN',
  /** column name */
  Nutrphos = 'NUTRPHOS',
  /** column name */
  Nutrpsys = 'NUTRPSYS',
  /** column name */
  Nutrpven = 'NUTRPVEN',
  /** column name */
  Occhshos = 'OCCHSHOS',
  /** column name */
  Occhssys = 'OCCHSSYS',
  /** column name */
  Occhsven = 'OCCHSVEN',
  /** column name */
  Oncolhos = 'ONCOLHOS',
  /** column name */
  Oncolsys = 'ONCOLSYS',
  /** column name */
  Oncolven = 'ONCOLVEN',
  /** column name */
  Ophoshos = 'OPHOSHOS',
  /** column name */
  Ophossys = 'OPHOSSYS',
  /** column name */
  Ophosven = 'OPHOSVEN',
  /** column name */
  Opsrghos = 'OPSRGHOS',
  /** column name */
  Opsrgsys = 'OPSRGSYS',
  /** column name */
  Opsrgven = 'OPSRGVEN',
  /** column name */
  Ortohos = 'ORTOHOS',
  /** column name */
  Ortosys = 'ORTOSYS',
  /** column name */
  Ortoven = 'ORTOVEN',
  /** column name */
  Painhos = 'PAINHOS',
  /** column name */
  Painsys = 'PAINSYS',
  /** column name */
  Painven = 'PAINVEN',
  /** column name */
  Palhos = 'PALHOS',
  /** column name */
  Palsys = 'PALSYS',
  /** column name */
  Palven = 'PALVEN',
  /** column name */
  Patedhos = 'PATEDHOS',
  /** column name */
  Patedsys = 'PATEDSYS',
  /** column name */
  Patedven = 'PATEDVEN',
  /** column name */
  Patrphos = 'PATRPHOS',
  /** column name */
  Patrpsys = 'PATRPSYS',
  /** column name */
  Patrpven = 'PATRPVEN',
  /** column name */
  Pcahos = 'PCAHOS',
  /** column name */
  Pcasys = 'PCASYS',
  /** column name */
  Pcaven = 'PCAVEN',
  /** column name */
  Pcdephos = 'PCDEPHOS',
  /** column name */
  Pcdepsys = 'PCDEPSYS',
  /** column name */
  Pcdepven = 'PCDEPVEN',
  /** column name */
  Petcthos = 'PETCTHOS',
  /** column name */
  Petctsys = 'PETCTSYS',
  /** column name */
  Petctven = 'PETCTVEN',
  /** column name */
  Pethos = 'PETHOS',
  /** column name */
  Petsys = 'PETSYS',
  /** column name */
  Petven = 'PETVEN',
  /** column name */
  Ppnhos = 'PPNHOS',
  /** column name */
  Ppnsys = 'PPNSYS',
  /** column name */
  Ppnven = 'PPNVEN',
  /** column name */
  Pscbd = 'PSCBD',
  /** column name */
  Pscishos = 'PSCISHOS',
  /** column name */
  Pscissys = 'PSCISSYS',
  /** column name */
  Pscisven = 'PSCISVEN',
  /** column name */
  Psgbd = 'PSGBD',
  /** column name */
  Pspihos = 'PSPIHOS',
  /** column name */
  Pspisys = 'PSPISYS',
  /** column name */
  Pspiven = 'PSPIVEN',
  /** column name */
  Pssochos = 'PSSOCHOS',
  /** column name */
  Pssocsys = 'PSSOCSYS',
  /** column name */
  Pssocven = 'PSSOCVEN',
  /** column name */
  Psycahos = 'PSYCAHOS',
  /** column name */
  Psycasys = 'PSYCASYS',
  /** column name */
  Psycaven = 'PSYCAVEN',
  /** column name */
  Psyedhos = 'PSYEDHOS',
  /** column name */
  Psyedsys = 'PSYEDSYS',
  /** column name */
  Psyedven = 'PSYEDVEN',
  /** column name */
  Psyemhos = 'PSYEMHOS',
  /** column name */
  Psyemsys = 'PSYEMSYS',
  /** column name */
  Psyemven = 'PSYEMVEN',
  /** column name */
  Psygrhos = 'PSYGRHOS',
  /** column name */
  Psygrsys = 'PSYGRSYS',
  /** column name */
  Psygrven = 'PSYGRVEN',
  /** column name */
  Psylshos = 'PSYLSHOS',
  /** column name */
  Psylssys = 'PSYLSSYS',
  /** column name */
  Psylsven = 'PSYLSVEN',
  /** column name */
  Psyoihos = 'PSYOIHOS',
  /** column name */
  Psyoisys = 'PSYOISYS',
  /** column name */
  Psyoiven = 'PSYOIVEN',
  /** column name */
  Psyophos = 'PSYOPHOS',
  /** column name */
  Psyopsys = 'PSYOPSYS',
  /** column name */
  Psyopven = 'PSYOPVEN',
  /** column name */
  Psyphahos = 'PSYPHAHOS',
  /** column name */
  Psyphasys = 'PSYPHASYS',
  /** column name */
  Psyphaven = 'PSYPHAVEN',
  /** column name */
  Psyphchos = 'PSYPHCHOS',
  /** column name */
  Psyphcsys = 'PSYPHCSYS',
  /** column name */
  Psyphcven = 'PSYPHCVEN',
  /** column name */
  Psytrahos = 'PSYTRAHOS',
  /** column name */
  Psytrasys = 'PSYTRASYS',
  /** column name */
  Psytraven = 'PSYTRAVEN',
  /** column name */
  Psytrphos = 'PSYTRPHOS',
  /** column name */
  Psytrpsys = 'PSYTRPSYS',
  /** column name */
  Psytrpven = 'PSYTRPVEN',
  /** column name */
  Ptonhos = 'PTONHOS',
  /** column name */
  Ptonsys = 'PTONSYS',
  /** column name */
  Ptonven = 'PTONVEN',
  /** column name */
  Rasthos = 'RASTHOS',
  /** column name */
  Rastsys = 'RASTSYS',
  /** column name */
  Rastven = 'RASTVEN',
  /** column name */
  Rbothos = 'RBOTHOS',
  /** column name */
  Rbotsys = 'RBOTSYS',
  /** column name */
  Rbotven = 'RBOTVEN',
  /** column name */
  Redshos = 'REDSHOS',
  /** column name */
  Redssys = 'REDSSYS',
  /** column name */
  Redsven = 'REDSVEN',
  /** column name */
  Retirhos = 'RETIRHOS',
  /** column name */
  Retirsys = 'RETIRSYS',
  /** column name */
  Retirven = 'RETIRVEN',
  /** column name */
  Rhbophos = 'RHBOPHOS',
  /** column name */
  Rhbopsys = 'RHBOPSYS',
  /** column name */
  Rhbopven = 'RHBOPVEN',
  /** column name */
  Robohos = 'ROBOHOS',
  /** column name */
  Robosys = 'ROBOSYS',
  /** column name */
  Roboven = 'ROBOVEN',
  /** column name */
  Rprshos = 'RPRSHOS',
  /** column name */
  Rprssys = 'RPRSSYS',
  /** column name */
  Rprsven = 'RPRSVEN',
  /** column name */
  Rsimhos = 'RSIMHOS',
  /** column name */
  Rsimsys = 'RSIMSYS',
  /** column name */
  Rsimven = 'RSIMVEN',
  /** column name */
  Specthos = 'SPECTHOS',
  /** column name */
  Spectsys = 'SPECTSYS',
  /** column name */
  Spectven = 'SPECTVEN',
  /** column name */
  Sphshos = 'SPHSHOS',
  /** column name */
  Sphssys = 'SPHSSYS',
  /** column name */
  Sphsven = 'SPHSVEN',
  /** column name */
  Sradhos = 'SRADHOS',
  /** column name */
  Sradsys = 'SRADSYS',
  /** column name */
  Sradven = 'SRADVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Ultsnhos = 'ULTSNHOS',
  /** column name */
  Ultsnsys = 'ULTSNSYS',
  /** column name */
  Ultsnven = 'ULTSNVEN'
}

/** input type for updating data in table "AS21SVC2" */
export type As21Svc2_Set_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As21Svc2_Stddev_Fields = {
  __typename?: 'AS21SVC2_stddev_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As21Svc2_Stddev_Pop_Fields = {
  __typename?: 'AS21SVC2_stddev_pop_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As21Svc2_Stddev_Samp_Fields = {
  __typename?: 'AS21SVC2_stddev_samp_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS21SVC2" */
export type As21Svc2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Svc2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Svc2_Stream_Cursor_Value_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As21Svc2_Sum_Fields = {
  __typename?: 'AS21SVC2_sum_fields';
  PSCBD: Maybe<Scalars['float8']>;
  PSGBD: Maybe<Scalars['float8']>;
};

/** update columns of table "AS21SVC2" */
export enum As21Svc2_Update_Column {
  /** column name */
  Aidsshos = 'AIDSSHOS',
  /** column name */
  Aidsssys = 'AIDSSSYS',
  /** column name */
  Aidssven = 'AIDSSVEN',
  /** column name */
  Asstlhos = 'ASSTLHOS',
  /** column name */
  Asstlsys = 'ASSTLSYS',
  /** column name */
  Asstlven = 'ASSTLVEN',
  /** column name */
  Beamhos = 'BEAMHOS',
  /** column name */
  Beamsys = 'BEAMSYS',
  /** column name */
  Beamven = 'BEAMVEN',
  /** column name */
  Bradhos = 'BRADHOS',
  /** column name */
  Bradsys = 'BRADSYS',
  /** column name */
  Bradven = 'BRADVEN',
  /** column name */
  Ctscnhos = 'CTSCNHOS',
  /** column name */
  Ctscnsys = 'CTSCNSYS',
  /** column name */
  Ctscnven = 'CTSCNVEN',
  /** column name */
  Dradfhos = 'DRADFHOS',
  /** column name */
  Dradfsys = 'DRADFSYS',
  /** column name */
  Dradfven = 'DRADFVEN',
  /** column name */
  Ebcthos = 'EBCTHOS',
  /** column name */
  Ebctsys = 'EBCTSYS',
  /** column name */
  Ebctven = 'EBCTVEN',
  /** column name */
  Ffdmhos = 'FFDMHOS',
  /** column name */
  Ffdmsys = 'FFDMSYS',
  /** column name */
  Ffdmven = 'FFDMVEN',
  /** column name */
  Gntchos = 'GNTCHOS',
  /** column name */
  Gntcsys = 'GNTCSYS',
  /** column name */
  Gntcven = 'GNTCVEN',
  /** column name */
  Hemohos = 'HEMOHOS',
  /** column name */
  Hemosys = 'HEMOSYS',
  /** column name */
  Hemoven = 'HEMOVEN',
  /** column name */
  Hlthchos = 'HLTHCHOS',
  /** column name */
  Hlthcsys = 'HLTHCSYS',
  /** column name */
  Hlthcven = 'HLTHCVEN',
  /** column name */
  Hlthfhos = 'HLTHFHOS',
  /** column name */
  Hlthfsys = 'HLTHFSYS',
  /** column name */
  Hlthfven = 'HLTHFVEN',
  /** column name */
  Hlthshos = 'HLTHSHOS',
  /** column name */
  Hlthssys = 'HLTHSSYS',
  /** column name */
  Hlthsven = 'HLTHSVEN',
  /** column name */
  Hltrhos = 'HLTRHOS',
  /** column name */
  Hltrsys = 'HLTRSYS',
  /** column name */
  Hltrven = 'HLTRVEN',
  /** column name */
  Homehhos = 'HOMEHHOS',
  /** column name */
  Homehsys = 'HOMEHSYS',
  /** column name */
  Homehven = 'HOMEHVEN',
  /** column name */
  Hospchos = 'HOSPCHOS',
  /** column name */
  Hospcsys = 'HOSPCSYS',
  /** column name */
  Hospcven = 'HOSPCVEN',
  /** column name */
  Icarhos = 'ICARHOS',
  /** column name */
  Icarsys = 'ICARSYS',
  /** column name */
  Icarven = 'ICARVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Igrthos = 'IGRTHOS',
  /** column name */
  Igrtsys = 'IGRTSYS',
  /** column name */
  Igrtven = 'IGRTVEN',
  /** column name */
  Imprhos = 'IMPRHOS',
  /** column name */
  Imprsys = 'IMPRSYS',
  /** column name */
  Imprven = 'IMPRVEN',
  /** column name */
  Imrihos = 'IMRIHOS',
  /** column name */
  Imrisys = 'IMRISYS',
  /** column name */
  Imriven = 'IMRIVEN',
  /** column name */
  Imrthos = 'IMRTHOS',
  /** column name */
  Imrtsys = 'IMRTSYS',
  /** column name */
  Imrtven = 'IMRTVEN',
  /** column name */
  Ipalhos = 'IPALHOS',
  /** column name */
  Ipalsys = 'IPALSYS',
  /** column name */
  Ipalven = 'IPALVEN',
  /** column name */
  Linghos = 'LINGHOS',
  /** column name */
  Lingsys = 'LINGSYS',
  /** column name */
  Lingven = 'LINGVEN',
  /** column name */
  Mealshos = 'MEALSHOS',
  /** column name */
  Mealssys = 'MEALSSYS',
  /** column name */
  Mealsven = 'MEALSVEN',
  /** column name */
  Meghos = 'MEGHOS',
  /** column name */
  Megsys = 'MEGSYS',
  /** column name */
  Megven = 'MEGVEN',
  /** column name */
  Mohshos = 'MOHSHOS',
  /** column name */
  Mohssys = 'MOHSSYS',
  /** column name */
  Mohsven = 'MOHSVEN',
  /** column name */
  Mrihos = 'MRIHOS',
  /** column name */
  Mrisys = 'MRISYS',
  /** column name */
  Mriven = 'MRIVEN',
  /** column name */
  Msctghos = 'MSCTGHOS',
  /** column name */
  Msctgsys = 'MSCTGSYS',
  /** column name */
  Msctgven = 'MSCTGVEN',
  /** column name */
  Mscthos = 'MSCTHOS',
  /** column name */
  Msctsys = 'MSCTSYS',
  /** column name */
  Msctven = 'MSCTVEN',
  /** column name */
  Nerohos = 'NEROHOS',
  /** column name */
  Nerosys = 'NEROSYS',
  /** column name */
  Neroven = 'NEROVEN',
  /** column name */
  Nutrphos = 'NUTRPHOS',
  /** column name */
  Nutrpsys = 'NUTRPSYS',
  /** column name */
  Nutrpven = 'NUTRPVEN',
  /** column name */
  Occhshos = 'OCCHSHOS',
  /** column name */
  Occhssys = 'OCCHSSYS',
  /** column name */
  Occhsven = 'OCCHSVEN',
  /** column name */
  Oncolhos = 'ONCOLHOS',
  /** column name */
  Oncolsys = 'ONCOLSYS',
  /** column name */
  Oncolven = 'ONCOLVEN',
  /** column name */
  Ophoshos = 'OPHOSHOS',
  /** column name */
  Ophossys = 'OPHOSSYS',
  /** column name */
  Ophosven = 'OPHOSVEN',
  /** column name */
  Opsrghos = 'OPSRGHOS',
  /** column name */
  Opsrgsys = 'OPSRGSYS',
  /** column name */
  Opsrgven = 'OPSRGVEN',
  /** column name */
  Ortohos = 'ORTOHOS',
  /** column name */
  Ortosys = 'ORTOSYS',
  /** column name */
  Ortoven = 'ORTOVEN',
  /** column name */
  Painhos = 'PAINHOS',
  /** column name */
  Painsys = 'PAINSYS',
  /** column name */
  Painven = 'PAINVEN',
  /** column name */
  Palhos = 'PALHOS',
  /** column name */
  Palsys = 'PALSYS',
  /** column name */
  Palven = 'PALVEN',
  /** column name */
  Patedhos = 'PATEDHOS',
  /** column name */
  Patedsys = 'PATEDSYS',
  /** column name */
  Patedven = 'PATEDVEN',
  /** column name */
  Patrphos = 'PATRPHOS',
  /** column name */
  Patrpsys = 'PATRPSYS',
  /** column name */
  Patrpven = 'PATRPVEN',
  /** column name */
  Pcahos = 'PCAHOS',
  /** column name */
  Pcasys = 'PCASYS',
  /** column name */
  Pcaven = 'PCAVEN',
  /** column name */
  Pcdephos = 'PCDEPHOS',
  /** column name */
  Pcdepsys = 'PCDEPSYS',
  /** column name */
  Pcdepven = 'PCDEPVEN',
  /** column name */
  Petcthos = 'PETCTHOS',
  /** column name */
  Petctsys = 'PETCTSYS',
  /** column name */
  Petctven = 'PETCTVEN',
  /** column name */
  Pethos = 'PETHOS',
  /** column name */
  Petsys = 'PETSYS',
  /** column name */
  Petven = 'PETVEN',
  /** column name */
  Ppnhos = 'PPNHOS',
  /** column name */
  Ppnsys = 'PPNSYS',
  /** column name */
  Ppnven = 'PPNVEN',
  /** column name */
  Pscbd = 'PSCBD',
  /** column name */
  Pscishos = 'PSCISHOS',
  /** column name */
  Pscissys = 'PSCISSYS',
  /** column name */
  Pscisven = 'PSCISVEN',
  /** column name */
  Psgbd = 'PSGBD',
  /** column name */
  Pspihos = 'PSPIHOS',
  /** column name */
  Pspisys = 'PSPISYS',
  /** column name */
  Pspiven = 'PSPIVEN',
  /** column name */
  Pssochos = 'PSSOCHOS',
  /** column name */
  Pssocsys = 'PSSOCSYS',
  /** column name */
  Pssocven = 'PSSOCVEN',
  /** column name */
  Psycahos = 'PSYCAHOS',
  /** column name */
  Psycasys = 'PSYCASYS',
  /** column name */
  Psycaven = 'PSYCAVEN',
  /** column name */
  Psyedhos = 'PSYEDHOS',
  /** column name */
  Psyedsys = 'PSYEDSYS',
  /** column name */
  Psyedven = 'PSYEDVEN',
  /** column name */
  Psyemhos = 'PSYEMHOS',
  /** column name */
  Psyemsys = 'PSYEMSYS',
  /** column name */
  Psyemven = 'PSYEMVEN',
  /** column name */
  Psygrhos = 'PSYGRHOS',
  /** column name */
  Psygrsys = 'PSYGRSYS',
  /** column name */
  Psygrven = 'PSYGRVEN',
  /** column name */
  Psylshos = 'PSYLSHOS',
  /** column name */
  Psylssys = 'PSYLSSYS',
  /** column name */
  Psylsven = 'PSYLSVEN',
  /** column name */
  Psyoihos = 'PSYOIHOS',
  /** column name */
  Psyoisys = 'PSYOISYS',
  /** column name */
  Psyoiven = 'PSYOIVEN',
  /** column name */
  Psyophos = 'PSYOPHOS',
  /** column name */
  Psyopsys = 'PSYOPSYS',
  /** column name */
  Psyopven = 'PSYOPVEN',
  /** column name */
  Psyphahos = 'PSYPHAHOS',
  /** column name */
  Psyphasys = 'PSYPHASYS',
  /** column name */
  Psyphaven = 'PSYPHAVEN',
  /** column name */
  Psyphchos = 'PSYPHCHOS',
  /** column name */
  Psyphcsys = 'PSYPHCSYS',
  /** column name */
  Psyphcven = 'PSYPHCVEN',
  /** column name */
  Psytrahos = 'PSYTRAHOS',
  /** column name */
  Psytrasys = 'PSYTRASYS',
  /** column name */
  Psytraven = 'PSYTRAVEN',
  /** column name */
  Psytrphos = 'PSYTRPHOS',
  /** column name */
  Psytrpsys = 'PSYTRPSYS',
  /** column name */
  Psytrpven = 'PSYTRPVEN',
  /** column name */
  Ptonhos = 'PTONHOS',
  /** column name */
  Ptonsys = 'PTONSYS',
  /** column name */
  Ptonven = 'PTONVEN',
  /** column name */
  Rasthos = 'RASTHOS',
  /** column name */
  Rastsys = 'RASTSYS',
  /** column name */
  Rastven = 'RASTVEN',
  /** column name */
  Rbothos = 'RBOTHOS',
  /** column name */
  Rbotsys = 'RBOTSYS',
  /** column name */
  Rbotven = 'RBOTVEN',
  /** column name */
  Redshos = 'REDSHOS',
  /** column name */
  Redssys = 'REDSSYS',
  /** column name */
  Redsven = 'REDSVEN',
  /** column name */
  Retirhos = 'RETIRHOS',
  /** column name */
  Retirsys = 'RETIRSYS',
  /** column name */
  Retirven = 'RETIRVEN',
  /** column name */
  Rhbophos = 'RHBOPHOS',
  /** column name */
  Rhbopsys = 'RHBOPSYS',
  /** column name */
  Rhbopven = 'RHBOPVEN',
  /** column name */
  Robohos = 'ROBOHOS',
  /** column name */
  Robosys = 'ROBOSYS',
  /** column name */
  Roboven = 'ROBOVEN',
  /** column name */
  Rprshos = 'RPRSHOS',
  /** column name */
  Rprssys = 'RPRSSYS',
  /** column name */
  Rprsven = 'RPRSVEN',
  /** column name */
  Rsimhos = 'RSIMHOS',
  /** column name */
  Rsimsys = 'RSIMSYS',
  /** column name */
  Rsimven = 'RSIMVEN',
  /** column name */
  Specthos = 'SPECTHOS',
  /** column name */
  Spectsys = 'SPECTSYS',
  /** column name */
  Spectven = 'SPECTVEN',
  /** column name */
  Sphshos = 'SPHSHOS',
  /** column name */
  Sphssys = 'SPHSSYS',
  /** column name */
  Sphsven = 'SPHSVEN',
  /** column name */
  Sradhos = 'SRADHOS',
  /** column name */
  Sradsys = 'SRADSYS',
  /** column name */
  Sradven = 'SRADVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Ultsnhos = 'ULTSNHOS',
  /** column name */
  Ultsnsys = 'ULTSNSYS',
  /** column name */
  Ultsnven = 'ULTSNVEN'
}

export type As21Svc2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As21Svc2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Svc2_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Svc2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As21Svc2_Var_Pop_Fields = {
  __typename?: 'AS21SVC2_var_pop_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As21Svc2_Var_Samp_Fields = {
  __typename?: 'AS21SVC2_var_samp_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As21Svc2_Variance_Fields = {
  __typename?: 'AS21SVC2_variance_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS21SVC3" */
export type As21Svc3 = {
  __typename?: 'AS21SVC3';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHLTA: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHACAR: Maybe<Scalars['String']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  CHER: Maybe<Scalars['String']>;
  CHPCS: Maybe<Scalars['String']>;
  CHXCAR: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  DHACAR: Maybe<Scalars['String']>;
  DHER: Maybe<Scalars['String']>;
  DHPCS: Maybe<Scalars['String']>;
  DHXCAR: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDMCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ICUCHG: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STFCHG: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS21SVC3" */
export type As21Svc3_Aggregate = {
  __typename?: 'AS21SVC3_aggregate';
  aggregate: Maybe<As21Svc3_Aggregate_Fields>;
  nodes: Array<As21Svc3>;
};

/** aggregate fields of "AS21SVC3" */
export type As21Svc3_Aggregate_Fields = {
  __typename?: 'AS21SVC3_aggregate_fields';
  avg: Maybe<As21Svc3_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As21Svc3_Max_Fields>;
  min: Maybe<As21Svc3_Min_Fields>;
  stddev: Maybe<As21Svc3_Stddev_Fields>;
  stddev_pop: Maybe<As21Svc3_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As21Svc3_Stddev_Samp_Fields>;
  sum: Maybe<As21Svc3_Sum_Fields>;
  var_pop: Maybe<As21Svc3_Var_Pop_Fields>;
  var_samp: Maybe<As21Svc3_Var_Samp_Fields>;
  variance: Maybe<As21Svc3_Variance_Fields>;
};


/** aggregate fields of "AS21SVC3" */
export type As21Svc3_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Svc3_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As21Svc3_Avg_Fields = {
  __typename?: 'AS21SVC3_avg_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS21SVC3". All fields are combined with a logical 'AND'. */
export type As21Svc3_Bool_Exp = {
  ADTRTHOS?: InputMaybe<String_Comparison_Exp>;
  ADTRTSYS?: InputMaybe<String_Comparison_Exp>;
  ADTRTVEN?: InputMaybe<String_Comparison_Exp>;
  ALCOPHOS?: InputMaybe<String_Comparison_Exp>;
  ALCOPSYS?: InputMaybe<String_Comparison_Exp>;
  ALCOPVEN?: InputMaybe<String_Comparison_Exp>;
  ALCPDHOS?: InputMaybe<String_Comparison_Exp>;
  ALCPDSYS?: InputMaybe<String_Comparison_Exp>;
  ALCPDVEN?: InputMaybe<String_Comparison_Exp>;
  ALCPRHOS?: InputMaybe<String_Comparison_Exp>;
  ALCPRSYS?: InputMaybe<String_Comparison_Exp>;
  ALCPRVEN?: InputMaybe<String_Comparison_Exp>;
  ALDBD?: InputMaybe<Float8_Comparison_Exp>;
  BAIMV?: InputMaybe<Float8_Comparison_Exp>;
  BHLTA?: InputMaybe<String_Comparison_Exp>;
  BPIMV?: InputMaybe<Float8_Comparison_Exp>;
  CHACAR?: InputMaybe<String_Comparison_Exp>;
  CHCARHOS?: InputMaybe<String_Comparison_Exp>;
  CHCARSYS?: InputMaybe<String_Comparison_Exp>;
  CHCARVEN?: InputMaybe<String_Comparison_Exp>;
  CHER?: InputMaybe<String_Comparison_Exp>;
  CHPCS?: InputMaybe<String_Comparison_Exp>;
  CHXCAR?: InputMaybe<String_Comparison_Exp>;
  COFVHOS?: InputMaybe<String_Comparison_Exp>;
  COFVSYS?: InputMaybe<String_Comparison_Exp>;
  COFVVEN?: InputMaybe<String_Comparison_Exp>;
  COVIDU?: InputMaybe<String_Comparison_Exp>;
  CPHCOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHHOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHIOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHOHOS?: InputMaybe<String_Comparison_Exp>;
  CPHOSYS?: InputMaybe<String_Comparison_Exp>;
  CPHP?: InputMaybe<Float8_Comparison_Exp>;
  CPHPOS?: InputMaybe<Float8_Comparison_Exp>;
  DECHC?: InputMaybe<String_Comparison_Exp>;
  DECUTLA?: InputMaybe<String_Comparison_Exp>;
  DHACAR?: InputMaybe<String_Comparison_Exp>;
  DHER?: InputMaybe<String_Comparison_Exp>;
  DHPCS?: InputMaybe<String_Comparison_Exp>;
  DHXCAR?: InputMaybe<String_Comparison_Exp>;
  EAIMV?: InputMaybe<Float8_Comparison_Exp>;
  EDMCHG?: InputMaybe<String_Comparison_Exp>;
  EICUHOS?: InputMaybe<String_Comparison_Exp>;
  EICUSYS?: InputMaybe<String_Comparison_Exp>;
  EICUVEN?: InputMaybe<String_Comparison_Exp>;
  EPIMV?: InputMaybe<Float8_Comparison_Exp>;
  EQMCOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMHOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMIOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMODHOS?: InputMaybe<String_Comparison_Exp>;
  EQMODSYS?: InputMaybe<String_Comparison_Exp>;
  EQMP?: InputMaybe<Float8_Comparison_Exp>;
  EQMPOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDCOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDHOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDIOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDP?: InputMaybe<Float8_Comparison_Exp>;
  FNDPOS?: InputMaybe<Float8_Comparison_Exp>;
  FOUNDHOS?: InputMaybe<String_Comparison_Exp>;
  FOUNDSYS?: InputMaybe<String_Comparison_Exp>;
  FTMT?: InputMaybe<Float8_Comparison_Exp>;
  GPWCOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWHOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWIOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWP?: InputMaybe<Float8_Comparison_Exp>;
  GPWPOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWWHOS?: InputMaybe<String_Comparison_Exp>;
  GPWWSYS?: InputMaybe<String_Comparison_Exp>;
  HARTHOS?: InputMaybe<String_Comparison_Exp>;
  HARTSYS?: InputMaybe<String_Comparison_Exp>;
  HARTVEN?: InputMaybe<String_Comparison_Exp>;
  ICUCHG?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IISMHOS?: InputMaybe<Float8_Comparison_Exp>;
  IMPSTAT?: InputMaybe<String_Comparison_Exp>;
  IPACOS?: InputMaybe<Float8_Comparison_Exp>;
  IPAHOS?: InputMaybe<String_Comparison_Exp>;
  IPAIOS?: InputMaybe<Float8_Comparison_Exp>;
  IPAP?: InputMaybe<Float8_Comparison_Exp>;
  IPAPOS?: InputMaybe<Float8_Comparison_Exp>;
  IPASYS?: InputMaybe<String_Comparison_Exp>;
  IPPAHOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMCOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMHOS?: InputMaybe<String_Comparison_Exp>;
  ISMIOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMP?: InputMaybe<Float8_Comparison_Exp>;
  ISMPOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMSYS?: InputMaybe<String_Comparison_Exp>;
  ISORMB?: InputMaybe<Float8_Comparison_Exp>;
  ISORMC?: InputMaybe<Float8_Comparison_Exp>;
  ISORME?: InputMaybe<Float8_Comparison_Exp>;
  JNLS?: InputMaybe<String_Comparison_Exp>;
  JNTAMB?: InputMaybe<String_Comparison_Exp>;
  JNTCTR?: InputMaybe<String_Comparison_Exp>;
  JNTLSC?: InputMaybe<String_Comparison_Exp>;
  JNTLSO?: InputMaybe<String_Comparison_Exp>;
  JNTLSS?: InputMaybe<String_Comparison_Exp>;
  JNTLST?: InputMaybe<String_Comparison_Exp>;
  JNTMD?: InputMaybe<String_Comparison_Exp>;
  JNTOTH?: InputMaybe<String_Comparison_Exp>;
  JNTPH?: InputMaybe<String_Comparison_Exp>;
  JNTTXT?: InputMaybe<String_Comparison_Exp>;
  KDNYHOS?: InputMaybe<String_Comparison_Exp>;
  KDNYSYS?: InputMaybe<String_Comparison_Exp>;
  KDNYVEN?: InputMaybe<String_Comparison_Exp>;
  LIVRHOS?: InputMaybe<String_Comparison_Exp>;
  LIVRSYS?: InputMaybe<String_Comparison_Exp>;
  LIVRVEN?: InputMaybe<String_Comparison_Exp>;
  LSHTXT?: InputMaybe<String_Comparison_Exp>;
  LUNGHOS?: InputMaybe<String_Comparison_Exp>;
  LUNGSYS?: InputMaybe<String_Comparison_Exp>;
  LUNGVEN?: InputMaybe<String_Comparison_Exp>;
  MEDOPHOS?: InputMaybe<String_Comparison_Exp>;
  MEDOPSYS?: InputMaybe<String_Comparison_Exp>;
  MEDOPVEN?: InputMaybe<String_Comparison_Exp>;
  MEDSUBHOS?: InputMaybe<String_Comparison_Exp>;
  MEDSUBSYS?: InputMaybe<String_Comparison_Exp>;
  MEDSUBVEN?: InputMaybe<String_Comparison_Exp>;
  MMSOHOS?: InputMaybe<Float8_Comparison_Exp>;
  MSGRP?: InputMaybe<Float8_Comparison_Exp>;
  MSGRPN?: InputMaybe<Float8_Comparison_Exp>;
  MSOCOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOHOS?: InputMaybe<String_Comparison_Exp>;
  MSOIOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOP?: InputMaybe<Float8_Comparison_Exp>;
  MSOPOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOSYS?: InputMaybe<String_Comparison_Exp>;
  OPHCOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHHOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHIOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHOHOS?: InputMaybe<String_Comparison_Exp>;
  OPHOSYS?: InputMaybe<String_Comparison_Exp>;
  OPHP?: InputMaybe<Float8_Comparison_Exp>;
  OPHPOS?: InputMaybe<Float8_Comparison_Exp>;
  ORPMHOS?: InputMaybe<String_Comparison_Exp>;
  ORPMSYS?: InputMaybe<String_Comparison_Exp>;
  ORPMVEN?: InputMaybe<String_Comparison_Exp>;
  OTBONHOS?: InputMaybe<String_Comparison_Exp>;
  OTBONSYS?: InputMaybe<String_Comparison_Exp>;
  OTBONVEN?: InputMaybe<String_Comparison_Exp>;
  OTHTHOS?: InputMaybe<String_Comparison_Exp>;
  OTHTSYS?: InputMaybe<String_Comparison_Exp>;
  OTHTVEN?: InputMaybe<String_Comparison_Exp>;
  OTOTHHOS?: InputMaybe<String_Comparison_Exp>;
  OTOTHSYS?: InputMaybe<String_Comparison_Exp>;
  OTOTHVEN?: InputMaybe<String_Comparison_Exp>;
  OUTMTX?: InputMaybe<String_Comparison_Exp>;
  PDISHOS?: InputMaybe<String_Comparison_Exp>;
  PDISSYS?: InputMaybe<String_Comparison_Exp>;
  PDISVEN?: InputMaybe<String_Comparison_Exp>;
  PHACAR?: InputMaybe<String_Comparison_Exp>;
  PHER?: InputMaybe<String_Comparison_Exp>;
  PHPCS?: InputMaybe<String_Comparison_Exp>;
  PHXCAR?: InputMaybe<String_Comparison_Exp>;
  PHYCOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYCPT?: InputMaybe<Float8_Comparison_Exp>;
  PHYHOS?: InputMaybe<String_Comparison_Exp>;
  PHYIOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYOCPT?: InputMaybe<Float8_Comparison_Exp>;
  PHYOTH?: InputMaybe<String_Comparison_Exp>;
  PHYP?: InputMaybe<Float8_Comparison_Exp>;
  PHYPOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYPR?: InputMaybe<Float8_Comparison_Exp>;
  PHYPRN?: InputMaybe<Float8_Comparison_Exp>;
  PHYSYS?: InputMaybe<String_Comparison_Exp>;
  PPHYHOS?: InputMaybe<Float8_Comparison_Exp>;
  RURLHOS?: InputMaybe<String_Comparison_Exp>;
  RURLSYS?: InputMaybe<String_Comparison_Exp>;
  RURLVEN?: InputMaybe<String_Comparison_Exp>;
  SCBH?: InputMaybe<String_Comparison_Exp>;
  SCEDL?: InputMaybe<String_Comparison_Exp>;
  SCFOD?: InputMaybe<String_Comparison_Exp>;
  SCHSE?: InputMaybe<String_Comparison_Exp>;
  SCIOS?: InputMaybe<String_Comparison_Exp>;
  SCNED?: InputMaybe<String_Comparison_Exp>;
  SCOTH?: InputMaybe<String_Comparison_Exp>;
  SCROT?: InputMaybe<String_Comparison_Exp>;
  SCSTAT?: InputMaybe<String_Comparison_Exp>;
  SCTRN?: InputMaybe<String_Comparison_Exp>;
  SCUND?: InputMaybe<String_Comparison_Exp>;
  SCV?: InputMaybe<String_Comparison_Exp>;
  SHACAR?: InputMaybe<String_Comparison_Exp>;
  SHER?: InputMaybe<String_Comparison_Exp>;
  SHPCS?: InputMaybe<String_Comparison_Exp>;
  SHXCAR?: InputMaybe<String_Comparison_Exp>;
  SLEPHOS?: InputMaybe<String_Comparison_Exp>;
  SLEPSYS?: InputMaybe<String_Comparison_Exp>;
  SLEPVEN?: InputMaybe<String_Comparison_Exp>;
  SOCBH?: InputMaybe<String_Comparison_Exp>;
  SOCED?: InputMaybe<String_Comparison_Exp>;
  SOCEHR?: InputMaybe<String_Comparison_Exp>;
  SOCFOD?: InputMaybe<String_Comparison_Exp>;
  SOCHSE?: InputMaybe<String_Comparison_Exp>;
  SOCINC?: InputMaybe<String_Comparison_Exp>;
  SOCIOS?: InputMaybe<String_Comparison_Exp>;
  SOCNED?: InputMaybe<String_Comparison_Exp>;
  SOCOT?: InputMaybe<String_Comparison_Exp>;
  SOCOTH?: InputMaybe<String_Comparison_Exp>;
  SOCTRN?: InputMaybe<String_Comparison_Exp>;
  SOCV?: InputMaybe<String_Comparison_Exp>;
  SOCWKHOS?: InputMaybe<String_Comparison_Exp>;
  SOCWKSYS?: InputMaybe<String_Comparison_Exp>;
  SOCWKVEN?: InputMaybe<String_Comparison_Exp>;
  SPORTHOS?: InputMaybe<String_Comparison_Exp>;
  SPORTSYS?: InputMaybe<String_Comparison_Exp>;
  SPORTVEN?: InputMaybe<String_Comparison_Exp>;
  SSGRP?: InputMaybe<Float8_Comparison_Exp>;
  SSGRPN?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  STFCHG?: InputMaybe<String_Comparison_Exp>;
  STRCHOS?: InputMaybe<String_Comparison_Exp>;
  STRCSYS?: InputMaybe<String_Comparison_Exp>;
  STRCVEN?: InputMaybe<String_Comparison_Exp>;
  SUPPGHOS?: InputMaybe<String_Comparison_Exp>;
  SUPPGSYS?: InputMaybe<String_Comparison_Exp>;
  SUPPGVEN?: InputMaybe<String_Comparison_Exp>;
  SWBDHOS?: InputMaybe<String_Comparison_Exp>;
  SWBDSYS?: InputMaybe<String_Comparison_Exp>;
  SWBDVEN?: InputMaybe<String_Comparison_Exp>;
  TEENSHOS?: InputMaybe<String_Comparison_Exp>;
  TEENSSYS?: InputMaybe<String_Comparison_Exp>;
  TEENSVEN?: InputMaybe<String_Comparison_Exp>;
  TISUHOS?: InputMaybe<String_Comparison_Exp>;
  TISUSYS?: InputMaybe<String_Comparison_Exp>;
  TISUVEN?: InputMaybe<String_Comparison_Exp>;
  TOBHOS?: InputMaybe<String_Comparison_Exp>;
  TOBSYS?: InputMaybe<String_Comparison_Exp>;
  TOBVEN?: InputMaybe<String_Comparison_Exp>;
  TPORTHOS?: InputMaybe<String_Comparison_Exp>;
  TPORTSYS?: InputMaybe<String_Comparison_Exp>;
  TPORTVEN?: InputMaybe<String_Comparison_Exp>;
  URGCCHOS?: InputMaybe<String_Comparison_Exp>;
  URGCCSYS?: InputMaybe<String_Comparison_Exp>;
  URGCCVEN?: InputMaybe<String_Comparison_Exp>;
  VCMMHOS?: InputMaybe<String_Comparison_Exp>;
  VCMMSYS?: InputMaybe<String_Comparison_Exp>;
  VCMMVEN?: InputMaybe<String_Comparison_Exp>;
  VOLSVHOS?: InputMaybe<String_Comparison_Exp>;
  VOLSVSYS?: InputMaybe<String_Comparison_Exp>;
  VOLSVVEN?: InputMaybe<String_Comparison_Exp>;
  VRCSHOS?: InputMaybe<String_Comparison_Exp>;
  VRCSSYS?: InputMaybe<String_Comparison_Exp>;
  VRCSVEN?: InputMaybe<String_Comparison_Exp>;
  VWRKHOS?: InputMaybe<String_Comparison_Exp>;
  VWRKSYS?: InputMaybe<String_Comparison_Exp>;
  VWRKVEN?: InputMaybe<String_Comparison_Exp>;
  WMGTHOS?: InputMaybe<String_Comparison_Exp>;
  WMGTSYS?: InputMaybe<String_Comparison_Exp>;
  WMGTVEN?: InputMaybe<String_Comparison_Exp>;
  WOMHCHOS?: InputMaybe<String_Comparison_Exp>;
  WOMHCSYS?: InputMaybe<String_Comparison_Exp>;
  WOMHCVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Svc3_Bool_Exp>>;
  _not?: InputMaybe<As21Svc3_Bool_Exp>;
  _or?: InputMaybe<Array<As21Svc3_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS21SVC3" */
export enum As21Svc3_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Svc3 = 'pk_AS21SVC3'
}

/** input type for incrementing numeric columns in table "AS21SVC3" */
export type As21Svc3_Inc_Input = {
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS21SVC3" */
export type As21Svc3_Insert_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHACAR?: InputMaybe<Scalars['String']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  CHER?: InputMaybe<Scalars['String']>;
  CHPCS?: InputMaybe<Scalars['String']>;
  CHXCAR?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  DHACAR?: InputMaybe<Scalars['String']>;
  DHER?: InputMaybe<Scalars['String']>;
  DHPCS?: InputMaybe<Scalars['String']>;
  DHXCAR?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDMCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ICUCHG?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STFCHG?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As21Svc3_Max_Fields = {
  __typename?: 'AS21SVC3_max_fields';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHLTA: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHACAR: Maybe<Scalars['String']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  CHER: Maybe<Scalars['String']>;
  CHPCS: Maybe<Scalars['String']>;
  CHXCAR: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  DHACAR: Maybe<Scalars['String']>;
  DHER: Maybe<Scalars['String']>;
  DHPCS: Maybe<Scalars['String']>;
  DHXCAR: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDMCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ICUCHG: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STFCHG: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As21Svc3_Min_Fields = {
  __typename?: 'AS21SVC3_min_fields';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHLTA: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHACAR: Maybe<Scalars['String']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  CHER: Maybe<Scalars['String']>;
  CHPCS: Maybe<Scalars['String']>;
  CHXCAR: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  DHACAR: Maybe<Scalars['String']>;
  DHER: Maybe<Scalars['String']>;
  DHPCS: Maybe<Scalars['String']>;
  DHXCAR: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDMCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ICUCHG: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STFCHG: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS21SVC3" */
export type As21Svc3_Mutation_Response = {
  __typename?: 'AS21SVC3_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Svc3>;
};

/** input type for inserting object relation for remote table "AS21SVC3" */
export type As21Svc3_Obj_Rel_Insert_Input = {
  data: As21Svc3_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Svc3_On_Conflict>;
};

/** on_conflict condition type for table "AS21SVC3" */
export type As21Svc3_On_Conflict = {
  constraint: As21Svc3_Constraint;
  update_columns?: Array<As21Svc3_Update_Column>;
  where?: InputMaybe<As21Svc3_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21SVC3". */
export type As21Svc3_Order_By = {
  ADTRTHOS?: InputMaybe<Order_By>;
  ADTRTSYS?: InputMaybe<Order_By>;
  ADTRTVEN?: InputMaybe<Order_By>;
  ALCOPHOS?: InputMaybe<Order_By>;
  ALCOPSYS?: InputMaybe<Order_By>;
  ALCOPVEN?: InputMaybe<Order_By>;
  ALCPDHOS?: InputMaybe<Order_By>;
  ALCPDSYS?: InputMaybe<Order_By>;
  ALCPDVEN?: InputMaybe<Order_By>;
  ALCPRHOS?: InputMaybe<Order_By>;
  ALCPRSYS?: InputMaybe<Order_By>;
  ALCPRVEN?: InputMaybe<Order_By>;
  ALDBD?: InputMaybe<Order_By>;
  BAIMV?: InputMaybe<Order_By>;
  BHLTA?: InputMaybe<Order_By>;
  BPIMV?: InputMaybe<Order_By>;
  CHACAR?: InputMaybe<Order_By>;
  CHCARHOS?: InputMaybe<Order_By>;
  CHCARSYS?: InputMaybe<Order_By>;
  CHCARVEN?: InputMaybe<Order_By>;
  CHER?: InputMaybe<Order_By>;
  CHPCS?: InputMaybe<Order_By>;
  CHXCAR?: InputMaybe<Order_By>;
  COFVHOS?: InputMaybe<Order_By>;
  COFVSYS?: InputMaybe<Order_By>;
  COFVVEN?: InputMaybe<Order_By>;
  COVIDU?: InputMaybe<Order_By>;
  CPHCOS?: InputMaybe<Order_By>;
  CPHHOS?: InputMaybe<Order_By>;
  CPHIOS?: InputMaybe<Order_By>;
  CPHOHOS?: InputMaybe<Order_By>;
  CPHOSYS?: InputMaybe<Order_By>;
  CPHP?: InputMaybe<Order_By>;
  CPHPOS?: InputMaybe<Order_By>;
  DECHC?: InputMaybe<Order_By>;
  DECUTLA?: InputMaybe<Order_By>;
  DHACAR?: InputMaybe<Order_By>;
  DHER?: InputMaybe<Order_By>;
  DHPCS?: InputMaybe<Order_By>;
  DHXCAR?: InputMaybe<Order_By>;
  EAIMV?: InputMaybe<Order_By>;
  EDMCHG?: InputMaybe<Order_By>;
  EICUHOS?: InputMaybe<Order_By>;
  EICUSYS?: InputMaybe<Order_By>;
  EICUVEN?: InputMaybe<Order_By>;
  EPIMV?: InputMaybe<Order_By>;
  EQMCOS?: InputMaybe<Order_By>;
  EQMHOS?: InputMaybe<Order_By>;
  EQMIOS?: InputMaybe<Order_By>;
  EQMODHOS?: InputMaybe<Order_By>;
  EQMODSYS?: InputMaybe<Order_By>;
  EQMP?: InputMaybe<Order_By>;
  EQMPOS?: InputMaybe<Order_By>;
  FNDCOS?: InputMaybe<Order_By>;
  FNDHOS?: InputMaybe<Order_By>;
  FNDIOS?: InputMaybe<Order_By>;
  FNDP?: InputMaybe<Order_By>;
  FNDPOS?: InputMaybe<Order_By>;
  FOUNDHOS?: InputMaybe<Order_By>;
  FOUNDSYS?: InputMaybe<Order_By>;
  FTMT?: InputMaybe<Order_By>;
  GPWCOS?: InputMaybe<Order_By>;
  GPWHOS?: InputMaybe<Order_By>;
  GPWIOS?: InputMaybe<Order_By>;
  GPWP?: InputMaybe<Order_By>;
  GPWPOS?: InputMaybe<Order_By>;
  GPWWHOS?: InputMaybe<Order_By>;
  GPWWSYS?: InputMaybe<Order_By>;
  HARTHOS?: InputMaybe<Order_By>;
  HARTSYS?: InputMaybe<Order_By>;
  HARTVEN?: InputMaybe<Order_By>;
  ICUCHG?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IISMHOS?: InputMaybe<Order_By>;
  IMPSTAT?: InputMaybe<Order_By>;
  IPACOS?: InputMaybe<Order_By>;
  IPAHOS?: InputMaybe<Order_By>;
  IPAIOS?: InputMaybe<Order_By>;
  IPAP?: InputMaybe<Order_By>;
  IPAPOS?: InputMaybe<Order_By>;
  IPASYS?: InputMaybe<Order_By>;
  IPPAHOS?: InputMaybe<Order_By>;
  ISMCOS?: InputMaybe<Order_By>;
  ISMHOS?: InputMaybe<Order_By>;
  ISMIOS?: InputMaybe<Order_By>;
  ISMP?: InputMaybe<Order_By>;
  ISMPOS?: InputMaybe<Order_By>;
  ISMSYS?: InputMaybe<Order_By>;
  ISORMB?: InputMaybe<Order_By>;
  ISORMC?: InputMaybe<Order_By>;
  ISORME?: InputMaybe<Order_By>;
  JNLS?: InputMaybe<Order_By>;
  JNTAMB?: InputMaybe<Order_By>;
  JNTCTR?: InputMaybe<Order_By>;
  JNTLSC?: InputMaybe<Order_By>;
  JNTLSO?: InputMaybe<Order_By>;
  JNTLSS?: InputMaybe<Order_By>;
  JNTLST?: InputMaybe<Order_By>;
  JNTMD?: InputMaybe<Order_By>;
  JNTOTH?: InputMaybe<Order_By>;
  JNTPH?: InputMaybe<Order_By>;
  JNTTXT?: InputMaybe<Order_By>;
  KDNYHOS?: InputMaybe<Order_By>;
  KDNYSYS?: InputMaybe<Order_By>;
  KDNYVEN?: InputMaybe<Order_By>;
  LIVRHOS?: InputMaybe<Order_By>;
  LIVRSYS?: InputMaybe<Order_By>;
  LIVRVEN?: InputMaybe<Order_By>;
  LSHTXT?: InputMaybe<Order_By>;
  LUNGHOS?: InputMaybe<Order_By>;
  LUNGSYS?: InputMaybe<Order_By>;
  LUNGVEN?: InputMaybe<Order_By>;
  MEDOPHOS?: InputMaybe<Order_By>;
  MEDOPSYS?: InputMaybe<Order_By>;
  MEDOPVEN?: InputMaybe<Order_By>;
  MEDSUBHOS?: InputMaybe<Order_By>;
  MEDSUBSYS?: InputMaybe<Order_By>;
  MEDSUBVEN?: InputMaybe<Order_By>;
  MMSOHOS?: InputMaybe<Order_By>;
  MSGRP?: InputMaybe<Order_By>;
  MSGRPN?: InputMaybe<Order_By>;
  MSOCOS?: InputMaybe<Order_By>;
  MSOHOS?: InputMaybe<Order_By>;
  MSOIOS?: InputMaybe<Order_By>;
  MSOP?: InputMaybe<Order_By>;
  MSOPOS?: InputMaybe<Order_By>;
  MSOSYS?: InputMaybe<Order_By>;
  OPHCOS?: InputMaybe<Order_By>;
  OPHHOS?: InputMaybe<Order_By>;
  OPHIOS?: InputMaybe<Order_By>;
  OPHOHOS?: InputMaybe<Order_By>;
  OPHOSYS?: InputMaybe<Order_By>;
  OPHP?: InputMaybe<Order_By>;
  OPHPOS?: InputMaybe<Order_By>;
  ORPMHOS?: InputMaybe<Order_By>;
  ORPMSYS?: InputMaybe<Order_By>;
  ORPMVEN?: InputMaybe<Order_By>;
  OTBONHOS?: InputMaybe<Order_By>;
  OTBONSYS?: InputMaybe<Order_By>;
  OTBONVEN?: InputMaybe<Order_By>;
  OTHTHOS?: InputMaybe<Order_By>;
  OTHTSYS?: InputMaybe<Order_By>;
  OTHTVEN?: InputMaybe<Order_By>;
  OTOTHHOS?: InputMaybe<Order_By>;
  OTOTHSYS?: InputMaybe<Order_By>;
  OTOTHVEN?: InputMaybe<Order_By>;
  OUTMTX?: InputMaybe<Order_By>;
  PDISHOS?: InputMaybe<Order_By>;
  PDISSYS?: InputMaybe<Order_By>;
  PDISVEN?: InputMaybe<Order_By>;
  PHACAR?: InputMaybe<Order_By>;
  PHER?: InputMaybe<Order_By>;
  PHPCS?: InputMaybe<Order_By>;
  PHXCAR?: InputMaybe<Order_By>;
  PHYCOS?: InputMaybe<Order_By>;
  PHYCPT?: InputMaybe<Order_By>;
  PHYHOS?: InputMaybe<Order_By>;
  PHYIOS?: InputMaybe<Order_By>;
  PHYOCPT?: InputMaybe<Order_By>;
  PHYOTH?: InputMaybe<Order_By>;
  PHYP?: InputMaybe<Order_By>;
  PHYPOS?: InputMaybe<Order_By>;
  PHYPR?: InputMaybe<Order_By>;
  PHYPRN?: InputMaybe<Order_By>;
  PHYSYS?: InputMaybe<Order_By>;
  PPHYHOS?: InputMaybe<Order_By>;
  RURLHOS?: InputMaybe<Order_By>;
  RURLSYS?: InputMaybe<Order_By>;
  RURLVEN?: InputMaybe<Order_By>;
  SCBH?: InputMaybe<Order_By>;
  SCEDL?: InputMaybe<Order_By>;
  SCFOD?: InputMaybe<Order_By>;
  SCHSE?: InputMaybe<Order_By>;
  SCIOS?: InputMaybe<Order_By>;
  SCNED?: InputMaybe<Order_By>;
  SCOTH?: InputMaybe<Order_By>;
  SCROT?: InputMaybe<Order_By>;
  SCSTAT?: InputMaybe<Order_By>;
  SCTRN?: InputMaybe<Order_By>;
  SCUND?: InputMaybe<Order_By>;
  SCV?: InputMaybe<Order_By>;
  SHACAR?: InputMaybe<Order_By>;
  SHER?: InputMaybe<Order_By>;
  SHPCS?: InputMaybe<Order_By>;
  SHXCAR?: InputMaybe<Order_By>;
  SLEPHOS?: InputMaybe<Order_By>;
  SLEPSYS?: InputMaybe<Order_By>;
  SLEPVEN?: InputMaybe<Order_By>;
  SOCBH?: InputMaybe<Order_By>;
  SOCED?: InputMaybe<Order_By>;
  SOCEHR?: InputMaybe<Order_By>;
  SOCFOD?: InputMaybe<Order_By>;
  SOCHSE?: InputMaybe<Order_By>;
  SOCINC?: InputMaybe<Order_By>;
  SOCIOS?: InputMaybe<Order_By>;
  SOCNED?: InputMaybe<Order_By>;
  SOCOT?: InputMaybe<Order_By>;
  SOCOTH?: InputMaybe<Order_By>;
  SOCTRN?: InputMaybe<Order_By>;
  SOCV?: InputMaybe<Order_By>;
  SOCWKHOS?: InputMaybe<Order_By>;
  SOCWKSYS?: InputMaybe<Order_By>;
  SOCWKVEN?: InputMaybe<Order_By>;
  SPORTHOS?: InputMaybe<Order_By>;
  SPORTSYS?: InputMaybe<Order_By>;
  SPORTVEN?: InputMaybe<Order_By>;
  SSGRP?: InputMaybe<Order_By>;
  SSGRPN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  STFCHG?: InputMaybe<Order_By>;
  STRCHOS?: InputMaybe<Order_By>;
  STRCSYS?: InputMaybe<Order_By>;
  STRCVEN?: InputMaybe<Order_By>;
  SUPPGHOS?: InputMaybe<Order_By>;
  SUPPGSYS?: InputMaybe<Order_By>;
  SUPPGVEN?: InputMaybe<Order_By>;
  SWBDHOS?: InputMaybe<Order_By>;
  SWBDSYS?: InputMaybe<Order_By>;
  SWBDVEN?: InputMaybe<Order_By>;
  TEENSHOS?: InputMaybe<Order_By>;
  TEENSSYS?: InputMaybe<Order_By>;
  TEENSVEN?: InputMaybe<Order_By>;
  TISUHOS?: InputMaybe<Order_By>;
  TISUSYS?: InputMaybe<Order_By>;
  TISUVEN?: InputMaybe<Order_By>;
  TOBHOS?: InputMaybe<Order_By>;
  TOBSYS?: InputMaybe<Order_By>;
  TOBVEN?: InputMaybe<Order_By>;
  TPORTHOS?: InputMaybe<Order_By>;
  TPORTSYS?: InputMaybe<Order_By>;
  TPORTVEN?: InputMaybe<Order_By>;
  URGCCHOS?: InputMaybe<Order_By>;
  URGCCSYS?: InputMaybe<Order_By>;
  URGCCVEN?: InputMaybe<Order_By>;
  VCMMHOS?: InputMaybe<Order_By>;
  VCMMSYS?: InputMaybe<Order_By>;
  VCMMVEN?: InputMaybe<Order_By>;
  VOLSVHOS?: InputMaybe<Order_By>;
  VOLSVSYS?: InputMaybe<Order_By>;
  VOLSVVEN?: InputMaybe<Order_By>;
  VRCSHOS?: InputMaybe<Order_By>;
  VRCSSYS?: InputMaybe<Order_By>;
  VRCSVEN?: InputMaybe<Order_By>;
  VWRKHOS?: InputMaybe<Order_By>;
  VWRKSYS?: InputMaybe<Order_By>;
  VWRKVEN?: InputMaybe<Order_By>;
  WMGTHOS?: InputMaybe<Order_By>;
  WMGTSYS?: InputMaybe<Order_By>;
  WMGTVEN?: InputMaybe<Order_By>;
  WOMHCHOS?: InputMaybe<Order_By>;
  WOMHCSYS?: InputMaybe<Order_By>;
  WOMHCVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS21SVC3 */
export type As21Svc3_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21SVC3" */
export enum As21Svc3_Select_Column {
  /** column name */
  Adtrthos = 'ADTRTHOS',
  /** column name */
  Adtrtsys = 'ADTRTSYS',
  /** column name */
  Adtrtven = 'ADTRTVEN',
  /** column name */
  Alcophos = 'ALCOPHOS',
  /** column name */
  Alcopsys = 'ALCOPSYS',
  /** column name */
  Alcopven = 'ALCOPVEN',
  /** column name */
  Alcpdhos = 'ALCPDHOS',
  /** column name */
  Alcpdsys = 'ALCPDSYS',
  /** column name */
  Alcpdven = 'ALCPDVEN',
  /** column name */
  Alcprhos = 'ALCPRHOS',
  /** column name */
  Alcprsys = 'ALCPRSYS',
  /** column name */
  Alcprven = 'ALCPRVEN',
  /** column name */
  Aldbd = 'ALDBD',
  /** column name */
  Baimv = 'BAIMV',
  /** column name */
  Bhlta = 'BHLTA',
  /** column name */
  Bpimv = 'BPIMV',
  /** column name */
  Chacar = 'CHACAR',
  /** column name */
  Chcarhos = 'CHCARHOS',
  /** column name */
  Chcarsys = 'CHCARSYS',
  /** column name */
  Chcarven = 'CHCARVEN',
  /** column name */
  Cher = 'CHER',
  /** column name */
  Chpcs = 'CHPCS',
  /** column name */
  Chxcar = 'CHXCAR',
  /** column name */
  Cofvhos = 'COFVHOS',
  /** column name */
  Cofvsys = 'COFVSYS',
  /** column name */
  Cofvven = 'COFVVEN',
  /** column name */
  Covidu = 'COVIDU',
  /** column name */
  Cphcos = 'CPHCOS',
  /** column name */
  Cphhos = 'CPHHOS',
  /** column name */
  Cphios = 'CPHIOS',
  /** column name */
  Cphohos = 'CPHOHOS',
  /** column name */
  Cphosys = 'CPHOSYS',
  /** column name */
  Cphp = 'CPHP',
  /** column name */
  Cphpos = 'CPHPOS',
  /** column name */
  Dechc = 'DECHC',
  /** column name */
  Decutla = 'DECUTLA',
  /** column name */
  Dhacar = 'DHACAR',
  /** column name */
  Dher = 'DHER',
  /** column name */
  Dhpcs = 'DHPCS',
  /** column name */
  Dhxcar = 'DHXCAR',
  /** column name */
  Eaimv = 'EAIMV',
  /** column name */
  Edmchg = 'EDMCHG',
  /** column name */
  Eicuhos = 'EICUHOS',
  /** column name */
  Eicusys = 'EICUSYS',
  /** column name */
  Eicuven = 'EICUVEN',
  /** column name */
  Epimv = 'EPIMV',
  /** column name */
  Eqmcos = 'EQMCOS',
  /** column name */
  Eqmhos = 'EQMHOS',
  /** column name */
  Eqmios = 'EQMIOS',
  /** column name */
  Eqmodhos = 'EQMODHOS',
  /** column name */
  Eqmodsys = 'EQMODSYS',
  /** column name */
  Eqmp = 'EQMP',
  /** column name */
  Eqmpos = 'EQMPOS',
  /** column name */
  Fndcos = 'FNDCOS',
  /** column name */
  Fndhos = 'FNDHOS',
  /** column name */
  Fndios = 'FNDIOS',
  /** column name */
  Fndp = 'FNDP',
  /** column name */
  Fndpos = 'FNDPOS',
  /** column name */
  Foundhos = 'FOUNDHOS',
  /** column name */
  Foundsys = 'FOUNDSYS',
  /** column name */
  Ftmt = 'FTMT',
  /** column name */
  Gpwcos = 'GPWCOS',
  /** column name */
  Gpwhos = 'GPWHOS',
  /** column name */
  Gpwios = 'GPWIOS',
  /** column name */
  Gpwp = 'GPWP',
  /** column name */
  Gpwpos = 'GPWPOS',
  /** column name */
  Gpwwhos = 'GPWWHOS',
  /** column name */
  Gpwwsys = 'GPWWSYS',
  /** column name */
  Harthos = 'HARTHOS',
  /** column name */
  Hartsys = 'HARTSYS',
  /** column name */
  Hartven = 'HARTVEN',
  /** column name */
  Icuchg = 'ICUCHG',
  /** column name */
  Id = 'ID',
  /** column name */
  Iismhos = 'IISMHOS',
  /** column name */
  Impstat = 'IMPSTAT',
  /** column name */
  Ipacos = 'IPACOS',
  /** column name */
  Ipahos = 'IPAHOS',
  /** column name */
  Ipaios = 'IPAIOS',
  /** column name */
  Ipap = 'IPAP',
  /** column name */
  Ipapos = 'IPAPOS',
  /** column name */
  Ipasys = 'IPASYS',
  /** column name */
  Ippahos = 'IPPAHOS',
  /** column name */
  Ismcos = 'ISMCOS',
  /** column name */
  Ismhos = 'ISMHOS',
  /** column name */
  Ismios = 'ISMIOS',
  /** column name */
  Ismp = 'ISMP',
  /** column name */
  Ismpos = 'ISMPOS',
  /** column name */
  Ismsys = 'ISMSYS',
  /** column name */
  Isormb = 'ISORMB',
  /** column name */
  Isormc = 'ISORMC',
  /** column name */
  Isorme = 'ISORME',
  /** column name */
  Jnls = 'JNLS',
  /** column name */
  Jntamb = 'JNTAMB',
  /** column name */
  Jntctr = 'JNTCTR',
  /** column name */
  Jntlsc = 'JNTLSC',
  /** column name */
  Jntlso = 'JNTLSO',
  /** column name */
  Jntlss = 'JNTLSS',
  /** column name */
  Jntlst = 'JNTLST',
  /** column name */
  Jntmd = 'JNTMD',
  /** column name */
  Jntoth = 'JNTOTH',
  /** column name */
  Jntph = 'JNTPH',
  /** column name */
  Jnttxt = 'JNTTXT',
  /** column name */
  Kdnyhos = 'KDNYHOS',
  /** column name */
  Kdnysys = 'KDNYSYS',
  /** column name */
  Kdnyven = 'KDNYVEN',
  /** column name */
  Livrhos = 'LIVRHOS',
  /** column name */
  Livrsys = 'LIVRSYS',
  /** column name */
  Livrven = 'LIVRVEN',
  /** column name */
  Lshtxt = 'LSHTXT',
  /** column name */
  Lunghos = 'LUNGHOS',
  /** column name */
  Lungsys = 'LUNGSYS',
  /** column name */
  Lungven = 'LUNGVEN',
  /** column name */
  Medophos = 'MEDOPHOS',
  /** column name */
  Medopsys = 'MEDOPSYS',
  /** column name */
  Medopven = 'MEDOPVEN',
  /** column name */
  Medsubhos = 'MEDSUBHOS',
  /** column name */
  Medsubsys = 'MEDSUBSYS',
  /** column name */
  Medsubven = 'MEDSUBVEN',
  /** column name */
  Mmsohos = 'MMSOHOS',
  /** column name */
  Msgrp = 'MSGRP',
  /** column name */
  Msgrpn = 'MSGRPN',
  /** column name */
  Msocos = 'MSOCOS',
  /** column name */
  Msohos = 'MSOHOS',
  /** column name */
  Msoios = 'MSOIOS',
  /** column name */
  Msop = 'MSOP',
  /** column name */
  Msopos = 'MSOPOS',
  /** column name */
  Msosys = 'MSOSYS',
  /** column name */
  Ophcos = 'OPHCOS',
  /** column name */
  Ophhos = 'OPHHOS',
  /** column name */
  Ophios = 'OPHIOS',
  /** column name */
  Ophohos = 'OPHOHOS',
  /** column name */
  Ophosys = 'OPHOSYS',
  /** column name */
  Ophp = 'OPHP',
  /** column name */
  Ophpos = 'OPHPOS',
  /** column name */
  Orpmhos = 'ORPMHOS',
  /** column name */
  Orpmsys = 'ORPMSYS',
  /** column name */
  Orpmven = 'ORPMVEN',
  /** column name */
  Otbonhos = 'OTBONHOS',
  /** column name */
  Otbonsys = 'OTBONSYS',
  /** column name */
  Otbonven = 'OTBONVEN',
  /** column name */
  Oththos = 'OTHTHOS',
  /** column name */
  Othtsys = 'OTHTSYS',
  /** column name */
  Othtven = 'OTHTVEN',
  /** column name */
  Otothhos = 'OTOTHHOS',
  /** column name */
  Otothsys = 'OTOTHSYS',
  /** column name */
  Otothven = 'OTOTHVEN',
  /** column name */
  Outmtx = 'OUTMTX',
  /** column name */
  Pdishos = 'PDISHOS',
  /** column name */
  Pdissys = 'PDISSYS',
  /** column name */
  Pdisven = 'PDISVEN',
  /** column name */
  Phacar = 'PHACAR',
  /** column name */
  Pher = 'PHER',
  /** column name */
  Phpcs = 'PHPCS',
  /** column name */
  Phxcar = 'PHXCAR',
  /** column name */
  Phycos = 'PHYCOS',
  /** column name */
  Phycpt = 'PHYCPT',
  /** column name */
  Phyhos = 'PHYHOS',
  /** column name */
  Phyios = 'PHYIOS',
  /** column name */
  Phyocpt = 'PHYOCPT',
  /** column name */
  Phyoth = 'PHYOTH',
  /** column name */
  Phyp = 'PHYP',
  /** column name */
  Phypos = 'PHYPOS',
  /** column name */
  Phypr = 'PHYPR',
  /** column name */
  Phyprn = 'PHYPRN',
  /** column name */
  Physys = 'PHYSYS',
  /** column name */
  Pphyhos = 'PPHYHOS',
  /** column name */
  Rurlhos = 'RURLHOS',
  /** column name */
  Rurlsys = 'RURLSYS',
  /** column name */
  Rurlven = 'RURLVEN',
  /** column name */
  Scbh = 'SCBH',
  /** column name */
  Scedl = 'SCEDL',
  /** column name */
  Scfod = 'SCFOD',
  /** column name */
  Schse = 'SCHSE',
  /** column name */
  Scios = 'SCIOS',
  /** column name */
  Scned = 'SCNED',
  /** column name */
  Scoth = 'SCOTH',
  /** column name */
  Scrot = 'SCROT',
  /** column name */
  Scstat = 'SCSTAT',
  /** column name */
  Sctrn = 'SCTRN',
  /** column name */
  Scund = 'SCUND',
  /** column name */
  Scv = 'SCV',
  /** column name */
  Shacar = 'SHACAR',
  /** column name */
  Sher = 'SHER',
  /** column name */
  Shpcs = 'SHPCS',
  /** column name */
  Shxcar = 'SHXCAR',
  /** column name */
  Slephos = 'SLEPHOS',
  /** column name */
  Slepsys = 'SLEPSYS',
  /** column name */
  Slepven = 'SLEPVEN',
  /** column name */
  Socbh = 'SOCBH',
  /** column name */
  Soced = 'SOCED',
  /** column name */
  Socehr = 'SOCEHR',
  /** column name */
  Socfod = 'SOCFOD',
  /** column name */
  Sochse = 'SOCHSE',
  /** column name */
  Socinc = 'SOCINC',
  /** column name */
  Socios = 'SOCIOS',
  /** column name */
  Socned = 'SOCNED',
  /** column name */
  Socot = 'SOCOT',
  /** column name */
  Socoth = 'SOCOTH',
  /** column name */
  Soctrn = 'SOCTRN',
  /** column name */
  Socv = 'SOCV',
  /** column name */
  Socwkhos = 'SOCWKHOS',
  /** column name */
  Socwksys = 'SOCWKSYS',
  /** column name */
  Socwkven = 'SOCWKVEN',
  /** column name */
  Sporthos = 'SPORTHOS',
  /** column name */
  Sportsys = 'SPORTSYS',
  /** column name */
  Sportven = 'SPORTVEN',
  /** column name */
  Ssgrp = 'SSGRP',
  /** column name */
  Ssgrpn = 'SSGRPN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Stfchg = 'STFCHG',
  /** column name */
  Strchos = 'STRCHOS',
  /** column name */
  Strcsys = 'STRCSYS',
  /** column name */
  Strcven = 'STRCVEN',
  /** column name */
  Suppghos = 'SUPPGHOS',
  /** column name */
  Suppgsys = 'SUPPGSYS',
  /** column name */
  Suppgven = 'SUPPGVEN',
  /** column name */
  Swbdhos = 'SWBDHOS',
  /** column name */
  Swbdsys = 'SWBDSYS',
  /** column name */
  Swbdven = 'SWBDVEN',
  /** column name */
  Teenshos = 'TEENSHOS',
  /** column name */
  Teenssys = 'TEENSSYS',
  /** column name */
  Teensven = 'TEENSVEN',
  /** column name */
  Tisuhos = 'TISUHOS',
  /** column name */
  Tisusys = 'TISUSYS',
  /** column name */
  Tisuven = 'TISUVEN',
  /** column name */
  Tobhos = 'TOBHOS',
  /** column name */
  Tobsys = 'TOBSYS',
  /** column name */
  Tobven = 'TOBVEN',
  /** column name */
  Tporthos = 'TPORTHOS',
  /** column name */
  Tportsys = 'TPORTSYS',
  /** column name */
  Tportven = 'TPORTVEN',
  /** column name */
  Urgcchos = 'URGCCHOS',
  /** column name */
  Urgccsys = 'URGCCSYS',
  /** column name */
  Urgccven = 'URGCCVEN',
  /** column name */
  Vcmmhos = 'VCMMHOS',
  /** column name */
  Vcmmsys = 'VCMMSYS',
  /** column name */
  Vcmmven = 'VCMMVEN',
  /** column name */
  Volsvhos = 'VOLSVHOS',
  /** column name */
  Volsvsys = 'VOLSVSYS',
  /** column name */
  Volsvven = 'VOLSVVEN',
  /** column name */
  Vrcshos = 'VRCSHOS',
  /** column name */
  Vrcssys = 'VRCSSYS',
  /** column name */
  Vrcsven = 'VRCSVEN',
  /** column name */
  Vwrkhos = 'VWRKHOS',
  /** column name */
  Vwrksys = 'VWRKSYS',
  /** column name */
  Vwrkven = 'VWRKVEN',
  /** column name */
  Wmgthos = 'WMGTHOS',
  /** column name */
  Wmgtsys = 'WMGTSYS',
  /** column name */
  Wmgtven = 'WMGTVEN',
  /** column name */
  Womhchos = 'WOMHCHOS',
  /** column name */
  Womhcsys = 'WOMHCSYS',
  /** column name */
  Womhcven = 'WOMHCVEN'
}

/** input type for updating data in table "AS21SVC3" */
export type As21Svc3_Set_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHACAR?: InputMaybe<Scalars['String']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  CHER?: InputMaybe<Scalars['String']>;
  CHPCS?: InputMaybe<Scalars['String']>;
  CHXCAR?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  DHACAR?: InputMaybe<Scalars['String']>;
  DHER?: InputMaybe<Scalars['String']>;
  DHPCS?: InputMaybe<Scalars['String']>;
  DHXCAR?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDMCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ICUCHG?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STFCHG?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As21Svc3_Stddev_Fields = {
  __typename?: 'AS21SVC3_stddev_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As21Svc3_Stddev_Pop_Fields = {
  __typename?: 'AS21SVC3_stddev_pop_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As21Svc3_Stddev_Samp_Fields = {
  __typename?: 'AS21SVC3_stddev_samp_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS21SVC3" */
export type As21Svc3_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Svc3_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Svc3_Stream_Cursor_Value_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHACAR?: InputMaybe<Scalars['String']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  CHER?: InputMaybe<Scalars['String']>;
  CHPCS?: InputMaybe<Scalars['String']>;
  CHXCAR?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  DHACAR?: InputMaybe<Scalars['String']>;
  DHER?: InputMaybe<Scalars['String']>;
  DHPCS?: InputMaybe<Scalars['String']>;
  DHXCAR?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDMCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ICUCHG?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STFCHG?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As21Svc3_Sum_Fields = {
  __typename?: 'AS21SVC3_sum_fields';
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BPIMV: Maybe<Scalars['float8']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  EAIMV: Maybe<Scalars['float8']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
};

/** update columns of table "AS21SVC3" */
export enum As21Svc3_Update_Column {
  /** column name */
  Adtrthos = 'ADTRTHOS',
  /** column name */
  Adtrtsys = 'ADTRTSYS',
  /** column name */
  Adtrtven = 'ADTRTVEN',
  /** column name */
  Alcophos = 'ALCOPHOS',
  /** column name */
  Alcopsys = 'ALCOPSYS',
  /** column name */
  Alcopven = 'ALCOPVEN',
  /** column name */
  Alcpdhos = 'ALCPDHOS',
  /** column name */
  Alcpdsys = 'ALCPDSYS',
  /** column name */
  Alcpdven = 'ALCPDVEN',
  /** column name */
  Alcprhos = 'ALCPRHOS',
  /** column name */
  Alcprsys = 'ALCPRSYS',
  /** column name */
  Alcprven = 'ALCPRVEN',
  /** column name */
  Aldbd = 'ALDBD',
  /** column name */
  Baimv = 'BAIMV',
  /** column name */
  Bhlta = 'BHLTA',
  /** column name */
  Bpimv = 'BPIMV',
  /** column name */
  Chacar = 'CHACAR',
  /** column name */
  Chcarhos = 'CHCARHOS',
  /** column name */
  Chcarsys = 'CHCARSYS',
  /** column name */
  Chcarven = 'CHCARVEN',
  /** column name */
  Cher = 'CHER',
  /** column name */
  Chpcs = 'CHPCS',
  /** column name */
  Chxcar = 'CHXCAR',
  /** column name */
  Cofvhos = 'COFVHOS',
  /** column name */
  Cofvsys = 'COFVSYS',
  /** column name */
  Cofvven = 'COFVVEN',
  /** column name */
  Covidu = 'COVIDU',
  /** column name */
  Cphcos = 'CPHCOS',
  /** column name */
  Cphhos = 'CPHHOS',
  /** column name */
  Cphios = 'CPHIOS',
  /** column name */
  Cphohos = 'CPHOHOS',
  /** column name */
  Cphosys = 'CPHOSYS',
  /** column name */
  Cphp = 'CPHP',
  /** column name */
  Cphpos = 'CPHPOS',
  /** column name */
  Dechc = 'DECHC',
  /** column name */
  Decutla = 'DECUTLA',
  /** column name */
  Dhacar = 'DHACAR',
  /** column name */
  Dher = 'DHER',
  /** column name */
  Dhpcs = 'DHPCS',
  /** column name */
  Dhxcar = 'DHXCAR',
  /** column name */
  Eaimv = 'EAIMV',
  /** column name */
  Edmchg = 'EDMCHG',
  /** column name */
  Eicuhos = 'EICUHOS',
  /** column name */
  Eicusys = 'EICUSYS',
  /** column name */
  Eicuven = 'EICUVEN',
  /** column name */
  Epimv = 'EPIMV',
  /** column name */
  Eqmcos = 'EQMCOS',
  /** column name */
  Eqmhos = 'EQMHOS',
  /** column name */
  Eqmios = 'EQMIOS',
  /** column name */
  Eqmodhos = 'EQMODHOS',
  /** column name */
  Eqmodsys = 'EQMODSYS',
  /** column name */
  Eqmp = 'EQMP',
  /** column name */
  Eqmpos = 'EQMPOS',
  /** column name */
  Fndcos = 'FNDCOS',
  /** column name */
  Fndhos = 'FNDHOS',
  /** column name */
  Fndios = 'FNDIOS',
  /** column name */
  Fndp = 'FNDP',
  /** column name */
  Fndpos = 'FNDPOS',
  /** column name */
  Foundhos = 'FOUNDHOS',
  /** column name */
  Foundsys = 'FOUNDSYS',
  /** column name */
  Ftmt = 'FTMT',
  /** column name */
  Gpwcos = 'GPWCOS',
  /** column name */
  Gpwhos = 'GPWHOS',
  /** column name */
  Gpwios = 'GPWIOS',
  /** column name */
  Gpwp = 'GPWP',
  /** column name */
  Gpwpos = 'GPWPOS',
  /** column name */
  Gpwwhos = 'GPWWHOS',
  /** column name */
  Gpwwsys = 'GPWWSYS',
  /** column name */
  Harthos = 'HARTHOS',
  /** column name */
  Hartsys = 'HARTSYS',
  /** column name */
  Hartven = 'HARTVEN',
  /** column name */
  Icuchg = 'ICUCHG',
  /** column name */
  Id = 'ID',
  /** column name */
  Iismhos = 'IISMHOS',
  /** column name */
  Impstat = 'IMPSTAT',
  /** column name */
  Ipacos = 'IPACOS',
  /** column name */
  Ipahos = 'IPAHOS',
  /** column name */
  Ipaios = 'IPAIOS',
  /** column name */
  Ipap = 'IPAP',
  /** column name */
  Ipapos = 'IPAPOS',
  /** column name */
  Ipasys = 'IPASYS',
  /** column name */
  Ippahos = 'IPPAHOS',
  /** column name */
  Ismcos = 'ISMCOS',
  /** column name */
  Ismhos = 'ISMHOS',
  /** column name */
  Ismios = 'ISMIOS',
  /** column name */
  Ismp = 'ISMP',
  /** column name */
  Ismpos = 'ISMPOS',
  /** column name */
  Ismsys = 'ISMSYS',
  /** column name */
  Isormb = 'ISORMB',
  /** column name */
  Isormc = 'ISORMC',
  /** column name */
  Isorme = 'ISORME',
  /** column name */
  Jnls = 'JNLS',
  /** column name */
  Jntamb = 'JNTAMB',
  /** column name */
  Jntctr = 'JNTCTR',
  /** column name */
  Jntlsc = 'JNTLSC',
  /** column name */
  Jntlso = 'JNTLSO',
  /** column name */
  Jntlss = 'JNTLSS',
  /** column name */
  Jntlst = 'JNTLST',
  /** column name */
  Jntmd = 'JNTMD',
  /** column name */
  Jntoth = 'JNTOTH',
  /** column name */
  Jntph = 'JNTPH',
  /** column name */
  Jnttxt = 'JNTTXT',
  /** column name */
  Kdnyhos = 'KDNYHOS',
  /** column name */
  Kdnysys = 'KDNYSYS',
  /** column name */
  Kdnyven = 'KDNYVEN',
  /** column name */
  Livrhos = 'LIVRHOS',
  /** column name */
  Livrsys = 'LIVRSYS',
  /** column name */
  Livrven = 'LIVRVEN',
  /** column name */
  Lshtxt = 'LSHTXT',
  /** column name */
  Lunghos = 'LUNGHOS',
  /** column name */
  Lungsys = 'LUNGSYS',
  /** column name */
  Lungven = 'LUNGVEN',
  /** column name */
  Medophos = 'MEDOPHOS',
  /** column name */
  Medopsys = 'MEDOPSYS',
  /** column name */
  Medopven = 'MEDOPVEN',
  /** column name */
  Medsubhos = 'MEDSUBHOS',
  /** column name */
  Medsubsys = 'MEDSUBSYS',
  /** column name */
  Medsubven = 'MEDSUBVEN',
  /** column name */
  Mmsohos = 'MMSOHOS',
  /** column name */
  Msgrp = 'MSGRP',
  /** column name */
  Msgrpn = 'MSGRPN',
  /** column name */
  Msocos = 'MSOCOS',
  /** column name */
  Msohos = 'MSOHOS',
  /** column name */
  Msoios = 'MSOIOS',
  /** column name */
  Msop = 'MSOP',
  /** column name */
  Msopos = 'MSOPOS',
  /** column name */
  Msosys = 'MSOSYS',
  /** column name */
  Ophcos = 'OPHCOS',
  /** column name */
  Ophhos = 'OPHHOS',
  /** column name */
  Ophios = 'OPHIOS',
  /** column name */
  Ophohos = 'OPHOHOS',
  /** column name */
  Ophosys = 'OPHOSYS',
  /** column name */
  Ophp = 'OPHP',
  /** column name */
  Ophpos = 'OPHPOS',
  /** column name */
  Orpmhos = 'ORPMHOS',
  /** column name */
  Orpmsys = 'ORPMSYS',
  /** column name */
  Orpmven = 'ORPMVEN',
  /** column name */
  Otbonhos = 'OTBONHOS',
  /** column name */
  Otbonsys = 'OTBONSYS',
  /** column name */
  Otbonven = 'OTBONVEN',
  /** column name */
  Oththos = 'OTHTHOS',
  /** column name */
  Othtsys = 'OTHTSYS',
  /** column name */
  Othtven = 'OTHTVEN',
  /** column name */
  Otothhos = 'OTOTHHOS',
  /** column name */
  Otothsys = 'OTOTHSYS',
  /** column name */
  Otothven = 'OTOTHVEN',
  /** column name */
  Outmtx = 'OUTMTX',
  /** column name */
  Pdishos = 'PDISHOS',
  /** column name */
  Pdissys = 'PDISSYS',
  /** column name */
  Pdisven = 'PDISVEN',
  /** column name */
  Phacar = 'PHACAR',
  /** column name */
  Pher = 'PHER',
  /** column name */
  Phpcs = 'PHPCS',
  /** column name */
  Phxcar = 'PHXCAR',
  /** column name */
  Phycos = 'PHYCOS',
  /** column name */
  Phycpt = 'PHYCPT',
  /** column name */
  Phyhos = 'PHYHOS',
  /** column name */
  Phyios = 'PHYIOS',
  /** column name */
  Phyocpt = 'PHYOCPT',
  /** column name */
  Phyoth = 'PHYOTH',
  /** column name */
  Phyp = 'PHYP',
  /** column name */
  Phypos = 'PHYPOS',
  /** column name */
  Phypr = 'PHYPR',
  /** column name */
  Phyprn = 'PHYPRN',
  /** column name */
  Physys = 'PHYSYS',
  /** column name */
  Pphyhos = 'PPHYHOS',
  /** column name */
  Rurlhos = 'RURLHOS',
  /** column name */
  Rurlsys = 'RURLSYS',
  /** column name */
  Rurlven = 'RURLVEN',
  /** column name */
  Scbh = 'SCBH',
  /** column name */
  Scedl = 'SCEDL',
  /** column name */
  Scfod = 'SCFOD',
  /** column name */
  Schse = 'SCHSE',
  /** column name */
  Scios = 'SCIOS',
  /** column name */
  Scned = 'SCNED',
  /** column name */
  Scoth = 'SCOTH',
  /** column name */
  Scrot = 'SCROT',
  /** column name */
  Scstat = 'SCSTAT',
  /** column name */
  Sctrn = 'SCTRN',
  /** column name */
  Scund = 'SCUND',
  /** column name */
  Scv = 'SCV',
  /** column name */
  Shacar = 'SHACAR',
  /** column name */
  Sher = 'SHER',
  /** column name */
  Shpcs = 'SHPCS',
  /** column name */
  Shxcar = 'SHXCAR',
  /** column name */
  Slephos = 'SLEPHOS',
  /** column name */
  Slepsys = 'SLEPSYS',
  /** column name */
  Slepven = 'SLEPVEN',
  /** column name */
  Socbh = 'SOCBH',
  /** column name */
  Soced = 'SOCED',
  /** column name */
  Socehr = 'SOCEHR',
  /** column name */
  Socfod = 'SOCFOD',
  /** column name */
  Sochse = 'SOCHSE',
  /** column name */
  Socinc = 'SOCINC',
  /** column name */
  Socios = 'SOCIOS',
  /** column name */
  Socned = 'SOCNED',
  /** column name */
  Socot = 'SOCOT',
  /** column name */
  Socoth = 'SOCOTH',
  /** column name */
  Soctrn = 'SOCTRN',
  /** column name */
  Socv = 'SOCV',
  /** column name */
  Socwkhos = 'SOCWKHOS',
  /** column name */
  Socwksys = 'SOCWKSYS',
  /** column name */
  Socwkven = 'SOCWKVEN',
  /** column name */
  Sporthos = 'SPORTHOS',
  /** column name */
  Sportsys = 'SPORTSYS',
  /** column name */
  Sportven = 'SPORTVEN',
  /** column name */
  Ssgrp = 'SSGRP',
  /** column name */
  Ssgrpn = 'SSGRPN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Stfchg = 'STFCHG',
  /** column name */
  Strchos = 'STRCHOS',
  /** column name */
  Strcsys = 'STRCSYS',
  /** column name */
  Strcven = 'STRCVEN',
  /** column name */
  Suppghos = 'SUPPGHOS',
  /** column name */
  Suppgsys = 'SUPPGSYS',
  /** column name */
  Suppgven = 'SUPPGVEN',
  /** column name */
  Swbdhos = 'SWBDHOS',
  /** column name */
  Swbdsys = 'SWBDSYS',
  /** column name */
  Swbdven = 'SWBDVEN',
  /** column name */
  Teenshos = 'TEENSHOS',
  /** column name */
  Teenssys = 'TEENSSYS',
  /** column name */
  Teensven = 'TEENSVEN',
  /** column name */
  Tisuhos = 'TISUHOS',
  /** column name */
  Tisusys = 'TISUSYS',
  /** column name */
  Tisuven = 'TISUVEN',
  /** column name */
  Tobhos = 'TOBHOS',
  /** column name */
  Tobsys = 'TOBSYS',
  /** column name */
  Tobven = 'TOBVEN',
  /** column name */
  Tporthos = 'TPORTHOS',
  /** column name */
  Tportsys = 'TPORTSYS',
  /** column name */
  Tportven = 'TPORTVEN',
  /** column name */
  Urgcchos = 'URGCCHOS',
  /** column name */
  Urgccsys = 'URGCCSYS',
  /** column name */
  Urgccven = 'URGCCVEN',
  /** column name */
  Vcmmhos = 'VCMMHOS',
  /** column name */
  Vcmmsys = 'VCMMSYS',
  /** column name */
  Vcmmven = 'VCMMVEN',
  /** column name */
  Volsvhos = 'VOLSVHOS',
  /** column name */
  Volsvsys = 'VOLSVSYS',
  /** column name */
  Volsvven = 'VOLSVVEN',
  /** column name */
  Vrcshos = 'VRCSHOS',
  /** column name */
  Vrcssys = 'VRCSSYS',
  /** column name */
  Vrcsven = 'VRCSVEN',
  /** column name */
  Vwrkhos = 'VWRKHOS',
  /** column name */
  Vwrksys = 'VWRKSYS',
  /** column name */
  Vwrkven = 'VWRKVEN',
  /** column name */
  Wmgthos = 'WMGTHOS',
  /** column name */
  Wmgtsys = 'WMGTSYS',
  /** column name */
  Wmgtven = 'WMGTVEN',
  /** column name */
  Womhchos = 'WOMHCHOS',
  /** column name */
  Womhcsys = 'WOMHCSYS',
  /** column name */
  Womhcven = 'WOMHCVEN'
}

export type As21Svc3_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As21Svc3_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Svc3_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Svc3_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As21Svc3_Var_Pop_Fields = {
  __typename?: 'AS21SVC3_var_pop_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As21Svc3_Var_Samp_Fields = {
  __typename?: 'AS21SVC3_var_samp_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As21Svc3_Variance_Fields = {
  __typename?: 'AS21SVC3_variance_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS21UNIT" */
export type As21Unit = {
  __typename?: 'AS21UNIT';
  ID: Scalars['String'];
  PARID: Scalars['String'];
  UADDR: Maybe<Scalars['String']>;
  UCITY: Maybe<Scalars['String']>;
  UNAME: Scalars['String'];
  UPHONE: Maybe<Scalars['String']>;
  USERV: Maybe<Scalars['String']>;
  USTATE: Maybe<Scalars['String']>;
  USTCD: Maybe<Scalars['String']>;
  UZIP: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_aha_facility: As21Dem;
};

/** aggregated selection of "AS21UNIT" */
export type As21Unit_Aggregate = {
  __typename?: 'AS21UNIT_aggregate';
  aggregate: Maybe<As21Unit_Aggregate_Fields>;
  nodes: Array<As21Unit>;
};

export type As21Unit_Aggregate_Bool_Exp = {
  count?: InputMaybe<As21Unit_Aggregate_Bool_Exp_Count>;
};

export type As21Unit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<As21Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<As21Unit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "AS21UNIT" */
export type As21Unit_Aggregate_Fields = {
  __typename?: 'AS21UNIT_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<As21Unit_Max_Fields>;
  min: Maybe<As21Unit_Min_Fields>;
};


/** aggregate fields of "AS21UNIT" */
export type As21Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "AS21UNIT" */
export type As21Unit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<As21Unit_Max_Order_By>;
  min?: InputMaybe<As21Unit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "AS21UNIT" */
export type As21Unit_Arr_Rel_Insert_Input = {
  data: Array<As21Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Unit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "AS21UNIT". All fields are combined with a logical 'AND'. */
export type As21Unit_Bool_Exp = {
  ID?: InputMaybe<String_Comparison_Exp>;
  PARID?: InputMaybe<String_Comparison_Exp>;
  UADDR?: InputMaybe<String_Comparison_Exp>;
  UCITY?: InputMaybe<String_Comparison_Exp>;
  UNAME?: InputMaybe<String_Comparison_Exp>;
  UPHONE?: InputMaybe<String_Comparison_Exp>;
  USERV?: InputMaybe<String_Comparison_Exp>;
  USTATE?: InputMaybe<String_Comparison_Exp>;
  USTCD?: InputMaybe<String_Comparison_Exp>;
  UZIP?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Unit_Bool_Exp>>;
  _not?: InputMaybe<As21Unit_Bool_Exp>;
  _or?: InputMaybe<Array<As21Unit_Bool_Exp>>;
  parent_aha_facility?: InputMaybe<As21Dem_Bool_Exp>;
};

/** unique or primary key constraints on table "AS21UNIT" */
export enum As21Unit_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Unit = 'pk_AS21UNIT'
}

/** input type for inserting data into table "AS21UNIT" */
export type As21Unit_Insert_Input = {
  ID?: InputMaybe<Scalars['String']>;
  PARID?: InputMaybe<Scalars['String']>;
  UADDR?: InputMaybe<Scalars['String']>;
  UCITY?: InputMaybe<Scalars['String']>;
  UNAME?: InputMaybe<Scalars['String']>;
  UPHONE?: InputMaybe<Scalars['String']>;
  USERV?: InputMaybe<Scalars['String']>;
  USTATE?: InputMaybe<Scalars['String']>;
  USTCD?: InputMaybe<Scalars['String']>;
  UZIP?: InputMaybe<Scalars['String']>;
  parent_aha_facility?: InputMaybe<As21Dem_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type As21Unit_Max_Fields = {
  __typename?: 'AS21UNIT_max_fields';
  ID: Maybe<Scalars['String']>;
  PARID: Maybe<Scalars['String']>;
  UADDR: Maybe<Scalars['String']>;
  UCITY: Maybe<Scalars['String']>;
  UNAME: Maybe<Scalars['String']>;
  UPHONE: Maybe<Scalars['String']>;
  USERV: Maybe<Scalars['String']>;
  USTATE: Maybe<Scalars['String']>;
  USTCD: Maybe<Scalars['String']>;
  UZIP: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "AS21UNIT" */
export type As21Unit_Max_Order_By = {
  ID?: InputMaybe<Order_By>;
  PARID?: InputMaybe<Order_By>;
  UADDR?: InputMaybe<Order_By>;
  UCITY?: InputMaybe<Order_By>;
  UNAME?: InputMaybe<Order_By>;
  UPHONE?: InputMaybe<Order_By>;
  USERV?: InputMaybe<Order_By>;
  USTATE?: InputMaybe<Order_By>;
  USTCD?: InputMaybe<Order_By>;
  UZIP?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type As21Unit_Min_Fields = {
  __typename?: 'AS21UNIT_min_fields';
  ID: Maybe<Scalars['String']>;
  PARID: Maybe<Scalars['String']>;
  UADDR: Maybe<Scalars['String']>;
  UCITY: Maybe<Scalars['String']>;
  UNAME: Maybe<Scalars['String']>;
  UPHONE: Maybe<Scalars['String']>;
  USERV: Maybe<Scalars['String']>;
  USTATE: Maybe<Scalars['String']>;
  USTCD: Maybe<Scalars['String']>;
  UZIP: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "AS21UNIT" */
export type As21Unit_Min_Order_By = {
  ID?: InputMaybe<Order_By>;
  PARID?: InputMaybe<Order_By>;
  UADDR?: InputMaybe<Order_By>;
  UCITY?: InputMaybe<Order_By>;
  UNAME?: InputMaybe<Order_By>;
  UPHONE?: InputMaybe<Order_By>;
  USERV?: InputMaybe<Order_By>;
  USTATE?: InputMaybe<Order_By>;
  USTCD?: InputMaybe<Order_By>;
  UZIP?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "AS21UNIT" */
export type As21Unit_Mutation_Response = {
  __typename?: 'AS21UNIT_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Unit>;
};

/** on_conflict condition type for table "AS21UNIT" */
export type As21Unit_On_Conflict = {
  constraint: As21Unit_Constraint;
  update_columns?: Array<As21Unit_Update_Column>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21UNIT". */
export type As21Unit_Order_By = {
  ID?: InputMaybe<Order_By>;
  PARID?: InputMaybe<Order_By>;
  UADDR?: InputMaybe<Order_By>;
  UCITY?: InputMaybe<Order_By>;
  UNAME?: InputMaybe<Order_By>;
  UPHONE?: InputMaybe<Order_By>;
  USERV?: InputMaybe<Order_By>;
  USTATE?: InputMaybe<Order_By>;
  USTCD?: InputMaybe<Order_By>;
  UZIP?: InputMaybe<Order_By>;
  parent_aha_facility?: InputMaybe<As21Dem_Order_By>;
};

/** primary key columns input for table: AS21UNIT */
export type As21Unit_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21UNIT" */
export enum As21Unit_Select_Column {
  /** column name */
  Id = 'ID',
  /** column name */
  Parid = 'PARID',
  /** column name */
  Uaddr = 'UADDR',
  /** column name */
  Ucity = 'UCITY',
  /** column name */
  Uname = 'UNAME',
  /** column name */
  Uphone = 'UPHONE',
  /** column name */
  Userv = 'USERV',
  /** column name */
  Ustate = 'USTATE',
  /** column name */
  Ustcd = 'USTCD',
  /** column name */
  Uzip = 'UZIP'
}

/** input type for updating data in table "AS21UNIT" */
export type As21Unit_Set_Input = {
  ID?: InputMaybe<Scalars['String']>;
  PARID?: InputMaybe<Scalars['String']>;
  UADDR?: InputMaybe<Scalars['String']>;
  UCITY?: InputMaybe<Scalars['String']>;
  UNAME?: InputMaybe<Scalars['String']>;
  UPHONE?: InputMaybe<Scalars['String']>;
  USERV?: InputMaybe<Scalars['String']>;
  USTATE?: InputMaybe<Scalars['String']>;
  USTCD?: InputMaybe<Scalars['String']>;
  UZIP?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "AS21UNIT" */
export type As21Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Unit_Stream_Cursor_Value_Input = {
  ID?: InputMaybe<Scalars['String']>;
  PARID?: InputMaybe<Scalars['String']>;
  UADDR?: InputMaybe<Scalars['String']>;
  UCITY?: InputMaybe<Scalars['String']>;
  UNAME?: InputMaybe<Scalars['String']>;
  UPHONE?: InputMaybe<Scalars['String']>;
  USERV?: InputMaybe<Scalars['String']>;
  USTATE?: InputMaybe<Scalars['String']>;
  USTCD?: InputMaybe<Scalars['String']>;
  UZIP?: InputMaybe<Scalars['String']>;
};

/** update columns of table "AS21UNIT" */
export enum As21Unit_Update_Column {
  /** column name */
  Id = 'ID',
  /** column name */
  Parid = 'PARID',
  /** column name */
  Uaddr = 'UADDR',
  /** column name */
  Ucity = 'UCITY',
  /** column name */
  Uname = 'UNAME',
  /** column name */
  Uphone = 'UPHONE',
  /** column name */
  Userv = 'USERV',
  /** column name */
  Ustate = 'USTATE',
  /** column name */
  Ustcd = 'USTCD',
  /** column name */
  Uzip = 'UZIP'
}

export type As21Unit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Unit_Bool_Exp;
};

/** columns and relationships of "AS21UTIL" */
export type As21Util = {
  __typename?: 'AS21UTIL';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Scalars['String'];
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** columns and relationships of "AS21UTIL2" */
export type As21Util2 = {
  __typename?: 'AS21UTIL2';
  AAACLI: Maybe<Scalars['String']>;
  AAACNA: Maybe<Scalars['String']>;
  AAANI: Maybe<Scalars['String']>;
  AAAPSN: Maybe<Scalars['String']>;
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  BHHLT: Maybe<Scalars['String']>;
  BHPRDCLI: Maybe<Scalars['String']>;
  BHPRDCNA: Maybe<Scalars['String']>;
  BHPRDNI: Maybe<Scalars['String']>;
  BHPRDPSN: Maybe<Scalars['String']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  CMHLT: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  KOREA: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OSFTE: Maybe<Scalars['float8']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PH: Maybe<Scalars['String']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** aggregated selection of "AS21UTIL2" */
export type As21Util2_Aggregate = {
  __typename?: 'AS21UTIL2_aggregate';
  aggregate: Maybe<As21Util2_Aggregate_Fields>;
  nodes: Array<As21Util2>;
};

/** aggregate fields of "AS21UTIL2" */
export type As21Util2_Aggregate_Fields = {
  __typename?: 'AS21UTIL2_aggregate_fields';
  avg: Maybe<As21Util2_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As21Util2_Max_Fields>;
  min: Maybe<As21Util2_Min_Fields>;
  stddev: Maybe<As21Util2_Stddev_Fields>;
  stddev_pop: Maybe<As21Util2_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As21Util2_Stddev_Samp_Fields>;
  sum: Maybe<As21Util2_Sum_Fields>;
  var_pop: Maybe<As21Util2_Var_Pop_Fields>;
  var_samp: Maybe<As21Util2_Var_Samp_Fields>;
  variance: Maybe<As21Util2_Variance_Fields>;
};


/** aggregate fields of "AS21UTIL2" */
export type As21Util2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Util2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As21Util2_Avg_Fields = {
  __typename?: 'AS21UTIL2_avg_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS21UTIL2". All fields are combined with a logical 'AND'. */
export type As21Util2_Bool_Exp = {
  AAACLI?: InputMaybe<String_Comparison_Exp>;
  AAACNA?: InputMaybe<String_Comparison_Exp>;
  AAANI?: InputMaybe<String_Comparison_Exp>;
  AAAPSN?: InputMaybe<String_Comparison_Exp>;
  ADEPRA?: InputMaybe<Float8_Comparison_Exp>;
  AFRICA?: InputMaybe<String_Comparison_Exp>;
  APANES?: InputMaybe<String_Comparison_Exp>;
  APCAR?: InputMaybe<String_Comparison_Exp>;
  APCASE?: InputMaybe<String_Comparison_Exp>;
  APED?: InputMaybe<String_Comparison_Exp>;
  APEMER?: InputMaybe<String_Comparison_Exp>;
  APOTH?: InputMaybe<String_Comparison_Exp>;
  APRN?: InputMaybe<String_Comparison_Exp>;
  APSPC?: InputMaybe<String_Comparison_Exp>;
  ASSNET?: InputMaybe<Float8_Comparison_Exp>;
  AUVZ?: InputMaybe<Float8_Comparison_Exp>;
  BHHLT?: InputMaybe<String_Comparison_Exp>;
  BHPRDCLI?: InputMaybe<String_Comparison_Exp>;
  BHPRDCNA?: InputMaybe<String_Comparison_Exp>;
  BHPRDNI?: InputMaybe<String_Comparison_Exp>;
  BHPRDPSN?: InputMaybe<String_Comparison_Exp>;
  CANADA?: InputMaybe<String_Comparison_Exp>;
  CEAMT?: InputMaybe<Float8_Comparison_Exp>;
  CHINA?: InputMaybe<String_Comparison_Exp>;
  CLSCIC?: InputMaybe<String_Comparison_Exp>;
  CLSMSI?: InputMaybe<String_Comparison_Exp>;
  CLSNIC?: InputMaybe<String_Comparison_Exp>;
  CLSOIC?: InputMaybe<String_Comparison_Exp>;
  CLSPIC?: InputMaybe<String_Comparison_Exp>;
  CMHLT?: InputMaybe<String_Comparison_Exp>;
  COLLCLI?: InputMaybe<String_Comparison_Exp>;
  COLLCNA?: InputMaybe<String_Comparison_Exp>;
  COLLNI?: InputMaybe<String_Comparison_Exp>;
  COLLPSN?: InputMaybe<String_Comparison_Exp>;
  DEIDPDEV?: InputMaybe<Float8_Comparison_Exp>;
  DEIDPO?: InputMaybe<Float8_Comparison_Exp>;
  DEIDPROC?: InputMaybe<Float8_Comparison_Exp>;
  DEIDSPCH?: InputMaybe<Float8_Comparison_Exp>;
  DEIDTRN?: InputMaybe<Float8_Comparison_Exp>;
  FBORCLI?: InputMaybe<String_Comparison_Exp>;
  FBORCNA?: InputMaybe<String_Comparison_Exp>;
  FBORNI?: InputMaybe<String_Comparison_Exp>;
  FBORPSN?: InputMaybe<String_Comparison_Exp>;
  FORNRSA?: InputMaybe<String_Comparison_Exp>;
  FTAPRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEAPN?: InputMaybe<Float8_Comparison_Exp>;
  FTECIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEHSP?: InputMaybe<Float8_Comparison_Exp>;
  FTEINT?: InputMaybe<Float8_Comparison_Exp>;
  FTEMSI?: InputMaybe<Float8_Comparison_Exp>;
  FTENIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEOIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEPHRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEPIC?: InputMaybe<Float8_Comparison_Exp>;
  FTPHRN?: InputMaybe<Float8_Comparison_Exp>;
  GFEET?: InputMaybe<Float8_Comparison_Exp>;
  HCOCCLI?: InputMaybe<String_Comparison_Exp>;
  HCOCCNA?: InputMaybe<String_Comparison_Exp>;
  HCOCNI?: InputMaybe<String_Comparison_Exp>;
  HCOCPSN?: InputMaybe<String_Comparison_Exp>;
  HHEGCDO?: InputMaybe<Float8_Comparison_Exp>;
  HHEGCEO?: InputMaybe<Float8_Comparison_Exp>;
  HHEGERG?: InputMaybe<Float8_Comparison_Exp>;
  HHEGLEAD?: InputMaybe<Float8_Comparison_Exp>;
  HHEGMDMN?: InputMaybe<Float8_Comparison_Exp>;
  HHEGTKFC?: InputMaybe<Float8_Comparison_Exp>;
  HICOCCLI?: InputMaybe<String_Comparison_Exp>;
  HICOCCNA?: InputMaybe<String_Comparison_Exp>;
  HICOCNI?: InputMaybe<String_Comparison_Exp>;
  HICOCPSN?: InputMaybe<String_Comparison_Exp>;
  HSPTL?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  INDIA?: InputMaybe<String_Comparison_Exp>;
  INTCAR?: InputMaybe<String_Comparison_Exp>;
  ITBUGT?: InputMaybe<Float8_Comparison_Exp>;
  ITEXPA?: InputMaybe<Float8_Comparison_Exp>;
  ITFTE?: InputMaybe<Float8_Comparison_Exp>;
  KOREA?: InputMaybe<String_Comparison_Exp>;
  KSCHCLI?: InputMaybe<String_Comparison_Exp>;
  KSCHCNA?: InputMaybe<String_Comparison_Exp>;
  KSCHNI?: InputMaybe<String_Comparison_Exp>;
  KSCHPSN?: InputMaybe<String_Comparison_Exp>;
  LOCFCLI?: InputMaybe<String_Comparison_Exp>;
  LOCFCNA?: InputMaybe<String_Comparison_Exp>;
  LOCFNI?: InputMaybe<String_Comparison_Exp>;
  LOCFPSN?: InputMaybe<String_Comparison_Exp>;
  LOCHSCLI?: InputMaybe<String_Comparison_Exp>;
  LOCHSCNA?: InputMaybe<String_Comparison_Exp>;
  LOCHSNI?: InputMaybe<String_Comparison_Exp>;
  LOCHSPSN?: InputMaybe<String_Comparison_Exp>;
  LOCLGCLI?: InputMaybe<String_Comparison_Exp>;
  LOCLGCNA?: InputMaybe<String_Comparison_Exp>;
  LOCLGNI?: InputMaybe<String_Comparison_Exp>;
  LOCLGPSN?: InputMaybe<String_Comparison_Exp>;
  LOCOCCLI?: InputMaybe<String_Comparison_Exp>;
  LOCOCCNA?: InputMaybe<String_Comparison_Exp>;
  LOCOCNI?: InputMaybe<String_Comparison_Exp>;
  LOCOCPSN?: InputMaybe<String_Comparison_Exp>;
  LOCTRCLI?: InputMaybe<String_Comparison_Exp>;
  LOCTRCNA?: InputMaybe<String_Comparison_Exp>;
  LOCTRNI?: InputMaybe<String_Comparison_Exp>;
  LOCTRPSN?: InputMaybe<String_Comparison_Exp>;
  LORGCLI?: InputMaybe<String_Comparison_Exp>;
  LORGCNA?: InputMaybe<String_Comparison_Exp>;
  LORGNI?: InputMaybe<String_Comparison_Exp>;
  LORGPSN?: InputMaybe<String_Comparison_Exp>;
  NECAR?: InputMaybe<Float8_Comparison_Exp>;
  NEGST?: InputMaybe<Float8_Comparison_Exp>;
  NEHSP?: InputMaybe<Float8_Comparison_Exp>;
  NEINT?: InputMaybe<Float8_Comparison_Exp>;
  NEMER?: InputMaybe<Float8_Comparison_Exp>;
  NEOB?: InputMaybe<Float8_Comparison_Exp>;
  NEOTH?: InputMaybe<Float8_Comparison_Exp>;
  NETOT?: InputMaybe<Float8_Comparison_Exp>;
  OFRNRS?: InputMaybe<String_Comparison_Exp>;
  OSFTE?: InputMaybe<Float8_Comparison_Exp>;
  OTCOMCLI?: InputMaybe<String_Comparison_Exp>;
  OTCOMCNA?: InputMaybe<String_Comparison_Exp>;
  OTCOMNI?: InputMaybe<String_Comparison_Exp>;
  OTCOMPSN?: InputMaybe<String_Comparison_Exp>;
  OTLSCLI?: InputMaybe<String_Comparison_Exp>;
  OTLSCNA?: InputMaybe<String_Comparison_Exp>;
  OTLSNI?: InputMaybe<String_Comparison_Exp>;
  OTLSPSN?: InputMaybe<String_Comparison_Exp>;
  PH?: InputMaybe<String_Comparison_Exp>;
  PHEGACC?: InputMaybe<Float8_Comparison_Exp>;
  PHEGCAPC?: InputMaybe<Float8_Comparison_Exp>;
  PHEGCMTY?: InputMaybe<Float8_Comparison_Exp>;
  PHEGDATA?: InputMaybe<Float8_Comparison_Exp>;
  PHEGEIOP?: InputMaybe<Float8_Comparison_Exp>;
  PHEGGOV?: InputMaybe<Float8_Comparison_Exp>;
  PHEGLEAD?: InputMaybe<Float8_Comparison_Exp>;
  PLCECLI?: InputMaybe<String_Comparison_Exp>;
  PLCECNA?: InputMaybe<String_Comparison_Exp>;
  PLCENI?: InputMaybe<String_Comparison_Exp>;
  PLCEPSN?: InputMaybe<String_Comparison_Exp>;
  PLNTA?: InputMaybe<Float8_Comparison_Exp>;
  PRPM?: InputMaybe<Float8_Comparison_Exp>;
  PTAPRN?: InputMaybe<Float8_Comparison_Exp>;
  PTPHRN?: InputMaybe<Float8_Comparison_Exp>;
  RNSCH?: InputMaybe<Float8_Comparison_Exp>;
  SHEGCDO?: InputMaybe<Float8_Comparison_Exp>;
  SHEGCEO?: InputMaybe<Float8_Comparison_Exp>;
  SHEGERG?: InputMaybe<Float8_Comparison_Exp>;
  SHEGLEAD?: InputMaybe<Float8_Comparison_Exp>;
  SHEGMDMN?: InputMaybe<Float8_Comparison_Exp>;
  SHEGTKFC?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  TCCAR?: InputMaybe<Float8_Comparison_Exp>;
  TCGST?: InputMaybe<Float8_Comparison_Exp>;
  TCHSP?: InputMaybe<Float8_Comparison_Exp>;
  TCINT?: InputMaybe<Float8_Comparison_Exp>;
  TCMER?: InputMaybe<Float8_Comparison_Exp>;
  TCOB?: InputMaybe<Float8_Comparison_Exp>;
  TCOTH?: InputMaybe<Float8_Comparison_Exp>;
  TCTOT?: InputMaybe<Float8_Comparison_Exp>;
  TECAR?: InputMaybe<Float8_Comparison_Exp>;
  TEGST?: InputMaybe<Float8_Comparison_Exp>;
  TEHSP?: InputMaybe<Float8_Comparison_Exp>;
  TEINT?: InputMaybe<Float8_Comparison_Exp>;
  TEMER?: InputMaybe<Float8_Comparison_Exp>;
  TEOB?: InputMaybe<Float8_Comparison_Exp>;
  TEOTH?: InputMaybe<Float8_Comparison_Exp>;
  TETOT?: InputMaybe<Float8_Comparison_Exp>;
  TGCAR?: InputMaybe<Float8_Comparison_Exp>;
  TGGST?: InputMaybe<Float8_Comparison_Exp>;
  TGHSP?: InputMaybe<Float8_Comparison_Exp>;
  TGINT?: InputMaybe<Float8_Comparison_Exp>;
  TGMER?: InputMaybe<Float8_Comparison_Exp>;
  TGOB?: InputMaybe<Float8_Comparison_Exp>;
  TGOTH?: InputMaybe<Float8_Comparison_Exp>;
  TGTOT?: InputMaybe<Float8_Comparison_Exp>;
  TPCAR?: InputMaybe<Float8_Comparison_Exp>;
  TPGST?: InputMaybe<Float8_Comparison_Exp>;
  TPHSP?: InputMaybe<Float8_Comparison_Exp>;
  TPINT?: InputMaybe<Float8_Comparison_Exp>;
  TPMER?: InputMaybe<Float8_Comparison_Exp>;
  TPOB?: InputMaybe<Float8_Comparison_Exp>;
  TPOTH?: InputMaybe<Float8_Comparison_Exp>;
  TPRTOT?: InputMaybe<Float8_Comparison_Exp>;
  VIDVZ?: InputMaybe<Float8_Comparison_Exp>;
  VPSRV?: InputMaybe<Float8_Comparison_Exp>;
  WFAIART?: InputMaybe<Float8_Comparison_Exp>;
  WFAIOACW?: InputMaybe<Float8_Comparison_Exp>;
  WFAIPPD?: InputMaybe<Float8_Comparison_Exp>;
  WFAIPSN?: InputMaybe<Float8_Comparison_Exp>;
  WFAISS?: InputMaybe<Float8_Comparison_Exp>;
  WFSTCNA?: InputMaybe<Float8_Comparison_Exp>;
  WFSTHCC?: InputMaybe<Float8_Comparison_Exp>;
  WFSTLSP?: InputMaybe<Float8_Comparison_Exp>;
  WFSTRRP?: InputMaybe<Float8_Comparison_Exp>;
  WFSTTDP?: InputMaybe<Float8_Comparison_Exp>;
  WFSTVTP?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Util2_Bool_Exp>>;
  _not?: InputMaybe<As21Util2_Bool_Exp>;
  _or?: InputMaybe<Array<As21Util2_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS21UTIL2" */
export enum As21Util2_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Util2 = 'pk_AS21UTIL2'
}

/** input type for incrementing numeric columns in table "AS21UTIL2" */
export type As21Util2_Inc_Input = {
  ADEPRA?: InputMaybe<Scalars['float8']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS21UTIL2" */
export type As21Util2_Insert_Input = {
  AAACLI?: InputMaybe<Scalars['String']>;
  AAACNA?: InputMaybe<Scalars['String']>;
  AAANI?: InputMaybe<Scalars['String']>;
  AAAPSN?: InputMaybe<Scalars['String']>;
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  BHHLT?: InputMaybe<Scalars['String']>;
  BHPRDCLI?: InputMaybe<Scalars['String']>;
  BHPRDCNA?: InputMaybe<Scalars['String']>;
  BHPRDNI?: InputMaybe<Scalars['String']>;
  BHPRDPSN?: InputMaybe<Scalars['String']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  CMHLT?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  KOREA?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PH?: InputMaybe<Scalars['String']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type As21Util2_Max_Fields = {
  __typename?: 'AS21UTIL2_max_fields';
  AAACLI: Maybe<Scalars['String']>;
  AAACNA: Maybe<Scalars['String']>;
  AAANI: Maybe<Scalars['String']>;
  AAAPSN: Maybe<Scalars['String']>;
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  BHHLT: Maybe<Scalars['String']>;
  BHPRDCLI: Maybe<Scalars['String']>;
  BHPRDCNA: Maybe<Scalars['String']>;
  BHPRDNI: Maybe<Scalars['String']>;
  BHPRDPSN: Maybe<Scalars['String']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  CMHLT: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  KOREA: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OSFTE: Maybe<Scalars['float8']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PH: Maybe<Scalars['String']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type As21Util2_Min_Fields = {
  __typename?: 'AS21UTIL2_min_fields';
  AAACLI: Maybe<Scalars['String']>;
  AAACNA: Maybe<Scalars['String']>;
  AAANI: Maybe<Scalars['String']>;
  AAAPSN: Maybe<Scalars['String']>;
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  BHHLT: Maybe<Scalars['String']>;
  BHPRDCLI: Maybe<Scalars['String']>;
  BHPRDCNA: Maybe<Scalars['String']>;
  BHPRDNI: Maybe<Scalars['String']>;
  BHPRDPSN: Maybe<Scalars['String']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  CMHLT: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  KOREA: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OSFTE: Maybe<Scalars['float8']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PH: Maybe<Scalars['String']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "AS21UTIL2" */
export type As21Util2_Mutation_Response = {
  __typename?: 'AS21UTIL2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Util2>;
};

/** input type for inserting object relation for remote table "AS21UTIL2" */
export type As21Util2_Obj_Rel_Insert_Input = {
  data: As21Util2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Util2_On_Conflict>;
};

/** on_conflict condition type for table "AS21UTIL2" */
export type As21Util2_On_Conflict = {
  constraint: As21Util2_Constraint;
  update_columns?: Array<As21Util2_Update_Column>;
  where?: InputMaybe<As21Util2_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21UTIL2". */
export type As21Util2_Order_By = {
  AAACLI?: InputMaybe<Order_By>;
  AAACNA?: InputMaybe<Order_By>;
  AAANI?: InputMaybe<Order_By>;
  AAAPSN?: InputMaybe<Order_By>;
  ADEPRA?: InputMaybe<Order_By>;
  AFRICA?: InputMaybe<Order_By>;
  APANES?: InputMaybe<Order_By>;
  APCAR?: InputMaybe<Order_By>;
  APCASE?: InputMaybe<Order_By>;
  APED?: InputMaybe<Order_By>;
  APEMER?: InputMaybe<Order_By>;
  APOTH?: InputMaybe<Order_By>;
  APRN?: InputMaybe<Order_By>;
  APSPC?: InputMaybe<Order_By>;
  ASSNET?: InputMaybe<Order_By>;
  AUVZ?: InputMaybe<Order_By>;
  BHHLT?: InputMaybe<Order_By>;
  BHPRDCLI?: InputMaybe<Order_By>;
  BHPRDCNA?: InputMaybe<Order_By>;
  BHPRDNI?: InputMaybe<Order_By>;
  BHPRDPSN?: InputMaybe<Order_By>;
  CANADA?: InputMaybe<Order_By>;
  CEAMT?: InputMaybe<Order_By>;
  CHINA?: InputMaybe<Order_By>;
  CLSCIC?: InputMaybe<Order_By>;
  CLSMSI?: InputMaybe<Order_By>;
  CLSNIC?: InputMaybe<Order_By>;
  CLSOIC?: InputMaybe<Order_By>;
  CLSPIC?: InputMaybe<Order_By>;
  CMHLT?: InputMaybe<Order_By>;
  COLLCLI?: InputMaybe<Order_By>;
  COLLCNA?: InputMaybe<Order_By>;
  COLLNI?: InputMaybe<Order_By>;
  COLLPSN?: InputMaybe<Order_By>;
  DEIDPDEV?: InputMaybe<Order_By>;
  DEIDPO?: InputMaybe<Order_By>;
  DEIDPROC?: InputMaybe<Order_By>;
  DEIDSPCH?: InputMaybe<Order_By>;
  DEIDTRN?: InputMaybe<Order_By>;
  FBORCLI?: InputMaybe<Order_By>;
  FBORCNA?: InputMaybe<Order_By>;
  FBORNI?: InputMaybe<Order_By>;
  FBORPSN?: InputMaybe<Order_By>;
  FORNRSA?: InputMaybe<Order_By>;
  FTAPRN?: InputMaybe<Order_By>;
  FTEAPN?: InputMaybe<Order_By>;
  FTECIC?: InputMaybe<Order_By>;
  FTEHSP?: InputMaybe<Order_By>;
  FTEINT?: InputMaybe<Order_By>;
  FTEMSI?: InputMaybe<Order_By>;
  FTENIC?: InputMaybe<Order_By>;
  FTEOIC?: InputMaybe<Order_By>;
  FTEPHRN?: InputMaybe<Order_By>;
  FTEPIC?: InputMaybe<Order_By>;
  FTPHRN?: InputMaybe<Order_By>;
  GFEET?: InputMaybe<Order_By>;
  HCOCCLI?: InputMaybe<Order_By>;
  HCOCCNA?: InputMaybe<Order_By>;
  HCOCNI?: InputMaybe<Order_By>;
  HCOCPSN?: InputMaybe<Order_By>;
  HHEGCDO?: InputMaybe<Order_By>;
  HHEGCEO?: InputMaybe<Order_By>;
  HHEGERG?: InputMaybe<Order_By>;
  HHEGLEAD?: InputMaybe<Order_By>;
  HHEGMDMN?: InputMaybe<Order_By>;
  HHEGTKFC?: InputMaybe<Order_By>;
  HICOCCLI?: InputMaybe<Order_By>;
  HICOCCNA?: InputMaybe<Order_By>;
  HICOCNI?: InputMaybe<Order_By>;
  HICOCPSN?: InputMaybe<Order_By>;
  HSPTL?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  INDIA?: InputMaybe<Order_By>;
  INTCAR?: InputMaybe<Order_By>;
  ITBUGT?: InputMaybe<Order_By>;
  ITEXPA?: InputMaybe<Order_By>;
  ITFTE?: InputMaybe<Order_By>;
  KOREA?: InputMaybe<Order_By>;
  KSCHCLI?: InputMaybe<Order_By>;
  KSCHCNA?: InputMaybe<Order_By>;
  KSCHNI?: InputMaybe<Order_By>;
  KSCHPSN?: InputMaybe<Order_By>;
  LOCFCLI?: InputMaybe<Order_By>;
  LOCFCNA?: InputMaybe<Order_By>;
  LOCFNI?: InputMaybe<Order_By>;
  LOCFPSN?: InputMaybe<Order_By>;
  LOCHSCLI?: InputMaybe<Order_By>;
  LOCHSCNA?: InputMaybe<Order_By>;
  LOCHSNI?: InputMaybe<Order_By>;
  LOCHSPSN?: InputMaybe<Order_By>;
  LOCLGCLI?: InputMaybe<Order_By>;
  LOCLGCNA?: InputMaybe<Order_By>;
  LOCLGNI?: InputMaybe<Order_By>;
  LOCLGPSN?: InputMaybe<Order_By>;
  LOCOCCLI?: InputMaybe<Order_By>;
  LOCOCCNA?: InputMaybe<Order_By>;
  LOCOCNI?: InputMaybe<Order_By>;
  LOCOCPSN?: InputMaybe<Order_By>;
  LOCTRCLI?: InputMaybe<Order_By>;
  LOCTRCNA?: InputMaybe<Order_By>;
  LOCTRNI?: InputMaybe<Order_By>;
  LOCTRPSN?: InputMaybe<Order_By>;
  LORGCLI?: InputMaybe<Order_By>;
  LORGCNA?: InputMaybe<Order_By>;
  LORGNI?: InputMaybe<Order_By>;
  LORGPSN?: InputMaybe<Order_By>;
  NECAR?: InputMaybe<Order_By>;
  NEGST?: InputMaybe<Order_By>;
  NEHSP?: InputMaybe<Order_By>;
  NEINT?: InputMaybe<Order_By>;
  NEMER?: InputMaybe<Order_By>;
  NEOB?: InputMaybe<Order_By>;
  NEOTH?: InputMaybe<Order_By>;
  NETOT?: InputMaybe<Order_By>;
  OFRNRS?: InputMaybe<Order_By>;
  OSFTE?: InputMaybe<Order_By>;
  OTCOMCLI?: InputMaybe<Order_By>;
  OTCOMCNA?: InputMaybe<Order_By>;
  OTCOMNI?: InputMaybe<Order_By>;
  OTCOMPSN?: InputMaybe<Order_By>;
  OTLSCLI?: InputMaybe<Order_By>;
  OTLSCNA?: InputMaybe<Order_By>;
  OTLSNI?: InputMaybe<Order_By>;
  OTLSPSN?: InputMaybe<Order_By>;
  PH?: InputMaybe<Order_By>;
  PHEGACC?: InputMaybe<Order_By>;
  PHEGCAPC?: InputMaybe<Order_By>;
  PHEGCMTY?: InputMaybe<Order_By>;
  PHEGDATA?: InputMaybe<Order_By>;
  PHEGEIOP?: InputMaybe<Order_By>;
  PHEGGOV?: InputMaybe<Order_By>;
  PHEGLEAD?: InputMaybe<Order_By>;
  PLCECLI?: InputMaybe<Order_By>;
  PLCECNA?: InputMaybe<Order_By>;
  PLCENI?: InputMaybe<Order_By>;
  PLCEPSN?: InputMaybe<Order_By>;
  PLNTA?: InputMaybe<Order_By>;
  PRPM?: InputMaybe<Order_By>;
  PTAPRN?: InputMaybe<Order_By>;
  PTPHRN?: InputMaybe<Order_By>;
  RNSCH?: InputMaybe<Order_By>;
  SHEGCDO?: InputMaybe<Order_By>;
  SHEGCEO?: InputMaybe<Order_By>;
  SHEGERG?: InputMaybe<Order_By>;
  SHEGLEAD?: InputMaybe<Order_By>;
  SHEGMDMN?: InputMaybe<Order_By>;
  SHEGTKFC?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  TCCAR?: InputMaybe<Order_By>;
  TCGST?: InputMaybe<Order_By>;
  TCHSP?: InputMaybe<Order_By>;
  TCINT?: InputMaybe<Order_By>;
  TCMER?: InputMaybe<Order_By>;
  TCOB?: InputMaybe<Order_By>;
  TCOTH?: InputMaybe<Order_By>;
  TCTOT?: InputMaybe<Order_By>;
  TECAR?: InputMaybe<Order_By>;
  TEGST?: InputMaybe<Order_By>;
  TEHSP?: InputMaybe<Order_By>;
  TEINT?: InputMaybe<Order_By>;
  TEMER?: InputMaybe<Order_By>;
  TEOB?: InputMaybe<Order_By>;
  TEOTH?: InputMaybe<Order_By>;
  TETOT?: InputMaybe<Order_By>;
  TGCAR?: InputMaybe<Order_By>;
  TGGST?: InputMaybe<Order_By>;
  TGHSP?: InputMaybe<Order_By>;
  TGINT?: InputMaybe<Order_By>;
  TGMER?: InputMaybe<Order_By>;
  TGOB?: InputMaybe<Order_By>;
  TGOTH?: InputMaybe<Order_By>;
  TGTOT?: InputMaybe<Order_By>;
  TPCAR?: InputMaybe<Order_By>;
  TPGST?: InputMaybe<Order_By>;
  TPHSP?: InputMaybe<Order_By>;
  TPINT?: InputMaybe<Order_By>;
  TPMER?: InputMaybe<Order_By>;
  TPOB?: InputMaybe<Order_By>;
  TPOTH?: InputMaybe<Order_By>;
  TPRTOT?: InputMaybe<Order_By>;
  VIDVZ?: InputMaybe<Order_By>;
  VPSRV?: InputMaybe<Order_By>;
  WFAIART?: InputMaybe<Order_By>;
  WFAIOACW?: InputMaybe<Order_By>;
  WFAIPPD?: InputMaybe<Order_By>;
  WFAIPSN?: InputMaybe<Order_By>;
  WFAISS?: InputMaybe<Order_By>;
  WFSTCNA?: InputMaybe<Order_By>;
  WFSTHCC?: InputMaybe<Order_By>;
  WFSTLSP?: InputMaybe<Order_By>;
  WFSTRRP?: InputMaybe<Order_By>;
  WFSTTDP?: InputMaybe<Order_By>;
  WFSTVTP?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS21UTIL2 */
export type As21Util2_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21UTIL2" */
export enum As21Util2_Select_Column {
  /** column name */
  Aaacli = 'AAACLI',
  /** column name */
  Aaacna = 'AAACNA',
  /** column name */
  Aaani = 'AAANI',
  /** column name */
  Aaapsn = 'AAAPSN',
  /** column name */
  Adepra = 'ADEPRA',
  /** column name */
  Africa = 'AFRICA',
  /** column name */
  Apanes = 'APANES',
  /** column name */
  Apcar = 'APCAR',
  /** column name */
  Apcase = 'APCASE',
  /** column name */
  Aped = 'APED',
  /** column name */
  Apemer = 'APEMER',
  /** column name */
  Apoth = 'APOTH',
  /** column name */
  Aprn = 'APRN',
  /** column name */
  Apspc = 'APSPC',
  /** column name */
  Assnet = 'ASSNET',
  /** column name */
  Auvz = 'AUVZ',
  /** column name */
  Bhhlt = 'BHHLT',
  /** column name */
  Bhprdcli = 'BHPRDCLI',
  /** column name */
  Bhprdcna = 'BHPRDCNA',
  /** column name */
  Bhprdni = 'BHPRDNI',
  /** column name */
  Bhprdpsn = 'BHPRDPSN',
  /** column name */
  Canada = 'CANADA',
  /** column name */
  Ceamt = 'CEAMT',
  /** column name */
  China = 'CHINA',
  /** column name */
  Clscic = 'CLSCIC',
  /** column name */
  Clsmsi = 'CLSMSI',
  /** column name */
  Clsnic = 'CLSNIC',
  /** column name */
  Clsoic = 'CLSOIC',
  /** column name */
  Clspic = 'CLSPIC',
  /** column name */
  Cmhlt = 'CMHLT',
  /** column name */
  Collcli = 'COLLCLI',
  /** column name */
  Collcna = 'COLLCNA',
  /** column name */
  Collni = 'COLLNI',
  /** column name */
  Collpsn = 'COLLPSN',
  /** column name */
  Deidpdev = 'DEIDPDEV',
  /** column name */
  Deidpo = 'DEIDPO',
  /** column name */
  Deidproc = 'DEIDPROC',
  /** column name */
  Deidspch = 'DEIDSPCH',
  /** column name */
  Deidtrn = 'DEIDTRN',
  /** column name */
  Fborcli = 'FBORCLI',
  /** column name */
  Fborcna = 'FBORCNA',
  /** column name */
  Fborni = 'FBORNI',
  /** column name */
  Fborpsn = 'FBORPSN',
  /** column name */
  Fornrsa = 'FORNRSA',
  /** column name */
  Ftaprn = 'FTAPRN',
  /** column name */
  Fteapn = 'FTEAPN',
  /** column name */
  Ftecic = 'FTECIC',
  /** column name */
  Ftehsp = 'FTEHSP',
  /** column name */
  Fteint = 'FTEINT',
  /** column name */
  Ftemsi = 'FTEMSI',
  /** column name */
  Ftenic = 'FTENIC',
  /** column name */
  Fteoic = 'FTEOIC',
  /** column name */
  Ftephrn = 'FTEPHRN',
  /** column name */
  Ftepic = 'FTEPIC',
  /** column name */
  Ftphrn = 'FTPHRN',
  /** column name */
  Gfeet = 'GFEET',
  /** column name */
  Hcoccli = 'HCOCCLI',
  /** column name */
  Hcoccna = 'HCOCCNA',
  /** column name */
  Hcocni = 'HCOCNI',
  /** column name */
  Hcocpsn = 'HCOCPSN',
  /** column name */
  Hhegcdo = 'HHEGCDO',
  /** column name */
  Hhegceo = 'HHEGCEO',
  /** column name */
  Hhegerg = 'HHEGERG',
  /** column name */
  Hheglead = 'HHEGLEAD',
  /** column name */
  Hhegmdmn = 'HHEGMDMN',
  /** column name */
  Hhegtkfc = 'HHEGTKFC',
  /** column name */
  Hicoccli = 'HICOCCLI',
  /** column name */
  Hicoccna = 'HICOCCNA',
  /** column name */
  Hicocni = 'HICOCNI',
  /** column name */
  Hicocpsn = 'HICOCPSN',
  /** column name */
  Hsptl = 'HSPTL',
  /** column name */
  Id = 'ID',
  /** column name */
  India = 'INDIA',
  /** column name */
  Intcar = 'INTCAR',
  /** column name */
  Itbugt = 'ITBUGT',
  /** column name */
  Itexpa = 'ITEXPA',
  /** column name */
  Itfte = 'ITFTE',
  /** column name */
  Korea = 'KOREA',
  /** column name */
  Kschcli = 'KSCHCLI',
  /** column name */
  Kschcna = 'KSCHCNA',
  /** column name */
  Kschni = 'KSCHNI',
  /** column name */
  Kschpsn = 'KSCHPSN',
  /** column name */
  Locfcli = 'LOCFCLI',
  /** column name */
  Locfcna = 'LOCFCNA',
  /** column name */
  Locfni = 'LOCFNI',
  /** column name */
  Locfpsn = 'LOCFPSN',
  /** column name */
  Lochscli = 'LOCHSCLI',
  /** column name */
  Lochscna = 'LOCHSCNA',
  /** column name */
  Lochsni = 'LOCHSNI',
  /** column name */
  Lochspsn = 'LOCHSPSN',
  /** column name */
  Loclgcli = 'LOCLGCLI',
  /** column name */
  Loclgcna = 'LOCLGCNA',
  /** column name */
  Loclgni = 'LOCLGNI',
  /** column name */
  Loclgpsn = 'LOCLGPSN',
  /** column name */
  Lococcli = 'LOCOCCLI',
  /** column name */
  Lococcna = 'LOCOCCNA',
  /** column name */
  Lococni = 'LOCOCNI',
  /** column name */
  Lococpsn = 'LOCOCPSN',
  /** column name */
  Loctrcli = 'LOCTRCLI',
  /** column name */
  Loctrcna = 'LOCTRCNA',
  /** column name */
  Loctrni = 'LOCTRNI',
  /** column name */
  Loctrpsn = 'LOCTRPSN',
  /** column name */
  Lorgcli = 'LORGCLI',
  /** column name */
  Lorgcna = 'LORGCNA',
  /** column name */
  Lorgni = 'LORGNI',
  /** column name */
  Lorgpsn = 'LORGPSN',
  /** column name */
  Necar = 'NECAR',
  /** column name */
  Negst = 'NEGST',
  /** column name */
  Nehsp = 'NEHSP',
  /** column name */
  Neint = 'NEINT',
  /** column name */
  Nemer = 'NEMER',
  /** column name */
  Neob = 'NEOB',
  /** column name */
  Neoth = 'NEOTH',
  /** column name */
  Netot = 'NETOT',
  /** column name */
  Ofrnrs = 'OFRNRS',
  /** column name */
  Osfte = 'OSFTE',
  /** column name */
  Otcomcli = 'OTCOMCLI',
  /** column name */
  Otcomcna = 'OTCOMCNA',
  /** column name */
  Otcomni = 'OTCOMNI',
  /** column name */
  Otcompsn = 'OTCOMPSN',
  /** column name */
  Otlscli = 'OTLSCLI',
  /** column name */
  Otlscna = 'OTLSCNA',
  /** column name */
  Otlsni = 'OTLSNI',
  /** column name */
  Otlspsn = 'OTLSPSN',
  /** column name */
  Ph = 'PH',
  /** column name */
  Phegacc = 'PHEGACC',
  /** column name */
  Phegcapc = 'PHEGCAPC',
  /** column name */
  Phegcmty = 'PHEGCMTY',
  /** column name */
  Phegdata = 'PHEGDATA',
  /** column name */
  Phegeiop = 'PHEGEIOP',
  /** column name */
  Pheggov = 'PHEGGOV',
  /** column name */
  Pheglead = 'PHEGLEAD',
  /** column name */
  Plcecli = 'PLCECLI',
  /** column name */
  Plcecna = 'PLCECNA',
  /** column name */
  Plceni = 'PLCENI',
  /** column name */
  Plcepsn = 'PLCEPSN',
  /** column name */
  Plnta = 'PLNTA',
  /** column name */
  Prpm = 'PRPM',
  /** column name */
  Ptaprn = 'PTAPRN',
  /** column name */
  Ptphrn = 'PTPHRN',
  /** column name */
  Rnsch = 'RNSCH',
  /** column name */
  Shegcdo = 'SHEGCDO',
  /** column name */
  Shegceo = 'SHEGCEO',
  /** column name */
  Shegerg = 'SHEGERG',
  /** column name */
  Sheglead = 'SHEGLEAD',
  /** column name */
  Shegmdmn = 'SHEGMDMN',
  /** column name */
  Shegtkfc = 'SHEGTKFC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Tccar = 'TCCAR',
  /** column name */
  Tcgst = 'TCGST',
  /** column name */
  Tchsp = 'TCHSP',
  /** column name */
  Tcint = 'TCINT',
  /** column name */
  Tcmer = 'TCMER',
  /** column name */
  Tcob = 'TCOB',
  /** column name */
  Tcoth = 'TCOTH',
  /** column name */
  Tctot = 'TCTOT',
  /** column name */
  Tecar = 'TECAR',
  /** column name */
  Tegst = 'TEGST',
  /** column name */
  Tehsp = 'TEHSP',
  /** column name */
  Teint = 'TEINT',
  /** column name */
  Temer = 'TEMER',
  /** column name */
  Teob = 'TEOB',
  /** column name */
  Teoth = 'TEOTH',
  /** column name */
  Tetot = 'TETOT',
  /** column name */
  Tgcar = 'TGCAR',
  /** column name */
  Tggst = 'TGGST',
  /** column name */
  Tghsp = 'TGHSP',
  /** column name */
  Tgint = 'TGINT',
  /** column name */
  Tgmer = 'TGMER',
  /** column name */
  Tgob = 'TGOB',
  /** column name */
  Tgoth = 'TGOTH',
  /** column name */
  Tgtot = 'TGTOT',
  /** column name */
  Tpcar = 'TPCAR',
  /** column name */
  Tpgst = 'TPGST',
  /** column name */
  Tphsp = 'TPHSP',
  /** column name */
  Tpint = 'TPINT',
  /** column name */
  Tpmer = 'TPMER',
  /** column name */
  Tpob = 'TPOB',
  /** column name */
  Tpoth = 'TPOTH',
  /** column name */
  Tprtot = 'TPRTOT',
  /** column name */
  Vidvz = 'VIDVZ',
  /** column name */
  Vpsrv = 'VPSRV',
  /** column name */
  Wfaiart = 'WFAIART',
  /** column name */
  Wfaioacw = 'WFAIOACW',
  /** column name */
  Wfaippd = 'WFAIPPD',
  /** column name */
  Wfaipsn = 'WFAIPSN',
  /** column name */
  Wfaiss = 'WFAISS',
  /** column name */
  Wfstcna = 'WFSTCNA',
  /** column name */
  Wfsthcc = 'WFSTHCC',
  /** column name */
  Wfstlsp = 'WFSTLSP',
  /** column name */
  Wfstrrp = 'WFSTRRP',
  /** column name */
  Wfsttdp = 'WFSTTDP',
  /** column name */
  Wfstvtp = 'WFSTVTP'
}

/** input type for updating data in table "AS21UTIL2" */
export type As21Util2_Set_Input = {
  AAACLI?: InputMaybe<Scalars['String']>;
  AAACNA?: InputMaybe<Scalars['String']>;
  AAANI?: InputMaybe<Scalars['String']>;
  AAAPSN?: InputMaybe<Scalars['String']>;
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  BHHLT?: InputMaybe<Scalars['String']>;
  BHPRDCLI?: InputMaybe<Scalars['String']>;
  BHPRDCNA?: InputMaybe<Scalars['String']>;
  BHPRDNI?: InputMaybe<Scalars['String']>;
  BHPRDPSN?: InputMaybe<Scalars['String']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  CMHLT?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  KOREA?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PH?: InputMaybe<Scalars['String']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type As21Util2_Stddev_Fields = {
  __typename?: 'AS21UTIL2_stddev_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As21Util2_Stddev_Pop_Fields = {
  __typename?: 'AS21UTIL2_stddev_pop_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As21Util2_Stddev_Samp_Fields = {
  __typename?: 'AS21UTIL2_stddev_samp_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS21UTIL2" */
export type As21Util2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Util2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Util2_Stream_Cursor_Value_Input = {
  AAACLI?: InputMaybe<Scalars['String']>;
  AAACNA?: InputMaybe<Scalars['String']>;
  AAANI?: InputMaybe<Scalars['String']>;
  AAAPSN?: InputMaybe<Scalars['String']>;
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  BHHLT?: InputMaybe<Scalars['String']>;
  BHPRDCLI?: InputMaybe<Scalars['String']>;
  BHPRDCNA?: InputMaybe<Scalars['String']>;
  BHPRDNI?: InputMaybe<Scalars['String']>;
  BHPRDPSN?: InputMaybe<Scalars['String']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  CMHLT?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  ITBUGT?: InputMaybe<Scalars['float8']>;
  ITEXPA?: InputMaybe<Scalars['float8']>;
  ITFTE?: InputMaybe<Scalars['float8']>;
  KOREA?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OSFTE?: InputMaybe<Scalars['float8']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PH?: InputMaybe<Scalars['String']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type As21Util2_Sum_Fields = {
  __typename?: 'AS21UTIL2_sum_fields';
  ADEPRA: Maybe<Scalars['float8']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  CEAMT: Maybe<Scalars['float8']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  ITBUGT: Maybe<Scalars['float8']>;
  ITEXPA: Maybe<Scalars['float8']>;
  ITFTE: Maybe<Scalars['float8']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OSFTE: Maybe<Scalars['float8']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** update columns of table "AS21UTIL2" */
export enum As21Util2_Update_Column {
  /** column name */
  Aaacli = 'AAACLI',
  /** column name */
  Aaacna = 'AAACNA',
  /** column name */
  Aaani = 'AAANI',
  /** column name */
  Aaapsn = 'AAAPSN',
  /** column name */
  Adepra = 'ADEPRA',
  /** column name */
  Africa = 'AFRICA',
  /** column name */
  Apanes = 'APANES',
  /** column name */
  Apcar = 'APCAR',
  /** column name */
  Apcase = 'APCASE',
  /** column name */
  Aped = 'APED',
  /** column name */
  Apemer = 'APEMER',
  /** column name */
  Apoth = 'APOTH',
  /** column name */
  Aprn = 'APRN',
  /** column name */
  Apspc = 'APSPC',
  /** column name */
  Assnet = 'ASSNET',
  /** column name */
  Auvz = 'AUVZ',
  /** column name */
  Bhhlt = 'BHHLT',
  /** column name */
  Bhprdcli = 'BHPRDCLI',
  /** column name */
  Bhprdcna = 'BHPRDCNA',
  /** column name */
  Bhprdni = 'BHPRDNI',
  /** column name */
  Bhprdpsn = 'BHPRDPSN',
  /** column name */
  Canada = 'CANADA',
  /** column name */
  Ceamt = 'CEAMT',
  /** column name */
  China = 'CHINA',
  /** column name */
  Clscic = 'CLSCIC',
  /** column name */
  Clsmsi = 'CLSMSI',
  /** column name */
  Clsnic = 'CLSNIC',
  /** column name */
  Clsoic = 'CLSOIC',
  /** column name */
  Clspic = 'CLSPIC',
  /** column name */
  Cmhlt = 'CMHLT',
  /** column name */
  Collcli = 'COLLCLI',
  /** column name */
  Collcna = 'COLLCNA',
  /** column name */
  Collni = 'COLLNI',
  /** column name */
  Collpsn = 'COLLPSN',
  /** column name */
  Deidpdev = 'DEIDPDEV',
  /** column name */
  Deidpo = 'DEIDPO',
  /** column name */
  Deidproc = 'DEIDPROC',
  /** column name */
  Deidspch = 'DEIDSPCH',
  /** column name */
  Deidtrn = 'DEIDTRN',
  /** column name */
  Fborcli = 'FBORCLI',
  /** column name */
  Fborcna = 'FBORCNA',
  /** column name */
  Fborni = 'FBORNI',
  /** column name */
  Fborpsn = 'FBORPSN',
  /** column name */
  Fornrsa = 'FORNRSA',
  /** column name */
  Ftaprn = 'FTAPRN',
  /** column name */
  Fteapn = 'FTEAPN',
  /** column name */
  Ftecic = 'FTECIC',
  /** column name */
  Ftehsp = 'FTEHSP',
  /** column name */
  Fteint = 'FTEINT',
  /** column name */
  Ftemsi = 'FTEMSI',
  /** column name */
  Ftenic = 'FTENIC',
  /** column name */
  Fteoic = 'FTEOIC',
  /** column name */
  Ftephrn = 'FTEPHRN',
  /** column name */
  Ftepic = 'FTEPIC',
  /** column name */
  Ftphrn = 'FTPHRN',
  /** column name */
  Gfeet = 'GFEET',
  /** column name */
  Hcoccli = 'HCOCCLI',
  /** column name */
  Hcoccna = 'HCOCCNA',
  /** column name */
  Hcocni = 'HCOCNI',
  /** column name */
  Hcocpsn = 'HCOCPSN',
  /** column name */
  Hhegcdo = 'HHEGCDO',
  /** column name */
  Hhegceo = 'HHEGCEO',
  /** column name */
  Hhegerg = 'HHEGERG',
  /** column name */
  Hheglead = 'HHEGLEAD',
  /** column name */
  Hhegmdmn = 'HHEGMDMN',
  /** column name */
  Hhegtkfc = 'HHEGTKFC',
  /** column name */
  Hicoccli = 'HICOCCLI',
  /** column name */
  Hicoccna = 'HICOCCNA',
  /** column name */
  Hicocni = 'HICOCNI',
  /** column name */
  Hicocpsn = 'HICOCPSN',
  /** column name */
  Hsptl = 'HSPTL',
  /** column name */
  Id = 'ID',
  /** column name */
  India = 'INDIA',
  /** column name */
  Intcar = 'INTCAR',
  /** column name */
  Itbugt = 'ITBUGT',
  /** column name */
  Itexpa = 'ITEXPA',
  /** column name */
  Itfte = 'ITFTE',
  /** column name */
  Korea = 'KOREA',
  /** column name */
  Kschcli = 'KSCHCLI',
  /** column name */
  Kschcna = 'KSCHCNA',
  /** column name */
  Kschni = 'KSCHNI',
  /** column name */
  Kschpsn = 'KSCHPSN',
  /** column name */
  Locfcli = 'LOCFCLI',
  /** column name */
  Locfcna = 'LOCFCNA',
  /** column name */
  Locfni = 'LOCFNI',
  /** column name */
  Locfpsn = 'LOCFPSN',
  /** column name */
  Lochscli = 'LOCHSCLI',
  /** column name */
  Lochscna = 'LOCHSCNA',
  /** column name */
  Lochsni = 'LOCHSNI',
  /** column name */
  Lochspsn = 'LOCHSPSN',
  /** column name */
  Loclgcli = 'LOCLGCLI',
  /** column name */
  Loclgcna = 'LOCLGCNA',
  /** column name */
  Loclgni = 'LOCLGNI',
  /** column name */
  Loclgpsn = 'LOCLGPSN',
  /** column name */
  Lococcli = 'LOCOCCLI',
  /** column name */
  Lococcna = 'LOCOCCNA',
  /** column name */
  Lococni = 'LOCOCNI',
  /** column name */
  Lococpsn = 'LOCOCPSN',
  /** column name */
  Loctrcli = 'LOCTRCLI',
  /** column name */
  Loctrcna = 'LOCTRCNA',
  /** column name */
  Loctrni = 'LOCTRNI',
  /** column name */
  Loctrpsn = 'LOCTRPSN',
  /** column name */
  Lorgcli = 'LORGCLI',
  /** column name */
  Lorgcna = 'LORGCNA',
  /** column name */
  Lorgni = 'LORGNI',
  /** column name */
  Lorgpsn = 'LORGPSN',
  /** column name */
  Necar = 'NECAR',
  /** column name */
  Negst = 'NEGST',
  /** column name */
  Nehsp = 'NEHSP',
  /** column name */
  Neint = 'NEINT',
  /** column name */
  Nemer = 'NEMER',
  /** column name */
  Neob = 'NEOB',
  /** column name */
  Neoth = 'NEOTH',
  /** column name */
  Netot = 'NETOT',
  /** column name */
  Ofrnrs = 'OFRNRS',
  /** column name */
  Osfte = 'OSFTE',
  /** column name */
  Otcomcli = 'OTCOMCLI',
  /** column name */
  Otcomcna = 'OTCOMCNA',
  /** column name */
  Otcomni = 'OTCOMNI',
  /** column name */
  Otcompsn = 'OTCOMPSN',
  /** column name */
  Otlscli = 'OTLSCLI',
  /** column name */
  Otlscna = 'OTLSCNA',
  /** column name */
  Otlsni = 'OTLSNI',
  /** column name */
  Otlspsn = 'OTLSPSN',
  /** column name */
  Ph = 'PH',
  /** column name */
  Phegacc = 'PHEGACC',
  /** column name */
  Phegcapc = 'PHEGCAPC',
  /** column name */
  Phegcmty = 'PHEGCMTY',
  /** column name */
  Phegdata = 'PHEGDATA',
  /** column name */
  Phegeiop = 'PHEGEIOP',
  /** column name */
  Pheggov = 'PHEGGOV',
  /** column name */
  Pheglead = 'PHEGLEAD',
  /** column name */
  Plcecli = 'PLCECLI',
  /** column name */
  Plcecna = 'PLCECNA',
  /** column name */
  Plceni = 'PLCENI',
  /** column name */
  Plcepsn = 'PLCEPSN',
  /** column name */
  Plnta = 'PLNTA',
  /** column name */
  Prpm = 'PRPM',
  /** column name */
  Ptaprn = 'PTAPRN',
  /** column name */
  Ptphrn = 'PTPHRN',
  /** column name */
  Rnsch = 'RNSCH',
  /** column name */
  Shegcdo = 'SHEGCDO',
  /** column name */
  Shegceo = 'SHEGCEO',
  /** column name */
  Shegerg = 'SHEGERG',
  /** column name */
  Sheglead = 'SHEGLEAD',
  /** column name */
  Shegmdmn = 'SHEGMDMN',
  /** column name */
  Shegtkfc = 'SHEGTKFC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Tccar = 'TCCAR',
  /** column name */
  Tcgst = 'TCGST',
  /** column name */
  Tchsp = 'TCHSP',
  /** column name */
  Tcint = 'TCINT',
  /** column name */
  Tcmer = 'TCMER',
  /** column name */
  Tcob = 'TCOB',
  /** column name */
  Tcoth = 'TCOTH',
  /** column name */
  Tctot = 'TCTOT',
  /** column name */
  Tecar = 'TECAR',
  /** column name */
  Tegst = 'TEGST',
  /** column name */
  Tehsp = 'TEHSP',
  /** column name */
  Teint = 'TEINT',
  /** column name */
  Temer = 'TEMER',
  /** column name */
  Teob = 'TEOB',
  /** column name */
  Teoth = 'TEOTH',
  /** column name */
  Tetot = 'TETOT',
  /** column name */
  Tgcar = 'TGCAR',
  /** column name */
  Tggst = 'TGGST',
  /** column name */
  Tghsp = 'TGHSP',
  /** column name */
  Tgint = 'TGINT',
  /** column name */
  Tgmer = 'TGMER',
  /** column name */
  Tgob = 'TGOB',
  /** column name */
  Tgoth = 'TGOTH',
  /** column name */
  Tgtot = 'TGTOT',
  /** column name */
  Tpcar = 'TPCAR',
  /** column name */
  Tpgst = 'TPGST',
  /** column name */
  Tphsp = 'TPHSP',
  /** column name */
  Tpint = 'TPINT',
  /** column name */
  Tpmer = 'TPMER',
  /** column name */
  Tpob = 'TPOB',
  /** column name */
  Tpoth = 'TPOTH',
  /** column name */
  Tprtot = 'TPRTOT',
  /** column name */
  Vidvz = 'VIDVZ',
  /** column name */
  Vpsrv = 'VPSRV',
  /** column name */
  Wfaiart = 'WFAIART',
  /** column name */
  Wfaioacw = 'WFAIOACW',
  /** column name */
  Wfaippd = 'WFAIPPD',
  /** column name */
  Wfaipsn = 'WFAIPSN',
  /** column name */
  Wfaiss = 'WFAISS',
  /** column name */
  Wfstcna = 'WFSTCNA',
  /** column name */
  Wfsthcc = 'WFSTHCC',
  /** column name */
  Wfstlsp = 'WFSTLSP',
  /** column name */
  Wfstrrp = 'WFSTRRP',
  /** column name */
  Wfsttdp = 'WFSTTDP',
  /** column name */
  Wfstvtp = 'WFSTVTP'
}

export type As21Util2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As21Util2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Util2_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Util2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As21Util2_Var_Pop_Fields = {
  __typename?: 'AS21UTIL2_var_pop_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As21Util2_Var_Samp_Fields = {
  __typename?: 'AS21UTIL2_var_samp_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As21Util2_Variance_Fields = {
  __typename?: 'AS21UTIL2_variance_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  ITBUGT: Maybe<Scalars['Float']>;
  ITEXPA: Maybe<Scalars['Float']>;
  ITFTE: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  OSFTE: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregated selection of "AS21UTIL" */
export type As21Util_Aggregate = {
  __typename?: 'AS21UTIL_aggregate';
  aggregate: Maybe<As21Util_Aggregate_Fields>;
  nodes: Array<As21Util>;
};

/** aggregate fields of "AS21UTIL" */
export type As21Util_Aggregate_Fields = {
  __typename?: 'AS21UTIL_aggregate_fields';
  avg: Maybe<As21Util_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As21Util_Max_Fields>;
  min: Maybe<As21Util_Min_Fields>;
  stddev: Maybe<As21Util_Stddev_Fields>;
  stddev_pop: Maybe<As21Util_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As21Util_Stddev_Samp_Fields>;
  sum: Maybe<As21Util_Sum_Fields>;
  var_pop: Maybe<As21Util_Var_Pop_Fields>;
  var_samp: Maybe<As21Util_Var_Samp_Fields>;
  variance: Maybe<As21Util_Variance_Fields>;
};


/** aggregate fields of "AS21UTIL" */
export type As21Util_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As21Util_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As21Util_Avg_Fields = {
  __typename?: 'AS21UTIL_avg_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS21UTIL". All fields are combined with a logical 'AND'. */
export type As21Util_Bool_Exp = {
  ADC?: InputMaybe<Float8_Comparison_Exp>;
  ADJADC?: InputMaybe<Float8_Comparison_Exp>;
  ADJADCH?: InputMaybe<Float8_Comparison_Exp>;
  ADJADM?: InputMaybe<Float8_Comparison_Exp>;
  ADJPD?: InputMaybe<Float8_Comparison_Exp>;
  ADJPDH?: InputMaybe<Float8_Comparison_Exp>;
  ADMH?: InputMaybe<Float8_Comparison_Exp>;
  ADMLT?: InputMaybe<Float8_Comparison_Exp>;
  ADMTOT?: InputMaybe<Float8_Comparison_Exp>;
  BASSIN?: InputMaybe<Float8_Comparison_Exp>;
  BDH?: InputMaybe<Float8_Comparison_Exp>;
  BDLT?: InputMaybe<Float8_Comparison_Exp>;
  BDTOT?: InputMaybe<Float8_Comparison_Exp>;
  BIRTHS?: InputMaybe<Float8_Comparison_Exp>;
  DPEXA?: InputMaybe<Float8_Comparison_Exp>;
  EADMH?: InputMaybe<String_Comparison_Exp>;
  EADMLT?: InputMaybe<String_Comparison_Exp>;
  EADMTOT?: InputMaybe<String_Comparison_Exp>;
  EBIRTHS?: InputMaybe<String_Comparison_Exp>;
  EEXPTOT?: InputMaybe<String_Comparison_Exp>;
  EFTAST?: InputMaybe<String_Comparison_Exp>;
  EFTLAB?: InputMaybe<String_Comparison_Exp>;
  EFTLPNTF?: InputMaybe<String_Comparison_Exp>;
  EFTMDTF?: InputMaybe<String_Comparison_Exp>;
  EFTOTHTF?: InputMaybe<String_Comparison_Exp>;
  EFTPHR?: InputMaybe<String_Comparison_Exp>;
  EFTPHT?: InputMaybe<String_Comparison_Exp>;
  EFTRAD?: InputMaybe<String_Comparison_Exp>;
  EFTRES?: InputMaybe<String_Comparison_Exp>;
  EFTRESP?: InputMaybe<String_Comparison_Exp>;
  EFTRNTF?: InputMaybe<String_Comparison_Exp>;
  EFTTOT?: InputMaybe<String_Comparison_Exp>;
  EFTTOTH?: InputMaybe<String_Comparison_Exp>;
  EFTTOTLT?: InputMaybe<String_Comparison_Exp>;
  EFTTRN84?: InputMaybe<String_Comparison_Exp>;
  EIPDH?: InputMaybe<String_Comparison_Exp>;
  EIPDLT?: InputMaybe<String_Comparison_Exp>;
  EIPDTOT?: InputMaybe<String_Comparison_Exp>;
  EMCDDC?: InputMaybe<String_Comparison_Exp>;
  EMCDDCH?: InputMaybe<String_Comparison_Exp>;
  EMCDDCLT?: InputMaybe<String_Comparison_Exp>;
  EMCDIPD?: InputMaybe<String_Comparison_Exp>;
  EMCDIPDH?: InputMaybe<String_Comparison_Exp>;
  EMCDPDLT?: InputMaybe<String_Comparison_Exp>;
  EMCRDC?: InputMaybe<String_Comparison_Exp>;
  EMCRDCH?: InputMaybe<String_Comparison_Exp>;
  EMCRDCLT?: InputMaybe<String_Comparison_Exp>;
  EMCRIPD?: InputMaybe<String_Comparison_Exp>;
  EMCRIPDH?: InputMaybe<String_Comparison_Exp>;
  EMCRPDLT?: InputMaybe<String_Comparison_Exp>;
  ENPAYBEN?: InputMaybe<String_Comparison_Exp>;
  ENPBENLT?: InputMaybe<String_Comparison_Exp>;
  ENPYBENH?: InputMaybe<String_Comparison_Exp>;
  EPAYTOT?: InputMaybe<String_Comparison_Exp>;
  EPAYTOTH?: InputMaybe<String_Comparison_Exp>;
  EPTAST?: InputMaybe<String_Comparison_Exp>;
  EPTLAB?: InputMaybe<String_Comparison_Exp>;
  EPTLPNTF?: InputMaybe<String_Comparison_Exp>;
  EPTMDTF?: InputMaybe<String_Comparison_Exp>;
  EPTOTHTF?: InputMaybe<String_Comparison_Exp>;
  EPTPHR?: InputMaybe<String_Comparison_Exp>;
  EPTPHT?: InputMaybe<String_Comparison_Exp>;
  EPTRAD?: InputMaybe<String_Comparison_Exp>;
  EPTRES?: InputMaybe<String_Comparison_Exp>;
  EPTRESP?: InputMaybe<String_Comparison_Exp>;
  EPTRNTF?: InputMaybe<String_Comparison_Exp>;
  EPTTOT?: InputMaybe<String_Comparison_Exp>;
  EPTTOTH?: InputMaybe<String_Comparison_Exp>;
  EPTTOTLT?: InputMaybe<String_Comparison_Exp>;
  EPTTRN84?: InputMaybe<String_Comparison_Exp>;
  EPYTOTLT?: InputMaybe<String_Comparison_Exp>;
  ERNFTE?: InputMaybe<Float8_Comparison_Exp>;
  ESUROPIP?: InputMaybe<String_Comparison_Exp>;
  ESUROPOP?: InputMaybe<String_Comparison_Exp>;
  ESUROPTO?: InputMaybe<String_Comparison_Exp>;
  EVEM?: InputMaybe<String_Comparison_Exp>;
  EVOTH?: InputMaybe<String_Comparison_Exp>;
  EVTOT?: InputMaybe<String_Comparison_Exp>;
  EXPTHA?: InputMaybe<Float8_Comparison_Exp>;
  EXPTHB?: InputMaybe<String_Comparison_Exp>;
  EXPTLA?: InputMaybe<Float8_Comparison_Exp>;
  EXPTLB?: InputMaybe<String_Comparison_Exp>;
  EXPTOT?: InputMaybe<Float8_Comparison_Exp>;
  FTAST?: InputMaybe<Float8_Comparison_Exp>;
  FTE?: InputMaybe<Float8_Comparison_Exp>;
  FTEAP?: InputMaybe<Float8_Comparison_Exp>;
  FTECAP?: InputMaybe<Float8_Comparison_Exp>;
  FTECLAB?: InputMaybe<Float8_Comparison_Exp>;
  FTECPH?: InputMaybe<Float8_Comparison_Exp>;
  FTECPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTECRAD?: InputMaybe<Float8_Comparison_Exp>;
  FTECRESP?: InputMaybe<Float8_Comparison_Exp>;
  FTED?: InputMaybe<Float8_Comparison_Exp>;
  FTEH?: InputMaybe<Float8_Comparison_Exp>;
  FTELAB?: InputMaybe<Float8_Comparison_Exp>;
  FTELPN?: InputMaybe<Float8_Comparison_Exp>;
  FTEMD?: InputMaybe<Float8_Comparison_Exp>;
  FTEN?: InputMaybe<Float8_Comparison_Exp>;
  FTENH?: InputMaybe<Float8_Comparison_Exp>;
  FTEO?: InputMaybe<Float8_Comparison_Exp>;
  FTEOTH94?: InputMaybe<Float8_Comparison_Exp>;
  FTEP?: InputMaybe<Float8_Comparison_Exp>;
  FTEPH?: InputMaybe<Float8_Comparison_Exp>;
  FTEPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTER?: InputMaybe<Float8_Comparison_Exp>;
  FTERAD?: InputMaybe<Float8_Comparison_Exp>;
  FTERES?: InputMaybe<Float8_Comparison_Exp>;
  FTERESP?: InputMaybe<Float8_Comparison_Exp>;
  FTERN?: InputMaybe<Float8_Comparison_Exp>;
  FTERNH?: InputMaybe<Float8_Comparison_Exp>;
  FTERNLT?: InputMaybe<Float8_Comparison_Exp>;
  FTET?: InputMaybe<Float8_Comparison_Exp>;
  FTETF?: InputMaybe<Float8_Comparison_Exp>;
  FTETRAN?: InputMaybe<Float8_Comparison_Exp>;
  FTETTRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEU?: InputMaybe<Float8_Comparison_Exp>;
  FTLAB?: InputMaybe<Float8_Comparison_Exp>;
  FTLPNTF?: InputMaybe<Float8_Comparison_Exp>;
  FTMDTF?: InputMaybe<Float8_Comparison_Exp>;
  FTOTHTF?: InputMaybe<Float8_Comparison_Exp>;
  FTPHR?: InputMaybe<Float8_Comparison_Exp>;
  FTPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTRAD?: InputMaybe<Float8_Comparison_Exp>;
  FTRES?: InputMaybe<Float8_Comparison_Exp>;
  FTRESP?: InputMaybe<Float8_Comparison_Exp>;
  FTRNLT?: InputMaybe<Float8_Comparison_Exp>;
  FTRNTF?: InputMaybe<Float8_Comparison_Exp>;
  FTTOT?: InputMaybe<Float8_Comparison_Exp>;
  FTTOTH?: InputMaybe<Float8_Comparison_Exp>;
  FTTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  FTTRAN84?: InputMaybe<Float8_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  INTEXA?: InputMaybe<Float8_Comparison_Exp>;
  IPDH?: InputMaybe<Float8_Comparison_Exp>;
  IPDLT?: InputMaybe<Float8_Comparison_Exp>;
  IPDTOT?: InputMaybe<Float8_Comparison_Exp>;
  LBEDLA?: InputMaybe<Float8_Comparison_Exp>;
  LBEDSA?: InputMaybe<Float8_Comparison_Exp>;
  MCDDC?: InputMaybe<Float8_Comparison_Exp>;
  MCDDCH?: InputMaybe<Float8_Comparison_Exp>;
  MCDDCLT?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPD?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPDH?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  MCRDC?: InputMaybe<Float8_Comparison_Exp>;
  MCRDCH?: InputMaybe<Float8_Comparison_Exp>;
  MCRDCLT?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPD?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPDH?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBEN?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBENH?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBENL?: InputMaybe<Float8_Comparison_Exp>;
  OPRA?: InputMaybe<Float8_Comparison_Exp>;
  OTHEXPA?: InputMaybe<Float8_Comparison_Exp>;
  OTHPCR?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOT?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOTH?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  PCMRES?: InputMaybe<Float8_Comparison_Exp>;
  PHREXA?: InputMaybe<Float8_Comparison_Exp>;
  PTAST?: InputMaybe<Float8_Comparison_Exp>;
  PTLAB?: InputMaybe<Float8_Comparison_Exp>;
  PTLPNTF?: InputMaybe<Float8_Comparison_Exp>;
  PTMDTF?: InputMaybe<Float8_Comparison_Exp>;
  PTOTHTF?: InputMaybe<Float8_Comparison_Exp>;
  PTPHR?: InputMaybe<Float8_Comparison_Exp>;
  PTPHT?: InputMaybe<Float8_Comparison_Exp>;
  PTRAD?: InputMaybe<Float8_Comparison_Exp>;
  PTRES?: InputMaybe<Float8_Comparison_Exp>;
  PTRESP?: InputMaybe<Float8_Comparison_Exp>;
  PTRNLT?: InputMaybe<Float8_Comparison_Exp>;
  PTRNTF?: InputMaybe<Float8_Comparison_Exp>;
  PTTOT?: InputMaybe<Float8_Comparison_Exp>;
  PTTOTH?: InputMaybe<Float8_Comparison_Exp>;
  PTTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  PTTRAN84?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUPEXA?: InputMaybe<Float8_Comparison_Exp>;
  SUROPIP?: InputMaybe<Float8_Comparison_Exp>;
  SUROPOP?: InputMaybe<Float8_Comparison_Exp>;
  SUROPTOT?: InputMaybe<Float8_Comparison_Exp>;
  VAST?: InputMaybe<Float8_Comparison_Exp>;
  VEM?: InputMaybe<Float8_Comparison_Exp>;
  VLAB?: InputMaybe<Float8_Comparison_Exp>;
  VLPN?: InputMaybe<Float8_Comparison_Exp>;
  VMD?: InputMaybe<Float8_Comparison_Exp>;
  VOTH?: InputMaybe<Float8_Comparison_Exp>;
  VOTHL?: InputMaybe<Float8_Comparison_Exp>;
  VPHR?: InputMaybe<Float8_Comparison_Exp>;
  VPHT?: InputMaybe<Float8_Comparison_Exp>;
  VRAD?: InputMaybe<Float8_Comparison_Exp>;
  VRES?: InputMaybe<Float8_Comparison_Exp>;
  VRN?: InputMaybe<Float8_Comparison_Exp>;
  VRNH?: InputMaybe<Float8_Comparison_Exp>;
  VRSP?: InputMaybe<Float8_Comparison_Exp>;
  VTNH?: InputMaybe<Float8_Comparison_Exp>;
  VTOT?: InputMaybe<Float8_Comparison_Exp>;
  VTOTL?: InputMaybe<Float8_Comparison_Exp>;
  VTTRN?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<As21Util_Bool_Exp>>;
  _not?: InputMaybe<As21Util_Bool_Exp>;
  _or?: InputMaybe<Array<As21Util_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS21UTIL" */
export enum As21Util_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs21Util = 'pk_AS21UTIL'
}

/** input type for incrementing numeric columns in table "AS21UTIL" */
export type As21Util_Inc_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS21UTIL" */
export type As21Util_Insert_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type As21Util_Max_Fields = {
  __typename?: 'AS21UTIL_max_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Maybe<Scalars['String']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type As21Util_Min_Fields = {
  __typename?: 'AS21UTIL_min_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Maybe<Scalars['String']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "AS21UTIL" */
export type As21Util_Mutation_Response = {
  __typename?: 'AS21UTIL_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As21Util>;
};

/** input type for inserting object relation for remote table "AS21UTIL" */
export type As21Util_Obj_Rel_Insert_Input = {
  data: As21Util_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As21Util_On_Conflict>;
};

/** on_conflict condition type for table "AS21UTIL" */
export type As21Util_On_Conflict = {
  constraint: As21Util_Constraint;
  update_columns?: Array<As21Util_Update_Column>;
  where?: InputMaybe<As21Util_Bool_Exp>;
};

/** Ordering options when selecting data from "AS21UTIL". */
export type As21Util_Order_By = {
  ADC?: InputMaybe<Order_By>;
  ADJADC?: InputMaybe<Order_By>;
  ADJADCH?: InputMaybe<Order_By>;
  ADJADM?: InputMaybe<Order_By>;
  ADJPD?: InputMaybe<Order_By>;
  ADJPDH?: InputMaybe<Order_By>;
  ADMH?: InputMaybe<Order_By>;
  ADMLT?: InputMaybe<Order_By>;
  ADMTOT?: InputMaybe<Order_By>;
  BASSIN?: InputMaybe<Order_By>;
  BDH?: InputMaybe<Order_By>;
  BDLT?: InputMaybe<Order_By>;
  BDTOT?: InputMaybe<Order_By>;
  BIRTHS?: InputMaybe<Order_By>;
  DPEXA?: InputMaybe<Order_By>;
  EADMH?: InputMaybe<Order_By>;
  EADMLT?: InputMaybe<Order_By>;
  EADMTOT?: InputMaybe<Order_By>;
  EBIRTHS?: InputMaybe<Order_By>;
  EEXPTOT?: InputMaybe<Order_By>;
  EFTAST?: InputMaybe<Order_By>;
  EFTLAB?: InputMaybe<Order_By>;
  EFTLPNTF?: InputMaybe<Order_By>;
  EFTMDTF?: InputMaybe<Order_By>;
  EFTOTHTF?: InputMaybe<Order_By>;
  EFTPHR?: InputMaybe<Order_By>;
  EFTPHT?: InputMaybe<Order_By>;
  EFTRAD?: InputMaybe<Order_By>;
  EFTRES?: InputMaybe<Order_By>;
  EFTRESP?: InputMaybe<Order_By>;
  EFTRNTF?: InputMaybe<Order_By>;
  EFTTOT?: InputMaybe<Order_By>;
  EFTTOTH?: InputMaybe<Order_By>;
  EFTTOTLT?: InputMaybe<Order_By>;
  EFTTRN84?: InputMaybe<Order_By>;
  EIPDH?: InputMaybe<Order_By>;
  EIPDLT?: InputMaybe<Order_By>;
  EIPDTOT?: InputMaybe<Order_By>;
  EMCDDC?: InputMaybe<Order_By>;
  EMCDDCH?: InputMaybe<Order_By>;
  EMCDDCLT?: InputMaybe<Order_By>;
  EMCDIPD?: InputMaybe<Order_By>;
  EMCDIPDH?: InputMaybe<Order_By>;
  EMCDPDLT?: InputMaybe<Order_By>;
  EMCRDC?: InputMaybe<Order_By>;
  EMCRDCH?: InputMaybe<Order_By>;
  EMCRDCLT?: InputMaybe<Order_By>;
  EMCRIPD?: InputMaybe<Order_By>;
  EMCRIPDH?: InputMaybe<Order_By>;
  EMCRPDLT?: InputMaybe<Order_By>;
  ENPAYBEN?: InputMaybe<Order_By>;
  ENPBENLT?: InputMaybe<Order_By>;
  ENPYBENH?: InputMaybe<Order_By>;
  EPAYTOT?: InputMaybe<Order_By>;
  EPAYTOTH?: InputMaybe<Order_By>;
  EPTAST?: InputMaybe<Order_By>;
  EPTLAB?: InputMaybe<Order_By>;
  EPTLPNTF?: InputMaybe<Order_By>;
  EPTMDTF?: InputMaybe<Order_By>;
  EPTOTHTF?: InputMaybe<Order_By>;
  EPTPHR?: InputMaybe<Order_By>;
  EPTPHT?: InputMaybe<Order_By>;
  EPTRAD?: InputMaybe<Order_By>;
  EPTRES?: InputMaybe<Order_By>;
  EPTRESP?: InputMaybe<Order_By>;
  EPTRNTF?: InputMaybe<Order_By>;
  EPTTOT?: InputMaybe<Order_By>;
  EPTTOTH?: InputMaybe<Order_By>;
  EPTTOTLT?: InputMaybe<Order_By>;
  EPTTRN84?: InputMaybe<Order_By>;
  EPYTOTLT?: InputMaybe<Order_By>;
  ERNFTE?: InputMaybe<Order_By>;
  ESUROPIP?: InputMaybe<Order_By>;
  ESUROPOP?: InputMaybe<Order_By>;
  ESUROPTO?: InputMaybe<Order_By>;
  EVEM?: InputMaybe<Order_By>;
  EVOTH?: InputMaybe<Order_By>;
  EVTOT?: InputMaybe<Order_By>;
  EXPTHA?: InputMaybe<Order_By>;
  EXPTHB?: InputMaybe<Order_By>;
  EXPTLA?: InputMaybe<Order_By>;
  EXPTLB?: InputMaybe<Order_By>;
  EXPTOT?: InputMaybe<Order_By>;
  FTAST?: InputMaybe<Order_By>;
  FTE?: InputMaybe<Order_By>;
  FTEAP?: InputMaybe<Order_By>;
  FTECAP?: InputMaybe<Order_By>;
  FTECLAB?: InputMaybe<Order_By>;
  FTECPH?: InputMaybe<Order_By>;
  FTECPHT?: InputMaybe<Order_By>;
  FTECRAD?: InputMaybe<Order_By>;
  FTECRESP?: InputMaybe<Order_By>;
  FTED?: InputMaybe<Order_By>;
  FTEH?: InputMaybe<Order_By>;
  FTELAB?: InputMaybe<Order_By>;
  FTELPN?: InputMaybe<Order_By>;
  FTEMD?: InputMaybe<Order_By>;
  FTEN?: InputMaybe<Order_By>;
  FTENH?: InputMaybe<Order_By>;
  FTEO?: InputMaybe<Order_By>;
  FTEOTH94?: InputMaybe<Order_By>;
  FTEP?: InputMaybe<Order_By>;
  FTEPH?: InputMaybe<Order_By>;
  FTEPHT?: InputMaybe<Order_By>;
  FTER?: InputMaybe<Order_By>;
  FTERAD?: InputMaybe<Order_By>;
  FTERES?: InputMaybe<Order_By>;
  FTERESP?: InputMaybe<Order_By>;
  FTERN?: InputMaybe<Order_By>;
  FTERNH?: InputMaybe<Order_By>;
  FTERNLT?: InputMaybe<Order_By>;
  FTET?: InputMaybe<Order_By>;
  FTETF?: InputMaybe<Order_By>;
  FTETRAN?: InputMaybe<Order_By>;
  FTETTRN?: InputMaybe<Order_By>;
  FTEU?: InputMaybe<Order_By>;
  FTLAB?: InputMaybe<Order_By>;
  FTLPNTF?: InputMaybe<Order_By>;
  FTMDTF?: InputMaybe<Order_By>;
  FTOTHTF?: InputMaybe<Order_By>;
  FTPHR?: InputMaybe<Order_By>;
  FTPHT?: InputMaybe<Order_By>;
  FTRAD?: InputMaybe<Order_By>;
  FTRES?: InputMaybe<Order_By>;
  FTRESP?: InputMaybe<Order_By>;
  FTRNLT?: InputMaybe<Order_By>;
  FTRNTF?: InputMaybe<Order_By>;
  FTTOT?: InputMaybe<Order_By>;
  FTTOTH?: InputMaybe<Order_By>;
  FTTOTLT?: InputMaybe<Order_By>;
  FTTRAN84?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  INTEXA?: InputMaybe<Order_By>;
  IPDH?: InputMaybe<Order_By>;
  IPDLT?: InputMaybe<Order_By>;
  IPDTOT?: InputMaybe<Order_By>;
  LBEDLA?: InputMaybe<Order_By>;
  LBEDSA?: InputMaybe<Order_By>;
  MCDDC?: InputMaybe<Order_By>;
  MCDDCH?: InputMaybe<Order_By>;
  MCDDCLT?: InputMaybe<Order_By>;
  MCDIPD?: InputMaybe<Order_By>;
  MCDIPDH?: InputMaybe<Order_By>;
  MCDIPDLT?: InputMaybe<Order_By>;
  MCRDC?: InputMaybe<Order_By>;
  MCRDCH?: InputMaybe<Order_By>;
  MCRDCLT?: InputMaybe<Order_By>;
  MCRIPD?: InputMaybe<Order_By>;
  MCRIPDH?: InputMaybe<Order_By>;
  MCRIPDLT?: InputMaybe<Order_By>;
  NPAYBEN?: InputMaybe<Order_By>;
  NPAYBENH?: InputMaybe<Order_By>;
  NPAYBENL?: InputMaybe<Order_By>;
  OPRA?: InputMaybe<Order_By>;
  OTHEXPA?: InputMaybe<Order_By>;
  OTHPCR?: InputMaybe<Order_By>;
  PAYTOT?: InputMaybe<Order_By>;
  PAYTOTH?: InputMaybe<Order_By>;
  PAYTOTLT?: InputMaybe<Order_By>;
  PCMRES?: InputMaybe<Order_By>;
  PHREXA?: InputMaybe<Order_By>;
  PTAST?: InputMaybe<Order_By>;
  PTLAB?: InputMaybe<Order_By>;
  PTLPNTF?: InputMaybe<Order_By>;
  PTMDTF?: InputMaybe<Order_By>;
  PTOTHTF?: InputMaybe<Order_By>;
  PTPHR?: InputMaybe<Order_By>;
  PTPHT?: InputMaybe<Order_By>;
  PTRAD?: InputMaybe<Order_By>;
  PTRES?: InputMaybe<Order_By>;
  PTRESP?: InputMaybe<Order_By>;
  PTRNLT?: InputMaybe<Order_By>;
  PTRNTF?: InputMaybe<Order_By>;
  PTTOT?: InputMaybe<Order_By>;
  PTTOTH?: InputMaybe<Order_By>;
  PTTOTLT?: InputMaybe<Order_By>;
  PTTRAN84?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUPEXA?: InputMaybe<Order_By>;
  SUROPIP?: InputMaybe<Order_By>;
  SUROPOP?: InputMaybe<Order_By>;
  SUROPTOT?: InputMaybe<Order_By>;
  VAST?: InputMaybe<Order_By>;
  VEM?: InputMaybe<Order_By>;
  VLAB?: InputMaybe<Order_By>;
  VLPN?: InputMaybe<Order_By>;
  VMD?: InputMaybe<Order_By>;
  VOTH?: InputMaybe<Order_By>;
  VOTHL?: InputMaybe<Order_By>;
  VPHR?: InputMaybe<Order_By>;
  VPHT?: InputMaybe<Order_By>;
  VRAD?: InputMaybe<Order_By>;
  VRES?: InputMaybe<Order_By>;
  VRN?: InputMaybe<Order_By>;
  VRNH?: InputMaybe<Order_By>;
  VRSP?: InputMaybe<Order_By>;
  VTNH?: InputMaybe<Order_By>;
  VTOT?: InputMaybe<Order_By>;
  VTOTL?: InputMaybe<Order_By>;
  VTTRN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS21UTIL */
export type As21Util_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS21UTIL" */
export enum As21Util_Select_Column {
  /** column name */
  Adc = 'ADC',
  /** column name */
  Adjadc = 'ADJADC',
  /** column name */
  Adjadch = 'ADJADCH',
  /** column name */
  Adjadm = 'ADJADM',
  /** column name */
  Adjpd = 'ADJPD',
  /** column name */
  Adjpdh = 'ADJPDH',
  /** column name */
  Admh = 'ADMH',
  /** column name */
  Admlt = 'ADMLT',
  /** column name */
  Admtot = 'ADMTOT',
  /** column name */
  Bassin = 'BASSIN',
  /** column name */
  Bdh = 'BDH',
  /** column name */
  Bdlt = 'BDLT',
  /** column name */
  Bdtot = 'BDTOT',
  /** column name */
  Births = 'BIRTHS',
  /** column name */
  Dpexa = 'DPEXA',
  /** column name */
  Eadmh = 'EADMH',
  /** column name */
  Eadmlt = 'EADMLT',
  /** column name */
  Eadmtot = 'EADMTOT',
  /** column name */
  Ebirths = 'EBIRTHS',
  /** column name */
  Eexptot = 'EEXPTOT',
  /** column name */
  Eftast = 'EFTAST',
  /** column name */
  Eftlab = 'EFTLAB',
  /** column name */
  Eftlpntf = 'EFTLPNTF',
  /** column name */
  Eftmdtf = 'EFTMDTF',
  /** column name */
  Eftothtf = 'EFTOTHTF',
  /** column name */
  Eftphr = 'EFTPHR',
  /** column name */
  Eftpht = 'EFTPHT',
  /** column name */
  Eftrad = 'EFTRAD',
  /** column name */
  Eftres = 'EFTRES',
  /** column name */
  Eftresp = 'EFTRESP',
  /** column name */
  Eftrntf = 'EFTRNTF',
  /** column name */
  Efttot = 'EFTTOT',
  /** column name */
  Efttoth = 'EFTTOTH',
  /** column name */
  Efttotlt = 'EFTTOTLT',
  /** column name */
  Efttrn84 = 'EFTTRN84',
  /** column name */
  Eipdh = 'EIPDH',
  /** column name */
  Eipdlt = 'EIPDLT',
  /** column name */
  Eipdtot = 'EIPDTOT',
  /** column name */
  Emcddc = 'EMCDDC',
  /** column name */
  Emcddch = 'EMCDDCH',
  /** column name */
  Emcddclt = 'EMCDDCLT',
  /** column name */
  Emcdipd = 'EMCDIPD',
  /** column name */
  Emcdipdh = 'EMCDIPDH',
  /** column name */
  Emcdpdlt = 'EMCDPDLT',
  /** column name */
  Emcrdc = 'EMCRDC',
  /** column name */
  Emcrdch = 'EMCRDCH',
  /** column name */
  Emcrdclt = 'EMCRDCLT',
  /** column name */
  Emcripd = 'EMCRIPD',
  /** column name */
  Emcripdh = 'EMCRIPDH',
  /** column name */
  Emcrpdlt = 'EMCRPDLT',
  /** column name */
  Enpayben = 'ENPAYBEN',
  /** column name */
  Enpbenlt = 'ENPBENLT',
  /** column name */
  Enpybenh = 'ENPYBENH',
  /** column name */
  Epaytot = 'EPAYTOT',
  /** column name */
  Epaytoth = 'EPAYTOTH',
  /** column name */
  Eptast = 'EPTAST',
  /** column name */
  Eptlab = 'EPTLAB',
  /** column name */
  Eptlpntf = 'EPTLPNTF',
  /** column name */
  Eptmdtf = 'EPTMDTF',
  /** column name */
  Eptothtf = 'EPTOTHTF',
  /** column name */
  Eptphr = 'EPTPHR',
  /** column name */
  Eptpht = 'EPTPHT',
  /** column name */
  Eptrad = 'EPTRAD',
  /** column name */
  Eptres = 'EPTRES',
  /** column name */
  Eptresp = 'EPTRESP',
  /** column name */
  Eptrntf = 'EPTRNTF',
  /** column name */
  Epttot = 'EPTTOT',
  /** column name */
  Epttoth = 'EPTTOTH',
  /** column name */
  Epttotlt = 'EPTTOTLT',
  /** column name */
  Epttrn84 = 'EPTTRN84',
  /** column name */
  Epytotlt = 'EPYTOTLT',
  /** column name */
  Ernfte = 'ERNFTE',
  /** column name */
  Esuropip = 'ESUROPIP',
  /** column name */
  Esuropop = 'ESUROPOP',
  /** column name */
  Esuropto = 'ESUROPTO',
  /** column name */
  Evem = 'EVEM',
  /** column name */
  Evoth = 'EVOTH',
  /** column name */
  Evtot = 'EVTOT',
  /** column name */
  Exptha = 'EXPTHA',
  /** column name */
  Expthb = 'EXPTHB',
  /** column name */
  Exptla = 'EXPTLA',
  /** column name */
  Exptlb = 'EXPTLB',
  /** column name */
  Exptot = 'EXPTOT',
  /** column name */
  Ftast = 'FTAST',
  /** column name */
  Fte = 'FTE',
  /** column name */
  Fteap = 'FTEAP',
  /** column name */
  Ftecap = 'FTECAP',
  /** column name */
  Fteclab = 'FTECLAB',
  /** column name */
  Ftecph = 'FTECPH',
  /** column name */
  Ftecpht = 'FTECPHT',
  /** column name */
  Ftecrad = 'FTECRAD',
  /** column name */
  Ftecresp = 'FTECRESP',
  /** column name */
  Fted = 'FTED',
  /** column name */
  Fteh = 'FTEH',
  /** column name */
  Ftelab = 'FTELAB',
  /** column name */
  Ftelpn = 'FTELPN',
  /** column name */
  Ftemd = 'FTEMD',
  /** column name */
  Ften = 'FTEN',
  /** column name */
  Ftenh = 'FTENH',
  /** column name */
  Fteo = 'FTEO',
  /** column name */
  Fteoth94 = 'FTEOTH94',
  /** column name */
  Ftep = 'FTEP',
  /** column name */
  Fteph = 'FTEPH',
  /** column name */
  Ftepht = 'FTEPHT',
  /** column name */
  Fter = 'FTER',
  /** column name */
  Fterad = 'FTERAD',
  /** column name */
  Fteres = 'FTERES',
  /** column name */
  Fteresp = 'FTERESP',
  /** column name */
  Ftern = 'FTERN',
  /** column name */
  Fternh = 'FTERNH',
  /** column name */
  Fternlt = 'FTERNLT',
  /** column name */
  Ftet = 'FTET',
  /** column name */
  Ftetf = 'FTETF',
  /** column name */
  Ftetran = 'FTETRAN',
  /** column name */
  Ftettrn = 'FTETTRN',
  /** column name */
  Fteu = 'FTEU',
  /** column name */
  Ftlab = 'FTLAB',
  /** column name */
  Ftlpntf = 'FTLPNTF',
  /** column name */
  Ftmdtf = 'FTMDTF',
  /** column name */
  Ftothtf = 'FTOTHTF',
  /** column name */
  Ftphr = 'FTPHR',
  /** column name */
  Ftpht = 'FTPHT',
  /** column name */
  Ftrad = 'FTRAD',
  /** column name */
  Ftres = 'FTRES',
  /** column name */
  Ftresp = 'FTRESP',
  /** column name */
  Ftrnlt = 'FTRNLT',
  /** column name */
  Ftrntf = 'FTRNTF',
  /** column name */
  Fttot = 'FTTOT',
  /** column name */
  Fttoth = 'FTTOTH',
  /** column name */
  Fttotlt = 'FTTOTLT',
  /** column name */
  Fttran84 = 'FTTRAN84',
  /** column name */
  Id = 'ID',
  /** column name */
  Intexa = 'INTEXA',
  /** column name */
  Ipdh = 'IPDH',
  /** column name */
  Ipdlt = 'IPDLT',
  /** column name */
  Ipdtot = 'IPDTOT',
  /** column name */
  Lbedla = 'LBEDLA',
  /** column name */
  Lbedsa = 'LBEDSA',
  /** column name */
  Mcddc = 'MCDDC',
  /** column name */
  Mcddch = 'MCDDCH',
  /** column name */
  Mcddclt = 'MCDDCLT',
  /** column name */
  Mcdipd = 'MCDIPD',
  /** column name */
  Mcdipdh = 'MCDIPDH',
  /** column name */
  Mcdipdlt = 'MCDIPDLT',
  /** column name */
  Mcrdc = 'MCRDC',
  /** column name */
  Mcrdch = 'MCRDCH',
  /** column name */
  Mcrdclt = 'MCRDCLT',
  /** column name */
  Mcripd = 'MCRIPD',
  /** column name */
  Mcripdh = 'MCRIPDH',
  /** column name */
  Mcripdlt = 'MCRIPDLT',
  /** column name */
  Npayben = 'NPAYBEN',
  /** column name */
  Npaybenh = 'NPAYBENH',
  /** column name */
  Npaybenl = 'NPAYBENL',
  /** column name */
  Opra = 'OPRA',
  /** column name */
  Othexpa = 'OTHEXPA',
  /** column name */
  Othpcr = 'OTHPCR',
  /** column name */
  Paytot = 'PAYTOT',
  /** column name */
  Paytoth = 'PAYTOTH',
  /** column name */
  Paytotlt = 'PAYTOTLT',
  /** column name */
  Pcmres = 'PCMRES',
  /** column name */
  Phrexa = 'PHREXA',
  /** column name */
  Ptast = 'PTAST',
  /** column name */
  Ptlab = 'PTLAB',
  /** column name */
  Ptlpntf = 'PTLPNTF',
  /** column name */
  Ptmdtf = 'PTMDTF',
  /** column name */
  Ptothtf = 'PTOTHTF',
  /** column name */
  Ptphr = 'PTPHR',
  /** column name */
  Ptpht = 'PTPHT',
  /** column name */
  Ptrad = 'PTRAD',
  /** column name */
  Ptres = 'PTRES',
  /** column name */
  Ptresp = 'PTRESP',
  /** column name */
  Ptrnlt = 'PTRNLT',
  /** column name */
  Ptrntf = 'PTRNTF',
  /** column name */
  Pttot = 'PTTOT',
  /** column name */
  Pttoth = 'PTTOTH',
  /** column name */
  Pttotlt = 'PTTOTLT',
  /** column name */
  Pttran84 = 'PTTRAN84',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Supexa = 'SUPEXA',
  /** column name */
  Suropip = 'SUROPIP',
  /** column name */
  Suropop = 'SUROPOP',
  /** column name */
  Suroptot = 'SUROPTOT',
  /** column name */
  Vast = 'VAST',
  /** column name */
  Vem = 'VEM',
  /** column name */
  Vlab = 'VLAB',
  /** column name */
  Vlpn = 'VLPN',
  /** column name */
  Vmd = 'VMD',
  /** column name */
  Voth = 'VOTH',
  /** column name */
  Vothl = 'VOTHL',
  /** column name */
  Vphr = 'VPHR',
  /** column name */
  Vpht = 'VPHT',
  /** column name */
  Vrad = 'VRAD',
  /** column name */
  Vres = 'VRES',
  /** column name */
  Vrn = 'VRN',
  /** column name */
  Vrnh = 'VRNH',
  /** column name */
  Vrsp = 'VRSP',
  /** column name */
  Vtnh = 'VTNH',
  /** column name */
  Vtot = 'VTOT',
  /** column name */
  Vtotl = 'VTOTL',
  /** column name */
  Vttrn = 'VTTRN'
}

/** input type for updating data in table "AS21UTIL" */
export type As21Util_Set_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type As21Util_Stddev_Fields = {
  __typename?: 'AS21UTIL_stddev_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As21Util_Stddev_Pop_Fields = {
  __typename?: 'AS21UTIL_stddev_pop_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As21Util_Stddev_Samp_Fields = {
  __typename?: 'AS21UTIL_stddev_samp_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS21UTIL" */
export type As21Util_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As21Util_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As21Util_Stream_Cursor_Value_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type As21Util_Sum_Fields = {
  __typename?: 'AS21UTIL_sum_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  ERNFTE: Maybe<Scalars['float8']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** update columns of table "AS21UTIL" */
export enum As21Util_Update_Column {
  /** column name */
  Adc = 'ADC',
  /** column name */
  Adjadc = 'ADJADC',
  /** column name */
  Adjadch = 'ADJADCH',
  /** column name */
  Adjadm = 'ADJADM',
  /** column name */
  Adjpd = 'ADJPD',
  /** column name */
  Adjpdh = 'ADJPDH',
  /** column name */
  Admh = 'ADMH',
  /** column name */
  Admlt = 'ADMLT',
  /** column name */
  Admtot = 'ADMTOT',
  /** column name */
  Bassin = 'BASSIN',
  /** column name */
  Bdh = 'BDH',
  /** column name */
  Bdlt = 'BDLT',
  /** column name */
  Bdtot = 'BDTOT',
  /** column name */
  Births = 'BIRTHS',
  /** column name */
  Dpexa = 'DPEXA',
  /** column name */
  Eadmh = 'EADMH',
  /** column name */
  Eadmlt = 'EADMLT',
  /** column name */
  Eadmtot = 'EADMTOT',
  /** column name */
  Ebirths = 'EBIRTHS',
  /** column name */
  Eexptot = 'EEXPTOT',
  /** column name */
  Eftast = 'EFTAST',
  /** column name */
  Eftlab = 'EFTLAB',
  /** column name */
  Eftlpntf = 'EFTLPNTF',
  /** column name */
  Eftmdtf = 'EFTMDTF',
  /** column name */
  Eftothtf = 'EFTOTHTF',
  /** column name */
  Eftphr = 'EFTPHR',
  /** column name */
  Eftpht = 'EFTPHT',
  /** column name */
  Eftrad = 'EFTRAD',
  /** column name */
  Eftres = 'EFTRES',
  /** column name */
  Eftresp = 'EFTRESP',
  /** column name */
  Eftrntf = 'EFTRNTF',
  /** column name */
  Efttot = 'EFTTOT',
  /** column name */
  Efttoth = 'EFTTOTH',
  /** column name */
  Efttotlt = 'EFTTOTLT',
  /** column name */
  Efttrn84 = 'EFTTRN84',
  /** column name */
  Eipdh = 'EIPDH',
  /** column name */
  Eipdlt = 'EIPDLT',
  /** column name */
  Eipdtot = 'EIPDTOT',
  /** column name */
  Emcddc = 'EMCDDC',
  /** column name */
  Emcddch = 'EMCDDCH',
  /** column name */
  Emcddclt = 'EMCDDCLT',
  /** column name */
  Emcdipd = 'EMCDIPD',
  /** column name */
  Emcdipdh = 'EMCDIPDH',
  /** column name */
  Emcdpdlt = 'EMCDPDLT',
  /** column name */
  Emcrdc = 'EMCRDC',
  /** column name */
  Emcrdch = 'EMCRDCH',
  /** column name */
  Emcrdclt = 'EMCRDCLT',
  /** column name */
  Emcripd = 'EMCRIPD',
  /** column name */
  Emcripdh = 'EMCRIPDH',
  /** column name */
  Emcrpdlt = 'EMCRPDLT',
  /** column name */
  Enpayben = 'ENPAYBEN',
  /** column name */
  Enpbenlt = 'ENPBENLT',
  /** column name */
  Enpybenh = 'ENPYBENH',
  /** column name */
  Epaytot = 'EPAYTOT',
  /** column name */
  Epaytoth = 'EPAYTOTH',
  /** column name */
  Eptast = 'EPTAST',
  /** column name */
  Eptlab = 'EPTLAB',
  /** column name */
  Eptlpntf = 'EPTLPNTF',
  /** column name */
  Eptmdtf = 'EPTMDTF',
  /** column name */
  Eptothtf = 'EPTOTHTF',
  /** column name */
  Eptphr = 'EPTPHR',
  /** column name */
  Eptpht = 'EPTPHT',
  /** column name */
  Eptrad = 'EPTRAD',
  /** column name */
  Eptres = 'EPTRES',
  /** column name */
  Eptresp = 'EPTRESP',
  /** column name */
  Eptrntf = 'EPTRNTF',
  /** column name */
  Epttot = 'EPTTOT',
  /** column name */
  Epttoth = 'EPTTOTH',
  /** column name */
  Epttotlt = 'EPTTOTLT',
  /** column name */
  Epttrn84 = 'EPTTRN84',
  /** column name */
  Epytotlt = 'EPYTOTLT',
  /** column name */
  Ernfte = 'ERNFTE',
  /** column name */
  Esuropip = 'ESUROPIP',
  /** column name */
  Esuropop = 'ESUROPOP',
  /** column name */
  Esuropto = 'ESUROPTO',
  /** column name */
  Evem = 'EVEM',
  /** column name */
  Evoth = 'EVOTH',
  /** column name */
  Evtot = 'EVTOT',
  /** column name */
  Exptha = 'EXPTHA',
  /** column name */
  Expthb = 'EXPTHB',
  /** column name */
  Exptla = 'EXPTLA',
  /** column name */
  Exptlb = 'EXPTLB',
  /** column name */
  Exptot = 'EXPTOT',
  /** column name */
  Ftast = 'FTAST',
  /** column name */
  Fte = 'FTE',
  /** column name */
  Fteap = 'FTEAP',
  /** column name */
  Ftecap = 'FTECAP',
  /** column name */
  Fteclab = 'FTECLAB',
  /** column name */
  Ftecph = 'FTECPH',
  /** column name */
  Ftecpht = 'FTECPHT',
  /** column name */
  Ftecrad = 'FTECRAD',
  /** column name */
  Ftecresp = 'FTECRESP',
  /** column name */
  Fted = 'FTED',
  /** column name */
  Fteh = 'FTEH',
  /** column name */
  Ftelab = 'FTELAB',
  /** column name */
  Ftelpn = 'FTELPN',
  /** column name */
  Ftemd = 'FTEMD',
  /** column name */
  Ften = 'FTEN',
  /** column name */
  Ftenh = 'FTENH',
  /** column name */
  Fteo = 'FTEO',
  /** column name */
  Fteoth94 = 'FTEOTH94',
  /** column name */
  Ftep = 'FTEP',
  /** column name */
  Fteph = 'FTEPH',
  /** column name */
  Ftepht = 'FTEPHT',
  /** column name */
  Fter = 'FTER',
  /** column name */
  Fterad = 'FTERAD',
  /** column name */
  Fteres = 'FTERES',
  /** column name */
  Fteresp = 'FTERESP',
  /** column name */
  Ftern = 'FTERN',
  /** column name */
  Fternh = 'FTERNH',
  /** column name */
  Fternlt = 'FTERNLT',
  /** column name */
  Ftet = 'FTET',
  /** column name */
  Ftetf = 'FTETF',
  /** column name */
  Ftetran = 'FTETRAN',
  /** column name */
  Ftettrn = 'FTETTRN',
  /** column name */
  Fteu = 'FTEU',
  /** column name */
  Ftlab = 'FTLAB',
  /** column name */
  Ftlpntf = 'FTLPNTF',
  /** column name */
  Ftmdtf = 'FTMDTF',
  /** column name */
  Ftothtf = 'FTOTHTF',
  /** column name */
  Ftphr = 'FTPHR',
  /** column name */
  Ftpht = 'FTPHT',
  /** column name */
  Ftrad = 'FTRAD',
  /** column name */
  Ftres = 'FTRES',
  /** column name */
  Ftresp = 'FTRESP',
  /** column name */
  Ftrnlt = 'FTRNLT',
  /** column name */
  Ftrntf = 'FTRNTF',
  /** column name */
  Fttot = 'FTTOT',
  /** column name */
  Fttoth = 'FTTOTH',
  /** column name */
  Fttotlt = 'FTTOTLT',
  /** column name */
  Fttran84 = 'FTTRAN84',
  /** column name */
  Id = 'ID',
  /** column name */
  Intexa = 'INTEXA',
  /** column name */
  Ipdh = 'IPDH',
  /** column name */
  Ipdlt = 'IPDLT',
  /** column name */
  Ipdtot = 'IPDTOT',
  /** column name */
  Lbedla = 'LBEDLA',
  /** column name */
  Lbedsa = 'LBEDSA',
  /** column name */
  Mcddc = 'MCDDC',
  /** column name */
  Mcddch = 'MCDDCH',
  /** column name */
  Mcddclt = 'MCDDCLT',
  /** column name */
  Mcdipd = 'MCDIPD',
  /** column name */
  Mcdipdh = 'MCDIPDH',
  /** column name */
  Mcdipdlt = 'MCDIPDLT',
  /** column name */
  Mcrdc = 'MCRDC',
  /** column name */
  Mcrdch = 'MCRDCH',
  /** column name */
  Mcrdclt = 'MCRDCLT',
  /** column name */
  Mcripd = 'MCRIPD',
  /** column name */
  Mcripdh = 'MCRIPDH',
  /** column name */
  Mcripdlt = 'MCRIPDLT',
  /** column name */
  Npayben = 'NPAYBEN',
  /** column name */
  Npaybenh = 'NPAYBENH',
  /** column name */
  Npaybenl = 'NPAYBENL',
  /** column name */
  Opra = 'OPRA',
  /** column name */
  Othexpa = 'OTHEXPA',
  /** column name */
  Othpcr = 'OTHPCR',
  /** column name */
  Paytot = 'PAYTOT',
  /** column name */
  Paytoth = 'PAYTOTH',
  /** column name */
  Paytotlt = 'PAYTOTLT',
  /** column name */
  Pcmres = 'PCMRES',
  /** column name */
  Phrexa = 'PHREXA',
  /** column name */
  Ptast = 'PTAST',
  /** column name */
  Ptlab = 'PTLAB',
  /** column name */
  Ptlpntf = 'PTLPNTF',
  /** column name */
  Ptmdtf = 'PTMDTF',
  /** column name */
  Ptothtf = 'PTOTHTF',
  /** column name */
  Ptphr = 'PTPHR',
  /** column name */
  Ptpht = 'PTPHT',
  /** column name */
  Ptrad = 'PTRAD',
  /** column name */
  Ptres = 'PTRES',
  /** column name */
  Ptresp = 'PTRESP',
  /** column name */
  Ptrnlt = 'PTRNLT',
  /** column name */
  Ptrntf = 'PTRNTF',
  /** column name */
  Pttot = 'PTTOT',
  /** column name */
  Pttoth = 'PTTOTH',
  /** column name */
  Pttotlt = 'PTTOTLT',
  /** column name */
  Pttran84 = 'PTTRAN84',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Supexa = 'SUPEXA',
  /** column name */
  Suropip = 'SUROPIP',
  /** column name */
  Suropop = 'SUROPOP',
  /** column name */
  Suroptot = 'SUROPTOT',
  /** column name */
  Vast = 'VAST',
  /** column name */
  Vem = 'VEM',
  /** column name */
  Vlab = 'VLAB',
  /** column name */
  Vlpn = 'VLPN',
  /** column name */
  Vmd = 'VMD',
  /** column name */
  Voth = 'VOTH',
  /** column name */
  Vothl = 'VOTHL',
  /** column name */
  Vphr = 'VPHR',
  /** column name */
  Vpht = 'VPHT',
  /** column name */
  Vrad = 'VRAD',
  /** column name */
  Vres = 'VRES',
  /** column name */
  Vrn = 'VRN',
  /** column name */
  Vrnh = 'VRNH',
  /** column name */
  Vrsp = 'VRSP',
  /** column name */
  Vtnh = 'VTNH',
  /** column name */
  Vtot = 'VTOT',
  /** column name */
  Vtotl = 'VTOTL',
  /** column name */
  Vttrn = 'VTTRN'
}

export type As21Util_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As21Util_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As21Util_Set_Input>;
  /** filter the rows which have to be updated */
  where: As21Util_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As21Util_Var_Pop_Fields = {
  __typename?: 'AS21UTIL_var_pop_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As21Util_Var_Samp_Fields = {
  __typename?: 'AS21UTIL_var_samp_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As21Util_Variance_Fields = {
  __typename?: 'AS21UTIL_variance_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS22DEM" */
export type As22Dem = {
  __typename?: 'AS22DEM';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDGASCP: Maybe<Scalars['float8']>;
  BDGASMA: Maybe<Scalars['float8']>;
  BDGASMD: Maybe<Scalars['float8']>;
  BDGASTM: Maybe<Scalars['float8']>;
  BDGICCP: Maybe<Scalars['float8']>;
  BDGICMA: Maybe<Scalars['float8']>;
  BDGICMD: Maybe<Scalars['float8']>;
  BDGICTM: Maybe<Scalars['float8']>;
  BDHEMCP: Maybe<Scalars['float8']>;
  BDHEMMA: Maybe<Scalars['float8']>;
  BDHEMMD: Maybe<Scalars['float8']>;
  BDHEMTM: Maybe<Scalars['float8']>;
  BDHPLCP: Maybe<Scalars['float8']>;
  BDHPLMA: Maybe<Scalars['float8']>;
  BDHPLMD: Maybe<Scalars['float8']>;
  BDHPLTM: Maybe<Scalars['float8']>;
  BDINDCP: Maybe<Scalars['float8']>;
  BDINDMA: Maybe<Scalars['float8']>;
  BDINDMD: Maybe<Scalars['float8']>;
  BDINDTM: Maybe<Scalars['float8']>;
  BDLGYCP: Maybe<Scalars['float8']>;
  BDLGYMA: Maybe<Scalars['float8']>;
  BDLGYMD: Maybe<Scalars['float8']>;
  BDLGYTM: Maybe<Scalars['float8']>;
  BDNDOCP: Maybe<Scalars['float8']>;
  BDNDOMA: Maybe<Scalars['float8']>;
  BDNDOMD: Maybe<Scalars['float8']>;
  BDNDOTM: Maybe<Scalars['float8']>;
  BDNEPCP: Maybe<Scalars['float8']>;
  BDNEPMA: Maybe<Scalars['float8']>;
  BDNEPMD: Maybe<Scalars['float8']>;
  BDNEPTM: Maybe<Scalars['float8']>;
  BDNOBCP: Maybe<Scalars['float8']>;
  BDNOBMA: Maybe<Scalars['float8']>;
  BDNOBMD: Maybe<Scalars['float8']>;
  BDNOBTM: Maybe<Scalars['float8']>;
  BDPEDCP: Maybe<Scalars['float8']>;
  BDPEDMA: Maybe<Scalars['float8']>;
  BDPEDMD: Maybe<Scalars['float8']>;
  BDPEDTM: Maybe<Scalars['float8']>;
  BDPHDCP: Maybe<Scalars['float8']>;
  BDPHDMA: Maybe<Scalars['float8']>;
  BDPHDMD: Maybe<Scalars['float8']>;
  BDPHDTM: Maybe<Scalars['float8']>;
  BDPOTCP: Maybe<Scalars['float8']>;
  BDPOTH: Maybe<Scalars['String']>;
  BDPOTMA: Maybe<Scalars['float8']>;
  BDPOTMD: Maybe<Scalars['float8']>;
  BDPOTTM: Maybe<Scalars['float8']>;
  BDPULCP: Maybe<Scalars['float8']>;
  BDPULMA: Maybe<Scalars['float8']>;
  BDPULMD: Maybe<Scalars['float8']>;
  BDPULTM: Maybe<Scalars['float8']>;
  BDSUBCP: Maybe<Scalars['float8']>;
  BDSUBMA: Maybe<Scalars['float8']>;
  BDSUBMD: Maybe<Scalars['float8']>;
  BDSUBTM: Maybe<Scalars['float8']>;
  BDVASCP: Maybe<Scalars['float8']>;
  BDVASMA: Maybe<Scalars['float8']>;
  BDVASMD: Maybe<Scalars['float8']>;
  BDVASTM: Maybe<Scalars['float8']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FRTLN: Maybe<Scalars['float8']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IINSPT: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  NOPATH: Maybe<Scalars['float8']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  PBDPY: Maybe<Scalars['String']>;
  PHYGP: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  RESPTC: Maybe<Scalars['float8']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPAH: Maybe<Scalars['float8']>;
  SPLAN: Maybe<Scalars['String']>;
  SPTC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
  rollups: Array<Scalars['String']>;
  /** An object relationship */
  svc1: Maybe<As22Svc1>;
  /** An object relationship */
  svc2: Maybe<As22Svc2>;
  /** An object relationship */
  svc3: Maybe<As22Svc3>;
  /** An array relationship */
  units: Array<As22Unit>;
  /** An aggregate relationship */
  units_aggregate: As22Unit_Aggregate;
  /** An object relationship */
  util1: Maybe<As22Util>;
  /** An object relationship */
  util2: Maybe<As22Util2>;
};


/** columns and relationships of "AS22DEM" */
export type As22DemUnitsArgs = {
  distinct_on?: InputMaybe<Array<As22Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Unit_Order_By>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};


/** columns and relationships of "AS22DEM" */
export type As22DemUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Unit_Order_By>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};

/** aggregated selection of "AS22DEM" */
export type As22Dem_Aggregate = {
  __typename?: 'AS22DEM_aggregate';
  aggregate: Maybe<As22Dem_Aggregate_Fields>;
  nodes: Array<As22Dem>;
};

/** aggregate fields of "AS22DEM" */
export type As22Dem_Aggregate_Fields = {
  __typename?: 'AS22DEM_aggregate_fields';
  avg: Maybe<As22Dem_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As22Dem_Max_Fields>;
  min: Maybe<As22Dem_Min_Fields>;
  stddev: Maybe<As22Dem_Stddev_Fields>;
  stddev_pop: Maybe<As22Dem_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As22Dem_Stddev_Samp_Fields>;
  sum: Maybe<As22Dem_Sum_Fields>;
  var_pop: Maybe<As22Dem_Var_Pop_Fields>;
  var_samp: Maybe<As22Dem_Var_Samp_Fields>;
  variance: Maybe<As22Dem_Variance_Fields>;
};


/** aggregate fields of "AS22DEM" */
export type As22Dem_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Dem_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As22Dem_Avg_Fields = {
  __typename?: 'AS22DEM_avg_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS22DEM". All fields are combined with a logical 'AND'. */
export type As22Dem_Bool_Exp = {
  ACOCN?: InputMaybe<Float8_Comparison_Exp>;
  ACOORG?: InputMaybe<String_Comparison_Exp>;
  ACOPCT?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPAD?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPCI?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPMD?: InputMaybe<Float8_Comparison_Exp>;
  ACOTYPT?: InputMaybe<Float8_Comparison_Exp>;
  AHAMBR?: InputMaybe<String_Comparison_Exp>;
  AREA?: InputMaybe<String_Comparison_Exp>;
  BDGASCP?: InputMaybe<Float8_Comparison_Exp>;
  BDGASMA?: InputMaybe<Float8_Comparison_Exp>;
  BDGASMD?: InputMaybe<Float8_Comparison_Exp>;
  BDGASTM?: InputMaybe<Float8_Comparison_Exp>;
  BDGICCP?: InputMaybe<Float8_Comparison_Exp>;
  BDGICMA?: InputMaybe<Float8_Comparison_Exp>;
  BDGICMD?: InputMaybe<Float8_Comparison_Exp>;
  BDGICTM?: InputMaybe<Float8_Comparison_Exp>;
  BDHEMCP?: InputMaybe<Float8_Comparison_Exp>;
  BDHEMMA?: InputMaybe<Float8_Comparison_Exp>;
  BDHEMMD?: InputMaybe<Float8_Comparison_Exp>;
  BDHEMTM?: InputMaybe<Float8_Comparison_Exp>;
  BDHPLCP?: InputMaybe<Float8_Comparison_Exp>;
  BDHPLMA?: InputMaybe<Float8_Comparison_Exp>;
  BDHPLMD?: InputMaybe<Float8_Comparison_Exp>;
  BDHPLTM?: InputMaybe<Float8_Comparison_Exp>;
  BDINDCP?: InputMaybe<Float8_Comparison_Exp>;
  BDINDMA?: InputMaybe<Float8_Comparison_Exp>;
  BDINDMD?: InputMaybe<Float8_Comparison_Exp>;
  BDINDTM?: InputMaybe<Float8_Comparison_Exp>;
  BDLGYCP?: InputMaybe<Float8_Comparison_Exp>;
  BDLGYMA?: InputMaybe<Float8_Comparison_Exp>;
  BDLGYMD?: InputMaybe<Float8_Comparison_Exp>;
  BDLGYTM?: InputMaybe<Float8_Comparison_Exp>;
  BDNDOCP?: InputMaybe<Float8_Comparison_Exp>;
  BDNDOMA?: InputMaybe<Float8_Comparison_Exp>;
  BDNDOMD?: InputMaybe<Float8_Comparison_Exp>;
  BDNDOTM?: InputMaybe<Float8_Comparison_Exp>;
  BDNEPCP?: InputMaybe<Float8_Comparison_Exp>;
  BDNEPMA?: InputMaybe<Float8_Comparison_Exp>;
  BDNEPMD?: InputMaybe<Float8_Comparison_Exp>;
  BDNEPTM?: InputMaybe<Float8_Comparison_Exp>;
  BDNOBCP?: InputMaybe<Float8_Comparison_Exp>;
  BDNOBMA?: InputMaybe<Float8_Comparison_Exp>;
  BDNOBMD?: InputMaybe<Float8_Comparison_Exp>;
  BDNOBTM?: InputMaybe<Float8_Comparison_Exp>;
  BDPEDCP?: InputMaybe<Float8_Comparison_Exp>;
  BDPEDMA?: InputMaybe<Float8_Comparison_Exp>;
  BDPEDMD?: InputMaybe<Float8_Comparison_Exp>;
  BDPEDTM?: InputMaybe<Float8_Comparison_Exp>;
  BDPHDCP?: InputMaybe<Float8_Comparison_Exp>;
  BDPHDMA?: InputMaybe<Float8_Comparison_Exp>;
  BDPHDMD?: InputMaybe<Float8_Comparison_Exp>;
  BDPHDTM?: InputMaybe<Float8_Comparison_Exp>;
  BDPOTCP?: InputMaybe<Float8_Comparison_Exp>;
  BDPOTH?: InputMaybe<String_Comparison_Exp>;
  BDPOTMA?: InputMaybe<Float8_Comparison_Exp>;
  BDPOTMD?: InputMaybe<Float8_Comparison_Exp>;
  BDPOTTM?: InputMaybe<Float8_Comparison_Exp>;
  BDPULCP?: InputMaybe<Float8_Comparison_Exp>;
  BDPULMA?: InputMaybe<Float8_Comparison_Exp>;
  BDPULMD?: InputMaybe<Float8_Comparison_Exp>;
  BDPULTM?: InputMaybe<Float8_Comparison_Exp>;
  BDSUBCP?: InputMaybe<Float8_Comparison_Exp>;
  BDSUBMA?: InputMaybe<Float8_Comparison_Exp>;
  BDSUBMD?: InputMaybe<Float8_Comparison_Exp>;
  BDSUBTM?: InputMaybe<Float8_Comparison_Exp>;
  BDVASCP?: InputMaybe<Float8_Comparison_Exp>;
  BDVASMA?: InputMaybe<Float8_Comparison_Exp>;
  BDVASMD?: InputMaybe<Float8_Comparison_Exp>;
  BDVASTM?: InputMaybe<Float8_Comparison_Exp>;
  BNDPAY?: InputMaybe<String_Comparison_Exp>;
  BNDPCT?: InputMaybe<Float8_Comparison_Exp>;
  BNDRSK?: InputMaybe<String_Comparison_Exp>;
  BSC?: InputMaybe<String_Comparison_Exp>;
  CAPCON94?: InputMaybe<String_Comparison_Exp>;
  CAPRSK?: InputMaybe<Float8_Comparison_Exp>;
  CBSACODE?: InputMaybe<String_Comparison_Exp>;
  CBSANAME?: InputMaybe<String_Comparison_Exp>;
  CBSATYPE?: InputMaybe<String_Comparison_Exp>;
  CHC?: InputMaybe<String_Comparison_Exp>;
  CITYRK?: InputMaybe<String_Comparison_Exp>;
  CLUSTER?: InputMaybe<Float8_Comparison_Exp>;
  CMRPAY?: InputMaybe<String_Comparison_Exp>;
  CNTRL?: InputMaybe<String_Comparison_Exp>;
  CNTYNAME?: InputMaybe<String_Comparison_Exp>;
  COHSP?: InputMaybe<String_Comparison_Exp>;
  COMMTY?: InputMaybe<String_Comparison_Exp>;
  COTYCAN?: InputMaybe<Float8_Comparison_Exp>;
  COTYCAR?: InputMaybe<Float8_Comparison_Exp>;
  COTYDESC?: InputMaybe<String_Comparison_Exp>;
  COTYORT?: InputMaybe<Float8_Comparison_Exp>;
  COTYOTH?: InputMaybe<Float8_Comparison_Exp>;
  COTYPED?: InputMaybe<Float8_Comparison_Exp>;
  COTYPSY?: InputMaybe<Float8_Comparison_Exp>;
  COTYSUR?: InputMaybe<Float8_Comparison_Exp>;
  CPPCT?: InputMaybe<Float8_Comparison_Exp>;
  CSACODE?: InputMaybe<String_Comparison_Exp>;
  CSANAME?: InputMaybe<String_Comparison_Exp>;
  DCOV?: InputMaybe<Float8_Comparison_Exp>;
  DIVCODE?: InputMaybe<String_Comparison_Exp>;
  DIVNAME?: InputMaybe<String_Comparison_Exp>;
  DTBEG?: InputMaybe<Timestamp_Comparison_Exp>;
  DTEND?: InputMaybe<Timestamp_Comparison_Exp>;
  FAMADV?: InputMaybe<String_Comparison_Exp>;
  FCNTYCD?: InputMaybe<String_Comparison_Exp>;
  FCOUNTY?: InputMaybe<String_Comparison_Exp>;
  FISYR?: InputMaybe<Timestamp_Comparison_Exp>;
  FNDBN?: InputMaybe<String_Comparison_Exp>;
  FRTLN?: InputMaybe<Float8_Comparison_Exp>;
  FSTCD?: InputMaybe<String_Comparison_Exp>;
  FYR?: InputMaybe<String_Comparison_Exp>;
  GPOCITY?: InputMaybe<String_Comparison_Exp>;
  GPONAME?: InputMaybe<String_Comparison_Exp>;
  GPOST?: InputMaybe<String_Comparison_Exp>;
  GROUP?: InputMaybe<String_Comparison_Exp>;
  HHPLAN?: InputMaybe<String_Comparison_Exp>;
  HLINDK?: InputMaybe<String_Comparison_Exp>;
  HLINHOS?: InputMaybe<String_Comparison_Exp>;
  HLINN?: InputMaybe<String_Comparison_Exp>;
  HLINSYS?: InputMaybe<String_Comparison_Exp>;
  HLINVEN?: InputMaybe<String_Comparison_Exp>;
  HRRCODE?: InputMaybe<Int_Comparison_Exp>;
  HRRNAME?: InputMaybe<String_Comparison_Exp>;
  HSACODE?: InputMaybe<Int_Comparison_Exp>;
  HSANAME?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IINSPT?: InputMaybe<String_Comparison_Exp>;
  LAT?: InputMaybe<String_Comparison_Exp>;
  LGRPDK?: InputMaybe<String_Comparison_Exp>;
  LGRPHOS?: InputMaybe<String_Comparison_Exp>;
  LGRPN?: InputMaybe<String_Comparison_Exp>;
  LGRPSYS?: InputMaybe<String_Comparison_Exp>;
  LGRPVEN?: InputMaybe<String_Comparison_Exp>;
  LONG?: InputMaybe<String_Comparison_Exp>;
  LOS?: InputMaybe<String_Comparison_Exp>;
  LTCHC?: InputMaybe<String_Comparison_Exp>;
  LTCHF?: InputMaybe<String_Comparison_Exp>;
  LTCT?: InputMaybe<String_Comparison_Exp>;
  LTNM?: InputMaybe<String_Comparison_Exp>;
  LTST?: InputMaybe<String_Comparison_Exp>;
  MADMIN?: InputMaybe<String_Comparison_Exp>;
  MAPP1?: InputMaybe<String_Comparison_Exp>;
  MAPP2?: InputMaybe<String_Comparison_Exp>;
  MAPP3?: InputMaybe<String_Comparison_Exp>;
  MAPP5?: InputMaybe<String_Comparison_Exp>;
  MAPP7?: InputMaybe<String_Comparison_Exp>;
  MAPP8?: InputMaybe<String_Comparison_Exp>;
  MAPP10?: InputMaybe<String_Comparison_Exp>;
  MAPP11?: InputMaybe<String_Comparison_Exp>;
  MAPP16?: InputMaybe<String_Comparison_Exp>;
  MAPP18?: InputMaybe<String_Comparison_Exp>;
  MAPP19?: InputMaybe<String_Comparison_Exp>;
  MAPP20?: InputMaybe<String_Comparison_Exp>;
  MAPP21?: InputMaybe<String_Comparison_Exp>;
  MAPP22?: InputMaybe<String_Comparison_Exp>;
  MCNTYCD?: InputMaybe<String_Comparison_Exp>;
  MCRNUM?: InputMaybe<String_Comparison_Exp>;
  MEDADDK?: InputMaybe<String_Comparison_Exp>;
  MEDADHOS?: InputMaybe<String_Comparison_Exp>;
  MEDADN?: InputMaybe<String_Comparison_Exp>;
  MEDADSYS?: InputMaybe<String_Comparison_Exp>;
  MEDADVEN?: InputMaybe<String_Comparison_Exp>;
  MEDHME?: InputMaybe<String_Comparison_Exp>;
  MEDHSE?: InputMaybe<String_Comparison_Exp>;
  MHSMEMB?: InputMaybe<String_Comparison_Exp>;
  MLOCADDR?: InputMaybe<String_Comparison_Exp>;
  MLOCCITY?: InputMaybe<String_Comparison_Exp>;
  MLOCSTCD?: InputMaybe<String_Comparison_Exp>;
  MLOCZIP?: InputMaybe<String_Comparison_Exp>;
  MMCDK?: InputMaybe<String_Comparison_Exp>;
  MMCHOS?: InputMaybe<String_Comparison_Exp>;
  MMCN?: InputMaybe<String_Comparison_Exp>;
  MMCSYS?: InputMaybe<String_Comparison_Exp>;
  MMCVEN?: InputMaybe<String_Comparison_Exp>;
  MNAME?: InputMaybe<String_Comparison_Exp>;
  MNGT?: InputMaybe<String_Comparison_Exp>;
  MNGTCITY?: InputMaybe<String_Comparison_Exp>;
  MNGTNAME?: InputMaybe<String_Comparison_Exp>;
  MNGTSTCD?: InputMaybe<String_Comparison_Exp>;
  MSSP?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBA?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBB?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBC?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBD?: InputMaybe<Float8_Comparison_Exp>;
  MSSPBE?: InputMaybe<Float8_Comparison_Exp>;
  MSSPCE?: InputMaybe<Float8_Comparison_Exp>;
  MSSPTRK?: InputMaybe<Float8_Comparison_Exp>;
  MSTATE?: InputMaybe<String_Comparison_Exp>;
  NOPATH?: InputMaybe<Float8_Comparison_Exp>;
  OSMGDK?: InputMaybe<String_Comparison_Exp>;
  OSMGHOS?: InputMaybe<String_Comparison_Exp>;
  OSMGN?: InputMaybe<String_Comparison_Exp>;
  OSMGOTH?: InputMaybe<String_Comparison_Exp>;
  OSMGSYS?: InputMaybe<String_Comparison_Exp>;
  OSMGVEN?: InputMaybe<String_Comparison_Exp>;
  OTHIMDK?: InputMaybe<String_Comparison_Exp>;
  OTHIMHOS?: InputMaybe<String_Comparison_Exp>;
  OTHIMN?: InputMaybe<String_Comparison_Exp>;
  OTHIMSYS?: InputMaybe<String_Comparison_Exp>;
  OTHIMVEN?: InputMaybe<String_Comparison_Exp>;
  PBDPY?: InputMaybe<String_Comparison_Exp>;
  PHYGP?: InputMaybe<String_Comparison_Exp>;
  RADMCHI?: InputMaybe<String_Comparison_Exp>;
  RESP?: InputMaybe<String_Comparison_Exp>;
  RESPTC?: InputMaybe<Float8_Comparison_Exp>;
  SERV?: InputMaybe<String_Comparison_Exp>;
  SERVOTH?: InputMaybe<String_Comparison_Exp>;
  SLFPLN?: InputMaybe<String_Comparison_Exp>;
  SMGPDK?: InputMaybe<String_Comparison_Exp>;
  SMGRPHOS?: InputMaybe<String_Comparison_Exp>;
  SMGRPN?: InputMaybe<String_Comparison_Exp>;
  SMGRPSYS?: InputMaybe<String_Comparison_Exp>;
  SMGRPVEN?: InputMaybe<String_Comparison_Exp>;
  SPAH?: InputMaybe<Float8_Comparison_Exp>;
  SPLAN?: InputMaybe<String_Comparison_Exp>;
  SPTC?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUBS?: InputMaybe<String_Comparison_Exp>;
  SUNITS?: InputMaybe<String_Comparison_Exp>;
  SUPLY?: InputMaybe<String_Comparison_Exp>;
  SUPNM?: InputMaybe<String_Comparison_Exp>;
  SYSADDR?: InputMaybe<String_Comparison_Exp>;
  SYSAREA?: InputMaybe<String_Comparison_Exp>;
  SYSCITY?: InputMaybe<String_Comparison_Exp>;
  SYSID?: InputMaybe<String_Comparison_Exp>;
  SYSNAME?: InputMaybe<String_Comparison_Exp>;
  SYSST?: InputMaybe<String_Comparison_Exp>;
  SYSTELN?: InputMaybe<String_Comparison_Exp>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<String_Comparison_Exp>;
  SYSTITLE?: InputMaybe<String_Comparison_Exp>;
  SYSZIP?: InputMaybe<String_Comparison_Exp>;
  TELNO?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Dem_Bool_Exp>>;
  _not?: InputMaybe<As22Dem_Bool_Exp>;
  _or?: InputMaybe<Array<As22Dem_Bool_Exp>>;
  svc1?: InputMaybe<As22Svc1_Bool_Exp>;
  svc2?: InputMaybe<As22Svc2_Bool_Exp>;
  svc3?: InputMaybe<As22Svc3_Bool_Exp>;
  units?: InputMaybe<As22Unit_Bool_Exp>;
  units_aggregate?: InputMaybe<As22Unit_Aggregate_Bool_Exp>;
  util1?: InputMaybe<As22Util_Bool_Exp>;
  util2?: InputMaybe<As22Util2_Bool_Exp>;
};

/** unique or primary key constraints on table "AS22DEM" */
export enum As22Dem_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Dem = 'pk_AS22DEM'
}

/** input type for incrementing numeric columns in table "AS22DEM" */
export type As22Dem_Inc_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  BDGASCP?: InputMaybe<Scalars['float8']>;
  BDGASMA?: InputMaybe<Scalars['float8']>;
  BDGASMD?: InputMaybe<Scalars['float8']>;
  BDGASTM?: InputMaybe<Scalars['float8']>;
  BDGICCP?: InputMaybe<Scalars['float8']>;
  BDGICMA?: InputMaybe<Scalars['float8']>;
  BDGICMD?: InputMaybe<Scalars['float8']>;
  BDGICTM?: InputMaybe<Scalars['float8']>;
  BDHEMCP?: InputMaybe<Scalars['float8']>;
  BDHEMMA?: InputMaybe<Scalars['float8']>;
  BDHEMMD?: InputMaybe<Scalars['float8']>;
  BDHEMTM?: InputMaybe<Scalars['float8']>;
  BDHPLCP?: InputMaybe<Scalars['float8']>;
  BDHPLMA?: InputMaybe<Scalars['float8']>;
  BDHPLMD?: InputMaybe<Scalars['float8']>;
  BDHPLTM?: InputMaybe<Scalars['float8']>;
  BDINDCP?: InputMaybe<Scalars['float8']>;
  BDINDMA?: InputMaybe<Scalars['float8']>;
  BDINDMD?: InputMaybe<Scalars['float8']>;
  BDINDTM?: InputMaybe<Scalars['float8']>;
  BDLGYCP?: InputMaybe<Scalars['float8']>;
  BDLGYMA?: InputMaybe<Scalars['float8']>;
  BDLGYMD?: InputMaybe<Scalars['float8']>;
  BDLGYTM?: InputMaybe<Scalars['float8']>;
  BDNDOCP?: InputMaybe<Scalars['float8']>;
  BDNDOMA?: InputMaybe<Scalars['float8']>;
  BDNDOMD?: InputMaybe<Scalars['float8']>;
  BDNDOTM?: InputMaybe<Scalars['float8']>;
  BDNEPCP?: InputMaybe<Scalars['float8']>;
  BDNEPMA?: InputMaybe<Scalars['float8']>;
  BDNEPMD?: InputMaybe<Scalars['float8']>;
  BDNEPTM?: InputMaybe<Scalars['float8']>;
  BDNOBCP?: InputMaybe<Scalars['float8']>;
  BDNOBMA?: InputMaybe<Scalars['float8']>;
  BDNOBMD?: InputMaybe<Scalars['float8']>;
  BDNOBTM?: InputMaybe<Scalars['float8']>;
  BDPEDCP?: InputMaybe<Scalars['float8']>;
  BDPEDMA?: InputMaybe<Scalars['float8']>;
  BDPEDMD?: InputMaybe<Scalars['float8']>;
  BDPEDTM?: InputMaybe<Scalars['float8']>;
  BDPHDCP?: InputMaybe<Scalars['float8']>;
  BDPHDMA?: InputMaybe<Scalars['float8']>;
  BDPHDMD?: InputMaybe<Scalars['float8']>;
  BDPHDTM?: InputMaybe<Scalars['float8']>;
  BDPOTCP?: InputMaybe<Scalars['float8']>;
  BDPOTMA?: InputMaybe<Scalars['float8']>;
  BDPOTMD?: InputMaybe<Scalars['float8']>;
  BDPOTTM?: InputMaybe<Scalars['float8']>;
  BDPULCP?: InputMaybe<Scalars['float8']>;
  BDPULMA?: InputMaybe<Scalars['float8']>;
  BDPULMD?: InputMaybe<Scalars['float8']>;
  BDPULTM?: InputMaybe<Scalars['float8']>;
  BDSUBCP?: InputMaybe<Scalars['float8']>;
  BDSUBMA?: InputMaybe<Scalars['float8']>;
  BDSUBMD?: InputMaybe<Scalars['float8']>;
  BDSUBTM?: InputMaybe<Scalars['float8']>;
  BDVASCP?: InputMaybe<Scalars['float8']>;
  BDVASMA?: InputMaybe<Scalars['float8']>;
  BDVASMD?: InputMaybe<Scalars['float8']>;
  BDVASTM?: InputMaybe<Scalars['float8']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  NOPATH?: InputMaybe<Scalars['float8']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPTC?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS22DEM" */
export type As22Dem_Insert_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDGASCP?: InputMaybe<Scalars['float8']>;
  BDGASMA?: InputMaybe<Scalars['float8']>;
  BDGASMD?: InputMaybe<Scalars['float8']>;
  BDGASTM?: InputMaybe<Scalars['float8']>;
  BDGICCP?: InputMaybe<Scalars['float8']>;
  BDGICMA?: InputMaybe<Scalars['float8']>;
  BDGICMD?: InputMaybe<Scalars['float8']>;
  BDGICTM?: InputMaybe<Scalars['float8']>;
  BDHEMCP?: InputMaybe<Scalars['float8']>;
  BDHEMMA?: InputMaybe<Scalars['float8']>;
  BDHEMMD?: InputMaybe<Scalars['float8']>;
  BDHEMTM?: InputMaybe<Scalars['float8']>;
  BDHPLCP?: InputMaybe<Scalars['float8']>;
  BDHPLMA?: InputMaybe<Scalars['float8']>;
  BDHPLMD?: InputMaybe<Scalars['float8']>;
  BDHPLTM?: InputMaybe<Scalars['float8']>;
  BDINDCP?: InputMaybe<Scalars['float8']>;
  BDINDMA?: InputMaybe<Scalars['float8']>;
  BDINDMD?: InputMaybe<Scalars['float8']>;
  BDINDTM?: InputMaybe<Scalars['float8']>;
  BDLGYCP?: InputMaybe<Scalars['float8']>;
  BDLGYMA?: InputMaybe<Scalars['float8']>;
  BDLGYMD?: InputMaybe<Scalars['float8']>;
  BDLGYTM?: InputMaybe<Scalars['float8']>;
  BDNDOCP?: InputMaybe<Scalars['float8']>;
  BDNDOMA?: InputMaybe<Scalars['float8']>;
  BDNDOMD?: InputMaybe<Scalars['float8']>;
  BDNDOTM?: InputMaybe<Scalars['float8']>;
  BDNEPCP?: InputMaybe<Scalars['float8']>;
  BDNEPMA?: InputMaybe<Scalars['float8']>;
  BDNEPMD?: InputMaybe<Scalars['float8']>;
  BDNEPTM?: InputMaybe<Scalars['float8']>;
  BDNOBCP?: InputMaybe<Scalars['float8']>;
  BDNOBMA?: InputMaybe<Scalars['float8']>;
  BDNOBMD?: InputMaybe<Scalars['float8']>;
  BDNOBTM?: InputMaybe<Scalars['float8']>;
  BDPEDCP?: InputMaybe<Scalars['float8']>;
  BDPEDMA?: InputMaybe<Scalars['float8']>;
  BDPEDMD?: InputMaybe<Scalars['float8']>;
  BDPEDTM?: InputMaybe<Scalars['float8']>;
  BDPHDCP?: InputMaybe<Scalars['float8']>;
  BDPHDMA?: InputMaybe<Scalars['float8']>;
  BDPHDMD?: InputMaybe<Scalars['float8']>;
  BDPHDTM?: InputMaybe<Scalars['float8']>;
  BDPOTCP?: InputMaybe<Scalars['float8']>;
  BDPOTH?: InputMaybe<Scalars['String']>;
  BDPOTMA?: InputMaybe<Scalars['float8']>;
  BDPOTMD?: InputMaybe<Scalars['float8']>;
  BDPOTTM?: InputMaybe<Scalars['float8']>;
  BDPULCP?: InputMaybe<Scalars['float8']>;
  BDPULMA?: InputMaybe<Scalars['float8']>;
  BDPULMD?: InputMaybe<Scalars['float8']>;
  BDPULTM?: InputMaybe<Scalars['float8']>;
  BDSUBCP?: InputMaybe<Scalars['float8']>;
  BDSUBMA?: InputMaybe<Scalars['float8']>;
  BDSUBMD?: InputMaybe<Scalars['float8']>;
  BDSUBTM?: InputMaybe<Scalars['float8']>;
  BDVASCP?: InputMaybe<Scalars['float8']>;
  BDVASMA?: InputMaybe<Scalars['float8']>;
  BDVASMD?: InputMaybe<Scalars['float8']>;
  BDVASTM?: InputMaybe<Scalars['float8']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  NOPATH?: InputMaybe<Scalars['float8']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  PBDPY?: InputMaybe<Scalars['String']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  SPTC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
  svc1?: InputMaybe<As22Svc1_Obj_Rel_Insert_Input>;
  svc2?: InputMaybe<As22Svc2_Obj_Rel_Insert_Input>;
  svc3?: InputMaybe<As22Svc3_Obj_Rel_Insert_Input>;
  units?: InputMaybe<As22Unit_Arr_Rel_Insert_Input>;
  util1?: InputMaybe<As22Util_Obj_Rel_Insert_Input>;
  util2?: InputMaybe<As22Util2_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type As22Dem_Max_Fields = {
  __typename?: 'AS22DEM_max_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDGASCP: Maybe<Scalars['float8']>;
  BDGASMA: Maybe<Scalars['float8']>;
  BDGASMD: Maybe<Scalars['float8']>;
  BDGASTM: Maybe<Scalars['float8']>;
  BDGICCP: Maybe<Scalars['float8']>;
  BDGICMA: Maybe<Scalars['float8']>;
  BDGICMD: Maybe<Scalars['float8']>;
  BDGICTM: Maybe<Scalars['float8']>;
  BDHEMCP: Maybe<Scalars['float8']>;
  BDHEMMA: Maybe<Scalars['float8']>;
  BDHEMMD: Maybe<Scalars['float8']>;
  BDHEMTM: Maybe<Scalars['float8']>;
  BDHPLCP: Maybe<Scalars['float8']>;
  BDHPLMA: Maybe<Scalars['float8']>;
  BDHPLMD: Maybe<Scalars['float8']>;
  BDHPLTM: Maybe<Scalars['float8']>;
  BDINDCP: Maybe<Scalars['float8']>;
  BDINDMA: Maybe<Scalars['float8']>;
  BDINDMD: Maybe<Scalars['float8']>;
  BDINDTM: Maybe<Scalars['float8']>;
  BDLGYCP: Maybe<Scalars['float8']>;
  BDLGYMA: Maybe<Scalars['float8']>;
  BDLGYMD: Maybe<Scalars['float8']>;
  BDLGYTM: Maybe<Scalars['float8']>;
  BDNDOCP: Maybe<Scalars['float8']>;
  BDNDOMA: Maybe<Scalars['float8']>;
  BDNDOMD: Maybe<Scalars['float8']>;
  BDNDOTM: Maybe<Scalars['float8']>;
  BDNEPCP: Maybe<Scalars['float8']>;
  BDNEPMA: Maybe<Scalars['float8']>;
  BDNEPMD: Maybe<Scalars['float8']>;
  BDNEPTM: Maybe<Scalars['float8']>;
  BDNOBCP: Maybe<Scalars['float8']>;
  BDNOBMA: Maybe<Scalars['float8']>;
  BDNOBMD: Maybe<Scalars['float8']>;
  BDNOBTM: Maybe<Scalars['float8']>;
  BDPEDCP: Maybe<Scalars['float8']>;
  BDPEDMA: Maybe<Scalars['float8']>;
  BDPEDMD: Maybe<Scalars['float8']>;
  BDPEDTM: Maybe<Scalars['float8']>;
  BDPHDCP: Maybe<Scalars['float8']>;
  BDPHDMA: Maybe<Scalars['float8']>;
  BDPHDMD: Maybe<Scalars['float8']>;
  BDPHDTM: Maybe<Scalars['float8']>;
  BDPOTCP: Maybe<Scalars['float8']>;
  BDPOTH: Maybe<Scalars['String']>;
  BDPOTMA: Maybe<Scalars['float8']>;
  BDPOTMD: Maybe<Scalars['float8']>;
  BDPOTTM: Maybe<Scalars['float8']>;
  BDPULCP: Maybe<Scalars['float8']>;
  BDPULMA: Maybe<Scalars['float8']>;
  BDPULMD: Maybe<Scalars['float8']>;
  BDPULTM: Maybe<Scalars['float8']>;
  BDSUBCP: Maybe<Scalars['float8']>;
  BDSUBMA: Maybe<Scalars['float8']>;
  BDSUBMD: Maybe<Scalars['float8']>;
  BDSUBTM: Maybe<Scalars['float8']>;
  BDVASCP: Maybe<Scalars['float8']>;
  BDVASMA: Maybe<Scalars['float8']>;
  BDVASMD: Maybe<Scalars['float8']>;
  BDVASTM: Maybe<Scalars['float8']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FRTLN: Maybe<Scalars['float8']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IINSPT: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  NOPATH: Maybe<Scalars['float8']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  PBDPY: Maybe<Scalars['String']>;
  PHYGP: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  RESPTC: Maybe<Scalars['float8']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPAH: Maybe<Scalars['float8']>;
  SPLAN: Maybe<Scalars['String']>;
  SPTC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As22Dem_Min_Fields = {
  __typename?: 'AS22DEM_min_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOORG: Maybe<Scalars['String']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  AHAMBR: Maybe<Scalars['String']>;
  AREA: Maybe<Scalars['String']>;
  BDGASCP: Maybe<Scalars['float8']>;
  BDGASMA: Maybe<Scalars['float8']>;
  BDGASMD: Maybe<Scalars['float8']>;
  BDGASTM: Maybe<Scalars['float8']>;
  BDGICCP: Maybe<Scalars['float8']>;
  BDGICMA: Maybe<Scalars['float8']>;
  BDGICMD: Maybe<Scalars['float8']>;
  BDGICTM: Maybe<Scalars['float8']>;
  BDHEMCP: Maybe<Scalars['float8']>;
  BDHEMMA: Maybe<Scalars['float8']>;
  BDHEMMD: Maybe<Scalars['float8']>;
  BDHEMTM: Maybe<Scalars['float8']>;
  BDHPLCP: Maybe<Scalars['float8']>;
  BDHPLMA: Maybe<Scalars['float8']>;
  BDHPLMD: Maybe<Scalars['float8']>;
  BDHPLTM: Maybe<Scalars['float8']>;
  BDINDCP: Maybe<Scalars['float8']>;
  BDINDMA: Maybe<Scalars['float8']>;
  BDINDMD: Maybe<Scalars['float8']>;
  BDINDTM: Maybe<Scalars['float8']>;
  BDLGYCP: Maybe<Scalars['float8']>;
  BDLGYMA: Maybe<Scalars['float8']>;
  BDLGYMD: Maybe<Scalars['float8']>;
  BDLGYTM: Maybe<Scalars['float8']>;
  BDNDOCP: Maybe<Scalars['float8']>;
  BDNDOMA: Maybe<Scalars['float8']>;
  BDNDOMD: Maybe<Scalars['float8']>;
  BDNDOTM: Maybe<Scalars['float8']>;
  BDNEPCP: Maybe<Scalars['float8']>;
  BDNEPMA: Maybe<Scalars['float8']>;
  BDNEPMD: Maybe<Scalars['float8']>;
  BDNEPTM: Maybe<Scalars['float8']>;
  BDNOBCP: Maybe<Scalars['float8']>;
  BDNOBMA: Maybe<Scalars['float8']>;
  BDNOBMD: Maybe<Scalars['float8']>;
  BDNOBTM: Maybe<Scalars['float8']>;
  BDPEDCP: Maybe<Scalars['float8']>;
  BDPEDMA: Maybe<Scalars['float8']>;
  BDPEDMD: Maybe<Scalars['float8']>;
  BDPEDTM: Maybe<Scalars['float8']>;
  BDPHDCP: Maybe<Scalars['float8']>;
  BDPHDMA: Maybe<Scalars['float8']>;
  BDPHDMD: Maybe<Scalars['float8']>;
  BDPHDTM: Maybe<Scalars['float8']>;
  BDPOTCP: Maybe<Scalars['float8']>;
  BDPOTH: Maybe<Scalars['String']>;
  BDPOTMA: Maybe<Scalars['float8']>;
  BDPOTMD: Maybe<Scalars['float8']>;
  BDPOTTM: Maybe<Scalars['float8']>;
  BDPULCP: Maybe<Scalars['float8']>;
  BDPULMA: Maybe<Scalars['float8']>;
  BDPULMD: Maybe<Scalars['float8']>;
  BDPULTM: Maybe<Scalars['float8']>;
  BDSUBCP: Maybe<Scalars['float8']>;
  BDSUBMA: Maybe<Scalars['float8']>;
  BDSUBMD: Maybe<Scalars['float8']>;
  BDSUBTM: Maybe<Scalars['float8']>;
  BDVASCP: Maybe<Scalars['float8']>;
  BDVASMA: Maybe<Scalars['float8']>;
  BDVASMD: Maybe<Scalars['float8']>;
  BDVASTM: Maybe<Scalars['float8']>;
  BNDPAY: Maybe<Scalars['String']>;
  BNDPCT: Maybe<Scalars['float8']>;
  BNDRSK: Maybe<Scalars['String']>;
  BSC: Maybe<Scalars['String']>;
  CAPCON94: Maybe<Scalars['String']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CBSACODE: Maybe<Scalars['String']>;
  CBSANAME: Maybe<Scalars['String']>;
  CBSATYPE: Maybe<Scalars['String']>;
  CHC: Maybe<Scalars['String']>;
  CITYRK: Maybe<Scalars['String']>;
  CLUSTER: Maybe<Scalars['float8']>;
  CMRPAY: Maybe<Scalars['String']>;
  CNTRL: Maybe<Scalars['String']>;
  CNTYNAME: Maybe<Scalars['String']>;
  COHSP: Maybe<Scalars['String']>;
  COMMTY: Maybe<Scalars['String']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYDESC: Maybe<Scalars['String']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  CSACODE: Maybe<Scalars['String']>;
  CSANAME: Maybe<Scalars['String']>;
  DCOV: Maybe<Scalars['float8']>;
  DIVCODE: Maybe<Scalars['String']>;
  DIVNAME: Maybe<Scalars['String']>;
  DTBEG: Maybe<Scalars['timestamp']>;
  DTEND: Maybe<Scalars['timestamp']>;
  FAMADV: Maybe<Scalars['String']>;
  FCNTYCD: Maybe<Scalars['String']>;
  FCOUNTY: Maybe<Scalars['String']>;
  FISYR: Maybe<Scalars['timestamp']>;
  FNDBN: Maybe<Scalars['String']>;
  FRTLN: Maybe<Scalars['float8']>;
  FSTCD: Maybe<Scalars['String']>;
  FYR: Maybe<Scalars['String']>;
  GPOCITY: Maybe<Scalars['String']>;
  GPONAME: Maybe<Scalars['String']>;
  GPOST: Maybe<Scalars['String']>;
  GROUP: Maybe<Scalars['String']>;
  HHPLAN: Maybe<Scalars['String']>;
  HLINDK: Maybe<Scalars['String']>;
  HLINHOS: Maybe<Scalars['String']>;
  HLINN: Maybe<Scalars['String']>;
  HLINSYS: Maybe<Scalars['String']>;
  HLINVEN: Maybe<Scalars['String']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HRRNAME: Maybe<Scalars['String']>;
  HSACODE: Maybe<Scalars['Int']>;
  HSANAME: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IINSPT: Maybe<Scalars['String']>;
  LAT: Maybe<Scalars['String']>;
  LGRPDK: Maybe<Scalars['String']>;
  LGRPHOS: Maybe<Scalars['String']>;
  LGRPN: Maybe<Scalars['String']>;
  LGRPSYS: Maybe<Scalars['String']>;
  LGRPVEN: Maybe<Scalars['String']>;
  LONG: Maybe<Scalars['String']>;
  LOS: Maybe<Scalars['String']>;
  LTCHC: Maybe<Scalars['String']>;
  LTCHF: Maybe<Scalars['String']>;
  LTCT: Maybe<Scalars['String']>;
  LTNM: Maybe<Scalars['String']>;
  LTST: Maybe<Scalars['String']>;
  MADMIN: Maybe<Scalars['String']>;
  MAPP1: Maybe<Scalars['String']>;
  MAPP2: Maybe<Scalars['String']>;
  MAPP3: Maybe<Scalars['String']>;
  MAPP5: Maybe<Scalars['String']>;
  MAPP7: Maybe<Scalars['String']>;
  MAPP8: Maybe<Scalars['String']>;
  MAPP10: Maybe<Scalars['String']>;
  MAPP11: Maybe<Scalars['String']>;
  MAPP16: Maybe<Scalars['String']>;
  MAPP18: Maybe<Scalars['String']>;
  MAPP19: Maybe<Scalars['String']>;
  MAPP20: Maybe<Scalars['String']>;
  MAPP21: Maybe<Scalars['String']>;
  MAPP22: Maybe<Scalars['String']>;
  MCNTYCD: Maybe<Scalars['String']>;
  MCRNUM: Maybe<Scalars['String']>;
  MEDADDK: Maybe<Scalars['String']>;
  MEDADHOS: Maybe<Scalars['String']>;
  MEDADN: Maybe<Scalars['String']>;
  MEDADSYS: Maybe<Scalars['String']>;
  MEDADVEN: Maybe<Scalars['String']>;
  MEDHME: Maybe<Scalars['String']>;
  MEDHSE: Maybe<Scalars['String']>;
  MHSMEMB: Maybe<Scalars['String']>;
  MLOCADDR: Maybe<Scalars['String']>;
  MLOCCITY: Maybe<Scalars['String']>;
  MLOCSTCD: Maybe<Scalars['String']>;
  MLOCZIP: Maybe<Scalars['String']>;
  MMCDK: Maybe<Scalars['String']>;
  MMCHOS: Maybe<Scalars['String']>;
  MMCN: Maybe<Scalars['String']>;
  MMCSYS: Maybe<Scalars['String']>;
  MMCVEN: Maybe<Scalars['String']>;
  MNAME: Maybe<Scalars['String']>;
  MNGT: Maybe<Scalars['String']>;
  MNGTCITY: Maybe<Scalars['String']>;
  MNGTNAME: Maybe<Scalars['String']>;
  MNGTSTCD: Maybe<Scalars['String']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  MSTATE: Maybe<Scalars['String']>;
  NOPATH: Maybe<Scalars['float8']>;
  OSMGDK: Maybe<Scalars['String']>;
  OSMGHOS: Maybe<Scalars['String']>;
  OSMGN: Maybe<Scalars['String']>;
  OSMGOTH: Maybe<Scalars['String']>;
  OSMGSYS: Maybe<Scalars['String']>;
  OSMGVEN: Maybe<Scalars['String']>;
  OTHIMDK: Maybe<Scalars['String']>;
  OTHIMHOS: Maybe<Scalars['String']>;
  OTHIMN: Maybe<Scalars['String']>;
  OTHIMSYS: Maybe<Scalars['String']>;
  OTHIMVEN: Maybe<Scalars['String']>;
  PBDPY: Maybe<Scalars['String']>;
  PHYGP: Maybe<Scalars['String']>;
  RADMCHI: Maybe<Scalars['String']>;
  RESP: Maybe<Scalars['String']>;
  RESPTC: Maybe<Scalars['float8']>;
  SERV: Maybe<Scalars['String']>;
  SERVOTH: Maybe<Scalars['String']>;
  SLFPLN: Maybe<Scalars['String']>;
  SMGPDK: Maybe<Scalars['String']>;
  SMGRPHOS: Maybe<Scalars['String']>;
  SMGRPN: Maybe<Scalars['String']>;
  SMGRPSYS: Maybe<Scalars['String']>;
  SMGRPVEN: Maybe<Scalars['String']>;
  SPAH: Maybe<Scalars['float8']>;
  SPLAN: Maybe<Scalars['String']>;
  SPTC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUBS: Maybe<Scalars['String']>;
  SUNITS: Maybe<Scalars['String']>;
  SUPLY: Maybe<Scalars['String']>;
  SUPNM: Maybe<Scalars['String']>;
  SYSADDR: Maybe<Scalars['String']>;
  SYSAREA: Maybe<Scalars['String']>;
  SYSCITY: Maybe<Scalars['String']>;
  SYSID: Maybe<Scalars['String']>;
  SYSNAME: Maybe<Scalars['String']>;
  SYSST: Maybe<Scalars['String']>;
  SYSTELN: Maybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT: Maybe<Scalars['String']>;
  SYSTITLE: Maybe<Scalars['String']>;
  SYSZIP: Maybe<Scalars['String']>;
  TELNO: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS22DEM" */
export type As22Dem_Mutation_Response = {
  __typename?: 'AS22DEM_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Dem>;
};

/** input type for inserting object relation for remote table "AS22DEM" */
export type As22Dem_Obj_Rel_Insert_Input = {
  data: As22Dem_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Dem_On_Conflict>;
};

/** on_conflict condition type for table "AS22DEM" */
export type As22Dem_On_Conflict = {
  constraint: As22Dem_Constraint;
  update_columns?: Array<As22Dem_Update_Column>;
  where?: InputMaybe<As22Dem_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22DEM". */
export type As22Dem_Order_By = {
  ACOCN?: InputMaybe<Order_By>;
  ACOORG?: InputMaybe<Order_By>;
  ACOPCT?: InputMaybe<Order_By>;
  ACOTYPAD?: InputMaybe<Order_By>;
  ACOTYPCI?: InputMaybe<Order_By>;
  ACOTYPMD?: InputMaybe<Order_By>;
  ACOTYPT?: InputMaybe<Order_By>;
  AHAMBR?: InputMaybe<Order_By>;
  AREA?: InputMaybe<Order_By>;
  BDGASCP?: InputMaybe<Order_By>;
  BDGASMA?: InputMaybe<Order_By>;
  BDGASMD?: InputMaybe<Order_By>;
  BDGASTM?: InputMaybe<Order_By>;
  BDGICCP?: InputMaybe<Order_By>;
  BDGICMA?: InputMaybe<Order_By>;
  BDGICMD?: InputMaybe<Order_By>;
  BDGICTM?: InputMaybe<Order_By>;
  BDHEMCP?: InputMaybe<Order_By>;
  BDHEMMA?: InputMaybe<Order_By>;
  BDHEMMD?: InputMaybe<Order_By>;
  BDHEMTM?: InputMaybe<Order_By>;
  BDHPLCP?: InputMaybe<Order_By>;
  BDHPLMA?: InputMaybe<Order_By>;
  BDHPLMD?: InputMaybe<Order_By>;
  BDHPLTM?: InputMaybe<Order_By>;
  BDINDCP?: InputMaybe<Order_By>;
  BDINDMA?: InputMaybe<Order_By>;
  BDINDMD?: InputMaybe<Order_By>;
  BDINDTM?: InputMaybe<Order_By>;
  BDLGYCP?: InputMaybe<Order_By>;
  BDLGYMA?: InputMaybe<Order_By>;
  BDLGYMD?: InputMaybe<Order_By>;
  BDLGYTM?: InputMaybe<Order_By>;
  BDNDOCP?: InputMaybe<Order_By>;
  BDNDOMA?: InputMaybe<Order_By>;
  BDNDOMD?: InputMaybe<Order_By>;
  BDNDOTM?: InputMaybe<Order_By>;
  BDNEPCP?: InputMaybe<Order_By>;
  BDNEPMA?: InputMaybe<Order_By>;
  BDNEPMD?: InputMaybe<Order_By>;
  BDNEPTM?: InputMaybe<Order_By>;
  BDNOBCP?: InputMaybe<Order_By>;
  BDNOBMA?: InputMaybe<Order_By>;
  BDNOBMD?: InputMaybe<Order_By>;
  BDNOBTM?: InputMaybe<Order_By>;
  BDPEDCP?: InputMaybe<Order_By>;
  BDPEDMA?: InputMaybe<Order_By>;
  BDPEDMD?: InputMaybe<Order_By>;
  BDPEDTM?: InputMaybe<Order_By>;
  BDPHDCP?: InputMaybe<Order_By>;
  BDPHDMA?: InputMaybe<Order_By>;
  BDPHDMD?: InputMaybe<Order_By>;
  BDPHDTM?: InputMaybe<Order_By>;
  BDPOTCP?: InputMaybe<Order_By>;
  BDPOTH?: InputMaybe<Order_By>;
  BDPOTMA?: InputMaybe<Order_By>;
  BDPOTMD?: InputMaybe<Order_By>;
  BDPOTTM?: InputMaybe<Order_By>;
  BDPULCP?: InputMaybe<Order_By>;
  BDPULMA?: InputMaybe<Order_By>;
  BDPULMD?: InputMaybe<Order_By>;
  BDPULTM?: InputMaybe<Order_By>;
  BDSUBCP?: InputMaybe<Order_By>;
  BDSUBMA?: InputMaybe<Order_By>;
  BDSUBMD?: InputMaybe<Order_By>;
  BDSUBTM?: InputMaybe<Order_By>;
  BDVASCP?: InputMaybe<Order_By>;
  BDVASMA?: InputMaybe<Order_By>;
  BDVASMD?: InputMaybe<Order_By>;
  BDVASTM?: InputMaybe<Order_By>;
  BNDPAY?: InputMaybe<Order_By>;
  BNDPCT?: InputMaybe<Order_By>;
  BNDRSK?: InputMaybe<Order_By>;
  BSC?: InputMaybe<Order_By>;
  CAPCON94?: InputMaybe<Order_By>;
  CAPRSK?: InputMaybe<Order_By>;
  CBSACODE?: InputMaybe<Order_By>;
  CBSANAME?: InputMaybe<Order_By>;
  CBSATYPE?: InputMaybe<Order_By>;
  CHC?: InputMaybe<Order_By>;
  CITYRK?: InputMaybe<Order_By>;
  CLUSTER?: InputMaybe<Order_By>;
  CMRPAY?: InputMaybe<Order_By>;
  CNTRL?: InputMaybe<Order_By>;
  CNTYNAME?: InputMaybe<Order_By>;
  COHSP?: InputMaybe<Order_By>;
  COMMTY?: InputMaybe<Order_By>;
  COTYCAN?: InputMaybe<Order_By>;
  COTYCAR?: InputMaybe<Order_By>;
  COTYDESC?: InputMaybe<Order_By>;
  COTYORT?: InputMaybe<Order_By>;
  COTYOTH?: InputMaybe<Order_By>;
  COTYPED?: InputMaybe<Order_By>;
  COTYPSY?: InputMaybe<Order_By>;
  COTYSUR?: InputMaybe<Order_By>;
  CPPCT?: InputMaybe<Order_By>;
  CSACODE?: InputMaybe<Order_By>;
  CSANAME?: InputMaybe<Order_By>;
  DCOV?: InputMaybe<Order_By>;
  DIVCODE?: InputMaybe<Order_By>;
  DIVNAME?: InputMaybe<Order_By>;
  DTBEG?: InputMaybe<Order_By>;
  DTEND?: InputMaybe<Order_By>;
  FAMADV?: InputMaybe<Order_By>;
  FCNTYCD?: InputMaybe<Order_By>;
  FCOUNTY?: InputMaybe<Order_By>;
  FISYR?: InputMaybe<Order_By>;
  FNDBN?: InputMaybe<Order_By>;
  FRTLN?: InputMaybe<Order_By>;
  FSTCD?: InputMaybe<Order_By>;
  FYR?: InputMaybe<Order_By>;
  GPOCITY?: InputMaybe<Order_By>;
  GPONAME?: InputMaybe<Order_By>;
  GPOST?: InputMaybe<Order_By>;
  GROUP?: InputMaybe<Order_By>;
  HHPLAN?: InputMaybe<Order_By>;
  HLINDK?: InputMaybe<Order_By>;
  HLINHOS?: InputMaybe<Order_By>;
  HLINN?: InputMaybe<Order_By>;
  HLINSYS?: InputMaybe<Order_By>;
  HLINVEN?: InputMaybe<Order_By>;
  HRRCODE?: InputMaybe<Order_By>;
  HRRNAME?: InputMaybe<Order_By>;
  HSACODE?: InputMaybe<Order_By>;
  HSANAME?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IINSPT?: InputMaybe<Order_By>;
  LAT?: InputMaybe<Order_By>;
  LGRPDK?: InputMaybe<Order_By>;
  LGRPHOS?: InputMaybe<Order_By>;
  LGRPN?: InputMaybe<Order_By>;
  LGRPSYS?: InputMaybe<Order_By>;
  LGRPVEN?: InputMaybe<Order_By>;
  LONG?: InputMaybe<Order_By>;
  LOS?: InputMaybe<Order_By>;
  LTCHC?: InputMaybe<Order_By>;
  LTCHF?: InputMaybe<Order_By>;
  LTCT?: InputMaybe<Order_By>;
  LTNM?: InputMaybe<Order_By>;
  LTST?: InputMaybe<Order_By>;
  MADMIN?: InputMaybe<Order_By>;
  MAPP1?: InputMaybe<Order_By>;
  MAPP2?: InputMaybe<Order_By>;
  MAPP3?: InputMaybe<Order_By>;
  MAPP5?: InputMaybe<Order_By>;
  MAPP7?: InputMaybe<Order_By>;
  MAPP8?: InputMaybe<Order_By>;
  MAPP10?: InputMaybe<Order_By>;
  MAPP11?: InputMaybe<Order_By>;
  MAPP16?: InputMaybe<Order_By>;
  MAPP18?: InputMaybe<Order_By>;
  MAPP19?: InputMaybe<Order_By>;
  MAPP20?: InputMaybe<Order_By>;
  MAPP21?: InputMaybe<Order_By>;
  MAPP22?: InputMaybe<Order_By>;
  MCNTYCD?: InputMaybe<Order_By>;
  MCRNUM?: InputMaybe<Order_By>;
  MEDADDK?: InputMaybe<Order_By>;
  MEDADHOS?: InputMaybe<Order_By>;
  MEDADN?: InputMaybe<Order_By>;
  MEDADSYS?: InputMaybe<Order_By>;
  MEDADVEN?: InputMaybe<Order_By>;
  MEDHME?: InputMaybe<Order_By>;
  MEDHSE?: InputMaybe<Order_By>;
  MHSMEMB?: InputMaybe<Order_By>;
  MLOCADDR?: InputMaybe<Order_By>;
  MLOCCITY?: InputMaybe<Order_By>;
  MLOCSTCD?: InputMaybe<Order_By>;
  MLOCZIP?: InputMaybe<Order_By>;
  MMCDK?: InputMaybe<Order_By>;
  MMCHOS?: InputMaybe<Order_By>;
  MMCN?: InputMaybe<Order_By>;
  MMCSYS?: InputMaybe<Order_By>;
  MMCVEN?: InputMaybe<Order_By>;
  MNAME?: InputMaybe<Order_By>;
  MNGT?: InputMaybe<Order_By>;
  MNGTCITY?: InputMaybe<Order_By>;
  MNGTNAME?: InputMaybe<Order_By>;
  MNGTSTCD?: InputMaybe<Order_By>;
  MSSP?: InputMaybe<Order_By>;
  MSSPBA?: InputMaybe<Order_By>;
  MSSPBB?: InputMaybe<Order_By>;
  MSSPBC?: InputMaybe<Order_By>;
  MSSPBD?: InputMaybe<Order_By>;
  MSSPBE?: InputMaybe<Order_By>;
  MSSPCE?: InputMaybe<Order_By>;
  MSSPTRK?: InputMaybe<Order_By>;
  MSTATE?: InputMaybe<Order_By>;
  NOPATH?: InputMaybe<Order_By>;
  OSMGDK?: InputMaybe<Order_By>;
  OSMGHOS?: InputMaybe<Order_By>;
  OSMGN?: InputMaybe<Order_By>;
  OSMGOTH?: InputMaybe<Order_By>;
  OSMGSYS?: InputMaybe<Order_By>;
  OSMGVEN?: InputMaybe<Order_By>;
  OTHIMDK?: InputMaybe<Order_By>;
  OTHIMHOS?: InputMaybe<Order_By>;
  OTHIMN?: InputMaybe<Order_By>;
  OTHIMSYS?: InputMaybe<Order_By>;
  OTHIMVEN?: InputMaybe<Order_By>;
  PBDPY?: InputMaybe<Order_By>;
  PHYGP?: InputMaybe<Order_By>;
  RADMCHI?: InputMaybe<Order_By>;
  RESP?: InputMaybe<Order_By>;
  RESPTC?: InputMaybe<Order_By>;
  SERV?: InputMaybe<Order_By>;
  SERVOTH?: InputMaybe<Order_By>;
  SLFPLN?: InputMaybe<Order_By>;
  SMGPDK?: InputMaybe<Order_By>;
  SMGRPHOS?: InputMaybe<Order_By>;
  SMGRPN?: InputMaybe<Order_By>;
  SMGRPSYS?: InputMaybe<Order_By>;
  SMGRPVEN?: InputMaybe<Order_By>;
  SPAH?: InputMaybe<Order_By>;
  SPLAN?: InputMaybe<Order_By>;
  SPTC?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUBS?: InputMaybe<Order_By>;
  SUNITS?: InputMaybe<Order_By>;
  SUPLY?: InputMaybe<Order_By>;
  SUPNM?: InputMaybe<Order_By>;
  SYSADDR?: InputMaybe<Order_By>;
  SYSAREA?: InputMaybe<Order_By>;
  SYSCITY?: InputMaybe<Order_By>;
  SYSID?: InputMaybe<Order_By>;
  SYSNAME?: InputMaybe<Order_By>;
  SYSST?: InputMaybe<Order_By>;
  SYSTELN?: InputMaybe<Order_By>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Order_By>;
  SYSTITLE?: InputMaybe<Order_By>;
  SYSZIP?: InputMaybe<Order_By>;
  TELNO?: InputMaybe<Order_By>;
  svc1?: InputMaybe<As22Svc1_Order_By>;
  svc2?: InputMaybe<As22Svc2_Order_By>;
  svc3?: InputMaybe<As22Svc3_Order_By>;
  units_aggregate?: InputMaybe<As22Unit_Aggregate_Order_By>;
  util1?: InputMaybe<As22Util_Order_By>;
  util2?: InputMaybe<As22Util2_Order_By>;
};

/** primary key columns input for table: AS22DEM */
export type As22Dem_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22DEM" */
export enum As22Dem_Select_Column {
  /** column name */
  Acocn = 'ACOCN',
  /** column name */
  Acoorg = 'ACOORG',
  /** column name */
  Acopct = 'ACOPCT',
  /** column name */
  Acotypad = 'ACOTYPAD',
  /** column name */
  Acotypci = 'ACOTYPCI',
  /** column name */
  Acotypmd = 'ACOTYPMD',
  /** column name */
  Acotypt = 'ACOTYPT',
  /** column name */
  Ahambr = 'AHAMBR',
  /** column name */
  Area = 'AREA',
  /** column name */
  Bdgascp = 'BDGASCP',
  /** column name */
  Bdgasma = 'BDGASMA',
  /** column name */
  Bdgasmd = 'BDGASMD',
  /** column name */
  Bdgastm = 'BDGASTM',
  /** column name */
  Bdgiccp = 'BDGICCP',
  /** column name */
  Bdgicma = 'BDGICMA',
  /** column name */
  Bdgicmd = 'BDGICMD',
  /** column name */
  Bdgictm = 'BDGICTM',
  /** column name */
  Bdhemcp = 'BDHEMCP',
  /** column name */
  Bdhemma = 'BDHEMMA',
  /** column name */
  Bdhemmd = 'BDHEMMD',
  /** column name */
  Bdhemtm = 'BDHEMTM',
  /** column name */
  Bdhplcp = 'BDHPLCP',
  /** column name */
  Bdhplma = 'BDHPLMA',
  /** column name */
  Bdhplmd = 'BDHPLMD',
  /** column name */
  Bdhpltm = 'BDHPLTM',
  /** column name */
  Bdindcp = 'BDINDCP',
  /** column name */
  Bdindma = 'BDINDMA',
  /** column name */
  Bdindmd = 'BDINDMD',
  /** column name */
  Bdindtm = 'BDINDTM',
  /** column name */
  Bdlgycp = 'BDLGYCP',
  /** column name */
  Bdlgyma = 'BDLGYMA',
  /** column name */
  Bdlgymd = 'BDLGYMD',
  /** column name */
  Bdlgytm = 'BDLGYTM',
  /** column name */
  Bdndocp = 'BDNDOCP',
  /** column name */
  Bdndoma = 'BDNDOMA',
  /** column name */
  Bdndomd = 'BDNDOMD',
  /** column name */
  Bdndotm = 'BDNDOTM',
  /** column name */
  Bdnepcp = 'BDNEPCP',
  /** column name */
  Bdnepma = 'BDNEPMA',
  /** column name */
  Bdnepmd = 'BDNEPMD',
  /** column name */
  Bdneptm = 'BDNEPTM',
  /** column name */
  Bdnobcp = 'BDNOBCP',
  /** column name */
  Bdnobma = 'BDNOBMA',
  /** column name */
  Bdnobmd = 'BDNOBMD',
  /** column name */
  Bdnobtm = 'BDNOBTM',
  /** column name */
  Bdpedcp = 'BDPEDCP',
  /** column name */
  Bdpedma = 'BDPEDMA',
  /** column name */
  Bdpedmd = 'BDPEDMD',
  /** column name */
  Bdpedtm = 'BDPEDTM',
  /** column name */
  Bdphdcp = 'BDPHDCP',
  /** column name */
  Bdphdma = 'BDPHDMA',
  /** column name */
  Bdphdmd = 'BDPHDMD',
  /** column name */
  Bdphdtm = 'BDPHDTM',
  /** column name */
  Bdpotcp = 'BDPOTCP',
  /** column name */
  Bdpoth = 'BDPOTH',
  /** column name */
  Bdpotma = 'BDPOTMA',
  /** column name */
  Bdpotmd = 'BDPOTMD',
  /** column name */
  Bdpottm = 'BDPOTTM',
  /** column name */
  Bdpulcp = 'BDPULCP',
  /** column name */
  Bdpulma = 'BDPULMA',
  /** column name */
  Bdpulmd = 'BDPULMD',
  /** column name */
  Bdpultm = 'BDPULTM',
  /** column name */
  Bdsubcp = 'BDSUBCP',
  /** column name */
  Bdsubma = 'BDSUBMA',
  /** column name */
  Bdsubmd = 'BDSUBMD',
  /** column name */
  Bdsubtm = 'BDSUBTM',
  /** column name */
  Bdvascp = 'BDVASCP',
  /** column name */
  Bdvasma = 'BDVASMA',
  /** column name */
  Bdvasmd = 'BDVASMD',
  /** column name */
  Bdvastm = 'BDVASTM',
  /** column name */
  Bndpay = 'BNDPAY',
  /** column name */
  Bndpct = 'BNDPCT',
  /** column name */
  Bndrsk = 'BNDRSK',
  /** column name */
  Bsc = 'BSC',
  /** column name */
  Capcon94 = 'CAPCON94',
  /** column name */
  Caprsk = 'CAPRSK',
  /** column name */
  Cbsacode = 'CBSACODE',
  /** column name */
  Cbsaname = 'CBSANAME',
  /** column name */
  Cbsatype = 'CBSATYPE',
  /** column name */
  Chc = 'CHC',
  /** column name */
  Cityrk = 'CITYRK',
  /** column name */
  Cluster = 'CLUSTER',
  /** column name */
  Cmrpay = 'CMRPAY',
  /** column name */
  Cntrl = 'CNTRL',
  /** column name */
  Cntyname = 'CNTYNAME',
  /** column name */
  Cohsp = 'COHSP',
  /** column name */
  Commty = 'COMMTY',
  /** column name */
  Cotycan = 'COTYCAN',
  /** column name */
  Cotycar = 'COTYCAR',
  /** column name */
  Cotydesc = 'COTYDESC',
  /** column name */
  Cotyort = 'COTYORT',
  /** column name */
  Cotyoth = 'COTYOTH',
  /** column name */
  Cotyped = 'COTYPED',
  /** column name */
  Cotypsy = 'COTYPSY',
  /** column name */
  Cotysur = 'COTYSUR',
  /** column name */
  Cppct = 'CPPCT',
  /** column name */
  Csacode = 'CSACODE',
  /** column name */
  Csaname = 'CSANAME',
  /** column name */
  Dcov = 'DCOV',
  /** column name */
  Divcode = 'DIVCODE',
  /** column name */
  Divname = 'DIVNAME',
  /** column name */
  Dtbeg = 'DTBEG',
  /** column name */
  Dtend = 'DTEND',
  /** column name */
  Famadv = 'FAMADV',
  /** column name */
  Fcntycd = 'FCNTYCD',
  /** column name */
  Fcounty = 'FCOUNTY',
  /** column name */
  Fisyr = 'FISYR',
  /** column name */
  Fndbn = 'FNDBN',
  /** column name */
  Frtln = 'FRTLN',
  /** column name */
  Fstcd = 'FSTCD',
  /** column name */
  Fyr = 'FYR',
  /** column name */
  Gpocity = 'GPOCITY',
  /** column name */
  Gponame = 'GPONAME',
  /** column name */
  Gpost = 'GPOST',
  /** column name */
  Group = 'GROUP',
  /** column name */
  Hhplan = 'HHPLAN',
  /** column name */
  Hlindk = 'HLINDK',
  /** column name */
  Hlinhos = 'HLINHOS',
  /** column name */
  Hlinn = 'HLINN',
  /** column name */
  Hlinsys = 'HLINSYS',
  /** column name */
  Hlinven = 'HLINVEN',
  /** column name */
  Hrrcode = 'HRRCODE',
  /** column name */
  Hrrname = 'HRRNAME',
  /** column name */
  Hsacode = 'HSACODE',
  /** column name */
  Hsaname = 'HSANAME',
  /** column name */
  Id = 'ID',
  /** column name */
  Iinspt = 'IINSPT',
  /** column name */
  Lat = 'LAT',
  /** column name */
  Lgrpdk = 'LGRPDK',
  /** column name */
  Lgrphos = 'LGRPHOS',
  /** column name */
  Lgrpn = 'LGRPN',
  /** column name */
  Lgrpsys = 'LGRPSYS',
  /** column name */
  Lgrpven = 'LGRPVEN',
  /** column name */
  Long = 'LONG',
  /** column name */
  Los = 'LOS',
  /** column name */
  Ltchc = 'LTCHC',
  /** column name */
  Ltchf = 'LTCHF',
  /** column name */
  Ltct = 'LTCT',
  /** column name */
  Ltnm = 'LTNM',
  /** column name */
  Ltst = 'LTST',
  /** column name */
  Madmin = 'MADMIN',
  /** column name */
  Mapp1 = 'MAPP1',
  /** column name */
  Mapp2 = 'MAPP2',
  /** column name */
  Mapp3 = 'MAPP3',
  /** column name */
  Mapp5 = 'MAPP5',
  /** column name */
  Mapp7 = 'MAPP7',
  /** column name */
  Mapp8 = 'MAPP8',
  /** column name */
  Mapp10 = 'MAPP10',
  /** column name */
  Mapp11 = 'MAPP11',
  /** column name */
  Mapp16 = 'MAPP16',
  /** column name */
  Mapp18 = 'MAPP18',
  /** column name */
  Mapp19 = 'MAPP19',
  /** column name */
  Mapp20 = 'MAPP20',
  /** column name */
  Mapp21 = 'MAPP21',
  /** column name */
  Mapp22 = 'MAPP22',
  /** column name */
  Mcntycd = 'MCNTYCD',
  /** column name */
  Mcrnum = 'MCRNUM',
  /** column name */
  Medaddk = 'MEDADDK',
  /** column name */
  Medadhos = 'MEDADHOS',
  /** column name */
  Medadn = 'MEDADN',
  /** column name */
  Medadsys = 'MEDADSYS',
  /** column name */
  Medadven = 'MEDADVEN',
  /** column name */
  Medhme = 'MEDHME',
  /** column name */
  Medhse = 'MEDHSE',
  /** column name */
  Mhsmemb = 'MHSMEMB',
  /** column name */
  Mlocaddr = 'MLOCADDR',
  /** column name */
  Mloccity = 'MLOCCITY',
  /** column name */
  Mlocstcd = 'MLOCSTCD',
  /** column name */
  Mloczip = 'MLOCZIP',
  /** column name */
  Mmcdk = 'MMCDK',
  /** column name */
  Mmchos = 'MMCHOS',
  /** column name */
  Mmcn = 'MMCN',
  /** column name */
  Mmcsys = 'MMCSYS',
  /** column name */
  Mmcven = 'MMCVEN',
  /** column name */
  Mname = 'MNAME',
  /** column name */
  Mngt = 'MNGT',
  /** column name */
  Mngtcity = 'MNGTCITY',
  /** column name */
  Mngtname = 'MNGTNAME',
  /** column name */
  Mngtstcd = 'MNGTSTCD',
  /** column name */
  Mssp = 'MSSP',
  /** column name */
  Msspba = 'MSSPBA',
  /** column name */
  Msspbb = 'MSSPBB',
  /** column name */
  Msspbc = 'MSSPBC',
  /** column name */
  Msspbd = 'MSSPBD',
  /** column name */
  Msspbe = 'MSSPBE',
  /** column name */
  Msspce = 'MSSPCE',
  /** column name */
  Mssptrk = 'MSSPTRK',
  /** column name */
  Mstate = 'MSTATE',
  /** column name */
  Nopath = 'NOPATH',
  /** column name */
  Osmgdk = 'OSMGDK',
  /** column name */
  Osmghos = 'OSMGHOS',
  /** column name */
  Osmgn = 'OSMGN',
  /** column name */
  Osmgoth = 'OSMGOTH',
  /** column name */
  Osmgsys = 'OSMGSYS',
  /** column name */
  Osmgven = 'OSMGVEN',
  /** column name */
  Othimdk = 'OTHIMDK',
  /** column name */
  Othimhos = 'OTHIMHOS',
  /** column name */
  Othimn = 'OTHIMN',
  /** column name */
  Othimsys = 'OTHIMSYS',
  /** column name */
  Othimven = 'OTHIMVEN',
  /** column name */
  Pbdpy = 'PBDPY',
  /** column name */
  Phygp = 'PHYGP',
  /** column name */
  Radmchi = 'RADMCHI',
  /** column name */
  Resp = 'RESP',
  /** column name */
  Resptc = 'RESPTC',
  /** column name */
  Serv = 'SERV',
  /** column name */
  Servoth = 'SERVOTH',
  /** column name */
  Slfpln = 'SLFPLN',
  /** column name */
  Smgpdk = 'SMGPDK',
  /** column name */
  Smgrphos = 'SMGRPHOS',
  /** column name */
  Smgrpn = 'SMGRPN',
  /** column name */
  Smgrpsys = 'SMGRPSYS',
  /** column name */
  Smgrpven = 'SMGRPVEN',
  /** column name */
  Spah = 'SPAH',
  /** column name */
  Splan = 'SPLAN',
  /** column name */
  Sptc = 'SPTC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Subs = 'SUBS',
  /** column name */
  Sunits = 'SUNITS',
  /** column name */
  Suply = 'SUPLY',
  /** column name */
  Supnm = 'SUPNM',
  /** column name */
  Sysaddr = 'SYSADDR',
  /** column name */
  Sysarea = 'SYSAREA',
  /** column name */
  Syscity = 'SYSCITY',
  /** column name */
  Sysid = 'SYSID',
  /** column name */
  Sysname = 'SYSNAME',
  /** column name */
  Sysst = 'SYSST',
  /** column name */
  Systeln = 'SYSTELN',
  /** column name */
  SystemPrimaryContact = 'SYSTEM_PRIMARY_CONTACT',
  /** column name */
  Systitle = 'SYSTITLE',
  /** column name */
  Syszip = 'SYSZIP',
  /** column name */
  Telno = 'TELNO'
}

/** input type for updating data in table "AS22DEM" */
export type As22Dem_Set_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDGASCP?: InputMaybe<Scalars['float8']>;
  BDGASMA?: InputMaybe<Scalars['float8']>;
  BDGASMD?: InputMaybe<Scalars['float8']>;
  BDGASTM?: InputMaybe<Scalars['float8']>;
  BDGICCP?: InputMaybe<Scalars['float8']>;
  BDGICMA?: InputMaybe<Scalars['float8']>;
  BDGICMD?: InputMaybe<Scalars['float8']>;
  BDGICTM?: InputMaybe<Scalars['float8']>;
  BDHEMCP?: InputMaybe<Scalars['float8']>;
  BDHEMMA?: InputMaybe<Scalars['float8']>;
  BDHEMMD?: InputMaybe<Scalars['float8']>;
  BDHEMTM?: InputMaybe<Scalars['float8']>;
  BDHPLCP?: InputMaybe<Scalars['float8']>;
  BDHPLMA?: InputMaybe<Scalars['float8']>;
  BDHPLMD?: InputMaybe<Scalars['float8']>;
  BDHPLTM?: InputMaybe<Scalars['float8']>;
  BDINDCP?: InputMaybe<Scalars['float8']>;
  BDINDMA?: InputMaybe<Scalars['float8']>;
  BDINDMD?: InputMaybe<Scalars['float8']>;
  BDINDTM?: InputMaybe<Scalars['float8']>;
  BDLGYCP?: InputMaybe<Scalars['float8']>;
  BDLGYMA?: InputMaybe<Scalars['float8']>;
  BDLGYMD?: InputMaybe<Scalars['float8']>;
  BDLGYTM?: InputMaybe<Scalars['float8']>;
  BDNDOCP?: InputMaybe<Scalars['float8']>;
  BDNDOMA?: InputMaybe<Scalars['float8']>;
  BDNDOMD?: InputMaybe<Scalars['float8']>;
  BDNDOTM?: InputMaybe<Scalars['float8']>;
  BDNEPCP?: InputMaybe<Scalars['float8']>;
  BDNEPMA?: InputMaybe<Scalars['float8']>;
  BDNEPMD?: InputMaybe<Scalars['float8']>;
  BDNEPTM?: InputMaybe<Scalars['float8']>;
  BDNOBCP?: InputMaybe<Scalars['float8']>;
  BDNOBMA?: InputMaybe<Scalars['float8']>;
  BDNOBMD?: InputMaybe<Scalars['float8']>;
  BDNOBTM?: InputMaybe<Scalars['float8']>;
  BDPEDCP?: InputMaybe<Scalars['float8']>;
  BDPEDMA?: InputMaybe<Scalars['float8']>;
  BDPEDMD?: InputMaybe<Scalars['float8']>;
  BDPEDTM?: InputMaybe<Scalars['float8']>;
  BDPHDCP?: InputMaybe<Scalars['float8']>;
  BDPHDMA?: InputMaybe<Scalars['float8']>;
  BDPHDMD?: InputMaybe<Scalars['float8']>;
  BDPHDTM?: InputMaybe<Scalars['float8']>;
  BDPOTCP?: InputMaybe<Scalars['float8']>;
  BDPOTH?: InputMaybe<Scalars['String']>;
  BDPOTMA?: InputMaybe<Scalars['float8']>;
  BDPOTMD?: InputMaybe<Scalars['float8']>;
  BDPOTTM?: InputMaybe<Scalars['float8']>;
  BDPULCP?: InputMaybe<Scalars['float8']>;
  BDPULMA?: InputMaybe<Scalars['float8']>;
  BDPULMD?: InputMaybe<Scalars['float8']>;
  BDPULTM?: InputMaybe<Scalars['float8']>;
  BDSUBCP?: InputMaybe<Scalars['float8']>;
  BDSUBMA?: InputMaybe<Scalars['float8']>;
  BDSUBMD?: InputMaybe<Scalars['float8']>;
  BDSUBTM?: InputMaybe<Scalars['float8']>;
  BDVASCP?: InputMaybe<Scalars['float8']>;
  BDVASMA?: InputMaybe<Scalars['float8']>;
  BDVASMD?: InputMaybe<Scalars['float8']>;
  BDVASTM?: InputMaybe<Scalars['float8']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  NOPATH?: InputMaybe<Scalars['float8']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  PBDPY?: InputMaybe<Scalars['String']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  SPTC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As22Dem_Stddev_Fields = {
  __typename?: 'AS22DEM_stddev_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As22Dem_Stddev_Pop_Fields = {
  __typename?: 'AS22DEM_stddev_pop_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As22Dem_Stddev_Samp_Fields = {
  __typename?: 'AS22DEM_stddev_samp_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS22DEM" */
export type As22Dem_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Dem_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Dem_Stream_Cursor_Value_Input = {
  ACOCN?: InputMaybe<Scalars['float8']>;
  ACOORG?: InputMaybe<Scalars['String']>;
  ACOPCT?: InputMaybe<Scalars['float8']>;
  ACOTYPAD?: InputMaybe<Scalars['float8']>;
  ACOTYPCI?: InputMaybe<Scalars['float8']>;
  ACOTYPMD?: InputMaybe<Scalars['float8']>;
  ACOTYPT?: InputMaybe<Scalars['float8']>;
  AHAMBR?: InputMaybe<Scalars['String']>;
  AREA?: InputMaybe<Scalars['String']>;
  BDGASCP?: InputMaybe<Scalars['float8']>;
  BDGASMA?: InputMaybe<Scalars['float8']>;
  BDGASMD?: InputMaybe<Scalars['float8']>;
  BDGASTM?: InputMaybe<Scalars['float8']>;
  BDGICCP?: InputMaybe<Scalars['float8']>;
  BDGICMA?: InputMaybe<Scalars['float8']>;
  BDGICMD?: InputMaybe<Scalars['float8']>;
  BDGICTM?: InputMaybe<Scalars['float8']>;
  BDHEMCP?: InputMaybe<Scalars['float8']>;
  BDHEMMA?: InputMaybe<Scalars['float8']>;
  BDHEMMD?: InputMaybe<Scalars['float8']>;
  BDHEMTM?: InputMaybe<Scalars['float8']>;
  BDHPLCP?: InputMaybe<Scalars['float8']>;
  BDHPLMA?: InputMaybe<Scalars['float8']>;
  BDHPLMD?: InputMaybe<Scalars['float8']>;
  BDHPLTM?: InputMaybe<Scalars['float8']>;
  BDINDCP?: InputMaybe<Scalars['float8']>;
  BDINDMA?: InputMaybe<Scalars['float8']>;
  BDINDMD?: InputMaybe<Scalars['float8']>;
  BDINDTM?: InputMaybe<Scalars['float8']>;
  BDLGYCP?: InputMaybe<Scalars['float8']>;
  BDLGYMA?: InputMaybe<Scalars['float8']>;
  BDLGYMD?: InputMaybe<Scalars['float8']>;
  BDLGYTM?: InputMaybe<Scalars['float8']>;
  BDNDOCP?: InputMaybe<Scalars['float8']>;
  BDNDOMA?: InputMaybe<Scalars['float8']>;
  BDNDOMD?: InputMaybe<Scalars['float8']>;
  BDNDOTM?: InputMaybe<Scalars['float8']>;
  BDNEPCP?: InputMaybe<Scalars['float8']>;
  BDNEPMA?: InputMaybe<Scalars['float8']>;
  BDNEPMD?: InputMaybe<Scalars['float8']>;
  BDNEPTM?: InputMaybe<Scalars['float8']>;
  BDNOBCP?: InputMaybe<Scalars['float8']>;
  BDNOBMA?: InputMaybe<Scalars['float8']>;
  BDNOBMD?: InputMaybe<Scalars['float8']>;
  BDNOBTM?: InputMaybe<Scalars['float8']>;
  BDPEDCP?: InputMaybe<Scalars['float8']>;
  BDPEDMA?: InputMaybe<Scalars['float8']>;
  BDPEDMD?: InputMaybe<Scalars['float8']>;
  BDPEDTM?: InputMaybe<Scalars['float8']>;
  BDPHDCP?: InputMaybe<Scalars['float8']>;
  BDPHDMA?: InputMaybe<Scalars['float8']>;
  BDPHDMD?: InputMaybe<Scalars['float8']>;
  BDPHDTM?: InputMaybe<Scalars['float8']>;
  BDPOTCP?: InputMaybe<Scalars['float8']>;
  BDPOTH?: InputMaybe<Scalars['String']>;
  BDPOTMA?: InputMaybe<Scalars['float8']>;
  BDPOTMD?: InputMaybe<Scalars['float8']>;
  BDPOTTM?: InputMaybe<Scalars['float8']>;
  BDPULCP?: InputMaybe<Scalars['float8']>;
  BDPULMA?: InputMaybe<Scalars['float8']>;
  BDPULMD?: InputMaybe<Scalars['float8']>;
  BDPULTM?: InputMaybe<Scalars['float8']>;
  BDSUBCP?: InputMaybe<Scalars['float8']>;
  BDSUBMA?: InputMaybe<Scalars['float8']>;
  BDSUBMD?: InputMaybe<Scalars['float8']>;
  BDSUBTM?: InputMaybe<Scalars['float8']>;
  BDVASCP?: InputMaybe<Scalars['float8']>;
  BDVASMA?: InputMaybe<Scalars['float8']>;
  BDVASMD?: InputMaybe<Scalars['float8']>;
  BDVASTM?: InputMaybe<Scalars['float8']>;
  BNDPAY?: InputMaybe<Scalars['String']>;
  BNDPCT?: InputMaybe<Scalars['float8']>;
  BNDRSK?: InputMaybe<Scalars['String']>;
  BSC?: InputMaybe<Scalars['String']>;
  CAPCON94?: InputMaybe<Scalars['String']>;
  CAPRSK?: InputMaybe<Scalars['float8']>;
  CBSACODE?: InputMaybe<Scalars['String']>;
  CBSANAME?: InputMaybe<Scalars['String']>;
  CBSATYPE?: InputMaybe<Scalars['String']>;
  CHC?: InputMaybe<Scalars['String']>;
  CITYRK?: InputMaybe<Scalars['String']>;
  CLUSTER?: InputMaybe<Scalars['float8']>;
  CMRPAY?: InputMaybe<Scalars['String']>;
  CNTRL?: InputMaybe<Scalars['String']>;
  CNTYNAME?: InputMaybe<Scalars['String']>;
  COHSP?: InputMaybe<Scalars['String']>;
  COMMTY?: InputMaybe<Scalars['String']>;
  COTYCAN?: InputMaybe<Scalars['float8']>;
  COTYCAR?: InputMaybe<Scalars['float8']>;
  COTYDESC?: InputMaybe<Scalars['String']>;
  COTYORT?: InputMaybe<Scalars['float8']>;
  COTYOTH?: InputMaybe<Scalars['float8']>;
  COTYPED?: InputMaybe<Scalars['float8']>;
  COTYPSY?: InputMaybe<Scalars['float8']>;
  COTYSUR?: InputMaybe<Scalars['float8']>;
  CPPCT?: InputMaybe<Scalars['float8']>;
  CSACODE?: InputMaybe<Scalars['String']>;
  CSANAME?: InputMaybe<Scalars['String']>;
  DCOV?: InputMaybe<Scalars['float8']>;
  DIVCODE?: InputMaybe<Scalars['String']>;
  DIVNAME?: InputMaybe<Scalars['String']>;
  DTBEG?: InputMaybe<Scalars['timestamp']>;
  DTEND?: InputMaybe<Scalars['timestamp']>;
  FAMADV?: InputMaybe<Scalars['String']>;
  FCNTYCD?: InputMaybe<Scalars['String']>;
  FCOUNTY?: InputMaybe<Scalars['String']>;
  FISYR?: InputMaybe<Scalars['timestamp']>;
  FNDBN?: InputMaybe<Scalars['String']>;
  FRTLN?: InputMaybe<Scalars['float8']>;
  FSTCD?: InputMaybe<Scalars['String']>;
  FYR?: InputMaybe<Scalars['String']>;
  GPOCITY?: InputMaybe<Scalars['String']>;
  GPONAME?: InputMaybe<Scalars['String']>;
  GPOST?: InputMaybe<Scalars['String']>;
  GROUP?: InputMaybe<Scalars['String']>;
  HHPLAN?: InputMaybe<Scalars['String']>;
  HLINDK?: InputMaybe<Scalars['String']>;
  HLINHOS?: InputMaybe<Scalars['String']>;
  HLINN?: InputMaybe<Scalars['String']>;
  HLINSYS?: InputMaybe<Scalars['String']>;
  HLINVEN?: InputMaybe<Scalars['String']>;
  HRRCODE?: InputMaybe<Scalars['Int']>;
  HRRNAME?: InputMaybe<Scalars['String']>;
  HSACODE?: InputMaybe<Scalars['Int']>;
  HSANAME?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IINSPT?: InputMaybe<Scalars['String']>;
  LAT?: InputMaybe<Scalars['String']>;
  LGRPDK?: InputMaybe<Scalars['String']>;
  LGRPHOS?: InputMaybe<Scalars['String']>;
  LGRPN?: InputMaybe<Scalars['String']>;
  LGRPSYS?: InputMaybe<Scalars['String']>;
  LGRPVEN?: InputMaybe<Scalars['String']>;
  LONG?: InputMaybe<Scalars['String']>;
  LOS?: InputMaybe<Scalars['String']>;
  LTCHC?: InputMaybe<Scalars['String']>;
  LTCHF?: InputMaybe<Scalars['String']>;
  LTCT?: InputMaybe<Scalars['String']>;
  LTNM?: InputMaybe<Scalars['String']>;
  LTST?: InputMaybe<Scalars['String']>;
  MADMIN?: InputMaybe<Scalars['String']>;
  MAPP1?: InputMaybe<Scalars['String']>;
  MAPP2?: InputMaybe<Scalars['String']>;
  MAPP3?: InputMaybe<Scalars['String']>;
  MAPP5?: InputMaybe<Scalars['String']>;
  MAPP7?: InputMaybe<Scalars['String']>;
  MAPP8?: InputMaybe<Scalars['String']>;
  MAPP10?: InputMaybe<Scalars['String']>;
  MAPP11?: InputMaybe<Scalars['String']>;
  MAPP16?: InputMaybe<Scalars['String']>;
  MAPP18?: InputMaybe<Scalars['String']>;
  MAPP19?: InputMaybe<Scalars['String']>;
  MAPP20?: InputMaybe<Scalars['String']>;
  MAPP21?: InputMaybe<Scalars['String']>;
  MAPP22?: InputMaybe<Scalars['String']>;
  MCNTYCD?: InputMaybe<Scalars['String']>;
  MCRNUM?: InputMaybe<Scalars['String']>;
  MEDADDK?: InputMaybe<Scalars['String']>;
  MEDADHOS?: InputMaybe<Scalars['String']>;
  MEDADN?: InputMaybe<Scalars['String']>;
  MEDADSYS?: InputMaybe<Scalars['String']>;
  MEDADVEN?: InputMaybe<Scalars['String']>;
  MEDHME?: InputMaybe<Scalars['String']>;
  MEDHSE?: InputMaybe<Scalars['String']>;
  MHSMEMB?: InputMaybe<Scalars['String']>;
  MLOCADDR?: InputMaybe<Scalars['String']>;
  MLOCCITY?: InputMaybe<Scalars['String']>;
  MLOCSTCD?: InputMaybe<Scalars['String']>;
  MLOCZIP?: InputMaybe<Scalars['String']>;
  MMCDK?: InputMaybe<Scalars['String']>;
  MMCHOS?: InputMaybe<Scalars['String']>;
  MMCN?: InputMaybe<Scalars['String']>;
  MMCSYS?: InputMaybe<Scalars['String']>;
  MMCVEN?: InputMaybe<Scalars['String']>;
  MNAME?: InputMaybe<Scalars['String']>;
  MNGT?: InputMaybe<Scalars['String']>;
  MNGTCITY?: InputMaybe<Scalars['String']>;
  MNGTNAME?: InputMaybe<Scalars['String']>;
  MNGTSTCD?: InputMaybe<Scalars['String']>;
  MSSP?: InputMaybe<Scalars['float8']>;
  MSSPBA?: InputMaybe<Scalars['float8']>;
  MSSPBB?: InputMaybe<Scalars['float8']>;
  MSSPBC?: InputMaybe<Scalars['float8']>;
  MSSPBD?: InputMaybe<Scalars['float8']>;
  MSSPBE?: InputMaybe<Scalars['float8']>;
  MSSPCE?: InputMaybe<Scalars['float8']>;
  MSSPTRK?: InputMaybe<Scalars['float8']>;
  MSTATE?: InputMaybe<Scalars['String']>;
  NOPATH?: InputMaybe<Scalars['float8']>;
  OSMGDK?: InputMaybe<Scalars['String']>;
  OSMGHOS?: InputMaybe<Scalars['String']>;
  OSMGN?: InputMaybe<Scalars['String']>;
  OSMGOTH?: InputMaybe<Scalars['String']>;
  OSMGSYS?: InputMaybe<Scalars['String']>;
  OSMGVEN?: InputMaybe<Scalars['String']>;
  OTHIMDK?: InputMaybe<Scalars['String']>;
  OTHIMHOS?: InputMaybe<Scalars['String']>;
  OTHIMN?: InputMaybe<Scalars['String']>;
  OTHIMSYS?: InputMaybe<Scalars['String']>;
  OTHIMVEN?: InputMaybe<Scalars['String']>;
  PBDPY?: InputMaybe<Scalars['String']>;
  PHYGP?: InputMaybe<Scalars['String']>;
  RADMCHI?: InputMaybe<Scalars['String']>;
  RESP?: InputMaybe<Scalars['String']>;
  RESPTC?: InputMaybe<Scalars['float8']>;
  SERV?: InputMaybe<Scalars['String']>;
  SERVOTH?: InputMaybe<Scalars['String']>;
  SLFPLN?: InputMaybe<Scalars['String']>;
  SMGPDK?: InputMaybe<Scalars['String']>;
  SMGRPHOS?: InputMaybe<Scalars['String']>;
  SMGRPN?: InputMaybe<Scalars['String']>;
  SMGRPSYS?: InputMaybe<Scalars['String']>;
  SMGRPVEN?: InputMaybe<Scalars['String']>;
  SPAH?: InputMaybe<Scalars['float8']>;
  SPLAN?: InputMaybe<Scalars['String']>;
  SPTC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUBS?: InputMaybe<Scalars['String']>;
  SUNITS?: InputMaybe<Scalars['String']>;
  SUPLY?: InputMaybe<Scalars['String']>;
  SUPNM?: InputMaybe<Scalars['String']>;
  SYSADDR?: InputMaybe<Scalars['String']>;
  SYSAREA?: InputMaybe<Scalars['String']>;
  SYSCITY?: InputMaybe<Scalars['String']>;
  SYSID?: InputMaybe<Scalars['String']>;
  SYSNAME?: InputMaybe<Scalars['String']>;
  SYSST?: InputMaybe<Scalars['String']>;
  SYSTELN?: InputMaybe<Scalars['String']>;
  SYSTEM_PRIMARY_CONTACT?: InputMaybe<Scalars['String']>;
  SYSTITLE?: InputMaybe<Scalars['String']>;
  SYSZIP?: InputMaybe<Scalars['String']>;
  TELNO?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As22Dem_Sum_Fields = {
  __typename?: 'AS22DEM_sum_fields';
  ACOCN: Maybe<Scalars['float8']>;
  ACOPCT: Maybe<Scalars['float8']>;
  ACOTYPAD: Maybe<Scalars['float8']>;
  ACOTYPCI: Maybe<Scalars['float8']>;
  ACOTYPMD: Maybe<Scalars['float8']>;
  ACOTYPT: Maybe<Scalars['float8']>;
  BDGASCP: Maybe<Scalars['float8']>;
  BDGASMA: Maybe<Scalars['float8']>;
  BDGASMD: Maybe<Scalars['float8']>;
  BDGASTM: Maybe<Scalars['float8']>;
  BDGICCP: Maybe<Scalars['float8']>;
  BDGICMA: Maybe<Scalars['float8']>;
  BDGICMD: Maybe<Scalars['float8']>;
  BDGICTM: Maybe<Scalars['float8']>;
  BDHEMCP: Maybe<Scalars['float8']>;
  BDHEMMA: Maybe<Scalars['float8']>;
  BDHEMMD: Maybe<Scalars['float8']>;
  BDHEMTM: Maybe<Scalars['float8']>;
  BDHPLCP: Maybe<Scalars['float8']>;
  BDHPLMA: Maybe<Scalars['float8']>;
  BDHPLMD: Maybe<Scalars['float8']>;
  BDHPLTM: Maybe<Scalars['float8']>;
  BDINDCP: Maybe<Scalars['float8']>;
  BDINDMA: Maybe<Scalars['float8']>;
  BDINDMD: Maybe<Scalars['float8']>;
  BDINDTM: Maybe<Scalars['float8']>;
  BDLGYCP: Maybe<Scalars['float8']>;
  BDLGYMA: Maybe<Scalars['float8']>;
  BDLGYMD: Maybe<Scalars['float8']>;
  BDLGYTM: Maybe<Scalars['float8']>;
  BDNDOCP: Maybe<Scalars['float8']>;
  BDNDOMA: Maybe<Scalars['float8']>;
  BDNDOMD: Maybe<Scalars['float8']>;
  BDNDOTM: Maybe<Scalars['float8']>;
  BDNEPCP: Maybe<Scalars['float8']>;
  BDNEPMA: Maybe<Scalars['float8']>;
  BDNEPMD: Maybe<Scalars['float8']>;
  BDNEPTM: Maybe<Scalars['float8']>;
  BDNOBCP: Maybe<Scalars['float8']>;
  BDNOBMA: Maybe<Scalars['float8']>;
  BDNOBMD: Maybe<Scalars['float8']>;
  BDNOBTM: Maybe<Scalars['float8']>;
  BDPEDCP: Maybe<Scalars['float8']>;
  BDPEDMA: Maybe<Scalars['float8']>;
  BDPEDMD: Maybe<Scalars['float8']>;
  BDPEDTM: Maybe<Scalars['float8']>;
  BDPHDCP: Maybe<Scalars['float8']>;
  BDPHDMA: Maybe<Scalars['float8']>;
  BDPHDMD: Maybe<Scalars['float8']>;
  BDPHDTM: Maybe<Scalars['float8']>;
  BDPOTCP: Maybe<Scalars['float8']>;
  BDPOTMA: Maybe<Scalars['float8']>;
  BDPOTMD: Maybe<Scalars['float8']>;
  BDPOTTM: Maybe<Scalars['float8']>;
  BDPULCP: Maybe<Scalars['float8']>;
  BDPULMA: Maybe<Scalars['float8']>;
  BDPULMD: Maybe<Scalars['float8']>;
  BDPULTM: Maybe<Scalars['float8']>;
  BDSUBCP: Maybe<Scalars['float8']>;
  BDSUBMA: Maybe<Scalars['float8']>;
  BDSUBMD: Maybe<Scalars['float8']>;
  BDSUBTM: Maybe<Scalars['float8']>;
  BDVASCP: Maybe<Scalars['float8']>;
  BDVASMA: Maybe<Scalars['float8']>;
  BDVASMD: Maybe<Scalars['float8']>;
  BDVASTM: Maybe<Scalars['float8']>;
  BNDPCT: Maybe<Scalars['float8']>;
  CAPRSK: Maybe<Scalars['float8']>;
  CLUSTER: Maybe<Scalars['float8']>;
  COTYCAN: Maybe<Scalars['float8']>;
  COTYCAR: Maybe<Scalars['float8']>;
  COTYORT: Maybe<Scalars['float8']>;
  COTYOTH: Maybe<Scalars['float8']>;
  COTYPED: Maybe<Scalars['float8']>;
  COTYPSY: Maybe<Scalars['float8']>;
  COTYSUR: Maybe<Scalars['float8']>;
  CPPCT: Maybe<Scalars['float8']>;
  DCOV: Maybe<Scalars['float8']>;
  FRTLN: Maybe<Scalars['float8']>;
  HRRCODE: Maybe<Scalars['Int']>;
  HSACODE: Maybe<Scalars['Int']>;
  MSSP: Maybe<Scalars['float8']>;
  MSSPBA: Maybe<Scalars['float8']>;
  MSSPBB: Maybe<Scalars['float8']>;
  MSSPBC: Maybe<Scalars['float8']>;
  MSSPBD: Maybe<Scalars['float8']>;
  MSSPBE: Maybe<Scalars['float8']>;
  MSSPCE: Maybe<Scalars['float8']>;
  MSSPTRK: Maybe<Scalars['float8']>;
  NOPATH: Maybe<Scalars['float8']>;
  RESPTC: Maybe<Scalars['float8']>;
  SPAH: Maybe<Scalars['float8']>;
  SPTC: Maybe<Scalars['float8']>;
};

/** update columns of table "AS22DEM" */
export enum As22Dem_Update_Column {
  /** column name */
  Acocn = 'ACOCN',
  /** column name */
  Acoorg = 'ACOORG',
  /** column name */
  Acopct = 'ACOPCT',
  /** column name */
  Acotypad = 'ACOTYPAD',
  /** column name */
  Acotypci = 'ACOTYPCI',
  /** column name */
  Acotypmd = 'ACOTYPMD',
  /** column name */
  Acotypt = 'ACOTYPT',
  /** column name */
  Ahambr = 'AHAMBR',
  /** column name */
  Area = 'AREA',
  /** column name */
  Bdgascp = 'BDGASCP',
  /** column name */
  Bdgasma = 'BDGASMA',
  /** column name */
  Bdgasmd = 'BDGASMD',
  /** column name */
  Bdgastm = 'BDGASTM',
  /** column name */
  Bdgiccp = 'BDGICCP',
  /** column name */
  Bdgicma = 'BDGICMA',
  /** column name */
  Bdgicmd = 'BDGICMD',
  /** column name */
  Bdgictm = 'BDGICTM',
  /** column name */
  Bdhemcp = 'BDHEMCP',
  /** column name */
  Bdhemma = 'BDHEMMA',
  /** column name */
  Bdhemmd = 'BDHEMMD',
  /** column name */
  Bdhemtm = 'BDHEMTM',
  /** column name */
  Bdhplcp = 'BDHPLCP',
  /** column name */
  Bdhplma = 'BDHPLMA',
  /** column name */
  Bdhplmd = 'BDHPLMD',
  /** column name */
  Bdhpltm = 'BDHPLTM',
  /** column name */
  Bdindcp = 'BDINDCP',
  /** column name */
  Bdindma = 'BDINDMA',
  /** column name */
  Bdindmd = 'BDINDMD',
  /** column name */
  Bdindtm = 'BDINDTM',
  /** column name */
  Bdlgycp = 'BDLGYCP',
  /** column name */
  Bdlgyma = 'BDLGYMA',
  /** column name */
  Bdlgymd = 'BDLGYMD',
  /** column name */
  Bdlgytm = 'BDLGYTM',
  /** column name */
  Bdndocp = 'BDNDOCP',
  /** column name */
  Bdndoma = 'BDNDOMA',
  /** column name */
  Bdndomd = 'BDNDOMD',
  /** column name */
  Bdndotm = 'BDNDOTM',
  /** column name */
  Bdnepcp = 'BDNEPCP',
  /** column name */
  Bdnepma = 'BDNEPMA',
  /** column name */
  Bdnepmd = 'BDNEPMD',
  /** column name */
  Bdneptm = 'BDNEPTM',
  /** column name */
  Bdnobcp = 'BDNOBCP',
  /** column name */
  Bdnobma = 'BDNOBMA',
  /** column name */
  Bdnobmd = 'BDNOBMD',
  /** column name */
  Bdnobtm = 'BDNOBTM',
  /** column name */
  Bdpedcp = 'BDPEDCP',
  /** column name */
  Bdpedma = 'BDPEDMA',
  /** column name */
  Bdpedmd = 'BDPEDMD',
  /** column name */
  Bdpedtm = 'BDPEDTM',
  /** column name */
  Bdphdcp = 'BDPHDCP',
  /** column name */
  Bdphdma = 'BDPHDMA',
  /** column name */
  Bdphdmd = 'BDPHDMD',
  /** column name */
  Bdphdtm = 'BDPHDTM',
  /** column name */
  Bdpotcp = 'BDPOTCP',
  /** column name */
  Bdpoth = 'BDPOTH',
  /** column name */
  Bdpotma = 'BDPOTMA',
  /** column name */
  Bdpotmd = 'BDPOTMD',
  /** column name */
  Bdpottm = 'BDPOTTM',
  /** column name */
  Bdpulcp = 'BDPULCP',
  /** column name */
  Bdpulma = 'BDPULMA',
  /** column name */
  Bdpulmd = 'BDPULMD',
  /** column name */
  Bdpultm = 'BDPULTM',
  /** column name */
  Bdsubcp = 'BDSUBCP',
  /** column name */
  Bdsubma = 'BDSUBMA',
  /** column name */
  Bdsubmd = 'BDSUBMD',
  /** column name */
  Bdsubtm = 'BDSUBTM',
  /** column name */
  Bdvascp = 'BDVASCP',
  /** column name */
  Bdvasma = 'BDVASMA',
  /** column name */
  Bdvasmd = 'BDVASMD',
  /** column name */
  Bdvastm = 'BDVASTM',
  /** column name */
  Bndpay = 'BNDPAY',
  /** column name */
  Bndpct = 'BNDPCT',
  /** column name */
  Bndrsk = 'BNDRSK',
  /** column name */
  Bsc = 'BSC',
  /** column name */
  Capcon94 = 'CAPCON94',
  /** column name */
  Caprsk = 'CAPRSK',
  /** column name */
  Cbsacode = 'CBSACODE',
  /** column name */
  Cbsaname = 'CBSANAME',
  /** column name */
  Cbsatype = 'CBSATYPE',
  /** column name */
  Chc = 'CHC',
  /** column name */
  Cityrk = 'CITYRK',
  /** column name */
  Cluster = 'CLUSTER',
  /** column name */
  Cmrpay = 'CMRPAY',
  /** column name */
  Cntrl = 'CNTRL',
  /** column name */
  Cntyname = 'CNTYNAME',
  /** column name */
  Cohsp = 'COHSP',
  /** column name */
  Commty = 'COMMTY',
  /** column name */
  Cotycan = 'COTYCAN',
  /** column name */
  Cotycar = 'COTYCAR',
  /** column name */
  Cotydesc = 'COTYDESC',
  /** column name */
  Cotyort = 'COTYORT',
  /** column name */
  Cotyoth = 'COTYOTH',
  /** column name */
  Cotyped = 'COTYPED',
  /** column name */
  Cotypsy = 'COTYPSY',
  /** column name */
  Cotysur = 'COTYSUR',
  /** column name */
  Cppct = 'CPPCT',
  /** column name */
  Csacode = 'CSACODE',
  /** column name */
  Csaname = 'CSANAME',
  /** column name */
  Dcov = 'DCOV',
  /** column name */
  Divcode = 'DIVCODE',
  /** column name */
  Divname = 'DIVNAME',
  /** column name */
  Dtbeg = 'DTBEG',
  /** column name */
  Dtend = 'DTEND',
  /** column name */
  Famadv = 'FAMADV',
  /** column name */
  Fcntycd = 'FCNTYCD',
  /** column name */
  Fcounty = 'FCOUNTY',
  /** column name */
  Fisyr = 'FISYR',
  /** column name */
  Fndbn = 'FNDBN',
  /** column name */
  Frtln = 'FRTLN',
  /** column name */
  Fstcd = 'FSTCD',
  /** column name */
  Fyr = 'FYR',
  /** column name */
  Gpocity = 'GPOCITY',
  /** column name */
  Gponame = 'GPONAME',
  /** column name */
  Gpost = 'GPOST',
  /** column name */
  Group = 'GROUP',
  /** column name */
  Hhplan = 'HHPLAN',
  /** column name */
  Hlindk = 'HLINDK',
  /** column name */
  Hlinhos = 'HLINHOS',
  /** column name */
  Hlinn = 'HLINN',
  /** column name */
  Hlinsys = 'HLINSYS',
  /** column name */
  Hlinven = 'HLINVEN',
  /** column name */
  Hrrcode = 'HRRCODE',
  /** column name */
  Hrrname = 'HRRNAME',
  /** column name */
  Hsacode = 'HSACODE',
  /** column name */
  Hsaname = 'HSANAME',
  /** column name */
  Id = 'ID',
  /** column name */
  Iinspt = 'IINSPT',
  /** column name */
  Lat = 'LAT',
  /** column name */
  Lgrpdk = 'LGRPDK',
  /** column name */
  Lgrphos = 'LGRPHOS',
  /** column name */
  Lgrpn = 'LGRPN',
  /** column name */
  Lgrpsys = 'LGRPSYS',
  /** column name */
  Lgrpven = 'LGRPVEN',
  /** column name */
  Long = 'LONG',
  /** column name */
  Los = 'LOS',
  /** column name */
  Ltchc = 'LTCHC',
  /** column name */
  Ltchf = 'LTCHF',
  /** column name */
  Ltct = 'LTCT',
  /** column name */
  Ltnm = 'LTNM',
  /** column name */
  Ltst = 'LTST',
  /** column name */
  Madmin = 'MADMIN',
  /** column name */
  Mapp1 = 'MAPP1',
  /** column name */
  Mapp2 = 'MAPP2',
  /** column name */
  Mapp3 = 'MAPP3',
  /** column name */
  Mapp5 = 'MAPP5',
  /** column name */
  Mapp7 = 'MAPP7',
  /** column name */
  Mapp8 = 'MAPP8',
  /** column name */
  Mapp10 = 'MAPP10',
  /** column name */
  Mapp11 = 'MAPP11',
  /** column name */
  Mapp16 = 'MAPP16',
  /** column name */
  Mapp18 = 'MAPP18',
  /** column name */
  Mapp19 = 'MAPP19',
  /** column name */
  Mapp20 = 'MAPP20',
  /** column name */
  Mapp21 = 'MAPP21',
  /** column name */
  Mapp22 = 'MAPP22',
  /** column name */
  Mcntycd = 'MCNTYCD',
  /** column name */
  Mcrnum = 'MCRNUM',
  /** column name */
  Medaddk = 'MEDADDK',
  /** column name */
  Medadhos = 'MEDADHOS',
  /** column name */
  Medadn = 'MEDADN',
  /** column name */
  Medadsys = 'MEDADSYS',
  /** column name */
  Medadven = 'MEDADVEN',
  /** column name */
  Medhme = 'MEDHME',
  /** column name */
  Medhse = 'MEDHSE',
  /** column name */
  Mhsmemb = 'MHSMEMB',
  /** column name */
  Mlocaddr = 'MLOCADDR',
  /** column name */
  Mloccity = 'MLOCCITY',
  /** column name */
  Mlocstcd = 'MLOCSTCD',
  /** column name */
  Mloczip = 'MLOCZIP',
  /** column name */
  Mmcdk = 'MMCDK',
  /** column name */
  Mmchos = 'MMCHOS',
  /** column name */
  Mmcn = 'MMCN',
  /** column name */
  Mmcsys = 'MMCSYS',
  /** column name */
  Mmcven = 'MMCVEN',
  /** column name */
  Mname = 'MNAME',
  /** column name */
  Mngt = 'MNGT',
  /** column name */
  Mngtcity = 'MNGTCITY',
  /** column name */
  Mngtname = 'MNGTNAME',
  /** column name */
  Mngtstcd = 'MNGTSTCD',
  /** column name */
  Mssp = 'MSSP',
  /** column name */
  Msspba = 'MSSPBA',
  /** column name */
  Msspbb = 'MSSPBB',
  /** column name */
  Msspbc = 'MSSPBC',
  /** column name */
  Msspbd = 'MSSPBD',
  /** column name */
  Msspbe = 'MSSPBE',
  /** column name */
  Msspce = 'MSSPCE',
  /** column name */
  Mssptrk = 'MSSPTRK',
  /** column name */
  Mstate = 'MSTATE',
  /** column name */
  Nopath = 'NOPATH',
  /** column name */
  Osmgdk = 'OSMGDK',
  /** column name */
  Osmghos = 'OSMGHOS',
  /** column name */
  Osmgn = 'OSMGN',
  /** column name */
  Osmgoth = 'OSMGOTH',
  /** column name */
  Osmgsys = 'OSMGSYS',
  /** column name */
  Osmgven = 'OSMGVEN',
  /** column name */
  Othimdk = 'OTHIMDK',
  /** column name */
  Othimhos = 'OTHIMHOS',
  /** column name */
  Othimn = 'OTHIMN',
  /** column name */
  Othimsys = 'OTHIMSYS',
  /** column name */
  Othimven = 'OTHIMVEN',
  /** column name */
  Pbdpy = 'PBDPY',
  /** column name */
  Phygp = 'PHYGP',
  /** column name */
  Radmchi = 'RADMCHI',
  /** column name */
  Resp = 'RESP',
  /** column name */
  Resptc = 'RESPTC',
  /** column name */
  Serv = 'SERV',
  /** column name */
  Servoth = 'SERVOTH',
  /** column name */
  Slfpln = 'SLFPLN',
  /** column name */
  Smgpdk = 'SMGPDK',
  /** column name */
  Smgrphos = 'SMGRPHOS',
  /** column name */
  Smgrpn = 'SMGRPN',
  /** column name */
  Smgrpsys = 'SMGRPSYS',
  /** column name */
  Smgrpven = 'SMGRPVEN',
  /** column name */
  Spah = 'SPAH',
  /** column name */
  Splan = 'SPLAN',
  /** column name */
  Sptc = 'SPTC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Subs = 'SUBS',
  /** column name */
  Sunits = 'SUNITS',
  /** column name */
  Suply = 'SUPLY',
  /** column name */
  Supnm = 'SUPNM',
  /** column name */
  Sysaddr = 'SYSADDR',
  /** column name */
  Sysarea = 'SYSAREA',
  /** column name */
  Syscity = 'SYSCITY',
  /** column name */
  Sysid = 'SYSID',
  /** column name */
  Sysname = 'SYSNAME',
  /** column name */
  Sysst = 'SYSST',
  /** column name */
  Systeln = 'SYSTELN',
  /** column name */
  SystemPrimaryContact = 'SYSTEM_PRIMARY_CONTACT',
  /** column name */
  Systitle = 'SYSTITLE',
  /** column name */
  Syszip = 'SYSZIP',
  /** column name */
  Telno = 'TELNO'
}

export type As22Dem_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As22Dem_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Dem_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Dem_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As22Dem_Var_Pop_Fields = {
  __typename?: 'AS22DEM_var_pop_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As22Dem_Var_Samp_Fields = {
  __typename?: 'AS22DEM_var_samp_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As22Dem_Variance_Fields = {
  __typename?: 'AS22DEM_variance_fields';
  ACOCN: Maybe<Scalars['Float']>;
  ACOPCT: Maybe<Scalars['Float']>;
  ACOTYPAD: Maybe<Scalars['Float']>;
  ACOTYPCI: Maybe<Scalars['Float']>;
  ACOTYPMD: Maybe<Scalars['Float']>;
  ACOTYPT: Maybe<Scalars['Float']>;
  BDGASCP: Maybe<Scalars['Float']>;
  BDGASMA: Maybe<Scalars['Float']>;
  BDGASMD: Maybe<Scalars['Float']>;
  BDGASTM: Maybe<Scalars['Float']>;
  BDGICCP: Maybe<Scalars['Float']>;
  BDGICMA: Maybe<Scalars['Float']>;
  BDGICMD: Maybe<Scalars['Float']>;
  BDGICTM: Maybe<Scalars['Float']>;
  BDHEMCP: Maybe<Scalars['Float']>;
  BDHEMMA: Maybe<Scalars['Float']>;
  BDHEMMD: Maybe<Scalars['Float']>;
  BDHEMTM: Maybe<Scalars['Float']>;
  BDHPLCP: Maybe<Scalars['Float']>;
  BDHPLMA: Maybe<Scalars['Float']>;
  BDHPLMD: Maybe<Scalars['Float']>;
  BDHPLTM: Maybe<Scalars['Float']>;
  BDINDCP: Maybe<Scalars['Float']>;
  BDINDMA: Maybe<Scalars['Float']>;
  BDINDMD: Maybe<Scalars['Float']>;
  BDINDTM: Maybe<Scalars['Float']>;
  BDLGYCP: Maybe<Scalars['Float']>;
  BDLGYMA: Maybe<Scalars['Float']>;
  BDLGYMD: Maybe<Scalars['Float']>;
  BDLGYTM: Maybe<Scalars['Float']>;
  BDNDOCP: Maybe<Scalars['Float']>;
  BDNDOMA: Maybe<Scalars['Float']>;
  BDNDOMD: Maybe<Scalars['Float']>;
  BDNDOTM: Maybe<Scalars['Float']>;
  BDNEPCP: Maybe<Scalars['Float']>;
  BDNEPMA: Maybe<Scalars['Float']>;
  BDNEPMD: Maybe<Scalars['Float']>;
  BDNEPTM: Maybe<Scalars['Float']>;
  BDNOBCP: Maybe<Scalars['Float']>;
  BDNOBMA: Maybe<Scalars['Float']>;
  BDNOBMD: Maybe<Scalars['Float']>;
  BDNOBTM: Maybe<Scalars['Float']>;
  BDPEDCP: Maybe<Scalars['Float']>;
  BDPEDMA: Maybe<Scalars['Float']>;
  BDPEDMD: Maybe<Scalars['Float']>;
  BDPEDTM: Maybe<Scalars['Float']>;
  BDPHDCP: Maybe<Scalars['Float']>;
  BDPHDMA: Maybe<Scalars['Float']>;
  BDPHDMD: Maybe<Scalars['Float']>;
  BDPHDTM: Maybe<Scalars['Float']>;
  BDPOTCP: Maybe<Scalars['Float']>;
  BDPOTMA: Maybe<Scalars['Float']>;
  BDPOTMD: Maybe<Scalars['Float']>;
  BDPOTTM: Maybe<Scalars['Float']>;
  BDPULCP: Maybe<Scalars['Float']>;
  BDPULMA: Maybe<Scalars['Float']>;
  BDPULMD: Maybe<Scalars['Float']>;
  BDPULTM: Maybe<Scalars['Float']>;
  BDSUBCP: Maybe<Scalars['Float']>;
  BDSUBMA: Maybe<Scalars['Float']>;
  BDSUBMD: Maybe<Scalars['Float']>;
  BDSUBTM: Maybe<Scalars['Float']>;
  BDVASCP: Maybe<Scalars['Float']>;
  BDVASMA: Maybe<Scalars['Float']>;
  BDVASMD: Maybe<Scalars['Float']>;
  BDVASTM: Maybe<Scalars['Float']>;
  BNDPCT: Maybe<Scalars['Float']>;
  CAPRSK: Maybe<Scalars['Float']>;
  CLUSTER: Maybe<Scalars['Float']>;
  COTYCAN: Maybe<Scalars['Float']>;
  COTYCAR: Maybe<Scalars['Float']>;
  COTYORT: Maybe<Scalars['Float']>;
  COTYOTH: Maybe<Scalars['Float']>;
  COTYPED: Maybe<Scalars['Float']>;
  COTYPSY: Maybe<Scalars['Float']>;
  COTYSUR: Maybe<Scalars['Float']>;
  CPPCT: Maybe<Scalars['Float']>;
  DCOV: Maybe<Scalars['Float']>;
  FRTLN: Maybe<Scalars['Float']>;
  HRRCODE: Maybe<Scalars['Float']>;
  HSACODE: Maybe<Scalars['Float']>;
  MSSP: Maybe<Scalars['Float']>;
  MSSPBA: Maybe<Scalars['Float']>;
  MSSPBB: Maybe<Scalars['Float']>;
  MSSPBC: Maybe<Scalars['Float']>;
  MSSPBD: Maybe<Scalars['Float']>;
  MSSPBE: Maybe<Scalars['Float']>;
  MSSPCE: Maybe<Scalars['Float']>;
  MSSPTRK: Maybe<Scalars['Float']>;
  NOPATH: Maybe<Scalars['Float']>;
  RESPTC: Maybe<Scalars['Float']>;
  SPAH: Maybe<Scalars['Float']>;
  SPTC: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS22SVC1" */
export type As22Svc1 = {
  __typename?: 'AS22SVC1';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BIOBD: Maybe<Scalars['float8']>;
  BIOHOS: Maybe<Scalars['String']>;
  BIOSYS: Maybe<Scalars['String']>;
  BIOVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMCER: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS22SVC1" */
export type As22Svc1_Aggregate = {
  __typename?: 'AS22SVC1_aggregate';
  aggregate: Maybe<As22Svc1_Aggregate_Fields>;
  nodes: Array<As22Svc1>;
};

/** aggregate fields of "AS22SVC1" */
export type As22Svc1_Aggregate_Fields = {
  __typename?: 'AS22SVC1_aggregate_fields';
  avg: Maybe<As22Svc1_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As22Svc1_Max_Fields>;
  min: Maybe<As22Svc1_Min_Fields>;
  stddev: Maybe<As22Svc1_Stddev_Fields>;
  stddev_pop: Maybe<As22Svc1_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As22Svc1_Stddev_Samp_Fields>;
  sum: Maybe<As22Svc1_Sum_Fields>;
  var_pop: Maybe<As22Svc1_Var_Pop_Fields>;
  var_samp: Maybe<As22Svc1_Var_Samp_Fields>;
  variance: Maybe<As22Svc1_Variance_Fields>;
};


/** aggregate fields of "AS22SVC1" */
export type As22Svc1_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Svc1_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As22Svc1_Avg_Fields = {
  __typename?: 'AS22SVC1_avg_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS22SVC1". All fields are combined with a logical 'AND'. */
export type As22Svc1_Bool_Exp = {
  ACARDHOS?: InputMaybe<String_Comparison_Exp>;
  ACARDSYS?: InputMaybe<String_Comparison_Exp>;
  ACARDVEN?: InputMaybe<String_Comparison_Exp>;
  ACLABHOS?: InputMaybe<String_Comparison_Exp>;
  ACLABSYS?: InputMaybe<String_Comparison_Exp>;
  ACLABVEN?: InputMaybe<String_Comparison_Exp>;
  ACUHOS?: InputMaybe<String_Comparison_Exp>;
  ACULTBD?: InputMaybe<Float8_Comparison_Exp>;
  ACUSYS?: InputMaybe<String_Comparison_Exp>;
  ACUVEN?: InputMaybe<String_Comparison_Exp>;
  ADTCHOS?: InputMaybe<String_Comparison_Exp>;
  ADTCSYS?: InputMaybe<String_Comparison_Exp>;
  ADTCVEN?: InputMaybe<String_Comparison_Exp>;
  ADTEHOS?: InputMaybe<String_Comparison_Exp>;
  ADTESYS?: InputMaybe<String_Comparison_Exp>;
  ADTEVEN?: InputMaybe<String_Comparison_Exp>;
  ADULTHOS?: InputMaybe<String_Comparison_Exp>;
  ADULTSYS?: InputMaybe<String_Comparison_Exp>;
  ADULTVEN?: InputMaybe<String_Comparison_Exp>;
  AIRBHOS?: InputMaybe<String_Comparison_Exp>;
  AIRBROOM?: InputMaybe<Float8_Comparison_Exp>;
  AIRBSYS?: InputMaybe<String_Comparison_Exp>;
  AIRBVEN?: InputMaybe<String_Comparison_Exp>;
  ALCHBD?: InputMaybe<Float8_Comparison_Exp>;
  ALCHHOS?: InputMaybe<String_Comparison_Exp>;
  ALCHSYS?: InputMaybe<String_Comparison_Exp>;
  ALCHVEN?: InputMaybe<String_Comparison_Exp>;
  ALZHOS?: InputMaybe<String_Comparison_Exp>;
  ALZSYS?: InputMaybe<String_Comparison_Exp>;
  ALZVEN?: InputMaybe<String_Comparison_Exp>;
  AMBAHOS?: InputMaybe<String_Comparison_Exp>;
  AMBASYS?: InputMaybe<String_Comparison_Exp>;
  AMBAVEN?: InputMaybe<String_Comparison_Exp>;
  AMBHOS?: InputMaybe<String_Comparison_Exp>;
  AMBSHOS?: InputMaybe<String_Comparison_Exp>;
  AMBSSYS?: InputMaybe<String_Comparison_Exp>;
  AMBSVEN?: InputMaybe<String_Comparison_Exp>;
  AMBSYS?: InputMaybe<String_Comparison_Exp>;
  AMBVEN?: InputMaybe<String_Comparison_Exp>;
  ARTHCHOS?: InputMaybe<String_Comparison_Exp>;
  ARTHCSYS?: InputMaybe<String_Comparison_Exp>;
  ARTHCVEN?: InputMaybe<String_Comparison_Exp>;
  AUXHOS?: InputMaybe<String_Comparison_Exp>;
  AUXSYS?: InputMaybe<String_Comparison_Exp>;
  AUXVEN?: InputMaybe<String_Comparison_Exp>;
  BIOBD?: InputMaybe<Float8_Comparison_Exp>;
  BIOHOS?: InputMaybe<String_Comparison_Exp>;
  BIOSYS?: InputMaybe<String_Comparison_Exp>;
  BIOVEN?: InputMaybe<String_Comparison_Exp>;
  BLDOHOS?: InputMaybe<String_Comparison_Exp>;
  BLDOSYS?: InputMaybe<String_Comparison_Exp>;
  BLDOVEN?: InputMaybe<String_Comparison_Exp>;
  BRNBD?: InputMaybe<Float8_Comparison_Exp>;
  BRNHOS?: InputMaybe<String_Comparison_Exp>;
  BRNSYS?: InputMaybe<String_Comparison_Exp>;
  BRNVEN?: InputMaybe<String_Comparison_Exp>;
  BROOMHOS?: InputMaybe<String_Comparison_Exp>;
  BROOMSYS?: InputMaybe<String_Comparison_Exp>;
  BROOMVEN?: InputMaybe<String_Comparison_Exp>;
  BWHTHOS?: InputMaybe<String_Comparison_Exp>;
  BWHTSYS?: InputMaybe<String_Comparison_Exp>;
  BWHTVEN?: InputMaybe<String_Comparison_Exp>;
  CAOSHOS?: InputMaybe<String_Comparison_Exp>;
  CAOSSYS?: InputMaybe<String_Comparison_Exp>;
  CAOSVEN?: InputMaybe<String_Comparison_Exp>;
  CHABHOS?: InputMaybe<String_Comparison_Exp>;
  CHABSYS?: InputMaybe<String_Comparison_Exp>;
  CHABVEN?: InputMaybe<String_Comparison_Exp>;
  CHAPHOS?: InputMaybe<String_Comparison_Exp>;
  CHAPSYS?: InputMaybe<String_Comparison_Exp>;
  CHAPVEN?: InputMaybe<String_Comparison_Exp>;
  CHIHOS?: InputMaybe<String_Comparison_Exp>;
  CHISYS?: InputMaybe<String_Comparison_Exp>;
  CHIVEN?: InputMaybe<String_Comparison_Exp>;
  CHTHHOS?: InputMaybe<String_Comparison_Exp>;
  CHTHSYS?: InputMaybe<String_Comparison_Exp>;
  CHTHVEN?: InputMaybe<String_Comparison_Exp>;
  CICBD?: InputMaybe<Float8_Comparison_Exp>;
  CICHOS?: InputMaybe<String_Comparison_Exp>;
  CICSYS?: InputMaybe<String_Comparison_Exp>;
  CICVEN?: InputMaybe<String_Comparison_Exp>;
  CMNGTHOS?: InputMaybe<String_Comparison_Exp>;
  CMNGTSYS?: InputMaybe<String_Comparison_Exp>;
  CMNGTVEN?: InputMaybe<String_Comparison_Exp>;
  COMPHOS?: InputMaybe<String_Comparison_Exp>;
  COMPSYS?: InputMaybe<String_Comparison_Exp>;
  COMPVEN?: InputMaybe<String_Comparison_Exp>;
  COUTRHOS?: InputMaybe<String_Comparison_Exp>;
  COUTRSYS?: InputMaybe<String_Comparison_Exp>;
  COUTRVEN?: InputMaybe<String_Comparison_Exp>;
  CPREVHOS?: InputMaybe<String_Comparison_Exp>;
  CPREVSYS?: InputMaybe<String_Comparison_Exp>;
  CPREVVEN?: InputMaybe<String_Comparison_Exp>;
  CWELLHOS?: InputMaybe<String_Comparison_Exp>;
  CWELLSYS?: InputMaybe<String_Comparison_Exp>;
  CWELLVEN?: InputMaybe<String_Comparison_Exp>;
  DENTSHOS?: InputMaybe<String_Comparison_Exp>;
  DENTSSYS?: InputMaybe<String_Comparison_Exp>;
  DENTSVEN?: InputMaybe<String_Comparison_Exp>;
  DPPHOS?: InputMaybe<String_Comparison_Exp>;
  DPPSYS?: InputMaybe<String_Comparison_Exp>;
  DPPVEN?: InputMaybe<String_Comparison_Exp>;
  EMDEPHOS?: InputMaybe<String_Comparison_Exp>;
  EMDEPSYS?: InputMaybe<String_Comparison_Exp>;
  EMDEPVEN?: InputMaybe<String_Comparison_Exp>;
  EMSSHOS?: InputMaybe<String_Comparison_Exp>;
  EMSSSYS?: InputMaybe<String_Comparison_Exp>;
  EMSSVEN?: InputMaybe<String_Comparison_Exp>;
  ENBHOS?: InputMaybe<String_Comparison_Exp>;
  ENBSYS?: InputMaybe<String_Comparison_Exp>;
  ENBVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOAHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOASYS?: InputMaybe<String_Comparison_Exp>;
  ENDOAVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOCHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOCSYS?: InputMaybe<String_Comparison_Exp>;
  ENDOCVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOEHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOESYS?: InputMaybe<String_Comparison_Exp>;
  ENDOEVEN?: InputMaybe<String_Comparison_Exp>;
  ENDORHOS?: InputMaybe<String_Comparison_Exp>;
  ENDORSYS?: InputMaybe<String_Comparison_Exp>;
  ENDORVEN?: InputMaybe<String_Comparison_Exp>;
  ENDOUHOS?: InputMaybe<String_Comparison_Exp>;
  ENDOUSYS?: InputMaybe<String_Comparison_Exp>;
  ENDOUVEN?: InputMaybe<String_Comparison_Exp>;
  ENRHOS?: InputMaybe<String_Comparison_Exp>;
  ENRSYS?: InputMaybe<String_Comparison_Exp>;
  ENRVEN?: InputMaybe<String_Comparison_Exp>;
  ESWLHOS?: InputMaybe<String_Comparison_Exp>;
  ESWLSYS?: InputMaybe<String_Comparison_Exp>;
  ESWLVEN?: InputMaybe<String_Comparison_Exp>;
  FITCHOS?: InputMaybe<String_Comparison_Exp>;
  FITCSYS?: InputMaybe<String_Comparison_Exp>;
  FITCVEN?: InputMaybe<String_Comparison_Exp>;
  FRTCHOS?: InputMaybe<String_Comparison_Exp>;
  FRTCSYS?: InputMaybe<String_Comparison_Exp>;
  FRTCVEN?: InputMaybe<String_Comparison_Exp>;
  FSERHOS?: InputMaybe<String_Comparison_Exp>;
  FSERSYS?: InputMaybe<String_Comparison_Exp>;
  FSERVEN?: InputMaybe<String_Comparison_Exp>;
  GENBD?: InputMaybe<Float8_Comparison_Exp>;
  GENHOS?: InputMaybe<String_Comparison_Exp>;
  GENSYS?: InputMaybe<String_Comparison_Exp>;
  GENVEN?: InputMaybe<String_Comparison_Exp>;
  GERSVHOS?: InputMaybe<String_Comparison_Exp>;
  GERSVSYS?: InputMaybe<String_Comparison_Exp>;
  GERSVVEN?: InputMaybe<String_Comparison_Exp>;
  HOSPBD?: InputMaybe<Float8_Comparison_Exp>;
  ICFBD88?: InputMaybe<Float8_Comparison_Exp>;
  ICFHOS?: InputMaybe<String_Comparison_Exp>;
  ICFSYS?: InputMaybe<String_Comparison_Exp>;
  ICFVEN?: InputMaybe<String_Comparison_Exp>;
  ICLABHOS?: InputMaybe<String_Comparison_Exp>;
  ICLABSYS?: InputMaybe<String_Comparison_Exp>;
  ICLABVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  MAMMSHOS?: InputMaybe<String_Comparison_Exp>;
  MAMMSSYS?: InputMaybe<String_Comparison_Exp>;
  MAMMSVEN?: InputMaybe<String_Comparison_Exp>;
  MSICBD?: InputMaybe<Float8_Comparison_Exp>;
  MSICHOS?: InputMaybe<String_Comparison_Exp>;
  MSICSYS?: InputMaybe<String_Comparison_Exp>;
  MSICVEN?: InputMaybe<String_Comparison_Exp>;
  NICBD?: InputMaybe<Float8_Comparison_Exp>;
  NICHOS?: InputMaybe<String_Comparison_Exp>;
  NICSYS?: InputMaybe<String_Comparison_Exp>;
  NICVEN?: InputMaybe<String_Comparison_Exp>;
  NINTBD?: InputMaybe<Float8_Comparison_Exp>;
  NINTHOS?: InputMaybe<String_Comparison_Exp>;
  NINTSYS?: InputMaybe<String_Comparison_Exp>;
  NINTVEN?: InputMaybe<String_Comparison_Exp>;
  OBBD?: InputMaybe<Float8_Comparison_Exp>;
  OBHOS?: InputMaybe<String_Comparison_Exp>;
  OBLEV?: InputMaybe<String_Comparison_Exp>;
  OBSYS?: InputMaybe<String_Comparison_Exp>;
  OBVEN?: InputMaybe<String_Comparison_Exp>;
  OPCENHOS?: InputMaybe<String_Comparison_Exp>;
  OPCENSYS?: InputMaybe<String_Comparison_Exp>;
  OPCENVEN?: InputMaybe<String_Comparison_Exp>;
  OSPOTH?: InputMaybe<String_Comparison_Exp>;
  OTHBD94?: InputMaybe<Float8_Comparison_Exp>;
  OTHCRHOS?: InputMaybe<String_Comparison_Exp>;
  OTHCRSYS?: InputMaybe<String_Comparison_Exp>;
  OTHCRVEN?: InputMaybe<String_Comparison_Exp>;
  OTHIC?: InputMaybe<String_Comparison_Exp>;
  OTHICBD?: InputMaybe<Float8_Comparison_Exp>;
  OTHIHOS?: InputMaybe<String_Comparison_Exp>;
  OTHISYS?: InputMaybe<String_Comparison_Exp>;
  OTHIVEN?: InputMaybe<String_Comparison_Exp>;
  OTHLBD94?: InputMaybe<Float8_Comparison_Exp>;
  OTHLTHOS?: InputMaybe<String_Comparison_Exp>;
  OTHLTSYS?: InputMaybe<String_Comparison_Exp>;
  OTHLTVEN?: InputMaybe<String_Comparison_Exp>;
  OTHOTH?: InputMaybe<String_Comparison_Exp>;
  PCARDHOS?: InputMaybe<String_Comparison_Exp>;
  PCARDSYS?: InputMaybe<String_Comparison_Exp>;
  PCARDVEN?: InputMaybe<String_Comparison_Exp>;
  PCLABHOS?: InputMaybe<String_Comparison_Exp>;
  PCLABSYS?: InputMaybe<String_Comparison_Exp>;
  PCLABVEN?: InputMaybe<String_Comparison_Exp>;
  PEDBD?: InputMaybe<Float8_Comparison_Exp>;
  PEDCSHOS?: InputMaybe<String_Comparison_Exp>;
  PEDCSSYS?: InputMaybe<String_Comparison_Exp>;
  PEDCSVEN?: InputMaybe<String_Comparison_Exp>;
  PEDEHOS?: InputMaybe<String_Comparison_Exp>;
  PEDESYS?: InputMaybe<String_Comparison_Exp>;
  PEDEVEN?: InputMaybe<String_Comparison_Exp>;
  PEDHOS?: InputMaybe<String_Comparison_Exp>;
  PEDICBD?: InputMaybe<Float8_Comparison_Exp>;
  PEDICHOS?: InputMaybe<String_Comparison_Exp>;
  PEDICSYS?: InputMaybe<String_Comparison_Exp>;
  PEDICVEN?: InputMaybe<String_Comparison_Exp>;
  PEDSYS?: InputMaybe<String_Comparison_Exp>;
  PEDVEN?: InputMaybe<String_Comparison_Exp>;
  PELABHOS?: InputMaybe<String_Comparison_Exp>;
  PELABSYS?: InputMaybe<String_Comparison_Exp>;
  PELABVEN?: InputMaybe<String_Comparison_Exp>;
  PEMERHOS?: InputMaybe<String_Comparison_Exp>;
  PEMERSYS?: InputMaybe<String_Comparison_Exp>;
  PEMERVEN?: InputMaybe<String_Comparison_Exp>;
  PSYBD?: InputMaybe<Float8_Comparison_Exp>;
  PSYHOS?: InputMaybe<String_Comparison_Exp>;
  PSYSYS?: InputMaybe<String_Comparison_Exp>;
  PSYVEN?: InputMaybe<String_Comparison_Exp>;
  REHABBD?: InputMaybe<Float8_Comparison_Exp>;
  REHABHOS?: InputMaybe<String_Comparison_Exp>;
  REHABSYS?: InputMaybe<String_Comparison_Exp>;
  REHABVEN?: InputMaybe<String_Comparison_Exp>;
  SNBD88?: InputMaybe<Float8_Comparison_Exp>;
  SNHOS?: InputMaybe<String_Comparison_Exp>;
  SNSYS?: InputMaybe<String_Comparison_Exp>;
  SNVEN?: InputMaybe<String_Comparison_Exp>;
  SPCICBD?: InputMaybe<Float8_Comparison_Exp>;
  SPCICHOS?: InputMaybe<String_Comparison_Exp>;
  SPCICSYS?: InputMaybe<String_Comparison_Exp>;
  SPCICVEN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  TRAUMCER?: InputMaybe<String_Comparison_Exp>;
  TRAUMHOS?: InputMaybe<String_Comparison_Exp>;
  TRAUML90?: InputMaybe<String_Comparison_Exp>;
  TRAUMSYS?: InputMaybe<String_Comparison_Exp>;
  TRAUMVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Svc1_Bool_Exp>>;
  _not?: InputMaybe<As22Svc1_Bool_Exp>;
  _or?: InputMaybe<Array<As22Svc1_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS22SVC1" */
export enum As22Svc1_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Svc1 = 'pk_AS22SVC1'
}

/** input type for incrementing numeric columns in table "AS22SVC1" */
export type As22Svc1_Inc_Input = {
  ACULTBD?: InputMaybe<Scalars['float8']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS22SVC1" */
export type As22Svc1_Insert_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BIOHOS?: InputMaybe<Scalars['String']>;
  BIOSYS?: InputMaybe<Scalars['String']>;
  BIOVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMCER?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As22Svc1_Max_Fields = {
  __typename?: 'AS22SVC1_max_fields';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BIOBD: Maybe<Scalars['float8']>;
  BIOHOS: Maybe<Scalars['String']>;
  BIOSYS: Maybe<Scalars['String']>;
  BIOVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMCER: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As22Svc1_Min_Fields = {
  __typename?: 'AS22SVC1_min_fields';
  ACARDHOS: Maybe<Scalars['String']>;
  ACARDSYS: Maybe<Scalars['String']>;
  ACARDVEN: Maybe<Scalars['String']>;
  ACLABHOS: Maybe<Scalars['String']>;
  ACLABSYS: Maybe<Scalars['String']>;
  ACLABVEN: Maybe<Scalars['String']>;
  ACUHOS: Maybe<Scalars['String']>;
  ACULTBD: Maybe<Scalars['float8']>;
  ACUSYS: Maybe<Scalars['String']>;
  ACUVEN: Maybe<Scalars['String']>;
  ADTCHOS: Maybe<Scalars['String']>;
  ADTCSYS: Maybe<Scalars['String']>;
  ADTCVEN: Maybe<Scalars['String']>;
  ADTEHOS: Maybe<Scalars['String']>;
  ADTESYS: Maybe<Scalars['String']>;
  ADTEVEN: Maybe<Scalars['String']>;
  ADULTHOS: Maybe<Scalars['String']>;
  ADULTSYS: Maybe<Scalars['String']>;
  ADULTVEN: Maybe<Scalars['String']>;
  AIRBHOS: Maybe<Scalars['String']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  AIRBSYS: Maybe<Scalars['String']>;
  AIRBVEN: Maybe<Scalars['String']>;
  ALCHBD: Maybe<Scalars['float8']>;
  ALCHHOS: Maybe<Scalars['String']>;
  ALCHSYS: Maybe<Scalars['String']>;
  ALCHVEN: Maybe<Scalars['String']>;
  ALZHOS: Maybe<Scalars['String']>;
  ALZSYS: Maybe<Scalars['String']>;
  ALZVEN: Maybe<Scalars['String']>;
  AMBAHOS: Maybe<Scalars['String']>;
  AMBASYS: Maybe<Scalars['String']>;
  AMBAVEN: Maybe<Scalars['String']>;
  AMBHOS: Maybe<Scalars['String']>;
  AMBSHOS: Maybe<Scalars['String']>;
  AMBSSYS: Maybe<Scalars['String']>;
  AMBSVEN: Maybe<Scalars['String']>;
  AMBSYS: Maybe<Scalars['String']>;
  AMBVEN: Maybe<Scalars['String']>;
  ARTHCHOS: Maybe<Scalars['String']>;
  ARTHCSYS: Maybe<Scalars['String']>;
  ARTHCVEN: Maybe<Scalars['String']>;
  AUXHOS: Maybe<Scalars['String']>;
  AUXSYS: Maybe<Scalars['String']>;
  AUXVEN: Maybe<Scalars['String']>;
  BIOBD: Maybe<Scalars['float8']>;
  BIOHOS: Maybe<Scalars['String']>;
  BIOSYS: Maybe<Scalars['String']>;
  BIOVEN: Maybe<Scalars['String']>;
  BLDOHOS: Maybe<Scalars['String']>;
  BLDOSYS: Maybe<Scalars['String']>;
  BLDOVEN: Maybe<Scalars['String']>;
  BRNBD: Maybe<Scalars['float8']>;
  BRNHOS: Maybe<Scalars['String']>;
  BRNSYS: Maybe<Scalars['String']>;
  BRNVEN: Maybe<Scalars['String']>;
  BROOMHOS: Maybe<Scalars['String']>;
  BROOMSYS: Maybe<Scalars['String']>;
  BROOMVEN: Maybe<Scalars['String']>;
  BWHTHOS: Maybe<Scalars['String']>;
  BWHTSYS: Maybe<Scalars['String']>;
  BWHTVEN: Maybe<Scalars['String']>;
  CAOSHOS: Maybe<Scalars['String']>;
  CAOSSYS: Maybe<Scalars['String']>;
  CAOSVEN: Maybe<Scalars['String']>;
  CHABHOS: Maybe<Scalars['String']>;
  CHABSYS: Maybe<Scalars['String']>;
  CHABVEN: Maybe<Scalars['String']>;
  CHAPHOS: Maybe<Scalars['String']>;
  CHAPSYS: Maybe<Scalars['String']>;
  CHAPVEN: Maybe<Scalars['String']>;
  CHIHOS: Maybe<Scalars['String']>;
  CHISYS: Maybe<Scalars['String']>;
  CHIVEN: Maybe<Scalars['String']>;
  CHTHHOS: Maybe<Scalars['String']>;
  CHTHSYS: Maybe<Scalars['String']>;
  CHTHVEN: Maybe<Scalars['String']>;
  CICBD: Maybe<Scalars['float8']>;
  CICHOS: Maybe<Scalars['String']>;
  CICSYS: Maybe<Scalars['String']>;
  CICVEN: Maybe<Scalars['String']>;
  CMNGTHOS: Maybe<Scalars['String']>;
  CMNGTSYS: Maybe<Scalars['String']>;
  CMNGTVEN: Maybe<Scalars['String']>;
  COMPHOS: Maybe<Scalars['String']>;
  COMPSYS: Maybe<Scalars['String']>;
  COMPVEN: Maybe<Scalars['String']>;
  COUTRHOS: Maybe<Scalars['String']>;
  COUTRSYS: Maybe<Scalars['String']>;
  COUTRVEN: Maybe<Scalars['String']>;
  CPREVHOS: Maybe<Scalars['String']>;
  CPREVSYS: Maybe<Scalars['String']>;
  CPREVVEN: Maybe<Scalars['String']>;
  CWELLHOS: Maybe<Scalars['String']>;
  CWELLSYS: Maybe<Scalars['String']>;
  CWELLVEN: Maybe<Scalars['String']>;
  DENTSHOS: Maybe<Scalars['String']>;
  DENTSSYS: Maybe<Scalars['String']>;
  DENTSVEN: Maybe<Scalars['String']>;
  DPPHOS: Maybe<Scalars['String']>;
  DPPSYS: Maybe<Scalars['String']>;
  DPPVEN: Maybe<Scalars['String']>;
  EMDEPHOS: Maybe<Scalars['String']>;
  EMDEPSYS: Maybe<Scalars['String']>;
  EMDEPVEN: Maybe<Scalars['String']>;
  EMSSHOS: Maybe<Scalars['String']>;
  EMSSSYS: Maybe<Scalars['String']>;
  EMSSVEN: Maybe<Scalars['String']>;
  ENBHOS: Maybe<Scalars['String']>;
  ENBSYS: Maybe<Scalars['String']>;
  ENBVEN: Maybe<Scalars['String']>;
  ENDOAHOS: Maybe<Scalars['String']>;
  ENDOASYS: Maybe<Scalars['String']>;
  ENDOAVEN: Maybe<Scalars['String']>;
  ENDOCHOS: Maybe<Scalars['String']>;
  ENDOCSYS: Maybe<Scalars['String']>;
  ENDOCVEN: Maybe<Scalars['String']>;
  ENDOEHOS: Maybe<Scalars['String']>;
  ENDOESYS: Maybe<Scalars['String']>;
  ENDOEVEN: Maybe<Scalars['String']>;
  ENDORHOS: Maybe<Scalars['String']>;
  ENDORSYS: Maybe<Scalars['String']>;
  ENDORVEN: Maybe<Scalars['String']>;
  ENDOUHOS: Maybe<Scalars['String']>;
  ENDOUSYS: Maybe<Scalars['String']>;
  ENDOUVEN: Maybe<Scalars['String']>;
  ENRHOS: Maybe<Scalars['String']>;
  ENRSYS: Maybe<Scalars['String']>;
  ENRVEN: Maybe<Scalars['String']>;
  ESWLHOS: Maybe<Scalars['String']>;
  ESWLSYS: Maybe<Scalars['String']>;
  ESWLVEN: Maybe<Scalars['String']>;
  FITCHOS: Maybe<Scalars['String']>;
  FITCSYS: Maybe<Scalars['String']>;
  FITCVEN: Maybe<Scalars['String']>;
  FRTCHOS: Maybe<Scalars['String']>;
  FRTCSYS: Maybe<Scalars['String']>;
  FRTCVEN: Maybe<Scalars['String']>;
  FSERHOS: Maybe<Scalars['String']>;
  FSERSYS: Maybe<Scalars['String']>;
  FSERVEN: Maybe<Scalars['String']>;
  GENBD: Maybe<Scalars['float8']>;
  GENHOS: Maybe<Scalars['String']>;
  GENSYS: Maybe<Scalars['String']>;
  GENVEN: Maybe<Scalars['String']>;
  GERSVHOS: Maybe<Scalars['String']>;
  GERSVSYS: Maybe<Scalars['String']>;
  GERSVVEN: Maybe<Scalars['String']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  ICFHOS: Maybe<Scalars['String']>;
  ICFSYS: Maybe<Scalars['String']>;
  ICFVEN: Maybe<Scalars['String']>;
  ICLABHOS: Maybe<Scalars['String']>;
  ICLABSYS: Maybe<Scalars['String']>;
  ICLABVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  MAMMSHOS: Maybe<Scalars['String']>;
  MAMMSSYS: Maybe<Scalars['String']>;
  MAMMSVEN: Maybe<Scalars['String']>;
  MSICBD: Maybe<Scalars['float8']>;
  MSICHOS: Maybe<Scalars['String']>;
  MSICSYS: Maybe<Scalars['String']>;
  MSICVEN: Maybe<Scalars['String']>;
  NICBD: Maybe<Scalars['float8']>;
  NICHOS: Maybe<Scalars['String']>;
  NICSYS: Maybe<Scalars['String']>;
  NICVEN: Maybe<Scalars['String']>;
  NINTBD: Maybe<Scalars['float8']>;
  NINTHOS: Maybe<Scalars['String']>;
  NINTSYS: Maybe<Scalars['String']>;
  NINTVEN: Maybe<Scalars['String']>;
  OBBD: Maybe<Scalars['float8']>;
  OBHOS: Maybe<Scalars['String']>;
  OBLEV: Maybe<Scalars['String']>;
  OBSYS: Maybe<Scalars['String']>;
  OBVEN: Maybe<Scalars['String']>;
  OPCENHOS: Maybe<Scalars['String']>;
  OPCENSYS: Maybe<Scalars['String']>;
  OPCENVEN: Maybe<Scalars['String']>;
  OSPOTH: Maybe<Scalars['String']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHCRHOS: Maybe<Scalars['String']>;
  OTHCRSYS: Maybe<Scalars['String']>;
  OTHCRVEN: Maybe<Scalars['String']>;
  OTHIC: Maybe<Scalars['String']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHIHOS: Maybe<Scalars['String']>;
  OTHISYS: Maybe<Scalars['String']>;
  OTHIVEN: Maybe<Scalars['String']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  OTHLTHOS: Maybe<Scalars['String']>;
  OTHLTSYS: Maybe<Scalars['String']>;
  OTHLTVEN: Maybe<Scalars['String']>;
  OTHOTH: Maybe<Scalars['String']>;
  PCARDHOS: Maybe<Scalars['String']>;
  PCARDSYS: Maybe<Scalars['String']>;
  PCARDVEN: Maybe<Scalars['String']>;
  PCLABHOS: Maybe<Scalars['String']>;
  PCLABSYS: Maybe<Scalars['String']>;
  PCLABVEN: Maybe<Scalars['String']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDCSHOS: Maybe<Scalars['String']>;
  PEDCSSYS: Maybe<Scalars['String']>;
  PEDCSVEN: Maybe<Scalars['String']>;
  PEDEHOS: Maybe<Scalars['String']>;
  PEDESYS: Maybe<Scalars['String']>;
  PEDEVEN: Maybe<Scalars['String']>;
  PEDHOS: Maybe<Scalars['String']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PEDICHOS: Maybe<Scalars['String']>;
  PEDICSYS: Maybe<Scalars['String']>;
  PEDICVEN: Maybe<Scalars['String']>;
  PEDSYS: Maybe<Scalars['String']>;
  PEDVEN: Maybe<Scalars['String']>;
  PELABHOS: Maybe<Scalars['String']>;
  PELABSYS: Maybe<Scalars['String']>;
  PELABVEN: Maybe<Scalars['String']>;
  PEMERHOS: Maybe<Scalars['String']>;
  PEMERSYS: Maybe<Scalars['String']>;
  PEMERVEN: Maybe<Scalars['String']>;
  PSYBD: Maybe<Scalars['float8']>;
  PSYHOS: Maybe<Scalars['String']>;
  PSYSYS: Maybe<Scalars['String']>;
  PSYVEN: Maybe<Scalars['String']>;
  REHABBD: Maybe<Scalars['float8']>;
  REHABHOS: Maybe<Scalars['String']>;
  REHABSYS: Maybe<Scalars['String']>;
  REHABVEN: Maybe<Scalars['String']>;
  SNBD88: Maybe<Scalars['float8']>;
  SNHOS: Maybe<Scalars['String']>;
  SNSYS: Maybe<Scalars['String']>;
  SNVEN: Maybe<Scalars['String']>;
  SPCICBD: Maybe<Scalars['float8']>;
  SPCICHOS: Maybe<Scalars['String']>;
  SPCICSYS: Maybe<Scalars['String']>;
  SPCICVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  TRAUMCER: Maybe<Scalars['String']>;
  TRAUMHOS: Maybe<Scalars['String']>;
  TRAUML90: Maybe<Scalars['String']>;
  TRAUMSYS: Maybe<Scalars['String']>;
  TRAUMVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS22SVC1" */
export type As22Svc1_Mutation_Response = {
  __typename?: 'AS22SVC1_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Svc1>;
};

/** input type for inserting object relation for remote table "AS22SVC1" */
export type As22Svc1_Obj_Rel_Insert_Input = {
  data: As22Svc1_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Svc1_On_Conflict>;
};

/** on_conflict condition type for table "AS22SVC1" */
export type As22Svc1_On_Conflict = {
  constraint: As22Svc1_Constraint;
  update_columns?: Array<As22Svc1_Update_Column>;
  where?: InputMaybe<As22Svc1_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22SVC1". */
export type As22Svc1_Order_By = {
  ACARDHOS?: InputMaybe<Order_By>;
  ACARDSYS?: InputMaybe<Order_By>;
  ACARDVEN?: InputMaybe<Order_By>;
  ACLABHOS?: InputMaybe<Order_By>;
  ACLABSYS?: InputMaybe<Order_By>;
  ACLABVEN?: InputMaybe<Order_By>;
  ACUHOS?: InputMaybe<Order_By>;
  ACULTBD?: InputMaybe<Order_By>;
  ACUSYS?: InputMaybe<Order_By>;
  ACUVEN?: InputMaybe<Order_By>;
  ADTCHOS?: InputMaybe<Order_By>;
  ADTCSYS?: InputMaybe<Order_By>;
  ADTCVEN?: InputMaybe<Order_By>;
  ADTEHOS?: InputMaybe<Order_By>;
  ADTESYS?: InputMaybe<Order_By>;
  ADTEVEN?: InputMaybe<Order_By>;
  ADULTHOS?: InputMaybe<Order_By>;
  ADULTSYS?: InputMaybe<Order_By>;
  ADULTVEN?: InputMaybe<Order_By>;
  AIRBHOS?: InputMaybe<Order_By>;
  AIRBROOM?: InputMaybe<Order_By>;
  AIRBSYS?: InputMaybe<Order_By>;
  AIRBVEN?: InputMaybe<Order_By>;
  ALCHBD?: InputMaybe<Order_By>;
  ALCHHOS?: InputMaybe<Order_By>;
  ALCHSYS?: InputMaybe<Order_By>;
  ALCHVEN?: InputMaybe<Order_By>;
  ALZHOS?: InputMaybe<Order_By>;
  ALZSYS?: InputMaybe<Order_By>;
  ALZVEN?: InputMaybe<Order_By>;
  AMBAHOS?: InputMaybe<Order_By>;
  AMBASYS?: InputMaybe<Order_By>;
  AMBAVEN?: InputMaybe<Order_By>;
  AMBHOS?: InputMaybe<Order_By>;
  AMBSHOS?: InputMaybe<Order_By>;
  AMBSSYS?: InputMaybe<Order_By>;
  AMBSVEN?: InputMaybe<Order_By>;
  AMBSYS?: InputMaybe<Order_By>;
  AMBVEN?: InputMaybe<Order_By>;
  ARTHCHOS?: InputMaybe<Order_By>;
  ARTHCSYS?: InputMaybe<Order_By>;
  ARTHCVEN?: InputMaybe<Order_By>;
  AUXHOS?: InputMaybe<Order_By>;
  AUXSYS?: InputMaybe<Order_By>;
  AUXVEN?: InputMaybe<Order_By>;
  BIOBD?: InputMaybe<Order_By>;
  BIOHOS?: InputMaybe<Order_By>;
  BIOSYS?: InputMaybe<Order_By>;
  BIOVEN?: InputMaybe<Order_By>;
  BLDOHOS?: InputMaybe<Order_By>;
  BLDOSYS?: InputMaybe<Order_By>;
  BLDOVEN?: InputMaybe<Order_By>;
  BRNBD?: InputMaybe<Order_By>;
  BRNHOS?: InputMaybe<Order_By>;
  BRNSYS?: InputMaybe<Order_By>;
  BRNVEN?: InputMaybe<Order_By>;
  BROOMHOS?: InputMaybe<Order_By>;
  BROOMSYS?: InputMaybe<Order_By>;
  BROOMVEN?: InputMaybe<Order_By>;
  BWHTHOS?: InputMaybe<Order_By>;
  BWHTSYS?: InputMaybe<Order_By>;
  BWHTVEN?: InputMaybe<Order_By>;
  CAOSHOS?: InputMaybe<Order_By>;
  CAOSSYS?: InputMaybe<Order_By>;
  CAOSVEN?: InputMaybe<Order_By>;
  CHABHOS?: InputMaybe<Order_By>;
  CHABSYS?: InputMaybe<Order_By>;
  CHABVEN?: InputMaybe<Order_By>;
  CHAPHOS?: InputMaybe<Order_By>;
  CHAPSYS?: InputMaybe<Order_By>;
  CHAPVEN?: InputMaybe<Order_By>;
  CHIHOS?: InputMaybe<Order_By>;
  CHISYS?: InputMaybe<Order_By>;
  CHIVEN?: InputMaybe<Order_By>;
  CHTHHOS?: InputMaybe<Order_By>;
  CHTHSYS?: InputMaybe<Order_By>;
  CHTHVEN?: InputMaybe<Order_By>;
  CICBD?: InputMaybe<Order_By>;
  CICHOS?: InputMaybe<Order_By>;
  CICSYS?: InputMaybe<Order_By>;
  CICVEN?: InputMaybe<Order_By>;
  CMNGTHOS?: InputMaybe<Order_By>;
  CMNGTSYS?: InputMaybe<Order_By>;
  CMNGTVEN?: InputMaybe<Order_By>;
  COMPHOS?: InputMaybe<Order_By>;
  COMPSYS?: InputMaybe<Order_By>;
  COMPVEN?: InputMaybe<Order_By>;
  COUTRHOS?: InputMaybe<Order_By>;
  COUTRSYS?: InputMaybe<Order_By>;
  COUTRVEN?: InputMaybe<Order_By>;
  CPREVHOS?: InputMaybe<Order_By>;
  CPREVSYS?: InputMaybe<Order_By>;
  CPREVVEN?: InputMaybe<Order_By>;
  CWELLHOS?: InputMaybe<Order_By>;
  CWELLSYS?: InputMaybe<Order_By>;
  CWELLVEN?: InputMaybe<Order_By>;
  DENTSHOS?: InputMaybe<Order_By>;
  DENTSSYS?: InputMaybe<Order_By>;
  DENTSVEN?: InputMaybe<Order_By>;
  DPPHOS?: InputMaybe<Order_By>;
  DPPSYS?: InputMaybe<Order_By>;
  DPPVEN?: InputMaybe<Order_By>;
  EMDEPHOS?: InputMaybe<Order_By>;
  EMDEPSYS?: InputMaybe<Order_By>;
  EMDEPVEN?: InputMaybe<Order_By>;
  EMSSHOS?: InputMaybe<Order_By>;
  EMSSSYS?: InputMaybe<Order_By>;
  EMSSVEN?: InputMaybe<Order_By>;
  ENBHOS?: InputMaybe<Order_By>;
  ENBSYS?: InputMaybe<Order_By>;
  ENBVEN?: InputMaybe<Order_By>;
  ENDOAHOS?: InputMaybe<Order_By>;
  ENDOASYS?: InputMaybe<Order_By>;
  ENDOAVEN?: InputMaybe<Order_By>;
  ENDOCHOS?: InputMaybe<Order_By>;
  ENDOCSYS?: InputMaybe<Order_By>;
  ENDOCVEN?: InputMaybe<Order_By>;
  ENDOEHOS?: InputMaybe<Order_By>;
  ENDOESYS?: InputMaybe<Order_By>;
  ENDOEVEN?: InputMaybe<Order_By>;
  ENDORHOS?: InputMaybe<Order_By>;
  ENDORSYS?: InputMaybe<Order_By>;
  ENDORVEN?: InputMaybe<Order_By>;
  ENDOUHOS?: InputMaybe<Order_By>;
  ENDOUSYS?: InputMaybe<Order_By>;
  ENDOUVEN?: InputMaybe<Order_By>;
  ENRHOS?: InputMaybe<Order_By>;
  ENRSYS?: InputMaybe<Order_By>;
  ENRVEN?: InputMaybe<Order_By>;
  ESWLHOS?: InputMaybe<Order_By>;
  ESWLSYS?: InputMaybe<Order_By>;
  ESWLVEN?: InputMaybe<Order_By>;
  FITCHOS?: InputMaybe<Order_By>;
  FITCSYS?: InputMaybe<Order_By>;
  FITCVEN?: InputMaybe<Order_By>;
  FRTCHOS?: InputMaybe<Order_By>;
  FRTCSYS?: InputMaybe<Order_By>;
  FRTCVEN?: InputMaybe<Order_By>;
  FSERHOS?: InputMaybe<Order_By>;
  FSERSYS?: InputMaybe<Order_By>;
  FSERVEN?: InputMaybe<Order_By>;
  GENBD?: InputMaybe<Order_By>;
  GENHOS?: InputMaybe<Order_By>;
  GENSYS?: InputMaybe<Order_By>;
  GENVEN?: InputMaybe<Order_By>;
  GERSVHOS?: InputMaybe<Order_By>;
  GERSVSYS?: InputMaybe<Order_By>;
  GERSVVEN?: InputMaybe<Order_By>;
  HOSPBD?: InputMaybe<Order_By>;
  ICFBD88?: InputMaybe<Order_By>;
  ICFHOS?: InputMaybe<Order_By>;
  ICFSYS?: InputMaybe<Order_By>;
  ICFVEN?: InputMaybe<Order_By>;
  ICLABHOS?: InputMaybe<Order_By>;
  ICLABSYS?: InputMaybe<Order_By>;
  ICLABVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  MAMMSHOS?: InputMaybe<Order_By>;
  MAMMSSYS?: InputMaybe<Order_By>;
  MAMMSVEN?: InputMaybe<Order_By>;
  MSICBD?: InputMaybe<Order_By>;
  MSICHOS?: InputMaybe<Order_By>;
  MSICSYS?: InputMaybe<Order_By>;
  MSICVEN?: InputMaybe<Order_By>;
  NICBD?: InputMaybe<Order_By>;
  NICHOS?: InputMaybe<Order_By>;
  NICSYS?: InputMaybe<Order_By>;
  NICVEN?: InputMaybe<Order_By>;
  NINTBD?: InputMaybe<Order_By>;
  NINTHOS?: InputMaybe<Order_By>;
  NINTSYS?: InputMaybe<Order_By>;
  NINTVEN?: InputMaybe<Order_By>;
  OBBD?: InputMaybe<Order_By>;
  OBHOS?: InputMaybe<Order_By>;
  OBLEV?: InputMaybe<Order_By>;
  OBSYS?: InputMaybe<Order_By>;
  OBVEN?: InputMaybe<Order_By>;
  OPCENHOS?: InputMaybe<Order_By>;
  OPCENSYS?: InputMaybe<Order_By>;
  OPCENVEN?: InputMaybe<Order_By>;
  OSPOTH?: InputMaybe<Order_By>;
  OTHBD94?: InputMaybe<Order_By>;
  OTHCRHOS?: InputMaybe<Order_By>;
  OTHCRSYS?: InputMaybe<Order_By>;
  OTHCRVEN?: InputMaybe<Order_By>;
  OTHIC?: InputMaybe<Order_By>;
  OTHICBD?: InputMaybe<Order_By>;
  OTHIHOS?: InputMaybe<Order_By>;
  OTHISYS?: InputMaybe<Order_By>;
  OTHIVEN?: InputMaybe<Order_By>;
  OTHLBD94?: InputMaybe<Order_By>;
  OTHLTHOS?: InputMaybe<Order_By>;
  OTHLTSYS?: InputMaybe<Order_By>;
  OTHLTVEN?: InputMaybe<Order_By>;
  OTHOTH?: InputMaybe<Order_By>;
  PCARDHOS?: InputMaybe<Order_By>;
  PCARDSYS?: InputMaybe<Order_By>;
  PCARDVEN?: InputMaybe<Order_By>;
  PCLABHOS?: InputMaybe<Order_By>;
  PCLABSYS?: InputMaybe<Order_By>;
  PCLABVEN?: InputMaybe<Order_By>;
  PEDBD?: InputMaybe<Order_By>;
  PEDCSHOS?: InputMaybe<Order_By>;
  PEDCSSYS?: InputMaybe<Order_By>;
  PEDCSVEN?: InputMaybe<Order_By>;
  PEDEHOS?: InputMaybe<Order_By>;
  PEDESYS?: InputMaybe<Order_By>;
  PEDEVEN?: InputMaybe<Order_By>;
  PEDHOS?: InputMaybe<Order_By>;
  PEDICBD?: InputMaybe<Order_By>;
  PEDICHOS?: InputMaybe<Order_By>;
  PEDICSYS?: InputMaybe<Order_By>;
  PEDICVEN?: InputMaybe<Order_By>;
  PEDSYS?: InputMaybe<Order_By>;
  PEDVEN?: InputMaybe<Order_By>;
  PELABHOS?: InputMaybe<Order_By>;
  PELABSYS?: InputMaybe<Order_By>;
  PELABVEN?: InputMaybe<Order_By>;
  PEMERHOS?: InputMaybe<Order_By>;
  PEMERSYS?: InputMaybe<Order_By>;
  PEMERVEN?: InputMaybe<Order_By>;
  PSYBD?: InputMaybe<Order_By>;
  PSYHOS?: InputMaybe<Order_By>;
  PSYSYS?: InputMaybe<Order_By>;
  PSYVEN?: InputMaybe<Order_By>;
  REHABBD?: InputMaybe<Order_By>;
  REHABHOS?: InputMaybe<Order_By>;
  REHABSYS?: InputMaybe<Order_By>;
  REHABVEN?: InputMaybe<Order_By>;
  SNBD88?: InputMaybe<Order_By>;
  SNHOS?: InputMaybe<Order_By>;
  SNSYS?: InputMaybe<Order_By>;
  SNVEN?: InputMaybe<Order_By>;
  SPCICBD?: InputMaybe<Order_By>;
  SPCICHOS?: InputMaybe<Order_By>;
  SPCICSYS?: InputMaybe<Order_By>;
  SPCICVEN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  TRAUMCER?: InputMaybe<Order_By>;
  TRAUMHOS?: InputMaybe<Order_By>;
  TRAUML90?: InputMaybe<Order_By>;
  TRAUMSYS?: InputMaybe<Order_By>;
  TRAUMVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS22SVC1 */
export type As22Svc1_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22SVC1" */
export enum As22Svc1_Select_Column {
  /** column name */
  Acardhos = 'ACARDHOS',
  /** column name */
  Acardsys = 'ACARDSYS',
  /** column name */
  Acardven = 'ACARDVEN',
  /** column name */
  Aclabhos = 'ACLABHOS',
  /** column name */
  Aclabsys = 'ACLABSYS',
  /** column name */
  Aclabven = 'ACLABVEN',
  /** column name */
  Acuhos = 'ACUHOS',
  /** column name */
  Acultbd = 'ACULTBD',
  /** column name */
  Acusys = 'ACUSYS',
  /** column name */
  Acuven = 'ACUVEN',
  /** column name */
  Adtchos = 'ADTCHOS',
  /** column name */
  Adtcsys = 'ADTCSYS',
  /** column name */
  Adtcven = 'ADTCVEN',
  /** column name */
  Adtehos = 'ADTEHOS',
  /** column name */
  Adtesys = 'ADTESYS',
  /** column name */
  Adteven = 'ADTEVEN',
  /** column name */
  Adulthos = 'ADULTHOS',
  /** column name */
  Adultsys = 'ADULTSYS',
  /** column name */
  Adultven = 'ADULTVEN',
  /** column name */
  Airbhos = 'AIRBHOS',
  /** column name */
  Airbroom = 'AIRBROOM',
  /** column name */
  Airbsys = 'AIRBSYS',
  /** column name */
  Airbven = 'AIRBVEN',
  /** column name */
  Alchbd = 'ALCHBD',
  /** column name */
  Alchhos = 'ALCHHOS',
  /** column name */
  Alchsys = 'ALCHSYS',
  /** column name */
  Alchven = 'ALCHVEN',
  /** column name */
  Alzhos = 'ALZHOS',
  /** column name */
  Alzsys = 'ALZSYS',
  /** column name */
  Alzven = 'ALZVEN',
  /** column name */
  Ambahos = 'AMBAHOS',
  /** column name */
  Ambasys = 'AMBASYS',
  /** column name */
  Ambaven = 'AMBAVEN',
  /** column name */
  Ambhos = 'AMBHOS',
  /** column name */
  Ambshos = 'AMBSHOS',
  /** column name */
  Ambssys = 'AMBSSYS',
  /** column name */
  Ambsven = 'AMBSVEN',
  /** column name */
  Ambsys = 'AMBSYS',
  /** column name */
  Ambven = 'AMBVEN',
  /** column name */
  Arthchos = 'ARTHCHOS',
  /** column name */
  Arthcsys = 'ARTHCSYS',
  /** column name */
  Arthcven = 'ARTHCVEN',
  /** column name */
  Auxhos = 'AUXHOS',
  /** column name */
  Auxsys = 'AUXSYS',
  /** column name */
  Auxven = 'AUXVEN',
  /** column name */
  Biobd = 'BIOBD',
  /** column name */
  Biohos = 'BIOHOS',
  /** column name */
  Biosys = 'BIOSYS',
  /** column name */
  Bioven = 'BIOVEN',
  /** column name */
  Bldohos = 'BLDOHOS',
  /** column name */
  Bldosys = 'BLDOSYS',
  /** column name */
  Bldoven = 'BLDOVEN',
  /** column name */
  Brnbd = 'BRNBD',
  /** column name */
  Brnhos = 'BRNHOS',
  /** column name */
  Brnsys = 'BRNSYS',
  /** column name */
  Brnven = 'BRNVEN',
  /** column name */
  Broomhos = 'BROOMHOS',
  /** column name */
  Broomsys = 'BROOMSYS',
  /** column name */
  Broomven = 'BROOMVEN',
  /** column name */
  Bwhthos = 'BWHTHOS',
  /** column name */
  Bwhtsys = 'BWHTSYS',
  /** column name */
  Bwhtven = 'BWHTVEN',
  /** column name */
  Caoshos = 'CAOSHOS',
  /** column name */
  Caossys = 'CAOSSYS',
  /** column name */
  Caosven = 'CAOSVEN',
  /** column name */
  Chabhos = 'CHABHOS',
  /** column name */
  Chabsys = 'CHABSYS',
  /** column name */
  Chabven = 'CHABVEN',
  /** column name */
  Chaphos = 'CHAPHOS',
  /** column name */
  Chapsys = 'CHAPSYS',
  /** column name */
  Chapven = 'CHAPVEN',
  /** column name */
  Chihos = 'CHIHOS',
  /** column name */
  Chisys = 'CHISYS',
  /** column name */
  Chiven = 'CHIVEN',
  /** column name */
  Chthhos = 'CHTHHOS',
  /** column name */
  Chthsys = 'CHTHSYS',
  /** column name */
  Chthven = 'CHTHVEN',
  /** column name */
  Cicbd = 'CICBD',
  /** column name */
  Cichos = 'CICHOS',
  /** column name */
  Cicsys = 'CICSYS',
  /** column name */
  Cicven = 'CICVEN',
  /** column name */
  Cmngthos = 'CMNGTHOS',
  /** column name */
  Cmngtsys = 'CMNGTSYS',
  /** column name */
  Cmngtven = 'CMNGTVEN',
  /** column name */
  Comphos = 'COMPHOS',
  /** column name */
  Compsys = 'COMPSYS',
  /** column name */
  Compven = 'COMPVEN',
  /** column name */
  Coutrhos = 'COUTRHOS',
  /** column name */
  Coutrsys = 'COUTRSYS',
  /** column name */
  Coutrven = 'COUTRVEN',
  /** column name */
  Cprevhos = 'CPREVHOS',
  /** column name */
  Cprevsys = 'CPREVSYS',
  /** column name */
  Cprevven = 'CPREVVEN',
  /** column name */
  Cwellhos = 'CWELLHOS',
  /** column name */
  Cwellsys = 'CWELLSYS',
  /** column name */
  Cwellven = 'CWELLVEN',
  /** column name */
  Dentshos = 'DENTSHOS',
  /** column name */
  Dentssys = 'DENTSSYS',
  /** column name */
  Dentsven = 'DENTSVEN',
  /** column name */
  Dpphos = 'DPPHOS',
  /** column name */
  Dppsys = 'DPPSYS',
  /** column name */
  Dppven = 'DPPVEN',
  /** column name */
  Emdephos = 'EMDEPHOS',
  /** column name */
  Emdepsys = 'EMDEPSYS',
  /** column name */
  Emdepven = 'EMDEPVEN',
  /** column name */
  Emsshos = 'EMSSHOS',
  /** column name */
  Emsssys = 'EMSSSYS',
  /** column name */
  Emssven = 'EMSSVEN',
  /** column name */
  Enbhos = 'ENBHOS',
  /** column name */
  Enbsys = 'ENBSYS',
  /** column name */
  Enbven = 'ENBVEN',
  /** column name */
  Endoahos = 'ENDOAHOS',
  /** column name */
  Endoasys = 'ENDOASYS',
  /** column name */
  Endoaven = 'ENDOAVEN',
  /** column name */
  Endochos = 'ENDOCHOS',
  /** column name */
  Endocsys = 'ENDOCSYS',
  /** column name */
  Endocven = 'ENDOCVEN',
  /** column name */
  Endoehos = 'ENDOEHOS',
  /** column name */
  Endoesys = 'ENDOESYS',
  /** column name */
  Endoeven = 'ENDOEVEN',
  /** column name */
  Endorhos = 'ENDORHOS',
  /** column name */
  Endorsys = 'ENDORSYS',
  /** column name */
  Endorven = 'ENDORVEN',
  /** column name */
  Endouhos = 'ENDOUHOS',
  /** column name */
  Endousys = 'ENDOUSYS',
  /** column name */
  Endouven = 'ENDOUVEN',
  /** column name */
  Enrhos = 'ENRHOS',
  /** column name */
  Enrsys = 'ENRSYS',
  /** column name */
  Enrven = 'ENRVEN',
  /** column name */
  Eswlhos = 'ESWLHOS',
  /** column name */
  Eswlsys = 'ESWLSYS',
  /** column name */
  Eswlven = 'ESWLVEN',
  /** column name */
  Fitchos = 'FITCHOS',
  /** column name */
  Fitcsys = 'FITCSYS',
  /** column name */
  Fitcven = 'FITCVEN',
  /** column name */
  Frtchos = 'FRTCHOS',
  /** column name */
  Frtcsys = 'FRTCSYS',
  /** column name */
  Frtcven = 'FRTCVEN',
  /** column name */
  Fserhos = 'FSERHOS',
  /** column name */
  Fsersys = 'FSERSYS',
  /** column name */
  Fserven = 'FSERVEN',
  /** column name */
  Genbd = 'GENBD',
  /** column name */
  Genhos = 'GENHOS',
  /** column name */
  Gensys = 'GENSYS',
  /** column name */
  Genven = 'GENVEN',
  /** column name */
  Gersvhos = 'GERSVHOS',
  /** column name */
  Gersvsys = 'GERSVSYS',
  /** column name */
  Gersvven = 'GERSVVEN',
  /** column name */
  Hospbd = 'HOSPBD',
  /** column name */
  Icfbd88 = 'ICFBD88',
  /** column name */
  Icfhos = 'ICFHOS',
  /** column name */
  Icfsys = 'ICFSYS',
  /** column name */
  Icfven = 'ICFVEN',
  /** column name */
  Iclabhos = 'ICLABHOS',
  /** column name */
  Iclabsys = 'ICLABSYS',
  /** column name */
  Iclabven = 'ICLABVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Mammshos = 'MAMMSHOS',
  /** column name */
  Mammssys = 'MAMMSSYS',
  /** column name */
  Mammsven = 'MAMMSVEN',
  /** column name */
  Msicbd = 'MSICBD',
  /** column name */
  Msichos = 'MSICHOS',
  /** column name */
  Msicsys = 'MSICSYS',
  /** column name */
  Msicven = 'MSICVEN',
  /** column name */
  Nicbd = 'NICBD',
  /** column name */
  Nichos = 'NICHOS',
  /** column name */
  Nicsys = 'NICSYS',
  /** column name */
  Nicven = 'NICVEN',
  /** column name */
  Nintbd = 'NINTBD',
  /** column name */
  Ninthos = 'NINTHOS',
  /** column name */
  Nintsys = 'NINTSYS',
  /** column name */
  Nintven = 'NINTVEN',
  /** column name */
  Obbd = 'OBBD',
  /** column name */
  Obhos = 'OBHOS',
  /** column name */
  Oblev = 'OBLEV',
  /** column name */
  Obsys = 'OBSYS',
  /** column name */
  Obven = 'OBVEN',
  /** column name */
  Opcenhos = 'OPCENHOS',
  /** column name */
  Opcensys = 'OPCENSYS',
  /** column name */
  Opcenven = 'OPCENVEN',
  /** column name */
  Ospoth = 'OSPOTH',
  /** column name */
  Othbd94 = 'OTHBD94',
  /** column name */
  Othcrhos = 'OTHCRHOS',
  /** column name */
  Othcrsys = 'OTHCRSYS',
  /** column name */
  Othcrven = 'OTHCRVEN',
  /** column name */
  Othic = 'OTHIC',
  /** column name */
  Othicbd = 'OTHICBD',
  /** column name */
  Othihos = 'OTHIHOS',
  /** column name */
  Othisys = 'OTHISYS',
  /** column name */
  Othiven = 'OTHIVEN',
  /** column name */
  Othlbd94 = 'OTHLBD94',
  /** column name */
  Othlthos = 'OTHLTHOS',
  /** column name */
  Othltsys = 'OTHLTSYS',
  /** column name */
  Othltven = 'OTHLTVEN',
  /** column name */
  Othoth = 'OTHOTH',
  /** column name */
  Pcardhos = 'PCARDHOS',
  /** column name */
  Pcardsys = 'PCARDSYS',
  /** column name */
  Pcardven = 'PCARDVEN',
  /** column name */
  Pclabhos = 'PCLABHOS',
  /** column name */
  Pclabsys = 'PCLABSYS',
  /** column name */
  Pclabven = 'PCLABVEN',
  /** column name */
  Pedbd = 'PEDBD',
  /** column name */
  Pedcshos = 'PEDCSHOS',
  /** column name */
  Pedcssys = 'PEDCSSYS',
  /** column name */
  Pedcsven = 'PEDCSVEN',
  /** column name */
  Pedehos = 'PEDEHOS',
  /** column name */
  Pedesys = 'PEDESYS',
  /** column name */
  Pedeven = 'PEDEVEN',
  /** column name */
  Pedhos = 'PEDHOS',
  /** column name */
  Pedicbd = 'PEDICBD',
  /** column name */
  Pedichos = 'PEDICHOS',
  /** column name */
  Pedicsys = 'PEDICSYS',
  /** column name */
  Pedicven = 'PEDICVEN',
  /** column name */
  Pedsys = 'PEDSYS',
  /** column name */
  Pedven = 'PEDVEN',
  /** column name */
  Pelabhos = 'PELABHOS',
  /** column name */
  Pelabsys = 'PELABSYS',
  /** column name */
  Pelabven = 'PELABVEN',
  /** column name */
  Pemerhos = 'PEMERHOS',
  /** column name */
  Pemersys = 'PEMERSYS',
  /** column name */
  Pemerven = 'PEMERVEN',
  /** column name */
  Psybd = 'PSYBD',
  /** column name */
  Psyhos = 'PSYHOS',
  /** column name */
  Psysys = 'PSYSYS',
  /** column name */
  Psyven = 'PSYVEN',
  /** column name */
  Rehabbd = 'REHABBD',
  /** column name */
  Rehabhos = 'REHABHOS',
  /** column name */
  Rehabsys = 'REHABSYS',
  /** column name */
  Rehabven = 'REHABVEN',
  /** column name */
  Snbd88 = 'SNBD88',
  /** column name */
  Snhos = 'SNHOS',
  /** column name */
  Snsys = 'SNSYS',
  /** column name */
  Snven = 'SNVEN',
  /** column name */
  Spcicbd = 'SPCICBD',
  /** column name */
  Spcichos = 'SPCICHOS',
  /** column name */
  Spcicsys = 'SPCICSYS',
  /** column name */
  Spcicven = 'SPCICVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Traumcer = 'TRAUMCER',
  /** column name */
  Traumhos = 'TRAUMHOS',
  /** column name */
  Trauml90 = 'TRAUML90',
  /** column name */
  Traumsys = 'TRAUMSYS',
  /** column name */
  Traumven = 'TRAUMVEN'
}

/** input type for updating data in table "AS22SVC1" */
export type As22Svc1_Set_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BIOHOS?: InputMaybe<Scalars['String']>;
  BIOSYS?: InputMaybe<Scalars['String']>;
  BIOVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMCER?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As22Svc1_Stddev_Fields = {
  __typename?: 'AS22SVC1_stddev_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As22Svc1_Stddev_Pop_Fields = {
  __typename?: 'AS22SVC1_stddev_pop_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As22Svc1_Stddev_Samp_Fields = {
  __typename?: 'AS22SVC1_stddev_samp_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS22SVC1" */
export type As22Svc1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Svc1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Svc1_Stream_Cursor_Value_Input = {
  ACARDHOS?: InputMaybe<Scalars['String']>;
  ACARDSYS?: InputMaybe<Scalars['String']>;
  ACARDVEN?: InputMaybe<Scalars['String']>;
  ACLABHOS?: InputMaybe<Scalars['String']>;
  ACLABSYS?: InputMaybe<Scalars['String']>;
  ACLABVEN?: InputMaybe<Scalars['String']>;
  ACUHOS?: InputMaybe<Scalars['String']>;
  ACULTBD?: InputMaybe<Scalars['float8']>;
  ACUSYS?: InputMaybe<Scalars['String']>;
  ACUVEN?: InputMaybe<Scalars['String']>;
  ADTCHOS?: InputMaybe<Scalars['String']>;
  ADTCSYS?: InputMaybe<Scalars['String']>;
  ADTCVEN?: InputMaybe<Scalars['String']>;
  ADTEHOS?: InputMaybe<Scalars['String']>;
  ADTESYS?: InputMaybe<Scalars['String']>;
  ADTEVEN?: InputMaybe<Scalars['String']>;
  ADULTHOS?: InputMaybe<Scalars['String']>;
  ADULTSYS?: InputMaybe<Scalars['String']>;
  ADULTVEN?: InputMaybe<Scalars['String']>;
  AIRBHOS?: InputMaybe<Scalars['String']>;
  AIRBROOM?: InputMaybe<Scalars['float8']>;
  AIRBSYS?: InputMaybe<Scalars['String']>;
  AIRBVEN?: InputMaybe<Scalars['String']>;
  ALCHBD?: InputMaybe<Scalars['float8']>;
  ALCHHOS?: InputMaybe<Scalars['String']>;
  ALCHSYS?: InputMaybe<Scalars['String']>;
  ALCHVEN?: InputMaybe<Scalars['String']>;
  ALZHOS?: InputMaybe<Scalars['String']>;
  ALZSYS?: InputMaybe<Scalars['String']>;
  ALZVEN?: InputMaybe<Scalars['String']>;
  AMBAHOS?: InputMaybe<Scalars['String']>;
  AMBASYS?: InputMaybe<Scalars['String']>;
  AMBAVEN?: InputMaybe<Scalars['String']>;
  AMBHOS?: InputMaybe<Scalars['String']>;
  AMBSHOS?: InputMaybe<Scalars['String']>;
  AMBSSYS?: InputMaybe<Scalars['String']>;
  AMBSVEN?: InputMaybe<Scalars['String']>;
  AMBSYS?: InputMaybe<Scalars['String']>;
  AMBVEN?: InputMaybe<Scalars['String']>;
  ARTHCHOS?: InputMaybe<Scalars['String']>;
  ARTHCSYS?: InputMaybe<Scalars['String']>;
  ARTHCVEN?: InputMaybe<Scalars['String']>;
  AUXHOS?: InputMaybe<Scalars['String']>;
  AUXSYS?: InputMaybe<Scalars['String']>;
  AUXVEN?: InputMaybe<Scalars['String']>;
  BIOBD?: InputMaybe<Scalars['float8']>;
  BIOHOS?: InputMaybe<Scalars['String']>;
  BIOSYS?: InputMaybe<Scalars['String']>;
  BIOVEN?: InputMaybe<Scalars['String']>;
  BLDOHOS?: InputMaybe<Scalars['String']>;
  BLDOSYS?: InputMaybe<Scalars['String']>;
  BLDOVEN?: InputMaybe<Scalars['String']>;
  BRNBD?: InputMaybe<Scalars['float8']>;
  BRNHOS?: InputMaybe<Scalars['String']>;
  BRNSYS?: InputMaybe<Scalars['String']>;
  BRNVEN?: InputMaybe<Scalars['String']>;
  BROOMHOS?: InputMaybe<Scalars['String']>;
  BROOMSYS?: InputMaybe<Scalars['String']>;
  BROOMVEN?: InputMaybe<Scalars['String']>;
  BWHTHOS?: InputMaybe<Scalars['String']>;
  BWHTSYS?: InputMaybe<Scalars['String']>;
  BWHTVEN?: InputMaybe<Scalars['String']>;
  CAOSHOS?: InputMaybe<Scalars['String']>;
  CAOSSYS?: InputMaybe<Scalars['String']>;
  CAOSVEN?: InputMaybe<Scalars['String']>;
  CHABHOS?: InputMaybe<Scalars['String']>;
  CHABSYS?: InputMaybe<Scalars['String']>;
  CHABVEN?: InputMaybe<Scalars['String']>;
  CHAPHOS?: InputMaybe<Scalars['String']>;
  CHAPSYS?: InputMaybe<Scalars['String']>;
  CHAPVEN?: InputMaybe<Scalars['String']>;
  CHIHOS?: InputMaybe<Scalars['String']>;
  CHISYS?: InputMaybe<Scalars['String']>;
  CHIVEN?: InputMaybe<Scalars['String']>;
  CHTHHOS?: InputMaybe<Scalars['String']>;
  CHTHSYS?: InputMaybe<Scalars['String']>;
  CHTHVEN?: InputMaybe<Scalars['String']>;
  CICBD?: InputMaybe<Scalars['float8']>;
  CICHOS?: InputMaybe<Scalars['String']>;
  CICSYS?: InputMaybe<Scalars['String']>;
  CICVEN?: InputMaybe<Scalars['String']>;
  CMNGTHOS?: InputMaybe<Scalars['String']>;
  CMNGTSYS?: InputMaybe<Scalars['String']>;
  CMNGTVEN?: InputMaybe<Scalars['String']>;
  COMPHOS?: InputMaybe<Scalars['String']>;
  COMPSYS?: InputMaybe<Scalars['String']>;
  COMPVEN?: InputMaybe<Scalars['String']>;
  COUTRHOS?: InputMaybe<Scalars['String']>;
  COUTRSYS?: InputMaybe<Scalars['String']>;
  COUTRVEN?: InputMaybe<Scalars['String']>;
  CPREVHOS?: InputMaybe<Scalars['String']>;
  CPREVSYS?: InputMaybe<Scalars['String']>;
  CPREVVEN?: InputMaybe<Scalars['String']>;
  CWELLHOS?: InputMaybe<Scalars['String']>;
  CWELLSYS?: InputMaybe<Scalars['String']>;
  CWELLVEN?: InputMaybe<Scalars['String']>;
  DENTSHOS?: InputMaybe<Scalars['String']>;
  DENTSSYS?: InputMaybe<Scalars['String']>;
  DENTSVEN?: InputMaybe<Scalars['String']>;
  DPPHOS?: InputMaybe<Scalars['String']>;
  DPPSYS?: InputMaybe<Scalars['String']>;
  DPPVEN?: InputMaybe<Scalars['String']>;
  EMDEPHOS?: InputMaybe<Scalars['String']>;
  EMDEPSYS?: InputMaybe<Scalars['String']>;
  EMDEPVEN?: InputMaybe<Scalars['String']>;
  EMSSHOS?: InputMaybe<Scalars['String']>;
  EMSSSYS?: InputMaybe<Scalars['String']>;
  EMSSVEN?: InputMaybe<Scalars['String']>;
  ENBHOS?: InputMaybe<Scalars['String']>;
  ENBSYS?: InputMaybe<Scalars['String']>;
  ENBVEN?: InputMaybe<Scalars['String']>;
  ENDOAHOS?: InputMaybe<Scalars['String']>;
  ENDOASYS?: InputMaybe<Scalars['String']>;
  ENDOAVEN?: InputMaybe<Scalars['String']>;
  ENDOCHOS?: InputMaybe<Scalars['String']>;
  ENDOCSYS?: InputMaybe<Scalars['String']>;
  ENDOCVEN?: InputMaybe<Scalars['String']>;
  ENDOEHOS?: InputMaybe<Scalars['String']>;
  ENDOESYS?: InputMaybe<Scalars['String']>;
  ENDOEVEN?: InputMaybe<Scalars['String']>;
  ENDORHOS?: InputMaybe<Scalars['String']>;
  ENDORSYS?: InputMaybe<Scalars['String']>;
  ENDORVEN?: InputMaybe<Scalars['String']>;
  ENDOUHOS?: InputMaybe<Scalars['String']>;
  ENDOUSYS?: InputMaybe<Scalars['String']>;
  ENDOUVEN?: InputMaybe<Scalars['String']>;
  ENRHOS?: InputMaybe<Scalars['String']>;
  ENRSYS?: InputMaybe<Scalars['String']>;
  ENRVEN?: InputMaybe<Scalars['String']>;
  ESWLHOS?: InputMaybe<Scalars['String']>;
  ESWLSYS?: InputMaybe<Scalars['String']>;
  ESWLVEN?: InputMaybe<Scalars['String']>;
  FITCHOS?: InputMaybe<Scalars['String']>;
  FITCSYS?: InputMaybe<Scalars['String']>;
  FITCVEN?: InputMaybe<Scalars['String']>;
  FRTCHOS?: InputMaybe<Scalars['String']>;
  FRTCSYS?: InputMaybe<Scalars['String']>;
  FRTCVEN?: InputMaybe<Scalars['String']>;
  FSERHOS?: InputMaybe<Scalars['String']>;
  FSERSYS?: InputMaybe<Scalars['String']>;
  FSERVEN?: InputMaybe<Scalars['String']>;
  GENBD?: InputMaybe<Scalars['float8']>;
  GENHOS?: InputMaybe<Scalars['String']>;
  GENSYS?: InputMaybe<Scalars['String']>;
  GENVEN?: InputMaybe<Scalars['String']>;
  GERSVHOS?: InputMaybe<Scalars['String']>;
  GERSVSYS?: InputMaybe<Scalars['String']>;
  GERSVVEN?: InputMaybe<Scalars['String']>;
  HOSPBD?: InputMaybe<Scalars['float8']>;
  ICFBD88?: InputMaybe<Scalars['float8']>;
  ICFHOS?: InputMaybe<Scalars['String']>;
  ICFSYS?: InputMaybe<Scalars['String']>;
  ICFVEN?: InputMaybe<Scalars['String']>;
  ICLABHOS?: InputMaybe<Scalars['String']>;
  ICLABSYS?: InputMaybe<Scalars['String']>;
  ICLABVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  MAMMSHOS?: InputMaybe<Scalars['String']>;
  MAMMSSYS?: InputMaybe<Scalars['String']>;
  MAMMSVEN?: InputMaybe<Scalars['String']>;
  MSICBD?: InputMaybe<Scalars['float8']>;
  MSICHOS?: InputMaybe<Scalars['String']>;
  MSICSYS?: InputMaybe<Scalars['String']>;
  MSICVEN?: InputMaybe<Scalars['String']>;
  NICBD?: InputMaybe<Scalars['float8']>;
  NICHOS?: InputMaybe<Scalars['String']>;
  NICSYS?: InputMaybe<Scalars['String']>;
  NICVEN?: InputMaybe<Scalars['String']>;
  NINTBD?: InputMaybe<Scalars['float8']>;
  NINTHOS?: InputMaybe<Scalars['String']>;
  NINTSYS?: InputMaybe<Scalars['String']>;
  NINTVEN?: InputMaybe<Scalars['String']>;
  OBBD?: InputMaybe<Scalars['float8']>;
  OBHOS?: InputMaybe<Scalars['String']>;
  OBLEV?: InputMaybe<Scalars['String']>;
  OBSYS?: InputMaybe<Scalars['String']>;
  OBVEN?: InputMaybe<Scalars['String']>;
  OPCENHOS?: InputMaybe<Scalars['String']>;
  OPCENSYS?: InputMaybe<Scalars['String']>;
  OPCENVEN?: InputMaybe<Scalars['String']>;
  OSPOTH?: InputMaybe<Scalars['String']>;
  OTHBD94?: InputMaybe<Scalars['float8']>;
  OTHCRHOS?: InputMaybe<Scalars['String']>;
  OTHCRSYS?: InputMaybe<Scalars['String']>;
  OTHCRVEN?: InputMaybe<Scalars['String']>;
  OTHIC?: InputMaybe<Scalars['String']>;
  OTHICBD?: InputMaybe<Scalars['float8']>;
  OTHIHOS?: InputMaybe<Scalars['String']>;
  OTHISYS?: InputMaybe<Scalars['String']>;
  OTHIVEN?: InputMaybe<Scalars['String']>;
  OTHLBD94?: InputMaybe<Scalars['float8']>;
  OTHLTHOS?: InputMaybe<Scalars['String']>;
  OTHLTSYS?: InputMaybe<Scalars['String']>;
  OTHLTVEN?: InputMaybe<Scalars['String']>;
  OTHOTH?: InputMaybe<Scalars['String']>;
  PCARDHOS?: InputMaybe<Scalars['String']>;
  PCARDSYS?: InputMaybe<Scalars['String']>;
  PCARDVEN?: InputMaybe<Scalars['String']>;
  PCLABHOS?: InputMaybe<Scalars['String']>;
  PCLABSYS?: InputMaybe<Scalars['String']>;
  PCLABVEN?: InputMaybe<Scalars['String']>;
  PEDBD?: InputMaybe<Scalars['float8']>;
  PEDCSHOS?: InputMaybe<Scalars['String']>;
  PEDCSSYS?: InputMaybe<Scalars['String']>;
  PEDCSVEN?: InputMaybe<Scalars['String']>;
  PEDEHOS?: InputMaybe<Scalars['String']>;
  PEDESYS?: InputMaybe<Scalars['String']>;
  PEDEVEN?: InputMaybe<Scalars['String']>;
  PEDHOS?: InputMaybe<Scalars['String']>;
  PEDICBD?: InputMaybe<Scalars['float8']>;
  PEDICHOS?: InputMaybe<Scalars['String']>;
  PEDICSYS?: InputMaybe<Scalars['String']>;
  PEDICVEN?: InputMaybe<Scalars['String']>;
  PEDSYS?: InputMaybe<Scalars['String']>;
  PEDVEN?: InputMaybe<Scalars['String']>;
  PELABHOS?: InputMaybe<Scalars['String']>;
  PELABSYS?: InputMaybe<Scalars['String']>;
  PELABVEN?: InputMaybe<Scalars['String']>;
  PEMERHOS?: InputMaybe<Scalars['String']>;
  PEMERSYS?: InputMaybe<Scalars['String']>;
  PEMERVEN?: InputMaybe<Scalars['String']>;
  PSYBD?: InputMaybe<Scalars['float8']>;
  PSYHOS?: InputMaybe<Scalars['String']>;
  PSYSYS?: InputMaybe<Scalars['String']>;
  PSYVEN?: InputMaybe<Scalars['String']>;
  REHABBD?: InputMaybe<Scalars['float8']>;
  REHABHOS?: InputMaybe<Scalars['String']>;
  REHABSYS?: InputMaybe<Scalars['String']>;
  REHABVEN?: InputMaybe<Scalars['String']>;
  SNBD88?: InputMaybe<Scalars['float8']>;
  SNHOS?: InputMaybe<Scalars['String']>;
  SNSYS?: InputMaybe<Scalars['String']>;
  SNVEN?: InputMaybe<Scalars['String']>;
  SPCICBD?: InputMaybe<Scalars['float8']>;
  SPCICHOS?: InputMaybe<Scalars['String']>;
  SPCICSYS?: InputMaybe<Scalars['String']>;
  SPCICVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  TRAUMCER?: InputMaybe<Scalars['String']>;
  TRAUMHOS?: InputMaybe<Scalars['String']>;
  TRAUML90?: InputMaybe<Scalars['String']>;
  TRAUMSYS?: InputMaybe<Scalars['String']>;
  TRAUMVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As22Svc1_Sum_Fields = {
  __typename?: 'AS22SVC1_sum_fields';
  ACULTBD: Maybe<Scalars['float8']>;
  AIRBROOM: Maybe<Scalars['float8']>;
  ALCHBD: Maybe<Scalars['float8']>;
  BIOBD: Maybe<Scalars['float8']>;
  BRNBD: Maybe<Scalars['float8']>;
  CICBD: Maybe<Scalars['float8']>;
  GENBD: Maybe<Scalars['float8']>;
  HOSPBD: Maybe<Scalars['float8']>;
  ICFBD88: Maybe<Scalars['float8']>;
  MSICBD: Maybe<Scalars['float8']>;
  NICBD: Maybe<Scalars['float8']>;
  NINTBD: Maybe<Scalars['float8']>;
  OBBD: Maybe<Scalars['float8']>;
  OTHBD94: Maybe<Scalars['float8']>;
  OTHICBD: Maybe<Scalars['float8']>;
  OTHLBD94: Maybe<Scalars['float8']>;
  PEDBD: Maybe<Scalars['float8']>;
  PEDICBD: Maybe<Scalars['float8']>;
  PSYBD: Maybe<Scalars['float8']>;
  REHABBD: Maybe<Scalars['float8']>;
  SNBD88: Maybe<Scalars['float8']>;
  SPCICBD: Maybe<Scalars['float8']>;
};

/** update columns of table "AS22SVC1" */
export enum As22Svc1_Update_Column {
  /** column name */
  Acardhos = 'ACARDHOS',
  /** column name */
  Acardsys = 'ACARDSYS',
  /** column name */
  Acardven = 'ACARDVEN',
  /** column name */
  Aclabhos = 'ACLABHOS',
  /** column name */
  Aclabsys = 'ACLABSYS',
  /** column name */
  Aclabven = 'ACLABVEN',
  /** column name */
  Acuhos = 'ACUHOS',
  /** column name */
  Acultbd = 'ACULTBD',
  /** column name */
  Acusys = 'ACUSYS',
  /** column name */
  Acuven = 'ACUVEN',
  /** column name */
  Adtchos = 'ADTCHOS',
  /** column name */
  Adtcsys = 'ADTCSYS',
  /** column name */
  Adtcven = 'ADTCVEN',
  /** column name */
  Adtehos = 'ADTEHOS',
  /** column name */
  Adtesys = 'ADTESYS',
  /** column name */
  Adteven = 'ADTEVEN',
  /** column name */
  Adulthos = 'ADULTHOS',
  /** column name */
  Adultsys = 'ADULTSYS',
  /** column name */
  Adultven = 'ADULTVEN',
  /** column name */
  Airbhos = 'AIRBHOS',
  /** column name */
  Airbroom = 'AIRBROOM',
  /** column name */
  Airbsys = 'AIRBSYS',
  /** column name */
  Airbven = 'AIRBVEN',
  /** column name */
  Alchbd = 'ALCHBD',
  /** column name */
  Alchhos = 'ALCHHOS',
  /** column name */
  Alchsys = 'ALCHSYS',
  /** column name */
  Alchven = 'ALCHVEN',
  /** column name */
  Alzhos = 'ALZHOS',
  /** column name */
  Alzsys = 'ALZSYS',
  /** column name */
  Alzven = 'ALZVEN',
  /** column name */
  Ambahos = 'AMBAHOS',
  /** column name */
  Ambasys = 'AMBASYS',
  /** column name */
  Ambaven = 'AMBAVEN',
  /** column name */
  Ambhos = 'AMBHOS',
  /** column name */
  Ambshos = 'AMBSHOS',
  /** column name */
  Ambssys = 'AMBSSYS',
  /** column name */
  Ambsven = 'AMBSVEN',
  /** column name */
  Ambsys = 'AMBSYS',
  /** column name */
  Ambven = 'AMBVEN',
  /** column name */
  Arthchos = 'ARTHCHOS',
  /** column name */
  Arthcsys = 'ARTHCSYS',
  /** column name */
  Arthcven = 'ARTHCVEN',
  /** column name */
  Auxhos = 'AUXHOS',
  /** column name */
  Auxsys = 'AUXSYS',
  /** column name */
  Auxven = 'AUXVEN',
  /** column name */
  Biobd = 'BIOBD',
  /** column name */
  Biohos = 'BIOHOS',
  /** column name */
  Biosys = 'BIOSYS',
  /** column name */
  Bioven = 'BIOVEN',
  /** column name */
  Bldohos = 'BLDOHOS',
  /** column name */
  Bldosys = 'BLDOSYS',
  /** column name */
  Bldoven = 'BLDOVEN',
  /** column name */
  Brnbd = 'BRNBD',
  /** column name */
  Brnhos = 'BRNHOS',
  /** column name */
  Brnsys = 'BRNSYS',
  /** column name */
  Brnven = 'BRNVEN',
  /** column name */
  Broomhos = 'BROOMHOS',
  /** column name */
  Broomsys = 'BROOMSYS',
  /** column name */
  Broomven = 'BROOMVEN',
  /** column name */
  Bwhthos = 'BWHTHOS',
  /** column name */
  Bwhtsys = 'BWHTSYS',
  /** column name */
  Bwhtven = 'BWHTVEN',
  /** column name */
  Caoshos = 'CAOSHOS',
  /** column name */
  Caossys = 'CAOSSYS',
  /** column name */
  Caosven = 'CAOSVEN',
  /** column name */
  Chabhos = 'CHABHOS',
  /** column name */
  Chabsys = 'CHABSYS',
  /** column name */
  Chabven = 'CHABVEN',
  /** column name */
  Chaphos = 'CHAPHOS',
  /** column name */
  Chapsys = 'CHAPSYS',
  /** column name */
  Chapven = 'CHAPVEN',
  /** column name */
  Chihos = 'CHIHOS',
  /** column name */
  Chisys = 'CHISYS',
  /** column name */
  Chiven = 'CHIVEN',
  /** column name */
  Chthhos = 'CHTHHOS',
  /** column name */
  Chthsys = 'CHTHSYS',
  /** column name */
  Chthven = 'CHTHVEN',
  /** column name */
  Cicbd = 'CICBD',
  /** column name */
  Cichos = 'CICHOS',
  /** column name */
  Cicsys = 'CICSYS',
  /** column name */
  Cicven = 'CICVEN',
  /** column name */
  Cmngthos = 'CMNGTHOS',
  /** column name */
  Cmngtsys = 'CMNGTSYS',
  /** column name */
  Cmngtven = 'CMNGTVEN',
  /** column name */
  Comphos = 'COMPHOS',
  /** column name */
  Compsys = 'COMPSYS',
  /** column name */
  Compven = 'COMPVEN',
  /** column name */
  Coutrhos = 'COUTRHOS',
  /** column name */
  Coutrsys = 'COUTRSYS',
  /** column name */
  Coutrven = 'COUTRVEN',
  /** column name */
  Cprevhos = 'CPREVHOS',
  /** column name */
  Cprevsys = 'CPREVSYS',
  /** column name */
  Cprevven = 'CPREVVEN',
  /** column name */
  Cwellhos = 'CWELLHOS',
  /** column name */
  Cwellsys = 'CWELLSYS',
  /** column name */
  Cwellven = 'CWELLVEN',
  /** column name */
  Dentshos = 'DENTSHOS',
  /** column name */
  Dentssys = 'DENTSSYS',
  /** column name */
  Dentsven = 'DENTSVEN',
  /** column name */
  Dpphos = 'DPPHOS',
  /** column name */
  Dppsys = 'DPPSYS',
  /** column name */
  Dppven = 'DPPVEN',
  /** column name */
  Emdephos = 'EMDEPHOS',
  /** column name */
  Emdepsys = 'EMDEPSYS',
  /** column name */
  Emdepven = 'EMDEPVEN',
  /** column name */
  Emsshos = 'EMSSHOS',
  /** column name */
  Emsssys = 'EMSSSYS',
  /** column name */
  Emssven = 'EMSSVEN',
  /** column name */
  Enbhos = 'ENBHOS',
  /** column name */
  Enbsys = 'ENBSYS',
  /** column name */
  Enbven = 'ENBVEN',
  /** column name */
  Endoahos = 'ENDOAHOS',
  /** column name */
  Endoasys = 'ENDOASYS',
  /** column name */
  Endoaven = 'ENDOAVEN',
  /** column name */
  Endochos = 'ENDOCHOS',
  /** column name */
  Endocsys = 'ENDOCSYS',
  /** column name */
  Endocven = 'ENDOCVEN',
  /** column name */
  Endoehos = 'ENDOEHOS',
  /** column name */
  Endoesys = 'ENDOESYS',
  /** column name */
  Endoeven = 'ENDOEVEN',
  /** column name */
  Endorhos = 'ENDORHOS',
  /** column name */
  Endorsys = 'ENDORSYS',
  /** column name */
  Endorven = 'ENDORVEN',
  /** column name */
  Endouhos = 'ENDOUHOS',
  /** column name */
  Endousys = 'ENDOUSYS',
  /** column name */
  Endouven = 'ENDOUVEN',
  /** column name */
  Enrhos = 'ENRHOS',
  /** column name */
  Enrsys = 'ENRSYS',
  /** column name */
  Enrven = 'ENRVEN',
  /** column name */
  Eswlhos = 'ESWLHOS',
  /** column name */
  Eswlsys = 'ESWLSYS',
  /** column name */
  Eswlven = 'ESWLVEN',
  /** column name */
  Fitchos = 'FITCHOS',
  /** column name */
  Fitcsys = 'FITCSYS',
  /** column name */
  Fitcven = 'FITCVEN',
  /** column name */
  Frtchos = 'FRTCHOS',
  /** column name */
  Frtcsys = 'FRTCSYS',
  /** column name */
  Frtcven = 'FRTCVEN',
  /** column name */
  Fserhos = 'FSERHOS',
  /** column name */
  Fsersys = 'FSERSYS',
  /** column name */
  Fserven = 'FSERVEN',
  /** column name */
  Genbd = 'GENBD',
  /** column name */
  Genhos = 'GENHOS',
  /** column name */
  Gensys = 'GENSYS',
  /** column name */
  Genven = 'GENVEN',
  /** column name */
  Gersvhos = 'GERSVHOS',
  /** column name */
  Gersvsys = 'GERSVSYS',
  /** column name */
  Gersvven = 'GERSVVEN',
  /** column name */
  Hospbd = 'HOSPBD',
  /** column name */
  Icfbd88 = 'ICFBD88',
  /** column name */
  Icfhos = 'ICFHOS',
  /** column name */
  Icfsys = 'ICFSYS',
  /** column name */
  Icfven = 'ICFVEN',
  /** column name */
  Iclabhos = 'ICLABHOS',
  /** column name */
  Iclabsys = 'ICLABSYS',
  /** column name */
  Iclabven = 'ICLABVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Mammshos = 'MAMMSHOS',
  /** column name */
  Mammssys = 'MAMMSSYS',
  /** column name */
  Mammsven = 'MAMMSVEN',
  /** column name */
  Msicbd = 'MSICBD',
  /** column name */
  Msichos = 'MSICHOS',
  /** column name */
  Msicsys = 'MSICSYS',
  /** column name */
  Msicven = 'MSICVEN',
  /** column name */
  Nicbd = 'NICBD',
  /** column name */
  Nichos = 'NICHOS',
  /** column name */
  Nicsys = 'NICSYS',
  /** column name */
  Nicven = 'NICVEN',
  /** column name */
  Nintbd = 'NINTBD',
  /** column name */
  Ninthos = 'NINTHOS',
  /** column name */
  Nintsys = 'NINTSYS',
  /** column name */
  Nintven = 'NINTVEN',
  /** column name */
  Obbd = 'OBBD',
  /** column name */
  Obhos = 'OBHOS',
  /** column name */
  Oblev = 'OBLEV',
  /** column name */
  Obsys = 'OBSYS',
  /** column name */
  Obven = 'OBVEN',
  /** column name */
  Opcenhos = 'OPCENHOS',
  /** column name */
  Opcensys = 'OPCENSYS',
  /** column name */
  Opcenven = 'OPCENVEN',
  /** column name */
  Ospoth = 'OSPOTH',
  /** column name */
  Othbd94 = 'OTHBD94',
  /** column name */
  Othcrhos = 'OTHCRHOS',
  /** column name */
  Othcrsys = 'OTHCRSYS',
  /** column name */
  Othcrven = 'OTHCRVEN',
  /** column name */
  Othic = 'OTHIC',
  /** column name */
  Othicbd = 'OTHICBD',
  /** column name */
  Othihos = 'OTHIHOS',
  /** column name */
  Othisys = 'OTHISYS',
  /** column name */
  Othiven = 'OTHIVEN',
  /** column name */
  Othlbd94 = 'OTHLBD94',
  /** column name */
  Othlthos = 'OTHLTHOS',
  /** column name */
  Othltsys = 'OTHLTSYS',
  /** column name */
  Othltven = 'OTHLTVEN',
  /** column name */
  Othoth = 'OTHOTH',
  /** column name */
  Pcardhos = 'PCARDHOS',
  /** column name */
  Pcardsys = 'PCARDSYS',
  /** column name */
  Pcardven = 'PCARDVEN',
  /** column name */
  Pclabhos = 'PCLABHOS',
  /** column name */
  Pclabsys = 'PCLABSYS',
  /** column name */
  Pclabven = 'PCLABVEN',
  /** column name */
  Pedbd = 'PEDBD',
  /** column name */
  Pedcshos = 'PEDCSHOS',
  /** column name */
  Pedcssys = 'PEDCSSYS',
  /** column name */
  Pedcsven = 'PEDCSVEN',
  /** column name */
  Pedehos = 'PEDEHOS',
  /** column name */
  Pedesys = 'PEDESYS',
  /** column name */
  Pedeven = 'PEDEVEN',
  /** column name */
  Pedhos = 'PEDHOS',
  /** column name */
  Pedicbd = 'PEDICBD',
  /** column name */
  Pedichos = 'PEDICHOS',
  /** column name */
  Pedicsys = 'PEDICSYS',
  /** column name */
  Pedicven = 'PEDICVEN',
  /** column name */
  Pedsys = 'PEDSYS',
  /** column name */
  Pedven = 'PEDVEN',
  /** column name */
  Pelabhos = 'PELABHOS',
  /** column name */
  Pelabsys = 'PELABSYS',
  /** column name */
  Pelabven = 'PELABVEN',
  /** column name */
  Pemerhos = 'PEMERHOS',
  /** column name */
  Pemersys = 'PEMERSYS',
  /** column name */
  Pemerven = 'PEMERVEN',
  /** column name */
  Psybd = 'PSYBD',
  /** column name */
  Psyhos = 'PSYHOS',
  /** column name */
  Psysys = 'PSYSYS',
  /** column name */
  Psyven = 'PSYVEN',
  /** column name */
  Rehabbd = 'REHABBD',
  /** column name */
  Rehabhos = 'REHABHOS',
  /** column name */
  Rehabsys = 'REHABSYS',
  /** column name */
  Rehabven = 'REHABVEN',
  /** column name */
  Snbd88 = 'SNBD88',
  /** column name */
  Snhos = 'SNHOS',
  /** column name */
  Snsys = 'SNSYS',
  /** column name */
  Snven = 'SNVEN',
  /** column name */
  Spcicbd = 'SPCICBD',
  /** column name */
  Spcichos = 'SPCICHOS',
  /** column name */
  Spcicsys = 'SPCICSYS',
  /** column name */
  Spcicven = 'SPCICVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Traumcer = 'TRAUMCER',
  /** column name */
  Traumhos = 'TRAUMHOS',
  /** column name */
  Trauml90 = 'TRAUML90',
  /** column name */
  Traumsys = 'TRAUMSYS',
  /** column name */
  Traumven = 'TRAUMVEN'
}

export type As22Svc1_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As22Svc1_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Svc1_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Svc1_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As22Svc1_Var_Pop_Fields = {
  __typename?: 'AS22SVC1_var_pop_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As22Svc1_Var_Samp_Fields = {
  __typename?: 'AS22SVC1_var_samp_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As22Svc1_Variance_Fields = {
  __typename?: 'AS22SVC1_variance_fields';
  ACULTBD: Maybe<Scalars['Float']>;
  AIRBROOM: Maybe<Scalars['Float']>;
  ALCHBD: Maybe<Scalars['Float']>;
  BIOBD: Maybe<Scalars['Float']>;
  BRNBD: Maybe<Scalars['Float']>;
  CICBD: Maybe<Scalars['Float']>;
  GENBD: Maybe<Scalars['Float']>;
  HOSPBD: Maybe<Scalars['Float']>;
  ICFBD88: Maybe<Scalars['Float']>;
  MSICBD: Maybe<Scalars['Float']>;
  NICBD: Maybe<Scalars['Float']>;
  NINTBD: Maybe<Scalars['Float']>;
  OBBD: Maybe<Scalars['Float']>;
  OTHBD94: Maybe<Scalars['Float']>;
  OTHICBD: Maybe<Scalars['Float']>;
  OTHLBD94: Maybe<Scalars['Float']>;
  PEDBD: Maybe<Scalars['Float']>;
  PEDICBD: Maybe<Scalars['Float']>;
  PSYBD: Maybe<Scalars['Float']>;
  REHABBD: Maybe<Scalars['Float']>;
  SNBD88: Maybe<Scalars['Float']>;
  SPCICBD: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS22SVC2" */
export type As22Svc2 = {
  __typename?: 'AS22SVC2';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS22SVC2" */
export type As22Svc2_Aggregate = {
  __typename?: 'AS22SVC2_aggregate';
  aggregate: Maybe<As22Svc2_Aggregate_Fields>;
  nodes: Array<As22Svc2>;
};

/** aggregate fields of "AS22SVC2" */
export type As22Svc2_Aggregate_Fields = {
  __typename?: 'AS22SVC2_aggregate_fields';
  avg: Maybe<As22Svc2_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As22Svc2_Max_Fields>;
  min: Maybe<As22Svc2_Min_Fields>;
  stddev: Maybe<As22Svc2_Stddev_Fields>;
  stddev_pop: Maybe<As22Svc2_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As22Svc2_Stddev_Samp_Fields>;
  sum: Maybe<As22Svc2_Sum_Fields>;
  var_pop: Maybe<As22Svc2_Var_Pop_Fields>;
  var_samp: Maybe<As22Svc2_Var_Samp_Fields>;
  variance: Maybe<As22Svc2_Variance_Fields>;
};


/** aggregate fields of "AS22SVC2" */
export type As22Svc2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Svc2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As22Svc2_Avg_Fields = {
  __typename?: 'AS22SVC2_avg_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS22SVC2". All fields are combined with a logical 'AND'. */
export type As22Svc2_Bool_Exp = {
  AIDSSHOS?: InputMaybe<String_Comparison_Exp>;
  AIDSSSYS?: InputMaybe<String_Comparison_Exp>;
  AIDSSVEN?: InputMaybe<String_Comparison_Exp>;
  ASSTLHOS?: InputMaybe<String_Comparison_Exp>;
  ASSTLSYS?: InputMaybe<String_Comparison_Exp>;
  ASSTLVEN?: InputMaybe<String_Comparison_Exp>;
  BEAMHOS?: InputMaybe<String_Comparison_Exp>;
  BEAMSYS?: InputMaybe<String_Comparison_Exp>;
  BEAMVEN?: InputMaybe<String_Comparison_Exp>;
  BRADHOS?: InputMaybe<String_Comparison_Exp>;
  BRADSYS?: InputMaybe<String_Comparison_Exp>;
  BRADVEN?: InputMaybe<String_Comparison_Exp>;
  CTSCNHOS?: InputMaybe<String_Comparison_Exp>;
  CTSCNSYS?: InputMaybe<String_Comparison_Exp>;
  CTSCNVEN?: InputMaybe<String_Comparison_Exp>;
  DRADFHOS?: InputMaybe<String_Comparison_Exp>;
  DRADFSYS?: InputMaybe<String_Comparison_Exp>;
  DRADFVEN?: InputMaybe<String_Comparison_Exp>;
  EBCTHOS?: InputMaybe<String_Comparison_Exp>;
  EBCTSYS?: InputMaybe<String_Comparison_Exp>;
  EBCTVEN?: InputMaybe<String_Comparison_Exp>;
  FFDMHOS?: InputMaybe<String_Comparison_Exp>;
  FFDMSYS?: InputMaybe<String_Comparison_Exp>;
  FFDMVEN?: InputMaybe<String_Comparison_Exp>;
  GNTCHOS?: InputMaybe<String_Comparison_Exp>;
  GNTCSYS?: InputMaybe<String_Comparison_Exp>;
  GNTCVEN?: InputMaybe<String_Comparison_Exp>;
  HEMOHOS?: InputMaybe<String_Comparison_Exp>;
  HEMOSYS?: InputMaybe<String_Comparison_Exp>;
  HEMOVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHCHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHCSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHCVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHFHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHFSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHFVEN?: InputMaybe<String_Comparison_Exp>;
  HLTHSHOS?: InputMaybe<String_Comparison_Exp>;
  HLTHSSYS?: InputMaybe<String_Comparison_Exp>;
  HLTHSVEN?: InputMaybe<String_Comparison_Exp>;
  HLTRHOS?: InputMaybe<String_Comparison_Exp>;
  HLTRSYS?: InputMaybe<String_Comparison_Exp>;
  HLTRVEN?: InputMaybe<String_Comparison_Exp>;
  HOMEHHOS?: InputMaybe<String_Comparison_Exp>;
  HOMEHSYS?: InputMaybe<String_Comparison_Exp>;
  HOMEHVEN?: InputMaybe<String_Comparison_Exp>;
  HOSPCHOS?: InputMaybe<String_Comparison_Exp>;
  HOSPCSYS?: InputMaybe<String_Comparison_Exp>;
  HOSPCVEN?: InputMaybe<String_Comparison_Exp>;
  ICARHOS?: InputMaybe<String_Comparison_Exp>;
  ICARSYS?: InputMaybe<String_Comparison_Exp>;
  ICARVEN?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IGRTHOS?: InputMaybe<String_Comparison_Exp>;
  IGRTSYS?: InputMaybe<String_Comparison_Exp>;
  IGRTVEN?: InputMaybe<String_Comparison_Exp>;
  IMPRHOS?: InputMaybe<String_Comparison_Exp>;
  IMPRSYS?: InputMaybe<String_Comparison_Exp>;
  IMPRVEN?: InputMaybe<String_Comparison_Exp>;
  IMRIHOS?: InputMaybe<String_Comparison_Exp>;
  IMRISYS?: InputMaybe<String_Comparison_Exp>;
  IMRIVEN?: InputMaybe<String_Comparison_Exp>;
  IMRTHOS?: InputMaybe<String_Comparison_Exp>;
  IMRTSYS?: InputMaybe<String_Comparison_Exp>;
  IMRTVEN?: InputMaybe<String_Comparison_Exp>;
  IPALHOS?: InputMaybe<String_Comparison_Exp>;
  IPALSYS?: InputMaybe<String_Comparison_Exp>;
  IPALVEN?: InputMaybe<String_Comparison_Exp>;
  LINGHOS?: InputMaybe<String_Comparison_Exp>;
  LINGSYS?: InputMaybe<String_Comparison_Exp>;
  LINGVEN?: InputMaybe<String_Comparison_Exp>;
  MEALSHOS?: InputMaybe<String_Comparison_Exp>;
  MEALSSYS?: InputMaybe<String_Comparison_Exp>;
  MEALSVEN?: InputMaybe<String_Comparison_Exp>;
  MEGHOS?: InputMaybe<String_Comparison_Exp>;
  MEGSYS?: InputMaybe<String_Comparison_Exp>;
  MEGVEN?: InputMaybe<String_Comparison_Exp>;
  MOHSHOS?: InputMaybe<String_Comparison_Exp>;
  MOHSSYS?: InputMaybe<String_Comparison_Exp>;
  MOHSVEN?: InputMaybe<String_Comparison_Exp>;
  MRIHOS?: InputMaybe<String_Comparison_Exp>;
  MRISYS?: InputMaybe<String_Comparison_Exp>;
  MRIVEN?: InputMaybe<String_Comparison_Exp>;
  MSCTGHOS?: InputMaybe<String_Comparison_Exp>;
  MSCTGSYS?: InputMaybe<String_Comparison_Exp>;
  MSCTGVEN?: InputMaybe<String_Comparison_Exp>;
  MSCTHOS?: InputMaybe<String_Comparison_Exp>;
  MSCTSYS?: InputMaybe<String_Comparison_Exp>;
  MSCTVEN?: InputMaybe<String_Comparison_Exp>;
  NEROHOS?: InputMaybe<String_Comparison_Exp>;
  NEROSYS?: InputMaybe<String_Comparison_Exp>;
  NEROVEN?: InputMaybe<String_Comparison_Exp>;
  NUTRPHOS?: InputMaybe<String_Comparison_Exp>;
  NUTRPSYS?: InputMaybe<String_Comparison_Exp>;
  NUTRPVEN?: InputMaybe<String_Comparison_Exp>;
  OCCHSHOS?: InputMaybe<String_Comparison_Exp>;
  OCCHSSYS?: InputMaybe<String_Comparison_Exp>;
  OCCHSVEN?: InputMaybe<String_Comparison_Exp>;
  ONCOLHOS?: InputMaybe<String_Comparison_Exp>;
  ONCOLSYS?: InputMaybe<String_Comparison_Exp>;
  ONCOLVEN?: InputMaybe<String_Comparison_Exp>;
  OPHOSHOS?: InputMaybe<String_Comparison_Exp>;
  OPHOSSYS?: InputMaybe<String_Comparison_Exp>;
  OPHOSVEN?: InputMaybe<String_Comparison_Exp>;
  OPSRGHOS?: InputMaybe<String_Comparison_Exp>;
  OPSRGSYS?: InputMaybe<String_Comparison_Exp>;
  OPSRGVEN?: InputMaybe<String_Comparison_Exp>;
  ORTOHOS?: InputMaybe<String_Comparison_Exp>;
  ORTOSYS?: InputMaybe<String_Comparison_Exp>;
  ORTOVEN?: InputMaybe<String_Comparison_Exp>;
  PAINHOS?: InputMaybe<String_Comparison_Exp>;
  PAINSYS?: InputMaybe<String_Comparison_Exp>;
  PAINVEN?: InputMaybe<String_Comparison_Exp>;
  PALHOS?: InputMaybe<String_Comparison_Exp>;
  PALSYS?: InputMaybe<String_Comparison_Exp>;
  PALVEN?: InputMaybe<String_Comparison_Exp>;
  PATEDHOS?: InputMaybe<String_Comparison_Exp>;
  PATEDSYS?: InputMaybe<String_Comparison_Exp>;
  PATEDVEN?: InputMaybe<String_Comparison_Exp>;
  PATRPHOS?: InputMaybe<String_Comparison_Exp>;
  PATRPSYS?: InputMaybe<String_Comparison_Exp>;
  PATRPVEN?: InputMaybe<String_Comparison_Exp>;
  PCAHOS?: InputMaybe<String_Comparison_Exp>;
  PCASYS?: InputMaybe<String_Comparison_Exp>;
  PCAVEN?: InputMaybe<String_Comparison_Exp>;
  PCDEPHOS?: InputMaybe<String_Comparison_Exp>;
  PCDEPSYS?: InputMaybe<String_Comparison_Exp>;
  PCDEPVEN?: InputMaybe<String_Comparison_Exp>;
  PETCTHOS?: InputMaybe<String_Comparison_Exp>;
  PETCTSYS?: InputMaybe<String_Comparison_Exp>;
  PETCTVEN?: InputMaybe<String_Comparison_Exp>;
  PETHOS?: InputMaybe<String_Comparison_Exp>;
  PETSYS?: InputMaybe<String_Comparison_Exp>;
  PETVEN?: InputMaybe<String_Comparison_Exp>;
  PPNHOS?: InputMaybe<String_Comparison_Exp>;
  PPNSYS?: InputMaybe<String_Comparison_Exp>;
  PPNVEN?: InputMaybe<String_Comparison_Exp>;
  PSCBD?: InputMaybe<Float8_Comparison_Exp>;
  PSCISHOS?: InputMaybe<String_Comparison_Exp>;
  PSCISSYS?: InputMaybe<String_Comparison_Exp>;
  PSCISVEN?: InputMaybe<String_Comparison_Exp>;
  PSGBD?: InputMaybe<Float8_Comparison_Exp>;
  PSPIHOS?: InputMaybe<String_Comparison_Exp>;
  PSPISYS?: InputMaybe<String_Comparison_Exp>;
  PSPIVEN?: InputMaybe<String_Comparison_Exp>;
  PSSOCHOS?: InputMaybe<String_Comparison_Exp>;
  PSSOCSYS?: InputMaybe<String_Comparison_Exp>;
  PSSOCVEN?: InputMaybe<String_Comparison_Exp>;
  PSYCAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYCASYS?: InputMaybe<String_Comparison_Exp>;
  PSYCAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYEDHOS?: InputMaybe<String_Comparison_Exp>;
  PSYEDSYS?: InputMaybe<String_Comparison_Exp>;
  PSYEDVEN?: InputMaybe<String_Comparison_Exp>;
  PSYEMHOS?: InputMaybe<String_Comparison_Exp>;
  PSYEMSYS?: InputMaybe<String_Comparison_Exp>;
  PSYEMVEN?: InputMaybe<String_Comparison_Exp>;
  PSYGRHOS?: InputMaybe<String_Comparison_Exp>;
  PSYGRSYS?: InputMaybe<String_Comparison_Exp>;
  PSYGRVEN?: InputMaybe<String_Comparison_Exp>;
  PSYLSHOS?: InputMaybe<String_Comparison_Exp>;
  PSYLSSYS?: InputMaybe<String_Comparison_Exp>;
  PSYLSVEN?: InputMaybe<String_Comparison_Exp>;
  PSYOIHOS?: InputMaybe<String_Comparison_Exp>;
  PSYOISYS?: InputMaybe<String_Comparison_Exp>;
  PSYOIVEN?: InputMaybe<String_Comparison_Exp>;
  PSYOPHOS?: InputMaybe<String_Comparison_Exp>;
  PSYOPSYS?: InputMaybe<String_Comparison_Exp>;
  PSYOPVEN?: InputMaybe<String_Comparison_Exp>;
  PSYPHAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYPHASYS?: InputMaybe<String_Comparison_Exp>;
  PSYPHAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYPHCHOS?: InputMaybe<String_Comparison_Exp>;
  PSYPHCSYS?: InputMaybe<String_Comparison_Exp>;
  PSYPHCVEN?: InputMaybe<String_Comparison_Exp>;
  PSYTRAHOS?: InputMaybe<String_Comparison_Exp>;
  PSYTRASYS?: InputMaybe<String_Comparison_Exp>;
  PSYTRAVEN?: InputMaybe<String_Comparison_Exp>;
  PSYTRPHOS?: InputMaybe<String_Comparison_Exp>;
  PSYTRPSYS?: InputMaybe<String_Comparison_Exp>;
  PSYTRPVEN?: InputMaybe<String_Comparison_Exp>;
  PTONHOS?: InputMaybe<String_Comparison_Exp>;
  PTONSYS?: InputMaybe<String_Comparison_Exp>;
  PTONVEN?: InputMaybe<String_Comparison_Exp>;
  RASTHOS?: InputMaybe<String_Comparison_Exp>;
  RASTSYS?: InputMaybe<String_Comparison_Exp>;
  RASTVEN?: InputMaybe<String_Comparison_Exp>;
  RBOTHOS?: InputMaybe<String_Comparison_Exp>;
  RBOTSYS?: InputMaybe<String_Comparison_Exp>;
  RBOTVEN?: InputMaybe<String_Comparison_Exp>;
  REDSHOS?: InputMaybe<String_Comparison_Exp>;
  REDSSYS?: InputMaybe<String_Comparison_Exp>;
  REDSVEN?: InputMaybe<String_Comparison_Exp>;
  RETIRHOS?: InputMaybe<String_Comparison_Exp>;
  RETIRSYS?: InputMaybe<String_Comparison_Exp>;
  RETIRVEN?: InputMaybe<String_Comparison_Exp>;
  RHBOPHOS?: InputMaybe<String_Comparison_Exp>;
  RHBOPSYS?: InputMaybe<String_Comparison_Exp>;
  RHBOPVEN?: InputMaybe<String_Comparison_Exp>;
  ROBOHOS?: InputMaybe<String_Comparison_Exp>;
  ROBOSYS?: InputMaybe<String_Comparison_Exp>;
  ROBOVEN?: InputMaybe<String_Comparison_Exp>;
  RPRSHOS?: InputMaybe<String_Comparison_Exp>;
  RPRSSYS?: InputMaybe<String_Comparison_Exp>;
  RPRSVEN?: InputMaybe<String_Comparison_Exp>;
  RSIMHOS?: InputMaybe<String_Comparison_Exp>;
  RSIMSYS?: InputMaybe<String_Comparison_Exp>;
  RSIMVEN?: InputMaybe<String_Comparison_Exp>;
  SPECTHOS?: InputMaybe<String_Comparison_Exp>;
  SPECTSYS?: InputMaybe<String_Comparison_Exp>;
  SPECTVEN?: InputMaybe<String_Comparison_Exp>;
  SPHSHOS?: InputMaybe<String_Comparison_Exp>;
  SPHSSYS?: InputMaybe<String_Comparison_Exp>;
  SPHSVEN?: InputMaybe<String_Comparison_Exp>;
  SRADHOS?: InputMaybe<String_Comparison_Exp>;
  SRADSYS?: InputMaybe<String_Comparison_Exp>;
  SRADVEN?: InputMaybe<String_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  ULTSNHOS?: InputMaybe<String_Comparison_Exp>;
  ULTSNSYS?: InputMaybe<String_Comparison_Exp>;
  ULTSNVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Svc2_Bool_Exp>>;
  _not?: InputMaybe<As22Svc2_Bool_Exp>;
  _or?: InputMaybe<Array<As22Svc2_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS22SVC2" */
export enum As22Svc2_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Svc2 = 'pk_AS22SVC2'
}

/** input type for incrementing numeric columns in table "AS22SVC2" */
export type As22Svc2_Inc_Input = {
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS22SVC2" */
export type As22Svc2_Insert_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As22Svc2_Max_Fields = {
  __typename?: 'AS22SVC2_max_fields';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As22Svc2_Min_Fields = {
  __typename?: 'AS22SVC2_min_fields';
  AIDSSHOS: Maybe<Scalars['String']>;
  AIDSSSYS: Maybe<Scalars['String']>;
  AIDSSVEN: Maybe<Scalars['String']>;
  ASSTLHOS: Maybe<Scalars['String']>;
  ASSTLSYS: Maybe<Scalars['String']>;
  ASSTLVEN: Maybe<Scalars['String']>;
  BEAMHOS: Maybe<Scalars['String']>;
  BEAMSYS: Maybe<Scalars['String']>;
  BEAMVEN: Maybe<Scalars['String']>;
  BRADHOS: Maybe<Scalars['String']>;
  BRADSYS: Maybe<Scalars['String']>;
  BRADVEN: Maybe<Scalars['String']>;
  CTSCNHOS: Maybe<Scalars['String']>;
  CTSCNSYS: Maybe<Scalars['String']>;
  CTSCNVEN: Maybe<Scalars['String']>;
  DRADFHOS: Maybe<Scalars['String']>;
  DRADFSYS: Maybe<Scalars['String']>;
  DRADFVEN: Maybe<Scalars['String']>;
  EBCTHOS: Maybe<Scalars['String']>;
  EBCTSYS: Maybe<Scalars['String']>;
  EBCTVEN: Maybe<Scalars['String']>;
  FFDMHOS: Maybe<Scalars['String']>;
  FFDMSYS: Maybe<Scalars['String']>;
  FFDMVEN: Maybe<Scalars['String']>;
  GNTCHOS: Maybe<Scalars['String']>;
  GNTCSYS: Maybe<Scalars['String']>;
  GNTCVEN: Maybe<Scalars['String']>;
  HEMOHOS: Maybe<Scalars['String']>;
  HEMOSYS: Maybe<Scalars['String']>;
  HEMOVEN: Maybe<Scalars['String']>;
  HLTHCHOS: Maybe<Scalars['String']>;
  HLTHCSYS: Maybe<Scalars['String']>;
  HLTHCVEN: Maybe<Scalars['String']>;
  HLTHFHOS: Maybe<Scalars['String']>;
  HLTHFSYS: Maybe<Scalars['String']>;
  HLTHFVEN: Maybe<Scalars['String']>;
  HLTHSHOS: Maybe<Scalars['String']>;
  HLTHSSYS: Maybe<Scalars['String']>;
  HLTHSVEN: Maybe<Scalars['String']>;
  HLTRHOS: Maybe<Scalars['String']>;
  HLTRSYS: Maybe<Scalars['String']>;
  HLTRVEN: Maybe<Scalars['String']>;
  HOMEHHOS: Maybe<Scalars['String']>;
  HOMEHSYS: Maybe<Scalars['String']>;
  HOMEHVEN: Maybe<Scalars['String']>;
  HOSPCHOS: Maybe<Scalars['String']>;
  HOSPCSYS: Maybe<Scalars['String']>;
  HOSPCVEN: Maybe<Scalars['String']>;
  ICARHOS: Maybe<Scalars['String']>;
  ICARSYS: Maybe<Scalars['String']>;
  ICARVEN: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IGRTHOS: Maybe<Scalars['String']>;
  IGRTSYS: Maybe<Scalars['String']>;
  IGRTVEN: Maybe<Scalars['String']>;
  IMPRHOS: Maybe<Scalars['String']>;
  IMPRSYS: Maybe<Scalars['String']>;
  IMPRVEN: Maybe<Scalars['String']>;
  IMRIHOS: Maybe<Scalars['String']>;
  IMRISYS: Maybe<Scalars['String']>;
  IMRIVEN: Maybe<Scalars['String']>;
  IMRTHOS: Maybe<Scalars['String']>;
  IMRTSYS: Maybe<Scalars['String']>;
  IMRTVEN: Maybe<Scalars['String']>;
  IPALHOS: Maybe<Scalars['String']>;
  IPALSYS: Maybe<Scalars['String']>;
  IPALVEN: Maybe<Scalars['String']>;
  LINGHOS: Maybe<Scalars['String']>;
  LINGSYS: Maybe<Scalars['String']>;
  LINGVEN: Maybe<Scalars['String']>;
  MEALSHOS: Maybe<Scalars['String']>;
  MEALSSYS: Maybe<Scalars['String']>;
  MEALSVEN: Maybe<Scalars['String']>;
  MEGHOS: Maybe<Scalars['String']>;
  MEGSYS: Maybe<Scalars['String']>;
  MEGVEN: Maybe<Scalars['String']>;
  MOHSHOS: Maybe<Scalars['String']>;
  MOHSSYS: Maybe<Scalars['String']>;
  MOHSVEN: Maybe<Scalars['String']>;
  MRIHOS: Maybe<Scalars['String']>;
  MRISYS: Maybe<Scalars['String']>;
  MRIVEN: Maybe<Scalars['String']>;
  MSCTGHOS: Maybe<Scalars['String']>;
  MSCTGSYS: Maybe<Scalars['String']>;
  MSCTGVEN: Maybe<Scalars['String']>;
  MSCTHOS: Maybe<Scalars['String']>;
  MSCTSYS: Maybe<Scalars['String']>;
  MSCTVEN: Maybe<Scalars['String']>;
  NEROHOS: Maybe<Scalars['String']>;
  NEROSYS: Maybe<Scalars['String']>;
  NEROVEN: Maybe<Scalars['String']>;
  NUTRPHOS: Maybe<Scalars['String']>;
  NUTRPSYS: Maybe<Scalars['String']>;
  NUTRPVEN: Maybe<Scalars['String']>;
  OCCHSHOS: Maybe<Scalars['String']>;
  OCCHSSYS: Maybe<Scalars['String']>;
  OCCHSVEN: Maybe<Scalars['String']>;
  ONCOLHOS: Maybe<Scalars['String']>;
  ONCOLSYS: Maybe<Scalars['String']>;
  ONCOLVEN: Maybe<Scalars['String']>;
  OPHOSHOS: Maybe<Scalars['String']>;
  OPHOSSYS: Maybe<Scalars['String']>;
  OPHOSVEN: Maybe<Scalars['String']>;
  OPSRGHOS: Maybe<Scalars['String']>;
  OPSRGSYS: Maybe<Scalars['String']>;
  OPSRGVEN: Maybe<Scalars['String']>;
  ORTOHOS: Maybe<Scalars['String']>;
  ORTOSYS: Maybe<Scalars['String']>;
  ORTOVEN: Maybe<Scalars['String']>;
  PAINHOS: Maybe<Scalars['String']>;
  PAINSYS: Maybe<Scalars['String']>;
  PAINVEN: Maybe<Scalars['String']>;
  PALHOS: Maybe<Scalars['String']>;
  PALSYS: Maybe<Scalars['String']>;
  PALVEN: Maybe<Scalars['String']>;
  PATEDHOS: Maybe<Scalars['String']>;
  PATEDSYS: Maybe<Scalars['String']>;
  PATEDVEN: Maybe<Scalars['String']>;
  PATRPHOS: Maybe<Scalars['String']>;
  PATRPSYS: Maybe<Scalars['String']>;
  PATRPVEN: Maybe<Scalars['String']>;
  PCAHOS: Maybe<Scalars['String']>;
  PCASYS: Maybe<Scalars['String']>;
  PCAVEN: Maybe<Scalars['String']>;
  PCDEPHOS: Maybe<Scalars['String']>;
  PCDEPSYS: Maybe<Scalars['String']>;
  PCDEPVEN: Maybe<Scalars['String']>;
  PETCTHOS: Maybe<Scalars['String']>;
  PETCTSYS: Maybe<Scalars['String']>;
  PETCTVEN: Maybe<Scalars['String']>;
  PETHOS: Maybe<Scalars['String']>;
  PETSYS: Maybe<Scalars['String']>;
  PETVEN: Maybe<Scalars['String']>;
  PPNHOS: Maybe<Scalars['String']>;
  PPNSYS: Maybe<Scalars['String']>;
  PPNVEN: Maybe<Scalars['String']>;
  PSCBD: Maybe<Scalars['float8']>;
  PSCISHOS: Maybe<Scalars['String']>;
  PSCISSYS: Maybe<Scalars['String']>;
  PSCISVEN: Maybe<Scalars['String']>;
  PSGBD: Maybe<Scalars['float8']>;
  PSPIHOS: Maybe<Scalars['String']>;
  PSPISYS: Maybe<Scalars['String']>;
  PSPIVEN: Maybe<Scalars['String']>;
  PSSOCHOS: Maybe<Scalars['String']>;
  PSSOCSYS: Maybe<Scalars['String']>;
  PSSOCVEN: Maybe<Scalars['String']>;
  PSYCAHOS: Maybe<Scalars['String']>;
  PSYCASYS: Maybe<Scalars['String']>;
  PSYCAVEN: Maybe<Scalars['String']>;
  PSYEDHOS: Maybe<Scalars['String']>;
  PSYEDSYS: Maybe<Scalars['String']>;
  PSYEDVEN: Maybe<Scalars['String']>;
  PSYEMHOS: Maybe<Scalars['String']>;
  PSYEMSYS: Maybe<Scalars['String']>;
  PSYEMVEN: Maybe<Scalars['String']>;
  PSYGRHOS: Maybe<Scalars['String']>;
  PSYGRSYS: Maybe<Scalars['String']>;
  PSYGRVEN: Maybe<Scalars['String']>;
  PSYLSHOS: Maybe<Scalars['String']>;
  PSYLSSYS: Maybe<Scalars['String']>;
  PSYLSVEN: Maybe<Scalars['String']>;
  PSYOIHOS: Maybe<Scalars['String']>;
  PSYOISYS: Maybe<Scalars['String']>;
  PSYOIVEN: Maybe<Scalars['String']>;
  PSYOPHOS: Maybe<Scalars['String']>;
  PSYOPSYS: Maybe<Scalars['String']>;
  PSYOPVEN: Maybe<Scalars['String']>;
  PSYPHAHOS: Maybe<Scalars['String']>;
  PSYPHASYS: Maybe<Scalars['String']>;
  PSYPHAVEN: Maybe<Scalars['String']>;
  PSYPHCHOS: Maybe<Scalars['String']>;
  PSYPHCSYS: Maybe<Scalars['String']>;
  PSYPHCVEN: Maybe<Scalars['String']>;
  PSYTRAHOS: Maybe<Scalars['String']>;
  PSYTRASYS: Maybe<Scalars['String']>;
  PSYTRAVEN: Maybe<Scalars['String']>;
  PSYTRPHOS: Maybe<Scalars['String']>;
  PSYTRPSYS: Maybe<Scalars['String']>;
  PSYTRPVEN: Maybe<Scalars['String']>;
  PTONHOS: Maybe<Scalars['String']>;
  PTONSYS: Maybe<Scalars['String']>;
  PTONVEN: Maybe<Scalars['String']>;
  RASTHOS: Maybe<Scalars['String']>;
  RASTSYS: Maybe<Scalars['String']>;
  RASTVEN: Maybe<Scalars['String']>;
  RBOTHOS: Maybe<Scalars['String']>;
  RBOTSYS: Maybe<Scalars['String']>;
  RBOTVEN: Maybe<Scalars['String']>;
  REDSHOS: Maybe<Scalars['String']>;
  REDSSYS: Maybe<Scalars['String']>;
  REDSVEN: Maybe<Scalars['String']>;
  RETIRHOS: Maybe<Scalars['String']>;
  RETIRSYS: Maybe<Scalars['String']>;
  RETIRVEN: Maybe<Scalars['String']>;
  RHBOPHOS: Maybe<Scalars['String']>;
  RHBOPSYS: Maybe<Scalars['String']>;
  RHBOPVEN: Maybe<Scalars['String']>;
  ROBOHOS: Maybe<Scalars['String']>;
  ROBOSYS: Maybe<Scalars['String']>;
  ROBOVEN: Maybe<Scalars['String']>;
  RPRSHOS: Maybe<Scalars['String']>;
  RPRSSYS: Maybe<Scalars['String']>;
  RPRSVEN: Maybe<Scalars['String']>;
  RSIMHOS: Maybe<Scalars['String']>;
  RSIMSYS: Maybe<Scalars['String']>;
  RSIMVEN: Maybe<Scalars['String']>;
  SPECTHOS: Maybe<Scalars['String']>;
  SPECTSYS: Maybe<Scalars['String']>;
  SPECTVEN: Maybe<Scalars['String']>;
  SPHSHOS: Maybe<Scalars['String']>;
  SPHSSYS: Maybe<Scalars['String']>;
  SPHSVEN: Maybe<Scalars['String']>;
  SRADHOS: Maybe<Scalars['String']>;
  SRADSYS: Maybe<Scalars['String']>;
  SRADVEN: Maybe<Scalars['String']>;
  STCD: Maybe<Scalars['String']>;
  ULTSNHOS: Maybe<Scalars['String']>;
  ULTSNSYS: Maybe<Scalars['String']>;
  ULTSNVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS22SVC2" */
export type As22Svc2_Mutation_Response = {
  __typename?: 'AS22SVC2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Svc2>;
};

/** input type for inserting object relation for remote table "AS22SVC2" */
export type As22Svc2_Obj_Rel_Insert_Input = {
  data: As22Svc2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Svc2_On_Conflict>;
};

/** on_conflict condition type for table "AS22SVC2" */
export type As22Svc2_On_Conflict = {
  constraint: As22Svc2_Constraint;
  update_columns?: Array<As22Svc2_Update_Column>;
  where?: InputMaybe<As22Svc2_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22SVC2". */
export type As22Svc2_Order_By = {
  AIDSSHOS?: InputMaybe<Order_By>;
  AIDSSSYS?: InputMaybe<Order_By>;
  AIDSSVEN?: InputMaybe<Order_By>;
  ASSTLHOS?: InputMaybe<Order_By>;
  ASSTLSYS?: InputMaybe<Order_By>;
  ASSTLVEN?: InputMaybe<Order_By>;
  BEAMHOS?: InputMaybe<Order_By>;
  BEAMSYS?: InputMaybe<Order_By>;
  BEAMVEN?: InputMaybe<Order_By>;
  BRADHOS?: InputMaybe<Order_By>;
  BRADSYS?: InputMaybe<Order_By>;
  BRADVEN?: InputMaybe<Order_By>;
  CTSCNHOS?: InputMaybe<Order_By>;
  CTSCNSYS?: InputMaybe<Order_By>;
  CTSCNVEN?: InputMaybe<Order_By>;
  DRADFHOS?: InputMaybe<Order_By>;
  DRADFSYS?: InputMaybe<Order_By>;
  DRADFVEN?: InputMaybe<Order_By>;
  EBCTHOS?: InputMaybe<Order_By>;
  EBCTSYS?: InputMaybe<Order_By>;
  EBCTVEN?: InputMaybe<Order_By>;
  FFDMHOS?: InputMaybe<Order_By>;
  FFDMSYS?: InputMaybe<Order_By>;
  FFDMVEN?: InputMaybe<Order_By>;
  GNTCHOS?: InputMaybe<Order_By>;
  GNTCSYS?: InputMaybe<Order_By>;
  GNTCVEN?: InputMaybe<Order_By>;
  HEMOHOS?: InputMaybe<Order_By>;
  HEMOSYS?: InputMaybe<Order_By>;
  HEMOVEN?: InputMaybe<Order_By>;
  HLTHCHOS?: InputMaybe<Order_By>;
  HLTHCSYS?: InputMaybe<Order_By>;
  HLTHCVEN?: InputMaybe<Order_By>;
  HLTHFHOS?: InputMaybe<Order_By>;
  HLTHFSYS?: InputMaybe<Order_By>;
  HLTHFVEN?: InputMaybe<Order_By>;
  HLTHSHOS?: InputMaybe<Order_By>;
  HLTHSSYS?: InputMaybe<Order_By>;
  HLTHSVEN?: InputMaybe<Order_By>;
  HLTRHOS?: InputMaybe<Order_By>;
  HLTRSYS?: InputMaybe<Order_By>;
  HLTRVEN?: InputMaybe<Order_By>;
  HOMEHHOS?: InputMaybe<Order_By>;
  HOMEHSYS?: InputMaybe<Order_By>;
  HOMEHVEN?: InputMaybe<Order_By>;
  HOSPCHOS?: InputMaybe<Order_By>;
  HOSPCSYS?: InputMaybe<Order_By>;
  HOSPCVEN?: InputMaybe<Order_By>;
  ICARHOS?: InputMaybe<Order_By>;
  ICARSYS?: InputMaybe<Order_By>;
  ICARVEN?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IGRTHOS?: InputMaybe<Order_By>;
  IGRTSYS?: InputMaybe<Order_By>;
  IGRTVEN?: InputMaybe<Order_By>;
  IMPRHOS?: InputMaybe<Order_By>;
  IMPRSYS?: InputMaybe<Order_By>;
  IMPRVEN?: InputMaybe<Order_By>;
  IMRIHOS?: InputMaybe<Order_By>;
  IMRISYS?: InputMaybe<Order_By>;
  IMRIVEN?: InputMaybe<Order_By>;
  IMRTHOS?: InputMaybe<Order_By>;
  IMRTSYS?: InputMaybe<Order_By>;
  IMRTVEN?: InputMaybe<Order_By>;
  IPALHOS?: InputMaybe<Order_By>;
  IPALSYS?: InputMaybe<Order_By>;
  IPALVEN?: InputMaybe<Order_By>;
  LINGHOS?: InputMaybe<Order_By>;
  LINGSYS?: InputMaybe<Order_By>;
  LINGVEN?: InputMaybe<Order_By>;
  MEALSHOS?: InputMaybe<Order_By>;
  MEALSSYS?: InputMaybe<Order_By>;
  MEALSVEN?: InputMaybe<Order_By>;
  MEGHOS?: InputMaybe<Order_By>;
  MEGSYS?: InputMaybe<Order_By>;
  MEGVEN?: InputMaybe<Order_By>;
  MOHSHOS?: InputMaybe<Order_By>;
  MOHSSYS?: InputMaybe<Order_By>;
  MOHSVEN?: InputMaybe<Order_By>;
  MRIHOS?: InputMaybe<Order_By>;
  MRISYS?: InputMaybe<Order_By>;
  MRIVEN?: InputMaybe<Order_By>;
  MSCTGHOS?: InputMaybe<Order_By>;
  MSCTGSYS?: InputMaybe<Order_By>;
  MSCTGVEN?: InputMaybe<Order_By>;
  MSCTHOS?: InputMaybe<Order_By>;
  MSCTSYS?: InputMaybe<Order_By>;
  MSCTVEN?: InputMaybe<Order_By>;
  NEROHOS?: InputMaybe<Order_By>;
  NEROSYS?: InputMaybe<Order_By>;
  NEROVEN?: InputMaybe<Order_By>;
  NUTRPHOS?: InputMaybe<Order_By>;
  NUTRPSYS?: InputMaybe<Order_By>;
  NUTRPVEN?: InputMaybe<Order_By>;
  OCCHSHOS?: InputMaybe<Order_By>;
  OCCHSSYS?: InputMaybe<Order_By>;
  OCCHSVEN?: InputMaybe<Order_By>;
  ONCOLHOS?: InputMaybe<Order_By>;
  ONCOLSYS?: InputMaybe<Order_By>;
  ONCOLVEN?: InputMaybe<Order_By>;
  OPHOSHOS?: InputMaybe<Order_By>;
  OPHOSSYS?: InputMaybe<Order_By>;
  OPHOSVEN?: InputMaybe<Order_By>;
  OPSRGHOS?: InputMaybe<Order_By>;
  OPSRGSYS?: InputMaybe<Order_By>;
  OPSRGVEN?: InputMaybe<Order_By>;
  ORTOHOS?: InputMaybe<Order_By>;
  ORTOSYS?: InputMaybe<Order_By>;
  ORTOVEN?: InputMaybe<Order_By>;
  PAINHOS?: InputMaybe<Order_By>;
  PAINSYS?: InputMaybe<Order_By>;
  PAINVEN?: InputMaybe<Order_By>;
  PALHOS?: InputMaybe<Order_By>;
  PALSYS?: InputMaybe<Order_By>;
  PALVEN?: InputMaybe<Order_By>;
  PATEDHOS?: InputMaybe<Order_By>;
  PATEDSYS?: InputMaybe<Order_By>;
  PATEDVEN?: InputMaybe<Order_By>;
  PATRPHOS?: InputMaybe<Order_By>;
  PATRPSYS?: InputMaybe<Order_By>;
  PATRPVEN?: InputMaybe<Order_By>;
  PCAHOS?: InputMaybe<Order_By>;
  PCASYS?: InputMaybe<Order_By>;
  PCAVEN?: InputMaybe<Order_By>;
  PCDEPHOS?: InputMaybe<Order_By>;
  PCDEPSYS?: InputMaybe<Order_By>;
  PCDEPVEN?: InputMaybe<Order_By>;
  PETCTHOS?: InputMaybe<Order_By>;
  PETCTSYS?: InputMaybe<Order_By>;
  PETCTVEN?: InputMaybe<Order_By>;
  PETHOS?: InputMaybe<Order_By>;
  PETSYS?: InputMaybe<Order_By>;
  PETVEN?: InputMaybe<Order_By>;
  PPNHOS?: InputMaybe<Order_By>;
  PPNSYS?: InputMaybe<Order_By>;
  PPNVEN?: InputMaybe<Order_By>;
  PSCBD?: InputMaybe<Order_By>;
  PSCISHOS?: InputMaybe<Order_By>;
  PSCISSYS?: InputMaybe<Order_By>;
  PSCISVEN?: InputMaybe<Order_By>;
  PSGBD?: InputMaybe<Order_By>;
  PSPIHOS?: InputMaybe<Order_By>;
  PSPISYS?: InputMaybe<Order_By>;
  PSPIVEN?: InputMaybe<Order_By>;
  PSSOCHOS?: InputMaybe<Order_By>;
  PSSOCSYS?: InputMaybe<Order_By>;
  PSSOCVEN?: InputMaybe<Order_By>;
  PSYCAHOS?: InputMaybe<Order_By>;
  PSYCASYS?: InputMaybe<Order_By>;
  PSYCAVEN?: InputMaybe<Order_By>;
  PSYEDHOS?: InputMaybe<Order_By>;
  PSYEDSYS?: InputMaybe<Order_By>;
  PSYEDVEN?: InputMaybe<Order_By>;
  PSYEMHOS?: InputMaybe<Order_By>;
  PSYEMSYS?: InputMaybe<Order_By>;
  PSYEMVEN?: InputMaybe<Order_By>;
  PSYGRHOS?: InputMaybe<Order_By>;
  PSYGRSYS?: InputMaybe<Order_By>;
  PSYGRVEN?: InputMaybe<Order_By>;
  PSYLSHOS?: InputMaybe<Order_By>;
  PSYLSSYS?: InputMaybe<Order_By>;
  PSYLSVEN?: InputMaybe<Order_By>;
  PSYOIHOS?: InputMaybe<Order_By>;
  PSYOISYS?: InputMaybe<Order_By>;
  PSYOIVEN?: InputMaybe<Order_By>;
  PSYOPHOS?: InputMaybe<Order_By>;
  PSYOPSYS?: InputMaybe<Order_By>;
  PSYOPVEN?: InputMaybe<Order_By>;
  PSYPHAHOS?: InputMaybe<Order_By>;
  PSYPHASYS?: InputMaybe<Order_By>;
  PSYPHAVEN?: InputMaybe<Order_By>;
  PSYPHCHOS?: InputMaybe<Order_By>;
  PSYPHCSYS?: InputMaybe<Order_By>;
  PSYPHCVEN?: InputMaybe<Order_By>;
  PSYTRAHOS?: InputMaybe<Order_By>;
  PSYTRASYS?: InputMaybe<Order_By>;
  PSYTRAVEN?: InputMaybe<Order_By>;
  PSYTRPHOS?: InputMaybe<Order_By>;
  PSYTRPSYS?: InputMaybe<Order_By>;
  PSYTRPVEN?: InputMaybe<Order_By>;
  PTONHOS?: InputMaybe<Order_By>;
  PTONSYS?: InputMaybe<Order_By>;
  PTONVEN?: InputMaybe<Order_By>;
  RASTHOS?: InputMaybe<Order_By>;
  RASTSYS?: InputMaybe<Order_By>;
  RASTVEN?: InputMaybe<Order_By>;
  RBOTHOS?: InputMaybe<Order_By>;
  RBOTSYS?: InputMaybe<Order_By>;
  RBOTVEN?: InputMaybe<Order_By>;
  REDSHOS?: InputMaybe<Order_By>;
  REDSSYS?: InputMaybe<Order_By>;
  REDSVEN?: InputMaybe<Order_By>;
  RETIRHOS?: InputMaybe<Order_By>;
  RETIRSYS?: InputMaybe<Order_By>;
  RETIRVEN?: InputMaybe<Order_By>;
  RHBOPHOS?: InputMaybe<Order_By>;
  RHBOPSYS?: InputMaybe<Order_By>;
  RHBOPVEN?: InputMaybe<Order_By>;
  ROBOHOS?: InputMaybe<Order_By>;
  ROBOSYS?: InputMaybe<Order_By>;
  ROBOVEN?: InputMaybe<Order_By>;
  RPRSHOS?: InputMaybe<Order_By>;
  RPRSSYS?: InputMaybe<Order_By>;
  RPRSVEN?: InputMaybe<Order_By>;
  RSIMHOS?: InputMaybe<Order_By>;
  RSIMSYS?: InputMaybe<Order_By>;
  RSIMVEN?: InputMaybe<Order_By>;
  SPECTHOS?: InputMaybe<Order_By>;
  SPECTSYS?: InputMaybe<Order_By>;
  SPECTVEN?: InputMaybe<Order_By>;
  SPHSHOS?: InputMaybe<Order_By>;
  SPHSSYS?: InputMaybe<Order_By>;
  SPHSVEN?: InputMaybe<Order_By>;
  SRADHOS?: InputMaybe<Order_By>;
  SRADSYS?: InputMaybe<Order_By>;
  SRADVEN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  ULTSNHOS?: InputMaybe<Order_By>;
  ULTSNSYS?: InputMaybe<Order_By>;
  ULTSNVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS22SVC2 */
export type As22Svc2_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22SVC2" */
export enum As22Svc2_Select_Column {
  /** column name */
  Aidsshos = 'AIDSSHOS',
  /** column name */
  Aidsssys = 'AIDSSSYS',
  /** column name */
  Aidssven = 'AIDSSVEN',
  /** column name */
  Asstlhos = 'ASSTLHOS',
  /** column name */
  Asstlsys = 'ASSTLSYS',
  /** column name */
  Asstlven = 'ASSTLVEN',
  /** column name */
  Beamhos = 'BEAMHOS',
  /** column name */
  Beamsys = 'BEAMSYS',
  /** column name */
  Beamven = 'BEAMVEN',
  /** column name */
  Bradhos = 'BRADHOS',
  /** column name */
  Bradsys = 'BRADSYS',
  /** column name */
  Bradven = 'BRADVEN',
  /** column name */
  Ctscnhos = 'CTSCNHOS',
  /** column name */
  Ctscnsys = 'CTSCNSYS',
  /** column name */
  Ctscnven = 'CTSCNVEN',
  /** column name */
  Dradfhos = 'DRADFHOS',
  /** column name */
  Dradfsys = 'DRADFSYS',
  /** column name */
  Dradfven = 'DRADFVEN',
  /** column name */
  Ebcthos = 'EBCTHOS',
  /** column name */
  Ebctsys = 'EBCTSYS',
  /** column name */
  Ebctven = 'EBCTVEN',
  /** column name */
  Ffdmhos = 'FFDMHOS',
  /** column name */
  Ffdmsys = 'FFDMSYS',
  /** column name */
  Ffdmven = 'FFDMVEN',
  /** column name */
  Gntchos = 'GNTCHOS',
  /** column name */
  Gntcsys = 'GNTCSYS',
  /** column name */
  Gntcven = 'GNTCVEN',
  /** column name */
  Hemohos = 'HEMOHOS',
  /** column name */
  Hemosys = 'HEMOSYS',
  /** column name */
  Hemoven = 'HEMOVEN',
  /** column name */
  Hlthchos = 'HLTHCHOS',
  /** column name */
  Hlthcsys = 'HLTHCSYS',
  /** column name */
  Hlthcven = 'HLTHCVEN',
  /** column name */
  Hlthfhos = 'HLTHFHOS',
  /** column name */
  Hlthfsys = 'HLTHFSYS',
  /** column name */
  Hlthfven = 'HLTHFVEN',
  /** column name */
  Hlthshos = 'HLTHSHOS',
  /** column name */
  Hlthssys = 'HLTHSSYS',
  /** column name */
  Hlthsven = 'HLTHSVEN',
  /** column name */
  Hltrhos = 'HLTRHOS',
  /** column name */
  Hltrsys = 'HLTRSYS',
  /** column name */
  Hltrven = 'HLTRVEN',
  /** column name */
  Homehhos = 'HOMEHHOS',
  /** column name */
  Homehsys = 'HOMEHSYS',
  /** column name */
  Homehven = 'HOMEHVEN',
  /** column name */
  Hospchos = 'HOSPCHOS',
  /** column name */
  Hospcsys = 'HOSPCSYS',
  /** column name */
  Hospcven = 'HOSPCVEN',
  /** column name */
  Icarhos = 'ICARHOS',
  /** column name */
  Icarsys = 'ICARSYS',
  /** column name */
  Icarven = 'ICARVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Igrthos = 'IGRTHOS',
  /** column name */
  Igrtsys = 'IGRTSYS',
  /** column name */
  Igrtven = 'IGRTVEN',
  /** column name */
  Imprhos = 'IMPRHOS',
  /** column name */
  Imprsys = 'IMPRSYS',
  /** column name */
  Imprven = 'IMPRVEN',
  /** column name */
  Imrihos = 'IMRIHOS',
  /** column name */
  Imrisys = 'IMRISYS',
  /** column name */
  Imriven = 'IMRIVEN',
  /** column name */
  Imrthos = 'IMRTHOS',
  /** column name */
  Imrtsys = 'IMRTSYS',
  /** column name */
  Imrtven = 'IMRTVEN',
  /** column name */
  Ipalhos = 'IPALHOS',
  /** column name */
  Ipalsys = 'IPALSYS',
  /** column name */
  Ipalven = 'IPALVEN',
  /** column name */
  Linghos = 'LINGHOS',
  /** column name */
  Lingsys = 'LINGSYS',
  /** column name */
  Lingven = 'LINGVEN',
  /** column name */
  Mealshos = 'MEALSHOS',
  /** column name */
  Mealssys = 'MEALSSYS',
  /** column name */
  Mealsven = 'MEALSVEN',
  /** column name */
  Meghos = 'MEGHOS',
  /** column name */
  Megsys = 'MEGSYS',
  /** column name */
  Megven = 'MEGVEN',
  /** column name */
  Mohshos = 'MOHSHOS',
  /** column name */
  Mohssys = 'MOHSSYS',
  /** column name */
  Mohsven = 'MOHSVEN',
  /** column name */
  Mrihos = 'MRIHOS',
  /** column name */
  Mrisys = 'MRISYS',
  /** column name */
  Mriven = 'MRIVEN',
  /** column name */
  Msctghos = 'MSCTGHOS',
  /** column name */
  Msctgsys = 'MSCTGSYS',
  /** column name */
  Msctgven = 'MSCTGVEN',
  /** column name */
  Mscthos = 'MSCTHOS',
  /** column name */
  Msctsys = 'MSCTSYS',
  /** column name */
  Msctven = 'MSCTVEN',
  /** column name */
  Nerohos = 'NEROHOS',
  /** column name */
  Nerosys = 'NEROSYS',
  /** column name */
  Neroven = 'NEROVEN',
  /** column name */
  Nutrphos = 'NUTRPHOS',
  /** column name */
  Nutrpsys = 'NUTRPSYS',
  /** column name */
  Nutrpven = 'NUTRPVEN',
  /** column name */
  Occhshos = 'OCCHSHOS',
  /** column name */
  Occhssys = 'OCCHSSYS',
  /** column name */
  Occhsven = 'OCCHSVEN',
  /** column name */
  Oncolhos = 'ONCOLHOS',
  /** column name */
  Oncolsys = 'ONCOLSYS',
  /** column name */
  Oncolven = 'ONCOLVEN',
  /** column name */
  Ophoshos = 'OPHOSHOS',
  /** column name */
  Ophossys = 'OPHOSSYS',
  /** column name */
  Ophosven = 'OPHOSVEN',
  /** column name */
  Opsrghos = 'OPSRGHOS',
  /** column name */
  Opsrgsys = 'OPSRGSYS',
  /** column name */
  Opsrgven = 'OPSRGVEN',
  /** column name */
  Ortohos = 'ORTOHOS',
  /** column name */
  Ortosys = 'ORTOSYS',
  /** column name */
  Ortoven = 'ORTOVEN',
  /** column name */
  Painhos = 'PAINHOS',
  /** column name */
  Painsys = 'PAINSYS',
  /** column name */
  Painven = 'PAINVEN',
  /** column name */
  Palhos = 'PALHOS',
  /** column name */
  Palsys = 'PALSYS',
  /** column name */
  Palven = 'PALVEN',
  /** column name */
  Patedhos = 'PATEDHOS',
  /** column name */
  Patedsys = 'PATEDSYS',
  /** column name */
  Patedven = 'PATEDVEN',
  /** column name */
  Patrphos = 'PATRPHOS',
  /** column name */
  Patrpsys = 'PATRPSYS',
  /** column name */
  Patrpven = 'PATRPVEN',
  /** column name */
  Pcahos = 'PCAHOS',
  /** column name */
  Pcasys = 'PCASYS',
  /** column name */
  Pcaven = 'PCAVEN',
  /** column name */
  Pcdephos = 'PCDEPHOS',
  /** column name */
  Pcdepsys = 'PCDEPSYS',
  /** column name */
  Pcdepven = 'PCDEPVEN',
  /** column name */
  Petcthos = 'PETCTHOS',
  /** column name */
  Petctsys = 'PETCTSYS',
  /** column name */
  Petctven = 'PETCTVEN',
  /** column name */
  Pethos = 'PETHOS',
  /** column name */
  Petsys = 'PETSYS',
  /** column name */
  Petven = 'PETVEN',
  /** column name */
  Ppnhos = 'PPNHOS',
  /** column name */
  Ppnsys = 'PPNSYS',
  /** column name */
  Ppnven = 'PPNVEN',
  /** column name */
  Pscbd = 'PSCBD',
  /** column name */
  Pscishos = 'PSCISHOS',
  /** column name */
  Pscissys = 'PSCISSYS',
  /** column name */
  Pscisven = 'PSCISVEN',
  /** column name */
  Psgbd = 'PSGBD',
  /** column name */
  Pspihos = 'PSPIHOS',
  /** column name */
  Pspisys = 'PSPISYS',
  /** column name */
  Pspiven = 'PSPIVEN',
  /** column name */
  Pssochos = 'PSSOCHOS',
  /** column name */
  Pssocsys = 'PSSOCSYS',
  /** column name */
  Pssocven = 'PSSOCVEN',
  /** column name */
  Psycahos = 'PSYCAHOS',
  /** column name */
  Psycasys = 'PSYCASYS',
  /** column name */
  Psycaven = 'PSYCAVEN',
  /** column name */
  Psyedhos = 'PSYEDHOS',
  /** column name */
  Psyedsys = 'PSYEDSYS',
  /** column name */
  Psyedven = 'PSYEDVEN',
  /** column name */
  Psyemhos = 'PSYEMHOS',
  /** column name */
  Psyemsys = 'PSYEMSYS',
  /** column name */
  Psyemven = 'PSYEMVEN',
  /** column name */
  Psygrhos = 'PSYGRHOS',
  /** column name */
  Psygrsys = 'PSYGRSYS',
  /** column name */
  Psygrven = 'PSYGRVEN',
  /** column name */
  Psylshos = 'PSYLSHOS',
  /** column name */
  Psylssys = 'PSYLSSYS',
  /** column name */
  Psylsven = 'PSYLSVEN',
  /** column name */
  Psyoihos = 'PSYOIHOS',
  /** column name */
  Psyoisys = 'PSYOISYS',
  /** column name */
  Psyoiven = 'PSYOIVEN',
  /** column name */
  Psyophos = 'PSYOPHOS',
  /** column name */
  Psyopsys = 'PSYOPSYS',
  /** column name */
  Psyopven = 'PSYOPVEN',
  /** column name */
  Psyphahos = 'PSYPHAHOS',
  /** column name */
  Psyphasys = 'PSYPHASYS',
  /** column name */
  Psyphaven = 'PSYPHAVEN',
  /** column name */
  Psyphchos = 'PSYPHCHOS',
  /** column name */
  Psyphcsys = 'PSYPHCSYS',
  /** column name */
  Psyphcven = 'PSYPHCVEN',
  /** column name */
  Psytrahos = 'PSYTRAHOS',
  /** column name */
  Psytrasys = 'PSYTRASYS',
  /** column name */
  Psytraven = 'PSYTRAVEN',
  /** column name */
  Psytrphos = 'PSYTRPHOS',
  /** column name */
  Psytrpsys = 'PSYTRPSYS',
  /** column name */
  Psytrpven = 'PSYTRPVEN',
  /** column name */
  Ptonhos = 'PTONHOS',
  /** column name */
  Ptonsys = 'PTONSYS',
  /** column name */
  Ptonven = 'PTONVEN',
  /** column name */
  Rasthos = 'RASTHOS',
  /** column name */
  Rastsys = 'RASTSYS',
  /** column name */
  Rastven = 'RASTVEN',
  /** column name */
  Rbothos = 'RBOTHOS',
  /** column name */
  Rbotsys = 'RBOTSYS',
  /** column name */
  Rbotven = 'RBOTVEN',
  /** column name */
  Redshos = 'REDSHOS',
  /** column name */
  Redssys = 'REDSSYS',
  /** column name */
  Redsven = 'REDSVEN',
  /** column name */
  Retirhos = 'RETIRHOS',
  /** column name */
  Retirsys = 'RETIRSYS',
  /** column name */
  Retirven = 'RETIRVEN',
  /** column name */
  Rhbophos = 'RHBOPHOS',
  /** column name */
  Rhbopsys = 'RHBOPSYS',
  /** column name */
  Rhbopven = 'RHBOPVEN',
  /** column name */
  Robohos = 'ROBOHOS',
  /** column name */
  Robosys = 'ROBOSYS',
  /** column name */
  Roboven = 'ROBOVEN',
  /** column name */
  Rprshos = 'RPRSHOS',
  /** column name */
  Rprssys = 'RPRSSYS',
  /** column name */
  Rprsven = 'RPRSVEN',
  /** column name */
  Rsimhos = 'RSIMHOS',
  /** column name */
  Rsimsys = 'RSIMSYS',
  /** column name */
  Rsimven = 'RSIMVEN',
  /** column name */
  Specthos = 'SPECTHOS',
  /** column name */
  Spectsys = 'SPECTSYS',
  /** column name */
  Spectven = 'SPECTVEN',
  /** column name */
  Sphshos = 'SPHSHOS',
  /** column name */
  Sphssys = 'SPHSSYS',
  /** column name */
  Sphsven = 'SPHSVEN',
  /** column name */
  Sradhos = 'SRADHOS',
  /** column name */
  Sradsys = 'SRADSYS',
  /** column name */
  Sradven = 'SRADVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Ultsnhos = 'ULTSNHOS',
  /** column name */
  Ultsnsys = 'ULTSNSYS',
  /** column name */
  Ultsnven = 'ULTSNVEN'
}

/** input type for updating data in table "AS22SVC2" */
export type As22Svc2_Set_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As22Svc2_Stddev_Fields = {
  __typename?: 'AS22SVC2_stddev_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As22Svc2_Stddev_Pop_Fields = {
  __typename?: 'AS22SVC2_stddev_pop_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As22Svc2_Stddev_Samp_Fields = {
  __typename?: 'AS22SVC2_stddev_samp_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS22SVC2" */
export type As22Svc2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Svc2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Svc2_Stream_Cursor_Value_Input = {
  AIDSSHOS?: InputMaybe<Scalars['String']>;
  AIDSSSYS?: InputMaybe<Scalars['String']>;
  AIDSSVEN?: InputMaybe<Scalars['String']>;
  ASSTLHOS?: InputMaybe<Scalars['String']>;
  ASSTLSYS?: InputMaybe<Scalars['String']>;
  ASSTLVEN?: InputMaybe<Scalars['String']>;
  BEAMHOS?: InputMaybe<Scalars['String']>;
  BEAMSYS?: InputMaybe<Scalars['String']>;
  BEAMVEN?: InputMaybe<Scalars['String']>;
  BRADHOS?: InputMaybe<Scalars['String']>;
  BRADSYS?: InputMaybe<Scalars['String']>;
  BRADVEN?: InputMaybe<Scalars['String']>;
  CTSCNHOS?: InputMaybe<Scalars['String']>;
  CTSCNSYS?: InputMaybe<Scalars['String']>;
  CTSCNVEN?: InputMaybe<Scalars['String']>;
  DRADFHOS?: InputMaybe<Scalars['String']>;
  DRADFSYS?: InputMaybe<Scalars['String']>;
  DRADFVEN?: InputMaybe<Scalars['String']>;
  EBCTHOS?: InputMaybe<Scalars['String']>;
  EBCTSYS?: InputMaybe<Scalars['String']>;
  EBCTVEN?: InputMaybe<Scalars['String']>;
  FFDMHOS?: InputMaybe<Scalars['String']>;
  FFDMSYS?: InputMaybe<Scalars['String']>;
  FFDMVEN?: InputMaybe<Scalars['String']>;
  GNTCHOS?: InputMaybe<Scalars['String']>;
  GNTCSYS?: InputMaybe<Scalars['String']>;
  GNTCVEN?: InputMaybe<Scalars['String']>;
  HEMOHOS?: InputMaybe<Scalars['String']>;
  HEMOSYS?: InputMaybe<Scalars['String']>;
  HEMOVEN?: InputMaybe<Scalars['String']>;
  HLTHCHOS?: InputMaybe<Scalars['String']>;
  HLTHCSYS?: InputMaybe<Scalars['String']>;
  HLTHCVEN?: InputMaybe<Scalars['String']>;
  HLTHFHOS?: InputMaybe<Scalars['String']>;
  HLTHFSYS?: InputMaybe<Scalars['String']>;
  HLTHFVEN?: InputMaybe<Scalars['String']>;
  HLTHSHOS?: InputMaybe<Scalars['String']>;
  HLTHSSYS?: InputMaybe<Scalars['String']>;
  HLTHSVEN?: InputMaybe<Scalars['String']>;
  HLTRHOS?: InputMaybe<Scalars['String']>;
  HLTRSYS?: InputMaybe<Scalars['String']>;
  HLTRVEN?: InputMaybe<Scalars['String']>;
  HOMEHHOS?: InputMaybe<Scalars['String']>;
  HOMEHSYS?: InputMaybe<Scalars['String']>;
  HOMEHVEN?: InputMaybe<Scalars['String']>;
  HOSPCHOS?: InputMaybe<Scalars['String']>;
  HOSPCSYS?: InputMaybe<Scalars['String']>;
  HOSPCVEN?: InputMaybe<Scalars['String']>;
  ICARHOS?: InputMaybe<Scalars['String']>;
  ICARSYS?: InputMaybe<Scalars['String']>;
  ICARVEN?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IGRTHOS?: InputMaybe<Scalars['String']>;
  IGRTSYS?: InputMaybe<Scalars['String']>;
  IGRTVEN?: InputMaybe<Scalars['String']>;
  IMPRHOS?: InputMaybe<Scalars['String']>;
  IMPRSYS?: InputMaybe<Scalars['String']>;
  IMPRVEN?: InputMaybe<Scalars['String']>;
  IMRIHOS?: InputMaybe<Scalars['String']>;
  IMRISYS?: InputMaybe<Scalars['String']>;
  IMRIVEN?: InputMaybe<Scalars['String']>;
  IMRTHOS?: InputMaybe<Scalars['String']>;
  IMRTSYS?: InputMaybe<Scalars['String']>;
  IMRTVEN?: InputMaybe<Scalars['String']>;
  IPALHOS?: InputMaybe<Scalars['String']>;
  IPALSYS?: InputMaybe<Scalars['String']>;
  IPALVEN?: InputMaybe<Scalars['String']>;
  LINGHOS?: InputMaybe<Scalars['String']>;
  LINGSYS?: InputMaybe<Scalars['String']>;
  LINGVEN?: InputMaybe<Scalars['String']>;
  MEALSHOS?: InputMaybe<Scalars['String']>;
  MEALSSYS?: InputMaybe<Scalars['String']>;
  MEALSVEN?: InputMaybe<Scalars['String']>;
  MEGHOS?: InputMaybe<Scalars['String']>;
  MEGSYS?: InputMaybe<Scalars['String']>;
  MEGVEN?: InputMaybe<Scalars['String']>;
  MOHSHOS?: InputMaybe<Scalars['String']>;
  MOHSSYS?: InputMaybe<Scalars['String']>;
  MOHSVEN?: InputMaybe<Scalars['String']>;
  MRIHOS?: InputMaybe<Scalars['String']>;
  MRISYS?: InputMaybe<Scalars['String']>;
  MRIVEN?: InputMaybe<Scalars['String']>;
  MSCTGHOS?: InputMaybe<Scalars['String']>;
  MSCTGSYS?: InputMaybe<Scalars['String']>;
  MSCTGVEN?: InputMaybe<Scalars['String']>;
  MSCTHOS?: InputMaybe<Scalars['String']>;
  MSCTSYS?: InputMaybe<Scalars['String']>;
  MSCTVEN?: InputMaybe<Scalars['String']>;
  NEROHOS?: InputMaybe<Scalars['String']>;
  NEROSYS?: InputMaybe<Scalars['String']>;
  NEROVEN?: InputMaybe<Scalars['String']>;
  NUTRPHOS?: InputMaybe<Scalars['String']>;
  NUTRPSYS?: InputMaybe<Scalars['String']>;
  NUTRPVEN?: InputMaybe<Scalars['String']>;
  OCCHSHOS?: InputMaybe<Scalars['String']>;
  OCCHSSYS?: InputMaybe<Scalars['String']>;
  OCCHSVEN?: InputMaybe<Scalars['String']>;
  ONCOLHOS?: InputMaybe<Scalars['String']>;
  ONCOLSYS?: InputMaybe<Scalars['String']>;
  ONCOLVEN?: InputMaybe<Scalars['String']>;
  OPHOSHOS?: InputMaybe<Scalars['String']>;
  OPHOSSYS?: InputMaybe<Scalars['String']>;
  OPHOSVEN?: InputMaybe<Scalars['String']>;
  OPSRGHOS?: InputMaybe<Scalars['String']>;
  OPSRGSYS?: InputMaybe<Scalars['String']>;
  OPSRGVEN?: InputMaybe<Scalars['String']>;
  ORTOHOS?: InputMaybe<Scalars['String']>;
  ORTOSYS?: InputMaybe<Scalars['String']>;
  ORTOVEN?: InputMaybe<Scalars['String']>;
  PAINHOS?: InputMaybe<Scalars['String']>;
  PAINSYS?: InputMaybe<Scalars['String']>;
  PAINVEN?: InputMaybe<Scalars['String']>;
  PALHOS?: InputMaybe<Scalars['String']>;
  PALSYS?: InputMaybe<Scalars['String']>;
  PALVEN?: InputMaybe<Scalars['String']>;
  PATEDHOS?: InputMaybe<Scalars['String']>;
  PATEDSYS?: InputMaybe<Scalars['String']>;
  PATEDVEN?: InputMaybe<Scalars['String']>;
  PATRPHOS?: InputMaybe<Scalars['String']>;
  PATRPSYS?: InputMaybe<Scalars['String']>;
  PATRPVEN?: InputMaybe<Scalars['String']>;
  PCAHOS?: InputMaybe<Scalars['String']>;
  PCASYS?: InputMaybe<Scalars['String']>;
  PCAVEN?: InputMaybe<Scalars['String']>;
  PCDEPHOS?: InputMaybe<Scalars['String']>;
  PCDEPSYS?: InputMaybe<Scalars['String']>;
  PCDEPVEN?: InputMaybe<Scalars['String']>;
  PETCTHOS?: InputMaybe<Scalars['String']>;
  PETCTSYS?: InputMaybe<Scalars['String']>;
  PETCTVEN?: InputMaybe<Scalars['String']>;
  PETHOS?: InputMaybe<Scalars['String']>;
  PETSYS?: InputMaybe<Scalars['String']>;
  PETVEN?: InputMaybe<Scalars['String']>;
  PPNHOS?: InputMaybe<Scalars['String']>;
  PPNSYS?: InputMaybe<Scalars['String']>;
  PPNVEN?: InputMaybe<Scalars['String']>;
  PSCBD?: InputMaybe<Scalars['float8']>;
  PSCISHOS?: InputMaybe<Scalars['String']>;
  PSCISSYS?: InputMaybe<Scalars['String']>;
  PSCISVEN?: InputMaybe<Scalars['String']>;
  PSGBD?: InputMaybe<Scalars['float8']>;
  PSPIHOS?: InputMaybe<Scalars['String']>;
  PSPISYS?: InputMaybe<Scalars['String']>;
  PSPIVEN?: InputMaybe<Scalars['String']>;
  PSSOCHOS?: InputMaybe<Scalars['String']>;
  PSSOCSYS?: InputMaybe<Scalars['String']>;
  PSSOCVEN?: InputMaybe<Scalars['String']>;
  PSYCAHOS?: InputMaybe<Scalars['String']>;
  PSYCASYS?: InputMaybe<Scalars['String']>;
  PSYCAVEN?: InputMaybe<Scalars['String']>;
  PSYEDHOS?: InputMaybe<Scalars['String']>;
  PSYEDSYS?: InputMaybe<Scalars['String']>;
  PSYEDVEN?: InputMaybe<Scalars['String']>;
  PSYEMHOS?: InputMaybe<Scalars['String']>;
  PSYEMSYS?: InputMaybe<Scalars['String']>;
  PSYEMVEN?: InputMaybe<Scalars['String']>;
  PSYGRHOS?: InputMaybe<Scalars['String']>;
  PSYGRSYS?: InputMaybe<Scalars['String']>;
  PSYGRVEN?: InputMaybe<Scalars['String']>;
  PSYLSHOS?: InputMaybe<Scalars['String']>;
  PSYLSSYS?: InputMaybe<Scalars['String']>;
  PSYLSVEN?: InputMaybe<Scalars['String']>;
  PSYOIHOS?: InputMaybe<Scalars['String']>;
  PSYOISYS?: InputMaybe<Scalars['String']>;
  PSYOIVEN?: InputMaybe<Scalars['String']>;
  PSYOPHOS?: InputMaybe<Scalars['String']>;
  PSYOPSYS?: InputMaybe<Scalars['String']>;
  PSYOPVEN?: InputMaybe<Scalars['String']>;
  PSYPHAHOS?: InputMaybe<Scalars['String']>;
  PSYPHASYS?: InputMaybe<Scalars['String']>;
  PSYPHAVEN?: InputMaybe<Scalars['String']>;
  PSYPHCHOS?: InputMaybe<Scalars['String']>;
  PSYPHCSYS?: InputMaybe<Scalars['String']>;
  PSYPHCVEN?: InputMaybe<Scalars['String']>;
  PSYTRAHOS?: InputMaybe<Scalars['String']>;
  PSYTRASYS?: InputMaybe<Scalars['String']>;
  PSYTRAVEN?: InputMaybe<Scalars['String']>;
  PSYTRPHOS?: InputMaybe<Scalars['String']>;
  PSYTRPSYS?: InputMaybe<Scalars['String']>;
  PSYTRPVEN?: InputMaybe<Scalars['String']>;
  PTONHOS?: InputMaybe<Scalars['String']>;
  PTONSYS?: InputMaybe<Scalars['String']>;
  PTONVEN?: InputMaybe<Scalars['String']>;
  RASTHOS?: InputMaybe<Scalars['String']>;
  RASTSYS?: InputMaybe<Scalars['String']>;
  RASTVEN?: InputMaybe<Scalars['String']>;
  RBOTHOS?: InputMaybe<Scalars['String']>;
  RBOTSYS?: InputMaybe<Scalars['String']>;
  RBOTVEN?: InputMaybe<Scalars['String']>;
  REDSHOS?: InputMaybe<Scalars['String']>;
  REDSSYS?: InputMaybe<Scalars['String']>;
  REDSVEN?: InputMaybe<Scalars['String']>;
  RETIRHOS?: InputMaybe<Scalars['String']>;
  RETIRSYS?: InputMaybe<Scalars['String']>;
  RETIRVEN?: InputMaybe<Scalars['String']>;
  RHBOPHOS?: InputMaybe<Scalars['String']>;
  RHBOPSYS?: InputMaybe<Scalars['String']>;
  RHBOPVEN?: InputMaybe<Scalars['String']>;
  ROBOHOS?: InputMaybe<Scalars['String']>;
  ROBOSYS?: InputMaybe<Scalars['String']>;
  ROBOVEN?: InputMaybe<Scalars['String']>;
  RPRSHOS?: InputMaybe<Scalars['String']>;
  RPRSSYS?: InputMaybe<Scalars['String']>;
  RPRSVEN?: InputMaybe<Scalars['String']>;
  RSIMHOS?: InputMaybe<Scalars['String']>;
  RSIMSYS?: InputMaybe<Scalars['String']>;
  RSIMVEN?: InputMaybe<Scalars['String']>;
  SPECTHOS?: InputMaybe<Scalars['String']>;
  SPECTSYS?: InputMaybe<Scalars['String']>;
  SPECTVEN?: InputMaybe<Scalars['String']>;
  SPHSHOS?: InputMaybe<Scalars['String']>;
  SPHSSYS?: InputMaybe<Scalars['String']>;
  SPHSVEN?: InputMaybe<Scalars['String']>;
  SRADHOS?: InputMaybe<Scalars['String']>;
  SRADSYS?: InputMaybe<Scalars['String']>;
  SRADVEN?: InputMaybe<Scalars['String']>;
  STCD?: InputMaybe<Scalars['String']>;
  ULTSNHOS?: InputMaybe<Scalars['String']>;
  ULTSNSYS?: InputMaybe<Scalars['String']>;
  ULTSNVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As22Svc2_Sum_Fields = {
  __typename?: 'AS22SVC2_sum_fields';
  PSCBD: Maybe<Scalars['float8']>;
  PSGBD: Maybe<Scalars['float8']>;
};

/** update columns of table "AS22SVC2" */
export enum As22Svc2_Update_Column {
  /** column name */
  Aidsshos = 'AIDSSHOS',
  /** column name */
  Aidsssys = 'AIDSSSYS',
  /** column name */
  Aidssven = 'AIDSSVEN',
  /** column name */
  Asstlhos = 'ASSTLHOS',
  /** column name */
  Asstlsys = 'ASSTLSYS',
  /** column name */
  Asstlven = 'ASSTLVEN',
  /** column name */
  Beamhos = 'BEAMHOS',
  /** column name */
  Beamsys = 'BEAMSYS',
  /** column name */
  Beamven = 'BEAMVEN',
  /** column name */
  Bradhos = 'BRADHOS',
  /** column name */
  Bradsys = 'BRADSYS',
  /** column name */
  Bradven = 'BRADVEN',
  /** column name */
  Ctscnhos = 'CTSCNHOS',
  /** column name */
  Ctscnsys = 'CTSCNSYS',
  /** column name */
  Ctscnven = 'CTSCNVEN',
  /** column name */
  Dradfhos = 'DRADFHOS',
  /** column name */
  Dradfsys = 'DRADFSYS',
  /** column name */
  Dradfven = 'DRADFVEN',
  /** column name */
  Ebcthos = 'EBCTHOS',
  /** column name */
  Ebctsys = 'EBCTSYS',
  /** column name */
  Ebctven = 'EBCTVEN',
  /** column name */
  Ffdmhos = 'FFDMHOS',
  /** column name */
  Ffdmsys = 'FFDMSYS',
  /** column name */
  Ffdmven = 'FFDMVEN',
  /** column name */
  Gntchos = 'GNTCHOS',
  /** column name */
  Gntcsys = 'GNTCSYS',
  /** column name */
  Gntcven = 'GNTCVEN',
  /** column name */
  Hemohos = 'HEMOHOS',
  /** column name */
  Hemosys = 'HEMOSYS',
  /** column name */
  Hemoven = 'HEMOVEN',
  /** column name */
  Hlthchos = 'HLTHCHOS',
  /** column name */
  Hlthcsys = 'HLTHCSYS',
  /** column name */
  Hlthcven = 'HLTHCVEN',
  /** column name */
  Hlthfhos = 'HLTHFHOS',
  /** column name */
  Hlthfsys = 'HLTHFSYS',
  /** column name */
  Hlthfven = 'HLTHFVEN',
  /** column name */
  Hlthshos = 'HLTHSHOS',
  /** column name */
  Hlthssys = 'HLTHSSYS',
  /** column name */
  Hlthsven = 'HLTHSVEN',
  /** column name */
  Hltrhos = 'HLTRHOS',
  /** column name */
  Hltrsys = 'HLTRSYS',
  /** column name */
  Hltrven = 'HLTRVEN',
  /** column name */
  Homehhos = 'HOMEHHOS',
  /** column name */
  Homehsys = 'HOMEHSYS',
  /** column name */
  Homehven = 'HOMEHVEN',
  /** column name */
  Hospchos = 'HOSPCHOS',
  /** column name */
  Hospcsys = 'HOSPCSYS',
  /** column name */
  Hospcven = 'HOSPCVEN',
  /** column name */
  Icarhos = 'ICARHOS',
  /** column name */
  Icarsys = 'ICARSYS',
  /** column name */
  Icarven = 'ICARVEN',
  /** column name */
  Id = 'ID',
  /** column name */
  Igrthos = 'IGRTHOS',
  /** column name */
  Igrtsys = 'IGRTSYS',
  /** column name */
  Igrtven = 'IGRTVEN',
  /** column name */
  Imprhos = 'IMPRHOS',
  /** column name */
  Imprsys = 'IMPRSYS',
  /** column name */
  Imprven = 'IMPRVEN',
  /** column name */
  Imrihos = 'IMRIHOS',
  /** column name */
  Imrisys = 'IMRISYS',
  /** column name */
  Imriven = 'IMRIVEN',
  /** column name */
  Imrthos = 'IMRTHOS',
  /** column name */
  Imrtsys = 'IMRTSYS',
  /** column name */
  Imrtven = 'IMRTVEN',
  /** column name */
  Ipalhos = 'IPALHOS',
  /** column name */
  Ipalsys = 'IPALSYS',
  /** column name */
  Ipalven = 'IPALVEN',
  /** column name */
  Linghos = 'LINGHOS',
  /** column name */
  Lingsys = 'LINGSYS',
  /** column name */
  Lingven = 'LINGVEN',
  /** column name */
  Mealshos = 'MEALSHOS',
  /** column name */
  Mealssys = 'MEALSSYS',
  /** column name */
  Mealsven = 'MEALSVEN',
  /** column name */
  Meghos = 'MEGHOS',
  /** column name */
  Megsys = 'MEGSYS',
  /** column name */
  Megven = 'MEGVEN',
  /** column name */
  Mohshos = 'MOHSHOS',
  /** column name */
  Mohssys = 'MOHSSYS',
  /** column name */
  Mohsven = 'MOHSVEN',
  /** column name */
  Mrihos = 'MRIHOS',
  /** column name */
  Mrisys = 'MRISYS',
  /** column name */
  Mriven = 'MRIVEN',
  /** column name */
  Msctghos = 'MSCTGHOS',
  /** column name */
  Msctgsys = 'MSCTGSYS',
  /** column name */
  Msctgven = 'MSCTGVEN',
  /** column name */
  Mscthos = 'MSCTHOS',
  /** column name */
  Msctsys = 'MSCTSYS',
  /** column name */
  Msctven = 'MSCTVEN',
  /** column name */
  Nerohos = 'NEROHOS',
  /** column name */
  Nerosys = 'NEROSYS',
  /** column name */
  Neroven = 'NEROVEN',
  /** column name */
  Nutrphos = 'NUTRPHOS',
  /** column name */
  Nutrpsys = 'NUTRPSYS',
  /** column name */
  Nutrpven = 'NUTRPVEN',
  /** column name */
  Occhshos = 'OCCHSHOS',
  /** column name */
  Occhssys = 'OCCHSSYS',
  /** column name */
  Occhsven = 'OCCHSVEN',
  /** column name */
  Oncolhos = 'ONCOLHOS',
  /** column name */
  Oncolsys = 'ONCOLSYS',
  /** column name */
  Oncolven = 'ONCOLVEN',
  /** column name */
  Ophoshos = 'OPHOSHOS',
  /** column name */
  Ophossys = 'OPHOSSYS',
  /** column name */
  Ophosven = 'OPHOSVEN',
  /** column name */
  Opsrghos = 'OPSRGHOS',
  /** column name */
  Opsrgsys = 'OPSRGSYS',
  /** column name */
  Opsrgven = 'OPSRGVEN',
  /** column name */
  Ortohos = 'ORTOHOS',
  /** column name */
  Ortosys = 'ORTOSYS',
  /** column name */
  Ortoven = 'ORTOVEN',
  /** column name */
  Painhos = 'PAINHOS',
  /** column name */
  Painsys = 'PAINSYS',
  /** column name */
  Painven = 'PAINVEN',
  /** column name */
  Palhos = 'PALHOS',
  /** column name */
  Palsys = 'PALSYS',
  /** column name */
  Palven = 'PALVEN',
  /** column name */
  Patedhos = 'PATEDHOS',
  /** column name */
  Patedsys = 'PATEDSYS',
  /** column name */
  Patedven = 'PATEDVEN',
  /** column name */
  Patrphos = 'PATRPHOS',
  /** column name */
  Patrpsys = 'PATRPSYS',
  /** column name */
  Patrpven = 'PATRPVEN',
  /** column name */
  Pcahos = 'PCAHOS',
  /** column name */
  Pcasys = 'PCASYS',
  /** column name */
  Pcaven = 'PCAVEN',
  /** column name */
  Pcdephos = 'PCDEPHOS',
  /** column name */
  Pcdepsys = 'PCDEPSYS',
  /** column name */
  Pcdepven = 'PCDEPVEN',
  /** column name */
  Petcthos = 'PETCTHOS',
  /** column name */
  Petctsys = 'PETCTSYS',
  /** column name */
  Petctven = 'PETCTVEN',
  /** column name */
  Pethos = 'PETHOS',
  /** column name */
  Petsys = 'PETSYS',
  /** column name */
  Petven = 'PETVEN',
  /** column name */
  Ppnhos = 'PPNHOS',
  /** column name */
  Ppnsys = 'PPNSYS',
  /** column name */
  Ppnven = 'PPNVEN',
  /** column name */
  Pscbd = 'PSCBD',
  /** column name */
  Pscishos = 'PSCISHOS',
  /** column name */
  Pscissys = 'PSCISSYS',
  /** column name */
  Pscisven = 'PSCISVEN',
  /** column name */
  Psgbd = 'PSGBD',
  /** column name */
  Pspihos = 'PSPIHOS',
  /** column name */
  Pspisys = 'PSPISYS',
  /** column name */
  Pspiven = 'PSPIVEN',
  /** column name */
  Pssochos = 'PSSOCHOS',
  /** column name */
  Pssocsys = 'PSSOCSYS',
  /** column name */
  Pssocven = 'PSSOCVEN',
  /** column name */
  Psycahos = 'PSYCAHOS',
  /** column name */
  Psycasys = 'PSYCASYS',
  /** column name */
  Psycaven = 'PSYCAVEN',
  /** column name */
  Psyedhos = 'PSYEDHOS',
  /** column name */
  Psyedsys = 'PSYEDSYS',
  /** column name */
  Psyedven = 'PSYEDVEN',
  /** column name */
  Psyemhos = 'PSYEMHOS',
  /** column name */
  Psyemsys = 'PSYEMSYS',
  /** column name */
  Psyemven = 'PSYEMVEN',
  /** column name */
  Psygrhos = 'PSYGRHOS',
  /** column name */
  Psygrsys = 'PSYGRSYS',
  /** column name */
  Psygrven = 'PSYGRVEN',
  /** column name */
  Psylshos = 'PSYLSHOS',
  /** column name */
  Psylssys = 'PSYLSSYS',
  /** column name */
  Psylsven = 'PSYLSVEN',
  /** column name */
  Psyoihos = 'PSYOIHOS',
  /** column name */
  Psyoisys = 'PSYOISYS',
  /** column name */
  Psyoiven = 'PSYOIVEN',
  /** column name */
  Psyophos = 'PSYOPHOS',
  /** column name */
  Psyopsys = 'PSYOPSYS',
  /** column name */
  Psyopven = 'PSYOPVEN',
  /** column name */
  Psyphahos = 'PSYPHAHOS',
  /** column name */
  Psyphasys = 'PSYPHASYS',
  /** column name */
  Psyphaven = 'PSYPHAVEN',
  /** column name */
  Psyphchos = 'PSYPHCHOS',
  /** column name */
  Psyphcsys = 'PSYPHCSYS',
  /** column name */
  Psyphcven = 'PSYPHCVEN',
  /** column name */
  Psytrahos = 'PSYTRAHOS',
  /** column name */
  Psytrasys = 'PSYTRASYS',
  /** column name */
  Psytraven = 'PSYTRAVEN',
  /** column name */
  Psytrphos = 'PSYTRPHOS',
  /** column name */
  Psytrpsys = 'PSYTRPSYS',
  /** column name */
  Psytrpven = 'PSYTRPVEN',
  /** column name */
  Ptonhos = 'PTONHOS',
  /** column name */
  Ptonsys = 'PTONSYS',
  /** column name */
  Ptonven = 'PTONVEN',
  /** column name */
  Rasthos = 'RASTHOS',
  /** column name */
  Rastsys = 'RASTSYS',
  /** column name */
  Rastven = 'RASTVEN',
  /** column name */
  Rbothos = 'RBOTHOS',
  /** column name */
  Rbotsys = 'RBOTSYS',
  /** column name */
  Rbotven = 'RBOTVEN',
  /** column name */
  Redshos = 'REDSHOS',
  /** column name */
  Redssys = 'REDSSYS',
  /** column name */
  Redsven = 'REDSVEN',
  /** column name */
  Retirhos = 'RETIRHOS',
  /** column name */
  Retirsys = 'RETIRSYS',
  /** column name */
  Retirven = 'RETIRVEN',
  /** column name */
  Rhbophos = 'RHBOPHOS',
  /** column name */
  Rhbopsys = 'RHBOPSYS',
  /** column name */
  Rhbopven = 'RHBOPVEN',
  /** column name */
  Robohos = 'ROBOHOS',
  /** column name */
  Robosys = 'ROBOSYS',
  /** column name */
  Roboven = 'ROBOVEN',
  /** column name */
  Rprshos = 'RPRSHOS',
  /** column name */
  Rprssys = 'RPRSSYS',
  /** column name */
  Rprsven = 'RPRSVEN',
  /** column name */
  Rsimhos = 'RSIMHOS',
  /** column name */
  Rsimsys = 'RSIMSYS',
  /** column name */
  Rsimven = 'RSIMVEN',
  /** column name */
  Specthos = 'SPECTHOS',
  /** column name */
  Spectsys = 'SPECTSYS',
  /** column name */
  Spectven = 'SPECTVEN',
  /** column name */
  Sphshos = 'SPHSHOS',
  /** column name */
  Sphssys = 'SPHSSYS',
  /** column name */
  Sphsven = 'SPHSVEN',
  /** column name */
  Sradhos = 'SRADHOS',
  /** column name */
  Sradsys = 'SRADSYS',
  /** column name */
  Sradven = 'SRADVEN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Ultsnhos = 'ULTSNHOS',
  /** column name */
  Ultsnsys = 'ULTSNSYS',
  /** column name */
  Ultsnven = 'ULTSNVEN'
}

export type As22Svc2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As22Svc2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Svc2_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Svc2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As22Svc2_Var_Pop_Fields = {
  __typename?: 'AS22SVC2_var_pop_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As22Svc2_Var_Samp_Fields = {
  __typename?: 'AS22SVC2_var_samp_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As22Svc2_Variance_Fields = {
  __typename?: 'AS22SVC2_variance_fields';
  PSCBD: Maybe<Scalars['Float']>;
  PSGBD: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS22SVC3" */
export type As22Svc3 = {
  __typename?: 'AS22SVC3';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHLTA: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHACAR: Maybe<Scalars['String']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  CHER: Maybe<Scalars['String']>;
  CHPCS: Maybe<Scalars['String']>;
  CHXCAR: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  DHACAR: Maybe<Scalars['String']>;
  DHER: Maybe<Scalars['String']>;
  DHPCS: Maybe<Scalars['String']>;
  DHXCAR: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDMCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GNONE: Maybe<Scalars['String']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ICUCHG: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STFCHG: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** aggregated selection of "AS22SVC3" */
export type As22Svc3_Aggregate = {
  __typename?: 'AS22SVC3_aggregate';
  aggregate: Maybe<As22Svc3_Aggregate_Fields>;
  nodes: Array<As22Svc3>;
};

/** aggregate fields of "AS22SVC3" */
export type As22Svc3_Aggregate_Fields = {
  __typename?: 'AS22SVC3_aggregate_fields';
  avg: Maybe<As22Svc3_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As22Svc3_Max_Fields>;
  min: Maybe<As22Svc3_Min_Fields>;
  stddev: Maybe<As22Svc3_Stddev_Fields>;
  stddev_pop: Maybe<As22Svc3_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As22Svc3_Stddev_Samp_Fields>;
  sum: Maybe<As22Svc3_Sum_Fields>;
  var_pop: Maybe<As22Svc3_Var_Pop_Fields>;
  var_samp: Maybe<As22Svc3_Var_Samp_Fields>;
  variance: Maybe<As22Svc3_Variance_Fields>;
};


/** aggregate fields of "AS22SVC3" */
export type As22Svc3_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Svc3_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As22Svc3_Avg_Fields = {
  __typename?: 'AS22SVC3_avg_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS22SVC3". All fields are combined with a logical 'AND'. */
export type As22Svc3_Bool_Exp = {
  ADTRTHOS?: InputMaybe<String_Comparison_Exp>;
  ADTRTSYS?: InputMaybe<String_Comparison_Exp>;
  ADTRTVEN?: InputMaybe<String_Comparison_Exp>;
  ALCOPHOS?: InputMaybe<String_Comparison_Exp>;
  ALCOPSYS?: InputMaybe<String_Comparison_Exp>;
  ALCOPVEN?: InputMaybe<String_Comparison_Exp>;
  ALCPDHOS?: InputMaybe<String_Comparison_Exp>;
  ALCPDSYS?: InputMaybe<String_Comparison_Exp>;
  ALCPDVEN?: InputMaybe<String_Comparison_Exp>;
  ALCPRHOS?: InputMaybe<String_Comparison_Exp>;
  ALCPRSYS?: InputMaybe<String_Comparison_Exp>;
  ALCPRVEN?: InputMaybe<String_Comparison_Exp>;
  ALDBD?: InputMaybe<Float8_Comparison_Exp>;
  BAIMV?: InputMaybe<Float8_Comparison_Exp>;
  BHLTA?: InputMaybe<String_Comparison_Exp>;
  BPIMV?: InputMaybe<Float8_Comparison_Exp>;
  CHACAR?: InputMaybe<String_Comparison_Exp>;
  CHCARHOS?: InputMaybe<String_Comparison_Exp>;
  CHCARSYS?: InputMaybe<String_Comparison_Exp>;
  CHCARVEN?: InputMaybe<String_Comparison_Exp>;
  CHER?: InputMaybe<String_Comparison_Exp>;
  CHPCS?: InputMaybe<String_Comparison_Exp>;
  CHXCAR?: InputMaybe<String_Comparison_Exp>;
  COFVHOS?: InputMaybe<String_Comparison_Exp>;
  COFVSYS?: InputMaybe<String_Comparison_Exp>;
  COFVVEN?: InputMaybe<String_Comparison_Exp>;
  COVIDU?: InputMaybe<String_Comparison_Exp>;
  CPHCOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHHOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHIOS?: InputMaybe<Float8_Comparison_Exp>;
  CPHOHOS?: InputMaybe<String_Comparison_Exp>;
  CPHOSYS?: InputMaybe<String_Comparison_Exp>;
  CPHP?: InputMaybe<Float8_Comparison_Exp>;
  CPHPOS?: InputMaybe<Float8_Comparison_Exp>;
  DECHC?: InputMaybe<String_Comparison_Exp>;
  DECUTLA?: InputMaybe<String_Comparison_Exp>;
  DHACAR?: InputMaybe<String_Comparison_Exp>;
  DHER?: InputMaybe<String_Comparison_Exp>;
  DHPCS?: InputMaybe<String_Comparison_Exp>;
  DHXCAR?: InputMaybe<String_Comparison_Exp>;
  EAIMV?: InputMaybe<Float8_Comparison_Exp>;
  EDMCHG?: InputMaybe<String_Comparison_Exp>;
  EICUHOS?: InputMaybe<String_Comparison_Exp>;
  EICUSYS?: InputMaybe<String_Comparison_Exp>;
  EICUVEN?: InputMaybe<String_Comparison_Exp>;
  EPIMV?: InputMaybe<Float8_Comparison_Exp>;
  EQMCOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMHOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMIOS?: InputMaybe<Float8_Comparison_Exp>;
  EQMODHOS?: InputMaybe<String_Comparison_Exp>;
  EQMODSYS?: InputMaybe<String_Comparison_Exp>;
  EQMP?: InputMaybe<Float8_Comparison_Exp>;
  EQMPOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDCOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDHOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDIOS?: InputMaybe<Float8_Comparison_Exp>;
  FNDP?: InputMaybe<Float8_Comparison_Exp>;
  FNDPOS?: InputMaybe<Float8_Comparison_Exp>;
  FOUNDHOS?: InputMaybe<String_Comparison_Exp>;
  FOUNDSYS?: InputMaybe<String_Comparison_Exp>;
  FTMT?: InputMaybe<Float8_Comparison_Exp>;
  GNONE?: InputMaybe<String_Comparison_Exp>;
  GPWCOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWHOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWIOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWP?: InputMaybe<Float8_Comparison_Exp>;
  GPWPOS?: InputMaybe<Float8_Comparison_Exp>;
  GPWWHOS?: InputMaybe<String_Comparison_Exp>;
  GPWWSYS?: InputMaybe<String_Comparison_Exp>;
  HARTHOS?: InputMaybe<String_Comparison_Exp>;
  HARTSYS?: InputMaybe<String_Comparison_Exp>;
  HARTVEN?: InputMaybe<String_Comparison_Exp>;
  ICUCHG?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  IISMHOS?: InputMaybe<Float8_Comparison_Exp>;
  IMPSTAT?: InputMaybe<String_Comparison_Exp>;
  IPACOS?: InputMaybe<Float8_Comparison_Exp>;
  IPAHOS?: InputMaybe<String_Comparison_Exp>;
  IPAIOS?: InputMaybe<Float8_Comparison_Exp>;
  IPAP?: InputMaybe<Float8_Comparison_Exp>;
  IPAPOS?: InputMaybe<Float8_Comparison_Exp>;
  IPASYS?: InputMaybe<String_Comparison_Exp>;
  IPPAHOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMCOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMHOS?: InputMaybe<String_Comparison_Exp>;
  ISMIOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMP?: InputMaybe<Float8_Comparison_Exp>;
  ISMPOS?: InputMaybe<Float8_Comparison_Exp>;
  ISMSYS?: InputMaybe<String_Comparison_Exp>;
  ISORMB?: InputMaybe<Float8_Comparison_Exp>;
  ISORMC?: InputMaybe<Float8_Comparison_Exp>;
  ISORME?: InputMaybe<Float8_Comparison_Exp>;
  JNLS?: InputMaybe<String_Comparison_Exp>;
  JNTAMB?: InputMaybe<String_Comparison_Exp>;
  JNTCTR?: InputMaybe<String_Comparison_Exp>;
  JNTLSC?: InputMaybe<String_Comparison_Exp>;
  JNTLSO?: InputMaybe<String_Comparison_Exp>;
  JNTLSS?: InputMaybe<String_Comparison_Exp>;
  JNTLST?: InputMaybe<String_Comparison_Exp>;
  JNTMD?: InputMaybe<String_Comparison_Exp>;
  JNTOTH?: InputMaybe<String_Comparison_Exp>;
  JNTPH?: InputMaybe<String_Comparison_Exp>;
  JNTTXT?: InputMaybe<String_Comparison_Exp>;
  KDNYHOS?: InputMaybe<String_Comparison_Exp>;
  KDNYSYS?: InputMaybe<String_Comparison_Exp>;
  KDNYVEN?: InputMaybe<String_Comparison_Exp>;
  LIVRHOS?: InputMaybe<String_Comparison_Exp>;
  LIVRSYS?: InputMaybe<String_Comparison_Exp>;
  LIVRVEN?: InputMaybe<String_Comparison_Exp>;
  LSHTXT?: InputMaybe<String_Comparison_Exp>;
  LUNGHOS?: InputMaybe<String_Comparison_Exp>;
  LUNGSYS?: InputMaybe<String_Comparison_Exp>;
  LUNGVEN?: InputMaybe<String_Comparison_Exp>;
  MEDOPHOS?: InputMaybe<String_Comparison_Exp>;
  MEDOPSYS?: InputMaybe<String_Comparison_Exp>;
  MEDOPVEN?: InputMaybe<String_Comparison_Exp>;
  MEDSUBHOS?: InputMaybe<String_Comparison_Exp>;
  MEDSUBSYS?: InputMaybe<String_Comparison_Exp>;
  MEDSUBVEN?: InputMaybe<String_Comparison_Exp>;
  MMSOHOS?: InputMaybe<Float8_Comparison_Exp>;
  MSGRP?: InputMaybe<Float8_Comparison_Exp>;
  MSGRPN?: InputMaybe<Float8_Comparison_Exp>;
  MSOCOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOHOS?: InputMaybe<String_Comparison_Exp>;
  MSOIOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOP?: InputMaybe<Float8_Comparison_Exp>;
  MSOPOS?: InputMaybe<Float8_Comparison_Exp>;
  MSOSYS?: InputMaybe<String_Comparison_Exp>;
  OPHCOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHHOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHIOS?: InputMaybe<Float8_Comparison_Exp>;
  OPHOHOS?: InputMaybe<String_Comparison_Exp>;
  OPHOSYS?: InputMaybe<String_Comparison_Exp>;
  OPHP?: InputMaybe<Float8_Comparison_Exp>;
  OPHPOS?: InputMaybe<Float8_Comparison_Exp>;
  ORPMHOS?: InputMaybe<String_Comparison_Exp>;
  ORPMSYS?: InputMaybe<String_Comparison_Exp>;
  ORPMVEN?: InputMaybe<String_Comparison_Exp>;
  OTBONHOS?: InputMaybe<String_Comparison_Exp>;
  OTBONSYS?: InputMaybe<String_Comparison_Exp>;
  OTBONVEN?: InputMaybe<String_Comparison_Exp>;
  OTHTHOS?: InputMaybe<String_Comparison_Exp>;
  OTHTSYS?: InputMaybe<String_Comparison_Exp>;
  OTHTVEN?: InputMaybe<String_Comparison_Exp>;
  OTOTHHOS?: InputMaybe<String_Comparison_Exp>;
  OTOTHSYS?: InputMaybe<String_Comparison_Exp>;
  OTOTHVEN?: InputMaybe<String_Comparison_Exp>;
  OUTMTX?: InputMaybe<String_Comparison_Exp>;
  PDISHOS?: InputMaybe<String_Comparison_Exp>;
  PDISSYS?: InputMaybe<String_Comparison_Exp>;
  PDISVEN?: InputMaybe<String_Comparison_Exp>;
  PHACAR?: InputMaybe<String_Comparison_Exp>;
  PHER?: InputMaybe<String_Comparison_Exp>;
  PHPCS?: InputMaybe<String_Comparison_Exp>;
  PHXCAR?: InputMaybe<String_Comparison_Exp>;
  PHYCOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYCPT?: InputMaybe<Float8_Comparison_Exp>;
  PHYHOS?: InputMaybe<String_Comparison_Exp>;
  PHYIOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYOCPT?: InputMaybe<Float8_Comparison_Exp>;
  PHYOTH?: InputMaybe<String_Comparison_Exp>;
  PHYP?: InputMaybe<Float8_Comparison_Exp>;
  PHYPOS?: InputMaybe<Float8_Comparison_Exp>;
  PHYPR?: InputMaybe<Float8_Comparison_Exp>;
  PHYPRN?: InputMaybe<Float8_Comparison_Exp>;
  PHYSYS?: InputMaybe<String_Comparison_Exp>;
  PPHYHOS?: InputMaybe<Float8_Comparison_Exp>;
  RURLHOS?: InputMaybe<String_Comparison_Exp>;
  RURLSYS?: InputMaybe<String_Comparison_Exp>;
  RURLVEN?: InputMaybe<String_Comparison_Exp>;
  SCBH?: InputMaybe<String_Comparison_Exp>;
  SCEDL?: InputMaybe<String_Comparison_Exp>;
  SCFOD?: InputMaybe<String_Comparison_Exp>;
  SCHSE?: InputMaybe<String_Comparison_Exp>;
  SCIOS?: InputMaybe<String_Comparison_Exp>;
  SCNED?: InputMaybe<String_Comparison_Exp>;
  SCOTH?: InputMaybe<String_Comparison_Exp>;
  SCROT?: InputMaybe<String_Comparison_Exp>;
  SCSTAT?: InputMaybe<String_Comparison_Exp>;
  SCTRN?: InputMaybe<String_Comparison_Exp>;
  SCUND?: InputMaybe<String_Comparison_Exp>;
  SCV?: InputMaybe<String_Comparison_Exp>;
  SHACAR?: InputMaybe<String_Comparison_Exp>;
  SHER?: InputMaybe<String_Comparison_Exp>;
  SHPCS?: InputMaybe<String_Comparison_Exp>;
  SHXCAR?: InputMaybe<String_Comparison_Exp>;
  SLEPHOS?: InputMaybe<String_Comparison_Exp>;
  SLEPSYS?: InputMaybe<String_Comparison_Exp>;
  SLEPVEN?: InputMaybe<String_Comparison_Exp>;
  SOCBH?: InputMaybe<String_Comparison_Exp>;
  SOCED?: InputMaybe<String_Comparison_Exp>;
  SOCEHR?: InputMaybe<String_Comparison_Exp>;
  SOCFOD?: InputMaybe<String_Comparison_Exp>;
  SOCHSE?: InputMaybe<String_Comparison_Exp>;
  SOCINC?: InputMaybe<String_Comparison_Exp>;
  SOCIOS?: InputMaybe<String_Comparison_Exp>;
  SOCNED?: InputMaybe<String_Comparison_Exp>;
  SOCOT?: InputMaybe<String_Comparison_Exp>;
  SOCOTH?: InputMaybe<String_Comparison_Exp>;
  SOCTRN?: InputMaybe<String_Comparison_Exp>;
  SOCV?: InputMaybe<String_Comparison_Exp>;
  SOCWKHOS?: InputMaybe<String_Comparison_Exp>;
  SOCWKSYS?: InputMaybe<String_Comparison_Exp>;
  SOCWKVEN?: InputMaybe<String_Comparison_Exp>;
  SPORTHOS?: InputMaybe<String_Comparison_Exp>;
  SPORTSYS?: InputMaybe<String_Comparison_Exp>;
  SPORTVEN?: InputMaybe<String_Comparison_Exp>;
  SSGRP?: InputMaybe<Float8_Comparison_Exp>;
  SSGRPN?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  STFCHG?: InputMaybe<String_Comparison_Exp>;
  STRCHOS?: InputMaybe<String_Comparison_Exp>;
  STRCSYS?: InputMaybe<String_Comparison_Exp>;
  STRCVEN?: InputMaybe<String_Comparison_Exp>;
  SUPPGHOS?: InputMaybe<String_Comparison_Exp>;
  SUPPGSYS?: InputMaybe<String_Comparison_Exp>;
  SUPPGVEN?: InputMaybe<String_Comparison_Exp>;
  SWBDHOS?: InputMaybe<String_Comparison_Exp>;
  SWBDSYS?: InputMaybe<String_Comparison_Exp>;
  SWBDVEN?: InputMaybe<String_Comparison_Exp>;
  TEENSHOS?: InputMaybe<String_Comparison_Exp>;
  TEENSSYS?: InputMaybe<String_Comparison_Exp>;
  TEENSVEN?: InputMaybe<String_Comparison_Exp>;
  TISUHOS?: InputMaybe<String_Comparison_Exp>;
  TISUSYS?: InputMaybe<String_Comparison_Exp>;
  TISUVEN?: InputMaybe<String_Comparison_Exp>;
  TOBHOS?: InputMaybe<String_Comparison_Exp>;
  TOBSYS?: InputMaybe<String_Comparison_Exp>;
  TOBVEN?: InputMaybe<String_Comparison_Exp>;
  TPORTHOS?: InputMaybe<String_Comparison_Exp>;
  TPORTSYS?: InputMaybe<String_Comparison_Exp>;
  TPORTVEN?: InputMaybe<String_Comparison_Exp>;
  URGCCHOS?: InputMaybe<String_Comparison_Exp>;
  URGCCSYS?: InputMaybe<String_Comparison_Exp>;
  URGCCVEN?: InputMaybe<String_Comparison_Exp>;
  VCMMHOS?: InputMaybe<String_Comparison_Exp>;
  VCMMSYS?: InputMaybe<String_Comparison_Exp>;
  VCMMVEN?: InputMaybe<String_Comparison_Exp>;
  VOLSVHOS?: InputMaybe<String_Comparison_Exp>;
  VOLSVSYS?: InputMaybe<String_Comparison_Exp>;
  VOLSVVEN?: InputMaybe<String_Comparison_Exp>;
  VRCSHOS?: InputMaybe<String_Comparison_Exp>;
  VRCSSYS?: InputMaybe<String_Comparison_Exp>;
  VRCSVEN?: InputMaybe<String_Comparison_Exp>;
  VWRKHOS?: InputMaybe<String_Comparison_Exp>;
  VWRKSYS?: InputMaybe<String_Comparison_Exp>;
  VWRKVEN?: InputMaybe<String_Comparison_Exp>;
  WMGTHOS?: InputMaybe<String_Comparison_Exp>;
  WMGTSYS?: InputMaybe<String_Comparison_Exp>;
  WMGTVEN?: InputMaybe<String_Comparison_Exp>;
  WOMHCHOS?: InputMaybe<String_Comparison_Exp>;
  WOMHCSYS?: InputMaybe<String_Comparison_Exp>;
  WOMHCVEN?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Svc3_Bool_Exp>>;
  _not?: InputMaybe<As22Svc3_Bool_Exp>;
  _or?: InputMaybe<Array<As22Svc3_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS22SVC3" */
export enum As22Svc3_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Svc3 = 'pk_AS22SVC3'
}

/** input type for incrementing numeric columns in table "AS22SVC3" */
export type As22Svc3_Inc_Input = {
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS22SVC3" */
export type As22Svc3_Insert_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHACAR?: InputMaybe<Scalars['String']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  CHER?: InputMaybe<Scalars['String']>;
  CHPCS?: InputMaybe<Scalars['String']>;
  CHXCAR?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  DHACAR?: InputMaybe<Scalars['String']>;
  DHER?: InputMaybe<Scalars['String']>;
  DHPCS?: InputMaybe<Scalars['String']>;
  DHXCAR?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDMCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GNONE?: InputMaybe<Scalars['String']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ICUCHG?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STFCHG?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type As22Svc3_Max_Fields = {
  __typename?: 'AS22SVC3_max_fields';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHLTA: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHACAR: Maybe<Scalars['String']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  CHER: Maybe<Scalars['String']>;
  CHPCS: Maybe<Scalars['String']>;
  CHXCAR: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  DHACAR: Maybe<Scalars['String']>;
  DHER: Maybe<Scalars['String']>;
  DHPCS: Maybe<Scalars['String']>;
  DHXCAR: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDMCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GNONE: Maybe<Scalars['String']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ICUCHG: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STFCHG: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type As22Svc3_Min_Fields = {
  __typename?: 'AS22SVC3_min_fields';
  ADTRTHOS: Maybe<Scalars['String']>;
  ADTRTSYS: Maybe<Scalars['String']>;
  ADTRTVEN: Maybe<Scalars['String']>;
  ALCOPHOS: Maybe<Scalars['String']>;
  ALCOPSYS: Maybe<Scalars['String']>;
  ALCOPVEN: Maybe<Scalars['String']>;
  ALCPDHOS: Maybe<Scalars['String']>;
  ALCPDSYS: Maybe<Scalars['String']>;
  ALCPDVEN: Maybe<Scalars['String']>;
  ALCPRHOS: Maybe<Scalars['String']>;
  ALCPRSYS: Maybe<Scalars['String']>;
  ALCPRVEN: Maybe<Scalars['String']>;
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BHLTA: Maybe<Scalars['String']>;
  BPIMV: Maybe<Scalars['float8']>;
  CHACAR: Maybe<Scalars['String']>;
  CHCARHOS: Maybe<Scalars['String']>;
  CHCARSYS: Maybe<Scalars['String']>;
  CHCARVEN: Maybe<Scalars['String']>;
  CHER: Maybe<Scalars['String']>;
  CHPCS: Maybe<Scalars['String']>;
  CHXCAR: Maybe<Scalars['String']>;
  COFVHOS: Maybe<Scalars['String']>;
  COFVSYS: Maybe<Scalars['String']>;
  COFVVEN: Maybe<Scalars['String']>;
  COVIDU: Maybe<Scalars['String']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHOHOS: Maybe<Scalars['String']>;
  CPHOSYS: Maybe<Scalars['String']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  DECHC: Maybe<Scalars['String']>;
  DECUTLA: Maybe<Scalars['String']>;
  DHACAR: Maybe<Scalars['String']>;
  DHER: Maybe<Scalars['String']>;
  DHPCS: Maybe<Scalars['String']>;
  DHXCAR: Maybe<Scalars['String']>;
  EAIMV: Maybe<Scalars['float8']>;
  EDMCHG: Maybe<Scalars['String']>;
  EICUHOS: Maybe<Scalars['String']>;
  EICUSYS: Maybe<Scalars['String']>;
  EICUVEN: Maybe<Scalars['String']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMODHOS: Maybe<Scalars['String']>;
  EQMODSYS: Maybe<Scalars['String']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FOUNDHOS: Maybe<Scalars['String']>;
  FOUNDSYS: Maybe<Scalars['String']>;
  FTMT: Maybe<Scalars['float8']>;
  GNONE: Maybe<Scalars['String']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  GPWWHOS: Maybe<Scalars['String']>;
  GPWWSYS: Maybe<Scalars['String']>;
  HARTHOS: Maybe<Scalars['String']>;
  HARTSYS: Maybe<Scalars['String']>;
  HARTVEN: Maybe<Scalars['String']>;
  ICUCHG: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IMPSTAT: Maybe<Scalars['String']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAHOS: Maybe<Scalars['String']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPASYS: Maybe<Scalars['String']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMHOS: Maybe<Scalars['String']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISMSYS: Maybe<Scalars['String']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  JNLS: Maybe<Scalars['String']>;
  JNTAMB: Maybe<Scalars['String']>;
  JNTCTR: Maybe<Scalars['String']>;
  JNTLSC: Maybe<Scalars['String']>;
  JNTLSO: Maybe<Scalars['String']>;
  JNTLSS: Maybe<Scalars['String']>;
  JNTLST: Maybe<Scalars['String']>;
  JNTMD: Maybe<Scalars['String']>;
  JNTOTH: Maybe<Scalars['String']>;
  JNTPH: Maybe<Scalars['String']>;
  JNTTXT: Maybe<Scalars['String']>;
  KDNYHOS: Maybe<Scalars['String']>;
  KDNYSYS: Maybe<Scalars['String']>;
  KDNYVEN: Maybe<Scalars['String']>;
  LIVRHOS: Maybe<Scalars['String']>;
  LIVRSYS: Maybe<Scalars['String']>;
  LIVRVEN: Maybe<Scalars['String']>;
  LSHTXT: Maybe<Scalars['String']>;
  LUNGHOS: Maybe<Scalars['String']>;
  LUNGSYS: Maybe<Scalars['String']>;
  LUNGVEN: Maybe<Scalars['String']>;
  MEDOPHOS: Maybe<Scalars['String']>;
  MEDOPSYS: Maybe<Scalars['String']>;
  MEDOPVEN: Maybe<Scalars['String']>;
  MEDSUBHOS: Maybe<Scalars['String']>;
  MEDSUBSYS: Maybe<Scalars['String']>;
  MEDSUBVEN: Maybe<Scalars['String']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOHOS: Maybe<Scalars['String']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  MSOSYS: Maybe<Scalars['String']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHOHOS: Maybe<Scalars['String']>;
  OPHOSYS: Maybe<Scalars['String']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  ORPMHOS: Maybe<Scalars['String']>;
  ORPMSYS: Maybe<Scalars['String']>;
  ORPMVEN: Maybe<Scalars['String']>;
  OTBONHOS: Maybe<Scalars['String']>;
  OTBONSYS: Maybe<Scalars['String']>;
  OTBONVEN: Maybe<Scalars['String']>;
  OTHTHOS: Maybe<Scalars['String']>;
  OTHTSYS: Maybe<Scalars['String']>;
  OTHTVEN: Maybe<Scalars['String']>;
  OTOTHHOS: Maybe<Scalars['String']>;
  OTOTHSYS: Maybe<Scalars['String']>;
  OTOTHVEN: Maybe<Scalars['String']>;
  OUTMTX: Maybe<Scalars['String']>;
  PDISHOS: Maybe<Scalars['String']>;
  PDISSYS: Maybe<Scalars['String']>;
  PDISVEN: Maybe<Scalars['String']>;
  PHACAR: Maybe<Scalars['String']>;
  PHER: Maybe<Scalars['String']>;
  PHPCS: Maybe<Scalars['String']>;
  PHXCAR: Maybe<Scalars['String']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYHOS: Maybe<Scalars['String']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYOTH: Maybe<Scalars['String']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PHYSYS: Maybe<Scalars['String']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  RURLHOS: Maybe<Scalars['String']>;
  RURLSYS: Maybe<Scalars['String']>;
  RURLVEN: Maybe<Scalars['String']>;
  SCBH: Maybe<Scalars['String']>;
  SCEDL: Maybe<Scalars['String']>;
  SCFOD: Maybe<Scalars['String']>;
  SCHSE: Maybe<Scalars['String']>;
  SCIOS: Maybe<Scalars['String']>;
  SCNED: Maybe<Scalars['String']>;
  SCOTH: Maybe<Scalars['String']>;
  SCROT: Maybe<Scalars['String']>;
  SCSTAT: Maybe<Scalars['String']>;
  SCTRN: Maybe<Scalars['String']>;
  SCUND: Maybe<Scalars['String']>;
  SCV: Maybe<Scalars['String']>;
  SHACAR: Maybe<Scalars['String']>;
  SHER: Maybe<Scalars['String']>;
  SHPCS: Maybe<Scalars['String']>;
  SHXCAR: Maybe<Scalars['String']>;
  SLEPHOS: Maybe<Scalars['String']>;
  SLEPSYS: Maybe<Scalars['String']>;
  SLEPVEN: Maybe<Scalars['String']>;
  SOCBH: Maybe<Scalars['String']>;
  SOCED: Maybe<Scalars['String']>;
  SOCEHR: Maybe<Scalars['String']>;
  SOCFOD: Maybe<Scalars['String']>;
  SOCHSE: Maybe<Scalars['String']>;
  SOCINC: Maybe<Scalars['String']>;
  SOCIOS: Maybe<Scalars['String']>;
  SOCNED: Maybe<Scalars['String']>;
  SOCOT: Maybe<Scalars['String']>;
  SOCOTH: Maybe<Scalars['String']>;
  SOCTRN: Maybe<Scalars['String']>;
  SOCV: Maybe<Scalars['String']>;
  SOCWKHOS: Maybe<Scalars['String']>;
  SOCWKSYS: Maybe<Scalars['String']>;
  SOCWKVEN: Maybe<Scalars['String']>;
  SPORTHOS: Maybe<Scalars['String']>;
  SPORTSYS: Maybe<Scalars['String']>;
  SPORTVEN: Maybe<Scalars['String']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  STFCHG: Maybe<Scalars['String']>;
  STRCHOS: Maybe<Scalars['String']>;
  STRCSYS: Maybe<Scalars['String']>;
  STRCVEN: Maybe<Scalars['String']>;
  SUPPGHOS: Maybe<Scalars['String']>;
  SUPPGSYS: Maybe<Scalars['String']>;
  SUPPGVEN: Maybe<Scalars['String']>;
  SWBDHOS: Maybe<Scalars['String']>;
  SWBDSYS: Maybe<Scalars['String']>;
  SWBDVEN: Maybe<Scalars['String']>;
  TEENSHOS: Maybe<Scalars['String']>;
  TEENSSYS: Maybe<Scalars['String']>;
  TEENSVEN: Maybe<Scalars['String']>;
  TISUHOS: Maybe<Scalars['String']>;
  TISUSYS: Maybe<Scalars['String']>;
  TISUVEN: Maybe<Scalars['String']>;
  TOBHOS: Maybe<Scalars['String']>;
  TOBSYS: Maybe<Scalars['String']>;
  TOBVEN: Maybe<Scalars['String']>;
  TPORTHOS: Maybe<Scalars['String']>;
  TPORTSYS: Maybe<Scalars['String']>;
  TPORTVEN: Maybe<Scalars['String']>;
  URGCCHOS: Maybe<Scalars['String']>;
  URGCCSYS: Maybe<Scalars['String']>;
  URGCCVEN: Maybe<Scalars['String']>;
  VCMMHOS: Maybe<Scalars['String']>;
  VCMMSYS: Maybe<Scalars['String']>;
  VCMMVEN: Maybe<Scalars['String']>;
  VOLSVHOS: Maybe<Scalars['String']>;
  VOLSVSYS: Maybe<Scalars['String']>;
  VOLSVVEN: Maybe<Scalars['String']>;
  VRCSHOS: Maybe<Scalars['String']>;
  VRCSSYS: Maybe<Scalars['String']>;
  VRCSVEN: Maybe<Scalars['String']>;
  VWRKHOS: Maybe<Scalars['String']>;
  VWRKSYS: Maybe<Scalars['String']>;
  VWRKVEN: Maybe<Scalars['String']>;
  WMGTHOS: Maybe<Scalars['String']>;
  WMGTSYS: Maybe<Scalars['String']>;
  WMGTVEN: Maybe<Scalars['String']>;
  WOMHCHOS: Maybe<Scalars['String']>;
  WOMHCSYS: Maybe<Scalars['String']>;
  WOMHCVEN: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "AS22SVC3" */
export type As22Svc3_Mutation_Response = {
  __typename?: 'AS22SVC3_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Svc3>;
};

/** input type for inserting object relation for remote table "AS22SVC3" */
export type As22Svc3_Obj_Rel_Insert_Input = {
  data: As22Svc3_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Svc3_On_Conflict>;
};

/** on_conflict condition type for table "AS22SVC3" */
export type As22Svc3_On_Conflict = {
  constraint: As22Svc3_Constraint;
  update_columns?: Array<As22Svc3_Update_Column>;
  where?: InputMaybe<As22Svc3_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22SVC3". */
export type As22Svc3_Order_By = {
  ADTRTHOS?: InputMaybe<Order_By>;
  ADTRTSYS?: InputMaybe<Order_By>;
  ADTRTVEN?: InputMaybe<Order_By>;
  ALCOPHOS?: InputMaybe<Order_By>;
  ALCOPSYS?: InputMaybe<Order_By>;
  ALCOPVEN?: InputMaybe<Order_By>;
  ALCPDHOS?: InputMaybe<Order_By>;
  ALCPDSYS?: InputMaybe<Order_By>;
  ALCPDVEN?: InputMaybe<Order_By>;
  ALCPRHOS?: InputMaybe<Order_By>;
  ALCPRSYS?: InputMaybe<Order_By>;
  ALCPRVEN?: InputMaybe<Order_By>;
  ALDBD?: InputMaybe<Order_By>;
  BAIMV?: InputMaybe<Order_By>;
  BHLTA?: InputMaybe<Order_By>;
  BPIMV?: InputMaybe<Order_By>;
  CHACAR?: InputMaybe<Order_By>;
  CHCARHOS?: InputMaybe<Order_By>;
  CHCARSYS?: InputMaybe<Order_By>;
  CHCARVEN?: InputMaybe<Order_By>;
  CHER?: InputMaybe<Order_By>;
  CHPCS?: InputMaybe<Order_By>;
  CHXCAR?: InputMaybe<Order_By>;
  COFVHOS?: InputMaybe<Order_By>;
  COFVSYS?: InputMaybe<Order_By>;
  COFVVEN?: InputMaybe<Order_By>;
  COVIDU?: InputMaybe<Order_By>;
  CPHCOS?: InputMaybe<Order_By>;
  CPHHOS?: InputMaybe<Order_By>;
  CPHIOS?: InputMaybe<Order_By>;
  CPHOHOS?: InputMaybe<Order_By>;
  CPHOSYS?: InputMaybe<Order_By>;
  CPHP?: InputMaybe<Order_By>;
  CPHPOS?: InputMaybe<Order_By>;
  DECHC?: InputMaybe<Order_By>;
  DECUTLA?: InputMaybe<Order_By>;
  DHACAR?: InputMaybe<Order_By>;
  DHER?: InputMaybe<Order_By>;
  DHPCS?: InputMaybe<Order_By>;
  DHXCAR?: InputMaybe<Order_By>;
  EAIMV?: InputMaybe<Order_By>;
  EDMCHG?: InputMaybe<Order_By>;
  EICUHOS?: InputMaybe<Order_By>;
  EICUSYS?: InputMaybe<Order_By>;
  EICUVEN?: InputMaybe<Order_By>;
  EPIMV?: InputMaybe<Order_By>;
  EQMCOS?: InputMaybe<Order_By>;
  EQMHOS?: InputMaybe<Order_By>;
  EQMIOS?: InputMaybe<Order_By>;
  EQMODHOS?: InputMaybe<Order_By>;
  EQMODSYS?: InputMaybe<Order_By>;
  EQMP?: InputMaybe<Order_By>;
  EQMPOS?: InputMaybe<Order_By>;
  FNDCOS?: InputMaybe<Order_By>;
  FNDHOS?: InputMaybe<Order_By>;
  FNDIOS?: InputMaybe<Order_By>;
  FNDP?: InputMaybe<Order_By>;
  FNDPOS?: InputMaybe<Order_By>;
  FOUNDHOS?: InputMaybe<Order_By>;
  FOUNDSYS?: InputMaybe<Order_By>;
  FTMT?: InputMaybe<Order_By>;
  GNONE?: InputMaybe<Order_By>;
  GPWCOS?: InputMaybe<Order_By>;
  GPWHOS?: InputMaybe<Order_By>;
  GPWIOS?: InputMaybe<Order_By>;
  GPWP?: InputMaybe<Order_By>;
  GPWPOS?: InputMaybe<Order_By>;
  GPWWHOS?: InputMaybe<Order_By>;
  GPWWSYS?: InputMaybe<Order_By>;
  HARTHOS?: InputMaybe<Order_By>;
  HARTSYS?: InputMaybe<Order_By>;
  HARTVEN?: InputMaybe<Order_By>;
  ICUCHG?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  IISMHOS?: InputMaybe<Order_By>;
  IMPSTAT?: InputMaybe<Order_By>;
  IPACOS?: InputMaybe<Order_By>;
  IPAHOS?: InputMaybe<Order_By>;
  IPAIOS?: InputMaybe<Order_By>;
  IPAP?: InputMaybe<Order_By>;
  IPAPOS?: InputMaybe<Order_By>;
  IPASYS?: InputMaybe<Order_By>;
  IPPAHOS?: InputMaybe<Order_By>;
  ISMCOS?: InputMaybe<Order_By>;
  ISMHOS?: InputMaybe<Order_By>;
  ISMIOS?: InputMaybe<Order_By>;
  ISMP?: InputMaybe<Order_By>;
  ISMPOS?: InputMaybe<Order_By>;
  ISMSYS?: InputMaybe<Order_By>;
  ISORMB?: InputMaybe<Order_By>;
  ISORMC?: InputMaybe<Order_By>;
  ISORME?: InputMaybe<Order_By>;
  JNLS?: InputMaybe<Order_By>;
  JNTAMB?: InputMaybe<Order_By>;
  JNTCTR?: InputMaybe<Order_By>;
  JNTLSC?: InputMaybe<Order_By>;
  JNTLSO?: InputMaybe<Order_By>;
  JNTLSS?: InputMaybe<Order_By>;
  JNTLST?: InputMaybe<Order_By>;
  JNTMD?: InputMaybe<Order_By>;
  JNTOTH?: InputMaybe<Order_By>;
  JNTPH?: InputMaybe<Order_By>;
  JNTTXT?: InputMaybe<Order_By>;
  KDNYHOS?: InputMaybe<Order_By>;
  KDNYSYS?: InputMaybe<Order_By>;
  KDNYVEN?: InputMaybe<Order_By>;
  LIVRHOS?: InputMaybe<Order_By>;
  LIVRSYS?: InputMaybe<Order_By>;
  LIVRVEN?: InputMaybe<Order_By>;
  LSHTXT?: InputMaybe<Order_By>;
  LUNGHOS?: InputMaybe<Order_By>;
  LUNGSYS?: InputMaybe<Order_By>;
  LUNGVEN?: InputMaybe<Order_By>;
  MEDOPHOS?: InputMaybe<Order_By>;
  MEDOPSYS?: InputMaybe<Order_By>;
  MEDOPVEN?: InputMaybe<Order_By>;
  MEDSUBHOS?: InputMaybe<Order_By>;
  MEDSUBSYS?: InputMaybe<Order_By>;
  MEDSUBVEN?: InputMaybe<Order_By>;
  MMSOHOS?: InputMaybe<Order_By>;
  MSGRP?: InputMaybe<Order_By>;
  MSGRPN?: InputMaybe<Order_By>;
  MSOCOS?: InputMaybe<Order_By>;
  MSOHOS?: InputMaybe<Order_By>;
  MSOIOS?: InputMaybe<Order_By>;
  MSOP?: InputMaybe<Order_By>;
  MSOPOS?: InputMaybe<Order_By>;
  MSOSYS?: InputMaybe<Order_By>;
  OPHCOS?: InputMaybe<Order_By>;
  OPHHOS?: InputMaybe<Order_By>;
  OPHIOS?: InputMaybe<Order_By>;
  OPHOHOS?: InputMaybe<Order_By>;
  OPHOSYS?: InputMaybe<Order_By>;
  OPHP?: InputMaybe<Order_By>;
  OPHPOS?: InputMaybe<Order_By>;
  ORPMHOS?: InputMaybe<Order_By>;
  ORPMSYS?: InputMaybe<Order_By>;
  ORPMVEN?: InputMaybe<Order_By>;
  OTBONHOS?: InputMaybe<Order_By>;
  OTBONSYS?: InputMaybe<Order_By>;
  OTBONVEN?: InputMaybe<Order_By>;
  OTHTHOS?: InputMaybe<Order_By>;
  OTHTSYS?: InputMaybe<Order_By>;
  OTHTVEN?: InputMaybe<Order_By>;
  OTOTHHOS?: InputMaybe<Order_By>;
  OTOTHSYS?: InputMaybe<Order_By>;
  OTOTHVEN?: InputMaybe<Order_By>;
  OUTMTX?: InputMaybe<Order_By>;
  PDISHOS?: InputMaybe<Order_By>;
  PDISSYS?: InputMaybe<Order_By>;
  PDISVEN?: InputMaybe<Order_By>;
  PHACAR?: InputMaybe<Order_By>;
  PHER?: InputMaybe<Order_By>;
  PHPCS?: InputMaybe<Order_By>;
  PHXCAR?: InputMaybe<Order_By>;
  PHYCOS?: InputMaybe<Order_By>;
  PHYCPT?: InputMaybe<Order_By>;
  PHYHOS?: InputMaybe<Order_By>;
  PHYIOS?: InputMaybe<Order_By>;
  PHYOCPT?: InputMaybe<Order_By>;
  PHYOTH?: InputMaybe<Order_By>;
  PHYP?: InputMaybe<Order_By>;
  PHYPOS?: InputMaybe<Order_By>;
  PHYPR?: InputMaybe<Order_By>;
  PHYPRN?: InputMaybe<Order_By>;
  PHYSYS?: InputMaybe<Order_By>;
  PPHYHOS?: InputMaybe<Order_By>;
  RURLHOS?: InputMaybe<Order_By>;
  RURLSYS?: InputMaybe<Order_By>;
  RURLVEN?: InputMaybe<Order_By>;
  SCBH?: InputMaybe<Order_By>;
  SCEDL?: InputMaybe<Order_By>;
  SCFOD?: InputMaybe<Order_By>;
  SCHSE?: InputMaybe<Order_By>;
  SCIOS?: InputMaybe<Order_By>;
  SCNED?: InputMaybe<Order_By>;
  SCOTH?: InputMaybe<Order_By>;
  SCROT?: InputMaybe<Order_By>;
  SCSTAT?: InputMaybe<Order_By>;
  SCTRN?: InputMaybe<Order_By>;
  SCUND?: InputMaybe<Order_By>;
  SCV?: InputMaybe<Order_By>;
  SHACAR?: InputMaybe<Order_By>;
  SHER?: InputMaybe<Order_By>;
  SHPCS?: InputMaybe<Order_By>;
  SHXCAR?: InputMaybe<Order_By>;
  SLEPHOS?: InputMaybe<Order_By>;
  SLEPSYS?: InputMaybe<Order_By>;
  SLEPVEN?: InputMaybe<Order_By>;
  SOCBH?: InputMaybe<Order_By>;
  SOCED?: InputMaybe<Order_By>;
  SOCEHR?: InputMaybe<Order_By>;
  SOCFOD?: InputMaybe<Order_By>;
  SOCHSE?: InputMaybe<Order_By>;
  SOCINC?: InputMaybe<Order_By>;
  SOCIOS?: InputMaybe<Order_By>;
  SOCNED?: InputMaybe<Order_By>;
  SOCOT?: InputMaybe<Order_By>;
  SOCOTH?: InputMaybe<Order_By>;
  SOCTRN?: InputMaybe<Order_By>;
  SOCV?: InputMaybe<Order_By>;
  SOCWKHOS?: InputMaybe<Order_By>;
  SOCWKSYS?: InputMaybe<Order_By>;
  SOCWKVEN?: InputMaybe<Order_By>;
  SPORTHOS?: InputMaybe<Order_By>;
  SPORTSYS?: InputMaybe<Order_By>;
  SPORTVEN?: InputMaybe<Order_By>;
  SSGRP?: InputMaybe<Order_By>;
  SSGRPN?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  STFCHG?: InputMaybe<Order_By>;
  STRCHOS?: InputMaybe<Order_By>;
  STRCSYS?: InputMaybe<Order_By>;
  STRCVEN?: InputMaybe<Order_By>;
  SUPPGHOS?: InputMaybe<Order_By>;
  SUPPGSYS?: InputMaybe<Order_By>;
  SUPPGVEN?: InputMaybe<Order_By>;
  SWBDHOS?: InputMaybe<Order_By>;
  SWBDSYS?: InputMaybe<Order_By>;
  SWBDVEN?: InputMaybe<Order_By>;
  TEENSHOS?: InputMaybe<Order_By>;
  TEENSSYS?: InputMaybe<Order_By>;
  TEENSVEN?: InputMaybe<Order_By>;
  TISUHOS?: InputMaybe<Order_By>;
  TISUSYS?: InputMaybe<Order_By>;
  TISUVEN?: InputMaybe<Order_By>;
  TOBHOS?: InputMaybe<Order_By>;
  TOBSYS?: InputMaybe<Order_By>;
  TOBVEN?: InputMaybe<Order_By>;
  TPORTHOS?: InputMaybe<Order_By>;
  TPORTSYS?: InputMaybe<Order_By>;
  TPORTVEN?: InputMaybe<Order_By>;
  URGCCHOS?: InputMaybe<Order_By>;
  URGCCSYS?: InputMaybe<Order_By>;
  URGCCVEN?: InputMaybe<Order_By>;
  VCMMHOS?: InputMaybe<Order_By>;
  VCMMSYS?: InputMaybe<Order_By>;
  VCMMVEN?: InputMaybe<Order_By>;
  VOLSVHOS?: InputMaybe<Order_By>;
  VOLSVSYS?: InputMaybe<Order_By>;
  VOLSVVEN?: InputMaybe<Order_By>;
  VRCSHOS?: InputMaybe<Order_By>;
  VRCSSYS?: InputMaybe<Order_By>;
  VRCSVEN?: InputMaybe<Order_By>;
  VWRKHOS?: InputMaybe<Order_By>;
  VWRKSYS?: InputMaybe<Order_By>;
  VWRKVEN?: InputMaybe<Order_By>;
  WMGTHOS?: InputMaybe<Order_By>;
  WMGTSYS?: InputMaybe<Order_By>;
  WMGTVEN?: InputMaybe<Order_By>;
  WOMHCHOS?: InputMaybe<Order_By>;
  WOMHCSYS?: InputMaybe<Order_By>;
  WOMHCVEN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS22SVC3 */
export type As22Svc3_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22SVC3" */
export enum As22Svc3_Select_Column {
  /** column name */
  Adtrthos = 'ADTRTHOS',
  /** column name */
  Adtrtsys = 'ADTRTSYS',
  /** column name */
  Adtrtven = 'ADTRTVEN',
  /** column name */
  Alcophos = 'ALCOPHOS',
  /** column name */
  Alcopsys = 'ALCOPSYS',
  /** column name */
  Alcopven = 'ALCOPVEN',
  /** column name */
  Alcpdhos = 'ALCPDHOS',
  /** column name */
  Alcpdsys = 'ALCPDSYS',
  /** column name */
  Alcpdven = 'ALCPDVEN',
  /** column name */
  Alcprhos = 'ALCPRHOS',
  /** column name */
  Alcprsys = 'ALCPRSYS',
  /** column name */
  Alcprven = 'ALCPRVEN',
  /** column name */
  Aldbd = 'ALDBD',
  /** column name */
  Baimv = 'BAIMV',
  /** column name */
  Bhlta = 'BHLTA',
  /** column name */
  Bpimv = 'BPIMV',
  /** column name */
  Chacar = 'CHACAR',
  /** column name */
  Chcarhos = 'CHCARHOS',
  /** column name */
  Chcarsys = 'CHCARSYS',
  /** column name */
  Chcarven = 'CHCARVEN',
  /** column name */
  Cher = 'CHER',
  /** column name */
  Chpcs = 'CHPCS',
  /** column name */
  Chxcar = 'CHXCAR',
  /** column name */
  Cofvhos = 'COFVHOS',
  /** column name */
  Cofvsys = 'COFVSYS',
  /** column name */
  Cofvven = 'COFVVEN',
  /** column name */
  Covidu = 'COVIDU',
  /** column name */
  Cphcos = 'CPHCOS',
  /** column name */
  Cphhos = 'CPHHOS',
  /** column name */
  Cphios = 'CPHIOS',
  /** column name */
  Cphohos = 'CPHOHOS',
  /** column name */
  Cphosys = 'CPHOSYS',
  /** column name */
  Cphp = 'CPHP',
  /** column name */
  Cphpos = 'CPHPOS',
  /** column name */
  Dechc = 'DECHC',
  /** column name */
  Decutla = 'DECUTLA',
  /** column name */
  Dhacar = 'DHACAR',
  /** column name */
  Dher = 'DHER',
  /** column name */
  Dhpcs = 'DHPCS',
  /** column name */
  Dhxcar = 'DHXCAR',
  /** column name */
  Eaimv = 'EAIMV',
  /** column name */
  Edmchg = 'EDMCHG',
  /** column name */
  Eicuhos = 'EICUHOS',
  /** column name */
  Eicusys = 'EICUSYS',
  /** column name */
  Eicuven = 'EICUVEN',
  /** column name */
  Epimv = 'EPIMV',
  /** column name */
  Eqmcos = 'EQMCOS',
  /** column name */
  Eqmhos = 'EQMHOS',
  /** column name */
  Eqmios = 'EQMIOS',
  /** column name */
  Eqmodhos = 'EQMODHOS',
  /** column name */
  Eqmodsys = 'EQMODSYS',
  /** column name */
  Eqmp = 'EQMP',
  /** column name */
  Eqmpos = 'EQMPOS',
  /** column name */
  Fndcos = 'FNDCOS',
  /** column name */
  Fndhos = 'FNDHOS',
  /** column name */
  Fndios = 'FNDIOS',
  /** column name */
  Fndp = 'FNDP',
  /** column name */
  Fndpos = 'FNDPOS',
  /** column name */
  Foundhos = 'FOUNDHOS',
  /** column name */
  Foundsys = 'FOUNDSYS',
  /** column name */
  Ftmt = 'FTMT',
  /** column name */
  Gnone = 'GNONE',
  /** column name */
  Gpwcos = 'GPWCOS',
  /** column name */
  Gpwhos = 'GPWHOS',
  /** column name */
  Gpwios = 'GPWIOS',
  /** column name */
  Gpwp = 'GPWP',
  /** column name */
  Gpwpos = 'GPWPOS',
  /** column name */
  Gpwwhos = 'GPWWHOS',
  /** column name */
  Gpwwsys = 'GPWWSYS',
  /** column name */
  Harthos = 'HARTHOS',
  /** column name */
  Hartsys = 'HARTSYS',
  /** column name */
  Hartven = 'HARTVEN',
  /** column name */
  Icuchg = 'ICUCHG',
  /** column name */
  Id = 'ID',
  /** column name */
  Iismhos = 'IISMHOS',
  /** column name */
  Impstat = 'IMPSTAT',
  /** column name */
  Ipacos = 'IPACOS',
  /** column name */
  Ipahos = 'IPAHOS',
  /** column name */
  Ipaios = 'IPAIOS',
  /** column name */
  Ipap = 'IPAP',
  /** column name */
  Ipapos = 'IPAPOS',
  /** column name */
  Ipasys = 'IPASYS',
  /** column name */
  Ippahos = 'IPPAHOS',
  /** column name */
  Ismcos = 'ISMCOS',
  /** column name */
  Ismhos = 'ISMHOS',
  /** column name */
  Ismios = 'ISMIOS',
  /** column name */
  Ismp = 'ISMP',
  /** column name */
  Ismpos = 'ISMPOS',
  /** column name */
  Ismsys = 'ISMSYS',
  /** column name */
  Isormb = 'ISORMB',
  /** column name */
  Isormc = 'ISORMC',
  /** column name */
  Isorme = 'ISORME',
  /** column name */
  Jnls = 'JNLS',
  /** column name */
  Jntamb = 'JNTAMB',
  /** column name */
  Jntctr = 'JNTCTR',
  /** column name */
  Jntlsc = 'JNTLSC',
  /** column name */
  Jntlso = 'JNTLSO',
  /** column name */
  Jntlss = 'JNTLSS',
  /** column name */
  Jntlst = 'JNTLST',
  /** column name */
  Jntmd = 'JNTMD',
  /** column name */
  Jntoth = 'JNTOTH',
  /** column name */
  Jntph = 'JNTPH',
  /** column name */
  Jnttxt = 'JNTTXT',
  /** column name */
  Kdnyhos = 'KDNYHOS',
  /** column name */
  Kdnysys = 'KDNYSYS',
  /** column name */
  Kdnyven = 'KDNYVEN',
  /** column name */
  Livrhos = 'LIVRHOS',
  /** column name */
  Livrsys = 'LIVRSYS',
  /** column name */
  Livrven = 'LIVRVEN',
  /** column name */
  Lshtxt = 'LSHTXT',
  /** column name */
  Lunghos = 'LUNGHOS',
  /** column name */
  Lungsys = 'LUNGSYS',
  /** column name */
  Lungven = 'LUNGVEN',
  /** column name */
  Medophos = 'MEDOPHOS',
  /** column name */
  Medopsys = 'MEDOPSYS',
  /** column name */
  Medopven = 'MEDOPVEN',
  /** column name */
  Medsubhos = 'MEDSUBHOS',
  /** column name */
  Medsubsys = 'MEDSUBSYS',
  /** column name */
  Medsubven = 'MEDSUBVEN',
  /** column name */
  Mmsohos = 'MMSOHOS',
  /** column name */
  Msgrp = 'MSGRP',
  /** column name */
  Msgrpn = 'MSGRPN',
  /** column name */
  Msocos = 'MSOCOS',
  /** column name */
  Msohos = 'MSOHOS',
  /** column name */
  Msoios = 'MSOIOS',
  /** column name */
  Msop = 'MSOP',
  /** column name */
  Msopos = 'MSOPOS',
  /** column name */
  Msosys = 'MSOSYS',
  /** column name */
  Ophcos = 'OPHCOS',
  /** column name */
  Ophhos = 'OPHHOS',
  /** column name */
  Ophios = 'OPHIOS',
  /** column name */
  Ophohos = 'OPHOHOS',
  /** column name */
  Ophosys = 'OPHOSYS',
  /** column name */
  Ophp = 'OPHP',
  /** column name */
  Ophpos = 'OPHPOS',
  /** column name */
  Orpmhos = 'ORPMHOS',
  /** column name */
  Orpmsys = 'ORPMSYS',
  /** column name */
  Orpmven = 'ORPMVEN',
  /** column name */
  Otbonhos = 'OTBONHOS',
  /** column name */
  Otbonsys = 'OTBONSYS',
  /** column name */
  Otbonven = 'OTBONVEN',
  /** column name */
  Oththos = 'OTHTHOS',
  /** column name */
  Othtsys = 'OTHTSYS',
  /** column name */
  Othtven = 'OTHTVEN',
  /** column name */
  Otothhos = 'OTOTHHOS',
  /** column name */
  Otothsys = 'OTOTHSYS',
  /** column name */
  Otothven = 'OTOTHVEN',
  /** column name */
  Outmtx = 'OUTMTX',
  /** column name */
  Pdishos = 'PDISHOS',
  /** column name */
  Pdissys = 'PDISSYS',
  /** column name */
  Pdisven = 'PDISVEN',
  /** column name */
  Phacar = 'PHACAR',
  /** column name */
  Pher = 'PHER',
  /** column name */
  Phpcs = 'PHPCS',
  /** column name */
  Phxcar = 'PHXCAR',
  /** column name */
  Phycos = 'PHYCOS',
  /** column name */
  Phycpt = 'PHYCPT',
  /** column name */
  Phyhos = 'PHYHOS',
  /** column name */
  Phyios = 'PHYIOS',
  /** column name */
  Phyocpt = 'PHYOCPT',
  /** column name */
  Phyoth = 'PHYOTH',
  /** column name */
  Phyp = 'PHYP',
  /** column name */
  Phypos = 'PHYPOS',
  /** column name */
  Phypr = 'PHYPR',
  /** column name */
  Phyprn = 'PHYPRN',
  /** column name */
  Physys = 'PHYSYS',
  /** column name */
  Pphyhos = 'PPHYHOS',
  /** column name */
  Rurlhos = 'RURLHOS',
  /** column name */
  Rurlsys = 'RURLSYS',
  /** column name */
  Rurlven = 'RURLVEN',
  /** column name */
  Scbh = 'SCBH',
  /** column name */
  Scedl = 'SCEDL',
  /** column name */
  Scfod = 'SCFOD',
  /** column name */
  Schse = 'SCHSE',
  /** column name */
  Scios = 'SCIOS',
  /** column name */
  Scned = 'SCNED',
  /** column name */
  Scoth = 'SCOTH',
  /** column name */
  Scrot = 'SCROT',
  /** column name */
  Scstat = 'SCSTAT',
  /** column name */
  Sctrn = 'SCTRN',
  /** column name */
  Scund = 'SCUND',
  /** column name */
  Scv = 'SCV',
  /** column name */
  Shacar = 'SHACAR',
  /** column name */
  Sher = 'SHER',
  /** column name */
  Shpcs = 'SHPCS',
  /** column name */
  Shxcar = 'SHXCAR',
  /** column name */
  Slephos = 'SLEPHOS',
  /** column name */
  Slepsys = 'SLEPSYS',
  /** column name */
  Slepven = 'SLEPVEN',
  /** column name */
  Socbh = 'SOCBH',
  /** column name */
  Soced = 'SOCED',
  /** column name */
  Socehr = 'SOCEHR',
  /** column name */
  Socfod = 'SOCFOD',
  /** column name */
  Sochse = 'SOCHSE',
  /** column name */
  Socinc = 'SOCINC',
  /** column name */
  Socios = 'SOCIOS',
  /** column name */
  Socned = 'SOCNED',
  /** column name */
  Socot = 'SOCOT',
  /** column name */
  Socoth = 'SOCOTH',
  /** column name */
  Soctrn = 'SOCTRN',
  /** column name */
  Socv = 'SOCV',
  /** column name */
  Socwkhos = 'SOCWKHOS',
  /** column name */
  Socwksys = 'SOCWKSYS',
  /** column name */
  Socwkven = 'SOCWKVEN',
  /** column name */
  Sporthos = 'SPORTHOS',
  /** column name */
  Sportsys = 'SPORTSYS',
  /** column name */
  Sportven = 'SPORTVEN',
  /** column name */
  Ssgrp = 'SSGRP',
  /** column name */
  Ssgrpn = 'SSGRPN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Stfchg = 'STFCHG',
  /** column name */
  Strchos = 'STRCHOS',
  /** column name */
  Strcsys = 'STRCSYS',
  /** column name */
  Strcven = 'STRCVEN',
  /** column name */
  Suppghos = 'SUPPGHOS',
  /** column name */
  Suppgsys = 'SUPPGSYS',
  /** column name */
  Suppgven = 'SUPPGVEN',
  /** column name */
  Swbdhos = 'SWBDHOS',
  /** column name */
  Swbdsys = 'SWBDSYS',
  /** column name */
  Swbdven = 'SWBDVEN',
  /** column name */
  Teenshos = 'TEENSHOS',
  /** column name */
  Teenssys = 'TEENSSYS',
  /** column name */
  Teensven = 'TEENSVEN',
  /** column name */
  Tisuhos = 'TISUHOS',
  /** column name */
  Tisusys = 'TISUSYS',
  /** column name */
  Tisuven = 'TISUVEN',
  /** column name */
  Tobhos = 'TOBHOS',
  /** column name */
  Tobsys = 'TOBSYS',
  /** column name */
  Tobven = 'TOBVEN',
  /** column name */
  Tporthos = 'TPORTHOS',
  /** column name */
  Tportsys = 'TPORTSYS',
  /** column name */
  Tportven = 'TPORTVEN',
  /** column name */
  Urgcchos = 'URGCCHOS',
  /** column name */
  Urgccsys = 'URGCCSYS',
  /** column name */
  Urgccven = 'URGCCVEN',
  /** column name */
  Vcmmhos = 'VCMMHOS',
  /** column name */
  Vcmmsys = 'VCMMSYS',
  /** column name */
  Vcmmven = 'VCMMVEN',
  /** column name */
  Volsvhos = 'VOLSVHOS',
  /** column name */
  Volsvsys = 'VOLSVSYS',
  /** column name */
  Volsvven = 'VOLSVVEN',
  /** column name */
  Vrcshos = 'VRCSHOS',
  /** column name */
  Vrcssys = 'VRCSSYS',
  /** column name */
  Vrcsven = 'VRCSVEN',
  /** column name */
  Vwrkhos = 'VWRKHOS',
  /** column name */
  Vwrksys = 'VWRKSYS',
  /** column name */
  Vwrkven = 'VWRKVEN',
  /** column name */
  Wmgthos = 'WMGTHOS',
  /** column name */
  Wmgtsys = 'WMGTSYS',
  /** column name */
  Wmgtven = 'WMGTVEN',
  /** column name */
  Womhchos = 'WOMHCHOS',
  /** column name */
  Womhcsys = 'WOMHCSYS',
  /** column name */
  Womhcven = 'WOMHCVEN'
}

/** input type for updating data in table "AS22SVC3" */
export type As22Svc3_Set_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHACAR?: InputMaybe<Scalars['String']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  CHER?: InputMaybe<Scalars['String']>;
  CHPCS?: InputMaybe<Scalars['String']>;
  CHXCAR?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  DHACAR?: InputMaybe<Scalars['String']>;
  DHER?: InputMaybe<Scalars['String']>;
  DHPCS?: InputMaybe<Scalars['String']>;
  DHXCAR?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDMCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GNONE?: InputMaybe<Scalars['String']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ICUCHG?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STFCHG?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type As22Svc3_Stddev_Fields = {
  __typename?: 'AS22SVC3_stddev_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As22Svc3_Stddev_Pop_Fields = {
  __typename?: 'AS22SVC3_stddev_pop_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As22Svc3_Stddev_Samp_Fields = {
  __typename?: 'AS22SVC3_stddev_samp_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS22SVC3" */
export type As22Svc3_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Svc3_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Svc3_Stream_Cursor_Value_Input = {
  ADTRTHOS?: InputMaybe<Scalars['String']>;
  ADTRTSYS?: InputMaybe<Scalars['String']>;
  ADTRTVEN?: InputMaybe<Scalars['String']>;
  ALCOPHOS?: InputMaybe<Scalars['String']>;
  ALCOPSYS?: InputMaybe<Scalars['String']>;
  ALCOPVEN?: InputMaybe<Scalars['String']>;
  ALCPDHOS?: InputMaybe<Scalars['String']>;
  ALCPDSYS?: InputMaybe<Scalars['String']>;
  ALCPDVEN?: InputMaybe<Scalars['String']>;
  ALCPRHOS?: InputMaybe<Scalars['String']>;
  ALCPRSYS?: InputMaybe<Scalars['String']>;
  ALCPRVEN?: InputMaybe<Scalars['String']>;
  ALDBD?: InputMaybe<Scalars['float8']>;
  BAIMV?: InputMaybe<Scalars['float8']>;
  BHLTA?: InputMaybe<Scalars['String']>;
  BPIMV?: InputMaybe<Scalars['float8']>;
  CHACAR?: InputMaybe<Scalars['String']>;
  CHCARHOS?: InputMaybe<Scalars['String']>;
  CHCARSYS?: InputMaybe<Scalars['String']>;
  CHCARVEN?: InputMaybe<Scalars['String']>;
  CHER?: InputMaybe<Scalars['String']>;
  CHPCS?: InputMaybe<Scalars['String']>;
  CHXCAR?: InputMaybe<Scalars['String']>;
  COFVHOS?: InputMaybe<Scalars['String']>;
  COFVSYS?: InputMaybe<Scalars['String']>;
  COFVVEN?: InputMaybe<Scalars['String']>;
  COVIDU?: InputMaybe<Scalars['String']>;
  CPHCOS?: InputMaybe<Scalars['float8']>;
  CPHHOS?: InputMaybe<Scalars['float8']>;
  CPHIOS?: InputMaybe<Scalars['float8']>;
  CPHOHOS?: InputMaybe<Scalars['String']>;
  CPHOSYS?: InputMaybe<Scalars['String']>;
  CPHP?: InputMaybe<Scalars['float8']>;
  CPHPOS?: InputMaybe<Scalars['float8']>;
  DECHC?: InputMaybe<Scalars['String']>;
  DECUTLA?: InputMaybe<Scalars['String']>;
  DHACAR?: InputMaybe<Scalars['String']>;
  DHER?: InputMaybe<Scalars['String']>;
  DHPCS?: InputMaybe<Scalars['String']>;
  DHXCAR?: InputMaybe<Scalars['String']>;
  EAIMV?: InputMaybe<Scalars['float8']>;
  EDMCHG?: InputMaybe<Scalars['String']>;
  EICUHOS?: InputMaybe<Scalars['String']>;
  EICUSYS?: InputMaybe<Scalars['String']>;
  EICUVEN?: InputMaybe<Scalars['String']>;
  EPIMV?: InputMaybe<Scalars['float8']>;
  EQMCOS?: InputMaybe<Scalars['float8']>;
  EQMHOS?: InputMaybe<Scalars['float8']>;
  EQMIOS?: InputMaybe<Scalars['float8']>;
  EQMODHOS?: InputMaybe<Scalars['String']>;
  EQMODSYS?: InputMaybe<Scalars['String']>;
  EQMP?: InputMaybe<Scalars['float8']>;
  EQMPOS?: InputMaybe<Scalars['float8']>;
  FNDCOS?: InputMaybe<Scalars['float8']>;
  FNDHOS?: InputMaybe<Scalars['float8']>;
  FNDIOS?: InputMaybe<Scalars['float8']>;
  FNDP?: InputMaybe<Scalars['float8']>;
  FNDPOS?: InputMaybe<Scalars['float8']>;
  FOUNDHOS?: InputMaybe<Scalars['String']>;
  FOUNDSYS?: InputMaybe<Scalars['String']>;
  FTMT?: InputMaybe<Scalars['float8']>;
  GNONE?: InputMaybe<Scalars['String']>;
  GPWCOS?: InputMaybe<Scalars['float8']>;
  GPWHOS?: InputMaybe<Scalars['float8']>;
  GPWIOS?: InputMaybe<Scalars['float8']>;
  GPWP?: InputMaybe<Scalars['float8']>;
  GPWPOS?: InputMaybe<Scalars['float8']>;
  GPWWHOS?: InputMaybe<Scalars['String']>;
  GPWWSYS?: InputMaybe<Scalars['String']>;
  HARTHOS?: InputMaybe<Scalars['String']>;
  HARTSYS?: InputMaybe<Scalars['String']>;
  HARTVEN?: InputMaybe<Scalars['String']>;
  ICUCHG?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  IISMHOS?: InputMaybe<Scalars['float8']>;
  IMPSTAT?: InputMaybe<Scalars['String']>;
  IPACOS?: InputMaybe<Scalars['float8']>;
  IPAHOS?: InputMaybe<Scalars['String']>;
  IPAIOS?: InputMaybe<Scalars['float8']>;
  IPAP?: InputMaybe<Scalars['float8']>;
  IPAPOS?: InputMaybe<Scalars['float8']>;
  IPASYS?: InputMaybe<Scalars['String']>;
  IPPAHOS?: InputMaybe<Scalars['float8']>;
  ISMCOS?: InputMaybe<Scalars['float8']>;
  ISMHOS?: InputMaybe<Scalars['String']>;
  ISMIOS?: InputMaybe<Scalars['float8']>;
  ISMP?: InputMaybe<Scalars['float8']>;
  ISMPOS?: InputMaybe<Scalars['float8']>;
  ISMSYS?: InputMaybe<Scalars['String']>;
  ISORMB?: InputMaybe<Scalars['float8']>;
  ISORMC?: InputMaybe<Scalars['float8']>;
  ISORME?: InputMaybe<Scalars['float8']>;
  JNLS?: InputMaybe<Scalars['String']>;
  JNTAMB?: InputMaybe<Scalars['String']>;
  JNTCTR?: InputMaybe<Scalars['String']>;
  JNTLSC?: InputMaybe<Scalars['String']>;
  JNTLSO?: InputMaybe<Scalars['String']>;
  JNTLSS?: InputMaybe<Scalars['String']>;
  JNTLST?: InputMaybe<Scalars['String']>;
  JNTMD?: InputMaybe<Scalars['String']>;
  JNTOTH?: InputMaybe<Scalars['String']>;
  JNTPH?: InputMaybe<Scalars['String']>;
  JNTTXT?: InputMaybe<Scalars['String']>;
  KDNYHOS?: InputMaybe<Scalars['String']>;
  KDNYSYS?: InputMaybe<Scalars['String']>;
  KDNYVEN?: InputMaybe<Scalars['String']>;
  LIVRHOS?: InputMaybe<Scalars['String']>;
  LIVRSYS?: InputMaybe<Scalars['String']>;
  LIVRVEN?: InputMaybe<Scalars['String']>;
  LSHTXT?: InputMaybe<Scalars['String']>;
  LUNGHOS?: InputMaybe<Scalars['String']>;
  LUNGSYS?: InputMaybe<Scalars['String']>;
  LUNGVEN?: InputMaybe<Scalars['String']>;
  MEDOPHOS?: InputMaybe<Scalars['String']>;
  MEDOPSYS?: InputMaybe<Scalars['String']>;
  MEDOPVEN?: InputMaybe<Scalars['String']>;
  MEDSUBHOS?: InputMaybe<Scalars['String']>;
  MEDSUBSYS?: InputMaybe<Scalars['String']>;
  MEDSUBVEN?: InputMaybe<Scalars['String']>;
  MMSOHOS?: InputMaybe<Scalars['float8']>;
  MSGRP?: InputMaybe<Scalars['float8']>;
  MSGRPN?: InputMaybe<Scalars['float8']>;
  MSOCOS?: InputMaybe<Scalars['float8']>;
  MSOHOS?: InputMaybe<Scalars['String']>;
  MSOIOS?: InputMaybe<Scalars['float8']>;
  MSOP?: InputMaybe<Scalars['float8']>;
  MSOPOS?: InputMaybe<Scalars['float8']>;
  MSOSYS?: InputMaybe<Scalars['String']>;
  OPHCOS?: InputMaybe<Scalars['float8']>;
  OPHHOS?: InputMaybe<Scalars['float8']>;
  OPHIOS?: InputMaybe<Scalars['float8']>;
  OPHOHOS?: InputMaybe<Scalars['String']>;
  OPHOSYS?: InputMaybe<Scalars['String']>;
  OPHP?: InputMaybe<Scalars['float8']>;
  OPHPOS?: InputMaybe<Scalars['float8']>;
  ORPMHOS?: InputMaybe<Scalars['String']>;
  ORPMSYS?: InputMaybe<Scalars['String']>;
  ORPMVEN?: InputMaybe<Scalars['String']>;
  OTBONHOS?: InputMaybe<Scalars['String']>;
  OTBONSYS?: InputMaybe<Scalars['String']>;
  OTBONVEN?: InputMaybe<Scalars['String']>;
  OTHTHOS?: InputMaybe<Scalars['String']>;
  OTHTSYS?: InputMaybe<Scalars['String']>;
  OTHTVEN?: InputMaybe<Scalars['String']>;
  OTOTHHOS?: InputMaybe<Scalars['String']>;
  OTOTHSYS?: InputMaybe<Scalars['String']>;
  OTOTHVEN?: InputMaybe<Scalars['String']>;
  OUTMTX?: InputMaybe<Scalars['String']>;
  PDISHOS?: InputMaybe<Scalars['String']>;
  PDISSYS?: InputMaybe<Scalars['String']>;
  PDISVEN?: InputMaybe<Scalars['String']>;
  PHACAR?: InputMaybe<Scalars['String']>;
  PHER?: InputMaybe<Scalars['String']>;
  PHPCS?: InputMaybe<Scalars['String']>;
  PHXCAR?: InputMaybe<Scalars['String']>;
  PHYCOS?: InputMaybe<Scalars['float8']>;
  PHYCPT?: InputMaybe<Scalars['float8']>;
  PHYHOS?: InputMaybe<Scalars['String']>;
  PHYIOS?: InputMaybe<Scalars['float8']>;
  PHYOCPT?: InputMaybe<Scalars['float8']>;
  PHYOTH?: InputMaybe<Scalars['String']>;
  PHYP?: InputMaybe<Scalars['float8']>;
  PHYPOS?: InputMaybe<Scalars['float8']>;
  PHYPR?: InputMaybe<Scalars['float8']>;
  PHYPRN?: InputMaybe<Scalars['float8']>;
  PHYSYS?: InputMaybe<Scalars['String']>;
  PPHYHOS?: InputMaybe<Scalars['float8']>;
  RURLHOS?: InputMaybe<Scalars['String']>;
  RURLSYS?: InputMaybe<Scalars['String']>;
  RURLVEN?: InputMaybe<Scalars['String']>;
  SCBH?: InputMaybe<Scalars['String']>;
  SCEDL?: InputMaybe<Scalars['String']>;
  SCFOD?: InputMaybe<Scalars['String']>;
  SCHSE?: InputMaybe<Scalars['String']>;
  SCIOS?: InputMaybe<Scalars['String']>;
  SCNED?: InputMaybe<Scalars['String']>;
  SCOTH?: InputMaybe<Scalars['String']>;
  SCROT?: InputMaybe<Scalars['String']>;
  SCSTAT?: InputMaybe<Scalars['String']>;
  SCTRN?: InputMaybe<Scalars['String']>;
  SCUND?: InputMaybe<Scalars['String']>;
  SCV?: InputMaybe<Scalars['String']>;
  SHACAR?: InputMaybe<Scalars['String']>;
  SHER?: InputMaybe<Scalars['String']>;
  SHPCS?: InputMaybe<Scalars['String']>;
  SHXCAR?: InputMaybe<Scalars['String']>;
  SLEPHOS?: InputMaybe<Scalars['String']>;
  SLEPSYS?: InputMaybe<Scalars['String']>;
  SLEPVEN?: InputMaybe<Scalars['String']>;
  SOCBH?: InputMaybe<Scalars['String']>;
  SOCED?: InputMaybe<Scalars['String']>;
  SOCEHR?: InputMaybe<Scalars['String']>;
  SOCFOD?: InputMaybe<Scalars['String']>;
  SOCHSE?: InputMaybe<Scalars['String']>;
  SOCINC?: InputMaybe<Scalars['String']>;
  SOCIOS?: InputMaybe<Scalars['String']>;
  SOCNED?: InputMaybe<Scalars['String']>;
  SOCOT?: InputMaybe<Scalars['String']>;
  SOCOTH?: InputMaybe<Scalars['String']>;
  SOCTRN?: InputMaybe<Scalars['String']>;
  SOCV?: InputMaybe<Scalars['String']>;
  SOCWKHOS?: InputMaybe<Scalars['String']>;
  SOCWKSYS?: InputMaybe<Scalars['String']>;
  SOCWKVEN?: InputMaybe<Scalars['String']>;
  SPORTHOS?: InputMaybe<Scalars['String']>;
  SPORTSYS?: InputMaybe<Scalars['String']>;
  SPORTVEN?: InputMaybe<Scalars['String']>;
  SSGRP?: InputMaybe<Scalars['float8']>;
  SSGRPN?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  STFCHG?: InputMaybe<Scalars['String']>;
  STRCHOS?: InputMaybe<Scalars['String']>;
  STRCSYS?: InputMaybe<Scalars['String']>;
  STRCVEN?: InputMaybe<Scalars['String']>;
  SUPPGHOS?: InputMaybe<Scalars['String']>;
  SUPPGSYS?: InputMaybe<Scalars['String']>;
  SUPPGVEN?: InputMaybe<Scalars['String']>;
  SWBDHOS?: InputMaybe<Scalars['String']>;
  SWBDSYS?: InputMaybe<Scalars['String']>;
  SWBDVEN?: InputMaybe<Scalars['String']>;
  TEENSHOS?: InputMaybe<Scalars['String']>;
  TEENSSYS?: InputMaybe<Scalars['String']>;
  TEENSVEN?: InputMaybe<Scalars['String']>;
  TISUHOS?: InputMaybe<Scalars['String']>;
  TISUSYS?: InputMaybe<Scalars['String']>;
  TISUVEN?: InputMaybe<Scalars['String']>;
  TOBHOS?: InputMaybe<Scalars['String']>;
  TOBSYS?: InputMaybe<Scalars['String']>;
  TOBVEN?: InputMaybe<Scalars['String']>;
  TPORTHOS?: InputMaybe<Scalars['String']>;
  TPORTSYS?: InputMaybe<Scalars['String']>;
  TPORTVEN?: InputMaybe<Scalars['String']>;
  URGCCHOS?: InputMaybe<Scalars['String']>;
  URGCCSYS?: InputMaybe<Scalars['String']>;
  URGCCVEN?: InputMaybe<Scalars['String']>;
  VCMMHOS?: InputMaybe<Scalars['String']>;
  VCMMSYS?: InputMaybe<Scalars['String']>;
  VCMMVEN?: InputMaybe<Scalars['String']>;
  VOLSVHOS?: InputMaybe<Scalars['String']>;
  VOLSVSYS?: InputMaybe<Scalars['String']>;
  VOLSVVEN?: InputMaybe<Scalars['String']>;
  VRCSHOS?: InputMaybe<Scalars['String']>;
  VRCSSYS?: InputMaybe<Scalars['String']>;
  VRCSVEN?: InputMaybe<Scalars['String']>;
  VWRKHOS?: InputMaybe<Scalars['String']>;
  VWRKSYS?: InputMaybe<Scalars['String']>;
  VWRKVEN?: InputMaybe<Scalars['String']>;
  WMGTHOS?: InputMaybe<Scalars['String']>;
  WMGTSYS?: InputMaybe<Scalars['String']>;
  WMGTVEN?: InputMaybe<Scalars['String']>;
  WOMHCHOS?: InputMaybe<Scalars['String']>;
  WOMHCSYS?: InputMaybe<Scalars['String']>;
  WOMHCVEN?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type As22Svc3_Sum_Fields = {
  __typename?: 'AS22SVC3_sum_fields';
  ALDBD: Maybe<Scalars['float8']>;
  BAIMV: Maybe<Scalars['float8']>;
  BPIMV: Maybe<Scalars['float8']>;
  CPHCOS: Maybe<Scalars['float8']>;
  CPHHOS: Maybe<Scalars['float8']>;
  CPHIOS: Maybe<Scalars['float8']>;
  CPHP: Maybe<Scalars['float8']>;
  CPHPOS: Maybe<Scalars['float8']>;
  EAIMV: Maybe<Scalars['float8']>;
  EPIMV: Maybe<Scalars['float8']>;
  EQMCOS: Maybe<Scalars['float8']>;
  EQMHOS: Maybe<Scalars['float8']>;
  EQMIOS: Maybe<Scalars['float8']>;
  EQMP: Maybe<Scalars['float8']>;
  EQMPOS: Maybe<Scalars['float8']>;
  FNDCOS: Maybe<Scalars['float8']>;
  FNDHOS: Maybe<Scalars['float8']>;
  FNDIOS: Maybe<Scalars['float8']>;
  FNDP: Maybe<Scalars['float8']>;
  FNDPOS: Maybe<Scalars['float8']>;
  FTMT: Maybe<Scalars['float8']>;
  GPWCOS: Maybe<Scalars['float8']>;
  GPWHOS: Maybe<Scalars['float8']>;
  GPWIOS: Maybe<Scalars['float8']>;
  GPWP: Maybe<Scalars['float8']>;
  GPWPOS: Maybe<Scalars['float8']>;
  IISMHOS: Maybe<Scalars['float8']>;
  IPACOS: Maybe<Scalars['float8']>;
  IPAIOS: Maybe<Scalars['float8']>;
  IPAP: Maybe<Scalars['float8']>;
  IPAPOS: Maybe<Scalars['float8']>;
  IPPAHOS: Maybe<Scalars['float8']>;
  ISMCOS: Maybe<Scalars['float8']>;
  ISMIOS: Maybe<Scalars['float8']>;
  ISMP: Maybe<Scalars['float8']>;
  ISMPOS: Maybe<Scalars['float8']>;
  ISORMB: Maybe<Scalars['float8']>;
  ISORMC: Maybe<Scalars['float8']>;
  ISORME: Maybe<Scalars['float8']>;
  MMSOHOS: Maybe<Scalars['float8']>;
  MSGRP: Maybe<Scalars['float8']>;
  MSGRPN: Maybe<Scalars['float8']>;
  MSOCOS: Maybe<Scalars['float8']>;
  MSOIOS: Maybe<Scalars['float8']>;
  MSOP: Maybe<Scalars['float8']>;
  MSOPOS: Maybe<Scalars['float8']>;
  OPHCOS: Maybe<Scalars['float8']>;
  OPHHOS: Maybe<Scalars['float8']>;
  OPHIOS: Maybe<Scalars['float8']>;
  OPHP: Maybe<Scalars['float8']>;
  OPHPOS: Maybe<Scalars['float8']>;
  PHYCOS: Maybe<Scalars['float8']>;
  PHYCPT: Maybe<Scalars['float8']>;
  PHYIOS: Maybe<Scalars['float8']>;
  PHYOCPT: Maybe<Scalars['float8']>;
  PHYP: Maybe<Scalars['float8']>;
  PHYPOS: Maybe<Scalars['float8']>;
  PHYPR: Maybe<Scalars['float8']>;
  PHYPRN: Maybe<Scalars['float8']>;
  PPHYHOS: Maybe<Scalars['float8']>;
  SSGRP: Maybe<Scalars['float8']>;
  SSGRPN: Maybe<Scalars['float8']>;
};

/** update columns of table "AS22SVC3" */
export enum As22Svc3_Update_Column {
  /** column name */
  Adtrthos = 'ADTRTHOS',
  /** column name */
  Adtrtsys = 'ADTRTSYS',
  /** column name */
  Adtrtven = 'ADTRTVEN',
  /** column name */
  Alcophos = 'ALCOPHOS',
  /** column name */
  Alcopsys = 'ALCOPSYS',
  /** column name */
  Alcopven = 'ALCOPVEN',
  /** column name */
  Alcpdhos = 'ALCPDHOS',
  /** column name */
  Alcpdsys = 'ALCPDSYS',
  /** column name */
  Alcpdven = 'ALCPDVEN',
  /** column name */
  Alcprhos = 'ALCPRHOS',
  /** column name */
  Alcprsys = 'ALCPRSYS',
  /** column name */
  Alcprven = 'ALCPRVEN',
  /** column name */
  Aldbd = 'ALDBD',
  /** column name */
  Baimv = 'BAIMV',
  /** column name */
  Bhlta = 'BHLTA',
  /** column name */
  Bpimv = 'BPIMV',
  /** column name */
  Chacar = 'CHACAR',
  /** column name */
  Chcarhos = 'CHCARHOS',
  /** column name */
  Chcarsys = 'CHCARSYS',
  /** column name */
  Chcarven = 'CHCARVEN',
  /** column name */
  Cher = 'CHER',
  /** column name */
  Chpcs = 'CHPCS',
  /** column name */
  Chxcar = 'CHXCAR',
  /** column name */
  Cofvhos = 'COFVHOS',
  /** column name */
  Cofvsys = 'COFVSYS',
  /** column name */
  Cofvven = 'COFVVEN',
  /** column name */
  Covidu = 'COVIDU',
  /** column name */
  Cphcos = 'CPHCOS',
  /** column name */
  Cphhos = 'CPHHOS',
  /** column name */
  Cphios = 'CPHIOS',
  /** column name */
  Cphohos = 'CPHOHOS',
  /** column name */
  Cphosys = 'CPHOSYS',
  /** column name */
  Cphp = 'CPHP',
  /** column name */
  Cphpos = 'CPHPOS',
  /** column name */
  Dechc = 'DECHC',
  /** column name */
  Decutla = 'DECUTLA',
  /** column name */
  Dhacar = 'DHACAR',
  /** column name */
  Dher = 'DHER',
  /** column name */
  Dhpcs = 'DHPCS',
  /** column name */
  Dhxcar = 'DHXCAR',
  /** column name */
  Eaimv = 'EAIMV',
  /** column name */
  Edmchg = 'EDMCHG',
  /** column name */
  Eicuhos = 'EICUHOS',
  /** column name */
  Eicusys = 'EICUSYS',
  /** column name */
  Eicuven = 'EICUVEN',
  /** column name */
  Epimv = 'EPIMV',
  /** column name */
  Eqmcos = 'EQMCOS',
  /** column name */
  Eqmhos = 'EQMHOS',
  /** column name */
  Eqmios = 'EQMIOS',
  /** column name */
  Eqmodhos = 'EQMODHOS',
  /** column name */
  Eqmodsys = 'EQMODSYS',
  /** column name */
  Eqmp = 'EQMP',
  /** column name */
  Eqmpos = 'EQMPOS',
  /** column name */
  Fndcos = 'FNDCOS',
  /** column name */
  Fndhos = 'FNDHOS',
  /** column name */
  Fndios = 'FNDIOS',
  /** column name */
  Fndp = 'FNDP',
  /** column name */
  Fndpos = 'FNDPOS',
  /** column name */
  Foundhos = 'FOUNDHOS',
  /** column name */
  Foundsys = 'FOUNDSYS',
  /** column name */
  Ftmt = 'FTMT',
  /** column name */
  Gnone = 'GNONE',
  /** column name */
  Gpwcos = 'GPWCOS',
  /** column name */
  Gpwhos = 'GPWHOS',
  /** column name */
  Gpwios = 'GPWIOS',
  /** column name */
  Gpwp = 'GPWP',
  /** column name */
  Gpwpos = 'GPWPOS',
  /** column name */
  Gpwwhos = 'GPWWHOS',
  /** column name */
  Gpwwsys = 'GPWWSYS',
  /** column name */
  Harthos = 'HARTHOS',
  /** column name */
  Hartsys = 'HARTSYS',
  /** column name */
  Hartven = 'HARTVEN',
  /** column name */
  Icuchg = 'ICUCHG',
  /** column name */
  Id = 'ID',
  /** column name */
  Iismhos = 'IISMHOS',
  /** column name */
  Impstat = 'IMPSTAT',
  /** column name */
  Ipacos = 'IPACOS',
  /** column name */
  Ipahos = 'IPAHOS',
  /** column name */
  Ipaios = 'IPAIOS',
  /** column name */
  Ipap = 'IPAP',
  /** column name */
  Ipapos = 'IPAPOS',
  /** column name */
  Ipasys = 'IPASYS',
  /** column name */
  Ippahos = 'IPPAHOS',
  /** column name */
  Ismcos = 'ISMCOS',
  /** column name */
  Ismhos = 'ISMHOS',
  /** column name */
  Ismios = 'ISMIOS',
  /** column name */
  Ismp = 'ISMP',
  /** column name */
  Ismpos = 'ISMPOS',
  /** column name */
  Ismsys = 'ISMSYS',
  /** column name */
  Isormb = 'ISORMB',
  /** column name */
  Isormc = 'ISORMC',
  /** column name */
  Isorme = 'ISORME',
  /** column name */
  Jnls = 'JNLS',
  /** column name */
  Jntamb = 'JNTAMB',
  /** column name */
  Jntctr = 'JNTCTR',
  /** column name */
  Jntlsc = 'JNTLSC',
  /** column name */
  Jntlso = 'JNTLSO',
  /** column name */
  Jntlss = 'JNTLSS',
  /** column name */
  Jntlst = 'JNTLST',
  /** column name */
  Jntmd = 'JNTMD',
  /** column name */
  Jntoth = 'JNTOTH',
  /** column name */
  Jntph = 'JNTPH',
  /** column name */
  Jnttxt = 'JNTTXT',
  /** column name */
  Kdnyhos = 'KDNYHOS',
  /** column name */
  Kdnysys = 'KDNYSYS',
  /** column name */
  Kdnyven = 'KDNYVEN',
  /** column name */
  Livrhos = 'LIVRHOS',
  /** column name */
  Livrsys = 'LIVRSYS',
  /** column name */
  Livrven = 'LIVRVEN',
  /** column name */
  Lshtxt = 'LSHTXT',
  /** column name */
  Lunghos = 'LUNGHOS',
  /** column name */
  Lungsys = 'LUNGSYS',
  /** column name */
  Lungven = 'LUNGVEN',
  /** column name */
  Medophos = 'MEDOPHOS',
  /** column name */
  Medopsys = 'MEDOPSYS',
  /** column name */
  Medopven = 'MEDOPVEN',
  /** column name */
  Medsubhos = 'MEDSUBHOS',
  /** column name */
  Medsubsys = 'MEDSUBSYS',
  /** column name */
  Medsubven = 'MEDSUBVEN',
  /** column name */
  Mmsohos = 'MMSOHOS',
  /** column name */
  Msgrp = 'MSGRP',
  /** column name */
  Msgrpn = 'MSGRPN',
  /** column name */
  Msocos = 'MSOCOS',
  /** column name */
  Msohos = 'MSOHOS',
  /** column name */
  Msoios = 'MSOIOS',
  /** column name */
  Msop = 'MSOP',
  /** column name */
  Msopos = 'MSOPOS',
  /** column name */
  Msosys = 'MSOSYS',
  /** column name */
  Ophcos = 'OPHCOS',
  /** column name */
  Ophhos = 'OPHHOS',
  /** column name */
  Ophios = 'OPHIOS',
  /** column name */
  Ophohos = 'OPHOHOS',
  /** column name */
  Ophosys = 'OPHOSYS',
  /** column name */
  Ophp = 'OPHP',
  /** column name */
  Ophpos = 'OPHPOS',
  /** column name */
  Orpmhos = 'ORPMHOS',
  /** column name */
  Orpmsys = 'ORPMSYS',
  /** column name */
  Orpmven = 'ORPMVEN',
  /** column name */
  Otbonhos = 'OTBONHOS',
  /** column name */
  Otbonsys = 'OTBONSYS',
  /** column name */
  Otbonven = 'OTBONVEN',
  /** column name */
  Oththos = 'OTHTHOS',
  /** column name */
  Othtsys = 'OTHTSYS',
  /** column name */
  Othtven = 'OTHTVEN',
  /** column name */
  Otothhos = 'OTOTHHOS',
  /** column name */
  Otothsys = 'OTOTHSYS',
  /** column name */
  Otothven = 'OTOTHVEN',
  /** column name */
  Outmtx = 'OUTMTX',
  /** column name */
  Pdishos = 'PDISHOS',
  /** column name */
  Pdissys = 'PDISSYS',
  /** column name */
  Pdisven = 'PDISVEN',
  /** column name */
  Phacar = 'PHACAR',
  /** column name */
  Pher = 'PHER',
  /** column name */
  Phpcs = 'PHPCS',
  /** column name */
  Phxcar = 'PHXCAR',
  /** column name */
  Phycos = 'PHYCOS',
  /** column name */
  Phycpt = 'PHYCPT',
  /** column name */
  Phyhos = 'PHYHOS',
  /** column name */
  Phyios = 'PHYIOS',
  /** column name */
  Phyocpt = 'PHYOCPT',
  /** column name */
  Phyoth = 'PHYOTH',
  /** column name */
  Phyp = 'PHYP',
  /** column name */
  Phypos = 'PHYPOS',
  /** column name */
  Phypr = 'PHYPR',
  /** column name */
  Phyprn = 'PHYPRN',
  /** column name */
  Physys = 'PHYSYS',
  /** column name */
  Pphyhos = 'PPHYHOS',
  /** column name */
  Rurlhos = 'RURLHOS',
  /** column name */
  Rurlsys = 'RURLSYS',
  /** column name */
  Rurlven = 'RURLVEN',
  /** column name */
  Scbh = 'SCBH',
  /** column name */
  Scedl = 'SCEDL',
  /** column name */
  Scfod = 'SCFOD',
  /** column name */
  Schse = 'SCHSE',
  /** column name */
  Scios = 'SCIOS',
  /** column name */
  Scned = 'SCNED',
  /** column name */
  Scoth = 'SCOTH',
  /** column name */
  Scrot = 'SCROT',
  /** column name */
  Scstat = 'SCSTAT',
  /** column name */
  Sctrn = 'SCTRN',
  /** column name */
  Scund = 'SCUND',
  /** column name */
  Scv = 'SCV',
  /** column name */
  Shacar = 'SHACAR',
  /** column name */
  Sher = 'SHER',
  /** column name */
  Shpcs = 'SHPCS',
  /** column name */
  Shxcar = 'SHXCAR',
  /** column name */
  Slephos = 'SLEPHOS',
  /** column name */
  Slepsys = 'SLEPSYS',
  /** column name */
  Slepven = 'SLEPVEN',
  /** column name */
  Socbh = 'SOCBH',
  /** column name */
  Soced = 'SOCED',
  /** column name */
  Socehr = 'SOCEHR',
  /** column name */
  Socfod = 'SOCFOD',
  /** column name */
  Sochse = 'SOCHSE',
  /** column name */
  Socinc = 'SOCINC',
  /** column name */
  Socios = 'SOCIOS',
  /** column name */
  Socned = 'SOCNED',
  /** column name */
  Socot = 'SOCOT',
  /** column name */
  Socoth = 'SOCOTH',
  /** column name */
  Soctrn = 'SOCTRN',
  /** column name */
  Socv = 'SOCV',
  /** column name */
  Socwkhos = 'SOCWKHOS',
  /** column name */
  Socwksys = 'SOCWKSYS',
  /** column name */
  Socwkven = 'SOCWKVEN',
  /** column name */
  Sporthos = 'SPORTHOS',
  /** column name */
  Sportsys = 'SPORTSYS',
  /** column name */
  Sportven = 'SPORTVEN',
  /** column name */
  Ssgrp = 'SSGRP',
  /** column name */
  Ssgrpn = 'SSGRPN',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Stfchg = 'STFCHG',
  /** column name */
  Strchos = 'STRCHOS',
  /** column name */
  Strcsys = 'STRCSYS',
  /** column name */
  Strcven = 'STRCVEN',
  /** column name */
  Suppghos = 'SUPPGHOS',
  /** column name */
  Suppgsys = 'SUPPGSYS',
  /** column name */
  Suppgven = 'SUPPGVEN',
  /** column name */
  Swbdhos = 'SWBDHOS',
  /** column name */
  Swbdsys = 'SWBDSYS',
  /** column name */
  Swbdven = 'SWBDVEN',
  /** column name */
  Teenshos = 'TEENSHOS',
  /** column name */
  Teenssys = 'TEENSSYS',
  /** column name */
  Teensven = 'TEENSVEN',
  /** column name */
  Tisuhos = 'TISUHOS',
  /** column name */
  Tisusys = 'TISUSYS',
  /** column name */
  Tisuven = 'TISUVEN',
  /** column name */
  Tobhos = 'TOBHOS',
  /** column name */
  Tobsys = 'TOBSYS',
  /** column name */
  Tobven = 'TOBVEN',
  /** column name */
  Tporthos = 'TPORTHOS',
  /** column name */
  Tportsys = 'TPORTSYS',
  /** column name */
  Tportven = 'TPORTVEN',
  /** column name */
  Urgcchos = 'URGCCHOS',
  /** column name */
  Urgccsys = 'URGCCSYS',
  /** column name */
  Urgccven = 'URGCCVEN',
  /** column name */
  Vcmmhos = 'VCMMHOS',
  /** column name */
  Vcmmsys = 'VCMMSYS',
  /** column name */
  Vcmmven = 'VCMMVEN',
  /** column name */
  Volsvhos = 'VOLSVHOS',
  /** column name */
  Volsvsys = 'VOLSVSYS',
  /** column name */
  Volsvven = 'VOLSVVEN',
  /** column name */
  Vrcshos = 'VRCSHOS',
  /** column name */
  Vrcssys = 'VRCSSYS',
  /** column name */
  Vrcsven = 'VRCSVEN',
  /** column name */
  Vwrkhos = 'VWRKHOS',
  /** column name */
  Vwrksys = 'VWRKSYS',
  /** column name */
  Vwrkven = 'VWRKVEN',
  /** column name */
  Wmgthos = 'WMGTHOS',
  /** column name */
  Wmgtsys = 'WMGTSYS',
  /** column name */
  Wmgtven = 'WMGTVEN',
  /** column name */
  Womhchos = 'WOMHCHOS',
  /** column name */
  Womhcsys = 'WOMHCSYS',
  /** column name */
  Womhcven = 'WOMHCVEN'
}

export type As22Svc3_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As22Svc3_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Svc3_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Svc3_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As22Svc3_Var_Pop_Fields = {
  __typename?: 'AS22SVC3_var_pop_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As22Svc3_Var_Samp_Fields = {
  __typename?: 'AS22SVC3_var_samp_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As22Svc3_Variance_Fields = {
  __typename?: 'AS22SVC3_variance_fields';
  ALDBD: Maybe<Scalars['Float']>;
  BAIMV: Maybe<Scalars['Float']>;
  BPIMV: Maybe<Scalars['Float']>;
  CPHCOS: Maybe<Scalars['Float']>;
  CPHHOS: Maybe<Scalars['Float']>;
  CPHIOS: Maybe<Scalars['Float']>;
  CPHP: Maybe<Scalars['Float']>;
  CPHPOS: Maybe<Scalars['Float']>;
  EAIMV: Maybe<Scalars['Float']>;
  EPIMV: Maybe<Scalars['Float']>;
  EQMCOS: Maybe<Scalars['Float']>;
  EQMHOS: Maybe<Scalars['Float']>;
  EQMIOS: Maybe<Scalars['Float']>;
  EQMP: Maybe<Scalars['Float']>;
  EQMPOS: Maybe<Scalars['Float']>;
  FNDCOS: Maybe<Scalars['Float']>;
  FNDHOS: Maybe<Scalars['Float']>;
  FNDIOS: Maybe<Scalars['Float']>;
  FNDP: Maybe<Scalars['Float']>;
  FNDPOS: Maybe<Scalars['Float']>;
  FTMT: Maybe<Scalars['Float']>;
  GPWCOS: Maybe<Scalars['Float']>;
  GPWHOS: Maybe<Scalars['Float']>;
  GPWIOS: Maybe<Scalars['Float']>;
  GPWP: Maybe<Scalars['Float']>;
  GPWPOS: Maybe<Scalars['Float']>;
  IISMHOS: Maybe<Scalars['Float']>;
  IPACOS: Maybe<Scalars['Float']>;
  IPAIOS: Maybe<Scalars['Float']>;
  IPAP: Maybe<Scalars['Float']>;
  IPAPOS: Maybe<Scalars['Float']>;
  IPPAHOS: Maybe<Scalars['Float']>;
  ISMCOS: Maybe<Scalars['Float']>;
  ISMIOS: Maybe<Scalars['Float']>;
  ISMP: Maybe<Scalars['Float']>;
  ISMPOS: Maybe<Scalars['Float']>;
  ISORMB: Maybe<Scalars['Float']>;
  ISORMC: Maybe<Scalars['Float']>;
  ISORME: Maybe<Scalars['Float']>;
  MMSOHOS: Maybe<Scalars['Float']>;
  MSGRP: Maybe<Scalars['Float']>;
  MSGRPN: Maybe<Scalars['Float']>;
  MSOCOS: Maybe<Scalars['Float']>;
  MSOIOS: Maybe<Scalars['Float']>;
  MSOP: Maybe<Scalars['Float']>;
  MSOPOS: Maybe<Scalars['Float']>;
  OPHCOS: Maybe<Scalars['Float']>;
  OPHHOS: Maybe<Scalars['Float']>;
  OPHIOS: Maybe<Scalars['Float']>;
  OPHP: Maybe<Scalars['Float']>;
  OPHPOS: Maybe<Scalars['Float']>;
  PHYCOS: Maybe<Scalars['Float']>;
  PHYCPT: Maybe<Scalars['Float']>;
  PHYIOS: Maybe<Scalars['Float']>;
  PHYOCPT: Maybe<Scalars['Float']>;
  PHYP: Maybe<Scalars['Float']>;
  PHYPOS: Maybe<Scalars['Float']>;
  PHYPR: Maybe<Scalars['Float']>;
  PHYPRN: Maybe<Scalars['Float']>;
  PPHYHOS: Maybe<Scalars['Float']>;
  SSGRP: Maybe<Scalars['Float']>;
  SSGRPN: Maybe<Scalars['Float']>;
};

/** columns and relationships of "AS22UNIT" */
export type As22Unit = {
  __typename?: 'AS22UNIT';
  ID: Scalars['String'];
  PARID: Scalars['String'];
  UADDR: Maybe<Scalars['String']>;
  UCITY: Maybe<Scalars['String']>;
  UNAME: Scalars['String'];
  UPHONE: Maybe<Scalars['String']>;
  USERV: Maybe<Scalars['String']>;
  USTATE: Maybe<Scalars['String']>;
  USTCD: Maybe<Scalars['String']>;
  UZIP: Maybe<Scalars['String']>;
  /** An object relationship */
  parent_aha_facility: As22Dem;
};

/** aggregated selection of "AS22UNIT" */
export type As22Unit_Aggregate = {
  __typename?: 'AS22UNIT_aggregate';
  aggregate: Maybe<As22Unit_Aggregate_Fields>;
  nodes: Array<As22Unit>;
};

export type As22Unit_Aggregate_Bool_Exp = {
  count?: InputMaybe<As22Unit_Aggregate_Bool_Exp_Count>;
};

export type As22Unit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<As22Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<As22Unit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "AS22UNIT" */
export type As22Unit_Aggregate_Fields = {
  __typename?: 'AS22UNIT_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<As22Unit_Max_Fields>;
  min: Maybe<As22Unit_Min_Fields>;
};


/** aggregate fields of "AS22UNIT" */
export type As22Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "AS22UNIT" */
export type As22Unit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<As22Unit_Max_Order_By>;
  min?: InputMaybe<As22Unit_Min_Order_By>;
};

/** input type for inserting array relation for remote table "AS22UNIT" */
export type As22Unit_Arr_Rel_Insert_Input = {
  data: Array<As22Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Unit_On_Conflict>;
};

/** Boolean expression to filter rows from the table "AS22UNIT". All fields are combined with a logical 'AND'. */
export type As22Unit_Bool_Exp = {
  ID?: InputMaybe<String_Comparison_Exp>;
  PARID?: InputMaybe<String_Comparison_Exp>;
  UADDR?: InputMaybe<String_Comparison_Exp>;
  UCITY?: InputMaybe<String_Comparison_Exp>;
  UNAME?: InputMaybe<String_Comparison_Exp>;
  UPHONE?: InputMaybe<String_Comparison_Exp>;
  USERV?: InputMaybe<String_Comparison_Exp>;
  USTATE?: InputMaybe<String_Comparison_Exp>;
  USTCD?: InputMaybe<String_Comparison_Exp>;
  UZIP?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Unit_Bool_Exp>>;
  _not?: InputMaybe<As22Unit_Bool_Exp>;
  _or?: InputMaybe<Array<As22Unit_Bool_Exp>>;
  parent_aha_facility?: InputMaybe<As22Dem_Bool_Exp>;
};

/** unique or primary key constraints on table "AS22UNIT" */
export enum As22Unit_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Unit = 'pk_AS22UNIT'
}

/** input type for inserting data into table "AS22UNIT" */
export type As22Unit_Insert_Input = {
  ID?: InputMaybe<Scalars['String']>;
  PARID?: InputMaybe<Scalars['String']>;
  UADDR?: InputMaybe<Scalars['String']>;
  UCITY?: InputMaybe<Scalars['String']>;
  UNAME?: InputMaybe<Scalars['String']>;
  UPHONE?: InputMaybe<Scalars['String']>;
  USERV?: InputMaybe<Scalars['String']>;
  USTATE?: InputMaybe<Scalars['String']>;
  USTCD?: InputMaybe<Scalars['String']>;
  UZIP?: InputMaybe<Scalars['String']>;
  parent_aha_facility?: InputMaybe<As22Dem_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type As22Unit_Max_Fields = {
  __typename?: 'AS22UNIT_max_fields';
  ID: Maybe<Scalars['String']>;
  PARID: Maybe<Scalars['String']>;
  UADDR: Maybe<Scalars['String']>;
  UCITY: Maybe<Scalars['String']>;
  UNAME: Maybe<Scalars['String']>;
  UPHONE: Maybe<Scalars['String']>;
  USERV: Maybe<Scalars['String']>;
  USTATE: Maybe<Scalars['String']>;
  USTCD: Maybe<Scalars['String']>;
  UZIP: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "AS22UNIT" */
export type As22Unit_Max_Order_By = {
  ID?: InputMaybe<Order_By>;
  PARID?: InputMaybe<Order_By>;
  UADDR?: InputMaybe<Order_By>;
  UCITY?: InputMaybe<Order_By>;
  UNAME?: InputMaybe<Order_By>;
  UPHONE?: InputMaybe<Order_By>;
  USERV?: InputMaybe<Order_By>;
  USTATE?: InputMaybe<Order_By>;
  USTCD?: InputMaybe<Order_By>;
  UZIP?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type As22Unit_Min_Fields = {
  __typename?: 'AS22UNIT_min_fields';
  ID: Maybe<Scalars['String']>;
  PARID: Maybe<Scalars['String']>;
  UADDR: Maybe<Scalars['String']>;
  UCITY: Maybe<Scalars['String']>;
  UNAME: Maybe<Scalars['String']>;
  UPHONE: Maybe<Scalars['String']>;
  USERV: Maybe<Scalars['String']>;
  USTATE: Maybe<Scalars['String']>;
  USTCD: Maybe<Scalars['String']>;
  UZIP: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "AS22UNIT" */
export type As22Unit_Min_Order_By = {
  ID?: InputMaybe<Order_By>;
  PARID?: InputMaybe<Order_By>;
  UADDR?: InputMaybe<Order_By>;
  UCITY?: InputMaybe<Order_By>;
  UNAME?: InputMaybe<Order_By>;
  UPHONE?: InputMaybe<Order_By>;
  USERV?: InputMaybe<Order_By>;
  USTATE?: InputMaybe<Order_By>;
  USTCD?: InputMaybe<Order_By>;
  UZIP?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "AS22UNIT" */
export type As22Unit_Mutation_Response = {
  __typename?: 'AS22UNIT_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Unit>;
};

/** on_conflict condition type for table "AS22UNIT" */
export type As22Unit_On_Conflict = {
  constraint: As22Unit_Constraint;
  update_columns?: Array<As22Unit_Update_Column>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22UNIT". */
export type As22Unit_Order_By = {
  ID?: InputMaybe<Order_By>;
  PARID?: InputMaybe<Order_By>;
  UADDR?: InputMaybe<Order_By>;
  UCITY?: InputMaybe<Order_By>;
  UNAME?: InputMaybe<Order_By>;
  UPHONE?: InputMaybe<Order_By>;
  USERV?: InputMaybe<Order_By>;
  USTATE?: InputMaybe<Order_By>;
  USTCD?: InputMaybe<Order_By>;
  UZIP?: InputMaybe<Order_By>;
  parent_aha_facility?: InputMaybe<As22Dem_Order_By>;
};

/** primary key columns input for table: AS22UNIT */
export type As22Unit_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22UNIT" */
export enum As22Unit_Select_Column {
  /** column name */
  Id = 'ID',
  /** column name */
  Parid = 'PARID',
  /** column name */
  Uaddr = 'UADDR',
  /** column name */
  Ucity = 'UCITY',
  /** column name */
  Uname = 'UNAME',
  /** column name */
  Uphone = 'UPHONE',
  /** column name */
  Userv = 'USERV',
  /** column name */
  Ustate = 'USTATE',
  /** column name */
  Ustcd = 'USTCD',
  /** column name */
  Uzip = 'UZIP'
}

/** input type for updating data in table "AS22UNIT" */
export type As22Unit_Set_Input = {
  ID?: InputMaybe<Scalars['String']>;
  PARID?: InputMaybe<Scalars['String']>;
  UADDR?: InputMaybe<Scalars['String']>;
  UCITY?: InputMaybe<Scalars['String']>;
  UNAME?: InputMaybe<Scalars['String']>;
  UPHONE?: InputMaybe<Scalars['String']>;
  USERV?: InputMaybe<Scalars['String']>;
  USTATE?: InputMaybe<Scalars['String']>;
  USTCD?: InputMaybe<Scalars['String']>;
  UZIP?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "AS22UNIT" */
export type As22Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Unit_Stream_Cursor_Value_Input = {
  ID?: InputMaybe<Scalars['String']>;
  PARID?: InputMaybe<Scalars['String']>;
  UADDR?: InputMaybe<Scalars['String']>;
  UCITY?: InputMaybe<Scalars['String']>;
  UNAME?: InputMaybe<Scalars['String']>;
  UPHONE?: InputMaybe<Scalars['String']>;
  USERV?: InputMaybe<Scalars['String']>;
  USTATE?: InputMaybe<Scalars['String']>;
  USTCD?: InputMaybe<Scalars['String']>;
  UZIP?: InputMaybe<Scalars['String']>;
};

/** update columns of table "AS22UNIT" */
export enum As22Unit_Update_Column {
  /** column name */
  Id = 'ID',
  /** column name */
  Parid = 'PARID',
  /** column name */
  Uaddr = 'UADDR',
  /** column name */
  Ucity = 'UCITY',
  /** column name */
  Uname = 'UNAME',
  /** column name */
  Uphone = 'UPHONE',
  /** column name */
  Userv = 'USERV',
  /** column name */
  Ustate = 'USTATE',
  /** column name */
  Ustcd = 'USTCD',
  /** column name */
  Uzip = 'UZIP'
}

export type As22Unit_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Unit_Bool_Exp;
};

/** columns and relationships of "AS22UTIL" */
export type As22Util = {
  __typename?: 'AS22UTIL';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  CRNFTE: Maybe<Scalars['float8']>;
  CTFTE: Maybe<Scalars['float8']>;
  DCLT: Maybe<Scalars['float8']>;
  DCTOT: Maybe<Scalars['float8']>;
  DCTOTH: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EOPDCH: Maybe<Scalars['float8']>;
  EOPDCLT: Maybe<Scalars['String']>;
  EOPIPDH: Maybe<Scalars['float8']>;
  EOPIPDLT: Maybe<Scalars['float8']>;
  EOPOTDC: Maybe<Scalars['String']>;
  EOPOTIP: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESPDCH: Maybe<Scalars['float8']>;
  ESPDCLT: Maybe<Scalars['float8']>;
  ESPIPDH: Maybe<Scalars['float8']>;
  ESPIPDLT: Maybe<Scalars['float8']>;
  ESPTDC: Maybe<Scalars['String']>;
  ESPTIP: Maybe<Scalars['String']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  ETHRDCH: Maybe<Scalars['float8']>;
  ETHRDCLT: Maybe<Scalars['String']>;
  ETHRIPDH: Maybe<Scalars['float8']>;
  ETHRIPDLT: Maybe<Scalars['float8']>;
  ETHRTDC: Maybe<Scalars['String']>;
  ETHRTIP: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Scalars['String'];
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LABFTE: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPDCH: Maybe<Scalars['float8']>;
  OPDCLT: Maybe<Scalars['float8']>;
  OPIPDH: Maybe<Scalars['float8']>;
  OPIPDLT: Maybe<Scalars['float8']>;
  OPOTDC: Maybe<Scalars['float8']>;
  OPOTIP: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHAFTE: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  RADFTE: Maybe<Scalars['float8']>;
  RTTFTE: Maybe<Scalars['float8']>;
  SPDCH: Maybe<Scalars['float8']>;
  SPDCLT: Maybe<Scalars['float8']>;
  SPIPDH: Maybe<Scalars['float8']>;
  SPIPDLT: Maybe<Scalars['float8']>;
  SPTDC: Maybe<Scalars['float8']>;
  SPTIP: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  TECFTE: Maybe<Scalars['float8']>;
  THRDCH: Maybe<Scalars['float8']>;
  THRDCLT: Maybe<Scalars['float8']>;
  THRIPDH: Maybe<Scalars['float8']>;
  THRIPDLT: Maybe<Scalars['float8']>;
  THRTDC: Maybe<Scalars['float8']>;
  THRTIP: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** columns and relationships of "AS22UTIL2" */
export type As22Util2 = {
  __typename?: 'AS22UTIL2';
  AAACLI: Maybe<Scalars['String']>;
  AAACNA: Maybe<Scalars['String']>;
  AAANI: Maybe<Scalars['String']>;
  AAAPSN: Maybe<Scalars['String']>;
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  BHHLT: Maybe<Scalars['String']>;
  BHPRDCLI: Maybe<Scalars['String']>;
  BHPRDCNA: Maybe<Scalars['String']>;
  BHPRDNI: Maybe<Scalars['String']>;
  BHPRDPSN: Maybe<Scalars['String']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  CMHLT: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  DEIDNA: Maybe<Scalars['float8']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGNA: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  KOREA: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PH: Maybe<Scalars['String']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PHEGNA: Maybe<Scalars['float8']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGNA: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIDNA: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTDNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** aggregated selection of "AS22UTIL2" */
export type As22Util2_Aggregate = {
  __typename?: 'AS22UTIL2_aggregate';
  aggregate: Maybe<As22Util2_Aggregate_Fields>;
  nodes: Array<As22Util2>;
};

/** aggregate fields of "AS22UTIL2" */
export type As22Util2_Aggregate_Fields = {
  __typename?: 'AS22UTIL2_aggregate_fields';
  avg: Maybe<As22Util2_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As22Util2_Max_Fields>;
  min: Maybe<As22Util2_Min_Fields>;
  stddev: Maybe<As22Util2_Stddev_Fields>;
  stddev_pop: Maybe<As22Util2_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As22Util2_Stddev_Samp_Fields>;
  sum: Maybe<As22Util2_Sum_Fields>;
  var_pop: Maybe<As22Util2_Var_Pop_Fields>;
  var_samp: Maybe<As22Util2_Var_Samp_Fields>;
  variance: Maybe<As22Util2_Variance_Fields>;
};


/** aggregate fields of "AS22UTIL2" */
export type As22Util2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Util2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As22Util2_Avg_Fields = {
  __typename?: 'AS22UTIL2_avg_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS22UTIL2". All fields are combined with a logical 'AND'. */
export type As22Util2_Bool_Exp = {
  AAACLI?: InputMaybe<String_Comparison_Exp>;
  AAACNA?: InputMaybe<String_Comparison_Exp>;
  AAANI?: InputMaybe<String_Comparison_Exp>;
  AAAPSN?: InputMaybe<String_Comparison_Exp>;
  ADEPRA?: InputMaybe<Float8_Comparison_Exp>;
  AFRICA?: InputMaybe<String_Comparison_Exp>;
  APANES?: InputMaybe<String_Comparison_Exp>;
  APCAR?: InputMaybe<String_Comparison_Exp>;
  APCASE?: InputMaybe<String_Comparison_Exp>;
  APED?: InputMaybe<String_Comparison_Exp>;
  APEMER?: InputMaybe<String_Comparison_Exp>;
  APOTH?: InputMaybe<String_Comparison_Exp>;
  APRN?: InputMaybe<String_Comparison_Exp>;
  APSPC?: InputMaybe<String_Comparison_Exp>;
  ASSNET?: InputMaybe<Float8_Comparison_Exp>;
  AUVZ?: InputMaybe<Float8_Comparison_Exp>;
  BHHLT?: InputMaybe<String_Comparison_Exp>;
  BHPRDCLI?: InputMaybe<String_Comparison_Exp>;
  BHPRDCNA?: InputMaybe<String_Comparison_Exp>;
  BHPRDNI?: InputMaybe<String_Comparison_Exp>;
  BHPRDPSN?: InputMaybe<String_Comparison_Exp>;
  CANADA?: InputMaybe<String_Comparison_Exp>;
  CEAMT?: InputMaybe<Float8_Comparison_Exp>;
  CHINA?: InputMaybe<String_Comparison_Exp>;
  CLSCIC?: InputMaybe<String_Comparison_Exp>;
  CLSMSI?: InputMaybe<String_Comparison_Exp>;
  CLSNIC?: InputMaybe<String_Comparison_Exp>;
  CLSOIC?: InputMaybe<String_Comparison_Exp>;
  CLSPIC?: InputMaybe<String_Comparison_Exp>;
  CMHLT?: InputMaybe<String_Comparison_Exp>;
  COLLCLI?: InputMaybe<String_Comparison_Exp>;
  COLLCNA?: InputMaybe<String_Comparison_Exp>;
  COLLNI?: InputMaybe<String_Comparison_Exp>;
  COLLPSN?: InputMaybe<String_Comparison_Exp>;
  DEIDNA?: InputMaybe<Float8_Comparison_Exp>;
  DEIDPDEV?: InputMaybe<Float8_Comparison_Exp>;
  DEIDPO?: InputMaybe<Float8_Comparison_Exp>;
  DEIDPROC?: InputMaybe<Float8_Comparison_Exp>;
  DEIDSPCH?: InputMaybe<Float8_Comparison_Exp>;
  DEIDTRN?: InputMaybe<Float8_Comparison_Exp>;
  FBORCLI?: InputMaybe<String_Comparison_Exp>;
  FBORCNA?: InputMaybe<String_Comparison_Exp>;
  FBORNI?: InputMaybe<String_Comparison_Exp>;
  FBORPSN?: InputMaybe<String_Comparison_Exp>;
  FORNRSA?: InputMaybe<String_Comparison_Exp>;
  FTAPRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEAPN?: InputMaybe<Float8_Comparison_Exp>;
  FTECIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEHSP?: InputMaybe<Float8_Comparison_Exp>;
  FTEINT?: InputMaybe<Float8_Comparison_Exp>;
  FTEMSI?: InputMaybe<Float8_Comparison_Exp>;
  FTENIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEOIC?: InputMaybe<Float8_Comparison_Exp>;
  FTEPHRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEPIC?: InputMaybe<Float8_Comparison_Exp>;
  FTPHRN?: InputMaybe<Float8_Comparison_Exp>;
  GFEET?: InputMaybe<Float8_Comparison_Exp>;
  HCOCCLI?: InputMaybe<String_Comparison_Exp>;
  HCOCCNA?: InputMaybe<String_Comparison_Exp>;
  HCOCNI?: InputMaybe<String_Comparison_Exp>;
  HCOCPSN?: InputMaybe<String_Comparison_Exp>;
  HHEGCDO?: InputMaybe<Float8_Comparison_Exp>;
  HHEGCEO?: InputMaybe<Float8_Comparison_Exp>;
  HHEGERG?: InputMaybe<Float8_Comparison_Exp>;
  HHEGLEAD?: InputMaybe<Float8_Comparison_Exp>;
  HHEGMDMN?: InputMaybe<Float8_Comparison_Exp>;
  HHEGNA?: InputMaybe<Float8_Comparison_Exp>;
  HHEGTKFC?: InputMaybe<Float8_Comparison_Exp>;
  HICOCCLI?: InputMaybe<String_Comparison_Exp>;
  HICOCCNA?: InputMaybe<String_Comparison_Exp>;
  HICOCNI?: InputMaybe<String_Comparison_Exp>;
  HICOCPSN?: InputMaybe<String_Comparison_Exp>;
  HSPTL?: InputMaybe<String_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  INDIA?: InputMaybe<String_Comparison_Exp>;
  INTCAR?: InputMaybe<String_Comparison_Exp>;
  KOREA?: InputMaybe<String_Comparison_Exp>;
  KSCHCLI?: InputMaybe<String_Comparison_Exp>;
  KSCHCNA?: InputMaybe<String_Comparison_Exp>;
  KSCHNI?: InputMaybe<String_Comparison_Exp>;
  KSCHPSN?: InputMaybe<String_Comparison_Exp>;
  LOCFCLI?: InputMaybe<String_Comparison_Exp>;
  LOCFCNA?: InputMaybe<String_Comparison_Exp>;
  LOCFNI?: InputMaybe<String_Comparison_Exp>;
  LOCFPSN?: InputMaybe<String_Comparison_Exp>;
  LOCHSCLI?: InputMaybe<String_Comparison_Exp>;
  LOCHSCNA?: InputMaybe<String_Comparison_Exp>;
  LOCHSNI?: InputMaybe<String_Comparison_Exp>;
  LOCHSPSN?: InputMaybe<String_Comparison_Exp>;
  LOCLGCLI?: InputMaybe<String_Comparison_Exp>;
  LOCLGCNA?: InputMaybe<String_Comparison_Exp>;
  LOCLGNI?: InputMaybe<String_Comparison_Exp>;
  LOCLGPSN?: InputMaybe<String_Comparison_Exp>;
  LOCOCCLI?: InputMaybe<String_Comparison_Exp>;
  LOCOCCNA?: InputMaybe<String_Comparison_Exp>;
  LOCOCNI?: InputMaybe<String_Comparison_Exp>;
  LOCOCPSN?: InputMaybe<String_Comparison_Exp>;
  LOCTRCLI?: InputMaybe<String_Comparison_Exp>;
  LOCTRCNA?: InputMaybe<String_Comparison_Exp>;
  LOCTRNI?: InputMaybe<String_Comparison_Exp>;
  LOCTRPSN?: InputMaybe<String_Comparison_Exp>;
  LORGCLI?: InputMaybe<String_Comparison_Exp>;
  LORGCNA?: InputMaybe<String_Comparison_Exp>;
  LORGNI?: InputMaybe<String_Comparison_Exp>;
  LORGPSN?: InputMaybe<String_Comparison_Exp>;
  NECAR?: InputMaybe<Float8_Comparison_Exp>;
  NEGST?: InputMaybe<Float8_Comparison_Exp>;
  NEHSP?: InputMaybe<Float8_Comparison_Exp>;
  NEINT?: InputMaybe<Float8_Comparison_Exp>;
  NEMER?: InputMaybe<Float8_Comparison_Exp>;
  NEOB?: InputMaybe<Float8_Comparison_Exp>;
  NEOTH?: InputMaybe<Float8_Comparison_Exp>;
  NETOT?: InputMaybe<Float8_Comparison_Exp>;
  OFRNRS?: InputMaybe<String_Comparison_Exp>;
  OTCOMCLI?: InputMaybe<String_Comparison_Exp>;
  OTCOMCNA?: InputMaybe<String_Comparison_Exp>;
  OTCOMNI?: InputMaybe<String_Comparison_Exp>;
  OTCOMPSN?: InputMaybe<String_Comparison_Exp>;
  OTLSCLI?: InputMaybe<String_Comparison_Exp>;
  OTLSCNA?: InputMaybe<String_Comparison_Exp>;
  OTLSNI?: InputMaybe<String_Comparison_Exp>;
  OTLSPSN?: InputMaybe<String_Comparison_Exp>;
  PH?: InputMaybe<String_Comparison_Exp>;
  PHEGACC?: InputMaybe<Float8_Comparison_Exp>;
  PHEGCAPC?: InputMaybe<Float8_Comparison_Exp>;
  PHEGCMTY?: InputMaybe<Float8_Comparison_Exp>;
  PHEGDATA?: InputMaybe<Float8_Comparison_Exp>;
  PHEGEIOP?: InputMaybe<Float8_Comparison_Exp>;
  PHEGGOV?: InputMaybe<Float8_Comparison_Exp>;
  PHEGLEAD?: InputMaybe<Float8_Comparison_Exp>;
  PHEGNA?: InputMaybe<Float8_Comparison_Exp>;
  PLCECLI?: InputMaybe<String_Comparison_Exp>;
  PLCECNA?: InputMaybe<String_Comparison_Exp>;
  PLCENI?: InputMaybe<String_Comparison_Exp>;
  PLCEPSN?: InputMaybe<String_Comparison_Exp>;
  PLNTA?: InputMaybe<Float8_Comparison_Exp>;
  PRPM?: InputMaybe<Float8_Comparison_Exp>;
  PTAPRN?: InputMaybe<Float8_Comparison_Exp>;
  PTPHRN?: InputMaybe<Float8_Comparison_Exp>;
  RNSCH?: InputMaybe<Float8_Comparison_Exp>;
  SHEGCDO?: InputMaybe<Float8_Comparison_Exp>;
  SHEGCEO?: InputMaybe<Float8_Comparison_Exp>;
  SHEGERG?: InputMaybe<Float8_Comparison_Exp>;
  SHEGLEAD?: InputMaybe<Float8_Comparison_Exp>;
  SHEGMDMN?: InputMaybe<Float8_Comparison_Exp>;
  SHEGNA?: InputMaybe<Float8_Comparison_Exp>;
  SHEGTKFC?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  TCCAR?: InputMaybe<Float8_Comparison_Exp>;
  TCGST?: InputMaybe<Float8_Comparison_Exp>;
  TCHSP?: InputMaybe<Float8_Comparison_Exp>;
  TCINT?: InputMaybe<Float8_Comparison_Exp>;
  TCMER?: InputMaybe<Float8_Comparison_Exp>;
  TCOB?: InputMaybe<Float8_Comparison_Exp>;
  TCOTH?: InputMaybe<Float8_Comparison_Exp>;
  TCTOT?: InputMaybe<Float8_Comparison_Exp>;
  TECAR?: InputMaybe<Float8_Comparison_Exp>;
  TEGST?: InputMaybe<Float8_Comparison_Exp>;
  TEHSP?: InputMaybe<Float8_Comparison_Exp>;
  TEINT?: InputMaybe<Float8_Comparison_Exp>;
  TEMER?: InputMaybe<Float8_Comparison_Exp>;
  TEOB?: InputMaybe<Float8_Comparison_Exp>;
  TEOTH?: InputMaybe<Float8_Comparison_Exp>;
  TETOT?: InputMaybe<Float8_Comparison_Exp>;
  TGCAR?: InputMaybe<Float8_Comparison_Exp>;
  TGGST?: InputMaybe<Float8_Comparison_Exp>;
  TGHSP?: InputMaybe<Float8_Comparison_Exp>;
  TGINT?: InputMaybe<Float8_Comparison_Exp>;
  TGMER?: InputMaybe<Float8_Comparison_Exp>;
  TGOB?: InputMaybe<Float8_Comparison_Exp>;
  TGOTH?: InputMaybe<Float8_Comparison_Exp>;
  TGTOT?: InputMaybe<Float8_Comparison_Exp>;
  TPCAR?: InputMaybe<Float8_Comparison_Exp>;
  TPGST?: InputMaybe<Float8_Comparison_Exp>;
  TPHSP?: InputMaybe<Float8_Comparison_Exp>;
  TPINT?: InputMaybe<Float8_Comparison_Exp>;
  TPMER?: InputMaybe<Float8_Comparison_Exp>;
  TPOB?: InputMaybe<Float8_Comparison_Exp>;
  TPOTH?: InputMaybe<Float8_Comparison_Exp>;
  TPRTOT?: InputMaybe<Float8_Comparison_Exp>;
  VIDVZ?: InputMaybe<Float8_Comparison_Exp>;
  VPSRV?: InputMaybe<Float8_Comparison_Exp>;
  WFAIART?: InputMaybe<Float8_Comparison_Exp>;
  WFAIDNA?: InputMaybe<Float8_Comparison_Exp>;
  WFAIOACW?: InputMaybe<Float8_Comparison_Exp>;
  WFAIPPD?: InputMaybe<Float8_Comparison_Exp>;
  WFAIPSN?: InputMaybe<Float8_Comparison_Exp>;
  WFAISS?: InputMaybe<Float8_Comparison_Exp>;
  WFSTCNA?: InputMaybe<Float8_Comparison_Exp>;
  WFSTDNA?: InputMaybe<Float8_Comparison_Exp>;
  WFSTHCC?: InputMaybe<Float8_Comparison_Exp>;
  WFSTLSP?: InputMaybe<Float8_Comparison_Exp>;
  WFSTRRP?: InputMaybe<Float8_Comparison_Exp>;
  WFSTTDP?: InputMaybe<Float8_Comparison_Exp>;
  WFSTVTP?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Util2_Bool_Exp>>;
  _not?: InputMaybe<As22Util2_Bool_Exp>;
  _or?: InputMaybe<Array<As22Util2_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS22UTIL2" */
export enum As22Util2_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Util2 = 'pk_AS22UTIL2'
}

/** input type for incrementing numeric columns in table "AS22UTIL2" */
export type As22Util2_Inc_Input = {
  ADEPRA?: InputMaybe<Scalars['float8']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  DEIDNA?: InputMaybe<Scalars['float8']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGNA?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PHEGNA?: InputMaybe<Scalars['float8']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGNA?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIDNA?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTDNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS22UTIL2" */
export type As22Util2_Insert_Input = {
  AAACLI?: InputMaybe<Scalars['String']>;
  AAACNA?: InputMaybe<Scalars['String']>;
  AAANI?: InputMaybe<Scalars['String']>;
  AAAPSN?: InputMaybe<Scalars['String']>;
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  BHHLT?: InputMaybe<Scalars['String']>;
  BHPRDCLI?: InputMaybe<Scalars['String']>;
  BHPRDCNA?: InputMaybe<Scalars['String']>;
  BHPRDNI?: InputMaybe<Scalars['String']>;
  BHPRDPSN?: InputMaybe<Scalars['String']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  CMHLT?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  DEIDNA?: InputMaybe<Scalars['float8']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGNA?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  KOREA?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PH?: InputMaybe<Scalars['String']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PHEGNA?: InputMaybe<Scalars['float8']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGNA?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIDNA?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTDNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type As22Util2_Max_Fields = {
  __typename?: 'AS22UTIL2_max_fields';
  AAACLI: Maybe<Scalars['String']>;
  AAACNA: Maybe<Scalars['String']>;
  AAANI: Maybe<Scalars['String']>;
  AAAPSN: Maybe<Scalars['String']>;
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  BHHLT: Maybe<Scalars['String']>;
  BHPRDCLI: Maybe<Scalars['String']>;
  BHPRDCNA: Maybe<Scalars['String']>;
  BHPRDNI: Maybe<Scalars['String']>;
  BHPRDPSN: Maybe<Scalars['String']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  CMHLT: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  DEIDNA: Maybe<Scalars['float8']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGNA: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  KOREA: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PH: Maybe<Scalars['String']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PHEGNA: Maybe<Scalars['float8']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGNA: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIDNA: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTDNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type As22Util2_Min_Fields = {
  __typename?: 'AS22UTIL2_min_fields';
  AAACLI: Maybe<Scalars['String']>;
  AAACNA: Maybe<Scalars['String']>;
  AAANI: Maybe<Scalars['String']>;
  AAAPSN: Maybe<Scalars['String']>;
  ADEPRA: Maybe<Scalars['float8']>;
  AFRICA: Maybe<Scalars['String']>;
  APANES: Maybe<Scalars['String']>;
  APCAR: Maybe<Scalars['String']>;
  APCASE: Maybe<Scalars['String']>;
  APED: Maybe<Scalars['String']>;
  APEMER: Maybe<Scalars['String']>;
  APOTH: Maybe<Scalars['String']>;
  APRN: Maybe<Scalars['String']>;
  APSPC: Maybe<Scalars['String']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  BHHLT: Maybe<Scalars['String']>;
  BHPRDCLI: Maybe<Scalars['String']>;
  BHPRDCNA: Maybe<Scalars['String']>;
  BHPRDNI: Maybe<Scalars['String']>;
  BHPRDPSN: Maybe<Scalars['String']>;
  CANADA: Maybe<Scalars['String']>;
  CEAMT: Maybe<Scalars['float8']>;
  CHINA: Maybe<Scalars['String']>;
  CLSCIC: Maybe<Scalars['String']>;
  CLSMSI: Maybe<Scalars['String']>;
  CLSNIC: Maybe<Scalars['String']>;
  CLSOIC: Maybe<Scalars['String']>;
  CLSPIC: Maybe<Scalars['String']>;
  CMHLT: Maybe<Scalars['String']>;
  COLLCLI: Maybe<Scalars['String']>;
  COLLCNA: Maybe<Scalars['String']>;
  COLLNI: Maybe<Scalars['String']>;
  COLLPSN: Maybe<Scalars['String']>;
  DEIDNA: Maybe<Scalars['float8']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FBORCLI: Maybe<Scalars['String']>;
  FBORCNA: Maybe<Scalars['String']>;
  FBORNI: Maybe<Scalars['String']>;
  FBORPSN: Maybe<Scalars['String']>;
  FORNRSA: Maybe<Scalars['String']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HCOCCLI: Maybe<Scalars['String']>;
  HCOCCNA: Maybe<Scalars['String']>;
  HCOCNI: Maybe<Scalars['String']>;
  HCOCPSN: Maybe<Scalars['String']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGNA: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  HICOCCLI: Maybe<Scalars['String']>;
  HICOCCNA: Maybe<Scalars['String']>;
  HICOCNI: Maybe<Scalars['String']>;
  HICOCPSN: Maybe<Scalars['String']>;
  HSPTL: Maybe<Scalars['String']>;
  ID: Maybe<Scalars['String']>;
  INDIA: Maybe<Scalars['String']>;
  INTCAR: Maybe<Scalars['String']>;
  KOREA: Maybe<Scalars['String']>;
  KSCHCLI: Maybe<Scalars['String']>;
  KSCHCNA: Maybe<Scalars['String']>;
  KSCHNI: Maybe<Scalars['String']>;
  KSCHPSN: Maybe<Scalars['String']>;
  LOCFCLI: Maybe<Scalars['String']>;
  LOCFCNA: Maybe<Scalars['String']>;
  LOCFNI: Maybe<Scalars['String']>;
  LOCFPSN: Maybe<Scalars['String']>;
  LOCHSCLI: Maybe<Scalars['String']>;
  LOCHSCNA: Maybe<Scalars['String']>;
  LOCHSNI: Maybe<Scalars['String']>;
  LOCHSPSN: Maybe<Scalars['String']>;
  LOCLGCLI: Maybe<Scalars['String']>;
  LOCLGCNA: Maybe<Scalars['String']>;
  LOCLGNI: Maybe<Scalars['String']>;
  LOCLGPSN: Maybe<Scalars['String']>;
  LOCOCCLI: Maybe<Scalars['String']>;
  LOCOCCNA: Maybe<Scalars['String']>;
  LOCOCNI: Maybe<Scalars['String']>;
  LOCOCPSN: Maybe<Scalars['String']>;
  LOCTRCLI: Maybe<Scalars['String']>;
  LOCTRCNA: Maybe<Scalars['String']>;
  LOCTRNI: Maybe<Scalars['String']>;
  LOCTRPSN: Maybe<Scalars['String']>;
  LORGCLI: Maybe<Scalars['String']>;
  LORGCNA: Maybe<Scalars['String']>;
  LORGNI: Maybe<Scalars['String']>;
  LORGPSN: Maybe<Scalars['String']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  OFRNRS: Maybe<Scalars['String']>;
  OTCOMCLI: Maybe<Scalars['String']>;
  OTCOMCNA: Maybe<Scalars['String']>;
  OTCOMNI: Maybe<Scalars['String']>;
  OTCOMPSN: Maybe<Scalars['String']>;
  OTLSCLI: Maybe<Scalars['String']>;
  OTLSCNA: Maybe<Scalars['String']>;
  OTLSNI: Maybe<Scalars['String']>;
  OTLSPSN: Maybe<Scalars['String']>;
  PH: Maybe<Scalars['String']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PHEGNA: Maybe<Scalars['float8']>;
  PLCECLI: Maybe<Scalars['String']>;
  PLCECNA: Maybe<Scalars['String']>;
  PLCENI: Maybe<Scalars['String']>;
  PLCEPSN: Maybe<Scalars['String']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGNA: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIDNA: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTDNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "AS22UTIL2" */
export type As22Util2_Mutation_Response = {
  __typename?: 'AS22UTIL2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Util2>;
};

/** input type for inserting object relation for remote table "AS22UTIL2" */
export type As22Util2_Obj_Rel_Insert_Input = {
  data: As22Util2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Util2_On_Conflict>;
};

/** on_conflict condition type for table "AS22UTIL2" */
export type As22Util2_On_Conflict = {
  constraint: As22Util2_Constraint;
  update_columns?: Array<As22Util2_Update_Column>;
  where?: InputMaybe<As22Util2_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22UTIL2". */
export type As22Util2_Order_By = {
  AAACLI?: InputMaybe<Order_By>;
  AAACNA?: InputMaybe<Order_By>;
  AAANI?: InputMaybe<Order_By>;
  AAAPSN?: InputMaybe<Order_By>;
  ADEPRA?: InputMaybe<Order_By>;
  AFRICA?: InputMaybe<Order_By>;
  APANES?: InputMaybe<Order_By>;
  APCAR?: InputMaybe<Order_By>;
  APCASE?: InputMaybe<Order_By>;
  APED?: InputMaybe<Order_By>;
  APEMER?: InputMaybe<Order_By>;
  APOTH?: InputMaybe<Order_By>;
  APRN?: InputMaybe<Order_By>;
  APSPC?: InputMaybe<Order_By>;
  ASSNET?: InputMaybe<Order_By>;
  AUVZ?: InputMaybe<Order_By>;
  BHHLT?: InputMaybe<Order_By>;
  BHPRDCLI?: InputMaybe<Order_By>;
  BHPRDCNA?: InputMaybe<Order_By>;
  BHPRDNI?: InputMaybe<Order_By>;
  BHPRDPSN?: InputMaybe<Order_By>;
  CANADA?: InputMaybe<Order_By>;
  CEAMT?: InputMaybe<Order_By>;
  CHINA?: InputMaybe<Order_By>;
  CLSCIC?: InputMaybe<Order_By>;
  CLSMSI?: InputMaybe<Order_By>;
  CLSNIC?: InputMaybe<Order_By>;
  CLSOIC?: InputMaybe<Order_By>;
  CLSPIC?: InputMaybe<Order_By>;
  CMHLT?: InputMaybe<Order_By>;
  COLLCLI?: InputMaybe<Order_By>;
  COLLCNA?: InputMaybe<Order_By>;
  COLLNI?: InputMaybe<Order_By>;
  COLLPSN?: InputMaybe<Order_By>;
  DEIDNA?: InputMaybe<Order_By>;
  DEIDPDEV?: InputMaybe<Order_By>;
  DEIDPO?: InputMaybe<Order_By>;
  DEIDPROC?: InputMaybe<Order_By>;
  DEIDSPCH?: InputMaybe<Order_By>;
  DEIDTRN?: InputMaybe<Order_By>;
  FBORCLI?: InputMaybe<Order_By>;
  FBORCNA?: InputMaybe<Order_By>;
  FBORNI?: InputMaybe<Order_By>;
  FBORPSN?: InputMaybe<Order_By>;
  FORNRSA?: InputMaybe<Order_By>;
  FTAPRN?: InputMaybe<Order_By>;
  FTEAPN?: InputMaybe<Order_By>;
  FTECIC?: InputMaybe<Order_By>;
  FTEHSP?: InputMaybe<Order_By>;
  FTEINT?: InputMaybe<Order_By>;
  FTEMSI?: InputMaybe<Order_By>;
  FTENIC?: InputMaybe<Order_By>;
  FTEOIC?: InputMaybe<Order_By>;
  FTEPHRN?: InputMaybe<Order_By>;
  FTEPIC?: InputMaybe<Order_By>;
  FTPHRN?: InputMaybe<Order_By>;
  GFEET?: InputMaybe<Order_By>;
  HCOCCLI?: InputMaybe<Order_By>;
  HCOCCNA?: InputMaybe<Order_By>;
  HCOCNI?: InputMaybe<Order_By>;
  HCOCPSN?: InputMaybe<Order_By>;
  HHEGCDO?: InputMaybe<Order_By>;
  HHEGCEO?: InputMaybe<Order_By>;
  HHEGERG?: InputMaybe<Order_By>;
  HHEGLEAD?: InputMaybe<Order_By>;
  HHEGMDMN?: InputMaybe<Order_By>;
  HHEGNA?: InputMaybe<Order_By>;
  HHEGTKFC?: InputMaybe<Order_By>;
  HICOCCLI?: InputMaybe<Order_By>;
  HICOCCNA?: InputMaybe<Order_By>;
  HICOCNI?: InputMaybe<Order_By>;
  HICOCPSN?: InputMaybe<Order_By>;
  HSPTL?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  INDIA?: InputMaybe<Order_By>;
  INTCAR?: InputMaybe<Order_By>;
  KOREA?: InputMaybe<Order_By>;
  KSCHCLI?: InputMaybe<Order_By>;
  KSCHCNA?: InputMaybe<Order_By>;
  KSCHNI?: InputMaybe<Order_By>;
  KSCHPSN?: InputMaybe<Order_By>;
  LOCFCLI?: InputMaybe<Order_By>;
  LOCFCNA?: InputMaybe<Order_By>;
  LOCFNI?: InputMaybe<Order_By>;
  LOCFPSN?: InputMaybe<Order_By>;
  LOCHSCLI?: InputMaybe<Order_By>;
  LOCHSCNA?: InputMaybe<Order_By>;
  LOCHSNI?: InputMaybe<Order_By>;
  LOCHSPSN?: InputMaybe<Order_By>;
  LOCLGCLI?: InputMaybe<Order_By>;
  LOCLGCNA?: InputMaybe<Order_By>;
  LOCLGNI?: InputMaybe<Order_By>;
  LOCLGPSN?: InputMaybe<Order_By>;
  LOCOCCLI?: InputMaybe<Order_By>;
  LOCOCCNA?: InputMaybe<Order_By>;
  LOCOCNI?: InputMaybe<Order_By>;
  LOCOCPSN?: InputMaybe<Order_By>;
  LOCTRCLI?: InputMaybe<Order_By>;
  LOCTRCNA?: InputMaybe<Order_By>;
  LOCTRNI?: InputMaybe<Order_By>;
  LOCTRPSN?: InputMaybe<Order_By>;
  LORGCLI?: InputMaybe<Order_By>;
  LORGCNA?: InputMaybe<Order_By>;
  LORGNI?: InputMaybe<Order_By>;
  LORGPSN?: InputMaybe<Order_By>;
  NECAR?: InputMaybe<Order_By>;
  NEGST?: InputMaybe<Order_By>;
  NEHSP?: InputMaybe<Order_By>;
  NEINT?: InputMaybe<Order_By>;
  NEMER?: InputMaybe<Order_By>;
  NEOB?: InputMaybe<Order_By>;
  NEOTH?: InputMaybe<Order_By>;
  NETOT?: InputMaybe<Order_By>;
  OFRNRS?: InputMaybe<Order_By>;
  OTCOMCLI?: InputMaybe<Order_By>;
  OTCOMCNA?: InputMaybe<Order_By>;
  OTCOMNI?: InputMaybe<Order_By>;
  OTCOMPSN?: InputMaybe<Order_By>;
  OTLSCLI?: InputMaybe<Order_By>;
  OTLSCNA?: InputMaybe<Order_By>;
  OTLSNI?: InputMaybe<Order_By>;
  OTLSPSN?: InputMaybe<Order_By>;
  PH?: InputMaybe<Order_By>;
  PHEGACC?: InputMaybe<Order_By>;
  PHEGCAPC?: InputMaybe<Order_By>;
  PHEGCMTY?: InputMaybe<Order_By>;
  PHEGDATA?: InputMaybe<Order_By>;
  PHEGEIOP?: InputMaybe<Order_By>;
  PHEGGOV?: InputMaybe<Order_By>;
  PHEGLEAD?: InputMaybe<Order_By>;
  PHEGNA?: InputMaybe<Order_By>;
  PLCECLI?: InputMaybe<Order_By>;
  PLCECNA?: InputMaybe<Order_By>;
  PLCENI?: InputMaybe<Order_By>;
  PLCEPSN?: InputMaybe<Order_By>;
  PLNTA?: InputMaybe<Order_By>;
  PRPM?: InputMaybe<Order_By>;
  PTAPRN?: InputMaybe<Order_By>;
  PTPHRN?: InputMaybe<Order_By>;
  RNSCH?: InputMaybe<Order_By>;
  SHEGCDO?: InputMaybe<Order_By>;
  SHEGCEO?: InputMaybe<Order_By>;
  SHEGERG?: InputMaybe<Order_By>;
  SHEGLEAD?: InputMaybe<Order_By>;
  SHEGMDMN?: InputMaybe<Order_By>;
  SHEGNA?: InputMaybe<Order_By>;
  SHEGTKFC?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  TCCAR?: InputMaybe<Order_By>;
  TCGST?: InputMaybe<Order_By>;
  TCHSP?: InputMaybe<Order_By>;
  TCINT?: InputMaybe<Order_By>;
  TCMER?: InputMaybe<Order_By>;
  TCOB?: InputMaybe<Order_By>;
  TCOTH?: InputMaybe<Order_By>;
  TCTOT?: InputMaybe<Order_By>;
  TECAR?: InputMaybe<Order_By>;
  TEGST?: InputMaybe<Order_By>;
  TEHSP?: InputMaybe<Order_By>;
  TEINT?: InputMaybe<Order_By>;
  TEMER?: InputMaybe<Order_By>;
  TEOB?: InputMaybe<Order_By>;
  TEOTH?: InputMaybe<Order_By>;
  TETOT?: InputMaybe<Order_By>;
  TGCAR?: InputMaybe<Order_By>;
  TGGST?: InputMaybe<Order_By>;
  TGHSP?: InputMaybe<Order_By>;
  TGINT?: InputMaybe<Order_By>;
  TGMER?: InputMaybe<Order_By>;
  TGOB?: InputMaybe<Order_By>;
  TGOTH?: InputMaybe<Order_By>;
  TGTOT?: InputMaybe<Order_By>;
  TPCAR?: InputMaybe<Order_By>;
  TPGST?: InputMaybe<Order_By>;
  TPHSP?: InputMaybe<Order_By>;
  TPINT?: InputMaybe<Order_By>;
  TPMER?: InputMaybe<Order_By>;
  TPOB?: InputMaybe<Order_By>;
  TPOTH?: InputMaybe<Order_By>;
  TPRTOT?: InputMaybe<Order_By>;
  VIDVZ?: InputMaybe<Order_By>;
  VPSRV?: InputMaybe<Order_By>;
  WFAIART?: InputMaybe<Order_By>;
  WFAIDNA?: InputMaybe<Order_By>;
  WFAIOACW?: InputMaybe<Order_By>;
  WFAIPPD?: InputMaybe<Order_By>;
  WFAIPSN?: InputMaybe<Order_By>;
  WFAISS?: InputMaybe<Order_By>;
  WFSTCNA?: InputMaybe<Order_By>;
  WFSTDNA?: InputMaybe<Order_By>;
  WFSTHCC?: InputMaybe<Order_By>;
  WFSTLSP?: InputMaybe<Order_By>;
  WFSTRRP?: InputMaybe<Order_By>;
  WFSTTDP?: InputMaybe<Order_By>;
  WFSTVTP?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS22UTIL2 */
export type As22Util2_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22UTIL2" */
export enum As22Util2_Select_Column {
  /** column name */
  Aaacli = 'AAACLI',
  /** column name */
  Aaacna = 'AAACNA',
  /** column name */
  Aaani = 'AAANI',
  /** column name */
  Aaapsn = 'AAAPSN',
  /** column name */
  Adepra = 'ADEPRA',
  /** column name */
  Africa = 'AFRICA',
  /** column name */
  Apanes = 'APANES',
  /** column name */
  Apcar = 'APCAR',
  /** column name */
  Apcase = 'APCASE',
  /** column name */
  Aped = 'APED',
  /** column name */
  Apemer = 'APEMER',
  /** column name */
  Apoth = 'APOTH',
  /** column name */
  Aprn = 'APRN',
  /** column name */
  Apspc = 'APSPC',
  /** column name */
  Assnet = 'ASSNET',
  /** column name */
  Auvz = 'AUVZ',
  /** column name */
  Bhhlt = 'BHHLT',
  /** column name */
  Bhprdcli = 'BHPRDCLI',
  /** column name */
  Bhprdcna = 'BHPRDCNA',
  /** column name */
  Bhprdni = 'BHPRDNI',
  /** column name */
  Bhprdpsn = 'BHPRDPSN',
  /** column name */
  Canada = 'CANADA',
  /** column name */
  Ceamt = 'CEAMT',
  /** column name */
  China = 'CHINA',
  /** column name */
  Clscic = 'CLSCIC',
  /** column name */
  Clsmsi = 'CLSMSI',
  /** column name */
  Clsnic = 'CLSNIC',
  /** column name */
  Clsoic = 'CLSOIC',
  /** column name */
  Clspic = 'CLSPIC',
  /** column name */
  Cmhlt = 'CMHLT',
  /** column name */
  Collcli = 'COLLCLI',
  /** column name */
  Collcna = 'COLLCNA',
  /** column name */
  Collni = 'COLLNI',
  /** column name */
  Collpsn = 'COLLPSN',
  /** column name */
  Deidna = 'DEIDNA',
  /** column name */
  Deidpdev = 'DEIDPDEV',
  /** column name */
  Deidpo = 'DEIDPO',
  /** column name */
  Deidproc = 'DEIDPROC',
  /** column name */
  Deidspch = 'DEIDSPCH',
  /** column name */
  Deidtrn = 'DEIDTRN',
  /** column name */
  Fborcli = 'FBORCLI',
  /** column name */
  Fborcna = 'FBORCNA',
  /** column name */
  Fborni = 'FBORNI',
  /** column name */
  Fborpsn = 'FBORPSN',
  /** column name */
  Fornrsa = 'FORNRSA',
  /** column name */
  Ftaprn = 'FTAPRN',
  /** column name */
  Fteapn = 'FTEAPN',
  /** column name */
  Ftecic = 'FTECIC',
  /** column name */
  Ftehsp = 'FTEHSP',
  /** column name */
  Fteint = 'FTEINT',
  /** column name */
  Ftemsi = 'FTEMSI',
  /** column name */
  Ftenic = 'FTENIC',
  /** column name */
  Fteoic = 'FTEOIC',
  /** column name */
  Ftephrn = 'FTEPHRN',
  /** column name */
  Ftepic = 'FTEPIC',
  /** column name */
  Ftphrn = 'FTPHRN',
  /** column name */
  Gfeet = 'GFEET',
  /** column name */
  Hcoccli = 'HCOCCLI',
  /** column name */
  Hcoccna = 'HCOCCNA',
  /** column name */
  Hcocni = 'HCOCNI',
  /** column name */
  Hcocpsn = 'HCOCPSN',
  /** column name */
  Hhegcdo = 'HHEGCDO',
  /** column name */
  Hhegceo = 'HHEGCEO',
  /** column name */
  Hhegerg = 'HHEGERG',
  /** column name */
  Hheglead = 'HHEGLEAD',
  /** column name */
  Hhegmdmn = 'HHEGMDMN',
  /** column name */
  Hhegna = 'HHEGNA',
  /** column name */
  Hhegtkfc = 'HHEGTKFC',
  /** column name */
  Hicoccli = 'HICOCCLI',
  /** column name */
  Hicoccna = 'HICOCCNA',
  /** column name */
  Hicocni = 'HICOCNI',
  /** column name */
  Hicocpsn = 'HICOCPSN',
  /** column name */
  Hsptl = 'HSPTL',
  /** column name */
  Id = 'ID',
  /** column name */
  India = 'INDIA',
  /** column name */
  Intcar = 'INTCAR',
  /** column name */
  Korea = 'KOREA',
  /** column name */
  Kschcli = 'KSCHCLI',
  /** column name */
  Kschcna = 'KSCHCNA',
  /** column name */
  Kschni = 'KSCHNI',
  /** column name */
  Kschpsn = 'KSCHPSN',
  /** column name */
  Locfcli = 'LOCFCLI',
  /** column name */
  Locfcna = 'LOCFCNA',
  /** column name */
  Locfni = 'LOCFNI',
  /** column name */
  Locfpsn = 'LOCFPSN',
  /** column name */
  Lochscli = 'LOCHSCLI',
  /** column name */
  Lochscna = 'LOCHSCNA',
  /** column name */
  Lochsni = 'LOCHSNI',
  /** column name */
  Lochspsn = 'LOCHSPSN',
  /** column name */
  Loclgcli = 'LOCLGCLI',
  /** column name */
  Loclgcna = 'LOCLGCNA',
  /** column name */
  Loclgni = 'LOCLGNI',
  /** column name */
  Loclgpsn = 'LOCLGPSN',
  /** column name */
  Lococcli = 'LOCOCCLI',
  /** column name */
  Lococcna = 'LOCOCCNA',
  /** column name */
  Lococni = 'LOCOCNI',
  /** column name */
  Lococpsn = 'LOCOCPSN',
  /** column name */
  Loctrcli = 'LOCTRCLI',
  /** column name */
  Loctrcna = 'LOCTRCNA',
  /** column name */
  Loctrni = 'LOCTRNI',
  /** column name */
  Loctrpsn = 'LOCTRPSN',
  /** column name */
  Lorgcli = 'LORGCLI',
  /** column name */
  Lorgcna = 'LORGCNA',
  /** column name */
  Lorgni = 'LORGNI',
  /** column name */
  Lorgpsn = 'LORGPSN',
  /** column name */
  Necar = 'NECAR',
  /** column name */
  Negst = 'NEGST',
  /** column name */
  Nehsp = 'NEHSP',
  /** column name */
  Neint = 'NEINT',
  /** column name */
  Nemer = 'NEMER',
  /** column name */
  Neob = 'NEOB',
  /** column name */
  Neoth = 'NEOTH',
  /** column name */
  Netot = 'NETOT',
  /** column name */
  Ofrnrs = 'OFRNRS',
  /** column name */
  Otcomcli = 'OTCOMCLI',
  /** column name */
  Otcomcna = 'OTCOMCNA',
  /** column name */
  Otcomni = 'OTCOMNI',
  /** column name */
  Otcompsn = 'OTCOMPSN',
  /** column name */
  Otlscli = 'OTLSCLI',
  /** column name */
  Otlscna = 'OTLSCNA',
  /** column name */
  Otlsni = 'OTLSNI',
  /** column name */
  Otlspsn = 'OTLSPSN',
  /** column name */
  Ph = 'PH',
  /** column name */
  Phegacc = 'PHEGACC',
  /** column name */
  Phegcapc = 'PHEGCAPC',
  /** column name */
  Phegcmty = 'PHEGCMTY',
  /** column name */
  Phegdata = 'PHEGDATA',
  /** column name */
  Phegeiop = 'PHEGEIOP',
  /** column name */
  Pheggov = 'PHEGGOV',
  /** column name */
  Pheglead = 'PHEGLEAD',
  /** column name */
  Phegna = 'PHEGNA',
  /** column name */
  Plcecli = 'PLCECLI',
  /** column name */
  Plcecna = 'PLCECNA',
  /** column name */
  Plceni = 'PLCENI',
  /** column name */
  Plcepsn = 'PLCEPSN',
  /** column name */
  Plnta = 'PLNTA',
  /** column name */
  Prpm = 'PRPM',
  /** column name */
  Ptaprn = 'PTAPRN',
  /** column name */
  Ptphrn = 'PTPHRN',
  /** column name */
  Rnsch = 'RNSCH',
  /** column name */
  Shegcdo = 'SHEGCDO',
  /** column name */
  Shegceo = 'SHEGCEO',
  /** column name */
  Shegerg = 'SHEGERG',
  /** column name */
  Sheglead = 'SHEGLEAD',
  /** column name */
  Shegmdmn = 'SHEGMDMN',
  /** column name */
  Shegna = 'SHEGNA',
  /** column name */
  Shegtkfc = 'SHEGTKFC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Tccar = 'TCCAR',
  /** column name */
  Tcgst = 'TCGST',
  /** column name */
  Tchsp = 'TCHSP',
  /** column name */
  Tcint = 'TCINT',
  /** column name */
  Tcmer = 'TCMER',
  /** column name */
  Tcob = 'TCOB',
  /** column name */
  Tcoth = 'TCOTH',
  /** column name */
  Tctot = 'TCTOT',
  /** column name */
  Tecar = 'TECAR',
  /** column name */
  Tegst = 'TEGST',
  /** column name */
  Tehsp = 'TEHSP',
  /** column name */
  Teint = 'TEINT',
  /** column name */
  Temer = 'TEMER',
  /** column name */
  Teob = 'TEOB',
  /** column name */
  Teoth = 'TEOTH',
  /** column name */
  Tetot = 'TETOT',
  /** column name */
  Tgcar = 'TGCAR',
  /** column name */
  Tggst = 'TGGST',
  /** column name */
  Tghsp = 'TGHSP',
  /** column name */
  Tgint = 'TGINT',
  /** column name */
  Tgmer = 'TGMER',
  /** column name */
  Tgob = 'TGOB',
  /** column name */
  Tgoth = 'TGOTH',
  /** column name */
  Tgtot = 'TGTOT',
  /** column name */
  Tpcar = 'TPCAR',
  /** column name */
  Tpgst = 'TPGST',
  /** column name */
  Tphsp = 'TPHSP',
  /** column name */
  Tpint = 'TPINT',
  /** column name */
  Tpmer = 'TPMER',
  /** column name */
  Tpob = 'TPOB',
  /** column name */
  Tpoth = 'TPOTH',
  /** column name */
  Tprtot = 'TPRTOT',
  /** column name */
  Vidvz = 'VIDVZ',
  /** column name */
  Vpsrv = 'VPSRV',
  /** column name */
  Wfaiart = 'WFAIART',
  /** column name */
  Wfaidna = 'WFAIDNA',
  /** column name */
  Wfaioacw = 'WFAIOACW',
  /** column name */
  Wfaippd = 'WFAIPPD',
  /** column name */
  Wfaipsn = 'WFAIPSN',
  /** column name */
  Wfaiss = 'WFAISS',
  /** column name */
  Wfstcna = 'WFSTCNA',
  /** column name */
  Wfstdna = 'WFSTDNA',
  /** column name */
  Wfsthcc = 'WFSTHCC',
  /** column name */
  Wfstlsp = 'WFSTLSP',
  /** column name */
  Wfstrrp = 'WFSTRRP',
  /** column name */
  Wfsttdp = 'WFSTTDP',
  /** column name */
  Wfstvtp = 'WFSTVTP'
}

/** input type for updating data in table "AS22UTIL2" */
export type As22Util2_Set_Input = {
  AAACLI?: InputMaybe<Scalars['String']>;
  AAACNA?: InputMaybe<Scalars['String']>;
  AAANI?: InputMaybe<Scalars['String']>;
  AAAPSN?: InputMaybe<Scalars['String']>;
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  BHHLT?: InputMaybe<Scalars['String']>;
  BHPRDCLI?: InputMaybe<Scalars['String']>;
  BHPRDCNA?: InputMaybe<Scalars['String']>;
  BHPRDNI?: InputMaybe<Scalars['String']>;
  BHPRDPSN?: InputMaybe<Scalars['String']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  CMHLT?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  DEIDNA?: InputMaybe<Scalars['float8']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGNA?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  KOREA?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PH?: InputMaybe<Scalars['String']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PHEGNA?: InputMaybe<Scalars['float8']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGNA?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIDNA?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTDNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type As22Util2_Stddev_Fields = {
  __typename?: 'AS22UTIL2_stddev_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As22Util2_Stddev_Pop_Fields = {
  __typename?: 'AS22UTIL2_stddev_pop_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As22Util2_Stddev_Samp_Fields = {
  __typename?: 'AS22UTIL2_stddev_samp_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS22UTIL2" */
export type As22Util2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Util2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Util2_Stream_Cursor_Value_Input = {
  AAACLI?: InputMaybe<Scalars['String']>;
  AAACNA?: InputMaybe<Scalars['String']>;
  AAANI?: InputMaybe<Scalars['String']>;
  AAAPSN?: InputMaybe<Scalars['String']>;
  ADEPRA?: InputMaybe<Scalars['float8']>;
  AFRICA?: InputMaybe<Scalars['String']>;
  APANES?: InputMaybe<Scalars['String']>;
  APCAR?: InputMaybe<Scalars['String']>;
  APCASE?: InputMaybe<Scalars['String']>;
  APED?: InputMaybe<Scalars['String']>;
  APEMER?: InputMaybe<Scalars['String']>;
  APOTH?: InputMaybe<Scalars['String']>;
  APRN?: InputMaybe<Scalars['String']>;
  APSPC?: InputMaybe<Scalars['String']>;
  ASSNET?: InputMaybe<Scalars['float8']>;
  AUVZ?: InputMaybe<Scalars['float8']>;
  BHHLT?: InputMaybe<Scalars['String']>;
  BHPRDCLI?: InputMaybe<Scalars['String']>;
  BHPRDCNA?: InputMaybe<Scalars['String']>;
  BHPRDNI?: InputMaybe<Scalars['String']>;
  BHPRDPSN?: InputMaybe<Scalars['String']>;
  CANADA?: InputMaybe<Scalars['String']>;
  CEAMT?: InputMaybe<Scalars['float8']>;
  CHINA?: InputMaybe<Scalars['String']>;
  CLSCIC?: InputMaybe<Scalars['String']>;
  CLSMSI?: InputMaybe<Scalars['String']>;
  CLSNIC?: InputMaybe<Scalars['String']>;
  CLSOIC?: InputMaybe<Scalars['String']>;
  CLSPIC?: InputMaybe<Scalars['String']>;
  CMHLT?: InputMaybe<Scalars['String']>;
  COLLCLI?: InputMaybe<Scalars['String']>;
  COLLCNA?: InputMaybe<Scalars['String']>;
  COLLNI?: InputMaybe<Scalars['String']>;
  COLLPSN?: InputMaybe<Scalars['String']>;
  DEIDNA?: InputMaybe<Scalars['float8']>;
  DEIDPDEV?: InputMaybe<Scalars['float8']>;
  DEIDPO?: InputMaybe<Scalars['float8']>;
  DEIDPROC?: InputMaybe<Scalars['float8']>;
  DEIDSPCH?: InputMaybe<Scalars['float8']>;
  DEIDTRN?: InputMaybe<Scalars['float8']>;
  FBORCLI?: InputMaybe<Scalars['String']>;
  FBORCNA?: InputMaybe<Scalars['String']>;
  FBORNI?: InputMaybe<Scalars['String']>;
  FBORPSN?: InputMaybe<Scalars['String']>;
  FORNRSA?: InputMaybe<Scalars['String']>;
  FTAPRN?: InputMaybe<Scalars['float8']>;
  FTEAPN?: InputMaybe<Scalars['float8']>;
  FTECIC?: InputMaybe<Scalars['float8']>;
  FTEHSP?: InputMaybe<Scalars['float8']>;
  FTEINT?: InputMaybe<Scalars['float8']>;
  FTEMSI?: InputMaybe<Scalars['float8']>;
  FTENIC?: InputMaybe<Scalars['float8']>;
  FTEOIC?: InputMaybe<Scalars['float8']>;
  FTEPHRN?: InputMaybe<Scalars['float8']>;
  FTEPIC?: InputMaybe<Scalars['float8']>;
  FTPHRN?: InputMaybe<Scalars['float8']>;
  GFEET?: InputMaybe<Scalars['float8']>;
  HCOCCLI?: InputMaybe<Scalars['String']>;
  HCOCCNA?: InputMaybe<Scalars['String']>;
  HCOCNI?: InputMaybe<Scalars['String']>;
  HCOCPSN?: InputMaybe<Scalars['String']>;
  HHEGCDO?: InputMaybe<Scalars['float8']>;
  HHEGCEO?: InputMaybe<Scalars['float8']>;
  HHEGERG?: InputMaybe<Scalars['float8']>;
  HHEGLEAD?: InputMaybe<Scalars['float8']>;
  HHEGMDMN?: InputMaybe<Scalars['float8']>;
  HHEGNA?: InputMaybe<Scalars['float8']>;
  HHEGTKFC?: InputMaybe<Scalars['float8']>;
  HICOCCLI?: InputMaybe<Scalars['String']>;
  HICOCCNA?: InputMaybe<Scalars['String']>;
  HICOCNI?: InputMaybe<Scalars['String']>;
  HICOCPSN?: InputMaybe<Scalars['String']>;
  HSPTL?: InputMaybe<Scalars['String']>;
  ID?: InputMaybe<Scalars['String']>;
  INDIA?: InputMaybe<Scalars['String']>;
  INTCAR?: InputMaybe<Scalars['String']>;
  KOREA?: InputMaybe<Scalars['String']>;
  KSCHCLI?: InputMaybe<Scalars['String']>;
  KSCHCNA?: InputMaybe<Scalars['String']>;
  KSCHNI?: InputMaybe<Scalars['String']>;
  KSCHPSN?: InputMaybe<Scalars['String']>;
  LOCFCLI?: InputMaybe<Scalars['String']>;
  LOCFCNA?: InputMaybe<Scalars['String']>;
  LOCFNI?: InputMaybe<Scalars['String']>;
  LOCFPSN?: InputMaybe<Scalars['String']>;
  LOCHSCLI?: InputMaybe<Scalars['String']>;
  LOCHSCNA?: InputMaybe<Scalars['String']>;
  LOCHSNI?: InputMaybe<Scalars['String']>;
  LOCHSPSN?: InputMaybe<Scalars['String']>;
  LOCLGCLI?: InputMaybe<Scalars['String']>;
  LOCLGCNA?: InputMaybe<Scalars['String']>;
  LOCLGNI?: InputMaybe<Scalars['String']>;
  LOCLGPSN?: InputMaybe<Scalars['String']>;
  LOCOCCLI?: InputMaybe<Scalars['String']>;
  LOCOCCNA?: InputMaybe<Scalars['String']>;
  LOCOCNI?: InputMaybe<Scalars['String']>;
  LOCOCPSN?: InputMaybe<Scalars['String']>;
  LOCTRCLI?: InputMaybe<Scalars['String']>;
  LOCTRCNA?: InputMaybe<Scalars['String']>;
  LOCTRNI?: InputMaybe<Scalars['String']>;
  LOCTRPSN?: InputMaybe<Scalars['String']>;
  LORGCLI?: InputMaybe<Scalars['String']>;
  LORGCNA?: InputMaybe<Scalars['String']>;
  LORGNI?: InputMaybe<Scalars['String']>;
  LORGPSN?: InputMaybe<Scalars['String']>;
  NECAR?: InputMaybe<Scalars['float8']>;
  NEGST?: InputMaybe<Scalars['float8']>;
  NEHSP?: InputMaybe<Scalars['float8']>;
  NEINT?: InputMaybe<Scalars['float8']>;
  NEMER?: InputMaybe<Scalars['float8']>;
  NEOB?: InputMaybe<Scalars['float8']>;
  NEOTH?: InputMaybe<Scalars['float8']>;
  NETOT?: InputMaybe<Scalars['float8']>;
  OFRNRS?: InputMaybe<Scalars['String']>;
  OTCOMCLI?: InputMaybe<Scalars['String']>;
  OTCOMCNA?: InputMaybe<Scalars['String']>;
  OTCOMNI?: InputMaybe<Scalars['String']>;
  OTCOMPSN?: InputMaybe<Scalars['String']>;
  OTLSCLI?: InputMaybe<Scalars['String']>;
  OTLSCNA?: InputMaybe<Scalars['String']>;
  OTLSNI?: InputMaybe<Scalars['String']>;
  OTLSPSN?: InputMaybe<Scalars['String']>;
  PH?: InputMaybe<Scalars['String']>;
  PHEGACC?: InputMaybe<Scalars['float8']>;
  PHEGCAPC?: InputMaybe<Scalars['float8']>;
  PHEGCMTY?: InputMaybe<Scalars['float8']>;
  PHEGDATA?: InputMaybe<Scalars['float8']>;
  PHEGEIOP?: InputMaybe<Scalars['float8']>;
  PHEGGOV?: InputMaybe<Scalars['float8']>;
  PHEGLEAD?: InputMaybe<Scalars['float8']>;
  PHEGNA?: InputMaybe<Scalars['float8']>;
  PLCECLI?: InputMaybe<Scalars['String']>;
  PLCECNA?: InputMaybe<Scalars['String']>;
  PLCENI?: InputMaybe<Scalars['String']>;
  PLCEPSN?: InputMaybe<Scalars['String']>;
  PLNTA?: InputMaybe<Scalars['float8']>;
  PRPM?: InputMaybe<Scalars['float8']>;
  PTAPRN?: InputMaybe<Scalars['float8']>;
  PTPHRN?: InputMaybe<Scalars['float8']>;
  RNSCH?: InputMaybe<Scalars['float8']>;
  SHEGCDO?: InputMaybe<Scalars['float8']>;
  SHEGCEO?: InputMaybe<Scalars['float8']>;
  SHEGERG?: InputMaybe<Scalars['float8']>;
  SHEGLEAD?: InputMaybe<Scalars['float8']>;
  SHEGMDMN?: InputMaybe<Scalars['float8']>;
  SHEGNA?: InputMaybe<Scalars['float8']>;
  SHEGTKFC?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  TCCAR?: InputMaybe<Scalars['float8']>;
  TCGST?: InputMaybe<Scalars['float8']>;
  TCHSP?: InputMaybe<Scalars['float8']>;
  TCINT?: InputMaybe<Scalars['float8']>;
  TCMER?: InputMaybe<Scalars['float8']>;
  TCOB?: InputMaybe<Scalars['float8']>;
  TCOTH?: InputMaybe<Scalars['float8']>;
  TCTOT?: InputMaybe<Scalars['float8']>;
  TECAR?: InputMaybe<Scalars['float8']>;
  TEGST?: InputMaybe<Scalars['float8']>;
  TEHSP?: InputMaybe<Scalars['float8']>;
  TEINT?: InputMaybe<Scalars['float8']>;
  TEMER?: InputMaybe<Scalars['float8']>;
  TEOB?: InputMaybe<Scalars['float8']>;
  TEOTH?: InputMaybe<Scalars['float8']>;
  TETOT?: InputMaybe<Scalars['float8']>;
  TGCAR?: InputMaybe<Scalars['float8']>;
  TGGST?: InputMaybe<Scalars['float8']>;
  TGHSP?: InputMaybe<Scalars['float8']>;
  TGINT?: InputMaybe<Scalars['float8']>;
  TGMER?: InputMaybe<Scalars['float8']>;
  TGOB?: InputMaybe<Scalars['float8']>;
  TGOTH?: InputMaybe<Scalars['float8']>;
  TGTOT?: InputMaybe<Scalars['float8']>;
  TPCAR?: InputMaybe<Scalars['float8']>;
  TPGST?: InputMaybe<Scalars['float8']>;
  TPHSP?: InputMaybe<Scalars['float8']>;
  TPINT?: InputMaybe<Scalars['float8']>;
  TPMER?: InputMaybe<Scalars['float8']>;
  TPOB?: InputMaybe<Scalars['float8']>;
  TPOTH?: InputMaybe<Scalars['float8']>;
  TPRTOT?: InputMaybe<Scalars['float8']>;
  VIDVZ?: InputMaybe<Scalars['float8']>;
  VPSRV?: InputMaybe<Scalars['float8']>;
  WFAIART?: InputMaybe<Scalars['float8']>;
  WFAIDNA?: InputMaybe<Scalars['float8']>;
  WFAIOACW?: InputMaybe<Scalars['float8']>;
  WFAIPPD?: InputMaybe<Scalars['float8']>;
  WFAIPSN?: InputMaybe<Scalars['float8']>;
  WFAISS?: InputMaybe<Scalars['float8']>;
  WFSTCNA?: InputMaybe<Scalars['float8']>;
  WFSTDNA?: InputMaybe<Scalars['float8']>;
  WFSTHCC?: InputMaybe<Scalars['float8']>;
  WFSTLSP?: InputMaybe<Scalars['float8']>;
  WFSTRRP?: InputMaybe<Scalars['float8']>;
  WFSTTDP?: InputMaybe<Scalars['float8']>;
  WFSTVTP?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type As22Util2_Sum_Fields = {
  __typename?: 'AS22UTIL2_sum_fields';
  ADEPRA: Maybe<Scalars['float8']>;
  ASSNET: Maybe<Scalars['float8']>;
  AUVZ: Maybe<Scalars['float8']>;
  CEAMT: Maybe<Scalars['float8']>;
  DEIDNA: Maybe<Scalars['float8']>;
  DEIDPDEV: Maybe<Scalars['float8']>;
  DEIDPO: Maybe<Scalars['float8']>;
  DEIDPROC: Maybe<Scalars['float8']>;
  DEIDSPCH: Maybe<Scalars['float8']>;
  DEIDTRN: Maybe<Scalars['float8']>;
  FTAPRN: Maybe<Scalars['float8']>;
  FTEAPN: Maybe<Scalars['float8']>;
  FTECIC: Maybe<Scalars['float8']>;
  FTEHSP: Maybe<Scalars['float8']>;
  FTEINT: Maybe<Scalars['float8']>;
  FTEMSI: Maybe<Scalars['float8']>;
  FTENIC: Maybe<Scalars['float8']>;
  FTEOIC: Maybe<Scalars['float8']>;
  FTEPHRN: Maybe<Scalars['float8']>;
  FTEPIC: Maybe<Scalars['float8']>;
  FTPHRN: Maybe<Scalars['float8']>;
  GFEET: Maybe<Scalars['float8']>;
  HHEGCDO: Maybe<Scalars['float8']>;
  HHEGCEO: Maybe<Scalars['float8']>;
  HHEGERG: Maybe<Scalars['float8']>;
  HHEGLEAD: Maybe<Scalars['float8']>;
  HHEGMDMN: Maybe<Scalars['float8']>;
  HHEGNA: Maybe<Scalars['float8']>;
  HHEGTKFC: Maybe<Scalars['float8']>;
  NECAR: Maybe<Scalars['float8']>;
  NEGST: Maybe<Scalars['float8']>;
  NEHSP: Maybe<Scalars['float8']>;
  NEINT: Maybe<Scalars['float8']>;
  NEMER: Maybe<Scalars['float8']>;
  NEOB: Maybe<Scalars['float8']>;
  NEOTH: Maybe<Scalars['float8']>;
  NETOT: Maybe<Scalars['float8']>;
  PHEGACC: Maybe<Scalars['float8']>;
  PHEGCAPC: Maybe<Scalars['float8']>;
  PHEGCMTY: Maybe<Scalars['float8']>;
  PHEGDATA: Maybe<Scalars['float8']>;
  PHEGEIOP: Maybe<Scalars['float8']>;
  PHEGGOV: Maybe<Scalars['float8']>;
  PHEGLEAD: Maybe<Scalars['float8']>;
  PHEGNA: Maybe<Scalars['float8']>;
  PLNTA: Maybe<Scalars['float8']>;
  PRPM: Maybe<Scalars['float8']>;
  PTAPRN: Maybe<Scalars['float8']>;
  PTPHRN: Maybe<Scalars['float8']>;
  RNSCH: Maybe<Scalars['float8']>;
  SHEGCDO: Maybe<Scalars['float8']>;
  SHEGCEO: Maybe<Scalars['float8']>;
  SHEGERG: Maybe<Scalars['float8']>;
  SHEGLEAD: Maybe<Scalars['float8']>;
  SHEGMDMN: Maybe<Scalars['float8']>;
  SHEGNA: Maybe<Scalars['float8']>;
  SHEGTKFC: Maybe<Scalars['float8']>;
  TCCAR: Maybe<Scalars['float8']>;
  TCGST: Maybe<Scalars['float8']>;
  TCHSP: Maybe<Scalars['float8']>;
  TCINT: Maybe<Scalars['float8']>;
  TCMER: Maybe<Scalars['float8']>;
  TCOB: Maybe<Scalars['float8']>;
  TCOTH: Maybe<Scalars['float8']>;
  TCTOT: Maybe<Scalars['float8']>;
  TECAR: Maybe<Scalars['float8']>;
  TEGST: Maybe<Scalars['float8']>;
  TEHSP: Maybe<Scalars['float8']>;
  TEINT: Maybe<Scalars['float8']>;
  TEMER: Maybe<Scalars['float8']>;
  TEOB: Maybe<Scalars['float8']>;
  TEOTH: Maybe<Scalars['float8']>;
  TETOT: Maybe<Scalars['float8']>;
  TGCAR: Maybe<Scalars['float8']>;
  TGGST: Maybe<Scalars['float8']>;
  TGHSP: Maybe<Scalars['float8']>;
  TGINT: Maybe<Scalars['float8']>;
  TGMER: Maybe<Scalars['float8']>;
  TGOB: Maybe<Scalars['float8']>;
  TGOTH: Maybe<Scalars['float8']>;
  TGTOT: Maybe<Scalars['float8']>;
  TPCAR: Maybe<Scalars['float8']>;
  TPGST: Maybe<Scalars['float8']>;
  TPHSP: Maybe<Scalars['float8']>;
  TPINT: Maybe<Scalars['float8']>;
  TPMER: Maybe<Scalars['float8']>;
  TPOB: Maybe<Scalars['float8']>;
  TPOTH: Maybe<Scalars['float8']>;
  TPRTOT: Maybe<Scalars['float8']>;
  VIDVZ: Maybe<Scalars['float8']>;
  VPSRV: Maybe<Scalars['float8']>;
  WFAIART: Maybe<Scalars['float8']>;
  WFAIDNA: Maybe<Scalars['float8']>;
  WFAIOACW: Maybe<Scalars['float8']>;
  WFAIPPD: Maybe<Scalars['float8']>;
  WFAIPSN: Maybe<Scalars['float8']>;
  WFAISS: Maybe<Scalars['float8']>;
  WFSTCNA: Maybe<Scalars['float8']>;
  WFSTDNA: Maybe<Scalars['float8']>;
  WFSTHCC: Maybe<Scalars['float8']>;
  WFSTLSP: Maybe<Scalars['float8']>;
  WFSTRRP: Maybe<Scalars['float8']>;
  WFSTTDP: Maybe<Scalars['float8']>;
  WFSTVTP: Maybe<Scalars['float8']>;
};

/** update columns of table "AS22UTIL2" */
export enum As22Util2_Update_Column {
  /** column name */
  Aaacli = 'AAACLI',
  /** column name */
  Aaacna = 'AAACNA',
  /** column name */
  Aaani = 'AAANI',
  /** column name */
  Aaapsn = 'AAAPSN',
  /** column name */
  Adepra = 'ADEPRA',
  /** column name */
  Africa = 'AFRICA',
  /** column name */
  Apanes = 'APANES',
  /** column name */
  Apcar = 'APCAR',
  /** column name */
  Apcase = 'APCASE',
  /** column name */
  Aped = 'APED',
  /** column name */
  Apemer = 'APEMER',
  /** column name */
  Apoth = 'APOTH',
  /** column name */
  Aprn = 'APRN',
  /** column name */
  Apspc = 'APSPC',
  /** column name */
  Assnet = 'ASSNET',
  /** column name */
  Auvz = 'AUVZ',
  /** column name */
  Bhhlt = 'BHHLT',
  /** column name */
  Bhprdcli = 'BHPRDCLI',
  /** column name */
  Bhprdcna = 'BHPRDCNA',
  /** column name */
  Bhprdni = 'BHPRDNI',
  /** column name */
  Bhprdpsn = 'BHPRDPSN',
  /** column name */
  Canada = 'CANADA',
  /** column name */
  Ceamt = 'CEAMT',
  /** column name */
  China = 'CHINA',
  /** column name */
  Clscic = 'CLSCIC',
  /** column name */
  Clsmsi = 'CLSMSI',
  /** column name */
  Clsnic = 'CLSNIC',
  /** column name */
  Clsoic = 'CLSOIC',
  /** column name */
  Clspic = 'CLSPIC',
  /** column name */
  Cmhlt = 'CMHLT',
  /** column name */
  Collcli = 'COLLCLI',
  /** column name */
  Collcna = 'COLLCNA',
  /** column name */
  Collni = 'COLLNI',
  /** column name */
  Collpsn = 'COLLPSN',
  /** column name */
  Deidna = 'DEIDNA',
  /** column name */
  Deidpdev = 'DEIDPDEV',
  /** column name */
  Deidpo = 'DEIDPO',
  /** column name */
  Deidproc = 'DEIDPROC',
  /** column name */
  Deidspch = 'DEIDSPCH',
  /** column name */
  Deidtrn = 'DEIDTRN',
  /** column name */
  Fborcli = 'FBORCLI',
  /** column name */
  Fborcna = 'FBORCNA',
  /** column name */
  Fborni = 'FBORNI',
  /** column name */
  Fborpsn = 'FBORPSN',
  /** column name */
  Fornrsa = 'FORNRSA',
  /** column name */
  Ftaprn = 'FTAPRN',
  /** column name */
  Fteapn = 'FTEAPN',
  /** column name */
  Ftecic = 'FTECIC',
  /** column name */
  Ftehsp = 'FTEHSP',
  /** column name */
  Fteint = 'FTEINT',
  /** column name */
  Ftemsi = 'FTEMSI',
  /** column name */
  Ftenic = 'FTENIC',
  /** column name */
  Fteoic = 'FTEOIC',
  /** column name */
  Ftephrn = 'FTEPHRN',
  /** column name */
  Ftepic = 'FTEPIC',
  /** column name */
  Ftphrn = 'FTPHRN',
  /** column name */
  Gfeet = 'GFEET',
  /** column name */
  Hcoccli = 'HCOCCLI',
  /** column name */
  Hcoccna = 'HCOCCNA',
  /** column name */
  Hcocni = 'HCOCNI',
  /** column name */
  Hcocpsn = 'HCOCPSN',
  /** column name */
  Hhegcdo = 'HHEGCDO',
  /** column name */
  Hhegceo = 'HHEGCEO',
  /** column name */
  Hhegerg = 'HHEGERG',
  /** column name */
  Hheglead = 'HHEGLEAD',
  /** column name */
  Hhegmdmn = 'HHEGMDMN',
  /** column name */
  Hhegna = 'HHEGNA',
  /** column name */
  Hhegtkfc = 'HHEGTKFC',
  /** column name */
  Hicoccli = 'HICOCCLI',
  /** column name */
  Hicoccna = 'HICOCCNA',
  /** column name */
  Hicocni = 'HICOCNI',
  /** column name */
  Hicocpsn = 'HICOCPSN',
  /** column name */
  Hsptl = 'HSPTL',
  /** column name */
  Id = 'ID',
  /** column name */
  India = 'INDIA',
  /** column name */
  Intcar = 'INTCAR',
  /** column name */
  Korea = 'KOREA',
  /** column name */
  Kschcli = 'KSCHCLI',
  /** column name */
  Kschcna = 'KSCHCNA',
  /** column name */
  Kschni = 'KSCHNI',
  /** column name */
  Kschpsn = 'KSCHPSN',
  /** column name */
  Locfcli = 'LOCFCLI',
  /** column name */
  Locfcna = 'LOCFCNA',
  /** column name */
  Locfni = 'LOCFNI',
  /** column name */
  Locfpsn = 'LOCFPSN',
  /** column name */
  Lochscli = 'LOCHSCLI',
  /** column name */
  Lochscna = 'LOCHSCNA',
  /** column name */
  Lochsni = 'LOCHSNI',
  /** column name */
  Lochspsn = 'LOCHSPSN',
  /** column name */
  Loclgcli = 'LOCLGCLI',
  /** column name */
  Loclgcna = 'LOCLGCNA',
  /** column name */
  Loclgni = 'LOCLGNI',
  /** column name */
  Loclgpsn = 'LOCLGPSN',
  /** column name */
  Lococcli = 'LOCOCCLI',
  /** column name */
  Lococcna = 'LOCOCCNA',
  /** column name */
  Lococni = 'LOCOCNI',
  /** column name */
  Lococpsn = 'LOCOCPSN',
  /** column name */
  Loctrcli = 'LOCTRCLI',
  /** column name */
  Loctrcna = 'LOCTRCNA',
  /** column name */
  Loctrni = 'LOCTRNI',
  /** column name */
  Loctrpsn = 'LOCTRPSN',
  /** column name */
  Lorgcli = 'LORGCLI',
  /** column name */
  Lorgcna = 'LORGCNA',
  /** column name */
  Lorgni = 'LORGNI',
  /** column name */
  Lorgpsn = 'LORGPSN',
  /** column name */
  Necar = 'NECAR',
  /** column name */
  Negst = 'NEGST',
  /** column name */
  Nehsp = 'NEHSP',
  /** column name */
  Neint = 'NEINT',
  /** column name */
  Nemer = 'NEMER',
  /** column name */
  Neob = 'NEOB',
  /** column name */
  Neoth = 'NEOTH',
  /** column name */
  Netot = 'NETOT',
  /** column name */
  Ofrnrs = 'OFRNRS',
  /** column name */
  Otcomcli = 'OTCOMCLI',
  /** column name */
  Otcomcna = 'OTCOMCNA',
  /** column name */
  Otcomni = 'OTCOMNI',
  /** column name */
  Otcompsn = 'OTCOMPSN',
  /** column name */
  Otlscli = 'OTLSCLI',
  /** column name */
  Otlscna = 'OTLSCNA',
  /** column name */
  Otlsni = 'OTLSNI',
  /** column name */
  Otlspsn = 'OTLSPSN',
  /** column name */
  Ph = 'PH',
  /** column name */
  Phegacc = 'PHEGACC',
  /** column name */
  Phegcapc = 'PHEGCAPC',
  /** column name */
  Phegcmty = 'PHEGCMTY',
  /** column name */
  Phegdata = 'PHEGDATA',
  /** column name */
  Phegeiop = 'PHEGEIOP',
  /** column name */
  Pheggov = 'PHEGGOV',
  /** column name */
  Pheglead = 'PHEGLEAD',
  /** column name */
  Phegna = 'PHEGNA',
  /** column name */
  Plcecli = 'PLCECLI',
  /** column name */
  Plcecna = 'PLCECNA',
  /** column name */
  Plceni = 'PLCENI',
  /** column name */
  Plcepsn = 'PLCEPSN',
  /** column name */
  Plnta = 'PLNTA',
  /** column name */
  Prpm = 'PRPM',
  /** column name */
  Ptaprn = 'PTAPRN',
  /** column name */
  Ptphrn = 'PTPHRN',
  /** column name */
  Rnsch = 'RNSCH',
  /** column name */
  Shegcdo = 'SHEGCDO',
  /** column name */
  Shegceo = 'SHEGCEO',
  /** column name */
  Shegerg = 'SHEGERG',
  /** column name */
  Sheglead = 'SHEGLEAD',
  /** column name */
  Shegmdmn = 'SHEGMDMN',
  /** column name */
  Shegna = 'SHEGNA',
  /** column name */
  Shegtkfc = 'SHEGTKFC',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Tccar = 'TCCAR',
  /** column name */
  Tcgst = 'TCGST',
  /** column name */
  Tchsp = 'TCHSP',
  /** column name */
  Tcint = 'TCINT',
  /** column name */
  Tcmer = 'TCMER',
  /** column name */
  Tcob = 'TCOB',
  /** column name */
  Tcoth = 'TCOTH',
  /** column name */
  Tctot = 'TCTOT',
  /** column name */
  Tecar = 'TECAR',
  /** column name */
  Tegst = 'TEGST',
  /** column name */
  Tehsp = 'TEHSP',
  /** column name */
  Teint = 'TEINT',
  /** column name */
  Temer = 'TEMER',
  /** column name */
  Teob = 'TEOB',
  /** column name */
  Teoth = 'TEOTH',
  /** column name */
  Tetot = 'TETOT',
  /** column name */
  Tgcar = 'TGCAR',
  /** column name */
  Tggst = 'TGGST',
  /** column name */
  Tghsp = 'TGHSP',
  /** column name */
  Tgint = 'TGINT',
  /** column name */
  Tgmer = 'TGMER',
  /** column name */
  Tgob = 'TGOB',
  /** column name */
  Tgoth = 'TGOTH',
  /** column name */
  Tgtot = 'TGTOT',
  /** column name */
  Tpcar = 'TPCAR',
  /** column name */
  Tpgst = 'TPGST',
  /** column name */
  Tphsp = 'TPHSP',
  /** column name */
  Tpint = 'TPINT',
  /** column name */
  Tpmer = 'TPMER',
  /** column name */
  Tpob = 'TPOB',
  /** column name */
  Tpoth = 'TPOTH',
  /** column name */
  Tprtot = 'TPRTOT',
  /** column name */
  Vidvz = 'VIDVZ',
  /** column name */
  Vpsrv = 'VPSRV',
  /** column name */
  Wfaiart = 'WFAIART',
  /** column name */
  Wfaidna = 'WFAIDNA',
  /** column name */
  Wfaioacw = 'WFAIOACW',
  /** column name */
  Wfaippd = 'WFAIPPD',
  /** column name */
  Wfaipsn = 'WFAIPSN',
  /** column name */
  Wfaiss = 'WFAISS',
  /** column name */
  Wfstcna = 'WFSTCNA',
  /** column name */
  Wfstdna = 'WFSTDNA',
  /** column name */
  Wfsthcc = 'WFSTHCC',
  /** column name */
  Wfstlsp = 'WFSTLSP',
  /** column name */
  Wfstrrp = 'WFSTRRP',
  /** column name */
  Wfsttdp = 'WFSTTDP',
  /** column name */
  Wfstvtp = 'WFSTVTP'
}

export type As22Util2_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As22Util2_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Util2_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Util2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As22Util2_Var_Pop_Fields = {
  __typename?: 'AS22UTIL2_var_pop_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As22Util2_Var_Samp_Fields = {
  __typename?: 'AS22UTIL2_var_samp_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As22Util2_Variance_Fields = {
  __typename?: 'AS22UTIL2_variance_fields';
  ADEPRA: Maybe<Scalars['Float']>;
  ASSNET: Maybe<Scalars['Float']>;
  AUVZ: Maybe<Scalars['Float']>;
  CEAMT: Maybe<Scalars['Float']>;
  DEIDNA: Maybe<Scalars['Float']>;
  DEIDPDEV: Maybe<Scalars['Float']>;
  DEIDPO: Maybe<Scalars['Float']>;
  DEIDPROC: Maybe<Scalars['Float']>;
  DEIDSPCH: Maybe<Scalars['Float']>;
  DEIDTRN: Maybe<Scalars['Float']>;
  FTAPRN: Maybe<Scalars['Float']>;
  FTEAPN: Maybe<Scalars['Float']>;
  FTECIC: Maybe<Scalars['Float']>;
  FTEHSP: Maybe<Scalars['Float']>;
  FTEINT: Maybe<Scalars['Float']>;
  FTEMSI: Maybe<Scalars['Float']>;
  FTENIC: Maybe<Scalars['Float']>;
  FTEOIC: Maybe<Scalars['Float']>;
  FTEPHRN: Maybe<Scalars['Float']>;
  FTEPIC: Maybe<Scalars['Float']>;
  FTPHRN: Maybe<Scalars['Float']>;
  GFEET: Maybe<Scalars['Float']>;
  HHEGCDO: Maybe<Scalars['Float']>;
  HHEGCEO: Maybe<Scalars['Float']>;
  HHEGERG: Maybe<Scalars['Float']>;
  HHEGLEAD: Maybe<Scalars['Float']>;
  HHEGMDMN: Maybe<Scalars['Float']>;
  HHEGNA: Maybe<Scalars['Float']>;
  HHEGTKFC: Maybe<Scalars['Float']>;
  NECAR: Maybe<Scalars['Float']>;
  NEGST: Maybe<Scalars['Float']>;
  NEHSP: Maybe<Scalars['Float']>;
  NEINT: Maybe<Scalars['Float']>;
  NEMER: Maybe<Scalars['Float']>;
  NEOB: Maybe<Scalars['Float']>;
  NEOTH: Maybe<Scalars['Float']>;
  NETOT: Maybe<Scalars['Float']>;
  PHEGACC: Maybe<Scalars['Float']>;
  PHEGCAPC: Maybe<Scalars['Float']>;
  PHEGCMTY: Maybe<Scalars['Float']>;
  PHEGDATA: Maybe<Scalars['Float']>;
  PHEGEIOP: Maybe<Scalars['Float']>;
  PHEGGOV: Maybe<Scalars['Float']>;
  PHEGLEAD: Maybe<Scalars['Float']>;
  PHEGNA: Maybe<Scalars['Float']>;
  PLNTA: Maybe<Scalars['Float']>;
  PRPM: Maybe<Scalars['Float']>;
  PTAPRN: Maybe<Scalars['Float']>;
  PTPHRN: Maybe<Scalars['Float']>;
  RNSCH: Maybe<Scalars['Float']>;
  SHEGCDO: Maybe<Scalars['Float']>;
  SHEGCEO: Maybe<Scalars['Float']>;
  SHEGERG: Maybe<Scalars['Float']>;
  SHEGLEAD: Maybe<Scalars['Float']>;
  SHEGMDMN: Maybe<Scalars['Float']>;
  SHEGNA: Maybe<Scalars['Float']>;
  SHEGTKFC: Maybe<Scalars['Float']>;
  TCCAR: Maybe<Scalars['Float']>;
  TCGST: Maybe<Scalars['Float']>;
  TCHSP: Maybe<Scalars['Float']>;
  TCINT: Maybe<Scalars['Float']>;
  TCMER: Maybe<Scalars['Float']>;
  TCOB: Maybe<Scalars['Float']>;
  TCOTH: Maybe<Scalars['Float']>;
  TCTOT: Maybe<Scalars['Float']>;
  TECAR: Maybe<Scalars['Float']>;
  TEGST: Maybe<Scalars['Float']>;
  TEHSP: Maybe<Scalars['Float']>;
  TEINT: Maybe<Scalars['Float']>;
  TEMER: Maybe<Scalars['Float']>;
  TEOB: Maybe<Scalars['Float']>;
  TEOTH: Maybe<Scalars['Float']>;
  TETOT: Maybe<Scalars['Float']>;
  TGCAR: Maybe<Scalars['Float']>;
  TGGST: Maybe<Scalars['Float']>;
  TGHSP: Maybe<Scalars['Float']>;
  TGINT: Maybe<Scalars['Float']>;
  TGMER: Maybe<Scalars['Float']>;
  TGOB: Maybe<Scalars['Float']>;
  TGOTH: Maybe<Scalars['Float']>;
  TGTOT: Maybe<Scalars['Float']>;
  TPCAR: Maybe<Scalars['Float']>;
  TPGST: Maybe<Scalars['Float']>;
  TPHSP: Maybe<Scalars['Float']>;
  TPINT: Maybe<Scalars['Float']>;
  TPMER: Maybe<Scalars['Float']>;
  TPOB: Maybe<Scalars['Float']>;
  TPOTH: Maybe<Scalars['Float']>;
  TPRTOT: Maybe<Scalars['Float']>;
  VIDVZ: Maybe<Scalars['Float']>;
  VPSRV: Maybe<Scalars['Float']>;
  WFAIART: Maybe<Scalars['Float']>;
  WFAIDNA: Maybe<Scalars['Float']>;
  WFAIOACW: Maybe<Scalars['Float']>;
  WFAIPPD: Maybe<Scalars['Float']>;
  WFAIPSN: Maybe<Scalars['Float']>;
  WFAISS: Maybe<Scalars['Float']>;
  WFSTCNA: Maybe<Scalars['Float']>;
  WFSTDNA: Maybe<Scalars['Float']>;
  WFSTHCC: Maybe<Scalars['Float']>;
  WFSTLSP: Maybe<Scalars['Float']>;
  WFSTRRP: Maybe<Scalars['Float']>;
  WFSTTDP: Maybe<Scalars['Float']>;
  WFSTVTP: Maybe<Scalars['Float']>;
};

/** aggregated selection of "AS22UTIL" */
export type As22Util_Aggregate = {
  __typename?: 'AS22UTIL_aggregate';
  aggregate: Maybe<As22Util_Aggregate_Fields>;
  nodes: Array<As22Util>;
};

/** aggregate fields of "AS22UTIL" */
export type As22Util_Aggregate_Fields = {
  __typename?: 'AS22UTIL_aggregate_fields';
  avg: Maybe<As22Util_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<As22Util_Max_Fields>;
  min: Maybe<As22Util_Min_Fields>;
  stddev: Maybe<As22Util_Stddev_Fields>;
  stddev_pop: Maybe<As22Util_Stddev_Pop_Fields>;
  stddev_samp: Maybe<As22Util_Stddev_Samp_Fields>;
  sum: Maybe<As22Util_Sum_Fields>;
  var_pop: Maybe<As22Util_Var_Pop_Fields>;
  var_samp: Maybe<As22Util_Var_Samp_Fields>;
  variance: Maybe<As22Util_Variance_Fields>;
};


/** aggregate fields of "AS22UTIL" */
export type As22Util_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<As22Util_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type As22Util_Avg_Fields = {
  __typename?: 'AS22UTIL_avg_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "AS22UTIL". All fields are combined with a logical 'AND'. */
export type As22Util_Bool_Exp = {
  ADC?: InputMaybe<Float8_Comparison_Exp>;
  ADJADC?: InputMaybe<Float8_Comparison_Exp>;
  ADJADCH?: InputMaybe<Float8_Comparison_Exp>;
  ADJADM?: InputMaybe<Float8_Comparison_Exp>;
  ADJPD?: InputMaybe<Float8_Comparison_Exp>;
  ADJPDH?: InputMaybe<Float8_Comparison_Exp>;
  ADMH?: InputMaybe<Float8_Comparison_Exp>;
  ADMLT?: InputMaybe<Float8_Comparison_Exp>;
  ADMTOT?: InputMaybe<Float8_Comparison_Exp>;
  BASSIN?: InputMaybe<Float8_Comparison_Exp>;
  BDH?: InputMaybe<Float8_Comparison_Exp>;
  BDLT?: InputMaybe<Float8_Comparison_Exp>;
  BDTOT?: InputMaybe<Float8_Comparison_Exp>;
  BIRTHS?: InputMaybe<Float8_Comparison_Exp>;
  CRNFTE?: InputMaybe<Float8_Comparison_Exp>;
  CTFTE?: InputMaybe<Float8_Comparison_Exp>;
  DCLT?: InputMaybe<Float8_Comparison_Exp>;
  DCTOT?: InputMaybe<Float8_Comparison_Exp>;
  DCTOTH?: InputMaybe<Float8_Comparison_Exp>;
  DPEXA?: InputMaybe<Float8_Comparison_Exp>;
  EADMH?: InputMaybe<String_Comparison_Exp>;
  EADMLT?: InputMaybe<String_Comparison_Exp>;
  EADMTOT?: InputMaybe<String_Comparison_Exp>;
  EBIRTHS?: InputMaybe<String_Comparison_Exp>;
  EEXPTOT?: InputMaybe<String_Comparison_Exp>;
  EFTAST?: InputMaybe<String_Comparison_Exp>;
  EFTLAB?: InputMaybe<String_Comparison_Exp>;
  EFTLPNTF?: InputMaybe<String_Comparison_Exp>;
  EFTMDTF?: InputMaybe<String_Comparison_Exp>;
  EFTOTHTF?: InputMaybe<String_Comparison_Exp>;
  EFTPHR?: InputMaybe<String_Comparison_Exp>;
  EFTPHT?: InputMaybe<String_Comparison_Exp>;
  EFTRAD?: InputMaybe<String_Comparison_Exp>;
  EFTRES?: InputMaybe<String_Comparison_Exp>;
  EFTRESP?: InputMaybe<String_Comparison_Exp>;
  EFTRNTF?: InputMaybe<String_Comparison_Exp>;
  EFTTOT?: InputMaybe<String_Comparison_Exp>;
  EFTTOTH?: InputMaybe<String_Comparison_Exp>;
  EFTTOTLT?: InputMaybe<String_Comparison_Exp>;
  EFTTRN84?: InputMaybe<String_Comparison_Exp>;
  EIPDH?: InputMaybe<String_Comparison_Exp>;
  EIPDLT?: InputMaybe<String_Comparison_Exp>;
  EIPDTOT?: InputMaybe<String_Comparison_Exp>;
  EMCDDC?: InputMaybe<String_Comparison_Exp>;
  EMCDDCH?: InputMaybe<String_Comparison_Exp>;
  EMCDDCLT?: InputMaybe<String_Comparison_Exp>;
  EMCDIPD?: InputMaybe<String_Comparison_Exp>;
  EMCDIPDH?: InputMaybe<String_Comparison_Exp>;
  EMCDPDLT?: InputMaybe<String_Comparison_Exp>;
  EMCRDC?: InputMaybe<String_Comparison_Exp>;
  EMCRDCH?: InputMaybe<String_Comparison_Exp>;
  EMCRDCLT?: InputMaybe<String_Comparison_Exp>;
  EMCRIPD?: InputMaybe<String_Comparison_Exp>;
  EMCRIPDH?: InputMaybe<String_Comparison_Exp>;
  EMCRPDLT?: InputMaybe<String_Comparison_Exp>;
  ENPAYBEN?: InputMaybe<String_Comparison_Exp>;
  ENPBENLT?: InputMaybe<String_Comparison_Exp>;
  ENPYBENH?: InputMaybe<String_Comparison_Exp>;
  EOPDCH?: InputMaybe<Float8_Comparison_Exp>;
  EOPDCLT?: InputMaybe<String_Comparison_Exp>;
  EOPIPDH?: InputMaybe<Float8_Comparison_Exp>;
  EOPIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  EOPOTDC?: InputMaybe<String_Comparison_Exp>;
  EOPOTIP?: InputMaybe<String_Comparison_Exp>;
  EPAYTOT?: InputMaybe<String_Comparison_Exp>;
  EPAYTOTH?: InputMaybe<String_Comparison_Exp>;
  EPTAST?: InputMaybe<String_Comparison_Exp>;
  EPTLAB?: InputMaybe<String_Comparison_Exp>;
  EPTLPNTF?: InputMaybe<String_Comparison_Exp>;
  EPTMDTF?: InputMaybe<String_Comparison_Exp>;
  EPTOTHTF?: InputMaybe<String_Comparison_Exp>;
  EPTPHR?: InputMaybe<String_Comparison_Exp>;
  EPTPHT?: InputMaybe<String_Comparison_Exp>;
  EPTRAD?: InputMaybe<String_Comparison_Exp>;
  EPTRES?: InputMaybe<String_Comparison_Exp>;
  EPTRESP?: InputMaybe<String_Comparison_Exp>;
  EPTRNTF?: InputMaybe<String_Comparison_Exp>;
  EPTTOT?: InputMaybe<String_Comparison_Exp>;
  EPTTOTH?: InputMaybe<String_Comparison_Exp>;
  EPTTOTLT?: InputMaybe<String_Comparison_Exp>;
  EPTTRN84?: InputMaybe<String_Comparison_Exp>;
  EPYTOTLT?: InputMaybe<String_Comparison_Exp>;
  ERNFTE?: InputMaybe<Float8_Comparison_Exp>;
  ESPDCH?: InputMaybe<Float8_Comparison_Exp>;
  ESPDCLT?: InputMaybe<Float8_Comparison_Exp>;
  ESPIPDH?: InputMaybe<Float8_Comparison_Exp>;
  ESPIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  ESPTDC?: InputMaybe<String_Comparison_Exp>;
  ESPTIP?: InputMaybe<String_Comparison_Exp>;
  ESUROPIP?: InputMaybe<String_Comparison_Exp>;
  ESUROPOP?: InputMaybe<String_Comparison_Exp>;
  ESUROPTO?: InputMaybe<String_Comparison_Exp>;
  ETHRDCH?: InputMaybe<Float8_Comparison_Exp>;
  ETHRDCLT?: InputMaybe<String_Comparison_Exp>;
  ETHRIPDH?: InputMaybe<Float8_Comparison_Exp>;
  ETHRIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  ETHRTDC?: InputMaybe<String_Comparison_Exp>;
  ETHRTIP?: InputMaybe<String_Comparison_Exp>;
  EVEM?: InputMaybe<String_Comparison_Exp>;
  EVOTH?: InputMaybe<String_Comparison_Exp>;
  EVTOT?: InputMaybe<String_Comparison_Exp>;
  EXPTHA?: InputMaybe<Float8_Comparison_Exp>;
  EXPTHB?: InputMaybe<String_Comparison_Exp>;
  EXPTLA?: InputMaybe<Float8_Comparison_Exp>;
  EXPTLB?: InputMaybe<String_Comparison_Exp>;
  EXPTOT?: InputMaybe<Float8_Comparison_Exp>;
  FTAST?: InputMaybe<Float8_Comparison_Exp>;
  FTE?: InputMaybe<Float8_Comparison_Exp>;
  FTEAP?: InputMaybe<Float8_Comparison_Exp>;
  FTECAP?: InputMaybe<Float8_Comparison_Exp>;
  FTECLAB?: InputMaybe<Float8_Comparison_Exp>;
  FTECPH?: InputMaybe<Float8_Comparison_Exp>;
  FTECPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTECRAD?: InputMaybe<Float8_Comparison_Exp>;
  FTECRESP?: InputMaybe<Float8_Comparison_Exp>;
  FTED?: InputMaybe<Float8_Comparison_Exp>;
  FTEH?: InputMaybe<Float8_Comparison_Exp>;
  FTELAB?: InputMaybe<Float8_Comparison_Exp>;
  FTELPN?: InputMaybe<Float8_Comparison_Exp>;
  FTEMD?: InputMaybe<Float8_Comparison_Exp>;
  FTEN?: InputMaybe<Float8_Comparison_Exp>;
  FTENH?: InputMaybe<Float8_Comparison_Exp>;
  FTEO?: InputMaybe<Float8_Comparison_Exp>;
  FTEOTH94?: InputMaybe<Float8_Comparison_Exp>;
  FTEP?: InputMaybe<Float8_Comparison_Exp>;
  FTEPH?: InputMaybe<Float8_Comparison_Exp>;
  FTEPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTER?: InputMaybe<Float8_Comparison_Exp>;
  FTERAD?: InputMaybe<Float8_Comparison_Exp>;
  FTERES?: InputMaybe<Float8_Comparison_Exp>;
  FTERESP?: InputMaybe<Float8_Comparison_Exp>;
  FTERN?: InputMaybe<Float8_Comparison_Exp>;
  FTERNH?: InputMaybe<Float8_Comparison_Exp>;
  FTERNLT?: InputMaybe<Float8_Comparison_Exp>;
  FTET?: InputMaybe<Float8_Comparison_Exp>;
  FTETF?: InputMaybe<Float8_Comparison_Exp>;
  FTETRAN?: InputMaybe<Float8_Comparison_Exp>;
  FTETTRN?: InputMaybe<Float8_Comparison_Exp>;
  FTEU?: InputMaybe<Float8_Comparison_Exp>;
  FTLAB?: InputMaybe<Float8_Comparison_Exp>;
  FTLPNTF?: InputMaybe<Float8_Comparison_Exp>;
  FTMDTF?: InputMaybe<Float8_Comparison_Exp>;
  FTOTHTF?: InputMaybe<Float8_Comparison_Exp>;
  FTPHR?: InputMaybe<Float8_Comparison_Exp>;
  FTPHT?: InputMaybe<Float8_Comparison_Exp>;
  FTRAD?: InputMaybe<Float8_Comparison_Exp>;
  FTRES?: InputMaybe<Float8_Comparison_Exp>;
  FTRESP?: InputMaybe<Float8_Comparison_Exp>;
  FTRNLT?: InputMaybe<Float8_Comparison_Exp>;
  FTRNTF?: InputMaybe<Float8_Comparison_Exp>;
  FTTOT?: InputMaybe<Float8_Comparison_Exp>;
  FTTOTH?: InputMaybe<Float8_Comparison_Exp>;
  FTTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  FTTRAN84?: InputMaybe<Float8_Comparison_Exp>;
  ID?: InputMaybe<String_Comparison_Exp>;
  INTEXA?: InputMaybe<Float8_Comparison_Exp>;
  IPDH?: InputMaybe<Float8_Comparison_Exp>;
  IPDLT?: InputMaybe<Float8_Comparison_Exp>;
  IPDTOT?: InputMaybe<Float8_Comparison_Exp>;
  LABFTE?: InputMaybe<Float8_Comparison_Exp>;
  LBEDLA?: InputMaybe<Float8_Comparison_Exp>;
  LBEDSA?: InputMaybe<Float8_Comparison_Exp>;
  MCDDC?: InputMaybe<Float8_Comparison_Exp>;
  MCDDCH?: InputMaybe<Float8_Comparison_Exp>;
  MCDDCLT?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPD?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPDH?: InputMaybe<Float8_Comparison_Exp>;
  MCDIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  MCRDC?: InputMaybe<Float8_Comparison_Exp>;
  MCRDCH?: InputMaybe<Float8_Comparison_Exp>;
  MCRDCLT?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPD?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPDH?: InputMaybe<Float8_Comparison_Exp>;
  MCRIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBEN?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBENH?: InputMaybe<Float8_Comparison_Exp>;
  NPAYBENL?: InputMaybe<Float8_Comparison_Exp>;
  OPDCH?: InputMaybe<Float8_Comparison_Exp>;
  OPDCLT?: InputMaybe<Float8_Comparison_Exp>;
  OPIPDH?: InputMaybe<Float8_Comparison_Exp>;
  OPIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  OPOTDC?: InputMaybe<Float8_Comparison_Exp>;
  OPOTIP?: InputMaybe<Float8_Comparison_Exp>;
  OPRA?: InputMaybe<Float8_Comparison_Exp>;
  OTHEXPA?: InputMaybe<Float8_Comparison_Exp>;
  OTHPCR?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOT?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOTH?: InputMaybe<Float8_Comparison_Exp>;
  PAYTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  PCMRES?: InputMaybe<Float8_Comparison_Exp>;
  PHAFTE?: InputMaybe<Float8_Comparison_Exp>;
  PHREXA?: InputMaybe<Float8_Comparison_Exp>;
  PTAST?: InputMaybe<Float8_Comparison_Exp>;
  PTLAB?: InputMaybe<Float8_Comparison_Exp>;
  PTLPNTF?: InputMaybe<Float8_Comparison_Exp>;
  PTMDTF?: InputMaybe<Float8_Comparison_Exp>;
  PTOTHTF?: InputMaybe<Float8_Comparison_Exp>;
  PTPHR?: InputMaybe<Float8_Comparison_Exp>;
  PTPHT?: InputMaybe<Float8_Comparison_Exp>;
  PTRAD?: InputMaybe<Float8_Comparison_Exp>;
  PTRES?: InputMaybe<Float8_Comparison_Exp>;
  PTRESP?: InputMaybe<Float8_Comparison_Exp>;
  PTRNLT?: InputMaybe<Float8_Comparison_Exp>;
  PTRNTF?: InputMaybe<Float8_Comparison_Exp>;
  PTTOT?: InputMaybe<Float8_Comparison_Exp>;
  PTTOTH?: InputMaybe<Float8_Comparison_Exp>;
  PTTOTLT?: InputMaybe<Float8_Comparison_Exp>;
  PTTRAN84?: InputMaybe<Float8_Comparison_Exp>;
  RADFTE?: InputMaybe<Float8_Comparison_Exp>;
  RTTFTE?: InputMaybe<Float8_Comparison_Exp>;
  SPDCH?: InputMaybe<Float8_Comparison_Exp>;
  SPDCLT?: InputMaybe<Float8_Comparison_Exp>;
  SPIPDH?: InputMaybe<Float8_Comparison_Exp>;
  SPIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  SPTDC?: InputMaybe<Float8_Comparison_Exp>;
  SPTIP?: InputMaybe<Float8_Comparison_Exp>;
  STCD?: InputMaybe<String_Comparison_Exp>;
  SUPEXA?: InputMaybe<Float8_Comparison_Exp>;
  SUROPIP?: InputMaybe<Float8_Comparison_Exp>;
  SUROPOP?: InputMaybe<Float8_Comparison_Exp>;
  SUROPTOT?: InputMaybe<Float8_Comparison_Exp>;
  TECFTE?: InputMaybe<Float8_Comparison_Exp>;
  THRDCH?: InputMaybe<Float8_Comparison_Exp>;
  THRDCLT?: InputMaybe<Float8_Comparison_Exp>;
  THRIPDH?: InputMaybe<Float8_Comparison_Exp>;
  THRIPDLT?: InputMaybe<Float8_Comparison_Exp>;
  THRTDC?: InputMaybe<Float8_Comparison_Exp>;
  THRTIP?: InputMaybe<Float8_Comparison_Exp>;
  VAST?: InputMaybe<Float8_Comparison_Exp>;
  VEM?: InputMaybe<Float8_Comparison_Exp>;
  VLAB?: InputMaybe<Float8_Comparison_Exp>;
  VLPN?: InputMaybe<Float8_Comparison_Exp>;
  VMD?: InputMaybe<Float8_Comparison_Exp>;
  VOTH?: InputMaybe<Float8_Comparison_Exp>;
  VOTHL?: InputMaybe<Float8_Comparison_Exp>;
  VPHR?: InputMaybe<Float8_Comparison_Exp>;
  VPHT?: InputMaybe<Float8_Comparison_Exp>;
  VRAD?: InputMaybe<Float8_Comparison_Exp>;
  VRES?: InputMaybe<Float8_Comparison_Exp>;
  VRN?: InputMaybe<Float8_Comparison_Exp>;
  VRNH?: InputMaybe<Float8_Comparison_Exp>;
  VRSP?: InputMaybe<Float8_Comparison_Exp>;
  VTNH?: InputMaybe<Float8_Comparison_Exp>;
  VTOT?: InputMaybe<Float8_Comparison_Exp>;
  VTOTL?: InputMaybe<Float8_Comparison_Exp>;
  VTTRN?: InputMaybe<Float8_Comparison_Exp>;
  _and?: InputMaybe<Array<As22Util_Bool_Exp>>;
  _not?: InputMaybe<As22Util_Bool_Exp>;
  _or?: InputMaybe<Array<As22Util_Bool_Exp>>;
};

/** unique or primary key constraints on table "AS22UTIL" */
export enum As22Util_Constraint {
  /** unique or primary key constraint on columns "ID" */
  PkAs22Util = 'pk_AS22UTIL'
}

/** input type for incrementing numeric columns in table "AS22UTIL" */
export type As22Util_Inc_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  CRNFTE?: InputMaybe<Scalars['float8']>;
  CTFTE?: InputMaybe<Scalars['float8']>;
  DCLT?: InputMaybe<Scalars['float8']>;
  DCTOT?: InputMaybe<Scalars['float8']>;
  DCTOTH?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EOPDCH?: InputMaybe<Scalars['float8']>;
  EOPIPDH?: InputMaybe<Scalars['float8']>;
  EOPIPDLT?: InputMaybe<Scalars['float8']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESPDCH?: InputMaybe<Scalars['float8']>;
  ESPDCLT?: InputMaybe<Scalars['float8']>;
  ESPIPDH?: InputMaybe<Scalars['float8']>;
  ESPIPDLT?: InputMaybe<Scalars['float8']>;
  ETHRDCH?: InputMaybe<Scalars['float8']>;
  ETHRIPDH?: InputMaybe<Scalars['float8']>;
  ETHRIPDLT?: InputMaybe<Scalars['float8']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LABFTE?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPDCH?: InputMaybe<Scalars['float8']>;
  OPDCLT?: InputMaybe<Scalars['float8']>;
  OPIPDH?: InputMaybe<Scalars['float8']>;
  OPIPDLT?: InputMaybe<Scalars['float8']>;
  OPOTDC?: InputMaybe<Scalars['float8']>;
  OPOTIP?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHAFTE?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  RADFTE?: InputMaybe<Scalars['float8']>;
  RTTFTE?: InputMaybe<Scalars['float8']>;
  SPDCH?: InputMaybe<Scalars['float8']>;
  SPDCLT?: InputMaybe<Scalars['float8']>;
  SPIPDH?: InputMaybe<Scalars['float8']>;
  SPIPDLT?: InputMaybe<Scalars['float8']>;
  SPTDC?: InputMaybe<Scalars['float8']>;
  SPTIP?: InputMaybe<Scalars['float8']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  TECFTE?: InputMaybe<Scalars['float8']>;
  THRDCH?: InputMaybe<Scalars['float8']>;
  THRDCLT?: InputMaybe<Scalars['float8']>;
  THRIPDH?: InputMaybe<Scalars['float8']>;
  THRIPDLT?: InputMaybe<Scalars['float8']>;
  THRTDC?: InputMaybe<Scalars['float8']>;
  THRTIP?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "AS22UTIL" */
export type As22Util_Insert_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  CRNFTE?: InputMaybe<Scalars['float8']>;
  CTFTE?: InputMaybe<Scalars['float8']>;
  DCLT?: InputMaybe<Scalars['float8']>;
  DCTOT?: InputMaybe<Scalars['float8']>;
  DCTOTH?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EOPDCH?: InputMaybe<Scalars['float8']>;
  EOPDCLT?: InputMaybe<Scalars['String']>;
  EOPIPDH?: InputMaybe<Scalars['float8']>;
  EOPIPDLT?: InputMaybe<Scalars['float8']>;
  EOPOTDC?: InputMaybe<Scalars['String']>;
  EOPOTIP?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESPDCH?: InputMaybe<Scalars['float8']>;
  ESPDCLT?: InputMaybe<Scalars['float8']>;
  ESPIPDH?: InputMaybe<Scalars['float8']>;
  ESPIPDLT?: InputMaybe<Scalars['float8']>;
  ESPTDC?: InputMaybe<Scalars['String']>;
  ESPTIP?: InputMaybe<Scalars['String']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  ETHRDCH?: InputMaybe<Scalars['float8']>;
  ETHRDCLT?: InputMaybe<Scalars['String']>;
  ETHRIPDH?: InputMaybe<Scalars['float8']>;
  ETHRIPDLT?: InputMaybe<Scalars['float8']>;
  ETHRTDC?: InputMaybe<Scalars['String']>;
  ETHRTIP?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LABFTE?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPDCH?: InputMaybe<Scalars['float8']>;
  OPDCLT?: InputMaybe<Scalars['float8']>;
  OPIPDH?: InputMaybe<Scalars['float8']>;
  OPIPDLT?: InputMaybe<Scalars['float8']>;
  OPOTDC?: InputMaybe<Scalars['float8']>;
  OPOTIP?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHAFTE?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  RADFTE?: InputMaybe<Scalars['float8']>;
  RTTFTE?: InputMaybe<Scalars['float8']>;
  SPDCH?: InputMaybe<Scalars['float8']>;
  SPDCLT?: InputMaybe<Scalars['float8']>;
  SPIPDH?: InputMaybe<Scalars['float8']>;
  SPIPDLT?: InputMaybe<Scalars['float8']>;
  SPTDC?: InputMaybe<Scalars['float8']>;
  SPTIP?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  TECFTE?: InputMaybe<Scalars['float8']>;
  THRDCH?: InputMaybe<Scalars['float8']>;
  THRDCLT?: InputMaybe<Scalars['float8']>;
  THRIPDH?: InputMaybe<Scalars['float8']>;
  THRIPDLT?: InputMaybe<Scalars['float8']>;
  THRTDC?: InputMaybe<Scalars['float8']>;
  THRTIP?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type As22Util_Max_Fields = {
  __typename?: 'AS22UTIL_max_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  CRNFTE: Maybe<Scalars['float8']>;
  CTFTE: Maybe<Scalars['float8']>;
  DCLT: Maybe<Scalars['float8']>;
  DCTOT: Maybe<Scalars['float8']>;
  DCTOTH: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EOPDCH: Maybe<Scalars['float8']>;
  EOPDCLT: Maybe<Scalars['String']>;
  EOPIPDH: Maybe<Scalars['float8']>;
  EOPIPDLT: Maybe<Scalars['float8']>;
  EOPOTDC: Maybe<Scalars['String']>;
  EOPOTIP: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESPDCH: Maybe<Scalars['float8']>;
  ESPDCLT: Maybe<Scalars['float8']>;
  ESPIPDH: Maybe<Scalars['float8']>;
  ESPIPDLT: Maybe<Scalars['float8']>;
  ESPTDC: Maybe<Scalars['String']>;
  ESPTIP: Maybe<Scalars['String']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  ETHRDCH: Maybe<Scalars['float8']>;
  ETHRDCLT: Maybe<Scalars['String']>;
  ETHRIPDH: Maybe<Scalars['float8']>;
  ETHRIPDLT: Maybe<Scalars['float8']>;
  ETHRTDC: Maybe<Scalars['String']>;
  ETHRTIP: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Maybe<Scalars['String']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LABFTE: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPDCH: Maybe<Scalars['float8']>;
  OPDCLT: Maybe<Scalars['float8']>;
  OPIPDH: Maybe<Scalars['float8']>;
  OPIPDLT: Maybe<Scalars['float8']>;
  OPOTDC: Maybe<Scalars['float8']>;
  OPOTIP: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHAFTE: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  RADFTE: Maybe<Scalars['float8']>;
  RTTFTE: Maybe<Scalars['float8']>;
  SPDCH: Maybe<Scalars['float8']>;
  SPDCLT: Maybe<Scalars['float8']>;
  SPIPDH: Maybe<Scalars['float8']>;
  SPIPDLT: Maybe<Scalars['float8']>;
  SPTDC: Maybe<Scalars['float8']>;
  SPTIP: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  TECFTE: Maybe<Scalars['float8']>;
  THRDCH: Maybe<Scalars['float8']>;
  THRDCLT: Maybe<Scalars['float8']>;
  THRIPDH: Maybe<Scalars['float8']>;
  THRIPDLT: Maybe<Scalars['float8']>;
  THRTDC: Maybe<Scalars['float8']>;
  THRTIP: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type As22Util_Min_Fields = {
  __typename?: 'AS22UTIL_min_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  CRNFTE: Maybe<Scalars['float8']>;
  CTFTE: Maybe<Scalars['float8']>;
  DCLT: Maybe<Scalars['float8']>;
  DCTOT: Maybe<Scalars['float8']>;
  DCTOTH: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EADMH: Maybe<Scalars['String']>;
  EADMLT: Maybe<Scalars['String']>;
  EADMTOT: Maybe<Scalars['String']>;
  EBIRTHS: Maybe<Scalars['String']>;
  EEXPTOT: Maybe<Scalars['String']>;
  EFTAST: Maybe<Scalars['String']>;
  EFTLAB: Maybe<Scalars['String']>;
  EFTLPNTF: Maybe<Scalars['String']>;
  EFTMDTF: Maybe<Scalars['String']>;
  EFTOTHTF: Maybe<Scalars['String']>;
  EFTPHR: Maybe<Scalars['String']>;
  EFTPHT: Maybe<Scalars['String']>;
  EFTRAD: Maybe<Scalars['String']>;
  EFTRES: Maybe<Scalars['String']>;
  EFTRESP: Maybe<Scalars['String']>;
  EFTRNTF: Maybe<Scalars['String']>;
  EFTTOT: Maybe<Scalars['String']>;
  EFTTOTH: Maybe<Scalars['String']>;
  EFTTOTLT: Maybe<Scalars['String']>;
  EFTTRN84: Maybe<Scalars['String']>;
  EIPDH: Maybe<Scalars['String']>;
  EIPDLT: Maybe<Scalars['String']>;
  EIPDTOT: Maybe<Scalars['String']>;
  EMCDDC: Maybe<Scalars['String']>;
  EMCDDCH: Maybe<Scalars['String']>;
  EMCDDCLT: Maybe<Scalars['String']>;
  EMCDIPD: Maybe<Scalars['String']>;
  EMCDIPDH: Maybe<Scalars['String']>;
  EMCDPDLT: Maybe<Scalars['String']>;
  EMCRDC: Maybe<Scalars['String']>;
  EMCRDCH: Maybe<Scalars['String']>;
  EMCRDCLT: Maybe<Scalars['String']>;
  EMCRIPD: Maybe<Scalars['String']>;
  EMCRIPDH: Maybe<Scalars['String']>;
  EMCRPDLT: Maybe<Scalars['String']>;
  ENPAYBEN: Maybe<Scalars['String']>;
  ENPBENLT: Maybe<Scalars['String']>;
  ENPYBENH: Maybe<Scalars['String']>;
  EOPDCH: Maybe<Scalars['float8']>;
  EOPDCLT: Maybe<Scalars['String']>;
  EOPIPDH: Maybe<Scalars['float8']>;
  EOPIPDLT: Maybe<Scalars['float8']>;
  EOPOTDC: Maybe<Scalars['String']>;
  EOPOTIP: Maybe<Scalars['String']>;
  EPAYTOT: Maybe<Scalars['String']>;
  EPAYTOTH: Maybe<Scalars['String']>;
  EPTAST: Maybe<Scalars['String']>;
  EPTLAB: Maybe<Scalars['String']>;
  EPTLPNTF: Maybe<Scalars['String']>;
  EPTMDTF: Maybe<Scalars['String']>;
  EPTOTHTF: Maybe<Scalars['String']>;
  EPTPHR: Maybe<Scalars['String']>;
  EPTPHT: Maybe<Scalars['String']>;
  EPTRAD: Maybe<Scalars['String']>;
  EPTRES: Maybe<Scalars['String']>;
  EPTRESP: Maybe<Scalars['String']>;
  EPTRNTF: Maybe<Scalars['String']>;
  EPTTOT: Maybe<Scalars['String']>;
  EPTTOTH: Maybe<Scalars['String']>;
  EPTTOTLT: Maybe<Scalars['String']>;
  EPTTRN84: Maybe<Scalars['String']>;
  EPYTOTLT: Maybe<Scalars['String']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESPDCH: Maybe<Scalars['float8']>;
  ESPDCLT: Maybe<Scalars['float8']>;
  ESPIPDH: Maybe<Scalars['float8']>;
  ESPIPDLT: Maybe<Scalars['float8']>;
  ESPTDC: Maybe<Scalars['String']>;
  ESPTIP: Maybe<Scalars['String']>;
  ESUROPIP: Maybe<Scalars['String']>;
  ESUROPOP: Maybe<Scalars['String']>;
  ESUROPTO: Maybe<Scalars['String']>;
  ETHRDCH: Maybe<Scalars['float8']>;
  ETHRDCLT: Maybe<Scalars['String']>;
  ETHRIPDH: Maybe<Scalars['float8']>;
  ETHRIPDLT: Maybe<Scalars['float8']>;
  ETHRTDC: Maybe<Scalars['String']>;
  ETHRTIP: Maybe<Scalars['String']>;
  EVEM: Maybe<Scalars['String']>;
  EVOTH: Maybe<Scalars['String']>;
  EVTOT: Maybe<Scalars['String']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTHB: Maybe<Scalars['String']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTLB: Maybe<Scalars['String']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  ID: Maybe<Scalars['String']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LABFTE: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPDCH: Maybe<Scalars['float8']>;
  OPDCLT: Maybe<Scalars['float8']>;
  OPIPDH: Maybe<Scalars['float8']>;
  OPIPDLT: Maybe<Scalars['float8']>;
  OPOTDC: Maybe<Scalars['float8']>;
  OPOTIP: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHAFTE: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  RADFTE: Maybe<Scalars['float8']>;
  RTTFTE: Maybe<Scalars['float8']>;
  SPDCH: Maybe<Scalars['float8']>;
  SPDCLT: Maybe<Scalars['float8']>;
  SPIPDH: Maybe<Scalars['float8']>;
  SPIPDLT: Maybe<Scalars['float8']>;
  SPTDC: Maybe<Scalars['float8']>;
  SPTIP: Maybe<Scalars['float8']>;
  STCD: Maybe<Scalars['String']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  TECFTE: Maybe<Scalars['float8']>;
  THRDCH: Maybe<Scalars['float8']>;
  THRDCLT: Maybe<Scalars['float8']>;
  THRIPDH: Maybe<Scalars['float8']>;
  THRIPDLT: Maybe<Scalars['float8']>;
  THRTDC: Maybe<Scalars['float8']>;
  THRTIP: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** response of any mutation on the table "AS22UTIL" */
export type As22Util_Mutation_Response = {
  __typename?: 'AS22UTIL_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<As22Util>;
};

/** input type for inserting object relation for remote table "AS22UTIL" */
export type As22Util_Obj_Rel_Insert_Input = {
  data: As22Util_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<As22Util_On_Conflict>;
};

/** on_conflict condition type for table "AS22UTIL" */
export type As22Util_On_Conflict = {
  constraint: As22Util_Constraint;
  update_columns?: Array<As22Util_Update_Column>;
  where?: InputMaybe<As22Util_Bool_Exp>;
};

/** Ordering options when selecting data from "AS22UTIL". */
export type As22Util_Order_By = {
  ADC?: InputMaybe<Order_By>;
  ADJADC?: InputMaybe<Order_By>;
  ADJADCH?: InputMaybe<Order_By>;
  ADJADM?: InputMaybe<Order_By>;
  ADJPD?: InputMaybe<Order_By>;
  ADJPDH?: InputMaybe<Order_By>;
  ADMH?: InputMaybe<Order_By>;
  ADMLT?: InputMaybe<Order_By>;
  ADMTOT?: InputMaybe<Order_By>;
  BASSIN?: InputMaybe<Order_By>;
  BDH?: InputMaybe<Order_By>;
  BDLT?: InputMaybe<Order_By>;
  BDTOT?: InputMaybe<Order_By>;
  BIRTHS?: InputMaybe<Order_By>;
  CRNFTE?: InputMaybe<Order_By>;
  CTFTE?: InputMaybe<Order_By>;
  DCLT?: InputMaybe<Order_By>;
  DCTOT?: InputMaybe<Order_By>;
  DCTOTH?: InputMaybe<Order_By>;
  DPEXA?: InputMaybe<Order_By>;
  EADMH?: InputMaybe<Order_By>;
  EADMLT?: InputMaybe<Order_By>;
  EADMTOT?: InputMaybe<Order_By>;
  EBIRTHS?: InputMaybe<Order_By>;
  EEXPTOT?: InputMaybe<Order_By>;
  EFTAST?: InputMaybe<Order_By>;
  EFTLAB?: InputMaybe<Order_By>;
  EFTLPNTF?: InputMaybe<Order_By>;
  EFTMDTF?: InputMaybe<Order_By>;
  EFTOTHTF?: InputMaybe<Order_By>;
  EFTPHR?: InputMaybe<Order_By>;
  EFTPHT?: InputMaybe<Order_By>;
  EFTRAD?: InputMaybe<Order_By>;
  EFTRES?: InputMaybe<Order_By>;
  EFTRESP?: InputMaybe<Order_By>;
  EFTRNTF?: InputMaybe<Order_By>;
  EFTTOT?: InputMaybe<Order_By>;
  EFTTOTH?: InputMaybe<Order_By>;
  EFTTOTLT?: InputMaybe<Order_By>;
  EFTTRN84?: InputMaybe<Order_By>;
  EIPDH?: InputMaybe<Order_By>;
  EIPDLT?: InputMaybe<Order_By>;
  EIPDTOT?: InputMaybe<Order_By>;
  EMCDDC?: InputMaybe<Order_By>;
  EMCDDCH?: InputMaybe<Order_By>;
  EMCDDCLT?: InputMaybe<Order_By>;
  EMCDIPD?: InputMaybe<Order_By>;
  EMCDIPDH?: InputMaybe<Order_By>;
  EMCDPDLT?: InputMaybe<Order_By>;
  EMCRDC?: InputMaybe<Order_By>;
  EMCRDCH?: InputMaybe<Order_By>;
  EMCRDCLT?: InputMaybe<Order_By>;
  EMCRIPD?: InputMaybe<Order_By>;
  EMCRIPDH?: InputMaybe<Order_By>;
  EMCRPDLT?: InputMaybe<Order_By>;
  ENPAYBEN?: InputMaybe<Order_By>;
  ENPBENLT?: InputMaybe<Order_By>;
  ENPYBENH?: InputMaybe<Order_By>;
  EOPDCH?: InputMaybe<Order_By>;
  EOPDCLT?: InputMaybe<Order_By>;
  EOPIPDH?: InputMaybe<Order_By>;
  EOPIPDLT?: InputMaybe<Order_By>;
  EOPOTDC?: InputMaybe<Order_By>;
  EOPOTIP?: InputMaybe<Order_By>;
  EPAYTOT?: InputMaybe<Order_By>;
  EPAYTOTH?: InputMaybe<Order_By>;
  EPTAST?: InputMaybe<Order_By>;
  EPTLAB?: InputMaybe<Order_By>;
  EPTLPNTF?: InputMaybe<Order_By>;
  EPTMDTF?: InputMaybe<Order_By>;
  EPTOTHTF?: InputMaybe<Order_By>;
  EPTPHR?: InputMaybe<Order_By>;
  EPTPHT?: InputMaybe<Order_By>;
  EPTRAD?: InputMaybe<Order_By>;
  EPTRES?: InputMaybe<Order_By>;
  EPTRESP?: InputMaybe<Order_By>;
  EPTRNTF?: InputMaybe<Order_By>;
  EPTTOT?: InputMaybe<Order_By>;
  EPTTOTH?: InputMaybe<Order_By>;
  EPTTOTLT?: InputMaybe<Order_By>;
  EPTTRN84?: InputMaybe<Order_By>;
  EPYTOTLT?: InputMaybe<Order_By>;
  ERNFTE?: InputMaybe<Order_By>;
  ESPDCH?: InputMaybe<Order_By>;
  ESPDCLT?: InputMaybe<Order_By>;
  ESPIPDH?: InputMaybe<Order_By>;
  ESPIPDLT?: InputMaybe<Order_By>;
  ESPTDC?: InputMaybe<Order_By>;
  ESPTIP?: InputMaybe<Order_By>;
  ESUROPIP?: InputMaybe<Order_By>;
  ESUROPOP?: InputMaybe<Order_By>;
  ESUROPTO?: InputMaybe<Order_By>;
  ETHRDCH?: InputMaybe<Order_By>;
  ETHRDCLT?: InputMaybe<Order_By>;
  ETHRIPDH?: InputMaybe<Order_By>;
  ETHRIPDLT?: InputMaybe<Order_By>;
  ETHRTDC?: InputMaybe<Order_By>;
  ETHRTIP?: InputMaybe<Order_By>;
  EVEM?: InputMaybe<Order_By>;
  EVOTH?: InputMaybe<Order_By>;
  EVTOT?: InputMaybe<Order_By>;
  EXPTHA?: InputMaybe<Order_By>;
  EXPTHB?: InputMaybe<Order_By>;
  EXPTLA?: InputMaybe<Order_By>;
  EXPTLB?: InputMaybe<Order_By>;
  EXPTOT?: InputMaybe<Order_By>;
  FTAST?: InputMaybe<Order_By>;
  FTE?: InputMaybe<Order_By>;
  FTEAP?: InputMaybe<Order_By>;
  FTECAP?: InputMaybe<Order_By>;
  FTECLAB?: InputMaybe<Order_By>;
  FTECPH?: InputMaybe<Order_By>;
  FTECPHT?: InputMaybe<Order_By>;
  FTECRAD?: InputMaybe<Order_By>;
  FTECRESP?: InputMaybe<Order_By>;
  FTED?: InputMaybe<Order_By>;
  FTEH?: InputMaybe<Order_By>;
  FTELAB?: InputMaybe<Order_By>;
  FTELPN?: InputMaybe<Order_By>;
  FTEMD?: InputMaybe<Order_By>;
  FTEN?: InputMaybe<Order_By>;
  FTENH?: InputMaybe<Order_By>;
  FTEO?: InputMaybe<Order_By>;
  FTEOTH94?: InputMaybe<Order_By>;
  FTEP?: InputMaybe<Order_By>;
  FTEPH?: InputMaybe<Order_By>;
  FTEPHT?: InputMaybe<Order_By>;
  FTER?: InputMaybe<Order_By>;
  FTERAD?: InputMaybe<Order_By>;
  FTERES?: InputMaybe<Order_By>;
  FTERESP?: InputMaybe<Order_By>;
  FTERN?: InputMaybe<Order_By>;
  FTERNH?: InputMaybe<Order_By>;
  FTERNLT?: InputMaybe<Order_By>;
  FTET?: InputMaybe<Order_By>;
  FTETF?: InputMaybe<Order_By>;
  FTETRAN?: InputMaybe<Order_By>;
  FTETTRN?: InputMaybe<Order_By>;
  FTEU?: InputMaybe<Order_By>;
  FTLAB?: InputMaybe<Order_By>;
  FTLPNTF?: InputMaybe<Order_By>;
  FTMDTF?: InputMaybe<Order_By>;
  FTOTHTF?: InputMaybe<Order_By>;
  FTPHR?: InputMaybe<Order_By>;
  FTPHT?: InputMaybe<Order_By>;
  FTRAD?: InputMaybe<Order_By>;
  FTRES?: InputMaybe<Order_By>;
  FTRESP?: InputMaybe<Order_By>;
  FTRNLT?: InputMaybe<Order_By>;
  FTRNTF?: InputMaybe<Order_By>;
  FTTOT?: InputMaybe<Order_By>;
  FTTOTH?: InputMaybe<Order_By>;
  FTTOTLT?: InputMaybe<Order_By>;
  FTTRAN84?: InputMaybe<Order_By>;
  ID?: InputMaybe<Order_By>;
  INTEXA?: InputMaybe<Order_By>;
  IPDH?: InputMaybe<Order_By>;
  IPDLT?: InputMaybe<Order_By>;
  IPDTOT?: InputMaybe<Order_By>;
  LABFTE?: InputMaybe<Order_By>;
  LBEDLA?: InputMaybe<Order_By>;
  LBEDSA?: InputMaybe<Order_By>;
  MCDDC?: InputMaybe<Order_By>;
  MCDDCH?: InputMaybe<Order_By>;
  MCDDCLT?: InputMaybe<Order_By>;
  MCDIPD?: InputMaybe<Order_By>;
  MCDIPDH?: InputMaybe<Order_By>;
  MCDIPDLT?: InputMaybe<Order_By>;
  MCRDC?: InputMaybe<Order_By>;
  MCRDCH?: InputMaybe<Order_By>;
  MCRDCLT?: InputMaybe<Order_By>;
  MCRIPD?: InputMaybe<Order_By>;
  MCRIPDH?: InputMaybe<Order_By>;
  MCRIPDLT?: InputMaybe<Order_By>;
  NPAYBEN?: InputMaybe<Order_By>;
  NPAYBENH?: InputMaybe<Order_By>;
  NPAYBENL?: InputMaybe<Order_By>;
  OPDCH?: InputMaybe<Order_By>;
  OPDCLT?: InputMaybe<Order_By>;
  OPIPDH?: InputMaybe<Order_By>;
  OPIPDLT?: InputMaybe<Order_By>;
  OPOTDC?: InputMaybe<Order_By>;
  OPOTIP?: InputMaybe<Order_By>;
  OPRA?: InputMaybe<Order_By>;
  OTHEXPA?: InputMaybe<Order_By>;
  OTHPCR?: InputMaybe<Order_By>;
  PAYTOT?: InputMaybe<Order_By>;
  PAYTOTH?: InputMaybe<Order_By>;
  PAYTOTLT?: InputMaybe<Order_By>;
  PCMRES?: InputMaybe<Order_By>;
  PHAFTE?: InputMaybe<Order_By>;
  PHREXA?: InputMaybe<Order_By>;
  PTAST?: InputMaybe<Order_By>;
  PTLAB?: InputMaybe<Order_By>;
  PTLPNTF?: InputMaybe<Order_By>;
  PTMDTF?: InputMaybe<Order_By>;
  PTOTHTF?: InputMaybe<Order_By>;
  PTPHR?: InputMaybe<Order_By>;
  PTPHT?: InputMaybe<Order_By>;
  PTRAD?: InputMaybe<Order_By>;
  PTRES?: InputMaybe<Order_By>;
  PTRESP?: InputMaybe<Order_By>;
  PTRNLT?: InputMaybe<Order_By>;
  PTRNTF?: InputMaybe<Order_By>;
  PTTOT?: InputMaybe<Order_By>;
  PTTOTH?: InputMaybe<Order_By>;
  PTTOTLT?: InputMaybe<Order_By>;
  PTTRAN84?: InputMaybe<Order_By>;
  RADFTE?: InputMaybe<Order_By>;
  RTTFTE?: InputMaybe<Order_By>;
  SPDCH?: InputMaybe<Order_By>;
  SPDCLT?: InputMaybe<Order_By>;
  SPIPDH?: InputMaybe<Order_By>;
  SPIPDLT?: InputMaybe<Order_By>;
  SPTDC?: InputMaybe<Order_By>;
  SPTIP?: InputMaybe<Order_By>;
  STCD?: InputMaybe<Order_By>;
  SUPEXA?: InputMaybe<Order_By>;
  SUROPIP?: InputMaybe<Order_By>;
  SUROPOP?: InputMaybe<Order_By>;
  SUROPTOT?: InputMaybe<Order_By>;
  TECFTE?: InputMaybe<Order_By>;
  THRDCH?: InputMaybe<Order_By>;
  THRDCLT?: InputMaybe<Order_By>;
  THRIPDH?: InputMaybe<Order_By>;
  THRIPDLT?: InputMaybe<Order_By>;
  THRTDC?: InputMaybe<Order_By>;
  THRTIP?: InputMaybe<Order_By>;
  VAST?: InputMaybe<Order_By>;
  VEM?: InputMaybe<Order_By>;
  VLAB?: InputMaybe<Order_By>;
  VLPN?: InputMaybe<Order_By>;
  VMD?: InputMaybe<Order_By>;
  VOTH?: InputMaybe<Order_By>;
  VOTHL?: InputMaybe<Order_By>;
  VPHR?: InputMaybe<Order_By>;
  VPHT?: InputMaybe<Order_By>;
  VRAD?: InputMaybe<Order_By>;
  VRES?: InputMaybe<Order_By>;
  VRN?: InputMaybe<Order_By>;
  VRNH?: InputMaybe<Order_By>;
  VRSP?: InputMaybe<Order_By>;
  VTNH?: InputMaybe<Order_By>;
  VTOT?: InputMaybe<Order_By>;
  VTOTL?: InputMaybe<Order_By>;
  VTTRN?: InputMaybe<Order_By>;
};

/** primary key columns input for table: AS22UTIL */
export type As22Util_Pk_Columns_Input = {
  ID: Scalars['String'];
};

/** select columns of table "AS22UTIL" */
export enum As22Util_Select_Column {
  /** column name */
  Adc = 'ADC',
  /** column name */
  Adjadc = 'ADJADC',
  /** column name */
  Adjadch = 'ADJADCH',
  /** column name */
  Adjadm = 'ADJADM',
  /** column name */
  Adjpd = 'ADJPD',
  /** column name */
  Adjpdh = 'ADJPDH',
  /** column name */
  Admh = 'ADMH',
  /** column name */
  Admlt = 'ADMLT',
  /** column name */
  Admtot = 'ADMTOT',
  /** column name */
  Bassin = 'BASSIN',
  /** column name */
  Bdh = 'BDH',
  /** column name */
  Bdlt = 'BDLT',
  /** column name */
  Bdtot = 'BDTOT',
  /** column name */
  Births = 'BIRTHS',
  /** column name */
  Crnfte = 'CRNFTE',
  /** column name */
  Ctfte = 'CTFTE',
  /** column name */
  Dclt = 'DCLT',
  /** column name */
  Dctot = 'DCTOT',
  /** column name */
  Dctoth = 'DCTOTH',
  /** column name */
  Dpexa = 'DPEXA',
  /** column name */
  Eadmh = 'EADMH',
  /** column name */
  Eadmlt = 'EADMLT',
  /** column name */
  Eadmtot = 'EADMTOT',
  /** column name */
  Ebirths = 'EBIRTHS',
  /** column name */
  Eexptot = 'EEXPTOT',
  /** column name */
  Eftast = 'EFTAST',
  /** column name */
  Eftlab = 'EFTLAB',
  /** column name */
  Eftlpntf = 'EFTLPNTF',
  /** column name */
  Eftmdtf = 'EFTMDTF',
  /** column name */
  Eftothtf = 'EFTOTHTF',
  /** column name */
  Eftphr = 'EFTPHR',
  /** column name */
  Eftpht = 'EFTPHT',
  /** column name */
  Eftrad = 'EFTRAD',
  /** column name */
  Eftres = 'EFTRES',
  /** column name */
  Eftresp = 'EFTRESP',
  /** column name */
  Eftrntf = 'EFTRNTF',
  /** column name */
  Efttot = 'EFTTOT',
  /** column name */
  Efttoth = 'EFTTOTH',
  /** column name */
  Efttotlt = 'EFTTOTLT',
  /** column name */
  Efttrn84 = 'EFTTRN84',
  /** column name */
  Eipdh = 'EIPDH',
  /** column name */
  Eipdlt = 'EIPDLT',
  /** column name */
  Eipdtot = 'EIPDTOT',
  /** column name */
  Emcddc = 'EMCDDC',
  /** column name */
  Emcddch = 'EMCDDCH',
  /** column name */
  Emcddclt = 'EMCDDCLT',
  /** column name */
  Emcdipd = 'EMCDIPD',
  /** column name */
  Emcdipdh = 'EMCDIPDH',
  /** column name */
  Emcdpdlt = 'EMCDPDLT',
  /** column name */
  Emcrdc = 'EMCRDC',
  /** column name */
  Emcrdch = 'EMCRDCH',
  /** column name */
  Emcrdclt = 'EMCRDCLT',
  /** column name */
  Emcripd = 'EMCRIPD',
  /** column name */
  Emcripdh = 'EMCRIPDH',
  /** column name */
  Emcrpdlt = 'EMCRPDLT',
  /** column name */
  Enpayben = 'ENPAYBEN',
  /** column name */
  Enpbenlt = 'ENPBENLT',
  /** column name */
  Enpybenh = 'ENPYBENH',
  /** column name */
  Eopdch = 'EOPDCH',
  /** column name */
  Eopdclt = 'EOPDCLT',
  /** column name */
  Eopipdh = 'EOPIPDH',
  /** column name */
  Eopipdlt = 'EOPIPDLT',
  /** column name */
  Eopotdc = 'EOPOTDC',
  /** column name */
  Eopotip = 'EOPOTIP',
  /** column name */
  Epaytot = 'EPAYTOT',
  /** column name */
  Epaytoth = 'EPAYTOTH',
  /** column name */
  Eptast = 'EPTAST',
  /** column name */
  Eptlab = 'EPTLAB',
  /** column name */
  Eptlpntf = 'EPTLPNTF',
  /** column name */
  Eptmdtf = 'EPTMDTF',
  /** column name */
  Eptothtf = 'EPTOTHTF',
  /** column name */
  Eptphr = 'EPTPHR',
  /** column name */
  Eptpht = 'EPTPHT',
  /** column name */
  Eptrad = 'EPTRAD',
  /** column name */
  Eptres = 'EPTRES',
  /** column name */
  Eptresp = 'EPTRESP',
  /** column name */
  Eptrntf = 'EPTRNTF',
  /** column name */
  Epttot = 'EPTTOT',
  /** column name */
  Epttoth = 'EPTTOTH',
  /** column name */
  Epttotlt = 'EPTTOTLT',
  /** column name */
  Epttrn84 = 'EPTTRN84',
  /** column name */
  Epytotlt = 'EPYTOTLT',
  /** column name */
  Ernfte = 'ERNFTE',
  /** column name */
  Espdch = 'ESPDCH',
  /** column name */
  Espdclt = 'ESPDCLT',
  /** column name */
  Espipdh = 'ESPIPDH',
  /** column name */
  Espipdlt = 'ESPIPDLT',
  /** column name */
  Esptdc = 'ESPTDC',
  /** column name */
  Esptip = 'ESPTIP',
  /** column name */
  Esuropip = 'ESUROPIP',
  /** column name */
  Esuropop = 'ESUROPOP',
  /** column name */
  Esuropto = 'ESUROPTO',
  /** column name */
  Ethrdch = 'ETHRDCH',
  /** column name */
  Ethrdclt = 'ETHRDCLT',
  /** column name */
  Ethripdh = 'ETHRIPDH',
  /** column name */
  Ethripdlt = 'ETHRIPDLT',
  /** column name */
  Ethrtdc = 'ETHRTDC',
  /** column name */
  Ethrtip = 'ETHRTIP',
  /** column name */
  Evem = 'EVEM',
  /** column name */
  Evoth = 'EVOTH',
  /** column name */
  Evtot = 'EVTOT',
  /** column name */
  Exptha = 'EXPTHA',
  /** column name */
  Expthb = 'EXPTHB',
  /** column name */
  Exptla = 'EXPTLA',
  /** column name */
  Exptlb = 'EXPTLB',
  /** column name */
  Exptot = 'EXPTOT',
  /** column name */
  Ftast = 'FTAST',
  /** column name */
  Fte = 'FTE',
  /** column name */
  Fteap = 'FTEAP',
  /** column name */
  Ftecap = 'FTECAP',
  /** column name */
  Fteclab = 'FTECLAB',
  /** column name */
  Ftecph = 'FTECPH',
  /** column name */
  Ftecpht = 'FTECPHT',
  /** column name */
  Ftecrad = 'FTECRAD',
  /** column name */
  Ftecresp = 'FTECRESP',
  /** column name */
  Fted = 'FTED',
  /** column name */
  Fteh = 'FTEH',
  /** column name */
  Ftelab = 'FTELAB',
  /** column name */
  Ftelpn = 'FTELPN',
  /** column name */
  Ftemd = 'FTEMD',
  /** column name */
  Ften = 'FTEN',
  /** column name */
  Ftenh = 'FTENH',
  /** column name */
  Fteo = 'FTEO',
  /** column name */
  Fteoth94 = 'FTEOTH94',
  /** column name */
  Ftep = 'FTEP',
  /** column name */
  Fteph = 'FTEPH',
  /** column name */
  Ftepht = 'FTEPHT',
  /** column name */
  Fter = 'FTER',
  /** column name */
  Fterad = 'FTERAD',
  /** column name */
  Fteres = 'FTERES',
  /** column name */
  Fteresp = 'FTERESP',
  /** column name */
  Ftern = 'FTERN',
  /** column name */
  Fternh = 'FTERNH',
  /** column name */
  Fternlt = 'FTERNLT',
  /** column name */
  Ftet = 'FTET',
  /** column name */
  Ftetf = 'FTETF',
  /** column name */
  Ftetran = 'FTETRAN',
  /** column name */
  Ftettrn = 'FTETTRN',
  /** column name */
  Fteu = 'FTEU',
  /** column name */
  Ftlab = 'FTLAB',
  /** column name */
  Ftlpntf = 'FTLPNTF',
  /** column name */
  Ftmdtf = 'FTMDTF',
  /** column name */
  Ftothtf = 'FTOTHTF',
  /** column name */
  Ftphr = 'FTPHR',
  /** column name */
  Ftpht = 'FTPHT',
  /** column name */
  Ftrad = 'FTRAD',
  /** column name */
  Ftres = 'FTRES',
  /** column name */
  Ftresp = 'FTRESP',
  /** column name */
  Ftrnlt = 'FTRNLT',
  /** column name */
  Ftrntf = 'FTRNTF',
  /** column name */
  Fttot = 'FTTOT',
  /** column name */
  Fttoth = 'FTTOTH',
  /** column name */
  Fttotlt = 'FTTOTLT',
  /** column name */
  Fttran84 = 'FTTRAN84',
  /** column name */
  Id = 'ID',
  /** column name */
  Intexa = 'INTEXA',
  /** column name */
  Ipdh = 'IPDH',
  /** column name */
  Ipdlt = 'IPDLT',
  /** column name */
  Ipdtot = 'IPDTOT',
  /** column name */
  Labfte = 'LABFTE',
  /** column name */
  Lbedla = 'LBEDLA',
  /** column name */
  Lbedsa = 'LBEDSA',
  /** column name */
  Mcddc = 'MCDDC',
  /** column name */
  Mcddch = 'MCDDCH',
  /** column name */
  Mcddclt = 'MCDDCLT',
  /** column name */
  Mcdipd = 'MCDIPD',
  /** column name */
  Mcdipdh = 'MCDIPDH',
  /** column name */
  Mcdipdlt = 'MCDIPDLT',
  /** column name */
  Mcrdc = 'MCRDC',
  /** column name */
  Mcrdch = 'MCRDCH',
  /** column name */
  Mcrdclt = 'MCRDCLT',
  /** column name */
  Mcripd = 'MCRIPD',
  /** column name */
  Mcripdh = 'MCRIPDH',
  /** column name */
  Mcripdlt = 'MCRIPDLT',
  /** column name */
  Npayben = 'NPAYBEN',
  /** column name */
  Npaybenh = 'NPAYBENH',
  /** column name */
  Npaybenl = 'NPAYBENL',
  /** column name */
  Opdch = 'OPDCH',
  /** column name */
  Opdclt = 'OPDCLT',
  /** column name */
  Opipdh = 'OPIPDH',
  /** column name */
  Opipdlt = 'OPIPDLT',
  /** column name */
  Opotdc = 'OPOTDC',
  /** column name */
  Opotip = 'OPOTIP',
  /** column name */
  Opra = 'OPRA',
  /** column name */
  Othexpa = 'OTHEXPA',
  /** column name */
  Othpcr = 'OTHPCR',
  /** column name */
  Paytot = 'PAYTOT',
  /** column name */
  Paytoth = 'PAYTOTH',
  /** column name */
  Paytotlt = 'PAYTOTLT',
  /** column name */
  Pcmres = 'PCMRES',
  /** column name */
  Phafte = 'PHAFTE',
  /** column name */
  Phrexa = 'PHREXA',
  /** column name */
  Ptast = 'PTAST',
  /** column name */
  Ptlab = 'PTLAB',
  /** column name */
  Ptlpntf = 'PTLPNTF',
  /** column name */
  Ptmdtf = 'PTMDTF',
  /** column name */
  Ptothtf = 'PTOTHTF',
  /** column name */
  Ptphr = 'PTPHR',
  /** column name */
  Ptpht = 'PTPHT',
  /** column name */
  Ptrad = 'PTRAD',
  /** column name */
  Ptres = 'PTRES',
  /** column name */
  Ptresp = 'PTRESP',
  /** column name */
  Ptrnlt = 'PTRNLT',
  /** column name */
  Ptrntf = 'PTRNTF',
  /** column name */
  Pttot = 'PTTOT',
  /** column name */
  Pttoth = 'PTTOTH',
  /** column name */
  Pttotlt = 'PTTOTLT',
  /** column name */
  Pttran84 = 'PTTRAN84',
  /** column name */
  Radfte = 'RADFTE',
  /** column name */
  Rttfte = 'RTTFTE',
  /** column name */
  Spdch = 'SPDCH',
  /** column name */
  Spdclt = 'SPDCLT',
  /** column name */
  Spipdh = 'SPIPDH',
  /** column name */
  Spipdlt = 'SPIPDLT',
  /** column name */
  Sptdc = 'SPTDC',
  /** column name */
  Sptip = 'SPTIP',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Supexa = 'SUPEXA',
  /** column name */
  Suropip = 'SUROPIP',
  /** column name */
  Suropop = 'SUROPOP',
  /** column name */
  Suroptot = 'SUROPTOT',
  /** column name */
  Tecfte = 'TECFTE',
  /** column name */
  Thrdch = 'THRDCH',
  /** column name */
  Thrdclt = 'THRDCLT',
  /** column name */
  Thripdh = 'THRIPDH',
  /** column name */
  Thripdlt = 'THRIPDLT',
  /** column name */
  Thrtdc = 'THRTDC',
  /** column name */
  Thrtip = 'THRTIP',
  /** column name */
  Vast = 'VAST',
  /** column name */
  Vem = 'VEM',
  /** column name */
  Vlab = 'VLAB',
  /** column name */
  Vlpn = 'VLPN',
  /** column name */
  Vmd = 'VMD',
  /** column name */
  Voth = 'VOTH',
  /** column name */
  Vothl = 'VOTHL',
  /** column name */
  Vphr = 'VPHR',
  /** column name */
  Vpht = 'VPHT',
  /** column name */
  Vrad = 'VRAD',
  /** column name */
  Vres = 'VRES',
  /** column name */
  Vrn = 'VRN',
  /** column name */
  Vrnh = 'VRNH',
  /** column name */
  Vrsp = 'VRSP',
  /** column name */
  Vtnh = 'VTNH',
  /** column name */
  Vtot = 'VTOT',
  /** column name */
  Vtotl = 'VTOTL',
  /** column name */
  Vttrn = 'VTTRN'
}

/** input type for updating data in table "AS22UTIL" */
export type As22Util_Set_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  CRNFTE?: InputMaybe<Scalars['float8']>;
  CTFTE?: InputMaybe<Scalars['float8']>;
  DCLT?: InputMaybe<Scalars['float8']>;
  DCTOT?: InputMaybe<Scalars['float8']>;
  DCTOTH?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EOPDCH?: InputMaybe<Scalars['float8']>;
  EOPDCLT?: InputMaybe<Scalars['String']>;
  EOPIPDH?: InputMaybe<Scalars['float8']>;
  EOPIPDLT?: InputMaybe<Scalars['float8']>;
  EOPOTDC?: InputMaybe<Scalars['String']>;
  EOPOTIP?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESPDCH?: InputMaybe<Scalars['float8']>;
  ESPDCLT?: InputMaybe<Scalars['float8']>;
  ESPIPDH?: InputMaybe<Scalars['float8']>;
  ESPIPDLT?: InputMaybe<Scalars['float8']>;
  ESPTDC?: InputMaybe<Scalars['String']>;
  ESPTIP?: InputMaybe<Scalars['String']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  ETHRDCH?: InputMaybe<Scalars['float8']>;
  ETHRDCLT?: InputMaybe<Scalars['String']>;
  ETHRIPDH?: InputMaybe<Scalars['float8']>;
  ETHRIPDLT?: InputMaybe<Scalars['float8']>;
  ETHRTDC?: InputMaybe<Scalars['String']>;
  ETHRTIP?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LABFTE?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPDCH?: InputMaybe<Scalars['float8']>;
  OPDCLT?: InputMaybe<Scalars['float8']>;
  OPIPDH?: InputMaybe<Scalars['float8']>;
  OPIPDLT?: InputMaybe<Scalars['float8']>;
  OPOTDC?: InputMaybe<Scalars['float8']>;
  OPOTIP?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHAFTE?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  RADFTE?: InputMaybe<Scalars['float8']>;
  RTTFTE?: InputMaybe<Scalars['float8']>;
  SPDCH?: InputMaybe<Scalars['float8']>;
  SPDCLT?: InputMaybe<Scalars['float8']>;
  SPIPDH?: InputMaybe<Scalars['float8']>;
  SPIPDLT?: InputMaybe<Scalars['float8']>;
  SPTDC?: InputMaybe<Scalars['float8']>;
  SPTIP?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  TECFTE?: InputMaybe<Scalars['float8']>;
  THRDCH?: InputMaybe<Scalars['float8']>;
  THRDCLT?: InputMaybe<Scalars['float8']>;
  THRIPDH?: InputMaybe<Scalars['float8']>;
  THRIPDLT?: InputMaybe<Scalars['float8']>;
  THRTDC?: InputMaybe<Scalars['float8']>;
  THRTIP?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate stddev on columns */
export type As22Util_Stddev_Fields = {
  __typename?: 'AS22UTIL_stddev_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type As22Util_Stddev_Pop_Fields = {
  __typename?: 'AS22UTIL_stddev_pop_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type As22Util_Stddev_Samp_Fields = {
  __typename?: 'AS22UTIL_stddev_samp_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "AS22UTIL" */
export type As22Util_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: As22Util_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type As22Util_Stream_Cursor_Value_Input = {
  ADC?: InputMaybe<Scalars['float8']>;
  ADJADC?: InputMaybe<Scalars['float8']>;
  ADJADCH?: InputMaybe<Scalars['float8']>;
  ADJADM?: InputMaybe<Scalars['float8']>;
  ADJPD?: InputMaybe<Scalars['float8']>;
  ADJPDH?: InputMaybe<Scalars['float8']>;
  ADMH?: InputMaybe<Scalars['float8']>;
  ADMLT?: InputMaybe<Scalars['float8']>;
  ADMTOT?: InputMaybe<Scalars['float8']>;
  BASSIN?: InputMaybe<Scalars['float8']>;
  BDH?: InputMaybe<Scalars['float8']>;
  BDLT?: InputMaybe<Scalars['float8']>;
  BDTOT?: InputMaybe<Scalars['float8']>;
  BIRTHS?: InputMaybe<Scalars['float8']>;
  CRNFTE?: InputMaybe<Scalars['float8']>;
  CTFTE?: InputMaybe<Scalars['float8']>;
  DCLT?: InputMaybe<Scalars['float8']>;
  DCTOT?: InputMaybe<Scalars['float8']>;
  DCTOTH?: InputMaybe<Scalars['float8']>;
  DPEXA?: InputMaybe<Scalars['float8']>;
  EADMH?: InputMaybe<Scalars['String']>;
  EADMLT?: InputMaybe<Scalars['String']>;
  EADMTOT?: InputMaybe<Scalars['String']>;
  EBIRTHS?: InputMaybe<Scalars['String']>;
  EEXPTOT?: InputMaybe<Scalars['String']>;
  EFTAST?: InputMaybe<Scalars['String']>;
  EFTLAB?: InputMaybe<Scalars['String']>;
  EFTLPNTF?: InputMaybe<Scalars['String']>;
  EFTMDTF?: InputMaybe<Scalars['String']>;
  EFTOTHTF?: InputMaybe<Scalars['String']>;
  EFTPHR?: InputMaybe<Scalars['String']>;
  EFTPHT?: InputMaybe<Scalars['String']>;
  EFTRAD?: InputMaybe<Scalars['String']>;
  EFTRES?: InputMaybe<Scalars['String']>;
  EFTRESP?: InputMaybe<Scalars['String']>;
  EFTRNTF?: InputMaybe<Scalars['String']>;
  EFTTOT?: InputMaybe<Scalars['String']>;
  EFTTOTH?: InputMaybe<Scalars['String']>;
  EFTTOTLT?: InputMaybe<Scalars['String']>;
  EFTTRN84?: InputMaybe<Scalars['String']>;
  EIPDH?: InputMaybe<Scalars['String']>;
  EIPDLT?: InputMaybe<Scalars['String']>;
  EIPDTOT?: InputMaybe<Scalars['String']>;
  EMCDDC?: InputMaybe<Scalars['String']>;
  EMCDDCH?: InputMaybe<Scalars['String']>;
  EMCDDCLT?: InputMaybe<Scalars['String']>;
  EMCDIPD?: InputMaybe<Scalars['String']>;
  EMCDIPDH?: InputMaybe<Scalars['String']>;
  EMCDPDLT?: InputMaybe<Scalars['String']>;
  EMCRDC?: InputMaybe<Scalars['String']>;
  EMCRDCH?: InputMaybe<Scalars['String']>;
  EMCRDCLT?: InputMaybe<Scalars['String']>;
  EMCRIPD?: InputMaybe<Scalars['String']>;
  EMCRIPDH?: InputMaybe<Scalars['String']>;
  EMCRPDLT?: InputMaybe<Scalars['String']>;
  ENPAYBEN?: InputMaybe<Scalars['String']>;
  ENPBENLT?: InputMaybe<Scalars['String']>;
  ENPYBENH?: InputMaybe<Scalars['String']>;
  EOPDCH?: InputMaybe<Scalars['float8']>;
  EOPDCLT?: InputMaybe<Scalars['String']>;
  EOPIPDH?: InputMaybe<Scalars['float8']>;
  EOPIPDLT?: InputMaybe<Scalars['float8']>;
  EOPOTDC?: InputMaybe<Scalars['String']>;
  EOPOTIP?: InputMaybe<Scalars['String']>;
  EPAYTOT?: InputMaybe<Scalars['String']>;
  EPAYTOTH?: InputMaybe<Scalars['String']>;
  EPTAST?: InputMaybe<Scalars['String']>;
  EPTLAB?: InputMaybe<Scalars['String']>;
  EPTLPNTF?: InputMaybe<Scalars['String']>;
  EPTMDTF?: InputMaybe<Scalars['String']>;
  EPTOTHTF?: InputMaybe<Scalars['String']>;
  EPTPHR?: InputMaybe<Scalars['String']>;
  EPTPHT?: InputMaybe<Scalars['String']>;
  EPTRAD?: InputMaybe<Scalars['String']>;
  EPTRES?: InputMaybe<Scalars['String']>;
  EPTRESP?: InputMaybe<Scalars['String']>;
  EPTRNTF?: InputMaybe<Scalars['String']>;
  EPTTOT?: InputMaybe<Scalars['String']>;
  EPTTOTH?: InputMaybe<Scalars['String']>;
  EPTTOTLT?: InputMaybe<Scalars['String']>;
  EPTTRN84?: InputMaybe<Scalars['String']>;
  EPYTOTLT?: InputMaybe<Scalars['String']>;
  ERNFTE?: InputMaybe<Scalars['float8']>;
  ESPDCH?: InputMaybe<Scalars['float8']>;
  ESPDCLT?: InputMaybe<Scalars['float8']>;
  ESPIPDH?: InputMaybe<Scalars['float8']>;
  ESPIPDLT?: InputMaybe<Scalars['float8']>;
  ESPTDC?: InputMaybe<Scalars['String']>;
  ESPTIP?: InputMaybe<Scalars['String']>;
  ESUROPIP?: InputMaybe<Scalars['String']>;
  ESUROPOP?: InputMaybe<Scalars['String']>;
  ESUROPTO?: InputMaybe<Scalars['String']>;
  ETHRDCH?: InputMaybe<Scalars['float8']>;
  ETHRDCLT?: InputMaybe<Scalars['String']>;
  ETHRIPDH?: InputMaybe<Scalars['float8']>;
  ETHRIPDLT?: InputMaybe<Scalars['float8']>;
  ETHRTDC?: InputMaybe<Scalars['String']>;
  ETHRTIP?: InputMaybe<Scalars['String']>;
  EVEM?: InputMaybe<Scalars['String']>;
  EVOTH?: InputMaybe<Scalars['String']>;
  EVTOT?: InputMaybe<Scalars['String']>;
  EXPTHA?: InputMaybe<Scalars['float8']>;
  EXPTHB?: InputMaybe<Scalars['String']>;
  EXPTLA?: InputMaybe<Scalars['float8']>;
  EXPTLB?: InputMaybe<Scalars['String']>;
  EXPTOT?: InputMaybe<Scalars['float8']>;
  FTAST?: InputMaybe<Scalars['float8']>;
  FTE?: InputMaybe<Scalars['float8']>;
  FTEAP?: InputMaybe<Scalars['float8']>;
  FTECAP?: InputMaybe<Scalars['float8']>;
  FTECLAB?: InputMaybe<Scalars['float8']>;
  FTECPH?: InputMaybe<Scalars['float8']>;
  FTECPHT?: InputMaybe<Scalars['float8']>;
  FTECRAD?: InputMaybe<Scalars['float8']>;
  FTECRESP?: InputMaybe<Scalars['float8']>;
  FTED?: InputMaybe<Scalars['float8']>;
  FTEH?: InputMaybe<Scalars['float8']>;
  FTELAB?: InputMaybe<Scalars['float8']>;
  FTELPN?: InputMaybe<Scalars['float8']>;
  FTEMD?: InputMaybe<Scalars['float8']>;
  FTEN?: InputMaybe<Scalars['float8']>;
  FTENH?: InputMaybe<Scalars['float8']>;
  FTEO?: InputMaybe<Scalars['float8']>;
  FTEOTH94?: InputMaybe<Scalars['float8']>;
  FTEP?: InputMaybe<Scalars['float8']>;
  FTEPH?: InputMaybe<Scalars['float8']>;
  FTEPHT?: InputMaybe<Scalars['float8']>;
  FTER?: InputMaybe<Scalars['float8']>;
  FTERAD?: InputMaybe<Scalars['float8']>;
  FTERES?: InputMaybe<Scalars['float8']>;
  FTERESP?: InputMaybe<Scalars['float8']>;
  FTERN?: InputMaybe<Scalars['float8']>;
  FTERNH?: InputMaybe<Scalars['float8']>;
  FTERNLT?: InputMaybe<Scalars['float8']>;
  FTET?: InputMaybe<Scalars['float8']>;
  FTETF?: InputMaybe<Scalars['float8']>;
  FTETRAN?: InputMaybe<Scalars['float8']>;
  FTETTRN?: InputMaybe<Scalars['float8']>;
  FTEU?: InputMaybe<Scalars['float8']>;
  FTLAB?: InputMaybe<Scalars['float8']>;
  FTLPNTF?: InputMaybe<Scalars['float8']>;
  FTMDTF?: InputMaybe<Scalars['float8']>;
  FTOTHTF?: InputMaybe<Scalars['float8']>;
  FTPHR?: InputMaybe<Scalars['float8']>;
  FTPHT?: InputMaybe<Scalars['float8']>;
  FTRAD?: InputMaybe<Scalars['float8']>;
  FTRES?: InputMaybe<Scalars['float8']>;
  FTRESP?: InputMaybe<Scalars['float8']>;
  FTRNLT?: InputMaybe<Scalars['float8']>;
  FTRNTF?: InputMaybe<Scalars['float8']>;
  FTTOT?: InputMaybe<Scalars['float8']>;
  FTTOTH?: InputMaybe<Scalars['float8']>;
  FTTOTLT?: InputMaybe<Scalars['float8']>;
  FTTRAN84?: InputMaybe<Scalars['float8']>;
  ID?: InputMaybe<Scalars['String']>;
  INTEXA?: InputMaybe<Scalars['float8']>;
  IPDH?: InputMaybe<Scalars['float8']>;
  IPDLT?: InputMaybe<Scalars['float8']>;
  IPDTOT?: InputMaybe<Scalars['float8']>;
  LABFTE?: InputMaybe<Scalars['float8']>;
  LBEDLA?: InputMaybe<Scalars['float8']>;
  LBEDSA?: InputMaybe<Scalars['float8']>;
  MCDDC?: InputMaybe<Scalars['float8']>;
  MCDDCH?: InputMaybe<Scalars['float8']>;
  MCDDCLT?: InputMaybe<Scalars['float8']>;
  MCDIPD?: InputMaybe<Scalars['float8']>;
  MCDIPDH?: InputMaybe<Scalars['float8']>;
  MCDIPDLT?: InputMaybe<Scalars['float8']>;
  MCRDC?: InputMaybe<Scalars['float8']>;
  MCRDCH?: InputMaybe<Scalars['float8']>;
  MCRDCLT?: InputMaybe<Scalars['float8']>;
  MCRIPD?: InputMaybe<Scalars['float8']>;
  MCRIPDH?: InputMaybe<Scalars['float8']>;
  MCRIPDLT?: InputMaybe<Scalars['float8']>;
  NPAYBEN?: InputMaybe<Scalars['float8']>;
  NPAYBENH?: InputMaybe<Scalars['float8']>;
  NPAYBENL?: InputMaybe<Scalars['float8']>;
  OPDCH?: InputMaybe<Scalars['float8']>;
  OPDCLT?: InputMaybe<Scalars['float8']>;
  OPIPDH?: InputMaybe<Scalars['float8']>;
  OPIPDLT?: InputMaybe<Scalars['float8']>;
  OPOTDC?: InputMaybe<Scalars['float8']>;
  OPOTIP?: InputMaybe<Scalars['float8']>;
  OPRA?: InputMaybe<Scalars['float8']>;
  OTHEXPA?: InputMaybe<Scalars['float8']>;
  OTHPCR?: InputMaybe<Scalars['float8']>;
  PAYTOT?: InputMaybe<Scalars['float8']>;
  PAYTOTH?: InputMaybe<Scalars['float8']>;
  PAYTOTLT?: InputMaybe<Scalars['float8']>;
  PCMRES?: InputMaybe<Scalars['float8']>;
  PHAFTE?: InputMaybe<Scalars['float8']>;
  PHREXA?: InputMaybe<Scalars['float8']>;
  PTAST?: InputMaybe<Scalars['float8']>;
  PTLAB?: InputMaybe<Scalars['float8']>;
  PTLPNTF?: InputMaybe<Scalars['float8']>;
  PTMDTF?: InputMaybe<Scalars['float8']>;
  PTOTHTF?: InputMaybe<Scalars['float8']>;
  PTPHR?: InputMaybe<Scalars['float8']>;
  PTPHT?: InputMaybe<Scalars['float8']>;
  PTRAD?: InputMaybe<Scalars['float8']>;
  PTRES?: InputMaybe<Scalars['float8']>;
  PTRESP?: InputMaybe<Scalars['float8']>;
  PTRNLT?: InputMaybe<Scalars['float8']>;
  PTRNTF?: InputMaybe<Scalars['float8']>;
  PTTOT?: InputMaybe<Scalars['float8']>;
  PTTOTH?: InputMaybe<Scalars['float8']>;
  PTTOTLT?: InputMaybe<Scalars['float8']>;
  PTTRAN84?: InputMaybe<Scalars['float8']>;
  RADFTE?: InputMaybe<Scalars['float8']>;
  RTTFTE?: InputMaybe<Scalars['float8']>;
  SPDCH?: InputMaybe<Scalars['float8']>;
  SPDCLT?: InputMaybe<Scalars['float8']>;
  SPIPDH?: InputMaybe<Scalars['float8']>;
  SPIPDLT?: InputMaybe<Scalars['float8']>;
  SPTDC?: InputMaybe<Scalars['float8']>;
  SPTIP?: InputMaybe<Scalars['float8']>;
  STCD?: InputMaybe<Scalars['String']>;
  SUPEXA?: InputMaybe<Scalars['float8']>;
  SUROPIP?: InputMaybe<Scalars['float8']>;
  SUROPOP?: InputMaybe<Scalars['float8']>;
  SUROPTOT?: InputMaybe<Scalars['float8']>;
  TECFTE?: InputMaybe<Scalars['float8']>;
  THRDCH?: InputMaybe<Scalars['float8']>;
  THRDCLT?: InputMaybe<Scalars['float8']>;
  THRIPDH?: InputMaybe<Scalars['float8']>;
  THRIPDLT?: InputMaybe<Scalars['float8']>;
  THRTDC?: InputMaybe<Scalars['float8']>;
  THRTIP?: InputMaybe<Scalars['float8']>;
  VAST?: InputMaybe<Scalars['float8']>;
  VEM?: InputMaybe<Scalars['float8']>;
  VLAB?: InputMaybe<Scalars['float8']>;
  VLPN?: InputMaybe<Scalars['float8']>;
  VMD?: InputMaybe<Scalars['float8']>;
  VOTH?: InputMaybe<Scalars['float8']>;
  VOTHL?: InputMaybe<Scalars['float8']>;
  VPHR?: InputMaybe<Scalars['float8']>;
  VPHT?: InputMaybe<Scalars['float8']>;
  VRAD?: InputMaybe<Scalars['float8']>;
  VRES?: InputMaybe<Scalars['float8']>;
  VRN?: InputMaybe<Scalars['float8']>;
  VRNH?: InputMaybe<Scalars['float8']>;
  VRSP?: InputMaybe<Scalars['float8']>;
  VTNH?: InputMaybe<Scalars['float8']>;
  VTOT?: InputMaybe<Scalars['float8']>;
  VTOTL?: InputMaybe<Scalars['float8']>;
  VTTRN?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type As22Util_Sum_Fields = {
  __typename?: 'AS22UTIL_sum_fields';
  ADC: Maybe<Scalars['float8']>;
  ADJADC: Maybe<Scalars['float8']>;
  ADJADCH: Maybe<Scalars['float8']>;
  ADJADM: Maybe<Scalars['float8']>;
  ADJPD: Maybe<Scalars['float8']>;
  ADJPDH: Maybe<Scalars['float8']>;
  ADMH: Maybe<Scalars['float8']>;
  ADMLT: Maybe<Scalars['float8']>;
  ADMTOT: Maybe<Scalars['float8']>;
  BASSIN: Maybe<Scalars['float8']>;
  BDH: Maybe<Scalars['float8']>;
  BDLT: Maybe<Scalars['float8']>;
  BDTOT: Maybe<Scalars['float8']>;
  BIRTHS: Maybe<Scalars['float8']>;
  CRNFTE: Maybe<Scalars['float8']>;
  CTFTE: Maybe<Scalars['float8']>;
  DCLT: Maybe<Scalars['float8']>;
  DCTOT: Maybe<Scalars['float8']>;
  DCTOTH: Maybe<Scalars['float8']>;
  DPEXA: Maybe<Scalars['float8']>;
  EOPDCH: Maybe<Scalars['float8']>;
  EOPIPDH: Maybe<Scalars['float8']>;
  EOPIPDLT: Maybe<Scalars['float8']>;
  ERNFTE: Maybe<Scalars['float8']>;
  ESPDCH: Maybe<Scalars['float8']>;
  ESPDCLT: Maybe<Scalars['float8']>;
  ESPIPDH: Maybe<Scalars['float8']>;
  ESPIPDLT: Maybe<Scalars['float8']>;
  ETHRDCH: Maybe<Scalars['float8']>;
  ETHRIPDH: Maybe<Scalars['float8']>;
  ETHRIPDLT: Maybe<Scalars['float8']>;
  EXPTHA: Maybe<Scalars['float8']>;
  EXPTLA: Maybe<Scalars['float8']>;
  EXPTOT: Maybe<Scalars['float8']>;
  FTAST: Maybe<Scalars['float8']>;
  FTE: Maybe<Scalars['float8']>;
  FTEAP: Maybe<Scalars['float8']>;
  FTECAP: Maybe<Scalars['float8']>;
  FTECLAB: Maybe<Scalars['float8']>;
  FTECPH: Maybe<Scalars['float8']>;
  FTECPHT: Maybe<Scalars['float8']>;
  FTECRAD: Maybe<Scalars['float8']>;
  FTECRESP: Maybe<Scalars['float8']>;
  FTED: Maybe<Scalars['float8']>;
  FTEH: Maybe<Scalars['float8']>;
  FTELAB: Maybe<Scalars['float8']>;
  FTELPN: Maybe<Scalars['float8']>;
  FTEMD: Maybe<Scalars['float8']>;
  FTEN: Maybe<Scalars['float8']>;
  FTENH: Maybe<Scalars['float8']>;
  FTEO: Maybe<Scalars['float8']>;
  FTEOTH94: Maybe<Scalars['float8']>;
  FTEP: Maybe<Scalars['float8']>;
  FTEPH: Maybe<Scalars['float8']>;
  FTEPHT: Maybe<Scalars['float8']>;
  FTER: Maybe<Scalars['float8']>;
  FTERAD: Maybe<Scalars['float8']>;
  FTERES: Maybe<Scalars['float8']>;
  FTERESP: Maybe<Scalars['float8']>;
  FTERN: Maybe<Scalars['float8']>;
  FTERNH: Maybe<Scalars['float8']>;
  FTERNLT: Maybe<Scalars['float8']>;
  FTET: Maybe<Scalars['float8']>;
  FTETF: Maybe<Scalars['float8']>;
  FTETRAN: Maybe<Scalars['float8']>;
  FTETTRN: Maybe<Scalars['float8']>;
  FTEU: Maybe<Scalars['float8']>;
  FTLAB: Maybe<Scalars['float8']>;
  FTLPNTF: Maybe<Scalars['float8']>;
  FTMDTF: Maybe<Scalars['float8']>;
  FTOTHTF: Maybe<Scalars['float8']>;
  FTPHR: Maybe<Scalars['float8']>;
  FTPHT: Maybe<Scalars['float8']>;
  FTRAD: Maybe<Scalars['float8']>;
  FTRES: Maybe<Scalars['float8']>;
  FTRESP: Maybe<Scalars['float8']>;
  FTRNLT: Maybe<Scalars['float8']>;
  FTRNTF: Maybe<Scalars['float8']>;
  FTTOT: Maybe<Scalars['float8']>;
  FTTOTH: Maybe<Scalars['float8']>;
  FTTOTLT: Maybe<Scalars['float8']>;
  FTTRAN84: Maybe<Scalars['float8']>;
  INTEXA: Maybe<Scalars['float8']>;
  IPDH: Maybe<Scalars['float8']>;
  IPDLT: Maybe<Scalars['float8']>;
  IPDTOT: Maybe<Scalars['float8']>;
  LABFTE: Maybe<Scalars['float8']>;
  LBEDLA: Maybe<Scalars['float8']>;
  LBEDSA: Maybe<Scalars['float8']>;
  MCDDC: Maybe<Scalars['float8']>;
  MCDDCH: Maybe<Scalars['float8']>;
  MCDDCLT: Maybe<Scalars['float8']>;
  MCDIPD: Maybe<Scalars['float8']>;
  MCDIPDH: Maybe<Scalars['float8']>;
  MCDIPDLT: Maybe<Scalars['float8']>;
  MCRDC: Maybe<Scalars['float8']>;
  MCRDCH: Maybe<Scalars['float8']>;
  MCRDCLT: Maybe<Scalars['float8']>;
  MCRIPD: Maybe<Scalars['float8']>;
  MCRIPDH: Maybe<Scalars['float8']>;
  MCRIPDLT: Maybe<Scalars['float8']>;
  NPAYBEN: Maybe<Scalars['float8']>;
  NPAYBENH: Maybe<Scalars['float8']>;
  NPAYBENL: Maybe<Scalars['float8']>;
  OPDCH: Maybe<Scalars['float8']>;
  OPDCLT: Maybe<Scalars['float8']>;
  OPIPDH: Maybe<Scalars['float8']>;
  OPIPDLT: Maybe<Scalars['float8']>;
  OPOTDC: Maybe<Scalars['float8']>;
  OPOTIP: Maybe<Scalars['float8']>;
  OPRA: Maybe<Scalars['float8']>;
  OTHEXPA: Maybe<Scalars['float8']>;
  OTHPCR: Maybe<Scalars['float8']>;
  PAYTOT: Maybe<Scalars['float8']>;
  PAYTOTH: Maybe<Scalars['float8']>;
  PAYTOTLT: Maybe<Scalars['float8']>;
  PCMRES: Maybe<Scalars['float8']>;
  PHAFTE: Maybe<Scalars['float8']>;
  PHREXA: Maybe<Scalars['float8']>;
  PTAST: Maybe<Scalars['float8']>;
  PTLAB: Maybe<Scalars['float8']>;
  PTLPNTF: Maybe<Scalars['float8']>;
  PTMDTF: Maybe<Scalars['float8']>;
  PTOTHTF: Maybe<Scalars['float8']>;
  PTPHR: Maybe<Scalars['float8']>;
  PTPHT: Maybe<Scalars['float8']>;
  PTRAD: Maybe<Scalars['float8']>;
  PTRES: Maybe<Scalars['float8']>;
  PTRESP: Maybe<Scalars['float8']>;
  PTRNLT: Maybe<Scalars['float8']>;
  PTRNTF: Maybe<Scalars['float8']>;
  PTTOT: Maybe<Scalars['float8']>;
  PTTOTH: Maybe<Scalars['float8']>;
  PTTOTLT: Maybe<Scalars['float8']>;
  PTTRAN84: Maybe<Scalars['float8']>;
  RADFTE: Maybe<Scalars['float8']>;
  RTTFTE: Maybe<Scalars['float8']>;
  SPDCH: Maybe<Scalars['float8']>;
  SPDCLT: Maybe<Scalars['float8']>;
  SPIPDH: Maybe<Scalars['float8']>;
  SPIPDLT: Maybe<Scalars['float8']>;
  SPTDC: Maybe<Scalars['float8']>;
  SPTIP: Maybe<Scalars['float8']>;
  SUPEXA: Maybe<Scalars['float8']>;
  SUROPIP: Maybe<Scalars['float8']>;
  SUROPOP: Maybe<Scalars['float8']>;
  SUROPTOT: Maybe<Scalars['float8']>;
  TECFTE: Maybe<Scalars['float8']>;
  THRDCH: Maybe<Scalars['float8']>;
  THRDCLT: Maybe<Scalars['float8']>;
  THRIPDH: Maybe<Scalars['float8']>;
  THRIPDLT: Maybe<Scalars['float8']>;
  THRTDC: Maybe<Scalars['float8']>;
  THRTIP: Maybe<Scalars['float8']>;
  VAST: Maybe<Scalars['float8']>;
  VEM: Maybe<Scalars['float8']>;
  VLAB: Maybe<Scalars['float8']>;
  VLPN: Maybe<Scalars['float8']>;
  VMD: Maybe<Scalars['float8']>;
  VOTH: Maybe<Scalars['float8']>;
  VOTHL: Maybe<Scalars['float8']>;
  VPHR: Maybe<Scalars['float8']>;
  VPHT: Maybe<Scalars['float8']>;
  VRAD: Maybe<Scalars['float8']>;
  VRES: Maybe<Scalars['float8']>;
  VRN: Maybe<Scalars['float8']>;
  VRNH: Maybe<Scalars['float8']>;
  VRSP: Maybe<Scalars['float8']>;
  VTNH: Maybe<Scalars['float8']>;
  VTOT: Maybe<Scalars['float8']>;
  VTOTL: Maybe<Scalars['float8']>;
  VTTRN: Maybe<Scalars['float8']>;
};

/** update columns of table "AS22UTIL" */
export enum As22Util_Update_Column {
  /** column name */
  Adc = 'ADC',
  /** column name */
  Adjadc = 'ADJADC',
  /** column name */
  Adjadch = 'ADJADCH',
  /** column name */
  Adjadm = 'ADJADM',
  /** column name */
  Adjpd = 'ADJPD',
  /** column name */
  Adjpdh = 'ADJPDH',
  /** column name */
  Admh = 'ADMH',
  /** column name */
  Admlt = 'ADMLT',
  /** column name */
  Admtot = 'ADMTOT',
  /** column name */
  Bassin = 'BASSIN',
  /** column name */
  Bdh = 'BDH',
  /** column name */
  Bdlt = 'BDLT',
  /** column name */
  Bdtot = 'BDTOT',
  /** column name */
  Births = 'BIRTHS',
  /** column name */
  Crnfte = 'CRNFTE',
  /** column name */
  Ctfte = 'CTFTE',
  /** column name */
  Dclt = 'DCLT',
  /** column name */
  Dctot = 'DCTOT',
  /** column name */
  Dctoth = 'DCTOTH',
  /** column name */
  Dpexa = 'DPEXA',
  /** column name */
  Eadmh = 'EADMH',
  /** column name */
  Eadmlt = 'EADMLT',
  /** column name */
  Eadmtot = 'EADMTOT',
  /** column name */
  Ebirths = 'EBIRTHS',
  /** column name */
  Eexptot = 'EEXPTOT',
  /** column name */
  Eftast = 'EFTAST',
  /** column name */
  Eftlab = 'EFTLAB',
  /** column name */
  Eftlpntf = 'EFTLPNTF',
  /** column name */
  Eftmdtf = 'EFTMDTF',
  /** column name */
  Eftothtf = 'EFTOTHTF',
  /** column name */
  Eftphr = 'EFTPHR',
  /** column name */
  Eftpht = 'EFTPHT',
  /** column name */
  Eftrad = 'EFTRAD',
  /** column name */
  Eftres = 'EFTRES',
  /** column name */
  Eftresp = 'EFTRESP',
  /** column name */
  Eftrntf = 'EFTRNTF',
  /** column name */
  Efttot = 'EFTTOT',
  /** column name */
  Efttoth = 'EFTTOTH',
  /** column name */
  Efttotlt = 'EFTTOTLT',
  /** column name */
  Efttrn84 = 'EFTTRN84',
  /** column name */
  Eipdh = 'EIPDH',
  /** column name */
  Eipdlt = 'EIPDLT',
  /** column name */
  Eipdtot = 'EIPDTOT',
  /** column name */
  Emcddc = 'EMCDDC',
  /** column name */
  Emcddch = 'EMCDDCH',
  /** column name */
  Emcddclt = 'EMCDDCLT',
  /** column name */
  Emcdipd = 'EMCDIPD',
  /** column name */
  Emcdipdh = 'EMCDIPDH',
  /** column name */
  Emcdpdlt = 'EMCDPDLT',
  /** column name */
  Emcrdc = 'EMCRDC',
  /** column name */
  Emcrdch = 'EMCRDCH',
  /** column name */
  Emcrdclt = 'EMCRDCLT',
  /** column name */
  Emcripd = 'EMCRIPD',
  /** column name */
  Emcripdh = 'EMCRIPDH',
  /** column name */
  Emcrpdlt = 'EMCRPDLT',
  /** column name */
  Enpayben = 'ENPAYBEN',
  /** column name */
  Enpbenlt = 'ENPBENLT',
  /** column name */
  Enpybenh = 'ENPYBENH',
  /** column name */
  Eopdch = 'EOPDCH',
  /** column name */
  Eopdclt = 'EOPDCLT',
  /** column name */
  Eopipdh = 'EOPIPDH',
  /** column name */
  Eopipdlt = 'EOPIPDLT',
  /** column name */
  Eopotdc = 'EOPOTDC',
  /** column name */
  Eopotip = 'EOPOTIP',
  /** column name */
  Epaytot = 'EPAYTOT',
  /** column name */
  Epaytoth = 'EPAYTOTH',
  /** column name */
  Eptast = 'EPTAST',
  /** column name */
  Eptlab = 'EPTLAB',
  /** column name */
  Eptlpntf = 'EPTLPNTF',
  /** column name */
  Eptmdtf = 'EPTMDTF',
  /** column name */
  Eptothtf = 'EPTOTHTF',
  /** column name */
  Eptphr = 'EPTPHR',
  /** column name */
  Eptpht = 'EPTPHT',
  /** column name */
  Eptrad = 'EPTRAD',
  /** column name */
  Eptres = 'EPTRES',
  /** column name */
  Eptresp = 'EPTRESP',
  /** column name */
  Eptrntf = 'EPTRNTF',
  /** column name */
  Epttot = 'EPTTOT',
  /** column name */
  Epttoth = 'EPTTOTH',
  /** column name */
  Epttotlt = 'EPTTOTLT',
  /** column name */
  Epttrn84 = 'EPTTRN84',
  /** column name */
  Epytotlt = 'EPYTOTLT',
  /** column name */
  Ernfte = 'ERNFTE',
  /** column name */
  Espdch = 'ESPDCH',
  /** column name */
  Espdclt = 'ESPDCLT',
  /** column name */
  Espipdh = 'ESPIPDH',
  /** column name */
  Espipdlt = 'ESPIPDLT',
  /** column name */
  Esptdc = 'ESPTDC',
  /** column name */
  Esptip = 'ESPTIP',
  /** column name */
  Esuropip = 'ESUROPIP',
  /** column name */
  Esuropop = 'ESUROPOP',
  /** column name */
  Esuropto = 'ESUROPTO',
  /** column name */
  Ethrdch = 'ETHRDCH',
  /** column name */
  Ethrdclt = 'ETHRDCLT',
  /** column name */
  Ethripdh = 'ETHRIPDH',
  /** column name */
  Ethripdlt = 'ETHRIPDLT',
  /** column name */
  Ethrtdc = 'ETHRTDC',
  /** column name */
  Ethrtip = 'ETHRTIP',
  /** column name */
  Evem = 'EVEM',
  /** column name */
  Evoth = 'EVOTH',
  /** column name */
  Evtot = 'EVTOT',
  /** column name */
  Exptha = 'EXPTHA',
  /** column name */
  Expthb = 'EXPTHB',
  /** column name */
  Exptla = 'EXPTLA',
  /** column name */
  Exptlb = 'EXPTLB',
  /** column name */
  Exptot = 'EXPTOT',
  /** column name */
  Ftast = 'FTAST',
  /** column name */
  Fte = 'FTE',
  /** column name */
  Fteap = 'FTEAP',
  /** column name */
  Ftecap = 'FTECAP',
  /** column name */
  Fteclab = 'FTECLAB',
  /** column name */
  Ftecph = 'FTECPH',
  /** column name */
  Ftecpht = 'FTECPHT',
  /** column name */
  Ftecrad = 'FTECRAD',
  /** column name */
  Ftecresp = 'FTECRESP',
  /** column name */
  Fted = 'FTED',
  /** column name */
  Fteh = 'FTEH',
  /** column name */
  Ftelab = 'FTELAB',
  /** column name */
  Ftelpn = 'FTELPN',
  /** column name */
  Ftemd = 'FTEMD',
  /** column name */
  Ften = 'FTEN',
  /** column name */
  Ftenh = 'FTENH',
  /** column name */
  Fteo = 'FTEO',
  /** column name */
  Fteoth94 = 'FTEOTH94',
  /** column name */
  Ftep = 'FTEP',
  /** column name */
  Fteph = 'FTEPH',
  /** column name */
  Ftepht = 'FTEPHT',
  /** column name */
  Fter = 'FTER',
  /** column name */
  Fterad = 'FTERAD',
  /** column name */
  Fteres = 'FTERES',
  /** column name */
  Fteresp = 'FTERESP',
  /** column name */
  Ftern = 'FTERN',
  /** column name */
  Fternh = 'FTERNH',
  /** column name */
  Fternlt = 'FTERNLT',
  /** column name */
  Ftet = 'FTET',
  /** column name */
  Ftetf = 'FTETF',
  /** column name */
  Ftetran = 'FTETRAN',
  /** column name */
  Ftettrn = 'FTETTRN',
  /** column name */
  Fteu = 'FTEU',
  /** column name */
  Ftlab = 'FTLAB',
  /** column name */
  Ftlpntf = 'FTLPNTF',
  /** column name */
  Ftmdtf = 'FTMDTF',
  /** column name */
  Ftothtf = 'FTOTHTF',
  /** column name */
  Ftphr = 'FTPHR',
  /** column name */
  Ftpht = 'FTPHT',
  /** column name */
  Ftrad = 'FTRAD',
  /** column name */
  Ftres = 'FTRES',
  /** column name */
  Ftresp = 'FTRESP',
  /** column name */
  Ftrnlt = 'FTRNLT',
  /** column name */
  Ftrntf = 'FTRNTF',
  /** column name */
  Fttot = 'FTTOT',
  /** column name */
  Fttoth = 'FTTOTH',
  /** column name */
  Fttotlt = 'FTTOTLT',
  /** column name */
  Fttran84 = 'FTTRAN84',
  /** column name */
  Id = 'ID',
  /** column name */
  Intexa = 'INTEXA',
  /** column name */
  Ipdh = 'IPDH',
  /** column name */
  Ipdlt = 'IPDLT',
  /** column name */
  Ipdtot = 'IPDTOT',
  /** column name */
  Labfte = 'LABFTE',
  /** column name */
  Lbedla = 'LBEDLA',
  /** column name */
  Lbedsa = 'LBEDSA',
  /** column name */
  Mcddc = 'MCDDC',
  /** column name */
  Mcddch = 'MCDDCH',
  /** column name */
  Mcddclt = 'MCDDCLT',
  /** column name */
  Mcdipd = 'MCDIPD',
  /** column name */
  Mcdipdh = 'MCDIPDH',
  /** column name */
  Mcdipdlt = 'MCDIPDLT',
  /** column name */
  Mcrdc = 'MCRDC',
  /** column name */
  Mcrdch = 'MCRDCH',
  /** column name */
  Mcrdclt = 'MCRDCLT',
  /** column name */
  Mcripd = 'MCRIPD',
  /** column name */
  Mcripdh = 'MCRIPDH',
  /** column name */
  Mcripdlt = 'MCRIPDLT',
  /** column name */
  Npayben = 'NPAYBEN',
  /** column name */
  Npaybenh = 'NPAYBENH',
  /** column name */
  Npaybenl = 'NPAYBENL',
  /** column name */
  Opdch = 'OPDCH',
  /** column name */
  Opdclt = 'OPDCLT',
  /** column name */
  Opipdh = 'OPIPDH',
  /** column name */
  Opipdlt = 'OPIPDLT',
  /** column name */
  Opotdc = 'OPOTDC',
  /** column name */
  Opotip = 'OPOTIP',
  /** column name */
  Opra = 'OPRA',
  /** column name */
  Othexpa = 'OTHEXPA',
  /** column name */
  Othpcr = 'OTHPCR',
  /** column name */
  Paytot = 'PAYTOT',
  /** column name */
  Paytoth = 'PAYTOTH',
  /** column name */
  Paytotlt = 'PAYTOTLT',
  /** column name */
  Pcmres = 'PCMRES',
  /** column name */
  Phafte = 'PHAFTE',
  /** column name */
  Phrexa = 'PHREXA',
  /** column name */
  Ptast = 'PTAST',
  /** column name */
  Ptlab = 'PTLAB',
  /** column name */
  Ptlpntf = 'PTLPNTF',
  /** column name */
  Ptmdtf = 'PTMDTF',
  /** column name */
  Ptothtf = 'PTOTHTF',
  /** column name */
  Ptphr = 'PTPHR',
  /** column name */
  Ptpht = 'PTPHT',
  /** column name */
  Ptrad = 'PTRAD',
  /** column name */
  Ptres = 'PTRES',
  /** column name */
  Ptresp = 'PTRESP',
  /** column name */
  Ptrnlt = 'PTRNLT',
  /** column name */
  Ptrntf = 'PTRNTF',
  /** column name */
  Pttot = 'PTTOT',
  /** column name */
  Pttoth = 'PTTOTH',
  /** column name */
  Pttotlt = 'PTTOTLT',
  /** column name */
  Pttran84 = 'PTTRAN84',
  /** column name */
  Radfte = 'RADFTE',
  /** column name */
  Rttfte = 'RTTFTE',
  /** column name */
  Spdch = 'SPDCH',
  /** column name */
  Spdclt = 'SPDCLT',
  /** column name */
  Spipdh = 'SPIPDH',
  /** column name */
  Spipdlt = 'SPIPDLT',
  /** column name */
  Sptdc = 'SPTDC',
  /** column name */
  Sptip = 'SPTIP',
  /** column name */
  Stcd = 'STCD',
  /** column name */
  Supexa = 'SUPEXA',
  /** column name */
  Suropip = 'SUROPIP',
  /** column name */
  Suropop = 'SUROPOP',
  /** column name */
  Suroptot = 'SUROPTOT',
  /** column name */
  Tecfte = 'TECFTE',
  /** column name */
  Thrdch = 'THRDCH',
  /** column name */
  Thrdclt = 'THRDCLT',
  /** column name */
  Thripdh = 'THRIPDH',
  /** column name */
  Thripdlt = 'THRIPDLT',
  /** column name */
  Thrtdc = 'THRTDC',
  /** column name */
  Thrtip = 'THRTIP',
  /** column name */
  Vast = 'VAST',
  /** column name */
  Vem = 'VEM',
  /** column name */
  Vlab = 'VLAB',
  /** column name */
  Vlpn = 'VLPN',
  /** column name */
  Vmd = 'VMD',
  /** column name */
  Voth = 'VOTH',
  /** column name */
  Vothl = 'VOTHL',
  /** column name */
  Vphr = 'VPHR',
  /** column name */
  Vpht = 'VPHT',
  /** column name */
  Vrad = 'VRAD',
  /** column name */
  Vres = 'VRES',
  /** column name */
  Vrn = 'VRN',
  /** column name */
  Vrnh = 'VRNH',
  /** column name */
  Vrsp = 'VRSP',
  /** column name */
  Vtnh = 'VTNH',
  /** column name */
  Vtot = 'VTOT',
  /** column name */
  Vtotl = 'VTOTL',
  /** column name */
  Vttrn = 'VTTRN'
}

export type As22Util_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<As22Util_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<As22Util_Set_Input>;
  /** filter the rows which have to be updated */
  where: As22Util_Bool_Exp;
};

/** aggregate var_pop on columns */
export type As22Util_Var_Pop_Fields = {
  __typename?: 'AS22UTIL_var_pop_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type As22Util_Var_Samp_Fields = {
  __typename?: 'AS22UTIL_var_samp_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type As22Util_Variance_Fields = {
  __typename?: 'AS22UTIL_variance_fields';
  ADC: Maybe<Scalars['Float']>;
  ADJADC: Maybe<Scalars['Float']>;
  ADJADCH: Maybe<Scalars['Float']>;
  ADJADM: Maybe<Scalars['Float']>;
  ADJPD: Maybe<Scalars['Float']>;
  ADJPDH: Maybe<Scalars['Float']>;
  ADMH: Maybe<Scalars['Float']>;
  ADMLT: Maybe<Scalars['Float']>;
  ADMTOT: Maybe<Scalars['Float']>;
  BASSIN: Maybe<Scalars['Float']>;
  BDH: Maybe<Scalars['Float']>;
  BDLT: Maybe<Scalars['Float']>;
  BDTOT: Maybe<Scalars['Float']>;
  BIRTHS: Maybe<Scalars['Float']>;
  CRNFTE: Maybe<Scalars['Float']>;
  CTFTE: Maybe<Scalars['Float']>;
  DCLT: Maybe<Scalars['Float']>;
  DCTOT: Maybe<Scalars['Float']>;
  DCTOTH: Maybe<Scalars['Float']>;
  DPEXA: Maybe<Scalars['Float']>;
  EOPDCH: Maybe<Scalars['Float']>;
  EOPIPDH: Maybe<Scalars['Float']>;
  EOPIPDLT: Maybe<Scalars['Float']>;
  ERNFTE: Maybe<Scalars['Float']>;
  ESPDCH: Maybe<Scalars['Float']>;
  ESPDCLT: Maybe<Scalars['Float']>;
  ESPIPDH: Maybe<Scalars['Float']>;
  ESPIPDLT: Maybe<Scalars['Float']>;
  ETHRDCH: Maybe<Scalars['Float']>;
  ETHRIPDH: Maybe<Scalars['Float']>;
  ETHRIPDLT: Maybe<Scalars['Float']>;
  EXPTHA: Maybe<Scalars['Float']>;
  EXPTLA: Maybe<Scalars['Float']>;
  EXPTOT: Maybe<Scalars['Float']>;
  FTAST: Maybe<Scalars['Float']>;
  FTE: Maybe<Scalars['Float']>;
  FTEAP: Maybe<Scalars['Float']>;
  FTECAP: Maybe<Scalars['Float']>;
  FTECLAB: Maybe<Scalars['Float']>;
  FTECPH: Maybe<Scalars['Float']>;
  FTECPHT: Maybe<Scalars['Float']>;
  FTECRAD: Maybe<Scalars['Float']>;
  FTECRESP: Maybe<Scalars['Float']>;
  FTED: Maybe<Scalars['Float']>;
  FTEH: Maybe<Scalars['Float']>;
  FTELAB: Maybe<Scalars['Float']>;
  FTELPN: Maybe<Scalars['Float']>;
  FTEMD: Maybe<Scalars['Float']>;
  FTEN: Maybe<Scalars['Float']>;
  FTENH: Maybe<Scalars['Float']>;
  FTEO: Maybe<Scalars['Float']>;
  FTEOTH94: Maybe<Scalars['Float']>;
  FTEP: Maybe<Scalars['Float']>;
  FTEPH: Maybe<Scalars['Float']>;
  FTEPHT: Maybe<Scalars['Float']>;
  FTER: Maybe<Scalars['Float']>;
  FTERAD: Maybe<Scalars['Float']>;
  FTERES: Maybe<Scalars['Float']>;
  FTERESP: Maybe<Scalars['Float']>;
  FTERN: Maybe<Scalars['Float']>;
  FTERNH: Maybe<Scalars['Float']>;
  FTERNLT: Maybe<Scalars['Float']>;
  FTET: Maybe<Scalars['Float']>;
  FTETF: Maybe<Scalars['Float']>;
  FTETRAN: Maybe<Scalars['Float']>;
  FTETTRN: Maybe<Scalars['Float']>;
  FTEU: Maybe<Scalars['Float']>;
  FTLAB: Maybe<Scalars['Float']>;
  FTLPNTF: Maybe<Scalars['Float']>;
  FTMDTF: Maybe<Scalars['Float']>;
  FTOTHTF: Maybe<Scalars['Float']>;
  FTPHR: Maybe<Scalars['Float']>;
  FTPHT: Maybe<Scalars['Float']>;
  FTRAD: Maybe<Scalars['Float']>;
  FTRES: Maybe<Scalars['Float']>;
  FTRESP: Maybe<Scalars['Float']>;
  FTRNLT: Maybe<Scalars['Float']>;
  FTRNTF: Maybe<Scalars['Float']>;
  FTTOT: Maybe<Scalars['Float']>;
  FTTOTH: Maybe<Scalars['Float']>;
  FTTOTLT: Maybe<Scalars['Float']>;
  FTTRAN84: Maybe<Scalars['Float']>;
  INTEXA: Maybe<Scalars['Float']>;
  IPDH: Maybe<Scalars['Float']>;
  IPDLT: Maybe<Scalars['Float']>;
  IPDTOT: Maybe<Scalars['Float']>;
  LABFTE: Maybe<Scalars['Float']>;
  LBEDLA: Maybe<Scalars['Float']>;
  LBEDSA: Maybe<Scalars['Float']>;
  MCDDC: Maybe<Scalars['Float']>;
  MCDDCH: Maybe<Scalars['Float']>;
  MCDDCLT: Maybe<Scalars['Float']>;
  MCDIPD: Maybe<Scalars['Float']>;
  MCDIPDH: Maybe<Scalars['Float']>;
  MCDIPDLT: Maybe<Scalars['Float']>;
  MCRDC: Maybe<Scalars['Float']>;
  MCRDCH: Maybe<Scalars['Float']>;
  MCRDCLT: Maybe<Scalars['Float']>;
  MCRIPD: Maybe<Scalars['Float']>;
  MCRIPDH: Maybe<Scalars['Float']>;
  MCRIPDLT: Maybe<Scalars['Float']>;
  NPAYBEN: Maybe<Scalars['Float']>;
  NPAYBENH: Maybe<Scalars['Float']>;
  NPAYBENL: Maybe<Scalars['Float']>;
  OPDCH: Maybe<Scalars['Float']>;
  OPDCLT: Maybe<Scalars['Float']>;
  OPIPDH: Maybe<Scalars['Float']>;
  OPIPDLT: Maybe<Scalars['Float']>;
  OPOTDC: Maybe<Scalars['Float']>;
  OPOTIP: Maybe<Scalars['Float']>;
  OPRA: Maybe<Scalars['Float']>;
  OTHEXPA: Maybe<Scalars['Float']>;
  OTHPCR: Maybe<Scalars['Float']>;
  PAYTOT: Maybe<Scalars['Float']>;
  PAYTOTH: Maybe<Scalars['Float']>;
  PAYTOTLT: Maybe<Scalars['Float']>;
  PCMRES: Maybe<Scalars['Float']>;
  PHAFTE: Maybe<Scalars['Float']>;
  PHREXA: Maybe<Scalars['Float']>;
  PTAST: Maybe<Scalars['Float']>;
  PTLAB: Maybe<Scalars['Float']>;
  PTLPNTF: Maybe<Scalars['Float']>;
  PTMDTF: Maybe<Scalars['Float']>;
  PTOTHTF: Maybe<Scalars['Float']>;
  PTPHR: Maybe<Scalars['Float']>;
  PTPHT: Maybe<Scalars['Float']>;
  PTRAD: Maybe<Scalars['Float']>;
  PTRES: Maybe<Scalars['Float']>;
  PTRESP: Maybe<Scalars['Float']>;
  PTRNLT: Maybe<Scalars['Float']>;
  PTRNTF: Maybe<Scalars['Float']>;
  PTTOT: Maybe<Scalars['Float']>;
  PTTOTH: Maybe<Scalars['Float']>;
  PTTOTLT: Maybe<Scalars['Float']>;
  PTTRAN84: Maybe<Scalars['Float']>;
  RADFTE: Maybe<Scalars['Float']>;
  RTTFTE: Maybe<Scalars['Float']>;
  SPDCH: Maybe<Scalars['Float']>;
  SPDCLT: Maybe<Scalars['Float']>;
  SPIPDH: Maybe<Scalars['Float']>;
  SPIPDLT: Maybe<Scalars['Float']>;
  SPTDC: Maybe<Scalars['Float']>;
  SPTIP: Maybe<Scalars['Float']>;
  SUPEXA: Maybe<Scalars['Float']>;
  SUROPIP: Maybe<Scalars['Float']>;
  SUROPOP: Maybe<Scalars['Float']>;
  SUROPTOT: Maybe<Scalars['Float']>;
  TECFTE: Maybe<Scalars['Float']>;
  THRDCH: Maybe<Scalars['Float']>;
  THRDCLT: Maybe<Scalars['Float']>;
  THRIPDH: Maybe<Scalars['Float']>;
  THRIPDLT: Maybe<Scalars['Float']>;
  THRTDC: Maybe<Scalars['Float']>;
  THRTIP: Maybe<Scalars['Float']>;
  VAST: Maybe<Scalars['Float']>;
  VEM: Maybe<Scalars['Float']>;
  VLAB: Maybe<Scalars['Float']>;
  VLPN: Maybe<Scalars['Float']>;
  VMD: Maybe<Scalars['Float']>;
  VOTH: Maybe<Scalars['Float']>;
  VOTHL: Maybe<Scalars['Float']>;
  VPHR: Maybe<Scalars['Float']>;
  VPHT: Maybe<Scalars['Float']>;
  VRAD: Maybe<Scalars['Float']>;
  VRES: Maybe<Scalars['Float']>;
  VRN: Maybe<Scalars['Float']>;
  VRNH: Maybe<Scalars['Float']>;
  VRSP: Maybe<Scalars['Float']>;
  VTNH: Maybe<Scalars['Float']>;
  VTOT: Maybe<Scalars['Float']>;
  VTOTL: Maybe<Scalars['Float']>;
  VTTRN: Maybe<Scalars['Float']>;
};

export type AcceptAcepOrgSurveyResult = {
  __typename?: 'AcceptAcepOrgSurveyResult';
  acep_org_survey: Maybe<Acep_Org_Survey>;
  acep_org_survey_id: Scalars['String'];
};

export type AdAuctionAsset = {
  __typename?: 'AdAuctionAsset';
  url: Scalars['String'];
};

export type AdAuctionCategory = {
  disjunctions?: InputMaybe<Array<Array<Scalars['String']>>>;
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type AdAuctionInput = {
  category?: InputMaybe<AdAuctionCategory>;
  device?: InputMaybe<Scalars['String']>;
  slotId: Scalars['String'];
  slots: Scalars['Int'];
  type: Scalars['String'];
};

export type AdAuctionResult = {
  __typename?: 'AdAuctionResult';
  error: Scalars['Boolean'];
  resultType: Scalars['String'];
  winners: Array<AdAuctionWinner>;
};

export type AdAuctionWinner = {
  __typename?: 'AdAuctionWinner';
  asset: Array<AdAuctionAsset>;
  id: Scalars['String'];
  rank: Scalars['Int'];
  resolvedBidId: Scalars['String'];
  type: Scalars['String'];
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int'];
};

export type AppCert = {
  __typename?: 'AppCert';
  degrees: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type ApplyToJobsInput = {
  contract_ids?: InputMaybe<Array<Scalars['String']>>;
  intro?: InputMaybe<Scalars['String']>;
  posting_ids?: InputMaybe<Array<Scalars['String']>>;
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** The file name */
  fileName: Scalars['String'];
  /** The file handle */
  handle: Scalars['String'];
  /** The height of the file */
  height: Maybe<Scalars['Float']>;
  /** List of Asset versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** The mime type of the file */
  mimeType: Maybe<Scalars['String']>;
  picturePost: Array<Post>;
  pictureTeammate: Array<Teammate>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size: Maybe<Scalars['Float']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String'];
  /** The file width */
  width: Maybe<Scalars['Float']>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetPicturePostArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostWhereInput>;
};


/** Asset system model */
export type AssetPictureTeammateArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TeammateOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeammateWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  handle: Scalars['String'];
  height?: InputMaybe<Scalars['Float']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  picturePost?: InputMaybe<PostCreateManyInlineInput>;
  pictureTeammate?: InputMaybe<TeammateCreateManyInlineInput>;
  size?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileName: Scalars['String'];
  handle: Scalars['String'];
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  picturePost_every?: InputMaybe<PostWhereInput>;
  picturePost_none?: InputMaybe<PostWhereInput>;
  picturePost_some?: InputMaybe<PostWhereInput>;
  pictureTeammate_every?: InputMaybe<TeammateWhereInput>;
  pictureTeammate_none?: InputMaybe<TeammateWhereInput>;
  pictureTeammate_some?: InputMaybe<TeammateWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AssetOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']>;
};

export type AssetUpdateInput = {
  fileName?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  picturePost?: InputMaybe<PostUpdateManyInlineInput>;
  pictureTeammate?: InputMaybe<TeammateUpdateManyInlineInput>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInput = {
  fileName?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateManyLocalizationDataInput = {
  fileName?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  fileName?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  mimeType?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']>;
  picturePost_every?: InputMaybe<PostWhereInput>;
  picturePost_none?: InputMaybe<PostWhereInput>;
  picturePost_some?: InputMaybe<PostWhereInput>;
  pictureTeammate_every?: InputMaybe<TeammateWhereInput>;
  pictureTeammate_none?: InputMaybe<TeammateWhereInput>;
  pictureTeammate_some?: InputMaybe<TeammateWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  width?: InputMaybe<Scalars['Float']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum Audience {
  Clinician = 'CLINICIAN',
  Employer = 'EMPLOYER'
}

export type BankPaymentMethodGql = {
  __typename?: 'BankPaymentMethodGQL';
  account_type: Maybe<Scalars['String']>;
  bank_name: Maybe<Scalars['String']>;
  last_4: Maybe<Scalars['String']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CardPaymentMethodGql = {
  __typename?: 'CardPaymentMethodGQL';
  brand: Scalars['String'];
  exp_month: Scalars['Int'];
  exp_year: Scalars['Int'];
  last_4: Scalars['String'];
};

export type CheckOrgUserSignupStatusResult = {
  __typename?: 'CheckOrgUserSignupStatusResult';
  description: Scalars['String'];
  first_name: Maybe<Scalars['String']>;
  last_name: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type CheckoutSetupIntentGql = {
  __typename?: 'CheckoutSetupIntentGQL';
  amount_due: Maybe<Scalars['Int']>;
  client_secret: Maybe<Scalars['String']>;
  id: Scalars['String'];
  setup_future_usage: Maybe<Scalars['String']>;
};

export type ClaimOrgUserInput = {
  acq_session?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referral?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAdAuctionInput = {
  auctions: Array<AdAuctionInput>;
};

export type CreateAdAuctionResult = {
  __typename?: 'CreateAdAuctionResult';
  results: Array<AdAuctionResult>;
};

export type CreateFileResult = {
  __typename?: 'CreateFileResult';
  content_type: Maybe<Scalars['String']>;
  file: Maybe<File>;
  filename: Scalars['String'];
  id: Scalars['String'];
  upload_url: Scalars['String'];
};

export type CustomerAddressInput = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type CustomerDetailsInput = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  full_name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type CustomerGql = {
  __typename?: 'CustomerGQL';
  address_1: Maybe<Scalars['String']>;
  address_2: Maybe<Scalars['String']>;
  balance: Maybe<Scalars['Float']>;
  checkout_bank_hold: Scalars['Boolean'];
  city: Maybe<Scalars['String']>;
  default_payment_id: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoices: InvoiceCollectionGql;
  payment_methods: Array<PaymentMethodGql>;
  state: Maybe<Scalars['String']>;
  subscription: Maybe<CustomerSubscriptionGql>;
  zipcode: Maybe<Scalars['String']>;
};


export type CustomerGqlInvoicesArgs = {
  limit?: Scalars['Int'];
  start_after?: InputMaybe<Scalars['String']>;
};

export type CustomerSubscriptionGql = {
  __typename?: 'CustomerSubscriptionGQL';
  active: Scalars['Boolean'];
  cancel_at: Maybe<Scalars['DateTime']>;
  discounted: Scalars['Boolean'];
  id: Scalars['String'];
  interval: Scalars['String'];
  invoice: Maybe<SubscriptionInvoiceGql>;
  slots: Scalars['Int'];
  status: Scalars['String'];
  tier: Scalars['String'];
  used_slots: Scalars['Int'];
};

export enum DocumentFileTypes {
  Doc = 'doc',
  Docx = 'docx',
  Html = 'html',
  Jpg = 'jpg',
  Odp = 'odp',
  Ods = 'ods',
  Odt = 'odt',
  Pdf = 'pdf',
  Png = 'png',
  Ppt = 'ppt',
  Pptx = 'pptx',
  Svg = 'svg',
  Txt = 'txt',
  Webp = 'webp',
  Xls = 'xls',
  Xlsx = 'xlsx'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * PDF:	jpg, odp, ods, odt, png, svg, txt, and webp
   * DOC:	docx, html, jpg, odt, pdf, png, svg, txt, and webp
   * DOCX:	doc, html, jpg, odt, pdf, png, svg, txt, and webp
   * ODT:	doc, docx, html, jpg, pdf, png, svg, txt, and webp
   * XLS:	jpg, pdf, ods, png, svg, xlsx, and webp
   * XLSX:	jpg, pdf, ods, png, svg, xls, and webp
   * ODS:	jpg, pdf, png, xls, svg, xlsx, and webp
   * PPT:	jpg, odp, pdf, png, svg, pptx, and webp
   * PPTX:	jpg, odp, pdf, png, svg, ppt, and webp
   * ODP:	jpg, pdf, png, ppt, svg, pptx, and webp
   * BMP:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * GIF:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * JPG:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * PNG:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * WEBP:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * TIFF:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * AI:	    jpg, odp, ods, odt, pdf, png, svg, and webp
   * PSD:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * SVG:	jpg, odp, ods, odt, pdf, png, and webp
   * HTML:	jpg, odt, pdf, svg, txt, and webp
   * TXT:	jpg, html, odt, pdf, svg, and webp
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime'];
  data: Maybe<Scalars['Json']>;
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export type EmailSuppression = {
  __typename?: 'EmailSuppression';
  category: Scalars['String'];
  id: Scalars['String'];
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Asset system model */
  Asset = 'Asset',
  Faq = 'Faq',
  Legal = 'Legal',
  Post = 'Post',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  Teammate = 'Teammate',
  /** User system model */
  User = 'User'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type Faq = Entity & Node & {
  __typename?: 'Faq';
  ans: RichText;
  audience: Audience;
  category: FaqCategory;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Faq>;
  /** List of Faq versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  order: Scalars['Int'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  question: Scalars['String'];
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
};


export type FaqCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type FaqHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type FaqPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FaqScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FaqUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export enum FaqCategory {
  Basics = 'BASICS',
  Dei = 'DEI',
  Finance = 'FINANCE',
  Privacy = 'PRIVACY',
  Subscription = 'SUBSCRIPTION',
  Support = 'SUPPORT',
  WhyIvy = 'WHY_IVY'
}

/** A connection to a list of items. */
export type FaqConnection = {
  __typename?: 'FaqConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FaqEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FaqCreateInput = {
  ans: Scalars['RichTextAST'];
  audience: Audience;
  category: FaqCategory;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  order: Scalars['Int'];
  question: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** An edge in a connection. */
export type FaqEdge = {
  __typename?: 'FaqEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Faq;
};

/** Identifies documents */
export type FaqManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  audience?: InputMaybe<Audience>;
  /** All values that are contained in given list. */
  audience_in?: InputMaybe<Array<InputMaybe<Audience>>>;
  /** Any other value that exists and is not equal to the given value. */
  audience_not?: InputMaybe<Audience>;
  /** All values that are not contained in given list. */
  audience_not_in?: InputMaybe<Array<InputMaybe<Audience>>>;
  category?: InputMaybe<FaqCategory>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<FaqCategory>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  order_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  order_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  order_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  order_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  order_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FaqOrderByInput {
  AudienceAsc = 'audience_ASC',
  AudienceDesc = 'audience_DESC',
  CategoryAsc = 'category_ASC',
  CategoryDesc = 'category_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  OrderAsc = 'order_ASC',
  OrderDesc = 'order_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  QuestionAsc = 'question_ASC',
  QuestionDesc = 'question_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FaqUpdateInput = {
  ans?: InputMaybe<Scalars['RichTextAST']>;
  audience?: InputMaybe<Audience>;
  category?: InputMaybe<FaqCategory>;
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

export type FaqUpdateManyInput = {
  ans?: InputMaybe<Scalars['RichTextAST']>;
  audience?: InputMaybe<Audience>;
  category?: InputMaybe<FaqCategory>;
  question?: InputMaybe<Scalars['String']>;
};

export type FaqUpsertInput = {
  /** Create document if it didn't exist */
  create: FaqCreateInput;
  /** Update document if it exists */
  update: FaqUpdateInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FaqWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type FaqWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  audience?: InputMaybe<Audience>;
  /** All values that are contained in given list. */
  audience_in?: InputMaybe<Array<InputMaybe<Audience>>>;
  /** Any other value that exists and is not equal to the given value. */
  audience_not?: InputMaybe<Audience>;
  /** All values that are not contained in given list. */
  audience_not_in?: InputMaybe<Array<InputMaybe<Audience>>>;
  category?: InputMaybe<FaqCategory>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<FaqCategory>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<FaqCategory>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FaqWhereStageInput>;
  documentInStages_none?: InputMaybe<FaqWhereStageInput>;
  documentInStages_some?: InputMaybe<FaqWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  order_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  order_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  order_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  order_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  order_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  question?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  question_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  question_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  question_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  question_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  question_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  question_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  question_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  question_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  question_starts_with?: InputMaybe<Scalars['String']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FaqWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FaqWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FaqWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FaqWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FaqWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Faq record uniquely */
export type FaqWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type FinalizeFileResult = {
  __typename?: 'FinalizeFileResult';
  content_type: Maybe<Scalars['String']>;
  file: Maybe<File>;
  filename: Scalars['String'];
  id: Scalars['String'];
  public_url: Scalars['String'];
  success: Scalars['Boolean'];
};

export type FinalizeSignupResult = {
  __typename?: 'FinalizeSignupResult';
  access_token: Scalars['String'];
  refresh_token: Scalars['String'];
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  Crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  Max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  Scale = 'scale'
}

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']>;
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
};

export type ImmediateNeedsArgs = {
  prof?: InputMaybe<Scalars['profession']>;
};

export type ImportCredentialsResult = {
  __typename?: 'ImportCredentialsResult';
  clinician: Maybe<Clinician>;
  clinician_id: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InviteOrgUserInput = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
};

export type InviteOrgUserResult = {
  __typename?: 'InviteOrgUserResult';
  account_id: Scalars['String'];
  success: Scalars['Boolean'];
};

export type InvoiceCollectionGql = {
  __typename?: 'InvoiceCollectionGQL';
  open: InvoicesDataGql;
  paid: InvoicesDataGql;
};

export type InvoiceGql = {
  __typename?: 'InvoiceGQL';
  date: Maybe<Scalars['Int']>;
  download_link: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  link: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
};

export type InvoicesDataGql = {
  __typename?: 'InvoicesDataGQL';
  data: Array<InvoiceGql>;
  has_more: Scalars['Boolean'];
};

export type Legal = Entity & Node & {
  __typename?: 'Legal';
  content: RichText;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Legal>;
  /** List of Legal versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
};


export type LegalCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LegalDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type LegalHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type LegalPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LegalScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LegalUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A connection to a list of items. */
export type LegalConnection = {
  __typename?: 'LegalConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LegalEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LegalCreateInput = {
  content: Scalars['RichTextAST'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** An edge in a connection. */
export type LegalEdge = {
  __typename?: 'LegalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Legal;
};

/** Identifies documents */
export type LegalManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LegalWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LegalWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LegalWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LegalWhereStageInput>;
  documentInStages_none?: InputMaybe<LegalWhereStageInput>;
  documentInStages_some?: InputMaybe<LegalWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LegalOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type LegalUpdateInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
  title?: InputMaybe<Scalars['String']>;
};

export type LegalUpdateManyInput = {
  content?: InputMaybe<Scalars['RichTextAST']>;
};

export type LegalUpsertInput = {
  /** Create document if it didn't exist */
  create: LegalCreateInput;
  /** Update document if it exists */
  update: LegalUpdateInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LegalWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type LegalWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LegalWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LegalWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LegalWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LegalWhereStageInput>;
  documentInStages_none?: InputMaybe<LegalWhereStageInput>;
  documentInStages_some?: InputMaybe<LegalWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LegalWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LegalWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LegalWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LegalWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LegalWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Legal record uniquely */
export type LegalWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en'
}

export type LogInResult = {
  __typename?: 'LogInResult';
  access_token: Scalars['String'];
  refresh_token: Scalars['String'];
};

export type MedicareSpecialty = {
  __typename?: 'MedicareSpecialty';
  cms_name: Scalars['String'];
  name: Scalars['String'];
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Number of items in the current page. */
  pageSize: Maybe<Scalars['Int']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

export type PaymentIntentGql = {
  __typename?: 'PaymentIntentGQL';
  amount_due: Scalars['Int'];
  client_secret: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  setup_future_usage: Maybe<Scalars['String']>;
};

export type PaymentMethodGql = {
  __typename?: 'PaymentMethodGQL';
  card: Maybe<CardPaymentMethodGql>;
  created_at: Scalars['Int'];
  id: Scalars['String'];
  type: Scalars['String'];
  us_bank: Maybe<BankPaymentMethodGql>;
};

export enum Platform {
  Default = 'DEFAULT',
  EmraMatch = 'EMRA_MATCH'
}

export type Post = Entity & Node & {
  __typename?: 'Post';
  actor: Maybe<Scalars['String']>;
  content: PostContentRichText;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Post>;
  /** List of Post versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  objectPosition: Maybe<Scalars['String']>;
  picture: Asset;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug: Scalars['String'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
};


export type PostCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PostDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type PostHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type PostPictureArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PostPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PostScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PostUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PostConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PostWhereUniqueInput;
};

/** A connection to a list of items. */
export type PostConnection = {
  __typename?: 'PostConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PostEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PostContentRichText = {
  __typename?: 'PostContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  json: Scalars['RichTextAST'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  raw: Scalars['RichTextAST'];
  references: Array<PostContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type PostContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type PostContentRichTextEmbeddedTypes = Asset;

export type PostCreateInput = {
  actor?: InputMaybe<Scalars['String']>;
  content: Scalars['RichTextAST'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  objectPosition?: InputMaybe<Scalars['String']>;
  picture: AssetCreateOneInlineInput;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PostCreateManyInlineInput = {
  /** Connect multiple existing Post documents */
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  /** Create and connect multiple existing Post documents */
  create?: InputMaybe<Array<PostCreateInput>>;
};

/** An edge in a connection. */
export type PostEdge = {
  __typename?: 'PostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Post;
};

/** Identifies documents */
export type PostManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PostWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PostWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PostWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  actor?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  actor_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  actor_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  actor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  actor_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  actor_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  actor_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  actor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  actor_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  actor_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PostWhereStageInput>;
  documentInStages_none?: InputMaybe<PostWhereStageInput>;
  documentInStages_some?: InputMaybe<PostWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  objectPosition?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  objectPosition_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  objectPosition_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  objectPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  objectPosition_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  objectPosition_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  objectPosition_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  objectPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  objectPosition_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  objectPosition_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PostOrderByInput {
  ActorAsc = 'actor_ASC',
  ActorDesc = 'actor_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ObjectPositionAsc = 'objectPosition_ASC',
  ObjectPositionDesc = 'objectPosition_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PostUpdateInput = {
  actor?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['RichTextAST']>;
  objectPosition?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<AssetUpdateOneInlineInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PostUpdateManyInlineInput = {
  /** Connect multiple existing Post documents */
  connect?: InputMaybe<Array<PostConnectInput>>;
  /** Create and connect multiple Post documents */
  create?: InputMaybe<Array<PostCreateInput>>;
  /** Delete multiple Post documents */
  delete?: InputMaybe<Array<PostWhereUniqueInput>>;
  /** Disconnect multiple Post documents */
  disconnect?: InputMaybe<Array<PostWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Post documents */
  set?: InputMaybe<Array<PostWhereUniqueInput>>;
  /** Update multiple Post documents */
  update?: InputMaybe<Array<PostUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Post documents */
  upsert?: InputMaybe<Array<PostUpsertWithNestedWhereUniqueInput>>;
};

export type PostUpdateManyInput = {
  actor?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['RichTextAST']>;
  objectPosition?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PostUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PostUpdateInput;
  /** Unique document search */
  where: PostWhereUniqueInput;
};

export type PostUpsertInput = {
  /** Create document if it didn't exist */
  create: PostCreateInput;
  /** Update document if it exists */
  update: PostUpdateInput;
};

export type PostUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PostUpsertInput;
  /** Unique document search */
  where: PostWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PostWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type PostWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PostWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PostWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PostWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  actor?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  actor_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  actor_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  actor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  actor_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  actor_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  actor_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  actor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  actor_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  actor_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PostWhereStageInput>;
  documentInStages_none?: InputMaybe<PostWhereStageInput>;
  documentInStages_some?: InputMaybe<PostWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  objectPosition?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  objectPosition_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  objectPosition_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  objectPosition_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  objectPosition_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  objectPosition_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  objectPosition_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  objectPosition_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  objectPosition_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  objectPosition_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PostWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PostWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PostWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PostWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PostWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Post record uniquely */
export type PostWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type PriceTierGql = {
  __typename?: 'PriceTierGQL';
  amount: Scalars['Float'];
  limit: Maybe<Scalars['Int']>;
};

export type ProductPriceGql = {
  __typename?: 'ProductPriceGQL';
  id: Scalars['String'];
  interval: Scalars['String'];
  tiers: Array<PriceTierGql>;
};

export type RefreshAuthResult = {
  __typename?: 'RefreshAuthResult';
  access_token: Scalars['String'];
};

export type RegisterClinicianInput = {
  acq_session?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  password: Scalars['String'];
  prof_degree: Scalars['String'];
  referral?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

export type RegisterClinicianResult = {
  __typename?: 'RegisterClinicianResult';
  access_token: Scalars['String'];
  refresh_token: Scalars['String'];
};

export type RegisterOrgUserInput = {
  acq_session?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  org_id: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referral?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

export type ResolveCityPlaceIdResult = {
  __typename?: 'ResolveCityPlaceIdResult';
  place_id: Maybe<Scalars['String']>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Operation description */
  description: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json'];
  /** The release this operation is scheduled for */
  release: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Asset | Faq | Legal | Post | Teammate;

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

export enum ScheduledOperationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Release description */
  description: Maybe<Scalars['String']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage: Maybe<Scalars['String']>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  /** Release date and time */
  releaseAt: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title: Maybe<Scalars['String']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

export enum ScheduledReleaseOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  ErrorMessageAsc = 'errorMessage_ASC',
  ErrorMessageDesc = 'errorMessage_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  IsImplicitAsc = 'isImplicit_ASC',
  IsImplicitDesc = 'isImplicit_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ReleaseAtAsc = 'releaseAt_ASC',
  ReleaseAtDesc = 'releaseAt_DESC',
  StatusAsc = 'status_ASC',
  StatusDesc = 'status_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isImplicit?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type SendJobApplicationBatchAdminFollowup = {
  __typename?: 'SendJobApplicationBatchAdminFollowup';
  job_application_batch: Maybe<Job_Application_Batch>;
  job_application_batch_id: Scalars['String'];
};

export type SetupIntentGql = {
  __typename?: 'SetupIntentGQL';
  client_secret: Maybe<Scalars['String']>;
  id: Scalars['String'];
  setup_future_usage: Maybe<Scalars['String']>;
};

export type SignUpOrgUserInput = {
  acq_session?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  org_id: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referral?: InputMaybe<Scalars['String']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED'
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_BigQuery_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type SubscriptionInvoiceGql = {
  __typename?: 'SubscriptionInvoiceGQL';
  id: Maybe<Scalars['String']>;
  invoice_date: Maybe<Scalars['DateTime']>;
  payment_intent: Maybe<Scalars['String']>;
  payment_status: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  subtotal: Scalars['Float'];
  total: Scalars['Float'];
};

export type SubscriptionInvoicePreviewGql = {
  __typename?: 'SubscriptionInvoicePreviewGQL';
  subtotal: Scalars['Float'];
  tax: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean'];
};

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Combined = 'COMBINED',
  Localization = 'LOCALIZATION'
}

export type Teammate = Entity & Node & {
  __typename?: 'Teammate';
  bio: Maybe<Scalars['String']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Teammate>;
  first: Scalars['String'];
  /** List of Teammate versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID'];
  last: Scalars['String'];
  linkedin: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  picture: Asset;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  suffix: Maybe<Scalars['String']>;
  titles: Array<Scalars['String']>;
  type: TeammateType;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy: Maybe<User>;
};


export type TeammateCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeammateDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};


export type TeammateHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: InputMaybe<Stage>;
};


export type TeammatePictureArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeammatePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TeammateScheduledInArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TeammateUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TeammateConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TeammateWhereUniqueInput;
};

/** A connection to a list of items. */
export type TeammateConnection = {
  __typename?: 'TeammateConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TeammateEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TeammateCreateInput = {
  bio?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['String'];
  last: Scalars['String'];
  linkedin?: InputMaybe<Scalars['String']>;
  order: Scalars['Int'];
  picture: AssetCreateOneInlineInput;
  suffix?: InputMaybe<Scalars['String']>;
  titles: Array<Scalars['String']>;
  type: TeammateType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type TeammateCreateManyInlineInput = {
  /** Connect multiple existing Teammate documents */
  connect?: InputMaybe<Array<TeammateWhereUniqueInput>>;
  /** Create and connect multiple existing Teammate documents */
  create?: InputMaybe<Array<TeammateCreateInput>>;
};

/** An edge in a connection. */
export type TeammateEdge = {
  __typename?: 'TeammateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: Teammate;
};

/** Identifies documents */
export type TeammateManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeammateWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeammateWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeammateWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TeammateWhereStageInput>;
  documentInStages_none?: InputMaybe<TeammateWhereStageInput>;
  documentInStages_some?: InputMaybe<TeammateWhereStageInput>;
  first?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  first_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  first_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  first_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  first_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  first_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  first_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  first_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  first_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  first_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  last_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  last_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  last_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  last_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  last_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  last_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  last_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  last_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  last_starts_with?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  linkedin_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  linkedin_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  linkedin_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedin_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  linkedin_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  linkedin_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  linkedin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  linkedin_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  linkedin_starts_with?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  order_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  order_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  order_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  order_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  order_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  picture?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  suffix?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  suffix_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  suffix_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  suffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  suffix_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  suffix_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  suffix_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  suffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  suffix_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  suffix_starts_with?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  titles?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  titles_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  titles_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  titles_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  titles_not?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<TeammateType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<TeammateType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<TeammateType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<TeammateType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TeammateOrderByInput {
  BioAsc = 'bio_ASC',
  BioDesc = 'bio_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FirstAsc = 'first_ASC',
  FirstDesc = 'first_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  LastAsc = 'last_ASC',
  LastDesc = 'last_DESC',
  LinkedinAsc = 'linkedin_ASC',
  LinkedinDesc = 'linkedin_DESC',
  OrderAsc = 'order_ASC',
  OrderDesc = 'order_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SuffixAsc = 'suffix_ASC',
  SuffixDesc = 'suffix_DESC',
  TitlesAsc = 'titles_ASC',
  TitlesDesc = 'titles_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum TeammateType {
  Advisor = 'ADVISOR',
  Bod = 'BOD',
  Core = 'CORE',
  FormalAdvisor = 'FORMAL_ADVISOR'
}

export type TeammateUpdateInput = {
  bio?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<AssetUpdateOneInlineInput>;
  suffix?: InputMaybe<Scalars['String']>;
  titles?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<TeammateType>;
};

export type TeammateUpdateManyInlineInput = {
  /** Connect multiple existing Teammate documents */
  connect?: InputMaybe<Array<TeammateConnectInput>>;
  /** Create and connect multiple Teammate documents */
  create?: InputMaybe<Array<TeammateCreateInput>>;
  /** Delete multiple Teammate documents */
  delete?: InputMaybe<Array<TeammateWhereUniqueInput>>;
  /** Disconnect multiple Teammate documents */
  disconnect?: InputMaybe<Array<TeammateWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Teammate documents */
  set?: InputMaybe<Array<TeammateWhereUniqueInput>>;
  /** Update multiple Teammate documents */
  update?: InputMaybe<Array<TeammateUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Teammate documents */
  upsert?: InputMaybe<Array<TeammateUpsertWithNestedWhereUniqueInput>>;
};

export type TeammateUpdateManyInput = {
  bio?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  suffix?: InputMaybe<Scalars['String']>;
  titles?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<TeammateType>;
};

export type TeammateUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TeammateUpdateInput;
  /** Unique document search */
  where: TeammateWhereUniqueInput;
};

export type TeammateUpsertInput = {
  /** Create document if it didn't exist */
  create: TeammateCreateInput;
  /** Update document if it exists */
  update: TeammateUpdateInput;
};

export type TeammateUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TeammateUpsertInput;
  /** Unique document search */
  where: TeammateWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TeammateWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type TeammateWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeammateWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeammateWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeammateWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  bio_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  bio_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bio_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bio_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  bio_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  bio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  bio_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TeammateWhereStageInput>;
  documentInStages_none?: InputMaybe<TeammateWhereStageInput>;
  documentInStages_some?: InputMaybe<TeammateWhereStageInput>;
  first?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  first_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  first_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  first_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  first_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  first_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  first_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  first_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  first_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  first_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  last_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  last_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  last_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  last_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  last_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  last_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  last_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  last_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  last_starts_with?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  linkedin_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  linkedin_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  linkedin_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedin_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  linkedin_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  linkedin_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  linkedin_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  linkedin_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  linkedin_starts_with?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  /** All values greater than the given value. */
  order_gt?: InputMaybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  order_gte?: InputMaybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  order_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** All values less than the given value. */
  order_lt?: InputMaybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  order_lte?: InputMaybe<Scalars['Int']>;
  /** Any other value that exists and is not equal to the given value. */
  order_not?: InputMaybe<Scalars['Int']>;
  /** All values that are not contained in given list. */
  order_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  picture?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  suffix?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  suffix_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  suffix_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  suffix_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  suffix_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  suffix_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  suffix_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  suffix_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  suffix_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  suffix_starts_with?: InputMaybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  titles?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  titles_contains_all?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  titles_contains_none?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  titles_contains_some?: InputMaybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  titles_not?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<TeammateType>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<TeammateType>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<TeammateType>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<TeammateType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TeammateWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TeammateWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TeammateWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TeammateWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TeammateWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Teammate record uniquely */
export type TeammateWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type TrainingSpecialty = {
  __typename?: 'TrainingSpecialty';
  name: Scalars['String'];
  training: Scalars['String'];
};

export enum TrainingSurveyStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export type UnlinkCredentialsResult = {
  __typename?: 'UnlinkCredentialsResult';
  clinician: Maybe<Clinician>;
  clinician_id: Scalars['String'];
};

export type UpdateTrainingSurveyStatusEventInput = {
  event_date: Scalars['Date'];
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTrainingSurveyStatusResult = {
  __typename?: 'UpdateTrainingSurveyStatusResult';
  training_survey: Maybe<Training_Survey>;
  training_survey_id: Scalars['String'];
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String'];
  /** Profile Picture url */
  picture: Maybe<Scalars['String']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt: Maybe<Scalars['DateTime']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
  stages?: Array<Stage>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

export enum UserOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<Scalars['String']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID'];
  revision: Scalars['Int'];
  stage: Stage;
};

/** columns and relationships of "ab_test" */
export type Ab_Test = {
  __typename?: 'ab_test';
  account_id: Scalars['uuid'];
  /** An object relationship */
  current_account: Maybe<Current_Account>;
  group: Scalars['String'];
  id: Scalars['uuid'];
  test: Scalars['String'];
};

/** aggregated selection of "ab_test" */
export type Ab_Test_Aggregate = {
  __typename?: 'ab_test_aggregate';
  aggregate: Maybe<Ab_Test_Aggregate_Fields>;
  nodes: Array<Ab_Test>;
};

export type Ab_Test_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ab_Test_Aggregate_Bool_Exp_Count>;
};

export type Ab_Test_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ab_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ab_Test_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ab_test" */
export type Ab_Test_Aggregate_Fields = {
  __typename?: 'ab_test_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Ab_Test_Max_Fields>;
  min: Maybe<Ab_Test_Min_Fields>;
};


/** aggregate fields of "ab_test" */
export type Ab_Test_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ab_Test_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ab_test" */
export type Ab_Test_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ab_Test_Max_Order_By>;
  min?: InputMaybe<Ab_Test_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ab_test" */
export type Ab_Test_Arr_Rel_Insert_Input = {
  data: Array<Ab_Test_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ab_Test_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ab_test". All fields are combined with a logical 'AND'. */
export type Ab_Test_Bool_Exp = {
  _and?: InputMaybe<Array<Ab_Test_Bool_Exp>>;
  _not?: InputMaybe<Ab_Test_Bool_Exp>;
  _or?: InputMaybe<Array<Ab_Test_Bool_Exp>>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  current_account?: InputMaybe<Current_Account_Bool_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  test?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ab_test" */
export enum Ab_Test_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAbTest = 'pk_ab_test',
  /** unique or primary key constraint on columns "test", "account_id" */
  UqAbTestAccountIdTest = 'uq_ab_test_account_id_test'
}

/** input type for inserting data into table "ab_test" */
export type Ab_Test_Insert_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  current_account?: InputMaybe<Current_Account_Obj_Rel_Insert_Input>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  test?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ab_Test_Max_Fields = {
  __typename?: 'ab_test_max_fields';
  account_id: Maybe<Scalars['uuid']>;
  group: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  test: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ab_test" */
export type Ab_Test_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  test?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ab_Test_Min_Fields = {
  __typename?: 'ab_test_min_fields';
  account_id: Maybe<Scalars['uuid']>;
  group: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  test: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ab_test" */
export type Ab_Test_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  test?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ab_test" */
export type Ab_Test_Mutation_Response = {
  __typename?: 'ab_test_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ab_Test>;
};

/** on_conflict condition type for table "ab_test" */
export type Ab_Test_On_Conflict = {
  constraint: Ab_Test_Constraint;
  update_columns?: Array<Ab_Test_Update_Column>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};

/** Ordering options when selecting data from "ab_test". */
export type Ab_Test_Order_By = {
  account_id?: InputMaybe<Order_By>;
  current_account?: InputMaybe<Current_Account_Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  test?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ab_test */
export type Ab_Test_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ab_test" */
export enum Ab_Test_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  Test = 'test'
}

/** input type for updating data in table "ab_test" */
export type Ab_Test_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  test?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ab_test" */
export type Ab_Test_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ab_Test_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ab_Test_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  group?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  test?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ab_test" */
export enum Ab_Test_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  Test = 'test'
}

export type Ab_Test_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ab_Test_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ab_Test_Bool_Exp;
};

/** columns and relationships of "access_info" */
export type Access_Info = {
  __typename?: 'access_info';
  /** An object relationship */
  account: Maybe<Account>;
  active: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['uuid']>;
  lastAccessDate: Maybe<Scalars['DateTime']>;
  last_access: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "access_info" */
export type Access_Info_Aggregate = {
  __typename?: 'access_info_aggregate';
  aggregate: Maybe<Access_Info_Aggregate_Fields>;
  nodes: Array<Access_Info>;
};

/** aggregate fields of "access_info" */
export type Access_Info_Aggregate_Fields = {
  __typename?: 'access_info_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Access_Info_Max_Fields>;
  min: Maybe<Access_Info_Min_Fields>;
};


/** aggregate fields of "access_info" */
export type Access_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Access_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "access_info". All fields are combined with a logical 'AND'. */
export type Access_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Access_Info_Bool_Exp>>;
  _not?: InputMaybe<Access_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Access_Info_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_access?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** input type for inserting data into table "access_info" */
export type Access_Info_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Access_Info_Max_Fields = {
  __typename?: 'access_info_max_fields';
  id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Access_Info_Min_Fields = {
  __typename?: 'access_info_min_fields';
  id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "access_info" */
export type Access_Info_Mutation_Response = {
  __typename?: 'access_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Access_Info>;
};

/** input type for inserting object relation for remote table "access_info" */
export type Access_Info_Obj_Rel_Insert_Input = {
  data: Access_Info_Insert_Input;
};

/** Ordering options when selecting data from "access_info". */
export type Access_Info_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  active?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_access?: InputMaybe<Order_By>;
};

/** select columns of table "access_info" */
export enum Access_Info_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Id = 'id',
  /** column name */
  LastAccess = 'last_access'
}

/** input type for updating data in table "access_info" */
export type Access_Info_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "access_info" */
export type Access_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Access_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Access_Info_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
};

export type Access_Info_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Access_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: Access_Info_Bool_Exp;
};

/** columns and relationships of "account" */
export type Account = {
  __typename?: 'account';
  /** An object relationship */
  access_info: Maybe<Access_Info>;
  access_salary: Scalars['Boolean'];
  acq_session: Maybe<Scalars['Boolean']>;
  active: Scalars['Boolean'];
  city: Scalars['String'];
  claimed: Scalars['Boolean'];
  /** An object relationship */
  clinician: Maybe<Clinician>;
  confirmation_attempts: Scalars['Int'];
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  confirmed_email: Scalars['Boolean'];
  /** An object relationship */
  contact_info: Maybe<Contact_Info>;
  created_at: Scalars['timestamp'];
  email: Scalars['String'];
  external_id: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  full_name: Scalars['String'];
  hide_search_instructions: Scalars['Boolean'];
  id: Scalars['uuid'];
  identity_provider_id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
  last_name: Scalars['String'];
  location: Maybe<Scalars['geography']>;
  notify_new_training_survey: Scalars['Boolean'];
  onboarding_tour_completed: Scalars['Boolean'];
  /** An object relationship */
  org_user: Maybe<Org_User>;
  password: Scalars['String'];
  pending_email: Scalars['String'];
  /** An object relationship */
  personal_info: Maybe<Personal_Info>;
  phone: Scalars['String'];
  /** An object relationship */
  picture: Maybe<File>;
  picture_id: Maybe<Scalars['uuid']>;
  platform: Scalars['platform'];
  premade: Scalars['Boolean'];
  referral: Scalars['String'];
  referrer_id: Maybe<Scalars['uuid']>;
  registered_at: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  roles: Array<Account_Role>;
  /** An aggregate relationship */
  roles_aggregate: Account_Role_Aggregate;
  state: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2: Scalars['String'];
  superuser: Scalars['Boolean'];
  type: Scalars['accounttype'];
  utm_campaign: Scalars['String'];
  utm_content: Scalars['String'];
  utm_id: Scalars['String'];
  utm_medium: Scalars['String'];
  utm_source: Scalars['String'];
  utm_term: Scalars['String'];
  zipcode: Scalars['String'];
};


/** columns and relationships of "account" */
export type AccountRolesArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};

/** aggregated selection of "account" */
export type Account_Aggregate = {
  __typename?: 'account_aggregate';
  aggregate: Maybe<Account_Aggregate_Fields>;
  nodes: Array<Account>;
};

export type Account_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Account_Aggregate_Bool_Exp_Count>;
};

export type Account_Aggregate_Bool_Exp_Bool_And = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account" */
export type Account_Aggregate_Fields = {
  __typename?: 'account_aggregate_fields';
  avg: Maybe<Account_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Account_Max_Fields>;
  min: Maybe<Account_Min_Fields>;
  stddev: Maybe<Account_Stddev_Fields>;
  stddev_pop: Maybe<Account_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Account_Stddev_Samp_Fields>;
  sum: Maybe<Account_Sum_Fields>;
  var_pop: Maybe<Account_Var_Pop_Fields>;
  var_samp: Maybe<Account_Var_Samp_Fields>;
  variance: Maybe<Account_Variance_Fields>;
};


/** aggregate fields of "account" */
export type Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account" */
export type Account_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Max_Order_By>;
  min?: InputMaybe<Account_Min_Order_By>;
  stddev?: InputMaybe<Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "account" */
export type Account_Arr_Rel_Insert_Input = {
  data: Array<Account_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** aggregate avg on columns */
export type Account_Avg_Fields = {
  __typename?: 'account_avg_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account" */
export type Account_Avg_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type Account_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Bool_Exp>>;
  _not?: InputMaybe<Account_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Bool_Exp>>;
  access_info?: InputMaybe<Access_Info_Bool_Exp>;
  access_salary?: InputMaybe<Boolean_Comparison_Exp>;
  acq_session?: InputMaybe<Boolean_Comparison_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  claimed?: InputMaybe<Boolean_Comparison_Exp>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  confirmation_attempts?: InputMaybe<Int_Comparison_Exp>;
  confirmation_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  confirmed_email?: InputMaybe<Boolean_Comparison_Exp>;
  contact_info?: InputMaybe<Contact_Info_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  hide_search_instructions?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_access?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  notify_new_training_survey?: InputMaybe<Boolean_Comparison_Exp>;
  onboarding_tour_completed?: InputMaybe<Boolean_Comparison_Exp>;
  org_user?: InputMaybe<Org_User_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  pending_email?: InputMaybe<String_Comparison_Exp>;
  personal_info?: InputMaybe<Personal_Info_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<File_Bool_Exp>;
  picture_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<Platform_Comparison_Exp>;
  premade?: InputMaybe<Boolean_Comparison_Exp>;
  referral?: InputMaybe<String_Comparison_Exp>;
  referrer_id?: InputMaybe<Uuid_Comparison_Exp>;
  registered_at?: InputMaybe<Timestamp_Comparison_Exp>;
  roles?: InputMaybe<Account_Role_Bool_Exp>;
  roles_aggregate?: InputMaybe<Account_Role_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  superuser?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<Accounttype_Comparison_Exp>;
  utm_campaign?: InputMaybe<String_Comparison_Exp>;
  utm_content?: InputMaybe<String_Comparison_Exp>;
  utm_id?: InputMaybe<String_Comparison_Exp>;
  utm_medium?: InputMaybe<String_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
  utm_term?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "account" */
export enum Account_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAccount = 'pk_account',
  /** unique or primary key constraint on columns "platform", "email" */
  UqAccountEmailPlatform = 'uq_account_email_platform',
  /** unique or primary key constraint on columns "external_id", "identity_provider_id" */
  UqAccountExternalIdIdentityProviderId = 'uq_account_external_id_identity_provider_id',
  /** unique or primary key constraint on columns "picture_id" */
  UqAccountPictureId = 'uq_account_picture_id'
}

/** input type for incrementing numeric columns in table "account" */
export type Account_Inc_Input = {
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "account" */
export type Account_Insert_Input = {
  access_info?: InputMaybe<Access_Info_Obj_Rel_Insert_Input>;
  access_salary?: InputMaybe<Scalars['Boolean']>;
  acq_session?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  contact_info?: InputMaybe<Contact_Info_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  hide_search_instructions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_provider_id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
  last_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  notify_new_training_survey?: InputMaybe<Scalars['Boolean']>;
  onboarding_tour_completed?: InputMaybe<Scalars['Boolean']>;
  org_user?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']>;
  pending_email?: InputMaybe<Scalars['String']>;
  personal_info?: InputMaybe<Personal_Info_Obj_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<File_Obj_Rel_Insert_Input>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
  premade?: InputMaybe<Scalars['Boolean']>;
  referral?: InputMaybe<Scalars['String']>;
  referrer_id?: InputMaybe<Scalars['uuid']>;
  registered_at?: InputMaybe<Scalars['timestamp']>;
  roles?: InputMaybe<Account_Role_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  superuser?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['accounttype']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Account_Max_Fields = {
  __typename?: 'account_max_fields';
  city: Maybe<Scalars['String']>;
  confirmation_attempts: Maybe<Scalars['Int']>;
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  created_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  external_id: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  identity_provider_id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
  last_name: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  picture_id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
  referral: Maybe<Scalars['String']>;
  referrer_id: Maybe<Scalars['uuid']>;
  registered_at: Maybe<Scalars['timestamp']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  type: Maybe<Scalars['accounttype']>;
  utm_campaign: Maybe<Scalars['String']>;
  utm_content: Maybe<Scalars['String']>;
  utm_id: Maybe<Scalars['String']>;
  utm_medium: Maybe<Scalars['String']>;
  utm_source: Maybe<Scalars['String']>;
  utm_term: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "account" */
export type Account_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  confirmation_attempts?: InputMaybe<Order_By>;
  confirmation_sent_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_provider_id?: InputMaybe<Order_By>;
  last_access?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  pending_email?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  picture_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_id?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Min_Fields = {
  __typename?: 'account_min_fields';
  city: Maybe<Scalars['String']>;
  confirmation_attempts: Maybe<Scalars['Int']>;
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  created_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  external_id: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  identity_provider_id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
  last_name: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  picture_id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
  referral: Maybe<Scalars['String']>;
  referrer_id: Maybe<Scalars['uuid']>;
  registered_at: Maybe<Scalars['timestamp']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  type: Maybe<Scalars['accounttype']>;
  utm_campaign: Maybe<Scalars['String']>;
  utm_content: Maybe<Scalars['String']>;
  utm_id: Maybe<Scalars['String']>;
  utm_medium: Maybe<Scalars['String']>;
  utm_source: Maybe<Scalars['String']>;
  utm_term: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "account" */
export type Account_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  confirmation_attempts?: InputMaybe<Order_By>;
  confirmation_sent_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_provider_id?: InputMaybe<Order_By>;
  last_access?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  pending_email?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  picture_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_id?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account" */
export type Account_Mutation_Response = {
  __typename?: 'account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Account>;
};

/** input type for inserting object relation for remote table "account" */
export type Account_Obj_Rel_Insert_Input = {
  data: Account_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_On_Conflict>;
};

/** on_conflict condition type for table "account" */
export type Account_On_Conflict = {
  constraint: Account_Constraint;
  update_columns?: Array<Account_Update_Column>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** Ordering options when selecting data from "account". */
export type Account_Order_By = {
  access_info?: InputMaybe<Access_Info_Order_By>;
  access_salary?: InputMaybe<Order_By>;
  acq_session?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  claimed?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Clinician_Order_By>;
  confirmation_attempts?: InputMaybe<Order_By>;
  confirmation_sent_at?: InputMaybe<Order_By>;
  confirmed_email?: InputMaybe<Order_By>;
  contact_info?: InputMaybe<Contact_Info_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hide_search_instructions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_provider_id?: InputMaybe<Order_By>;
  last_access?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notify_new_training_survey?: InputMaybe<Order_By>;
  onboarding_tour_completed?: InputMaybe<Order_By>;
  org_user?: InputMaybe<Org_User_Order_By>;
  password?: InputMaybe<Order_By>;
  pending_email?: InputMaybe<Order_By>;
  personal_info?: InputMaybe<Personal_Info_Order_By>;
  phone?: InputMaybe<Order_By>;
  picture?: InputMaybe<File_Order_By>;
  picture_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  premade?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  roles_aggregate?: InputMaybe<Account_Role_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  superuser?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_id?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account */
export type Account_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "account_role" */
export type Account_Role = {
  __typename?: 'account_role';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid'];
  id: Scalars['uuid'];
  role: Scalars['role'];
};

/** aggregated selection of "account_role" */
export type Account_Role_Aggregate = {
  __typename?: 'account_role_aggregate';
  aggregate: Maybe<Account_Role_Aggregate_Fields>;
  nodes: Array<Account_Role>;
};

export type Account_Role_Aggregate_Bool_Exp = {
  count?: InputMaybe<Account_Role_Aggregate_Bool_Exp_Count>;
};

export type Account_Role_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Role_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account_role" */
export type Account_Role_Aggregate_Fields = {
  __typename?: 'account_role_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Account_Role_Max_Fields>;
  min: Maybe<Account_Role_Min_Fields>;
};


/** aggregate fields of "account_role" */
export type Account_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account_role" */
export type Account_Role_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Role_Max_Order_By>;
  min?: InputMaybe<Account_Role_Min_Order_By>;
};

/** input type for inserting array relation for remote table "account_role" */
export type Account_Role_Arr_Rel_Insert_Input = {
  data: Array<Account_Role_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Account_Role_On_Conflict>;
};

/** Boolean expression to filter rows from the table "account_role". All fields are combined with a logical 'AND'. */
export type Account_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Role_Bool_Exp>>;
  _not?: InputMaybe<Account_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Role_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Role_Comparison_Exp>;
};

/** unique or primary key constraints on table "account_role" */
export enum Account_Role_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAccountRole = 'pk_account_role',
  /** unique or primary key constraint on columns "account_id", "role" */
  UqAccountRoleAccountIdRole = 'uq_account_role_account_id_role'
}

/** input type for inserting data into table "account_role" */
export type Account_Role_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['role']>;
};

/** aggregate max on columns */
export type Account_Role_Max_Fields = {
  __typename?: 'account_role_max_fields';
  account_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  role: Maybe<Scalars['role']>;
};

/** order by max() on columns of table "account_role" */
export type Account_Role_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Role_Min_Fields = {
  __typename?: 'account_role_min_fields';
  account_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  role: Maybe<Scalars['role']>;
};

/** order by min() on columns of table "account_role" */
export type Account_Role_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account_role" */
export type Account_Role_Mutation_Response = {
  __typename?: 'account_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Account_Role>;
};

/** on_conflict condition type for table "account_role" */
export type Account_Role_On_Conflict = {
  constraint: Account_Role_Constraint;
  update_columns?: Array<Account_Role_Update_Column>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "account_role". */
export type Account_Role_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account_role */
export type Account_Role_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "account_role" */
export enum Account_Role_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "account_role" */
export type Account_Role_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['role']>;
};

/** Streaming cursor of the table "account_role" */
export type Account_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Role_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Scalars['role']>;
};

/** update columns of table "account_role" */
export enum Account_Role_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role'
}

export type Account_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Role_Bool_Exp;
};

/** select columns of table "account" */
export enum Account_Select_Column {
  /** column name */
  AccessSalary = 'access_salary',
  /** column name */
  AcqSession = 'acq_session',
  /** column name */
  Active = 'active',
  /** column name */
  City = 'city',
  /** column name */
  Claimed = 'claimed',
  /** column name */
  ConfirmationAttempts = 'confirmation_attempts',
  /** column name */
  ConfirmationSentAt = 'confirmation_sent_at',
  /** column name */
  ConfirmedEmail = 'confirmed_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HideSearchInstructions = 'hide_search_instructions',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityProviderId = 'identity_provider_id',
  /** column name */
  LastAccess = 'last_access',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Location = 'location',
  /** column name */
  NotifyNewTrainingSurvey = 'notify_new_training_survey',
  /** column name */
  OnboardingTourCompleted = 'onboarding_tour_completed',
  /** column name */
  Password = 'password',
  /** column name */
  PendingEmail = 'pending_email',
  /** column name */
  Phone = 'phone',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Premade = 'premade',
  /** column name */
  Referral = 'referral',
  /** column name */
  ReferrerId = 'referrer_id',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Superuser = 'superuser',
  /** column name */
  Type = 'type',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmId = 'utm_id',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  UtmTerm = 'utm_term',
  /** column name */
  Zipcode = 'zipcode'
}

/** select "account_aggregate_bool_exp_bool_and_arguments_columns" columns of table "account" */
export enum Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AccessSalary = 'access_salary',
  /** column name */
  AcqSession = 'acq_session',
  /** column name */
  Active = 'active',
  /** column name */
  Claimed = 'claimed',
  /** column name */
  ConfirmedEmail = 'confirmed_email',
  /** column name */
  HideSearchInstructions = 'hide_search_instructions',
  /** column name */
  NotifyNewTrainingSurvey = 'notify_new_training_survey',
  /** column name */
  OnboardingTourCompleted = 'onboarding_tour_completed',
  /** column name */
  Premade = 'premade',
  /** column name */
  Superuser = 'superuser'
}

/** select "account_aggregate_bool_exp_bool_or_arguments_columns" columns of table "account" */
export enum Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AccessSalary = 'access_salary',
  /** column name */
  AcqSession = 'acq_session',
  /** column name */
  Active = 'active',
  /** column name */
  Claimed = 'claimed',
  /** column name */
  ConfirmedEmail = 'confirmed_email',
  /** column name */
  HideSearchInstructions = 'hide_search_instructions',
  /** column name */
  NotifyNewTrainingSurvey = 'notify_new_training_survey',
  /** column name */
  OnboardingTourCompleted = 'onboarding_tour_completed',
  /** column name */
  Premade = 'premade',
  /** column name */
  Superuser = 'superuser'
}

/** input type for updating data in table "account" */
export type Account_Set_Input = {
  access_salary?: InputMaybe<Scalars['Boolean']>;
  acq_session?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  hide_search_instructions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_provider_id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
  last_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  notify_new_training_survey?: InputMaybe<Scalars['Boolean']>;
  onboarding_tour_completed?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
  premade?: InputMaybe<Scalars['Boolean']>;
  referral?: InputMaybe<Scalars['String']>;
  referrer_id?: InputMaybe<Scalars['uuid']>;
  registered_at?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  superuser?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['accounttype']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Account_Stddev_Fields = {
  __typename?: 'account_stddev_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account" */
export type Account_Stddev_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Stddev_Pop_Fields = {
  __typename?: 'account_stddev_pop_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "account" */
export type Account_Stddev_Pop_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Stddev_Samp_Fields = {
  __typename?: 'account_stddev_samp_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "account" */
export type Account_Stddev_Samp_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account" */
export type Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Stream_Cursor_Value_Input = {
  access_salary?: InputMaybe<Scalars['Boolean']>;
  acq_session?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hide_search_instructions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_provider_id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
  last_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  notify_new_training_survey?: InputMaybe<Scalars['Boolean']>;
  onboarding_tour_completed?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
  premade?: InputMaybe<Scalars['Boolean']>;
  referral?: InputMaybe<Scalars['String']>;
  referrer_id?: InputMaybe<Scalars['uuid']>;
  registered_at?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  superuser?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['accounttype']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Account_Sum_Fields = {
  __typename?: 'account_sum_fields';
  confirmation_attempts: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "account" */
export type Account_Sum_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** update columns of table "account" */
export enum Account_Update_Column {
  /** column name */
  AccessSalary = 'access_salary',
  /** column name */
  AcqSession = 'acq_session',
  /** column name */
  Active = 'active',
  /** column name */
  City = 'city',
  /** column name */
  Claimed = 'claimed',
  /** column name */
  ConfirmationAttempts = 'confirmation_attempts',
  /** column name */
  ConfirmationSentAt = 'confirmation_sent_at',
  /** column name */
  ConfirmedEmail = 'confirmed_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HideSearchInstructions = 'hide_search_instructions',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityProviderId = 'identity_provider_id',
  /** column name */
  LastAccess = 'last_access',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Location = 'location',
  /** column name */
  NotifyNewTrainingSurvey = 'notify_new_training_survey',
  /** column name */
  OnboardingTourCompleted = 'onboarding_tour_completed',
  /** column name */
  Password = 'password',
  /** column name */
  PendingEmail = 'pending_email',
  /** column name */
  Phone = 'phone',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Premade = 'premade',
  /** column name */
  Referral = 'referral',
  /** column name */
  ReferrerId = 'referrer_id',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Superuser = 'superuser',
  /** column name */
  Type = 'type',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmId = 'utm_id',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  UtmTerm = 'utm_term',
  /** column name */
  Zipcode = 'zipcode'
}

export type Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Var_Pop_Fields = {
  __typename?: 'account_var_pop_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "account" */
export type Account_Var_Pop_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Var_Samp_Fields = {
  __typename?: 'account_var_samp_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "account" */
export type Account_Var_Samp_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Variance_Fields = {
  __typename?: 'account_variance_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account" */
export type Account_Variance_Order_By = {
  confirmation_attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "accounttype". All fields are combined with logical 'AND'. */
export type Accounttype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['accounttype']>;
  _gt?: InputMaybe<Scalars['accounttype']>;
  _gte?: InputMaybe<Scalars['accounttype']>;
  _in?: InputMaybe<Array<Scalars['accounttype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['accounttype']>;
  _lte?: InputMaybe<Scalars['accounttype']>;
  _neq?: InputMaybe<Scalars['accounttype']>;
  _nin?: InputMaybe<Array<Scalars['accounttype']>>;
};

/** columns and relationships of "acep_org_survey" */
export type Acep_Org_Survey = {
  __typename?: 'acep_org_survey';
  accepted_at: Maybe<Scalars['timestamp']>;
  accepted_by_id: Maybe<Scalars['uuid']>;
  acep_policies: Array<Scalars['String']>;
  apps: Scalars['String'];
  apps_unsupervised: Scalars['String'];
  billing_disclosure: Scalars['String'];
  ceo_is_physician: Scalars['String'];
  city: Scalars['String'];
  contract_owner: Array<Scalars['String']>;
  created_at: Scalars['timestamp'];
  dba: Scalars['String'];
  email_admin: Scalars['String'];
  email_cmo: Scalars['String'];
  funding: Array<Scalars['String']>;
  geographic_dist: Scalars['String'];
  governance: Array<Scalars['String']>;
  id: Scalars['uuid'];
  name_admin: Scalars['String'];
  name_cmo: Scalars['String'];
  num_em_physicians: Scalars['String'];
  /** An object relationship */
  org: Maybe<Organization>;
  org_id: Maybe<Scalars['uuid']>;
  org_name: Scalars['String'];
  partnerships_offered: Scalars['String'];
  phone: Scalars['String'];
  practice_size: Scalars['String'];
  staffing: Array<Scalars['String']>;
  state: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2: Scalars['String'];
  tin: Scalars['String'];
  website: Scalars['String'];
  zipcode: Scalars['String'];
};

/** aggregated selection of "acep_org_survey" */
export type Acep_Org_Survey_Aggregate = {
  __typename?: 'acep_org_survey_aggregate';
  aggregate: Maybe<Acep_Org_Survey_Aggregate_Fields>;
  nodes: Array<Acep_Org_Survey>;
};

export type Acep_Org_Survey_Aggregate_Bool_Exp = {
  count?: InputMaybe<Acep_Org_Survey_Aggregate_Bool_Exp_Count>;
};

export type Acep_Org_Survey_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "acep_org_survey" */
export type Acep_Org_Survey_Aggregate_Fields = {
  __typename?: 'acep_org_survey_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Acep_Org_Survey_Max_Fields>;
  min: Maybe<Acep_Org_Survey_Min_Fields>;
};


/** aggregate fields of "acep_org_survey" */
export type Acep_Org_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "acep_org_survey" */
export type Acep_Org_Survey_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Acep_Org_Survey_Max_Order_By>;
  min?: InputMaybe<Acep_Org_Survey_Min_Order_By>;
};

/** input type for inserting array relation for remote table "acep_org_survey" */
export type Acep_Org_Survey_Arr_Rel_Insert_Input = {
  data: Array<Acep_Org_Survey_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Acep_Org_Survey_On_Conflict>;
};

/** Boolean expression to filter rows from the table "acep_org_survey". All fields are combined with a logical 'AND'. */
export type Acep_Org_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Acep_Org_Survey_Bool_Exp>>;
  _not?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Acep_Org_Survey_Bool_Exp>>;
  accepted_at?: InputMaybe<Timestamp_Comparison_Exp>;
  accepted_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  acep_policies?: InputMaybe<String_Array_Comparison_Exp>;
  apps?: InputMaybe<String_Comparison_Exp>;
  apps_unsupervised?: InputMaybe<String_Comparison_Exp>;
  billing_disclosure?: InputMaybe<String_Comparison_Exp>;
  ceo_is_physician?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  contract_owner?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  dba?: InputMaybe<String_Comparison_Exp>;
  email_admin?: InputMaybe<String_Comparison_Exp>;
  email_cmo?: InputMaybe<String_Comparison_Exp>;
  funding?: InputMaybe<String_Array_Comparison_Exp>;
  geographic_dist?: InputMaybe<String_Comparison_Exp>;
  governance?: InputMaybe<String_Array_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name_admin?: InputMaybe<String_Comparison_Exp>;
  name_cmo?: InputMaybe<String_Comparison_Exp>;
  num_em_physicians?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  org_name?: InputMaybe<String_Comparison_Exp>;
  partnerships_offered?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  practice_size?: InputMaybe<String_Comparison_Exp>;
  staffing?: InputMaybe<String_Array_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  tin?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "acep_org_survey" */
export enum Acep_Org_Survey_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkAcepOrgSurvey = 'pk_acep_org_survey'
}

/** input type for inserting data into table "acep_org_survey" */
export type Acep_Org_Survey_Insert_Input = {
  accepted_at?: InputMaybe<Scalars['timestamp']>;
  accepted_by_id?: InputMaybe<Scalars['uuid']>;
  acep_policies?: InputMaybe<Array<Scalars['String']>>;
  apps?: InputMaybe<Scalars['String']>;
  apps_unsupervised?: InputMaybe<Scalars['String']>;
  billing_disclosure?: InputMaybe<Scalars['String']>;
  ceo_is_physician?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contract_owner?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dba?: InputMaybe<Scalars['String']>;
  email_admin?: InputMaybe<Scalars['String']>;
  email_cmo?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Array<Scalars['String']>>;
  geographic_dist?: InputMaybe<Scalars['String']>;
  governance?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['uuid']>;
  name_admin?: InputMaybe<Scalars['String']>;
  name_cmo?: InputMaybe<Scalars['String']>;
  num_em_physicians?: InputMaybe<Scalars['String']>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_name?: InputMaybe<Scalars['String']>;
  partnerships_offered?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  practice_size?: InputMaybe<Scalars['String']>;
  staffing?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Acep_Org_Survey_Max_Fields = {
  __typename?: 'acep_org_survey_max_fields';
  accepted_at: Maybe<Scalars['timestamp']>;
  accepted_by_id: Maybe<Scalars['uuid']>;
  acep_policies: Maybe<Array<Scalars['String']>>;
  apps: Maybe<Scalars['String']>;
  apps_unsupervised: Maybe<Scalars['String']>;
  billing_disclosure: Maybe<Scalars['String']>;
  ceo_is_physician: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  contract_owner: Maybe<Array<Scalars['String']>>;
  created_at: Maybe<Scalars['timestamp']>;
  dba: Maybe<Scalars['String']>;
  email_admin: Maybe<Scalars['String']>;
  email_cmo: Maybe<Scalars['String']>;
  funding: Maybe<Array<Scalars['String']>>;
  geographic_dist: Maybe<Scalars['String']>;
  governance: Maybe<Array<Scalars['String']>>;
  id: Maybe<Scalars['uuid']>;
  name_admin: Maybe<Scalars['String']>;
  name_cmo: Maybe<Scalars['String']>;
  num_em_physicians: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
  org_name: Maybe<Scalars['String']>;
  partnerships_offered: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  practice_size: Maybe<Scalars['String']>;
  staffing: Maybe<Array<Scalars['String']>>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  tin: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "acep_org_survey" */
export type Acep_Org_Survey_Max_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  accepted_by_id?: InputMaybe<Order_By>;
  acep_policies?: InputMaybe<Order_By>;
  apps?: InputMaybe<Order_By>;
  apps_unsupervised?: InputMaybe<Order_By>;
  billing_disclosure?: InputMaybe<Order_By>;
  ceo_is_physician?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contract_owner?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dba?: InputMaybe<Order_By>;
  email_admin?: InputMaybe<Order_By>;
  email_cmo?: InputMaybe<Order_By>;
  funding?: InputMaybe<Order_By>;
  geographic_dist?: InputMaybe<Order_By>;
  governance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_admin?: InputMaybe<Order_By>;
  name_cmo?: InputMaybe<Order_By>;
  num_em_physicians?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_name?: InputMaybe<Order_By>;
  partnerships_offered?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  practice_size?: InputMaybe<Order_By>;
  staffing?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  tin?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Acep_Org_Survey_Min_Fields = {
  __typename?: 'acep_org_survey_min_fields';
  accepted_at: Maybe<Scalars['timestamp']>;
  accepted_by_id: Maybe<Scalars['uuid']>;
  acep_policies: Maybe<Array<Scalars['String']>>;
  apps: Maybe<Scalars['String']>;
  apps_unsupervised: Maybe<Scalars['String']>;
  billing_disclosure: Maybe<Scalars['String']>;
  ceo_is_physician: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  contract_owner: Maybe<Array<Scalars['String']>>;
  created_at: Maybe<Scalars['timestamp']>;
  dba: Maybe<Scalars['String']>;
  email_admin: Maybe<Scalars['String']>;
  email_cmo: Maybe<Scalars['String']>;
  funding: Maybe<Array<Scalars['String']>>;
  geographic_dist: Maybe<Scalars['String']>;
  governance: Maybe<Array<Scalars['String']>>;
  id: Maybe<Scalars['uuid']>;
  name_admin: Maybe<Scalars['String']>;
  name_cmo: Maybe<Scalars['String']>;
  num_em_physicians: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
  org_name: Maybe<Scalars['String']>;
  partnerships_offered: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  practice_size: Maybe<Scalars['String']>;
  staffing: Maybe<Array<Scalars['String']>>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  tin: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "acep_org_survey" */
export type Acep_Org_Survey_Min_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  accepted_by_id?: InputMaybe<Order_By>;
  acep_policies?: InputMaybe<Order_By>;
  apps?: InputMaybe<Order_By>;
  apps_unsupervised?: InputMaybe<Order_By>;
  billing_disclosure?: InputMaybe<Order_By>;
  ceo_is_physician?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contract_owner?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dba?: InputMaybe<Order_By>;
  email_admin?: InputMaybe<Order_By>;
  email_cmo?: InputMaybe<Order_By>;
  funding?: InputMaybe<Order_By>;
  geographic_dist?: InputMaybe<Order_By>;
  governance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_admin?: InputMaybe<Order_By>;
  name_cmo?: InputMaybe<Order_By>;
  num_em_physicians?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_name?: InputMaybe<Order_By>;
  partnerships_offered?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  practice_size?: InputMaybe<Order_By>;
  staffing?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  tin?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "acep_org_survey" */
export type Acep_Org_Survey_Mutation_Response = {
  __typename?: 'acep_org_survey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Acep_Org_Survey>;
};

/** on_conflict condition type for table "acep_org_survey" */
export type Acep_Org_Survey_On_Conflict = {
  constraint: Acep_Org_Survey_Constraint;
  update_columns?: Array<Acep_Org_Survey_Update_Column>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};

/** Ordering options when selecting data from "acep_org_survey". */
export type Acep_Org_Survey_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  accepted_by_id?: InputMaybe<Order_By>;
  acep_policies?: InputMaybe<Order_By>;
  apps?: InputMaybe<Order_By>;
  apps_unsupervised?: InputMaybe<Order_By>;
  billing_disclosure?: InputMaybe<Order_By>;
  ceo_is_physician?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contract_owner?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dba?: InputMaybe<Order_By>;
  email_admin?: InputMaybe<Order_By>;
  email_cmo?: InputMaybe<Order_By>;
  funding?: InputMaybe<Order_By>;
  geographic_dist?: InputMaybe<Order_By>;
  governance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name_admin?: InputMaybe<Order_By>;
  name_cmo?: InputMaybe<Order_By>;
  num_em_physicians?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_name?: InputMaybe<Order_By>;
  partnerships_offered?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  practice_size?: InputMaybe<Order_By>;
  staffing?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  tin?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: acep_org_survey */
export type Acep_Org_Survey_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "acep_org_survey" */
export enum Acep_Org_Survey_Select_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  AcceptedById = 'accepted_by_id',
  /** column name */
  AcepPolicies = 'acep_policies',
  /** column name */
  Apps = 'apps',
  /** column name */
  AppsUnsupervised = 'apps_unsupervised',
  /** column name */
  BillingDisclosure = 'billing_disclosure',
  /** column name */
  CeoIsPhysician = 'ceo_is_physician',
  /** column name */
  City = 'city',
  /** column name */
  ContractOwner = 'contract_owner',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dba = 'dba',
  /** column name */
  EmailAdmin = 'email_admin',
  /** column name */
  EmailCmo = 'email_cmo',
  /** column name */
  Funding = 'funding',
  /** column name */
  GeographicDist = 'geographic_dist',
  /** column name */
  Governance = 'governance',
  /** column name */
  Id = 'id',
  /** column name */
  NameAdmin = 'name_admin',
  /** column name */
  NameCmo = 'name_cmo',
  /** column name */
  NumEmPhysicians = 'num_em_physicians',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgName = 'org_name',
  /** column name */
  PartnershipsOffered = 'partnerships_offered',
  /** column name */
  Phone = 'phone',
  /** column name */
  PracticeSize = 'practice_size',
  /** column name */
  Staffing = 'staffing',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Tin = 'tin',
  /** column name */
  Website = 'website',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "acep_org_survey" */
export type Acep_Org_Survey_Set_Input = {
  accepted_at?: InputMaybe<Scalars['timestamp']>;
  accepted_by_id?: InputMaybe<Scalars['uuid']>;
  acep_policies?: InputMaybe<Array<Scalars['String']>>;
  apps?: InputMaybe<Scalars['String']>;
  apps_unsupervised?: InputMaybe<Scalars['String']>;
  billing_disclosure?: InputMaybe<Scalars['String']>;
  ceo_is_physician?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contract_owner?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dba?: InputMaybe<Scalars['String']>;
  email_admin?: InputMaybe<Scalars['String']>;
  email_cmo?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Array<Scalars['String']>>;
  geographic_dist?: InputMaybe<Scalars['String']>;
  governance?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['uuid']>;
  name_admin?: InputMaybe<Scalars['String']>;
  name_cmo?: InputMaybe<Scalars['String']>;
  num_em_physicians?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_name?: InputMaybe<Scalars['String']>;
  partnerships_offered?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  practice_size?: InputMaybe<Scalars['String']>;
  staffing?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "acep_org_survey" */
export type Acep_Org_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Acep_Org_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Acep_Org_Survey_Stream_Cursor_Value_Input = {
  accepted_at?: InputMaybe<Scalars['timestamp']>;
  accepted_by_id?: InputMaybe<Scalars['uuid']>;
  acep_policies?: InputMaybe<Array<Scalars['String']>>;
  apps?: InputMaybe<Scalars['String']>;
  apps_unsupervised?: InputMaybe<Scalars['String']>;
  billing_disclosure?: InputMaybe<Scalars['String']>;
  ceo_is_physician?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contract_owner?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  dba?: InputMaybe<Scalars['String']>;
  email_admin?: InputMaybe<Scalars['String']>;
  email_cmo?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<Array<Scalars['String']>>;
  geographic_dist?: InputMaybe<Scalars['String']>;
  governance?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['uuid']>;
  name_admin?: InputMaybe<Scalars['String']>;
  name_cmo?: InputMaybe<Scalars['String']>;
  num_em_physicians?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_name?: InputMaybe<Scalars['String']>;
  partnerships_offered?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  practice_size?: InputMaybe<Scalars['String']>;
  staffing?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  tin?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "acep_org_survey" */
export enum Acep_Org_Survey_Update_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  AcceptedById = 'accepted_by_id',
  /** column name */
  AcepPolicies = 'acep_policies',
  /** column name */
  Apps = 'apps',
  /** column name */
  AppsUnsupervised = 'apps_unsupervised',
  /** column name */
  BillingDisclosure = 'billing_disclosure',
  /** column name */
  CeoIsPhysician = 'ceo_is_physician',
  /** column name */
  City = 'city',
  /** column name */
  ContractOwner = 'contract_owner',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Dba = 'dba',
  /** column name */
  EmailAdmin = 'email_admin',
  /** column name */
  EmailCmo = 'email_cmo',
  /** column name */
  Funding = 'funding',
  /** column name */
  GeographicDist = 'geographic_dist',
  /** column name */
  Governance = 'governance',
  /** column name */
  Id = 'id',
  /** column name */
  NameAdmin = 'name_admin',
  /** column name */
  NameCmo = 'name_cmo',
  /** column name */
  NumEmPhysicians = 'num_em_physicians',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgName = 'org_name',
  /** column name */
  PartnershipsOffered = 'partnerships_offered',
  /** column name */
  Phone = 'phone',
  /** column name */
  PracticeSize = 'practice_size',
  /** column name */
  Staffing = 'staffing',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Tin = 'tin',
  /** column name */
  Website = 'website',
  /** column name */
  Zipcode = 'zipcode'
}

export type Acep_Org_Survey_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Acep_Org_Survey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Acep_Org_Survey_Bool_Exp;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "board" */
export type Board = {
  __typename?: 'board';
  /** An object relationship */
  cert_org: Cert_Org;
  cert_org_id: Scalars['uuid'];
  /** An array relationship */
  certs: Array<Board_Cert>;
  /** An aggregate relationship */
  certs_aggregate: Board_Cert_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "board" */
export type BoardCertsArgs = {
  distinct_on?: InputMaybe<Array<Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Cert_Order_By>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};


/** columns and relationships of "board" */
export type BoardCerts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Cert_Order_By>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};

/** aggregated selection of "board" */
export type Board_Aggregate = {
  __typename?: 'board_aggregate';
  aggregate: Maybe<Board_Aggregate_Fields>;
  nodes: Array<Board>;
};

export type Board_Aggregate_Bool_Exp = {
  count?: InputMaybe<Board_Aggregate_Bool_Exp_Count>;
};

export type Board_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Board_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Board_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "board" */
export type Board_Aggregate_Fields = {
  __typename?: 'board_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Board_Max_Fields>;
  min: Maybe<Board_Min_Fields>;
};


/** aggregate fields of "board" */
export type Board_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "board" */
export type Board_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Board_Max_Order_By>;
  min?: InputMaybe<Board_Min_Order_By>;
};

/** input type for inserting array relation for remote table "board" */
export type Board_Arr_Rel_Insert_Input = {
  data: Array<Board_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_On_Conflict>;
};

/** Boolean expression to filter rows from the table "board". All fields are combined with a logical 'AND'. */
export type Board_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Bool_Exp>>;
  _not?: InputMaybe<Board_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Bool_Exp>>;
  cert_org?: InputMaybe<Cert_Org_Bool_Exp>;
  cert_org_id?: InputMaybe<Uuid_Comparison_Exp>;
  certs?: InputMaybe<Board_Cert_Bool_Exp>;
  certs_aggregate?: InputMaybe<Board_Cert_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "board_cert" */
export type Board_Cert = {
  __typename?: 'board_cert';
  /** An object relationship */
  board: Board;
  board_id: Scalars['uuid'];
  field: Scalars['String'];
  field_type: Scalars['fieldtype'];
  id: Scalars['uuid'];
};

/** aggregated selection of "board_cert" */
export type Board_Cert_Aggregate = {
  __typename?: 'board_cert_aggregate';
  aggregate: Maybe<Board_Cert_Aggregate_Fields>;
  nodes: Array<Board_Cert>;
};

export type Board_Cert_Aggregate_Bool_Exp = {
  count?: InputMaybe<Board_Cert_Aggregate_Bool_Exp_Count>;
};

export type Board_Cert_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Board_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Board_Cert_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "board_cert" */
export type Board_Cert_Aggregate_Fields = {
  __typename?: 'board_cert_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Board_Cert_Max_Fields>;
  min: Maybe<Board_Cert_Min_Fields>;
};


/** aggregate fields of "board_cert" */
export type Board_Cert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Board_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "board_cert" */
export type Board_Cert_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Board_Cert_Max_Order_By>;
  min?: InputMaybe<Board_Cert_Min_Order_By>;
};

/** input type for inserting array relation for remote table "board_cert" */
export type Board_Cert_Arr_Rel_Insert_Input = {
  data: Array<Board_Cert_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Cert_On_Conflict>;
};

/** Boolean expression to filter rows from the table "board_cert". All fields are combined with a logical 'AND'. */
export type Board_Cert_Bool_Exp = {
  _and?: InputMaybe<Array<Board_Cert_Bool_Exp>>;
  _not?: InputMaybe<Board_Cert_Bool_Exp>;
  _or?: InputMaybe<Array<Board_Cert_Bool_Exp>>;
  board?: InputMaybe<Board_Bool_Exp>;
  board_id?: InputMaybe<Uuid_Comparison_Exp>;
  field?: InputMaybe<String_Comparison_Exp>;
  field_type?: InputMaybe<Fieldtype_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "board_cert" */
export enum Board_Cert_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkBoardCert = 'pk_board_cert',
  /** unique or primary key constraint on columns "field_type", "board_id", "field" */
  UqBoardCertBoardIdFieldFieldType = 'uq_board_cert_board_id_field_field_type'
}

/** input type for inserting data into table "board_cert" */
export type Board_Cert_Insert_Input = {
  board?: InputMaybe<Board_Obj_Rel_Insert_Input>;
  board_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  field_type?: InputMaybe<Scalars['fieldtype']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Board_Cert_Max_Fields = {
  __typename?: 'board_cert_max_fields';
  board_id: Maybe<Scalars['uuid']>;
  field: Maybe<Scalars['String']>;
  field_type: Maybe<Scalars['fieldtype']>;
  id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "board_cert" */
export type Board_Cert_Max_Order_By = {
  board_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Board_Cert_Min_Fields = {
  __typename?: 'board_cert_min_fields';
  board_id: Maybe<Scalars['uuid']>;
  field: Maybe<Scalars['String']>;
  field_type: Maybe<Scalars['fieldtype']>;
  id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "board_cert" */
export type Board_Cert_Min_Order_By = {
  board_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "board_cert" */
export type Board_Cert_Mutation_Response = {
  __typename?: 'board_cert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Board_Cert>;
};

/** input type for inserting object relation for remote table "board_cert" */
export type Board_Cert_Obj_Rel_Insert_Input = {
  data: Board_Cert_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_Cert_On_Conflict>;
};

/** on_conflict condition type for table "board_cert" */
export type Board_Cert_On_Conflict = {
  constraint: Board_Cert_Constraint;
  update_columns?: Array<Board_Cert_Update_Column>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};

/** Ordering options when selecting data from "board_cert". */
export type Board_Cert_Order_By = {
  board?: InputMaybe<Board_Order_By>;
  board_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  field_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board_cert */
export type Board_Cert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "board_cert" */
export enum Board_Cert_Select_Column {
  /** column name */
  BoardId = 'board_id',
  /** column name */
  Field = 'field',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "board_cert" */
export type Board_Cert_Set_Input = {
  board_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  field_type?: InputMaybe<Scalars['fieldtype']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "board_cert" */
export type Board_Cert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Cert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Cert_Stream_Cursor_Value_Input = {
  board_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  field_type?: InputMaybe<Scalars['fieldtype']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "board_cert" */
export enum Board_Cert_Update_Column {
  /** column name */
  BoardId = 'board_id',
  /** column name */
  Field = 'field',
  /** column name */
  FieldType = 'field_type',
  /** column name */
  Id = 'id'
}

export type Board_Cert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Cert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Cert_Bool_Exp;
};

/** unique or primary key constraints on table "board" */
export enum Board_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkBoard = 'pk_board',
  /** unique or primary key constraint on columns "name", "cert_org_id" */
  UqBoardCertOrgIdName = 'uq_board_cert_org_id_name'
}

/** input type for inserting data into table "board" */
export type Board_Insert_Input = {
  cert_org?: InputMaybe<Cert_Org_Obj_Rel_Insert_Input>;
  cert_org_id?: InputMaybe<Scalars['uuid']>;
  certs?: InputMaybe<Board_Cert_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Board_Max_Fields = {
  __typename?: 'board_max_fields';
  cert_org_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "board" */
export type Board_Max_Order_By = {
  cert_org_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Board_Min_Fields = {
  __typename?: 'board_min_fields';
  cert_org_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "board" */
export type Board_Min_Order_By = {
  cert_org_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "board" */
export type Board_Mutation_Response = {
  __typename?: 'board_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Board>;
};

/** input type for inserting object relation for remote table "board" */
export type Board_Obj_Rel_Insert_Input = {
  data: Board_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Board_On_Conflict>;
};

/** on_conflict condition type for table "board" */
export type Board_On_Conflict = {
  constraint: Board_Constraint;
  update_columns?: Array<Board_Update_Column>;
  where?: InputMaybe<Board_Bool_Exp>;
};

/** Ordering options when selecting data from "board". */
export type Board_Order_By = {
  cert_org?: InputMaybe<Cert_Org_Order_By>;
  cert_org_id?: InputMaybe<Order_By>;
  certs_aggregate?: InputMaybe<Board_Cert_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: board */
export type Board_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "board" */
export enum Board_Select_Column {
  /** column name */
  CertOrgId = 'cert_org_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "board" */
export type Board_Set_Input = {
  cert_org_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "board" */
export type Board_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Board_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Board_Stream_Cursor_Value_Input = {
  cert_org_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "board" */
export enum Board_Update_Column {
  /** column name */
  CertOrgId = 'cert_org_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Board_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Board_Set_Input>;
  /** filter the rows which have to be updated */
  where: Board_Bool_Exp;
};

/** columns and relationships of "analytics.facility_map_perf_90" */
export type Bqanalytics_Facility_Map_Perf_90 = {
  __typename?: 'bqanalytics_facility_map_perf_90';
  impressions: Maybe<Scalars['Int']>;
  visitors: Maybe<Scalars['Int']>;
};

/** aggregated selection of "analytics.facility_map_perf_90" */
export type Bqanalytics_Facility_Map_Perf_90_Aggregate = {
  __typename?: 'bqanalytics_facility_map_perf_90_aggregate';
  aggregate: Maybe<Bqanalytics_Facility_Map_Perf_90_Aggregate_Fields>;
  nodes: Array<Bqanalytics_Facility_Map_Perf_90>;
};

/** aggregate fields of "analytics.facility_map_perf_90" */
export type Bqanalytics_Facility_Map_Perf_90_Aggregate_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_aggregate_fields';
  avg: Maybe<Bqanalytics_Facility_Map_Perf_90_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Bqanalytics_Facility_Map_Perf_90_Max_Fields>;
  min: Maybe<Bqanalytics_Facility_Map_Perf_90_Min_Fields>;
  stddev: Maybe<Bqanalytics_Facility_Map_Perf_90_Stddev_Fields>;
  stddev_pop: Maybe<Bqanalytics_Facility_Map_Perf_90_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Bqanalytics_Facility_Map_Perf_90_Stddev_Samp_Fields>;
  sum: Maybe<Bqanalytics_Facility_Map_Perf_90_Sum_Fields>;
  var_pop: Maybe<Bqanalytics_Facility_Map_Perf_90_Var_Pop_Fields>;
  var_samp: Maybe<Bqanalytics_Facility_Map_Perf_90_Var_Samp_Fields>;
  variance: Maybe<Bqanalytics_Facility_Map_Perf_90_Variance_Fields>;
};


/** aggregate fields of "analytics.facility_map_perf_90" */
export type Bqanalytics_Facility_Map_Perf_90_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Bqanalytics_Facility_Map_Perf_90_Avg_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_avg_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "analytics.facility_map_perf_90". All fields are combined with a logical 'AND'. */
export type Bqanalytics_Facility_Map_Perf_90_Bool_Exp = {
  _and?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>>;
  _not?: InputMaybe<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>;
  _or?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>>;
  impressions?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  visitors?: InputMaybe<Int_BigQuery_Comparison_Exp>;
};

/** aggregate max on columns */
export type Bqanalytics_Facility_Map_Perf_90_Max_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_max_fields';
  impressions: Maybe<Scalars['Int']>;
  visitors: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Bqanalytics_Facility_Map_Perf_90_Min_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_min_fields';
  impressions: Maybe<Scalars['Int']>;
  visitors: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "analytics.facility_map_perf_90". */
export type Bqanalytics_Facility_Map_Perf_90_Order_By = {
  impressions?: InputMaybe<Order_By>;
  visitors?: InputMaybe<Order_By>;
};

/** select columns of table "analytics.facility_map_perf_90" */
export enum Bqanalytics_Facility_Map_Perf_90_Select_Column {
  /** column name */
  Impressions = 'impressions',
  /** column name */
  Visitors = 'visitors'
}

/** aggregate stddev on columns */
export type Bqanalytics_Facility_Map_Perf_90_Stddev_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_stddev_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bqanalytics_Facility_Map_Perf_90_Stddev_Pop_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_stddev_pop_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bqanalytics_Facility_Map_Perf_90_Stddev_Samp_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_stddev_samp_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Bqanalytics_Facility_Map_Perf_90_Sum_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_sum_fields';
  impressions: Maybe<Scalars['Int']>;
  visitors: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Bqanalytics_Facility_Map_Perf_90_Var_Pop_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_var_pop_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bqanalytics_Facility_Map_Perf_90_Var_Samp_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_var_samp_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bqanalytics_Facility_Map_Perf_90_Variance_Fields = {
  __typename?: 'bqanalytics_facility_map_perf_90_variance_fields';
  impressions: Maybe<Scalars['Float']>;
  visitors: Maybe<Scalars['Float']>;
};

/** columns and relationships of "analytics.facility_map_state_impressions_90" */
export type Bqanalytics_Facility_Map_State_Impressions_90 = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** aggregated selection of "analytics.facility_map_state_impressions_90" */
export type Bqanalytics_Facility_Map_State_Impressions_90_Aggregate = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_aggregate';
  aggregate: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Aggregate_Fields>;
  nodes: Array<Bqanalytics_Facility_Map_State_Impressions_90>;
};

/** aggregate fields of "analytics.facility_map_state_impressions_90" */
export type Bqanalytics_Facility_Map_State_Impressions_90_Aggregate_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_aggregate_fields';
  avg: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Max_Fields>;
  min: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Min_Fields>;
  stddev: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Stddev_Fields>;
  stddev_pop: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Stddev_Samp_Fields>;
  sum: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Sum_Fields>;
  var_pop: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Var_Pop_Fields>;
  var_samp: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Var_Samp_Fields>;
  variance: Maybe<Bqanalytics_Facility_Map_State_Impressions_90_Variance_Fields>;
};


/** aggregate fields of "analytics.facility_map_state_impressions_90" */
export type Bqanalytics_Facility_Map_State_Impressions_90_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Avg_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_avg_fields';
  count: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "analytics.facility_map_state_impressions_90". All fields are combined with a logical 'AND'. */
export type Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp = {
  _and?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>>;
  _not?: InputMaybe<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>;
  _or?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>>;
  count?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  id?: InputMaybe<String_BigQuery_Comparison_Exp>;
  name?: InputMaybe<String_BigQuery_Comparison_Exp>;
};

/** aggregate max on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Max_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_max_fields';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Min_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_min_fields';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "analytics.facility_map_state_impressions_90". */
export type Bqanalytics_Facility_Map_State_Impressions_90_Order_By = {
  count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "analytics.facility_map_state_impressions_90" */
export enum Bqanalytics_Facility_Map_State_Impressions_90_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** aggregate stddev on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Stddev_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_stddev_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Stddev_Pop_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_stddev_pop_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Stddev_Samp_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_stddev_samp_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Sum_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_sum_fields';
  count: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Var_Pop_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_var_pop_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Var_Samp_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_var_samp_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bqanalytics_Facility_Map_State_Impressions_90_Variance_Fields = {
  __typename?: 'bqanalytics_facility_map_state_impressions_90_variance_fields';
  count: Maybe<Scalars['Float']>;
};

/** columns and relationships of "analytics.job_posting_impressions" */
export type Bqanalytics_Job_Posting_Impressions = {
  __typename?: 'bqanalytics_job_posting_impressions';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
  job_posting: Maybe<Job_Posting>;
};

/** aggregated selection of "analytics.job_posting_impressions" */
export type Bqanalytics_Job_Posting_Impressions_Aggregate = {
  __typename?: 'bqanalytics_job_posting_impressions_aggregate';
  aggregate: Maybe<Bqanalytics_Job_Posting_Impressions_Aggregate_Fields>;
  nodes: Array<Bqanalytics_Job_Posting_Impressions>;
};

/** aggregate fields of "analytics.job_posting_impressions" */
export type Bqanalytics_Job_Posting_Impressions_Aggregate_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_aggregate_fields';
  avg: Maybe<Bqanalytics_Job_Posting_Impressions_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Bqanalytics_Job_Posting_Impressions_Max_Fields>;
  min: Maybe<Bqanalytics_Job_Posting_Impressions_Min_Fields>;
  stddev: Maybe<Bqanalytics_Job_Posting_Impressions_Stddev_Fields>;
  stddev_pop: Maybe<Bqanalytics_Job_Posting_Impressions_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Bqanalytics_Job_Posting_Impressions_Stddev_Samp_Fields>;
  sum: Maybe<Bqanalytics_Job_Posting_Impressions_Sum_Fields>;
  var_pop: Maybe<Bqanalytics_Job_Posting_Impressions_Var_Pop_Fields>;
  var_samp: Maybe<Bqanalytics_Job_Posting_Impressions_Var_Samp_Fields>;
  variance: Maybe<Bqanalytics_Job_Posting_Impressions_Variance_Fields>;
};


/** aggregate fields of "analytics.job_posting_impressions" */
export type Bqanalytics_Job_Posting_Impressions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Bqanalytics_Job_Posting_Impressions_Avg_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_avg_fields';
  count: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "analytics.job_posting_impressions". All fields are combined with a logical 'AND'. */
export type Bqanalytics_Job_Posting_Impressions_Bool_Exp = {
  _and?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Bool_Exp>>;
  _not?: InputMaybe<Bqanalytics_Job_Posting_Impressions_Bool_Exp>;
  _or?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Bool_Exp>>;
  count?: InputMaybe<Int_BigQuery_Comparison_Exp>;
  id?: InputMaybe<String_BigQuery_Comparison_Exp>;
};

/** aggregate max on columns */
export type Bqanalytics_Job_Posting_Impressions_Max_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_max_fields';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Bqanalytics_Job_Posting_Impressions_Min_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_min_fields';
  count: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "analytics.job_posting_impressions". */
export type Bqanalytics_Job_Posting_Impressions_Order_By = {
  count?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "analytics.job_posting_impressions" */
export enum Bqanalytics_Job_Posting_Impressions_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Bqanalytics_Job_Posting_Impressions_Stddev_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_stddev_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bqanalytics_Job_Posting_Impressions_Stddev_Pop_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_stddev_pop_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bqanalytics_Job_Posting_Impressions_Stddev_Samp_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_stddev_samp_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Bqanalytics_Job_Posting_Impressions_Sum_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_sum_fields';
  count: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Bqanalytics_Job_Posting_Impressions_Var_Pop_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_var_pop_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bqanalytics_Job_Posting_Impressions_Var_Samp_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_var_samp_fields';
  count: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bqanalytics_Job_Posting_Impressions_Variance_Fields = {
  __typename?: 'bqanalytics_job_posting_impressions_variance_fields';
  count: Maybe<Scalars['Float']>;
};

export type Bqbq_Query = {
  __typename?: 'bqbq_query';
  /** fetch data from the table: "analytics.facility_map_perf_90" */
  analytics_facility_map_perf_90: Array<Bqanalytics_Facility_Map_Perf_90>;
  /** fetch aggregated fields from the table: "analytics.facility_map_perf_90" */
  analytics_facility_map_perf_90_aggregate: Bqanalytics_Facility_Map_Perf_90_Aggregate;
  /** fetch data from the table: "analytics.facility_map_state_impressions_90" */
  analytics_facility_map_state_impressions_90: Array<Bqanalytics_Facility_Map_State_Impressions_90>;
  /** fetch aggregated fields from the table: "analytics.facility_map_state_impressions_90" */
  analytics_facility_map_state_impressions_90_aggregate: Bqanalytics_Facility_Map_State_Impressions_90_Aggregate;
  /** fetch data from the table: "analytics.job_posting_impressions" */
  analytics_job_posting_impressions: Array<Bqanalytics_Job_Posting_Impressions>;
  /** fetch aggregated fields from the table: "analytics.job_posting_impressions" */
  analytics_job_posting_impressions_aggregate: Bqanalytics_Job_Posting_Impressions_Aggregate;
};


export type Bqbq_QueryAnalytics_Facility_Map_Perf_90Args = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>;
};


export type Bqbq_QueryAnalytics_Facility_Map_Perf_90_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>;
};


export type Bqbq_QueryAnalytics_Facility_Map_State_Impressions_90Args = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>;
};


export type Bqbq_QueryAnalytics_Facility_Map_State_Impressions_90_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>;
};


export type Bqbq_QueryAnalytics_Job_Posting_ImpressionsArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Order_By>>;
  where?: InputMaybe<Bqanalytics_Job_Posting_Impressions_Bool_Exp>;
};


export type Bqbq_QueryAnalytics_Job_Posting_Impressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Order_By>>;
  where?: InputMaybe<Bqanalytics_Job_Posting_Impressions_Bool_Exp>;
};

export type Bqbq_Subscription = {
  __typename?: 'bqbq_subscription';
  /** fetch data from the table: "analytics.facility_map_perf_90" */
  analytics_facility_map_perf_90: Array<Bqanalytics_Facility_Map_Perf_90>;
  /** fetch aggregated fields from the table: "analytics.facility_map_perf_90" */
  analytics_facility_map_perf_90_aggregate: Bqanalytics_Facility_Map_Perf_90_Aggregate;
  /** fetch data from the table: "analytics.facility_map_state_impressions_90" */
  analytics_facility_map_state_impressions_90: Array<Bqanalytics_Facility_Map_State_Impressions_90>;
  /** fetch aggregated fields from the table: "analytics.facility_map_state_impressions_90" */
  analytics_facility_map_state_impressions_90_aggregate: Bqanalytics_Facility_Map_State_Impressions_90_Aggregate;
  /** fetch data from the table: "analytics.job_posting_impressions" */
  analytics_job_posting_impressions: Array<Bqanalytics_Job_Posting_Impressions>;
  /** fetch aggregated fields from the table: "analytics.job_posting_impressions" */
  analytics_job_posting_impressions_aggregate: Bqanalytics_Job_Posting_Impressions_Aggregate;
};


export type Bqbq_SubscriptionAnalytics_Facility_Map_Perf_90Args = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>;
};


export type Bqbq_SubscriptionAnalytics_Facility_Map_Perf_90_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_Perf_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_Perf_90_Bool_Exp>;
};


export type Bqbq_SubscriptionAnalytics_Facility_Map_State_Impressions_90Args = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>;
};


export type Bqbq_SubscriptionAnalytics_Facility_Map_State_Impressions_90_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Facility_Map_State_Impressions_90_Order_By>>;
  where?: InputMaybe<Bqanalytics_Facility_Map_State_Impressions_90_Bool_Exp>;
};


export type Bqbq_SubscriptionAnalytics_Job_Posting_ImpressionsArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Order_By>>;
  where?: InputMaybe<Bqanalytics_Job_Posting_Impressions_Bool_Exp>;
};


export type Bqbq_SubscriptionAnalytics_Job_Posting_Impressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bqanalytics_Job_Posting_Impressions_Order_By>>;
  where?: InputMaybe<Bqanalytics_Job_Posting_Impressions_Bool_Exp>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']>;
  _gt?: InputMaybe<Scalars['bytea']>;
  _gte?: InputMaybe<Scalars['bytea']>;
  _in?: InputMaybe<Array<Scalars['bytea']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bytea']>;
  _lte?: InputMaybe<Scalars['bytea']>;
  _neq?: InputMaybe<Scalars['bytea']>;
  _nin?: InputMaybe<Array<Scalars['bytea']>>;
};

/** columns and relationships of "candidate" */
export type Candidate = {
  __typename?: 'candidate';
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  /** A computed field, executes function "candidate_has_recent_messages" */
  has_recent_messages: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  /** An array relationship */
  job_application_batches: Array<Job_Application_Batch>;
  /** An aggregate relationship */
  job_application_batches_aggregate: Job_Application_Batch_Aggregate;
  lastAppliedDate: Maybe<Scalars['DateTime']>;
  /** A computed field, executes function "candidate_last_applied" */
  last_applied: Maybe<Scalars['timestamp']>;
  /** A computed field, executes function "candidate_masked_email" */
  masked_email: Maybe<Scalars['String']>;
  /** An object relationship */
  org: Organization;
  org_id: Scalars['uuid'];
};


/** columns and relationships of "candidate" */
export type CandidateHas_Recent_MessagesArgs = {
  args?: InputMaybe<Has_Recent_Messages_Candidate_Args>;
};


/** columns and relationships of "candidate" */
export type CandidateJob_Application_BatchesArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Batch_Order_By>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};


/** columns and relationships of "candidate" */
export type CandidateJob_Application_Batches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Batch_Order_By>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};

/** aggregated selection of "candidate" */
export type Candidate_Aggregate = {
  __typename?: 'candidate_aggregate';
  aggregate: Maybe<Candidate_Aggregate_Fields>;
  nodes: Array<Candidate>;
};

export type Candidate_Aggregate_Bool_Exp = {
  count?: InputMaybe<Candidate_Aggregate_Bool_Exp_Count>;
};

export type Candidate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Candidate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Candidate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "candidate" */
export type Candidate_Aggregate_Fields = {
  __typename?: 'candidate_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Candidate_Max_Fields>;
  min: Maybe<Candidate_Min_Fields>;
};


/** aggregate fields of "candidate" */
export type Candidate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Candidate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "candidate" */
export type Candidate_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Candidate_Max_Order_By>;
  min?: InputMaybe<Candidate_Min_Order_By>;
};

/** input type for inserting array relation for remote table "candidate" */
export type Candidate_Arr_Rel_Insert_Input = {
  data: Array<Candidate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Candidate_On_Conflict>;
};

/** Boolean expression to filter rows from the table "candidate". All fields are combined with a logical 'AND'. */
export type Candidate_Bool_Exp = {
  _and?: InputMaybe<Array<Candidate_Bool_Exp>>;
  _not?: InputMaybe<Candidate_Bool_Exp>;
  _or?: InputMaybe<Array<Candidate_Bool_Exp>>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_application_batches?: InputMaybe<Job_Application_Batch_Bool_Exp>;
  job_application_batches_aggregate?: InputMaybe<Job_Application_Batch_Aggregate_Bool_Exp>;
  last_applied?: InputMaybe<Timestamp_Comparison_Exp>;
  masked_email?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "candidate" */
export enum Candidate_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCandidate = 'pk_candidate',
  /** unique or primary key constraint on columns "org_id", "clinician_id" */
  UqCandidateOrgIdClinicianId = 'uq_candidate_org_id_clinician_id'
}

/** input type for inserting data into table "candidate" */
export type Candidate_Insert_Input = {
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_application_batches?: InputMaybe<Job_Application_Batch_Arr_Rel_Insert_Input>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Candidate_Max_Fields = {
  __typename?: 'candidate_max_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "candidate_last_applied" */
  last_applied: Maybe<Scalars['timestamp']>;
  /** A computed field, executes function "candidate_masked_email" */
  masked_email: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "candidate" */
export type Candidate_Max_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Candidate_Min_Fields = {
  __typename?: 'candidate_min_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "candidate_last_applied" */
  last_applied: Maybe<Scalars['timestamp']>;
  /** A computed field, executes function "candidate_masked_email" */
  masked_email: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "candidate" */
export type Candidate_Min_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "candidate" */
export type Candidate_Mutation_Response = {
  __typename?: 'candidate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Candidate>;
};

/** input type for inserting object relation for remote table "candidate" */
export type Candidate_Obj_Rel_Insert_Input = {
  data: Candidate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Candidate_On_Conflict>;
};

/** on_conflict condition type for table "candidate" */
export type Candidate_On_Conflict = {
  constraint: Candidate_Constraint;
  update_columns?: Array<Candidate_Update_Column>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};

/** Ordering options when selecting data from "candidate". */
export type Candidate_Order_By = {
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_application_batches_aggregate?: InputMaybe<Job_Application_Batch_Aggregate_Order_By>;
  last_applied?: InputMaybe<Order_By>;
  masked_email?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: candidate */
export type Candidate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "candidate" */
export enum Candidate_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id'
}

/** input type for updating data in table "candidate" */
export type Candidate_Set_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "candidate" */
export type Candidate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Candidate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Candidate_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "candidate" */
export enum Candidate_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id'
}

export type Candidate_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Candidate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Candidate_Bool_Exp;
};

/** columns and relationships of "cert_org" */
export type Cert_Org = {
  __typename?: 'cert_org';
  /** An array relationship */
  boards: Array<Board>;
  /** An aggregate relationship */
  boards_aggregate: Board_Aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
};


/** columns and relationships of "cert_org" */
export type Cert_OrgBoardsArgs = {
  distinct_on?: InputMaybe<Array<Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Order_By>>;
  where?: InputMaybe<Board_Bool_Exp>;
};


/** columns and relationships of "cert_org" */
export type Cert_OrgBoards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Order_By>>;
  where?: InputMaybe<Board_Bool_Exp>;
};

/** aggregated selection of "cert_org" */
export type Cert_Org_Aggregate = {
  __typename?: 'cert_org_aggregate';
  aggregate: Maybe<Cert_Org_Aggregate_Fields>;
  nodes: Array<Cert_Org>;
};

/** aggregate fields of "cert_org" */
export type Cert_Org_Aggregate_Fields = {
  __typename?: 'cert_org_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Cert_Org_Max_Fields>;
  min: Maybe<Cert_Org_Min_Fields>;
};


/** aggregate fields of "cert_org" */
export type Cert_Org_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cert_Org_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cert_org". All fields are combined with a logical 'AND'. */
export type Cert_Org_Bool_Exp = {
  _and?: InputMaybe<Array<Cert_Org_Bool_Exp>>;
  _not?: InputMaybe<Cert_Org_Bool_Exp>;
  _or?: InputMaybe<Array<Cert_Org_Bool_Exp>>;
  boards?: InputMaybe<Board_Bool_Exp>;
  boards_aggregate?: InputMaybe<Board_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cert_org" */
export enum Cert_Org_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCertOrg = 'pk_cert_org',
  /** unique or primary key constraint on columns "name" */
  UqCertOrgName = 'uq_cert_org_name'
}

/** input type for inserting data into table "cert_org" */
export type Cert_Org_Insert_Input = {
  boards?: InputMaybe<Board_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cert_Org_Max_Fields = {
  __typename?: 'cert_org_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cert_Org_Min_Fields = {
  __typename?: 'cert_org_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cert_org" */
export type Cert_Org_Mutation_Response = {
  __typename?: 'cert_org_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cert_Org>;
};

/** input type for inserting object relation for remote table "cert_org" */
export type Cert_Org_Obj_Rel_Insert_Input = {
  data: Cert_Org_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cert_Org_On_Conflict>;
};

/** on_conflict condition type for table "cert_org" */
export type Cert_Org_On_Conflict = {
  constraint: Cert_Org_Constraint;
  update_columns?: Array<Cert_Org_Update_Column>;
  where?: InputMaybe<Cert_Org_Bool_Exp>;
};

/** Ordering options when selecting data from "cert_org". */
export type Cert_Org_Order_By = {
  boards_aggregate?: InputMaybe<Board_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cert_org */
export type Cert_Org_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cert_org" */
export enum Cert_Org_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "cert_org" */
export type Cert_Org_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cert_org" */
export type Cert_Org_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cert_Org_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cert_Org_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cert_org" */
export enum Cert_Org_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Cert_Org_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cert_Org_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cert_Org_Bool_Exp;
};

export type Change_Facility_Picture_Args = {
  fid?: InputMaybe<Scalars['uuid']>;
  file_id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "clerkship" */
export type Clerkship = {
  __typename?: 'clerkship';
  id: Scalars['uuid'];
  /** An object relationship */
  latest_survey: Maybe<Latest_Clerkship_Survey>;
  /** An array relationship */
  surveys: Array<Clerkship_Survey>;
  /** An aggregate relationship */
  surveys_aggregate: Clerkship_Survey_Aggregate;
  /** An object relationship */
  training: Training;
};


/** columns and relationships of "clerkship" */
export type ClerkshipSurveysArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


/** columns and relationships of "clerkship" */
export type ClerkshipSurveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};

/** aggregated selection of "clerkship" */
export type Clerkship_Aggregate = {
  __typename?: 'clerkship_aggregate';
  aggregate: Maybe<Clerkship_Aggregate_Fields>;
  nodes: Array<Clerkship>;
};

/** aggregate fields of "clerkship" */
export type Clerkship_Aggregate_Fields = {
  __typename?: 'clerkship_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clerkship_Max_Fields>;
  min: Maybe<Clerkship_Min_Fields>;
};


/** aggregate fields of "clerkship" */
export type Clerkship_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clerkship_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "clerkship". All fields are combined with a logical 'AND'. */
export type Clerkship_Bool_Exp = {
  _and?: InputMaybe<Array<Clerkship_Bool_Exp>>;
  _not?: InputMaybe<Clerkship_Bool_Exp>;
  _or?: InputMaybe<Array<Clerkship_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latest_survey?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
  surveys?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  surveys_aggregate?: InputMaybe<Clerkship_Survey_Aggregate_Bool_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
};

/** unique or primary key constraints on table "clerkship" */
export enum Clerkship_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClerkship = 'pk_clerkship'
}

/** input type for inserting data into table "clerkship" */
export type Clerkship_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  latest_survey?: InputMaybe<Latest_Clerkship_Survey_Obj_Rel_Insert_Input>;
  surveys?: InputMaybe<Clerkship_Survey_Arr_Rel_Insert_Input>;
  training?: InputMaybe<Training_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Clerkship_Max_Fields = {
  __typename?: 'clerkship_max_fields';
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Clerkship_Min_Fields = {
  __typename?: 'clerkship_min_fields';
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "clerkship" */
export type Clerkship_Mutation_Response = {
  __typename?: 'clerkship_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clerkship>;
};

/** input type for inserting object relation for remote table "clerkship" */
export type Clerkship_Obj_Rel_Insert_Input = {
  data: Clerkship_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Clerkship_On_Conflict>;
};

/** on_conflict condition type for table "clerkship" */
export type Clerkship_On_Conflict = {
  constraint: Clerkship_Constraint;
  update_columns?: Array<Clerkship_Update_Column>;
  where?: InputMaybe<Clerkship_Bool_Exp>;
};

/** Ordering options when selecting data from "clerkship". */
export type Clerkship_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_survey?: InputMaybe<Latest_Clerkship_Survey_Order_By>;
  surveys_aggregate?: InputMaybe<Clerkship_Survey_Aggregate_Order_By>;
  training?: InputMaybe<Training_Order_By>;
};

/** primary key columns input for table: clerkship */
export type Clerkship_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clerkship" */
export enum Clerkship_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "clerkship" */
export type Clerkship_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "clerkship" */
export type Clerkship_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clerkship_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clerkship_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "clerkship_survey" */
export type Clerkship_Survey = {
  __typename?: 'clerkship_survey';
  auth_student_sloe: Scalars['String'];
  /** An object relationship */
  clerkship: Maybe<Clerkship>;
  clerkship_id: Maybe<Scalars['uuid']>;
  comlex_required: Scalars['String'];
  do_students: Maybe<Scalars['Boolean']>;
  flexible_rotation: Maybe<Scalars['Boolean']>;
  housing: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  img_students: Maybe<Scalars['Boolean']>;
  interview_policy: Scalars['String'];
  /** An object relationship */
  residency: Maybe<Residency>;
  residency_id: Maybe<Scalars['uuid']>;
  residency_other: Scalars['String'];
  rotation_types: Array<Scalars['String']>;
  spot_availability_1: Maybe<Scalars['Boolean']>;
  spot_availability_2: Maybe<Scalars['Boolean']>;
  spot_availability_3: Maybe<Scalars['Boolean']>;
  spot_availability_4: Maybe<Scalars['Boolean']>;
  spot_availability_5: Maybe<Scalars['Boolean']>;
  spot_availability_6: Maybe<Scalars['Boolean']>;
  spot_availability_7: Maybe<Scalars['Boolean']>;
  spot_availability_8: Maybe<Scalars['Boolean']>;
  spot_availability_9: Maybe<Scalars['Boolean']>;
  spot_availability_10: Maybe<Scalars['Boolean']>;
  spot_availability_11: Maybe<Scalars['Boolean']>;
  spot_availability_12: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  training_survey: Training_Survey;
  vehicle_rec: Scalars['String'];
  vslo_participant: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "clerkship_survey" */
export type Clerkship_Survey_Aggregate = {
  __typename?: 'clerkship_survey_aggregate';
  aggregate: Maybe<Clerkship_Survey_Aggregate_Fields>;
  nodes: Array<Clerkship_Survey>;
};

export type Clerkship_Survey_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Clerkship_Survey_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Clerkship_Survey_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Clerkship_Survey_Aggregate_Bool_Exp_Count>;
};

export type Clerkship_Survey_Aggregate_Bool_Exp_Bool_And = {
  arguments: Clerkship_Survey_Select_Column_Clerkship_Survey_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clerkship_Survey_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Clerkship_Survey_Select_Column_Clerkship_Survey_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clerkship_Survey_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clerkship_survey" */
export type Clerkship_Survey_Aggregate_Fields = {
  __typename?: 'clerkship_survey_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clerkship_Survey_Max_Fields>;
  min: Maybe<Clerkship_Survey_Min_Fields>;
};


/** aggregate fields of "clerkship_survey" */
export type Clerkship_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clerkship_survey" */
export type Clerkship_Survey_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clerkship_Survey_Max_Order_By>;
  min?: InputMaybe<Clerkship_Survey_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clerkship_survey" */
export type Clerkship_Survey_Arr_Rel_Insert_Input = {
  data: Array<Clerkship_Survey_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clerkship_Survey_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clerkship_survey". All fields are combined with a logical 'AND'. */
export type Clerkship_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Clerkship_Survey_Bool_Exp>>;
  _not?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Clerkship_Survey_Bool_Exp>>;
  auth_student_sloe?: InputMaybe<String_Comparison_Exp>;
  clerkship?: InputMaybe<Clerkship_Bool_Exp>;
  clerkship_id?: InputMaybe<Uuid_Comparison_Exp>;
  comlex_required?: InputMaybe<String_Comparison_Exp>;
  do_students?: InputMaybe<Boolean_Comparison_Exp>;
  flexible_rotation?: InputMaybe<Boolean_Comparison_Exp>;
  housing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  img_students?: InputMaybe<Boolean_Comparison_Exp>;
  interview_policy?: InputMaybe<String_Comparison_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
  residency_id?: InputMaybe<Uuid_Comparison_Exp>;
  residency_other?: InputMaybe<String_Comparison_Exp>;
  rotation_types?: InputMaybe<String_Array_Comparison_Exp>;
  spot_availability_1?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_2?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_3?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_4?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_5?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_6?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_7?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_8?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_9?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_10?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_11?: InputMaybe<Boolean_Comparison_Exp>;
  spot_availability_12?: InputMaybe<Boolean_Comparison_Exp>;
  training_survey?: InputMaybe<Training_Survey_Bool_Exp>;
  vehicle_rec?: InputMaybe<String_Comparison_Exp>;
  vslo_participant?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "clerkship_survey" */
export enum Clerkship_Survey_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClerkshipSurvey = 'pk_clerkship_survey'
}

/** input type for inserting data into table "clerkship_survey" */
export type Clerkship_Survey_Insert_Input = {
  auth_student_sloe?: InputMaybe<Scalars['String']>;
  clerkship?: InputMaybe<Clerkship_Obj_Rel_Insert_Input>;
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  comlex_required?: InputMaybe<Scalars['String']>;
  do_students?: InputMaybe<Scalars['Boolean']>;
  flexible_rotation?: InputMaybe<Scalars['Boolean']>;
  housing?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_students?: InputMaybe<Scalars['Boolean']>;
  interview_policy?: InputMaybe<Scalars['String']>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  residency_other?: InputMaybe<Scalars['String']>;
  rotation_types?: InputMaybe<Array<Scalars['String']>>;
  spot_availability_1?: InputMaybe<Scalars['Boolean']>;
  spot_availability_2?: InputMaybe<Scalars['Boolean']>;
  spot_availability_3?: InputMaybe<Scalars['Boolean']>;
  spot_availability_4?: InputMaybe<Scalars['Boolean']>;
  spot_availability_5?: InputMaybe<Scalars['Boolean']>;
  spot_availability_6?: InputMaybe<Scalars['Boolean']>;
  spot_availability_7?: InputMaybe<Scalars['Boolean']>;
  spot_availability_8?: InputMaybe<Scalars['Boolean']>;
  spot_availability_9?: InputMaybe<Scalars['Boolean']>;
  spot_availability_10?: InputMaybe<Scalars['Boolean']>;
  spot_availability_11?: InputMaybe<Scalars['Boolean']>;
  spot_availability_12?: InputMaybe<Scalars['Boolean']>;
  training_survey?: InputMaybe<Training_Survey_Obj_Rel_Insert_Input>;
  vehicle_rec?: InputMaybe<Scalars['String']>;
  vslo_participant?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Clerkship_Survey_Max_Fields = {
  __typename?: 'clerkship_survey_max_fields';
  auth_student_sloe: Maybe<Scalars['String']>;
  clerkship_id: Maybe<Scalars['uuid']>;
  comlex_required: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  interview_policy: Maybe<Scalars['String']>;
  residency_id: Maybe<Scalars['uuid']>;
  residency_other: Maybe<Scalars['String']>;
  rotation_types: Maybe<Array<Scalars['String']>>;
  vehicle_rec: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "clerkship_survey" */
export type Clerkship_Survey_Max_Order_By = {
  auth_student_sloe?: InputMaybe<Order_By>;
  clerkship_id?: InputMaybe<Order_By>;
  comlex_required?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_policy?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  residency_other?: InputMaybe<Order_By>;
  rotation_types?: InputMaybe<Order_By>;
  vehicle_rec?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clerkship_Survey_Min_Fields = {
  __typename?: 'clerkship_survey_min_fields';
  auth_student_sloe: Maybe<Scalars['String']>;
  clerkship_id: Maybe<Scalars['uuid']>;
  comlex_required: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  interview_policy: Maybe<Scalars['String']>;
  residency_id: Maybe<Scalars['uuid']>;
  residency_other: Maybe<Scalars['String']>;
  rotation_types: Maybe<Array<Scalars['String']>>;
  vehicle_rec: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "clerkship_survey" */
export type Clerkship_Survey_Min_Order_By = {
  auth_student_sloe?: InputMaybe<Order_By>;
  clerkship_id?: InputMaybe<Order_By>;
  comlex_required?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interview_policy?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  residency_other?: InputMaybe<Order_By>;
  rotation_types?: InputMaybe<Order_By>;
  vehicle_rec?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clerkship_survey" */
export type Clerkship_Survey_Mutation_Response = {
  __typename?: 'clerkship_survey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clerkship_Survey>;
};

/** input type for inserting object relation for remote table "clerkship_survey" */
export type Clerkship_Survey_Obj_Rel_Insert_Input = {
  data: Clerkship_Survey_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Clerkship_Survey_On_Conflict>;
};

/** on_conflict condition type for table "clerkship_survey" */
export type Clerkship_Survey_On_Conflict = {
  constraint: Clerkship_Survey_Constraint;
  update_columns?: Array<Clerkship_Survey_Update_Column>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};

/** Ordering options when selecting data from "clerkship_survey". */
export type Clerkship_Survey_Order_By = {
  auth_student_sloe?: InputMaybe<Order_By>;
  clerkship?: InputMaybe<Clerkship_Order_By>;
  clerkship_id?: InputMaybe<Order_By>;
  comlex_required?: InputMaybe<Order_By>;
  do_students?: InputMaybe<Order_By>;
  flexible_rotation?: InputMaybe<Order_By>;
  housing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  img_students?: InputMaybe<Order_By>;
  interview_policy?: InputMaybe<Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
  residency_id?: InputMaybe<Order_By>;
  residency_other?: InputMaybe<Order_By>;
  rotation_types?: InputMaybe<Order_By>;
  spot_availability_1?: InputMaybe<Order_By>;
  spot_availability_2?: InputMaybe<Order_By>;
  spot_availability_3?: InputMaybe<Order_By>;
  spot_availability_4?: InputMaybe<Order_By>;
  spot_availability_5?: InputMaybe<Order_By>;
  spot_availability_6?: InputMaybe<Order_By>;
  spot_availability_7?: InputMaybe<Order_By>;
  spot_availability_8?: InputMaybe<Order_By>;
  spot_availability_9?: InputMaybe<Order_By>;
  spot_availability_10?: InputMaybe<Order_By>;
  spot_availability_11?: InputMaybe<Order_By>;
  spot_availability_12?: InputMaybe<Order_By>;
  training_survey?: InputMaybe<Training_Survey_Order_By>;
  vehicle_rec?: InputMaybe<Order_By>;
  vslo_participant?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clerkship_survey */
export type Clerkship_Survey_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clerkship_survey" */
export enum Clerkship_Survey_Select_Column {
  /** column name */
  AuthStudentSloe = 'auth_student_sloe',
  /** column name */
  ClerkshipId = 'clerkship_id',
  /** column name */
  ComlexRequired = 'comlex_required',
  /** column name */
  DoStudents = 'do_students',
  /** column name */
  FlexibleRotation = 'flexible_rotation',
  /** column name */
  Housing = 'housing',
  /** column name */
  Id = 'id',
  /** column name */
  ImgStudents = 'img_students',
  /** column name */
  InterviewPolicy = 'interview_policy',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  ResidencyOther = 'residency_other',
  /** column name */
  RotationTypes = 'rotation_types',
  /** column name */
  SpotAvailability_1 = 'spot_availability_1',
  /** column name */
  SpotAvailability_2 = 'spot_availability_2',
  /** column name */
  SpotAvailability_3 = 'spot_availability_3',
  /** column name */
  SpotAvailability_4 = 'spot_availability_4',
  /** column name */
  SpotAvailability_5 = 'spot_availability_5',
  /** column name */
  SpotAvailability_6 = 'spot_availability_6',
  /** column name */
  SpotAvailability_7 = 'spot_availability_7',
  /** column name */
  SpotAvailability_8 = 'spot_availability_8',
  /** column name */
  SpotAvailability_9 = 'spot_availability_9',
  /** column name */
  SpotAvailability_10 = 'spot_availability_10',
  /** column name */
  SpotAvailability_11 = 'spot_availability_11',
  /** column name */
  SpotAvailability_12 = 'spot_availability_12',
  /** column name */
  VehicleRec = 'vehicle_rec',
  /** column name */
  VsloParticipant = 'vslo_participant'
}

/** select "clerkship_survey_aggregate_bool_exp_bool_and_arguments_columns" columns of table "clerkship_survey" */
export enum Clerkship_Survey_Select_Column_Clerkship_Survey_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DoStudents = 'do_students',
  /** column name */
  FlexibleRotation = 'flexible_rotation',
  /** column name */
  Housing = 'housing',
  /** column name */
  ImgStudents = 'img_students',
  /** column name */
  SpotAvailability_1 = 'spot_availability_1',
  /** column name */
  SpotAvailability_2 = 'spot_availability_2',
  /** column name */
  SpotAvailability_3 = 'spot_availability_3',
  /** column name */
  SpotAvailability_4 = 'spot_availability_4',
  /** column name */
  SpotAvailability_5 = 'spot_availability_5',
  /** column name */
  SpotAvailability_6 = 'spot_availability_6',
  /** column name */
  SpotAvailability_7 = 'spot_availability_7',
  /** column name */
  SpotAvailability_8 = 'spot_availability_8',
  /** column name */
  SpotAvailability_9 = 'spot_availability_9',
  /** column name */
  SpotAvailability_10 = 'spot_availability_10',
  /** column name */
  SpotAvailability_11 = 'spot_availability_11',
  /** column name */
  SpotAvailability_12 = 'spot_availability_12',
  /** column name */
  VsloParticipant = 'vslo_participant'
}

/** select "clerkship_survey_aggregate_bool_exp_bool_or_arguments_columns" columns of table "clerkship_survey" */
export enum Clerkship_Survey_Select_Column_Clerkship_Survey_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DoStudents = 'do_students',
  /** column name */
  FlexibleRotation = 'flexible_rotation',
  /** column name */
  Housing = 'housing',
  /** column name */
  ImgStudents = 'img_students',
  /** column name */
  SpotAvailability_1 = 'spot_availability_1',
  /** column name */
  SpotAvailability_2 = 'spot_availability_2',
  /** column name */
  SpotAvailability_3 = 'spot_availability_3',
  /** column name */
  SpotAvailability_4 = 'spot_availability_4',
  /** column name */
  SpotAvailability_5 = 'spot_availability_5',
  /** column name */
  SpotAvailability_6 = 'spot_availability_6',
  /** column name */
  SpotAvailability_7 = 'spot_availability_7',
  /** column name */
  SpotAvailability_8 = 'spot_availability_8',
  /** column name */
  SpotAvailability_9 = 'spot_availability_9',
  /** column name */
  SpotAvailability_10 = 'spot_availability_10',
  /** column name */
  SpotAvailability_11 = 'spot_availability_11',
  /** column name */
  SpotAvailability_12 = 'spot_availability_12',
  /** column name */
  VsloParticipant = 'vslo_participant'
}

/** input type for updating data in table "clerkship_survey" */
export type Clerkship_Survey_Set_Input = {
  auth_student_sloe?: InputMaybe<Scalars['String']>;
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  comlex_required?: InputMaybe<Scalars['String']>;
  do_students?: InputMaybe<Scalars['Boolean']>;
  flexible_rotation?: InputMaybe<Scalars['Boolean']>;
  housing?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_students?: InputMaybe<Scalars['Boolean']>;
  interview_policy?: InputMaybe<Scalars['String']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  residency_other?: InputMaybe<Scalars['String']>;
  rotation_types?: InputMaybe<Array<Scalars['String']>>;
  spot_availability_1?: InputMaybe<Scalars['Boolean']>;
  spot_availability_2?: InputMaybe<Scalars['Boolean']>;
  spot_availability_3?: InputMaybe<Scalars['Boolean']>;
  spot_availability_4?: InputMaybe<Scalars['Boolean']>;
  spot_availability_5?: InputMaybe<Scalars['Boolean']>;
  spot_availability_6?: InputMaybe<Scalars['Boolean']>;
  spot_availability_7?: InputMaybe<Scalars['Boolean']>;
  spot_availability_8?: InputMaybe<Scalars['Boolean']>;
  spot_availability_9?: InputMaybe<Scalars['Boolean']>;
  spot_availability_10?: InputMaybe<Scalars['Boolean']>;
  spot_availability_11?: InputMaybe<Scalars['Boolean']>;
  spot_availability_12?: InputMaybe<Scalars['Boolean']>;
  vehicle_rec?: InputMaybe<Scalars['String']>;
  vslo_participant?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "clerkship_survey" */
export type Clerkship_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clerkship_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clerkship_Survey_Stream_Cursor_Value_Input = {
  auth_student_sloe?: InputMaybe<Scalars['String']>;
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  comlex_required?: InputMaybe<Scalars['String']>;
  do_students?: InputMaybe<Scalars['Boolean']>;
  flexible_rotation?: InputMaybe<Scalars['Boolean']>;
  housing?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  img_students?: InputMaybe<Scalars['Boolean']>;
  interview_policy?: InputMaybe<Scalars['String']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  residency_other?: InputMaybe<Scalars['String']>;
  rotation_types?: InputMaybe<Array<Scalars['String']>>;
  spot_availability_1?: InputMaybe<Scalars['Boolean']>;
  spot_availability_2?: InputMaybe<Scalars['Boolean']>;
  spot_availability_3?: InputMaybe<Scalars['Boolean']>;
  spot_availability_4?: InputMaybe<Scalars['Boolean']>;
  spot_availability_5?: InputMaybe<Scalars['Boolean']>;
  spot_availability_6?: InputMaybe<Scalars['Boolean']>;
  spot_availability_7?: InputMaybe<Scalars['Boolean']>;
  spot_availability_8?: InputMaybe<Scalars['Boolean']>;
  spot_availability_9?: InputMaybe<Scalars['Boolean']>;
  spot_availability_10?: InputMaybe<Scalars['Boolean']>;
  spot_availability_11?: InputMaybe<Scalars['Boolean']>;
  spot_availability_12?: InputMaybe<Scalars['Boolean']>;
  vehicle_rec?: InputMaybe<Scalars['String']>;
  vslo_participant?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "clerkship_survey" */
export enum Clerkship_Survey_Update_Column {
  /** column name */
  AuthStudentSloe = 'auth_student_sloe',
  /** column name */
  ClerkshipId = 'clerkship_id',
  /** column name */
  ComlexRequired = 'comlex_required',
  /** column name */
  DoStudents = 'do_students',
  /** column name */
  FlexibleRotation = 'flexible_rotation',
  /** column name */
  Housing = 'housing',
  /** column name */
  Id = 'id',
  /** column name */
  ImgStudents = 'img_students',
  /** column name */
  InterviewPolicy = 'interview_policy',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  ResidencyOther = 'residency_other',
  /** column name */
  RotationTypes = 'rotation_types',
  /** column name */
  SpotAvailability_1 = 'spot_availability_1',
  /** column name */
  SpotAvailability_2 = 'spot_availability_2',
  /** column name */
  SpotAvailability_3 = 'spot_availability_3',
  /** column name */
  SpotAvailability_4 = 'spot_availability_4',
  /** column name */
  SpotAvailability_5 = 'spot_availability_5',
  /** column name */
  SpotAvailability_6 = 'spot_availability_6',
  /** column name */
  SpotAvailability_7 = 'spot_availability_7',
  /** column name */
  SpotAvailability_8 = 'spot_availability_8',
  /** column name */
  SpotAvailability_9 = 'spot_availability_9',
  /** column name */
  SpotAvailability_10 = 'spot_availability_10',
  /** column name */
  SpotAvailability_11 = 'spot_availability_11',
  /** column name */
  SpotAvailability_12 = 'spot_availability_12',
  /** column name */
  VehicleRec = 'vehicle_rec',
  /** column name */
  VsloParticipant = 'vslo_participant'
}

export type Clerkship_Survey_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clerkship_Survey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clerkship_Survey_Bool_Exp;
};

/** update columns of table "clerkship" */
export enum Clerkship_Update_Column {
  /** column name */
  Id = 'id'
}

export type Clerkship_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clerkship_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clerkship_Bool_Exp;
};

/** columns and relationships of "clinician" */
export type Clinician = {
  __typename?: 'clinician';
  /** An object relationship */
  account: Account;
  /** An array relationship */
  app_certs: Array<Clinician_App_Cert>;
  /** An aggregate relationship */
  app_certs_aggregate: Clinician_App_Cert_Aggregate;
  /** An array relationship */
  board_certs: Array<Clinician_Board_Cert>;
  /** An aggregate relationship */
  board_certs_aggregate: Clinician_Board_Cert_Aggregate;
  campaign_reg: Maybe<Scalars['timestamp']>;
  campaign_review: Maybe<Scalars['timestamp']>;
  campaign_salary: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  candidates: Array<Candidate>;
  /** An aggregate relationship */
  candidates_aggregate: Candidate_Aggregate;
  creds: Scalars['String'];
  current_student: Scalars['Boolean'];
  /** A computed field, executes function "is_current_trainee" */
  current_trainee: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  cv: Maybe<File>;
  cv_id: Maybe<Scalars['uuid']>;
  fid: Maybe<Scalars['String']>;
  /** An object relationship */
  fsmb_bio: Maybe<Fsmb_Bio>;
  grad_yr: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  isAPP: Scalars['Boolean'];
  /** An array relationship */
  licenses: Array<Clinician_License>;
  /** An aggregate relationship */
  licenses_aggregate: Clinician_License_Aggregate;
  npi: Scalars['String'];
  prof_degree: Scalars['professionaldegree'];
  profession: Scalars['profession'];
  profile_complete: Scalars['Boolean'];
  /** A computed field, executes function "reported_salary" */
  reported_salary: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  reviews: Array<Review>;
  /** An aggregate relationship */
  reviews_aggregate: Review_Aggregate;
  /** An array relationship */
  salary_reports: Array<Salary_Report>;
  /** An aggregate relationship */
  salary_reports_aggregate: Salary_Report_Aggregate;
  school_name: Scalars['String'];
  skill_central_venous_line_placement: Scalars['Boolean'];
  skill_chest_needle: Scalars['Boolean'];
  skill_chest_tube_placement: Scalars['Boolean'];
  skill_ear_fb: Scalars['Boolean'];
  skill_ekg_interpret: Scalars['Boolean'];
  skill_ekg_stemi: Scalars['Boolean'];
  skill_endotracheal_intubation: Scalars['Boolean'];
  skill_eye_fb: Scalars['Boolean'];
  skill_fracture_blocks: Scalars['Boolean'];
  skill_io_access: Scalars['Boolean'];
  skill_joint_reduction: Scalars['Boolean'];
  skill_lumbar_puncture: Scalars['Boolean'];
  skill_neonates: Scalars['Boolean'];
  skill_obgyn: Scalars['Boolean'];
  skill_oral: Scalars['Boolean'];
  skill_peds: Scalars['Boolean'];
  skill_procedural_sedation: Scalars['Boolean'];
  skill_us_diagnostics: Scalars['Boolean'];
  skill_us_procedures: Scalars['Boolean'];
  skill_wound_repair: Scalars['Boolean'];
  /** An array relationship */
  sp_exp: Array<Clinician_Sp_Exp>;
  /** An aggregate relationship */
  sp_exp_aggregate: Clinician_Sp_Exp_Aggregate;
  /** An array relationship */
  specialties: Array<Clinician_Specialty>;
  /** An aggregate relationship */
  specialties_aggregate: Clinician_Specialty_Aggregate;
  /** An array relationship */
  training: Array<Clinician_Training>;
  /** An aggregate relationship */
  training_aggregate: Clinician_Training_Aggregate;
};


/** columns and relationships of "clinician" */
export type ClinicianApp_CertsArgs = {
  distinct_on?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_App_Cert_Order_By>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianApp_Certs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_App_Cert_Order_By>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianBoard_CertsArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Board_Cert_Order_By>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianBoard_Certs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Board_Cert_Order_By>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianCandidatesArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianCandidates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianLicensesArgs = {
  distinct_on?: InputMaybe<Array<Clinician_License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_License_Order_By>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianLicenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_License_Order_By>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianReviewsArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianSalary_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianSalary_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianSp_ExpArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Sp_Exp_Order_By>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianSp_Exp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Sp_Exp_Order_By>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianSpecialtiesArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Specialty_Order_By>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianSpecialties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Specialty_Order_By>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianTrainingArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Training_Order_By>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};


/** columns and relationships of "clinician" */
export type ClinicianTraining_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Training_Order_By>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};

/** aggregated selection of "clinician" */
export type Clinician_Aggregate = {
  __typename?: 'clinician_aggregate';
  aggregate: Maybe<Clinician_Aggregate_Fields>;
  nodes: Array<Clinician>;
};

export type Clinician_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Clinician_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Clinician_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Clinician_Aggregate_Bool_Exp_Count>;
};

export type Clinician_Aggregate_Bool_Exp_Bool_And = {
  arguments: Clinician_Select_Column_Clinician_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Clinician_Select_Column_Clinician_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician" */
export type Clinician_Aggregate_Fields = {
  __typename?: 'clinician_aggregate_fields';
  avg: Maybe<Clinician_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Clinician_Max_Fields>;
  min: Maybe<Clinician_Min_Fields>;
  stddev: Maybe<Clinician_Stddev_Fields>;
  stddev_pop: Maybe<Clinician_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Clinician_Stddev_Samp_Fields>;
  sum: Maybe<Clinician_Sum_Fields>;
  var_pop: Maybe<Clinician_Var_Pop_Fields>;
  var_samp: Maybe<Clinician_Var_Samp_Fields>;
  variance: Maybe<Clinician_Variance_Fields>;
};


/** aggregate fields of "clinician" */
export type Clinician_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician" */
export type Clinician_Aggregate_Order_By = {
  avg?: InputMaybe<Clinician_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_Max_Order_By>;
  min?: InputMaybe<Clinician_Min_Order_By>;
  stddev?: InputMaybe<Clinician_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Clinician_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Clinician_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Clinician_Sum_Order_By>;
  var_pop?: InputMaybe<Clinician_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Clinician_Var_Samp_Order_By>;
  variance?: InputMaybe<Clinician_Variance_Order_By>;
};

/** columns and relationships of "clinician_app_cert" */
export type Clinician_App_Cert = {
  __typename?: 'clinician_app_cert';
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** aggregated selection of "clinician_app_cert" */
export type Clinician_App_Cert_Aggregate = {
  __typename?: 'clinician_app_cert_aggregate';
  aggregate: Maybe<Clinician_App_Cert_Aggregate_Fields>;
  nodes: Array<Clinician_App_Cert>;
};

export type Clinician_App_Cert_Aggregate_Bool_Exp = {
  count?: InputMaybe<Clinician_App_Cert_Aggregate_Bool_Exp_Count>;
};

export type Clinician_App_Cert_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician_app_cert" */
export type Clinician_App_Cert_Aggregate_Fields = {
  __typename?: 'clinician_app_cert_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clinician_App_Cert_Max_Fields>;
  min: Maybe<Clinician_App_Cert_Min_Fields>;
};


/** aggregate fields of "clinician_app_cert" */
export type Clinician_App_Cert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician_app_cert" */
export type Clinician_App_Cert_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_App_Cert_Max_Order_By>;
  min?: InputMaybe<Clinician_App_Cert_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clinician_app_cert" */
export type Clinician_App_Cert_Arr_Rel_Insert_Input = {
  data: Array<Clinician_App_Cert_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_App_Cert_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clinician_app_cert". All fields are combined with a logical 'AND'. */
export type Clinician_App_Cert_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_App_Cert_Bool_Exp>>;
  _not?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_App_Cert_Bool_Exp>>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "clinician_app_cert" */
export enum Clinician_App_Cert_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClinicianAppCert = 'pk_clinician_app_cert',
  /** unique or primary key constraint on columns "clinician_id", "name" */
  UqClinicianAppCertClinicianIdName = 'uq_clinician_app_cert_clinician_id_name'
}

/** input type for inserting data into table "clinician_app_cert" */
export type Clinician_App_Cert_Insert_Input = {
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Clinician_App_Cert_Max_Fields = {
  __typename?: 'clinician_app_cert_max_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "clinician_app_cert" */
export type Clinician_App_Cert_Max_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_App_Cert_Min_Fields = {
  __typename?: 'clinician_app_cert_min_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "clinician_app_cert" */
export type Clinician_App_Cert_Min_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician_app_cert" */
export type Clinician_App_Cert_Mutation_Response = {
  __typename?: 'clinician_app_cert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician_App_Cert>;
};

/** on_conflict condition type for table "clinician_app_cert" */
export type Clinician_App_Cert_On_Conflict = {
  constraint: Clinician_App_Cert_Constraint;
  update_columns?: Array<Clinician_App_Cert_Update_Column>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician_app_cert". */
export type Clinician_App_Cert_Order_By = {
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clinician_app_cert */
export type Clinician_App_Cert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician_app_cert" */
export enum Clinician_App_Cert_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "clinician_app_cert" */
export type Clinician_App_Cert_Set_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "clinician_app_cert" */
export type Clinician_App_Cert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_App_Cert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_App_Cert_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "clinician_app_cert" */
export enum Clinician_App_Cert_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Clinician_App_Cert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_App_Cert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_App_Cert_Bool_Exp;
};

/** input type for inserting array relation for remote table "clinician" */
export type Clinician_Arr_Rel_Insert_Input = {
  data: Array<Clinician_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_On_Conflict>;
};

/** aggregate avg on columns */
export type Clinician_Avg_Fields = {
  __typename?: 'clinician_avg_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "clinician" */
export type Clinician_Avg_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** columns and relationships of "clinician_board_cert" */
export type Clinician_Board_Cert = {
  __typename?: 'clinician_board_cert';
  /** An object relationship */
  cert: Board_Cert;
  cert_id: Scalars['uuid'];
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  eligible: Scalars['Boolean'];
  id: Scalars['uuid'];
};

/** aggregated selection of "clinician_board_cert" */
export type Clinician_Board_Cert_Aggregate = {
  __typename?: 'clinician_board_cert_aggregate';
  aggregate: Maybe<Clinician_Board_Cert_Aggregate_Fields>;
  nodes: Array<Clinician_Board_Cert>;
};

export type Clinician_Board_Cert_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Clinician_Board_Cert_Aggregate_Bool_Exp_Count>;
};

export type Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_And = {
  arguments: Clinician_Board_Cert_Select_Column_Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Clinician_Board_Cert_Select_Column_Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Board_Cert_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician_board_cert" */
export type Clinician_Board_Cert_Aggregate_Fields = {
  __typename?: 'clinician_board_cert_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clinician_Board_Cert_Max_Fields>;
  min: Maybe<Clinician_Board_Cert_Min_Fields>;
};


/** aggregate fields of "clinician_board_cert" */
export type Clinician_Board_Cert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician_board_cert" */
export type Clinician_Board_Cert_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_Board_Cert_Max_Order_By>;
  min?: InputMaybe<Clinician_Board_Cert_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clinician_board_cert" */
export type Clinician_Board_Cert_Arr_Rel_Insert_Input = {
  data: Array<Clinician_Board_Cert_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_Board_Cert_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clinician_board_cert". All fields are combined with a logical 'AND'. */
export type Clinician_Board_Cert_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_Board_Cert_Bool_Exp>>;
  _not?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_Board_Cert_Bool_Exp>>;
  cert?: InputMaybe<Board_Cert_Bool_Exp>;
  cert_id?: InputMaybe<Uuid_Comparison_Exp>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  eligible?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "clinician_board_cert" */
export enum Clinician_Board_Cert_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClinicianBoardCert = 'pk_clinician_board_cert',
  /** unique or primary key constraint on columns "cert_id", "clinician_id" */
  UqClinicianBoardCertClinicianIdCertId = 'uq_clinician_board_cert_clinician_id_cert_id'
}

/** input type for inserting data into table "clinician_board_cert" */
export type Clinician_Board_Cert_Insert_Input = {
  cert?: InputMaybe<Board_Cert_Obj_Rel_Insert_Input>;
  cert_id?: InputMaybe<Scalars['uuid']>;
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  eligible?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Clinician_Board_Cert_Max_Fields = {
  __typename?: 'clinician_board_cert_max_fields';
  cert_id: Maybe<Scalars['uuid']>;
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "clinician_board_cert" */
export type Clinician_Board_Cert_Max_Order_By = {
  cert_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_Board_Cert_Min_Fields = {
  __typename?: 'clinician_board_cert_min_fields';
  cert_id: Maybe<Scalars['uuid']>;
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "clinician_board_cert" */
export type Clinician_Board_Cert_Min_Order_By = {
  cert_id?: InputMaybe<Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician_board_cert" */
export type Clinician_Board_Cert_Mutation_Response = {
  __typename?: 'clinician_board_cert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician_Board_Cert>;
};

/** on_conflict condition type for table "clinician_board_cert" */
export type Clinician_Board_Cert_On_Conflict = {
  constraint: Clinician_Board_Cert_Constraint;
  update_columns?: Array<Clinician_Board_Cert_Update_Column>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician_board_cert". */
export type Clinician_Board_Cert_Order_By = {
  cert?: InputMaybe<Board_Cert_Order_By>;
  cert_id?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  eligible?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clinician_board_cert */
export type Clinician_Board_Cert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician_board_cert" */
export enum Clinician_Board_Cert_Select_Column {
  /** column name */
  CertId = 'cert_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Eligible = 'eligible',
  /** column name */
  Id = 'id'
}

/** select "clinician_board_cert_aggregate_bool_exp_bool_and_arguments_columns" columns of table "clinician_board_cert" */
export enum Clinician_Board_Cert_Select_Column_Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Eligible = 'eligible'
}

/** select "clinician_board_cert_aggregate_bool_exp_bool_or_arguments_columns" columns of table "clinician_board_cert" */
export enum Clinician_Board_Cert_Select_Column_Clinician_Board_Cert_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Eligible = 'eligible'
}

/** input type for updating data in table "clinician_board_cert" */
export type Clinician_Board_Cert_Set_Input = {
  cert_id?: InputMaybe<Scalars['uuid']>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  eligible?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "clinician_board_cert" */
export type Clinician_Board_Cert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_Board_Cert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_Board_Cert_Stream_Cursor_Value_Input = {
  cert_id?: InputMaybe<Scalars['uuid']>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  eligible?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "clinician_board_cert" */
export enum Clinician_Board_Cert_Update_Column {
  /** column name */
  CertId = 'cert_id',
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Eligible = 'eligible',
  /** column name */
  Id = 'id'
}

export type Clinician_Board_Cert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_Board_Cert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_Board_Cert_Bool_Exp;
};

/** Boolean expression to filter rows from the table "clinician". All fields are combined with a logical 'AND'. */
export type Clinician_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_Bool_Exp>>;
  _not?: InputMaybe<Clinician_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  app_certs?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
  app_certs_aggregate?: InputMaybe<Clinician_App_Cert_Aggregate_Bool_Exp>;
  board_certs?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
  board_certs_aggregate?: InputMaybe<Clinician_Board_Cert_Aggregate_Bool_Exp>;
  campaign_reg?: InputMaybe<Timestamp_Comparison_Exp>;
  campaign_review?: InputMaybe<Timestamp_Comparison_Exp>;
  campaign_salary?: InputMaybe<Timestamp_Comparison_Exp>;
  candidates?: InputMaybe<Candidate_Bool_Exp>;
  candidates_aggregate?: InputMaybe<Candidate_Aggregate_Bool_Exp>;
  creds?: InputMaybe<String_Comparison_Exp>;
  current_student?: InputMaybe<Boolean_Comparison_Exp>;
  current_trainee?: InputMaybe<Boolean_Comparison_Exp>;
  cv?: InputMaybe<File_Bool_Exp>;
  cv_id?: InputMaybe<Uuid_Comparison_Exp>;
  fid?: InputMaybe<String_Comparison_Exp>;
  fsmb_bio?: InputMaybe<Fsmb_Bio_Bool_Exp>;
  grad_yr?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  licenses?: InputMaybe<Clinician_License_Bool_Exp>;
  licenses_aggregate?: InputMaybe<Clinician_License_Aggregate_Bool_Exp>;
  npi?: InputMaybe<String_Comparison_Exp>;
  prof_degree?: InputMaybe<Professionaldegree_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
  profile_complete?: InputMaybe<Boolean_Comparison_Exp>;
  reported_salary?: InputMaybe<Boolean_Comparison_Exp>;
  reviews?: InputMaybe<Review_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Bool_Exp>;
  salary_reports?: InputMaybe<Salary_Report_Bool_Exp>;
  salary_reports_aggregate?: InputMaybe<Salary_Report_Aggregate_Bool_Exp>;
  school_name?: InputMaybe<String_Comparison_Exp>;
  skill_central_venous_line_placement?: InputMaybe<Boolean_Comparison_Exp>;
  skill_chest_needle?: InputMaybe<Boolean_Comparison_Exp>;
  skill_chest_tube_placement?: InputMaybe<Boolean_Comparison_Exp>;
  skill_ear_fb?: InputMaybe<Boolean_Comparison_Exp>;
  skill_ekg_interpret?: InputMaybe<Boolean_Comparison_Exp>;
  skill_ekg_stemi?: InputMaybe<Boolean_Comparison_Exp>;
  skill_endotracheal_intubation?: InputMaybe<Boolean_Comparison_Exp>;
  skill_eye_fb?: InputMaybe<Boolean_Comparison_Exp>;
  skill_fracture_blocks?: InputMaybe<Boolean_Comparison_Exp>;
  skill_io_access?: InputMaybe<Boolean_Comparison_Exp>;
  skill_joint_reduction?: InputMaybe<Boolean_Comparison_Exp>;
  skill_lumbar_puncture?: InputMaybe<Boolean_Comparison_Exp>;
  skill_neonates?: InputMaybe<Boolean_Comparison_Exp>;
  skill_obgyn?: InputMaybe<Boolean_Comparison_Exp>;
  skill_oral?: InputMaybe<Boolean_Comparison_Exp>;
  skill_peds?: InputMaybe<Boolean_Comparison_Exp>;
  skill_procedural_sedation?: InputMaybe<Boolean_Comparison_Exp>;
  skill_us_diagnostics?: InputMaybe<Boolean_Comparison_Exp>;
  skill_us_procedures?: InputMaybe<Boolean_Comparison_Exp>;
  skill_wound_repair?: InputMaybe<Boolean_Comparison_Exp>;
  sp_exp?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
  sp_exp_aggregate?: InputMaybe<Clinician_Sp_Exp_Aggregate_Bool_Exp>;
  specialties?: InputMaybe<Clinician_Specialty_Bool_Exp>;
  specialties_aggregate?: InputMaybe<Clinician_Specialty_Aggregate_Bool_Exp>;
  training?: InputMaybe<Clinician_Training_Bool_Exp>;
  training_aggregate?: InputMaybe<Clinician_Training_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "clinician" */
export enum Clinician_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClinician = 'pk_clinician'
}

/** input type for incrementing numeric columns in table "clinician" */
export type Clinician_Inc_Input = {
  grad_yr?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "clinician" */
export type Clinician_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  app_certs?: InputMaybe<Clinician_App_Cert_Arr_Rel_Insert_Input>;
  board_certs?: InputMaybe<Clinician_Board_Cert_Arr_Rel_Insert_Input>;
  campaign_reg?: InputMaybe<Scalars['timestamp']>;
  campaign_review?: InputMaybe<Scalars['timestamp']>;
  campaign_salary?: InputMaybe<Scalars['timestamp']>;
  candidates?: InputMaybe<Candidate_Arr_Rel_Insert_Input>;
  creds?: InputMaybe<Scalars['String']>;
  cv?: InputMaybe<File_Obj_Rel_Insert_Input>;
  cv_id?: InputMaybe<Scalars['uuid']>;
  fid?: InputMaybe<Scalars['String']>;
  fsmb_bio?: InputMaybe<Fsmb_Bio_Obj_Rel_Insert_Input>;
  grad_yr?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  licenses?: InputMaybe<Clinician_License_Arr_Rel_Insert_Input>;
  npi?: InputMaybe<Scalars['String']>;
  prof_degree?: InputMaybe<Scalars['professionaldegree']>;
  profile_complete?: InputMaybe<Scalars['Boolean']>;
  reviews?: InputMaybe<Review_Arr_Rel_Insert_Input>;
  salary_reports?: InputMaybe<Salary_Report_Arr_Rel_Insert_Input>;
  school_name?: InputMaybe<Scalars['String']>;
  skill_central_venous_line_placement?: InputMaybe<Scalars['Boolean']>;
  skill_chest_needle?: InputMaybe<Scalars['Boolean']>;
  skill_chest_tube_placement?: InputMaybe<Scalars['Boolean']>;
  skill_ear_fb?: InputMaybe<Scalars['Boolean']>;
  skill_ekg_interpret?: InputMaybe<Scalars['Boolean']>;
  skill_ekg_stemi?: InputMaybe<Scalars['Boolean']>;
  skill_endotracheal_intubation?: InputMaybe<Scalars['Boolean']>;
  skill_eye_fb?: InputMaybe<Scalars['Boolean']>;
  skill_fracture_blocks?: InputMaybe<Scalars['Boolean']>;
  skill_io_access?: InputMaybe<Scalars['Boolean']>;
  skill_joint_reduction?: InputMaybe<Scalars['Boolean']>;
  skill_lumbar_puncture?: InputMaybe<Scalars['Boolean']>;
  skill_neonates?: InputMaybe<Scalars['Boolean']>;
  skill_obgyn?: InputMaybe<Scalars['Boolean']>;
  skill_oral?: InputMaybe<Scalars['Boolean']>;
  skill_peds?: InputMaybe<Scalars['Boolean']>;
  skill_procedural_sedation?: InputMaybe<Scalars['Boolean']>;
  skill_us_diagnostics?: InputMaybe<Scalars['Boolean']>;
  skill_us_procedures?: InputMaybe<Scalars['Boolean']>;
  skill_wound_repair?: InputMaybe<Scalars['Boolean']>;
  sp_exp?: InputMaybe<Clinician_Sp_Exp_Arr_Rel_Insert_Input>;
  specialties?: InputMaybe<Clinician_Specialty_Arr_Rel_Insert_Input>;
  training?: InputMaybe<Clinician_Training_Arr_Rel_Insert_Input>;
};

/** columns and relationships of "clinician_license" */
export type Clinician_License = {
  __typename?: 'clinician_license';
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  id: Scalars['uuid'];
  state: Scalars['String'];
};

/** aggregated selection of "clinician_license" */
export type Clinician_License_Aggregate = {
  __typename?: 'clinician_license_aggregate';
  aggregate: Maybe<Clinician_License_Aggregate_Fields>;
  nodes: Array<Clinician_License>;
};

export type Clinician_License_Aggregate_Bool_Exp = {
  count?: InputMaybe<Clinician_License_Aggregate_Bool_Exp_Count>;
};

export type Clinician_License_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_License_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_License_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician_license" */
export type Clinician_License_Aggregate_Fields = {
  __typename?: 'clinician_license_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clinician_License_Max_Fields>;
  min: Maybe<Clinician_License_Min_Fields>;
};


/** aggregate fields of "clinician_license" */
export type Clinician_License_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_License_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician_license" */
export type Clinician_License_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_License_Max_Order_By>;
  min?: InputMaybe<Clinician_License_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clinician_license" */
export type Clinician_License_Arr_Rel_Insert_Input = {
  data: Array<Clinician_License_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_License_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clinician_license". All fields are combined with a logical 'AND'. */
export type Clinician_License_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_License_Bool_Exp>>;
  _not?: InputMaybe<Clinician_License_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_License_Bool_Exp>>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "clinician_license" */
export enum Clinician_License_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClinicianLicense = 'pk_clinician_license',
  /** unique or primary key constraint on columns "state", "clinician_id" */
  UqClinicianLicenseClinicianIdState = 'uq_clinician_license_clinician_id_state'
}

/** input type for inserting data into table "clinician_license" */
export type Clinician_License_Insert_Input = {
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Clinician_License_Max_Fields = {
  __typename?: 'clinician_license_max_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  state: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "clinician_license" */
export type Clinician_License_Max_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_License_Min_Fields = {
  __typename?: 'clinician_license_min_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  state: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "clinician_license" */
export type Clinician_License_Min_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician_license" */
export type Clinician_License_Mutation_Response = {
  __typename?: 'clinician_license_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician_License>;
};

/** on_conflict condition type for table "clinician_license" */
export type Clinician_License_On_Conflict = {
  constraint: Clinician_License_Constraint;
  update_columns?: Array<Clinician_License_Update_Column>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician_license". */
export type Clinician_License_Order_By = {
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clinician_license */
export type Clinician_License_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician_license" */
export enum Clinician_License_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "clinician_license" */
export type Clinician_License_Set_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "clinician_license" */
export type Clinician_License_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_License_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_License_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
};

/** update columns of table "clinician_license" */
export enum Clinician_License_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state'
}

export type Clinician_License_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_License_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_License_Bool_Exp;
};

/** aggregate max on columns */
export type Clinician_Max_Fields = {
  __typename?: 'clinician_max_fields';
  campaign_reg: Maybe<Scalars['timestamp']>;
  campaign_review: Maybe<Scalars['timestamp']>;
  campaign_salary: Maybe<Scalars['timestamp']>;
  creds: Maybe<Scalars['String']>;
  cv_id: Maybe<Scalars['uuid']>;
  fid: Maybe<Scalars['String']>;
  grad_yr: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  npi: Maybe<Scalars['String']>;
  prof_degree: Maybe<Scalars['professionaldegree']>;
  profession: Maybe<Scalars['profession']>;
  school_name: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "clinician" */
export type Clinician_Max_Order_By = {
  campaign_reg?: InputMaybe<Order_By>;
  campaign_review?: InputMaybe<Order_By>;
  campaign_salary?: InputMaybe<Order_By>;
  creds?: InputMaybe<Order_By>;
  cv_id?: InputMaybe<Order_By>;
  fid?: InputMaybe<Order_By>;
  grad_yr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  prof_degree?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  school_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_Min_Fields = {
  __typename?: 'clinician_min_fields';
  campaign_reg: Maybe<Scalars['timestamp']>;
  campaign_review: Maybe<Scalars['timestamp']>;
  campaign_salary: Maybe<Scalars['timestamp']>;
  creds: Maybe<Scalars['String']>;
  cv_id: Maybe<Scalars['uuid']>;
  fid: Maybe<Scalars['String']>;
  grad_yr: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  npi: Maybe<Scalars['String']>;
  prof_degree: Maybe<Scalars['professionaldegree']>;
  profession: Maybe<Scalars['profession']>;
  school_name: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "clinician" */
export type Clinician_Min_Order_By = {
  campaign_reg?: InputMaybe<Order_By>;
  campaign_review?: InputMaybe<Order_By>;
  campaign_salary?: InputMaybe<Order_By>;
  creds?: InputMaybe<Order_By>;
  cv_id?: InputMaybe<Order_By>;
  fid?: InputMaybe<Order_By>;
  grad_yr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  prof_degree?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  school_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician" */
export type Clinician_Mutation_Response = {
  __typename?: 'clinician_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician>;
};

/** input type for inserting object relation for remote table "clinician" */
export type Clinician_Obj_Rel_Insert_Input = {
  data: Clinician_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_On_Conflict>;
};

/** on_conflict condition type for table "clinician" */
export type Clinician_On_Conflict = {
  constraint: Clinician_Constraint;
  update_columns?: Array<Clinician_Update_Column>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician". */
export type Clinician_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  app_certs_aggregate?: InputMaybe<Clinician_App_Cert_Aggregate_Order_By>;
  board_certs_aggregate?: InputMaybe<Clinician_Board_Cert_Aggregate_Order_By>;
  campaign_reg?: InputMaybe<Order_By>;
  campaign_review?: InputMaybe<Order_By>;
  campaign_salary?: InputMaybe<Order_By>;
  candidates_aggregate?: InputMaybe<Candidate_Aggregate_Order_By>;
  creds?: InputMaybe<Order_By>;
  current_student?: InputMaybe<Order_By>;
  current_trainee?: InputMaybe<Order_By>;
  cv?: InputMaybe<File_Order_By>;
  cv_id?: InputMaybe<Order_By>;
  fid?: InputMaybe<Order_By>;
  fsmb_bio?: InputMaybe<Fsmb_Bio_Order_By>;
  grad_yr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  licenses_aggregate?: InputMaybe<Clinician_License_Aggregate_Order_By>;
  npi?: InputMaybe<Order_By>;
  prof_degree?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  profile_complete?: InputMaybe<Order_By>;
  reported_salary?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Order_By>;
  salary_reports_aggregate?: InputMaybe<Salary_Report_Aggregate_Order_By>;
  school_name?: InputMaybe<Order_By>;
  skill_central_venous_line_placement?: InputMaybe<Order_By>;
  skill_chest_needle?: InputMaybe<Order_By>;
  skill_chest_tube_placement?: InputMaybe<Order_By>;
  skill_ear_fb?: InputMaybe<Order_By>;
  skill_ekg_interpret?: InputMaybe<Order_By>;
  skill_ekg_stemi?: InputMaybe<Order_By>;
  skill_endotracheal_intubation?: InputMaybe<Order_By>;
  skill_eye_fb?: InputMaybe<Order_By>;
  skill_fracture_blocks?: InputMaybe<Order_By>;
  skill_io_access?: InputMaybe<Order_By>;
  skill_joint_reduction?: InputMaybe<Order_By>;
  skill_lumbar_puncture?: InputMaybe<Order_By>;
  skill_neonates?: InputMaybe<Order_By>;
  skill_obgyn?: InputMaybe<Order_By>;
  skill_oral?: InputMaybe<Order_By>;
  skill_peds?: InputMaybe<Order_By>;
  skill_procedural_sedation?: InputMaybe<Order_By>;
  skill_us_diagnostics?: InputMaybe<Order_By>;
  skill_us_procedures?: InputMaybe<Order_By>;
  skill_wound_repair?: InputMaybe<Order_By>;
  sp_exp_aggregate?: InputMaybe<Clinician_Sp_Exp_Aggregate_Order_By>;
  specialties_aggregate?: InputMaybe<Clinician_Specialty_Aggregate_Order_By>;
  training_aggregate?: InputMaybe<Clinician_Training_Aggregate_Order_By>;
};

/** primary key columns input for table: clinician */
export type Clinician_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician" */
export enum Clinician_Select_Column {
  /** column name */
  CampaignReg = 'campaign_reg',
  /** column name */
  CampaignReview = 'campaign_review',
  /** column name */
  CampaignSalary = 'campaign_salary',
  /** column name */
  Creds = 'creds',
  /** column name */
  CurrentStudent = 'current_student',
  /** column name */
  CvId = 'cv_id',
  /** column name */
  Fid = 'fid',
  /** column name */
  GradYr = 'grad_yr',
  /** column name */
  Id = 'id',
  /** column name */
  Npi = 'npi',
  /** column name */
  ProfDegree = 'prof_degree',
  /** column name */
  Profession = 'profession',
  /** column name */
  ProfileComplete = 'profile_complete',
  /** column name */
  SchoolName = 'school_name',
  /** column name */
  SkillCentralVenousLinePlacement = 'skill_central_venous_line_placement',
  /** column name */
  SkillChestNeedle = 'skill_chest_needle',
  /** column name */
  SkillChestTubePlacement = 'skill_chest_tube_placement',
  /** column name */
  SkillEarFb = 'skill_ear_fb',
  /** column name */
  SkillEkgInterpret = 'skill_ekg_interpret',
  /** column name */
  SkillEkgStemi = 'skill_ekg_stemi',
  /** column name */
  SkillEndotrachealIntubation = 'skill_endotracheal_intubation',
  /** column name */
  SkillEyeFb = 'skill_eye_fb',
  /** column name */
  SkillFractureBlocks = 'skill_fracture_blocks',
  /** column name */
  SkillIoAccess = 'skill_io_access',
  /** column name */
  SkillJointReduction = 'skill_joint_reduction',
  /** column name */
  SkillLumbarPuncture = 'skill_lumbar_puncture',
  /** column name */
  SkillNeonates = 'skill_neonates',
  /** column name */
  SkillObgyn = 'skill_obgyn',
  /** column name */
  SkillOral = 'skill_oral',
  /** column name */
  SkillPeds = 'skill_peds',
  /** column name */
  SkillProceduralSedation = 'skill_procedural_sedation',
  /** column name */
  SkillUsDiagnostics = 'skill_us_diagnostics',
  /** column name */
  SkillUsProcedures = 'skill_us_procedures',
  /** column name */
  SkillWoundRepair = 'skill_wound_repair'
}

/** select "clinician_aggregate_bool_exp_bool_and_arguments_columns" columns of table "clinician" */
export enum Clinician_Select_Column_Clinician_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CurrentStudent = 'current_student',
  /** column name */
  ProfileComplete = 'profile_complete',
  /** column name */
  SkillCentralVenousLinePlacement = 'skill_central_venous_line_placement',
  /** column name */
  SkillChestNeedle = 'skill_chest_needle',
  /** column name */
  SkillChestTubePlacement = 'skill_chest_tube_placement',
  /** column name */
  SkillEarFb = 'skill_ear_fb',
  /** column name */
  SkillEkgInterpret = 'skill_ekg_interpret',
  /** column name */
  SkillEkgStemi = 'skill_ekg_stemi',
  /** column name */
  SkillEndotrachealIntubation = 'skill_endotracheal_intubation',
  /** column name */
  SkillEyeFb = 'skill_eye_fb',
  /** column name */
  SkillFractureBlocks = 'skill_fracture_blocks',
  /** column name */
  SkillIoAccess = 'skill_io_access',
  /** column name */
  SkillJointReduction = 'skill_joint_reduction',
  /** column name */
  SkillLumbarPuncture = 'skill_lumbar_puncture',
  /** column name */
  SkillNeonates = 'skill_neonates',
  /** column name */
  SkillObgyn = 'skill_obgyn',
  /** column name */
  SkillOral = 'skill_oral',
  /** column name */
  SkillPeds = 'skill_peds',
  /** column name */
  SkillProceduralSedation = 'skill_procedural_sedation',
  /** column name */
  SkillUsDiagnostics = 'skill_us_diagnostics',
  /** column name */
  SkillUsProcedures = 'skill_us_procedures',
  /** column name */
  SkillWoundRepair = 'skill_wound_repair'
}

/** select "clinician_aggregate_bool_exp_bool_or_arguments_columns" columns of table "clinician" */
export enum Clinician_Select_Column_Clinician_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CurrentStudent = 'current_student',
  /** column name */
  ProfileComplete = 'profile_complete',
  /** column name */
  SkillCentralVenousLinePlacement = 'skill_central_venous_line_placement',
  /** column name */
  SkillChestNeedle = 'skill_chest_needle',
  /** column name */
  SkillChestTubePlacement = 'skill_chest_tube_placement',
  /** column name */
  SkillEarFb = 'skill_ear_fb',
  /** column name */
  SkillEkgInterpret = 'skill_ekg_interpret',
  /** column name */
  SkillEkgStemi = 'skill_ekg_stemi',
  /** column name */
  SkillEndotrachealIntubation = 'skill_endotracheal_intubation',
  /** column name */
  SkillEyeFb = 'skill_eye_fb',
  /** column name */
  SkillFractureBlocks = 'skill_fracture_blocks',
  /** column name */
  SkillIoAccess = 'skill_io_access',
  /** column name */
  SkillJointReduction = 'skill_joint_reduction',
  /** column name */
  SkillLumbarPuncture = 'skill_lumbar_puncture',
  /** column name */
  SkillNeonates = 'skill_neonates',
  /** column name */
  SkillObgyn = 'skill_obgyn',
  /** column name */
  SkillOral = 'skill_oral',
  /** column name */
  SkillPeds = 'skill_peds',
  /** column name */
  SkillProceduralSedation = 'skill_procedural_sedation',
  /** column name */
  SkillUsDiagnostics = 'skill_us_diagnostics',
  /** column name */
  SkillUsProcedures = 'skill_us_procedures',
  /** column name */
  SkillWoundRepair = 'skill_wound_repair'
}

/** input type for updating data in table "clinician" */
export type Clinician_Set_Input = {
  campaign_reg?: InputMaybe<Scalars['timestamp']>;
  campaign_review?: InputMaybe<Scalars['timestamp']>;
  campaign_salary?: InputMaybe<Scalars['timestamp']>;
  creds?: InputMaybe<Scalars['String']>;
  cv_id?: InputMaybe<Scalars['uuid']>;
  fid?: InputMaybe<Scalars['String']>;
  grad_yr?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  npi?: InputMaybe<Scalars['String']>;
  prof_degree?: InputMaybe<Scalars['professionaldegree']>;
  profile_complete?: InputMaybe<Scalars['Boolean']>;
  school_name?: InputMaybe<Scalars['String']>;
  skill_central_venous_line_placement?: InputMaybe<Scalars['Boolean']>;
  skill_chest_needle?: InputMaybe<Scalars['Boolean']>;
  skill_chest_tube_placement?: InputMaybe<Scalars['Boolean']>;
  skill_ear_fb?: InputMaybe<Scalars['Boolean']>;
  skill_ekg_interpret?: InputMaybe<Scalars['Boolean']>;
  skill_ekg_stemi?: InputMaybe<Scalars['Boolean']>;
  skill_endotracheal_intubation?: InputMaybe<Scalars['Boolean']>;
  skill_eye_fb?: InputMaybe<Scalars['Boolean']>;
  skill_fracture_blocks?: InputMaybe<Scalars['Boolean']>;
  skill_io_access?: InputMaybe<Scalars['Boolean']>;
  skill_joint_reduction?: InputMaybe<Scalars['Boolean']>;
  skill_lumbar_puncture?: InputMaybe<Scalars['Boolean']>;
  skill_neonates?: InputMaybe<Scalars['Boolean']>;
  skill_obgyn?: InputMaybe<Scalars['Boolean']>;
  skill_oral?: InputMaybe<Scalars['Boolean']>;
  skill_peds?: InputMaybe<Scalars['Boolean']>;
  skill_procedural_sedation?: InputMaybe<Scalars['Boolean']>;
  skill_us_diagnostics?: InputMaybe<Scalars['Boolean']>;
  skill_us_procedures?: InputMaybe<Scalars['Boolean']>;
  skill_wound_repair?: InputMaybe<Scalars['Boolean']>;
};

/** columns and relationships of "clinician_sp_exp" */
export type Clinician_Sp_Exp = {
  __typename?: 'clinician_sp_exp';
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  field: Scalars['String'];
  id: Scalars['uuid'];
  level: Scalars['experiencelevel'];
};

/** aggregated selection of "clinician_sp_exp" */
export type Clinician_Sp_Exp_Aggregate = {
  __typename?: 'clinician_sp_exp_aggregate';
  aggregate: Maybe<Clinician_Sp_Exp_Aggregate_Fields>;
  nodes: Array<Clinician_Sp_Exp>;
};

export type Clinician_Sp_Exp_Aggregate_Bool_Exp = {
  count?: InputMaybe<Clinician_Sp_Exp_Aggregate_Bool_Exp_Count>;
};

export type Clinician_Sp_Exp_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician_sp_exp" */
export type Clinician_Sp_Exp_Aggregate_Fields = {
  __typename?: 'clinician_sp_exp_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clinician_Sp_Exp_Max_Fields>;
  min: Maybe<Clinician_Sp_Exp_Min_Fields>;
};


/** aggregate fields of "clinician_sp_exp" */
export type Clinician_Sp_Exp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_Sp_Exp_Max_Order_By>;
  min?: InputMaybe<Clinician_Sp_Exp_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Arr_Rel_Insert_Input = {
  data: Array<Clinician_Sp_Exp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_Sp_Exp_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clinician_sp_exp". All fields are combined with a logical 'AND'. */
export type Clinician_Sp_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_Sp_Exp_Bool_Exp>>;
  _not?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_Sp_Exp_Bool_Exp>>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  field?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<Experiencelevel_Comparison_Exp>;
};

/** unique or primary key constraints on table "clinician_sp_exp" */
export enum Clinician_Sp_Exp_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClinicianSpExp = 'pk_clinician_sp_exp',
  /** unique or primary key constraint on columns "clinician_id", "field" */
  UqClinicianSpExpClinicianIdField = 'uq_clinician_sp_exp_clinician_id_field'
}

/** input type for inserting data into table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Insert_Input = {
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['experiencelevel']>;
};

/** aggregate max on columns */
export type Clinician_Sp_Exp_Max_Fields = {
  __typename?: 'clinician_sp_exp_max_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  level: Maybe<Scalars['experiencelevel']>;
};

/** order by max() on columns of table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Max_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_Sp_Exp_Min_Fields = {
  __typename?: 'clinician_sp_exp_min_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  level: Maybe<Scalars['experiencelevel']>;
};

/** order by min() on columns of table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Min_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Mutation_Response = {
  __typename?: 'clinician_sp_exp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician_Sp_Exp>;
};

/** on_conflict condition type for table "clinician_sp_exp" */
export type Clinician_Sp_Exp_On_Conflict = {
  constraint: Clinician_Sp_Exp_Constraint;
  update_columns?: Array<Clinician_Sp_Exp_Update_Column>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician_sp_exp". */
export type Clinician_Sp_Exp_Order_By = {
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clinician_sp_exp */
export type Clinician_Sp_Exp_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician_sp_exp" */
export enum Clinician_Sp_Exp_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level'
}

/** input type for updating data in table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Set_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['experiencelevel']>;
};

/** Streaming cursor of the table "clinician_sp_exp" */
export type Clinician_Sp_Exp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_Sp_Exp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_Sp_Exp_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['experiencelevel']>;
};

/** update columns of table "clinician_sp_exp" */
export enum Clinician_Sp_Exp_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level'
}

export type Clinician_Sp_Exp_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_Sp_Exp_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_Sp_Exp_Bool_Exp;
};

/** columns and relationships of "clinician_specialty" */
export type Clinician_Specialty = {
  __typename?: 'clinician_specialty';
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  primary: Scalars['Boolean'];
};

/** aggregated selection of "clinician_specialty" */
export type Clinician_Specialty_Aggregate = {
  __typename?: 'clinician_specialty_aggregate';
  aggregate: Maybe<Clinician_Specialty_Aggregate_Fields>;
  nodes: Array<Clinician_Specialty>;
};

export type Clinician_Specialty_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Clinician_Specialty_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Clinician_Specialty_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Clinician_Specialty_Aggregate_Bool_Exp_Count>;
};

export type Clinician_Specialty_Aggregate_Bool_Exp_Bool_And = {
  arguments: Clinician_Specialty_Select_Column_Clinician_Specialty_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Specialty_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Specialty_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Clinician_Specialty_Select_Column_Clinician_Specialty_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Specialty_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Specialty_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Specialty_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician_specialty" */
export type Clinician_Specialty_Aggregate_Fields = {
  __typename?: 'clinician_specialty_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Clinician_Specialty_Max_Fields>;
  min: Maybe<Clinician_Specialty_Min_Fields>;
};


/** aggregate fields of "clinician_specialty" */
export type Clinician_Specialty_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician_specialty" */
export type Clinician_Specialty_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_Specialty_Max_Order_By>;
  min?: InputMaybe<Clinician_Specialty_Min_Order_By>;
};

/** input type for inserting array relation for remote table "clinician_specialty" */
export type Clinician_Specialty_Arr_Rel_Insert_Input = {
  data: Array<Clinician_Specialty_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_Specialty_On_Conflict>;
};

/** Boolean expression to filter rows from the table "clinician_specialty". All fields are combined with a logical 'AND'. */
export type Clinician_Specialty_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_Specialty_Bool_Exp>>;
  _not?: InputMaybe<Clinician_Specialty_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_Specialty_Bool_Exp>>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "clinician_specialty" */
export enum Clinician_Specialty_Constraint {
  /** unique or primary key constraint on columns "primary", "clinician_id" */
  IxClinicianSpecialtyClinicianIdUniquePrimary = 'ix_clinician_specialty_clinician_id_unique_primary',
  /** unique or primary key constraint on columns "id" */
  PkClinicianSpecialty = 'pk_clinician_specialty',
  /** unique or primary key constraint on columns "clinician_id", "name" */
  UqClinicianSpecialtyClinicianIdName = 'uq_clinician_specialty_clinician_id_name'
}

/** input type for inserting data into table "clinician_specialty" */
export type Clinician_Specialty_Insert_Input = {
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Clinician_Specialty_Max_Fields = {
  __typename?: 'clinician_specialty_max_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "clinician_specialty" */
export type Clinician_Specialty_Max_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_Specialty_Min_Fields = {
  __typename?: 'clinician_specialty_min_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "clinician_specialty" */
export type Clinician_Specialty_Min_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician_specialty" */
export type Clinician_Specialty_Mutation_Response = {
  __typename?: 'clinician_specialty_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician_Specialty>;
};

/** on_conflict condition type for table "clinician_specialty" */
export type Clinician_Specialty_On_Conflict = {
  constraint: Clinician_Specialty_Constraint;
  update_columns?: Array<Clinician_Specialty_Update_Column>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician_specialty". */
export type Clinician_Specialty_Order_By = {
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clinician_specialty */
export type Clinician_Specialty_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician_specialty" */
export enum Clinician_Specialty_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Primary = 'primary'
}

/** select "clinician_specialty_aggregate_bool_exp_bool_and_arguments_columns" columns of table "clinician_specialty" */
export enum Clinician_Specialty_Select_Column_Clinician_Specialty_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** select "clinician_specialty_aggregate_bool_exp_bool_or_arguments_columns" columns of table "clinician_specialty" */
export enum Clinician_Specialty_Select_Column_Clinician_Specialty_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** input type for updating data in table "clinician_specialty" */
export type Clinician_Specialty_Set_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "clinician_specialty" */
export type Clinician_Specialty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_Specialty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_Specialty_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "clinician_specialty" */
export enum Clinician_Specialty_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Primary = 'primary'
}

export type Clinician_Specialty_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_Specialty_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_Specialty_Bool_Exp;
};

/** aggregate stddev on columns */
export type Clinician_Stddev_Fields = {
  __typename?: 'clinician_stddev_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "clinician" */
export type Clinician_Stddev_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Clinician_Stddev_Pop_Fields = {
  __typename?: 'clinician_stddev_pop_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "clinician" */
export type Clinician_Stddev_Pop_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Clinician_Stddev_Samp_Fields = {
  __typename?: 'clinician_stddev_samp_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "clinician" */
export type Clinician_Stddev_Samp_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "clinician" */
export type Clinician_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_Stream_Cursor_Value_Input = {
  campaign_reg?: InputMaybe<Scalars['timestamp']>;
  campaign_review?: InputMaybe<Scalars['timestamp']>;
  campaign_salary?: InputMaybe<Scalars['timestamp']>;
  creds?: InputMaybe<Scalars['String']>;
  current_student?: InputMaybe<Scalars['Boolean']>;
  cv_id?: InputMaybe<Scalars['uuid']>;
  fid?: InputMaybe<Scalars['String']>;
  grad_yr?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  npi?: InputMaybe<Scalars['String']>;
  prof_degree?: InputMaybe<Scalars['professionaldegree']>;
  profession?: InputMaybe<Scalars['profession']>;
  profile_complete?: InputMaybe<Scalars['Boolean']>;
  school_name?: InputMaybe<Scalars['String']>;
  skill_central_venous_line_placement?: InputMaybe<Scalars['Boolean']>;
  skill_chest_needle?: InputMaybe<Scalars['Boolean']>;
  skill_chest_tube_placement?: InputMaybe<Scalars['Boolean']>;
  skill_ear_fb?: InputMaybe<Scalars['Boolean']>;
  skill_ekg_interpret?: InputMaybe<Scalars['Boolean']>;
  skill_ekg_stemi?: InputMaybe<Scalars['Boolean']>;
  skill_endotracheal_intubation?: InputMaybe<Scalars['Boolean']>;
  skill_eye_fb?: InputMaybe<Scalars['Boolean']>;
  skill_fracture_blocks?: InputMaybe<Scalars['Boolean']>;
  skill_io_access?: InputMaybe<Scalars['Boolean']>;
  skill_joint_reduction?: InputMaybe<Scalars['Boolean']>;
  skill_lumbar_puncture?: InputMaybe<Scalars['Boolean']>;
  skill_neonates?: InputMaybe<Scalars['Boolean']>;
  skill_obgyn?: InputMaybe<Scalars['Boolean']>;
  skill_oral?: InputMaybe<Scalars['Boolean']>;
  skill_peds?: InputMaybe<Scalars['Boolean']>;
  skill_procedural_sedation?: InputMaybe<Scalars['Boolean']>;
  skill_us_diagnostics?: InputMaybe<Scalars['Boolean']>;
  skill_us_procedures?: InputMaybe<Scalars['Boolean']>;
  skill_wound_repair?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Clinician_Sum_Fields = {
  __typename?: 'clinician_sum_fields';
  grad_yr: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "clinician" */
export type Clinician_Sum_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** columns and relationships of "clinician_training" */
export type Clinician_Training = {
  __typename?: 'clinician_training';
  /** An object relationship */
  clinician: Clinician;
  clinician_id: Scalars['uuid'];
  end_yr: Maybe<Scalars['Int']>;
  field: Scalars['String'];
  id: Scalars['uuid'];
  present: Scalars['Boolean'];
  program: Scalars['String'];
  start_yr: Scalars['Int'];
  type: Scalars['trainingtype'];
};

/** aggregated selection of "clinician_training" */
export type Clinician_Training_Aggregate = {
  __typename?: 'clinician_training_aggregate';
  aggregate: Maybe<Clinician_Training_Aggregate_Fields>;
  nodes: Array<Clinician_Training>;
};

export type Clinician_Training_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Clinician_Training_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Clinician_Training_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Clinician_Training_Aggregate_Bool_Exp_Count>;
};

export type Clinician_Training_Aggregate_Bool_Exp_Bool_And = {
  arguments: Clinician_Training_Select_Column_Clinician_Training_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Training_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Training_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Clinician_Training_Select_Column_Clinician_Training_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Training_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Clinician_Training_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Clinician_Training_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "clinician_training" */
export type Clinician_Training_Aggregate_Fields = {
  __typename?: 'clinician_training_aggregate_fields';
  avg: Maybe<Clinician_Training_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Clinician_Training_Max_Fields>;
  min: Maybe<Clinician_Training_Min_Fields>;
  stddev: Maybe<Clinician_Training_Stddev_Fields>;
  stddev_pop: Maybe<Clinician_Training_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Clinician_Training_Stddev_Samp_Fields>;
  sum: Maybe<Clinician_Training_Sum_Fields>;
  var_pop: Maybe<Clinician_Training_Var_Pop_Fields>;
  var_samp: Maybe<Clinician_Training_Var_Samp_Fields>;
  variance: Maybe<Clinician_Training_Variance_Fields>;
};


/** aggregate fields of "clinician_training" */
export type Clinician_Training_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "clinician_training" */
export type Clinician_Training_Aggregate_Order_By = {
  avg?: InputMaybe<Clinician_Training_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Clinician_Training_Max_Order_By>;
  min?: InputMaybe<Clinician_Training_Min_Order_By>;
  stddev?: InputMaybe<Clinician_Training_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Clinician_Training_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Clinician_Training_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Clinician_Training_Sum_Order_By>;
  var_pop?: InputMaybe<Clinician_Training_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Clinician_Training_Var_Samp_Order_By>;
  variance?: InputMaybe<Clinician_Training_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "clinician_training" */
export type Clinician_Training_Arr_Rel_Insert_Input = {
  data: Array<Clinician_Training_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Clinician_Training_On_Conflict>;
};

/** aggregate avg on columns */
export type Clinician_Training_Avg_Fields = {
  __typename?: 'clinician_training_avg_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "clinician_training" */
export type Clinician_Training_Avg_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "clinician_training". All fields are combined with a logical 'AND'. */
export type Clinician_Training_Bool_Exp = {
  _and?: InputMaybe<Array<Clinician_Training_Bool_Exp>>;
  _not?: InputMaybe<Clinician_Training_Bool_Exp>;
  _or?: InputMaybe<Array<Clinician_Training_Bool_Exp>>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_yr?: InputMaybe<Int_Comparison_Exp>;
  field?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  present?: InputMaybe<Boolean_Comparison_Exp>;
  program?: InputMaybe<String_Comparison_Exp>;
  start_yr?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Trainingtype_Comparison_Exp>;
};

/** unique or primary key constraints on table "clinician_training" */
export enum Clinician_Training_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkClinicianTraining = 'pk_clinician_training'
}

/** input type for incrementing numeric columns in table "clinician_training" */
export type Clinician_Training_Inc_Input = {
  end_yr?: InputMaybe<Scalars['Int']>;
  start_yr?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "clinician_training" */
export type Clinician_Training_Insert_Input = {
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  clinician_id?: InputMaybe<Scalars['uuid']>;
  end_yr?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  program?: InputMaybe<Scalars['String']>;
  start_yr?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['trainingtype']>;
};

/** aggregate max on columns */
export type Clinician_Training_Max_Fields = {
  __typename?: 'clinician_training_max_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  end_yr: Maybe<Scalars['Int']>;
  field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  program: Maybe<Scalars['String']>;
  start_yr: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['trainingtype']>;
};

/** order by max() on columns of table "clinician_training" */
export type Clinician_Training_Max_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  end_yr?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Clinician_Training_Min_Fields = {
  __typename?: 'clinician_training_min_fields';
  clinician_id: Maybe<Scalars['uuid']>;
  end_yr: Maybe<Scalars['Int']>;
  field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  program: Maybe<Scalars['String']>;
  start_yr: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['trainingtype']>;
};

/** order by min() on columns of table "clinician_training" */
export type Clinician_Training_Min_Order_By = {
  clinician_id?: InputMaybe<Order_By>;
  end_yr?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "clinician_training" */
export type Clinician_Training_Mutation_Response = {
  __typename?: 'clinician_training_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Clinician_Training>;
};

/** on_conflict condition type for table "clinician_training" */
export type Clinician_Training_On_Conflict = {
  constraint: Clinician_Training_Constraint;
  update_columns?: Array<Clinician_Training_Update_Column>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};

/** Ordering options when selecting data from "clinician_training". */
export type Clinician_Training_Order_By = {
  clinician?: InputMaybe<Clinician_Order_By>;
  clinician_id?: InputMaybe<Order_By>;
  end_yr?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  present?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: clinician_training */
export type Clinician_Training_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "clinician_training" */
export enum Clinician_Training_Select_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EndYr = 'end_yr',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  Present = 'present',
  /** column name */
  Program = 'program',
  /** column name */
  StartYr = 'start_yr',
  /** column name */
  Type = 'type'
}

/** select "clinician_training_aggregate_bool_exp_bool_and_arguments_columns" columns of table "clinician_training" */
export enum Clinician_Training_Select_Column_Clinician_Training_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Present = 'present'
}

/** select "clinician_training_aggregate_bool_exp_bool_or_arguments_columns" columns of table "clinician_training" */
export enum Clinician_Training_Select_Column_Clinician_Training_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Present = 'present'
}

/** input type for updating data in table "clinician_training" */
export type Clinician_Training_Set_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  end_yr?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  program?: InputMaybe<Scalars['String']>;
  start_yr?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['trainingtype']>;
};

/** aggregate stddev on columns */
export type Clinician_Training_Stddev_Fields = {
  __typename?: 'clinician_training_stddev_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "clinician_training" */
export type Clinician_Training_Stddev_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Clinician_Training_Stddev_Pop_Fields = {
  __typename?: 'clinician_training_stddev_pop_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "clinician_training" */
export type Clinician_Training_Stddev_Pop_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Clinician_Training_Stddev_Samp_Fields = {
  __typename?: 'clinician_training_stddev_samp_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "clinician_training" */
export type Clinician_Training_Stddev_Samp_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "clinician_training" */
export type Clinician_Training_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clinician_Training_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clinician_Training_Stream_Cursor_Value_Input = {
  clinician_id?: InputMaybe<Scalars['uuid']>;
  end_yr?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  present?: InputMaybe<Scalars['Boolean']>;
  program?: InputMaybe<Scalars['String']>;
  start_yr?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['trainingtype']>;
};

/** aggregate sum on columns */
export type Clinician_Training_Sum_Fields = {
  __typename?: 'clinician_training_sum_fields';
  end_yr: Maybe<Scalars['Int']>;
  start_yr: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "clinician_training" */
export type Clinician_Training_Sum_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** update columns of table "clinician_training" */
export enum Clinician_Training_Update_Column {
  /** column name */
  ClinicianId = 'clinician_id',
  /** column name */
  EndYr = 'end_yr',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  Program = 'program',
  /** column name */
  StartYr = 'start_yr',
  /** column name */
  Type = 'type'
}

export type Clinician_Training_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Clinician_Training_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_Training_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_Training_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Clinician_Training_Var_Pop_Fields = {
  __typename?: 'clinician_training_var_pop_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "clinician_training" */
export type Clinician_Training_Var_Pop_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Clinician_Training_Var_Samp_Fields = {
  __typename?: 'clinician_training_var_samp_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "clinician_training" */
export type Clinician_Training_Var_Samp_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Clinician_Training_Variance_Fields = {
  __typename?: 'clinician_training_variance_fields';
  end_yr: Maybe<Scalars['Float']>;
  start_yr: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "clinician_training" */
export type Clinician_Training_Variance_Order_By = {
  end_yr?: InputMaybe<Order_By>;
  start_yr?: InputMaybe<Order_By>;
};

/** update columns of table "clinician" */
export enum Clinician_Update_Column {
  /** column name */
  CampaignReg = 'campaign_reg',
  /** column name */
  CampaignReview = 'campaign_review',
  /** column name */
  CampaignSalary = 'campaign_salary',
  /** column name */
  Creds = 'creds',
  /** column name */
  CvId = 'cv_id',
  /** column name */
  Fid = 'fid',
  /** column name */
  GradYr = 'grad_yr',
  /** column name */
  Id = 'id',
  /** column name */
  Npi = 'npi',
  /** column name */
  ProfDegree = 'prof_degree',
  /** column name */
  ProfileComplete = 'profile_complete',
  /** column name */
  SchoolName = 'school_name',
  /** column name */
  SkillCentralVenousLinePlacement = 'skill_central_venous_line_placement',
  /** column name */
  SkillChestNeedle = 'skill_chest_needle',
  /** column name */
  SkillChestTubePlacement = 'skill_chest_tube_placement',
  /** column name */
  SkillEarFb = 'skill_ear_fb',
  /** column name */
  SkillEkgInterpret = 'skill_ekg_interpret',
  /** column name */
  SkillEkgStemi = 'skill_ekg_stemi',
  /** column name */
  SkillEndotrachealIntubation = 'skill_endotracheal_intubation',
  /** column name */
  SkillEyeFb = 'skill_eye_fb',
  /** column name */
  SkillFractureBlocks = 'skill_fracture_blocks',
  /** column name */
  SkillIoAccess = 'skill_io_access',
  /** column name */
  SkillJointReduction = 'skill_joint_reduction',
  /** column name */
  SkillLumbarPuncture = 'skill_lumbar_puncture',
  /** column name */
  SkillNeonates = 'skill_neonates',
  /** column name */
  SkillObgyn = 'skill_obgyn',
  /** column name */
  SkillOral = 'skill_oral',
  /** column name */
  SkillPeds = 'skill_peds',
  /** column name */
  SkillProceduralSedation = 'skill_procedural_sedation',
  /** column name */
  SkillUsDiagnostics = 'skill_us_diagnostics',
  /** column name */
  SkillUsProcedures = 'skill_us_procedures',
  /** column name */
  SkillWoundRepair = 'skill_wound_repair'
}

export type Clinician_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Clinician_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Clinician_Set_Input>;
  /** filter the rows which have to be updated */
  where: Clinician_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Clinician_Var_Pop_Fields = {
  __typename?: 'clinician_var_pop_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "clinician" */
export type Clinician_Var_Pop_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Clinician_Var_Samp_Fields = {
  __typename?: 'clinician_var_samp_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "clinician" */
export type Clinician_Var_Samp_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Clinician_Variance_Fields = {
  __typename?: 'clinician_variance_fields';
  grad_yr: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "clinician" */
export type Clinician_Variance_Order_By = {
  grad_yr?: InputMaybe<Order_By>;
};

/** columns and relationships of "cms_facility" */
export type Cms_Facility = {
  __typename?: 'cms_facility';
  address: Scalars['String'];
  city: Scalars['String'];
  county: Scalars['String'];
  em_services: Scalars['Boolean'];
  /** An object relationship */
  enrollment: Maybe<Cms_Facility_Enrollment>;
  /** An array relationship */
  facilities: Array<Facility>;
  /** An aggregate relationship */
  facilities_aggregate: Facility_Aggregate;
  hospital_type: Scalars['String'];
  id: Scalars['String'];
  /** An array relationship */
  metrics: Array<Cms_Facility_Metric>;
  /** An aggregate relationship */
  metrics_aggregate: Cms_Facility_Metric_Aggregate;
  name: Scalars['String'];
  overall_rating: Maybe<Scalars['Int']>;
  ownership: Scalars['String'];
  /** An object relationship */
  pos: Maybe<Cms_Facility_Pos>;
  state: Scalars['String'];
  zipcode: Scalars['String'];
};


/** columns and relationships of "cms_facility" */
export type Cms_FacilityFacilitiesArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "cms_facility" */
export type Cms_FacilityFacilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "cms_facility" */
export type Cms_FacilityMetricsArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Metric_Order_By>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};


/** columns and relationships of "cms_facility" */
export type Cms_FacilityMetrics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Metric_Order_By>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};

/** aggregated selection of "cms_facility" */
export type Cms_Facility_Aggregate = {
  __typename?: 'cms_facility_aggregate';
  aggregate: Maybe<Cms_Facility_Aggregate_Fields>;
  nodes: Array<Cms_Facility>;
};

/** aggregate fields of "cms_facility" */
export type Cms_Facility_Aggregate_Fields = {
  __typename?: 'cms_facility_aggregate_fields';
  avg: Maybe<Cms_Facility_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Cms_Facility_Max_Fields>;
  min: Maybe<Cms_Facility_Min_Fields>;
  stddev: Maybe<Cms_Facility_Stddev_Fields>;
  stddev_pop: Maybe<Cms_Facility_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Cms_Facility_Stddev_Samp_Fields>;
  sum: Maybe<Cms_Facility_Sum_Fields>;
  var_pop: Maybe<Cms_Facility_Var_Pop_Fields>;
  var_samp: Maybe<Cms_Facility_Var_Samp_Fields>;
  variance: Maybe<Cms_Facility_Variance_Fields>;
};


/** aggregate fields of "cms_facility" */
export type Cms_Facility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cms_Facility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Cms_Facility_Avg_Fields = {
  __typename?: 'cms_facility_avg_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cms_facility". All fields are combined with a logical 'AND'. */
export type Cms_Facility_Bool_Exp = {
  _and?: InputMaybe<Array<Cms_Facility_Bool_Exp>>;
  _not?: InputMaybe<Cms_Facility_Bool_Exp>;
  _or?: InputMaybe<Array<Cms_Facility_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  em_services?: InputMaybe<Boolean_Comparison_Exp>;
  enrollment?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
  facilities?: InputMaybe<Facility_Bool_Exp>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Bool_Exp>;
  hospital_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  metrics?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
  metrics_aggregate?: InputMaybe<Cms_Facility_Metric_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  overall_rating?: InputMaybe<Int_Comparison_Exp>;
  ownership?: InputMaybe<String_Comparison_Exp>;
  pos?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cms_facility" */
export enum Cms_Facility_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCmsFacility = 'pk_cms_facility'
}

/** columns and relationships of "cms_facility_enrollment" */
export type Cms_Facility_Enrollment = {
  __typename?: 'cms_facility_enrollment';
  /** An object relationship */
  cms_facility: Maybe<Cms_Facility>;
  /** An array relationship */
  facilities: Array<Facility>;
  /** An aggregate relationship */
  facilities_aggregate: Facility_Aggregate;
  id: Scalars['String'];
  provider_type_code: Scalars['String'];
  reh_prev_id: Maybe<Scalars['String']>;
};


/** columns and relationships of "cms_facility_enrollment" */
export type Cms_Facility_EnrollmentFacilitiesArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "cms_facility_enrollment" */
export type Cms_Facility_EnrollmentFacilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};

/** aggregated selection of "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Aggregate = {
  __typename?: 'cms_facility_enrollment_aggregate';
  aggregate: Maybe<Cms_Facility_Enrollment_Aggregate_Fields>;
  nodes: Array<Cms_Facility_Enrollment>;
};

/** aggregate fields of "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Aggregate_Fields = {
  __typename?: 'cms_facility_enrollment_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Cms_Facility_Enrollment_Max_Fields>;
  min: Maybe<Cms_Facility_Enrollment_Min_Fields>;
};


/** aggregate fields of "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cms_Facility_Enrollment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cms_facility_enrollment". All fields are combined with a logical 'AND'. */
export type Cms_Facility_Enrollment_Bool_Exp = {
  _and?: InputMaybe<Array<Cms_Facility_Enrollment_Bool_Exp>>;
  _not?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
  _or?: InputMaybe<Array<Cms_Facility_Enrollment_Bool_Exp>>;
  cms_facility?: InputMaybe<Cms_Facility_Bool_Exp>;
  facilities?: InputMaybe<Facility_Bool_Exp>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  provider_type_code?: InputMaybe<String_Comparison_Exp>;
  reh_prev_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cms_facility_enrollment" */
export enum Cms_Facility_Enrollment_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCmsFacilityEnrollment = 'pk_cms_facility_enrollment'
}

/** input type for inserting data into table "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Insert_Input = {
  cms_facility?: InputMaybe<Cms_Facility_Obj_Rel_Insert_Input>;
  facilities?: InputMaybe<Facility_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  provider_type_code?: InputMaybe<Scalars['String']>;
  reh_prev_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cms_Facility_Enrollment_Max_Fields = {
  __typename?: 'cms_facility_enrollment_max_fields';
  id: Maybe<Scalars['String']>;
  provider_type_code: Maybe<Scalars['String']>;
  reh_prev_id: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cms_Facility_Enrollment_Min_Fields = {
  __typename?: 'cms_facility_enrollment_min_fields';
  id: Maybe<Scalars['String']>;
  provider_type_code: Maybe<Scalars['String']>;
  reh_prev_id: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Mutation_Response = {
  __typename?: 'cms_facility_enrollment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cms_Facility_Enrollment>;
};

/** input type for inserting object relation for remote table "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Obj_Rel_Insert_Input = {
  data: Cms_Facility_Enrollment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cms_Facility_Enrollment_On_Conflict>;
};

/** on_conflict condition type for table "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_On_Conflict = {
  constraint: Cms_Facility_Enrollment_Constraint;
  update_columns?: Array<Cms_Facility_Enrollment_Update_Column>;
  where?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
};

/** Ordering options when selecting data from "cms_facility_enrollment". */
export type Cms_Facility_Enrollment_Order_By = {
  cms_facility?: InputMaybe<Cms_Facility_Order_By>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  provider_type_code?: InputMaybe<Order_By>;
  reh_prev_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cms_facility_enrollment */
export type Cms_Facility_Enrollment_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "cms_facility_enrollment" */
export enum Cms_Facility_Enrollment_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProviderTypeCode = 'provider_type_code',
  /** column name */
  RehPrevId = 'reh_prev_id'
}

/** input type for updating data in table "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  provider_type_code?: InputMaybe<Scalars['String']>;
  reh_prev_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cms_facility_enrollment" */
export type Cms_Facility_Enrollment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cms_Facility_Enrollment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cms_Facility_Enrollment_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  provider_type_code?: InputMaybe<Scalars['String']>;
  reh_prev_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cms_facility_enrollment" */
export enum Cms_Facility_Enrollment_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProviderTypeCode = 'provider_type_code',
  /** column name */
  RehPrevId = 'reh_prev_id'
}

export type Cms_Facility_Enrollment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cms_Facility_Enrollment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cms_Facility_Enrollment_Bool_Exp;
};

/** input type for incrementing numeric columns in table "cms_facility" */
export type Cms_Facility_Inc_Input = {
  overall_rating?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cms_facility" */
export type Cms_Facility_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  em_services?: InputMaybe<Scalars['Boolean']>;
  enrollment?: InputMaybe<Cms_Facility_Enrollment_Obj_Rel_Insert_Input>;
  facilities?: InputMaybe<Facility_Arr_Rel_Insert_Input>;
  hospital_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Cms_Facility_Metric_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  overall_rating?: InputMaybe<Scalars['Int']>;
  ownership?: InputMaybe<Scalars['String']>;
  pos?: InputMaybe<Cms_Facility_Pos_Obj_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cms_Facility_Max_Fields = {
  __typename?: 'cms_facility_max_fields';
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  county: Maybe<Scalars['String']>;
  hospital_type: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  overall_rating: Maybe<Scalars['Int']>;
  ownership: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** columns and relationships of "cms_facility_metric" */
export type Cms_Facility_Metric = {
  __typename?: 'cms_facility_metric';
  /** An object relationship */
  cms_facility: Cms_Facility;
  cms_facility_id: Scalars['String'];
  id: Scalars['uuid'];
  measure_id: Scalars['String'];
  measure_name: Scalars['String'];
  score: Maybe<Scalars['String']>;
};

/** aggregated selection of "cms_facility_metric" */
export type Cms_Facility_Metric_Aggregate = {
  __typename?: 'cms_facility_metric_aggregate';
  aggregate: Maybe<Cms_Facility_Metric_Aggregate_Fields>;
  nodes: Array<Cms_Facility_Metric>;
};

export type Cms_Facility_Metric_Aggregate_Bool_Exp = {
  count?: InputMaybe<Cms_Facility_Metric_Aggregate_Bool_Exp_Count>;
};

export type Cms_Facility_Metric_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cms_facility_metric" */
export type Cms_Facility_Metric_Aggregate_Fields = {
  __typename?: 'cms_facility_metric_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Cms_Facility_Metric_Max_Fields>;
  min: Maybe<Cms_Facility_Metric_Min_Fields>;
};


/** aggregate fields of "cms_facility_metric" */
export type Cms_Facility_Metric_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cms_facility_metric" */
export type Cms_Facility_Metric_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cms_Facility_Metric_Max_Order_By>;
  min?: InputMaybe<Cms_Facility_Metric_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cms_facility_metric" */
export type Cms_Facility_Metric_Arr_Rel_Insert_Input = {
  data: Array<Cms_Facility_Metric_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cms_Facility_Metric_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cms_facility_metric". All fields are combined with a logical 'AND'. */
export type Cms_Facility_Metric_Bool_Exp = {
  _and?: InputMaybe<Array<Cms_Facility_Metric_Bool_Exp>>;
  _not?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
  _or?: InputMaybe<Array<Cms_Facility_Metric_Bool_Exp>>;
  cms_facility?: InputMaybe<Cms_Facility_Bool_Exp>;
  cms_facility_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  measure_id?: InputMaybe<String_Comparison_Exp>;
  measure_name?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cms_facility_metric" */
export enum Cms_Facility_Metric_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCmsFacilityMetric = 'pk_cms_facility_metric'
}

/** input type for inserting data into table "cms_facility_metric" */
export type Cms_Facility_Metric_Insert_Input = {
  cms_facility?: InputMaybe<Cms_Facility_Obj_Rel_Insert_Input>;
  cms_facility_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  measure_id?: InputMaybe<Scalars['String']>;
  measure_name?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cms_Facility_Metric_Max_Fields = {
  __typename?: 'cms_facility_metric_max_fields';
  cms_facility_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  measure_id: Maybe<Scalars['String']>;
  measure_name: Maybe<Scalars['String']>;
  score: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "cms_facility_metric" */
export type Cms_Facility_Metric_Max_Order_By = {
  cms_facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_id?: InputMaybe<Order_By>;
  measure_name?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cms_Facility_Metric_Min_Fields = {
  __typename?: 'cms_facility_metric_min_fields';
  cms_facility_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  measure_id: Maybe<Scalars['String']>;
  measure_name: Maybe<Scalars['String']>;
  score: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "cms_facility_metric" */
export type Cms_Facility_Metric_Min_Order_By = {
  cms_facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_id?: InputMaybe<Order_By>;
  measure_name?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cms_facility_metric" */
export type Cms_Facility_Metric_Mutation_Response = {
  __typename?: 'cms_facility_metric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cms_Facility_Metric>;
};

/** on_conflict condition type for table "cms_facility_metric" */
export type Cms_Facility_Metric_On_Conflict = {
  constraint: Cms_Facility_Metric_Constraint;
  update_columns?: Array<Cms_Facility_Metric_Update_Column>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};

/** Ordering options when selecting data from "cms_facility_metric". */
export type Cms_Facility_Metric_Order_By = {
  cms_facility?: InputMaybe<Cms_Facility_Order_By>;
  cms_facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measure_id?: InputMaybe<Order_By>;
  measure_name?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cms_facility_metric */
export type Cms_Facility_Metric_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cms_facility_metric" */
export enum Cms_Facility_Metric_Select_Column {
  /** column name */
  CmsFacilityId = 'cms_facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeasureId = 'measure_id',
  /** column name */
  MeasureName = 'measure_name',
  /** column name */
  Score = 'score'
}

/** input type for updating data in table "cms_facility_metric" */
export type Cms_Facility_Metric_Set_Input = {
  cms_facility_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  measure_id?: InputMaybe<Scalars['String']>;
  measure_name?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cms_facility_metric" */
export type Cms_Facility_Metric_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cms_Facility_Metric_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cms_Facility_Metric_Stream_Cursor_Value_Input = {
  cms_facility_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  measure_id?: InputMaybe<Scalars['String']>;
  measure_name?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cms_facility_metric" */
export enum Cms_Facility_Metric_Update_Column {
  /** column name */
  CmsFacilityId = 'cms_facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  MeasureId = 'measure_id',
  /** column name */
  MeasureName = 'measure_name',
  /** column name */
  Score = 'score'
}

export type Cms_Facility_Metric_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cms_Facility_Metric_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cms_Facility_Metric_Bool_Exp;
};

/** aggregate min on columns */
export type Cms_Facility_Min_Fields = {
  __typename?: 'cms_facility_min_fields';
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  county: Maybe<Scalars['String']>;
  hospital_type: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  overall_rating: Maybe<Scalars['Int']>;
  ownership: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cms_facility" */
export type Cms_Facility_Mutation_Response = {
  __typename?: 'cms_facility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cms_Facility>;
};

/** input type for inserting object relation for remote table "cms_facility" */
export type Cms_Facility_Obj_Rel_Insert_Input = {
  data: Cms_Facility_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cms_Facility_On_Conflict>;
};

/** on_conflict condition type for table "cms_facility" */
export type Cms_Facility_On_Conflict = {
  constraint: Cms_Facility_Constraint;
  update_columns?: Array<Cms_Facility_Update_Column>;
  where?: InputMaybe<Cms_Facility_Bool_Exp>;
};

/** Ordering options when selecting data from "cms_facility". */
export type Cms_Facility_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  em_services?: InputMaybe<Order_By>;
  enrollment?: InputMaybe<Cms_Facility_Enrollment_Order_By>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Order_By>;
  hospital_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metrics_aggregate?: InputMaybe<Cms_Facility_Metric_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  overall_rating?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  pos?: InputMaybe<Cms_Facility_Pos_Order_By>;
  state?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cms_facility */
export type Cms_Facility_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** columns and relationships of "cms_facility_pos" */
export type Cms_Facility_Pos = {
  __typename?: 'cms_facility_pos';
  /** An object relationship */
  cms_facility: Maybe<Cms_Facility>;
  cross_ref_id: Maybe<Scalars['String']>;
  /** An array relationship */
  facilities: Array<Facility>;
  /** An aggregate relationship */
  facilities_aggregate: Facility_Aggregate;
  id: Scalars['String'];
  provider_subtype: Scalars['String'];
  related_id: Maybe<Scalars['String']>;
};


/** columns and relationships of "cms_facility_pos" */
export type Cms_Facility_PosFacilitiesArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "cms_facility_pos" */
export type Cms_Facility_PosFacilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};

/** aggregated selection of "cms_facility_pos" */
export type Cms_Facility_Pos_Aggregate = {
  __typename?: 'cms_facility_pos_aggregate';
  aggregate: Maybe<Cms_Facility_Pos_Aggregate_Fields>;
  nodes: Array<Cms_Facility_Pos>;
};

/** aggregate fields of "cms_facility_pos" */
export type Cms_Facility_Pos_Aggregate_Fields = {
  __typename?: 'cms_facility_pos_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Cms_Facility_Pos_Max_Fields>;
  min: Maybe<Cms_Facility_Pos_Min_Fields>;
};


/** aggregate fields of "cms_facility_pos" */
export type Cms_Facility_Pos_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cms_Facility_Pos_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cms_facility_pos". All fields are combined with a logical 'AND'. */
export type Cms_Facility_Pos_Bool_Exp = {
  _and?: InputMaybe<Array<Cms_Facility_Pos_Bool_Exp>>;
  _not?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
  _or?: InputMaybe<Array<Cms_Facility_Pos_Bool_Exp>>;
  cms_facility?: InputMaybe<Cms_Facility_Bool_Exp>;
  cross_ref_id?: InputMaybe<String_Comparison_Exp>;
  facilities?: InputMaybe<Facility_Bool_Exp>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  provider_subtype?: InputMaybe<String_Comparison_Exp>;
  related_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cms_facility_pos" */
export enum Cms_Facility_Pos_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkCmsFacilityPos = 'pk_cms_facility_pos'
}

/** input type for inserting data into table "cms_facility_pos" */
export type Cms_Facility_Pos_Insert_Input = {
  cms_facility?: InputMaybe<Cms_Facility_Obj_Rel_Insert_Input>;
  cross_ref_id?: InputMaybe<Scalars['String']>;
  facilities?: InputMaybe<Facility_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  provider_subtype?: InputMaybe<Scalars['String']>;
  related_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cms_Facility_Pos_Max_Fields = {
  __typename?: 'cms_facility_pos_max_fields';
  cross_ref_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  provider_subtype: Maybe<Scalars['String']>;
  related_id: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cms_Facility_Pos_Min_Fields = {
  __typename?: 'cms_facility_pos_min_fields';
  cross_ref_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  provider_subtype: Maybe<Scalars['String']>;
  related_id: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cms_facility_pos" */
export type Cms_Facility_Pos_Mutation_Response = {
  __typename?: 'cms_facility_pos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cms_Facility_Pos>;
};

/** input type for inserting object relation for remote table "cms_facility_pos" */
export type Cms_Facility_Pos_Obj_Rel_Insert_Input = {
  data: Cms_Facility_Pos_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cms_Facility_Pos_On_Conflict>;
};

/** on_conflict condition type for table "cms_facility_pos" */
export type Cms_Facility_Pos_On_Conflict = {
  constraint: Cms_Facility_Pos_Constraint;
  update_columns?: Array<Cms_Facility_Pos_Update_Column>;
  where?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
};

/** Ordering options when selecting data from "cms_facility_pos". */
export type Cms_Facility_Pos_Order_By = {
  cms_facility?: InputMaybe<Cms_Facility_Order_By>;
  cross_ref_id?: InputMaybe<Order_By>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  provider_subtype?: InputMaybe<Order_By>;
  related_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cms_facility_pos */
export type Cms_Facility_Pos_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "cms_facility_pos" */
export enum Cms_Facility_Pos_Select_Column {
  /** column name */
  CrossRefId = 'cross_ref_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderSubtype = 'provider_subtype',
  /** column name */
  RelatedId = 'related_id'
}

/** input type for updating data in table "cms_facility_pos" */
export type Cms_Facility_Pos_Set_Input = {
  cross_ref_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  provider_subtype?: InputMaybe<Scalars['String']>;
  related_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cms_facility_pos" */
export type Cms_Facility_Pos_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cms_Facility_Pos_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cms_Facility_Pos_Stream_Cursor_Value_Input = {
  cross_ref_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  provider_subtype?: InputMaybe<Scalars['String']>;
  related_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cms_facility_pos" */
export enum Cms_Facility_Pos_Update_Column {
  /** column name */
  CrossRefId = 'cross_ref_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProviderSubtype = 'provider_subtype',
  /** column name */
  RelatedId = 'related_id'
}

export type Cms_Facility_Pos_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cms_Facility_Pos_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cms_Facility_Pos_Bool_Exp;
};

/** select columns of table "cms_facility" */
export enum Cms_Facility_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  County = 'county',
  /** column name */
  EmServices = 'em_services',
  /** column name */
  HospitalType = 'hospital_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OverallRating = 'overall_rating',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  State = 'state',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "cms_facility" */
export type Cms_Facility_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  em_services?: InputMaybe<Scalars['Boolean']>;
  hospital_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overall_rating?: InputMaybe<Scalars['Int']>;
  ownership?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Cms_Facility_Stddev_Fields = {
  __typename?: 'cms_facility_stddev_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Cms_Facility_Stddev_Pop_Fields = {
  __typename?: 'cms_facility_stddev_pop_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Cms_Facility_Stddev_Samp_Fields = {
  __typename?: 'cms_facility_stddev_samp_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cms_facility" */
export type Cms_Facility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cms_Facility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cms_Facility_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  em_services?: InputMaybe<Scalars['Boolean']>;
  hospital_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overall_rating?: InputMaybe<Scalars['Int']>;
  ownership?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Cms_Facility_Sum_Fields = {
  __typename?: 'cms_facility_sum_fields';
  overall_rating: Maybe<Scalars['Int']>;
};

/** update columns of table "cms_facility" */
export enum Cms_Facility_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  County = 'county',
  /** column name */
  EmServices = 'em_services',
  /** column name */
  HospitalType = 'hospital_type',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OverallRating = 'overall_rating',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  State = 'state',
  /** column name */
  Zipcode = 'zipcode'
}

export type Cms_Facility_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cms_Facility_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cms_Facility_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cms_Facility_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cms_Facility_Var_Pop_Fields = {
  __typename?: 'cms_facility_var_pop_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Cms_Facility_Var_Samp_Fields = {
  __typename?: 'cms_facility_var_samp_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Cms_Facility_Variance_Fields = {
  __typename?: 'cms_facility_variance_fields';
  overall_rating: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cms_specialty" */
export type Cms_Specialty = {
  __typename?: 'cms_specialty';
  id: Scalars['uuid'];
  npi: Scalars['String'];
  primary: Scalars['Boolean'];
  specialty: Scalars['String'];
};

/** aggregated selection of "cms_specialty" */
export type Cms_Specialty_Aggregate = {
  __typename?: 'cms_specialty_aggregate';
  aggregate: Maybe<Cms_Specialty_Aggregate_Fields>;
  nodes: Array<Cms_Specialty>;
};

export type Cms_Specialty_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cms_Specialty_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cms_Specialty_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cms_Specialty_Aggregate_Bool_Exp_Count>;
};

export type Cms_Specialty_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cms_Specialty_Select_Column_Cms_Specialty_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cms_Specialty_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cms_Specialty_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cms_Specialty_Select_Column_Cms_Specialty_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cms_Specialty_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cms_Specialty_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Cms_Specialty_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cms_specialty" */
export type Cms_Specialty_Aggregate_Fields = {
  __typename?: 'cms_specialty_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Cms_Specialty_Max_Fields>;
  min: Maybe<Cms_Specialty_Min_Fields>;
};


/** aggregate fields of "cms_specialty" */
export type Cms_Specialty_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "cms_specialty" */
export type Cms_Specialty_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cms_Specialty_Max_Order_By>;
  min?: InputMaybe<Cms_Specialty_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cms_specialty" */
export type Cms_Specialty_Arr_Rel_Insert_Input = {
  data: Array<Cms_Specialty_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cms_Specialty_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cms_specialty". All fields are combined with a logical 'AND'. */
export type Cms_Specialty_Bool_Exp = {
  _and?: InputMaybe<Array<Cms_Specialty_Bool_Exp>>;
  _not?: InputMaybe<Cms_Specialty_Bool_Exp>;
  _or?: InputMaybe<Array<Cms_Specialty_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  npi?: InputMaybe<String_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  specialty?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cms_specialty" */
export enum Cms_Specialty_Constraint {
  /** unique or primary key constraint on columns "primary", "npi" */
  IxCmsSpecialtyNpiUniquePrimary = 'ix_cms_specialty_npi_unique_primary',
  /** unique or primary key constraint on columns "id" */
  PkCmsSpecialty = 'pk_cms_specialty',
  /** unique or primary key constraint on columns "npi", "specialty" */
  UqCmsSpecialtyNpiSpecialty = 'uq_cms_specialty_npi_specialty'
}

/** input type for inserting data into table "cms_specialty" */
export type Cms_Specialty_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  npi?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  specialty?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cms_Specialty_Max_Fields = {
  __typename?: 'cms_specialty_max_fields';
  id: Maybe<Scalars['uuid']>;
  npi: Maybe<Scalars['String']>;
  specialty: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "cms_specialty" */
export type Cms_Specialty_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cms_Specialty_Min_Fields = {
  __typename?: 'cms_specialty_min_fields';
  id: Maybe<Scalars['uuid']>;
  npi: Maybe<Scalars['String']>;
  specialty: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "cms_specialty" */
export type Cms_Specialty_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cms_specialty" */
export type Cms_Specialty_Mutation_Response = {
  __typename?: 'cms_specialty_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cms_Specialty>;
};

/** on_conflict condition type for table "cms_specialty" */
export type Cms_Specialty_On_Conflict = {
  constraint: Cms_Specialty_Constraint;
  update_columns?: Array<Cms_Specialty_Update_Column>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};

/** Ordering options when selecting data from "cms_specialty". */
export type Cms_Specialty_Order_By = {
  id?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cms_specialty */
export type Cms_Specialty_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cms_specialty" */
export enum Cms_Specialty_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Npi = 'npi',
  /** column name */
  Primary = 'primary',
  /** column name */
  Specialty = 'specialty'
}

/** select "cms_specialty_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cms_specialty" */
export enum Cms_Specialty_Select_Column_Cms_Specialty_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** select "cms_specialty_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cms_specialty" */
export enum Cms_Specialty_Select_Column_Cms_Specialty_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** input type for updating data in table "cms_specialty" */
export type Cms_Specialty_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  npi?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  specialty?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cms_specialty" */
export type Cms_Specialty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cms_Specialty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cms_Specialty_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  npi?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  specialty?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cms_specialty" */
export enum Cms_Specialty_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Npi = 'npi',
  /** column name */
  Primary = 'primary',
  /** column name */
  Specialty = 'specialty'
}

export type Cms_Specialty_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cms_Specialty_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cms_Specialty_Bool_Exp;
};

/** columns and relationships of "contact_info" */
export type Contact_Info = {
  __typename?: 'contact_info';
  /** An object relationship */
  account: Maybe<Account>;
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  confirmed_email: Maybe<Scalars['Boolean']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

/** aggregated selection of "contact_info" */
export type Contact_Info_Aggregate = {
  __typename?: 'contact_info_aggregate';
  aggregate: Maybe<Contact_Info_Aggregate_Fields>;
  nodes: Array<Contact_Info>;
};

/** aggregate fields of "contact_info" */
export type Contact_Info_Aggregate_Fields = {
  __typename?: 'contact_info_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Contact_Info_Max_Fields>;
  min: Maybe<Contact_Info_Min_Fields>;
};


/** aggregate fields of "contact_info" */
export type Contact_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "contact_info". All fields are combined with a logical 'AND'. */
export type Contact_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Info_Bool_Exp>>;
  _not?: InputMaybe<Contact_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Info_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  confirmation_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  confirmed_email?: InputMaybe<Boolean_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  pending_email?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "contact_info" */
export type Contact_Info_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Contact_Info_Max_Fields = {
  __typename?: 'contact_info_max_fields';
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Contact_Info_Min_Fields = {
  __typename?: 'contact_info_min_fields';
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contact_info" */
export type Contact_Info_Mutation_Response = {
  __typename?: 'contact_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contact_Info>;
};

/** input type for inserting object relation for remote table "contact_info" */
export type Contact_Info_Obj_Rel_Insert_Input = {
  data: Contact_Info_Insert_Input;
};

/** Ordering options when selecting data from "contact_info". */
export type Contact_Info_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  confirmation_sent_at?: InputMaybe<Order_By>;
  confirmed_email?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pending_email?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** select columns of table "contact_info" */
export enum Contact_Info_Select_Column {
  /** column name */
  ConfirmationSentAt = 'confirmation_sent_at',
  /** column name */
  ConfirmedEmail = 'confirmed_email',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  PendingEmail = 'pending_email',
  /** column name */
  Phone = 'phone'
}

/** input type for updating data in table "contact_info" */
export type Contact_Info_Set_Input = {
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "contact_info" */
export type Contact_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Info_Stream_Cursor_Value_Input = {
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type Contact_Info_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contact_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contact_Info_Bool_Exp;
};

/** Boolean expression to compare columns of type "contractchangerequest". All fields are combined with logical 'AND'. */
export type Contractchangerequest_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['contractchangerequest']>;
  _gt?: InputMaybe<Scalars['contractchangerequest']>;
  _gte?: InputMaybe<Scalars['contractchangerequest']>;
  _in?: InputMaybe<Array<Scalars['contractchangerequest']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['contractchangerequest']>;
  _lte?: InputMaybe<Scalars['contractchangerequest']>;
  _neq?: InputMaybe<Scalars['contractchangerequest']>;
  _nin?: InputMaybe<Array<Scalars['contractchangerequest']>>;
};

/** columns and relationships of "current_account" */
export type Current_Account = {
  __typename?: 'current_account';
  /** An array relationship */
  ab_tests: Array<Ab_Test>;
  /** An aggregate relationship */
  ab_tests_aggregate: Ab_Test_Aggregate;
  access_salary: Maybe<Scalars['Boolean']>;
  acq_session: Maybe<Scalars['Boolean']>;
  active: Maybe<Scalars['Boolean']>;
  city: Maybe<Scalars['String']>;
  claimed: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  clinician: Maybe<Clinician>;
  confirmation_attempts: Maybe<Scalars['Int']>;
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  confirmed_email: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  contact_info: Maybe<Contact_Info>;
  created_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  external_id: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  hide_search_instructions: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  identity_provider: Maybe<Identity_Provider>;
  identity_provider_id: Maybe<Scalars['uuid']>;
  isClinician: Scalars['Boolean'];
  isOrgUser: Scalars['Boolean'];
  last_access: Maybe<Scalars['timestamp']>;
  last_name: Maybe<Scalars['String']>;
  location: Maybe<Scalars['geography']>;
  notify_new_training_survey: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  org_user: Maybe<Org_User>;
  password: Maybe<Scalars['String']>;
  pending_email: Maybe<Scalars['String']>;
  /** An object relationship */
  personal_info: Maybe<Personal_Info>;
  phone: Maybe<Scalars['String']>;
  /** An object relationship */
  picture: Maybe<File>;
  picture_id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
  premade: Maybe<Scalars['Boolean']>;
  referral: Maybe<Scalars['String']>;
  referrer_id: Maybe<Scalars['uuid']>;
  registered_at: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  roles: Array<Account_Role>;
  /** An aggregate relationship */
  roles_aggregate: Account_Role_Aggregate;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  superuser: Maybe<Scalars['Boolean']>;
  type: Maybe<Scalars['accounttype']>;
  utm_campaign: Maybe<Scalars['String']>;
  utm_content: Maybe<Scalars['String']>;
  utm_id: Maybe<Scalars['String']>;
  utm_medium: Maybe<Scalars['String']>;
  utm_source: Maybe<Scalars['String']>;
  utm_term: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** columns and relationships of "current_account" */
export type Current_AccountAb_TestsArgs = {
  distinct_on?: InputMaybe<Array<Ab_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ab_Test_Order_By>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


/** columns and relationships of "current_account" */
export type Current_AccountAb_Tests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ab_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ab_Test_Order_By>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


/** columns and relationships of "current_account" */
export type Current_AccountRolesArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


/** columns and relationships of "current_account" */
export type Current_AccountRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};

/** aggregated selection of "current_account" */
export type Current_Account_Aggregate = {
  __typename?: 'current_account_aggregate';
  aggregate: Maybe<Current_Account_Aggregate_Fields>;
  nodes: Array<Current_Account>;
};

/** aggregate fields of "current_account" */
export type Current_Account_Aggregate_Fields = {
  __typename?: 'current_account_aggregate_fields';
  avg: Maybe<Current_Account_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Current_Account_Max_Fields>;
  min: Maybe<Current_Account_Min_Fields>;
  stddev: Maybe<Current_Account_Stddev_Fields>;
  stddev_pop: Maybe<Current_Account_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Current_Account_Stddev_Samp_Fields>;
  sum: Maybe<Current_Account_Sum_Fields>;
  var_pop: Maybe<Current_Account_Var_Pop_Fields>;
  var_samp: Maybe<Current_Account_Var_Samp_Fields>;
  variance: Maybe<Current_Account_Variance_Fields>;
};


/** aggregate fields of "current_account" */
export type Current_Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Current_Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Current_Account_Avg_Fields = {
  __typename?: 'current_account_avg_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "current_account". All fields are combined with a logical 'AND'. */
export type Current_Account_Bool_Exp = {
  _and?: InputMaybe<Array<Current_Account_Bool_Exp>>;
  _not?: InputMaybe<Current_Account_Bool_Exp>;
  _or?: InputMaybe<Array<Current_Account_Bool_Exp>>;
  ab_tests?: InputMaybe<Ab_Test_Bool_Exp>;
  ab_tests_aggregate?: InputMaybe<Ab_Test_Aggregate_Bool_Exp>;
  access_salary?: InputMaybe<Boolean_Comparison_Exp>;
  acq_session?: InputMaybe<Boolean_Comparison_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  claimed?: InputMaybe<Boolean_Comparison_Exp>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  confirmation_attempts?: InputMaybe<Int_Comparison_Exp>;
  confirmation_sent_at?: InputMaybe<Timestamp_Comparison_Exp>;
  confirmed_email?: InputMaybe<Boolean_Comparison_Exp>;
  contact_info?: InputMaybe<Contact_Info_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  hide_search_instructions?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity_provider?: InputMaybe<Identity_Provider_Bool_Exp>;
  identity_provider_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_access?: InputMaybe<Timestamp_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  notify_new_training_survey?: InputMaybe<Boolean_Comparison_Exp>;
  org_user?: InputMaybe<Org_User_Bool_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  pending_email?: InputMaybe<String_Comparison_Exp>;
  personal_info?: InputMaybe<Personal_Info_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  picture?: InputMaybe<File_Bool_Exp>;
  picture_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<Platform_Comparison_Exp>;
  premade?: InputMaybe<Boolean_Comparison_Exp>;
  referral?: InputMaybe<String_Comparison_Exp>;
  referrer_id?: InputMaybe<Uuid_Comparison_Exp>;
  registered_at?: InputMaybe<Timestamp_Comparison_Exp>;
  roles?: InputMaybe<Account_Role_Bool_Exp>;
  roles_aggregate?: InputMaybe<Account_Role_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  superuser?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<Accounttype_Comparison_Exp>;
  utm_campaign?: InputMaybe<String_Comparison_Exp>;
  utm_content?: InputMaybe<String_Comparison_Exp>;
  utm_id?: InputMaybe<String_Comparison_Exp>;
  utm_medium?: InputMaybe<String_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
  utm_term?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "current_account" */
export type Current_Account_Inc_Input = {
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "current_account" */
export type Current_Account_Insert_Input = {
  ab_tests?: InputMaybe<Ab_Test_Arr_Rel_Insert_Input>;
  access_salary?: InputMaybe<Scalars['Boolean']>;
  acq_session?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  contact_info?: InputMaybe<Contact_Info_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hide_search_instructions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_provider?: InputMaybe<Identity_Provider_Obj_Rel_Insert_Input>;
  identity_provider_id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
  last_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  notify_new_training_survey?: InputMaybe<Scalars['Boolean']>;
  org_user?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  password?: InputMaybe<Scalars['String']>;
  pending_email?: InputMaybe<Scalars['String']>;
  personal_info?: InputMaybe<Personal_Info_Obj_Rel_Insert_Input>;
  phone?: InputMaybe<Scalars['String']>;
  picture?: InputMaybe<File_Obj_Rel_Insert_Input>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
  premade?: InputMaybe<Scalars['Boolean']>;
  referral?: InputMaybe<Scalars['String']>;
  referrer_id?: InputMaybe<Scalars['uuid']>;
  registered_at?: InputMaybe<Scalars['timestamp']>;
  roles?: InputMaybe<Account_Role_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  superuser?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['accounttype']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Current_Account_Max_Fields = {
  __typename?: 'current_account_max_fields';
  city: Maybe<Scalars['String']>;
  confirmation_attempts: Maybe<Scalars['Int']>;
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  created_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  external_id: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  identity_provider_id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
  last_name: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  picture_id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
  referral: Maybe<Scalars['String']>;
  referrer_id: Maybe<Scalars['uuid']>;
  registered_at: Maybe<Scalars['timestamp']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  type: Maybe<Scalars['accounttype']>;
  utm_campaign: Maybe<Scalars['String']>;
  utm_content: Maybe<Scalars['String']>;
  utm_id: Maybe<Scalars['String']>;
  utm_medium: Maybe<Scalars['String']>;
  utm_source: Maybe<Scalars['String']>;
  utm_term: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Current_Account_Min_Fields = {
  __typename?: 'current_account_min_fields';
  city: Maybe<Scalars['String']>;
  confirmation_attempts: Maybe<Scalars['Int']>;
  confirmation_sent_at: Maybe<Scalars['timestamp']>;
  created_at: Maybe<Scalars['timestamp']>;
  email: Maybe<Scalars['String']>;
  external_id: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  identity_provider_id: Maybe<Scalars['uuid']>;
  last_access: Maybe<Scalars['timestamp']>;
  last_name: Maybe<Scalars['String']>;
  password: Maybe<Scalars['String']>;
  pending_email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  picture_id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
  referral: Maybe<Scalars['String']>;
  referrer_id: Maybe<Scalars['uuid']>;
  registered_at: Maybe<Scalars['timestamp']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  type: Maybe<Scalars['accounttype']>;
  utm_campaign: Maybe<Scalars['String']>;
  utm_content: Maybe<Scalars['String']>;
  utm_id: Maybe<Scalars['String']>;
  utm_medium: Maybe<Scalars['String']>;
  utm_source: Maybe<Scalars['String']>;
  utm_term: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "current_account" */
export type Current_Account_Mutation_Response = {
  __typename?: 'current_account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Current_Account>;
};

/** input type for inserting object relation for remote table "current_account" */
export type Current_Account_Obj_Rel_Insert_Input = {
  data: Current_Account_Insert_Input;
};

/** Ordering options when selecting data from "current_account". */
export type Current_Account_Order_By = {
  ab_tests_aggregate?: InputMaybe<Ab_Test_Aggregate_Order_By>;
  access_salary?: InputMaybe<Order_By>;
  acq_session?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  claimed?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Clinician_Order_By>;
  confirmation_attempts?: InputMaybe<Order_By>;
  confirmation_sent_at?: InputMaybe<Order_By>;
  confirmed_email?: InputMaybe<Order_By>;
  contact_info?: InputMaybe<Contact_Info_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  hide_search_instructions?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_provider?: InputMaybe<Identity_Provider_Order_By>;
  identity_provider_id?: InputMaybe<Order_By>;
  last_access?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  notify_new_training_survey?: InputMaybe<Order_By>;
  org_user?: InputMaybe<Org_User_Order_By>;
  password?: InputMaybe<Order_By>;
  pending_email?: InputMaybe<Order_By>;
  personal_info?: InputMaybe<Personal_Info_Order_By>;
  phone?: InputMaybe<Order_By>;
  picture?: InputMaybe<File_Order_By>;
  picture_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  premade?: InputMaybe<Order_By>;
  referral?: InputMaybe<Order_By>;
  referrer_id?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  roles_aggregate?: InputMaybe<Account_Role_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  superuser?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_content?: InputMaybe<Order_By>;
  utm_id?: InputMaybe<Order_By>;
  utm_medium?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
  utm_term?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** select columns of table "current_account" */
export enum Current_Account_Select_Column {
  /** column name */
  AccessSalary = 'access_salary',
  /** column name */
  AcqSession = 'acq_session',
  /** column name */
  Active = 'active',
  /** column name */
  City = 'city',
  /** column name */
  Claimed = 'claimed',
  /** column name */
  ConfirmationAttempts = 'confirmation_attempts',
  /** column name */
  ConfirmationSentAt = 'confirmation_sent_at',
  /** column name */
  ConfirmedEmail = 'confirmed_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  HideSearchInstructions = 'hide_search_instructions',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityProviderId = 'identity_provider_id',
  /** column name */
  LastAccess = 'last_access',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Location = 'location',
  /** column name */
  NotifyNewTrainingSurvey = 'notify_new_training_survey',
  /** column name */
  Password = 'password',
  /** column name */
  PendingEmail = 'pending_email',
  /** column name */
  Phone = 'phone',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Premade = 'premade',
  /** column name */
  Referral = 'referral',
  /** column name */
  ReferrerId = 'referrer_id',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Superuser = 'superuser',
  /** column name */
  Type = 'type',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmContent = 'utm_content',
  /** column name */
  UtmId = 'utm_id',
  /** column name */
  UtmMedium = 'utm_medium',
  /** column name */
  UtmSource = 'utm_source',
  /** column name */
  UtmTerm = 'utm_term',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "current_account" */
export type Current_Account_Set_Input = {
  access_salary?: InputMaybe<Scalars['Boolean']>;
  acq_session?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hide_search_instructions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_provider_id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
  last_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  notify_new_training_survey?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
  premade?: InputMaybe<Scalars['Boolean']>;
  referral?: InputMaybe<Scalars['String']>;
  referrer_id?: InputMaybe<Scalars['uuid']>;
  registered_at?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  superuser?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['accounttype']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Current_Account_Stddev_Fields = {
  __typename?: 'current_account_stddev_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Current_Account_Stddev_Pop_Fields = {
  __typename?: 'current_account_stddev_pop_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Current_Account_Stddev_Samp_Fields = {
  __typename?: 'current_account_stddev_samp_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "current_account" */
export type Current_Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Current_Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Current_Account_Stream_Cursor_Value_Input = {
  access_salary?: InputMaybe<Scalars['Boolean']>;
  acq_session?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  confirmation_attempts?: InputMaybe<Scalars['Int']>;
  confirmation_sent_at?: InputMaybe<Scalars['timestamp']>;
  confirmed_email?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  hide_search_instructions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  identity_provider_id?: InputMaybe<Scalars['uuid']>;
  last_access?: InputMaybe<Scalars['timestamp']>;
  last_name?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  notify_new_training_survey?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  pending_email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
  premade?: InputMaybe<Scalars['Boolean']>;
  referral?: InputMaybe<Scalars['String']>;
  referrer_id?: InputMaybe<Scalars['uuid']>;
  registered_at?: InputMaybe<Scalars['timestamp']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  superuser?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['accounttype']>;
  utm_campaign?: InputMaybe<Scalars['String']>;
  utm_content?: InputMaybe<Scalars['String']>;
  utm_id?: InputMaybe<Scalars['String']>;
  utm_medium?: InputMaybe<Scalars['String']>;
  utm_source?: InputMaybe<Scalars['String']>;
  utm_term?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Current_Account_Sum_Fields = {
  __typename?: 'current_account_sum_fields';
  confirmation_attempts: Maybe<Scalars['Int']>;
};

export type Current_Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Current_Account_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Current_Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Current_Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Current_Account_Var_Pop_Fields = {
  __typename?: 'current_account_var_pop_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Current_Account_Var_Samp_Fields = {
  __typename?: 'current_account_var_samp_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Current_Account_Variance_Fields = {
  __typename?: 'current_account_variance_fields';
  confirmation_attempts: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Boolean expression to compare columns of type "ehrtype". All fields are combined with logical 'AND'. */
export type Ehrtype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ehrtype']>;
  _gt?: InputMaybe<Scalars['ehrtype']>;
  _gte?: InputMaybe<Scalars['ehrtype']>;
  _in?: InputMaybe<Array<Scalars['ehrtype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ehrtype']>;
  _lte?: InputMaybe<Scalars['ehrtype']>;
  _neq?: InputMaybe<Scalars['ehrtype']>;
  _nin?: InputMaybe<Array<Scalars['ehrtype']>>;
};

/** columns and relationships of "email_contact" */
export type Email_Contact = {
  __typename?: 'email_contact';
  address: Scalars['String'];
  /** An object relationship */
  email_message: Email_Message;
  email_message_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  order: Scalars['Int'];
  type: Scalars['emailcontacttype'];
};

/** aggregated selection of "email_contact" */
export type Email_Contact_Aggregate = {
  __typename?: 'email_contact_aggregate';
  aggregate: Maybe<Email_Contact_Aggregate_Fields>;
  nodes: Array<Email_Contact>;
};

export type Email_Contact_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Contact_Aggregate_Bool_Exp_Count>;
};

export type Email_Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Email_Contact_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_contact" */
export type Email_Contact_Aggregate_Fields = {
  __typename?: 'email_contact_aggregate_fields';
  avg: Maybe<Email_Contact_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Email_Contact_Max_Fields>;
  min: Maybe<Email_Contact_Min_Fields>;
  stddev: Maybe<Email_Contact_Stddev_Fields>;
  stddev_pop: Maybe<Email_Contact_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Email_Contact_Stddev_Samp_Fields>;
  sum: Maybe<Email_Contact_Sum_Fields>;
  var_pop: Maybe<Email_Contact_Var_Pop_Fields>;
  var_samp: Maybe<Email_Contact_Var_Samp_Fields>;
  variance: Maybe<Email_Contact_Variance_Fields>;
};


/** aggregate fields of "email_contact" */
export type Email_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_contact" */
export type Email_Contact_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Contact_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Contact_Max_Order_By>;
  min?: InputMaybe<Email_Contact_Min_Order_By>;
  stddev?: InputMaybe<Email_Contact_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Contact_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Contact_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Contact_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Contact_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Contact_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Contact_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "email_contact" */
export type Email_Contact_Arr_Rel_Insert_Input = {
  data: Array<Email_Contact_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Contact_On_Conflict>;
};

/** aggregate avg on columns */
export type Email_Contact_Avg_Fields = {
  __typename?: 'email_contact_avg_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "email_contact" */
export type Email_Contact_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_contact". All fields are combined with a logical 'AND'. */
export type Email_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Contact_Bool_Exp>>;
  _not?: InputMaybe<Email_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Contact_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  email_message?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<Emailcontacttype_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_contact" */
export enum Email_Contact_Constraint {
  /** unique or primary key constraint on columns "email_message_id", "type" */
  IxEmailContactEmailMessageIdUniqueTypeSender = 'ix_email_contact_email_message_id_unique_type_sender',
  /** unique or primary key constraint on columns "id" */
  PkEmailContact = 'pk_email_contact',
  /** unique or primary key constraint on columns "order", "email_message_id", "type" */
  UqEmailContactEmailMessageIdTypeOrder = 'uq_email_contact_email_message_id_type_order'
}

/** input type for incrementing numeric columns in table "email_contact" */
export type Email_Contact_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "email_contact" */
export type Email_Contact_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  email_message?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['emailcontacttype']>;
};

/** aggregate max on columns */
export type Email_Contact_Max_Fields = {
  __typename?: 'email_contact_max_fields';
  address: Maybe<Scalars['String']>;
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  order: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['emailcontacttype']>;
};

/** order by max() on columns of table "email_contact" */
export type Email_Contact_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Contact_Min_Fields = {
  __typename?: 'email_contact_min_fields';
  address: Maybe<Scalars['String']>;
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  order: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['emailcontacttype']>;
};

/** order by min() on columns of table "email_contact" */
export type Email_Contact_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_contact" */
export type Email_Contact_Mutation_Response = {
  __typename?: 'email_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Contact>;
};

/** on_conflict condition type for table "email_contact" */
export type Email_Contact_On_Conflict = {
  constraint: Email_Contact_Constraint;
  update_columns?: Array<Email_Contact_Update_Column>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "email_contact". */
export type Email_Contact_Order_By = {
  address?: InputMaybe<Order_By>;
  email_message?: InputMaybe<Email_Message_Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_contact */
export type Email_Contact_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_contact" */
export enum Email_Contact_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "email_contact" */
export type Email_Contact_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['emailcontacttype']>;
};

/** aggregate stddev on columns */
export type Email_Contact_Stddev_Fields = {
  __typename?: 'email_contact_stddev_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "email_contact" */
export type Email_Contact_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Email_Contact_Stddev_Pop_Fields = {
  __typename?: 'email_contact_stddev_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "email_contact" */
export type Email_Contact_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Email_Contact_Stddev_Samp_Fields = {
  __typename?: 'email_contact_stddev_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "email_contact" */
export type Email_Contact_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_contact" */
export type Email_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Contact_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['emailcontacttype']>;
};

/** aggregate sum on columns */
export type Email_Contact_Sum_Fields = {
  __typename?: 'email_contact_sum_fields';
  order: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "email_contact" */
export type Email_Contact_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "email_contact" */
export enum Email_Contact_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Type = 'type'
}

export type Email_Contact_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Contact_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Contact_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Contact_Var_Pop_Fields = {
  __typename?: 'email_contact_var_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "email_contact" */
export type Email_Contact_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Email_Contact_Var_Samp_Fields = {
  __typename?: 'email_contact_var_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "email_contact" */
export type Email_Contact_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Email_Contact_Variance_Fields = {
  __typename?: 'email_contact_variance_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "email_contact" */
export type Email_Contact_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "email_envelope" */
export type Email_Envelope = {
  __typename?: 'email_envelope';
  address: Scalars['String'];
  /** An object relationship */
  email_message: Email_Message;
  email_message_id: Scalars['uuid'];
  id: Scalars['uuid'];
  type: Scalars['emailenvelopetype'];
};

/** aggregated selection of "email_envelope" */
export type Email_Envelope_Aggregate = {
  __typename?: 'email_envelope_aggregate';
  aggregate: Maybe<Email_Envelope_Aggregate_Fields>;
  nodes: Array<Email_Envelope>;
};

export type Email_Envelope_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Envelope_Aggregate_Bool_Exp_Count>;
};

export type Email_Envelope_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Email_Envelope_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_envelope" */
export type Email_Envelope_Aggregate_Fields = {
  __typename?: 'email_envelope_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Email_Envelope_Max_Fields>;
  min: Maybe<Email_Envelope_Min_Fields>;
};


/** aggregate fields of "email_envelope" */
export type Email_Envelope_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_envelope" */
export type Email_Envelope_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Envelope_Max_Order_By>;
  min?: InputMaybe<Email_Envelope_Min_Order_By>;
};

/** input type for inserting array relation for remote table "email_envelope" */
export type Email_Envelope_Arr_Rel_Insert_Input = {
  data: Array<Email_Envelope_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Envelope_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_envelope". All fields are combined with a logical 'AND'. */
export type Email_Envelope_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Envelope_Bool_Exp>>;
  _not?: InputMaybe<Email_Envelope_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Envelope_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  email_message?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Emailenvelopetype_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_envelope" */
export enum Email_Envelope_Constraint {
  /** unique or primary key constraint on columns "email_message_id", "type" */
  IxEmailEnvelopeEmailMessageIdUniqueTypeMailFrom = 'ix_email_envelope_email_message_id_unique_type_mail_from',
  /** unique or primary key constraint on columns "id" */
  PkEmailEnvelope = 'pk_email_envelope'
}

/** input type for inserting data into table "email_envelope" */
export type Email_Envelope_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  email_message?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['emailenvelopetype']>;
};

/** aggregate max on columns */
export type Email_Envelope_Max_Fields = {
  __typename?: 'email_envelope_max_fields';
  address: Maybe<Scalars['String']>;
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['emailenvelopetype']>;
};

/** order by max() on columns of table "email_envelope" */
export type Email_Envelope_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Envelope_Min_Fields = {
  __typename?: 'email_envelope_min_fields';
  address: Maybe<Scalars['String']>;
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['emailenvelopetype']>;
};

/** order by min() on columns of table "email_envelope" */
export type Email_Envelope_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_envelope" */
export type Email_Envelope_Mutation_Response = {
  __typename?: 'email_envelope_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Envelope>;
};

/** on_conflict condition type for table "email_envelope" */
export type Email_Envelope_On_Conflict = {
  constraint: Email_Envelope_Constraint;
  update_columns?: Array<Email_Envelope_Update_Column>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};

/** Ordering options when selecting data from "email_envelope". */
export type Email_Envelope_Order_By = {
  address?: InputMaybe<Order_By>;
  email_message?: InputMaybe<Email_Message_Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_envelope */
export type Email_Envelope_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_envelope" */
export enum Email_Envelope_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "email_envelope" */
export type Email_Envelope_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['emailenvelopetype']>;
};

/** Streaming cursor of the table "email_envelope" */
export type Email_Envelope_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Envelope_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Envelope_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['emailenvelopetype']>;
};

/** update columns of table "email_envelope" */
export enum Email_Envelope_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

export type Email_Envelope_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Envelope_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Envelope_Bool_Exp;
};

/** columns and relationships of "email_event" */
export type Email_Event = {
  __typename?: 'email_event';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  email_message: Email_Message;
  email_message_id: Scalars['uuid'];
  id: Scalars['uuid'];
  ip: Scalars['String'];
  type: Scalars['emaileventtype'];
  user_agent: Scalars['String'];
};

/** aggregated selection of "email_event" */
export type Email_Event_Aggregate = {
  __typename?: 'email_event_aggregate';
  aggregate: Maybe<Email_Event_Aggregate_Fields>;
  nodes: Array<Email_Event>;
};

export type Email_Event_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Event_Aggregate_Bool_Exp_Count>;
};

export type Email_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Email_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_event" */
export type Email_Event_Aggregate_Fields = {
  __typename?: 'email_event_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Email_Event_Max_Fields>;
  min: Maybe<Email_Event_Min_Fields>;
};


/** aggregate fields of "email_event" */
export type Email_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_event" */
export type Email_Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Event_Max_Order_By>;
  min?: InputMaybe<Email_Event_Min_Order_By>;
};

/** input type for inserting array relation for remote table "email_event" */
export type Email_Event_Arr_Rel_Insert_Input = {
  data: Array<Email_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_event". All fields are combined with a logical 'AND'. */
export type Email_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Event_Bool_Exp>>;
  _not?: InputMaybe<Email_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email_message?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Emaileventtype_Comparison_Exp>;
  user_agent?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_event" */
export enum Email_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEmailEvent = 'pk_email_event'
}

/** input type for inserting data into table "email_event" */
export type Email_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_message?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['emaileventtype']>;
  user_agent?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Email_Event_Max_Fields = {
  __typename?: 'email_event_max_fields';
  created_at: Maybe<Scalars['timestamp']>;
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  ip: Maybe<Scalars['String']>;
  type: Maybe<Scalars['emaileventtype']>;
  user_agent: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "email_event" */
export type Email_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Event_Min_Fields = {
  __typename?: 'email_event_min_fields';
  created_at: Maybe<Scalars['timestamp']>;
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  ip: Maybe<Scalars['String']>;
  type: Maybe<Scalars['emaileventtype']>;
  user_agent: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "email_event" */
export type Email_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_event" */
export type Email_Event_Mutation_Response = {
  __typename?: 'email_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Event>;
};

/** on_conflict condition type for table "email_event" */
export type Email_Event_On_Conflict = {
  constraint: Email_Event_Constraint;
  update_columns?: Array<Email_Event_Update_Column>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "email_event". */
export type Email_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_message?: InputMaybe<Email_Message_Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_event */
export type Email_Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_event" */
export enum Email_Event_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Type = 'type',
  /** column name */
  UserAgent = 'user_agent'
}

/** input type for updating data in table "email_event" */
export type Email_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['emaileventtype']>;
  user_agent?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "email_event" */
export type Email_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  ip?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['emaileventtype']>;
  user_agent?: InputMaybe<Scalars['String']>;
};

/** update columns of table "email_event" */
export enum Email_Event_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Ip = 'ip',
  /** column name */
  Type = 'type',
  /** column name */
  UserAgent = 'user_agent'
}

export type Email_Event_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Event_Bool_Exp;
};

/** columns and relationships of "email_message" */
export type Email_Message = {
  __typename?: 'email_message';
  /** An array relationship */
  contacts: Array<Email_Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Email_Contact_Aggregate;
  content: Scalars['String'];
  created_at: Scalars['timestamp'];
  /** An array relationship */
  envelope: Array<Email_Envelope>;
  /** An aggregate relationship */
  envelope_aggregate: Email_Envelope_Aggregate;
  /** An array relationship */
  events: Array<Email_Event>;
  /** An aggregate relationship */
  events_aggregate: Email_Event_Aggregate;
  id: Scalars['uuid'];
  meta: Maybe<Scalars['jsonb']>;
  mime: Scalars['bytea'];
  msgid: Scalars['String'];
  /** An array relationship */
  pointers: Array<Email_Pointer>;
  /** An aggregate relationship */
  pointers_aggregate: Email_Pointer_Aggregate;
  subject: Scalars['String'];
};


/** columns and relationships of "email_message" */
export type Email_MessageContactsArgs = {
  distinct_on?: InputMaybe<Array<Email_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Contact_Order_By>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessageContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Contact_Order_By>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessageEnvelopeArgs = {
  distinct_on?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Envelope_Order_By>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessageEnvelope_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Envelope_Order_By>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessageEventsArgs = {
  distinct_on?: InputMaybe<Array<Email_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Event_Order_By>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessageEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Event_Order_By>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessageMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "email_message" */
export type Email_MessagePointersArgs = {
  distinct_on?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Pointer_Order_By>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};


/** columns and relationships of "email_message" */
export type Email_MessagePointers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Pointer_Order_By>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};

/** aggregated selection of "email_message" */
export type Email_Message_Aggregate = {
  __typename?: 'email_message_aggregate';
  aggregate: Maybe<Email_Message_Aggregate_Fields>;
  nodes: Array<Email_Message>;
};

/** aggregate fields of "email_message" */
export type Email_Message_Aggregate_Fields = {
  __typename?: 'email_message_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Email_Message_Max_Fields>;
  min: Maybe<Email_Message_Min_Fields>;
};


/** aggregate fields of "email_message" */
export type Email_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Message_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "email_message". All fields are combined with a logical 'AND'. */
export type Email_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Message_Bool_Exp>>;
  _not?: InputMaybe<Email_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Message_Bool_Exp>>;
  contacts?: InputMaybe<Email_Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Email_Contact_Aggregate_Bool_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  envelope?: InputMaybe<Email_Envelope_Bool_Exp>;
  envelope_aggregate?: InputMaybe<Email_Envelope_Aggregate_Bool_Exp>;
  events?: InputMaybe<Email_Event_Bool_Exp>;
  events_aggregate?: InputMaybe<Email_Event_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  mime?: InputMaybe<Bytea_Comparison_Exp>;
  msgid?: InputMaybe<String_Comparison_Exp>;
  pointers?: InputMaybe<Email_Pointer_Bool_Exp>;
  pointers_aggregate?: InputMaybe<Email_Pointer_Aggregate_Bool_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_message" */
export enum Email_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEmailMessage = 'pk_email_message'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Message_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Message_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Message_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "email_message" */
export type Email_Message_Insert_Input = {
  contacts?: InputMaybe<Email_Contact_Arr_Rel_Insert_Input>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  envelope?: InputMaybe<Email_Envelope_Arr_Rel_Insert_Input>;
  events?: InputMaybe<Email_Event_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mime?: InputMaybe<Scalars['bytea']>;
  msgid?: InputMaybe<Scalars['String']>;
  pointers?: InputMaybe<Email_Pointer_Arr_Rel_Insert_Input>;
  subject?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Email_Message_Max_Fields = {
  __typename?: 'email_message_max_fields';
  content: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  msgid: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Email_Message_Min_Fields = {
  __typename?: 'email_message_min_fields';
  content: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  msgid: Maybe<Scalars['String']>;
  subject: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "email_message" */
export type Email_Message_Mutation_Response = {
  __typename?: 'email_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Message>;
};

/** input type for inserting object relation for remote table "email_message" */
export type Email_Message_Obj_Rel_Insert_Input = {
  data: Email_Message_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Message_On_Conflict>;
};

/** on_conflict condition type for table "email_message" */
export type Email_Message_On_Conflict = {
  constraint: Email_Message_Constraint;
  update_columns?: Array<Email_Message_Update_Column>;
  where?: InputMaybe<Email_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "email_message". */
export type Email_Message_Order_By = {
  contacts_aggregate?: InputMaybe<Email_Contact_Aggregate_Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  envelope_aggregate?: InputMaybe<Email_Envelope_Aggregate_Order_By>;
  events_aggregate?: InputMaybe<Email_Event_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  mime?: InputMaybe<Order_By>;
  msgid?: InputMaybe<Order_By>;
  pointers_aggregate?: InputMaybe<Email_Pointer_Aggregate_Order_By>;
  subject?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_message */
export type Email_Message_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Message_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "email_message" */
export enum Email_Message_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mime = 'mime',
  /** column name */
  Msgid = 'msgid',
  /** column name */
  Subject = 'subject'
}

/** input type for updating data in table "email_message" */
export type Email_Message_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mime?: InputMaybe<Scalars['bytea']>;
  msgid?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "email_message" */
export type Email_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Message_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mime?: InputMaybe<Scalars['bytea']>;
  msgid?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/** update columns of table "email_message" */
export enum Email_Message_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mime = 'mime',
  /** column name */
  Msgid = 'msgid',
  /** column name */
  Subject = 'subject'
}

export type Email_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Message_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Message_Bool_Exp;
};

/** columns and relationships of "email_pointer" */
export type Email_Pointer = {
  __typename?: 'email_pointer';
  /** An object relationship */
  email_message: Email_Message;
  email_message_id: Scalars['uuid'];
  id: Scalars['uuid'];
  order: Scalars['Int'];
  pointer_msgid: Scalars['String'];
  type: Scalars['emailpointertype'];
};

/** aggregated selection of "email_pointer" */
export type Email_Pointer_Aggregate = {
  __typename?: 'email_pointer_aggregate';
  aggregate: Maybe<Email_Pointer_Aggregate_Fields>;
  nodes: Array<Email_Pointer>;
};

export type Email_Pointer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Pointer_Aggregate_Bool_Exp_Count>;
};

export type Email_Pointer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Email_Pointer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_pointer" */
export type Email_Pointer_Aggregate_Fields = {
  __typename?: 'email_pointer_aggregate_fields';
  avg: Maybe<Email_Pointer_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Email_Pointer_Max_Fields>;
  min: Maybe<Email_Pointer_Min_Fields>;
  stddev: Maybe<Email_Pointer_Stddev_Fields>;
  stddev_pop: Maybe<Email_Pointer_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Email_Pointer_Stddev_Samp_Fields>;
  sum: Maybe<Email_Pointer_Sum_Fields>;
  var_pop: Maybe<Email_Pointer_Var_Pop_Fields>;
  var_samp: Maybe<Email_Pointer_Var_Samp_Fields>;
  variance: Maybe<Email_Pointer_Variance_Fields>;
};


/** aggregate fields of "email_pointer" */
export type Email_Pointer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "email_pointer" */
export type Email_Pointer_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Pointer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Pointer_Max_Order_By>;
  min?: InputMaybe<Email_Pointer_Min_Order_By>;
  stddev?: InputMaybe<Email_Pointer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Pointer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Pointer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Pointer_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Pointer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Pointer_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Pointer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "email_pointer" */
export type Email_Pointer_Arr_Rel_Insert_Input = {
  data: Array<Email_Pointer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Pointer_On_Conflict>;
};

/** aggregate avg on columns */
export type Email_Pointer_Avg_Fields = {
  __typename?: 'email_pointer_avg_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "email_pointer" */
export type Email_Pointer_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_pointer". All fields are combined with a logical 'AND'. */
export type Email_Pointer_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Pointer_Bool_Exp>>;
  _not?: InputMaybe<Email_Pointer_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Pointer_Bool_Exp>>;
  email_message?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  pointer_msgid?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Emailpointertype_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_pointer" */
export enum Email_Pointer_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkEmailPointer = 'pk_email_pointer',
  /** unique or primary key constraint on columns "order", "email_message_id", "type" */
  UqEmailPointerEmailMessageIdTypeOrder = 'uq_email_pointer_email_message_id_type_order'
}

/** input type for incrementing numeric columns in table "email_pointer" */
export type Email_Pointer_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "email_pointer" */
export type Email_Pointer_Insert_Input = {
  email_message?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  pointer_msgid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['emailpointertype']>;
};

/** aggregate max on columns */
export type Email_Pointer_Max_Fields = {
  __typename?: 'email_pointer_max_fields';
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  order: Maybe<Scalars['Int']>;
  pointer_msgid: Maybe<Scalars['String']>;
  type: Maybe<Scalars['emailpointertype']>;
};

/** order by max() on columns of table "email_pointer" */
export type Email_Pointer_Max_Order_By = {
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pointer_msgid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Pointer_Min_Fields = {
  __typename?: 'email_pointer_min_fields';
  email_message_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  order: Maybe<Scalars['Int']>;
  pointer_msgid: Maybe<Scalars['String']>;
  type: Maybe<Scalars['emailpointertype']>;
};

/** order by min() on columns of table "email_pointer" */
export type Email_Pointer_Min_Order_By = {
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pointer_msgid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_pointer" */
export type Email_Pointer_Mutation_Response = {
  __typename?: 'email_pointer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Pointer>;
};

/** on_conflict condition type for table "email_pointer" */
export type Email_Pointer_On_Conflict = {
  constraint: Email_Pointer_Constraint;
  update_columns?: Array<Email_Pointer_Update_Column>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};

/** Ordering options when selecting data from "email_pointer". */
export type Email_Pointer_Order_By = {
  email_message?: InputMaybe<Email_Message_Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  pointer_msgid?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_pointer */
export type Email_Pointer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "email_pointer" */
export enum Email_Pointer_Select_Column {
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PointerMsgid = 'pointer_msgid',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "email_pointer" */
export type Email_Pointer_Set_Input = {
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  pointer_msgid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['emailpointertype']>;
};

/** aggregate stddev on columns */
export type Email_Pointer_Stddev_Fields = {
  __typename?: 'email_pointer_stddev_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "email_pointer" */
export type Email_Pointer_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Email_Pointer_Stddev_Pop_Fields = {
  __typename?: 'email_pointer_stddev_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "email_pointer" */
export type Email_Pointer_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Email_Pointer_Stddev_Samp_Fields = {
  __typename?: 'email_pointer_stddev_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "email_pointer" */
export type Email_Pointer_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_pointer" */
export type Email_Pointer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Pointer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Pointer_Stream_Cursor_Value_Input = {
  email_message_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  pointer_msgid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['emailpointertype']>;
};

/** aggregate sum on columns */
export type Email_Pointer_Sum_Fields = {
  __typename?: 'email_pointer_sum_fields';
  order: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "email_pointer" */
export type Email_Pointer_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "email_pointer" */
export enum Email_Pointer_Update_Column {
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PointerMsgid = 'pointer_msgid',
  /** column name */
  Type = 'type'
}

export type Email_Pointer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Pointer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Pointer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Pointer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Pointer_Var_Pop_Fields = {
  __typename?: 'email_pointer_var_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "email_pointer" */
export type Email_Pointer_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Email_Pointer_Var_Samp_Fields = {
  __typename?: 'email_pointer_var_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "email_pointer" */
export type Email_Pointer_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Email_Pointer_Variance_Fields = {
  __typename?: 'email_pointer_variance_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "email_pointer" */
export type Email_Pointer_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "emailcontacttype". All fields are combined with logical 'AND'. */
export type Emailcontacttype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['emailcontacttype']>;
  _gt?: InputMaybe<Scalars['emailcontacttype']>;
  _gte?: InputMaybe<Scalars['emailcontacttype']>;
  _in?: InputMaybe<Array<Scalars['emailcontacttype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['emailcontacttype']>;
  _lte?: InputMaybe<Scalars['emailcontacttype']>;
  _neq?: InputMaybe<Scalars['emailcontacttype']>;
  _nin?: InputMaybe<Array<Scalars['emailcontacttype']>>;
};

/** Boolean expression to compare columns of type "emailenvelopetype". All fields are combined with logical 'AND'. */
export type Emailenvelopetype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['emailenvelopetype']>;
  _gt?: InputMaybe<Scalars['emailenvelopetype']>;
  _gte?: InputMaybe<Scalars['emailenvelopetype']>;
  _in?: InputMaybe<Array<Scalars['emailenvelopetype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['emailenvelopetype']>;
  _lte?: InputMaybe<Scalars['emailenvelopetype']>;
  _neq?: InputMaybe<Scalars['emailenvelopetype']>;
  _nin?: InputMaybe<Array<Scalars['emailenvelopetype']>>;
};

/** Boolean expression to compare columns of type "emaileventtype". All fields are combined with logical 'AND'. */
export type Emaileventtype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['emaileventtype']>;
  _gt?: InputMaybe<Scalars['emaileventtype']>;
  _gte?: InputMaybe<Scalars['emaileventtype']>;
  _in?: InputMaybe<Array<Scalars['emaileventtype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['emaileventtype']>;
  _lte?: InputMaybe<Scalars['emaileventtype']>;
  _neq?: InputMaybe<Scalars['emaileventtype']>;
  _nin?: InputMaybe<Array<Scalars['emaileventtype']>>;
};

/** Boolean expression to compare columns of type "emailpointertype". All fields are combined with logical 'AND'. */
export type Emailpointertype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['emailpointertype']>;
  _gt?: InputMaybe<Scalars['emailpointertype']>;
  _gte?: InputMaybe<Scalars['emailpointertype']>;
  _in?: InputMaybe<Array<Scalars['emailpointertype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['emailpointertype']>;
  _lte?: InputMaybe<Scalars['emailpointertype']>;
  _neq?: InputMaybe<Scalars['emailpointertype']>;
  _nin?: InputMaybe<Array<Scalars['emailpointertype']>>;
};

/** Boolean expression to compare columns of type "experiencelevel". All fields are combined with logical 'AND'. */
export type Experiencelevel_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['experiencelevel']>;
  _gt?: InputMaybe<Scalars['experiencelevel']>;
  _gte?: InputMaybe<Scalars['experiencelevel']>;
  _in?: InputMaybe<Array<Scalars['experiencelevel']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['experiencelevel']>;
  _lte?: InputMaybe<Scalars['experiencelevel']>;
  _neq?: InputMaybe<Scalars['experiencelevel']>;
  _nin?: InputMaybe<Array<Scalars['experiencelevel']>>;
};

/** columns and relationships of "ext_job_posting" */
export type Ext_Job_Posting = {
  __typename?: 'ext_job_posting';
  city: Scalars['String'];
  created_at: Scalars['timestamp'];
  description_html: Scalars['String'];
  description_plain: Scalars['String'];
  /** An array relationship */
  errors: Array<Ext_Posting_Error>;
  /** An aggregate relationship */
  errors_aggregate: Ext_Posting_Error_Aggregate;
  /** An object relationship */
  facility: Maybe<Facility>;
  facility_id: Maybe<Scalars['uuid']>;
  facility_name: Scalars['String'];
  id: Scalars['uuid'];
  ignored: Scalars['Boolean'];
  /** An object relationship */
  int_posting: Maybe<Job_Posting>;
  int_posting_id: Maybe<Scalars['uuid']>;
  job_id: Scalars['String'];
  location: Maybe<Scalars['geography']>;
  /** An object relationship */
  org: Maybe<Organization>;
  org_id: Maybe<Scalars['uuid']>;
  org_name: Scalars['String'];
  posted: Maybe<Scalars['timestamp']>;
  proc_auto: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  professions: Array<Ext_Posting_Profession>;
  /** An aggregate relationship */
  professions_aggregate: Ext_Posting_Profession_Aggregate;
  r_email: Scalars['String'];
  r_first_name: Scalars['String'];
  r_last_name: Scalars['String'];
  r_phone: Scalars['String'];
  r_title: Scalars['String'];
  /** An object relationship */
  recruiter: Maybe<Org_User>;
  recruiter_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  scrape: Ext_Job_Scrape;
  scrape_id: Scalars['uuid'];
  specialty: Scalars['String'];
  state: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  zipcode: Scalars['String'];
};


/** columns and relationships of "ext_job_posting" */
export type Ext_Job_PostingErrorsArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Error_Order_By>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


/** columns and relationships of "ext_job_posting" */
export type Ext_Job_PostingErrors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Error_Order_By>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


/** columns and relationships of "ext_job_posting" */
export type Ext_Job_PostingProfessionsArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Profession_Order_By>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};


/** columns and relationships of "ext_job_posting" */
export type Ext_Job_PostingProfessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Profession_Order_By>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};

/** aggregated selection of "ext_job_posting" */
export type Ext_Job_Posting_Aggregate = {
  __typename?: 'ext_job_posting_aggregate';
  aggregate: Maybe<Ext_Job_Posting_Aggregate_Fields>;
  nodes: Array<Ext_Job_Posting>;
};

export type Ext_Job_Posting_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp_Count>;
};

export type Ext_Job_Posting_Aggregate_Bool_Exp_Bool_And = {
  arguments: Ext_Job_Posting_Select_Column_Ext_Job_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ext_Job_Posting_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Ext_Job_Posting_Select_Column_Ext_Job_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Ext_Job_Posting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ext_job_posting" */
export type Ext_Job_Posting_Aggregate_Fields = {
  __typename?: 'ext_job_posting_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Ext_Job_Posting_Max_Fields>;
  min: Maybe<Ext_Job_Posting_Min_Fields>;
};


/** aggregate fields of "ext_job_posting" */
export type Ext_Job_Posting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ext_job_posting" */
export type Ext_Job_Posting_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ext_Job_Posting_Max_Order_By>;
  min?: InputMaybe<Ext_Job_Posting_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ext_job_posting" */
export type Ext_Job_Posting_Arr_Rel_Insert_Input = {
  data: Array<Ext_Job_Posting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ext_Job_Posting_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ext_job_posting". All fields are combined with a logical 'AND'. */
export type Ext_Job_Posting_Bool_Exp = {
  _and?: InputMaybe<Array<Ext_Job_Posting_Bool_Exp>>;
  _not?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  _or?: InputMaybe<Array<Ext_Job_Posting_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description_html?: InputMaybe<String_Comparison_Exp>;
  description_plain?: InputMaybe<String_Comparison_Exp>;
  errors?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
  errors_aggregate?: InputMaybe<Ext_Posting_Error_Aggregate_Bool_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  facility_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ignored?: InputMaybe<Boolean_Comparison_Exp>;
  int_posting?: InputMaybe<Job_Posting_Bool_Exp>;
  int_posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  job_id?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  org_name?: InputMaybe<String_Comparison_Exp>;
  posted?: InputMaybe<Timestamp_Comparison_Exp>;
  proc_auto?: InputMaybe<Timestamp_Comparison_Exp>;
  professions?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
  professions_aggregate?: InputMaybe<Ext_Posting_Profession_Aggregate_Bool_Exp>;
  r_email?: InputMaybe<String_Comparison_Exp>;
  r_first_name?: InputMaybe<String_Comparison_Exp>;
  r_last_name?: InputMaybe<String_Comparison_Exp>;
  r_phone?: InputMaybe<String_Comparison_Exp>;
  r_title?: InputMaybe<String_Comparison_Exp>;
  recruiter?: InputMaybe<Org_User_Bool_Exp>;
  recruiter_id?: InputMaybe<Uuid_Comparison_Exp>;
  scrape?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
  scrape_id?: InputMaybe<Uuid_Comparison_Exp>;
  specialty?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ext_job_posting" */
export enum Ext_Job_Posting_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExtJobPosting = 'pk_ext_job_posting'
}

/** input type for inserting data into table "ext_job_posting" */
export type Ext_Job_Posting_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description_html?: InputMaybe<Scalars['String']>;
  description_plain?: InputMaybe<Scalars['String']>;
  errors?: InputMaybe<Ext_Posting_Error_Arr_Rel_Insert_Input>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  facility_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  int_posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  int_posting_id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_name?: InputMaybe<Scalars['String']>;
  posted?: InputMaybe<Scalars['timestamp']>;
  proc_auto?: InputMaybe<Scalars['timestamp']>;
  professions?: InputMaybe<Ext_Posting_Profession_Arr_Rel_Insert_Input>;
  r_email?: InputMaybe<Scalars['String']>;
  r_first_name?: InputMaybe<Scalars['String']>;
  r_last_name?: InputMaybe<Scalars['String']>;
  r_phone?: InputMaybe<Scalars['String']>;
  r_title?: InputMaybe<Scalars['String']>;
  recruiter?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
  scrape?: InputMaybe<Ext_Job_Scrape_Obj_Rel_Insert_Input>;
  scrape_id?: InputMaybe<Scalars['uuid']>;
  specialty?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ext_Job_Posting_Max_Fields = {
  __typename?: 'ext_job_posting_max_fields';
  city: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  description_html: Maybe<Scalars['String']>;
  description_plain: Maybe<Scalars['String']>;
  facility_id: Maybe<Scalars['uuid']>;
  facility_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  int_posting_id: Maybe<Scalars['uuid']>;
  job_id: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
  org_name: Maybe<Scalars['String']>;
  posted: Maybe<Scalars['timestamp']>;
  proc_auto: Maybe<Scalars['timestamp']>;
  r_email: Maybe<Scalars['String']>;
  r_first_name: Maybe<Scalars['String']>;
  r_last_name: Maybe<Scalars['String']>;
  r_phone: Maybe<Scalars['String']>;
  r_title: Maybe<Scalars['String']>;
  recruiter_id: Maybe<Scalars['uuid']>;
  scrape_id: Maybe<Scalars['uuid']>;
  specialty: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ext_job_posting" */
export type Ext_Job_Posting_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description_html?: InputMaybe<Order_By>;
  description_plain?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  facility_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  int_posting_id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_name?: InputMaybe<Order_By>;
  posted?: InputMaybe<Order_By>;
  proc_auto?: InputMaybe<Order_By>;
  r_email?: InputMaybe<Order_By>;
  r_first_name?: InputMaybe<Order_By>;
  r_last_name?: InputMaybe<Order_By>;
  r_phone?: InputMaybe<Order_By>;
  r_title?: InputMaybe<Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
  scrape_id?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ext_Job_Posting_Min_Fields = {
  __typename?: 'ext_job_posting_min_fields';
  city: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  description_html: Maybe<Scalars['String']>;
  description_plain: Maybe<Scalars['String']>;
  facility_id: Maybe<Scalars['uuid']>;
  facility_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  int_posting_id: Maybe<Scalars['uuid']>;
  job_id: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
  org_name: Maybe<Scalars['String']>;
  posted: Maybe<Scalars['timestamp']>;
  proc_auto: Maybe<Scalars['timestamp']>;
  r_email: Maybe<Scalars['String']>;
  r_first_name: Maybe<Scalars['String']>;
  r_last_name: Maybe<Scalars['String']>;
  r_phone: Maybe<Scalars['String']>;
  r_title: Maybe<Scalars['String']>;
  recruiter_id: Maybe<Scalars['uuid']>;
  scrape_id: Maybe<Scalars['uuid']>;
  specialty: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  title: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ext_job_posting" */
export type Ext_Job_Posting_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description_html?: InputMaybe<Order_By>;
  description_plain?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  facility_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  int_posting_id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_name?: InputMaybe<Order_By>;
  posted?: InputMaybe<Order_By>;
  proc_auto?: InputMaybe<Order_By>;
  r_email?: InputMaybe<Order_By>;
  r_first_name?: InputMaybe<Order_By>;
  r_last_name?: InputMaybe<Order_By>;
  r_phone?: InputMaybe<Order_By>;
  r_title?: InputMaybe<Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
  scrape_id?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ext_job_posting" */
export type Ext_Job_Posting_Mutation_Response = {
  __typename?: 'ext_job_posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ext_Job_Posting>;
};

/** input type for inserting object relation for remote table "ext_job_posting" */
export type Ext_Job_Posting_Obj_Rel_Insert_Input = {
  data: Ext_Job_Posting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ext_Job_Posting_On_Conflict>;
};

/** on_conflict condition type for table "ext_job_posting" */
export type Ext_Job_Posting_On_Conflict = {
  constraint: Ext_Job_Posting_Constraint;
  update_columns?: Array<Ext_Job_Posting_Update_Column>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};

/** Ordering options when selecting data from "ext_job_posting". */
export type Ext_Job_Posting_Order_By = {
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description_html?: InputMaybe<Order_By>;
  description_plain?: InputMaybe<Order_By>;
  errors_aggregate?: InputMaybe<Ext_Posting_Error_Aggregate_Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  facility_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignored?: InputMaybe<Order_By>;
  int_posting?: InputMaybe<Job_Posting_Order_By>;
  int_posting_id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_name?: InputMaybe<Order_By>;
  posted?: InputMaybe<Order_By>;
  proc_auto?: InputMaybe<Order_By>;
  professions_aggregate?: InputMaybe<Ext_Posting_Profession_Aggregate_Order_By>;
  r_email?: InputMaybe<Order_By>;
  r_first_name?: InputMaybe<Order_By>;
  r_last_name?: InputMaybe<Order_By>;
  r_phone?: InputMaybe<Order_By>;
  r_title?: InputMaybe<Order_By>;
  recruiter?: InputMaybe<Org_User_Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
  scrape?: InputMaybe<Ext_Job_Scrape_Order_By>;
  scrape_id?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ext_job_posting */
export type Ext_Job_Posting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ext_job_posting" */
export enum Ext_Job_Posting_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionHtml = 'description_html',
  /** column name */
  DescriptionPlain = 'description_plain',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FacilityName = 'facility_name',
  /** column name */
  Id = 'id',
  /** column name */
  Ignored = 'ignored',
  /** column name */
  IntPostingId = 'int_posting_id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Location = 'location',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgName = 'org_name',
  /** column name */
  Posted = 'posted',
  /** column name */
  ProcAuto = 'proc_auto',
  /** column name */
  REmail = 'r_email',
  /** column name */
  RFirstName = 'r_first_name',
  /** column name */
  RLastName = 'r_last_name',
  /** column name */
  RPhone = 'r_phone',
  /** column name */
  RTitle = 'r_title',
  /** column name */
  RecruiterId = 'recruiter_id',
  /** column name */
  ScrapeId = 'scrape_id',
  /** column name */
  Specialty = 'specialty',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url',
  /** column name */
  Zipcode = 'zipcode'
}

/** select "ext_job_posting_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ext_job_posting" */
export enum Ext_Job_Posting_Select_Column_Ext_Job_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Ignored = 'ignored'
}

/** select "ext_job_posting_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ext_job_posting" */
export enum Ext_Job_Posting_Select_Column_Ext_Job_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Ignored = 'ignored'
}

/** input type for updating data in table "ext_job_posting" */
export type Ext_Job_Posting_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description_html?: InputMaybe<Scalars['String']>;
  description_plain?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  facility_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  int_posting_id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_name?: InputMaybe<Scalars['String']>;
  posted?: InputMaybe<Scalars['timestamp']>;
  proc_auto?: InputMaybe<Scalars['timestamp']>;
  r_email?: InputMaybe<Scalars['String']>;
  r_first_name?: InputMaybe<Scalars['String']>;
  r_last_name?: InputMaybe<Scalars['String']>;
  r_phone?: InputMaybe<Scalars['String']>;
  r_title?: InputMaybe<Scalars['String']>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
  scrape_id?: InputMaybe<Scalars['uuid']>;
  specialty?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ext_job_posting" */
export type Ext_Job_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ext_Job_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ext_Job_Posting_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description_html?: InputMaybe<Scalars['String']>;
  description_plain?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  facility_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  int_posting_id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_name?: InputMaybe<Scalars['String']>;
  posted?: InputMaybe<Scalars['timestamp']>;
  proc_auto?: InputMaybe<Scalars['timestamp']>;
  r_email?: InputMaybe<Scalars['String']>;
  r_first_name?: InputMaybe<Scalars['String']>;
  r_last_name?: InputMaybe<Scalars['String']>;
  r_phone?: InputMaybe<Scalars['String']>;
  r_title?: InputMaybe<Scalars['String']>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
  scrape_id?: InputMaybe<Scalars['uuid']>;
  specialty?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ext_job_posting" */
export enum Ext_Job_Posting_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionHtml = 'description_html',
  /** column name */
  DescriptionPlain = 'description_plain',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FacilityName = 'facility_name',
  /** column name */
  Id = 'id',
  /** column name */
  Ignored = 'ignored',
  /** column name */
  IntPostingId = 'int_posting_id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Location = 'location',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgName = 'org_name',
  /** column name */
  Posted = 'posted',
  /** column name */
  ProcAuto = 'proc_auto',
  /** column name */
  REmail = 'r_email',
  /** column name */
  RFirstName = 'r_first_name',
  /** column name */
  RLastName = 'r_last_name',
  /** column name */
  RPhone = 'r_phone',
  /** column name */
  RTitle = 'r_title',
  /** column name */
  RecruiterId = 'recruiter_id',
  /** column name */
  ScrapeId = 'scrape_id',
  /** column name */
  Specialty = 'specialty',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url',
  /** column name */
  Zipcode = 'zipcode'
}

export type Ext_Job_Posting_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ext_Job_Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ext_Job_Posting_Bool_Exp;
};

/** columns and relationships of "ext_job_scrape" */
export type Ext_Job_Scrape = {
  __typename?: 'ext_job_scrape';
  created_at: Scalars['timestamp'];
  /** An array relationship */
  ext_postings: Array<Ext_Job_Posting>;
  /** An aggregate relationship */
  ext_postings_aggregate: Ext_Job_Posting_Aggregate;
  id: Scalars['uuid'];
  perpetual: Scalars['Boolean'];
  proc_auto: Maybe<Scalars['timestamp']>;
  proc_man: Maybe<Scalars['timestamp']>;
  scraped_at: Maybe<Scalars['timestamp']>;
  scraper: Scalars['String'];
};


/** columns and relationships of "ext_job_scrape" */
export type Ext_Job_ScrapeExt_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "ext_job_scrape" */
export type Ext_Job_ScrapeExt_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};

/** aggregated selection of "ext_job_scrape" */
export type Ext_Job_Scrape_Aggregate = {
  __typename?: 'ext_job_scrape_aggregate';
  aggregate: Maybe<Ext_Job_Scrape_Aggregate_Fields>;
  nodes: Array<Ext_Job_Scrape>;
};

/** aggregate fields of "ext_job_scrape" */
export type Ext_Job_Scrape_Aggregate_Fields = {
  __typename?: 'ext_job_scrape_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Ext_Job_Scrape_Max_Fields>;
  min: Maybe<Ext_Job_Scrape_Min_Fields>;
};


/** aggregate fields of "ext_job_scrape" */
export type Ext_Job_Scrape_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ext_Job_Scrape_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ext_job_scrape". All fields are combined with a logical 'AND'. */
export type Ext_Job_Scrape_Bool_Exp = {
  _and?: InputMaybe<Array<Ext_Job_Scrape_Bool_Exp>>;
  _not?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
  _or?: InputMaybe<Array<Ext_Job_Scrape_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  perpetual?: InputMaybe<Boolean_Comparison_Exp>;
  proc_auto?: InputMaybe<Timestamp_Comparison_Exp>;
  proc_man?: InputMaybe<Timestamp_Comparison_Exp>;
  scraped_at?: InputMaybe<Timestamp_Comparison_Exp>;
  scraper?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ext_job_scrape" */
export enum Ext_Job_Scrape_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExtJobScrape = 'pk_ext_job_scrape'
}

/** input type for inserting data into table "ext_job_scrape" */
export type Ext_Job_Scrape_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  perpetual?: InputMaybe<Scalars['Boolean']>;
  proc_auto?: InputMaybe<Scalars['timestamp']>;
  proc_man?: InputMaybe<Scalars['timestamp']>;
  scraped_at?: InputMaybe<Scalars['timestamp']>;
  scraper?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ext_Job_Scrape_Max_Fields = {
  __typename?: 'ext_job_scrape_max_fields';
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  proc_auto: Maybe<Scalars['timestamp']>;
  proc_man: Maybe<Scalars['timestamp']>;
  scraped_at: Maybe<Scalars['timestamp']>;
  scraper: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ext_Job_Scrape_Min_Fields = {
  __typename?: 'ext_job_scrape_min_fields';
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  proc_auto: Maybe<Scalars['timestamp']>;
  proc_man: Maybe<Scalars['timestamp']>;
  scraped_at: Maybe<Scalars['timestamp']>;
  scraper: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "ext_job_scrape" */
export type Ext_Job_Scrape_Mutation_Response = {
  __typename?: 'ext_job_scrape_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ext_Job_Scrape>;
};

/** input type for inserting object relation for remote table "ext_job_scrape" */
export type Ext_Job_Scrape_Obj_Rel_Insert_Input = {
  data: Ext_Job_Scrape_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Ext_Job_Scrape_On_Conflict>;
};

/** on_conflict condition type for table "ext_job_scrape" */
export type Ext_Job_Scrape_On_Conflict = {
  constraint: Ext_Job_Scrape_Constraint;
  update_columns?: Array<Ext_Job_Scrape_Update_Column>;
  where?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
};

/** Ordering options when selecting data from "ext_job_scrape". */
export type Ext_Job_Scrape_Order_By = {
  created_at?: InputMaybe<Order_By>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  perpetual?: InputMaybe<Order_By>;
  proc_auto?: InputMaybe<Order_By>;
  proc_man?: InputMaybe<Order_By>;
  scraped_at?: InputMaybe<Order_By>;
  scraper?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ext_job_scrape */
export type Ext_Job_Scrape_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ext_job_scrape" */
export enum Ext_Job_Scrape_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Perpetual = 'perpetual',
  /** column name */
  ProcAuto = 'proc_auto',
  /** column name */
  ProcMan = 'proc_man',
  /** column name */
  ScrapedAt = 'scraped_at',
  /** column name */
  Scraper = 'scraper'
}

/** input type for updating data in table "ext_job_scrape" */
export type Ext_Job_Scrape_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  perpetual?: InputMaybe<Scalars['Boolean']>;
  proc_auto?: InputMaybe<Scalars['timestamp']>;
  proc_man?: InputMaybe<Scalars['timestamp']>;
  scraped_at?: InputMaybe<Scalars['timestamp']>;
  scraper?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ext_job_scrape" */
export type Ext_Job_Scrape_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ext_Job_Scrape_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ext_Job_Scrape_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  perpetual?: InputMaybe<Scalars['Boolean']>;
  proc_auto?: InputMaybe<Scalars['timestamp']>;
  proc_man?: InputMaybe<Scalars['timestamp']>;
  scraped_at?: InputMaybe<Scalars['timestamp']>;
  scraper?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ext_job_scrape" */
export enum Ext_Job_Scrape_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Perpetual = 'perpetual',
  /** column name */
  ProcAuto = 'proc_auto',
  /** column name */
  ProcMan = 'proc_man',
  /** column name */
  ScrapedAt = 'scraped_at',
  /** column name */
  Scraper = 'scraper'
}

export type Ext_Job_Scrape_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ext_Job_Scrape_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ext_Job_Scrape_Bool_Exp;
};

/** columns and relationships of "ext_posting_error" */
export type Ext_Posting_Error = {
  __typename?: 'ext_posting_error';
  /** An object relationship */
  ext_posting: Ext_Job_Posting;
  ext_posting_id: Scalars['uuid'];
  field: Scalars['String'];
  id: Scalars['uuid'];
  message: Scalars['String'];
};

/** aggregated selection of "ext_posting_error" */
export type Ext_Posting_Error_Aggregate = {
  __typename?: 'ext_posting_error_aggregate';
  aggregate: Maybe<Ext_Posting_Error_Aggregate_Fields>;
  nodes: Array<Ext_Posting_Error>;
};

export type Ext_Posting_Error_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ext_Posting_Error_Aggregate_Bool_Exp_Count>;
};

export type Ext_Posting_Error_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ext_posting_error" */
export type Ext_Posting_Error_Aggregate_Fields = {
  __typename?: 'ext_posting_error_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Ext_Posting_Error_Max_Fields>;
  min: Maybe<Ext_Posting_Error_Min_Fields>;
};


/** aggregate fields of "ext_posting_error" */
export type Ext_Posting_Error_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ext_posting_error" */
export type Ext_Posting_Error_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ext_Posting_Error_Max_Order_By>;
  min?: InputMaybe<Ext_Posting_Error_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ext_posting_error" */
export type Ext_Posting_Error_Arr_Rel_Insert_Input = {
  data: Array<Ext_Posting_Error_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ext_Posting_Error_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ext_posting_error". All fields are combined with a logical 'AND'. */
export type Ext_Posting_Error_Bool_Exp = {
  _and?: InputMaybe<Array<Ext_Posting_Error_Bool_Exp>>;
  _not?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
  _or?: InputMaybe<Array<Ext_Posting_Error_Bool_Exp>>;
  ext_posting?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  ext_posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  field?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ext_posting_error" */
export enum Ext_Posting_Error_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExtPostingError = 'pk_ext_posting_error'
}

/** input type for inserting data into table "ext_posting_error" */
export type Ext_Posting_Error_Insert_Input = {
  ext_posting?: InputMaybe<Ext_Job_Posting_Obj_Rel_Insert_Input>;
  ext_posting_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ext_Posting_Error_Max_Fields = {
  __typename?: 'ext_posting_error_max_fields';
  ext_posting_id: Maybe<Scalars['uuid']>;
  field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  message: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ext_posting_error" */
export type Ext_Posting_Error_Max_Order_By = {
  ext_posting_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ext_Posting_Error_Min_Fields = {
  __typename?: 'ext_posting_error_min_fields';
  ext_posting_id: Maybe<Scalars['uuid']>;
  field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  message: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ext_posting_error" */
export type Ext_Posting_Error_Min_Order_By = {
  ext_posting_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ext_posting_error" */
export type Ext_Posting_Error_Mutation_Response = {
  __typename?: 'ext_posting_error_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ext_Posting_Error>;
};

/** on_conflict condition type for table "ext_posting_error" */
export type Ext_Posting_Error_On_Conflict = {
  constraint: Ext_Posting_Error_Constraint;
  update_columns?: Array<Ext_Posting_Error_Update_Column>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};

/** Ordering options when selecting data from "ext_posting_error". */
export type Ext_Posting_Error_Order_By = {
  ext_posting?: InputMaybe<Ext_Job_Posting_Order_By>;
  ext_posting_id?: InputMaybe<Order_By>;
  field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ext_posting_error */
export type Ext_Posting_Error_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ext_posting_error" */
export enum Ext_Posting_Error_Select_Column {
  /** column name */
  ExtPostingId = 'ext_posting_id',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message'
}

/** input type for updating data in table "ext_posting_error" */
export type Ext_Posting_Error_Set_Input = {
  ext_posting_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ext_posting_error" */
export type Ext_Posting_Error_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ext_Posting_Error_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ext_Posting_Error_Stream_Cursor_Value_Input = {
  ext_posting_id?: InputMaybe<Scalars['uuid']>;
  field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
};

/** update columns of table "ext_posting_error" */
export enum Ext_Posting_Error_Update_Column {
  /** column name */
  ExtPostingId = 'ext_posting_id',
  /** column name */
  Field = 'field',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message'
}

export type Ext_Posting_Error_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ext_Posting_Error_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ext_Posting_Error_Bool_Exp;
};

/** columns and relationships of "ext_posting_profession" */
export type Ext_Posting_Profession = {
  __typename?: 'ext_posting_profession';
  /** An object relationship */
  contract_featured: Maybe<Facility_Contract_Featured>;
  contract_featured_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  ext_posting: Ext_Job_Posting;
  ext_posting_id: Scalars['uuid'];
  id: Scalars['uuid'];
  profession: Scalars['profession'];
};

/** aggregated selection of "ext_posting_profession" */
export type Ext_Posting_Profession_Aggregate = {
  __typename?: 'ext_posting_profession_aggregate';
  aggregate: Maybe<Ext_Posting_Profession_Aggregate_Fields>;
  nodes: Array<Ext_Posting_Profession>;
};

export type Ext_Posting_Profession_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ext_Posting_Profession_Aggregate_Bool_Exp_Count>;
};

export type Ext_Posting_Profession_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ext_posting_profession" */
export type Ext_Posting_Profession_Aggregate_Fields = {
  __typename?: 'ext_posting_profession_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Ext_Posting_Profession_Max_Fields>;
  min: Maybe<Ext_Posting_Profession_Min_Fields>;
};


/** aggregate fields of "ext_posting_profession" */
export type Ext_Posting_Profession_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ext_posting_profession" */
export type Ext_Posting_Profession_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ext_Posting_Profession_Max_Order_By>;
  min?: InputMaybe<Ext_Posting_Profession_Min_Order_By>;
};

/** input type for inserting array relation for remote table "ext_posting_profession" */
export type Ext_Posting_Profession_Arr_Rel_Insert_Input = {
  data: Array<Ext_Posting_Profession_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ext_Posting_Profession_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ext_posting_profession". All fields are combined with a logical 'AND'. */
export type Ext_Posting_Profession_Bool_Exp = {
  _and?: InputMaybe<Array<Ext_Posting_Profession_Bool_Exp>>;
  _not?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
  _or?: InputMaybe<Array<Ext_Posting_Profession_Bool_Exp>>;
  contract_featured?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
  contract_featured_id?: InputMaybe<Uuid_Comparison_Exp>;
  ext_posting?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  ext_posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
};

/** unique or primary key constraints on table "ext_posting_profession" */
export enum Ext_Posting_Profession_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkExtPostingProfession = 'pk_ext_posting_profession',
  /** unique or primary key constraint on columns "ext_posting_id", "profession" */
  UqExtPostingProfessionExtPostingIdProfession = 'uq_ext_posting_profession_ext_posting_id_profession'
}

/** input type for inserting data into table "ext_posting_profession" */
export type Ext_Posting_Profession_Insert_Input = {
  contract_featured?: InputMaybe<Facility_Contract_Featured_Obj_Rel_Insert_Input>;
  contract_featured_id?: InputMaybe<Scalars['uuid']>;
  ext_posting?: InputMaybe<Ext_Job_Posting_Obj_Rel_Insert_Input>;
  ext_posting_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** aggregate max on columns */
export type Ext_Posting_Profession_Max_Fields = {
  __typename?: 'ext_posting_profession_max_fields';
  contract_featured_id: Maybe<Scalars['uuid']>;
  ext_posting_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  profession: Maybe<Scalars['profession']>;
};

/** order by max() on columns of table "ext_posting_profession" */
export type Ext_Posting_Profession_Max_Order_By = {
  contract_featured_id?: InputMaybe<Order_By>;
  ext_posting_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ext_Posting_Profession_Min_Fields = {
  __typename?: 'ext_posting_profession_min_fields';
  contract_featured_id: Maybe<Scalars['uuid']>;
  ext_posting_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  profession: Maybe<Scalars['profession']>;
};

/** order by min() on columns of table "ext_posting_profession" */
export type Ext_Posting_Profession_Min_Order_By = {
  contract_featured_id?: InputMaybe<Order_By>;
  ext_posting_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ext_posting_profession" */
export type Ext_Posting_Profession_Mutation_Response = {
  __typename?: 'ext_posting_profession_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ext_Posting_Profession>;
};

/** on_conflict condition type for table "ext_posting_profession" */
export type Ext_Posting_Profession_On_Conflict = {
  constraint: Ext_Posting_Profession_Constraint;
  update_columns?: Array<Ext_Posting_Profession_Update_Column>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};

/** Ordering options when selecting data from "ext_posting_profession". */
export type Ext_Posting_Profession_Order_By = {
  contract_featured?: InputMaybe<Facility_Contract_Featured_Order_By>;
  contract_featured_id?: InputMaybe<Order_By>;
  ext_posting?: InputMaybe<Ext_Job_Posting_Order_By>;
  ext_posting_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ext_posting_profession */
export type Ext_Posting_Profession_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ext_posting_profession" */
export enum Ext_Posting_Profession_Select_Column {
  /** column name */
  ContractFeaturedId = 'contract_featured_id',
  /** column name */
  ExtPostingId = 'ext_posting_id',
  /** column name */
  Id = 'id',
  /** column name */
  Profession = 'profession'
}

/** input type for updating data in table "ext_posting_profession" */
export type Ext_Posting_Profession_Set_Input = {
  contract_featured_id?: InputMaybe<Scalars['uuid']>;
  ext_posting_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** Streaming cursor of the table "ext_posting_profession" */
export type Ext_Posting_Profession_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ext_Posting_Profession_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ext_Posting_Profession_Stream_Cursor_Value_Input = {
  contract_featured_id?: InputMaybe<Scalars['uuid']>;
  ext_posting_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** update columns of table "ext_posting_profession" */
export enum Ext_Posting_Profession_Update_Column {
  /** column name */
  ContractFeaturedId = 'contract_featured_id',
  /** column name */
  ExtPostingId = 'ext_posting_id',
  /** column name */
  Id = 'id',
  /** column name */
  Profession = 'profession'
}

export type Ext_Posting_Profession_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ext_Posting_Profession_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ext_Posting_Profession_Bool_Exp;
};

/** columns and relationships of "facility" */
export type Facility = {
  __typename?: 'facility';
  /** An array relationship */
  accreditations: Array<Facility_Accreditation>;
  /** An aggregate relationship */
  accreditations_aggregate: Facility_Accreditation_Aggregate;
  adult_trauma_lvl: Maybe<Scalars['Int']>;
  /** An object relationship */
  aha_facility: Maybe<As20Dem>;
  /** An object relationship */
  aha_facility_21: Maybe<As21Dem>;
  aha_facility_21_id: Maybe<Scalars['String']>;
  /** An object relationship */
  aha_facility_22: Maybe<As22Dem>;
  aha_facility_22_id: Maybe<Scalars['String']>;
  aha_facility_id: Maybe<Scalars['String']>;
  city: Scalars['String'];
  /** An object relationship */
  cms_facility: Maybe<Cms_Facility>;
  /** An object relationship */
  cms_facility_enrollment: Maybe<Cms_Facility_Enrollment>;
  cms_facility_id: Maybe<Scalars['String']>;
  /** An object relationship */
  cms_facility_pos: Maybe<Cms_Facility_Pos>;
  /** An array relationship */
  contracts: Array<Facility_Contract>;
  /** An aggregate relationship */
  contracts_aggregate: Facility_Contract_Aggregate;
  description: Scalars['String'];
  /** An array relationship */
  ehrs: Array<Facility_Ehr>;
  /** An aggregate relationship */
  ehrs_aggregate: Facility_Ehr_Aggregate;
  /** An array relationship */
  ext_postings: Array<Ext_Job_Posting>;
  /** An aggregate relationship */
  ext_postings_aggregate: Ext_Job_Posting_Aggregate;
  facilityType: Scalars['String'];
  /** An array relationship */
  facility_ratings: Array<Facility_Rating>;
  /** An aggregate relationship */
  facility_ratings_aggregate: Facility_Rating_Aggregate;
  /** A computed field, executes function "facility_featured_for_prof" */
  featured_for_prof: Maybe<Scalars['Boolean']>;
  freestanding_er: Scalars['Boolean'];
  gmaps_address_place_id: Maybe<Scalars['String']>;
  gmaps_city_place_id: Maybe<Scalars['String']>;
  gmaps_establishment_place_id: Maybe<Scalars['String']>;
  gmaps_last_checked: Maybe<Scalars['timestamp']>;
  gmaps_state_place_id: Maybe<Scalars['String']>;
  /** A computed field, executes function "facility_has_verified_org" */
  has_verified_org: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  immediateNeeds: Scalars['Boolean'];
  location: Maybe<Scalars['geography']>;
  /** A computed field, executes function "max_facility_job_postings_for_prof" */
  max_postings_for_prof: Maybe<Array<Job_Posting>>;
  name: Scalars['String'];
  npi: Scalars['String'];
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Int']>;
  /** An object relationship */
  picture: Maybe<File>;
  picture_id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "facility_job_postings" */
  postings: Maybe<Array<Job_Posting>>;
  /** A computed field, executes function "facility_job_postings_for_prof" */
  postings_for_prof: Maybe<Array<Job_Posting>>;
  /** A computed field, executes function "facility_primary_residencies" */
  primary_residencies: Maybe<Array<Residency>>;
  ranking_review: Maybe<Scalars['Int']>;
  /** A computed field, executes function "facility_residencies" */
  residencies: Maybe<Array<Residency>>;
  residency: Scalars['String'];
  /** An array relationship */
  reviews: Array<Review>;
  /** An aggregate relationship */
  reviews_aggregate: Review_Aggregate;
  /** An array relationship */
  salary_reports: Array<Salary_Report>;
  /** An aggregate relationship */
  salary_reports_aggregate: Salary_Report_Aggregate;
  /** An array relationship */
  salary_reports_fmt: Array<Salary_Report_Fmt>;
  /** An aggregate relationship */
  salary_reports_fmt_aggregate: Salary_Report_Fmt_Aggregate;
  search_vec: Scalars['tsvector'];
  slug: Scalars['String'];
  state: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2: Scalars['String'];
  /** An array relationship */
  stroke_certs: Array<Stroke_Cert>;
  /** An aggregate relationship */
  stroke_certs_aggregate: Stroke_Cert_Aggregate;
  zipcode: Scalars['String'];
};


/** columns and relationships of "facility" */
export type FacilityAccreditationsArgs = {
  distinct_on?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Accreditation_Order_By>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityAccreditations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Accreditation_Order_By>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityContractsArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityEhrsArgs = {
  distinct_on?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Ehr_Order_By>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityEhrs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Ehr_Order_By>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityExt_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityExt_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityFacility_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Rating_Order_By>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityFacility_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Rating_Order_By>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityFeatured_For_ProfArgs = {
  args: Featured_For_Prof_Facility_Args;
};


/** columns and relationships of "facility" */
export type FacilityImmediateNeedsArgs = {
  args: ImmediateNeedsArgs;
};


/** columns and relationships of "facility" */
export type FacilityMax_Postings_For_ProfArgs = {
  args: Max_Postings_For_Prof_Facility_Args;
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};


/** columns and relationships of "facility" */
export type FacilityPostingsArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityPostings_For_ProfArgs = {
  args: Postings_For_Prof_Facility_Args;
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityPrimary_ResidenciesArgs = {
  distinct_on?: InputMaybe<Array<Residency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Order_By>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityResidenciesArgs = {
  distinct_on?: InputMaybe<Array<Residency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Order_By>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityReviewsArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilitySalary_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilitySalary_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilitySalary_Reports_FmtArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilitySalary_Reports_Fmt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityStroke_CertsArgs = {
  distinct_on?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stroke_Cert_Order_By>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};


/** columns and relationships of "facility" */
export type FacilityStroke_Certs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stroke_Cert_Order_By>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};

/** columns and relationships of "facility_accreditation" */
export type Facility_Accreditation = {
  __typename?: 'facility_accreditation';
  accreditation: Scalars['String'];
  /** An object relationship */
  facility: Facility;
  facility_id: Scalars['uuid'];
  id: Scalars['uuid'];
  level: Scalars['String'];
};

/** aggregated selection of "facility_accreditation" */
export type Facility_Accreditation_Aggregate = {
  __typename?: 'facility_accreditation_aggregate';
  aggregate: Maybe<Facility_Accreditation_Aggregate_Fields>;
  nodes: Array<Facility_Accreditation>;
};

export type Facility_Accreditation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Facility_Accreditation_Aggregate_Bool_Exp_Count>;
};

export type Facility_Accreditation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Accreditation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "facility_accreditation" */
export type Facility_Accreditation_Aggregate_Fields = {
  __typename?: 'facility_accreditation_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Facility_Accreditation_Max_Fields>;
  min: Maybe<Facility_Accreditation_Min_Fields>;
};


/** aggregate fields of "facility_accreditation" */
export type Facility_Accreditation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "facility_accreditation" */
export type Facility_Accreditation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Facility_Accreditation_Max_Order_By>;
  min?: InputMaybe<Facility_Accreditation_Min_Order_By>;
};

/** input type for inserting array relation for remote table "facility_accreditation" */
export type Facility_Accreditation_Arr_Rel_Insert_Input = {
  data: Array<Facility_Accreditation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_Accreditation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "facility_accreditation". All fields are combined with a logical 'AND'. */
export type Facility_Accreditation_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Accreditation_Bool_Exp>>;
  _not?: InputMaybe<Facility_Accreditation_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Accreditation_Bool_Exp>>;
  accreditation?: InputMaybe<String_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "facility_accreditation" */
export enum Facility_Accreditation_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFacilityAccreditation = 'pk_facility_accreditation',
  /** unique or primary key constraint on columns "facility_id", "accreditation" */
  UqFacilityAccreditationFacilityIdAccreditation = 'uq_facility_accreditation_facility_id_accreditation'
}

/** input type for inserting data into table "facility_accreditation" */
export type Facility_Accreditation_Insert_Input = {
  accreditation?: InputMaybe<Scalars['String']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Facility_Accreditation_Max_Fields = {
  __typename?: 'facility_accreditation_max_fields';
  accreditation: Maybe<Scalars['String']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  level: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "facility_accreditation" */
export type Facility_Accreditation_Max_Order_By = {
  accreditation?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Facility_Accreditation_Min_Fields = {
  __typename?: 'facility_accreditation_min_fields';
  accreditation: Maybe<Scalars['String']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  level: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "facility_accreditation" */
export type Facility_Accreditation_Min_Order_By = {
  accreditation?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "facility_accreditation" */
export type Facility_Accreditation_Mutation_Response = {
  __typename?: 'facility_accreditation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility_Accreditation>;
};

/** on_conflict condition type for table "facility_accreditation" */
export type Facility_Accreditation_On_Conflict = {
  constraint: Facility_Accreditation_Constraint;
  update_columns?: Array<Facility_Accreditation_Update_Column>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};

/** Ordering options when selecting data from "facility_accreditation". */
export type Facility_Accreditation_Order_By = {
  accreditation?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** primary key columns input for table: facility_accreditation */
export type Facility_Accreditation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "facility_accreditation" */
export enum Facility_Accreditation_Select_Column {
  /** column name */
  Accreditation = 'accreditation',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level'
}

/** input type for updating data in table "facility_accreditation" */
export type Facility_Accreditation_Set_Input = {
  accreditation?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "facility_accreditation" */
export type Facility_Accreditation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Accreditation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Accreditation_Stream_Cursor_Value_Input = {
  accreditation?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Scalars['String']>;
};

/** update columns of table "facility_accreditation" */
export enum Facility_Accreditation_Update_Column {
  /** column name */
  Accreditation = 'accreditation',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level'
}

export type Facility_Accreditation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Accreditation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Accreditation_Bool_Exp;
};

/** aggregated selection of "facility" */
export type Facility_Aggregate = {
  __typename?: 'facility_aggregate';
  aggregate: Maybe<Facility_Aggregate_Fields>;
  nodes: Array<Facility>;
};

export type Facility_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Facility_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Facility_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Facility_Aggregate_Bool_Exp_Count>;
};

export type Facility_Aggregate_Bool_Exp_Bool_And = {
  arguments: Facility_Select_Column_Facility_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Facility_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Facility_Select_Column_Facility_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Facility_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Facility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "facility" */
export type Facility_Aggregate_Fields = {
  __typename?: 'facility_aggregate_fields';
  avg: Maybe<Facility_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Facility_Max_Fields>;
  min: Maybe<Facility_Min_Fields>;
  stddev: Maybe<Facility_Stddev_Fields>;
  stddev_pop: Maybe<Facility_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Facility_Stddev_Samp_Fields>;
  sum: Maybe<Facility_Sum_Fields>;
  var_pop: Maybe<Facility_Var_Pop_Fields>;
  var_samp: Maybe<Facility_Var_Samp_Fields>;
  variance: Maybe<Facility_Variance_Fields>;
};


/** aggregate fields of "facility" */
export type Facility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "facility" */
export type Facility_Aggregate_Order_By = {
  avg?: InputMaybe<Facility_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Facility_Max_Order_By>;
  min?: InputMaybe<Facility_Min_Order_By>;
  stddev?: InputMaybe<Facility_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Facility_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Facility_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Facility_Sum_Order_By>;
  var_pop?: InputMaybe<Facility_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Facility_Var_Samp_Order_By>;
  variance?: InputMaybe<Facility_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "facility" */
export type Facility_Arr_Rel_Insert_Input = {
  data: Array<Facility_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_On_Conflict>;
};

/** aggregate avg on columns */
export type Facility_Avg_Fields = {
  __typename?: 'facility_avg_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate avg on columns */
export type Facility_Avg_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by avg() on columns of table "facility" */
export type Facility_Avg_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "facility". All fields are combined with a logical 'AND'. */
export type Facility_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Bool_Exp>>;
  _not?: InputMaybe<Facility_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Bool_Exp>>;
  accreditations?: InputMaybe<Facility_Accreditation_Bool_Exp>;
  accreditations_aggregate?: InputMaybe<Facility_Accreditation_Aggregate_Bool_Exp>;
  adult_trauma_lvl?: InputMaybe<Int_Comparison_Exp>;
  aha_facility?: InputMaybe<As20Dem_Bool_Exp>;
  aha_facility_21?: InputMaybe<As21Dem_Bool_Exp>;
  aha_facility_21_id?: InputMaybe<String_Comparison_Exp>;
  aha_facility_22?: InputMaybe<As22Dem_Bool_Exp>;
  aha_facility_22_id?: InputMaybe<String_Comparison_Exp>;
  aha_facility_id?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  cms_facility?: InputMaybe<Cms_Facility_Bool_Exp>;
  cms_facility_enrollment?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
  cms_facility_id?: InputMaybe<String_Comparison_Exp>;
  cms_facility_pos?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
  contracts?: InputMaybe<Facility_Contract_Bool_Exp>;
  contracts_aggregate?: InputMaybe<Facility_Contract_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  ehrs?: InputMaybe<Facility_Ehr_Bool_Exp>;
  ehrs_aggregate?: InputMaybe<Facility_Ehr_Aggregate_Bool_Exp>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp>;
  facility_ratings?: InputMaybe<Facility_Rating_Bool_Exp>;
  facility_ratings_aggregate?: InputMaybe<Facility_Rating_Aggregate_Bool_Exp>;
  freestanding_er?: InputMaybe<Boolean_Comparison_Exp>;
  gmaps_address_place_id?: InputMaybe<String_Comparison_Exp>;
  gmaps_city_place_id?: InputMaybe<String_Comparison_Exp>;
  gmaps_establishment_place_id?: InputMaybe<String_Comparison_Exp>;
  gmaps_last_checked?: InputMaybe<Timestamp_Comparison_Exp>;
  gmaps_state_place_id?: InputMaybe<String_Comparison_Exp>;
  has_verified_org?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  npi?: InputMaybe<String_Comparison_Exp>;
  ped_trauma_lvl?: InputMaybe<Int_Comparison_Exp>;
  picture?: InputMaybe<File_Bool_Exp>;
  picture_id?: InputMaybe<Uuid_Comparison_Exp>;
  postings?: InputMaybe<Job_Posting_Bool_Exp>;
  primary_residencies?: InputMaybe<Residency_Bool_Exp>;
  ranking_review?: InputMaybe<Int_Comparison_Exp>;
  residencies?: InputMaybe<Residency_Bool_Exp>;
  residency?: InputMaybe<String_Comparison_Exp>;
  reviews?: InputMaybe<Review_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Bool_Exp>;
  salary_reports?: InputMaybe<Salary_Report_Bool_Exp>;
  salary_reports_aggregate?: InputMaybe<Salary_Report_Aggregate_Bool_Exp>;
  salary_reports_fmt?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
  salary_reports_fmt_aggregate?: InputMaybe<Salary_Report_Fmt_Aggregate_Bool_Exp>;
  search_vec?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  stroke_certs?: InputMaybe<Stroke_Cert_Bool_Exp>;
  stroke_certs_aggregate?: InputMaybe<Stroke_Cert_Aggregate_Bool_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "facility" */
export enum Facility_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFacility = 'pk_facility',
  /** unique or primary key constraint on columns "picture_id" */
  UqFacilityPictureId = 'uq_facility_picture_id'
}

/** columns and relationships of "facility_contract" */
export type Facility_Contract = {
  __typename?: 'facility_contract';
  active: Scalars['Boolean'];
  change_request: Maybe<Scalars['contractchangerequest']>;
  change_requested_at: Maybe<Scalars['timestamp']>;
  change_requested_by_id: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  /** An object relationship */
  facility: Facility;
  facility_id: Scalars['uuid'];
  /** An array relationship */
  featured: Array<Facility_Contract_Featured>;
  /** An aggregate relationship */
  featured_aggregate: Facility_Contract_Featured_Aggregate;
  id: Scalars['uuid'];
  /** A computed field, executes function "is_contract_owner" */
  is_contract_owner: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  job_applications: Array<Job_Application>;
  /** An aggregate relationship */
  job_applications_aggregate: Job_Application_Aggregate;
  lastAppliedDate: Maybe<Scalars['DateTime']>;
  /** A computed field, executes function "facility_contract_last_applied" */
  last_applied: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  org: Organization;
  org_id: Scalars['uuid'];
  pending_or_active: Scalars['Boolean'];
  /** An array relationship */
  postings: Array<Job_Posting>;
  /** An aggregate relationship */
  postings_aggregate: Job_Posting_Aggregate;
  /** An object relationship */
  recruiter: Org_User;
  recruiter_id: Scalars['uuid'];
};


/** columns and relationships of "facility_contract" */
export type Facility_ContractFeaturedArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Featured_Order_By>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


/** columns and relationships of "facility_contract" */
export type Facility_ContractFeatured_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Featured_Order_By>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


/** columns and relationships of "facility_contract" */
export type Facility_ContractJob_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


/** columns and relationships of "facility_contract" */
export type Facility_ContractJob_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


/** columns and relationships of "facility_contract" */
export type Facility_ContractPostingsArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


/** columns and relationships of "facility_contract" */
export type Facility_ContractPostings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};

/** aggregated selection of "facility_contract" */
export type Facility_Contract_Aggregate = {
  __typename?: 'facility_contract_aggregate';
  aggregate: Maybe<Facility_Contract_Aggregate_Fields>;
  nodes: Array<Facility_Contract>;
};

export type Facility_Contract_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Facility_Contract_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Facility_Contract_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Facility_Contract_Aggregate_Bool_Exp_Count>;
};

export type Facility_Contract_Aggregate_Bool_Exp_Bool_And = {
  arguments: Facility_Contract_Select_Column_Facility_Contract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Contract_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Facility_Contract_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Facility_Contract_Select_Column_Facility_Contract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Contract_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Facility_Contract_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Contract_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "facility_contract" */
export type Facility_Contract_Aggregate_Fields = {
  __typename?: 'facility_contract_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Facility_Contract_Max_Fields>;
  min: Maybe<Facility_Contract_Min_Fields>;
};


/** aggregate fields of "facility_contract" */
export type Facility_Contract_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "facility_contract" */
export type Facility_Contract_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Facility_Contract_Max_Order_By>;
  min?: InputMaybe<Facility_Contract_Min_Order_By>;
};

/** input type for inserting array relation for remote table "facility_contract" */
export type Facility_Contract_Arr_Rel_Insert_Input = {
  data: Array<Facility_Contract_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_Contract_On_Conflict>;
};

/** Boolean expression to filter rows from the table "facility_contract". All fields are combined with a logical 'AND'. */
export type Facility_Contract_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Contract_Bool_Exp>>;
  _not?: InputMaybe<Facility_Contract_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Contract_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  change_request?: InputMaybe<Contractchangerequest_Comparison_Exp>;
  change_requested_at?: InputMaybe<Timestamp_Comparison_Exp>;
  change_requested_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  featured?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
  featured_aggregate?: InputMaybe<Facility_Contract_Featured_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_contract_owner?: InputMaybe<Boolean_Comparison_Exp>;
  job_applications?: InputMaybe<Job_Application_Bool_Exp>;
  job_applications_aggregate?: InputMaybe<Job_Application_Aggregate_Bool_Exp>;
  last_applied?: InputMaybe<Timestamp_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  pending_or_active?: InputMaybe<Boolean_Comparison_Exp>;
  postings?: InputMaybe<Job_Posting_Bool_Exp>;
  postings_aggregate?: InputMaybe<Job_Posting_Aggregate_Bool_Exp>;
  recruiter?: InputMaybe<Org_User_Bool_Exp>;
  recruiter_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "facility_contract" */
export enum Facility_Contract_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFacilityContract = 'pk_facility_contract',
  /** unique or primary key constraint on columns "org_id", "facility_id" */
  UqFacilityContractFacilityIdOrgId = 'uq_facility_contract_facility_id_org_id'
}

/** columns and relationships of "facility_contract_featured" */
export type Facility_Contract_Featured = {
  __typename?: 'facility_contract_featured';
  /** An object relationship */
  contract: Facility_Contract;
  contract_id: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  profession: Scalars['profession'];
};

/** aggregated selection of "facility_contract_featured" */
export type Facility_Contract_Featured_Aggregate = {
  __typename?: 'facility_contract_featured_aggregate';
  aggregate: Maybe<Facility_Contract_Featured_Aggregate_Fields>;
  nodes: Array<Facility_Contract_Featured>;
};

export type Facility_Contract_Featured_Aggregate_Bool_Exp = {
  count?: InputMaybe<Facility_Contract_Featured_Aggregate_Bool_Exp_Count>;
};

export type Facility_Contract_Featured_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "facility_contract_featured" */
export type Facility_Contract_Featured_Aggregate_Fields = {
  __typename?: 'facility_contract_featured_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Facility_Contract_Featured_Max_Fields>;
  min: Maybe<Facility_Contract_Featured_Min_Fields>;
};


/** aggregate fields of "facility_contract_featured" */
export type Facility_Contract_Featured_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "facility_contract_featured" */
export type Facility_Contract_Featured_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Facility_Contract_Featured_Max_Order_By>;
  min?: InputMaybe<Facility_Contract_Featured_Min_Order_By>;
};

/** input type for inserting array relation for remote table "facility_contract_featured" */
export type Facility_Contract_Featured_Arr_Rel_Insert_Input = {
  data: Array<Facility_Contract_Featured_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_Contract_Featured_On_Conflict>;
};

/** Boolean expression to filter rows from the table "facility_contract_featured". All fields are combined with a logical 'AND'. */
export type Facility_Contract_Featured_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Contract_Featured_Bool_Exp>>;
  _not?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Contract_Featured_Bool_Exp>>;
  contract?: InputMaybe<Facility_Contract_Bool_Exp>;
  contract_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
};

/** unique or primary key constraints on table "facility_contract_featured" */
export enum Facility_Contract_Featured_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFacilityContractFeatured = 'pk_facility_contract_featured',
  /** unique or primary key constraint on columns "profession", "contract_id" */
  UqFacilityContractFeaturedContractIdProfession = 'uq_facility_contract_featured_contract_id_profession'
}

/** input type for inserting data into table "facility_contract_featured" */
export type Facility_Contract_Featured_Insert_Input = {
  contract?: InputMaybe<Facility_Contract_Obj_Rel_Insert_Input>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** aggregate max on columns */
export type Facility_Contract_Featured_Max_Fields = {
  __typename?: 'facility_contract_featured_max_fields';
  contract_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  profession: Maybe<Scalars['profession']>;
};

/** order by max() on columns of table "facility_contract_featured" */
export type Facility_Contract_Featured_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Facility_Contract_Featured_Min_Fields = {
  __typename?: 'facility_contract_featured_min_fields';
  contract_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  profession: Maybe<Scalars['profession']>;
};

/** order by min() on columns of table "facility_contract_featured" */
export type Facility_Contract_Featured_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "facility_contract_featured" */
export type Facility_Contract_Featured_Mutation_Response = {
  __typename?: 'facility_contract_featured_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility_Contract_Featured>;
};

/** input type for inserting object relation for remote table "facility_contract_featured" */
export type Facility_Contract_Featured_Obj_Rel_Insert_Input = {
  data: Facility_Contract_Featured_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_Contract_Featured_On_Conflict>;
};

/** on_conflict condition type for table "facility_contract_featured" */
export type Facility_Contract_Featured_On_Conflict = {
  constraint: Facility_Contract_Featured_Constraint;
  update_columns?: Array<Facility_Contract_Featured_Update_Column>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};

/** Ordering options when selecting data from "facility_contract_featured". */
export type Facility_Contract_Featured_Order_By = {
  contract?: InputMaybe<Facility_Contract_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** primary key columns input for table: facility_contract_featured */
export type Facility_Contract_Featured_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "facility_contract_featured" */
export enum Facility_Contract_Featured_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Profession = 'profession'
}

/** input type for updating data in table "facility_contract_featured" */
export type Facility_Contract_Featured_Set_Input = {
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** Streaming cursor of the table "facility_contract_featured" */
export type Facility_Contract_Featured_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Contract_Featured_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Contract_Featured_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** update columns of table "facility_contract_featured" */
export enum Facility_Contract_Featured_Update_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Profession = 'profession'
}

export type Facility_Contract_Featured_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Contract_Featured_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Contract_Featured_Bool_Exp;
};

/** input type for inserting data into table "facility_contract" */
export type Facility_Contract_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  change_request?: InputMaybe<Scalars['contractchangerequest']>;
  change_requested_at?: InputMaybe<Scalars['timestamp']>;
  change_requested_by_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  featured?: InputMaybe<Facility_Contract_Featured_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  job_applications?: InputMaybe<Job_Application_Arr_Rel_Insert_Input>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  postings?: InputMaybe<Job_Posting_Arr_Rel_Insert_Input>;
  recruiter?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Facility_Contract_Max_Fields = {
  __typename?: 'facility_contract_max_fields';
  change_request: Maybe<Scalars['contractchangerequest']>;
  change_requested_at: Maybe<Scalars['timestamp']>;
  change_requested_by_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "facility_contract_last_applied" */
  last_applied: Maybe<Scalars['timestamp']>;
  org_id: Maybe<Scalars['uuid']>;
  recruiter_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "facility_contract" */
export type Facility_Contract_Max_Order_By = {
  change_request?: InputMaybe<Order_By>;
  change_requested_at?: InputMaybe<Order_By>;
  change_requested_by_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Facility_Contract_Min_Fields = {
  __typename?: 'facility_contract_min_fields';
  change_request: Maybe<Scalars['contractchangerequest']>;
  change_requested_at: Maybe<Scalars['timestamp']>;
  change_requested_by_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "facility_contract_last_applied" */
  last_applied: Maybe<Scalars['timestamp']>;
  org_id: Maybe<Scalars['uuid']>;
  recruiter_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "facility_contract" */
export type Facility_Contract_Min_Order_By = {
  change_request?: InputMaybe<Order_By>;
  change_requested_at?: InputMaybe<Order_By>;
  change_requested_by_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "facility_contract" */
export type Facility_Contract_Mutation_Response = {
  __typename?: 'facility_contract_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility_Contract>;
};

/** input type for inserting object relation for remote table "facility_contract" */
export type Facility_Contract_Obj_Rel_Insert_Input = {
  data: Facility_Contract_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_Contract_On_Conflict>;
};

/** on_conflict condition type for table "facility_contract" */
export type Facility_Contract_On_Conflict = {
  constraint: Facility_Contract_Constraint;
  update_columns?: Array<Facility_Contract_Update_Column>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};

/** Ordering options when selecting data from "facility_contract". */
export type Facility_Contract_Order_By = {
  active?: InputMaybe<Order_By>;
  change_request?: InputMaybe<Order_By>;
  change_requested_at?: InputMaybe<Order_By>;
  change_requested_by_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  featured_aggregate?: InputMaybe<Facility_Contract_Featured_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_contract_owner?: InputMaybe<Order_By>;
  job_applications_aggregate?: InputMaybe<Job_Application_Aggregate_Order_By>;
  last_applied?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  org_id?: InputMaybe<Order_By>;
  pending_or_active?: InputMaybe<Order_By>;
  postings_aggregate?: InputMaybe<Job_Posting_Aggregate_Order_By>;
  recruiter?: InputMaybe<Org_User_Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: facility_contract */
export type Facility_Contract_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "facility_contract" */
export enum Facility_Contract_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ChangeRequest = 'change_request',
  /** column name */
  ChangeRequestedAt = 'change_requested_at',
  /** column name */
  ChangeRequestedById = 'change_requested_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  PendingOrActive = 'pending_or_active',
  /** column name */
  RecruiterId = 'recruiter_id'
}

/** select "facility_contract_aggregate_bool_exp_bool_and_arguments_columns" columns of table "facility_contract" */
export enum Facility_Contract_Select_Column_Facility_Contract_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  PendingOrActive = 'pending_or_active'
}

/** select "facility_contract_aggregate_bool_exp_bool_or_arguments_columns" columns of table "facility_contract" */
export enum Facility_Contract_Select_Column_Facility_Contract_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  PendingOrActive = 'pending_or_active'
}

/** input type for updating data in table "facility_contract" */
export type Facility_Contract_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  change_request?: InputMaybe<Scalars['contractchangerequest']>;
  change_requested_at?: InputMaybe<Scalars['timestamp']>;
  change_requested_by_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "facility_contract" */
export type Facility_Contract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Contract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Contract_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  change_request?: InputMaybe<Scalars['contractchangerequest']>;
  change_requested_at?: InputMaybe<Scalars['timestamp']>;
  change_requested_by_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  pending_or_active?: InputMaybe<Scalars['Boolean']>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "facility_contract" */
export enum Facility_Contract_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ChangeRequest = 'change_request',
  /** column name */
  ChangeRequestedAt = 'change_requested_at',
  /** column name */
  ChangeRequestedById = 'change_requested_by_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  RecruiterId = 'recruiter_id'
}

export type Facility_Contract_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Contract_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Contract_Bool_Exp;
};

/** columns and relationships of "facility_correction" */
export type Facility_Correction = {
  __typename?: 'facility_correction';
  created_at: Scalars['timestamp'];
  details: Scalars['String'];
  facility_id: Scalars['uuid'];
  id: Scalars['uuid'];
  problem: Scalars['String'];
  reporter_email: Scalars['String'];
  reporter_id: Maybe<Scalars['uuid']>;
  reporter_org_id: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "facility_correction" */
export type Facility_Correction_Aggregate = {
  __typename?: 'facility_correction_aggregate';
  aggregate: Maybe<Facility_Correction_Aggregate_Fields>;
  nodes: Array<Facility_Correction>;
};

/** aggregate fields of "facility_correction" */
export type Facility_Correction_Aggregate_Fields = {
  __typename?: 'facility_correction_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Facility_Correction_Max_Fields>;
  min: Maybe<Facility_Correction_Min_Fields>;
};


/** aggregate fields of "facility_correction" */
export type Facility_Correction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Correction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "facility_correction". All fields are combined with a logical 'AND'. */
export type Facility_Correction_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Correction_Bool_Exp>>;
  _not?: InputMaybe<Facility_Correction_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Correction_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  details?: InputMaybe<String_Comparison_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  problem?: InputMaybe<String_Comparison_Exp>;
  reporter_email?: InputMaybe<String_Comparison_Exp>;
  reporter_id?: InputMaybe<Uuid_Comparison_Exp>;
  reporter_org_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "facility_correction" */
export enum Facility_Correction_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFacilityCorrection = 'pk_facility_correction'
}

/** input type for inserting data into table "facility_correction" */
export type Facility_Correction_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  problem?: InputMaybe<Scalars['String']>;
  reporter_email?: InputMaybe<Scalars['String']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  reporter_org_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Facility_Correction_Max_Fields = {
  __typename?: 'facility_correction_max_fields';
  created_at: Maybe<Scalars['timestamp']>;
  details: Maybe<Scalars['String']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  problem: Maybe<Scalars['String']>;
  reporter_email: Maybe<Scalars['String']>;
  reporter_id: Maybe<Scalars['uuid']>;
  reporter_org_id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Facility_Correction_Min_Fields = {
  __typename?: 'facility_correction_min_fields';
  created_at: Maybe<Scalars['timestamp']>;
  details: Maybe<Scalars['String']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  problem: Maybe<Scalars['String']>;
  reporter_email: Maybe<Scalars['String']>;
  reporter_id: Maybe<Scalars['uuid']>;
  reporter_org_id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "facility_correction" */
export type Facility_Correction_Mutation_Response = {
  __typename?: 'facility_correction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility_Correction>;
};

/** on_conflict condition type for table "facility_correction" */
export type Facility_Correction_On_Conflict = {
  constraint: Facility_Correction_Constraint;
  update_columns?: Array<Facility_Correction_Update_Column>;
  where?: InputMaybe<Facility_Correction_Bool_Exp>;
};

/** Ordering options when selecting data from "facility_correction". */
export type Facility_Correction_Order_By = {
  created_at?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  problem?: InputMaybe<Order_By>;
  reporter_email?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  reporter_org_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: facility_correction */
export type Facility_Correction_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "facility_correction" */
export enum Facility_Correction_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  Problem = 'problem',
  /** column name */
  ReporterEmail = 'reporter_email',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  ReporterOrgId = 'reporter_org_id'
}

/** input type for updating data in table "facility_correction" */
export type Facility_Correction_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  problem?: InputMaybe<Scalars['String']>;
  reporter_email?: InputMaybe<Scalars['String']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  reporter_org_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "facility_correction" */
export type Facility_Correction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Correction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Correction_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  problem?: InputMaybe<Scalars['String']>;
  reporter_email?: InputMaybe<Scalars['String']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  reporter_org_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "facility_correction" */
export enum Facility_Correction_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  Problem = 'problem',
  /** column name */
  ReporterEmail = 'reporter_email',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  ReporterOrgId = 'reporter_org_id'
}

export type Facility_Correction_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Correction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Correction_Bool_Exp;
};

export type Facility_Dist_Args = {
  x?: InputMaybe<Scalars['float8']>;
  y?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "facility_dist_result" */
export type Facility_Dist_Result = {
  __typename?: 'facility_dist_result';
  distance: Maybe<Scalars['float8']>;
  /** An object relationship */
  facility: Maybe<Facility>;
  id: Maybe<Scalars['uuid']>;
};

export type Facility_Dist_Result_Aggregate = {
  __typename?: 'facility_dist_result_aggregate';
  aggregate: Maybe<Facility_Dist_Result_Aggregate_Fields>;
  nodes: Array<Facility_Dist_Result>;
};

/** aggregate fields of "facility_dist_result" */
export type Facility_Dist_Result_Aggregate_Fields = {
  __typename?: 'facility_dist_result_aggregate_fields';
  avg: Maybe<Facility_Dist_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Facility_Dist_Result_Max_Fields>;
  min: Maybe<Facility_Dist_Result_Min_Fields>;
  stddev: Maybe<Facility_Dist_Result_Stddev_Fields>;
  stddev_pop: Maybe<Facility_Dist_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Facility_Dist_Result_Stddev_Samp_Fields>;
  sum: Maybe<Facility_Dist_Result_Sum_Fields>;
  var_pop: Maybe<Facility_Dist_Result_Var_Pop_Fields>;
  var_samp: Maybe<Facility_Dist_Result_Var_Samp_Fields>;
  variance: Maybe<Facility_Dist_Result_Variance_Fields>;
};


/** aggregate fields of "facility_dist_result" */
export type Facility_Dist_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Facility_Dist_Result_Avg_Fields = {
  __typename?: 'facility_dist_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "facility_dist_result". All fields are combined with a logical 'AND'. */
export type Facility_Dist_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Dist_Result_Bool_Exp>>;
  _not?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Dist_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "facility_dist_result" */
export type Facility_Dist_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "facility_dist_result" */
export type Facility_Dist_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Facility_Dist_Result_Max_Fields = {
  __typename?: 'facility_dist_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Facility_Dist_Result_Min_Fields = {
  __typename?: 'facility_dist_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "facility_dist_result" */
export type Facility_Dist_Result_Mutation_Response = {
  __typename?: 'facility_dist_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility_Dist_Result>;
};

/** Ordering options when selecting data from "facility_dist_result". */
export type Facility_Dist_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "facility_dist_result" */
export enum Facility_Dist_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "facility_dist_result" */
export type Facility_Dist_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Facility_Dist_Result_Stddev_Fields = {
  __typename?: 'facility_dist_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Facility_Dist_Result_Stddev_Pop_Fields = {
  __typename?: 'facility_dist_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Facility_Dist_Result_Stddev_Samp_Fields = {
  __typename?: 'facility_dist_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "facility_dist_result" */
export type Facility_Dist_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Dist_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Dist_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Facility_Dist_Result_Sum_Fields = {
  __typename?: 'facility_dist_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Facility_Dist_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Facility_Dist_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Dist_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Dist_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Facility_Dist_Result_Var_Pop_Fields = {
  __typename?: 'facility_dist_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Facility_Dist_Result_Var_Samp_Fields = {
  __typename?: 'facility_dist_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Facility_Dist_Result_Variance_Fields = {
  __typename?: 'facility_dist_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

/** columns and relationships of "facility_ehr" */
export type Facility_Ehr = {
  __typename?: 'facility_ehr';
  /** An object relationship */
  facility: Facility;
  facility_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  type: Scalars['ehrtype'];
};

/** aggregated selection of "facility_ehr" */
export type Facility_Ehr_Aggregate = {
  __typename?: 'facility_ehr_aggregate';
  aggregate: Maybe<Facility_Ehr_Aggregate_Fields>;
  nodes: Array<Facility_Ehr>;
};

export type Facility_Ehr_Aggregate_Bool_Exp = {
  count?: InputMaybe<Facility_Ehr_Aggregate_Bool_Exp_Count>;
};

export type Facility_Ehr_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Ehr_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "facility_ehr" */
export type Facility_Ehr_Aggregate_Fields = {
  __typename?: 'facility_ehr_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Facility_Ehr_Max_Fields>;
  min: Maybe<Facility_Ehr_Min_Fields>;
};


/** aggregate fields of "facility_ehr" */
export type Facility_Ehr_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "facility_ehr" */
export type Facility_Ehr_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Facility_Ehr_Max_Order_By>;
  min?: InputMaybe<Facility_Ehr_Min_Order_By>;
};

/** input type for inserting array relation for remote table "facility_ehr" */
export type Facility_Ehr_Arr_Rel_Insert_Input = {
  data: Array<Facility_Ehr_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_Ehr_On_Conflict>;
};

/** Boolean expression to filter rows from the table "facility_ehr". All fields are combined with a logical 'AND'. */
export type Facility_Ehr_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Ehr_Bool_Exp>>;
  _not?: InputMaybe<Facility_Ehr_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Ehr_Bool_Exp>>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Ehrtype_Comparison_Exp>;
};

/** unique or primary key constraints on table "facility_ehr" */
export enum Facility_Ehr_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFacilityEhr = 'pk_facility_ehr',
  /** unique or primary key constraint on columns "facility_id", "type", "name" */
  UqFacilityEhrFacilityIdTypeName = 'uq_facility_ehr_facility_id_type_name'
}

/** input type for inserting data into table "facility_ehr" */
export type Facility_Ehr_Insert_Input = {
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['ehrtype']>;
};

/** aggregate max on columns */
export type Facility_Ehr_Max_Fields = {
  __typename?: 'facility_ehr_max_fields';
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['ehrtype']>;
};

/** order by max() on columns of table "facility_ehr" */
export type Facility_Ehr_Max_Order_By = {
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Facility_Ehr_Min_Fields = {
  __typename?: 'facility_ehr_min_fields';
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  type: Maybe<Scalars['ehrtype']>;
};

/** order by min() on columns of table "facility_ehr" */
export type Facility_Ehr_Min_Order_By = {
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "facility_ehr" */
export type Facility_Ehr_Mutation_Response = {
  __typename?: 'facility_ehr_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility_Ehr>;
};

/** on_conflict condition type for table "facility_ehr" */
export type Facility_Ehr_On_Conflict = {
  constraint: Facility_Ehr_Constraint;
  update_columns?: Array<Facility_Ehr_Update_Column>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};

/** Ordering options when selecting data from "facility_ehr". */
export type Facility_Ehr_Order_By = {
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: facility_ehr */
export type Facility_Ehr_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "facility_ehr" */
export enum Facility_Ehr_Select_Column {
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "facility_ehr" */
export type Facility_Ehr_Set_Input = {
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['ehrtype']>;
};

/** Streaming cursor of the table "facility_ehr" */
export type Facility_Ehr_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Ehr_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Ehr_Stream_Cursor_Value_Input = {
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['ehrtype']>;
};

/** update columns of table "facility_ehr" */
export enum Facility_Ehr_Update_Column {
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

export type Facility_Ehr_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Ehr_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Ehr_Bool_Exp;
};

/** input type for incrementing numeric columns in table "facility" */
export type Facility_Inc_Input = {
  adult_trauma_lvl?: InputMaybe<Scalars['Int']>;
  ped_trauma_lvl?: InputMaybe<Scalars['Int']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "facility" */
export type Facility_Insert_Input = {
  accreditations?: InputMaybe<Facility_Accreditation_Arr_Rel_Insert_Input>;
  adult_trauma_lvl?: InputMaybe<Scalars['Int']>;
  aha_facility?: InputMaybe<As20Dem_Obj_Rel_Insert_Input>;
  aha_facility_21?: InputMaybe<As21Dem_Obj_Rel_Insert_Input>;
  aha_facility_21_id?: InputMaybe<Scalars['String']>;
  aha_facility_22?: InputMaybe<As22Dem_Obj_Rel_Insert_Input>;
  aha_facility_22_id?: InputMaybe<Scalars['String']>;
  aha_facility_id?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cms_facility?: InputMaybe<Cms_Facility_Obj_Rel_Insert_Input>;
  cms_facility_enrollment?: InputMaybe<Cms_Facility_Enrollment_Obj_Rel_Insert_Input>;
  cms_facility_id?: InputMaybe<Scalars['String']>;
  cms_facility_pos?: InputMaybe<Cms_Facility_Pos_Obj_Rel_Insert_Input>;
  contracts?: InputMaybe<Facility_Contract_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  ehrs?: InputMaybe<Facility_Ehr_Arr_Rel_Insert_Input>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Arr_Rel_Insert_Input>;
  facility_ratings?: InputMaybe<Facility_Rating_Arr_Rel_Insert_Input>;
  freestanding_er?: InputMaybe<Scalars['Boolean']>;
  gmaps_address_place_id?: InputMaybe<Scalars['String']>;
  gmaps_city_place_id?: InputMaybe<Scalars['String']>;
  gmaps_establishment_place_id?: InputMaybe<Scalars['String']>;
  gmaps_last_checked?: InputMaybe<Scalars['timestamp']>;
  gmaps_state_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  ped_trauma_lvl?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<File_Obj_Rel_Insert_Input>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
  residency?: InputMaybe<Scalars['String']>;
  reviews?: InputMaybe<Review_Arr_Rel_Insert_Input>;
  salary_reports?: InputMaybe<Salary_Report_Arr_Rel_Insert_Input>;
  salary_reports_fmt?: InputMaybe<Salary_Report_Fmt_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  stroke_certs?: InputMaybe<Stroke_Cert_Arr_Rel_Insert_Input>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Facility_Max_Fields = {
  __typename?: 'facility_max_fields';
  adult_trauma_lvl: Maybe<Scalars['Int']>;
  aha_facility_21_id: Maybe<Scalars['String']>;
  aha_facility_22_id: Maybe<Scalars['String']>;
  aha_facility_id: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  cms_facility_id: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  gmaps_address_place_id: Maybe<Scalars['String']>;
  gmaps_city_place_id: Maybe<Scalars['String']>;
  gmaps_establishment_place_id: Maybe<Scalars['String']>;
  gmaps_last_checked: Maybe<Scalars['timestamp']>;
  gmaps_state_place_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  npi: Maybe<Scalars['String']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Int']>;
  picture_id: Maybe<Scalars['uuid']>;
  ranking_review: Maybe<Scalars['Int']>;
  residency: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** aggregate max on columns */
export type Facility_Max_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by max() on columns of table "facility" */
export type Facility_Max_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  aha_facility_21_id?: InputMaybe<Order_By>;
  aha_facility_22_id?: InputMaybe<Order_By>;
  aha_facility_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cms_facility_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gmaps_address_place_id?: InputMaybe<Order_By>;
  gmaps_city_place_id?: InputMaybe<Order_By>;
  gmaps_establishment_place_id?: InputMaybe<Order_By>;
  gmaps_last_checked?: InputMaybe<Order_By>;
  gmaps_state_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  picture_id?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
  residency?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Facility_Min_Fields = {
  __typename?: 'facility_min_fields';
  adult_trauma_lvl: Maybe<Scalars['Int']>;
  aha_facility_21_id: Maybe<Scalars['String']>;
  aha_facility_22_id: Maybe<Scalars['String']>;
  aha_facility_id: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  cms_facility_id: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  gmaps_address_place_id: Maybe<Scalars['String']>;
  gmaps_city_place_id: Maybe<Scalars['String']>;
  gmaps_establishment_place_id: Maybe<Scalars['String']>;
  gmaps_last_checked: Maybe<Scalars['timestamp']>;
  gmaps_state_place_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  npi: Maybe<Scalars['String']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Int']>;
  picture_id: Maybe<Scalars['uuid']>;
  ranking_review: Maybe<Scalars['Int']>;
  residency: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** aggregate min on columns */
export type Facility_Min_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by min() on columns of table "facility" */
export type Facility_Min_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  aha_facility_21_id?: InputMaybe<Order_By>;
  aha_facility_22_id?: InputMaybe<Order_By>;
  aha_facility_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cms_facility_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  gmaps_address_place_id?: InputMaybe<Order_By>;
  gmaps_city_place_id?: InputMaybe<Order_By>;
  gmaps_establishment_place_id?: InputMaybe<Order_By>;
  gmaps_last_checked?: InputMaybe<Order_By>;
  gmaps_state_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  picture_id?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
  residency?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "facility" */
export type Facility_Mutation_Response = {
  __typename?: 'facility_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Facility>;
};

/** input type for inserting object relation for remote table "facility" */
export type Facility_Obj_Rel_Insert_Input = {
  data: Facility_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Facility_On_Conflict>;
};

/** on_conflict condition type for table "facility" */
export type Facility_On_Conflict = {
  constraint: Facility_Constraint;
  update_columns?: Array<Facility_Update_Column>;
  where?: InputMaybe<Facility_Bool_Exp>;
};

/** Ordering options when selecting data from "facility". */
export type Facility_Order_By = {
  accreditations_aggregate?: InputMaybe<Facility_Accreditation_Aggregate_Order_By>;
  adult_trauma_lvl?: InputMaybe<Order_By>;
  aha_facility?: InputMaybe<As20Dem_Order_By>;
  aha_facility_21?: InputMaybe<As21Dem_Order_By>;
  aha_facility_21_id?: InputMaybe<Order_By>;
  aha_facility_22?: InputMaybe<As22Dem_Order_By>;
  aha_facility_22_id?: InputMaybe<Order_By>;
  aha_facility_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cms_facility?: InputMaybe<Cms_Facility_Order_By>;
  cms_facility_enrollment?: InputMaybe<Cms_Facility_Enrollment_Order_By>;
  cms_facility_id?: InputMaybe<Order_By>;
  cms_facility_pos?: InputMaybe<Cms_Facility_Pos_Order_By>;
  contracts_aggregate?: InputMaybe<Facility_Contract_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  ehrs_aggregate?: InputMaybe<Facility_Ehr_Aggregate_Order_By>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Order_By>;
  facility_ratings_aggregate?: InputMaybe<Facility_Rating_Aggregate_Order_By>;
  freestanding_er?: InputMaybe<Order_By>;
  gmaps_address_place_id?: InputMaybe<Order_By>;
  gmaps_city_place_id?: InputMaybe<Order_By>;
  gmaps_establishment_place_id?: InputMaybe<Order_By>;
  gmaps_last_checked?: InputMaybe<Order_By>;
  gmaps_state_place_id?: InputMaybe<Order_By>;
  has_verified_org?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  picture?: InputMaybe<File_Order_By>;
  picture_id?: InputMaybe<Order_By>;
  postings_aggregate?: InputMaybe<Job_Posting_Aggregate_Order_By>;
  primary_residencies_aggregate?: InputMaybe<Residency_Aggregate_Order_By>;
  ranking_review?: InputMaybe<Order_By>;
  residencies_aggregate?: InputMaybe<Residency_Aggregate_Order_By>;
  residency?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Order_By>;
  salary_reports_aggregate?: InputMaybe<Salary_Report_Aggregate_Order_By>;
  salary_reports_fmt_aggregate?: InputMaybe<Salary_Report_Fmt_Aggregate_Order_By>;
  search_vec?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  stroke_certs_aggregate?: InputMaybe<Stroke_Cert_Aggregate_Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: facility */
export type Facility_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "facility_rating" */
export type Facility_Rating = {
  __typename?: 'facility_rating';
  count: Maybe<Scalars['bigint']>;
  facility_id: Maybe<Scalars['uuid']>;
  rating_job: Maybe<Scalars['Int']>;
};

/** aggregated selection of "facility_rating" */
export type Facility_Rating_Aggregate = {
  __typename?: 'facility_rating_aggregate';
  aggregate: Maybe<Facility_Rating_Aggregate_Fields>;
  nodes: Array<Facility_Rating>;
};

export type Facility_Rating_Aggregate_Bool_Exp = {
  count?: InputMaybe<Facility_Rating_Aggregate_Bool_Exp_Count>;
};

export type Facility_Rating_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Facility_Rating_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "facility_rating" */
export type Facility_Rating_Aggregate_Fields = {
  __typename?: 'facility_rating_aggregate_fields';
  avg: Maybe<Facility_Rating_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Facility_Rating_Max_Fields>;
  min: Maybe<Facility_Rating_Min_Fields>;
  stddev: Maybe<Facility_Rating_Stddev_Fields>;
  stddev_pop: Maybe<Facility_Rating_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Facility_Rating_Stddev_Samp_Fields>;
  sum: Maybe<Facility_Rating_Sum_Fields>;
  var_pop: Maybe<Facility_Rating_Var_Pop_Fields>;
  var_samp: Maybe<Facility_Rating_Var_Samp_Fields>;
  variance: Maybe<Facility_Rating_Variance_Fields>;
};


/** aggregate fields of "facility_rating" */
export type Facility_Rating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "facility_rating" */
export type Facility_Rating_Aggregate_Order_By = {
  avg?: InputMaybe<Facility_Rating_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Facility_Rating_Max_Order_By>;
  min?: InputMaybe<Facility_Rating_Min_Order_By>;
  stddev?: InputMaybe<Facility_Rating_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Facility_Rating_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Facility_Rating_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Facility_Rating_Sum_Order_By>;
  var_pop?: InputMaybe<Facility_Rating_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Facility_Rating_Var_Samp_Order_By>;
  variance?: InputMaybe<Facility_Rating_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "facility_rating" */
export type Facility_Rating_Arr_Rel_Insert_Input = {
  data: Array<Facility_Rating_Insert_Input>;
};

/** aggregate avg on columns */
export type Facility_Rating_Avg_Fields = {
  __typename?: 'facility_rating_avg_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "facility_rating" */
export type Facility_Rating_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "facility_rating". All fields are combined with a logical 'AND'. */
export type Facility_Rating_Bool_Exp = {
  _and?: InputMaybe<Array<Facility_Rating_Bool_Exp>>;
  _not?: InputMaybe<Facility_Rating_Bool_Exp>;
  _or?: InputMaybe<Array<Facility_Rating_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  rating_job?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for inserting data into table "facility_rating" */
export type Facility_Rating_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  rating_job?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Facility_Rating_Max_Fields = {
  __typename?: 'facility_rating_max_fields';
  count: Maybe<Scalars['bigint']>;
  facility_id: Maybe<Scalars['uuid']>;
  rating_job: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "facility_rating" */
export type Facility_Rating_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Facility_Rating_Min_Fields = {
  __typename?: 'facility_rating_min_fields';
  count: Maybe<Scalars['bigint']>;
  facility_id: Maybe<Scalars['uuid']>;
  rating_job: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "facility_rating" */
export type Facility_Rating_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "facility_rating". */
export type Facility_Rating_Order_By = {
  count?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** select columns of table "facility_rating" */
export enum Facility_Rating_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  RatingJob = 'rating_job'
}

/** aggregate stddev on columns */
export type Facility_Rating_Stddev_Fields = {
  __typename?: 'facility_rating_stddev_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "facility_rating" */
export type Facility_Rating_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Facility_Rating_Stddev_Pop_Fields = {
  __typename?: 'facility_rating_stddev_pop_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "facility_rating" */
export type Facility_Rating_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Facility_Rating_Stddev_Samp_Fields = {
  __typename?: 'facility_rating_stddev_samp_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "facility_rating" */
export type Facility_Rating_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "facility_rating" */
export type Facility_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Rating_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  rating_job?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Facility_Rating_Sum_Fields = {
  __typename?: 'facility_rating_sum_fields';
  count: Maybe<Scalars['bigint']>;
  rating_job: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "facility_rating" */
export type Facility_Rating_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Facility_Rating_Var_Pop_Fields = {
  __typename?: 'facility_rating_var_pop_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "facility_rating" */
export type Facility_Rating_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Facility_Rating_Var_Samp_Fields = {
  __typename?: 'facility_rating_var_samp_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "facility_rating" */
export type Facility_Rating_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Facility_Rating_Variance_Fields = {
  __typename?: 'facility_rating_variance_fields';
  count: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "facility_rating" */
export type Facility_Rating_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
};

/** select columns of table "facility" */
export enum Facility_Select_Column {
  /** column name */
  AdultTraumaLvl = 'adult_trauma_lvl',
  /** column name */
  AhaFacility_21Id = 'aha_facility_21_id',
  /** column name */
  AhaFacility_22Id = 'aha_facility_22_id',
  /** column name */
  AhaFacilityId = 'aha_facility_id',
  /** column name */
  City = 'city',
  /** column name */
  CmsFacilityId = 'cms_facility_id',
  /** column name */
  Description = 'description',
  /** column name */
  FreestandingEr = 'freestanding_er',
  /** column name */
  GmapsAddressPlaceId = 'gmaps_address_place_id',
  /** column name */
  GmapsCityPlaceId = 'gmaps_city_place_id',
  /** column name */
  GmapsEstablishmentPlaceId = 'gmaps_establishment_place_id',
  /** column name */
  GmapsLastChecked = 'gmaps_last_checked',
  /** column name */
  GmapsStatePlaceId = 'gmaps_state_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Npi = 'npi',
  /** column name */
  PedTraumaLvl = 'ped_trauma_lvl',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  RankingReview = 'ranking_review',
  /** column name */
  Residency = 'residency',
  /** column name */
  SearchVec = 'search_vec',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Zipcode = 'zipcode'
}

/** select "facility_aggregate_bool_exp_bool_and_arguments_columns" columns of table "facility" */
export enum Facility_Select_Column_Facility_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FreestandingEr = 'freestanding_er'
}

/** select "facility_aggregate_bool_exp_bool_or_arguments_columns" columns of table "facility" */
export enum Facility_Select_Column_Facility_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FreestandingEr = 'freestanding_er'
}

/** input type for updating data in table "facility" */
export type Facility_Set_Input = {
  adult_trauma_lvl?: InputMaybe<Scalars['Int']>;
  aha_facility_21_id?: InputMaybe<Scalars['String']>;
  aha_facility_22_id?: InputMaybe<Scalars['String']>;
  aha_facility_id?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cms_facility_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  freestanding_er?: InputMaybe<Scalars['Boolean']>;
  gmaps_address_place_id?: InputMaybe<Scalars['String']>;
  gmaps_city_place_id?: InputMaybe<Scalars['String']>;
  gmaps_establishment_place_id?: InputMaybe<Scalars['String']>;
  gmaps_last_checked?: InputMaybe<Scalars['timestamp']>;
  gmaps_state_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  ped_trauma_lvl?: InputMaybe<Scalars['Int']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
  residency?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Facility_Stddev_Fields = {
  __typename?: 'facility_stddev_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate stddev on columns */
export type Facility_Stddev_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by stddev() on columns of table "facility" */
export type Facility_Stddev_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Facility_Stddev_Pop_Fields = {
  __typename?: 'facility_stddev_pop_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate stddev_pop on columns */
export type Facility_Stddev_Pop_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by stddev_pop() on columns of table "facility" */
export type Facility_Stddev_Pop_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Facility_Stddev_Samp_Fields = {
  __typename?: 'facility_stddev_samp_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate stddev_samp on columns */
export type Facility_Stddev_Samp_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by stddev_samp() on columns of table "facility" */
export type Facility_Stddev_Samp_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "facility" */
export type Facility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Facility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Facility_Stream_Cursor_Value_Input = {
  adult_trauma_lvl?: InputMaybe<Scalars['Int']>;
  aha_facility_21_id?: InputMaybe<Scalars['String']>;
  aha_facility_22_id?: InputMaybe<Scalars['String']>;
  aha_facility_id?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  cms_facility_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  freestanding_er?: InputMaybe<Scalars['Boolean']>;
  gmaps_address_place_id?: InputMaybe<Scalars['String']>;
  gmaps_city_place_id?: InputMaybe<Scalars['String']>;
  gmaps_establishment_place_id?: InputMaybe<Scalars['String']>;
  gmaps_last_checked?: InputMaybe<Scalars['timestamp']>;
  gmaps_state_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['geography']>;
  name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  ped_trauma_lvl?: InputMaybe<Scalars['Int']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
  residency?: InputMaybe<Scalars['String']>;
  search_vec?: InputMaybe<Scalars['tsvector']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Facility_Sum_Fields = {
  __typename?: 'facility_sum_fields';
  adult_trauma_lvl: Maybe<Scalars['Int']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Int']>;
  ranking_review: Maybe<Scalars['Int']>;
};


/** aggregate sum on columns */
export type Facility_Sum_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by sum() on columns of table "facility" */
export type Facility_Sum_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** update columns of table "facility" */
export enum Facility_Update_Column {
  /** column name */
  AdultTraumaLvl = 'adult_trauma_lvl',
  /** column name */
  AhaFacility_21Id = 'aha_facility_21_id',
  /** column name */
  AhaFacility_22Id = 'aha_facility_22_id',
  /** column name */
  AhaFacilityId = 'aha_facility_id',
  /** column name */
  City = 'city',
  /** column name */
  CmsFacilityId = 'cms_facility_id',
  /** column name */
  Description = 'description',
  /** column name */
  FreestandingEr = 'freestanding_er',
  /** column name */
  GmapsAddressPlaceId = 'gmaps_address_place_id',
  /** column name */
  GmapsCityPlaceId = 'gmaps_city_place_id',
  /** column name */
  GmapsEstablishmentPlaceId = 'gmaps_establishment_place_id',
  /** column name */
  GmapsLastChecked = 'gmaps_last_checked',
  /** column name */
  GmapsStatePlaceId = 'gmaps_state_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Npi = 'npi',
  /** column name */
  PedTraumaLvl = 'ped_trauma_lvl',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  RankingReview = 'ranking_review',
  /** column name */
  Residency = 'residency',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  Zipcode = 'zipcode'
}

export type Facility_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Facility_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Facility_Set_Input>;
  /** filter the rows which have to be updated */
  where: Facility_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Facility_Var_Pop_Fields = {
  __typename?: 'facility_var_pop_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate var_pop on columns */
export type Facility_Var_Pop_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by var_pop() on columns of table "facility" */
export type Facility_Var_Pop_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Facility_Var_Samp_Fields = {
  __typename?: 'facility_var_samp_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate var_samp on columns */
export type Facility_Var_Samp_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by var_samp() on columns of table "facility" */
export type Facility_Var_Samp_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Facility_Variance_Fields = {
  __typename?: 'facility_variance_fields';
  adult_trauma_lvl: Maybe<Scalars['Float']>;
  /** A computed field, executes function "num_facility_job_postings_for_prof" */
  num_postings_for_prof: Maybe<Scalars['Int']>;
  ped_trauma_lvl: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};


/** aggregate variance on columns */
export type Facility_Variance_FieldsNum_Postings_For_ProfArgs = {
  args: Num_Postings_For_Prof_Facility_Args;
};

/** order by variance() on columns of table "facility" */
export type Facility_Variance_Order_By = {
  adult_trauma_lvl?: InputMaybe<Order_By>;
  ped_trauma_lvl?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** columns and relationships of "favorite" */
export type Favorite = {
  __typename?: 'favorite';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid'];
  /** An object relationship */
  clerkship: Maybe<Clerkship>;
  clerkship_id: Maybe<Scalars['uuid']>;
  created_at: Scalars['timestamp'];
  /** An object relationship */
  facility: Maybe<Facility>;
  facility_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  fellowship: Maybe<Fellowship>;
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  org_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization: Maybe<Organization>;
  /** An object relationship */
  residency: Maybe<Residency>;
  residency_id: Maybe<Scalars['uuid']>;
  type: Scalars['favoritetype'];
};

/** aggregated selection of "favorite" */
export type Favorite_Aggregate = {
  __typename?: 'favorite_aggregate';
  aggregate: Maybe<Favorite_Aggregate_Fields>;
  nodes: Array<Favorite>;
};

/** aggregate fields of "favorite" */
export type Favorite_Aggregate_Fields = {
  __typename?: 'favorite_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Favorite_Max_Fields>;
  min: Maybe<Favorite_Min_Fields>;
};


/** aggregate fields of "favorite" */
export type Favorite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Favorite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "favorite" */
export type Favorite_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Favorite_Max_Order_By>;
  min?: InputMaybe<Favorite_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "favorite". All fields are combined with a logical 'AND'. */
export type Favorite_Bool_Exp = {
  _and?: InputMaybe<Array<Favorite_Bool_Exp>>;
  _not?: InputMaybe<Favorite_Bool_Exp>;
  _or?: InputMaybe<Array<Favorite_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  clerkship?: InputMaybe<Clerkship_Bool_Exp>;
  clerkship_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  fellowship?: InputMaybe<Fellowship_Bool_Exp>;
  fellowship_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
  residency_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Favoritetype_Comparison_Exp>;
};

/** unique or primary key constraints on table "favorite" */
export enum Favorite_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFavorite = 'pk_favorite',
  /** unique or primary key constraint on columns "account_id", "clerkship_id" */
  UqFavoriteClerkshipIdAccountId = 'uq_favorite_clerkship_id_account_id',
  /** unique or primary key constraint on columns "account_id", "facility_id" */
  UqFavoriteFacilityIdAccountId = 'uq_favorite_facility_id_account_id',
  /** unique or primary key constraint on columns "account_id", "fellowship_id" */
  UqFavoriteFellowshipIdAccountId = 'uq_favorite_fellowship_id_account_id',
  /** unique or primary key constraint on columns "account_id", "org_id" */
  UqFavoriteOrgIdAccountId = 'uq_favorite_org_id_account_id',
  /** unique or primary key constraint on columns "account_id", "residency_id" */
  UqFavoriteResidencyIdAccountId = 'uq_favorite_residency_id_account_id'
}

/** input type for inserting data into table "favorite" */
export type Favorite_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  clerkship?: InputMaybe<Clerkship_Obj_Rel_Insert_Input>;
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  fellowship?: InputMaybe<Fellowship_Obj_Rel_Insert_Input>;
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['favoritetype']>;
};

/** aggregate max on columns */
export type Favorite_Max_Fields = {
  __typename?: 'favorite_max_fields';
  account_id: Maybe<Scalars['uuid']>;
  clerkship_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  facility_id: Maybe<Scalars['uuid']>;
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  org_id: Maybe<Scalars['uuid']>;
  residency_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['favoritetype']>;
};

/** order by max() on columns of table "favorite" */
export type Favorite_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  clerkship_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Favorite_Min_Fields = {
  __typename?: 'favorite_min_fields';
  account_id: Maybe<Scalars['uuid']>;
  clerkship_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  facility_id: Maybe<Scalars['uuid']>;
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  org_id: Maybe<Scalars['uuid']>;
  residency_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['favoritetype']>;
};

/** order by min() on columns of table "favorite" */
export type Favorite_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  clerkship_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "favorite" */
export type Favorite_Mutation_Response = {
  __typename?: 'favorite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Favorite>;
};

/** on_conflict condition type for table "favorite" */
export type Favorite_On_Conflict = {
  constraint: Favorite_Constraint;
  update_columns?: Array<Favorite_Update_Column>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};

/** Ordering options when selecting data from "favorite". */
export type Favorite_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  clerkship?: InputMaybe<Clerkship_Order_By>;
  clerkship_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  fellowship?: InputMaybe<Fellowship_Order_By>;
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
  residency_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: favorite */
export type Favorite_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "favorite" */
export enum Favorite_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ClerkshipId = 'clerkship_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FellowshipId = 'fellowship_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "favorite" */
export type Favorite_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['favoritetype']>;
};

/** Streaming cursor of the table "favorite" */
export type Favorite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Favorite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Favorite_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['favoritetype']>;
};

/** update columns of table "favorite" */
export enum Favorite_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ClerkshipId = 'clerkship_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FellowshipId = 'fellowship_id',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  Type = 'type'
}

export type Favorite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Favorite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Favorite_Bool_Exp;
};

/** Boolean expression to compare columns of type "favoritetype". All fields are combined with logical 'AND'. */
export type Favoritetype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['favoritetype']>;
  _gt?: InputMaybe<Scalars['favoritetype']>;
  _gte?: InputMaybe<Scalars['favoritetype']>;
  _in?: InputMaybe<Array<Scalars['favoritetype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['favoritetype']>;
  _lte?: InputMaybe<Scalars['favoritetype']>;
  _neq?: InputMaybe<Scalars['favoritetype']>;
  _nin?: InputMaybe<Array<Scalars['favoritetype']>>;
};

export type Featured_Clerkship_Dist_Args = {
  x?: InputMaybe<Scalars['float8']>;
  y?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result = {
  __typename?: 'featured_clerkship_dist_result';
  /** An object relationship */
  clerkship: Maybe<Clerkship>;
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

export type Featured_Clerkship_Dist_Result_Aggregate = {
  __typename?: 'featured_clerkship_dist_result_aggregate';
  aggregate: Maybe<Featured_Clerkship_Dist_Result_Aggregate_Fields>;
  nodes: Array<Featured_Clerkship_Dist_Result>;
};

/** aggregate fields of "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Aggregate_Fields = {
  __typename?: 'featured_clerkship_dist_result_aggregate_fields';
  avg: Maybe<Featured_Clerkship_Dist_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Featured_Clerkship_Dist_Result_Max_Fields>;
  min: Maybe<Featured_Clerkship_Dist_Result_Min_Fields>;
  stddev: Maybe<Featured_Clerkship_Dist_Result_Stddev_Fields>;
  stddev_pop: Maybe<Featured_Clerkship_Dist_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Featured_Clerkship_Dist_Result_Stddev_Samp_Fields>;
  sum: Maybe<Featured_Clerkship_Dist_Result_Sum_Fields>;
  var_pop: Maybe<Featured_Clerkship_Dist_Result_Var_Pop_Fields>;
  var_samp: Maybe<Featured_Clerkship_Dist_Result_Var_Samp_Fields>;
  variance: Maybe<Featured_Clerkship_Dist_Result_Variance_Fields>;
};


/** aggregate fields of "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Featured_Clerkship_Dist_Result_Avg_Fields = {
  __typename?: 'featured_clerkship_dist_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "featured_clerkship_dist_result". All fields are combined with a logical 'AND'. */
export type Featured_Clerkship_Dist_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Bool_Exp>>;
  _not?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Bool_Exp>>;
  clerkship?: InputMaybe<Clerkship_Bool_Exp>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Insert_Input = {
  clerkship?: InputMaybe<Clerkship_Obj_Rel_Insert_Input>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Featured_Clerkship_Dist_Result_Max_Fields = {
  __typename?: 'featured_clerkship_dist_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Featured_Clerkship_Dist_Result_Min_Fields = {
  __typename?: 'featured_clerkship_dist_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Mutation_Response = {
  __typename?: 'featured_clerkship_dist_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Featured_Clerkship_Dist_Result>;
};

/** Ordering options when selecting data from "featured_clerkship_dist_result". */
export type Featured_Clerkship_Dist_Result_Order_By = {
  clerkship?: InputMaybe<Clerkship_Order_By>;
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "featured_clerkship_dist_result" */
export enum Featured_Clerkship_Dist_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Featured_Clerkship_Dist_Result_Stddev_Fields = {
  __typename?: 'featured_clerkship_dist_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Featured_Clerkship_Dist_Result_Stddev_Pop_Fields = {
  __typename?: 'featured_clerkship_dist_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Featured_Clerkship_Dist_Result_Stddev_Samp_Fields = {
  __typename?: 'featured_clerkship_dist_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "featured_clerkship_dist_result" */
export type Featured_Clerkship_Dist_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Featured_Clerkship_Dist_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Featured_Clerkship_Dist_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Featured_Clerkship_Dist_Result_Sum_Fields = {
  __typename?: 'featured_clerkship_dist_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Featured_Clerkship_Dist_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Featured_Clerkship_Dist_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Featured_Clerkship_Dist_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Featured_Clerkship_Dist_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Featured_Clerkship_Dist_Result_Var_Pop_Fields = {
  __typename?: 'featured_clerkship_dist_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Featured_Clerkship_Dist_Result_Var_Samp_Fields = {
  __typename?: 'featured_clerkship_dist_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Featured_Clerkship_Dist_Result_Variance_Fields = {
  __typename?: 'featured_clerkship_dist_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Featured_Fellowship_Dist_Args = {
  x?: InputMaybe<Scalars['float8']>;
  y?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result = {
  __typename?: 'featured_fellowship_dist_result';
  distance: Maybe<Scalars['float8']>;
  /** An object relationship */
  fellowship: Maybe<Fellowship>;
  id: Maybe<Scalars['uuid']>;
};

export type Featured_Fellowship_Dist_Result_Aggregate = {
  __typename?: 'featured_fellowship_dist_result_aggregate';
  aggregate: Maybe<Featured_Fellowship_Dist_Result_Aggregate_Fields>;
  nodes: Array<Featured_Fellowship_Dist_Result>;
};

/** aggregate fields of "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Aggregate_Fields = {
  __typename?: 'featured_fellowship_dist_result_aggregate_fields';
  avg: Maybe<Featured_Fellowship_Dist_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Featured_Fellowship_Dist_Result_Max_Fields>;
  min: Maybe<Featured_Fellowship_Dist_Result_Min_Fields>;
  stddev: Maybe<Featured_Fellowship_Dist_Result_Stddev_Fields>;
  stddev_pop: Maybe<Featured_Fellowship_Dist_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Featured_Fellowship_Dist_Result_Stddev_Samp_Fields>;
  sum: Maybe<Featured_Fellowship_Dist_Result_Sum_Fields>;
  var_pop: Maybe<Featured_Fellowship_Dist_Result_Var_Pop_Fields>;
  var_samp: Maybe<Featured_Fellowship_Dist_Result_Var_Samp_Fields>;
  variance: Maybe<Featured_Fellowship_Dist_Result_Variance_Fields>;
};


/** aggregate fields of "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Featured_Fellowship_Dist_Result_Avg_Fields = {
  __typename?: 'featured_fellowship_dist_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "featured_fellowship_dist_result". All fields are combined with a logical 'AND'. */
export type Featured_Fellowship_Dist_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Bool_Exp>>;
  _not?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  fellowship?: InputMaybe<Fellowship_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  fellowship?: InputMaybe<Fellowship_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Featured_Fellowship_Dist_Result_Max_Fields = {
  __typename?: 'featured_fellowship_dist_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Featured_Fellowship_Dist_Result_Min_Fields = {
  __typename?: 'featured_fellowship_dist_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Mutation_Response = {
  __typename?: 'featured_fellowship_dist_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Featured_Fellowship_Dist_Result>;
};

/** Ordering options when selecting data from "featured_fellowship_dist_result". */
export type Featured_Fellowship_Dist_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  fellowship?: InputMaybe<Fellowship_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "featured_fellowship_dist_result" */
export enum Featured_Fellowship_Dist_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Featured_Fellowship_Dist_Result_Stddev_Fields = {
  __typename?: 'featured_fellowship_dist_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Featured_Fellowship_Dist_Result_Stddev_Pop_Fields = {
  __typename?: 'featured_fellowship_dist_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Featured_Fellowship_Dist_Result_Stddev_Samp_Fields = {
  __typename?: 'featured_fellowship_dist_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "featured_fellowship_dist_result" */
export type Featured_Fellowship_Dist_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Featured_Fellowship_Dist_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Featured_Fellowship_Dist_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Featured_Fellowship_Dist_Result_Sum_Fields = {
  __typename?: 'featured_fellowship_dist_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Featured_Fellowship_Dist_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Featured_Fellowship_Dist_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Featured_Fellowship_Dist_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Featured_Fellowship_Dist_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Featured_Fellowship_Dist_Result_Var_Pop_Fields = {
  __typename?: 'featured_fellowship_dist_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Featured_Fellowship_Dist_Result_Var_Samp_Fields = {
  __typename?: 'featured_fellowship_dist_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Featured_Fellowship_Dist_Result_Variance_Fields = {
  __typename?: 'featured_fellowship_dist_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Featured_For_Prof_Facility_Args = {
  prof?: InputMaybe<Scalars['profession']>;
};

export type Featured_Residency_Dist_Args = {
  x?: InputMaybe<Scalars['float8']>;
  y?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result = {
  __typename?: 'featured_residency_dist_result';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  residency: Maybe<Residency>;
};

export type Featured_Residency_Dist_Result_Aggregate = {
  __typename?: 'featured_residency_dist_result_aggregate';
  aggregate: Maybe<Featured_Residency_Dist_Result_Aggregate_Fields>;
  nodes: Array<Featured_Residency_Dist_Result>;
};

/** aggregate fields of "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Aggregate_Fields = {
  __typename?: 'featured_residency_dist_result_aggregate_fields';
  avg: Maybe<Featured_Residency_Dist_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Featured_Residency_Dist_Result_Max_Fields>;
  min: Maybe<Featured_Residency_Dist_Result_Min_Fields>;
  stddev: Maybe<Featured_Residency_Dist_Result_Stddev_Fields>;
  stddev_pop: Maybe<Featured_Residency_Dist_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Featured_Residency_Dist_Result_Stddev_Samp_Fields>;
  sum: Maybe<Featured_Residency_Dist_Result_Sum_Fields>;
  var_pop: Maybe<Featured_Residency_Dist_Result_Var_Pop_Fields>;
  var_samp: Maybe<Featured_Residency_Dist_Result_Var_Samp_Fields>;
  variance: Maybe<Featured_Residency_Dist_Result_Variance_Fields>;
};


/** aggregate fields of "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Featured_Residency_Dist_Result_Avg_Fields = {
  __typename?: 'featured_residency_dist_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "featured_residency_dist_result". All fields are combined with a logical 'AND'. */
export type Featured_Residency_Dist_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Featured_Residency_Dist_Result_Bool_Exp>>;
  _not?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Featured_Residency_Dist_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Featured_Residency_Dist_Result_Max_Fields = {
  __typename?: 'featured_residency_dist_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Featured_Residency_Dist_Result_Min_Fields = {
  __typename?: 'featured_residency_dist_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Mutation_Response = {
  __typename?: 'featured_residency_dist_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Featured_Residency_Dist_Result>;
};

/** Ordering options when selecting data from "featured_residency_dist_result". */
export type Featured_Residency_Dist_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
};

/** select columns of table "featured_residency_dist_result" */
export enum Featured_Residency_Dist_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Featured_Residency_Dist_Result_Stddev_Fields = {
  __typename?: 'featured_residency_dist_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Featured_Residency_Dist_Result_Stddev_Pop_Fields = {
  __typename?: 'featured_residency_dist_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Featured_Residency_Dist_Result_Stddev_Samp_Fields = {
  __typename?: 'featured_residency_dist_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "featured_residency_dist_result" */
export type Featured_Residency_Dist_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Featured_Residency_Dist_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Featured_Residency_Dist_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Featured_Residency_Dist_Result_Sum_Fields = {
  __typename?: 'featured_residency_dist_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Featured_Residency_Dist_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Featured_Residency_Dist_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Featured_Residency_Dist_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Featured_Residency_Dist_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Featured_Residency_Dist_Result_Var_Pop_Fields = {
  __typename?: 'featured_residency_dist_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Featured_Residency_Dist_Result_Var_Samp_Fields = {
  __typename?: 'featured_residency_dist_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Featured_Residency_Dist_Result_Variance_Fields = {
  __typename?: 'featured_residency_dist_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fellowship" */
export type Fellowship = {
  __typename?: 'fellowship';
  id: Scalars['uuid'];
  /** An object relationship */
  latest_survey: Maybe<Latest_Fellowship_Survey>;
  /** An array relationship */
  surveys: Array<Fellowship_Survey>;
  /** An aggregate relationship */
  surveys_aggregate: Fellowship_Survey_Aggregate;
  /** An object relationship */
  training: Training;
};


/** columns and relationships of "fellowship" */
export type FellowshipSurveysArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


/** columns and relationships of "fellowship" */
export type FellowshipSurveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};

/** aggregated selection of "fellowship" */
export type Fellowship_Aggregate = {
  __typename?: 'fellowship_aggregate';
  aggregate: Maybe<Fellowship_Aggregate_Fields>;
  nodes: Array<Fellowship>;
};

/** aggregate fields of "fellowship" */
export type Fellowship_Aggregate_Fields = {
  __typename?: 'fellowship_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Fellowship_Max_Fields>;
  min: Maybe<Fellowship_Min_Fields>;
};


/** aggregate fields of "fellowship" */
export type Fellowship_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fellowship_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fellowship". All fields are combined with a logical 'AND'. */
export type Fellowship_Bool_Exp = {
  _and?: InputMaybe<Array<Fellowship_Bool_Exp>>;
  _not?: InputMaybe<Fellowship_Bool_Exp>;
  _or?: InputMaybe<Array<Fellowship_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latest_survey?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
  surveys?: InputMaybe<Fellowship_Survey_Bool_Exp>;
  surveys_aggregate?: InputMaybe<Fellowship_Survey_Aggregate_Bool_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
};

/** unique or primary key constraints on table "fellowship" */
export enum Fellowship_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFellowship = 'pk_fellowship'
}

/** input type for inserting data into table "fellowship" */
export type Fellowship_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  latest_survey?: InputMaybe<Latest_Fellowship_Survey_Obj_Rel_Insert_Input>;
  surveys?: InputMaybe<Fellowship_Survey_Arr_Rel_Insert_Input>;
  training?: InputMaybe<Training_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Fellowship_Max_Fields = {
  __typename?: 'fellowship_max_fields';
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Fellowship_Min_Fields = {
  __typename?: 'fellowship_min_fields';
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "fellowship" */
export type Fellowship_Mutation_Response = {
  __typename?: 'fellowship_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fellowship>;
};

/** input type for inserting object relation for remote table "fellowship" */
export type Fellowship_Obj_Rel_Insert_Input = {
  data: Fellowship_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fellowship_On_Conflict>;
};

/** on_conflict condition type for table "fellowship" */
export type Fellowship_On_Conflict = {
  constraint: Fellowship_Constraint;
  update_columns?: Array<Fellowship_Update_Column>;
  where?: InputMaybe<Fellowship_Bool_Exp>;
};

/** Ordering options when selecting data from "fellowship". */
export type Fellowship_Order_By = {
  id?: InputMaybe<Order_By>;
  latest_survey?: InputMaybe<Latest_Fellowship_Survey_Order_By>;
  surveys_aggregate?: InputMaybe<Fellowship_Survey_Aggregate_Order_By>;
  training?: InputMaybe<Training_Order_By>;
};

/** primary key columns input for table: fellowship */
export type Fellowship_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "fellowship" */
export enum Fellowship_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "fellowship" */
export type Fellowship_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "fellowship" */
export type Fellowship_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fellowship_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fellowship_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "fellowship_survey" */
export type Fellowship_Survey = {
  __typename?: 'fellowship_survey';
  advanced_degrees: Array<Scalars['String']>;
  clinical_exp: Scalars['String'];
  compensation: Scalars['String'];
  degree_granting_institution: Scalars['String'];
  /** An object relationship */
  fellowship: Maybe<Fellowship>;
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  moonlighting_allowed: Scalars['String'];
  positions_per_year: Maybe<Scalars['Int']>;
  program_length: Maybe<Scalars['Int']>;
  research_project: Scalars['String'];
  /** An object relationship */
  residency: Maybe<Residency>;
  residency_id: Maybe<Scalars['uuid']>;
  residency_other: Scalars['String'];
  shifts_per_month: Maybe<Scalars['Int']>;
  subspecialty: Scalars['String'];
  /** An object relationship */
  training_survey: Training_Survey;
};

/** aggregated selection of "fellowship_survey" */
export type Fellowship_Survey_Aggregate = {
  __typename?: 'fellowship_survey_aggregate';
  aggregate: Maybe<Fellowship_Survey_Aggregate_Fields>;
  nodes: Array<Fellowship_Survey>;
};

export type Fellowship_Survey_Aggregate_Bool_Exp = {
  count?: InputMaybe<Fellowship_Survey_Aggregate_Bool_Exp_Count>;
};

export type Fellowship_Survey_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fellowship_Survey_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fellowship_survey" */
export type Fellowship_Survey_Aggregate_Fields = {
  __typename?: 'fellowship_survey_aggregate_fields';
  avg: Maybe<Fellowship_Survey_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Fellowship_Survey_Max_Fields>;
  min: Maybe<Fellowship_Survey_Min_Fields>;
  stddev: Maybe<Fellowship_Survey_Stddev_Fields>;
  stddev_pop: Maybe<Fellowship_Survey_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Fellowship_Survey_Stddev_Samp_Fields>;
  sum: Maybe<Fellowship_Survey_Sum_Fields>;
  var_pop: Maybe<Fellowship_Survey_Var_Pop_Fields>;
  var_samp: Maybe<Fellowship_Survey_Var_Samp_Fields>;
  variance: Maybe<Fellowship_Survey_Variance_Fields>;
};


/** aggregate fields of "fellowship_survey" */
export type Fellowship_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fellowship_survey" */
export type Fellowship_Survey_Aggregate_Order_By = {
  avg?: InputMaybe<Fellowship_Survey_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fellowship_Survey_Max_Order_By>;
  min?: InputMaybe<Fellowship_Survey_Min_Order_By>;
  stddev?: InputMaybe<Fellowship_Survey_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fellowship_Survey_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fellowship_Survey_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fellowship_Survey_Sum_Order_By>;
  var_pop?: InputMaybe<Fellowship_Survey_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fellowship_Survey_Var_Samp_Order_By>;
  variance?: InputMaybe<Fellowship_Survey_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fellowship_survey" */
export type Fellowship_Survey_Arr_Rel_Insert_Input = {
  data: Array<Fellowship_Survey_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fellowship_Survey_On_Conflict>;
};

/** aggregate avg on columns */
export type Fellowship_Survey_Avg_Fields = {
  __typename?: 'fellowship_survey_avg_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Avg_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fellowship_survey". All fields are combined with a logical 'AND'. */
export type Fellowship_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Fellowship_Survey_Bool_Exp>>;
  _not?: InputMaybe<Fellowship_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Fellowship_Survey_Bool_Exp>>;
  advanced_degrees?: InputMaybe<String_Array_Comparison_Exp>;
  clinical_exp?: InputMaybe<String_Comparison_Exp>;
  compensation?: InputMaybe<String_Comparison_Exp>;
  degree_granting_institution?: InputMaybe<String_Comparison_Exp>;
  fellowship?: InputMaybe<Fellowship_Bool_Exp>;
  fellowship_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  moonlighting_allowed?: InputMaybe<String_Comparison_Exp>;
  positions_per_year?: InputMaybe<Int_Comparison_Exp>;
  program_length?: InputMaybe<Int_Comparison_Exp>;
  research_project?: InputMaybe<String_Comparison_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
  residency_id?: InputMaybe<Uuid_Comparison_Exp>;
  residency_other?: InputMaybe<String_Comparison_Exp>;
  shifts_per_month?: InputMaybe<Int_Comparison_Exp>;
  subspecialty?: InputMaybe<String_Comparison_Exp>;
  training_survey?: InputMaybe<Training_Survey_Bool_Exp>;
};

/** unique or primary key constraints on table "fellowship_survey" */
export enum Fellowship_Survey_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFellowshipSurvey = 'pk_fellowship_survey'
}

/** input type for incrementing numeric columns in table "fellowship_survey" */
export type Fellowship_Survey_Inc_Input = {
  positions_per_year?: InputMaybe<Scalars['Int']>;
  program_length?: InputMaybe<Scalars['Int']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "fellowship_survey" */
export type Fellowship_Survey_Insert_Input = {
  advanced_degrees?: InputMaybe<Array<Scalars['String']>>;
  clinical_exp?: InputMaybe<Scalars['String']>;
  compensation?: InputMaybe<Scalars['String']>;
  degree_granting_institution?: InputMaybe<Scalars['String']>;
  fellowship?: InputMaybe<Fellowship_Obj_Rel_Insert_Input>;
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  moonlighting_allowed?: InputMaybe<Scalars['String']>;
  positions_per_year?: InputMaybe<Scalars['Int']>;
  program_length?: InputMaybe<Scalars['Int']>;
  research_project?: InputMaybe<Scalars['String']>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  residency_other?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  subspecialty?: InputMaybe<Scalars['String']>;
  training_survey?: InputMaybe<Training_Survey_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Fellowship_Survey_Max_Fields = {
  __typename?: 'fellowship_survey_max_fields';
  advanced_degrees: Maybe<Array<Scalars['String']>>;
  clinical_exp: Maybe<Scalars['String']>;
  compensation: Maybe<Scalars['String']>;
  degree_granting_institution: Maybe<Scalars['String']>;
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  moonlighting_allowed: Maybe<Scalars['String']>;
  positions_per_year: Maybe<Scalars['Int']>;
  program_length: Maybe<Scalars['Int']>;
  research_project: Maybe<Scalars['String']>;
  residency_id: Maybe<Scalars['uuid']>;
  residency_other: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  subspecialty: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Max_Order_By = {
  advanced_degrees?: InputMaybe<Order_By>;
  clinical_exp?: InputMaybe<Order_By>;
  compensation?: InputMaybe<Order_By>;
  degree_granting_institution?: InputMaybe<Order_By>;
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moonlighting_allowed?: InputMaybe<Order_By>;
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  research_project?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  residency_other?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  subspecialty?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fellowship_Survey_Min_Fields = {
  __typename?: 'fellowship_survey_min_fields';
  advanced_degrees: Maybe<Array<Scalars['String']>>;
  clinical_exp: Maybe<Scalars['String']>;
  compensation: Maybe<Scalars['String']>;
  degree_granting_institution: Maybe<Scalars['String']>;
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  moonlighting_allowed: Maybe<Scalars['String']>;
  positions_per_year: Maybe<Scalars['Int']>;
  program_length: Maybe<Scalars['Int']>;
  research_project: Maybe<Scalars['String']>;
  residency_id: Maybe<Scalars['uuid']>;
  residency_other: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  subspecialty: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Min_Order_By = {
  advanced_degrees?: InputMaybe<Order_By>;
  clinical_exp?: InputMaybe<Order_By>;
  compensation?: InputMaybe<Order_By>;
  degree_granting_institution?: InputMaybe<Order_By>;
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moonlighting_allowed?: InputMaybe<Order_By>;
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  research_project?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  residency_other?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  subspecialty?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fellowship_survey" */
export type Fellowship_Survey_Mutation_Response = {
  __typename?: 'fellowship_survey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fellowship_Survey>;
};

/** input type for inserting object relation for remote table "fellowship_survey" */
export type Fellowship_Survey_Obj_Rel_Insert_Input = {
  data: Fellowship_Survey_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fellowship_Survey_On_Conflict>;
};

/** on_conflict condition type for table "fellowship_survey" */
export type Fellowship_Survey_On_Conflict = {
  constraint: Fellowship_Survey_Constraint;
  update_columns?: Array<Fellowship_Survey_Update_Column>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};

/** Ordering options when selecting data from "fellowship_survey". */
export type Fellowship_Survey_Order_By = {
  advanced_degrees?: InputMaybe<Order_By>;
  clinical_exp?: InputMaybe<Order_By>;
  compensation?: InputMaybe<Order_By>;
  degree_granting_institution?: InputMaybe<Order_By>;
  fellowship?: InputMaybe<Fellowship_Order_By>;
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moonlighting_allowed?: InputMaybe<Order_By>;
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  research_project?: InputMaybe<Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
  residency_id?: InputMaybe<Order_By>;
  residency_other?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  subspecialty?: InputMaybe<Order_By>;
  training_survey?: InputMaybe<Training_Survey_Order_By>;
};

/** primary key columns input for table: fellowship_survey */
export type Fellowship_Survey_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "fellowship_survey" */
export enum Fellowship_Survey_Select_Column {
  /** column name */
  AdvancedDegrees = 'advanced_degrees',
  /** column name */
  ClinicalExp = 'clinical_exp',
  /** column name */
  Compensation = 'compensation',
  /** column name */
  DegreeGrantingInstitution = 'degree_granting_institution',
  /** column name */
  FellowshipId = 'fellowship_id',
  /** column name */
  Id = 'id',
  /** column name */
  MoonlightingAllowed = 'moonlighting_allowed',
  /** column name */
  PositionsPerYear = 'positions_per_year',
  /** column name */
  ProgramLength = 'program_length',
  /** column name */
  ResearchProject = 'research_project',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  ResidencyOther = 'residency_other',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  Subspecialty = 'subspecialty'
}

/** input type for updating data in table "fellowship_survey" */
export type Fellowship_Survey_Set_Input = {
  advanced_degrees?: InputMaybe<Array<Scalars['String']>>;
  clinical_exp?: InputMaybe<Scalars['String']>;
  compensation?: InputMaybe<Scalars['String']>;
  degree_granting_institution?: InputMaybe<Scalars['String']>;
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  moonlighting_allowed?: InputMaybe<Scalars['String']>;
  positions_per_year?: InputMaybe<Scalars['Int']>;
  program_length?: InputMaybe<Scalars['Int']>;
  research_project?: InputMaybe<Scalars['String']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  residency_other?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  subspecialty?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Fellowship_Survey_Stddev_Fields = {
  __typename?: 'fellowship_survey_stddev_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Stddev_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fellowship_Survey_Stddev_Pop_Fields = {
  __typename?: 'fellowship_survey_stddev_pop_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Stddev_Pop_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fellowship_Survey_Stddev_Samp_Fields = {
  __typename?: 'fellowship_survey_stddev_samp_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Stddev_Samp_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fellowship_survey" */
export type Fellowship_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fellowship_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fellowship_Survey_Stream_Cursor_Value_Input = {
  advanced_degrees?: InputMaybe<Array<Scalars['String']>>;
  clinical_exp?: InputMaybe<Scalars['String']>;
  compensation?: InputMaybe<Scalars['String']>;
  degree_granting_institution?: InputMaybe<Scalars['String']>;
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  moonlighting_allowed?: InputMaybe<Scalars['String']>;
  positions_per_year?: InputMaybe<Scalars['Int']>;
  program_length?: InputMaybe<Scalars['Int']>;
  research_project?: InputMaybe<Scalars['String']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  residency_other?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  subspecialty?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fellowship_Survey_Sum_Fields = {
  __typename?: 'fellowship_survey_sum_fields';
  positions_per_year: Maybe<Scalars['Int']>;
  program_length: Maybe<Scalars['Int']>;
  shifts_per_month: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Sum_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** update columns of table "fellowship_survey" */
export enum Fellowship_Survey_Update_Column {
  /** column name */
  AdvancedDegrees = 'advanced_degrees',
  /** column name */
  ClinicalExp = 'clinical_exp',
  /** column name */
  Compensation = 'compensation',
  /** column name */
  DegreeGrantingInstitution = 'degree_granting_institution',
  /** column name */
  FellowshipId = 'fellowship_id',
  /** column name */
  Id = 'id',
  /** column name */
  MoonlightingAllowed = 'moonlighting_allowed',
  /** column name */
  PositionsPerYear = 'positions_per_year',
  /** column name */
  ProgramLength = 'program_length',
  /** column name */
  ResearchProject = 'research_project',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  ResidencyOther = 'residency_other',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  Subspecialty = 'subspecialty'
}

export type Fellowship_Survey_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fellowship_Survey_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fellowship_Survey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fellowship_Survey_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fellowship_Survey_Var_Pop_Fields = {
  __typename?: 'fellowship_survey_var_pop_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Var_Pop_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fellowship_Survey_Var_Samp_Fields = {
  __typename?: 'fellowship_survey_var_samp_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Var_Samp_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fellowship_Survey_Variance_Fields = {
  __typename?: 'fellowship_survey_variance_fields';
  positions_per_year: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fellowship_survey" */
export type Fellowship_Survey_Variance_Order_By = {
  positions_per_year?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
};

/** update columns of table "fellowship" */
export enum Fellowship_Update_Column {
  /** column name */
  Id = 'id'
}

export type Fellowship_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fellowship_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fellowship_Bool_Exp;
};

/** Boolean expression to compare columns of type "fieldtype". All fields are combined with logical 'AND'. */
export type Fieldtype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['fieldtype']>;
  _gt?: InputMaybe<Scalars['fieldtype']>;
  _gte?: InputMaybe<Scalars['fieldtype']>;
  _in?: InputMaybe<Array<Scalars['fieldtype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['fieldtype']>;
  _lte?: InputMaybe<Scalars['fieldtype']>;
  _neq?: InputMaybe<Scalars['fieldtype']>;
  _nin?: InputMaybe<Array<Scalars['fieldtype']>>;
};

/** columns and relationships of "file" */
export type File = {
  __typename?: 'file';
  /** An array relationship */
  accounts: Array<Account>;
  /** An aggregate relationship */
  accounts_aggregate: Account_Aggregate;
  content_type: Scalars['String'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  creator: Maybe<Account>;
  creator_id: Maybe<Scalars['uuid']>;
  /** An array relationship */
  cv_clinicians: Array<Clinician>;
  /** An aggregate relationship */
  cv_clinicians_aggregate: Clinician_Aggregate;
  /** An array relationship */
  facilities: Array<Facility>;
  /** An aggregate relationship */
  facilities_aggregate: Facility_Aggregate;
  filename: Scalars['String'];
  finalized: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  org_cover_photo: Maybe<Organization>;
  /** An object relationship */
  org_logo: Maybe<Organization>;
  public_url: Scalars['String'];
  /** An array relationship */
  training_survey_pictures: Array<Training_Survey_Picture>;
  /** An aggregate relationship */
  training_survey_pictures_aggregate: Training_Survey_Picture_Aggregate;
};


/** columns and relationships of "file" */
export type FileAccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileCv_CliniciansArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Order_By>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileCv_Clinicians_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Order_By>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileFacilitiesArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileFacilities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileTraining_Survey_PicturesArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


/** columns and relationships of "file" */
export type FileTraining_Survey_Pictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};

/** aggregated selection of "file" */
export type File_Aggregate = {
  __typename?: 'file_aggregate';
  aggregate: Maybe<File_Aggregate_Fields>;
  nodes: Array<File>;
};

/** aggregate fields of "file" */
export type File_Aggregate_Fields = {
  __typename?: 'file_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<File_Max_Fields>;
  min: Maybe<File_Min_Fields>;
};


/** aggregate fields of "file" */
export type File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  _and?: InputMaybe<Array<File_Bool_Exp>>;
  _not?: InputMaybe<File_Bool_Exp>;
  _or?: InputMaybe<Array<File_Bool_Exp>>;
  accounts?: InputMaybe<Account_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Account_Aggregate_Bool_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  creator?: InputMaybe<Account_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  cv_clinicians?: InputMaybe<Clinician_Bool_Exp>;
  cv_clinicians_aggregate?: InputMaybe<Clinician_Aggregate_Bool_Exp>;
  facilities?: InputMaybe<Facility_Bool_Exp>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Bool_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  finalized?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_cover_photo?: InputMaybe<Organization_Bool_Exp>;
  org_logo?: InputMaybe<Organization_Bool_Exp>;
  public_url?: InputMaybe<String_Comparison_Exp>;
  training_survey_pictures?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
  training_survey_pictures_aggregate?: InputMaybe<Training_Survey_Picture_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "file" */
export enum File_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFile = 'pk_file'
}

/** input type for inserting data into table "file" */
export type File_Insert_Input = {
  accounts?: InputMaybe<Account_Arr_Rel_Insert_Input>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  creator?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  cv_clinicians?: InputMaybe<Clinician_Arr_Rel_Insert_Input>;
  facilities?: InputMaybe<Facility_Arr_Rel_Insert_Input>;
  filename?: InputMaybe<Scalars['String']>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  org_cover_photo?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_logo?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  public_url?: InputMaybe<Scalars['String']>;
  training_survey_pictures?: InputMaybe<Training_Survey_Picture_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type File_Max_Fields = {
  __typename?: 'file_max_fields';
  content_type: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  creator_id: Maybe<Scalars['uuid']>;
  filename: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  public_url: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_Min_Fields = {
  __typename?: 'file_min_fields';
  content_type: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  creator_id: Maybe<Scalars['uuid']>;
  filename: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  public_url: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file" */
export type File_Mutation_Response = {
  __typename?: 'file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** input type for inserting object relation for remote table "file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** on_conflict condition type for table "file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns?: Array<File_Update_Column>;
  where?: InputMaybe<File_Bool_Exp>;
};

/** Ordering options when selecting data from "file". */
export type File_Order_By = {
  accounts_aggregate?: InputMaybe<Account_Aggregate_Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Account_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  cv_clinicians_aggregate?: InputMaybe<Clinician_Aggregate_Order_By>;
  facilities_aggregate?: InputMaybe<Facility_Aggregate_Order_By>;
  filename?: InputMaybe<Order_By>;
  finalized?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_cover_photo?: InputMaybe<Organization_Order_By>;
  org_logo?: InputMaybe<Organization_Order_By>;
  public_url?: InputMaybe<Order_By>;
  training_survey_pictures_aggregate?: InputMaybe<Training_Survey_Picture_Aggregate_Order_By>;
};

/** primary key columns input for table: file */
export type File_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "file" */
export enum File_Select_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Finalized = 'finalized',
  /** column name */
  Id = 'id',
  /** column name */
  PublicUrl = 'public_url'
}

/** input type for updating data in table "file" */
export type File_Set_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  public_url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file" */
export type File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stream_Cursor_Value_Input = {
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  filename?: InputMaybe<Scalars['String']>;
  finalized?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  public_url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "file" */
export enum File_Update_Column {
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  Filename = 'filename',
  /** column name */
  Finalized = 'finalized',
  /** column name */
  Id = 'id',
  /** column name */
  PublicUrl = 'public_url'
}

export type File_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "fsmb_bio" */
export type Fsmb_Bio = {
  __typename?: 'fsmb_bio';
  board_action_flag: Scalars['Boolean'];
  city: Scalars['String'];
  /** An array relationship */
  cms_specialties: Array<Cms_Specialty>;
  /** An aggregate relationship */
  cms_specialties_aggregate: Cms_Specialty_Aggregate;
  fid: Scalars['String'];
  first_name: Scalars['String'];
  gender: Scalars['String'];
  graduation_year: Maybe<Scalars['Int']>;
  last_name: Scalars['String'];
  /** An array relationship */
  licenses: Array<Fsmb_Licensure>;
  /** An aggregate relationship */
  licenses_aggregate: Fsmb_Licensure_Aggregate;
  medical_school_name: Scalars['String'];
  middle_name: Scalars['String'];
  npi: Scalars['String'];
  npi_active_flag: Maybe<Scalars['Boolean']>;
  npi_entity_type: Scalars['String'];
  practitioner_type: Scalars['String'];
  state: Scalars['String'];
  suffix: Scalars['String'];
  zipcode: Scalars['String'];
};


/** columns and relationships of "fsmb_bio" */
export type Fsmb_BioCms_SpecialtiesArgs = {
  distinct_on?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Specialty_Order_By>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


/** columns and relationships of "fsmb_bio" */
export type Fsmb_BioCms_Specialties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Specialty_Order_By>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


/** columns and relationships of "fsmb_bio" */
export type Fsmb_BioLicensesArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Licensure_Order_By>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};


/** columns and relationships of "fsmb_bio" */
export type Fsmb_BioLicenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Licensure_Order_By>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};

/** aggregated selection of "fsmb_bio" */
export type Fsmb_Bio_Aggregate = {
  __typename?: 'fsmb_bio_aggregate';
  aggregate: Maybe<Fsmb_Bio_Aggregate_Fields>;
  nodes: Array<Fsmb_Bio>;
};

/** aggregate fields of "fsmb_bio" */
export type Fsmb_Bio_Aggregate_Fields = {
  __typename?: 'fsmb_bio_aggregate_fields';
  avg: Maybe<Fsmb_Bio_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Fsmb_Bio_Max_Fields>;
  min: Maybe<Fsmb_Bio_Min_Fields>;
  stddev: Maybe<Fsmb_Bio_Stddev_Fields>;
  stddev_pop: Maybe<Fsmb_Bio_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Fsmb_Bio_Stddev_Samp_Fields>;
  sum: Maybe<Fsmb_Bio_Sum_Fields>;
  var_pop: Maybe<Fsmb_Bio_Var_Pop_Fields>;
  var_samp: Maybe<Fsmb_Bio_Var_Samp_Fields>;
  variance: Maybe<Fsmb_Bio_Variance_Fields>;
};


/** aggregate fields of "fsmb_bio" */
export type Fsmb_Bio_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fsmb_Bio_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fsmb_Bio_Avg_Fields = {
  __typename?: 'fsmb_bio_avg_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fsmb_bio". All fields are combined with a logical 'AND'. */
export type Fsmb_Bio_Bool_Exp = {
  _and?: InputMaybe<Array<Fsmb_Bio_Bool_Exp>>;
  _not?: InputMaybe<Fsmb_Bio_Bool_Exp>;
  _or?: InputMaybe<Array<Fsmb_Bio_Bool_Exp>>;
  board_action_flag?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  cms_specialties?: InputMaybe<Cms_Specialty_Bool_Exp>;
  cms_specialties_aggregate?: InputMaybe<Cms_Specialty_Aggregate_Bool_Exp>;
  fid?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  graduation_year?: InputMaybe<Int_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  licenses?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
  licenses_aggregate?: InputMaybe<Fsmb_Licensure_Aggregate_Bool_Exp>;
  medical_school_name?: InputMaybe<String_Comparison_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  npi?: InputMaybe<String_Comparison_Exp>;
  npi_active_flag?: InputMaybe<Boolean_Comparison_Exp>;
  npi_entity_type?: InputMaybe<String_Comparison_Exp>;
  practitioner_type?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  suffix?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fsmb_bio" */
export enum Fsmb_Bio_Constraint {
  /** unique or primary key constraint on columns "fid" */
  PkFsmbBio = 'pk_fsmb_bio'
}

/** input type for incrementing numeric columns in table "fsmb_bio" */
export type Fsmb_Bio_Inc_Input = {
  graduation_year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "fsmb_bio" */
export type Fsmb_Bio_Insert_Input = {
  board_action_flag?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  cms_specialties?: InputMaybe<Cms_Specialty_Arr_Rel_Insert_Input>;
  fid?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Fsmb_Licensure_Arr_Rel_Insert_Input>;
  medical_school_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  npi_active_flag?: InputMaybe<Scalars['Boolean']>;
  npi_entity_type?: InputMaybe<Scalars['String']>;
  practitioner_type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Fsmb_Bio_Max_Fields = {
  __typename?: 'fsmb_bio_max_fields';
  city: Maybe<Scalars['String']>;
  fid: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  gender: Maybe<Scalars['String']>;
  graduation_year: Maybe<Scalars['Int']>;
  last_name: Maybe<Scalars['String']>;
  medical_school_name: Maybe<Scalars['String']>;
  middle_name: Maybe<Scalars['String']>;
  npi: Maybe<Scalars['String']>;
  npi_entity_type: Maybe<Scalars['String']>;
  practitioner_type: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  suffix: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fsmb_Bio_Min_Fields = {
  __typename?: 'fsmb_bio_min_fields';
  city: Maybe<Scalars['String']>;
  fid: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  gender: Maybe<Scalars['String']>;
  graduation_year: Maybe<Scalars['Int']>;
  last_name: Maybe<Scalars['String']>;
  medical_school_name: Maybe<Scalars['String']>;
  middle_name: Maybe<Scalars['String']>;
  npi: Maybe<Scalars['String']>;
  npi_entity_type: Maybe<Scalars['String']>;
  practitioner_type: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  suffix: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "fsmb_bio" */
export type Fsmb_Bio_Mutation_Response = {
  __typename?: 'fsmb_bio_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fsmb_Bio>;
};

/** input type for inserting object relation for remote table "fsmb_bio" */
export type Fsmb_Bio_Obj_Rel_Insert_Input = {
  data: Fsmb_Bio_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Fsmb_Bio_On_Conflict>;
};

/** on_conflict condition type for table "fsmb_bio" */
export type Fsmb_Bio_On_Conflict = {
  constraint: Fsmb_Bio_Constraint;
  update_columns?: Array<Fsmb_Bio_Update_Column>;
  where?: InputMaybe<Fsmb_Bio_Bool_Exp>;
};

/** Ordering options when selecting data from "fsmb_bio". */
export type Fsmb_Bio_Order_By = {
  board_action_flag?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cms_specialties_aggregate?: InputMaybe<Cms_Specialty_Aggregate_Order_By>;
  fid?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  graduation_year?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  licenses_aggregate?: InputMaybe<Fsmb_Licensure_Aggregate_Order_By>;
  medical_school_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  npi?: InputMaybe<Order_By>;
  npi_active_flag?: InputMaybe<Order_By>;
  npi_entity_type?: InputMaybe<Order_By>;
  practitioner_type?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  suffix?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fsmb_bio */
export type Fsmb_Bio_Pk_Columns_Input = {
  fid: Scalars['String'];
};

/** select columns of table "fsmb_bio" */
export enum Fsmb_Bio_Select_Column {
  /** column name */
  BoardActionFlag = 'board_action_flag',
  /** column name */
  City = 'city',
  /** column name */
  Fid = 'fid',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GraduationYear = 'graduation_year',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MedicalSchoolName = 'medical_school_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  Npi = 'npi',
  /** column name */
  NpiActiveFlag = 'npi_active_flag',
  /** column name */
  NpiEntityType = 'npi_entity_type',
  /** column name */
  PractitionerType = 'practitioner_type',
  /** column name */
  State = 'state',
  /** column name */
  Suffix = 'suffix',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "fsmb_bio" */
export type Fsmb_Bio_Set_Input = {
  board_action_flag?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  fid?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  medical_school_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  npi_active_flag?: InputMaybe<Scalars['Boolean']>;
  npi_entity_type?: InputMaybe<Scalars['String']>;
  practitioner_type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Fsmb_Bio_Stddev_Fields = {
  __typename?: 'fsmb_bio_stddev_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fsmb_Bio_Stddev_Pop_Fields = {
  __typename?: 'fsmb_bio_stddev_pop_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fsmb_Bio_Stddev_Samp_Fields = {
  __typename?: 'fsmb_bio_stddev_samp_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fsmb_bio" */
export type Fsmb_Bio_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fsmb_Bio_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fsmb_Bio_Stream_Cursor_Value_Input = {
  board_action_flag?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  fid?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  last_name?: InputMaybe<Scalars['String']>;
  medical_school_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
  npi_active_flag?: InputMaybe<Scalars['Boolean']>;
  npi_entity_type?: InputMaybe<Scalars['String']>;
  practitioner_type?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fsmb_Bio_Sum_Fields = {
  __typename?: 'fsmb_bio_sum_fields';
  graduation_year: Maybe<Scalars['Int']>;
};

/** update columns of table "fsmb_bio" */
export enum Fsmb_Bio_Update_Column {
  /** column name */
  BoardActionFlag = 'board_action_flag',
  /** column name */
  City = 'city',
  /** column name */
  Fid = 'fid',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  GraduationYear = 'graduation_year',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MedicalSchoolName = 'medical_school_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  Npi = 'npi',
  /** column name */
  NpiActiveFlag = 'npi_active_flag',
  /** column name */
  NpiEntityType = 'npi_entity_type',
  /** column name */
  PractitionerType = 'practitioner_type',
  /** column name */
  State = 'state',
  /** column name */
  Suffix = 'suffix',
  /** column name */
  Zipcode = 'zipcode'
}

export type Fsmb_Bio_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fsmb_Bio_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fsmb_Bio_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fsmb_Bio_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fsmb_Bio_Var_Pop_Fields = {
  __typename?: 'fsmb_bio_var_pop_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fsmb_Bio_Var_Samp_Fields = {
  __typename?: 'fsmb_bio_var_samp_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fsmb_Bio_Variance_Fields = {
  __typename?: 'fsmb_bio_variance_fields';
  graduation_year: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fsmb_licensure" */
export type Fsmb_Licensure = {
  __typename?: 'fsmb_licensure';
  /** A computed field, executes function "fsmb_licensure_active" */
  active: Maybe<Scalars['Boolean']>;
  active_flag: Scalars['Boolean'];
  entity: Scalars['String'];
  expiry_date: Maybe<Scalars['date']>;
  fid: Scalars['String'];
  id: Scalars['uuid'];
  issue_date: Maybe<Scalars['date']>;
  license_no: Scalars['String'];
  report_date: Maybe<Scalars['date']>;
  state: Scalars['String'];
};

/** aggregated selection of "fsmb_licensure" */
export type Fsmb_Licensure_Aggregate = {
  __typename?: 'fsmb_licensure_aggregate';
  aggregate: Maybe<Fsmb_Licensure_Aggregate_Fields>;
  nodes: Array<Fsmb_Licensure>;
};

export type Fsmb_Licensure_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Fsmb_Licensure_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Fsmb_Licensure_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Fsmb_Licensure_Aggregate_Bool_Exp_Count>;
};

export type Fsmb_Licensure_Aggregate_Bool_Exp_Bool_And = {
  arguments: Fsmb_Licensure_Select_Column_Fsmb_Licensure_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fsmb_Licensure_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Fsmb_Licensure_Select_Column_Fsmb_Licensure_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Fsmb_Licensure_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fsmb_licensure" */
export type Fsmb_Licensure_Aggregate_Fields = {
  __typename?: 'fsmb_licensure_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Fsmb_Licensure_Max_Fields>;
  min: Maybe<Fsmb_Licensure_Min_Fields>;
};


/** aggregate fields of "fsmb_licensure" */
export type Fsmb_Licensure_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fsmb_licensure" */
export type Fsmb_Licensure_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fsmb_Licensure_Max_Order_By>;
  min?: InputMaybe<Fsmb_Licensure_Min_Order_By>;
};

/** input type for inserting array relation for remote table "fsmb_licensure" */
export type Fsmb_Licensure_Arr_Rel_Insert_Input = {
  data: Array<Fsmb_Licensure_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Fsmb_Licensure_On_Conflict>;
};

/** Boolean expression to filter rows from the table "fsmb_licensure". All fields are combined with a logical 'AND'. */
export type Fsmb_Licensure_Bool_Exp = {
  _and?: InputMaybe<Array<Fsmb_Licensure_Bool_Exp>>;
  _not?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
  _or?: InputMaybe<Array<Fsmb_Licensure_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  active_flag?: InputMaybe<Boolean_Comparison_Exp>;
  entity?: InputMaybe<String_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  fid?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  issue_date?: InputMaybe<Date_Comparison_Exp>;
  license_no?: InputMaybe<String_Comparison_Exp>;
  report_date?: InputMaybe<Date_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "fsmb_licensure" */
export enum Fsmb_Licensure_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkFsmbLicensure = 'pk_fsmb_licensure'
}

/** input type for inserting data into table "fsmb_licensure" */
export type Fsmb_Licensure_Insert_Input = {
  active_flag?: InputMaybe<Scalars['Boolean']>;
  entity?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  fid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  issue_date?: InputMaybe<Scalars['date']>;
  license_no?: InputMaybe<Scalars['String']>;
  report_date?: InputMaybe<Scalars['date']>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Fsmb_Licensure_Max_Fields = {
  __typename?: 'fsmb_licensure_max_fields';
  entity: Maybe<Scalars['String']>;
  expiry_date: Maybe<Scalars['date']>;
  fid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  issue_date: Maybe<Scalars['date']>;
  license_no: Maybe<Scalars['String']>;
  report_date: Maybe<Scalars['date']>;
  state: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fsmb_licensure" */
export type Fsmb_Licensure_Max_Order_By = {
  entity?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  fid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  license_no?: InputMaybe<Order_By>;
  report_date?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fsmb_Licensure_Min_Fields = {
  __typename?: 'fsmb_licensure_min_fields';
  entity: Maybe<Scalars['String']>;
  expiry_date: Maybe<Scalars['date']>;
  fid: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  issue_date: Maybe<Scalars['date']>;
  license_no: Maybe<Scalars['String']>;
  report_date: Maybe<Scalars['date']>;
  state: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fsmb_licensure" */
export type Fsmb_Licensure_Min_Order_By = {
  entity?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  fid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  license_no?: InputMaybe<Order_By>;
  report_date?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fsmb_licensure" */
export type Fsmb_Licensure_Mutation_Response = {
  __typename?: 'fsmb_licensure_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fsmb_Licensure>;
};

/** on_conflict condition type for table "fsmb_licensure" */
export type Fsmb_Licensure_On_Conflict = {
  constraint: Fsmb_Licensure_Constraint;
  update_columns?: Array<Fsmb_Licensure_Update_Column>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};

/** Ordering options when selecting data from "fsmb_licensure". */
export type Fsmb_Licensure_Order_By = {
  active?: InputMaybe<Order_By>;
  active_flag?: InputMaybe<Order_By>;
  entity?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  fid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  license_no?: InputMaybe<Order_By>;
  report_date?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fsmb_licensure */
export type Fsmb_Licensure_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "fsmb_licensure" */
export enum Fsmb_Licensure_Select_Column {
  /** column name */
  ActiveFlag = 'active_flag',
  /** column name */
  Entity = 'entity',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Fid = 'fid',
  /** column name */
  Id = 'id',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LicenseNo = 'license_no',
  /** column name */
  ReportDate = 'report_date',
  /** column name */
  State = 'state'
}

/** select "fsmb_licensure_aggregate_bool_exp_bool_and_arguments_columns" columns of table "fsmb_licensure" */
export enum Fsmb_Licensure_Select_Column_Fsmb_Licensure_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActiveFlag = 'active_flag'
}

/** select "fsmb_licensure_aggregate_bool_exp_bool_or_arguments_columns" columns of table "fsmb_licensure" */
export enum Fsmb_Licensure_Select_Column_Fsmb_Licensure_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActiveFlag = 'active_flag'
}

/** input type for updating data in table "fsmb_licensure" */
export type Fsmb_Licensure_Set_Input = {
  active_flag?: InputMaybe<Scalars['Boolean']>;
  entity?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  fid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  issue_date?: InputMaybe<Scalars['date']>;
  license_no?: InputMaybe<Scalars['String']>;
  report_date?: InputMaybe<Scalars['date']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "fsmb_licensure" */
export type Fsmb_Licensure_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fsmb_Licensure_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fsmb_Licensure_Stream_Cursor_Value_Input = {
  active_flag?: InputMaybe<Scalars['Boolean']>;
  entity?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  fid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  issue_date?: InputMaybe<Scalars['date']>;
  license_no?: InputMaybe<Scalars['String']>;
  report_date?: InputMaybe<Scalars['date']>;
  state?: InputMaybe<Scalars['String']>;
};

/** update columns of table "fsmb_licensure" */
export enum Fsmb_Licensure_Update_Column {
  /** column name */
  ActiveFlag = 'active_flag',
  /** column name */
  Entity = 'entity',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Fid = 'fid',
  /** column name */
  Id = 'id',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  LicenseNo = 'license_no',
  /** column name */
  ReportDate = 'report_date',
  /** column name */
  State = 'state'
}

export type Fsmb_Licensure_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fsmb_Licensure_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fsmb_Licensure_Bool_Exp;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "gmaps_link" */
export type Gmaps_Link = {
  __typename?: 'gmaps_link';
  center: Scalars['geometry'];
  /** An array relationship */
  facilities_in_city: Array<Facility>;
  /** An aggregate relationship */
  facilities_in_city_aggregate: Facility_Aggregate;
  /** An array relationship */
  facilities_in_state: Array<Facility>;
  /** An aggregate relationship */
  facilities_in_state_aggregate: Facility_Aggregate;
  /** An object relationship */
  gmaps_place: Gmaps_Place;
  gmaps_place_id: Scalars['String'];
  id: Scalars['uuid'];
  label: Scalars['String'];
  last_refreshed: Maybe<Scalars['timestamp']>;
  slug: Scalars['String'];
  /** An array relationship */
  types: Array<Gmaps_Link_Type>;
  /** An aggregate relationship */
  types_aggregate: Gmaps_Link_Type_Aggregate;
  viewport: Scalars['geometry'];
};


/** columns and relationships of "gmaps_link" */
export type Gmaps_LinkFacilities_In_CityArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "gmaps_link" */
export type Gmaps_LinkFacilities_In_City_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "gmaps_link" */
export type Gmaps_LinkFacilities_In_StateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "gmaps_link" */
export type Gmaps_LinkFacilities_In_State_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** columns and relationships of "gmaps_link" */
export type Gmaps_LinkTypesArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Type_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};


/** columns and relationships of "gmaps_link" */
export type Gmaps_LinkTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Type_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};

/** aggregated selection of "gmaps_link" */
export type Gmaps_Link_Aggregate = {
  __typename?: 'gmaps_link_aggregate';
  aggregate: Maybe<Gmaps_Link_Aggregate_Fields>;
  nodes: Array<Gmaps_Link>;
};

/** aggregate fields of "gmaps_link" */
export type Gmaps_Link_Aggregate_Fields = {
  __typename?: 'gmaps_link_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Gmaps_Link_Max_Fields>;
  min: Maybe<Gmaps_Link_Min_Fields>;
};


/** aggregate fields of "gmaps_link" */
export type Gmaps_Link_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gmaps_Link_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "gmaps_link". All fields are combined with a logical 'AND'. */
export type Gmaps_Link_Bool_Exp = {
  _and?: InputMaybe<Array<Gmaps_Link_Bool_Exp>>;
  _not?: InputMaybe<Gmaps_Link_Bool_Exp>;
  _or?: InputMaybe<Array<Gmaps_Link_Bool_Exp>>;
  center?: InputMaybe<Geometry_Comparison_Exp>;
  facilities_in_city?: InputMaybe<Facility_Bool_Exp>;
  facilities_in_city_aggregate?: InputMaybe<Facility_Aggregate_Bool_Exp>;
  facilities_in_state?: InputMaybe<Facility_Bool_Exp>;
  facilities_in_state_aggregate?: InputMaybe<Facility_Aggregate_Bool_Exp>;
  gmaps_place?: InputMaybe<Gmaps_Place_Bool_Exp>;
  gmaps_place_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  last_refreshed?: InputMaybe<Timestamp_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  types?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
  types_aggregate?: InputMaybe<Gmaps_Link_Type_Aggregate_Bool_Exp>;
  viewport?: InputMaybe<Geometry_Comparison_Exp>;
};

/** unique or primary key constraints on table "gmaps_link" */
export enum Gmaps_Link_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkGmapsLink = 'pk_gmaps_link',
  /** unique or primary key constraint on columns "gmaps_place_id" */
  UqGmapsLinkGmapsPlaceId = 'uq_gmaps_link_gmaps_place_id',
  /** unique or primary key constraint on columns "slug" */
  UqGmapsLinkSlug = 'uq_gmaps_link_slug'
}

/** input type for inserting data into table "gmaps_link" */
export type Gmaps_Link_Insert_Input = {
  center?: InputMaybe<Scalars['geometry']>;
  facilities_in_city?: InputMaybe<Facility_Arr_Rel_Insert_Input>;
  facilities_in_state?: InputMaybe<Facility_Arr_Rel_Insert_Input>;
  gmaps_place?: InputMaybe<Gmaps_Place_Obj_Rel_Insert_Input>;
  gmaps_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  last_refreshed?: InputMaybe<Scalars['timestamp']>;
  slug?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Gmaps_Link_Type_Arr_Rel_Insert_Input>;
  viewport?: InputMaybe<Scalars['geometry']>;
};

/** aggregate max on columns */
export type Gmaps_Link_Max_Fields = {
  __typename?: 'gmaps_link_max_fields';
  gmaps_place_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  label: Maybe<Scalars['String']>;
  last_refreshed: Maybe<Scalars['timestamp']>;
  slug: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Gmaps_Link_Min_Fields = {
  __typename?: 'gmaps_link_min_fields';
  gmaps_place_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  label: Maybe<Scalars['String']>;
  last_refreshed: Maybe<Scalars['timestamp']>;
  slug: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "gmaps_link" */
export type Gmaps_Link_Mutation_Response = {
  __typename?: 'gmaps_link_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gmaps_Link>;
};

/** input type for inserting object relation for remote table "gmaps_link" */
export type Gmaps_Link_Obj_Rel_Insert_Input = {
  data: Gmaps_Link_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gmaps_Link_On_Conflict>;
};

/** on_conflict condition type for table "gmaps_link" */
export type Gmaps_Link_On_Conflict = {
  constraint: Gmaps_Link_Constraint;
  update_columns?: Array<Gmaps_Link_Update_Column>;
  where?: InputMaybe<Gmaps_Link_Bool_Exp>;
};

/** Ordering options when selecting data from "gmaps_link". */
export type Gmaps_Link_Order_By = {
  center?: InputMaybe<Order_By>;
  facilities_in_city_aggregate?: InputMaybe<Facility_Aggregate_Order_By>;
  facilities_in_state_aggregate?: InputMaybe<Facility_Aggregate_Order_By>;
  gmaps_place?: InputMaybe<Gmaps_Place_Order_By>;
  gmaps_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  last_refreshed?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  types_aggregate?: InputMaybe<Gmaps_Link_Type_Aggregate_Order_By>;
  viewport?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gmaps_link */
export type Gmaps_Link_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "gmaps_link" */
export enum Gmaps_Link_Select_Column {
  /** column name */
  Center = 'center',
  /** column name */
  GmapsPlaceId = 'gmaps_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  LastRefreshed = 'last_refreshed',
  /** column name */
  Slug = 'slug',
  /** column name */
  Viewport = 'viewport'
}

/** input type for updating data in table "gmaps_link" */
export type Gmaps_Link_Set_Input = {
  center?: InputMaybe<Scalars['geometry']>;
  gmaps_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  last_refreshed?: InputMaybe<Scalars['timestamp']>;
  slug?: InputMaybe<Scalars['String']>;
  viewport?: InputMaybe<Scalars['geometry']>;
};

/** Streaming cursor of the table "gmaps_link" */
export type Gmaps_Link_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gmaps_Link_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gmaps_Link_Stream_Cursor_Value_Input = {
  center?: InputMaybe<Scalars['geometry']>;
  gmaps_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  label?: InputMaybe<Scalars['String']>;
  last_refreshed?: InputMaybe<Scalars['timestamp']>;
  slug?: InputMaybe<Scalars['String']>;
  viewport?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "gmaps_link_type" */
export type Gmaps_Link_Type = {
  __typename?: 'gmaps_link_type';
  /** An object relationship */
  gmaps_link: Gmaps_Link;
  gmaps_link_id: Scalars['uuid'];
  id: Scalars['uuid'];
  type: Scalars['String'];
};

/** aggregated selection of "gmaps_link_type" */
export type Gmaps_Link_Type_Aggregate = {
  __typename?: 'gmaps_link_type_aggregate';
  aggregate: Maybe<Gmaps_Link_Type_Aggregate_Fields>;
  nodes: Array<Gmaps_Link_Type>;
};

export type Gmaps_Link_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Gmaps_Link_Type_Aggregate_Bool_Exp_Count>;
};

export type Gmaps_Link_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "gmaps_link_type" */
export type Gmaps_Link_Type_Aggregate_Fields = {
  __typename?: 'gmaps_link_type_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Gmaps_Link_Type_Max_Fields>;
  min: Maybe<Gmaps_Link_Type_Min_Fields>;
};


/** aggregate fields of "gmaps_link_type" */
export type Gmaps_Link_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gmaps_link_type" */
export type Gmaps_Link_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gmaps_Link_Type_Max_Order_By>;
  min?: InputMaybe<Gmaps_Link_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "gmaps_link_type" */
export type Gmaps_Link_Type_Arr_Rel_Insert_Input = {
  data: Array<Gmaps_Link_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Gmaps_Link_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "gmaps_link_type". All fields are combined with a logical 'AND'. */
export type Gmaps_Link_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Gmaps_Link_Type_Bool_Exp>>;
  _not?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Gmaps_Link_Type_Bool_Exp>>;
  gmaps_link?: InputMaybe<Gmaps_Link_Bool_Exp>;
  gmaps_link_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "gmaps_link_type" */
export enum Gmaps_Link_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkGmapsLinkType = 'pk_gmaps_link_type',
  /** unique or primary key constraint on columns "type", "gmaps_link_id" */
  UqGmapsLinkTypeGmapsLinkIdType = 'uq_gmaps_link_type_gmaps_link_id_type'
}

/** input type for inserting data into table "gmaps_link_type" */
export type Gmaps_Link_Type_Insert_Input = {
  gmaps_link?: InputMaybe<Gmaps_Link_Obj_Rel_Insert_Input>;
  gmaps_link_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Gmaps_Link_Type_Max_Fields = {
  __typename?: 'gmaps_link_type_max_fields';
  gmaps_link_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "gmaps_link_type" */
export type Gmaps_Link_Type_Max_Order_By = {
  gmaps_link_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gmaps_Link_Type_Min_Fields = {
  __typename?: 'gmaps_link_type_min_fields';
  gmaps_link_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "gmaps_link_type" */
export type Gmaps_Link_Type_Min_Order_By = {
  gmaps_link_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "gmaps_link_type" */
export type Gmaps_Link_Type_Mutation_Response = {
  __typename?: 'gmaps_link_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gmaps_Link_Type>;
};

/** on_conflict condition type for table "gmaps_link_type" */
export type Gmaps_Link_Type_On_Conflict = {
  constraint: Gmaps_Link_Type_Constraint;
  update_columns?: Array<Gmaps_Link_Type_Update_Column>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "gmaps_link_type". */
export type Gmaps_Link_Type_Order_By = {
  gmaps_link?: InputMaybe<Gmaps_Link_Order_By>;
  gmaps_link_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gmaps_link_type */
export type Gmaps_Link_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "gmaps_link_type" */
export enum Gmaps_Link_Type_Select_Column {
  /** column name */
  GmapsLinkId = 'gmaps_link_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "gmaps_link_type" */
export type Gmaps_Link_Type_Set_Input = {
  gmaps_link_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "gmaps_link_type" */
export type Gmaps_Link_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gmaps_Link_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gmaps_Link_Type_Stream_Cursor_Value_Input = {
  gmaps_link_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "gmaps_link_type" */
export enum Gmaps_Link_Type_Update_Column {
  /** column name */
  GmapsLinkId = 'gmaps_link_id',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

export type Gmaps_Link_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gmaps_Link_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gmaps_Link_Type_Bool_Exp;
};

/** update columns of table "gmaps_link" */
export enum Gmaps_Link_Update_Column {
  /** column name */
  Center = 'center',
  /** column name */
  GmapsPlaceId = 'gmaps_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  LastRefreshed = 'last_refreshed',
  /** column name */
  Slug = 'slug',
  /** column name */
  Viewport = 'viewport'
}

export type Gmaps_Link_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gmaps_Link_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gmaps_Link_Bool_Exp;
};

/** columns and relationships of "gmaps_place" */
export type Gmaps_Place = {
  __typename?: 'gmaps_place';
  /** An array relationship */
  boundaries: Array<Place_Boundary>;
  /** An aggregate relationship */
  boundaries_aggregate: Place_Boundary_Aggregate;
  details: Maybe<Scalars['jsonb']>;
  details_updated_at: Maybe<Scalars['timestamp']>;
  geocode: Maybe<Scalars['jsonb']>;
  geocode_public: Maybe<Scalars['jsonb']>;
  geocode_short_name: Maybe<Scalars['String']>;
  geocode_updated_at: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  gmaps_link: Maybe<Gmaps_Link>;
  id: Scalars['String'];
  last_refreshed: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "gmaps_place" */
export type Gmaps_PlaceBoundariesArgs = {
  distinct_on?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Place_Boundary_Order_By>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


/** columns and relationships of "gmaps_place" */
export type Gmaps_PlaceBoundaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Place_Boundary_Order_By>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


/** columns and relationships of "gmaps_place" */
export type Gmaps_PlaceDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "gmaps_place" */
export type Gmaps_PlaceGeocodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "gmaps_place" */
export type Gmaps_PlaceGeocode_PublicArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "gmaps_place" */
export type Gmaps_Place_Aggregate = {
  __typename?: 'gmaps_place_aggregate';
  aggregate: Maybe<Gmaps_Place_Aggregate_Fields>;
  nodes: Array<Gmaps_Place>;
};

/** aggregate fields of "gmaps_place" */
export type Gmaps_Place_Aggregate_Fields = {
  __typename?: 'gmaps_place_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Gmaps_Place_Max_Fields>;
  min: Maybe<Gmaps_Place_Min_Fields>;
};


/** aggregate fields of "gmaps_place" */
export type Gmaps_Place_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gmaps_Place_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Gmaps_Place_Append_Input = {
  details?: InputMaybe<Scalars['jsonb']>;
  geocode?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "gmaps_place". All fields are combined with a logical 'AND'. */
export type Gmaps_Place_Bool_Exp = {
  _and?: InputMaybe<Array<Gmaps_Place_Bool_Exp>>;
  _not?: InputMaybe<Gmaps_Place_Bool_Exp>;
  _or?: InputMaybe<Array<Gmaps_Place_Bool_Exp>>;
  boundaries?: InputMaybe<Place_Boundary_Bool_Exp>;
  boundaries_aggregate?: InputMaybe<Place_Boundary_Aggregate_Bool_Exp>;
  details?: InputMaybe<Jsonb_Comparison_Exp>;
  details_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  geocode?: InputMaybe<Jsonb_Comparison_Exp>;
  geocode_public?: InputMaybe<Jsonb_Comparison_Exp>;
  geocode_short_name?: InputMaybe<String_Comparison_Exp>;
  geocode_updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  gmaps_link?: InputMaybe<Gmaps_Link_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_refreshed?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "gmaps_place" */
export enum Gmaps_Place_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkGmapsPlace = 'pk_gmaps_place'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Gmaps_Place_Delete_At_Path_Input = {
  details?: InputMaybe<Array<Scalars['String']>>;
  geocode?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Gmaps_Place_Delete_Elem_Input = {
  details?: InputMaybe<Scalars['Int']>;
  geocode?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Gmaps_Place_Delete_Key_Input = {
  details?: InputMaybe<Scalars['String']>;
  geocode?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "gmaps_place" */
export type Gmaps_Place_Insert_Input = {
  boundaries?: InputMaybe<Place_Boundary_Arr_Rel_Insert_Input>;
  details?: InputMaybe<Scalars['jsonb']>;
  details_updated_at?: InputMaybe<Scalars['timestamp']>;
  geocode?: InputMaybe<Scalars['jsonb']>;
  geocode_updated_at?: InputMaybe<Scalars['timestamp']>;
  gmaps_link?: InputMaybe<Gmaps_Link_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  last_refreshed?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Gmaps_Place_Max_Fields = {
  __typename?: 'gmaps_place_max_fields';
  details_updated_at: Maybe<Scalars['timestamp']>;
  geocode_short_name: Maybe<Scalars['String']>;
  geocode_updated_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['String']>;
  last_refreshed: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Gmaps_Place_Min_Fields = {
  __typename?: 'gmaps_place_min_fields';
  details_updated_at: Maybe<Scalars['timestamp']>;
  geocode_short_name: Maybe<Scalars['String']>;
  geocode_updated_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['String']>;
  last_refreshed: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "gmaps_place" */
export type Gmaps_Place_Mutation_Response = {
  __typename?: 'gmaps_place_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Gmaps_Place>;
};

/** input type for inserting object relation for remote table "gmaps_place" */
export type Gmaps_Place_Obj_Rel_Insert_Input = {
  data: Gmaps_Place_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Gmaps_Place_On_Conflict>;
};

/** on_conflict condition type for table "gmaps_place" */
export type Gmaps_Place_On_Conflict = {
  constraint: Gmaps_Place_Constraint;
  update_columns?: Array<Gmaps_Place_Update_Column>;
  where?: InputMaybe<Gmaps_Place_Bool_Exp>;
};

/** Ordering options when selecting data from "gmaps_place". */
export type Gmaps_Place_Order_By = {
  boundaries_aggregate?: InputMaybe<Place_Boundary_Aggregate_Order_By>;
  details?: InputMaybe<Order_By>;
  details_updated_at?: InputMaybe<Order_By>;
  geocode?: InputMaybe<Order_By>;
  geocode_public?: InputMaybe<Order_By>;
  geocode_short_name?: InputMaybe<Order_By>;
  geocode_updated_at?: InputMaybe<Order_By>;
  gmaps_link?: InputMaybe<Gmaps_Link_Order_By>;
  id?: InputMaybe<Order_By>;
  last_refreshed?: InputMaybe<Order_By>;
};

/** primary key columns input for table: gmaps_place */
export type Gmaps_Place_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Gmaps_Place_Prepend_Input = {
  details?: InputMaybe<Scalars['jsonb']>;
  geocode?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "gmaps_place" */
export enum Gmaps_Place_Select_Column {
  /** column name */
  Details = 'details',
  /** column name */
  DetailsUpdatedAt = 'details_updated_at',
  /** column name */
  Geocode = 'geocode',
  /** column name */
  GeocodePublic = 'geocode_public',
  /** column name */
  GeocodeShortName = 'geocode_short_name',
  /** column name */
  GeocodeUpdatedAt = 'geocode_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastRefreshed = 'last_refreshed'
}

/** input type for updating data in table "gmaps_place" */
export type Gmaps_Place_Set_Input = {
  details?: InputMaybe<Scalars['jsonb']>;
  details_updated_at?: InputMaybe<Scalars['timestamp']>;
  geocode?: InputMaybe<Scalars['jsonb']>;
  geocode_updated_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  last_refreshed?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "gmaps_place" */
export type Gmaps_Place_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gmaps_Place_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gmaps_Place_Stream_Cursor_Value_Input = {
  details?: InputMaybe<Scalars['jsonb']>;
  details_updated_at?: InputMaybe<Scalars['timestamp']>;
  geocode?: InputMaybe<Scalars['jsonb']>;
  geocode_public?: InputMaybe<Scalars['jsonb']>;
  geocode_short_name?: InputMaybe<Scalars['String']>;
  geocode_updated_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  last_refreshed?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "gmaps_place" */
export enum Gmaps_Place_Update_Column {
  /** column name */
  Details = 'details',
  /** column name */
  DetailsUpdatedAt = 'details_updated_at',
  /** column name */
  Geocode = 'geocode',
  /** column name */
  GeocodeUpdatedAt = 'geocode_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastRefreshed = 'last_refreshed'
}

export type Gmaps_Place_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Gmaps_Place_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Gmaps_Place_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Gmaps_Place_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Gmaps_Place_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Gmaps_Place_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Gmaps_Place_Set_Input>;
  /** filter the rows which have to be updated */
  where: Gmaps_Place_Bool_Exp;
};

export type Has_Recent_Messages_Candidate_Args = {
  cutoff?: InputMaybe<Scalars['interval']>;
};

/** columns and relationships of "identity_provider" */
export type Identity_Provider = {
  __typename?: 'identity_provider';
  default_return_to: Scalars['String'];
  display_name: Scalars['String'];
  email_field: Scalars['String'];
  email_field_alt: Scalars['String'];
  external_id_field: Scalars['String'];
  first_name_field: Scalars['String'];
  id: Scalars['uuid'];
  issuer: Scalars['String'];
  last_name_field: Scalars['String'];
  name: Scalars['String'];
  platform: Scalars['platform'];
  return_to_domains: Array<Scalars['String']>;
  settings: Scalars['jsonb'];
};


/** columns and relationships of "identity_provider" */
export type Identity_ProviderSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "identity_provider" */
export type Identity_Provider_Aggregate = {
  __typename?: 'identity_provider_aggregate';
  aggregate: Maybe<Identity_Provider_Aggregate_Fields>;
  nodes: Array<Identity_Provider>;
};

/** aggregate fields of "identity_provider" */
export type Identity_Provider_Aggregate_Fields = {
  __typename?: 'identity_provider_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Identity_Provider_Max_Fields>;
  min: Maybe<Identity_Provider_Min_Fields>;
};


/** aggregate fields of "identity_provider" */
export type Identity_Provider_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Identity_Provider_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Identity_Provider_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "identity_provider". All fields are combined with a logical 'AND'. */
export type Identity_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Identity_Provider_Bool_Exp>>;
  _not?: InputMaybe<Identity_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Identity_Provider_Bool_Exp>>;
  default_return_to?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email_field?: InputMaybe<String_Comparison_Exp>;
  email_field_alt?: InputMaybe<String_Comparison_Exp>;
  external_id_field?: InputMaybe<String_Comparison_Exp>;
  first_name_field?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  issuer?: InputMaybe<String_Comparison_Exp>;
  last_name_field?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<Platform_Comparison_Exp>;
  return_to_domains?: InputMaybe<String_Array_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "identity_provider" */
export enum Identity_Provider_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkIdentityProvider = 'pk_identity_provider',
  /** unique or primary key constraint on columns "display_name" */
  UqIdentityProviderDisplayName = 'uq_identity_provider_display_name',
  /** unique or primary key constraint on columns "issuer" */
  UqIdentityProviderIssuer = 'uq_identity_provider_issuer',
  /** unique or primary key constraint on columns "name" */
  UqIdentityProviderName = 'uq_identity_provider_name'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Identity_Provider_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Identity_Provider_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Identity_Provider_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "identity_provider" */
export type Identity_Provider_Insert_Input = {
  default_return_to?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  email_field?: InputMaybe<Scalars['String']>;
  email_field_alt?: InputMaybe<Scalars['String']>;
  external_id_field?: InputMaybe<Scalars['String']>;
  first_name_field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  issuer?: InputMaybe<Scalars['String']>;
  last_name_field?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['platform']>;
  return_to_domains?: InputMaybe<Array<Scalars['String']>>;
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Identity_Provider_Max_Fields = {
  __typename?: 'identity_provider_max_fields';
  default_return_to: Maybe<Scalars['String']>;
  display_name: Maybe<Scalars['String']>;
  email_field: Maybe<Scalars['String']>;
  email_field_alt: Maybe<Scalars['String']>;
  external_id_field: Maybe<Scalars['String']>;
  first_name_field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  issuer: Maybe<Scalars['String']>;
  last_name_field: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  platform: Maybe<Scalars['platform']>;
  return_to_domains: Maybe<Array<Scalars['String']>>;
};

/** aggregate min on columns */
export type Identity_Provider_Min_Fields = {
  __typename?: 'identity_provider_min_fields';
  default_return_to: Maybe<Scalars['String']>;
  display_name: Maybe<Scalars['String']>;
  email_field: Maybe<Scalars['String']>;
  email_field_alt: Maybe<Scalars['String']>;
  external_id_field: Maybe<Scalars['String']>;
  first_name_field: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  issuer: Maybe<Scalars['String']>;
  last_name_field: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  platform: Maybe<Scalars['platform']>;
  return_to_domains: Maybe<Array<Scalars['String']>>;
};

/** response of any mutation on the table "identity_provider" */
export type Identity_Provider_Mutation_Response = {
  __typename?: 'identity_provider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Identity_Provider>;
};

/** input type for inserting object relation for remote table "identity_provider" */
export type Identity_Provider_Obj_Rel_Insert_Input = {
  data: Identity_Provider_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Identity_Provider_On_Conflict>;
};

/** on_conflict condition type for table "identity_provider" */
export type Identity_Provider_On_Conflict = {
  constraint: Identity_Provider_Constraint;
  update_columns?: Array<Identity_Provider_Update_Column>;
  where?: InputMaybe<Identity_Provider_Bool_Exp>;
};

/** Ordering options when selecting data from "identity_provider". */
export type Identity_Provider_Order_By = {
  default_return_to?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_field?: InputMaybe<Order_By>;
  email_field_alt?: InputMaybe<Order_By>;
  external_id_field?: InputMaybe<Order_By>;
  first_name_field?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issuer?: InputMaybe<Order_By>;
  last_name_field?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  return_to_domains?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
};

/** primary key columns input for table: identity_provider */
export type Identity_Provider_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Identity_Provider_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "identity_provider" */
export enum Identity_Provider_Select_Column {
  /** column name */
  DefaultReturnTo = 'default_return_to',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailField = 'email_field',
  /** column name */
  EmailFieldAlt = 'email_field_alt',
  /** column name */
  ExternalIdField = 'external_id_field',
  /** column name */
  FirstNameField = 'first_name_field',
  /** column name */
  Id = 'id',
  /** column name */
  Issuer = 'issuer',
  /** column name */
  LastNameField = 'last_name_field',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  ReturnToDomains = 'return_to_domains',
  /** column name */
  Settings = 'settings'
}

/** input type for updating data in table "identity_provider" */
export type Identity_Provider_Set_Input = {
  default_return_to?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  email_field?: InputMaybe<Scalars['String']>;
  email_field_alt?: InputMaybe<Scalars['String']>;
  external_id_field?: InputMaybe<Scalars['String']>;
  first_name_field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  issuer?: InputMaybe<Scalars['String']>;
  last_name_field?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['platform']>;
  return_to_domains?: InputMaybe<Array<Scalars['String']>>;
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "identity_provider" */
export type Identity_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Identity_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Identity_Provider_Stream_Cursor_Value_Input = {
  default_return_to?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  email_field?: InputMaybe<Scalars['String']>;
  email_field_alt?: InputMaybe<Scalars['String']>;
  external_id_field?: InputMaybe<Scalars['String']>;
  first_name_field?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  issuer?: InputMaybe<Scalars['String']>;
  last_name_field?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['platform']>;
  return_to_domains?: InputMaybe<Array<Scalars['String']>>;
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "identity_provider" */
export enum Identity_Provider_Update_Column {
  /** column name */
  DefaultReturnTo = 'default_return_to',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailField = 'email_field',
  /** column name */
  EmailFieldAlt = 'email_field_alt',
  /** column name */
  ExternalIdField = 'external_id_field',
  /** column name */
  FirstNameField = 'first_name_field',
  /** column name */
  Id = 'id',
  /** column name */
  Issuer = 'issuer',
  /** column name */
  LastNameField = 'last_name_field',
  /** column name */
  Name = 'name',
  /** column name */
  Platform = 'platform',
  /** column name */
  ReturnToDomains = 'return_to_domains',
  /** column name */
  Settings = 'settings'
}

export type Identity_Provider_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Identity_Provider_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Identity_Provider_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Identity_Provider_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Identity_Provider_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Identity_Provider_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Identity_Provider_Set_Input>;
  /** filter the rows which have to be updated */
  where: Identity_Provider_Bool_Exp;
};

/** columns and relationships of "job_application" */
export type Job_Application = {
  __typename?: 'job_application';
  addon: Scalars['Boolean'];
  /** An object relationship */
  batch: Job_Application_Batch;
  batch_id: Scalars['uuid'];
  /** An object relationship */
  contract: Facility_Contract;
  contract_id: Scalars['uuid'];
  createdAtDate: Scalars['DateTime'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An array relationship */
  job_application_postings: Array<Job_Application_Posting>;
  /** An aggregate relationship */
  job_application_postings_aggregate: Job_Application_Posting_Aggregate;
};


/** columns and relationships of "job_application" */
export type Job_ApplicationJob_Application_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


/** columns and relationships of "job_application" */
export type Job_ApplicationJob_Application_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};

/** aggregated selection of "job_application" */
export type Job_Application_Aggregate = {
  __typename?: 'job_application_aggregate';
  aggregate: Maybe<Job_Application_Aggregate_Fields>;
  nodes: Array<Job_Application>;
};

export type Job_Application_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Job_Application_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Job_Application_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Job_Application_Aggregate_Bool_Exp_Count>;
};

export type Job_Application_Aggregate_Bool_Exp_Bool_And = {
  arguments: Job_Application_Select_Column_Job_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Application_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Job_Application_Select_Column_Job_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Application_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_application" */
export type Job_Application_Aggregate_Fields = {
  __typename?: 'job_application_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Job_Application_Max_Fields>;
  min: Maybe<Job_Application_Min_Fields>;
};


/** aggregate fields of "job_application" */
export type Job_Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_application" */
export type Job_Application_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Application_Max_Order_By>;
  min?: InputMaybe<Job_Application_Min_Order_By>;
};

/** input type for inserting array relation for remote table "job_application" */
export type Job_Application_Arr_Rel_Insert_Input = {
  data: Array<Job_Application_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Application_On_Conflict>;
};

/** columns and relationships of "job_application_batch" */
export type Job_Application_Batch = {
  __typename?: 'job_application_batch';
  /** An object relationship */
  candidate: Candidate;
  candidate_id: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  email_message_admin: Maybe<Email_Message>;
  email_message_admin_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  email_message_clinician: Maybe<Email_Message>;
  email_message_clinician_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  email_message_recruiter: Maybe<Email_Message>;
  email_message_recruiter_id: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  intro: Scalars['String'];
  /** An array relationship */
  job_applications: Array<Job_Application>;
  /** An aggregate relationship */
  job_applications_aggregate: Job_Application_Aggregate;
  legacy: Scalars['Boolean'];
  notes: Scalars['String'];
  /** An object relationship */
  recruiter: Org_User;
  recruiter_id: Scalars['uuid'];
};


/** columns and relationships of "job_application_batch" */
export type Job_Application_BatchJob_ApplicationsArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


/** columns and relationships of "job_application_batch" */
export type Job_Application_BatchJob_Applications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};

/** aggregated selection of "job_application_batch" */
export type Job_Application_Batch_Aggregate = {
  __typename?: 'job_application_batch_aggregate';
  aggregate: Maybe<Job_Application_Batch_Aggregate_Fields>;
  nodes: Array<Job_Application_Batch>;
};

export type Job_Application_Batch_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Job_Application_Batch_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Job_Application_Batch_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Job_Application_Batch_Aggregate_Bool_Exp_Count>;
};

export type Job_Application_Batch_Aggregate_Bool_Exp_Bool_And = {
  arguments: Job_Application_Batch_Select_Column_Job_Application_Batch_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Batch_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Application_Batch_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Job_Application_Batch_Select_Column_Job_Application_Batch_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Batch_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Application_Batch_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Batch_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_application_batch" */
export type Job_Application_Batch_Aggregate_Fields = {
  __typename?: 'job_application_batch_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Job_Application_Batch_Max_Fields>;
  min: Maybe<Job_Application_Batch_Min_Fields>;
};


/** aggregate fields of "job_application_batch" */
export type Job_Application_Batch_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_application_batch" */
export type Job_Application_Batch_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Application_Batch_Max_Order_By>;
  min?: InputMaybe<Job_Application_Batch_Min_Order_By>;
};

/** input type for inserting array relation for remote table "job_application_batch" */
export type Job_Application_Batch_Arr_Rel_Insert_Input = {
  data: Array<Job_Application_Batch_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Application_Batch_On_Conflict>;
};

/** Boolean expression to filter rows from the table "job_application_batch". All fields are combined with a logical 'AND'. */
export type Job_Application_Batch_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Application_Batch_Bool_Exp>>;
  _not?: InputMaybe<Job_Application_Batch_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Application_Batch_Bool_Exp>>;
  candidate?: InputMaybe<Candidate_Bool_Exp>;
  candidate_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  email_message_admin?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_message_clinician?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_clinician_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_message_recruiter?: InputMaybe<Email_Message_Bool_Exp>;
  email_message_recruiter_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  intro?: InputMaybe<String_Comparison_Exp>;
  job_applications?: InputMaybe<Job_Application_Bool_Exp>;
  job_applications_aggregate?: InputMaybe<Job_Application_Aggregate_Bool_Exp>;
  legacy?: InputMaybe<Boolean_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  recruiter?: InputMaybe<Org_User_Bool_Exp>;
  recruiter_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_application_batch" */
export enum Job_Application_Batch_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkJobApplicationBatch = 'pk_job_application_batch',
  /** unique or primary key constraint on columns "email_message_admin_id" */
  UqJobApplicationBatchEmailMessageAdminId = 'uq_job_application_batch_email_message_admin_id',
  /** unique or primary key constraint on columns "email_message_clinician_id" */
  UqJobApplicationBatchEmailMessageClinicianId = 'uq_job_application_batch_email_message_clinician_id',
  /** unique or primary key constraint on columns "email_message_recruiter_id" */
  UqJobApplicationBatchEmailMessageRecruiterId = 'uq_job_application_batch_email_message_recruiter_id'
}

/** input type for inserting data into table "job_application_batch" */
export type Job_Application_Batch_Insert_Input = {
  candidate?: InputMaybe<Candidate_Obj_Rel_Insert_Input>;
  candidate_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_message_admin?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_admin_id?: InputMaybe<Scalars['uuid']>;
  email_message_clinician?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_clinician_id?: InputMaybe<Scalars['uuid']>;
  email_message_recruiter?: InputMaybe<Email_Message_Obj_Rel_Insert_Input>;
  email_message_recruiter_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  intro?: InputMaybe<Scalars['String']>;
  job_applications?: InputMaybe<Job_Application_Arr_Rel_Insert_Input>;
  legacy?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  recruiter?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Job_Application_Batch_Max_Fields = {
  __typename?: 'job_application_batch_max_fields';
  candidate_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  email_message_admin_id: Maybe<Scalars['uuid']>;
  email_message_clinician_id: Maybe<Scalars['uuid']>;
  email_message_recruiter_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  intro: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  recruiter_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_application_batch" */
export type Job_Application_Batch_Max_Order_By = {
  candidate_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_message_admin_id?: InputMaybe<Order_By>;
  email_message_clinician_id?: InputMaybe<Order_By>;
  email_message_recruiter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intro?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Application_Batch_Min_Fields = {
  __typename?: 'job_application_batch_min_fields';
  candidate_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  email_message_admin_id: Maybe<Scalars['uuid']>;
  email_message_clinician_id: Maybe<Scalars['uuid']>;
  email_message_recruiter_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  intro: Maybe<Scalars['String']>;
  notes: Maybe<Scalars['String']>;
  recruiter_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_application_batch" */
export type Job_Application_Batch_Min_Order_By = {
  candidate_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_message_admin_id?: InputMaybe<Order_By>;
  email_message_clinician_id?: InputMaybe<Order_By>;
  email_message_recruiter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intro?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_application_batch" */
export type Job_Application_Batch_Mutation_Response = {
  __typename?: 'job_application_batch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Application_Batch>;
};

/** input type for inserting object relation for remote table "job_application_batch" */
export type Job_Application_Batch_Obj_Rel_Insert_Input = {
  data: Job_Application_Batch_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Application_Batch_On_Conflict>;
};

/** on_conflict condition type for table "job_application_batch" */
export type Job_Application_Batch_On_Conflict = {
  constraint: Job_Application_Batch_Constraint;
  update_columns?: Array<Job_Application_Batch_Update_Column>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};

/** Ordering options when selecting data from "job_application_batch". */
export type Job_Application_Batch_Order_By = {
  candidate?: InputMaybe<Candidate_Order_By>;
  candidate_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_message_admin?: InputMaybe<Email_Message_Order_By>;
  email_message_admin_id?: InputMaybe<Order_By>;
  email_message_clinician?: InputMaybe<Email_Message_Order_By>;
  email_message_clinician_id?: InputMaybe<Order_By>;
  email_message_recruiter?: InputMaybe<Email_Message_Order_By>;
  email_message_recruiter_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intro?: InputMaybe<Order_By>;
  job_applications_aggregate?: InputMaybe<Job_Application_Aggregate_Order_By>;
  legacy?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  recruiter?: InputMaybe<Org_User_Order_By>;
  recruiter_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_application_batch */
export type Job_Application_Batch_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "job_application_batch" */
export enum Job_Application_Batch_Select_Column {
  /** column name */
  CandidateId = 'candidate_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailMessageAdminId = 'email_message_admin_id',
  /** column name */
  EmailMessageClinicianId = 'email_message_clinician_id',
  /** column name */
  EmailMessageRecruiterId = 'email_message_recruiter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Intro = 'intro',
  /** column name */
  Legacy = 'legacy',
  /** column name */
  Notes = 'notes',
  /** column name */
  RecruiterId = 'recruiter_id'
}

/** select "job_application_batch_aggregate_bool_exp_bool_and_arguments_columns" columns of table "job_application_batch" */
export enum Job_Application_Batch_Select_Column_Job_Application_Batch_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Legacy = 'legacy'
}

/** select "job_application_batch_aggregate_bool_exp_bool_or_arguments_columns" columns of table "job_application_batch" */
export enum Job_Application_Batch_Select_Column_Job_Application_Batch_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Legacy = 'legacy'
}

/** input type for updating data in table "job_application_batch" */
export type Job_Application_Batch_Set_Input = {
  candidate_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_message_admin_id?: InputMaybe<Scalars['uuid']>;
  email_message_clinician_id?: InputMaybe<Scalars['uuid']>;
  email_message_recruiter_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  intro?: InputMaybe<Scalars['String']>;
  legacy?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "job_application_batch" */
export type Job_Application_Batch_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Application_Batch_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Application_Batch_Stream_Cursor_Value_Input = {
  candidate_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  email_message_admin_id?: InputMaybe<Scalars['uuid']>;
  email_message_clinician_id?: InputMaybe<Scalars['uuid']>;
  email_message_recruiter_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  intro?: InputMaybe<Scalars['String']>;
  legacy?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  recruiter_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "job_application_batch" */
export enum Job_Application_Batch_Update_Column {
  /** column name */
  CandidateId = 'candidate_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailMessageAdminId = 'email_message_admin_id',
  /** column name */
  EmailMessageClinicianId = 'email_message_clinician_id',
  /** column name */
  EmailMessageRecruiterId = 'email_message_recruiter_id',
  /** column name */
  Id = 'id',
  /** column name */
  Intro = 'intro',
  /** column name */
  Legacy = 'legacy',
  /** column name */
  Notes = 'notes',
  /** column name */
  RecruiterId = 'recruiter_id'
}

export type Job_Application_Batch_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Application_Batch_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Application_Batch_Bool_Exp;
};

/** Boolean expression to filter rows from the table "job_application". All fields are combined with a logical 'AND'. */
export type Job_Application_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Application_Bool_Exp>>;
  _not?: InputMaybe<Job_Application_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Application_Bool_Exp>>;
  addon?: InputMaybe<Boolean_Comparison_Exp>;
  batch?: InputMaybe<Job_Application_Batch_Bool_Exp>;
  batch_id?: InputMaybe<Uuid_Comparison_Exp>;
  contract?: InputMaybe<Facility_Contract_Bool_Exp>;
  contract_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_application_postings?: InputMaybe<Job_Application_Posting_Bool_Exp>;
  job_application_postings_aggregate?: InputMaybe<Job_Application_Posting_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "job_application" */
export enum Job_Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkJobApplication = 'pk_job_application',
  /** unique or primary key constraint on columns "batch_id", "contract_id" */
  UqJobApplicationBatchIdContractId = 'uq_job_application_batch_id_contract_id'
}

/** input type for inserting data into table "job_application" */
export type Job_Application_Insert_Input = {
  addon?: InputMaybe<Scalars['Boolean']>;
  batch?: InputMaybe<Job_Application_Batch_Obj_Rel_Insert_Input>;
  batch_id?: InputMaybe<Scalars['uuid']>;
  contract?: InputMaybe<Facility_Contract_Obj_Rel_Insert_Input>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_application_postings?: InputMaybe<Job_Application_Posting_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Job_Application_Max_Fields = {
  __typename?: 'job_application_max_fields';
  batch_id: Maybe<Scalars['uuid']>;
  contract_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_application" */
export type Job_Application_Max_Order_By = {
  batch_id?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Application_Min_Fields = {
  __typename?: 'job_application_min_fields';
  batch_id: Maybe<Scalars['uuid']>;
  contract_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_application" */
export type Job_Application_Min_Order_By = {
  batch_id?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_application" */
export type Job_Application_Mutation_Response = {
  __typename?: 'job_application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Application>;
};

/** input type for inserting object relation for remote table "job_application" */
export type Job_Application_Obj_Rel_Insert_Input = {
  data: Job_Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Application_On_Conflict>;
};

/** on_conflict condition type for table "job_application" */
export type Job_Application_On_Conflict = {
  constraint: Job_Application_Constraint;
  update_columns?: Array<Job_Application_Update_Column>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};

/** Ordering options when selecting data from "job_application". */
export type Job_Application_Order_By = {
  addon?: InputMaybe<Order_By>;
  batch?: InputMaybe<Job_Application_Batch_Order_By>;
  batch_id?: InputMaybe<Order_By>;
  contract?: InputMaybe<Facility_Contract_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_application_postings_aggregate?: InputMaybe<Job_Application_Posting_Aggregate_Order_By>;
};

/** primary key columns input for table: job_application */
export type Job_Application_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "job_application_posting" */
export type Job_Application_Posting = {
  __typename?: 'job_application_posting';
  id: Scalars['uuid'];
  /** An object relationship */
  job_application: Job_Application;
  job_application_id: Scalars['uuid'];
  /** An object relationship */
  posting: Job_Posting;
  posting_id: Scalars['uuid'];
};

/** aggregated selection of "job_application_posting" */
export type Job_Application_Posting_Aggregate = {
  __typename?: 'job_application_posting_aggregate';
  aggregate: Maybe<Job_Application_Posting_Aggregate_Fields>;
  nodes: Array<Job_Application_Posting>;
};

export type Job_Application_Posting_Aggregate_Bool_Exp = {
  count?: InputMaybe<Job_Application_Posting_Aggregate_Bool_Exp_Count>;
};

export type Job_Application_Posting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Application_Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_application_posting" */
export type Job_Application_Posting_Aggregate_Fields = {
  __typename?: 'job_application_posting_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Job_Application_Posting_Max_Fields>;
  min: Maybe<Job_Application_Posting_Min_Fields>;
};


/** aggregate fields of "job_application_posting" */
export type Job_Application_Posting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_application_posting" */
export type Job_Application_Posting_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Application_Posting_Max_Order_By>;
  min?: InputMaybe<Job_Application_Posting_Min_Order_By>;
};

/** input type for inserting array relation for remote table "job_application_posting" */
export type Job_Application_Posting_Arr_Rel_Insert_Input = {
  data: Array<Job_Application_Posting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Application_Posting_On_Conflict>;
};

/** Boolean expression to filter rows from the table "job_application_posting". All fields are combined with a logical 'AND'. */
export type Job_Application_Posting_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Application_Posting_Bool_Exp>>;
  _not?: InputMaybe<Job_Application_Posting_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Application_Posting_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_application?: InputMaybe<Job_Application_Bool_Exp>;
  job_application_id?: InputMaybe<Uuid_Comparison_Exp>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_application_posting" */
export enum Job_Application_Posting_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkJobApplicationPosting = 'pk_job_application_posting',
  /** unique or primary key constraint on columns "job_application_id", "posting_id" */
  UqJobApplicationPostingJobApplicationIdPostingId = 'uq_job_application_posting_job_application_id_posting_id'
}

/** input type for inserting data into table "job_application_posting" */
export type Job_Application_Posting_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  job_application?: InputMaybe<Job_Application_Obj_Rel_Insert_Input>;
  job_application_id?: InputMaybe<Scalars['uuid']>;
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Job_Application_Posting_Max_Fields = {
  __typename?: 'job_application_posting_max_fields';
  id: Maybe<Scalars['uuid']>;
  job_application_id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "job_application_posting" */
export type Job_Application_Posting_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  job_application_id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Application_Posting_Min_Fields = {
  __typename?: 'job_application_posting_min_fields';
  id: Maybe<Scalars['uuid']>;
  job_application_id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "job_application_posting" */
export type Job_Application_Posting_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  job_application_id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_application_posting" */
export type Job_Application_Posting_Mutation_Response = {
  __typename?: 'job_application_posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Application_Posting>;
};

/** on_conflict condition type for table "job_application_posting" */
export type Job_Application_Posting_On_Conflict = {
  constraint: Job_Application_Posting_Constraint;
  update_columns?: Array<Job_Application_Posting_Update_Column>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};

/** Ordering options when selecting data from "job_application_posting". */
export type Job_Application_Posting_Order_By = {
  id?: InputMaybe<Order_By>;
  job_application?: InputMaybe<Job_Application_Order_By>;
  job_application_id?: InputMaybe<Order_By>;
  posting?: InputMaybe<Job_Posting_Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_application_posting */
export type Job_Application_Posting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "job_application_posting" */
export enum Job_Application_Posting_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JobApplicationId = 'job_application_id',
  /** column name */
  PostingId = 'posting_id'
}

/** input type for updating data in table "job_application_posting" */
export type Job_Application_Posting_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  job_application_id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "job_application_posting" */
export type Job_Application_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Application_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Application_Posting_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  job_application_id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "job_application_posting" */
export enum Job_Application_Posting_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JobApplicationId = 'job_application_id',
  /** column name */
  PostingId = 'posting_id'
}

export type Job_Application_Posting_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Application_Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Application_Posting_Bool_Exp;
};

/** select columns of table "job_application" */
export enum Job_Application_Select_Column {
  /** column name */
  Addon = 'addon',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** select "job_application_aggregate_bool_exp_bool_and_arguments_columns" columns of table "job_application" */
export enum Job_Application_Select_Column_Job_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Addon = 'addon'
}

/** select "job_application_aggregate_bool_exp_bool_or_arguments_columns" columns of table "job_application" */
export enum Job_Application_Select_Column_Job_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Addon = 'addon'
}

/** input type for updating data in table "job_application" */
export type Job_Application_Set_Input = {
  addon?: InputMaybe<Scalars['Boolean']>;
  batch_id?: InputMaybe<Scalars['uuid']>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "job_application" */
export type Job_Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Application_Stream_Cursor_Value_Input = {
  addon?: InputMaybe<Scalars['Boolean']>;
  batch_id?: InputMaybe<Scalars['uuid']>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "job_application" */
export enum Job_Application_Update_Column {
  /** column name */
  Addon = 'addon',
  /** column name */
  BatchId = 'batch_id',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type Job_Application_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Application_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Application_Bool_Exp;
};

/** columns and relationships of "job_posting" */
export type Job_Posting = {
  __typename?: 'job_posting';
  active: Scalars['Boolean'];
  /** An array relationship */
  app_certs: Array<Posting_App_Cert>;
  /** An aggregate relationship */
  app_certs_aggregate: Posting_App_Cert_Aggregate;
  bcbe: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  board_certs: Array<Posting_Board_Cert>;
  /** An aggregate relationship */
  board_certs_aggregate: Posting_Board_Cert_Aggregate;
  cme: Scalars['Boolean'];
  /** An object relationship */
  contract: Facility_Contract;
  contract_id: Scalars['uuid'];
  createdAtDate: Scalars['DateTime'];
  created_at: Scalars['timestamp'];
  /** An object relationship */
  creator: Maybe<Org_User>;
  creator_id: Maybe<Scalars['uuid']>;
  current_license: Maybe<Scalars['Boolean']>;
  dental_insurance: Scalars['Boolean'];
  description: Scalars['String'];
  description_html: Scalars['String'];
  disability_insurance: Scalars['Boolean'];
  equity: Scalars['Boolean'];
  exact_rate: Maybe<Scalars['Int']>;
  exp_req: Maybe<Scalars['Boolean']>;
  experience: Maybe<Scalars['Int']>;
  expiration_date: Maybe<Scalars['date']>;
  expiration_notif: Scalars['Boolean'];
  /** An array relationship */
  ext_postings: Array<Ext_Job_Posting>;
  /** An aggregate relationship */
  ext_postings_aggregate: Ext_Job_Posting_Aggregate;
  h1b_visa: Maybe<Scalars['Boolean']>;
  has_perf_bonus: Scalars['Boolean'];
  has_rate: Scalars['Boolean'];
  has_relocation_assist: Scalars['Boolean'];
  has_signing_bonus: Scalars['Boolean'];
  has_start_date: Maybe<Scalars['Boolean']>;
  health_account: Scalars['Boolean'];
  health_insurance: Scalars['Boolean'];
  id: Scalars['uuid'];
  impressions: Maybe<Bqanalytics_Job_Posting_Impressions>;
  is_exact_rate: Maybe<Scalars['Boolean']>;
  j1_visa: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  job_application_postings: Array<Job_Application_Posting>;
  /** An aggregate relationship */
  job_application_postings_aggregate: Job_Application_Posting_Aggregate;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  last_modified: Scalars['timestamp'];
  /** An object relationship */
  latest_publication: Maybe<Posting_Latest_Publication>;
  life_insurance: Scalars['Boolean'];
  malpractice_insurance: Scalars['Boolean'];
  max_rate: Maybe<Scalars['Int']>;
  min_rate: Maybe<Scalars['Int']>;
  /** An object relationship */
  modifier: Maybe<Org_User>;
  modifier_id: Maybe<Scalars['uuid']>;
  normalized_rate: Maybe<Scalars['Int']>;
  paid_parental: Scalars['Boolean'];
  paid_vacation: Scalars['Boolean'];
  /** An array relationship */
  professions: Array<Posting_Profession>;
  /** An aggregate relationship */
  professions_aggregate: Posting_Profession_Aggregate;
  rate_period: Maybe<Scalars['paymentrateperiod']>;
  retirement_account: Scalars['Boolean'];
  schedule: Maybe<Scalars['workschedule']>;
  slug: Scalars['String'];
  startOrTodayDate: Maybe<Scalars['Date']>;
  start_date: Maybe<Scalars['date']>;
  student_loan: Scalars['Boolean'];
  tail_coverage: Scalars['Boolean'];
  term: Maybe<Scalars['workterm']>;
  title: Scalars['String'];
  vision_insurance: Scalars['Boolean'];
  wageTrunc: Scalars['String'];
  /** An array relationship */
  worker_classifications: Array<Posting_Worker_Classification>;
  /** An aggregate relationship */
  worker_classifications_aggregate: Posting_Worker_Classification_Aggregate;
};


/** columns and relationships of "job_posting" */
export type Job_PostingApp_CertsArgs = {
  distinct_on?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_App_Cert_Order_By>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingApp_Certs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_App_Cert_Order_By>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingBoard_CertsArgs = {
  distinct_on?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Board_Cert_Order_By>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingBoard_Certs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Board_Cert_Order_By>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingExt_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingExt_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingJob_Application_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingJob_Application_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingProfessionsArgs = {
  distinct_on?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Profession_Order_By>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingProfessions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Profession_Order_By>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingWorker_ClassificationsArgs = {
  distinct_on?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Worker_Classification_Order_By>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};


/** columns and relationships of "job_posting" */
export type Job_PostingWorker_Classifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Worker_Classification_Order_By>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};

/** aggregated selection of "job_posting" */
export type Job_Posting_Aggregate = {
  __typename?: 'job_posting_aggregate';
  aggregate: Maybe<Job_Posting_Aggregate_Fields>;
  nodes: Array<Job_Posting>;
};

export type Job_Posting_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Job_Posting_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Job_Posting_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Job_Posting_Aggregate_Bool_Exp_Count>;
};

export type Job_Posting_Aggregate_Bool_Exp_Bool_And = {
  arguments: Job_Posting_Select_Column_Job_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Posting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Posting_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Job_Posting_Select_Column_Job_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Posting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Job_Posting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Job_Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "job_posting" */
export type Job_Posting_Aggregate_Fields = {
  __typename?: 'job_posting_aggregate_fields';
  avg: Maybe<Job_Posting_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Job_Posting_Max_Fields>;
  min: Maybe<Job_Posting_Min_Fields>;
  stddev: Maybe<Job_Posting_Stddev_Fields>;
  stddev_pop: Maybe<Job_Posting_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Job_Posting_Stddev_Samp_Fields>;
  sum: Maybe<Job_Posting_Sum_Fields>;
  var_pop: Maybe<Job_Posting_Var_Pop_Fields>;
  var_samp: Maybe<Job_Posting_Var_Samp_Fields>;
  variance: Maybe<Job_Posting_Variance_Fields>;
};


/** aggregate fields of "job_posting" */
export type Job_Posting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "job_posting" */
export type Job_Posting_Aggregate_Order_By = {
  avg?: InputMaybe<Job_Posting_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Job_Posting_Max_Order_By>;
  min?: InputMaybe<Job_Posting_Min_Order_By>;
  stddev?: InputMaybe<Job_Posting_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Job_Posting_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Job_Posting_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Job_Posting_Sum_Order_By>;
  var_pop?: InputMaybe<Job_Posting_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Job_Posting_Var_Samp_Order_By>;
  variance?: InputMaybe<Job_Posting_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "job_posting" */
export type Job_Posting_Arr_Rel_Insert_Input = {
  data: Array<Job_Posting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Posting_On_Conflict>;
};

/** aggregate avg on columns */
export type Job_Posting_Avg_Fields = {
  __typename?: 'job_posting_avg_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "job_posting" */
export type Job_Posting_Avg_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "job_posting". All fields are combined with a logical 'AND'. */
export type Job_Posting_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Posting_Bool_Exp>>;
  _not?: InputMaybe<Job_Posting_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Posting_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  app_certs?: InputMaybe<Posting_App_Cert_Bool_Exp>;
  app_certs_aggregate?: InputMaybe<Posting_App_Cert_Aggregate_Bool_Exp>;
  bcbe?: InputMaybe<Boolean_Comparison_Exp>;
  board_certs?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
  board_certs_aggregate?: InputMaybe<Posting_Board_Cert_Aggregate_Bool_Exp>;
  cme?: InputMaybe<Boolean_Comparison_Exp>;
  contract?: InputMaybe<Facility_Contract_Bool_Exp>;
  contract_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  creator?: InputMaybe<Org_User_Bool_Exp>;
  creator_id?: InputMaybe<Uuid_Comparison_Exp>;
  current_license?: InputMaybe<Boolean_Comparison_Exp>;
  dental_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_html?: InputMaybe<String_Comparison_Exp>;
  disability_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  equity?: InputMaybe<Boolean_Comparison_Exp>;
  exact_rate?: InputMaybe<Int_Comparison_Exp>;
  exp_req?: InputMaybe<Boolean_Comparison_Exp>;
  experience?: InputMaybe<Int_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  expiration_notif?: InputMaybe<Boolean_Comparison_Exp>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp>;
  h1b_visa?: InputMaybe<Boolean_Comparison_Exp>;
  has_perf_bonus?: InputMaybe<Boolean_Comparison_Exp>;
  has_rate?: InputMaybe<Boolean_Comparison_Exp>;
  has_relocation_assist?: InputMaybe<Boolean_Comparison_Exp>;
  has_signing_bonus?: InputMaybe<Boolean_Comparison_Exp>;
  has_start_date?: InputMaybe<Boolean_Comparison_Exp>;
  health_account?: InputMaybe<Boolean_Comparison_Exp>;
  health_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_exact_rate?: InputMaybe<Boolean_Comparison_Exp>;
  j1_visa?: InputMaybe<Boolean_Comparison_Exp>;
  job_application_postings?: InputMaybe<Job_Application_Posting_Bool_Exp>;
  job_application_postings_aggregate?: InputMaybe<Job_Application_Posting_Aggregate_Bool_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  latest_publication?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
  life_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  malpractice_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  max_rate?: InputMaybe<Int_Comparison_Exp>;
  min_rate?: InputMaybe<Int_Comparison_Exp>;
  modifier?: InputMaybe<Org_User_Bool_Exp>;
  modifier_id?: InputMaybe<Uuid_Comparison_Exp>;
  normalized_rate?: InputMaybe<Int_Comparison_Exp>;
  paid_parental?: InputMaybe<Boolean_Comparison_Exp>;
  paid_vacation?: InputMaybe<Boolean_Comparison_Exp>;
  professions?: InputMaybe<Posting_Profession_Bool_Exp>;
  professions_aggregate?: InputMaybe<Posting_Profession_Aggregate_Bool_Exp>;
  rate_period?: InputMaybe<Paymentrateperiod_Comparison_Exp>;
  retirement_account?: InputMaybe<Boolean_Comparison_Exp>;
  schedule?: InputMaybe<Workschedule_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  student_loan?: InputMaybe<Boolean_Comparison_Exp>;
  tail_coverage?: InputMaybe<Boolean_Comparison_Exp>;
  term?: InputMaybe<Workterm_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  vision_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  worker_classifications?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
  worker_classifications_aggregate?: InputMaybe<Posting_Worker_Classification_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "job_posting" */
export enum Job_Posting_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkJobPosting = 'pk_job_posting'
}

/** input type for incrementing numeric columns in table "job_posting" */
export type Job_Posting_Inc_Input = {
  exact_rate?: InputMaybe<Scalars['Int']>;
  experience?: InputMaybe<Scalars['Int']>;
  max_rate?: InputMaybe<Scalars['Int']>;
  min_rate?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "job_posting" */
export type Job_Posting_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  app_certs?: InputMaybe<Posting_App_Cert_Arr_Rel_Insert_Input>;
  bcbe?: InputMaybe<Scalars['Boolean']>;
  board_certs?: InputMaybe<Posting_Board_Cert_Arr_Rel_Insert_Input>;
  cme?: InputMaybe<Scalars['Boolean']>;
  contract?: InputMaybe<Facility_Contract_Obj_Rel_Insert_Input>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  creator?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  current_license?: InputMaybe<Scalars['Boolean']>;
  dental_insurance?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  description_html?: InputMaybe<Scalars['String']>;
  disability_insurance?: InputMaybe<Scalars['Boolean']>;
  equity?: InputMaybe<Scalars['Boolean']>;
  exact_rate?: InputMaybe<Scalars['Int']>;
  exp_req?: InputMaybe<Scalars['Boolean']>;
  experience?: InputMaybe<Scalars['Int']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  expiration_notif?: InputMaybe<Scalars['Boolean']>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Arr_Rel_Insert_Input>;
  h1b_visa?: InputMaybe<Scalars['Boolean']>;
  has_perf_bonus?: InputMaybe<Scalars['Boolean']>;
  has_rate?: InputMaybe<Scalars['Boolean']>;
  has_relocation_assist?: InputMaybe<Scalars['Boolean']>;
  has_signing_bonus?: InputMaybe<Scalars['Boolean']>;
  has_start_date?: InputMaybe<Scalars['Boolean']>;
  health_account?: InputMaybe<Scalars['Boolean']>;
  health_insurance?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_exact_rate?: InputMaybe<Scalars['Boolean']>;
  j1_visa?: InputMaybe<Scalars['Boolean']>;
  job_application_postings?: InputMaybe<Job_Application_Posting_Arr_Rel_Insert_Input>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  latest_publication?: InputMaybe<Posting_Latest_Publication_Obj_Rel_Insert_Input>;
  life_insurance?: InputMaybe<Scalars['Boolean']>;
  malpractice_insurance?: InputMaybe<Scalars['Boolean']>;
  max_rate?: InputMaybe<Scalars['Int']>;
  min_rate?: InputMaybe<Scalars['Int']>;
  modifier?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  modifier_id?: InputMaybe<Scalars['uuid']>;
  paid_parental?: InputMaybe<Scalars['Boolean']>;
  paid_vacation?: InputMaybe<Scalars['Boolean']>;
  professions?: InputMaybe<Posting_Profession_Arr_Rel_Insert_Input>;
  rate_period?: InputMaybe<Scalars['paymentrateperiod']>;
  retirement_account?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<Scalars['workschedule']>;
  start_date?: InputMaybe<Scalars['date']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  tail_coverage?: InputMaybe<Scalars['Boolean']>;
  term?: InputMaybe<Scalars['workterm']>;
  title?: InputMaybe<Scalars['String']>;
  vision_insurance?: InputMaybe<Scalars['Boolean']>;
  worker_classifications?: InputMaybe<Posting_Worker_Classification_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Job_Posting_Max_Fields = {
  __typename?: 'job_posting_max_fields';
  contract_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  creator_id: Maybe<Scalars['uuid']>;
  description: Maybe<Scalars['String']>;
  description_html: Maybe<Scalars['String']>;
  exact_rate: Maybe<Scalars['Int']>;
  experience: Maybe<Scalars['Int']>;
  expiration_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  max_rate: Maybe<Scalars['Int']>;
  min_rate: Maybe<Scalars['Int']>;
  modifier_id: Maybe<Scalars['uuid']>;
  normalized_rate: Maybe<Scalars['Int']>;
  rate_period: Maybe<Scalars['paymentrateperiod']>;
  schedule: Maybe<Scalars['workschedule']>;
  slug: Maybe<Scalars['String']>;
  start_date: Maybe<Scalars['date']>;
  term: Maybe<Scalars['workterm']>;
  title: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "job_posting" */
export type Job_Posting_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_html?: InputMaybe<Order_By>;
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  modifier_id?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
  rate_period?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Job_Posting_Min_Fields = {
  __typename?: 'job_posting_min_fields';
  contract_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  creator_id: Maybe<Scalars['uuid']>;
  description: Maybe<Scalars['String']>;
  description_html: Maybe<Scalars['String']>;
  exact_rate: Maybe<Scalars['Int']>;
  experience: Maybe<Scalars['Int']>;
  expiration_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  max_rate: Maybe<Scalars['Int']>;
  min_rate: Maybe<Scalars['Int']>;
  modifier_id: Maybe<Scalars['uuid']>;
  normalized_rate: Maybe<Scalars['Int']>;
  rate_period: Maybe<Scalars['paymentrateperiod']>;
  schedule: Maybe<Scalars['workschedule']>;
  slug: Maybe<Scalars['String']>;
  start_date: Maybe<Scalars['date']>;
  term: Maybe<Scalars['workterm']>;
  title: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "job_posting" */
export type Job_Posting_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_html?: InputMaybe<Order_By>;
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  modifier_id?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
  rate_period?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "job_posting" */
export type Job_Posting_Mutation_Response = {
  __typename?: 'job_posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Posting>;
};

/** input type for inserting object relation for remote table "job_posting" */
export type Job_Posting_Obj_Rel_Insert_Input = {
  data: Job_Posting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Job_Posting_On_Conflict>;
};

/** on_conflict condition type for table "job_posting" */
export type Job_Posting_On_Conflict = {
  constraint: Job_Posting_Constraint;
  update_columns?: Array<Job_Posting_Update_Column>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};

/** Ordering options when selecting data from "job_posting". */
export type Job_Posting_Order_By = {
  active?: InputMaybe<Order_By>;
  app_certs_aggregate?: InputMaybe<Posting_App_Cert_Aggregate_Order_By>;
  bcbe?: InputMaybe<Order_By>;
  board_certs_aggregate?: InputMaybe<Posting_Board_Cert_Aggregate_Order_By>;
  cme?: InputMaybe<Order_By>;
  contract?: InputMaybe<Facility_Contract_Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Org_User_Order_By>;
  creator_id?: InputMaybe<Order_By>;
  current_license?: InputMaybe<Order_By>;
  dental_insurance?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_html?: InputMaybe<Order_By>;
  disability_insurance?: InputMaybe<Order_By>;
  equity?: InputMaybe<Order_By>;
  exact_rate?: InputMaybe<Order_By>;
  exp_req?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  expiration_notif?: InputMaybe<Order_By>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Order_By>;
  h1b_visa?: InputMaybe<Order_By>;
  has_perf_bonus?: InputMaybe<Order_By>;
  has_rate?: InputMaybe<Order_By>;
  has_relocation_assist?: InputMaybe<Order_By>;
  has_signing_bonus?: InputMaybe<Order_By>;
  has_start_date?: InputMaybe<Order_By>;
  health_account?: InputMaybe<Order_By>;
  health_insurance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_exact_rate?: InputMaybe<Order_By>;
  j1_visa?: InputMaybe<Order_By>;
  job_application_postings_aggregate?: InputMaybe<Job_Application_Posting_Aggregate_Order_By>;
  last_modified?: InputMaybe<Order_By>;
  latest_publication?: InputMaybe<Posting_Latest_Publication_Order_By>;
  life_insurance?: InputMaybe<Order_By>;
  malpractice_insurance?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  modifier?: InputMaybe<Org_User_Order_By>;
  modifier_id?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
  paid_parental?: InputMaybe<Order_By>;
  paid_vacation?: InputMaybe<Order_By>;
  professions_aggregate?: InputMaybe<Posting_Profession_Aggregate_Order_By>;
  rate_period?: InputMaybe<Order_By>;
  retirement_account?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  student_loan?: InputMaybe<Order_By>;
  tail_coverage?: InputMaybe<Order_By>;
  term?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  vision_insurance?: InputMaybe<Order_By>;
  worker_classifications_aggregate?: InputMaybe<Posting_Worker_Classification_Aggregate_Order_By>;
};

/** primary key columns input for table: job_posting */
export type Job_Posting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "job_posting" */
export enum Job_Posting_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Bcbe = 'bcbe',
  /** column name */
  Cme = 'cme',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  CurrentLicense = 'current_license',
  /** column name */
  DentalInsurance = 'dental_insurance',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionHtml = 'description_html',
  /** column name */
  DisabilityInsurance = 'disability_insurance',
  /** column name */
  Equity = 'equity',
  /** column name */
  ExactRate = 'exact_rate',
  /** column name */
  ExpReq = 'exp_req',
  /** column name */
  Experience = 'experience',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  ExpirationNotif = 'expiration_notif',
  /** column name */
  H1bVisa = 'h1b_visa',
  /** column name */
  HasPerfBonus = 'has_perf_bonus',
  /** column name */
  HasRate = 'has_rate',
  /** column name */
  HasRelocationAssist = 'has_relocation_assist',
  /** column name */
  HasSigningBonus = 'has_signing_bonus',
  /** column name */
  HasStartDate = 'has_start_date',
  /** column name */
  HealthAccount = 'health_account',
  /** column name */
  HealthInsurance = 'health_insurance',
  /** column name */
  Id = 'id',
  /** column name */
  IsExactRate = 'is_exact_rate',
  /** column name */
  J1Visa = 'j1_visa',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LifeInsurance = 'life_insurance',
  /** column name */
  MalpracticeInsurance = 'malpractice_insurance',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  ModifierId = 'modifier_id',
  /** column name */
  NormalizedRate = 'normalized_rate',
  /** column name */
  PaidParental = 'paid_parental',
  /** column name */
  PaidVacation = 'paid_vacation',
  /** column name */
  RatePeriod = 'rate_period',
  /** column name */
  RetirementAccount = 'retirement_account',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  Slug = 'slug',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  TailCoverage = 'tail_coverage',
  /** column name */
  Term = 'term',
  /** column name */
  Title = 'title',
  /** column name */
  VisionInsurance = 'vision_insurance'
}

/** select "job_posting_aggregate_bool_exp_bool_and_arguments_columns" columns of table "job_posting" */
export enum Job_Posting_Select_Column_Job_Posting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Bcbe = 'bcbe',
  /** column name */
  Cme = 'cme',
  /** column name */
  CurrentLicense = 'current_license',
  /** column name */
  DentalInsurance = 'dental_insurance',
  /** column name */
  DisabilityInsurance = 'disability_insurance',
  /** column name */
  Equity = 'equity',
  /** column name */
  ExpReq = 'exp_req',
  /** column name */
  ExpirationNotif = 'expiration_notif',
  /** column name */
  H1bVisa = 'h1b_visa',
  /** column name */
  HasPerfBonus = 'has_perf_bonus',
  /** column name */
  HasRate = 'has_rate',
  /** column name */
  HasRelocationAssist = 'has_relocation_assist',
  /** column name */
  HasSigningBonus = 'has_signing_bonus',
  /** column name */
  HasStartDate = 'has_start_date',
  /** column name */
  HealthAccount = 'health_account',
  /** column name */
  HealthInsurance = 'health_insurance',
  /** column name */
  IsExactRate = 'is_exact_rate',
  /** column name */
  J1Visa = 'j1_visa',
  /** column name */
  LifeInsurance = 'life_insurance',
  /** column name */
  MalpracticeInsurance = 'malpractice_insurance',
  /** column name */
  PaidParental = 'paid_parental',
  /** column name */
  PaidVacation = 'paid_vacation',
  /** column name */
  RetirementAccount = 'retirement_account',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  TailCoverage = 'tail_coverage',
  /** column name */
  VisionInsurance = 'vision_insurance'
}

/** select "job_posting_aggregate_bool_exp_bool_or_arguments_columns" columns of table "job_posting" */
export enum Job_Posting_Select_Column_Job_Posting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  Bcbe = 'bcbe',
  /** column name */
  Cme = 'cme',
  /** column name */
  CurrentLicense = 'current_license',
  /** column name */
  DentalInsurance = 'dental_insurance',
  /** column name */
  DisabilityInsurance = 'disability_insurance',
  /** column name */
  Equity = 'equity',
  /** column name */
  ExpReq = 'exp_req',
  /** column name */
  ExpirationNotif = 'expiration_notif',
  /** column name */
  H1bVisa = 'h1b_visa',
  /** column name */
  HasPerfBonus = 'has_perf_bonus',
  /** column name */
  HasRate = 'has_rate',
  /** column name */
  HasRelocationAssist = 'has_relocation_assist',
  /** column name */
  HasSigningBonus = 'has_signing_bonus',
  /** column name */
  HasStartDate = 'has_start_date',
  /** column name */
  HealthAccount = 'health_account',
  /** column name */
  HealthInsurance = 'health_insurance',
  /** column name */
  IsExactRate = 'is_exact_rate',
  /** column name */
  J1Visa = 'j1_visa',
  /** column name */
  LifeInsurance = 'life_insurance',
  /** column name */
  MalpracticeInsurance = 'malpractice_insurance',
  /** column name */
  PaidParental = 'paid_parental',
  /** column name */
  PaidVacation = 'paid_vacation',
  /** column name */
  RetirementAccount = 'retirement_account',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  TailCoverage = 'tail_coverage',
  /** column name */
  VisionInsurance = 'vision_insurance'
}

/** input type for updating data in table "job_posting" */
export type Job_Posting_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  bcbe?: InputMaybe<Scalars['Boolean']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  current_license?: InputMaybe<Scalars['Boolean']>;
  dental_insurance?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  description_html?: InputMaybe<Scalars['String']>;
  disability_insurance?: InputMaybe<Scalars['Boolean']>;
  equity?: InputMaybe<Scalars['Boolean']>;
  exact_rate?: InputMaybe<Scalars['Int']>;
  exp_req?: InputMaybe<Scalars['Boolean']>;
  experience?: InputMaybe<Scalars['Int']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  expiration_notif?: InputMaybe<Scalars['Boolean']>;
  h1b_visa?: InputMaybe<Scalars['Boolean']>;
  has_perf_bonus?: InputMaybe<Scalars['Boolean']>;
  has_rate?: InputMaybe<Scalars['Boolean']>;
  has_relocation_assist?: InputMaybe<Scalars['Boolean']>;
  has_signing_bonus?: InputMaybe<Scalars['Boolean']>;
  has_start_date?: InputMaybe<Scalars['Boolean']>;
  health_account?: InputMaybe<Scalars['Boolean']>;
  health_insurance?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_exact_rate?: InputMaybe<Scalars['Boolean']>;
  j1_visa?: InputMaybe<Scalars['Boolean']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  life_insurance?: InputMaybe<Scalars['Boolean']>;
  malpractice_insurance?: InputMaybe<Scalars['Boolean']>;
  max_rate?: InputMaybe<Scalars['Int']>;
  min_rate?: InputMaybe<Scalars['Int']>;
  modifier_id?: InputMaybe<Scalars['uuid']>;
  paid_parental?: InputMaybe<Scalars['Boolean']>;
  paid_vacation?: InputMaybe<Scalars['Boolean']>;
  rate_period?: InputMaybe<Scalars['paymentrateperiod']>;
  retirement_account?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<Scalars['workschedule']>;
  start_date?: InputMaybe<Scalars['date']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  tail_coverage?: InputMaybe<Scalars['Boolean']>;
  term?: InputMaybe<Scalars['workterm']>;
  title?: InputMaybe<Scalars['String']>;
  vision_insurance?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Job_Posting_Stddev_Fields = {
  __typename?: 'job_posting_stddev_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "job_posting" */
export type Job_Posting_Stddev_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Job_Posting_Stddev_Pop_Fields = {
  __typename?: 'job_posting_stddev_pop_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "job_posting" */
export type Job_Posting_Stddev_Pop_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Job_Posting_Stddev_Samp_Fields = {
  __typename?: 'job_posting_stddev_samp_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "job_posting" */
export type Job_Posting_Stddev_Samp_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "job_posting" */
export type Job_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Posting_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  bcbe?: InputMaybe<Scalars['Boolean']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  contract_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  creator_id?: InputMaybe<Scalars['uuid']>;
  current_license?: InputMaybe<Scalars['Boolean']>;
  dental_insurance?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  description_html?: InputMaybe<Scalars['String']>;
  disability_insurance?: InputMaybe<Scalars['Boolean']>;
  equity?: InputMaybe<Scalars['Boolean']>;
  exact_rate?: InputMaybe<Scalars['Int']>;
  exp_req?: InputMaybe<Scalars['Boolean']>;
  experience?: InputMaybe<Scalars['Int']>;
  expiration_date?: InputMaybe<Scalars['date']>;
  expiration_notif?: InputMaybe<Scalars['Boolean']>;
  h1b_visa?: InputMaybe<Scalars['Boolean']>;
  has_perf_bonus?: InputMaybe<Scalars['Boolean']>;
  has_rate?: InputMaybe<Scalars['Boolean']>;
  has_relocation_assist?: InputMaybe<Scalars['Boolean']>;
  has_signing_bonus?: InputMaybe<Scalars['Boolean']>;
  has_start_date?: InputMaybe<Scalars['Boolean']>;
  health_account?: InputMaybe<Scalars['Boolean']>;
  health_insurance?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_exact_rate?: InputMaybe<Scalars['Boolean']>;
  j1_visa?: InputMaybe<Scalars['Boolean']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  life_insurance?: InputMaybe<Scalars['Boolean']>;
  malpractice_insurance?: InputMaybe<Scalars['Boolean']>;
  max_rate?: InputMaybe<Scalars['Int']>;
  min_rate?: InputMaybe<Scalars['Int']>;
  modifier_id?: InputMaybe<Scalars['uuid']>;
  normalized_rate?: InputMaybe<Scalars['Int']>;
  paid_parental?: InputMaybe<Scalars['Boolean']>;
  paid_vacation?: InputMaybe<Scalars['Boolean']>;
  rate_period?: InputMaybe<Scalars['paymentrateperiod']>;
  retirement_account?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<Scalars['workschedule']>;
  slug?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  tail_coverage?: InputMaybe<Scalars['Boolean']>;
  term?: InputMaybe<Scalars['workterm']>;
  title?: InputMaybe<Scalars['String']>;
  vision_insurance?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Job_Posting_Sum_Fields = {
  __typename?: 'job_posting_sum_fields';
  exact_rate: Maybe<Scalars['Int']>;
  experience: Maybe<Scalars['Int']>;
  max_rate: Maybe<Scalars['Int']>;
  min_rate: Maybe<Scalars['Int']>;
  normalized_rate: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "job_posting" */
export type Job_Posting_Sum_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** update columns of table "job_posting" */
export enum Job_Posting_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Bcbe = 'bcbe',
  /** column name */
  Cme = 'cme',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatorId = 'creator_id',
  /** column name */
  CurrentLicense = 'current_license',
  /** column name */
  DentalInsurance = 'dental_insurance',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionHtml = 'description_html',
  /** column name */
  DisabilityInsurance = 'disability_insurance',
  /** column name */
  Equity = 'equity',
  /** column name */
  ExactRate = 'exact_rate',
  /** column name */
  ExpReq = 'exp_req',
  /** column name */
  Experience = 'experience',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  ExpirationNotif = 'expiration_notif',
  /** column name */
  H1bVisa = 'h1b_visa',
  /** column name */
  HasPerfBonus = 'has_perf_bonus',
  /** column name */
  HasRate = 'has_rate',
  /** column name */
  HasRelocationAssist = 'has_relocation_assist',
  /** column name */
  HasSigningBonus = 'has_signing_bonus',
  /** column name */
  HasStartDate = 'has_start_date',
  /** column name */
  HealthAccount = 'health_account',
  /** column name */
  HealthInsurance = 'health_insurance',
  /** column name */
  Id = 'id',
  /** column name */
  IsExactRate = 'is_exact_rate',
  /** column name */
  J1Visa = 'j1_visa',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  LifeInsurance = 'life_insurance',
  /** column name */
  MalpracticeInsurance = 'malpractice_insurance',
  /** column name */
  MaxRate = 'max_rate',
  /** column name */
  MinRate = 'min_rate',
  /** column name */
  ModifierId = 'modifier_id',
  /** column name */
  PaidParental = 'paid_parental',
  /** column name */
  PaidVacation = 'paid_vacation',
  /** column name */
  RatePeriod = 'rate_period',
  /** column name */
  RetirementAccount = 'retirement_account',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  TailCoverage = 'tail_coverage',
  /** column name */
  Term = 'term',
  /** column name */
  Title = 'title',
  /** column name */
  VisionInsurance = 'vision_insurance'
}

export type Job_Posting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Job_Posting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Posting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Job_Posting_Var_Pop_Fields = {
  __typename?: 'job_posting_var_pop_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "job_posting" */
export type Job_Posting_Var_Pop_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Job_Posting_Var_Samp_Fields = {
  __typename?: 'job_posting_var_samp_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "job_posting" */
export type Job_Posting_Var_Samp_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Job_Posting_Variance_Fields = {
  __typename?: 'job_posting_variance_fields';
  exact_rate: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  max_rate: Maybe<Scalars['Float']>;
  min_rate: Maybe<Scalars['Float']>;
  normalized_rate: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "job_posting" */
export type Job_Posting_Variance_Order_By = {
  exact_rate?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  max_rate?: InputMaybe<Order_By>;
  min_rate?: InputMaybe<Order_By>;
  normalized_rate?: InputMaybe<Order_By>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "latest_clerkship_survey" */
export type Latest_Clerkship_Survey = {
  __typename?: 'latest_clerkship_survey';
  clerkship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  survey: Maybe<Clerkship_Survey>;
};

/** aggregated selection of "latest_clerkship_survey" */
export type Latest_Clerkship_Survey_Aggregate = {
  __typename?: 'latest_clerkship_survey_aggregate';
  aggregate: Maybe<Latest_Clerkship_Survey_Aggregate_Fields>;
  nodes: Array<Latest_Clerkship_Survey>;
};

/** aggregate fields of "latest_clerkship_survey" */
export type Latest_Clerkship_Survey_Aggregate_Fields = {
  __typename?: 'latest_clerkship_survey_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Latest_Clerkship_Survey_Max_Fields>;
  min: Maybe<Latest_Clerkship_Survey_Min_Fields>;
};


/** aggregate fields of "latest_clerkship_survey" */
export type Latest_Clerkship_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Latest_Clerkship_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "latest_clerkship_survey". All fields are combined with a logical 'AND'. */
export type Latest_Clerkship_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Latest_Clerkship_Survey_Bool_Exp>>;
  _not?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Latest_Clerkship_Survey_Bool_Exp>>;
  clerkship_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  survey?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};

/** input type for inserting data into table "latest_clerkship_survey" */
export type Latest_Clerkship_Survey_Insert_Input = {
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  survey?: InputMaybe<Clerkship_Survey_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Latest_Clerkship_Survey_Max_Fields = {
  __typename?: 'latest_clerkship_survey_max_fields';
  clerkship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Latest_Clerkship_Survey_Min_Fields = {
  __typename?: 'latest_clerkship_survey_min_fields';
  clerkship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "latest_clerkship_survey" */
export type Latest_Clerkship_Survey_Obj_Rel_Insert_Input = {
  data: Latest_Clerkship_Survey_Insert_Input;
};

/** Ordering options when selecting data from "latest_clerkship_survey". */
export type Latest_Clerkship_Survey_Order_By = {
  clerkship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey?: InputMaybe<Clerkship_Survey_Order_By>;
};

/** select columns of table "latest_clerkship_survey" */
export enum Latest_Clerkship_Survey_Select_Column {
  /** column name */
  ClerkshipId = 'clerkship_id',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "latest_clerkship_survey" */
export type Latest_Clerkship_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latest_Clerkship_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latest_Clerkship_Survey_Stream_Cursor_Value_Input = {
  clerkship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "latest_fellowship_survey" */
export type Latest_Fellowship_Survey = {
  __typename?: 'latest_fellowship_survey';
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  survey: Maybe<Fellowship_Survey>;
};

/** aggregated selection of "latest_fellowship_survey" */
export type Latest_Fellowship_Survey_Aggregate = {
  __typename?: 'latest_fellowship_survey_aggregate';
  aggregate: Maybe<Latest_Fellowship_Survey_Aggregate_Fields>;
  nodes: Array<Latest_Fellowship_Survey>;
};

/** aggregate fields of "latest_fellowship_survey" */
export type Latest_Fellowship_Survey_Aggregate_Fields = {
  __typename?: 'latest_fellowship_survey_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Latest_Fellowship_Survey_Max_Fields>;
  min: Maybe<Latest_Fellowship_Survey_Min_Fields>;
};


/** aggregate fields of "latest_fellowship_survey" */
export type Latest_Fellowship_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Latest_Fellowship_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "latest_fellowship_survey". All fields are combined with a logical 'AND'. */
export type Latest_Fellowship_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Latest_Fellowship_Survey_Bool_Exp>>;
  _not?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Latest_Fellowship_Survey_Bool_Exp>>;
  fellowship_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  survey?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};

/** input type for inserting data into table "latest_fellowship_survey" */
export type Latest_Fellowship_Survey_Insert_Input = {
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  survey?: InputMaybe<Fellowship_Survey_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Latest_Fellowship_Survey_Max_Fields = {
  __typename?: 'latest_fellowship_survey_max_fields';
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Latest_Fellowship_Survey_Min_Fields = {
  __typename?: 'latest_fellowship_survey_min_fields';
  fellowship_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "latest_fellowship_survey" */
export type Latest_Fellowship_Survey_Obj_Rel_Insert_Input = {
  data: Latest_Fellowship_Survey_Insert_Input;
};

/** Ordering options when selecting data from "latest_fellowship_survey". */
export type Latest_Fellowship_Survey_Order_By = {
  fellowship_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  survey?: InputMaybe<Fellowship_Survey_Order_By>;
};

/** select columns of table "latest_fellowship_survey" */
export enum Latest_Fellowship_Survey_Select_Column {
  /** column name */
  FellowshipId = 'fellowship_id',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "latest_fellowship_survey" */
export type Latest_Fellowship_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latest_Fellowship_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latest_Fellowship_Survey_Stream_Cursor_Value_Input = {
  fellowship_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "latest_residency_survey" */
export type Latest_Residency_Survey = {
  __typename?: 'latest_residency_survey';
  id: Maybe<Scalars['uuid']>;
  residency_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  survey: Maybe<Residency_Survey>;
};

/** aggregated selection of "latest_residency_survey" */
export type Latest_Residency_Survey_Aggregate = {
  __typename?: 'latest_residency_survey_aggregate';
  aggregate: Maybe<Latest_Residency_Survey_Aggregate_Fields>;
  nodes: Array<Latest_Residency_Survey>;
};

/** aggregate fields of "latest_residency_survey" */
export type Latest_Residency_Survey_Aggregate_Fields = {
  __typename?: 'latest_residency_survey_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Latest_Residency_Survey_Max_Fields>;
  min: Maybe<Latest_Residency_Survey_Min_Fields>;
};


/** aggregate fields of "latest_residency_survey" */
export type Latest_Residency_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Latest_Residency_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "latest_residency_survey". All fields are combined with a logical 'AND'. */
export type Latest_Residency_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Latest_Residency_Survey_Bool_Exp>>;
  _not?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Latest_Residency_Survey_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  residency_id?: InputMaybe<Uuid_Comparison_Exp>;
  survey?: InputMaybe<Residency_Survey_Bool_Exp>;
};

/** input type for inserting data into table "latest_residency_survey" */
export type Latest_Residency_Survey_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  survey?: InputMaybe<Residency_Survey_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Latest_Residency_Survey_Max_Fields = {
  __typename?: 'latest_residency_survey_max_fields';
  id: Maybe<Scalars['uuid']>;
  residency_id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Latest_Residency_Survey_Min_Fields = {
  __typename?: 'latest_residency_survey_min_fields';
  id: Maybe<Scalars['uuid']>;
  residency_id: Maybe<Scalars['uuid']>;
};

/** input type for inserting object relation for remote table "latest_residency_survey" */
export type Latest_Residency_Survey_Obj_Rel_Insert_Input = {
  data: Latest_Residency_Survey_Insert_Input;
};

/** Ordering options when selecting data from "latest_residency_survey". */
export type Latest_Residency_Survey_Order_By = {
  id?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  survey?: InputMaybe<Residency_Survey_Order_By>;
};

/** select columns of table "latest_residency_survey" */
export enum Latest_Residency_Survey_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ResidencyId = 'residency_id'
}

/** Streaming cursor of the table "latest_residency_survey" */
export type Latest_Residency_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Latest_Residency_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Latest_Residency_Survey_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
};

export type Max_Postings_For_Prof_Facility_Args = {
  prof?: InputMaybe<Scalars['profession']>;
};

/** Boolean expression to compare columns of type "moderationstatus". All fields are combined with logical 'AND'. */
export type Moderationstatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['moderationstatus']>;
  _gt?: InputMaybe<Scalars['moderationstatus']>;
  _gte?: InputMaybe<Scalars['moderationstatus']>;
  _in?: InputMaybe<Array<Scalars['moderationstatus']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['moderationstatus']>;
  _lte?: InputMaybe<Scalars['moderationstatus']>;
  _neq?: InputMaybe<Scalars['moderationstatus']>;
  _nin?: InputMaybe<Array<Scalars['moderationstatus']>>;
};

export type Most_Helpful_Review_Args = {
  fid?: InputMaybe<Scalars['uuid']>;
  oid?: InputMaybe<Scalars['uuid']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  accept_acep_org_survey: AcceptAcepOrgSurveyResult;
  apply_to_jobs: SuccessResult;
  cancel_customer_subscription: CustomerSubscriptionGql;
  /** execute VOLATILE function "change_facility_picture" which returns "facility" */
  change_facility_picture: Array<Facility>;
  check_org_user_signup_status: CheckOrgUserSignupStatusResult;
  claim_org_user: SuccessResult;
  complete_customer_checkout: CheckoutSetupIntentGql;
  createAdAuction: CreateAdAuctionResult;
  /** Create one asset */
  createAsset: Maybe<Asset>;
  /** Create one faq */
  createFaq: Maybe<Faq>;
  /** Create one legal */
  createLegal: Maybe<Legal>;
  /** Create one post */
  createPost: Maybe<Post>;
  /** Create one scheduledRelease */
  createScheduledRelease: Maybe<ScheduledRelease>;
  /** Create one teammate */
  createTeammate: Maybe<Teammate>;
  create_customer_payment_method: Maybe<SetupIntentGql>;
  create_customer_subscription: PaymentIntentGql;
  create_file: CreateFileResult;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset: Maybe<Asset>;
  /** Delete one faq from _all_ existing stages. Returns deleted document. */
  deleteFaq: Maybe<Faq>;
  /** Delete one legal from _all_ existing stages. Returns deleted document. */
  deleteLegal: Maybe<Legal>;
  /** Delete many Asset documents */
  deleteManyAssets: BatchPayload;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /** Delete many Faq documents */
  deleteManyFaqs: BatchPayload;
  /** Delete many Faq documents, return deleted documents */
  deleteManyFaqsConnection: FaqConnection;
  /** Delete many Legal documents */
  deleteManyLegals: BatchPayload;
  /** Delete many Legal documents, return deleted documents */
  deleteManyLegalsConnection: LegalConnection;
  /** Delete many Post documents */
  deleteManyPosts: BatchPayload;
  /** Delete many Post documents, return deleted documents */
  deleteManyPostsConnection: PostConnection;
  /** Delete many Teammate documents */
  deleteManyTeammates: BatchPayload;
  /** Delete many Teammate documents, return deleted documents */
  deleteManyTeammatesConnection: TeammateConnection;
  /** Delete one post from _all_ existing stages. Returns deleted document. */
  deletePost: Maybe<Post>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease: Maybe<ScheduledRelease>;
  /** Delete one teammate from _all_ existing stages. Returns deleted document. */
  deleteTeammate: Maybe<Teammate>;
  /** delete data from the table: "AS20DEM" */
  delete_AS20DEM: Maybe<As20Dem_Mutation_Response>;
  /** delete single row from the table: "AS20DEM" */
  delete_AS20DEM_by_pk: Maybe<As20Dem>;
  /** delete data from the table: "AS20SVC1" */
  delete_AS20SVC1: Maybe<As20Svc1_Mutation_Response>;
  /** delete single row from the table: "AS20SVC1" */
  delete_AS20SVC1_by_pk: Maybe<As20Svc1>;
  /** delete data from the table: "AS20SVC2" */
  delete_AS20SVC2: Maybe<As20Svc2_Mutation_Response>;
  /** delete single row from the table: "AS20SVC2" */
  delete_AS20SVC2_by_pk: Maybe<As20Svc2>;
  /** delete data from the table: "AS20SVC3" */
  delete_AS20SVC3: Maybe<As20Svc3_Mutation_Response>;
  /** delete single row from the table: "AS20SVC3" */
  delete_AS20SVC3_by_pk: Maybe<As20Svc3>;
  /** delete data from the table: "AS20UTIL1" */
  delete_AS20UTIL1: Maybe<As20Util1_Mutation_Response>;
  /** delete single row from the table: "AS20UTIL1" */
  delete_AS20UTIL1_by_pk: Maybe<As20Util1>;
  /** delete data from the table: "AS20UTIL2" */
  delete_AS20UTIL2: Maybe<As20Util2_Mutation_Response>;
  /** delete single row from the table: "AS20UTIL2" */
  delete_AS20UTIL2_by_pk: Maybe<As20Util2>;
  /** delete data from the table: "AS21DEM" */
  delete_AS21DEM: Maybe<As21Dem_Mutation_Response>;
  /** delete single row from the table: "AS21DEM" */
  delete_AS21DEM_by_pk: Maybe<As21Dem>;
  /** delete data from the table: "AS21SVC1" */
  delete_AS21SVC1: Maybe<As21Svc1_Mutation_Response>;
  /** delete single row from the table: "AS21SVC1" */
  delete_AS21SVC1_by_pk: Maybe<As21Svc1>;
  /** delete data from the table: "AS21SVC2" */
  delete_AS21SVC2: Maybe<As21Svc2_Mutation_Response>;
  /** delete single row from the table: "AS21SVC2" */
  delete_AS21SVC2_by_pk: Maybe<As21Svc2>;
  /** delete data from the table: "AS21SVC3" */
  delete_AS21SVC3: Maybe<As21Svc3_Mutation_Response>;
  /** delete single row from the table: "AS21SVC3" */
  delete_AS21SVC3_by_pk: Maybe<As21Svc3>;
  /** delete data from the table: "AS21UNIT" */
  delete_AS21UNIT: Maybe<As21Unit_Mutation_Response>;
  /** delete single row from the table: "AS21UNIT" */
  delete_AS21UNIT_by_pk: Maybe<As21Unit>;
  /** delete data from the table: "AS21UTIL" */
  delete_AS21UTIL: Maybe<As21Util_Mutation_Response>;
  /** delete data from the table: "AS21UTIL2" */
  delete_AS21UTIL2: Maybe<As21Util2_Mutation_Response>;
  /** delete single row from the table: "AS21UTIL2" */
  delete_AS21UTIL2_by_pk: Maybe<As21Util2>;
  /** delete single row from the table: "AS21UTIL" */
  delete_AS21UTIL_by_pk: Maybe<As21Util>;
  /** delete data from the table: "AS22DEM" */
  delete_AS22DEM: Maybe<As22Dem_Mutation_Response>;
  /** delete single row from the table: "AS22DEM" */
  delete_AS22DEM_by_pk: Maybe<As22Dem>;
  /** delete data from the table: "AS22SVC1" */
  delete_AS22SVC1: Maybe<As22Svc1_Mutation_Response>;
  /** delete single row from the table: "AS22SVC1" */
  delete_AS22SVC1_by_pk: Maybe<As22Svc1>;
  /** delete data from the table: "AS22SVC2" */
  delete_AS22SVC2: Maybe<As22Svc2_Mutation_Response>;
  /** delete single row from the table: "AS22SVC2" */
  delete_AS22SVC2_by_pk: Maybe<As22Svc2>;
  /** delete data from the table: "AS22SVC3" */
  delete_AS22SVC3: Maybe<As22Svc3_Mutation_Response>;
  /** delete single row from the table: "AS22SVC3" */
  delete_AS22SVC3_by_pk: Maybe<As22Svc3>;
  /** delete data from the table: "AS22UNIT" */
  delete_AS22UNIT: Maybe<As22Unit_Mutation_Response>;
  /** delete single row from the table: "AS22UNIT" */
  delete_AS22UNIT_by_pk: Maybe<As22Unit>;
  /** delete data from the table: "AS22UTIL" */
  delete_AS22UTIL: Maybe<As22Util_Mutation_Response>;
  /** delete data from the table: "AS22UTIL2" */
  delete_AS22UTIL2: Maybe<As22Util2_Mutation_Response>;
  /** delete single row from the table: "AS22UTIL2" */
  delete_AS22UTIL2_by_pk: Maybe<As22Util2>;
  /** delete single row from the table: "AS22UTIL" */
  delete_AS22UTIL_by_pk: Maybe<As22Util>;
  /** delete data from the table: "ab_test" */
  delete_ab_test: Maybe<Ab_Test_Mutation_Response>;
  /** delete single row from the table: "ab_test" */
  delete_ab_test_by_pk: Maybe<Ab_Test>;
  /** delete data from the table: "access_info" */
  delete_access_info: Maybe<Access_Info_Mutation_Response>;
  /** delete data from the table: "account" */
  delete_account: Maybe<Account_Mutation_Response>;
  /** delete single row from the table: "account" */
  delete_account_by_pk: Maybe<Account>;
  /** delete data from the table: "account_role" */
  delete_account_role: Maybe<Account_Role_Mutation_Response>;
  /** delete single row from the table: "account_role" */
  delete_account_role_by_pk: Maybe<Account_Role>;
  /** delete data from the table: "acep_org_survey" */
  delete_acep_org_survey: Maybe<Acep_Org_Survey_Mutation_Response>;
  /** delete single row from the table: "acep_org_survey" */
  delete_acep_org_survey_by_pk: Maybe<Acep_Org_Survey>;
  /** delete data from the table: "board" */
  delete_board: Maybe<Board_Mutation_Response>;
  /** delete single row from the table: "board" */
  delete_board_by_pk: Maybe<Board>;
  /** delete data from the table: "board_cert" */
  delete_board_cert: Maybe<Board_Cert_Mutation_Response>;
  /** delete single row from the table: "board_cert" */
  delete_board_cert_by_pk: Maybe<Board_Cert>;
  /** delete data from the table: "candidate" */
  delete_candidate: Maybe<Candidate_Mutation_Response>;
  /** delete single row from the table: "candidate" */
  delete_candidate_by_pk: Maybe<Candidate>;
  /** delete data from the table: "cert_org" */
  delete_cert_org: Maybe<Cert_Org_Mutation_Response>;
  /** delete single row from the table: "cert_org" */
  delete_cert_org_by_pk: Maybe<Cert_Org>;
  /** delete data from the table: "clerkship" */
  delete_clerkship: Maybe<Clerkship_Mutation_Response>;
  /** delete single row from the table: "clerkship" */
  delete_clerkship_by_pk: Maybe<Clerkship>;
  /** delete data from the table: "clerkship_survey" */
  delete_clerkship_survey: Maybe<Clerkship_Survey_Mutation_Response>;
  /** delete single row from the table: "clerkship_survey" */
  delete_clerkship_survey_by_pk: Maybe<Clerkship_Survey>;
  /** delete data from the table: "clinician" */
  delete_clinician: Maybe<Clinician_Mutation_Response>;
  /** delete data from the table: "clinician_app_cert" */
  delete_clinician_app_cert: Maybe<Clinician_App_Cert_Mutation_Response>;
  /** delete single row from the table: "clinician_app_cert" */
  delete_clinician_app_cert_by_pk: Maybe<Clinician_App_Cert>;
  /** delete data from the table: "clinician_board_cert" */
  delete_clinician_board_cert: Maybe<Clinician_Board_Cert_Mutation_Response>;
  /** delete single row from the table: "clinician_board_cert" */
  delete_clinician_board_cert_by_pk: Maybe<Clinician_Board_Cert>;
  /** delete single row from the table: "clinician" */
  delete_clinician_by_pk: Maybe<Clinician>;
  /** delete data from the table: "clinician_license" */
  delete_clinician_license: Maybe<Clinician_License_Mutation_Response>;
  /** delete single row from the table: "clinician_license" */
  delete_clinician_license_by_pk: Maybe<Clinician_License>;
  /** delete data from the table: "clinician_sp_exp" */
  delete_clinician_sp_exp: Maybe<Clinician_Sp_Exp_Mutation_Response>;
  /** delete single row from the table: "clinician_sp_exp" */
  delete_clinician_sp_exp_by_pk: Maybe<Clinician_Sp_Exp>;
  /** delete data from the table: "clinician_specialty" */
  delete_clinician_specialty: Maybe<Clinician_Specialty_Mutation_Response>;
  /** delete single row from the table: "clinician_specialty" */
  delete_clinician_specialty_by_pk: Maybe<Clinician_Specialty>;
  /** delete data from the table: "clinician_training" */
  delete_clinician_training: Maybe<Clinician_Training_Mutation_Response>;
  /** delete single row from the table: "clinician_training" */
  delete_clinician_training_by_pk: Maybe<Clinician_Training>;
  /** delete data from the table: "cms_facility" */
  delete_cms_facility: Maybe<Cms_Facility_Mutation_Response>;
  /** delete single row from the table: "cms_facility" */
  delete_cms_facility_by_pk: Maybe<Cms_Facility>;
  /** delete data from the table: "cms_facility_enrollment" */
  delete_cms_facility_enrollment: Maybe<Cms_Facility_Enrollment_Mutation_Response>;
  /** delete single row from the table: "cms_facility_enrollment" */
  delete_cms_facility_enrollment_by_pk: Maybe<Cms_Facility_Enrollment>;
  /** delete data from the table: "cms_facility_metric" */
  delete_cms_facility_metric: Maybe<Cms_Facility_Metric_Mutation_Response>;
  /** delete single row from the table: "cms_facility_metric" */
  delete_cms_facility_metric_by_pk: Maybe<Cms_Facility_Metric>;
  /** delete data from the table: "cms_facility_pos" */
  delete_cms_facility_pos: Maybe<Cms_Facility_Pos_Mutation_Response>;
  /** delete single row from the table: "cms_facility_pos" */
  delete_cms_facility_pos_by_pk: Maybe<Cms_Facility_Pos>;
  /** delete data from the table: "cms_specialty" */
  delete_cms_specialty: Maybe<Cms_Specialty_Mutation_Response>;
  /** delete single row from the table: "cms_specialty" */
  delete_cms_specialty_by_pk: Maybe<Cms_Specialty>;
  /** delete data from the table: "contact_info" */
  delete_contact_info: Maybe<Contact_Info_Mutation_Response>;
  /** delete data from the table: "current_account" */
  delete_current_account: Maybe<Current_Account_Mutation_Response>;
  delete_customer_payment_method: SuccessResult;
  delete_customer_subscription: SuccessResult;
  /** delete data from the table: "email_contact" */
  delete_email_contact: Maybe<Email_Contact_Mutation_Response>;
  /** delete single row from the table: "email_contact" */
  delete_email_contact_by_pk: Maybe<Email_Contact>;
  /** delete data from the table: "email_envelope" */
  delete_email_envelope: Maybe<Email_Envelope_Mutation_Response>;
  /** delete single row from the table: "email_envelope" */
  delete_email_envelope_by_pk: Maybe<Email_Envelope>;
  /** delete data from the table: "email_event" */
  delete_email_event: Maybe<Email_Event_Mutation_Response>;
  /** delete single row from the table: "email_event" */
  delete_email_event_by_pk: Maybe<Email_Event>;
  /** delete data from the table: "email_message" */
  delete_email_message: Maybe<Email_Message_Mutation_Response>;
  /** delete single row from the table: "email_message" */
  delete_email_message_by_pk: Maybe<Email_Message>;
  /** delete data from the table: "email_pointer" */
  delete_email_pointer: Maybe<Email_Pointer_Mutation_Response>;
  /** delete single row from the table: "email_pointer" */
  delete_email_pointer_by_pk: Maybe<Email_Pointer>;
  /** delete data from the table: "ext_job_posting" */
  delete_ext_job_posting: Maybe<Ext_Job_Posting_Mutation_Response>;
  /** delete single row from the table: "ext_job_posting" */
  delete_ext_job_posting_by_pk: Maybe<Ext_Job_Posting>;
  /** delete data from the table: "ext_job_scrape" */
  delete_ext_job_scrape: Maybe<Ext_Job_Scrape_Mutation_Response>;
  /** delete single row from the table: "ext_job_scrape" */
  delete_ext_job_scrape_by_pk: Maybe<Ext_Job_Scrape>;
  /** delete data from the table: "ext_posting_error" */
  delete_ext_posting_error: Maybe<Ext_Posting_Error_Mutation_Response>;
  /** delete single row from the table: "ext_posting_error" */
  delete_ext_posting_error_by_pk: Maybe<Ext_Posting_Error>;
  /** delete data from the table: "ext_posting_profession" */
  delete_ext_posting_profession: Maybe<Ext_Posting_Profession_Mutation_Response>;
  /** delete single row from the table: "ext_posting_profession" */
  delete_ext_posting_profession_by_pk: Maybe<Ext_Posting_Profession>;
  /** delete data from the table: "facility" */
  delete_facility: Maybe<Facility_Mutation_Response>;
  /** delete data from the table: "facility_accreditation" */
  delete_facility_accreditation: Maybe<Facility_Accreditation_Mutation_Response>;
  /** delete single row from the table: "facility_accreditation" */
  delete_facility_accreditation_by_pk: Maybe<Facility_Accreditation>;
  /** delete single row from the table: "facility" */
  delete_facility_by_pk: Maybe<Facility>;
  /** delete data from the table: "facility_contract" */
  delete_facility_contract: Maybe<Facility_Contract_Mutation_Response>;
  /** delete single row from the table: "facility_contract" */
  delete_facility_contract_by_pk: Maybe<Facility_Contract>;
  /** delete data from the table: "facility_contract_featured" */
  delete_facility_contract_featured: Maybe<Facility_Contract_Featured_Mutation_Response>;
  /** delete single row from the table: "facility_contract_featured" */
  delete_facility_contract_featured_by_pk: Maybe<Facility_Contract_Featured>;
  /** delete data from the table: "facility_correction" */
  delete_facility_correction: Maybe<Facility_Correction_Mutation_Response>;
  /** delete single row from the table: "facility_correction" */
  delete_facility_correction_by_pk: Maybe<Facility_Correction>;
  /** delete data from the table: "facility_dist_result" */
  delete_facility_dist_result: Maybe<Facility_Dist_Result_Mutation_Response>;
  /** delete data from the table: "facility_ehr" */
  delete_facility_ehr: Maybe<Facility_Ehr_Mutation_Response>;
  /** delete single row from the table: "facility_ehr" */
  delete_facility_ehr_by_pk: Maybe<Facility_Ehr>;
  /** delete data from the table: "favorite" */
  delete_favorite: Maybe<Favorite_Mutation_Response>;
  /** delete single row from the table: "favorite" */
  delete_favorite_by_pk: Maybe<Favorite>;
  /** delete data from the table: "featured_clerkship_dist_result" */
  delete_featured_clerkship_dist_result: Maybe<Featured_Clerkship_Dist_Result_Mutation_Response>;
  /** delete data from the table: "featured_fellowship_dist_result" */
  delete_featured_fellowship_dist_result: Maybe<Featured_Fellowship_Dist_Result_Mutation_Response>;
  /** delete data from the table: "featured_residency_dist_result" */
  delete_featured_residency_dist_result: Maybe<Featured_Residency_Dist_Result_Mutation_Response>;
  /** delete data from the table: "fellowship" */
  delete_fellowship: Maybe<Fellowship_Mutation_Response>;
  /** delete single row from the table: "fellowship" */
  delete_fellowship_by_pk: Maybe<Fellowship>;
  /** delete data from the table: "fellowship_survey" */
  delete_fellowship_survey: Maybe<Fellowship_Survey_Mutation_Response>;
  /** delete single row from the table: "fellowship_survey" */
  delete_fellowship_survey_by_pk: Maybe<Fellowship_Survey>;
  /** delete data from the table: "file" */
  delete_file: Maybe<File_Mutation_Response>;
  /** delete single row from the table: "file" */
  delete_file_by_pk: Maybe<File>;
  /** delete data from the table: "fsmb_bio" */
  delete_fsmb_bio: Maybe<Fsmb_Bio_Mutation_Response>;
  /** delete single row from the table: "fsmb_bio" */
  delete_fsmb_bio_by_pk: Maybe<Fsmb_Bio>;
  /** delete data from the table: "fsmb_licensure" */
  delete_fsmb_licensure: Maybe<Fsmb_Licensure_Mutation_Response>;
  /** delete single row from the table: "fsmb_licensure" */
  delete_fsmb_licensure_by_pk: Maybe<Fsmb_Licensure>;
  /** delete data from the table: "gmaps_link" */
  delete_gmaps_link: Maybe<Gmaps_Link_Mutation_Response>;
  /** delete single row from the table: "gmaps_link" */
  delete_gmaps_link_by_pk: Maybe<Gmaps_Link>;
  /** delete data from the table: "gmaps_link_type" */
  delete_gmaps_link_type: Maybe<Gmaps_Link_Type_Mutation_Response>;
  /** delete single row from the table: "gmaps_link_type" */
  delete_gmaps_link_type_by_pk: Maybe<Gmaps_Link_Type>;
  /** delete data from the table: "gmaps_place" */
  delete_gmaps_place: Maybe<Gmaps_Place_Mutation_Response>;
  /** delete single row from the table: "gmaps_place" */
  delete_gmaps_place_by_pk: Maybe<Gmaps_Place>;
  /** delete data from the table: "identity_provider" */
  delete_identity_provider: Maybe<Identity_Provider_Mutation_Response>;
  /** delete single row from the table: "identity_provider" */
  delete_identity_provider_by_pk: Maybe<Identity_Provider>;
  /** delete data from the table: "job_application" */
  delete_job_application: Maybe<Job_Application_Mutation_Response>;
  /** delete data from the table: "job_application_batch" */
  delete_job_application_batch: Maybe<Job_Application_Batch_Mutation_Response>;
  /** delete single row from the table: "job_application_batch" */
  delete_job_application_batch_by_pk: Maybe<Job_Application_Batch>;
  /** delete single row from the table: "job_application" */
  delete_job_application_by_pk: Maybe<Job_Application>;
  /** delete data from the table: "job_application_posting" */
  delete_job_application_posting: Maybe<Job_Application_Posting_Mutation_Response>;
  /** delete single row from the table: "job_application_posting" */
  delete_job_application_posting_by_pk: Maybe<Job_Application_Posting>;
  /** delete data from the table: "job_posting" */
  delete_job_posting: Maybe<Job_Posting_Mutation_Response>;
  /** delete single row from the table: "job_posting" */
  delete_job_posting_by_pk: Maybe<Job_Posting>;
  /** delete data from the table: "nearby_facilities_by_geography_result" */
  delete_nearby_facilities_by_geography_result: Maybe<Nearby_Facilities_By_Geography_Result_Mutation_Response>;
  /** delete data from the table: "org_dist_result" */
  delete_org_dist_result: Maybe<Org_Dist_Result_Mutation_Response>;
  /** delete data from the table: "org_domain" */
  delete_org_domain: Maybe<Org_Domain_Mutation_Response>;
  /** delete single row from the table: "org_domain" */
  delete_org_domain_by_pk: Maybe<Org_Domain>;
  /** delete data from the table: "org_user" */
  delete_org_user: Maybe<Org_User_Mutation_Response>;
  /** delete single row from the table: "org_user" */
  delete_org_user_by_pk: Maybe<Org_User>;
  /** delete data from the table: "organization" */
  delete_organization: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk: Maybe<Organization>;
  /** delete data from the table: "personal_info" */
  delete_personal_info: Maybe<Personal_Info_Mutation_Response>;
  /** delete data from the table: "place_boundary" */
  delete_place_boundary: Maybe<Place_Boundary_Mutation_Response>;
  /** delete single row from the table: "place_boundary" */
  delete_place_boundary_by_pk: Maybe<Place_Boundary>;
  /** delete data from the table: "posting_app_cert" */
  delete_posting_app_cert: Maybe<Posting_App_Cert_Mutation_Response>;
  /** delete single row from the table: "posting_app_cert" */
  delete_posting_app_cert_by_pk: Maybe<Posting_App_Cert>;
  /** delete data from the table: "posting_board_cert" */
  delete_posting_board_cert: Maybe<Posting_Board_Cert_Mutation_Response>;
  /** delete single row from the table: "posting_board_cert" */
  delete_posting_board_cert_by_pk: Maybe<Posting_Board_Cert>;
  /** delete data from the table: "posting_profession" */
  delete_posting_profession: Maybe<Posting_Profession_Mutation_Response>;
  /** delete single row from the table: "posting_profession" */
  delete_posting_profession_by_pk: Maybe<Posting_Profession>;
  /** delete data from the table: "posting_worker_classification" */
  delete_posting_worker_classification: Maybe<Posting_Worker_Classification_Mutation_Response>;
  /** delete single row from the table: "posting_worker_classification" */
  delete_posting_worker_classification_by_pk: Maybe<Posting_Worker_Classification>;
  /** delete data from the table: "relevant_job_posting" */
  delete_relevant_job_posting: Maybe<Relevant_Job_Posting_Mutation_Response>;
  /** delete data from the table: "relevant_salary_report" */
  delete_relevant_salary_report: Maybe<Relevant_Salary_Report_Mutation_Response>;
  /** delete data from the table: "residency" */
  delete_residency: Maybe<Residency_Mutation_Response>;
  /** delete single row from the table: "residency" */
  delete_residency_by_pk: Maybe<Residency>;
  /** delete data from the table: "residency_survey" */
  delete_residency_survey: Maybe<Residency_Survey_Mutation_Response>;
  /** delete single row from the table: "residency_survey" */
  delete_residency_survey_by_pk: Maybe<Residency_Survey>;
  /** delete data from the table: "review" */
  delete_review: Maybe<Review_Mutation_Response>;
  /** delete single row from the table: "review" */
  delete_review_by_pk: Maybe<Review>;
  /** delete data from the table: "review_reply" */
  delete_review_reply: Maybe<Review_Reply_Mutation_Response>;
  /** delete single row from the table: "review_reply" */
  delete_review_reply_by_pk: Maybe<Review_Reply>;
  /** delete data from the table: "review_report" */
  delete_review_report: Maybe<Review_Report_Mutation_Response>;
  /** delete single row from the table: "review_report" */
  delete_review_report_by_pk: Maybe<Review_Report>;
  /** delete data from the table: "review_vote" */
  delete_review_vote: Maybe<Review_Vote_Mutation_Response>;
  /** delete single row from the table: "review_vote" */
  delete_review_vote_by_pk: Maybe<Review_Vote>;
  /** delete data from the table: "salary_report" */
  delete_salary_report: Maybe<Salary_Report_Mutation_Response>;
  /** delete single row from the table: "salary_report" */
  delete_salary_report_by_pk: Maybe<Salary_Report>;
  /** delete data from the table: "salary_report_fmt" */
  delete_salary_report_fmt: Maybe<Salary_Report_Fmt_Mutation_Response>;
  /** delete data from the table: "school" */
  delete_school: Maybe<School_Mutation_Response>;
  /** delete single row from the table: "school" */
  delete_school_by_pk: Maybe<School>;
  /** delete data from the table: "search_candidate_result" */
  delete_search_candidate_result: Maybe<Search_Candidate_Result_Mutation_Response>;
  /** delete data from the table: "search_clerkship_by_geography_result" */
  delete_search_clerkship_by_geography_result: Maybe<Search_Clerkship_By_Geography_Result_Mutation_Response>;
  /** delete data from the table: "search_facility_by_prefix_result" */
  delete_search_facility_by_prefix_result: Maybe<Search_Facility_By_Prefix_Result_Mutation_Response>;
  /** delete data from the table: "search_fellowship_by_geography_result" */
  delete_search_fellowship_by_geography_result: Maybe<Search_Fellowship_By_Geography_Result_Mutation_Response>;
  /** delete data from the table: "search_fsmb_bio_result" */
  delete_search_fsmb_bio_result: Maybe<Search_Fsmb_Bio_Result_Mutation_Response>;
  /** delete data from the table: "search_job_postings_by_geography_result" */
  delete_search_job_postings_by_geography_result: Maybe<Search_Job_Postings_By_Geography_Result_Mutation_Response>;
  /** delete data from the table: "search_org_market_result" */
  delete_search_org_market_result: Maybe<Search_Org_Market_Result_Mutation_Response>;
  /** delete data from the table: "search_organization_by_prefix_result" */
  delete_search_organization_by_prefix_result: Maybe<Search_Organization_By_Prefix_Result_Mutation_Response>;
  /** delete data from the table: "search_residency_by_geography_result" */
  delete_search_residency_by_geography_result: Maybe<Search_Residency_By_Geography_Result_Mutation_Response>;
  /** delete data from the table: "search_training_by_prefix_result" */
  delete_search_training_by_prefix_result: Maybe<Search_Training_By_Prefix_Result_Mutation_Response>;
  /** delete data from the table: "site" */
  delete_site: Maybe<Site_Mutation_Response>;
  /** delete single row from the table: "site" */
  delete_site_by_pk: Maybe<Site>;
  /** delete data from the table: "stroke_cert" */
  delete_stroke_cert: Maybe<Stroke_Cert_Mutation_Response>;
  /** delete single row from the table: "stroke_cert" */
  delete_stroke_cert_by_pk: Maybe<Stroke_Cert>;
  /** delete data from the table: "training" */
  delete_training: Maybe<Training_Mutation_Response>;
  /** delete single row from the table: "training" */
  delete_training_by_pk: Maybe<Training>;
  /** delete data from the table: "training_event" */
  delete_training_event: Maybe<Training_Event_Mutation_Response>;
  /** delete single row from the table: "training_event" */
  delete_training_event_by_pk: Maybe<Training_Event>;
  /** delete data from the table: "training_field" */
  delete_training_field: Maybe<Training_Field_Mutation_Response>;
  /** delete single row from the table: "training_field" */
  delete_training_field_by_pk: Maybe<Training_Field>;
  /** delete data from the table: "training_program" */
  delete_training_program: Maybe<Training_Program_Mutation_Response>;
  /** delete single row from the table: "training_program" */
  delete_training_program_by_pk: Maybe<Training_Program>;
  /** delete data from the table: "training_survey" */
  delete_training_survey: Maybe<Training_Survey_Mutation_Response>;
  /** delete single row from the table: "training_survey" */
  delete_training_survey_by_pk: Maybe<Training_Survey>;
  /** delete data from the table: "training_survey_picture" */
  delete_training_survey_picture: Maybe<Training_Survey_Picture_Mutation_Response>;
  /** delete single row from the table: "training_survey_picture" */
  delete_training_survey_picture_by_pk: Maybe<Training_Survey_Picture>;
  /** delete data from the table: "training_survey_site" */
  delete_training_survey_site: Maybe<Training_Survey_Site_Mutation_Response>;
  /** delete single row from the table: "training_survey_site" */
  delete_training_survey_site_by_pk: Maybe<Training_Survey_Site>;
  finalize_email_change: SuccessResult;
  finalize_file: FinalizeFileResult;
  finalize_signup: FinalizeSignupResult;
  import_credentials: ImportCredentialsResult;
  /** insert data into the table: "AS20DEM" */
  insert_AS20DEM: Maybe<As20Dem_Mutation_Response>;
  /** insert a single row into the table: "AS20DEM" */
  insert_AS20DEM_one: Maybe<As20Dem>;
  /** insert data into the table: "AS20SVC1" */
  insert_AS20SVC1: Maybe<As20Svc1_Mutation_Response>;
  /** insert a single row into the table: "AS20SVC1" */
  insert_AS20SVC1_one: Maybe<As20Svc1>;
  /** insert data into the table: "AS20SVC2" */
  insert_AS20SVC2: Maybe<As20Svc2_Mutation_Response>;
  /** insert a single row into the table: "AS20SVC2" */
  insert_AS20SVC2_one: Maybe<As20Svc2>;
  /** insert data into the table: "AS20SVC3" */
  insert_AS20SVC3: Maybe<As20Svc3_Mutation_Response>;
  /** insert a single row into the table: "AS20SVC3" */
  insert_AS20SVC3_one: Maybe<As20Svc3>;
  /** insert data into the table: "AS20UTIL1" */
  insert_AS20UTIL1: Maybe<As20Util1_Mutation_Response>;
  /** insert a single row into the table: "AS20UTIL1" */
  insert_AS20UTIL1_one: Maybe<As20Util1>;
  /** insert data into the table: "AS20UTIL2" */
  insert_AS20UTIL2: Maybe<As20Util2_Mutation_Response>;
  /** insert a single row into the table: "AS20UTIL2" */
  insert_AS20UTIL2_one: Maybe<As20Util2>;
  /** insert data into the table: "AS21DEM" */
  insert_AS21DEM: Maybe<As21Dem_Mutation_Response>;
  /** insert a single row into the table: "AS21DEM" */
  insert_AS21DEM_one: Maybe<As21Dem>;
  /** insert data into the table: "AS21SVC1" */
  insert_AS21SVC1: Maybe<As21Svc1_Mutation_Response>;
  /** insert a single row into the table: "AS21SVC1" */
  insert_AS21SVC1_one: Maybe<As21Svc1>;
  /** insert data into the table: "AS21SVC2" */
  insert_AS21SVC2: Maybe<As21Svc2_Mutation_Response>;
  /** insert a single row into the table: "AS21SVC2" */
  insert_AS21SVC2_one: Maybe<As21Svc2>;
  /** insert data into the table: "AS21SVC3" */
  insert_AS21SVC3: Maybe<As21Svc3_Mutation_Response>;
  /** insert a single row into the table: "AS21SVC3" */
  insert_AS21SVC3_one: Maybe<As21Svc3>;
  /** insert data into the table: "AS21UNIT" */
  insert_AS21UNIT: Maybe<As21Unit_Mutation_Response>;
  /** insert a single row into the table: "AS21UNIT" */
  insert_AS21UNIT_one: Maybe<As21Unit>;
  /** insert data into the table: "AS21UTIL" */
  insert_AS21UTIL: Maybe<As21Util_Mutation_Response>;
  /** insert data into the table: "AS21UTIL2" */
  insert_AS21UTIL2: Maybe<As21Util2_Mutation_Response>;
  /** insert a single row into the table: "AS21UTIL2" */
  insert_AS21UTIL2_one: Maybe<As21Util2>;
  /** insert a single row into the table: "AS21UTIL" */
  insert_AS21UTIL_one: Maybe<As21Util>;
  /** insert data into the table: "AS22DEM" */
  insert_AS22DEM: Maybe<As22Dem_Mutation_Response>;
  /** insert a single row into the table: "AS22DEM" */
  insert_AS22DEM_one: Maybe<As22Dem>;
  /** insert data into the table: "AS22SVC1" */
  insert_AS22SVC1: Maybe<As22Svc1_Mutation_Response>;
  /** insert a single row into the table: "AS22SVC1" */
  insert_AS22SVC1_one: Maybe<As22Svc1>;
  /** insert data into the table: "AS22SVC2" */
  insert_AS22SVC2: Maybe<As22Svc2_Mutation_Response>;
  /** insert a single row into the table: "AS22SVC2" */
  insert_AS22SVC2_one: Maybe<As22Svc2>;
  /** insert data into the table: "AS22SVC3" */
  insert_AS22SVC3: Maybe<As22Svc3_Mutation_Response>;
  /** insert a single row into the table: "AS22SVC3" */
  insert_AS22SVC3_one: Maybe<As22Svc3>;
  /** insert data into the table: "AS22UNIT" */
  insert_AS22UNIT: Maybe<As22Unit_Mutation_Response>;
  /** insert a single row into the table: "AS22UNIT" */
  insert_AS22UNIT_one: Maybe<As22Unit>;
  /** insert data into the table: "AS22UTIL" */
  insert_AS22UTIL: Maybe<As22Util_Mutation_Response>;
  /** insert data into the table: "AS22UTIL2" */
  insert_AS22UTIL2: Maybe<As22Util2_Mutation_Response>;
  /** insert a single row into the table: "AS22UTIL2" */
  insert_AS22UTIL2_one: Maybe<As22Util2>;
  /** insert a single row into the table: "AS22UTIL" */
  insert_AS22UTIL_one: Maybe<As22Util>;
  /** insert data into the table: "ab_test" */
  insert_ab_test: Maybe<Ab_Test_Mutation_Response>;
  /** insert a single row into the table: "ab_test" */
  insert_ab_test_one: Maybe<Ab_Test>;
  /** insert data into the table: "access_info" */
  insert_access_info: Maybe<Access_Info_Mutation_Response>;
  /** insert a single row into the table: "access_info" */
  insert_access_info_one: Maybe<Access_Info>;
  /** insert data into the table: "account" */
  insert_account: Maybe<Account_Mutation_Response>;
  /** insert a single row into the table: "account" */
  insert_account_one: Maybe<Account>;
  /** insert data into the table: "account_role" */
  insert_account_role: Maybe<Account_Role_Mutation_Response>;
  /** insert a single row into the table: "account_role" */
  insert_account_role_one: Maybe<Account_Role>;
  /** insert data into the table: "acep_org_survey" */
  insert_acep_org_survey: Maybe<Acep_Org_Survey_Mutation_Response>;
  /** insert a single row into the table: "acep_org_survey" */
  insert_acep_org_survey_one: Maybe<Acep_Org_Survey>;
  /** insert data into the table: "board" */
  insert_board: Maybe<Board_Mutation_Response>;
  /** insert data into the table: "board_cert" */
  insert_board_cert: Maybe<Board_Cert_Mutation_Response>;
  /** insert a single row into the table: "board_cert" */
  insert_board_cert_one: Maybe<Board_Cert>;
  /** insert a single row into the table: "board" */
  insert_board_one: Maybe<Board>;
  /** insert data into the table: "candidate" */
  insert_candidate: Maybe<Candidate_Mutation_Response>;
  /** insert a single row into the table: "candidate" */
  insert_candidate_one: Maybe<Candidate>;
  /** insert data into the table: "cert_org" */
  insert_cert_org: Maybe<Cert_Org_Mutation_Response>;
  /** insert a single row into the table: "cert_org" */
  insert_cert_org_one: Maybe<Cert_Org>;
  /** insert data into the table: "clerkship" */
  insert_clerkship: Maybe<Clerkship_Mutation_Response>;
  /** insert a single row into the table: "clerkship" */
  insert_clerkship_one: Maybe<Clerkship>;
  /** insert data into the table: "clerkship_survey" */
  insert_clerkship_survey: Maybe<Clerkship_Survey_Mutation_Response>;
  /** insert a single row into the table: "clerkship_survey" */
  insert_clerkship_survey_one: Maybe<Clerkship_Survey>;
  /** insert data into the table: "clinician" */
  insert_clinician: Maybe<Clinician_Mutation_Response>;
  /** insert data into the table: "clinician_app_cert" */
  insert_clinician_app_cert: Maybe<Clinician_App_Cert_Mutation_Response>;
  /** insert a single row into the table: "clinician_app_cert" */
  insert_clinician_app_cert_one: Maybe<Clinician_App_Cert>;
  /** insert data into the table: "clinician_board_cert" */
  insert_clinician_board_cert: Maybe<Clinician_Board_Cert_Mutation_Response>;
  /** insert a single row into the table: "clinician_board_cert" */
  insert_clinician_board_cert_one: Maybe<Clinician_Board_Cert>;
  /** insert data into the table: "clinician_license" */
  insert_clinician_license: Maybe<Clinician_License_Mutation_Response>;
  /** insert a single row into the table: "clinician_license" */
  insert_clinician_license_one: Maybe<Clinician_License>;
  /** insert a single row into the table: "clinician" */
  insert_clinician_one: Maybe<Clinician>;
  /** insert data into the table: "clinician_sp_exp" */
  insert_clinician_sp_exp: Maybe<Clinician_Sp_Exp_Mutation_Response>;
  /** insert a single row into the table: "clinician_sp_exp" */
  insert_clinician_sp_exp_one: Maybe<Clinician_Sp_Exp>;
  /** insert data into the table: "clinician_specialty" */
  insert_clinician_specialty: Maybe<Clinician_Specialty_Mutation_Response>;
  /** insert a single row into the table: "clinician_specialty" */
  insert_clinician_specialty_one: Maybe<Clinician_Specialty>;
  /** insert data into the table: "clinician_training" */
  insert_clinician_training: Maybe<Clinician_Training_Mutation_Response>;
  /** insert a single row into the table: "clinician_training" */
  insert_clinician_training_one: Maybe<Clinician_Training>;
  /** insert data into the table: "cms_facility" */
  insert_cms_facility: Maybe<Cms_Facility_Mutation_Response>;
  /** insert data into the table: "cms_facility_enrollment" */
  insert_cms_facility_enrollment: Maybe<Cms_Facility_Enrollment_Mutation_Response>;
  /** insert a single row into the table: "cms_facility_enrollment" */
  insert_cms_facility_enrollment_one: Maybe<Cms_Facility_Enrollment>;
  /** insert data into the table: "cms_facility_metric" */
  insert_cms_facility_metric: Maybe<Cms_Facility_Metric_Mutation_Response>;
  /** insert a single row into the table: "cms_facility_metric" */
  insert_cms_facility_metric_one: Maybe<Cms_Facility_Metric>;
  /** insert a single row into the table: "cms_facility" */
  insert_cms_facility_one: Maybe<Cms_Facility>;
  /** insert data into the table: "cms_facility_pos" */
  insert_cms_facility_pos: Maybe<Cms_Facility_Pos_Mutation_Response>;
  /** insert a single row into the table: "cms_facility_pos" */
  insert_cms_facility_pos_one: Maybe<Cms_Facility_Pos>;
  /** insert data into the table: "cms_specialty" */
  insert_cms_specialty: Maybe<Cms_Specialty_Mutation_Response>;
  /** insert a single row into the table: "cms_specialty" */
  insert_cms_specialty_one: Maybe<Cms_Specialty>;
  /** insert data into the table: "contact_info" */
  insert_contact_info: Maybe<Contact_Info_Mutation_Response>;
  /** insert a single row into the table: "contact_info" */
  insert_contact_info_one: Maybe<Contact_Info>;
  /** insert data into the table: "current_account" */
  insert_current_account: Maybe<Current_Account_Mutation_Response>;
  /** insert a single row into the table: "current_account" */
  insert_current_account_one: Maybe<Current_Account>;
  /** insert data into the table: "email_contact" */
  insert_email_contact: Maybe<Email_Contact_Mutation_Response>;
  /** insert a single row into the table: "email_contact" */
  insert_email_contact_one: Maybe<Email_Contact>;
  /** insert data into the table: "email_envelope" */
  insert_email_envelope: Maybe<Email_Envelope_Mutation_Response>;
  /** insert a single row into the table: "email_envelope" */
  insert_email_envelope_one: Maybe<Email_Envelope>;
  /** insert data into the table: "email_event" */
  insert_email_event: Maybe<Email_Event_Mutation_Response>;
  /** insert a single row into the table: "email_event" */
  insert_email_event_one: Maybe<Email_Event>;
  /** insert data into the table: "email_message" */
  insert_email_message: Maybe<Email_Message_Mutation_Response>;
  /** insert a single row into the table: "email_message" */
  insert_email_message_one: Maybe<Email_Message>;
  /** insert data into the table: "email_pointer" */
  insert_email_pointer: Maybe<Email_Pointer_Mutation_Response>;
  /** insert a single row into the table: "email_pointer" */
  insert_email_pointer_one: Maybe<Email_Pointer>;
  /** insert data into the table: "ext_job_posting" */
  insert_ext_job_posting: Maybe<Ext_Job_Posting_Mutation_Response>;
  /** insert a single row into the table: "ext_job_posting" */
  insert_ext_job_posting_one: Maybe<Ext_Job_Posting>;
  /** insert data into the table: "ext_job_scrape" */
  insert_ext_job_scrape: Maybe<Ext_Job_Scrape_Mutation_Response>;
  /** insert a single row into the table: "ext_job_scrape" */
  insert_ext_job_scrape_one: Maybe<Ext_Job_Scrape>;
  /** insert data into the table: "ext_posting_error" */
  insert_ext_posting_error: Maybe<Ext_Posting_Error_Mutation_Response>;
  /** insert a single row into the table: "ext_posting_error" */
  insert_ext_posting_error_one: Maybe<Ext_Posting_Error>;
  /** insert data into the table: "ext_posting_profession" */
  insert_ext_posting_profession: Maybe<Ext_Posting_Profession_Mutation_Response>;
  /** insert a single row into the table: "ext_posting_profession" */
  insert_ext_posting_profession_one: Maybe<Ext_Posting_Profession>;
  /** insert data into the table: "facility" */
  insert_facility: Maybe<Facility_Mutation_Response>;
  /** insert data into the table: "facility_accreditation" */
  insert_facility_accreditation: Maybe<Facility_Accreditation_Mutation_Response>;
  /** insert a single row into the table: "facility_accreditation" */
  insert_facility_accreditation_one: Maybe<Facility_Accreditation>;
  /** insert data into the table: "facility_contract" */
  insert_facility_contract: Maybe<Facility_Contract_Mutation_Response>;
  /** insert data into the table: "facility_contract_featured" */
  insert_facility_contract_featured: Maybe<Facility_Contract_Featured_Mutation_Response>;
  /** insert a single row into the table: "facility_contract_featured" */
  insert_facility_contract_featured_one: Maybe<Facility_Contract_Featured>;
  /** insert a single row into the table: "facility_contract" */
  insert_facility_contract_one: Maybe<Facility_Contract>;
  /** insert data into the table: "facility_correction" */
  insert_facility_correction: Maybe<Facility_Correction_Mutation_Response>;
  /** insert a single row into the table: "facility_correction" */
  insert_facility_correction_one: Maybe<Facility_Correction>;
  /** insert data into the table: "facility_dist_result" */
  insert_facility_dist_result: Maybe<Facility_Dist_Result_Mutation_Response>;
  /** insert a single row into the table: "facility_dist_result" */
  insert_facility_dist_result_one: Maybe<Facility_Dist_Result>;
  /** insert data into the table: "facility_ehr" */
  insert_facility_ehr: Maybe<Facility_Ehr_Mutation_Response>;
  /** insert a single row into the table: "facility_ehr" */
  insert_facility_ehr_one: Maybe<Facility_Ehr>;
  /** insert a single row into the table: "facility" */
  insert_facility_one: Maybe<Facility>;
  /** insert data into the table: "favorite" */
  insert_favorite: Maybe<Favorite_Mutation_Response>;
  /** insert a single row into the table: "favorite" */
  insert_favorite_one: Maybe<Favorite>;
  /** insert data into the table: "featured_clerkship_dist_result" */
  insert_featured_clerkship_dist_result: Maybe<Featured_Clerkship_Dist_Result_Mutation_Response>;
  /** insert a single row into the table: "featured_clerkship_dist_result" */
  insert_featured_clerkship_dist_result_one: Maybe<Featured_Clerkship_Dist_Result>;
  /** insert data into the table: "featured_fellowship_dist_result" */
  insert_featured_fellowship_dist_result: Maybe<Featured_Fellowship_Dist_Result_Mutation_Response>;
  /** insert a single row into the table: "featured_fellowship_dist_result" */
  insert_featured_fellowship_dist_result_one: Maybe<Featured_Fellowship_Dist_Result>;
  /** insert data into the table: "featured_residency_dist_result" */
  insert_featured_residency_dist_result: Maybe<Featured_Residency_Dist_Result_Mutation_Response>;
  /** insert a single row into the table: "featured_residency_dist_result" */
  insert_featured_residency_dist_result_one: Maybe<Featured_Residency_Dist_Result>;
  /** insert data into the table: "fellowship" */
  insert_fellowship: Maybe<Fellowship_Mutation_Response>;
  /** insert a single row into the table: "fellowship" */
  insert_fellowship_one: Maybe<Fellowship>;
  /** insert data into the table: "fellowship_survey" */
  insert_fellowship_survey: Maybe<Fellowship_Survey_Mutation_Response>;
  /** insert a single row into the table: "fellowship_survey" */
  insert_fellowship_survey_one: Maybe<Fellowship_Survey>;
  /** insert data into the table: "file" */
  insert_file: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "file" */
  insert_file_one: Maybe<File>;
  /** insert data into the table: "fsmb_bio" */
  insert_fsmb_bio: Maybe<Fsmb_Bio_Mutation_Response>;
  /** insert a single row into the table: "fsmb_bio" */
  insert_fsmb_bio_one: Maybe<Fsmb_Bio>;
  /** insert data into the table: "fsmb_licensure" */
  insert_fsmb_licensure: Maybe<Fsmb_Licensure_Mutation_Response>;
  /** insert a single row into the table: "fsmb_licensure" */
  insert_fsmb_licensure_one: Maybe<Fsmb_Licensure>;
  /** insert data into the table: "gmaps_link" */
  insert_gmaps_link: Maybe<Gmaps_Link_Mutation_Response>;
  /** insert a single row into the table: "gmaps_link" */
  insert_gmaps_link_one: Maybe<Gmaps_Link>;
  /** insert data into the table: "gmaps_link_type" */
  insert_gmaps_link_type: Maybe<Gmaps_Link_Type_Mutation_Response>;
  /** insert a single row into the table: "gmaps_link_type" */
  insert_gmaps_link_type_one: Maybe<Gmaps_Link_Type>;
  /** insert data into the table: "gmaps_place" */
  insert_gmaps_place: Maybe<Gmaps_Place_Mutation_Response>;
  /** insert a single row into the table: "gmaps_place" */
  insert_gmaps_place_one: Maybe<Gmaps_Place>;
  /** insert data into the table: "identity_provider" */
  insert_identity_provider: Maybe<Identity_Provider_Mutation_Response>;
  /** insert a single row into the table: "identity_provider" */
  insert_identity_provider_one: Maybe<Identity_Provider>;
  /** insert data into the table: "job_application" */
  insert_job_application: Maybe<Job_Application_Mutation_Response>;
  /** insert data into the table: "job_application_batch" */
  insert_job_application_batch: Maybe<Job_Application_Batch_Mutation_Response>;
  /** insert a single row into the table: "job_application_batch" */
  insert_job_application_batch_one: Maybe<Job_Application_Batch>;
  /** insert a single row into the table: "job_application" */
  insert_job_application_one: Maybe<Job_Application>;
  /** insert data into the table: "job_application_posting" */
  insert_job_application_posting: Maybe<Job_Application_Posting_Mutation_Response>;
  /** insert a single row into the table: "job_application_posting" */
  insert_job_application_posting_one: Maybe<Job_Application_Posting>;
  /** insert data into the table: "job_posting" */
  insert_job_posting: Maybe<Job_Posting_Mutation_Response>;
  /** insert a single row into the table: "job_posting" */
  insert_job_posting_one: Maybe<Job_Posting>;
  /** insert data into the table: "nearby_facilities_by_geography_result" */
  insert_nearby_facilities_by_geography_result: Maybe<Nearby_Facilities_By_Geography_Result_Mutation_Response>;
  /** insert a single row into the table: "nearby_facilities_by_geography_result" */
  insert_nearby_facilities_by_geography_result_one: Maybe<Nearby_Facilities_By_Geography_Result>;
  /** insert data into the table: "org_dist_result" */
  insert_org_dist_result: Maybe<Org_Dist_Result_Mutation_Response>;
  /** insert a single row into the table: "org_dist_result" */
  insert_org_dist_result_one: Maybe<Org_Dist_Result>;
  /** insert data into the table: "org_domain" */
  insert_org_domain: Maybe<Org_Domain_Mutation_Response>;
  /** insert a single row into the table: "org_domain" */
  insert_org_domain_one: Maybe<Org_Domain>;
  /** insert data into the table: "org_user" */
  insert_org_user: Maybe<Org_User_Mutation_Response>;
  /** insert a single row into the table: "org_user" */
  insert_org_user_one: Maybe<Org_User>;
  /** insert data into the table: "organization" */
  insert_organization: Maybe<Organization_Mutation_Response>;
  /** insert a single row into the table: "organization" */
  insert_organization_one: Maybe<Organization>;
  /** insert data into the table: "personal_info" */
  insert_personal_info: Maybe<Personal_Info_Mutation_Response>;
  /** insert a single row into the table: "personal_info" */
  insert_personal_info_one: Maybe<Personal_Info>;
  /** insert data into the table: "place_boundary" */
  insert_place_boundary: Maybe<Place_Boundary_Mutation_Response>;
  /** insert a single row into the table: "place_boundary" */
  insert_place_boundary_one: Maybe<Place_Boundary>;
  /** insert data into the table: "posting_app_cert" */
  insert_posting_app_cert: Maybe<Posting_App_Cert_Mutation_Response>;
  /** insert a single row into the table: "posting_app_cert" */
  insert_posting_app_cert_one: Maybe<Posting_App_Cert>;
  /** insert data into the table: "posting_board_cert" */
  insert_posting_board_cert: Maybe<Posting_Board_Cert_Mutation_Response>;
  /** insert a single row into the table: "posting_board_cert" */
  insert_posting_board_cert_one: Maybe<Posting_Board_Cert>;
  /** insert data into the table: "posting_profession" */
  insert_posting_profession: Maybe<Posting_Profession_Mutation_Response>;
  /** insert a single row into the table: "posting_profession" */
  insert_posting_profession_one: Maybe<Posting_Profession>;
  /** insert data into the table: "posting_worker_classification" */
  insert_posting_worker_classification: Maybe<Posting_Worker_Classification_Mutation_Response>;
  /** insert a single row into the table: "posting_worker_classification" */
  insert_posting_worker_classification_one: Maybe<Posting_Worker_Classification>;
  /** insert data into the table: "relevant_job_posting" */
  insert_relevant_job_posting: Maybe<Relevant_Job_Posting_Mutation_Response>;
  /** insert a single row into the table: "relevant_job_posting" */
  insert_relevant_job_posting_one: Maybe<Relevant_Job_Posting>;
  /** insert data into the table: "relevant_salary_report" */
  insert_relevant_salary_report: Maybe<Relevant_Salary_Report_Mutation_Response>;
  /** insert a single row into the table: "relevant_salary_report" */
  insert_relevant_salary_report_one: Maybe<Relevant_Salary_Report>;
  /** insert data into the table: "residency" */
  insert_residency: Maybe<Residency_Mutation_Response>;
  /** insert a single row into the table: "residency" */
  insert_residency_one: Maybe<Residency>;
  /** insert data into the table: "residency_survey" */
  insert_residency_survey: Maybe<Residency_Survey_Mutation_Response>;
  /** insert a single row into the table: "residency_survey" */
  insert_residency_survey_one: Maybe<Residency_Survey>;
  /** insert data into the table: "review" */
  insert_review: Maybe<Review_Mutation_Response>;
  /** insert a single row into the table: "review" */
  insert_review_one: Maybe<Review>;
  /** insert data into the table: "review_reply" */
  insert_review_reply: Maybe<Review_Reply_Mutation_Response>;
  /** insert a single row into the table: "review_reply" */
  insert_review_reply_one: Maybe<Review_Reply>;
  /** insert data into the table: "review_report" */
  insert_review_report: Maybe<Review_Report_Mutation_Response>;
  /** insert a single row into the table: "review_report" */
  insert_review_report_one: Maybe<Review_Report>;
  /** insert data into the table: "review_vote" */
  insert_review_vote: Maybe<Review_Vote_Mutation_Response>;
  /** insert a single row into the table: "review_vote" */
  insert_review_vote_one: Maybe<Review_Vote>;
  /** insert data into the table: "salary_report" */
  insert_salary_report: Maybe<Salary_Report_Mutation_Response>;
  /** insert data into the table: "salary_report_fmt" */
  insert_salary_report_fmt: Maybe<Salary_Report_Fmt_Mutation_Response>;
  /** insert a single row into the table: "salary_report_fmt" */
  insert_salary_report_fmt_one: Maybe<Salary_Report_Fmt>;
  /** insert a single row into the table: "salary_report" */
  insert_salary_report_one: Maybe<Salary_Report>;
  /** insert data into the table: "school" */
  insert_school: Maybe<School_Mutation_Response>;
  /** insert a single row into the table: "school" */
  insert_school_one: Maybe<School>;
  /** insert data into the table: "search_candidate_result" */
  insert_search_candidate_result: Maybe<Search_Candidate_Result_Mutation_Response>;
  /** insert a single row into the table: "search_candidate_result" */
  insert_search_candidate_result_one: Maybe<Search_Candidate_Result>;
  /** insert data into the table: "search_clerkship_by_geography_result" */
  insert_search_clerkship_by_geography_result: Maybe<Search_Clerkship_By_Geography_Result_Mutation_Response>;
  /** insert a single row into the table: "search_clerkship_by_geography_result" */
  insert_search_clerkship_by_geography_result_one: Maybe<Search_Clerkship_By_Geography_Result>;
  /** insert data into the table: "search_facility_by_prefix_result" */
  insert_search_facility_by_prefix_result: Maybe<Search_Facility_By_Prefix_Result_Mutation_Response>;
  /** insert a single row into the table: "search_facility_by_prefix_result" */
  insert_search_facility_by_prefix_result_one: Maybe<Search_Facility_By_Prefix_Result>;
  /** insert data into the table: "search_fellowship_by_geography_result" */
  insert_search_fellowship_by_geography_result: Maybe<Search_Fellowship_By_Geography_Result_Mutation_Response>;
  /** insert a single row into the table: "search_fellowship_by_geography_result" */
  insert_search_fellowship_by_geography_result_one: Maybe<Search_Fellowship_By_Geography_Result>;
  /** insert data into the table: "search_fsmb_bio_result" */
  insert_search_fsmb_bio_result: Maybe<Search_Fsmb_Bio_Result_Mutation_Response>;
  /** insert a single row into the table: "search_fsmb_bio_result" */
  insert_search_fsmb_bio_result_one: Maybe<Search_Fsmb_Bio_Result>;
  /** insert data into the table: "search_job_postings_by_geography_result" */
  insert_search_job_postings_by_geography_result: Maybe<Search_Job_Postings_By_Geography_Result_Mutation_Response>;
  /** insert a single row into the table: "search_job_postings_by_geography_result" */
  insert_search_job_postings_by_geography_result_one: Maybe<Search_Job_Postings_By_Geography_Result>;
  /** insert data into the table: "search_org_market_result" */
  insert_search_org_market_result: Maybe<Search_Org_Market_Result_Mutation_Response>;
  /** insert a single row into the table: "search_org_market_result" */
  insert_search_org_market_result_one: Maybe<Search_Org_Market_Result>;
  /** insert data into the table: "search_organization_by_prefix_result" */
  insert_search_organization_by_prefix_result: Maybe<Search_Organization_By_Prefix_Result_Mutation_Response>;
  /** insert a single row into the table: "search_organization_by_prefix_result" */
  insert_search_organization_by_prefix_result_one: Maybe<Search_Organization_By_Prefix_Result>;
  /** insert data into the table: "search_residency_by_geography_result" */
  insert_search_residency_by_geography_result: Maybe<Search_Residency_By_Geography_Result_Mutation_Response>;
  /** insert a single row into the table: "search_residency_by_geography_result" */
  insert_search_residency_by_geography_result_one: Maybe<Search_Residency_By_Geography_Result>;
  /** insert data into the table: "search_training_by_prefix_result" */
  insert_search_training_by_prefix_result: Maybe<Search_Training_By_Prefix_Result_Mutation_Response>;
  /** insert a single row into the table: "search_training_by_prefix_result" */
  insert_search_training_by_prefix_result_one: Maybe<Search_Training_By_Prefix_Result>;
  /** insert data into the table: "site" */
  insert_site: Maybe<Site_Mutation_Response>;
  /** insert a single row into the table: "site" */
  insert_site_one: Maybe<Site>;
  /** insert data into the table: "stroke_cert" */
  insert_stroke_cert: Maybe<Stroke_Cert_Mutation_Response>;
  /** insert a single row into the table: "stroke_cert" */
  insert_stroke_cert_one: Maybe<Stroke_Cert>;
  /** insert data into the table: "training" */
  insert_training: Maybe<Training_Mutation_Response>;
  /** insert data into the table: "training_event" */
  insert_training_event: Maybe<Training_Event_Mutation_Response>;
  /** insert a single row into the table: "training_event" */
  insert_training_event_one: Maybe<Training_Event>;
  /** insert data into the table: "training_field" */
  insert_training_field: Maybe<Training_Field_Mutation_Response>;
  /** insert a single row into the table: "training_field" */
  insert_training_field_one: Maybe<Training_Field>;
  /** insert a single row into the table: "training" */
  insert_training_one: Maybe<Training>;
  /** insert data into the table: "training_program" */
  insert_training_program: Maybe<Training_Program_Mutation_Response>;
  /** insert a single row into the table: "training_program" */
  insert_training_program_one: Maybe<Training_Program>;
  /** insert data into the table: "training_survey" */
  insert_training_survey: Maybe<Training_Survey_Mutation_Response>;
  /** insert a single row into the table: "training_survey" */
  insert_training_survey_one: Maybe<Training_Survey>;
  /** insert data into the table: "training_survey_picture" */
  insert_training_survey_picture: Maybe<Training_Survey_Picture_Mutation_Response>;
  /** insert a single row into the table: "training_survey_picture" */
  insert_training_survey_picture_one: Maybe<Training_Survey_Picture>;
  /** insert data into the table: "training_survey_site" */
  insert_training_survey_site: Maybe<Training_Survey_Site_Mutation_Response>;
  /** insert a single row into the table: "training_survey_site" */
  insert_training_survey_site_one: Maybe<Training_Survey_Site>;
  invite_org_user: InviteOrgUserResult;
  log_in: LogInResult;
  pay_outstanding_balance: PaymentIntentGql;
  /** Publish one asset */
  publishAsset: Maybe<Asset>;
  /** Publish one faq */
  publishFaq: Maybe<Faq>;
  /** Publish one legal */
  publishLegal: Maybe<Legal>;
  /** Publish many Asset documents */
  publishManyAssets: BatchPayload;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /** Publish many Faq documents */
  publishManyFaqs: BatchPayload;
  /** Publish many Faq documents */
  publishManyFaqsConnection: FaqConnection;
  /** Publish many Legal documents */
  publishManyLegals: BatchPayload;
  /** Publish many Legal documents */
  publishManyLegalsConnection: LegalConnection;
  /** Publish many Post documents */
  publishManyPosts: BatchPayload;
  /** Publish many Post documents */
  publishManyPostsConnection: PostConnection;
  /** Publish many Teammate documents */
  publishManyTeammates: BatchPayload;
  /** Publish many Teammate documents */
  publishManyTeammatesConnection: TeammateConnection;
  /** Publish one post */
  publishPost: Maybe<Post>;
  /** Publish one teammate */
  publishTeammate: Maybe<Teammate>;
  reactivate_customer_subscription: CustomerSubscriptionGql;
  recreate_job_application_batch: SuccessResult;
  refresh_auth: RefreshAuthResult;
  register_clinician: RegisterClinicianResult;
  register_org_user: SuccessResult;
  request_email_change: SuccessResult;
  resend_verification: SuccessResult;
  reset_password: SuccessResult;
  /** Schedule to publish one asset */
  schedulePublishAsset: Maybe<Asset>;
  /** Schedule to publish one faq */
  schedulePublishFaq: Maybe<Faq>;
  /** Schedule to publish one legal */
  schedulePublishLegal: Maybe<Legal>;
  /** Schedule to publish one post */
  schedulePublishPost: Maybe<Post>;
  /** Schedule to publish one teammate */
  schedulePublishTeammate: Maybe<Teammate>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset: Maybe<Asset>;
  /** Unpublish one faq from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFaq: Maybe<Faq>;
  /** Unpublish one legal from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLegal: Maybe<Legal>;
  /** Unpublish one post from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPost: Maybe<Post>;
  /** Unpublish one teammate from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTeammate: Maybe<Teammate>;
  send_job_application_batch_admin_followup: SendJobApplicationBatchAdminFollowup;
  send_password_reset: SuccessResult;
  set_email_suppressions: Array<EmailSuppression>;
  sign_up_org_user: SuccessResult;
  unlink_credentials: UnlinkCredentialsResult;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset: Maybe<Asset>;
  /** Unpublish one faq from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFaq: Maybe<Faq>;
  /** Unpublish one legal from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLegal: Maybe<Legal>;
  /** Unpublish many Asset documents */
  unpublishManyAssets: BatchPayload;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /** Unpublish many Faq documents */
  unpublishManyFaqs: BatchPayload;
  /** Find many Faq documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFaqsConnection: FaqConnection;
  /** Unpublish many Legal documents */
  unpublishManyLegals: BatchPayload;
  /** Find many Legal documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLegalsConnection: LegalConnection;
  /** Unpublish many Post documents */
  unpublishManyPosts: BatchPayload;
  /** Find many Post documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPostsConnection: PostConnection;
  /** Unpublish many Teammate documents */
  unpublishManyTeammates: BatchPayload;
  /** Find many Teammate documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTeammatesConnection: TeammateConnection;
  /** Unpublish one post from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPost: Maybe<Post>;
  /** Unpublish one teammate from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTeammate: Maybe<Teammate>;
  /** Update one asset */
  updateAsset: Maybe<Asset>;
  /** Update one faq */
  updateFaq: Maybe<Faq>;
  /** Update one legal */
  updateLegal: Maybe<Legal>;
  /** Update many assets */
  updateManyAssets: BatchPayload;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /** Update many faqs */
  updateManyFaqs: BatchPayload;
  /** Update many Faq documents */
  updateManyFaqsConnection: FaqConnection;
  /** Update many legals */
  updateManyLegals: BatchPayload;
  /** Update many Legal documents */
  updateManyLegalsConnection: LegalConnection;
  /** Update many posts */
  updateManyPosts: BatchPayload;
  /** Update many Post documents */
  updateManyPostsConnection: PostConnection;
  /** Update many teammates */
  updateManyTeammates: BatchPayload;
  /** Update many Teammate documents */
  updateManyTeammatesConnection: TeammateConnection;
  /** Update one post */
  updatePost: Maybe<Post>;
  /** Update one scheduledRelease */
  updateScheduledRelease: Maybe<ScheduledRelease>;
  /** Update one teammate */
  updateTeammate: Maybe<Teammate>;
  /** update data of the table: "AS20DEM" */
  update_AS20DEM: Maybe<As20Dem_Mutation_Response>;
  /** update single row of the table: "AS20DEM" */
  update_AS20DEM_by_pk: Maybe<As20Dem>;
  /** update multiples rows of table: "AS20DEM" */
  update_AS20DEM_many: Maybe<Array<Maybe<As20Dem_Mutation_Response>>>;
  /** update data of the table: "AS20SVC1" */
  update_AS20SVC1: Maybe<As20Svc1_Mutation_Response>;
  /** update single row of the table: "AS20SVC1" */
  update_AS20SVC1_by_pk: Maybe<As20Svc1>;
  /** update multiples rows of table: "AS20SVC1" */
  update_AS20SVC1_many: Maybe<Array<Maybe<As20Svc1_Mutation_Response>>>;
  /** update data of the table: "AS20SVC2" */
  update_AS20SVC2: Maybe<As20Svc2_Mutation_Response>;
  /** update single row of the table: "AS20SVC2" */
  update_AS20SVC2_by_pk: Maybe<As20Svc2>;
  /** update multiples rows of table: "AS20SVC2" */
  update_AS20SVC2_many: Maybe<Array<Maybe<As20Svc2_Mutation_Response>>>;
  /** update data of the table: "AS20SVC3" */
  update_AS20SVC3: Maybe<As20Svc3_Mutation_Response>;
  /** update single row of the table: "AS20SVC3" */
  update_AS20SVC3_by_pk: Maybe<As20Svc3>;
  /** update multiples rows of table: "AS20SVC3" */
  update_AS20SVC3_many: Maybe<Array<Maybe<As20Svc3_Mutation_Response>>>;
  /** update data of the table: "AS20UTIL1" */
  update_AS20UTIL1: Maybe<As20Util1_Mutation_Response>;
  /** update single row of the table: "AS20UTIL1" */
  update_AS20UTIL1_by_pk: Maybe<As20Util1>;
  /** update multiples rows of table: "AS20UTIL1" */
  update_AS20UTIL1_many: Maybe<Array<Maybe<As20Util1_Mutation_Response>>>;
  /** update data of the table: "AS20UTIL2" */
  update_AS20UTIL2: Maybe<As20Util2_Mutation_Response>;
  /** update single row of the table: "AS20UTIL2" */
  update_AS20UTIL2_by_pk: Maybe<As20Util2>;
  /** update multiples rows of table: "AS20UTIL2" */
  update_AS20UTIL2_many: Maybe<Array<Maybe<As20Util2_Mutation_Response>>>;
  /** update data of the table: "AS21DEM" */
  update_AS21DEM: Maybe<As21Dem_Mutation_Response>;
  /** update single row of the table: "AS21DEM" */
  update_AS21DEM_by_pk: Maybe<As21Dem>;
  /** update multiples rows of table: "AS21DEM" */
  update_AS21DEM_many: Maybe<Array<Maybe<As21Dem_Mutation_Response>>>;
  /** update data of the table: "AS21SVC1" */
  update_AS21SVC1: Maybe<As21Svc1_Mutation_Response>;
  /** update single row of the table: "AS21SVC1" */
  update_AS21SVC1_by_pk: Maybe<As21Svc1>;
  /** update multiples rows of table: "AS21SVC1" */
  update_AS21SVC1_many: Maybe<Array<Maybe<As21Svc1_Mutation_Response>>>;
  /** update data of the table: "AS21SVC2" */
  update_AS21SVC2: Maybe<As21Svc2_Mutation_Response>;
  /** update single row of the table: "AS21SVC2" */
  update_AS21SVC2_by_pk: Maybe<As21Svc2>;
  /** update multiples rows of table: "AS21SVC2" */
  update_AS21SVC2_many: Maybe<Array<Maybe<As21Svc2_Mutation_Response>>>;
  /** update data of the table: "AS21SVC3" */
  update_AS21SVC3: Maybe<As21Svc3_Mutation_Response>;
  /** update single row of the table: "AS21SVC3" */
  update_AS21SVC3_by_pk: Maybe<As21Svc3>;
  /** update multiples rows of table: "AS21SVC3" */
  update_AS21SVC3_many: Maybe<Array<Maybe<As21Svc3_Mutation_Response>>>;
  /** update data of the table: "AS21UNIT" */
  update_AS21UNIT: Maybe<As21Unit_Mutation_Response>;
  /** update single row of the table: "AS21UNIT" */
  update_AS21UNIT_by_pk: Maybe<As21Unit>;
  /** update multiples rows of table: "AS21UNIT" */
  update_AS21UNIT_many: Maybe<Array<Maybe<As21Unit_Mutation_Response>>>;
  /** update data of the table: "AS21UTIL" */
  update_AS21UTIL: Maybe<As21Util_Mutation_Response>;
  /** update data of the table: "AS21UTIL2" */
  update_AS21UTIL2: Maybe<As21Util2_Mutation_Response>;
  /** update single row of the table: "AS21UTIL2" */
  update_AS21UTIL2_by_pk: Maybe<As21Util2>;
  /** update multiples rows of table: "AS21UTIL2" */
  update_AS21UTIL2_many: Maybe<Array<Maybe<As21Util2_Mutation_Response>>>;
  /** update single row of the table: "AS21UTIL" */
  update_AS21UTIL_by_pk: Maybe<As21Util>;
  /** update multiples rows of table: "AS21UTIL" */
  update_AS21UTIL_many: Maybe<Array<Maybe<As21Util_Mutation_Response>>>;
  /** update data of the table: "AS22DEM" */
  update_AS22DEM: Maybe<As22Dem_Mutation_Response>;
  /** update single row of the table: "AS22DEM" */
  update_AS22DEM_by_pk: Maybe<As22Dem>;
  /** update multiples rows of table: "AS22DEM" */
  update_AS22DEM_many: Maybe<Array<Maybe<As22Dem_Mutation_Response>>>;
  /** update data of the table: "AS22SVC1" */
  update_AS22SVC1: Maybe<As22Svc1_Mutation_Response>;
  /** update single row of the table: "AS22SVC1" */
  update_AS22SVC1_by_pk: Maybe<As22Svc1>;
  /** update multiples rows of table: "AS22SVC1" */
  update_AS22SVC1_many: Maybe<Array<Maybe<As22Svc1_Mutation_Response>>>;
  /** update data of the table: "AS22SVC2" */
  update_AS22SVC2: Maybe<As22Svc2_Mutation_Response>;
  /** update single row of the table: "AS22SVC2" */
  update_AS22SVC2_by_pk: Maybe<As22Svc2>;
  /** update multiples rows of table: "AS22SVC2" */
  update_AS22SVC2_many: Maybe<Array<Maybe<As22Svc2_Mutation_Response>>>;
  /** update data of the table: "AS22SVC3" */
  update_AS22SVC3: Maybe<As22Svc3_Mutation_Response>;
  /** update single row of the table: "AS22SVC3" */
  update_AS22SVC3_by_pk: Maybe<As22Svc3>;
  /** update multiples rows of table: "AS22SVC3" */
  update_AS22SVC3_many: Maybe<Array<Maybe<As22Svc3_Mutation_Response>>>;
  /** update data of the table: "AS22UNIT" */
  update_AS22UNIT: Maybe<As22Unit_Mutation_Response>;
  /** update single row of the table: "AS22UNIT" */
  update_AS22UNIT_by_pk: Maybe<As22Unit>;
  /** update multiples rows of table: "AS22UNIT" */
  update_AS22UNIT_many: Maybe<Array<Maybe<As22Unit_Mutation_Response>>>;
  /** update data of the table: "AS22UTIL" */
  update_AS22UTIL: Maybe<As22Util_Mutation_Response>;
  /** update data of the table: "AS22UTIL2" */
  update_AS22UTIL2: Maybe<As22Util2_Mutation_Response>;
  /** update single row of the table: "AS22UTIL2" */
  update_AS22UTIL2_by_pk: Maybe<As22Util2>;
  /** update multiples rows of table: "AS22UTIL2" */
  update_AS22UTIL2_many: Maybe<Array<Maybe<As22Util2_Mutation_Response>>>;
  /** update single row of the table: "AS22UTIL" */
  update_AS22UTIL_by_pk: Maybe<As22Util>;
  /** update multiples rows of table: "AS22UTIL" */
  update_AS22UTIL_many: Maybe<Array<Maybe<As22Util_Mutation_Response>>>;
  /** update data of the table: "ab_test" */
  update_ab_test: Maybe<Ab_Test_Mutation_Response>;
  /** update single row of the table: "ab_test" */
  update_ab_test_by_pk: Maybe<Ab_Test>;
  /** update multiples rows of table: "ab_test" */
  update_ab_test_many: Maybe<Array<Maybe<Ab_Test_Mutation_Response>>>;
  /** update data of the table: "access_info" */
  update_access_info: Maybe<Access_Info_Mutation_Response>;
  /** update multiples rows of table: "access_info" */
  update_access_info_many: Maybe<Array<Maybe<Access_Info_Mutation_Response>>>;
  /** update data of the table: "account" */
  update_account: Maybe<Account_Mutation_Response>;
  /** update single row of the table: "account" */
  update_account_by_pk: Maybe<Account>;
  /** update multiples rows of table: "account" */
  update_account_many: Maybe<Array<Maybe<Account_Mutation_Response>>>;
  /** update data of the table: "account_role" */
  update_account_role: Maybe<Account_Role_Mutation_Response>;
  /** update single row of the table: "account_role" */
  update_account_role_by_pk: Maybe<Account_Role>;
  /** update multiples rows of table: "account_role" */
  update_account_role_many: Maybe<Array<Maybe<Account_Role_Mutation_Response>>>;
  /** update data of the table: "acep_org_survey" */
  update_acep_org_survey: Maybe<Acep_Org_Survey_Mutation_Response>;
  /** update single row of the table: "acep_org_survey" */
  update_acep_org_survey_by_pk: Maybe<Acep_Org_Survey>;
  /** update multiples rows of table: "acep_org_survey" */
  update_acep_org_survey_many: Maybe<Array<Maybe<Acep_Org_Survey_Mutation_Response>>>;
  /** update data of the table: "board" */
  update_board: Maybe<Board_Mutation_Response>;
  /** update single row of the table: "board" */
  update_board_by_pk: Maybe<Board>;
  /** update data of the table: "board_cert" */
  update_board_cert: Maybe<Board_Cert_Mutation_Response>;
  /** update single row of the table: "board_cert" */
  update_board_cert_by_pk: Maybe<Board_Cert>;
  /** update multiples rows of table: "board_cert" */
  update_board_cert_many: Maybe<Array<Maybe<Board_Cert_Mutation_Response>>>;
  /** update multiples rows of table: "board" */
  update_board_many: Maybe<Array<Maybe<Board_Mutation_Response>>>;
  /** update data of the table: "candidate" */
  update_candidate: Maybe<Candidate_Mutation_Response>;
  /** update single row of the table: "candidate" */
  update_candidate_by_pk: Maybe<Candidate>;
  /** update multiples rows of table: "candidate" */
  update_candidate_many: Maybe<Array<Maybe<Candidate_Mutation_Response>>>;
  /** update data of the table: "cert_org" */
  update_cert_org: Maybe<Cert_Org_Mutation_Response>;
  /** update single row of the table: "cert_org" */
  update_cert_org_by_pk: Maybe<Cert_Org>;
  /** update multiples rows of table: "cert_org" */
  update_cert_org_many: Maybe<Array<Maybe<Cert_Org_Mutation_Response>>>;
  /** update data of the table: "clerkship" */
  update_clerkship: Maybe<Clerkship_Mutation_Response>;
  /** update single row of the table: "clerkship" */
  update_clerkship_by_pk: Maybe<Clerkship>;
  /** update multiples rows of table: "clerkship" */
  update_clerkship_many: Maybe<Array<Maybe<Clerkship_Mutation_Response>>>;
  /** update data of the table: "clerkship_survey" */
  update_clerkship_survey: Maybe<Clerkship_Survey_Mutation_Response>;
  /** update single row of the table: "clerkship_survey" */
  update_clerkship_survey_by_pk: Maybe<Clerkship_Survey>;
  /** update multiples rows of table: "clerkship_survey" */
  update_clerkship_survey_many: Maybe<Array<Maybe<Clerkship_Survey_Mutation_Response>>>;
  /** update data of the table: "clinician" */
  update_clinician: Maybe<Clinician_Mutation_Response>;
  /** update data of the table: "clinician_app_cert" */
  update_clinician_app_cert: Maybe<Clinician_App_Cert_Mutation_Response>;
  /** update single row of the table: "clinician_app_cert" */
  update_clinician_app_cert_by_pk: Maybe<Clinician_App_Cert>;
  /** update multiples rows of table: "clinician_app_cert" */
  update_clinician_app_cert_many: Maybe<Array<Maybe<Clinician_App_Cert_Mutation_Response>>>;
  /** update data of the table: "clinician_board_cert" */
  update_clinician_board_cert: Maybe<Clinician_Board_Cert_Mutation_Response>;
  /** update single row of the table: "clinician_board_cert" */
  update_clinician_board_cert_by_pk: Maybe<Clinician_Board_Cert>;
  /** update multiples rows of table: "clinician_board_cert" */
  update_clinician_board_cert_many: Maybe<Array<Maybe<Clinician_Board_Cert_Mutation_Response>>>;
  /** update single row of the table: "clinician" */
  update_clinician_by_pk: Maybe<Clinician>;
  /** update data of the table: "clinician_license" */
  update_clinician_license: Maybe<Clinician_License_Mutation_Response>;
  /** update single row of the table: "clinician_license" */
  update_clinician_license_by_pk: Maybe<Clinician_License>;
  /** update multiples rows of table: "clinician_license" */
  update_clinician_license_many: Maybe<Array<Maybe<Clinician_License_Mutation_Response>>>;
  /** update multiples rows of table: "clinician" */
  update_clinician_many: Maybe<Array<Maybe<Clinician_Mutation_Response>>>;
  /** update data of the table: "clinician_sp_exp" */
  update_clinician_sp_exp: Maybe<Clinician_Sp_Exp_Mutation_Response>;
  /** update single row of the table: "clinician_sp_exp" */
  update_clinician_sp_exp_by_pk: Maybe<Clinician_Sp_Exp>;
  /** update multiples rows of table: "clinician_sp_exp" */
  update_clinician_sp_exp_many: Maybe<Array<Maybe<Clinician_Sp_Exp_Mutation_Response>>>;
  /** update data of the table: "clinician_specialty" */
  update_clinician_specialty: Maybe<Clinician_Specialty_Mutation_Response>;
  /** update single row of the table: "clinician_specialty" */
  update_clinician_specialty_by_pk: Maybe<Clinician_Specialty>;
  /** update multiples rows of table: "clinician_specialty" */
  update_clinician_specialty_many: Maybe<Array<Maybe<Clinician_Specialty_Mutation_Response>>>;
  /** update data of the table: "clinician_training" */
  update_clinician_training: Maybe<Clinician_Training_Mutation_Response>;
  /** update single row of the table: "clinician_training" */
  update_clinician_training_by_pk: Maybe<Clinician_Training>;
  /** update multiples rows of table: "clinician_training" */
  update_clinician_training_many: Maybe<Array<Maybe<Clinician_Training_Mutation_Response>>>;
  /** update data of the table: "cms_facility" */
  update_cms_facility: Maybe<Cms_Facility_Mutation_Response>;
  /** update single row of the table: "cms_facility" */
  update_cms_facility_by_pk: Maybe<Cms_Facility>;
  /** update data of the table: "cms_facility_enrollment" */
  update_cms_facility_enrollment: Maybe<Cms_Facility_Enrollment_Mutation_Response>;
  /** update single row of the table: "cms_facility_enrollment" */
  update_cms_facility_enrollment_by_pk: Maybe<Cms_Facility_Enrollment>;
  /** update multiples rows of table: "cms_facility_enrollment" */
  update_cms_facility_enrollment_many: Maybe<Array<Maybe<Cms_Facility_Enrollment_Mutation_Response>>>;
  /** update multiples rows of table: "cms_facility" */
  update_cms_facility_many: Maybe<Array<Maybe<Cms_Facility_Mutation_Response>>>;
  /** update data of the table: "cms_facility_metric" */
  update_cms_facility_metric: Maybe<Cms_Facility_Metric_Mutation_Response>;
  /** update single row of the table: "cms_facility_metric" */
  update_cms_facility_metric_by_pk: Maybe<Cms_Facility_Metric>;
  /** update multiples rows of table: "cms_facility_metric" */
  update_cms_facility_metric_many: Maybe<Array<Maybe<Cms_Facility_Metric_Mutation_Response>>>;
  /** update data of the table: "cms_facility_pos" */
  update_cms_facility_pos: Maybe<Cms_Facility_Pos_Mutation_Response>;
  /** update single row of the table: "cms_facility_pos" */
  update_cms_facility_pos_by_pk: Maybe<Cms_Facility_Pos>;
  /** update multiples rows of table: "cms_facility_pos" */
  update_cms_facility_pos_many: Maybe<Array<Maybe<Cms_Facility_Pos_Mutation_Response>>>;
  /** update data of the table: "cms_specialty" */
  update_cms_specialty: Maybe<Cms_Specialty_Mutation_Response>;
  /** update single row of the table: "cms_specialty" */
  update_cms_specialty_by_pk: Maybe<Cms_Specialty>;
  /** update multiples rows of table: "cms_specialty" */
  update_cms_specialty_many: Maybe<Array<Maybe<Cms_Specialty_Mutation_Response>>>;
  /** update data of the table: "contact_info" */
  update_contact_info: Maybe<Contact_Info_Mutation_Response>;
  /** update multiples rows of table: "contact_info" */
  update_contact_info_many: Maybe<Array<Maybe<Contact_Info_Mutation_Response>>>;
  /** update data of the table: "current_account" */
  update_current_account: Maybe<Current_Account_Mutation_Response>;
  /** update multiples rows of table: "current_account" */
  update_current_account_many: Maybe<Array<Maybe<Current_Account_Mutation_Response>>>;
  update_customer_default_payment_method: SuccessResult;
  update_customer_subscription: PaymentIntentGql;
  /** update data of the table: "email_contact" */
  update_email_contact: Maybe<Email_Contact_Mutation_Response>;
  /** update single row of the table: "email_contact" */
  update_email_contact_by_pk: Maybe<Email_Contact>;
  /** update multiples rows of table: "email_contact" */
  update_email_contact_many: Maybe<Array<Maybe<Email_Contact_Mutation_Response>>>;
  /** update data of the table: "email_envelope" */
  update_email_envelope: Maybe<Email_Envelope_Mutation_Response>;
  /** update single row of the table: "email_envelope" */
  update_email_envelope_by_pk: Maybe<Email_Envelope>;
  /** update multiples rows of table: "email_envelope" */
  update_email_envelope_many: Maybe<Array<Maybe<Email_Envelope_Mutation_Response>>>;
  /** update data of the table: "email_event" */
  update_email_event: Maybe<Email_Event_Mutation_Response>;
  /** update single row of the table: "email_event" */
  update_email_event_by_pk: Maybe<Email_Event>;
  /** update multiples rows of table: "email_event" */
  update_email_event_many: Maybe<Array<Maybe<Email_Event_Mutation_Response>>>;
  /** update data of the table: "email_message" */
  update_email_message: Maybe<Email_Message_Mutation_Response>;
  /** update single row of the table: "email_message" */
  update_email_message_by_pk: Maybe<Email_Message>;
  /** update multiples rows of table: "email_message" */
  update_email_message_many: Maybe<Array<Maybe<Email_Message_Mutation_Response>>>;
  /** update data of the table: "email_pointer" */
  update_email_pointer: Maybe<Email_Pointer_Mutation_Response>;
  /** update single row of the table: "email_pointer" */
  update_email_pointer_by_pk: Maybe<Email_Pointer>;
  /** update multiples rows of table: "email_pointer" */
  update_email_pointer_many: Maybe<Array<Maybe<Email_Pointer_Mutation_Response>>>;
  /** update data of the table: "ext_job_posting" */
  update_ext_job_posting: Maybe<Ext_Job_Posting_Mutation_Response>;
  /** update single row of the table: "ext_job_posting" */
  update_ext_job_posting_by_pk: Maybe<Ext_Job_Posting>;
  /** update multiples rows of table: "ext_job_posting" */
  update_ext_job_posting_many: Maybe<Array<Maybe<Ext_Job_Posting_Mutation_Response>>>;
  /** update data of the table: "ext_job_scrape" */
  update_ext_job_scrape: Maybe<Ext_Job_Scrape_Mutation_Response>;
  /** update single row of the table: "ext_job_scrape" */
  update_ext_job_scrape_by_pk: Maybe<Ext_Job_Scrape>;
  /** update multiples rows of table: "ext_job_scrape" */
  update_ext_job_scrape_many: Maybe<Array<Maybe<Ext_Job_Scrape_Mutation_Response>>>;
  /** update data of the table: "ext_posting_error" */
  update_ext_posting_error: Maybe<Ext_Posting_Error_Mutation_Response>;
  /** update single row of the table: "ext_posting_error" */
  update_ext_posting_error_by_pk: Maybe<Ext_Posting_Error>;
  /** update multiples rows of table: "ext_posting_error" */
  update_ext_posting_error_many: Maybe<Array<Maybe<Ext_Posting_Error_Mutation_Response>>>;
  /** update data of the table: "ext_posting_profession" */
  update_ext_posting_profession: Maybe<Ext_Posting_Profession_Mutation_Response>;
  /** update single row of the table: "ext_posting_profession" */
  update_ext_posting_profession_by_pk: Maybe<Ext_Posting_Profession>;
  /** update multiples rows of table: "ext_posting_profession" */
  update_ext_posting_profession_many: Maybe<Array<Maybe<Ext_Posting_Profession_Mutation_Response>>>;
  /** update data of the table: "facility" */
  update_facility: Maybe<Facility_Mutation_Response>;
  /** update data of the table: "facility_accreditation" */
  update_facility_accreditation: Maybe<Facility_Accreditation_Mutation_Response>;
  /** update single row of the table: "facility_accreditation" */
  update_facility_accreditation_by_pk: Maybe<Facility_Accreditation>;
  /** update multiples rows of table: "facility_accreditation" */
  update_facility_accreditation_many: Maybe<Array<Maybe<Facility_Accreditation_Mutation_Response>>>;
  /** update single row of the table: "facility" */
  update_facility_by_pk: Maybe<Facility>;
  /** update data of the table: "facility_contract" */
  update_facility_contract: Maybe<Facility_Contract_Mutation_Response>;
  /** update single row of the table: "facility_contract" */
  update_facility_contract_by_pk: Maybe<Facility_Contract>;
  /** update data of the table: "facility_contract_featured" */
  update_facility_contract_featured: Maybe<Facility_Contract_Featured_Mutation_Response>;
  /** update single row of the table: "facility_contract_featured" */
  update_facility_contract_featured_by_pk: Maybe<Facility_Contract_Featured>;
  /** update multiples rows of table: "facility_contract_featured" */
  update_facility_contract_featured_many: Maybe<Array<Maybe<Facility_Contract_Featured_Mutation_Response>>>;
  /** update multiples rows of table: "facility_contract" */
  update_facility_contract_many: Maybe<Array<Maybe<Facility_Contract_Mutation_Response>>>;
  /** update data of the table: "facility_correction" */
  update_facility_correction: Maybe<Facility_Correction_Mutation_Response>;
  /** update single row of the table: "facility_correction" */
  update_facility_correction_by_pk: Maybe<Facility_Correction>;
  /** update multiples rows of table: "facility_correction" */
  update_facility_correction_many: Maybe<Array<Maybe<Facility_Correction_Mutation_Response>>>;
  /** update data of the table: "facility_dist_result" */
  update_facility_dist_result: Maybe<Facility_Dist_Result_Mutation_Response>;
  /** update multiples rows of table: "facility_dist_result" */
  update_facility_dist_result_many: Maybe<Array<Maybe<Facility_Dist_Result_Mutation_Response>>>;
  /** update data of the table: "facility_ehr" */
  update_facility_ehr: Maybe<Facility_Ehr_Mutation_Response>;
  /** update single row of the table: "facility_ehr" */
  update_facility_ehr_by_pk: Maybe<Facility_Ehr>;
  /** update multiples rows of table: "facility_ehr" */
  update_facility_ehr_many: Maybe<Array<Maybe<Facility_Ehr_Mutation_Response>>>;
  /** update multiples rows of table: "facility" */
  update_facility_many: Maybe<Array<Maybe<Facility_Mutation_Response>>>;
  /** update data of the table: "favorite" */
  update_favorite: Maybe<Favorite_Mutation_Response>;
  /** update single row of the table: "favorite" */
  update_favorite_by_pk: Maybe<Favorite>;
  /** update multiples rows of table: "favorite" */
  update_favorite_many: Maybe<Array<Maybe<Favorite_Mutation_Response>>>;
  /** update data of the table: "featured_clerkship_dist_result" */
  update_featured_clerkship_dist_result: Maybe<Featured_Clerkship_Dist_Result_Mutation_Response>;
  /** update multiples rows of table: "featured_clerkship_dist_result" */
  update_featured_clerkship_dist_result_many: Maybe<Array<Maybe<Featured_Clerkship_Dist_Result_Mutation_Response>>>;
  /** update data of the table: "featured_fellowship_dist_result" */
  update_featured_fellowship_dist_result: Maybe<Featured_Fellowship_Dist_Result_Mutation_Response>;
  /** update multiples rows of table: "featured_fellowship_dist_result" */
  update_featured_fellowship_dist_result_many: Maybe<Array<Maybe<Featured_Fellowship_Dist_Result_Mutation_Response>>>;
  /** update data of the table: "featured_residency_dist_result" */
  update_featured_residency_dist_result: Maybe<Featured_Residency_Dist_Result_Mutation_Response>;
  /** update multiples rows of table: "featured_residency_dist_result" */
  update_featured_residency_dist_result_many: Maybe<Array<Maybe<Featured_Residency_Dist_Result_Mutation_Response>>>;
  /** update data of the table: "fellowship" */
  update_fellowship: Maybe<Fellowship_Mutation_Response>;
  /** update single row of the table: "fellowship" */
  update_fellowship_by_pk: Maybe<Fellowship>;
  /** update multiples rows of table: "fellowship" */
  update_fellowship_many: Maybe<Array<Maybe<Fellowship_Mutation_Response>>>;
  /** update data of the table: "fellowship_survey" */
  update_fellowship_survey: Maybe<Fellowship_Survey_Mutation_Response>;
  /** update single row of the table: "fellowship_survey" */
  update_fellowship_survey_by_pk: Maybe<Fellowship_Survey>;
  /** update multiples rows of table: "fellowship_survey" */
  update_fellowship_survey_many: Maybe<Array<Maybe<Fellowship_Survey_Mutation_Response>>>;
  /** update data of the table: "file" */
  update_file: Maybe<File_Mutation_Response>;
  /** update single row of the table: "file" */
  update_file_by_pk: Maybe<File>;
  /** update multiples rows of table: "file" */
  update_file_many: Maybe<Array<Maybe<File_Mutation_Response>>>;
  /** update data of the table: "fsmb_bio" */
  update_fsmb_bio: Maybe<Fsmb_Bio_Mutation_Response>;
  /** update single row of the table: "fsmb_bio" */
  update_fsmb_bio_by_pk: Maybe<Fsmb_Bio>;
  /** update multiples rows of table: "fsmb_bio" */
  update_fsmb_bio_many: Maybe<Array<Maybe<Fsmb_Bio_Mutation_Response>>>;
  /** update data of the table: "fsmb_licensure" */
  update_fsmb_licensure: Maybe<Fsmb_Licensure_Mutation_Response>;
  /** update single row of the table: "fsmb_licensure" */
  update_fsmb_licensure_by_pk: Maybe<Fsmb_Licensure>;
  /** update multiples rows of table: "fsmb_licensure" */
  update_fsmb_licensure_many: Maybe<Array<Maybe<Fsmb_Licensure_Mutation_Response>>>;
  /** update data of the table: "gmaps_link" */
  update_gmaps_link: Maybe<Gmaps_Link_Mutation_Response>;
  /** update single row of the table: "gmaps_link" */
  update_gmaps_link_by_pk: Maybe<Gmaps_Link>;
  /** update multiples rows of table: "gmaps_link" */
  update_gmaps_link_many: Maybe<Array<Maybe<Gmaps_Link_Mutation_Response>>>;
  /** update data of the table: "gmaps_link_type" */
  update_gmaps_link_type: Maybe<Gmaps_Link_Type_Mutation_Response>;
  /** update single row of the table: "gmaps_link_type" */
  update_gmaps_link_type_by_pk: Maybe<Gmaps_Link_Type>;
  /** update multiples rows of table: "gmaps_link_type" */
  update_gmaps_link_type_many: Maybe<Array<Maybe<Gmaps_Link_Type_Mutation_Response>>>;
  /** update data of the table: "gmaps_place" */
  update_gmaps_place: Maybe<Gmaps_Place_Mutation_Response>;
  /** update single row of the table: "gmaps_place" */
  update_gmaps_place_by_pk: Maybe<Gmaps_Place>;
  /** update multiples rows of table: "gmaps_place" */
  update_gmaps_place_many: Maybe<Array<Maybe<Gmaps_Place_Mutation_Response>>>;
  /** update data of the table: "identity_provider" */
  update_identity_provider: Maybe<Identity_Provider_Mutation_Response>;
  /** update single row of the table: "identity_provider" */
  update_identity_provider_by_pk: Maybe<Identity_Provider>;
  /** update multiples rows of table: "identity_provider" */
  update_identity_provider_many: Maybe<Array<Maybe<Identity_Provider_Mutation_Response>>>;
  /** update data of the table: "job_application" */
  update_job_application: Maybe<Job_Application_Mutation_Response>;
  /** update data of the table: "job_application_batch" */
  update_job_application_batch: Maybe<Job_Application_Batch_Mutation_Response>;
  /** update single row of the table: "job_application_batch" */
  update_job_application_batch_by_pk: Maybe<Job_Application_Batch>;
  /** update multiples rows of table: "job_application_batch" */
  update_job_application_batch_many: Maybe<Array<Maybe<Job_Application_Batch_Mutation_Response>>>;
  /** update single row of the table: "job_application" */
  update_job_application_by_pk: Maybe<Job_Application>;
  /** update multiples rows of table: "job_application" */
  update_job_application_many: Maybe<Array<Maybe<Job_Application_Mutation_Response>>>;
  /** update data of the table: "job_application_posting" */
  update_job_application_posting: Maybe<Job_Application_Posting_Mutation_Response>;
  /** update single row of the table: "job_application_posting" */
  update_job_application_posting_by_pk: Maybe<Job_Application_Posting>;
  /** update multiples rows of table: "job_application_posting" */
  update_job_application_posting_many: Maybe<Array<Maybe<Job_Application_Posting_Mutation_Response>>>;
  /** update data of the table: "job_posting" */
  update_job_posting: Maybe<Job_Posting_Mutation_Response>;
  /** update single row of the table: "job_posting" */
  update_job_posting_by_pk: Maybe<Job_Posting>;
  /** update multiples rows of table: "job_posting" */
  update_job_posting_many: Maybe<Array<Maybe<Job_Posting_Mutation_Response>>>;
  /** update data of the table: "nearby_facilities_by_geography_result" */
  update_nearby_facilities_by_geography_result: Maybe<Nearby_Facilities_By_Geography_Result_Mutation_Response>;
  /** update multiples rows of table: "nearby_facilities_by_geography_result" */
  update_nearby_facilities_by_geography_result_many: Maybe<Array<Maybe<Nearby_Facilities_By_Geography_Result_Mutation_Response>>>;
  /** update data of the table: "org_dist_result" */
  update_org_dist_result: Maybe<Org_Dist_Result_Mutation_Response>;
  /** update multiples rows of table: "org_dist_result" */
  update_org_dist_result_many: Maybe<Array<Maybe<Org_Dist_Result_Mutation_Response>>>;
  /** update data of the table: "org_domain" */
  update_org_domain: Maybe<Org_Domain_Mutation_Response>;
  /** update single row of the table: "org_domain" */
  update_org_domain_by_pk: Maybe<Org_Domain>;
  /** update multiples rows of table: "org_domain" */
  update_org_domain_many: Maybe<Array<Maybe<Org_Domain_Mutation_Response>>>;
  /** update data of the table: "org_user" */
  update_org_user: Maybe<Org_User_Mutation_Response>;
  /** update single row of the table: "org_user" */
  update_org_user_by_pk: Maybe<Org_User>;
  /** update multiples rows of table: "org_user" */
  update_org_user_many: Maybe<Array<Maybe<Org_User_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "organization" */
  update_organization_by_pk: Maybe<Organization>;
  /** update multiples rows of table: "organization" */
  update_organization_many: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "personal_info" */
  update_personal_info: Maybe<Personal_Info_Mutation_Response>;
  /** update multiples rows of table: "personal_info" */
  update_personal_info_many: Maybe<Array<Maybe<Personal_Info_Mutation_Response>>>;
  /** update data of the table: "place_boundary" */
  update_place_boundary: Maybe<Place_Boundary_Mutation_Response>;
  /** update single row of the table: "place_boundary" */
  update_place_boundary_by_pk: Maybe<Place_Boundary>;
  /** update multiples rows of table: "place_boundary" */
  update_place_boundary_many: Maybe<Array<Maybe<Place_Boundary_Mutation_Response>>>;
  /** update data of the table: "posting_app_cert" */
  update_posting_app_cert: Maybe<Posting_App_Cert_Mutation_Response>;
  /** update single row of the table: "posting_app_cert" */
  update_posting_app_cert_by_pk: Maybe<Posting_App_Cert>;
  /** update multiples rows of table: "posting_app_cert" */
  update_posting_app_cert_many: Maybe<Array<Maybe<Posting_App_Cert_Mutation_Response>>>;
  /** update data of the table: "posting_board_cert" */
  update_posting_board_cert: Maybe<Posting_Board_Cert_Mutation_Response>;
  /** update single row of the table: "posting_board_cert" */
  update_posting_board_cert_by_pk: Maybe<Posting_Board_Cert>;
  /** update multiples rows of table: "posting_board_cert" */
  update_posting_board_cert_many: Maybe<Array<Maybe<Posting_Board_Cert_Mutation_Response>>>;
  /** update data of the table: "posting_profession" */
  update_posting_profession: Maybe<Posting_Profession_Mutation_Response>;
  /** update single row of the table: "posting_profession" */
  update_posting_profession_by_pk: Maybe<Posting_Profession>;
  /** update multiples rows of table: "posting_profession" */
  update_posting_profession_many: Maybe<Array<Maybe<Posting_Profession_Mutation_Response>>>;
  /** update data of the table: "posting_worker_classification" */
  update_posting_worker_classification: Maybe<Posting_Worker_Classification_Mutation_Response>;
  /** update single row of the table: "posting_worker_classification" */
  update_posting_worker_classification_by_pk: Maybe<Posting_Worker_Classification>;
  /** update multiples rows of table: "posting_worker_classification" */
  update_posting_worker_classification_many: Maybe<Array<Maybe<Posting_Worker_Classification_Mutation_Response>>>;
  /** update data of the table: "relevant_job_posting" */
  update_relevant_job_posting: Maybe<Relevant_Job_Posting_Mutation_Response>;
  /** update multiples rows of table: "relevant_job_posting" */
  update_relevant_job_posting_many: Maybe<Array<Maybe<Relevant_Job_Posting_Mutation_Response>>>;
  /** update data of the table: "relevant_salary_report" */
  update_relevant_salary_report: Maybe<Relevant_Salary_Report_Mutation_Response>;
  /** update multiples rows of table: "relevant_salary_report" */
  update_relevant_salary_report_many: Maybe<Array<Maybe<Relevant_Salary_Report_Mutation_Response>>>;
  /** update data of the table: "residency" */
  update_residency: Maybe<Residency_Mutation_Response>;
  /** update single row of the table: "residency" */
  update_residency_by_pk: Maybe<Residency>;
  /** update multiples rows of table: "residency" */
  update_residency_many: Maybe<Array<Maybe<Residency_Mutation_Response>>>;
  /** update data of the table: "residency_survey" */
  update_residency_survey: Maybe<Residency_Survey_Mutation_Response>;
  /** update single row of the table: "residency_survey" */
  update_residency_survey_by_pk: Maybe<Residency_Survey>;
  /** update multiples rows of table: "residency_survey" */
  update_residency_survey_many: Maybe<Array<Maybe<Residency_Survey_Mutation_Response>>>;
  /** update data of the table: "review" */
  update_review: Maybe<Review_Mutation_Response>;
  /** update single row of the table: "review" */
  update_review_by_pk: Maybe<Review>;
  /** update multiples rows of table: "review" */
  update_review_many: Maybe<Array<Maybe<Review_Mutation_Response>>>;
  /** update data of the table: "review_reply" */
  update_review_reply: Maybe<Review_Reply_Mutation_Response>;
  /** update single row of the table: "review_reply" */
  update_review_reply_by_pk: Maybe<Review_Reply>;
  /** update multiples rows of table: "review_reply" */
  update_review_reply_many: Maybe<Array<Maybe<Review_Reply_Mutation_Response>>>;
  /** update data of the table: "review_report" */
  update_review_report: Maybe<Review_Report_Mutation_Response>;
  /** update single row of the table: "review_report" */
  update_review_report_by_pk: Maybe<Review_Report>;
  /** update multiples rows of table: "review_report" */
  update_review_report_many: Maybe<Array<Maybe<Review_Report_Mutation_Response>>>;
  /** update data of the table: "review_vote" */
  update_review_vote: Maybe<Review_Vote_Mutation_Response>;
  /** update single row of the table: "review_vote" */
  update_review_vote_by_pk: Maybe<Review_Vote>;
  /** update multiples rows of table: "review_vote" */
  update_review_vote_many: Maybe<Array<Maybe<Review_Vote_Mutation_Response>>>;
  /** update data of the table: "salary_report" */
  update_salary_report: Maybe<Salary_Report_Mutation_Response>;
  /** update single row of the table: "salary_report" */
  update_salary_report_by_pk: Maybe<Salary_Report>;
  /** update data of the table: "salary_report_fmt" */
  update_salary_report_fmt: Maybe<Salary_Report_Fmt_Mutation_Response>;
  /** update multiples rows of table: "salary_report_fmt" */
  update_salary_report_fmt_many: Maybe<Array<Maybe<Salary_Report_Fmt_Mutation_Response>>>;
  /** update multiples rows of table: "salary_report" */
  update_salary_report_many: Maybe<Array<Maybe<Salary_Report_Mutation_Response>>>;
  /** update data of the table: "school" */
  update_school: Maybe<School_Mutation_Response>;
  /** update single row of the table: "school" */
  update_school_by_pk: Maybe<School>;
  /** update multiples rows of table: "school" */
  update_school_many: Maybe<Array<Maybe<School_Mutation_Response>>>;
  /** update data of the table: "search_candidate_result" */
  update_search_candidate_result: Maybe<Search_Candidate_Result_Mutation_Response>;
  /** update multiples rows of table: "search_candidate_result" */
  update_search_candidate_result_many: Maybe<Array<Maybe<Search_Candidate_Result_Mutation_Response>>>;
  /** update data of the table: "search_clerkship_by_geography_result" */
  update_search_clerkship_by_geography_result: Maybe<Search_Clerkship_By_Geography_Result_Mutation_Response>;
  /** update multiples rows of table: "search_clerkship_by_geography_result" */
  update_search_clerkship_by_geography_result_many: Maybe<Array<Maybe<Search_Clerkship_By_Geography_Result_Mutation_Response>>>;
  /** update data of the table: "search_facility_by_prefix_result" */
  update_search_facility_by_prefix_result: Maybe<Search_Facility_By_Prefix_Result_Mutation_Response>;
  /** update multiples rows of table: "search_facility_by_prefix_result" */
  update_search_facility_by_prefix_result_many: Maybe<Array<Maybe<Search_Facility_By_Prefix_Result_Mutation_Response>>>;
  /** update data of the table: "search_fellowship_by_geography_result" */
  update_search_fellowship_by_geography_result: Maybe<Search_Fellowship_By_Geography_Result_Mutation_Response>;
  /** update multiples rows of table: "search_fellowship_by_geography_result" */
  update_search_fellowship_by_geography_result_many: Maybe<Array<Maybe<Search_Fellowship_By_Geography_Result_Mutation_Response>>>;
  /** update data of the table: "search_fsmb_bio_result" */
  update_search_fsmb_bio_result: Maybe<Search_Fsmb_Bio_Result_Mutation_Response>;
  /** update multiples rows of table: "search_fsmb_bio_result" */
  update_search_fsmb_bio_result_many: Maybe<Array<Maybe<Search_Fsmb_Bio_Result_Mutation_Response>>>;
  /** update data of the table: "search_job_postings_by_geography_result" */
  update_search_job_postings_by_geography_result: Maybe<Search_Job_Postings_By_Geography_Result_Mutation_Response>;
  /** update multiples rows of table: "search_job_postings_by_geography_result" */
  update_search_job_postings_by_geography_result_many: Maybe<Array<Maybe<Search_Job_Postings_By_Geography_Result_Mutation_Response>>>;
  /** update data of the table: "search_org_market_result" */
  update_search_org_market_result: Maybe<Search_Org_Market_Result_Mutation_Response>;
  /** update multiples rows of table: "search_org_market_result" */
  update_search_org_market_result_many: Maybe<Array<Maybe<Search_Org_Market_Result_Mutation_Response>>>;
  /** update data of the table: "search_organization_by_prefix_result" */
  update_search_organization_by_prefix_result: Maybe<Search_Organization_By_Prefix_Result_Mutation_Response>;
  /** update multiples rows of table: "search_organization_by_prefix_result" */
  update_search_organization_by_prefix_result_many: Maybe<Array<Maybe<Search_Organization_By_Prefix_Result_Mutation_Response>>>;
  /** update data of the table: "search_residency_by_geography_result" */
  update_search_residency_by_geography_result: Maybe<Search_Residency_By_Geography_Result_Mutation_Response>;
  /** update multiples rows of table: "search_residency_by_geography_result" */
  update_search_residency_by_geography_result_many: Maybe<Array<Maybe<Search_Residency_By_Geography_Result_Mutation_Response>>>;
  /** update data of the table: "search_training_by_prefix_result" */
  update_search_training_by_prefix_result: Maybe<Search_Training_By_Prefix_Result_Mutation_Response>;
  /** update multiples rows of table: "search_training_by_prefix_result" */
  update_search_training_by_prefix_result_many: Maybe<Array<Maybe<Search_Training_By_Prefix_Result_Mutation_Response>>>;
  /** update data of the table: "site" */
  update_site: Maybe<Site_Mutation_Response>;
  /** update single row of the table: "site" */
  update_site_by_pk: Maybe<Site>;
  /** update multiples rows of table: "site" */
  update_site_many: Maybe<Array<Maybe<Site_Mutation_Response>>>;
  /** update data of the table: "stroke_cert" */
  update_stroke_cert: Maybe<Stroke_Cert_Mutation_Response>;
  /** update single row of the table: "stroke_cert" */
  update_stroke_cert_by_pk: Maybe<Stroke_Cert>;
  /** update multiples rows of table: "stroke_cert" */
  update_stroke_cert_many: Maybe<Array<Maybe<Stroke_Cert_Mutation_Response>>>;
  /** update data of the table: "training" */
  update_training: Maybe<Training_Mutation_Response>;
  /** update single row of the table: "training" */
  update_training_by_pk: Maybe<Training>;
  /** update data of the table: "training_event" */
  update_training_event: Maybe<Training_Event_Mutation_Response>;
  /** update single row of the table: "training_event" */
  update_training_event_by_pk: Maybe<Training_Event>;
  /** update multiples rows of table: "training_event" */
  update_training_event_many: Maybe<Array<Maybe<Training_Event_Mutation_Response>>>;
  /** update data of the table: "training_field" */
  update_training_field: Maybe<Training_Field_Mutation_Response>;
  /** update single row of the table: "training_field" */
  update_training_field_by_pk: Maybe<Training_Field>;
  /** update multiples rows of table: "training_field" */
  update_training_field_many: Maybe<Array<Maybe<Training_Field_Mutation_Response>>>;
  /** update multiples rows of table: "training" */
  update_training_many: Maybe<Array<Maybe<Training_Mutation_Response>>>;
  /** update data of the table: "training_program" */
  update_training_program: Maybe<Training_Program_Mutation_Response>;
  /** update single row of the table: "training_program" */
  update_training_program_by_pk: Maybe<Training_Program>;
  /** update multiples rows of table: "training_program" */
  update_training_program_many: Maybe<Array<Maybe<Training_Program_Mutation_Response>>>;
  /** update data of the table: "training_survey" */
  update_training_survey: Maybe<Training_Survey_Mutation_Response>;
  /** update single row of the table: "training_survey" */
  update_training_survey_by_pk: Maybe<Training_Survey>;
  /** update multiples rows of table: "training_survey" */
  update_training_survey_many: Maybe<Array<Maybe<Training_Survey_Mutation_Response>>>;
  /** update data of the table: "training_survey_picture" */
  update_training_survey_picture: Maybe<Training_Survey_Picture_Mutation_Response>;
  /** update single row of the table: "training_survey_picture" */
  update_training_survey_picture_by_pk: Maybe<Training_Survey_Picture>;
  /** update multiples rows of table: "training_survey_picture" */
  update_training_survey_picture_many: Maybe<Array<Maybe<Training_Survey_Picture_Mutation_Response>>>;
  /** update data of the table: "training_survey_site" */
  update_training_survey_site: Maybe<Training_Survey_Site_Mutation_Response>;
  /** update single row of the table: "training_survey_site" */
  update_training_survey_site_by_pk: Maybe<Training_Survey_Site>;
  /** update multiples rows of table: "training_survey_site" */
  update_training_survey_site_many: Maybe<Array<Maybe<Training_Survey_Site_Mutation_Response>>>;
  update_training_survey_status: UpdateTrainingSurveyStatusResult;
  /** Upsert one asset */
  upsertAsset: Maybe<Asset>;
  /** Upsert one faq */
  upsertFaq: Maybe<Faq>;
  /** Upsert one legal */
  upsertLegal: Maybe<Legal>;
  /** Upsert one post */
  upsertPost: Maybe<Post>;
  /** Upsert one teammate */
  upsertTeammate: Maybe<Teammate>;
  upsert_customer: CustomerGql;
};


/** mutation root */
export type Mutation_RootAccept_Acep_Org_SurveyArgs = {
  acep_org_survey_id: Scalars['String'];
  org_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootApply_To_JobsArgs = {
  input: ApplyToJobsInput;
};


/** mutation root */
export type Mutation_RootChange_Facility_PictureArgs = {
  args: Change_Facility_Picture_Args;
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCheck_Org_User_Signup_StatusArgs = {
  email: Scalars['String'];
  org_id: Scalars['String'];
  send_verification?: Scalars['Boolean'];
};


/** mutation root */
export type Mutation_RootClaim_Org_UserArgs = {
  input: ClaimOrgUserInput;
};


/** mutation root */
export type Mutation_RootComplete_Customer_CheckoutArgs = {
  customer_details: CustomerDetailsInput;
};


/** mutation root */
export type Mutation_RootCreateAdAuctionArgs = {
  input: CreateAdAuctionInput;
};


/** mutation root */
export type Mutation_RootCreateAssetArgs = {
  data: AssetCreateInput;
};


/** mutation root */
export type Mutation_RootCreateFaqArgs = {
  data: FaqCreateInput;
};


/** mutation root */
export type Mutation_RootCreateLegalArgs = {
  data: LegalCreateInput;
};


/** mutation root */
export type Mutation_RootCreatePostArgs = {
  data: PostCreateInput;
};


/** mutation root */
export type Mutation_RootCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


/** mutation root */
export type Mutation_RootCreateTeammateArgs = {
  data: TeammateCreateInput;
};


/** mutation root */
export type Mutation_RootCreate_Customer_SubscriptionArgs = {
  customer_details: CustomerDetailsInput;
  interval: Scalars['String'];
  payment_id?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootCreate_FileArgs = {
  content_type?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  origin?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDeleteFaqArgs = {
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDeleteLegalArgs = {
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyFaqsArgs = {
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyLegalsArgs = {
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyLegalsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyPostsArgs = {
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyTeammatesArgs = {
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeleteManyTeammatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootDeletePostArgs = {
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDeleteTeammateArgs = {
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootDelete_As20DemArgs = {
  where: As20Dem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As20Dem_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As20Svc1Args = {
  where: As20Svc1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As20Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As20Svc2Args = {
  where: As20Svc2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As20Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As20Svc3Args = {
  where: As20Svc3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As20Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As20Util1Args = {
  where: As20Util1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As20Util1_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As20Util2Args = {
  where: As20Util2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As20Util2_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21DemArgs = {
  where: As21Dem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Dem_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21Svc1Args = {
  where: As21Svc1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21Svc2Args = {
  where: As21Svc2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21Svc3Args = {
  where: As21Svc3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21UnitArgs = {
  where: As21Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Unit_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21UtilArgs = {
  where: As21Util_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Util2Args = {
  where: As21Util2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As21Util2_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As21Util_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22DemArgs = {
  where: As22Dem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Dem_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22Svc1Args = {
  where: As22Svc1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22Svc2Args = {
  where: As22Svc2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22Svc3Args = {
  where: As22Svc3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22UnitArgs = {
  where: As22Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Unit_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22UtilArgs = {
  where: As22Util_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Util2Args = {
  where: As22Util2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_As22Util2_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_As22Util_By_PkArgs = {
  ID: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Ab_TestArgs = {
  where: Ab_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ab_Test_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Access_InfoArgs = {
  where: Access_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AccountArgs = {
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Account_RoleArgs = {
  where: Account_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Account_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Acep_Org_SurveyArgs = {
  where: Acep_Org_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Acep_Org_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_BoardArgs = {
  where: Board_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Board_CertArgs = {
  where: Board_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CandidateArgs = {
  where: Candidate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Candidate_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cert_OrgArgs = {
  where: Cert_Org_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cert_Org_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ClerkshipArgs = {
  where: Clerkship_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clerkship_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clerkship_SurveyArgs = {
  where: Clerkship_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clerkship_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ClinicianArgs = {
  where: Clinician_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_App_CertArgs = {
  where: Clinician_App_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_App_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clinician_Board_CertArgs = {
  where: Clinician_Board_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clinician_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clinician_LicenseArgs = {
  where: Clinician_License_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_License_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clinician_Sp_ExpArgs = {
  where: Clinician_Sp_Exp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_Sp_Exp_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clinician_SpecialtyArgs = {
  where: Clinician_Specialty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_Specialty_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Clinician_TrainingArgs = {
  where: Clinician_Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Clinician_Training_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cms_FacilityArgs = {
  where: Cms_Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_EnrollmentArgs = {
  where: Cms_Facility_Enrollment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_Enrollment_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_MetricArgs = {
  where: Cms_Facility_Metric_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_Metric_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_PosArgs = {
  where: Cms_Facility_Pos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cms_Facility_Pos_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Cms_SpecialtyArgs = {
  where: Cms_Specialty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cms_Specialty_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Contact_InfoArgs = {
  where: Contact_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Current_AccountArgs = {
  where: Current_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Payment_MethodArgs = {
  default_payment_id?: InputMaybe<Scalars['String']>;
  payment_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Email_ContactArgs = {
  where: Email_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_EnvelopeArgs = {
  where: Email_Envelope_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Envelope_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_EventArgs = {
  where: Email_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_MessageArgs = {
  where: Email_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_PointerArgs = {
  where: Email_Pointer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Pointer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ext_Job_PostingArgs = {
  where: Ext_Job_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ext_Job_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ext_Job_ScrapeArgs = {
  where: Ext_Job_Scrape_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ext_Job_Scrape_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ext_Posting_ErrorArgs = {
  where: Ext_Posting_Error_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ext_Posting_Error_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Ext_Posting_ProfessionArgs = {
  where: Ext_Posting_Profession_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ext_Posting_Profession_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FacilityArgs = {
  where: Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_AccreditationArgs = {
  where: Facility_Accreditation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_Accreditation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Facility_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Facility_ContractArgs = {
  where: Facility_Contract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_Contract_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Facility_Contract_FeaturedArgs = {
  where: Facility_Contract_Featured_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_Contract_Featured_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Facility_CorrectionArgs = {
  where: Facility_Correction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_Correction_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Facility_Dist_ResultArgs = {
  where: Facility_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_EhrArgs = {
  where: Facility_Ehr_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Facility_Ehr_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FavoriteArgs = {
  where: Favorite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Favorite_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Featured_Clerkship_Dist_ResultArgs = {
  where: Featured_Clerkship_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Featured_Fellowship_Dist_ResultArgs = {
  where: Featured_Fellowship_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Featured_Residency_Dist_ResultArgs = {
  where: Featured_Residency_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FellowshipArgs = {
  where: Fellowship_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fellowship_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fellowship_SurveyArgs = {
  where: Fellowship_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fellowship_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Fsmb_BioArgs = {
  where: Fsmb_Bio_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fsmb_Bio_By_PkArgs = {
  fid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Fsmb_LicensureArgs = {
  where: Fsmb_Licensure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Fsmb_Licensure_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gmaps_LinkArgs = {
  where: Gmaps_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gmaps_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gmaps_Link_TypeArgs = {
  where: Gmaps_Link_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gmaps_Link_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Gmaps_PlaceArgs = {
  where: Gmaps_Place_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Gmaps_Place_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Identity_ProviderArgs = {
  where: Identity_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Identity_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Job_ApplicationArgs = {
  where: Job_Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Application_BatchArgs = {
  where: Job_Application_Batch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Application_Batch_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Job_Application_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Job_Application_PostingArgs = {
  where: Job_Application_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Application_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Job_PostingArgs = {
  where: Job_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Nearby_Facilities_By_Geography_ResultArgs = {
  where: Nearby_Facilities_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Dist_ResultArgs = {
  where: Org_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_DomainArgs = {
  where: Org_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Domain_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_UserArgs = {
  where: Org_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_User_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Personal_InfoArgs = {
  where: Personal_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Place_BoundaryArgs = {
  where: Place_Boundary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Place_Boundary_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_App_CertArgs = {
  where: Posting_App_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_App_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_Board_CertArgs = {
  where: Posting_Board_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_ProfessionArgs = {
  where: Posting_Profession_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_Profession_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Posting_Worker_ClassificationArgs = {
  where: Posting_Worker_Classification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Posting_Worker_Classification_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Relevant_Job_PostingArgs = {
  where: Relevant_Job_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relevant_Salary_ReportArgs = {
  where: Relevant_Salary_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ResidencyArgs = {
  where: Residency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Residency_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Residency_SurveyArgs = {
  where: Residency_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Residency_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ReviewArgs = {
  where: Review_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Review_ReplyArgs = {
  where: Review_Reply_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_Reply_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Review_ReportArgs = {
  where: Review_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_Report_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Review_VoteArgs = {
  where: Review_Vote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_Vote_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Salary_ReportArgs = {
  where: Salary_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Salary_Report_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Salary_Report_FmtArgs = {
  where: Salary_Report_Fmt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SchoolArgs = {
  where: School_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_School_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Search_Candidate_ResultArgs = {
  where: Search_Candidate_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Clerkship_By_Geography_ResultArgs = {
  where: Search_Clerkship_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Facility_By_Prefix_ResultArgs = {
  where: Search_Facility_By_Prefix_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Fellowship_By_Geography_ResultArgs = {
  where: Search_Fellowship_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Fsmb_Bio_ResultArgs = {
  where: Search_Fsmb_Bio_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Job_Postings_By_Geography_ResultArgs = {
  where: Search_Job_Postings_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Org_Market_ResultArgs = {
  where: Search_Org_Market_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Organization_By_Prefix_ResultArgs = {
  where: Search_Organization_By_Prefix_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Residency_By_Geography_ResultArgs = {
  where: Search_Residency_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Training_By_Prefix_ResultArgs = {
  where: Search_Training_By_Prefix_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SiteArgs = {
  where: Site_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Site_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Stroke_CertArgs = {
  where: Stroke_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Stroke_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_TrainingArgs = {
  where: Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Training_EventArgs = {
  where: Training_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Training_FieldArgs = {
  where: Training_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Training_ProgramArgs = {
  where: Training_Program_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_Program_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Training_SurveyArgs = {
  where: Training_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Training_Survey_PictureArgs = {
  where: Training_Survey_Picture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_Survey_Picture_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Training_Survey_SiteArgs = {
  where: Training_Survey_Site_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Training_Survey_Site_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootFinalize_Email_ChangeArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootFinalize_FileArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootFinalize_SignupArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootImport_CredentialsArgs = {
  fid: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_As20DemArgs = {
  objects: Array<As20Dem_Insert_Input>;
  on_conflict?: InputMaybe<As20Dem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Dem_OneArgs = {
  object: As20Dem_Insert_Input;
  on_conflict?: InputMaybe<As20Dem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Svc1Args = {
  objects: Array<As20Svc1_Insert_Input>;
  on_conflict?: InputMaybe<As20Svc1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Svc1_OneArgs = {
  object: As20Svc1_Insert_Input;
  on_conflict?: InputMaybe<As20Svc1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Svc2Args = {
  objects: Array<As20Svc2_Insert_Input>;
  on_conflict?: InputMaybe<As20Svc2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Svc2_OneArgs = {
  object: As20Svc2_Insert_Input;
  on_conflict?: InputMaybe<As20Svc2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Svc3Args = {
  objects: Array<As20Svc3_Insert_Input>;
  on_conflict?: InputMaybe<As20Svc3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Svc3_OneArgs = {
  object: As20Svc3_Insert_Input;
  on_conflict?: InputMaybe<As20Svc3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Util1Args = {
  objects: Array<As20Util1_Insert_Input>;
  on_conflict?: InputMaybe<As20Util1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Util1_OneArgs = {
  object: As20Util1_Insert_Input;
  on_conflict?: InputMaybe<As20Util1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Util2Args = {
  objects: Array<As20Util2_Insert_Input>;
  on_conflict?: InputMaybe<As20Util2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As20Util2_OneArgs = {
  object: As20Util2_Insert_Input;
  on_conflict?: InputMaybe<As20Util2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21DemArgs = {
  objects: Array<As21Dem_Insert_Input>;
  on_conflict?: InputMaybe<As21Dem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Dem_OneArgs = {
  object: As21Dem_Insert_Input;
  on_conflict?: InputMaybe<As21Dem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Svc1Args = {
  objects: Array<As21Svc1_Insert_Input>;
  on_conflict?: InputMaybe<As21Svc1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Svc1_OneArgs = {
  object: As21Svc1_Insert_Input;
  on_conflict?: InputMaybe<As21Svc1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Svc2Args = {
  objects: Array<As21Svc2_Insert_Input>;
  on_conflict?: InputMaybe<As21Svc2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Svc2_OneArgs = {
  object: As21Svc2_Insert_Input;
  on_conflict?: InputMaybe<As21Svc2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Svc3Args = {
  objects: Array<As21Svc3_Insert_Input>;
  on_conflict?: InputMaybe<As21Svc3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Svc3_OneArgs = {
  object: As21Svc3_Insert_Input;
  on_conflict?: InputMaybe<As21Svc3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21UnitArgs = {
  objects: Array<As21Unit_Insert_Input>;
  on_conflict?: InputMaybe<As21Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Unit_OneArgs = {
  object: As21Unit_Insert_Input;
  on_conflict?: InputMaybe<As21Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21UtilArgs = {
  objects: Array<As21Util_Insert_Input>;
  on_conflict?: InputMaybe<As21Util_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Util2Args = {
  objects: Array<As21Util2_Insert_Input>;
  on_conflict?: InputMaybe<As21Util2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Util2_OneArgs = {
  object: As21Util2_Insert_Input;
  on_conflict?: InputMaybe<As21Util2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As21Util_OneArgs = {
  object: As21Util_Insert_Input;
  on_conflict?: InputMaybe<As21Util_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22DemArgs = {
  objects: Array<As22Dem_Insert_Input>;
  on_conflict?: InputMaybe<As22Dem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Dem_OneArgs = {
  object: As22Dem_Insert_Input;
  on_conflict?: InputMaybe<As22Dem_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Svc1Args = {
  objects: Array<As22Svc1_Insert_Input>;
  on_conflict?: InputMaybe<As22Svc1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Svc1_OneArgs = {
  object: As22Svc1_Insert_Input;
  on_conflict?: InputMaybe<As22Svc1_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Svc2Args = {
  objects: Array<As22Svc2_Insert_Input>;
  on_conflict?: InputMaybe<As22Svc2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Svc2_OneArgs = {
  object: As22Svc2_Insert_Input;
  on_conflict?: InputMaybe<As22Svc2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Svc3Args = {
  objects: Array<As22Svc3_Insert_Input>;
  on_conflict?: InputMaybe<As22Svc3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Svc3_OneArgs = {
  object: As22Svc3_Insert_Input;
  on_conflict?: InputMaybe<As22Svc3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22UnitArgs = {
  objects: Array<As22Unit_Insert_Input>;
  on_conflict?: InputMaybe<As22Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Unit_OneArgs = {
  object: As22Unit_Insert_Input;
  on_conflict?: InputMaybe<As22Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22UtilArgs = {
  objects: Array<As22Util_Insert_Input>;
  on_conflict?: InputMaybe<As22Util_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Util2Args = {
  objects: Array<As22Util2_Insert_Input>;
  on_conflict?: InputMaybe<As22Util2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Util2_OneArgs = {
  object: As22Util2_Insert_Input;
  on_conflict?: InputMaybe<As22Util2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_As22Util_OneArgs = {
  object: As22Util_Insert_Input;
  on_conflict?: InputMaybe<As22Util_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ab_TestArgs = {
  objects: Array<Ab_Test_Insert_Input>;
  on_conflict?: InputMaybe<Ab_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ab_Test_OneArgs = {
  object: Ab_Test_Insert_Input;
  on_conflict?: InputMaybe<Ab_Test_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Access_InfoArgs = {
  objects: Array<Access_Info_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Access_Info_OneArgs = {
  object: Access_Info_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_AccountArgs = {
  objects: Array<Account_Insert_Input>;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_OneArgs = {
  object: Account_Insert_Input;
  on_conflict?: InputMaybe<Account_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_RoleArgs = {
  objects: Array<Account_Role_Insert_Input>;
  on_conflict?: InputMaybe<Account_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Account_Role_OneArgs = {
  object: Account_Role_Insert_Input;
  on_conflict?: InputMaybe<Account_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Acep_Org_SurveyArgs = {
  objects: Array<Acep_Org_Survey_Insert_Input>;
  on_conflict?: InputMaybe<Acep_Org_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Acep_Org_Survey_OneArgs = {
  object: Acep_Org_Survey_Insert_Input;
  on_conflict?: InputMaybe<Acep_Org_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BoardArgs = {
  objects: Array<Board_Insert_Input>;
  on_conflict?: InputMaybe<Board_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_CertArgs = {
  objects: Array<Board_Cert_Insert_Input>;
  on_conflict?: InputMaybe<Board_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_Cert_OneArgs = {
  object: Board_Cert_Insert_Input;
  on_conflict?: InputMaybe<Board_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Board_OneArgs = {
  object: Board_Insert_Input;
  on_conflict?: InputMaybe<Board_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CandidateArgs = {
  objects: Array<Candidate_Insert_Input>;
  on_conflict?: InputMaybe<Candidate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Candidate_OneArgs = {
  object: Candidate_Insert_Input;
  on_conflict?: InputMaybe<Candidate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cert_OrgArgs = {
  objects: Array<Cert_Org_Insert_Input>;
  on_conflict?: InputMaybe<Cert_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cert_Org_OneArgs = {
  object: Cert_Org_Insert_Input;
  on_conflict?: InputMaybe<Cert_Org_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClerkshipArgs = {
  objects: Array<Clerkship_Insert_Input>;
  on_conflict?: InputMaybe<Clerkship_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clerkship_OneArgs = {
  object: Clerkship_Insert_Input;
  on_conflict?: InputMaybe<Clerkship_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clerkship_SurveyArgs = {
  objects: Array<Clerkship_Survey_Insert_Input>;
  on_conflict?: InputMaybe<Clerkship_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clerkship_Survey_OneArgs = {
  object: Clerkship_Survey_Insert_Input;
  on_conflict?: InputMaybe<Clerkship_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ClinicianArgs = {
  objects: Array<Clinician_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_App_CertArgs = {
  objects: Array<Clinician_App_Cert_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_App_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_App_Cert_OneArgs = {
  object: Clinician_App_Cert_Insert_Input;
  on_conflict?: InputMaybe<Clinician_App_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_Board_CertArgs = {
  objects: Array<Clinician_Board_Cert_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_Board_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_Board_Cert_OneArgs = {
  object: Clinician_Board_Cert_Insert_Input;
  on_conflict?: InputMaybe<Clinician_Board_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_LicenseArgs = {
  objects: Array<Clinician_License_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_License_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_License_OneArgs = {
  object: Clinician_License_Insert_Input;
  on_conflict?: InputMaybe<Clinician_License_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_OneArgs = {
  object: Clinician_Insert_Input;
  on_conflict?: InputMaybe<Clinician_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_Sp_ExpArgs = {
  objects: Array<Clinician_Sp_Exp_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_Sp_Exp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_Sp_Exp_OneArgs = {
  object: Clinician_Sp_Exp_Insert_Input;
  on_conflict?: InputMaybe<Clinician_Sp_Exp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_SpecialtyArgs = {
  objects: Array<Clinician_Specialty_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_Specialty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_Specialty_OneArgs = {
  object: Clinician_Specialty_Insert_Input;
  on_conflict?: InputMaybe<Clinician_Specialty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_TrainingArgs = {
  objects: Array<Clinician_Training_Insert_Input>;
  on_conflict?: InputMaybe<Clinician_Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Clinician_Training_OneArgs = {
  object: Clinician_Training_Insert_Input;
  on_conflict?: InputMaybe<Clinician_Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_FacilityArgs = {
  objects: Array<Cms_Facility_Insert_Input>;
  on_conflict?: InputMaybe<Cms_Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_EnrollmentArgs = {
  objects: Array<Cms_Facility_Enrollment_Insert_Input>;
  on_conflict?: InputMaybe<Cms_Facility_Enrollment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_Enrollment_OneArgs = {
  object: Cms_Facility_Enrollment_Insert_Input;
  on_conflict?: InputMaybe<Cms_Facility_Enrollment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_MetricArgs = {
  objects: Array<Cms_Facility_Metric_Insert_Input>;
  on_conflict?: InputMaybe<Cms_Facility_Metric_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_Metric_OneArgs = {
  object: Cms_Facility_Metric_Insert_Input;
  on_conflict?: InputMaybe<Cms_Facility_Metric_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_OneArgs = {
  object: Cms_Facility_Insert_Input;
  on_conflict?: InputMaybe<Cms_Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_PosArgs = {
  objects: Array<Cms_Facility_Pos_Insert_Input>;
  on_conflict?: InputMaybe<Cms_Facility_Pos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Facility_Pos_OneArgs = {
  object: Cms_Facility_Pos_Insert_Input;
  on_conflict?: InputMaybe<Cms_Facility_Pos_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_SpecialtyArgs = {
  objects: Array<Cms_Specialty_Insert_Input>;
  on_conflict?: InputMaybe<Cms_Specialty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cms_Specialty_OneArgs = {
  object: Cms_Specialty_Insert_Input;
  on_conflict?: InputMaybe<Cms_Specialty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_InfoArgs = {
  objects: Array<Contact_Info_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Contact_Info_OneArgs = {
  object: Contact_Info_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Current_AccountArgs = {
  objects: Array<Current_Account_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Current_Account_OneArgs = {
  object: Current_Account_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Email_ContactArgs = {
  objects: Array<Email_Contact_Insert_Input>;
  on_conflict?: InputMaybe<Email_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Contact_OneArgs = {
  object: Email_Contact_Insert_Input;
  on_conflict?: InputMaybe<Email_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_EnvelopeArgs = {
  objects: Array<Email_Envelope_Insert_Input>;
  on_conflict?: InputMaybe<Email_Envelope_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Envelope_OneArgs = {
  object: Email_Envelope_Insert_Input;
  on_conflict?: InputMaybe<Email_Envelope_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_EventArgs = {
  objects: Array<Email_Event_Insert_Input>;
  on_conflict?: InputMaybe<Email_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Event_OneArgs = {
  object: Email_Event_Insert_Input;
  on_conflict?: InputMaybe<Email_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_MessageArgs = {
  objects: Array<Email_Message_Insert_Input>;
  on_conflict?: InputMaybe<Email_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Message_OneArgs = {
  object: Email_Message_Insert_Input;
  on_conflict?: InputMaybe<Email_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_PointerArgs = {
  objects: Array<Email_Pointer_Insert_Input>;
  on_conflict?: InputMaybe<Email_Pointer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Pointer_OneArgs = {
  object: Email_Pointer_Insert_Input;
  on_conflict?: InputMaybe<Email_Pointer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Job_PostingArgs = {
  objects: Array<Ext_Job_Posting_Insert_Input>;
  on_conflict?: InputMaybe<Ext_Job_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Job_Posting_OneArgs = {
  object: Ext_Job_Posting_Insert_Input;
  on_conflict?: InputMaybe<Ext_Job_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Job_ScrapeArgs = {
  objects: Array<Ext_Job_Scrape_Insert_Input>;
  on_conflict?: InputMaybe<Ext_Job_Scrape_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Job_Scrape_OneArgs = {
  object: Ext_Job_Scrape_Insert_Input;
  on_conflict?: InputMaybe<Ext_Job_Scrape_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Posting_ErrorArgs = {
  objects: Array<Ext_Posting_Error_Insert_Input>;
  on_conflict?: InputMaybe<Ext_Posting_Error_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Posting_Error_OneArgs = {
  object: Ext_Posting_Error_Insert_Input;
  on_conflict?: InputMaybe<Ext_Posting_Error_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Posting_ProfessionArgs = {
  objects: Array<Ext_Posting_Profession_Insert_Input>;
  on_conflict?: InputMaybe<Ext_Posting_Profession_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ext_Posting_Profession_OneArgs = {
  object: Ext_Posting_Profession_Insert_Input;
  on_conflict?: InputMaybe<Ext_Posting_Profession_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FacilityArgs = {
  objects: Array<Facility_Insert_Input>;
  on_conflict?: InputMaybe<Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_AccreditationArgs = {
  objects: Array<Facility_Accreditation_Insert_Input>;
  on_conflict?: InputMaybe<Facility_Accreditation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Accreditation_OneArgs = {
  object: Facility_Accreditation_Insert_Input;
  on_conflict?: InputMaybe<Facility_Accreditation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_ContractArgs = {
  objects: Array<Facility_Contract_Insert_Input>;
  on_conflict?: InputMaybe<Facility_Contract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Contract_FeaturedArgs = {
  objects: Array<Facility_Contract_Featured_Insert_Input>;
  on_conflict?: InputMaybe<Facility_Contract_Featured_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Contract_Featured_OneArgs = {
  object: Facility_Contract_Featured_Insert_Input;
  on_conflict?: InputMaybe<Facility_Contract_Featured_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Contract_OneArgs = {
  object: Facility_Contract_Insert_Input;
  on_conflict?: InputMaybe<Facility_Contract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_CorrectionArgs = {
  objects: Array<Facility_Correction_Insert_Input>;
  on_conflict?: InputMaybe<Facility_Correction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Correction_OneArgs = {
  object: Facility_Correction_Insert_Input;
  on_conflict?: InputMaybe<Facility_Correction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Dist_ResultArgs = {
  objects: Array<Facility_Dist_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Dist_Result_OneArgs = {
  object: Facility_Dist_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Facility_EhrArgs = {
  objects: Array<Facility_Ehr_Insert_Input>;
  on_conflict?: InputMaybe<Facility_Ehr_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_Ehr_OneArgs = {
  object: Facility_Ehr_Insert_Input;
  on_conflict?: InputMaybe<Facility_Ehr_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Facility_OneArgs = {
  object: Facility_Insert_Input;
  on_conflict?: InputMaybe<Facility_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FavoriteArgs = {
  objects: Array<Favorite_Insert_Input>;
  on_conflict?: InputMaybe<Favorite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Favorite_OneArgs = {
  object: Favorite_Insert_Input;
  on_conflict?: InputMaybe<Favorite_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Featured_Clerkship_Dist_ResultArgs = {
  objects: Array<Featured_Clerkship_Dist_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Featured_Clerkship_Dist_Result_OneArgs = {
  object: Featured_Clerkship_Dist_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Featured_Fellowship_Dist_ResultArgs = {
  objects: Array<Featured_Fellowship_Dist_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Featured_Fellowship_Dist_Result_OneArgs = {
  object: Featured_Fellowship_Dist_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Featured_Residency_Dist_ResultArgs = {
  objects: Array<Featured_Residency_Dist_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Featured_Residency_Dist_Result_OneArgs = {
  object: Featured_Residency_Dist_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_FellowshipArgs = {
  objects: Array<Fellowship_Insert_Input>;
  on_conflict?: InputMaybe<Fellowship_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fellowship_OneArgs = {
  object: Fellowship_Insert_Input;
  on_conflict?: InputMaybe<Fellowship_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fellowship_SurveyArgs = {
  objects: Array<Fellowship_Survey_Insert_Input>;
  on_conflict?: InputMaybe<Fellowship_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fellowship_Survey_OneArgs = {
  object: Fellowship_Survey_Insert_Input;
  on_conflict?: InputMaybe<Fellowship_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fsmb_BioArgs = {
  objects: Array<Fsmb_Bio_Insert_Input>;
  on_conflict?: InputMaybe<Fsmb_Bio_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fsmb_Bio_OneArgs = {
  object: Fsmb_Bio_Insert_Input;
  on_conflict?: InputMaybe<Fsmb_Bio_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fsmb_LicensureArgs = {
  objects: Array<Fsmb_Licensure_Insert_Input>;
  on_conflict?: InputMaybe<Fsmb_Licensure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Fsmb_Licensure_OneArgs = {
  object: Fsmb_Licensure_Insert_Input;
  on_conflict?: InputMaybe<Fsmb_Licensure_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gmaps_LinkArgs = {
  objects: Array<Gmaps_Link_Insert_Input>;
  on_conflict?: InputMaybe<Gmaps_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gmaps_Link_OneArgs = {
  object: Gmaps_Link_Insert_Input;
  on_conflict?: InputMaybe<Gmaps_Link_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gmaps_Link_TypeArgs = {
  objects: Array<Gmaps_Link_Type_Insert_Input>;
  on_conflict?: InputMaybe<Gmaps_Link_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gmaps_Link_Type_OneArgs = {
  object: Gmaps_Link_Type_Insert_Input;
  on_conflict?: InputMaybe<Gmaps_Link_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gmaps_PlaceArgs = {
  objects: Array<Gmaps_Place_Insert_Input>;
  on_conflict?: InputMaybe<Gmaps_Place_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Gmaps_Place_OneArgs = {
  object: Gmaps_Place_Insert_Input;
  on_conflict?: InputMaybe<Gmaps_Place_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identity_ProviderArgs = {
  objects: Array<Identity_Provider_Insert_Input>;
  on_conflict?: InputMaybe<Identity_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identity_Provider_OneArgs = {
  object: Identity_Provider_Insert_Input;
  on_conflict?: InputMaybe<Identity_Provider_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_ApplicationArgs = {
  objects: Array<Job_Application_Insert_Input>;
  on_conflict?: InputMaybe<Job_Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Application_BatchArgs = {
  objects: Array<Job_Application_Batch_Insert_Input>;
  on_conflict?: InputMaybe<Job_Application_Batch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Application_Batch_OneArgs = {
  object: Job_Application_Batch_Insert_Input;
  on_conflict?: InputMaybe<Job_Application_Batch_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Application_OneArgs = {
  object: Job_Application_Insert_Input;
  on_conflict?: InputMaybe<Job_Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Application_PostingArgs = {
  objects: Array<Job_Application_Posting_Insert_Input>;
  on_conflict?: InputMaybe<Job_Application_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Application_Posting_OneArgs = {
  object: Job_Application_Posting_Insert_Input;
  on_conflict?: InputMaybe<Job_Application_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_PostingArgs = {
  objects: Array<Job_Posting_Insert_Input>;
  on_conflict?: InputMaybe<Job_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Posting_OneArgs = {
  object: Job_Posting_Insert_Input;
  on_conflict?: InputMaybe<Job_Posting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nearby_Facilities_By_Geography_ResultArgs = {
  objects: Array<Nearby_Facilities_By_Geography_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Nearby_Facilities_By_Geography_Result_OneArgs = {
  object: Nearby_Facilities_By_Geography_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Org_Dist_ResultArgs = {
  objects: Array<Org_Dist_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Dist_Result_OneArgs = {
  object: Org_Dist_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Org_DomainArgs = {
  objects: Array<Org_Domain_Insert_Input>;
  on_conflict?: InputMaybe<Org_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Domain_OneArgs = {
  object: Org_Domain_Insert_Input;
  on_conflict?: InputMaybe<Org_Domain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_UserArgs = {
  objects: Array<Org_User_Insert_Input>;
  on_conflict?: InputMaybe<Org_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_User_OneArgs = {
  object: Org_User_Insert_Input;
  on_conflict?: InputMaybe<Org_User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_InfoArgs = {
  objects: Array<Personal_Info_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Personal_Info_OneArgs = {
  object: Personal_Info_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Place_BoundaryArgs = {
  objects: Array<Place_Boundary_Insert_Input>;
  on_conflict?: InputMaybe<Place_Boundary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Place_Boundary_OneArgs = {
  object: Place_Boundary_Insert_Input;
  on_conflict?: InputMaybe<Place_Boundary_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_App_CertArgs = {
  objects: Array<Posting_App_Cert_Insert_Input>;
  on_conflict?: InputMaybe<Posting_App_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_App_Cert_OneArgs = {
  object: Posting_App_Cert_Insert_Input;
  on_conflict?: InputMaybe<Posting_App_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Board_CertArgs = {
  objects: Array<Posting_Board_Cert_Insert_Input>;
  on_conflict?: InputMaybe<Posting_Board_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Board_Cert_OneArgs = {
  object: Posting_Board_Cert_Insert_Input;
  on_conflict?: InputMaybe<Posting_Board_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_ProfessionArgs = {
  objects: Array<Posting_Profession_Insert_Input>;
  on_conflict?: InputMaybe<Posting_Profession_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Profession_OneArgs = {
  object: Posting_Profession_Insert_Input;
  on_conflict?: InputMaybe<Posting_Profession_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Worker_ClassificationArgs = {
  objects: Array<Posting_Worker_Classification_Insert_Input>;
  on_conflict?: InputMaybe<Posting_Worker_Classification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Posting_Worker_Classification_OneArgs = {
  object: Posting_Worker_Classification_Insert_Input;
  on_conflict?: InputMaybe<Posting_Worker_Classification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Job_PostingArgs = {
  objects: Array<Relevant_Job_Posting_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Job_Posting_OneArgs = {
  object: Relevant_Job_Posting_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Salary_ReportArgs = {
  objects: Array<Relevant_Salary_Report_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Relevant_Salary_Report_OneArgs = {
  object: Relevant_Salary_Report_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_ResidencyArgs = {
  objects: Array<Residency_Insert_Input>;
  on_conflict?: InputMaybe<Residency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Residency_OneArgs = {
  object: Residency_Insert_Input;
  on_conflict?: InputMaybe<Residency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Residency_SurveyArgs = {
  objects: Array<Residency_Survey_Insert_Input>;
  on_conflict?: InputMaybe<Residency_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Residency_Survey_OneArgs = {
  object: Residency_Survey_Insert_Input;
  on_conflict?: InputMaybe<Residency_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReviewArgs = {
  objects: Array<Review_Insert_Input>;
  on_conflict?: InputMaybe<Review_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_OneArgs = {
  object: Review_Insert_Input;
  on_conflict?: InputMaybe<Review_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_ReplyArgs = {
  objects: Array<Review_Reply_Insert_Input>;
  on_conflict?: InputMaybe<Review_Reply_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Reply_OneArgs = {
  object: Review_Reply_Insert_Input;
  on_conflict?: InputMaybe<Review_Reply_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_ReportArgs = {
  objects: Array<Review_Report_Insert_Input>;
  on_conflict?: InputMaybe<Review_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Report_OneArgs = {
  object: Review_Report_Insert_Input;
  on_conflict?: InputMaybe<Review_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_VoteArgs = {
  objects: Array<Review_Vote_Insert_Input>;
  on_conflict?: InputMaybe<Review_Vote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Vote_OneArgs = {
  object: Review_Vote_Insert_Input;
  on_conflict?: InputMaybe<Review_Vote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_ReportArgs = {
  objects: Array<Salary_Report_Insert_Input>;
  on_conflict?: InputMaybe<Salary_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_Report_FmtArgs = {
  objects: Array<Salary_Report_Fmt_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Salary_Report_Fmt_OneArgs = {
  object: Salary_Report_Fmt_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Salary_Report_OneArgs = {
  object: Salary_Report_Insert_Input;
  on_conflict?: InputMaybe<Salary_Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SchoolArgs = {
  objects: Array<School_Insert_Input>;
  on_conflict?: InputMaybe<School_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_School_OneArgs = {
  object: School_Insert_Input;
  on_conflict?: InputMaybe<School_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Candidate_ResultArgs = {
  objects: Array<Search_Candidate_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Candidate_Result_OneArgs = {
  object: Search_Candidate_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Clerkship_By_Geography_ResultArgs = {
  objects: Array<Search_Clerkship_By_Geography_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Clerkship_By_Geography_Result_OneArgs = {
  object: Search_Clerkship_By_Geography_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Facility_By_Prefix_ResultArgs = {
  objects: Array<Search_Facility_By_Prefix_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Facility_By_Prefix_Result_OneArgs = {
  object: Search_Facility_By_Prefix_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Fellowship_By_Geography_ResultArgs = {
  objects: Array<Search_Fellowship_By_Geography_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Fellowship_By_Geography_Result_OneArgs = {
  object: Search_Fellowship_By_Geography_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Fsmb_Bio_ResultArgs = {
  objects: Array<Search_Fsmb_Bio_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Fsmb_Bio_Result_OneArgs = {
  object: Search_Fsmb_Bio_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Job_Postings_By_Geography_ResultArgs = {
  objects: Array<Search_Job_Postings_By_Geography_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Job_Postings_By_Geography_Result_OneArgs = {
  object: Search_Job_Postings_By_Geography_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Org_Market_ResultArgs = {
  objects: Array<Search_Org_Market_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Org_Market_Result_OneArgs = {
  object: Search_Org_Market_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Organization_By_Prefix_ResultArgs = {
  objects: Array<Search_Organization_By_Prefix_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Organization_By_Prefix_Result_OneArgs = {
  object: Search_Organization_By_Prefix_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Residency_By_Geography_ResultArgs = {
  objects: Array<Search_Residency_By_Geography_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Residency_By_Geography_Result_OneArgs = {
  object: Search_Residency_By_Geography_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Search_Training_By_Prefix_ResultArgs = {
  objects: Array<Search_Training_By_Prefix_Result_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Training_By_Prefix_Result_OneArgs = {
  object: Search_Training_By_Prefix_Result_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_SiteArgs = {
  objects: Array<Site_Insert_Input>;
  on_conflict?: InputMaybe<Site_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Site_OneArgs = {
  object: Site_Insert_Input;
  on_conflict?: InputMaybe<Site_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stroke_CertArgs = {
  objects: Array<Stroke_Cert_Insert_Input>;
  on_conflict?: InputMaybe<Stroke_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Stroke_Cert_OneArgs = {
  object: Stroke_Cert_Insert_Input;
  on_conflict?: InputMaybe<Stroke_Cert_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrainingArgs = {
  objects: Array<Training_Insert_Input>;
  on_conflict?: InputMaybe<Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_EventArgs = {
  objects: Array<Training_Event_Insert_Input>;
  on_conflict?: InputMaybe<Training_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Event_OneArgs = {
  object: Training_Event_Insert_Input;
  on_conflict?: InputMaybe<Training_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_FieldArgs = {
  objects: Array<Training_Field_Insert_Input>;
  on_conflict?: InputMaybe<Training_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Field_OneArgs = {
  object: Training_Field_Insert_Input;
  on_conflict?: InputMaybe<Training_Field_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_OneArgs = {
  object: Training_Insert_Input;
  on_conflict?: InputMaybe<Training_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_ProgramArgs = {
  objects: Array<Training_Program_Insert_Input>;
  on_conflict?: InputMaybe<Training_Program_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Program_OneArgs = {
  object: Training_Program_Insert_Input;
  on_conflict?: InputMaybe<Training_Program_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_SurveyArgs = {
  objects: Array<Training_Survey_Insert_Input>;
  on_conflict?: InputMaybe<Training_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Survey_OneArgs = {
  object: Training_Survey_Insert_Input;
  on_conflict?: InputMaybe<Training_Survey_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Survey_PictureArgs = {
  objects: Array<Training_Survey_Picture_Insert_Input>;
  on_conflict?: InputMaybe<Training_Survey_Picture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Survey_Picture_OneArgs = {
  object: Training_Survey_Picture_Insert_Input;
  on_conflict?: InputMaybe<Training_Survey_Picture_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Survey_SiteArgs = {
  objects: Array<Training_Survey_Site_Insert_Input>;
  on_conflict?: InputMaybe<Training_Survey_Site_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Training_Survey_Site_OneArgs = {
  object: Training_Survey_Site_Insert_Input;
  on_conflict?: InputMaybe<Training_Survey_Site_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInvite_Org_UserArgs = {
  input: InviteOrgUserInput;
};


/** mutation root */
export type Mutation_RootLog_InArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  platform?: Platform;
};


/** mutation root */
export type Mutation_RootPay_Outstanding_BalanceArgs = {
  payment_id?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootPublishFaqArgs = {
  to?: Array<Stage>;
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootPublishLegalArgs = {
  to?: Array<Stage>;
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootPublishManyFaqsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyLegalsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyLegalsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyPostsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyTeammatesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishManyTeammatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  to?: Array<Stage>;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootPublishPostArgs = {
  to?: Array<Stage>;
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootPublishTeammateArgs = {
  to?: Array<Stage>;
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootRecreate_Job_Application_BatchArgs = {
  batch_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRefresh_AuthArgs = {
  refresh_token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootRegister_ClinicianArgs = {
  input: RegisterClinicianInput;
};


/** mutation root */
export type Mutation_RootRegister_Org_UserArgs = {
  input: RegisterOrgUserInput;
};


/** mutation root */
export type Mutation_RootRequest_Email_ChangeArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootResend_VerificationArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootReset_PasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootSchedulePublishFaqArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootSchedulePublishLegalArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootSchedulePublishPostArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootSchedulePublishTeammateArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  to?: Array<Stage>;
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootScheduleUnpublishFaqArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootScheduleUnpublishLegalArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootScheduleUnpublishPostArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootScheduleUnpublishTeammateArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']>;
  releaseId?: InputMaybe<Scalars['String']>;
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootSend_Job_Application_Batch_Admin_FollowupArgs = {
  batch_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSend_Password_ResetArgs = {
  email: Scalars['String'];
  platform?: Platform;
};


/** mutation root */
export type Mutation_RootSet_Email_SuppressionsArgs = {
  categories: Array<Scalars['String']>;
  token: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSign_Up_Org_UserArgs = {
  input: SignUpOrgUserInput;
};


/** mutation root */
export type Mutation_RootUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where: AssetWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUnpublishFaqArgs = {
  from?: Array<Stage>;
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUnpublishLegalArgs = {
  from?: Array<Stage>;
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyFaqsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyLegalsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyLegalsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyPostsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyTeammatesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishManyTeammatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUnpublishPostArgs = {
  from?: Array<Stage>;
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUnpublishTeammateArgs = {
  from?: Array<Stage>;
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdateFaqArgs = {
  data: FaqUpdateInput;
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdateLegalArgs = {
  data: LegalUpdateInput;
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyFaqsArgs = {
  data: FaqUpdateManyInput;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: FaqUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FaqManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyLegalsArgs = {
  data: LegalUpdateManyInput;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyLegalsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: LegalUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LegalManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyPostsArgs = {
  data: PostUpdateManyInput;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyPostsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: PostUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyTeammatesArgs = {
  data: TeammateUpdateManyInput;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateManyTeammatesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  data: TeammateUpdateManyInput;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeammateManyWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdatePostArgs = {
  data: PostUpdateInput;
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdateTeammateArgs = {
  data: TeammateUpdateInput;
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpdate_As20DemArgs = {
  _inc?: InputMaybe<As20Dem_Inc_Input>;
  _set?: InputMaybe<As20Dem_Set_Input>;
  where: As20Dem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As20Dem_By_PkArgs = {
  _inc?: InputMaybe<As20Dem_Inc_Input>;
  _set?: InputMaybe<As20Dem_Set_Input>;
  pk_columns: As20Dem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As20Dem_ManyArgs = {
  updates: Array<As20Dem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc1Args = {
  _inc?: InputMaybe<As20Svc1_Inc_Input>;
  _set?: InputMaybe<As20Svc1_Set_Input>;
  where: As20Svc1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc1_By_PkArgs = {
  _inc?: InputMaybe<As20Svc1_Inc_Input>;
  _set?: InputMaybe<As20Svc1_Set_Input>;
  pk_columns: As20Svc1_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc1_ManyArgs = {
  updates: Array<As20Svc1_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc2Args = {
  _inc?: InputMaybe<As20Svc2_Inc_Input>;
  _set?: InputMaybe<As20Svc2_Set_Input>;
  where: As20Svc2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc2_By_PkArgs = {
  _inc?: InputMaybe<As20Svc2_Inc_Input>;
  _set?: InputMaybe<As20Svc2_Set_Input>;
  pk_columns: As20Svc2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc2_ManyArgs = {
  updates: Array<As20Svc2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc3Args = {
  _inc?: InputMaybe<As20Svc3_Inc_Input>;
  _set?: InputMaybe<As20Svc3_Set_Input>;
  where: As20Svc3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc3_By_PkArgs = {
  _inc?: InputMaybe<As20Svc3_Inc_Input>;
  _set?: InputMaybe<As20Svc3_Set_Input>;
  pk_columns: As20Svc3_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As20Svc3_ManyArgs = {
  updates: Array<As20Svc3_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As20Util1Args = {
  _inc?: InputMaybe<As20Util1_Inc_Input>;
  _set?: InputMaybe<As20Util1_Set_Input>;
  where: As20Util1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As20Util1_By_PkArgs = {
  _inc?: InputMaybe<As20Util1_Inc_Input>;
  _set?: InputMaybe<As20Util1_Set_Input>;
  pk_columns: As20Util1_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As20Util1_ManyArgs = {
  updates: Array<As20Util1_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As20Util2Args = {
  _inc?: InputMaybe<As20Util2_Inc_Input>;
  _set?: InputMaybe<As20Util2_Set_Input>;
  where: As20Util2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As20Util2_By_PkArgs = {
  _inc?: InputMaybe<As20Util2_Inc_Input>;
  _set?: InputMaybe<As20Util2_Set_Input>;
  pk_columns: As20Util2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As20Util2_ManyArgs = {
  updates: Array<As20Util2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21DemArgs = {
  _inc?: InputMaybe<As21Dem_Inc_Input>;
  _set?: InputMaybe<As21Dem_Set_Input>;
  where: As21Dem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Dem_By_PkArgs = {
  _inc?: InputMaybe<As21Dem_Inc_Input>;
  _set?: InputMaybe<As21Dem_Set_Input>;
  pk_columns: As21Dem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Dem_ManyArgs = {
  updates: Array<As21Dem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc1Args = {
  _inc?: InputMaybe<As21Svc1_Inc_Input>;
  _set?: InputMaybe<As21Svc1_Set_Input>;
  where: As21Svc1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc1_By_PkArgs = {
  _inc?: InputMaybe<As21Svc1_Inc_Input>;
  _set?: InputMaybe<As21Svc1_Set_Input>;
  pk_columns: As21Svc1_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc1_ManyArgs = {
  updates: Array<As21Svc1_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc2Args = {
  _inc?: InputMaybe<As21Svc2_Inc_Input>;
  _set?: InputMaybe<As21Svc2_Set_Input>;
  where: As21Svc2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc2_By_PkArgs = {
  _inc?: InputMaybe<As21Svc2_Inc_Input>;
  _set?: InputMaybe<As21Svc2_Set_Input>;
  pk_columns: As21Svc2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc2_ManyArgs = {
  updates: Array<As21Svc2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc3Args = {
  _inc?: InputMaybe<As21Svc3_Inc_Input>;
  _set?: InputMaybe<As21Svc3_Set_Input>;
  where: As21Svc3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc3_By_PkArgs = {
  _inc?: InputMaybe<As21Svc3_Inc_Input>;
  _set?: InputMaybe<As21Svc3_Set_Input>;
  pk_columns: As21Svc3_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Svc3_ManyArgs = {
  updates: Array<As21Svc3_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21UnitArgs = {
  _set?: InputMaybe<As21Unit_Set_Input>;
  where: As21Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Unit_By_PkArgs = {
  _set?: InputMaybe<As21Unit_Set_Input>;
  pk_columns: As21Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Unit_ManyArgs = {
  updates: Array<As21Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21UtilArgs = {
  _inc?: InputMaybe<As21Util_Inc_Input>;
  _set?: InputMaybe<As21Util_Set_Input>;
  where: As21Util_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Util2Args = {
  _inc?: InputMaybe<As21Util2_Inc_Input>;
  _set?: InputMaybe<As21Util2_Set_Input>;
  where: As21Util2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As21Util2_By_PkArgs = {
  _inc?: InputMaybe<As21Util2_Inc_Input>;
  _set?: InputMaybe<As21Util2_Set_Input>;
  pk_columns: As21Util2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Util2_ManyArgs = {
  updates: Array<As21Util2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As21Util_By_PkArgs = {
  _inc?: InputMaybe<As21Util_Inc_Input>;
  _set?: InputMaybe<As21Util_Set_Input>;
  pk_columns: As21Util_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As21Util_ManyArgs = {
  updates: Array<As21Util_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22DemArgs = {
  _inc?: InputMaybe<As22Dem_Inc_Input>;
  _set?: InputMaybe<As22Dem_Set_Input>;
  where: As22Dem_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Dem_By_PkArgs = {
  _inc?: InputMaybe<As22Dem_Inc_Input>;
  _set?: InputMaybe<As22Dem_Set_Input>;
  pk_columns: As22Dem_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Dem_ManyArgs = {
  updates: Array<As22Dem_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc1Args = {
  _inc?: InputMaybe<As22Svc1_Inc_Input>;
  _set?: InputMaybe<As22Svc1_Set_Input>;
  where: As22Svc1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc1_By_PkArgs = {
  _inc?: InputMaybe<As22Svc1_Inc_Input>;
  _set?: InputMaybe<As22Svc1_Set_Input>;
  pk_columns: As22Svc1_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc1_ManyArgs = {
  updates: Array<As22Svc1_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc2Args = {
  _inc?: InputMaybe<As22Svc2_Inc_Input>;
  _set?: InputMaybe<As22Svc2_Set_Input>;
  where: As22Svc2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc2_By_PkArgs = {
  _inc?: InputMaybe<As22Svc2_Inc_Input>;
  _set?: InputMaybe<As22Svc2_Set_Input>;
  pk_columns: As22Svc2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc2_ManyArgs = {
  updates: Array<As22Svc2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc3Args = {
  _inc?: InputMaybe<As22Svc3_Inc_Input>;
  _set?: InputMaybe<As22Svc3_Set_Input>;
  where: As22Svc3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc3_By_PkArgs = {
  _inc?: InputMaybe<As22Svc3_Inc_Input>;
  _set?: InputMaybe<As22Svc3_Set_Input>;
  pk_columns: As22Svc3_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Svc3_ManyArgs = {
  updates: Array<As22Svc3_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22UnitArgs = {
  _set?: InputMaybe<As22Unit_Set_Input>;
  where: As22Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Unit_By_PkArgs = {
  _set?: InputMaybe<As22Unit_Set_Input>;
  pk_columns: As22Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Unit_ManyArgs = {
  updates: Array<As22Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22UtilArgs = {
  _inc?: InputMaybe<As22Util_Inc_Input>;
  _set?: InputMaybe<As22Util_Set_Input>;
  where: As22Util_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Util2Args = {
  _inc?: InputMaybe<As22Util2_Inc_Input>;
  _set?: InputMaybe<As22Util2_Set_Input>;
  where: As22Util2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_As22Util2_By_PkArgs = {
  _inc?: InputMaybe<As22Util2_Inc_Input>;
  _set?: InputMaybe<As22Util2_Set_Input>;
  pk_columns: As22Util2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Util2_ManyArgs = {
  updates: Array<As22Util2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_As22Util_By_PkArgs = {
  _inc?: InputMaybe<As22Util_Inc_Input>;
  _set?: InputMaybe<As22Util_Set_Input>;
  pk_columns: As22Util_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_As22Util_ManyArgs = {
  updates: Array<As22Util_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ab_TestArgs = {
  _set?: InputMaybe<Ab_Test_Set_Input>;
  where: Ab_Test_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ab_Test_By_PkArgs = {
  _set?: InputMaybe<Ab_Test_Set_Input>;
  pk_columns: Ab_Test_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ab_Test_ManyArgs = {
  updates: Array<Ab_Test_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Access_InfoArgs = {
  _set?: InputMaybe<Access_Info_Set_Input>;
  where: Access_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Access_Info_ManyArgs = {
  updates: Array<Access_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountArgs = {
  _inc?: InputMaybe<Account_Inc_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_By_PkArgs = {
  _inc?: InputMaybe<Account_Inc_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  pk_columns: Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_ManyArgs = {
  updates: Array<Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Account_RoleArgs = {
  _set?: InputMaybe<Account_Role_Set_Input>;
  where: Account_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Role_By_PkArgs = {
  _set?: InputMaybe<Account_Role_Set_Input>;
  pk_columns: Account_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_Role_ManyArgs = {
  updates: Array<Account_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Acep_Org_SurveyArgs = {
  _set?: InputMaybe<Acep_Org_Survey_Set_Input>;
  where: Acep_Org_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Acep_Org_Survey_By_PkArgs = {
  _set?: InputMaybe<Acep_Org_Survey_Set_Input>;
  pk_columns: Acep_Org_Survey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Acep_Org_Survey_ManyArgs = {
  updates: Array<Acep_Org_Survey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BoardArgs = {
  _set?: InputMaybe<Board_Set_Input>;
  where: Board_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_By_PkArgs = {
  _set?: InputMaybe<Board_Set_Input>;
  pk_columns: Board_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_CertArgs = {
  _set?: InputMaybe<Board_Cert_Set_Input>;
  where: Board_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Cert_By_PkArgs = {
  _set?: InputMaybe<Board_Cert_Set_Input>;
  pk_columns: Board_Cert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Board_Cert_ManyArgs = {
  updates: Array<Board_Cert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Board_ManyArgs = {
  updates: Array<Board_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CandidateArgs = {
  _set?: InputMaybe<Candidate_Set_Input>;
  where: Candidate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Candidate_By_PkArgs = {
  _set?: InputMaybe<Candidate_Set_Input>;
  pk_columns: Candidate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Candidate_ManyArgs = {
  updates: Array<Candidate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cert_OrgArgs = {
  _set?: InputMaybe<Cert_Org_Set_Input>;
  where: Cert_Org_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cert_Org_By_PkArgs = {
  _set?: InputMaybe<Cert_Org_Set_Input>;
  pk_columns: Cert_Org_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cert_Org_ManyArgs = {
  updates: Array<Cert_Org_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClerkshipArgs = {
  _set?: InputMaybe<Clerkship_Set_Input>;
  where: Clerkship_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clerkship_By_PkArgs = {
  _set?: InputMaybe<Clerkship_Set_Input>;
  pk_columns: Clerkship_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clerkship_ManyArgs = {
  updates: Array<Clerkship_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clerkship_SurveyArgs = {
  _set?: InputMaybe<Clerkship_Survey_Set_Input>;
  where: Clerkship_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clerkship_Survey_By_PkArgs = {
  _set?: InputMaybe<Clerkship_Survey_Set_Input>;
  pk_columns: Clerkship_Survey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clerkship_Survey_ManyArgs = {
  updates: Array<Clerkship_Survey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClinicianArgs = {
  _inc?: InputMaybe<Clinician_Inc_Input>;
  _set?: InputMaybe<Clinician_Set_Input>;
  where: Clinician_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_App_CertArgs = {
  _set?: InputMaybe<Clinician_App_Cert_Set_Input>;
  where: Clinician_App_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_App_Cert_By_PkArgs = {
  _set?: InputMaybe<Clinician_App_Cert_Set_Input>;
  pk_columns: Clinician_App_Cert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_App_Cert_ManyArgs = {
  updates: Array<Clinician_App_Cert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Board_CertArgs = {
  _set?: InputMaybe<Clinician_Board_Cert_Set_Input>;
  where: Clinician_Board_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Board_Cert_By_PkArgs = {
  _set?: InputMaybe<Clinician_Board_Cert_Set_Input>;
  pk_columns: Clinician_Board_Cert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Board_Cert_ManyArgs = {
  updates: Array<Clinician_Board_Cert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_By_PkArgs = {
  _inc?: InputMaybe<Clinician_Inc_Input>;
  _set?: InputMaybe<Clinician_Set_Input>;
  pk_columns: Clinician_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_LicenseArgs = {
  _set?: InputMaybe<Clinician_License_Set_Input>;
  where: Clinician_License_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_License_By_PkArgs = {
  _set?: InputMaybe<Clinician_License_Set_Input>;
  pk_columns: Clinician_License_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_License_ManyArgs = {
  updates: Array<Clinician_License_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_ManyArgs = {
  updates: Array<Clinician_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Sp_ExpArgs = {
  _set?: InputMaybe<Clinician_Sp_Exp_Set_Input>;
  where: Clinician_Sp_Exp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Sp_Exp_By_PkArgs = {
  _set?: InputMaybe<Clinician_Sp_Exp_Set_Input>;
  pk_columns: Clinician_Sp_Exp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Sp_Exp_ManyArgs = {
  updates: Array<Clinician_Sp_Exp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_SpecialtyArgs = {
  _set?: InputMaybe<Clinician_Specialty_Set_Input>;
  where: Clinician_Specialty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Specialty_By_PkArgs = {
  _set?: InputMaybe<Clinician_Specialty_Set_Input>;
  pk_columns: Clinician_Specialty_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Specialty_ManyArgs = {
  updates: Array<Clinician_Specialty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_TrainingArgs = {
  _inc?: InputMaybe<Clinician_Training_Inc_Input>;
  _set?: InputMaybe<Clinician_Training_Set_Input>;
  where: Clinician_Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Training_By_PkArgs = {
  _inc?: InputMaybe<Clinician_Training_Inc_Input>;
  _set?: InputMaybe<Clinician_Training_Set_Input>;
  pk_columns: Clinician_Training_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Clinician_Training_ManyArgs = {
  updates: Array<Clinician_Training_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_FacilityArgs = {
  _inc?: InputMaybe<Cms_Facility_Inc_Input>;
  _set?: InputMaybe<Cms_Facility_Set_Input>;
  where: Cms_Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_By_PkArgs = {
  _inc?: InputMaybe<Cms_Facility_Inc_Input>;
  _set?: InputMaybe<Cms_Facility_Set_Input>;
  pk_columns: Cms_Facility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_EnrollmentArgs = {
  _set?: InputMaybe<Cms_Facility_Enrollment_Set_Input>;
  where: Cms_Facility_Enrollment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_Enrollment_By_PkArgs = {
  _set?: InputMaybe<Cms_Facility_Enrollment_Set_Input>;
  pk_columns: Cms_Facility_Enrollment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_Enrollment_ManyArgs = {
  updates: Array<Cms_Facility_Enrollment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_ManyArgs = {
  updates: Array<Cms_Facility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_MetricArgs = {
  _set?: InputMaybe<Cms_Facility_Metric_Set_Input>;
  where: Cms_Facility_Metric_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_Metric_By_PkArgs = {
  _set?: InputMaybe<Cms_Facility_Metric_Set_Input>;
  pk_columns: Cms_Facility_Metric_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_Metric_ManyArgs = {
  updates: Array<Cms_Facility_Metric_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_PosArgs = {
  _set?: InputMaybe<Cms_Facility_Pos_Set_Input>;
  where: Cms_Facility_Pos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_Pos_By_PkArgs = {
  _set?: InputMaybe<Cms_Facility_Pos_Set_Input>;
  pk_columns: Cms_Facility_Pos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Facility_Pos_ManyArgs = {
  updates: Array<Cms_Facility_Pos_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_SpecialtyArgs = {
  _set?: InputMaybe<Cms_Specialty_Set_Input>;
  where: Cms_Specialty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Specialty_By_PkArgs = {
  _set?: InputMaybe<Cms_Specialty_Set_Input>;
  pk_columns: Cms_Specialty_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cms_Specialty_ManyArgs = {
  updates: Array<Cms_Specialty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_InfoArgs = {
  _set?: InputMaybe<Contact_Info_Set_Input>;
  where: Contact_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contact_Info_ManyArgs = {
  updates: Array<Contact_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Current_AccountArgs = {
  _inc?: InputMaybe<Current_Account_Inc_Input>;
  _set?: InputMaybe<Current_Account_Set_Input>;
  where: Current_Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Current_Account_ManyArgs = {
  updates: Array<Current_Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Default_Payment_MethodArgs = {
  payment_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdate_Customer_SubscriptionArgs = {
  customer_details: CustomerDetailsInput;
  interval: Scalars['String'];
  payment_id?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootUpdate_Email_ContactArgs = {
  _inc?: InputMaybe<Email_Contact_Inc_Input>;
  _set?: InputMaybe<Email_Contact_Set_Input>;
  where: Email_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Contact_By_PkArgs = {
  _inc?: InputMaybe<Email_Contact_Inc_Input>;
  _set?: InputMaybe<Email_Contact_Set_Input>;
  pk_columns: Email_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Contact_ManyArgs = {
  updates: Array<Email_Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_EnvelopeArgs = {
  _set?: InputMaybe<Email_Envelope_Set_Input>;
  where: Email_Envelope_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Envelope_By_PkArgs = {
  _set?: InputMaybe<Email_Envelope_Set_Input>;
  pk_columns: Email_Envelope_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Envelope_ManyArgs = {
  updates: Array<Email_Envelope_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_EventArgs = {
  _set?: InputMaybe<Email_Event_Set_Input>;
  where: Email_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Event_By_PkArgs = {
  _set?: InputMaybe<Email_Event_Set_Input>;
  pk_columns: Email_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Event_ManyArgs = {
  updates: Array<Email_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_MessageArgs = {
  _append?: InputMaybe<Email_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Message_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Message_Prepend_Input>;
  _set?: InputMaybe<Email_Message_Set_Input>;
  where: Email_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Message_By_PkArgs = {
  _append?: InputMaybe<Email_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Message_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Message_Prepend_Input>;
  _set?: InputMaybe<Email_Message_Set_Input>;
  pk_columns: Email_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Message_ManyArgs = {
  updates: Array<Email_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_PointerArgs = {
  _inc?: InputMaybe<Email_Pointer_Inc_Input>;
  _set?: InputMaybe<Email_Pointer_Set_Input>;
  where: Email_Pointer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Pointer_By_PkArgs = {
  _inc?: InputMaybe<Email_Pointer_Inc_Input>;
  _set?: InputMaybe<Email_Pointer_Set_Input>;
  pk_columns: Email_Pointer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Pointer_ManyArgs = {
  updates: Array<Email_Pointer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Job_PostingArgs = {
  _set?: InputMaybe<Ext_Job_Posting_Set_Input>;
  where: Ext_Job_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Job_Posting_By_PkArgs = {
  _set?: InputMaybe<Ext_Job_Posting_Set_Input>;
  pk_columns: Ext_Job_Posting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Job_Posting_ManyArgs = {
  updates: Array<Ext_Job_Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Job_ScrapeArgs = {
  _set?: InputMaybe<Ext_Job_Scrape_Set_Input>;
  where: Ext_Job_Scrape_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Job_Scrape_By_PkArgs = {
  _set?: InputMaybe<Ext_Job_Scrape_Set_Input>;
  pk_columns: Ext_Job_Scrape_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Job_Scrape_ManyArgs = {
  updates: Array<Ext_Job_Scrape_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Posting_ErrorArgs = {
  _set?: InputMaybe<Ext_Posting_Error_Set_Input>;
  where: Ext_Posting_Error_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Posting_Error_By_PkArgs = {
  _set?: InputMaybe<Ext_Posting_Error_Set_Input>;
  pk_columns: Ext_Posting_Error_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Posting_Error_ManyArgs = {
  updates: Array<Ext_Posting_Error_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Posting_ProfessionArgs = {
  _set?: InputMaybe<Ext_Posting_Profession_Set_Input>;
  where: Ext_Posting_Profession_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Posting_Profession_By_PkArgs = {
  _set?: InputMaybe<Ext_Posting_Profession_Set_Input>;
  pk_columns: Ext_Posting_Profession_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ext_Posting_Profession_ManyArgs = {
  updates: Array<Ext_Posting_Profession_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FacilityArgs = {
  _inc?: InputMaybe<Facility_Inc_Input>;
  _set?: InputMaybe<Facility_Set_Input>;
  where: Facility_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_AccreditationArgs = {
  _set?: InputMaybe<Facility_Accreditation_Set_Input>;
  where: Facility_Accreditation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Accreditation_By_PkArgs = {
  _set?: InputMaybe<Facility_Accreditation_Set_Input>;
  pk_columns: Facility_Accreditation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Accreditation_ManyArgs = {
  updates: Array<Facility_Accreditation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_By_PkArgs = {
  _inc?: InputMaybe<Facility_Inc_Input>;
  _set?: InputMaybe<Facility_Set_Input>;
  pk_columns: Facility_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_ContractArgs = {
  _set?: InputMaybe<Facility_Contract_Set_Input>;
  where: Facility_Contract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Contract_By_PkArgs = {
  _set?: InputMaybe<Facility_Contract_Set_Input>;
  pk_columns: Facility_Contract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Contract_FeaturedArgs = {
  _set?: InputMaybe<Facility_Contract_Featured_Set_Input>;
  where: Facility_Contract_Featured_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Contract_Featured_By_PkArgs = {
  _set?: InputMaybe<Facility_Contract_Featured_Set_Input>;
  pk_columns: Facility_Contract_Featured_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Contract_Featured_ManyArgs = {
  updates: Array<Facility_Contract_Featured_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Contract_ManyArgs = {
  updates: Array<Facility_Contract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_CorrectionArgs = {
  _set?: InputMaybe<Facility_Correction_Set_Input>;
  where: Facility_Correction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Correction_By_PkArgs = {
  _set?: InputMaybe<Facility_Correction_Set_Input>;
  pk_columns: Facility_Correction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Correction_ManyArgs = {
  updates: Array<Facility_Correction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Dist_ResultArgs = {
  _inc?: InputMaybe<Facility_Dist_Result_Inc_Input>;
  _set?: InputMaybe<Facility_Dist_Result_Set_Input>;
  where: Facility_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Dist_Result_ManyArgs = {
  updates: Array<Facility_Dist_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_EhrArgs = {
  _set?: InputMaybe<Facility_Ehr_Set_Input>;
  where: Facility_Ehr_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Ehr_By_PkArgs = {
  _set?: InputMaybe<Facility_Ehr_Set_Input>;
  pk_columns: Facility_Ehr_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_Ehr_ManyArgs = {
  updates: Array<Facility_Ehr_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Facility_ManyArgs = {
  updates: Array<Facility_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FavoriteArgs = {
  _set?: InputMaybe<Favorite_Set_Input>;
  where: Favorite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Favorite_By_PkArgs = {
  _set?: InputMaybe<Favorite_Set_Input>;
  pk_columns: Favorite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Favorite_ManyArgs = {
  updates: Array<Favorite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Featured_Clerkship_Dist_ResultArgs = {
  _inc?: InputMaybe<Featured_Clerkship_Dist_Result_Inc_Input>;
  _set?: InputMaybe<Featured_Clerkship_Dist_Result_Set_Input>;
  where: Featured_Clerkship_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Featured_Clerkship_Dist_Result_ManyArgs = {
  updates: Array<Featured_Clerkship_Dist_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Featured_Fellowship_Dist_ResultArgs = {
  _inc?: InputMaybe<Featured_Fellowship_Dist_Result_Inc_Input>;
  _set?: InputMaybe<Featured_Fellowship_Dist_Result_Set_Input>;
  where: Featured_Fellowship_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Featured_Fellowship_Dist_Result_ManyArgs = {
  updates: Array<Featured_Fellowship_Dist_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Featured_Residency_Dist_ResultArgs = {
  _inc?: InputMaybe<Featured_Residency_Dist_Result_Inc_Input>;
  _set?: InputMaybe<Featured_Residency_Dist_Result_Set_Input>;
  where: Featured_Residency_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Featured_Residency_Dist_Result_ManyArgs = {
  updates: Array<Featured_Residency_Dist_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FellowshipArgs = {
  _set?: InputMaybe<Fellowship_Set_Input>;
  where: Fellowship_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fellowship_By_PkArgs = {
  _set?: InputMaybe<Fellowship_Set_Input>;
  pk_columns: Fellowship_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fellowship_ManyArgs = {
  updates: Array<Fellowship_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fellowship_SurveyArgs = {
  _inc?: InputMaybe<Fellowship_Survey_Inc_Input>;
  _set?: InputMaybe<Fellowship_Survey_Set_Input>;
  where: Fellowship_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fellowship_Survey_By_PkArgs = {
  _inc?: InputMaybe<Fellowship_Survey_Inc_Input>;
  _set?: InputMaybe<Fellowship_Survey_Set_Input>;
  pk_columns: Fellowship_Survey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fellowship_Survey_ManyArgs = {
  updates: Array<Fellowship_Survey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _set?: InputMaybe<File_Set_Input>;
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_By_PkArgs = {
  _set?: InputMaybe<File_Set_Input>;
  pk_columns: File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_ManyArgs = {
  updates: Array<File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fsmb_BioArgs = {
  _inc?: InputMaybe<Fsmb_Bio_Inc_Input>;
  _set?: InputMaybe<Fsmb_Bio_Set_Input>;
  where: Fsmb_Bio_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fsmb_Bio_By_PkArgs = {
  _inc?: InputMaybe<Fsmb_Bio_Inc_Input>;
  _set?: InputMaybe<Fsmb_Bio_Set_Input>;
  pk_columns: Fsmb_Bio_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fsmb_Bio_ManyArgs = {
  updates: Array<Fsmb_Bio_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Fsmb_LicensureArgs = {
  _set?: InputMaybe<Fsmb_Licensure_Set_Input>;
  where: Fsmb_Licensure_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Fsmb_Licensure_By_PkArgs = {
  _set?: InputMaybe<Fsmb_Licensure_Set_Input>;
  pk_columns: Fsmb_Licensure_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Fsmb_Licensure_ManyArgs = {
  updates: Array<Fsmb_Licensure_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_LinkArgs = {
  _set?: InputMaybe<Gmaps_Link_Set_Input>;
  where: Gmaps_Link_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Link_By_PkArgs = {
  _set?: InputMaybe<Gmaps_Link_Set_Input>;
  pk_columns: Gmaps_Link_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Link_ManyArgs = {
  updates: Array<Gmaps_Link_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Link_TypeArgs = {
  _set?: InputMaybe<Gmaps_Link_Type_Set_Input>;
  where: Gmaps_Link_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Link_Type_By_PkArgs = {
  _set?: InputMaybe<Gmaps_Link_Type_Set_Input>;
  pk_columns: Gmaps_Link_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Link_Type_ManyArgs = {
  updates: Array<Gmaps_Link_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_PlaceArgs = {
  _append?: InputMaybe<Gmaps_Place_Append_Input>;
  _delete_at_path?: InputMaybe<Gmaps_Place_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Gmaps_Place_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Gmaps_Place_Delete_Key_Input>;
  _prepend?: InputMaybe<Gmaps_Place_Prepend_Input>;
  _set?: InputMaybe<Gmaps_Place_Set_Input>;
  where: Gmaps_Place_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Place_By_PkArgs = {
  _append?: InputMaybe<Gmaps_Place_Append_Input>;
  _delete_at_path?: InputMaybe<Gmaps_Place_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Gmaps_Place_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Gmaps_Place_Delete_Key_Input>;
  _prepend?: InputMaybe<Gmaps_Place_Prepend_Input>;
  _set?: InputMaybe<Gmaps_Place_Set_Input>;
  pk_columns: Gmaps_Place_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Gmaps_Place_ManyArgs = {
  updates: Array<Gmaps_Place_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_ProviderArgs = {
  _append?: InputMaybe<Identity_Provider_Append_Input>;
  _delete_at_path?: InputMaybe<Identity_Provider_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Identity_Provider_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Identity_Provider_Delete_Key_Input>;
  _prepend?: InputMaybe<Identity_Provider_Prepend_Input>;
  _set?: InputMaybe<Identity_Provider_Set_Input>;
  where: Identity_Provider_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_Provider_By_PkArgs = {
  _append?: InputMaybe<Identity_Provider_Append_Input>;
  _delete_at_path?: InputMaybe<Identity_Provider_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Identity_Provider_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Identity_Provider_Delete_Key_Input>;
  _prepend?: InputMaybe<Identity_Provider_Prepend_Input>;
  _set?: InputMaybe<Identity_Provider_Set_Input>;
  pk_columns: Identity_Provider_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_Provider_ManyArgs = {
  updates: Array<Identity_Provider_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_ApplicationArgs = {
  _set?: InputMaybe<Job_Application_Set_Input>;
  where: Job_Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_BatchArgs = {
  _set?: InputMaybe<Job_Application_Batch_Set_Input>;
  where: Job_Application_Batch_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_Batch_By_PkArgs = {
  _set?: InputMaybe<Job_Application_Batch_Set_Input>;
  pk_columns: Job_Application_Batch_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_Batch_ManyArgs = {
  updates: Array<Job_Application_Batch_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_By_PkArgs = {
  _set?: InputMaybe<Job_Application_Set_Input>;
  pk_columns: Job_Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_ManyArgs = {
  updates: Array<Job_Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_PostingArgs = {
  _set?: InputMaybe<Job_Application_Posting_Set_Input>;
  where: Job_Application_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_Posting_By_PkArgs = {
  _set?: InputMaybe<Job_Application_Posting_Set_Input>;
  pk_columns: Job_Application_Posting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Application_Posting_ManyArgs = {
  updates: Array<Job_Application_Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_PostingArgs = {
  _inc?: InputMaybe<Job_Posting_Inc_Input>;
  _set?: InputMaybe<Job_Posting_Set_Input>;
  where: Job_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Posting_By_PkArgs = {
  _inc?: InputMaybe<Job_Posting_Inc_Input>;
  _set?: InputMaybe<Job_Posting_Set_Input>;
  pk_columns: Job_Posting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Posting_ManyArgs = {
  updates: Array<Job_Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Nearby_Facilities_By_Geography_ResultArgs = {
  _inc?: InputMaybe<Nearby_Facilities_By_Geography_Result_Inc_Input>;
  _set?: InputMaybe<Nearby_Facilities_By_Geography_Result_Set_Input>;
  where: Nearby_Facilities_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Nearby_Facilities_By_Geography_Result_ManyArgs = {
  updates: Array<Nearby_Facilities_By_Geography_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Dist_ResultArgs = {
  _inc?: InputMaybe<Org_Dist_Result_Inc_Input>;
  _set?: InputMaybe<Org_Dist_Result_Set_Input>;
  where: Org_Dist_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Dist_Result_ManyArgs = {
  updates: Array<Org_Dist_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_DomainArgs = {
  _set?: InputMaybe<Org_Domain_Set_Input>;
  where: Org_Domain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Domain_By_PkArgs = {
  _set?: InputMaybe<Org_Domain_Set_Input>;
  pk_columns: Org_Domain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Domain_ManyArgs = {
  updates: Array<Org_Domain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_UserArgs = {
  _set?: InputMaybe<Org_User_Set_Input>;
  where: Org_User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_By_PkArgs = {
  _set?: InputMaybe<Org_User_Set_Input>;
  pk_columns: Org_User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_User_ManyArgs = {
  updates: Array<Org_User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _inc?: InputMaybe<Organization_Inc_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _inc?: InputMaybe<Organization_Inc_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_InfoArgs = {
  _set?: InputMaybe<Personal_Info_Set_Input>;
  where: Personal_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Personal_Info_ManyArgs = {
  updates: Array<Personal_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Place_BoundaryArgs = {
  _set?: InputMaybe<Place_Boundary_Set_Input>;
  where: Place_Boundary_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Boundary_By_PkArgs = {
  _set?: InputMaybe<Place_Boundary_Set_Input>;
  pk_columns: Place_Boundary_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Place_Boundary_ManyArgs = {
  updates: Array<Place_Boundary_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_App_CertArgs = {
  _set?: InputMaybe<Posting_App_Cert_Set_Input>;
  where: Posting_App_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_App_Cert_By_PkArgs = {
  _set?: InputMaybe<Posting_App_Cert_Set_Input>;
  pk_columns: Posting_App_Cert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_App_Cert_ManyArgs = {
  updates: Array<Posting_App_Cert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Board_CertArgs = {
  _set?: InputMaybe<Posting_Board_Cert_Set_Input>;
  where: Posting_Board_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Board_Cert_By_PkArgs = {
  _set?: InputMaybe<Posting_Board_Cert_Set_Input>;
  pk_columns: Posting_Board_Cert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Board_Cert_ManyArgs = {
  updates: Array<Posting_Board_Cert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_ProfessionArgs = {
  _set?: InputMaybe<Posting_Profession_Set_Input>;
  where: Posting_Profession_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Profession_By_PkArgs = {
  _set?: InputMaybe<Posting_Profession_Set_Input>;
  pk_columns: Posting_Profession_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Profession_ManyArgs = {
  updates: Array<Posting_Profession_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Worker_ClassificationArgs = {
  _set?: InputMaybe<Posting_Worker_Classification_Set_Input>;
  where: Posting_Worker_Classification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Worker_Classification_By_PkArgs = {
  _set?: InputMaybe<Posting_Worker_Classification_Set_Input>;
  pk_columns: Posting_Worker_Classification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Posting_Worker_Classification_ManyArgs = {
  updates: Array<Posting_Worker_Classification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Job_PostingArgs = {
  _inc?: InputMaybe<Relevant_Job_Posting_Inc_Input>;
  _set?: InputMaybe<Relevant_Job_Posting_Set_Input>;
  where: Relevant_Job_Posting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Job_Posting_ManyArgs = {
  updates: Array<Relevant_Job_Posting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Salary_ReportArgs = {
  _inc?: InputMaybe<Relevant_Salary_Report_Inc_Input>;
  _set?: InputMaybe<Relevant_Salary_Report_Set_Input>;
  where: Relevant_Salary_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relevant_Salary_Report_ManyArgs = {
  updates: Array<Relevant_Salary_Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ResidencyArgs = {
  _set?: InputMaybe<Residency_Set_Input>;
  where: Residency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Residency_By_PkArgs = {
  _set?: InputMaybe<Residency_Set_Input>;
  pk_columns: Residency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Residency_ManyArgs = {
  updates: Array<Residency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Residency_SurveyArgs = {
  _inc?: InputMaybe<Residency_Survey_Inc_Input>;
  _set?: InputMaybe<Residency_Survey_Set_Input>;
  where: Residency_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Residency_Survey_By_PkArgs = {
  _inc?: InputMaybe<Residency_Survey_Inc_Input>;
  _set?: InputMaybe<Residency_Survey_Set_Input>;
  pk_columns: Residency_Survey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Residency_Survey_ManyArgs = {
  updates: Array<Residency_Survey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReviewArgs = {
  _inc?: InputMaybe<Review_Inc_Input>;
  _set?: InputMaybe<Review_Set_Input>;
  where: Review_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Review_By_PkArgs = {
  _inc?: InputMaybe<Review_Inc_Input>;
  _set?: InputMaybe<Review_Set_Input>;
  pk_columns: Review_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Review_ManyArgs = {
  updates: Array<Review_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Review_ReplyArgs = {
  _set?: InputMaybe<Review_Reply_Set_Input>;
  where: Review_Reply_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Reply_By_PkArgs = {
  _set?: InputMaybe<Review_Reply_Set_Input>;
  pk_columns: Review_Reply_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Reply_ManyArgs = {
  updates: Array<Review_Reply_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Review_ReportArgs = {
  _set?: InputMaybe<Review_Report_Set_Input>;
  where: Review_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Report_By_PkArgs = {
  _set?: InputMaybe<Review_Report_Set_Input>;
  pk_columns: Review_Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Report_ManyArgs = {
  updates: Array<Review_Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Review_VoteArgs = {
  _inc?: InputMaybe<Review_Vote_Inc_Input>;
  _set?: InputMaybe<Review_Vote_Set_Input>;
  where: Review_Vote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Vote_By_PkArgs = {
  _inc?: InputMaybe<Review_Vote_Inc_Input>;
  _set?: InputMaybe<Review_Vote_Set_Input>;
  pk_columns: Review_Vote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Vote_ManyArgs = {
  updates: Array<Review_Vote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_ReportArgs = {
  _inc?: InputMaybe<Salary_Report_Inc_Input>;
  _set?: InputMaybe<Salary_Report_Set_Input>;
  where: Salary_Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_Report_By_PkArgs = {
  _inc?: InputMaybe<Salary_Report_Inc_Input>;
  _set?: InputMaybe<Salary_Report_Set_Input>;
  pk_columns: Salary_Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_Report_FmtArgs = {
  _inc?: InputMaybe<Salary_Report_Fmt_Inc_Input>;
  _set?: InputMaybe<Salary_Report_Fmt_Set_Input>;
  where: Salary_Report_Fmt_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_Report_Fmt_ManyArgs = {
  updates: Array<Salary_Report_Fmt_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Salary_Report_ManyArgs = {
  updates: Array<Salary_Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SchoolArgs = {
  _set?: InputMaybe<School_Set_Input>;
  where: School_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_School_By_PkArgs = {
  _set?: InputMaybe<School_Set_Input>;
  pk_columns: School_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_School_ManyArgs = {
  updates: Array<School_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Candidate_ResultArgs = {
  _inc?: InputMaybe<Search_Candidate_Result_Inc_Input>;
  _set?: InputMaybe<Search_Candidate_Result_Set_Input>;
  where: Search_Candidate_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Candidate_Result_ManyArgs = {
  updates: Array<Search_Candidate_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Clerkship_By_Geography_ResultArgs = {
  _inc?: InputMaybe<Search_Clerkship_By_Geography_Result_Inc_Input>;
  _set?: InputMaybe<Search_Clerkship_By_Geography_Result_Set_Input>;
  where: Search_Clerkship_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Clerkship_By_Geography_Result_ManyArgs = {
  updates: Array<Search_Clerkship_By_Geography_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Facility_By_Prefix_ResultArgs = {
  _inc?: InputMaybe<Search_Facility_By_Prefix_Result_Inc_Input>;
  _set?: InputMaybe<Search_Facility_By_Prefix_Result_Set_Input>;
  where: Search_Facility_By_Prefix_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Facility_By_Prefix_Result_ManyArgs = {
  updates: Array<Search_Facility_By_Prefix_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Fellowship_By_Geography_ResultArgs = {
  _inc?: InputMaybe<Search_Fellowship_By_Geography_Result_Inc_Input>;
  _set?: InputMaybe<Search_Fellowship_By_Geography_Result_Set_Input>;
  where: Search_Fellowship_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Fellowship_By_Geography_Result_ManyArgs = {
  updates: Array<Search_Fellowship_By_Geography_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Fsmb_Bio_ResultArgs = {
  _inc?: InputMaybe<Search_Fsmb_Bio_Result_Inc_Input>;
  _set?: InputMaybe<Search_Fsmb_Bio_Result_Set_Input>;
  where: Search_Fsmb_Bio_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Fsmb_Bio_Result_ManyArgs = {
  updates: Array<Search_Fsmb_Bio_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Job_Postings_By_Geography_ResultArgs = {
  _inc?: InputMaybe<Search_Job_Postings_By_Geography_Result_Inc_Input>;
  _set?: InputMaybe<Search_Job_Postings_By_Geography_Result_Set_Input>;
  where: Search_Job_Postings_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Job_Postings_By_Geography_Result_ManyArgs = {
  updates: Array<Search_Job_Postings_By_Geography_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Org_Market_ResultArgs = {
  _inc?: InputMaybe<Search_Org_Market_Result_Inc_Input>;
  _set?: InputMaybe<Search_Org_Market_Result_Set_Input>;
  where: Search_Org_Market_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Org_Market_Result_ManyArgs = {
  updates: Array<Search_Org_Market_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Organization_By_Prefix_ResultArgs = {
  _inc?: InputMaybe<Search_Organization_By_Prefix_Result_Inc_Input>;
  _set?: InputMaybe<Search_Organization_By_Prefix_Result_Set_Input>;
  where: Search_Organization_By_Prefix_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Organization_By_Prefix_Result_ManyArgs = {
  updates: Array<Search_Organization_By_Prefix_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Residency_By_Geography_ResultArgs = {
  _inc?: InputMaybe<Search_Residency_By_Geography_Result_Inc_Input>;
  _set?: InputMaybe<Search_Residency_By_Geography_Result_Set_Input>;
  where: Search_Residency_By_Geography_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Residency_By_Geography_Result_ManyArgs = {
  updates: Array<Search_Residency_By_Geography_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Training_By_Prefix_ResultArgs = {
  _inc?: InputMaybe<Search_Training_By_Prefix_Result_Inc_Input>;
  _set?: InputMaybe<Search_Training_By_Prefix_Result_Set_Input>;
  where: Search_Training_By_Prefix_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Training_By_Prefix_Result_ManyArgs = {
  updates: Array<Search_Training_By_Prefix_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SiteArgs = {
  _set?: InputMaybe<Site_Set_Input>;
  where: Site_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Site_By_PkArgs = {
  _set?: InputMaybe<Site_Set_Input>;
  pk_columns: Site_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Site_ManyArgs = {
  updates: Array<Site_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Stroke_CertArgs = {
  _set?: InputMaybe<Stroke_Cert_Set_Input>;
  where: Stroke_Cert_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Stroke_Cert_By_PkArgs = {
  _set?: InputMaybe<Stroke_Cert_Set_Input>;
  pk_columns: Stroke_Cert_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Stroke_Cert_ManyArgs = {
  updates: Array<Stroke_Cert_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TrainingArgs = {
  _set?: InputMaybe<Training_Set_Input>;
  where: Training_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_By_PkArgs = {
  _set?: InputMaybe<Training_Set_Input>;
  pk_columns: Training_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_EventArgs = {
  _set?: InputMaybe<Training_Event_Set_Input>;
  where: Training_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Event_By_PkArgs = {
  _set?: InputMaybe<Training_Event_Set_Input>;
  pk_columns: Training_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Event_ManyArgs = {
  updates: Array<Training_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_FieldArgs = {
  _set?: InputMaybe<Training_Field_Set_Input>;
  where: Training_Field_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Field_By_PkArgs = {
  _set?: InputMaybe<Training_Field_Set_Input>;
  pk_columns: Training_Field_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Field_ManyArgs = {
  updates: Array<Training_Field_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_ManyArgs = {
  updates: Array<Training_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_ProgramArgs = {
  _set?: InputMaybe<Training_Program_Set_Input>;
  where: Training_Program_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Program_By_PkArgs = {
  _set?: InputMaybe<Training_Program_Set_Input>;
  pk_columns: Training_Program_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Program_ManyArgs = {
  updates: Array<Training_Program_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_SurveyArgs = {
  _set?: InputMaybe<Training_Survey_Set_Input>;
  where: Training_Survey_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_By_PkArgs = {
  _set?: InputMaybe<Training_Survey_Set_Input>;
  pk_columns: Training_Survey_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_ManyArgs = {
  updates: Array<Training_Survey_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_PictureArgs = {
  _inc?: InputMaybe<Training_Survey_Picture_Inc_Input>;
  _set?: InputMaybe<Training_Survey_Picture_Set_Input>;
  where: Training_Survey_Picture_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_Picture_By_PkArgs = {
  _inc?: InputMaybe<Training_Survey_Picture_Inc_Input>;
  _set?: InputMaybe<Training_Survey_Picture_Set_Input>;
  pk_columns: Training_Survey_Picture_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_Picture_ManyArgs = {
  updates: Array<Training_Survey_Picture_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_SiteArgs = {
  _inc?: InputMaybe<Training_Survey_Site_Inc_Input>;
  _set?: InputMaybe<Training_Survey_Site_Set_Input>;
  where: Training_Survey_Site_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_Site_By_PkArgs = {
  _inc?: InputMaybe<Training_Survey_Site_Inc_Input>;
  _set?: InputMaybe<Training_Survey_Site_Set_Input>;
  pk_columns: Training_Survey_Site_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_Site_ManyArgs = {
  updates: Array<Training_Survey_Site_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Training_Survey_StatusArgs = {
  emra_account_no?: InputMaybe<Scalars['String']>;
  emrafied?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  pd_interview?: InputMaybe<Scalars['String']>;
  status: TrainingSurveyStatus;
  training_survey_id: Scalars['String'];
  upcoming_events?: InputMaybe<Array<UpdateTrainingSurveyStatusEventInput>>;
};


/** mutation root */
export type Mutation_RootUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpsertFaqArgs = {
  upsert: FaqUpsertInput;
  where: FaqWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpsertLegalArgs = {
  upsert: LegalUpsertInput;
  where: LegalWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpsertPostArgs = {
  upsert: PostUpsertInput;
  where: PostWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpsertTeammateArgs = {
  upsert: TeammateUpsertInput;
  where: TeammateWhereUniqueInput;
};


/** mutation root */
export type Mutation_RootUpsert_CustomerArgs = {
  customer_details: CustomerDetailsInput;
};

export type Nearby_Facilities_By_Geography_Args = {
  prof?: InputMaybe<Scalars['profession']>;
  radius?: InputMaybe<Scalars['float8']>;
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result = {
  __typename?: 'nearby_facilities_by_geography_result';
  distance: Maybe<Scalars['float8']>;
  /** An object relationship */
  facility: Maybe<Facility>;
  id: Maybe<Scalars['uuid']>;
};

export type Nearby_Facilities_By_Geography_Result_Aggregate = {
  __typename?: 'nearby_facilities_by_geography_result_aggregate';
  aggregate: Maybe<Nearby_Facilities_By_Geography_Result_Aggregate_Fields>;
  nodes: Array<Nearby_Facilities_By_Geography_Result>;
};

/** aggregate fields of "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Aggregate_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_aggregate_fields';
  avg: Maybe<Nearby_Facilities_By_Geography_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Nearby_Facilities_By_Geography_Result_Max_Fields>;
  min: Maybe<Nearby_Facilities_By_Geography_Result_Min_Fields>;
  stddev: Maybe<Nearby_Facilities_By_Geography_Result_Stddev_Fields>;
  stddev_pop: Maybe<Nearby_Facilities_By_Geography_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Nearby_Facilities_By_Geography_Result_Stddev_Samp_Fields>;
  sum: Maybe<Nearby_Facilities_By_Geography_Result_Sum_Fields>;
  var_pop: Maybe<Nearby_Facilities_By_Geography_Result_Var_Pop_Fields>;
  var_samp: Maybe<Nearby_Facilities_By_Geography_Result_Var_Samp_Fields>;
  variance: Maybe<Nearby_Facilities_By_Geography_Result_Variance_Fields>;
};


/** aggregate fields of "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Nearby_Facilities_By_Geography_Result_Avg_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "nearby_facilities_by_geography_result". All fields are combined with a logical 'AND'. */
export type Nearby_Facilities_By_Geography_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Bool_Exp>>;
  _not?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Nearby_Facilities_By_Geography_Result_Max_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Nearby_Facilities_By_Geography_Result_Min_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Mutation_Response = {
  __typename?: 'nearby_facilities_by_geography_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Nearby_Facilities_By_Geography_Result>;
};

/** Ordering options when selecting data from "nearby_facilities_by_geography_result". */
export type Nearby_Facilities_By_Geography_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "nearby_facilities_by_geography_result" */
export enum Nearby_Facilities_By_Geography_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Nearby_Facilities_By_Geography_Result_Stddev_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Nearby_Facilities_By_Geography_Result_Stddev_Pop_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Nearby_Facilities_By_Geography_Result_Stddev_Samp_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "nearby_facilities_by_geography_result" */
export type Nearby_Facilities_By_Geography_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nearby_Facilities_By_Geography_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nearby_Facilities_By_Geography_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Nearby_Facilities_By_Geography_Result_Sum_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Nearby_Facilities_By_Geography_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Nearby_Facilities_By_Geography_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Nearby_Facilities_By_Geography_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Nearby_Facilities_By_Geography_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Nearby_Facilities_By_Geography_Result_Var_Pop_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Nearby_Facilities_By_Geography_Result_Var_Samp_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Nearby_Facilities_By_Geography_Result_Variance_Fields = {
  __typename?: 'nearby_facilities_by_geography_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Num_Postings_For_Prof_Facility_Args = {
  prof?: InputMaybe<Scalars['profession']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Org_Dist_Args = {
  x?: InputMaybe<Scalars['float8']>;
  y?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "org_dist_result" */
export type Org_Dist_Result = {
  __typename?: 'org_dist_result';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization: Maybe<Organization>;
};

export type Org_Dist_Result_Aggregate = {
  __typename?: 'org_dist_result_aggregate';
  aggregate: Maybe<Org_Dist_Result_Aggregate_Fields>;
  nodes: Array<Org_Dist_Result>;
};

/** aggregate fields of "org_dist_result" */
export type Org_Dist_Result_Aggregate_Fields = {
  __typename?: 'org_dist_result_aggregate_fields';
  avg: Maybe<Org_Dist_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Org_Dist_Result_Max_Fields>;
  min: Maybe<Org_Dist_Result_Min_Fields>;
  stddev: Maybe<Org_Dist_Result_Stddev_Fields>;
  stddev_pop: Maybe<Org_Dist_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Org_Dist_Result_Stddev_Samp_Fields>;
  sum: Maybe<Org_Dist_Result_Sum_Fields>;
  var_pop: Maybe<Org_Dist_Result_Var_Pop_Fields>;
  var_samp: Maybe<Org_Dist_Result_Var_Samp_Fields>;
  variance: Maybe<Org_Dist_Result_Variance_Fields>;
};


/** aggregate fields of "org_dist_result" */
export type Org_Dist_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Org_Dist_Result_Avg_Fields = {
  __typename?: 'org_dist_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "org_dist_result". All fields are combined with a logical 'AND'. */
export type Org_Dist_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Dist_Result_Bool_Exp>>;
  _not?: InputMaybe<Org_Dist_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Dist_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "org_dist_result" */
export type Org_Dist_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "org_dist_result" */
export type Org_Dist_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Org_Dist_Result_Max_Fields = {
  __typename?: 'org_dist_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Org_Dist_Result_Min_Fields = {
  __typename?: 'org_dist_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "org_dist_result" */
export type Org_Dist_Result_Mutation_Response = {
  __typename?: 'org_dist_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Dist_Result>;
};

/** Ordering options when selecting data from "org_dist_result". */
export type Org_Dist_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
};

/** select columns of table "org_dist_result" */
export enum Org_Dist_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "org_dist_result" */
export type Org_Dist_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Org_Dist_Result_Stddev_Fields = {
  __typename?: 'org_dist_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Org_Dist_Result_Stddev_Pop_Fields = {
  __typename?: 'org_dist_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Org_Dist_Result_Stddev_Samp_Fields = {
  __typename?: 'org_dist_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "org_dist_result" */
export type Org_Dist_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Dist_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Dist_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Org_Dist_Result_Sum_Fields = {
  __typename?: 'org_dist_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Org_Dist_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Dist_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Dist_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_Dist_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Dist_Result_Var_Pop_Fields = {
  __typename?: 'org_dist_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Org_Dist_Result_Var_Samp_Fields = {
  __typename?: 'org_dist_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Org_Dist_Result_Variance_Fields = {
  __typename?: 'org_dist_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

/** columns and relationships of "org_domain" */
export type Org_Domain = {
  __typename?: 'org_domain';
  id: Scalars['uuid'];
  name: Scalars['String'];
  org_id: Scalars['uuid'];
};

/** aggregated selection of "org_domain" */
export type Org_Domain_Aggregate = {
  __typename?: 'org_domain_aggregate';
  aggregate: Maybe<Org_Domain_Aggregate_Fields>;
  nodes: Array<Org_Domain>;
};

export type Org_Domain_Aggregate_Bool_Exp = {
  count?: InputMaybe<Org_Domain_Aggregate_Bool_Exp_Count>;
};

export type Org_Domain_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Org_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_Domain_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "org_domain" */
export type Org_Domain_Aggregate_Fields = {
  __typename?: 'org_domain_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Org_Domain_Max_Fields>;
  min: Maybe<Org_Domain_Min_Fields>;
};


/** aggregate fields of "org_domain" */
export type Org_Domain_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Domain_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_domain" */
export type Org_Domain_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Domain_Max_Order_By>;
  min?: InputMaybe<Org_Domain_Min_Order_By>;
};

/** input type for inserting array relation for remote table "org_domain" */
export type Org_Domain_Arr_Rel_Insert_Input = {
  data: Array<Org_Domain_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Domain_On_Conflict>;
};

/** Boolean expression to filter rows from the table "org_domain". All fields are combined with a logical 'AND'. */
export type Org_Domain_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Domain_Bool_Exp>>;
  _not?: InputMaybe<Org_Domain_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Domain_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_domain" */
export enum Org_Domain_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkOrgDomain = 'pk_org_domain',
  /** unique or primary key constraint on columns "org_id", "name" */
  UqOrgDomainOrgIdName = 'uq_org_domain_org_id_name'
}

/** input type for inserting data into table "org_domain" */
export type Org_Domain_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Org_Domain_Max_Fields = {
  __typename?: 'org_domain_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "org_domain" */
export type Org_Domain_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Domain_Min_Fields = {
  __typename?: 'org_domain_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "org_domain" */
export type Org_Domain_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_domain" */
export type Org_Domain_Mutation_Response = {
  __typename?: 'org_domain_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Domain>;
};

/** on_conflict condition type for table "org_domain" */
export type Org_Domain_On_Conflict = {
  constraint: Org_Domain_Constraint;
  update_columns?: Array<Org_Domain_Update_Column>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};

/** Ordering options when selecting data from "org_domain". */
export type Org_Domain_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_domain */
export type Org_Domain_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_domain" */
export enum Org_Domain_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id'
}

/** input type for updating data in table "org_domain" */
export type Org_Domain_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "org_domain" */
export type Org_Domain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Domain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Domain_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "org_domain" */
export enum Org_Domain_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id'
}

export type Org_Domain_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Domain_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_Domain_Bool_Exp;
};

/** columns and relationships of "org_market" */
export type Org_Market = {
  __typename?: 'org_market';
  ed_coverage: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  num_eds: Maybe<Scalars['bigint']>;
  num_freestanding_eds: Maybe<Scalars['bigint']>;
  num_residency_eds: Maybe<Scalars['bigint']>;
  /** An object relationship */
  org: Maybe<Organization>;
};

/** aggregated selection of "org_market" */
export type Org_Market_Aggregate = {
  __typename?: 'org_market_aggregate';
  aggregate: Maybe<Org_Market_Aggregate_Fields>;
  nodes: Array<Org_Market>;
};

/** aggregate fields of "org_market" */
export type Org_Market_Aggregate_Fields = {
  __typename?: 'org_market_aggregate_fields';
  avg: Maybe<Org_Market_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Org_Market_Max_Fields>;
  min: Maybe<Org_Market_Min_Fields>;
  stddev: Maybe<Org_Market_Stddev_Fields>;
  stddev_pop: Maybe<Org_Market_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Org_Market_Stddev_Samp_Fields>;
  sum: Maybe<Org_Market_Sum_Fields>;
  var_pop: Maybe<Org_Market_Var_Pop_Fields>;
  var_samp: Maybe<Org_Market_Var_Samp_Fields>;
  variance: Maybe<Org_Market_Variance_Fields>;
};


/** aggregate fields of "org_market" */
export type Org_Market_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Market_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Org_Market_Avg_Fields = {
  __typename?: 'org_market_avg_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "org_market". All fields are combined with a logical 'AND'. */
export type Org_Market_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Market_Bool_Exp>>;
  _not?: InputMaybe<Org_Market_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Market_Bool_Exp>>;
  ed_coverage?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  num_eds?: InputMaybe<Bigint_Comparison_Exp>;
  num_freestanding_eds?: InputMaybe<Bigint_Comparison_Exp>;
  num_residency_eds?: InputMaybe<Bigint_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
};

/** input type for inserting data into table "org_market" */
export type Org_Market_Insert_Input = {
  ed_coverage?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_eds?: InputMaybe<Scalars['bigint']>;
  num_freestanding_eds?: InputMaybe<Scalars['bigint']>;
  num_residency_eds?: InputMaybe<Scalars['bigint']>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Org_Market_Max_Fields = {
  __typename?: 'org_market_max_fields';
  ed_coverage: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  num_eds: Maybe<Scalars['bigint']>;
  num_freestanding_eds: Maybe<Scalars['bigint']>;
  num_residency_eds: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Org_Market_Min_Fields = {
  __typename?: 'org_market_min_fields';
  ed_coverage: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  num_eds: Maybe<Scalars['bigint']>;
  num_freestanding_eds: Maybe<Scalars['bigint']>;
  num_residency_eds: Maybe<Scalars['bigint']>;
};

/** input type for inserting object relation for remote table "org_market" */
export type Org_Market_Obj_Rel_Insert_Input = {
  data: Org_Market_Insert_Input;
};

/** Ordering options when selecting data from "org_market". */
export type Org_Market_Order_By = {
  ed_coverage?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  num_eds?: InputMaybe<Order_By>;
  num_freestanding_eds?: InputMaybe<Order_By>;
  num_residency_eds?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
};

/** select columns of table "org_market" */
export enum Org_Market_Select_Column {
  /** column name */
  EdCoverage = 'ed_coverage',
  /** column name */
  Id = 'id',
  /** column name */
  NumEds = 'num_eds',
  /** column name */
  NumFreestandingEds = 'num_freestanding_eds',
  /** column name */
  NumResidencyEds = 'num_residency_eds'
}

/** aggregate stddev on columns */
export type Org_Market_Stddev_Fields = {
  __typename?: 'org_market_stddev_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Org_Market_Stddev_Pop_Fields = {
  __typename?: 'org_market_stddev_pop_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Org_Market_Stddev_Samp_Fields = {
  __typename?: 'org_market_stddev_samp_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "org_market" */
export type Org_Market_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Market_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Market_Stream_Cursor_Value_Input = {
  ed_coverage?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  num_eds?: InputMaybe<Scalars['bigint']>;
  num_freestanding_eds?: InputMaybe<Scalars['bigint']>;
  num_residency_eds?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Org_Market_Sum_Fields = {
  __typename?: 'org_market_sum_fields';
  ed_coverage: Maybe<Scalars['float8']>;
  num_eds: Maybe<Scalars['bigint']>;
  num_freestanding_eds: Maybe<Scalars['bigint']>;
  num_residency_eds: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Org_Market_Var_Pop_Fields = {
  __typename?: 'org_market_var_pop_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Org_Market_Var_Samp_Fields = {
  __typename?: 'org_market_var_samp_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Org_Market_Variance_Fields = {
  __typename?: 'org_market_variance_fields';
  ed_coverage: Maybe<Scalars['Float']>;
  num_eds: Maybe<Scalars['Float']>;
  num_freestanding_eds: Maybe<Scalars['Float']>;
  num_residency_eds: Maybe<Scalars['Float']>;
};

/** columns and relationships of "org_rating" */
export type Org_Rating = {
  __typename?: 'org_rating';
  count: Maybe<Scalars['bigint']>;
  org_id: Maybe<Scalars['uuid']>;
  rating_org: Maybe<Scalars['Int']>;
};

/** aggregated selection of "org_rating" */
export type Org_Rating_Aggregate = {
  __typename?: 'org_rating_aggregate';
  aggregate: Maybe<Org_Rating_Aggregate_Fields>;
  nodes: Array<Org_Rating>;
};

export type Org_Rating_Aggregate_Bool_Exp = {
  count?: InputMaybe<Org_Rating_Aggregate_Bool_Exp_Count>;
};

export type Org_Rating_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Org_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_Rating_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "org_rating" */
export type Org_Rating_Aggregate_Fields = {
  __typename?: 'org_rating_aggregate_fields';
  avg: Maybe<Org_Rating_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Org_Rating_Max_Fields>;
  min: Maybe<Org_Rating_Min_Fields>;
  stddev: Maybe<Org_Rating_Stddev_Fields>;
  stddev_pop: Maybe<Org_Rating_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Org_Rating_Stddev_Samp_Fields>;
  sum: Maybe<Org_Rating_Sum_Fields>;
  var_pop: Maybe<Org_Rating_Var_Pop_Fields>;
  var_samp: Maybe<Org_Rating_Var_Samp_Fields>;
  variance: Maybe<Org_Rating_Variance_Fields>;
};


/** aggregate fields of "org_rating" */
export type Org_Rating_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Rating_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_rating" */
export type Org_Rating_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Rating_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Rating_Max_Order_By>;
  min?: InputMaybe<Org_Rating_Min_Order_By>;
  stddev?: InputMaybe<Org_Rating_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Rating_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Rating_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Rating_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Rating_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Rating_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Rating_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_rating" */
export type Org_Rating_Arr_Rel_Insert_Input = {
  data: Array<Org_Rating_Insert_Input>;
};

/** aggregate avg on columns */
export type Org_Rating_Avg_Fields = {
  __typename?: 'org_rating_avg_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_rating" */
export type Org_Rating_Avg_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_rating". All fields are combined with a logical 'AND'. */
export type Org_Rating_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Rating_Bool_Exp>>;
  _not?: InputMaybe<Org_Rating_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Rating_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  rating_org?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for inserting data into table "org_rating" */
export type Org_Rating_Insert_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rating_org?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Org_Rating_Max_Fields = {
  __typename?: 'org_rating_max_fields';
  count: Maybe<Scalars['bigint']>;
  org_id: Maybe<Scalars['uuid']>;
  rating_org: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "org_rating" */
export type Org_Rating_Max_Order_By = {
  count?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Rating_Min_Fields = {
  __typename?: 'org_rating_min_fields';
  count: Maybe<Scalars['bigint']>;
  org_id: Maybe<Scalars['uuid']>;
  rating_org: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "org_rating" */
export type Org_Rating_Min_Order_By = {
  count?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "org_rating". */
export type Org_Rating_Order_By = {
  count?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** select columns of table "org_rating" */
export enum Org_Rating_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  RatingOrg = 'rating_org'
}

/** aggregate stddev on columns */
export type Org_Rating_Stddev_Fields = {
  __typename?: 'org_rating_stddev_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_rating" */
export type Org_Rating_Stddev_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_Rating_Stddev_Pop_Fields = {
  __typename?: 'org_rating_stddev_pop_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_rating" */
export type Org_Rating_Stddev_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_Rating_Stddev_Samp_Fields = {
  __typename?: 'org_rating_stddev_samp_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_rating" */
export type Org_Rating_Stddev_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_rating" */
export type Org_Rating_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Rating_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Rating_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rating_org?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Org_Rating_Sum_Fields = {
  __typename?: 'org_rating_sum_fields';
  count: Maybe<Scalars['bigint']>;
  rating_org: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "org_rating" */
export type Org_Rating_Sum_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Org_Rating_Var_Pop_Fields = {
  __typename?: 'org_rating_var_pop_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_rating" */
export type Org_Rating_Var_Pop_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_Rating_Var_Samp_Fields = {
  __typename?: 'org_rating_var_samp_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_rating" */
export type Org_Rating_Var_Samp_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_Rating_Variance_Fields = {
  __typename?: 'org_rating_variance_fields';
  count: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_rating" */
export type Org_Rating_Variance_Order_By = {
  count?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_user" */
export type Org_User = {
  __typename?: 'org_user';
  /** An object relationship */
  account: Account;
  /** An array relationship */
  contracts: Array<Facility_Contract>;
  /** An aggregate relationship */
  contracts_aggregate: Facility_Contract_Aggregate;
  /** An array relationship */
  default_recruiter_for: Array<Organization>;
  /** An aggregate relationship */
  default_recruiter_for_aggregate: Organization_Aggregate;
  disable_admin_followup: Scalars['Boolean'];
  id: Scalars['uuid'];
  lastViewedCandidatesDate: Maybe<Scalars['DateTime']>;
  last_viewed_candidates: Maybe<Scalars['timestamp']>;
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
  /** An object relationship */
  org: Organization;
  org_id: Scalars['uuid'];
  reporting: Scalars['Boolean'];
};


/** columns and relationships of "org_user" */
export type Org_UserContractsArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


/** columns and relationships of "org_user" */
export type Org_UserContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


/** columns and relationships of "org_user" */
export type Org_UserDefault_Recruiter_ForArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "org_user" */
export type Org_UserDefault_Recruiter_For_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** aggregated selection of "org_user" */
export type Org_User_Aggregate = {
  __typename?: 'org_user_aggregate';
  aggregate: Maybe<Org_User_Aggregate_Fields>;
  nodes: Array<Org_User>;
};

export type Org_User_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Org_User_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Org_User_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Org_User_Aggregate_Bool_Exp_Count>;
};

export type Org_User_Aggregate_Bool_Exp_Bool_And = {
  arguments: Org_User_Select_Column_Org_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Org_User_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Org_User_Select_Column_Org_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_User_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Org_User_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Org_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_User_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "org_user" */
export type Org_User_Aggregate_Fields = {
  __typename?: 'org_user_aggregate_fields';
  avg: Maybe<Org_User_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Org_User_Max_Fields>;
  min: Maybe<Org_User_Min_Fields>;
  stddev: Maybe<Org_User_Stddev_Fields>;
  stddev_pop: Maybe<Org_User_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Org_User_Stddev_Samp_Fields>;
  sum: Maybe<Org_User_Sum_Fields>;
  var_pop: Maybe<Org_User_Var_Pop_Fields>;
  var_samp: Maybe<Org_User_Var_Samp_Fields>;
  variance: Maybe<Org_User_Variance_Fields>;
};


/** aggregate fields of "org_user" */
export type Org_User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_user" */
export type Org_User_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_User_Max_Order_By>;
  min?: InputMaybe<Org_User_Min_Order_By>;
};

/** input type for inserting array relation for remote table "org_user" */
export type Org_User_Arr_Rel_Insert_Input = {
  data: Array<Org_User_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_User_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_User_Avg_Fields = {
  __typename?: 'org_user_avg_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** Boolean expression to filter rows from the table "org_user". All fields are combined with a logical 'AND'. */
export type Org_User_Bool_Exp = {
  _and?: InputMaybe<Array<Org_User_Bool_Exp>>;
  _not?: InputMaybe<Org_User_Bool_Exp>;
  _or?: InputMaybe<Array<Org_User_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  contracts?: InputMaybe<Facility_Contract_Bool_Exp>;
  contracts_aggregate?: InputMaybe<Facility_Contract_Aggregate_Bool_Exp>;
  default_recruiter_for?: InputMaybe<Organization_Bool_Exp>;
  default_recruiter_for_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  disable_admin_followup?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_viewed_candidates?: InputMaybe<Timestamp_Comparison_Exp>;
  num_unseen_candidates?: InputMaybe<Int_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  reporting?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_user" */
export enum Org_User_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkOrgUser = 'pk_org_user'
}

/** input type for inserting data into table "org_user" */
export type Org_User_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  contracts?: InputMaybe<Facility_Contract_Arr_Rel_Insert_Input>;
  default_recruiter_for?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  disable_admin_followup?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_viewed_candidates?: InputMaybe<Scalars['timestamp']>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
  reporting?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Org_User_Max_Fields = {
  __typename?: 'org_user_max_fields';
  id: Maybe<Scalars['uuid']>;
  last_viewed_candidates: Maybe<Scalars['timestamp']>;
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "org_user" */
export type Org_User_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  last_viewed_candidates?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_User_Min_Fields = {
  __typename?: 'org_user_min_fields';
  id: Maybe<Scalars['uuid']>;
  last_viewed_candidates: Maybe<Scalars['timestamp']>;
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "org_user" */
export type Org_User_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  last_viewed_candidates?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_user" */
export type Org_User_Mutation_Response = {
  __typename?: 'org_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_User>;
};

/** input type for inserting object relation for remote table "org_user" */
export type Org_User_Obj_Rel_Insert_Input = {
  data: Org_User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_User_On_Conflict>;
};

/** on_conflict condition type for table "org_user" */
export type Org_User_On_Conflict = {
  constraint: Org_User_Constraint;
  update_columns?: Array<Org_User_Update_Column>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};

/** Ordering options when selecting data from "org_user". */
export type Org_User_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  contracts_aggregate?: InputMaybe<Facility_Contract_Aggregate_Order_By>;
  default_recruiter_for_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  disable_admin_followup?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_viewed_candidates?: InputMaybe<Order_By>;
  num_unseen_candidates?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  org_id?: InputMaybe<Order_By>;
  reporting?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_user */
export type Org_User_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_user" */
export enum Org_User_Select_Column {
  /** column name */
  DisableAdminFollowup = 'disable_admin_followup',
  /** column name */
  Id = 'id',
  /** column name */
  LastViewedCandidates = 'last_viewed_candidates',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Reporting = 'reporting'
}

/** select "org_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "org_user" */
export enum Org_User_Select_Column_Org_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DisableAdminFollowup = 'disable_admin_followup',
  /** column name */
  Reporting = 'reporting'
}

/** select "org_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "org_user" */
export enum Org_User_Select_Column_Org_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DisableAdminFollowup = 'disable_admin_followup',
  /** column name */
  Reporting = 'reporting'
}

/** input type for updating data in table "org_user" */
export type Org_User_Set_Input = {
  disable_admin_followup?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_viewed_candidates?: InputMaybe<Scalars['timestamp']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  reporting?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Org_User_Stddev_Fields = {
  __typename?: 'org_user_stddev_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** aggregate stddev_pop on columns */
export type Org_User_Stddev_Pop_Fields = {
  __typename?: 'org_user_stddev_pop_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** aggregate stddev_samp on columns */
export type Org_User_Stddev_Samp_Fields = {
  __typename?: 'org_user_stddev_samp_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "org_user" */
export type Org_User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_User_Stream_Cursor_Value_Input = {
  disable_admin_followup?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_viewed_candidates?: InputMaybe<Scalars['timestamp']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  reporting?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Org_User_Sum_Fields = {
  __typename?: 'org_user_sum_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** update columns of table "org_user" */
export enum Org_User_Update_Column {
  /** column name */
  DisableAdminFollowup = 'disable_admin_followup',
  /** column name */
  Id = 'id',
  /** column name */
  LastViewedCandidates = 'last_viewed_candidates',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Reporting = 'reporting'
}

export type Org_User_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_User_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_User_Var_Pop_Fields = {
  __typename?: 'org_user_var_pop_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** aggregate var_samp on columns */
export type Org_User_Var_Samp_Fields = {
  __typename?: 'org_user_var_samp_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** aggregate variance on columns */
export type Org_User_Variance_Fields = {
  __typename?: 'org_user_variance_fields';
  /** A computed field, executes function "num_unseen_candidates" */
  num_unseen_candidates: Maybe<Scalars['Int']>;
};

/** columns and relationships of "organization" */
export type Organization = {
  __typename?: 'organization';
  /** An array relationship */
  acep_org_surveys: Array<Acep_Org_Survey>;
  /** An aggregate relationship */
  acep_org_surveys_aggregate: Acep_Org_Survey_Aggregate;
  active: Scalars['Boolean'];
  billing_email: Scalars['String'];
  /** An object relationship */
  bounds: Maybe<Organization_Bounds>;
  /** An array relationship */
  candidates: Array<Candidate>;
  /** An aggregate relationship */
  candidates_aggregate: Candidate_Aggregate;
  checkout_bank_hold: Scalars['Boolean'];
  city: Scalars['String'];
  /** An array relationship */
  contracts: Array<Facility_Contract>;
  /** An aggregate relationship */
  contracts_aggregate: Facility_Contract_Aggregate;
  /** An object relationship */
  cover_photo: Maybe<File>;
  cover_photo_id: Maybe<Scalars['uuid']>;
  crosspost: Scalars['Boolean'];
  customer: Maybe<CustomerGql>;
  customer_id: Maybe<Scalars['String']>;
  /** An object relationship */
  default_recruiter: Maybe<Org_User>;
  default_recruiter_id: Maybe<Scalars['uuid']>;
  description: Scalars['String'];
  domain_signups: Scalars['Boolean'];
  /** An array relationship */
  domains: Array<Org_Domain>;
  /** An aggregate relationship */
  domains_aggregate: Org_Domain_Aggregate;
  /** An array relationship */
  ext_postings: Array<Ext_Job_Posting>;
  /** An aggregate relationship */
  ext_postings_aggregate: Ext_Job_Posting_Aggregate;
  id: Scalars['uuid'];
  job_posting_slots: Maybe<Scalars['Int']>;
  /** An array relationship */
  job_postings: Array<Organization_Job_Posting>;
  /** An aggregate relationship */
  job_postings_aggregate: Organization_Job_Posting_Aggregate;
  location: Maybe<Scalars['geography']>;
  /** An object relationship */
  logo: Maybe<File>;
  logo_id: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  name_change: Scalars['String'];
  name_change_requested_at: Maybe<Scalars['timestamp']>;
  name_change_requested_by_id: Maybe<Scalars['uuid']>;
  /** An array relationship */
  org_ratings: Array<Org_Rating>;
  /** An aggregate relationship */
  org_ratings_aggregate: Org_Rating_Aggregate;
  /** An array relationship */
  org_users: Array<Org_User>;
  /** An aggregate relationship */
  org_users_aggregate: Org_User_Aggregate;
  ownership_structure: Maybe<Scalars['ownershipstructure']>;
  phone: Scalars['String'];
  ranking_review: Maybe<Scalars['Int']>;
  /** An array relationship */
  reviews: Array<Review>;
  /** An aggregate relationship */
  reviews_aggregate: Review_Aggregate;
  /** An array relationship */
  salary_reports: Array<Salary_Report>;
  /** An aggregate relationship */
  salary_reports_aggregate: Salary_Report_Aggregate;
  /** An array relationship */
  salary_reports_fmt: Array<Salary_Report_Fmt>;
  /** An aggregate relationship */
  salary_reports_fmt_aggregate: Salary_Report_Fmt_Aggregate;
  search_vec: Scalars['tsvector'];
  slug: Scalars['String'];
  state: Scalars['String'];
  street_address_1: Scalars['String'];
  street_address_2: Scalars['String'];
  subscription_active: Scalars['Boolean'];
  verified: Scalars['Boolean'];
  website: Scalars['String'];
  zipcode: Scalars['String'];
};


/** columns and relationships of "organization" */
export type OrganizationAcep_Org_SurveysArgs = {
  distinct_on?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acep_Org_Survey_Order_By>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAcep_Org_Surveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acep_Org_Survey_Order_By>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCandidatesArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationCandidates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationContractsArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDomainsArgs = {
  distinct_on?: InputMaybe<Array<Org_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Domain_Order_By>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationDomains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Domain_Order_By>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationExt_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationExt_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationJob_PostingsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Job_Posting_Order_By>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationJob_Postings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Job_Posting_Order_By>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrg_RatingsArgs = {
  distinct_on?: InputMaybe<Array<Org_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Rating_Order_By>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrg_Ratings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Rating_Order_By>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrg_UsersArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Order_By>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrg_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Order_By>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationReviewsArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSalary_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSalary_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSalary_Reports_FmtArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationSalary_Reports_Fmt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

export type Organization_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Aggregate_Bool_Exp_Count>;
};

export type Organization_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  avg: Maybe<Organization_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Organization_Max_Fields>;
  min: Maybe<Organization_Min_Fields>;
  stddev: Maybe<Organization_Stddev_Fields>;
  stddev_pop: Maybe<Organization_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Organization_Stddev_Samp_Fields>;
  sum: Maybe<Organization_Sum_Fields>;
  var_pop: Maybe<Organization_Var_Pop_Fields>;
  var_samp: Maybe<Organization_Var_Samp_Fields>;
  variance: Maybe<Organization_Variance_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization" */
export type Organization_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Max_Order_By>;
  min?: InputMaybe<Organization_Min_Order_By>;
  stddev?: InputMaybe<Organization_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization" */
export type Organization_Arr_Rel_Insert_Input = {
  data: Array<Organization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Avg_Fields = {
  __typename?: 'organization_avg_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organization" */
export type Organization_Avg_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  acep_org_surveys?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
  acep_org_surveys_aggregate?: InputMaybe<Acep_Org_Survey_Aggregate_Bool_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  billing_email?: InputMaybe<String_Comparison_Exp>;
  bounds?: InputMaybe<Organization_Bounds_Bool_Exp>;
  candidates?: InputMaybe<Candidate_Bool_Exp>;
  candidates_aggregate?: InputMaybe<Candidate_Aggregate_Bool_Exp>;
  checkout_bank_hold?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  contracts?: InputMaybe<Facility_Contract_Bool_Exp>;
  contracts_aggregate?: InputMaybe<Facility_Contract_Aggregate_Bool_Exp>;
  cover_photo?: InputMaybe<File_Bool_Exp>;
  cover_photo_id?: InputMaybe<Uuid_Comparison_Exp>;
  crosspost?: InputMaybe<Boolean_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  default_recruiter?: InputMaybe<Org_User_Bool_Exp>;
  default_recruiter_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  domain_signups?: InputMaybe<Boolean_Comparison_Exp>;
  domains?: InputMaybe<Org_Domain_Bool_Exp>;
  domains_aggregate?: InputMaybe<Org_Domain_Aggregate_Bool_Exp>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_posting_slots?: InputMaybe<Int_Comparison_Exp>;
  job_postings?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
  job_postings_aggregate?: InputMaybe<Organization_Job_Posting_Aggregate_Bool_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  logo?: InputMaybe<File_Bool_Exp>;
  logo_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  name_change?: InputMaybe<String_Comparison_Exp>;
  name_change_requested_at?: InputMaybe<Timestamp_Comparison_Exp>;
  name_change_requested_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  org_ratings?: InputMaybe<Org_Rating_Bool_Exp>;
  org_ratings_aggregate?: InputMaybe<Org_Rating_Aggregate_Bool_Exp>;
  org_users?: InputMaybe<Org_User_Bool_Exp>;
  org_users_aggregate?: InputMaybe<Org_User_Aggregate_Bool_Exp>;
  ownership_structure?: InputMaybe<Ownershipstructure_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  ranking_review?: InputMaybe<Int_Comparison_Exp>;
  reviews?: InputMaybe<Review_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Bool_Exp>;
  salary_reports?: InputMaybe<Salary_Report_Bool_Exp>;
  salary_reports_aggregate?: InputMaybe<Salary_Report_Aggregate_Bool_Exp>;
  salary_reports_fmt?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
  salary_reports_fmt_aggregate?: InputMaybe<Salary_Report_Fmt_Aggregate_Bool_Exp>;
  search_vec?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  subscription_active?: InputMaybe<Boolean_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "organization_bounds" */
export type Organization_Bounds = {
  __typename?: 'organization_bounds';
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  org: Maybe<Organization>;
  x_max: Maybe<Scalars['float8']>;
  x_min: Maybe<Scalars['float8']>;
  y_max: Maybe<Scalars['float8']>;
  y_min: Maybe<Scalars['float8']>;
};

/** aggregated selection of "organization_bounds" */
export type Organization_Bounds_Aggregate = {
  __typename?: 'organization_bounds_aggregate';
  aggregate: Maybe<Organization_Bounds_Aggregate_Fields>;
  nodes: Array<Organization_Bounds>;
};

/** aggregate fields of "organization_bounds" */
export type Organization_Bounds_Aggregate_Fields = {
  __typename?: 'organization_bounds_aggregate_fields';
  avg: Maybe<Organization_Bounds_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Organization_Bounds_Max_Fields>;
  min: Maybe<Organization_Bounds_Min_Fields>;
  stddev: Maybe<Organization_Bounds_Stddev_Fields>;
  stddev_pop: Maybe<Organization_Bounds_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Organization_Bounds_Stddev_Samp_Fields>;
  sum: Maybe<Organization_Bounds_Sum_Fields>;
  var_pop: Maybe<Organization_Bounds_Var_Pop_Fields>;
  var_samp: Maybe<Organization_Bounds_Var_Samp_Fields>;
  variance: Maybe<Organization_Bounds_Variance_Fields>;
};


/** aggregate fields of "organization_bounds" */
export type Organization_Bounds_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Bounds_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Organization_Bounds_Avg_Fields = {
  __typename?: 'organization_bounds_avg_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organization_bounds". All fields are combined with a logical 'AND'. */
export type Organization_Bounds_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bounds_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bounds_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bounds_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  x_max?: InputMaybe<Float8_Comparison_Exp>;
  x_min?: InputMaybe<Float8_Comparison_Exp>;
  y_max?: InputMaybe<Float8_Comparison_Exp>;
  y_min?: InputMaybe<Float8_Comparison_Exp>;
};

/** input type for inserting data into table "organization_bounds" */
export type Organization_Bounds_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Organization_Bounds_Max_Fields = {
  __typename?: 'organization_bounds_max_fields';
  id: Maybe<Scalars['uuid']>;
  x_max: Maybe<Scalars['float8']>;
  x_min: Maybe<Scalars['float8']>;
  y_max: Maybe<Scalars['float8']>;
  y_min: Maybe<Scalars['float8']>;
};

/** aggregate min on columns */
export type Organization_Bounds_Min_Fields = {
  __typename?: 'organization_bounds_min_fields';
  id: Maybe<Scalars['uuid']>;
  x_max: Maybe<Scalars['float8']>;
  x_min: Maybe<Scalars['float8']>;
  y_max: Maybe<Scalars['float8']>;
  y_min: Maybe<Scalars['float8']>;
};

/** input type for inserting object relation for remote table "organization_bounds" */
export type Organization_Bounds_Obj_Rel_Insert_Input = {
  data: Organization_Bounds_Insert_Input;
};

/** Ordering options when selecting data from "organization_bounds". */
export type Organization_Bounds_Order_By = {
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  x_max?: InputMaybe<Order_By>;
  x_min?: InputMaybe<Order_By>;
  y_max?: InputMaybe<Order_By>;
  y_min?: InputMaybe<Order_By>;
};

/** select columns of table "organization_bounds" */
export enum Organization_Bounds_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  XMax = 'x_max',
  /** column name */
  XMin = 'x_min',
  /** column name */
  YMax = 'y_max',
  /** column name */
  YMin = 'y_min'
}

/** aggregate stddev on columns */
export type Organization_Bounds_Stddev_Fields = {
  __typename?: 'organization_bounds_stddev_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organization_Bounds_Stddev_Pop_Fields = {
  __typename?: 'organization_bounds_stddev_pop_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organization_Bounds_Stddev_Samp_Fields = {
  __typename?: 'organization_bounds_stddev_samp_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organization_bounds" */
export type Organization_Bounds_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Bounds_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Bounds_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** aggregate sum on columns */
export type Organization_Bounds_Sum_Fields = {
  __typename?: 'organization_bounds_sum_fields';
  x_max: Maybe<Scalars['float8']>;
  x_min: Maybe<Scalars['float8']>;
  y_max: Maybe<Scalars['float8']>;
  y_min: Maybe<Scalars['float8']>;
};

/** aggregate var_pop on columns */
export type Organization_Bounds_Var_Pop_Fields = {
  __typename?: 'organization_bounds_var_pop_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organization_Bounds_Var_Samp_Fields = {
  __typename?: 'organization_bounds_var_samp_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organization_Bounds_Variance_Fields = {
  __typename?: 'organization_bounds_variance_fields';
  x_max: Maybe<Scalars['Float']>;
  x_min: Maybe<Scalars['Float']>;
  y_max: Maybe<Scalars['Float']>;
  y_min: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkOrganization = 'pk_organization',
  /** unique or primary key constraint on columns "cover_photo_id" */
  UqOrganizationCoverPhotoId = 'uq_organization_cover_photo_id',
  /** unique or primary key constraint on columns "customer_id" */
  UqOrganizationCustomerId = 'uq_organization_customer_id',
  /** unique or primary key constraint on columns "logo_id" */
  UqOrganizationLogoId = 'uq_organization_logo_id',
  /** unique or primary key constraint on columns "name" */
  UqOrganizationName = 'uq_organization_name'
}

/** input type for incrementing numeric columns in table "organization" */
export type Organization_Inc_Input = {
  job_posting_slots?: InputMaybe<Scalars['Int']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  acep_org_surveys?: InputMaybe<Acep_Org_Survey_Arr_Rel_Insert_Input>;
  active?: InputMaybe<Scalars['Boolean']>;
  billing_email?: InputMaybe<Scalars['String']>;
  bounds?: InputMaybe<Organization_Bounds_Obj_Rel_Insert_Input>;
  candidates?: InputMaybe<Candidate_Arr_Rel_Insert_Input>;
  checkout_bank_hold?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  contracts?: InputMaybe<Facility_Contract_Arr_Rel_Insert_Input>;
  cover_photo?: InputMaybe<File_Obj_Rel_Insert_Input>;
  cover_photo_id?: InputMaybe<Scalars['uuid']>;
  crosspost?: InputMaybe<Scalars['Boolean']>;
  customer_id?: InputMaybe<Scalars['String']>;
  default_recruiter?: InputMaybe<Org_User_Obj_Rel_Insert_Input>;
  default_recruiter_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  domain_signups?: InputMaybe<Scalars['Boolean']>;
  domains?: InputMaybe<Org_Domain_Arr_Rel_Insert_Input>;
  ext_postings?: InputMaybe<Ext_Job_Posting_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  job_posting_slots?: InputMaybe<Scalars['Int']>;
  job_postings?: InputMaybe<Organization_Job_Posting_Arr_Rel_Insert_Input>;
  location?: InputMaybe<Scalars['geography']>;
  logo?: InputMaybe<File_Obj_Rel_Insert_Input>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  name_change?: InputMaybe<Scalars['String']>;
  name_change_requested_at?: InputMaybe<Scalars['timestamp']>;
  name_change_requested_by_id?: InputMaybe<Scalars['uuid']>;
  org_ratings?: InputMaybe<Org_Rating_Arr_Rel_Insert_Input>;
  org_users?: InputMaybe<Org_User_Arr_Rel_Insert_Input>;
  ownership_structure?: InputMaybe<Scalars['ownershipstructure']>;
  phone?: InputMaybe<Scalars['String']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
  reviews?: InputMaybe<Review_Arr_Rel_Insert_Input>;
  salary_reports?: InputMaybe<Salary_Report_Arr_Rel_Insert_Input>;
  salary_reports_fmt?: InputMaybe<Salary_Report_Fmt_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  subscription_active?: InputMaybe<Scalars['Boolean']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "organization_job_posting" */
export type Organization_Job_Posting = {
  __typename?: 'organization_job_posting';
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  job_posting: Maybe<Job_Posting>;
  /** An object relationship */
  org: Maybe<Organization>;
  org_id: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "organization_job_posting" */
export type Organization_Job_Posting_Aggregate = {
  __typename?: 'organization_job_posting_aggregate';
  aggregate: Maybe<Organization_Job_Posting_Aggregate_Fields>;
  nodes: Array<Organization_Job_Posting>;
};

export type Organization_Job_Posting_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Job_Posting_Aggregate_Bool_Exp_Count>;
};

export type Organization_Job_Posting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_job_posting" */
export type Organization_Job_Posting_Aggregate_Fields = {
  __typename?: 'organization_job_posting_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Organization_Job_Posting_Max_Fields>;
  min: Maybe<Organization_Job_Posting_Min_Fields>;
};


/** aggregate fields of "organization_job_posting" */
export type Organization_Job_Posting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_job_posting" */
export type Organization_Job_Posting_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Job_Posting_Max_Order_By>;
  min?: InputMaybe<Organization_Job_Posting_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_job_posting" */
export type Organization_Job_Posting_Arr_Rel_Insert_Input = {
  data: Array<Organization_Job_Posting_Insert_Input>;
};

/** Boolean expression to filter rows from the table "organization_job_posting". All fields are combined with a logical 'AND'. */
export type Organization_Job_Posting_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Job_Posting_Bool_Exp>>;
  _not?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Job_Posting_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_posting?: InputMaybe<Job_Posting_Bool_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for inserting data into table "organization_job_posting" */
export type Organization_Job_Posting_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  job_posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Organization_Job_Posting_Max_Fields = {
  __typename?: 'organization_job_posting_max_fields';
  id: Maybe<Scalars['uuid']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "organization_job_posting" */
export type Organization_Job_Posting_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Job_Posting_Min_Fields = {
  __typename?: 'organization_job_posting_min_fields';
  id: Maybe<Scalars['uuid']>;
  org_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "organization_job_posting" */
export type Organization_Job_Posting_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "organization_job_posting". */
export type Organization_Job_Posting_Order_By = {
  id?: InputMaybe<Order_By>;
  job_posting?: InputMaybe<Job_Posting_Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  org_id?: InputMaybe<Order_By>;
};

/** select columns of table "organization_job_posting" */
export enum Organization_Job_Posting_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id'
}

/** Streaming cursor of the table "organization_job_posting" */
export type Organization_Job_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Job_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Job_Posting_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  billing_email: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  cover_photo_id: Maybe<Scalars['uuid']>;
  customer_id: Maybe<Scalars['String']>;
  default_recruiter_id: Maybe<Scalars['uuid']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  job_posting_slots: Maybe<Scalars['Int']>;
  logo_id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  name_change: Maybe<Scalars['String']>;
  name_change_requested_at: Maybe<Scalars['timestamp']>;
  name_change_requested_by_id: Maybe<Scalars['uuid']>;
  ownership_structure: Maybe<Scalars['ownershipstructure']>;
  phone: Maybe<Scalars['String']>;
  ranking_review: Maybe<Scalars['Int']>;
  slug: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "organization" */
export type Organization_Max_Order_By = {
  billing_email?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cover_photo_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  default_recruiter_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_posting_slots?: InputMaybe<Order_By>;
  logo_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_change?: InputMaybe<Order_By>;
  name_change_requested_at?: InputMaybe<Order_By>;
  name_change_requested_by_id?: InputMaybe<Order_By>;
  ownership_structure?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  billing_email: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  cover_photo_id: Maybe<Scalars['uuid']>;
  customer_id: Maybe<Scalars['String']>;
  default_recruiter_id: Maybe<Scalars['uuid']>;
  description: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  job_posting_slots: Maybe<Scalars['Int']>;
  logo_id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  name_change: Maybe<Scalars['String']>;
  name_change_requested_at: Maybe<Scalars['timestamp']>;
  name_change_requested_by_id: Maybe<Scalars['uuid']>;
  ownership_structure: Maybe<Scalars['ownershipstructure']>;
  phone: Maybe<Scalars['String']>;
  ranking_review: Maybe<Scalars['Int']>;
  slug: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "organization" */
export type Organization_Min_Order_By = {
  billing_email?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cover_photo_id?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  default_recruiter_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_posting_slots?: InputMaybe<Order_By>;
  logo_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_change?: InputMaybe<Order_By>;
  name_change_requested_at?: InputMaybe<Order_By>;
  name_change_requested_by_id?: InputMaybe<Order_By>;
  ownership_structure?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  acep_org_surveys_aggregate?: InputMaybe<Acep_Org_Survey_Aggregate_Order_By>;
  active?: InputMaybe<Order_By>;
  billing_email?: InputMaybe<Order_By>;
  bounds?: InputMaybe<Organization_Bounds_Order_By>;
  candidates_aggregate?: InputMaybe<Candidate_Aggregate_Order_By>;
  checkout_bank_hold?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contracts_aggregate?: InputMaybe<Facility_Contract_Aggregate_Order_By>;
  cover_photo?: InputMaybe<File_Order_By>;
  cover_photo_id?: InputMaybe<Order_By>;
  crosspost?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  default_recruiter?: InputMaybe<Org_User_Order_By>;
  default_recruiter_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  domain_signups?: InputMaybe<Order_By>;
  domains_aggregate?: InputMaybe<Org_Domain_Aggregate_Order_By>;
  ext_postings_aggregate?: InputMaybe<Ext_Job_Posting_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  job_posting_slots?: InputMaybe<Order_By>;
  job_postings_aggregate?: InputMaybe<Organization_Job_Posting_Aggregate_Order_By>;
  location?: InputMaybe<Order_By>;
  logo?: InputMaybe<File_Order_By>;
  logo_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  name_change?: InputMaybe<Order_By>;
  name_change_requested_at?: InputMaybe<Order_By>;
  name_change_requested_by_id?: InputMaybe<Order_By>;
  org_ratings_aggregate?: InputMaybe<Org_Rating_Aggregate_Order_By>;
  org_users_aggregate?: InputMaybe<Org_User_Aggregate_Order_By>;
  ownership_structure?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Order_By>;
  salary_reports_aggregate?: InputMaybe<Salary_Report_Aggregate_Order_By>;
  salary_reports_fmt_aggregate?: InputMaybe<Salary_Report_Fmt_Aggregate_Order_By>;
  search_vec?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  subscription_active?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization" */
export enum Organization_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  BillingEmail = 'billing_email',
  /** column name */
  CheckoutBankHold = 'checkout_bank_hold',
  /** column name */
  City = 'city',
  /** column name */
  CoverPhotoId = 'cover_photo_id',
  /** column name */
  Crosspost = 'crosspost',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DefaultRecruiterId = 'default_recruiter_id',
  /** column name */
  Description = 'description',
  /** column name */
  DomainSignups = 'domain_signups',
  /** column name */
  Id = 'id',
  /** column name */
  JobPostingSlots = 'job_posting_slots',
  /** column name */
  Location = 'location',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NameChange = 'name_change',
  /** column name */
  NameChangeRequestedAt = 'name_change_requested_at',
  /** column name */
  NameChangeRequestedById = 'name_change_requested_by_id',
  /** column name */
  OwnershipStructure = 'ownership_structure',
  /** column name */
  Phone = 'phone',
  /** column name */
  RankingReview = 'ranking_review',
  /** column name */
  SearchVec = 'search_vec',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  SubscriptionActive = 'subscription_active',
  /** column name */
  Verified = 'verified',
  /** column name */
  Website = 'website',
  /** column name */
  Zipcode = 'zipcode'
}

/** select "organization_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CheckoutBankHold = 'checkout_bank_hold',
  /** column name */
  Crosspost = 'crosspost',
  /** column name */
  DomainSignups = 'domain_signups',
  /** column name */
  SubscriptionActive = 'subscription_active',
  /** column name */
  Verified = 'verified'
}

/** select "organization_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CheckoutBankHold = 'checkout_bank_hold',
  /** column name */
  Crosspost = 'crosspost',
  /** column name */
  DomainSignups = 'domain_signups',
  /** column name */
  SubscriptionActive = 'subscription_active',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  billing_email?: InputMaybe<Scalars['String']>;
  checkout_bank_hold?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  cover_photo_id?: InputMaybe<Scalars['uuid']>;
  crosspost?: InputMaybe<Scalars['Boolean']>;
  customer_id?: InputMaybe<Scalars['String']>;
  default_recruiter_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  domain_signups?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_posting_slots?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['geography']>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  name_change?: InputMaybe<Scalars['String']>;
  name_change_requested_at?: InputMaybe<Scalars['timestamp']>;
  name_change_requested_by_id?: InputMaybe<Scalars['uuid']>;
  ownership_structure?: InputMaybe<Scalars['ownershipstructure']>;
  phone?: InputMaybe<Scalars['String']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  subscription_active?: InputMaybe<Scalars['Boolean']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Organization_Stddev_Fields = {
  __typename?: 'organization_stddev_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organization" */
export type Organization_Stddev_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Stddev_Pop_Fields = {
  __typename?: 'organization_stddev_pop_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organization" */
export type Organization_Stddev_Pop_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Stddev_Samp_Fields = {
  __typename?: 'organization_stddev_samp_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organization" */
export type Organization_Stddev_Samp_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  billing_email?: InputMaybe<Scalars['String']>;
  checkout_bank_hold?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  cover_photo_id?: InputMaybe<Scalars['uuid']>;
  crosspost?: InputMaybe<Scalars['Boolean']>;
  customer_id?: InputMaybe<Scalars['String']>;
  default_recruiter_id?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  domain_signups?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_posting_slots?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['geography']>;
  logo_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  name_change?: InputMaybe<Scalars['String']>;
  name_change_requested_at?: InputMaybe<Scalars['timestamp']>;
  name_change_requested_by_id?: InputMaybe<Scalars['uuid']>;
  ownership_structure?: InputMaybe<Scalars['ownershipstructure']>;
  phone?: InputMaybe<Scalars['String']>;
  ranking_review?: InputMaybe<Scalars['Int']>;
  search_vec?: InputMaybe<Scalars['tsvector']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  subscription_active?: InputMaybe<Scalars['Boolean']>;
  verified?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Organization_Sum_Fields = {
  __typename?: 'organization_sum_fields';
  job_posting_slots: Maybe<Scalars['Int']>;
  ranking_review: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organization" */
export type Organization_Sum_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** update columns of table "organization" */
export enum Organization_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  BillingEmail = 'billing_email',
  /** column name */
  CheckoutBankHold = 'checkout_bank_hold',
  /** column name */
  City = 'city',
  /** column name */
  CoverPhotoId = 'cover_photo_id',
  /** column name */
  Crosspost = 'crosspost',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DefaultRecruiterId = 'default_recruiter_id',
  /** column name */
  Description = 'description',
  /** column name */
  DomainSignups = 'domain_signups',
  /** column name */
  Id = 'id',
  /** column name */
  JobPostingSlots = 'job_posting_slots',
  /** column name */
  Location = 'location',
  /** column name */
  LogoId = 'logo_id',
  /** column name */
  Name = 'name',
  /** column name */
  NameChange = 'name_change',
  /** column name */
  NameChangeRequestedAt = 'name_change_requested_at',
  /** column name */
  NameChangeRequestedById = 'name_change_requested_by_id',
  /** column name */
  OwnershipStructure = 'ownership_structure',
  /** column name */
  Phone = 'phone',
  /** column name */
  RankingReview = 'ranking_review',
  /** column name */
  State = 'state',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  SubscriptionActive = 'subscription_active',
  /** column name */
  Verified = 'verified',
  /** column name */
  Website = 'website',
  /** column name */
  Zipcode = 'zipcode'
}

export type Organization_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Var_Pop_Fields = {
  __typename?: 'organization_var_pop_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organization" */
export type Organization_Var_Pop_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Var_Samp_Fields = {
  __typename?: 'organization_var_samp_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organization" */
export type Organization_Var_Samp_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Variance_Fields = {
  __typename?: 'organization_variance_fields';
  job_posting_slots: Maybe<Scalars['Float']>;
  ranking_review: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organization" */
export type Organization_Variance_Order_By = {
  job_posting_slots?: InputMaybe<Order_By>;
  ranking_review?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "ownershipstructure". All fields are combined with logical 'AND'. */
export type Ownershipstructure_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['ownershipstructure']>;
  _gt?: InputMaybe<Scalars['ownershipstructure']>;
  _gte?: InputMaybe<Scalars['ownershipstructure']>;
  _in?: InputMaybe<Array<Scalars['ownershipstructure']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ownershipstructure']>;
  _lte?: InputMaybe<Scalars['ownershipstructure']>;
  _neq?: InputMaybe<Scalars['ownershipstructure']>;
  _nin?: InputMaybe<Array<Scalars['ownershipstructure']>>;
};

/** Boolean expression to compare columns of type "paymentrateperiod". All fields are combined with logical 'AND'. */
export type Paymentrateperiod_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['paymentrateperiod']>;
  _gt?: InputMaybe<Scalars['paymentrateperiod']>;
  _gte?: InputMaybe<Scalars['paymentrateperiod']>;
  _in?: InputMaybe<Array<Scalars['paymentrateperiod']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['paymentrateperiod']>;
  _lte?: InputMaybe<Scalars['paymentrateperiod']>;
  _neq?: InputMaybe<Scalars['paymentrateperiod']>;
  _nin?: InputMaybe<Array<Scalars['paymentrateperiod']>>;
};

/** columns and relationships of "personal_info" */
export type Personal_Info = {
  __typename?: 'personal_info';
  /** An object relationship */
  account: Maybe<Account>;
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  last_name: Maybe<Scalars['String']>;
};

/** aggregated selection of "personal_info" */
export type Personal_Info_Aggregate = {
  __typename?: 'personal_info_aggregate';
  aggregate: Maybe<Personal_Info_Aggregate_Fields>;
  nodes: Array<Personal_Info>;
};

/** aggregate fields of "personal_info" */
export type Personal_Info_Aggregate_Fields = {
  __typename?: 'personal_info_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Personal_Info_Max_Fields>;
  min: Maybe<Personal_Info_Min_Fields>;
};


/** aggregate fields of "personal_info" */
export type Personal_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Personal_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "personal_info". All fields are combined with a logical 'AND'. */
export type Personal_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Personal_Info_Bool_Exp>>;
  _not?: InputMaybe<Personal_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Personal_Info_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "personal_info" */
export type Personal_Info_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Personal_Info_Max_Fields = {
  __typename?: 'personal_info_max_fields';
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  last_name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Personal_Info_Min_Fields = {
  __typename?: 'personal_info_min_fields';
  first_name: Maybe<Scalars['String']>;
  full_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  last_name: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "personal_info" */
export type Personal_Info_Mutation_Response = {
  __typename?: 'personal_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Personal_Info>;
};

/** input type for inserting object relation for remote table "personal_info" */
export type Personal_Info_Obj_Rel_Insert_Input = {
  data: Personal_Info_Insert_Input;
};

/** Ordering options when selecting data from "personal_info". */
export type Personal_Info_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
};

/** select columns of table "personal_info" */
export enum Personal_Info_Select_Column {
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name'
}

/** input type for updating data in table "personal_info" */
export type Personal_Info_Set_Input = {
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "personal_info" */
export type Personal_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Personal_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Personal_Info_Stream_Cursor_Value_Input = {
  first_name?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
};

export type Personal_Info_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Personal_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: Personal_Info_Bool_Exp;
};

/** columns and relationships of "place_boundary" */
export type Place_Boundary = {
  __typename?: 'place_boundary';
  boundary: Scalars['geometry'];
  /** A computed field, executes function "place_boundary_boundary_geojson" */
  boundary_geojson: Maybe<Scalars['String']>;
  /** An object relationship */
  gmaps_place: Maybe<Gmaps_Place>;
  gmaps_place_id: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  impressions: Maybe<Bqanalytics_Facility_Map_State_Impressions_90>;
  name: Scalars['String'];
  precision: Scalars['placeboundaryprecision'];
  type: Scalars['placeboundarytype'];
};

/** aggregated selection of "place_boundary" */
export type Place_Boundary_Aggregate = {
  __typename?: 'place_boundary_aggregate';
  aggregate: Maybe<Place_Boundary_Aggregate_Fields>;
  nodes: Array<Place_Boundary>;
};

export type Place_Boundary_Aggregate_Bool_Exp = {
  count?: InputMaybe<Place_Boundary_Aggregate_Bool_Exp_Count>;
};

export type Place_Boundary_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Place_Boundary_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "place_boundary" */
export type Place_Boundary_Aggregate_Fields = {
  __typename?: 'place_boundary_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Place_Boundary_Max_Fields>;
  min: Maybe<Place_Boundary_Min_Fields>;
};


/** aggregate fields of "place_boundary" */
export type Place_Boundary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "place_boundary" */
export type Place_Boundary_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Place_Boundary_Max_Order_By>;
  min?: InputMaybe<Place_Boundary_Min_Order_By>;
};

/** input type for inserting array relation for remote table "place_boundary" */
export type Place_Boundary_Arr_Rel_Insert_Input = {
  data: Array<Place_Boundary_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Place_Boundary_On_Conflict>;
};

/** Boolean expression to filter rows from the table "place_boundary". All fields are combined with a logical 'AND'. */
export type Place_Boundary_Bool_Exp = {
  _and?: InputMaybe<Array<Place_Boundary_Bool_Exp>>;
  _not?: InputMaybe<Place_Boundary_Bool_Exp>;
  _or?: InputMaybe<Array<Place_Boundary_Bool_Exp>>;
  boundary?: InputMaybe<Geometry_Comparison_Exp>;
  boundary_geojson?: InputMaybe<String_Comparison_Exp>;
  gmaps_place?: InputMaybe<Gmaps_Place_Bool_Exp>;
  gmaps_place_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  precision?: InputMaybe<Placeboundaryprecision_Comparison_Exp>;
  type?: InputMaybe<Placeboundarytype_Comparison_Exp>;
};

/** unique or primary key constraints on table "place_boundary" */
export enum Place_Boundary_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPlaceBoundary = 'pk_place_boundary',
  /** unique or primary key constraint on columns "precision", "type", "name" */
  UqPlaceBoundaryNameTypePrecision = 'uq_place_boundary_name_type_precision'
}

/** input type for inserting data into table "place_boundary" */
export type Place_Boundary_Insert_Input = {
  boundary?: InputMaybe<Scalars['geometry']>;
  gmaps_place?: InputMaybe<Gmaps_Place_Obj_Rel_Insert_Input>;
  gmaps_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['placeboundaryprecision']>;
  type?: InputMaybe<Scalars['placeboundarytype']>;
};

/** aggregate max on columns */
export type Place_Boundary_Max_Fields = {
  __typename?: 'place_boundary_max_fields';
  /** A computed field, executes function "place_boundary_boundary_geojson" */
  boundary_geojson: Maybe<Scalars['String']>;
  gmaps_place_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  precision: Maybe<Scalars['placeboundaryprecision']>;
  type: Maybe<Scalars['placeboundarytype']>;
};

/** order by max() on columns of table "place_boundary" */
export type Place_Boundary_Max_Order_By = {
  gmaps_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Place_Boundary_Min_Fields = {
  __typename?: 'place_boundary_min_fields';
  /** A computed field, executes function "place_boundary_boundary_geojson" */
  boundary_geojson: Maybe<Scalars['String']>;
  gmaps_place_id: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  precision: Maybe<Scalars['placeboundaryprecision']>;
  type: Maybe<Scalars['placeboundarytype']>;
};

/** order by min() on columns of table "place_boundary" */
export type Place_Boundary_Min_Order_By = {
  gmaps_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "place_boundary" */
export type Place_Boundary_Mutation_Response = {
  __typename?: 'place_boundary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Place_Boundary>;
};

/** on_conflict condition type for table "place_boundary" */
export type Place_Boundary_On_Conflict = {
  constraint: Place_Boundary_Constraint;
  update_columns?: Array<Place_Boundary_Update_Column>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};

/** Ordering options when selecting data from "place_boundary". */
export type Place_Boundary_Order_By = {
  boundary?: InputMaybe<Order_By>;
  boundary_geojson?: InputMaybe<Order_By>;
  gmaps_place?: InputMaybe<Gmaps_Place_Order_By>;
  gmaps_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  precision?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: place_boundary */
export type Place_Boundary_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "place_boundary" */
export enum Place_Boundary_Select_Column {
  /** column name */
  Boundary = 'boundary',
  /** column name */
  GmapsPlaceId = 'gmaps_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Precision = 'precision',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "place_boundary" */
export type Place_Boundary_Set_Input = {
  boundary?: InputMaybe<Scalars['geometry']>;
  gmaps_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['placeboundaryprecision']>;
  type?: InputMaybe<Scalars['placeboundarytype']>;
};

/** Streaming cursor of the table "place_boundary" */
export type Place_Boundary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Place_Boundary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Place_Boundary_Stream_Cursor_Value_Input = {
  boundary?: InputMaybe<Scalars['geometry']>;
  gmaps_place_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['placeboundaryprecision']>;
  type?: InputMaybe<Scalars['placeboundarytype']>;
};

/** update columns of table "place_boundary" */
export enum Place_Boundary_Update_Column {
  /** column name */
  Boundary = 'boundary',
  /** column name */
  GmapsPlaceId = 'gmaps_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Precision = 'precision',
  /** column name */
  Type = 'type'
}

export type Place_Boundary_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Place_Boundary_Set_Input>;
  /** filter the rows which have to be updated */
  where: Place_Boundary_Bool_Exp;
};

/** Boolean expression to compare columns of type "placeboundaryprecision". All fields are combined with logical 'AND'. */
export type Placeboundaryprecision_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['placeboundaryprecision']>;
  _gt?: InputMaybe<Scalars['placeboundaryprecision']>;
  _gte?: InputMaybe<Scalars['placeboundaryprecision']>;
  _in?: InputMaybe<Array<Scalars['placeboundaryprecision']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['placeboundaryprecision']>;
  _lte?: InputMaybe<Scalars['placeboundaryprecision']>;
  _neq?: InputMaybe<Scalars['placeboundaryprecision']>;
  _nin?: InputMaybe<Array<Scalars['placeboundaryprecision']>>;
};

/** Boolean expression to compare columns of type "placeboundarytype". All fields are combined with logical 'AND'. */
export type Placeboundarytype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['placeboundarytype']>;
  _gt?: InputMaybe<Scalars['placeboundarytype']>;
  _gte?: InputMaybe<Scalars['placeboundarytype']>;
  _in?: InputMaybe<Array<Scalars['placeboundarytype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['placeboundarytype']>;
  _lte?: InputMaybe<Scalars['placeboundarytype']>;
  _neq?: InputMaybe<Scalars['placeboundarytype']>;
  _nin?: InputMaybe<Array<Scalars['placeboundarytype']>>;
};

/** Boolean expression to compare columns of type "platform". All fields are combined with logical 'AND'. */
export type Platform_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['platform']>;
  _gt?: InputMaybe<Scalars['platform']>;
  _gte?: InputMaybe<Scalars['platform']>;
  _in?: InputMaybe<Array<Scalars['platform']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['platform']>;
  _lte?: InputMaybe<Scalars['platform']>;
  _neq?: InputMaybe<Scalars['platform']>;
  _nin?: InputMaybe<Array<Scalars['platform']>>;
};

/** columns and relationships of "posting_app_cert" */
export type Posting_App_Cert = {
  __typename?: 'posting_app_cert';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  posting: Job_Posting;
  posting_id: Scalars['uuid'];
};

/** aggregated selection of "posting_app_cert" */
export type Posting_App_Cert_Aggregate = {
  __typename?: 'posting_app_cert_aggregate';
  aggregate: Maybe<Posting_App_Cert_Aggregate_Fields>;
  nodes: Array<Posting_App_Cert>;
};

export type Posting_App_Cert_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posting_App_Cert_Aggregate_Bool_Exp_Count>;
};

export type Posting_App_Cert_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Posting_App_Cert_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_app_cert" */
export type Posting_App_Cert_Aggregate_Fields = {
  __typename?: 'posting_app_cert_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Posting_App_Cert_Max_Fields>;
  min: Maybe<Posting_App_Cert_Min_Fields>;
};


/** aggregate fields of "posting_app_cert" */
export type Posting_App_Cert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_app_cert" */
export type Posting_App_Cert_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posting_App_Cert_Max_Order_By>;
  min?: InputMaybe<Posting_App_Cert_Min_Order_By>;
};

/** input type for inserting array relation for remote table "posting_app_cert" */
export type Posting_App_Cert_Arr_Rel_Insert_Input = {
  data: Array<Posting_App_Cert_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posting_App_Cert_On_Conflict>;
};

/** Boolean expression to filter rows from the table "posting_app_cert". All fields are combined with a logical 'AND'. */
export type Posting_App_Cert_Bool_Exp = {
  _and?: InputMaybe<Array<Posting_App_Cert_Bool_Exp>>;
  _not?: InputMaybe<Posting_App_Cert_Bool_Exp>;
  _or?: InputMaybe<Array<Posting_App_Cert_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_app_cert" */
export enum Posting_App_Cert_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPostingAppCert = 'pk_posting_app_cert',
  /** unique or primary key constraint on columns "posting_id", "name" */
  UqPostingAppCertPostingIdName = 'uq_posting_app_cert_posting_id_name'
}

/** input type for inserting data into table "posting_app_cert" */
export type Posting_App_Cert_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Posting_App_Cert_Max_Fields = {
  __typename?: 'posting_app_cert_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  posting_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "posting_app_cert" */
export type Posting_App_Cert_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_App_Cert_Min_Fields = {
  __typename?: 'posting_app_cert_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  posting_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "posting_app_cert" */
export type Posting_App_Cert_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posting_app_cert" */
export type Posting_App_Cert_Mutation_Response = {
  __typename?: 'posting_app_cert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_App_Cert>;
};

/** on_conflict condition type for table "posting_app_cert" */
export type Posting_App_Cert_On_Conflict = {
  constraint: Posting_App_Cert_Constraint;
  update_columns?: Array<Posting_App_Cert_Update_Column>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_app_cert". */
export type Posting_App_Cert_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  posting?: InputMaybe<Job_Posting_Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posting_app_cert */
export type Posting_App_Cert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_app_cert" */
export enum Posting_App_Cert_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostingId = 'posting_id'
}

/** input type for updating data in table "posting_app_cert" */
export type Posting_App_Cert_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "posting_app_cert" */
export type Posting_App_Cert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_App_Cert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_App_Cert_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "posting_app_cert" */
export enum Posting_App_Cert_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostingId = 'posting_id'
}

export type Posting_App_Cert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posting_App_Cert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_App_Cert_Bool_Exp;
};

/** columns and relationships of "posting_board_cert" */
export type Posting_Board_Cert = {
  __typename?: 'posting_board_cert';
  /** An object relationship */
  cert: Board_Cert;
  cert_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Job_Posting;
  posting_id: Scalars['uuid'];
};

/** aggregated selection of "posting_board_cert" */
export type Posting_Board_Cert_Aggregate = {
  __typename?: 'posting_board_cert_aggregate';
  aggregate: Maybe<Posting_Board_Cert_Aggregate_Fields>;
  nodes: Array<Posting_Board_Cert>;
};

export type Posting_Board_Cert_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posting_Board_Cert_Aggregate_Bool_Exp_Count>;
};

export type Posting_Board_Cert_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_board_cert" */
export type Posting_Board_Cert_Aggregate_Fields = {
  __typename?: 'posting_board_cert_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Posting_Board_Cert_Max_Fields>;
  min: Maybe<Posting_Board_Cert_Min_Fields>;
};


/** aggregate fields of "posting_board_cert" */
export type Posting_Board_Cert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_board_cert" */
export type Posting_Board_Cert_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posting_Board_Cert_Max_Order_By>;
  min?: InputMaybe<Posting_Board_Cert_Min_Order_By>;
};

/** input type for inserting array relation for remote table "posting_board_cert" */
export type Posting_Board_Cert_Arr_Rel_Insert_Input = {
  data: Array<Posting_Board_Cert_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posting_Board_Cert_On_Conflict>;
};

/** Boolean expression to filter rows from the table "posting_board_cert". All fields are combined with a logical 'AND'. */
export type Posting_Board_Cert_Bool_Exp = {
  _and?: InputMaybe<Array<Posting_Board_Cert_Bool_Exp>>;
  _not?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
  _or?: InputMaybe<Array<Posting_Board_Cert_Bool_Exp>>;
  cert?: InputMaybe<Board_Cert_Bool_Exp>;
  cert_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_board_cert" */
export enum Posting_Board_Cert_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPostingBoardCert = 'pk_posting_board_cert',
  /** unique or primary key constraint on columns "cert_id", "posting_id" */
  UqPostingBoardCertPostingIdCertId = 'uq_posting_board_cert_posting_id_cert_id'
}

/** input type for inserting data into table "posting_board_cert" */
export type Posting_Board_Cert_Insert_Input = {
  cert?: InputMaybe<Board_Cert_Obj_Rel_Insert_Input>;
  cert_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Posting_Board_Cert_Max_Fields = {
  __typename?: 'posting_board_cert_max_fields';
  cert_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "posting_board_cert" */
export type Posting_Board_Cert_Max_Order_By = {
  cert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Board_Cert_Min_Fields = {
  __typename?: 'posting_board_cert_min_fields';
  cert_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "posting_board_cert" */
export type Posting_Board_Cert_Min_Order_By = {
  cert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posting_board_cert" */
export type Posting_Board_Cert_Mutation_Response = {
  __typename?: 'posting_board_cert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_Board_Cert>;
};

/** on_conflict condition type for table "posting_board_cert" */
export type Posting_Board_Cert_On_Conflict = {
  constraint: Posting_Board_Cert_Constraint;
  update_columns?: Array<Posting_Board_Cert_Update_Column>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_board_cert". */
export type Posting_Board_Cert_Order_By = {
  cert?: InputMaybe<Board_Cert_Order_By>;
  cert_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  posting?: InputMaybe<Job_Posting_Order_By>;
  posting_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posting_board_cert */
export type Posting_Board_Cert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_board_cert" */
export enum Posting_Board_Cert_Select_Column {
  /** column name */
  CertId = 'cert_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id'
}

/** input type for updating data in table "posting_board_cert" */
export type Posting_Board_Cert_Set_Input = {
  cert_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "posting_board_cert" */
export type Posting_Board_Cert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Board_Cert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Board_Cert_Stream_Cursor_Value_Input = {
  cert_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "posting_board_cert" */
export enum Posting_Board_Cert_Update_Column {
  /** column name */
  CertId = 'cert_id',
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id'
}

export type Posting_Board_Cert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posting_Board_Cert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Board_Cert_Bool_Exp;
};

/** columns and relationships of "posting_latest_publication" */
export type Posting_Latest_Publication = {
  __typename?: 'posting_latest_publication';
  /** An object relationship */
  posting: Maybe<Job_Posting>;
  posting_id: Maybe<Scalars['uuid']>;
  published_at: Maybe<Scalars['timestamp']>;
  unpublished_at: Maybe<Scalars['timestamp']>;
};

/** aggregated selection of "posting_latest_publication" */
export type Posting_Latest_Publication_Aggregate = {
  __typename?: 'posting_latest_publication_aggregate';
  aggregate: Maybe<Posting_Latest_Publication_Aggregate_Fields>;
  nodes: Array<Posting_Latest_Publication>;
};

/** aggregate fields of "posting_latest_publication" */
export type Posting_Latest_Publication_Aggregate_Fields = {
  __typename?: 'posting_latest_publication_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Posting_Latest_Publication_Max_Fields>;
  min: Maybe<Posting_Latest_Publication_Min_Fields>;
};


/** aggregate fields of "posting_latest_publication" */
export type Posting_Latest_Publication_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posting_Latest_Publication_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "posting_latest_publication". All fields are combined with a logical 'AND'. */
export type Posting_Latest_Publication_Bool_Exp = {
  _and?: InputMaybe<Array<Posting_Latest_Publication_Bool_Exp>>;
  _not?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
  _or?: InputMaybe<Array<Posting_Latest_Publication_Bool_Exp>>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  published_at?: InputMaybe<Timestamp_Comparison_Exp>;
  unpublished_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** input type for inserting data into table "posting_latest_publication" */
export type Posting_Latest_Publication_Insert_Input = {
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  published_at?: InputMaybe<Scalars['timestamp']>;
  unpublished_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Posting_Latest_Publication_Max_Fields = {
  __typename?: 'posting_latest_publication_max_fields';
  posting_id: Maybe<Scalars['uuid']>;
  published_at: Maybe<Scalars['timestamp']>;
  unpublished_at: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Posting_Latest_Publication_Min_Fields = {
  __typename?: 'posting_latest_publication_min_fields';
  posting_id: Maybe<Scalars['uuid']>;
  published_at: Maybe<Scalars['timestamp']>;
  unpublished_at: Maybe<Scalars['timestamp']>;
};

/** input type for inserting object relation for remote table "posting_latest_publication" */
export type Posting_Latest_Publication_Obj_Rel_Insert_Input = {
  data: Posting_Latest_Publication_Insert_Input;
};

/** Ordering options when selecting data from "posting_latest_publication". */
export type Posting_Latest_Publication_Order_By = {
  posting?: InputMaybe<Job_Posting_Order_By>;
  posting_id?: InputMaybe<Order_By>;
  published_at?: InputMaybe<Order_By>;
  unpublished_at?: InputMaybe<Order_By>;
};

/** select columns of table "posting_latest_publication" */
export enum Posting_Latest_Publication_Select_Column {
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  PublishedAt = 'published_at',
  /** column name */
  UnpublishedAt = 'unpublished_at'
}

/** Streaming cursor of the table "posting_latest_publication" */
export type Posting_Latest_Publication_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Latest_Publication_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Latest_Publication_Stream_Cursor_Value_Input = {
  posting_id?: InputMaybe<Scalars['uuid']>;
  published_at?: InputMaybe<Scalars['timestamp']>;
  unpublished_at?: InputMaybe<Scalars['timestamp']>;
};

/** columns and relationships of "posting_profession" */
export type Posting_Profession = {
  __typename?: 'posting_profession';
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Job_Posting;
  posting_id: Scalars['uuid'];
  profession: Scalars['profession'];
};

/** aggregated selection of "posting_profession" */
export type Posting_Profession_Aggregate = {
  __typename?: 'posting_profession_aggregate';
  aggregate: Maybe<Posting_Profession_Aggregate_Fields>;
  nodes: Array<Posting_Profession>;
};

export type Posting_Profession_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posting_Profession_Aggregate_Bool_Exp_Count>;
};

export type Posting_Profession_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Posting_Profession_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_profession" */
export type Posting_Profession_Aggregate_Fields = {
  __typename?: 'posting_profession_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Posting_Profession_Max_Fields>;
  min: Maybe<Posting_Profession_Min_Fields>;
};


/** aggregate fields of "posting_profession" */
export type Posting_Profession_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_profession" */
export type Posting_Profession_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posting_Profession_Max_Order_By>;
  min?: InputMaybe<Posting_Profession_Min_Order_By>;
};

/** input type for inserting array relation for remote table "posting_profession" */
export type Posting_Profession_Arr_Rel_Insert_Input = {
  data: Array<Posting_Profession_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posting_Profession_On_Conflict>;
};

/** Boolean expression to filter rows from the table "posting_profession". All fields are combined with a logical 'AND'. */
export type Posting_Profession_Bool_Exp = {
  _and?: InputMaybe<Array<Posting_Profession_Bool_Exp>>;
  _not?: InputMaybe<Posting_Profession_Bool_Exp>;
  _or?: InputMaybe<Array<Posting_Profession_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_profession" */
export enum Posting_Profession_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPostingProfession = 'pk_posting_profession',
  /** unique or primary key constraint on columns "profession", "posting_id" */
  UqPostingProfessionPostingIdProfession = 'uq_posting_profession_posting_id_profession'
}

/** input type for inserting data into table "posting_profession" */
export type Posting_Profession_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** aggregate max on columns */
export type Posting_Profession_Max_Fields = {
  __typename?: 'posting_profession_max_fields';
  id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
  profession: Maybe<Scalars['profession']>;
};

/** order by max() on columns of table "posting_profession" */
export type Posting_Profession_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Profession_Min_Fields = {
  __typename?: 'posting_profession_min_fields';
  id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
  profession: Maybe<Scalars['profession']>;
};

/** order by min() on columns of table "posting_profession" */
export type Posting_Profession_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posting_profession" */
export type Posting_Profession_Mutation_Response = {
  __typename?: 'posting_profession_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_Profession>;
};

/** on_conflict condition type for table "posting_profession" */
export type Posting_Profession_On_Conflict = {
  constraint: Posting_Profession_Constraint;
  update_columns?: Array<Posting_Profession_Update_Column>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_profession". */
export type Posting_Profession_Order_By = {
  id?: InputMaybe<Order_By>;
  posting?: InputMaybe<Job_Posting_Order_By>;
  posting_id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posting_profession */
export type Posting_Profession_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_profession" */
export enum Posting_Profession_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  Profession = 'profession'
}

/** input type for updating data in table "posting_profession" */
export type Posting_Profession_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** Streaming cursor of the table "posting_profession" */
export type Posting_Profession_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Profession_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Profession_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** update columns of table "posting_profession" */
export enum Posting_Profession_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  Profession = 'profession'
}

export type Posting_Profession_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posting_Profession_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Profession_Bool_Exp;
};

/** columns and relationships of "posting_worker_classification" */
export type Posting_Worker_Classification = {
  __typename?: 'posting_worker_classification';
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Maybe<Job_Posting>;
  posting_id: Scalars['uuid'];
  worker: Scalars['workerclassification'];
};

/** aggregated selection of "posting_worker_classification" */
export type Posting_Worker_Classification_Aggregate = {
  __typename?: 'posting_worker_classification_aggregate';
  aggregate: Maybe<Posting_Worker_Classification_Aggregate_Fields>;
  nodes: Array<Posting_Worker_Classification>;
};

export type Posting_Worker_Classification_Aggregate_Bool_Exp = {
  count?: InputMaybe<Posting_Worker_Classification_Aggregate_Bool_Exp_Count>;
};

export type Posting_Worker_Classification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "posting_worker_classification" */
export type Posting_Worker_Classification_Aggregate_Fields = {
  __typename?: 'posting_worker_classification_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Posting_Worker_Classification_Max_Fields>;
  min: Maybe<Posting_Worker_Classification_Min_Fields>;
};


/** aggregate fields of "posting_worker_classification" */
export type Posting_Worker_Classification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "posting_worker_classification" */
export type Posting_Worker_Classification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Posting_Worker_Classification_Max_Order_By>;
  min?: InputMaybe<Posting_Worker_Classification_Min_Order_By>;
};

/** input type for inserting array relation for remote table "posting_worker_classification" */
export type Posting_Worker_Classification_Arr_Rel_Insert_Input = {
  data: Array<Posting_Worker_Classification_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Posting_Worker_Classification_On_Conflict>;
};

/** Boolean expression to filter rows from the table "posting_worker_classification". All fields are combined with a logical 'AND'. */
export type Posting_Worker_Classification_Bool_Exp = {
  _and?: InputMaybe<Array<Posting_Worker_Classification_Bool_Exp>>;
  _not?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
  _or?: InputMaybe<Array<Posting_Worker_Classification_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
  posting_id?: InputMaybe<Uuid_Comparison_Exp>;
  worker?: InputMaybe<Workerclassification_Comparison_Exp>;
};

/** unique or primary key constraints on table "posting_worker_classification" */
export enum Posting_Worker_Classification_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkPostingWorkerClassification = 'pk_posting_worker_classification',
  /** unique or primary key constraint on columns "posting_id", "worker" */
  UqPostingWorkerClassificationPostingIdWorker = 'uq_posting_worker_classification_posting_id_worker'
}

/** input type for inserting data into table "posting_worker_classification" */
export type Posting_Worker_Classification_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate max on columns */
export type Posting_Worker_Classification_Max_Fields = {
  __typename?: 'posting_worker_classification_max_fields';
  id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** order by max() on columns of table "posting_worker_classification" */
export type Posting_Worker_Classification_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Posting_Worker_Classification_Min_Fields = {
  __typename?: 'posting_worker_classification_min_fields';
  id: Maybe<Scalars['uuid']>;
  posting_id: Maybe<Scalars['uuid']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** order by min() on columns of table "posting_worker_classification" */
export type Posting_Worker_Classification_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  posting_id?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "posting_worker_classification" */
export type Posting_Worker_Classification_Mutation_Response = {
  __typename?: 'posting_worker_classification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Posting_Worker_Classification>;
};

/** on_conflict condition type for table "posting_worker_classification" */
export type Posting_Worker_Classification_On_Conflict = {
  constraint: Posting_Worker_Classification_Constraint;
  update_columns?: Array<Posting_Worker_Classification_Update_Column>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};

/** Ordering options when selecting data from "posting_worker_classification". */
export type Posting_Worker_Classification_Order_By = {
  id?: InputMaybe<Order_By>;
  posting?: InputMaybe<Job_Posting_Order_By>;
  posting_id?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** primary key columns input for table: posting_worker_classification */
export type Posting_Worker_Classification_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "posting_worker_classification" */
export enum Posting_Worker_Classification_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  Worker = 'worker'
}

/** input type for updating data in table "posting_worker_classification" */
export type Posting_Worker_Classification_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** Streaming cursor of the table "posting_worker_classification" */
export type Posting_Worker_Classification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Posting_Worker_Classification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Posting_Worker_Classification_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  posting_id?: InputMaybe<Scalars['uuid']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** update columns of table "posting_worker_classification" */
export enum Posting_Worker_Classification_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  PostingId = 'posting_id',
  /** column name */
  Worker = 'worker'
}

export type Posting_Worker_Classification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Posting_Worker_Classification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Posting_Worker_Classification_Bool_Exp;
};

export type Postings_For_Prof_Facility_Args = {
  prof?: InputMaybe<Scalars['profession']>;
};

/** Boolean expression to compare columns of type "profession". All fields are combined with logical 'AND'. */
export type Profession_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['profession']>;
  _gt?: InputMaybe<Scalars['profession']>;
  _gte?: InputMaybe<Scalars['profession']>;
  _in?: InputMaybe<Array<Scalars['profession']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['profession']>;
  _lte?: InputMaybe<Scalars['profession']>;
  _neq?: InputMaybe<Scalars['profession']>;
  _nin?: InputMaybe<Array<Scalars['profession']>>;
};

/** Boolean expression to compare columns of type "professionaldegree". All fields are combined with logical 'AND'. */
export type Professionaldegree_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['professionaldegree']>;
  _gt?: InputMaybe<Scalars['professionaldegree']>;
  _gte?: InputMaybe<Scalars['professionaldegree']>;
  _in?: InputMaybe<Array<Scalars['professionaldegree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['professionaldegree']>;
  _lte?: InputMaybe<Scalars['professionaldegree']>;
  _neq?: InputMaybe<Scalars['professionaldegree']>;
  _nin?: InputMaybe<Array<Scalars['professionaldegree']>>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "AS20DEM" */
  AS20DEM: Array<As20Dem>;
  /** fetch aggregated fields from the table: "AS20DEM" */
  AS20DEM_aggregate: As20Dem_Aggregate;
  /** fetch data from the table: "AS20DEM" using primary key columns */
  AS20DEM_by_pk: Maybe<As20Dem>;
  /** fetch data from the table: "AS20SVC1" */
  AS20SVC1: Array<As20Svc1>;
  /** fetch aggregated fields from the table: "AS20SVC1" */
  AS20SVC1_aggregate: As20Svc1_Aggregate;
  /** fetch data from the table: "AS20SVC1" using primary key columns */
  AS20SVC1_by_pk: Maybe<As20Svc1>;
  /** fetch data from the table: "AS20SVC2" */
  AS20SVC2: Array<As20Svc2>;
  /** fetch aggregated fields from the table: "AS20SVC2" */
  AS20SVC2_aggregate: As20Svc2_Aggregate;
  /** fetch data from the table: "AS20SVC2" using primary key columns */
  AS20SVC2_by_pk: Maybe<As20Svc2>;
  /** fetch data from the table: "AS20SVC3" */
  AS20SVC3: Array<As20Svc3>;
  /** fetch aggregated fields from the table: "AS20SVC3" */
  AS20SVC3_aggregate: As20Svc3_Aggregate;
  /** fetch data from the table: "AS20SVC3" using primary key columns */
  AS20SVC3_by_pk: Maybe<As20Svc3>;
  /** fetch data from the table: "AS20UTIL1" */
  AS20UTIL1: Array<As20Util1>;
  /** fetch aggregated fields from the table: "AS20UTIL1" */
  AS20UTIL1_aggregate: As20Util1_Aggregate;
  /** fetch data from the table: "AS20UTIL1" using primary key columns */
  AS20UTIL1_by_pk: Maybe<As20Util1>;
  /** fetch data from the table: "AS20UTIL2" */
  AS20UTIL2: Array<As20Util2>;
  /** fetch aggregated fields from the table: "AS20UTIL2" */
  AS20UTIL2_aggregate: As20Util2_Aggregate;
  /** fetch data from the table: "AS20UTIL2" using primary key columns */
  AS20UTIL2_by_pk: Maybe<As20Util2>;
  /** fetch data from the table: "AS21DEM" */
  AS21DEM: Array<As21Dem>;
  /** fetch aggregated fields from the table: "AS21DEM" */
  AS21DEM_aggregate: As21Dem_Aggregate;
  /** fetch data from the table: "AS21DEM" using primary key columns */
  AS21DEM_by_pk: Maybe<As21Dem>;
  /** fetch data from the table: "AS21SVC1" */
  AS21SVC1: Array<As21Svc1>;
  /** fetch aggregated fields from the table: "AS21SVC1" */
  AS21SVC1_aggregate: As21Svc1_Aggregate;
  /** fetch data from the table: "AS21SVC1" using primary key columns */
  AS21SVC1_by_pk: Maybe<As21Svc1>;
  /** fetch data from the table: "AS21SVC2" */
  AS21SVC2: Array<As21Svc2>;
  /** fetch aggregated fields from the table: "AS21SVC2" */
  AS21SVC2_aggregate: As21Svc2_Aggregate;
  /** fetch data from the table: "AS21SVC2" using primary key columns */
  AS21SVC2_by_pk: Maybe<As21Svc2>;
  /** fetch data from the table: "AS21SVC3" */
  AS21SVC3: Array<As21Svc3>;
  /** fetch aggregated fields from the table: "AS21SVC3" */
  AS21SVC3_aggregate: As21Svc3_Aggregate;
  /** fetch data from the table: "AS21SVC3" using primary key columns */
  AS21SVC3_by_pk: Maybe<As21Svc3>;
  /** fetch data from the table: "AS21UNIT" */
  AS21UNIT: Array<As21Unit>;
  /** fetch aggregated fields from the table: "AS21UNIT" */
  AS21UNIT_aggregate: As21Unit_Aggregate;
  /** fetch data from the table: "AS21UNIT" using primary key columns */
  AS21UNIT_by_pk: Maybe<As21Unit>;
  /** fetch data from the table: "AS21UTIL" */
  AS21UTIL: Array<As21Util>;
  /** fetch data from the table: "AS21UTIL2" */
  AS21UTIL2: Array<As21Util2>;
  /** fetch aggregated fields from the table: "AS21UTIL2" */
  AS21UTIL2_aggregate: As21Util2_Aggregate;
  /** fetch data from the table: "AS21UTIL2" using primary key columns */
  AS21UTIL2_by_pk: Maybe<As21Util2>;
  /** fetch aggregated fields from the table: "AS21UTIL" */
  AS21UTIL_aggregate: As21Util_Aggregate;
  /** fetch data from the table: "AS21UTIL" using primary key columns */
  AS21UTIL_by_pk: Maybe<As21Util>;
  /** fetch data from the table: "AS22DEM" */
  AS22DEM: Array<As22Dem>;
  /** fetch aggregated fields from the table: "AS22DEM" */
  AS22DEM_aggregate: As22Dem_Aggregate;
  /** fetch data from the table: "AS22DEM" using primary key columns */
  AS22DEM_by_pk: Maybe<As22Dem>;
  /** fetch data from the table: "AS22SVC1" */
  AS22SVC1: Array<As22Svc1>;
  /** fetch aggregated fields from the table: "AS22SVC1" */
  AS22SVC1_aggregate: As22Svc1_Aggregate;
  /** fetch data from the table: "AS22SVC1" using primary key columns */
  AS22SVC1_by_pk: Maybe<As22Svc1>;
  /** fetch data from the table: "AS22SVC2" */
  AS22SVC2: Array<As22Svc2>;
  /** fetch aggregated fields from the table: "AS22SVC2" */
  AS22SVC2_aggregate: As22Svc2_Aggregate;
  /** fetch data from the table: "AS22SVC2" using primary key columns */
  AS22SVC2_by_pk: Maybe<As22Svc2>;
  /** fetch data from the table: "AS22SVC3" */
  AS22SVC3: Array<As22Svc3>;
  /** fetch aggregated fields from the table: "AS22SVC3" */
  AS22SVC3_aggregate: As22Svc3_Aggregate;
  /** fetch data from the table: "AS22SVC3" using primary key columns */
  AS22SVC3_by_pk: Maybe<As22Svc3>;
  /** fetch data from the table: "AS22UNIT" */
  AS22UNIT: Array<As22Unit>;
  /** fetch aggregated fields from the table: "AS22UNIT" */
  AS22UNIT_aggregate: As22Unit_Aggregate;
  /** fetch data from the table: "AS22UNIT" using primary key columns */
  AS22UNIT_by_pk: Maybe<As22Unit>;
  /** fetch data from the table: "AS22UTIL" */
  AS22UTIL: Array<As22Util>;
  /** fetch data from the table: "AS22UTIL2" */
  AS22UTIL2: Array<As22Util2>;
  /** fetch aggregated fields from the table: "AS22UTIL2" */
  AS22UTIL2_aggregate: As22Util2_Aggregate;
  /** fetch data from the table: "AS22UTIL2" using primary key columns */
  AS22UTIL2_by_pk: Maybe<As22Util2>;
  /** fetch aggregated fields from the table: "AS22UTIL" */
  AS22UTIL_aggregate: As22Util_Aggregate;
  /** fetch data from the table: "AS22UTIL" using primary key columns */
  AS22UTIL_by_pk: Maybe<As22Util>;
  /** fetch data from the table: "ab_test" */
  ab_test: Array<Ab_Test>;
  /** fetch aggregated fields from the table: "ab_test" */
  ab_test_aggregate: Ab_Test_Aggregate;
  /** fetch data from the table: "ab_test" using primary key columns */
  ab_test_by_pk: Maybe<Ab_Test>;
  /** fetch data from the table: "access_info" */
  access_info: Array<Access_Info>;
  /** fetch aggregated fields from the table: "access_info" */
  access_info_aggregate: Access_Info_Aggregate;
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  account_aggregate: Account_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  account_by_pk: Maybe<Account>;
  /** fetch data from the table: "account_role" */
  account_role: Array<Account_Role>;
  /** fetch aggregated fields from the table: "account_role" */
  account_role_aggregate: Account_Role_Aggregate;
  /** fetch data from the table: "account_role" using primary key columns */
  account_role_by_pk: Maybe<Account_Role>;
  /** fetch data from the table: "acep_org_survey" */
  acep_org_survey: Array<Acep_Org_Survey>;
  /** fetch aggregated fields from the table: "acep_org_survey" */
  acep_org_survey_aggregate: Acep_Org_Survey_Aggregate;
  /** fetch data from the table: "acep_org_survey" using primary key columns */
  acep_org_survey_by_pk: Maybe<Acep_Org_Survey>;
  app_certs: Array<AppCert>;
  /** Retrieve a single asset */
  asset: Maybe<Asset>;
  /** Retrieve document version */
  assetVersion: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** fetch data from the table: "board" */
  board: Array<Board>;
  /** fetch aggregated fields from the table: "board" */
  board_aggregate: Board_Aggregate;
  /** fetch data from the table: "board" using primary key columns */
  board_by_pk: Maybe<Board>;
  /** fetch data from the table: "board_cert" */
  board_cert: Array<Board_Cert>;
  /** fetch aggregated fields from the table: "board_cert" */
  board_cert_aggregate: Board_Cert_Aggregate;
  /** fetch data from the table: "board_cert" using primary key columns */
  board_cert_by_pk: Maybe<Board_Cert>;
  bq: Maybe<Bqbq_Query>;
  /** fetch data from the table: "candidate" */
  candidate: Array<Candidate>;
  /** fetch aggregated fields from the table: "candidate" */
  candidate_aggregate: Candidate_Aggregate;
  /** fetch data from the table: "candidate" using primary key columns */
  candidate_by_pk: Maybe<Candidate>;
  /** fetch data from the table: "cert_org" */
  cert_org: Array<Cert_Org>;
  /** fetch aggregated fields from the table: "cert_org" */
  cert_org_aggregate: Cert_Org_Aggregate;
  /** fetch data from the table: "cert_org" using primary key columns */
  cert_org_by_pk: Maybe<Cert_Org>;
  /** fetch data from the table: "clerkship" */
  clerkship: Array<Clerkship>;
  /** fetch aggregated fields from the table: "clerkship" */
  clerkship_aggregate: Clerkship_Aggregate;
  /** fetch data from the table: "clerkship" using primary key columns */
  clerkship_by_pk: Maybe<Clerkship>;
  /** fetch data from the table: "clerkship_survey" */
  clerkship_survey: Array<Clerkship_Survey>;
  /** fetch aggregated fields from the table: "clerkship_survey" */
  clerkship_survey_aggregate: Clerkship_Survey_Aggregate;
  /** fetch data from the table: "clerkship_survey" using primary key columns */
  clerkship_survey_by_pk: Maybe<Clerkship_Survey>;
  /** fetch data from the table: "clinician" */
  clinician: Array<Clinician>;
  /** fetch aggregated fields from the table: "clinician" */
  clinician_aggregate: Clinician_Aggregate;
  /** fetch data from the table: "clinician_app_cert" */
  clinician_app_cert: Array<Clinician_App_Cert>;
  /** fetch aggregated fields from the table: "clinician_app_cert" */
  clinician_app_cert_aggregate: Clinician_App_Cert_Aggregate;
  /** fetch data from the table: "clinician_app_cert" using primary key columns */
  clinician_app_cert_by_pk: Maybe<Clinician_App_Cert>;
  /** fetch data from the table: "clinician_board_cert" */
  clinician_board_cert: Array<Clinician_Board_Cert>;
  /** fetch aggregated fields from the table: "clinician_board_cert" */
  clinician_board_cert_aggregate: Clinician_Board_Cert_Aggregate;
  /** fetch data from the table: "clinician_board_cert" using primary key columns */
  clinician_board_cert_by_pk: Maybe<Clinician_Board_Cert>;
  /** fetch data from the table: "clinician" using primary key columns */
  clinician_by_pk: Maybe<Clinician>;
  /** fetch data from the table: "clinician_license" */
  clinician_license: Array<Clinician_License>;
  /** fetch aggregated fields from the table: "clinician_license" */
  clinician_license_aggregate: Clinician_License_Aggregate;
  /** fetch data from the table: "clinician_license" using primary key columns */
  clinician_license_by_pk: Maybe<Clinician_License>;
  /** fetch data from the table: "clinician_sp_exp" */
  clinician_sp_exp: Array<Clinician_Sp_Exp>;
  /** fetch aggregated fields from the table: "clinician_sp_exp" */
  clinician_sp_exp_aggregate: Clinician_Sp_Exp_Aggregate;
  /** fetch data from the table: "clinician_sp_exp" using primary key columns */
  clinician_sp_exp_by_pk: Maybe<Clinician_Sp_Exp>;
  /** fetch data from the table: "clinician_specialty" */
  clinician_specialty: Array<Clinician_Specialty>;
  /** fetch aggregated fields from the table: "clinician_specialty" */
  clinician_specialty_aggregate: Clinician_Specialty_Aggregate;
  /** fetch data from the table: "clinician_specialty" using primary key columns */
  clinician_specialty_by_pk: Maybe<Clinician_Specialty>;
  /** fetch data from the table: "clinician_training" */
  clinician_training: Array<Clinician_Training>;
  /** fetch aggregated fields from the table: "clinician_training" */
  clinician_training_aggregate: Clinician_Training_Aggregate;
  /** fetch data from the table: "clinician_training" using primary key columns */
  clinician_training_by_pk: Maybe<Clinician_Training>;
  /** fetch data from the table: "cms_facility" */
  cms_facility: Array<Cms_Facility>;
  /** fetch aggregated fields from the table: "cms_facility" */
  cms_facility_aggregate: Cms_Facility_Aggregate;
  /** fetch data from the table: "cms_facility" using primary key columns */
  cms_facility_by_pk: Maybe<Cms_Facility>;
  /** fetch data from the table: "cms_facility_enrollment" */
  cms_facility_enrollment: Array<Cms_Facility_Enrollment>;
  /** fetch aggregated fields from the table: "cms_facility_enrollment" */
  cms_facility_enrollment_aggregate: Cms_Facility_Enrollment_Aggregate;
  /** fetch data from the table: "cms_facility_enrollment" using primary key columns */
  cms_facility_enrollment_by_pk: Maybe<Cms_Facility_Enrollment>;
  /** fetch data from the table: "cms_facility_metric" */
  cms_facility_metric: Array<Cms_Facility_Metric>;
  /** fetch aggregated fields from the table: "cms_facility_metric" */
  cms_facility_metric_aggregate: Cms_Facility_Metric_Aggregate;
  /** fetch data from the table: "cms_facility_metric" using primary key columns */
  cms_facility_metric_by_pk: Maybe<Cms_Facility_Metric>;
  /** fetch data from the table: "cms_facility_pos" */
  cms_facility_pos: Array<Cms_Facility_Pos>;
  /** fetch aggregated fields from the table: "cms_facility_pos" */
  cms_facility_pos_aggregate: Cms_Facility_Pos_Aggregate;
  /** fetch data from the table: "cms_facility_pos" using primary key columns */
  cms_facility_pos_by_pk: Maybe<Cms_Facility_Pos>;
  /** fetch data from the table: "cms_specialty" */
  cms_specialty: Array<Cms_Specialty>;
  /** fetch aggregated fields from the table: "cms_specialty" */
  cms_specialty_aggregate: Cms_Specialty_Aggregate;
  /** fetch data from the table: "cms_specialty" using primary key columns */
  cms_specialty_by_pk: Maybe<Cms_Specialty>;
  /** fetch data from the table: "contact_info" */
  contact_info: Array<Contact_Info>;
  /** fetch aggregated fields from the table: "contact_info" */
  contact_info_aggregate: Contact_Info_Aggregate;
  /** fetch data from the table: "current_account" */
  current_account: Array<Current_Account>;
  /** fetch aggregated fields from the table: "current_account" */
  current_account_aggregate: Current_Account_Aggregate;
  customer_by_org_id: Maybe<CustomerGql>;
  /** fetch data from the table: "email_contact" */
  email_contact: Array<Email_Contact>;
  /** fetch aggregated fields from the table: "email_contact" */
  email_contact_aggregate: Email_Contact_Aggregate;
  /** fetch data from the table: "email_contact" using primary key columns */
  email_contact_by_pk: Maybe<Email_Contact>;
  /** fetch data from the table: "email_envelope" */
  email_envelope: Array<Email_Envelope>;
  /** fetch aggregated fields from the table: "email_envelope" */
  email_envelope_aggregate: Email_Envelope_Aggregate;
  /** fetch data from the table: "email_envelope" using primary key columns */
  email_envelope_by_pk: Maybe<Email_Envelope>;
  /** fetch data from the table: "email_event" */
  email_event: Array<Email_Event>;
  /** fetch aggregated fields from the table: "email_event" */
  email_event_aggregate: Email_Event_Aggregate;
  /** fetch data from the table: "email_event" using primary key columns */
  email_event_by_pk: Maybe<Email_Event>;
  /** fetch data from the table: "email_message" */
  email_message: Array<Email_Message>;
  /** fetch aggregated fields from the table: "email_message" */
  email_message_aggregate: Email_Message_Aggregate;
  /** fetch data from the table: "email_message" using primary key columns */
  email_message_by_pk: Maybe<Email_Message>;
  /** fetch data from the table: "email_pointer" */
  email_pointer: Array<Email_Pointer>;
  /** fetch aggregated fields from the table: "email_pointer" */
  email_pointer_aggregate: Email_Pointer_Aggregate;
  /** fetch data from the table: "email_pointer" using primary key columns */
  email_pointer_by_pk: Maybe<Email_Pointer>;
  email_suppressions: Array<EmailSuppression>;
  /** Fetches an object given its ID */
  entities: Maybe<Array<Entity>>;
  /** fetch data from the table: "ext_job_posting" */
  ext_job_posting: Array<Ext_Job_Posting>;
  /** fetch aggregated fields from the table: "ext_job_posting" */
  ext_job_posting_aggregate: Ext_Job_Posting_Aggregate;
  /** fetch data from the table: "ext_job_posting" using primary key columns */
  ext_job_posting_by_pk: Maybe<Ext_Job_Posting>;
  /** fetch data from the table: "ext_job_scrape" */
  ext_job_scrape: Array<Ext_Job_Scrape>;
  /** fetch aggregated fields from the table: "ext_job_scrape" */
  ext_job_scrape_aggregate: Ext_Job_Scrape_Aggregate;
  /** fetch data from the table: "ext_job_scrape" using primary key columns */
  ext_job_scrape_by_pk: Maybe<Ext_Job_Scrape>;
  /** fetch data from the table: "ext_posting_error" */
  ext_posting_error: Array<Ext_Posting_Error>;
  /** fetch aggregated fields from the table: "ext_posting_error" */
  ext_posting_error_aggregate: Ext_Posting_Error_Aggregate;
  /** fetch data from the table: "ext_posting_error" using primary key columns */
  ext_posting_error_by_pk: Maybe<Ext_Posting_Error>;
  /** fetch data from the table: "ext_posting_profession" */
  ext_posting_profession: Array<Ext_Posting_Profession>;
  /** fetch aggregated fields from the table: "ext_posting_profession" */
  ext_posting_profession_aggregate: Ext_Posting_Profession_Aggregate;
  /** fetch data from the table: "ext_posting_profession" using primary key columns */
  ext_posting_profession_by_pk: Maybe<Ext_Posting_Profession>;
  /** fetch data from the table: "facility" */
  facility: Array<Facility>;
  /** fetch data from the table: "facility_accreditation" */
  facility_accreditation: Array<Facility_Accreditation>;
  /** fetch aggregated fields from the table: "facility_accreditation" */
  facility_accreditation_aggregate: Facility_Accreditation_Aggregate;
  /** fetch data from the table: "facility_accreditation" using primary key columns */
  facility_accreditation_by_pk: Maybe<Facility_Accreditation>;
  /** fetch aggregated fields from the table: "facility" */
  facility_aggregate: Facility_Aggregate;
  /** fetch data from the table: "facility" using primary key columns */
  facility_by_pk: Maybe<Facility>;
  /** fetch data from the table: "facility_contract" */
  facility_contract: Array<Facility_Contract>;
  /** fetch aggregated fields from the table: "facility_contract" */
  facility_contract_aggregate: Facility_Contract_Aggregate;
  /** fetch data from the table: "facility_contract" using primary key columns */
  facility_contract_by_pk: Maybe<Facility_Contract>;
  /** fetch data from the table: "facility_contract_featured" */
  facility_contract_featured: Array<Facility_Contract_Featured>;
  /** fetch aggregated fields from the table: "facility_contract_featured" */
  facility_contract_featured_aggregate: Facility_Contract_Featured_Aggregate;
  /** fetch data from the table: "facility_contract_featured" using primary key columns */
  facility_contract_featured_by_pk: Maybe<Facility_Contract_Featured>;
  /** fetch data from the table: "facility_correction" */
  facility_correction: Array<Facility_Correction>;
  /** fetch aggregated fields from the table: "facility_correction" */
  facility_correction_aggregate: Facility_Correction_Aggregate;
  /** fetch data from the table: "facility_correction" using primary key columns */
  facility_correction_by_pk: Maybe<Facility_Correction>;
  /** execute function "facility_dist" which returns "facility_dist_result" */
  facility_dist: Array<Facility_Dist_Result>;
  /** execute function "facility_dist" and query aggregates on result of table type "facility_dist_result" */
  facility_dist_aggregate: Facility_Dist_Result_Aggregate;
  /** fetch data from the table: "facility_dist_result" */
  facility_dist_result: Array<Facility_Dist_Result>;
  /** fetch aggregated fields from the table: "facility_dist_result" */
  facility_dist_result_aggregate: Facility_Dist_Result_Aggregate;
  /** fetch data from the table: "facility_ehr" */
  facility_ehr: Array<Facility_Ehr>;
  /** fetch aggregated fields from the table: "facility_ehr" */
  facility_ehr_aggregate: Facility_Ehr_Aggregate;
  /** fetch data from the table: "facility_ehr" using primary key columns */
  facility_ehr_by_pk: Maybe<Facility_Ehr>;
  /** fetch data from the table: "facility_rating" */
  facility_rating: Array<Facility_Rating>;
  /** fetch aggregated fields from the table: "facility_rating" */
  facility_rating_aggregate: Facility_Rating_Aggregate;
  /** Retrieve a single faq */
  faq: Maybe<Faq>;
  /** Retrieve document version */
  faqVersion: Maybe<DocumentVersion>;
  /** Retrieve multiple faqs */
  faqs: Array<Faq>;
  /** Retrieve multiple faqs using the Relay connection interface */
  faqsConnection: FaqConnection;
  /** fetch data from the table: "favorite" */
  favorite: Array<Favorite>;
  /** fetch aggregated fields from the table: "favorite" */
  favorite_aggregate: Favorite_Aggregate;
  /** fetch data from the table: "favorite" using primary key columns */
  favorite_by_pk: Maybe<Favorite>;
  /** execute function "featured_clerkship_dist" which returns "featured_clerkship_dist_result" */
  featured_clerkship_dist: Array<Featured_Clerkship_Dist_Result>;
  /** execute function "featured_clerkship_dist" and query aggregates on result of table type "featured_clerkship_dist_result" */
  featured_clerkship_dist_aggregate: Featured_Clerkship_Dist_Result_Aggregate;
  /** fetch data from the table: "featured_clerkship_dist_result" */
  featured_clerkship_dist_result: Array<Featured_Clerkship_Dist_Result>;
  /** fetch aggregated fields from the table: "featured_clerkship_dist_result" */
  featured_clerkship_dist_result_aggregate: Featured_Clerkship_Dist_Result_Aggregate;
  /** execute function "featured_fellowship_dist" which returns "featured_fellowship_dist_result" */
  featured_fellowship_dist: Array<Featured_Fellowship_Dist_Result>;
  /** execute function "featured_fellowship_dist" and query aggregates on result of table type "featured_fellowship_dist_result" */
  featured_fellowship_dist_aggregate: Featured_Fellowship_Dist_Result_Aggregate;
  /** fetch data from the table: "featured_fellowship_dist_result" */
  featured_fellowship_dist_result: Array<Featured_Fellowship_Dist_Result>;
  /** fetch aggregated fields from the table: "featured_fellowship_dist_result" */
  featured_fellowship_dist_result_aggregate: Featured_Fellowship_Dist_Result_Aggregate;
  /** execute function "featured_residency_dist" which returns "featured_residency_dist_result" */
  featured_residency_dist: Array<Featured_Residency_Dist_Result>;
  /** execute function "featured_residency_dist" and query aggregates on result of table type "featured_residency_dist_result" */
  featured_residency_dist_aggregate: Featured_Residency_Dist_Result_Aggregate;
  /** fetch data from the table: "featured_residency_dist_result" */
  featured_residency_dist_result: Array<Featured_Residency_Dist_Result>;
  /** fetch aggregated fields from the table: "featured_residency_dist_result" */
  featured_residency_dist_result_aggregate: Featured_Residency_Dist_Result_Aggregate;
  /** fetch data from the table: "fellowship" */
  fellowship: Array<Fellowship>;
  /** fetch aggregated fields from the table: "fellowship" */
  fellowship_aggregate: Fellowship_Aggregate;
  /** fetch data from the table: "fellowship" using primary key columns */
  fellowship_by_pk: Maybe<Fellowship>;
  /** fetch data from the table: "fellowship_survey" */
  fellowship_survey: Array<Fellowship_Survey>;
  /** fetch aggregated fields from the table: "fellowship_survey" */
  fellowship_survey_aggregate: Fellowship_Survey_Aggregate;
  /** fetch data from the table: "fellowship_survey" using primary key columns */
  fellowship_survey_by_pk: Maybe<Fellowship_Survey>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk: Maybe<File>;
  /** fetch data from the table: "fsmb_bio" */
  fsmb_bio: Array<Fsmb_Bio>;
  /** fetch aggregated fields from the table: "fsmb_bio" */
  fsmb_bio_aggregate: Fsmb_Bio_Aggregate;
  /** fetch data from the table: "fsmb_bio" using primary key columns */
  fsmb_bio_by_pk: Maybe<Fsmb_Bio>;
  /** fetch data from the table: "fsmb_licensure" */
  fsmb_licensure: Array<Fsmb_Licensure>;
  /** fetch aggregated fields from the table: "fsmb_licensure" */
  fsmb_licensure_aggregate: Fsmb_Licensure_Aggregate;
  /** fetch data from the table: "fsmb_licensure" using primary key columns */
  fsmb_licensure_by_pk: Maybe<Fsmb_Licensure>;
  get_payment_prices: Array<ProductPriceGql>;
  get_subscription_invoice_preview: SubscriptionInvoicePreviewGql;
  /** fetch data from the table: "gmaps_link" */
  gmaps_link: Array<Gmaps_Link>;
  /** fetch aggregated fields from the table: "gmaps_link" */
  gmaps_link_aggregate: Gmaps_Link_Aggregate;
  /** fetch data from the table: "gmaps_link" using primary key columns */
  gmaps_link_by_pk: Maybe<Gmaps_Link>;
  /** fetch data from the table: "gmaps_link_type" */
  gmaps_link_type: Array<Gmaps_Link_Type>;
  /** fetch aggregated fields from the table: "gmaps_link_type" */
  gmaps_link_type_aggregate: Gmaps_Link_Type_Aggregate;
  /** fetch data from the table: "gmaps_link_type" using primary key columns */
  gmaps_link_type_by_pk: Maybe<Gmaps_Link_Type>;
  /** fetch data from the table: "gmaps_place" */
  gmaps_place: Array<Gmaps_Place>;
  /** fetch aggregated fields from the table: "gmaps_place" */
  gmaps_place_aggregate: Gmaps_Place_Aggregate;
  /** fetch data from the table: "gmaps_place" using primary key columns */
  gmaps_place_by_pk: Maybe<Gmaps_Place>;
  /** fetch data from the table: "identity_provider" */
  identity_provider: Array<Identity_Provider>;
  /** fetch aggregated fields from the table: "identity_provider" */
  identity_provider_aggregate: Identity_Provider_Aggregate;
  /** fetch data from the table: "identity_provider" using primary key columns */
  identity_provider_by_pk: Maybe<Identity_Provider>;
  /** fetch data from the table: "job_application" */
  job_application: Array<Job_Application>;
  /** fetch aggregated fields from the table: "job_application" */
  job_application_aggregate: Job_Application_Aggregate;
  /** fetch data from the table: "job_application_batch" */
  job_application_batch: Array<Job_Application_Batch>;
  /** fetch aggregated fields from the table: "job_application_batch" */
  job_application_batch_aggregate: Job_Application_Batch_Aggregate;
  /** fetch data from the table: "job_application_batch" using primary key columns */
  job_application_batch_by_pk: Maybe<Job_Application_Batch>;
  /** fetch data from the table: "job_application" using primary key columns */
  job_application_by_pk: Maybe<Job_Application>;
  /** fetch data from the table: "job_application_posting" */
  job_application_posting: Array<Job_Application_Posting>;
  /** fetch aggregated fields from the table: "job_application_posting" */
  job_application_posting_aggregate: Job_Application_Posting_Aggregate;
  /** fetch data from the table: "job_application_posting" using primary key columns */
  job_application_posting_by_pk: Maybe<Job_Application_Posting>;
  /** fetch data from the table: "job_posting" */
  job_posting: Array<Job_Posting>;
  /** fetch aggregated fields from the table: "job_posting" */
  job_posting_aggregate: Job_Posting_Aggregate;
  /** fetch data from the table: "job_posting" using primary key columns */
  job_posting_by_pk: Maybe<Job_Posting>;
  /** fetch data from the table: "latest_clerkship_survey" */
  latest_clerkship_survey: Array<Latest_Clerkship_Survey>;
  /** fetch aggregated fields from the table: "latest_clerkship_survey" */
  latest_clerkship_survey_aggregate: Latest_Clerkship_Survey_Aggregate;
  /** fetch data from the table: "latest_fellowship_survey" */
  latest_fellowship_survey: Array<Latest_Fellowship_Survey>;
  /** fetch aggregated fields from the table: "latest_fellowship_survey" */
  latest_fellowship_survey_aggregate: Latest_Fellowship_Survey_Aggregate;
  /** fetch data from the table: "latest_residency_survey" */
  latest_residency_survey: Array<Latest_Residency_Survey>;
  /** fetch aggregated fields from the table: "latest_residency_survey" */
  latest_residency_survey_aggregate: Latest_Residency_Survey_Aggregate;
  /** Retrieve a single legal */
  legal: Maybe<Legal>;
  /** Retrieve document version */
  legalVersion: Maybe<DocumentVersion>;
  /** Retrieve multiple legals */
  legals: Array<Legal>;
  /** Retrieve multiple legals using the Relay connection interface */
  legalsConnection: LegalConnection;
  medicare_specialties: Array<MedicareSpecialty>;
  /** execute function "nearby_facilities_by_geography" which returns "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography: Array<Nearby_Facilities_By_Geography_Result>;
  /** execute function "nearby_facilities_by_geography" and query aggregates on result of table type "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_aggregate: Nearby_Facilities_By_Geography_Result_Aggregate;
  /** fetch data from the table: "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_result: Array<Nearby_Facilities_By_Geography_Result>;
  /** fetch aggregated fields from the table: "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_result_aggregate: Nearby_Facilities_By_Geography_Result_Aggregate;
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** execute function "org_dist" which returns "org_dist_result" */
  org_dist: Array<Org_Dist_Result>;
  /** execute function "org_dist" and query aggregates on result of table type "org_dist_result" */
  org_dist_aggregate: Org_Dist_Result_Aggregate;
  /** fetch data from the table: "org_dist_result" */
  org_dist_result: Array<Org_Dist_Result>;
  /** fetch aggregated fields from the table: "org_dist_result" */
  org_dist_result_aggregate: Org_Dist_Result_Aggregate;
  /** fetch data from the table: "org_domain" */
  org_domain: Array<Org_Domain>;
  /** fetch aggregated fields from the table: "org_domain" */
  org_domain_aggregate: Org_Domain_Aggregate;
  /** fetch data from the table: "org_domain" using primary key columns */
  org_domain_by_pk: Maybe<Org_Domain>;
  /** fetch data from the table: "org_market" */
  org_market: Array<Org_Market>;
  /** fetch aggregated fields from the table: "org_market" */
  org_market_aggregate: Org_Market_Aggregate;
  /** fetch data from the table: "org_rating" */
  org_rating: Array<Org_Rating>;
  /** fetch aggregated fields from the table: "org_rating" */
  org_rating_aggregate: Org_Rating_Aggregate;
  /** fetch data from the table: "org_user" */
  org_user: Array<Org_User>;
  /** fetch aggregated fields from the table: "org_user" */
  org_user_aggregate: Org_User_Aggregate;
  /** fetch data from the table: "org_user" using primary key columns */
  org_user_by_pk: Maybe<Org_User>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization_bounds" */
  organization_bounds: Array<Organization_Bounds>;
  /** fetch aggregated fields from the table: "organization_bounds" */
  organization_bounds_aggregate: Organization_Bounds_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk: Maybe<Organization>;
  /** fetch data from the table: "organization_job_posting" */
  organization_job_posting: Array<Organization_Job_Posting>;
  /** fetch aggregated fields from the table: "organization_job_posting" */
  organization_job_posting_aggregate: Organization_Job_Posting_Aggregate;
  /** fetch data from the table: "personal_info" */
  personal_info: Array<Personal_Info>;
  /** fetch aggregated fields from the table: "personal_info" */
  personal_info_aggregate: Personal_Info_Aggregate;
  /** fetch data from the table: "place_boundary" */
  place_boundary: Array<Place_Boundary>;
  /** fetch aggregated fields from the table: "place_boundary" */
  place_boundary_aggregate: Place_Boundary_Aggregate;
  /** fetch data from the table: "place_boundary" using primary key columns */
  place_boundary_by_pk: Maybe<Place_Boundary>;
  /** Retrieve a single post */
  post: Maybe<Post>;
  /** Retrieve document version */
  postVersion: Maybe<DocumentVersion>;
  /** fetch data from the table: "posting_app_cert" */
  posting_app_cert: Array<Posting_App_Cert>;
  /** fetch aggregated fields from the table: "posting_app_cert" */
  posting_app_cert_aggregate: Posting_App_Cert_Aggregate;
  /** fetch data from the table: "posting_app_cert" using primary key columns */
  posting_app_cert_by_pk: Maybe<Posting_App_Cert>;
  /** fetch data from the table: "posting_board_cert" */
  posting_board_cert: Array<Posting_Board_Cert>;
  /** fetch aggregated fields from the table: "posting_board_cert" */
  posting_board_cert_aggregate: Posting_Board_Cert_Aggregate;
  /** fetch data from the table: "posting_board_cert" using primary key columns */
  posting_board_cert_by_pk: Maybe<Posting_Board_Cert>;
  /** fetch data from the table: "posting_latest_publication" */
  posting_latest_publication: Array<Posting_Latest_Publication>;
  /** fetch aggregated fields from the table: "posting_latest_publication" */
  posting_latest_publication_aggregate: Posting_Latest_Publication_Aggregate;
  /** fetch data from the table: "posting_profession" */
  posting_profession: Array<Posting_Profession>;
  /** fetch aggregated fields from the table: "posting_profession" */
  posting_profession_aggregate: Posting_Profession_Aggregate;
  /** fetch data from the table: "posting_profession" using primary key columns */
  posting_profession_by_pk: Maybe<Posting_Profession>;
  /** fetch data from the table: "posting_worker_classification" */
  posting_worker_classification: Array<Posting_Worker_Classification>;
  /** fetch aggregated fields from the table: "posting_worker_classification" */
  posting_worker_classification_aggregate: Posting_Worker_Classification_Aggregate;
  /** fetch data from the table: "posting_worker_classification" using primary key columns */
  posting_worker_classification_by_pk: Maybe<Posting_Worker_Classification>;
  /** Retrieve multiple posts */
  posts: Array<Post>;
  /** Retrieve multiple posts using the Relay connection interface */
  postsConnection: PostConnection;
  /** fetch data from the table: "ranked_facility" */
  ranked_facility: Array<Ranked_Facility>;
  /** fetch aggregated fields from the table: "ranked_facility" */
  ranked_facility_aggregate: Ranked_Facility_Aggregate;
  /** execute function "ranked_facility_dist" which returns "ranked_facility" */
  ranked_facility_dist: Array<Ranked_Facility>;
  /** execute function "ranked_facility_dist" and query aggregates on result of table type "ranked_facility" */
  ranked_facility_dist_aggregate: Ranked_Facility_Aggregate;
  /** fetch data from the table: "relevant_job_posting" */
  relevant_job_posting: Array<Relevant_Job_Posting>;
  /** fetch aggregated fields from the table: "relevant_job_posting" */
  relevant_job_posting_aggregate: Relevant_Job_Posting_Aggregate;
  /** fetch data from the table: "relevant_salary_report" */
  relevant_salary_report: Array<Relevant_Salary_Report>;
  /** fetch aggregated fields from the table: "relevant_salary_report" */
  relevant_salary_report_aggregate: Relevant_Salary_Report_Aggregate;
  /** fetch data from the table: "residency" */
  residency: Array<Residency>;
  /** fetch aggregated fields from the table: "residency" */
  residency_aggregate: Residency_Aggregate;
  /** fetch data from the table: "residency" using primary key columns */
  residency_by_pk: Maybe<Residency>;
  /** fetch data from the table: "residency_survey" */
  residency_survey: Array<Residency_Survey>;
  /** fetch aggregated fields from the table: "residency_survey" */
  residency_survey_aggregate: Residency_Survey_Aggregate;
  /** fetch data from the table: "residency_survey" using primary key columns */
  residency_survey_by_pk: Maybe<Residency_Survey>;
  resolve_city_place_id: ResolveCityPlaceIdResult;
  /** fetch data from the table: "review" */
  review: Array<Review>;
  /** fetch aggregated fields from the table: "review" */
  review_aggregate: Review_Aggregate;
  /** fetch data from the table: "review" using primary key columns */
  review_by_pk: Maybe<Review>;
  /** fetch data from the table: "review_reply" */
  review_reply: Array<Review_Reply>;
  /** fetch aggregated fields from the table: "review_reply" */
  review_reply_aggregate: Review_Reply_Aggregate;
  /** fetch data from the table: "review_reply" using primary key columns */
  review_reply_by_pk: Maybe<Review_Reply>;
  /** fetch data from the table: "review_report" */
  review_report: Array<Review_Report>;
  /** fetch aggregated fields from the table: "review_report" */
  review_report_aggregate: Review_Report_Aggregate;
  /** fetch data from the table: "review_report" using primary key columns */
  review_report_by_pk: Maybe<Review_Report>;
  /** fetch data from the table: "review_vote" */
  review_vote: Array<Review_Vote>;
  /** fetch aggregated fields from the table: "review_vote" */
  review_vote_aggregate: Review_Vote_Aggregate;
  /** fetch data from the table: "review_vote" using primary key columns */
  review_vote_by_pk: Maybe<Review_Vote>;
  /** fetch data from the table: "salary_report" */
  salary_report: Array<Salary_Report>;
  /** fetch aggregated fields from the table: "salary_report" */
  salary_report_aggregate: Salary_Report_Aggregate;
  /** fetch data from the table: "salary_report" using primary key columns */
  salary_report_by_pk: Maybe<Salary_Report>;
  /** fetch data from the table: "salary_report_fmt" */
  salary_report_fmt: Array<Salary_Report_Fmt>;
  /** fetch aggregated fields from the table: "salary_report_fmt" */
  salary_report_fmt_aggregate: Salary_Report_Fmt_Aggregate;
  /** Retrieve a single scheduledOperation */
  scheduledOperation: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** fetch data from the table: "school" */
  school: Array<School>;
  /** fetch aggregated fields from the table: "school" */
  school_aggregate: School_Aggregate;
  /** fetch data from the table: "school" using primary key columns */
  school_by_pk: Maybe<School>;
  /** execute function "search_candidate" which returns "search_candidate_result" */
  search_candidate: Array<Search_Candidate_Result>;
  /** execute function "search_candidate" and query aggregates on result of table type "search_candidate_result" */
  search_candidate_aggregate: Search_Candidate_Result_Aggregate;
  /** fetch data from the table: "search_candidate_result" */
  search_candidate_result: Array<Search_Candidate_Result>;
  /** fetch aggregated fields from the table: "search_candidate_result" */
  search_candidate_result_aggregate: Search_Candidate_Result_Aggregate;
  /** execute function "search_clerkship_by_geography" which returns "search_clerkship_by_geography_result" */
  search_clerkship_by_geography: Array<Search_Clerkship_By_Geography_Result>;
  /** execute function "search_clerkship_by_geography" and query aggregates on result of table type "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_aggregate: Search_Clerkship_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_result: Array<Search_Clerkship_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_result_aggregate: Search_Clerkship_By_Geography_Result_Aggregate;
  /** execute function "search_facility_by_prefix" which returns "search_facility_by_prefix_result" */
  search_facility_by_prefix: Array<Search_Facility_By_Prefix_Result>;
  /** execute function "search_facility_by_prefix" and query aggregates on result of table type "search_facility_by_prefix_result" */
  search_facility_by_prefix_aggregate: Search_Facility_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "search_facility_by_prefix_result" */
  search_facility_by_prefix_result: Array<Search_Facility_By_Prefix_Result>;
  /** fetch aggregated fields from the table: "search_facility_by_prefix_result" */
  search_facility_by_prefix_result_aggregate: Search_Facility_By_Prefix_Result_Aggregate;
  /** execute function "search_fellowship_by_geography" which returns "search_fellowship_by_geography_result" */
  search_fellowship_by_geography: Array<Search_Fellowship_By_Geography_Result>;
  /** execute function "search_fellowship_by_geography" and query aggregates on result of table type "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_aggregate: Search_Fellowship_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_result: Array<Search_Fellowship_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_result_aggregate: Search_Fellowship_By_Geography_Result_Aggregate;
  /** execute function "search_fsmb_bio" which returns "search_fsmb_bio_result" */
  search_fsmb_bio: Array<Search_Fsmb_Bio_Result>;
  /** execute function "search_fsmb_bio" and query aggregates on result of table type "search_fsmb_bio_result" */
  search_fsmb_bio_aggregate: Search_Fsmb_Bio_Result_Aggregate;
  /** fetch data from the table: "search_fsmb_bio_result" */
  search_fsmb_bio_result: Array<Search_Fsmb_Bio_Result>;
  /** fetch aggregated fields from the table: "search_fsmb_bio_result" */
  search_fsmb_bio_result_aggregate: Search_Fsmb_Bio_Result_Aggregate;
  /** execute function "search_job_postings_by_geography" which returns "search_job_postings_by_geography_result" */
  search_job_postings_by_geography: Array<Search_Job_Postings_By_Geography_Result>;
  /** execute function "search_job_postings_by_geography" and query aggregates on result of table type "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_aggregate: Search_Job_Postings_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_result: Array<Search_Job_Postings_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_result_aggregate: Search_Job_Postings_By_Geography_Result_Aggregate;
  /** execute function "search_org_market" which returns "search_org_market_result" */
  search_org_market: Array<Search_Org_Market_Result>;
  /** execute function "search_org_market" and query aggregates on result of table type "search_org_market_result" */
  search_org_market_aggregate: Search_Org_Market_Result_Aggregate;
  /** fetch data from the table: "search_org_market_result" */
  search_org_market_result: Array<Search_Org_Market_Result>;
  /** fetch aggregated fields from the table: "search_org_market_result" */
  search_org_market_result_aggregate: Search_Org_Market_Result_Aggregate;
  /** execute function "search_organization_by_prefix" which returns "search_organization_by_prefix_result" */
  search_organization_by_prefix: Array<Search_Organization_By_Prefix_Result>;
  /** execute function "search_organization_by_prefix" and query aggregates on result of table type "search_organization_by_prefix_result" */
  search_organization_by_prefix_aggregate: Search_Organization_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "search_organization_by_prefix_result" */
  search_organization_by_prefix_result: Array<Search_Organization_By_Prefix_Result>;
  /** fetch aggregated fields from the table: "search_organization_by_prefix_result" */
  search_organization_by_prefix_result_aggregate: Search_Organization_By_Prefix_Result_Aggregate;
  /** execute function "search_ranked_facilities_by_geography" which returns "ranked_facility" */
  search_ranked_facilities_by_geography: Array<Ranked_Facility>;
  /** execute function "search_ranked_facilities_by_geography" and query aggregates on result of table type "ranked_facility" */
  search_ranked_facilities_by_geography_aggregate: Ranked_Facility_Aggregate;
  /** execute function "search_relevant_job_posting" which returns "relevant_job_posting" */
  search_relevant_job_posting: Array<Relevant_Job_Posting>;
  /** execute function "search_relevant_job_posting" and query aggregates on result of table type "relevant_job_posting" */
  search_relevant_job_posting_aggregate: Relevant_Job_Posting_Aggregate;
  /** execute function "search_relevant_salary_report" which returns "relevant_salary_report" */
  search_relevant_salary_report: Array<Relevant_Salary_Report>;
  /** execute function "search_relevant_salary_report" and query aggregates on result of table type "relevant_salary_report" */
  search_relevant_salary_report_aggregate: Relevant_Salary_Report_Aggregate;
  /** execute function "search_residency_by_geography" which returns "search_residency_by_geography_result" */
  search_residency_by_geography: Array<Search_Residency_By_Geography_Result>;
  /** execute function "search_residency_by_geography" and query aggregates on result of table type "search_residency_by_geography_result" */
  search_residency_by_geography_aggregate: Search_Residency_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_residency_by_geography_result" */
  search_residency_by_geography_result: Array<Search_Residency_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_residency_by_geography_result" */
  search_residency_by_geography_result_aggregate: Search_Residency_By_Geography_Result_Aggregate;
  /** execute function "search_training_by_prefix" which returns "search_training_by_prefix_result" */
  search_training_by_prefix: Array<Search_Training_By_Prefix_Result>;
  /** execute function "search_training_by_prefix" and query aggregates on result of table type "search_training_by_prefix_result" */
  search_training_by_prefix_aggregate: Search_Training_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "search_training_by_prefix_result" */
  search_training_by_prefix_result: Array<Search_Training_By_Prefix_Result>;
  /** fetch aggregated fields from the table: "search_training_by_prefix_result" */
  search_training_by_prefix_result_aggregate: Search_Training_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "site" */
  site: Array<Site>;
  /** fetch aggregated fields from the table: "site" */
  site_aggregate: Site_Aggregate;
  /** fetch data from the table: "site" using primary key columns */
  site_by_pk: Maybe<Site>;
  /** fetch data from the table: "stroke_cert" */
  stroke_cert: Array<Stroke_Cert>;
  /** fetch aggregated fields from the table: "stroke_cert" */
  stroke_cert_aggregate: Stroke_Cert_Aggregate;
  /** fetch data from the table: "stroke_cert" using primary key columns */
  stroke_cert_by_pk: Maybe<Stroke_Cert>;
  /** execute function "suggest_ranked_facilities" which returns "ranked_facility" */
  suggest_ranked_facilities: Array<Ranked_Facility>;
  /** execute function "suggest_ranked_facilities" and query aggregates on result of table type "ranked_facility" */
  suggest_ranked_facilities_aggregate: Ranked_Facility_Aggregate;
  /** Retrieve a single teammate */
  teammate: Maybe<Teammate>;
  /** Retrieve document version */
  teammateVersion: Maybe<DocumentVersion>;
  /** Retrieve multiple teammates */
  teammates: Array<Teammate>;
  /** Retrieve multiple teammates using the Relay connection interface */
  teammatesConnection: TeammateConnection;
  /** fetch data from the table: "training" */
  training: Array<Training>;
  /** fetch aggregated fields from the table: "training" */
  training_aggregate: Training_Aggregate;
  /** fetch data from the table: "training" using primary key columns */
  training_by_pk: Maybe<Training>;
  /** fetch data from the table: "training_event" */
  training_event: Array<Training_Event>;
  /** fetch aggregated fields from the table: "training_event" */
  training_event_aggregate: Training_Event_Aggregate;
  /** fetch data from the table: "training_event" using primary key columns */
  training_event_by_pk: Maybe<Training_Event>;
  /** fetch data from the table: "training_field" */
  training_field: Array<Training_Field>;
  /** fetch aggregated fields from the table: "training_field" */
  training_field_aggregate: Training_Field_Aggregate;
  /** fetch data from the table: "training_field" using primary key columns */
  training_field_by_pk: Maybe<Training_Field>;
  /** fetch data from the table: "training_program" */
  training_program: Array<Training_Program>;
  /** fetch aggregated fields from the table: "training_program" */
  training_program_aggregate: Training_Program_Aggregate;
  /** fetch data from the table: "training_program" using primary key columns */
  training_program_by_pk: Maybe<Training_Program>;
  training_specialties: Array<TrainingSpecialty>;
  /** fetch data from the table: "training_survey" */
  training_survey: Array<Training_Survey>;
  /** fetch aggregated fields from the table: "training_survey" */
  training_survey_aggregate: Training_Survey_Aggregate;
  /** fetch data from the table: "training_survey" using primary key columns */
  training_survey_by_pk: Maybe<Training_Survey>;
  /** fetch data from the table: "training_survey_picture" */
  training_survey_picture: Array<Training_Survey_Picture>;
  /** fetch aggregated fields from the table: "training_survey_picture" */
  training_survey_picture_aggregate: Training_Survey_Picture_Aggregate;
  /** fetch data from the table: "training_survey_picture" using primary key columns */
  training_survey_picture_by_pk: Maybe<Training_Survey_Picture>;
  /** fetch data from the table: "training_survey_site" */
  training_survey_site: Array<Training_Survey_Site>;
  /** fetch aggregated fields from the table: "training_survey_site" */
  training_survey_site_aggregate: Training_Survey_Site_Aggregate;
  /** fetch data from the table: "training_survey_site" using primary key columns */
  training_survey_site_by_pk: Maybe<Training_Survey_Site>;
  /** Retrieve a single user */
  user: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type Query_RootAs20DemArgs = {
  distinct_on?: InputMaybe<Array<As20Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Dem_Order_By>>;
  where?: InputMaybe<As20Dem_Bool_Exp>;
};


export type Query_RootAs20Dem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Dem_Order_By>>;
  where?: InputMaybe<As20Dem_Bool_Exp>;
};


export type Query_RootAs20Dem_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs20Svc1Args = {
  distinct_on?: InputMaybe<Array<As20Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc1_Order_By>>;
  where?: InputMaybe<As20Svc1_Bool_Exp>;
};


export type Query_RootAs20Svc1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc1_Order_By>>;
  where?: InputMaybe<As20Svc1_Bool_Exp>;
};


export type Query_RootAs20Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs20Svc2Args = {
  distinct_on?: InputMaybe<Array<As20Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc2_Order_By>>;
  where?: InputMaybe<As20Svc2_Bool_Exp>;
};


export type Query_RootAs20Svc2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc2_Order_By>>;
  where?: InputMaybe<As20Svc2_Bool_Exp>;
};


export type Query_RootAs20Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs20Svc3Args = {
  distinct_on?: InputMaybe<Array<As20Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc3_Order_By>>;
  where?: InputMaybe<As20Svc3_Bool_Exp>;
};


export type Query_RootAs20Svc3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc3_Order_By>>;
  where?: InputMaybe<As20Svc3_Bool_Exp>;
};


export type Query_RootAs20Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs20Util1Args = {
  distinct_on?: InputMaybe<Array<As20Util1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util1_Order_By>>;
  where?: InputMaybe<As20Util1_Bool_Exp>;
};


export type Query_RootAs20Util1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Util1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util1_Order_By>>;
  where?: InputMaybe<As20Util1_Bool_Exp>;
};


export type Query_RootAs20Util1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs20Util2Args = {
  distinct_on?: InputMaybe<Array<As20Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util2_Order_By>>;
  where?: InputMaybe<As20Util2_Bool_Exp>;
};


export type Query_RootAs20Util2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util2_Order_By>>;
  where?: InputMaybe<As20Util2_Bool_Exp>;
};


export type Query_RootAs20Util2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21DemArgs = {
  distinct_on?: InputMaybe<Array<As21Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Dem_Order_By>>;
  where?: InputMaybe<As21Dem_Bool_Exp>;
};


export type Query_RootAs21Dem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Dem_Order_By>>;
  where?: InputMaybe<As21Dem_Bool_Exp>;
};


export type Query_RootAs21Dem_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21Svc1Args = {
  distinct_on?: InputMaybe<Array<As21Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc1_Order_By>>;
  where?: InputMaybe<As21Svc1_Bool_Exp>;
};


export type Query_RootAs21Svc1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc1_Order_By>>;
  where?: InputMaybe<As21Svc1_Bool_Exp>;
};


export type Query_RootAs21Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21Svc2Args = {
  distinct_on?: InputMaybe<Array<As21Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc2_Order_By>>;
  where?: InputMaybe<As21Svc2_Bool_Exp>;
};


export type Query_RootAs21Svc2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc2_Order_By>>;
  where?: InputMaybe<As21Svc2_Bool_Exp>;
};


export type Query_RootAs21Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21Svc3Args = {
  distinct_on?: InputMaybe<Array<As21Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc3_Order_By>>;
  where?: InputMaybe<As21Svc3_Bool_Exp>;
};


export type Query_RootAs21Svc3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc3_Order_By>>;
  where?: InputMaybe<As21Svc3_Bool_Exp>;
};


export type Query_RootAs21Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21UnitArgs = {
  distinct_on?: InputMaybe<Array<As21Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Unit_Order_By>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};


export type Query_RootAs21Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Unit_Order_By>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};


export type Query_RootAs21Unit_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21UtilArgs = {
  distinct_on?: InputMaybe<Array<As21Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util_Order_By>>;
  where?: InputMaybe<As21Util_Bool_Exp>;
};


export type Query_RootAs21Util2Args = {
  distinct_on?: InputMaybe<Array<As21Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util2_Order_By>>;
  where?: InputMaybe<As21Util2_Bool_Exp>;
};


export type Query_RootAs21Util2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util2_Order_By>>;
  where?: InputMaybe<As21Util2_Bool_Exp>;
};


export type Query_RootAs21Util2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs21Util_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util_Order_By>>;
  where?: InputMaybe<As21Util_Bool_Exp>;
};


export type Query_RootAs21Util_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22DemArgs = {
  distinct_on?: InputMaybe<Array<As22Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Dem_Order_By>>;
  where?: InputMaybe<As22Dem_Bool_Exp>;
};


export type Query_RootAs22Dem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Dem_Order_By>>;
  where?: InputMaybe<As22Dem_Bool_Exp>;
};


export type Query_RootAs22Dem_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22Svc1Args = {
  distinct_on?: InputMaybe<Array<As22Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc1_Order_By>>;
  where?: InputMaybe<As22Svc1_Bool_Exp>;
};


export type Query_RootAs22Svc1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc1_Order_By>>;
  where?: InputMaybe<As22Svc1_Bool_Exp>;
};


export type Query_RootAs22Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22Svc2Args = {
  distinct_on?: InputMaybe<Array<As22Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc2_Order_By>>;
  where?: InputMaybe<As22Svc2_Bool_Exp>;
};


export type Query_RootAs22Svc2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc2_Order_By>>;
  where?: InputMaybe<As22Svc2_Bool_Exp>;
};


export type Query_RootAs22Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22Svc3Args = {
  distinct_on?: InputMaybe<Array<As22Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc3_Order_By>>;
  where?: InputMaybe<As22Svc3_Bool_Exp>;
};


export type Query_RootAs22Svc3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc3_Order_By>>;
  where?: InputMaybe<As22Svc3_Bool_Exp>;
};


export type Query_RootAs22Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22UnitArgs = {
  distinct_on?: InputMaybe<Array<As22Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Unit_Order_By>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};


export type Query_RootAs22Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Unit_Order_By>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};


export type Query_RootAs22Unit_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22UtilArgs = {
  distinct_on?: InputMaybe<Array<As22Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util_Order_By>>;
  where?: InputMaybe<As22Util_Bool_Exp>;
};


export type Query_RootAs22Util2Args = {
  distinct_on?: InputMaybe<Array<As22Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util2_Order_By>>;
  where?: InputMaybe<As22Util2_Bool_Exp>;
};


export type Query_RootAs22Util2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util2_Order_By>>;
  where?: InputMaybe<As22Util2_Bool_Exp>;
};


export type Query_RootAs22Util2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAs22Util_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util_Order_By>>;
  where?: InputMaybe<As22Util_Bool_Exp>;
};


export type Query_RootAs22Util_By_PkArgs = {
  ID: Scalars['String'];
};


export type Query_RootAb_TestArgs = {
  distinct_on?: InputMaybe<Array<Ab_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ab_Test_Order_By>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


export type Query_RootAb_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ab_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ab_Test_Order_By>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


export type Query_RootAb_Test_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAccess_InfoArgs = {
  distinct_on?: InputMaybe<Array<Access_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Access_Info_Order_By>>;
  where?: InputMaybe<Access_Info_Bool_Exp>;
};


export type Query_RootAccess_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Access_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Access_Info_Order_By>>;
  where?: InputMaybe<Access_Info_Bool_Exp>;
};


export type Query_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccount_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAccount_RoleArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


export type Query_RootAccount_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


export type Query_RootAccount_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAcep_Org_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acep_Org_Survey_Order_By>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


export type Query_RootAcep_Org_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acep_Org_Survey_Order_By>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


export type Query_RootAcep_Org_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type Query_RootAssetVersionArgs = {
  where: VersionWhereInput;
};


export type Query_RootAssetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type Query_RootAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type Query_RootBoardArgs = {
  distinct_on?: InputMaybe<Array<Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Order_By>>;
  where?: InputMaybe<Board_Bool_Exp>;
};


export type Query_RootBoard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Order_By>>;
  where?: InputMaybe<Board_Bool_Exp>;
};


export type Query_RootBoard_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBoard_CertArgs = {
  distinct_on?: InputMaybe<Array<Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Cert_Order_By>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};


export type Query_RootBoard_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Cert_Order_By>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};


export type Query_RootBoard_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCandidateArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


export type Query_RootCandidate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


export type Query_RootCandidate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCert_OrgArgs = {
  distinct_on?: InputMaybe<Array<Cert_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cert_Org_Order_By>>;
  where?: InputMaybe<Cert_Org_Bool_Exp>;
};


export type Query_RootCert_Org_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cert_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cert_Org_Order_By>>;
  where?: InputMaybe<Cert_Org_Bool_Exp>;
};


export type Query_RootCert_Org_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClerkshipArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Order_By>>;
  where?: InputMaybe<Clerkship_Bool_Exp>;
};


export type Query_RootClerkship_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Order_By>>;
  where?: InputMaybe<Clerkship_Bool_Exp>;
};


export type Query_RootClerkship_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClerkship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


export type Query_RootClerkship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


export type Query_RootClerkship_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinicianArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Order_By>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


export type Query_RootClinician_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Order_By>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


export type Query_RootClinician_App_CertArgs = {
  distinct_on?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_App_Cert_Order_By>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


export type Query_RootClinician_App_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_App_Cert_Order_By>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


export type Query_RootClinician_App_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinician_Board_CertArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Board_Cert_Order_By>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


export type Query_RootClinician_Board_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Board_Cert_Order_By>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


export type Query_RootClinician_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinician_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinician_LicenseArgs = {
  distinct_on?: InputMaybe<Array<Clinician_License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_License_Order_By>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


export type Query_RootClinician_License_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_License_Order_By>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


export type Query_RootClinician_License_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinician_Sp_ExpArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Sp_Exp_Order_By>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


export type Query_RootClinician_Sp_Exp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Sp_Exp_Order_By>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


export type Query_RootClinician_Sp_Exp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinician_SpecialtyArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Specialty_Order_By>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


export type Query_RootClinician_Specialty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Specialty_Order_By>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


export type Query_RootClinician_Specialty_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootClinician_TrainingArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Training_Order_By>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};


export type Query_RootClinician_Training_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Training_Order_By>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};


export type Query_RootClinician_Training_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCms_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Order_By>>;
  where?: InputMaybe<Cms_Facility_Bool_Exp>;
};


export type Query_RootCms_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Order_By>>;
  where?: InputMaybe<Cms_Facility_Bool_Exp>;
};


export type Query_RootCms_Facility_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCms_Facility_EnrollmentArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Enrollment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Enrollment_Order_By>>;
  where?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
};


export type Query_RootCms_Facility_Enrollment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Enrollment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Enrollment_Order_By>>;
  where?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
};


export type Query_RootCms_Facility_Enrollment_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCms_Facility_MetricArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Metric_Order_By>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};


export type Query_RootCms_Facility_Metric_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Metric_Order_By>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};


export type Query_RootCms_Facility_Metric_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCms_Facility_PosArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Pos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Pos_Order_By>>;
  where?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
};


export type Query_RootCms_Facility_Pos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Pos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Pos_Order_By>>;
  where?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
};


export type Query_RootCms_Facility_Pos_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCms_SpecialtyArgs = {
  distinct_on?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Specialty_Order_By>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


export type Query_RootCms_Specialty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Specialty_Order_By>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


export type Query_RootCms_Specialty_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootContact_InfoArgs = {
  distinct_on?: InputMaybe<Array<Contact_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Info_Order_By>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


export type Query_RootContact_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Info_Order_By>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


export type Query_RootCurrent_AccountArgs = {
  distinct_on?: InputMaybe<Array<Current_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Current_Account_Order_By>>;
  where?: InputMaybe<Current_Account_Bool_Exp>;
};


export type Query_RootCurrent_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Current_Account_Order_By>>;
  where?: InputMaybe<Current_Account_Bool_Exp>;
};


export type Query_RootCustomer_By_Org_IdArgs = {
  org_id: Scalars['String'];
};


export type Query_RootEmail_ContactArgs = {
  distinct_on?: InputMaybe<Array<Email_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Contact_Order_By>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


export type Query_RootEmail_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Contact_Order_By>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


export type Query_RootEmail_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_EnvelopeArgs = {
  distinct_on?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Envelope_Order_By>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


export type Query_RootEmail_Envelope_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Envelope_Order_By>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


export type Query_RootEmail_Envelope_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_EventArgs = {
  distinct_on?: InputMaybe<Array<Email_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Event_Order_By>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


export type Query_RootEmail_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Event_Order_By>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


export type Query_RootEmail_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_MessageArgs = {
  distinct_on?: InputMaybe<Array<Email_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Message_Order_By>>;
  where?: InputMaybe<Email_Message_Bool_Exp>;
};


export type Query_RootEmail_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Message_Order_By>>;
  where?: InputMaybe<Email_Message_Bool_Exp>;
};


export type Query_RootEmail_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_PointerArgs = {
  distinct_on?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Pointer_Order_By>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};


export type Query_RootEmail_Pointer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Pointer_Order_By>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};


export type Query_RootEmail_Pointer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEmail_SuppressionsArgs = {
  token: Scalars['String'];
};


export type Query_RootEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type Query_RootExt_Job_PostingArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


export type Query_RootExt_Job_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


export type Query_RootExt_Job_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExt_Job_ScrapeArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Scrape_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Scrape_Order_By>>;
  where?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
};


export type Query_RootExt_Job_Scrape_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Scrape_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Scrape_Order_By>>;
  where?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
};


export type Query_RootExt_Job_Scrape_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExt_Posting_ErrorArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Error_Order_By>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


export type Query_RootExt_Posting_Error_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Error_Order_By>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


export type Query_RootExt_Posting_Error_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExt_Posting_ProfessionArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Profession_Order_By>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};


export type Query_RootExt_Posting_Profession_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Profession_Order_By>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};


export type Query_RootExt_Posting_Profession_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacilityArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


export type Query_RootFacility_AccreditationArgs = {
  distinct_on?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Accreditation_Order_By>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


export type Query_RootFacility_Accreditation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Accreditation_Order_By>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


export type Query_RootFacility_Accreditation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


export type Query_RootFacility_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacility_ContractArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


export type Query_RootFacility_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


export type Query_RootFacility_Contract_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacility_Contract_FeaturedArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Featured_Order_By>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


export type Query_RootFacility_Contract_Featured_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Featured_Order_By>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


export type Query_RootFacility_Contract_Featured_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacility_CorrectionArgs = {
  distinct_on?: InputMaybe<Array<Facility_Correction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Correction_Order_By>>;
  where?: InputMaybe<Facility_Correction_Bool_Exp>;
};


export type Query_RootFacility_Correction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Correction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Correction_Order_By>>;
  where?: InputMaybe<Facility_Correction_Bool_Exp>;
};


export type Query_RootFacility_Correction_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacility_DistArgs = {
  args: Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Query_RootFacility_Dist_AggregateArgs = {
  args: Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Query_RootFacility_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Query_RootFacility_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Query_RootFacility_EhrArgs = {
  distinct_on?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Ehr_Order_By>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


export type Query_RootFacility_Ehr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Ehr_Order_By>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


export type Query_RootFacility_Ehr_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFacility_RatingArgs = {
  distinct_on?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Rating_Order_By>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


export type Query_RootFacility_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Rating_Order_By>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


export type Query_RootFaqArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FaqWhereUniqueInput;
};


export type Query_RootFaqVersionArgs = {
  where: VersionWhereInput;
};


export type Query_RootFaqsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FaqWhereInput>;
};


export type Query_RootFaqsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FaqOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<FaqWhereInput>;
};


export type Query_RootFavoriteArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Favorite_Order_By>>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};


export type Query_RootFavorite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Favorite_Order_By>>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};


export type Query_RootFavorite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeatured_Clerkship_DistArgs = {
  args: Featured_Clerkship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Clerkship_Dist_AggregateArgs = {
  args: Featured_Clerkship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Clerkship_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Clerkship_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Fellowship_DistArgs = {
  args: Featured_Fellowship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Fellowship_Dist_AggregateArgs = {
  args: Featured_Fellowship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Fellowship_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Fellowship_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Residency_DistArgs = {
  args: Featured_Residency_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Residency_Dist_AggregateArgs = {
  args: Featured_Residency_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Residency_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Query_RootFeatured_Residency_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Query_RootFellowshipArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Order_By>>;
  where?: InputMaybe<Fellowship_Bool_Exp>;
};


export type Query_RootFellowship_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Order_By>>;
  where?: InputMaybe<Fellowship_Bool_Exp>;
};


export type Query_RootFellowship_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFellowship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


export type Query_RootFellowship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


export type Query_RootFellowship_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFsmb_BioArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Bio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Bio_Order_By>>;
  where?: InputMaybe<Fsmb_Bio_Bool_Exp>;
};


export type Query_RootFsmb_Bio_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Bio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Bio_Order_By>>;
  where?: InputMaybe<Fsmb_Bio_Bool_Exp>;
};


export type Query_RootFsmb_Bio_By_PkArgs = {
  fid: Scalars['String'];
};


export type Query_RootFsmb_LicensureArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Licensure_Order_By>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};


export type Query_RootFsmb_Licensure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Licensure_Order_By>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};


export type Query_RootFsmb_Licensure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGet_Subscription_Invoice_PreviewArgs = {
  address: CustomerAddressInput;
  interval: Scalars['String'];
  org_id?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};


export type Query_RootGmaps_LinkArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Bool_Exp>;
};


export type Query_RootGmaps_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Bool_Exp>;
};


export type Query_RootGmaps_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGmaps_Link_TypeArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Type_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};


export type Query_RootGmaps_Link_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Type_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};


export type Query_RootGmaps_Link_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGmaps_PlaceArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Place_Order_By>>;
  where?: InputMaybe<Gmaps_Place_Bool_Exp>;
};


export type Query_RootGmaps_Place_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Place_Order_By>>;
  where?: InputMaybe<Gmaps_Place_Bool_Exp>;
};


export type Query_RootGmaps_Place_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootIdentity_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Identity_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Provider_Order_By>>;
  where?: InputMaybe<Identity_Provider_Bool_Exp>;
};


export type Query_RootIdentity_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Provider_Order_By>>;
  where?: InputMaybe<Identity_Provider_Bool_Exp>;
};


export type Query_RootIdentity_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootJob_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


export type Query_RootJob_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


export type Query_RootJob_Application_BatchArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Batch_Order_By>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};


export type Query_RootJob_Application_Batch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Batch_Order_By>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};


export type Query_RootJob_Application_Batch_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootJob_Application_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootJob_Application_PostingArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


export type Query_RootJob_Application_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


export type Query_RootJob_Application_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootJob_PostingArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


export type Query_RootJob_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


export type Query_RootJob_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLatest_Clerkship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Latest_Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
};


export type Query_RootLatest_Clerkship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
};


export type Query_RootLatest_Fellowship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Latest_Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
};


export type Query_RootLatest_Fellowship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
};


export type Query_RootLatest_Residency_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Latest_Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Residency_Survey_Order_By>>;
  where?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
};


export type Query_RootLatest_Residency_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Residency_Survey_Order_By>>;
  where?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
};


export type Query_RootLegalArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LegalWhereUniqueInput;
};


export type Query_RootLegalVersionArgs = {
  where: VersionWhereInput;
};


export type Query_RootLegalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LegalOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<LegalWhereInput>;
};


export type Query_RootLegalsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LegalOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<LegalWhereInput>;
};


export type Query_RootNearby_Facilities_By_GeographyArgs = {
  args: Nearby_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Query_RootNearby_Facilities_By_Geography_AggregateArgs = {
  args: Nearby_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Query_RootNearby_Facilities_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Query_RootNearby_Facilities_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Query_RootNodeArgs = {
  id: Scalars['ID'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type Query_RootOrg_DistArgs = {
  args: Org_Dist_Args;
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Query_RootOrg_Dist_AggregateArgs = {
  args: Org_Dist_Args;
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Query_RootOrg_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Query_RootOrg_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Query_RootOrg_DomainArgs = {
  distinct_on?: InputMaybe<Array<Org_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Domain_Order_By>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


export type Query_RootOrg_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Domain_Order_By>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


export type Query_RootOrg_Domain_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_MarketArgs = {
  distinct_on?: InputMaybe<Array<Org_Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Market_Order_By>>;
  where?: InputMaybe<Org_Market_Bool_Exp>;
};


export type Query_RootOrg_Market_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Market_Order_By>>;
  where?: InputMaybe<Org_Market_Bool_Exp>;
};


export type Query_RootOrg_RatingArgs = {
  distinct_on?: InputMaybe<Array<Org_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Rating_Order_By>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


export type Query_RootOrg_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Rating_Order_By>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


export type Query_RootOrg_UserArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Order_By>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


export type Query_RootOrg_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Order_By>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


export type Query_RootOrg_User_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_BoundsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Bounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Bounds_Order_By>>;
  where?: InputMaybe<Organization_Bounds_Bool_Exp>;
};


export type Query_RootOrganization_Bounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Bounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Bounds_Order_By>>;
  where?: InputMaybe<Organization_Bounds_Bool_Exp>;
};


export type Query_RootOrganization_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_Job_PostingArgs = {
  distinct_on?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Job_Posting_Order_By>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


export type Query_RootOrganization_Job_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Job_Posting_Order_By>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


export type Query_RootPersonal_InfoArgs = {
  distinct_on?: InputMaybe<Array<Personal_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Personal_Info_Order_By>>;
  where?: InputMaybe<Personal_Info_Bool_Exp>;
};


export type Query_RootPersonal_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Personal_Info_Order_By>>;
  where?: InputMaybe<Personal_Info_Bool_Exp>;
};


export type Query_RootPlace_BoundaryArgs = {
  distinct_on?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Place_Boundary_Order_By>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


export type Query_RootPlace_Boundary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Place_Boundary_Order_By>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


export type Query_RootPlace_Boundary_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPostArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PostWhereUniqueInput;
};


export type Query_RootPostVersionArgs = {
  where: VersionWhereInput;
};


export type Query_RootPosting_App_CertArgs = {
  distinct_on?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_App_Cert_Order_By>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


export type Query_RootPosting_App_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_App_Cert_Order_By>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


export type Query_RootPosting_App_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPosting_Board_CertArgs = {
  distinct_on?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Board_Cert_Order_By>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


export type Query_RootPosting_Board_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Board_Cert_Order_By>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


export type Query_RootPosting_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPosting_Latest_PublicationArgs = {
  distinct_on?: InputMaybe<Array<Posting_Latest_Publication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Latest_Publication_Order_By>>;
  where?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
};


export type Query_RootPosting_Latest_Publication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Latest_Publication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Latest_Publication_Order_By>>;
  where?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
};


export type Query_RootPosting_ProfessionArgs = {
  distinct_on?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Profession_Order_By>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


export type Query_RootPosting_Profession_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Profession_Order_By>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


export type Query_RootPosting_Profession_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPosting_Worker_ClassificationArgs = {
  distinct_on?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Worker_Classification_Order_By>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};


export type Query_RootPosting_Worker_Classification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Worker_Classification_Order_By>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};


export type Query_RootPosting_Worker_Classification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PostWhereInput>;
};


export type Query_RootPostsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PostOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<PostWhereInput>;
};


export type Query_RootRanked_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootRanked_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootRanked_Facility_DistArgs = {
  args: Ranked_Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootRanked_Facility_Dist_AggregateArgs = {
  args: Ranked_Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootRelevant_Job_PostingArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Query_RootRelevant_Job_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Query_RootRelevant_Salary_ReportArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Query_RootRelevant_Salary_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Query_RootResidencyArgs = {
  distinct_on?: InputMaybe<Array<Residency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Order_By>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


export type Query_RootResidency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Residency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Order_By>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


export type Query_RootResidency_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootResidency_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Survey_Order_By>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};


export type Query_RootResidency_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Survey_Order_By>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};


export type Query_RootResidency_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootResolve_City_Place_IdArgs = {
  city: Scalars['String'];
  state: Scalars['String'];
};


export type Query_RootReviewArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Query_RootReview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Query_RootReview_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReview_ReplyArgs = {
  distinct_on?: InputMaybe<Array<Review_Reply_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Reply_Order_By>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


export type Query_RootReview_Reply_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Reply_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Reply_Order_By>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


export type Query_RootReview_Reply_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReview_ReportArgs = {
  distinct_on?: InputMaybe<Array<Review_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Report_Order_By>>;
  where?: InputMaybe<Review_Report_Bool_Exp>;
};


export type Query_RootReview_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Report_Order_By>>;
  where?: InputMaybe<Review_Report_Bool_Exp>;
};


export type Query_RootReview_Report_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootReview_VoteArgs = {
  distinct_on?: InputMaybe<Array<Review_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Vote_Order_By>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};


export type Query_RootReview_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Vote_Order_By>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};


export type Query_RootReview_Vote_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSalary_ReportArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


export type Query_RootSalary_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


export type Query_RootSalary_Report_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSalary_Report_FmtArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


export type Query_RootSalary_Report_Fmt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


export type Query_RootScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type Query_RootScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type Query_RootScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type Query_RootScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type Query_RootScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type Query_RootScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type Query_RootSchoolArgs = {
  distinct_on?: InputMaybe<Array<School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Order_By>>;
  where?: InputMaybe<School_Bool_Exp>;
};


export type Query_RootSchool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Order_By>>;
  where?: InputMaybe<School_Bool_Exp>;
};


export type Query_RootSchool_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSearch_CandidateArgs = {
  args: Search_Candidate_Args;
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Query_RootSearch_Candidate_AggregateArgs = {
  args: Search_Candidate_Args;
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Query_RootSearch_Candidate_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Query_RootSearch_Candidate_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Query_RootSearch_Clerkship_By_GeographyArgs = {
  args: Search_Clerkship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Clerkship_By_Geography_AggregateArgs = {
  args: Search_Clerkship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Clerkship_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Clerkship_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Facility_By_PrefixArgs = {
  args: Search_Facility_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Facility_By_Prefix_AggregateArgs = {
  args: Search_Facility_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Facility_By_Prefix_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Facility_By_Prefix_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Fellowship_By_GeographyArgs = {
  args: Search_Fellowship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Fellowship_By_Geography_AggregateArgs = {
  args: Search_Fellowship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Fellowship_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Fellowship_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Fsmb_BioArgs = {
  args: Search_Fsmb_Bio_Args;
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Query_RootSearch_Fsmb_Bio_AggregateArgs = {
  args: Search_Fsmb_Bio_Args;
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Query_RootSearch_Fsmb_Bio_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Query_RootSearch_Fsmb_Bio_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Query_RootSearch_Job_Postings_By_GeographyArgs = {
  args: Search_Job_Postings_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Job_Postings_By_Geography_AggregateArgs = {
  args: Search_Job_Postings_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Job_Postings_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Job_Postings_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Org_MarketArgs = {
  args: Search_Org_Market_Args;
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Query_RootSearch_Org_Market_AggregateArgs = {
  args: Search_Org_Market_Args;
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Query_RootSearch_Org_Market_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Query_RootSearch_Org_Market_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Query_RootSearch_Organization_By_PrefixArgs = {
  args: Search_Organization_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Organization_By_Prefix_AggregateArgs = {
  args: Search_Organization_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Organization_By_Prefix_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Organization_By_Prefix_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Ranked_Facilities_By_GeographyArgs = {
  args: Search_Ranked_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootSearch_Ranked_Facilities_By_Geography_AggregateArgs = {
  args: Search_Ranked_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootSearch_Relevant_Job_PostingArgs = {
  args?: InputMaybe<Search_Relevant_Job_Posting_Args>;
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Query_RootSearch_Relevant_Job_Posting_AggregateArgs = {
  args?: InputMaybe<Search_Relevant_Job_Posting_Args>;
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Query_RootSearch_Relevant_Salary_ReportArgs = {
  args: Search_Relevant_Salary_Report_Args;
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Query_RootSearch_Relevant_Salary_Report_AggregateArgs = {
  args: Search_Relevant_Salary_Report_Args;
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Query_RootSearch_Residency_By_GeographyArgs = {
  args: Search_Residency_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Residency_By_Geography_AggregateArgs = {
  args: Search_Residency_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Residency_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Residency_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Query_RootSearch_Training_By_PrefixArgs = {
  args: Search_Training_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Training_By_Prefix_AggregateArgs = {
  args: Search_Training_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Training_By_Prefix_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSearch_Training_By_Prefix_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Query_RootSiteArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Query_RootSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Query_RootSite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootStroke_CertArgs = {
  distinct_on?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stroke_Cert_Order_By>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};


export type Query_RootStroke_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stroke_Cert_Order_By>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};


export type Query_RootStroke_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSuggest_Ranked_FacilitiesArgs = {
  args: Suggest_Ranked_Facilities_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootSuggest_Ranked_Facilities_AggregateArgs = {
  args: Suggest_Ranked_Facilities_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Query_RootTeammateArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TeammateWhereUniqueInput;
};


export type Query_RootTeammateVersionArgs = {
  where: VersionWhereInput;
};


export type Query_RootTeammatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeammateOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TeammateWhereInput>;
};


export type Query_RootTeammatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TeammateOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<TeammateWhereInput>;
};


export type Query_RootTrainingArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Query_RootTraining_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Query_RootTraining_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTraining_EventArgs = {
  distinct_on?: InputMaybe<Array<Training_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Event_Order_By>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


export type Query_RootTraining_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Event_Order_By>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


export type Query_RootTraining_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTraining_FieldArgs = {
  distinct_on?: InputMaybe<Array<Training_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Field_Order_By>>;
  where?: InputMaybe<Training_Field_Bool_Exp>;
};


export type Query_RootTraining_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Field_Order_By>>;
  where?: InputMaybe<Training_Field_Bool_Exp>;
};


export type Query_RootTraining_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTraining_ProgramArgs = {
  distinct_on?: InputMaybe<Array<Training_Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Program_Order_By>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};


export type Query_RootTraining_Program_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Program_Order_By>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};


export type Query_RootTraining_Program_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTraining_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Order_By>>;
  where?: InputMaybe<Training_Survey_Bool_Exp>;
};


export type Query_RootTraining_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Order_By>>;
  where?: InputMaybe<Training_Survey_Bool_Exp>;
};


export type Query_RootTraining_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTraining_Survey_PictureArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


export type Query_RootTraining_Survey_Picture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


export type Query_RootTraining_Survey_Picture_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTraining_Survey_SiteArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Site_Order_By>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};


export type Query_RootTraining_Survey_Site_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Site_Order_By>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};


export type Query_RootTraining_Survey_Site_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type Query_RootUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type Query_RootUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};

/** columns and relationships of "ranked_facility" */
export type Ranked_Facility = {
  __typename?: 'ranked_facility';
  distance: Maybe<Scalars['float8']>;
  /** An object relationship */
  facility: Maybe<Facility>;
  featured: Maybe<Scalars['Boolean']>;
  has_posting: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['uuid']>;
  max_norm_rate: Maybe<Scalars['Int']>;
  org_active: Maybe<Scalars['Boolean']>;
  org_verified: Maybe<Scalars['Boolean']>;
  profession: Maybe<Scalars['profession']>;
};

/** aggregated selection of "ranked_facility" */
export type Ranked_Facility_Aggregate = {
  __typename?: 'ranked_facility_aggregate';
  aggregate: Maybe<Ranked_Facility_Aggregate_Fields>;
  nodes: Array<Ranked_Facility>;
};

/** aggregate fields of "ranked_facility" */
export type Ranked_Facility_Aggregate_Fields = {
  __typename?: 'ranked_facility_aggregate_fields';
  avg: Maybe<Ranked_Facility_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Ranked_Facility_Max_Fields>;
  min: Maybe<Ranked_Facility_Min_Fields>;
  stddev: Maybe<Ranked_Facility_Stddev_Fields>;
  stddev_pop: Maybe<Ranked_Facility_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Ranked_Facility_Stddev_Samp_Fields>;
  sum: Maybe<Ranked_Facility_Sum_Fields>;
  var_pop: Maybe<Ranked_Facility_Var_Pop_Fields>;
  var_samp: Maybe<Ranked_Facility_Var_Samp_Fields>;
  variance: Maybe<Ranked_Facility_Variance_Fields>;
};


/** aggregate fields of "ranked_facility" */
export type Ranked_Facility_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Ranked_Facility_Avg_Fields = {
  __typename?: 'ranked_facility_avg_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "ranked_facility". All fields are combined with a logical 'AND'. */
export type Ranked_Facility_Bool_Exp = {
  _and?: InputMaybe<Array<Ranked_Facility_Bool_Exp>>;
  _not?: InputMaybe<Ranked_Facility_Bool_Exp>;
  _or?: InputMaybe<Array<Ranked_Facility_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  has_posting?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max_norm_rate?: InputMaybe<Int_Comparison_Exp>;
  org_active?: InputMaybe<Boolean_Comparison_Exp>;
  org_verified?: InputMaybe<Boolean_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
};

export type Ranked_Facility_Dist_Args = {
  x?: InputMaybe<Scalars['float8']>;
  y?: InputMaybe<Scalars['float8']>;
};

/** aggregate max on columns */
export type Ranked_Facility_Max_Fields = {
  __typename?: 'ranked_facility_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  max_norm_rate: Maybe<Scalars['Int']>;
  profession: Maybe<Scalars['profession']>;
};

/** aggregate min on columns */
export type Ranked_Facility_Min_Fields = {
  __typename?: 'ranked_facility_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  max_norm_rate: Maybe<Scalars['Int']>;
  profession: Maybe<Scalars['profession']>;
};

/** Ordering options when selecting data from "ranked_facility". */
export type Ranked_Facility_Order_By = {
  distance?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  featured?: InputMaybe<Order_By>;
  has_posting?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_norm_rate?: InputMaybe<Order_By>;
  org_active?: InputMaybe<Order_By>;
  org_verified?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
};

/** select columns of table "ranked_facility" */
export enum Ranked_Facility_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Featured = 'featured',
  /** column name */
  HasPosting = 'has_posting',
  /** column name */
  Id = 'id',
  /** column name */
  MaxNormRate = 'max_norm_rate',
  /** column name */
  OrgActive = 'org_active',
  /** column name */
  OrgVerified = 'org_verified',
  /** column name */
  Profession = 'profession'
}

/** aggregate stddev on columns */
export type Ranked_Facility_Stddev_Fields = {
  __typename?: 'ranked_facility_stddev_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Ranked_Facility_Stddev_Pop_Fields = {
  __typename?: 'ranked_facility_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Ranked_Facility_Stddev_Samp_Fields = {
  __typename?: 'ranked_facility_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "ranked_facility" */
export type Ranked_Facility_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ranked_Facility_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ranked_Facility_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  has_posting?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  max_norm_rate?: InputMaybe<Scalars['Int']>;
  org_active?: InputMaybe<Scalars['Boolean']>;
  org_verified?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
};

/** aggregate sum on columns */
export type Ranked_Facility_Sum_Fields = {
  __typename?: 'ranked_facility_sum_fields';
  distance: Maybe<Scalars['float8']>;
  max_norm_rate: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Ranked_Facility_Var_Pop_Fields = {
  __typename?: 'ranked_facility_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Ranked_Facility_Var_Samp_Fields = {
  __typename?: 'ranked_facility_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Ranked_Facility_Variance_Fields = {
  __typename?: 'ranked_facility_variance_fields';
  distance: Maybe<Scalars['Float']>;
  max_norm_rate: Maybe<Scalars['Float']>;
};

/** columns and relationships of "relevant_job_posting" */
export type Relevant_Job_Posting = {
  __typename?: 'relevant_job_posting';
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  job_posting: Maybe<Job_Posting>;
  relevance: Maybe<Scalars['Float']>;
};

/** aggregated selection of "relevant_job_posting" */
export type Relevant_Job_Posting_Aggregate = {
  __typename?: 'relevant_job_posting_aggregate';
  aggregate: Maybe<Relevant_Job_Posting_Aggregate_Fields>;
  nodes: Array<Relevant_Job_Posting>;
};

/** aggregate fields of "relevant_job_posting" */
export type Relevant_Job_Posting_Aggregate_Fields = {
  __typename?: 'relevant_job_posting_aggregate_fields';
  avg: Maybe<Relevant_Job_Posting_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Relevant_Job_Posting_Max_Fields>;
  min: Maybe<Relevant_Job_Posting_Min_Fields>;
  stddev: Maybe<Relevant_Job_Posting_Stddev_Fields>;
  stddev_pop: Maybe<Relevant_Job_Posting_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Relevant_Job_Posting_Stddev_Samp_Fields>;
  sum: Maybe<Relevant_Job_Posting_Sum_Fields>;
  var_pop: Maybe<Relevant_Job_Posting_Var_Pop_Fields>;
  var_samp: Maybe<Relevant_Job_Posting_Var_Samp_Fields>;
  variance: Maybe<Relevant_Job_Posting_Variance_Fields>;
};


/** aggregate fields of "relevant_job_posting" */
export type Relevant_Job_Posting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Relevant_Job_Posting_Avg_Fields = {
  __typename?: 'relevant_job_posting_avg_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "relevant_job_posting". All fields are combined with a logical 'AND'. */
export type Relevant_Job_Posting_Bool_Exp = {
  _and?: InputMaybe<Array<Relevant_Job_Posting_Bool_Exp>>;
  _not?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
  _or?: InputMaybe<Array<Relevant_Job_Posting_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_posting?: InputMaybe<Job_Posting_Bool_Exp>;
  relevance?: InputMaybe<Float_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "relevant_job_posting" */
export type Relevant_Job_Posting_Inc_Input = {
  relevance?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "relevant_job_posting" */
export type Relevant_Job_Posting_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  job_posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Relevant_Job_Posting_Max_Fields = {
  __typename?: 'relevant_job_posting_max_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Relevant_Job_Posting_Min_Fields = {
  __typename?: 'relevant_job_posting_min_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "relevant_job_posting" */
export type Relevant_Job_Posting_Mutation_Response = {
  __typename?: 'relevant_job_posting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relevant_Job_Posting>;
};

/** Ordering options when selecting data from "relevant_job_posting". */
export type Relevant_Job_Posting_Order_By = {
  id?: InputMaybe<Order_By>;
  job_posting?: InputMaybe<Job_Posting_Order_By>;
  relevance?: InputMaybe<Order_By>;
};

/** select columns of table "relevant_job_posting" */
export enum Relevant_Job_Posting_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Relevance = 'relevance'
}

/** input type for updating data in table "relevant_job_posting" */
export type Relevant_Job_Posting_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Relevant_Job_Posting_Stddev_Fields = {
  __typename?: 'relevant_job_posting_stddev_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Relevant_Job_Posting_Stddev_Pop_Fields = {
  __typename?: 'relevant_job_posting_stddev_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Relevant_Job_Posting_Stddev_Samp_Fields = {
  __typename?: 'relevant_job_posting_stddev_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "relevant_job_posting" */
export type Relevant_Job_Posting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relevant_Job_Posting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relevant_Job_Posting_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Relevant_Job_Posting_Sum_Fields = {
  __typename?: 'relevant_job_posting_sum_fields';
  relevance: Maybe<Scalars['Float']>;
};

export type Relevant_Job_Posting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Relevant_Job_Posting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relevant_Job_Posting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relevant_Job_Posting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Relevant_Job_Posting_Var_Pop_Fields = {
  __typename?: 'relevant_job_posting_var_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Relevant_Job_Posting_Var_Samp_Fields = {
  __typename?: 'relevant_job_posting_var_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Relevant_Job_Posting_Variance_Fields = {
  __typename?: 'relevant_job_posting_variance_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** columns and relationships of "relevant_salary_report" */
export type Relevant_Salary_Report = {
  __typename?: 'relevant_salary_report';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
  /** An object relationship */
  salary_report_fmt: Maybe<Salary_Report_Fmt>;
};

/** aggregated selection of "relevant_salary_report" */
export type Relevant_Salary_Report_Aggregate = {
  __typename?: 'relevant_salary_report_aggregate';
  aggregate: Maybe<Relevant_Salary_Report_Aggregate_Fields>;
  nodes: Array<Relevant_Salary_Report>;
};

/** aggregate fields of "relevant_salary_report" */
export type Relevant_Salary_Report_Aggregate_Fields = {
  __typename?: 'relevant_salary_report_aggregate_fields';
  avg: Maybe<Relevant_Salary_Report_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Relevant_Salary_Report_Max_Fields>;
  min: Maybe<Relevant_Salary_Report_Min_Fields>;
  stddev: Maybe<Relevant_Salary_Report_Stddev_Fields>;
  stddev_pop: Maybe<Relevant_Salary_Report_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Relevant_Salary_Report_Stddev_Samp_Fields>;
  sum: Maybe<Relevant_Salary_Report_Sum_Fields>;
  var_pop: Maybe<Relevant_Salary_Report_Var_Pop_Fields>;
  var_samp: Maybe<Relevant_Salary_Report_Var_Samp_Fields>;
  variance: Maybe<Relevant_Salary_Report_Variance_Fields>;
};


/** aggregate fields of "relevant_salary_report" */
export type Relevant_Salary_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Relevant_Salary_Report_Avg_Fields = {
  __typename?: 'relevant_salary_report_avg_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "relevant_salary_report". All fields are combined with a logical 'AND'. */
export type Relevant_Salary_Report_Bool_Exp = {
  _and?: InputMaybe<Array<Relevant_Salary_Report_Bool_Exp>>;
  _not?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
  _or?: InputMaybe<Array<Relevant_Salary_Report_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  relevance?: InputMaybe<Float_Comparison_Exp>;
  salary_report_fmt?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "relevant_salary_report" */
export type Relevant_Salary_Report_Inc_Input = {
  relevance?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "relevant_salary_report" */
export type Relevant_Salary_Report_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
  salary_report_fmt?: InputMaybe<Salary_Report_Fmt_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Relevant_Salary_Report_Max_Fields = {
  __typename?: 'relevant_salary_report_max_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Relevant_Salary_Report_Min_Fields = {
  __typename?: 'relevant_salary_report_min_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "relevant_salary_report" */
export type Relevant_Salary_Report_Mutation_Response = {
  __typename?: 'relevant_salary_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relevant_Salary_Report>;
};

/** Ordering options when selecting data from "relevant_salary_report". */
export type Relevant_Salary_Report_Order_By = {
  id?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  salary_report_fmt?: InputMaybe<Salary_Report_Fmt_Order_By>;
};

/** select columns of table "relevant_salary_report" */
export enum Relevant_Salary_Report_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Relevance = 'relevance'
}

/** input type for updating data in table "relevant_salary_report" */
export type Relevant_Salary_Report_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Relevant_Salary_Report_Stddev_Fields = {
  __typename?: 'relevant_salary_report_stddev_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Relevant_Salary_Report_Stddev_Pop_Fields = {
  __typename?: 'relevant_salary_report_stddev_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Relevant_Salary_Report_Stddev_Samp_Fields = {
  __typename?: 'relevant_salary_report_stddev_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "relevant_salary_report" */
export type Relevant_Salary_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relevant_Salary_Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relevant_Salary_Report_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Relevant_Salary_Report_Sum_Fields = {
  __typename?: 'relevant_salary_report_sum_fields';
  relevance: Maybe<Scalars['Float']>;
};

export type Relevant_Salary_Report_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Relevant_Salary_Report_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relevant_Salary_Report_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relevant_Salary_Report_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Relevant_Salary_Report_Var_Pop_Fields = {
  __typename?: 'relevant_salary_report_var_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Relevant_Salary_Report_Var_Samp_Fields = {
  __typename?: 'relevant_salary_report_var_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Relevant_Salary_Report_Variance_Fields = {
  __typename?: 'relevant_salary_report_variance_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** columns and relationships of "residency" */
export type Residency = {
  __typename?: 'residency';
  /** An array relationship */
  clerkship_surveys: Array<Clerkship_Survey>;
  /** An aggregate relationship */
  clerkship_surveys_aggregate: Clerkship_Survey_Aggregate;
  emrafied: Scalars['Boolean'];
  /** An array relationship */
  fellowship_surveys: Array<Fellowship_Survey>;
  /** An aggregate relationship */
  fellowship_surveys_aggregate: Fellowship_Survey_Aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  latest_survey: Maybe<Latest_Residency_Survey>;
  pd_interview: Scalars['String'];
  /** An array relationship */
  surveys: Array<Residency_Survey>;
  /** An aggregate relationship */
  surveys_aggregate: Residency_Survey_Aggregate;
  /** An object relationship */
  training: Training;
};


/** columns and relationships of "residency" */
export type ResidencyClerkship_SurveysArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


/** columns and relationships of "residency" */
export type ResidencyClerkship_Surveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


/** columns and relationships of "residency" */
export type ResidencyFellowship_SurveysArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


/** columns and relationships of "residency" */
export type ResidencyFellowship_Surveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


/** columns and relationships of "residency" */
export type ResidencySurveysArgs = {
  distinct_on?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Survey_Order_By>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};


/** columns and relationships of "residency" */
export type ResidencySurveys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Survey_Order_By>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};

/** aggregated selection of "residency" */
export type Residency_Aggregate = {
  __typename?: 'residency_aggregate';
  aggregate: Maybe<Residency_Aggregate_Fields>;
  nodes: Array<Residency>;
};

/** aggregate fields of "residency" */
export type Residency_Aggregate_Fields = {
  __typename?: 'residency_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Residency_Max_Fields>;
  min: Maybe<Residency_Min_Fields>;
};


/** aggregate fields of "residency" */
export type Residency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Residency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "residency" */
export type Residency_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Residency_Max_Order_By>;
  min?: InputMaybe<Residency_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "residency". All fields are combined with a logical 'AND'. */
export type Residency_Bool_Exp = {
  _and?: InputMaybe<Array<Residency_Bool_Exp>>;
  _not?: InputMaybe<Residency_Bool_Exp>;
  _or?: InputMaybe<Array<Residency_Bool_Exp>>;
  clerkship_surveys?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  clerkship_surveys_aggregate?: InputMaybe<Clerkship_Survey_Aggregate_Bool_Exp>;
  emrafied?: InputMaybe<Boolean_Comparison_Exp>;
  fellowship_surveys?: InputMaybe<Fellowship_Survey_Bool_Exp>;
  fellowship_surveys_aggregate?: InputMaybe<Fellowship_Survey_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latest_survey?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
  pd_interview?: InputMaybe<String_Comparison_Exp>;
  surveys?: InputMaybe<Residency_Survey_Bool_Exp>;
  surveys_aggregate?: InputMaybe<Residency_Survey_Aggregate_Bool_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
};

/** unique or primary key constraints on table "residency" */
export enum Residency_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkResidency = 'pk_residency'
}

/** input type for inserting data into table "residency" */
export type Residency_Insert_Input = {
  clerkship_surveys?: InputMaybe<Clerkship_Survey_Arr_Rel_Insert_Input>;
  emrafied?: InputMaybe<Scalars['Boolean']>;
  fellowship_surveys?: InputMaybe<Fellowship_Survey_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  latest_survey?: InputMaybe<Latest_Residency_Survey_Obj_Rel_Insert_Input>;
  pd_interview?: InputMaybe<Scalars['String']>;
  surveys?: InputMaybe<Residency_Survey_Arr_Rel_Insert_Input>;
  training?: InputMaybe<Training_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Residency_Max_Fields = {
  __typename?: 'residency_max_fields';
  id: Maybe<Scalars['uuid']>;
  pd_interview: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "residency" */
export type Residency_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  pd_interview?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Residency_Min_Fields = {
  __typename?: 'residency_min_fields';
  id: Maybe<Scalars['uuid']>;
  pd_interview: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "residency" */
export type Residency_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  pd_interview?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "residency" */
export type Residency_Mutation_Response = {
  __typename?: 'residency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Residency>;
};

/** input type for inserting object relation for remote table "residency" */
export type Residency_Obj_Rel_Insert_Input = {
  data: Residency_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Residency_On_Conflict>;
};

/** on_conflict condition type for table "residency" */
export type Residency_On_Conflict = {
  constraint: Residency_Constraint;
  update_columns?: Array<Residency_Update_Column>;
  where?: InputMaybe<Residency_Bool_Exp>;
};

/** Ordering options when selecting data from "residency". */
export type Residency_Order_By = {
  clerkship_surveys_aggregate?: InputMaybe<Clerkship_Survey_Aggregate_Order_By>;
  emrafied?: InputMaybe<Order_By>;
  fellowship_surveys_aggregate?: InputMaybe<Fellowship_Survey_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  latest_survey?: InputMaybe<Latest_Residency_Survey_Order_By>;
  pd_interview?: InputMaybe<Order_By>;
  surveys_aggregate?: InputMaybe<Residency_Survey_Aggregate_Order_By>;
  training?: InputMaybe<Training_Order_By>;
};

/** primary key columns input for table: residency */
export type Residency_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "residency" */
export enum Residency_Select_Column {
  /** column name */
  Emrafied = 'emrafied',
  /** column name */
  Id = 'id',
  /** column name */
  PdInterview = 'pd_interview'
}

/** input type for updating data in table "residency" */
export type Residency_Set_Input = {
  emrafied?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  pd_interview?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "residency" */
export type Residency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Residency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Residency_Stream_Cursor_Value_Input = {
  emrafied?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  pd_interview?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "residency_survey" */
export type Residency_Survey = {
  __typename?: 'residency_survey';
  acgme_id: Scalars['String'];
  applications_received: Maybe<Scalars['Int']>;
  available_intern_positions: Maybe<Scalars['Int']>;
  cord_apic_interview: Maybe<Scalars['Boolean']>;
  critical_care_weeks: Maybe<Scalars['Int']>;
  elective_weeks: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  in_person_second_looks: Maybe<Scalars['Boolean']>;
  military_branch: Scalars['String'];
  moonlighting: Maybe<Scalars['Boolean']>;
  nrmp_id: Scalars['String'];
  percent_img: Scalars['String'];
  percent_osteopath: Scalars['String'];
  pgy_1_percent_off_service: Maybe<Scalars['Int']>;
  primary_training_site: Scalars['String'];
  program_length: Maybe<Scalars['Int']>;
  /** An object relationship */
  residency: Maybe<Residency>;
  residency_id: Maybe<Scalars['uuid']>;
  secondary_training_site: Scalars['String'];
  shift_length: Scalars['String'];
  shifts_per_month: Scalars['String'];
  sloes_for_interview: Maybe<Scalars['Int']>;
  specialty: Array<Scalars['String']>;
  step_1_cutoff: Scalars['String'];
  step_1_failures: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  training_survey: Training_Survey;
  usmle_comlex_1_preference: Scalars['String'];
  usmle_comlex_2_preference: Scalars['String'];
  visa_sponsorship: Scalars['String'];
};

/** aggregated selection of "residency_survey" */
export type Residency_Survey_Aggregate = {
  __typename?: 'residency_survey_aggregate';
  aggregate: Maybe<Residency_Survey_Aggregate_Fields>;
  nodes: Array<Residency_Survey>;
};

export type Residency_Survey_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Residency_Survey_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Residency_Survey_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Residency_Survey_Aggregate_Bool_Exp_Count>;
};

export type Residency_Survey_Aggregate_Bool_Exp_Bool_And = {
  arguments: Residency_Survey_Select_Column_Residency_Survey_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Residency_Survey_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Residency_Survey_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Residency_Survey_Select_Column_Residency_Survey_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Residency_Survey_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Residency_Survey_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Residency_Survey_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "residency_survey" */
export type Residency_Survey_Aggregate_Fields = {
  __typename?: 'residency_survey_aggregate_fields';
  avg: Maybe<Residency_Survey_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Residency_Survey_Max_Fields>;
  min: Maybe<Residency_Survey_Min_Fields>;
  stddev: Maybe<Residency_Survey_Stddev_Fields>;
  stddev_pop: Maybe<Residency_Survey_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Residency_Survey_Stddev_Samp_Fields>;
  sum: Maybe<Residency_Survey_Sum_Fields>;
  var_pop: Maybe<Residency_Survey_Var_Pop_Fields>;
  var_samp: Maybe<Residency_Survey_Var_Samp_Fields>;
  variance: Maybe<Residency_Survey_Variance_Fields>;
};


/** aggregate fields of "residency_survey" */
export type Residency_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "residency_survey" */
export type Residency_Survey_Aggregate_Order_By = {
  avg?: InputMaybe<Residency_Survey_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Residency_Survey_Max_Order_By>;
  min?: InputMaybe<Residency_Survey_Min_Order_By>;
  stddev?: InputMaybe<Residency_Survey_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Residency_Survey_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Residency_Survey_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Residency_Survey_Sum_Order_By>;
  var_pop?: InputMaybe<Residency_Survey_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Residency_Survey_Var_Samp_Order_By>;
  variance?: InputMaybe<Residency_Survey_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "residency_survey" */
export type Residency_Survey_Arr_Rel_Insert_Input = {
  data: Array<Residency_Survey_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Residency_Survey_On_Conflict>;
};

/** aggregate avg on columns */
export type Residency_Survey_Avg_Fields = {
  __typename?: 'residency_survey_avg_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "residency_survey" */
export type Residency_Survey_Avg_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "residency_survey". All fields are combined with a logical 'AND'. */
export type Residency_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Residency_Survey_Bool_Exp>>;
  _not?: InputMaybe<Residency_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Residency_Survey_Bool_Exp>>;
  acgme_id?: InputMaybe<String_Comparison_Exp>;
  applications_received?: InputMaybe<Int_Comparison_Exp>;
  available_intern_positions?: InputMaybe<Int_Comparison_Exp>;
  cord_apic_interview?: InputMaybe<Boolean_Comparison_Exp>;
  critical_care_weeks?: InputMaybe<Int_Comparison_Exp>;
  elective_weeks?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_person_second_looks?: InputMaybe<Boolean_Comparison_Exp>;
  military_branch?: InputMaybe<String_Comparison_Exp>;
  moonlighting?: InputMaybe<Boolean_Comparison_Exp>;
  nrmp_id?: InputMaybe<String_Comparison_Exp>;
  percent_img?: InputMaybe<String_Comparison_Exp>;
  percent_osteopath?: InputMaybe<String_Comparison_Exp>;
  pgy_1_percent_off_service?: InputMaybe<Int_Comparison_Exp>;
  primary_training_site?: InputMaybe<String_Comparison_Exp>;
  program_length?: InputMaybe<Int_Comparison_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
  residency_id?: InputMaybe<Uuid_Comparison_Exp>;
  secondary_training_site?: InputMaybe<String_Comparison_Exp>;
  shift_length?: InputMaybe<String_Comparison_Exp>;
  shifts_per_month?: InputMaybe<String_Comparison_Exp>;
  sloes_for_interview?: InputMaybe<Int_Comparison_Exp>;
  specialty?: InputMaybe<String_Array_Comparison_Exp>;
  step_1_cutoff?: InputMaybe<String_Comparison_Exp>;
  step_1_failures?: InputMaybe<Boolean_Comparison_Exp>;
  training_survey?: InputMaybe<Training_Survey_Bool_Exp>;
  usmle_comlex_1_preference?: InputMaybe<String_Comparison_Exp>;
  usmle_comlex_2_preference?: InputMaybe<String_Comparison_Exp>;
  visa_sponsorship?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "residency_survey" */
export enum Residency_Survey_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkResidencySurvey = 'pk_residency_survey'
}

/** input type for incrementing numeric columns in table "residency_survey" */
export type Residency_Survey_Inc_Input = {
  applications_received?: InputMaybe<Scalars['Int']>;
  available_intern_positions?: InputMaybe<Scalars['Int']>;
  critical_care_weeks?: InputMaybe<Scalars['Int']>;
  elective_weeks?: InputMaybe<Scalars['Int']>;
  pgy_1_percent_off_service?: InputMaybe<Scalars['Int']>;
  program_length?: InputMaybe<Scalars['Int']>;
  sloes_for_interview?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "residency_survey" */
export type Residency_Survey_Insert_Input = {
  acgme_id?: InputMaybe<Scalars['String']>;
  applications_received?: InputMaybe<Scalars['Int']>;
  available_intern_positions?: InputMaybe<Scalars['Int']>;
  cord_apic_interview?: InputMaybe<Scalars['Boolean']>;
  critical_care_weeks?: InputMaybe<Scalars['Int']>;
  elective_weeks?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_person_second_looks?: InputMaybe<Scalars['Boolean']>;
  military_branch?: InputMaybe<Scalars['String']>;
  moonlighting?: InputMaybe<Scalars['Boolean']>;
  nrmp_id?: InputMaybe<Scalars['String']>;
  percent_img?: InputMaybe<Scalars['String']>;
  percent_osteopath?: InputMaybe<Scalars['String']>;
  pgy_1_percent_off_service?: InputMaybe<Scalars['Int']>;
  primary_training_site?: InputMaybe<Scalars['String']>;
  program_length?: InputMaybe<Scalars['Int']>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  secondary_training_site?: InputMaybe<Scalars['String']>;
  shift_length?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['String']>;
  sloes_for_interview?: InputMaybe<Scalars['Int']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  step_1_cutoff?: InputMaybe<Scalars['String']>;
  step_1_failures?: InputMaybe<Scalars['Boolean']>;
  training_survey?: InputMaybe<Training_Survey_Obj_Rel_Insert_Input>;
  usmle_comlex_1_preference?: InputMaybe<Scalars['String']>;
  usmle_comlex_2_preference?: InputMaybe<Scalars['String']>;
  visa_sponsorship?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Residency_Survey_Max_Fields = {
  __typename?: 'residency_survey_max_fields';
  acgme_id: Maybe<Scalars['String']>;
  applications_received: Maybe<Scalars['Int']>;
  available_intern_positions: Maybe<Scalars['Int']>;
  critical_care_weeks: Maybe<Scalars['Int']>;
  elective_weeks: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  military_branch: Maybe<Scalars['String']>;
  nrmp_id: Maybe<Scalars['String']>;
  percent_img: Maybe<Scalars['String']>;
  percent_osteopath: Maybe<Scalars['String']>;
  pgy_1_percent_off_service: Maybe<Scalars['Int']>;
  primary_training_site: Maybe<Scalars['String']>;
  program_length: Maybe<Scalars['Int']>;
  residency_id: Maybe<Scalars['uuid']>;
  secondary_training_site: Maybe<Scalars['String']>;
  shift_length: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['String']>;
  sloes_for_interview: Maybe<Scalars['Int']>;
  specialty: Maybe<Array<Scalars['String']>>;
  step_1_cutoff: Maybe<Scalars['String']>;
  usmle_comlex_1_preference: Maybe<Scalars['String']>;
  usmle_comlex_2_preference: Maybe<Scalars['String']>;
  visa_sponsorship: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "residency_survey" */
export type Residency_Survey_Max_Order_By = {
  acgme_id?: InputMaybe<Order_By>;
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  military_branch?: InputMaybe<Order_By>;
  nrmp_id?: InputMaybe<Order_By>;
  percent_img?: InputMaybe<Order_By>;
  percent_osteopath?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  primary_training_site?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  secondary_training_site?: InputMaybe<Order_By>;
  shift_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  step_1_cutoff?: InputMaybe<Order_By>;
  usmle_comlex_1_preference?: InputMaybe<Order_By>;
  usmle_comlex_2_preference?: InputMaybe<Order_By>;
  visa_sponsorship?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Residency_Survey_Min_Fields = {
  __typename?: 'residency_survey_min_fields';
  acgme_id: Maybe<Scalars['String']>;
  applications_received: Maybe<Scalars['Int']>;
  available_intern_positions: Maybe<Scalars['Int']>;
  critical_care_weeks: Maybe<Scalars['Int']>;
  elective_weeks: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  military_branch: Maybe<Scalars['String']>;
  nrmp_id: Maybe<Scalars['String']>;
  percent_img: Maybe<Scalars['String']>;
  percent_osteopath: Maybe<Scalars['String']>;
  pgy_1_percent_off_service: Maybe<Scalars['Int']>;
  primary_training_site: Maybe<Scalars['String']>;
  program_length: Maybe<Scalars['Int']>;
  residency_id: Maybe<Scalars['uuid']>;
  secondary_training_site: Maybe<Scalars['String']>;
  shift_length: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['String']>;
  sloes_for_interview: Maybe<Scalars['Int']>;
  specialty: Maybe<Array<Scalars['String']>>;
  step_1_cutoff: Maybe<Scalars['String']>;
  usmle_comlex_1_preference: Maybe<Scalars['String']>;
  usmle_comlex_2_preference: Maybe<Scalars['String']>;
  visa_sponsorship: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "residency_survey" */
export type Residency_Survey_Min_Order_By = {
  acgme_id?: InputMaybe<Order_By>;
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  military_branch?: InputMaybe<Order_By>;
  nrmp_id?: InputMaybe<Order_By>;
  percent_img?: InputMaybe<Order_By>;
  percent_osteopath?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  primary_training_site?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  residency_id?: InputMaybe<Order_By>;
  secondary_training_site?: InputMaybe<Order_By>;
  shift_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  step_1_cutoff?: InputMaybe<Order_By>;
  usmle_comlex_1_preference?: InputMaybe<Order_By>;
  usmle_comlex_2_preference?: InputMaybe<Order_By>;
  visa_sponsorship?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "residency_survey" */
export type Residency_Survey_Mutation_Response = {
  __typename?: 'residency_survey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Residency_Survey>;
};

/** input type for inserting object relation for remote table "residency_survey" */
export type Residency_Survey_Obj_Rel_Insert_Input = {
  data: Residency_Survey_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Residency_Survey_On_Conflict>;
};

/** on_conflict condition type for table "residency_survey" */
export type Residency_Survey_On_Conflict = {
  constraint: Residency_Survey_Constraint;
  update_columns?: Array<Residency_Survey_Update_Column>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};

/** Ordering options when selecting data from "residency_survey". */
export type Residency_Survey_Order_By = {
  acgme_id?: InputMaybe<Order_By>;
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  cord_apic_interview?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_person_second_looks?: InputMaybe<Order_By>;
  military_branch?: InputMaybe<Order_By>;
  moonlighting?: InputMaybe<Order_By>;
  nrmp_id?: InputMaybe<Order_By>;
  percent_img?: InputMaybe<Order_By>;
  percent_osteopath?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  primary_training_site?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
  residency_id?: InputMaybe<Order_By>;
  secondary_training_site?: InputMaybe<Order_By>;
  shift_length?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  step_1_cutoff?: InputMaybe<Order_By>;
  step_1_failures?: InputMaybe<Order_By>;
  training_survey?: InputMaybe<Training_Survey_Order_By>;
  usmle_comlex_1_preference?: InputMaybe<Order_By>;
  usmle_comlex_2_preference?: InputMaybe<Order_By>;
  visa_sponsorship?: InputMaybe<Order_By>;
};

/** primary key columns input for table: residency_survey */
export type Residency_Survey_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "residency_survey" */
export enum Residency_Survey_Select_Column {
  /** column name */
  AcgmeId = 'acgme_id',
  /** column name */
  ApplicationsReceived = 'applications_received',
  /** column name */
  AvailableInternPositions = 'available_intern_positions',
  /** column name */
  CordApicInterview = 'cord_apic_interview',
  /** column name */
  CriticalCareWeeks = 'critical_care_weeks',
  /** column name */
  ElectiveWeeks = 'elective_weeks',
  /** column name */
  Id = 'id',
  /** column name */
  InPersonSecondLooks = 'in_person_second_looks',
  /** column name */
  MilitaryBranch = 'military_branch',
  /** column name */
  Moonlighting = 'moonlighting',
  /** column name */
  NrmpId = 'nrmp_id',
  /** column name */
  PercentImg = 'percent_img',
  /** column name */
  PercentOsteopath = 'percent_osteopath',
  /** column name */
  Pgy_1PercentOffService = 'pgy_1_percent_off_service',
  /** column name */
  PrimaryTrainingSite = 'primary_training_site',
  /** column name */
  ProgramLength = 'program_length',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  SecondaryTrainingSite = 'secondary_training_site',
  /** column name */
  ShiftLength = 'shift_length',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  SloesForInterview = 'sloes_for_interview',
  /** column name */
  Specialty = 'specialty',
  /** column name */
  Step_1Cutoff = 'step_1_cutoff',
  /** column name */
  Step_1Failures = 'step_1_failures',
  /** column name */
  UsmleComlex_1Preference = 'usmle_comlex_1_preference',
  /** column name */
  UsmleComlex_2Preference = 'usmle_comlex_2_preference',
  /** column name */
  VisaSponsorship = 'visa_sponsorship'
}

/** select "residency_survey_aggregate_bool_exp_bool_and_arguments_columns" columns of table "residency_survey" */
export enum Residency_Survey_Select_Column_Residency_Survey_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CordApicInterview = 'cord_apic_interview',
  /** column name */
  InPersonSecondLooks = 'in_person_second_looks',
  /** column name */
  Moonlighting = 'moonlighting',
  /** column name */
  Step_1Failures = 'step_1_failures'
}

/** select "residency_survey_aggregate_bool_exp_bool_or_arguments_columns" columns of table "residency_survey" */
export enum Residency_Survey_Select_Column_Residency_Survey_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CordApicInterview = 'cord_apic_interview',
  /** column name */
  InPersonSecondLooks = 'in_person_second_looks',
  /** column name */
  Moonlighting = 'moonlighting',
  /** column name */
  Step_1Failures = 'step_1_failures'
}

/** input type for updating data in table "residency_survey" */
export type Residency_Survey_Set_Input = {
  acgme_id?: InputMaybe<Scalars['String']>;
  applications_received?: InputMaybe<Scalars['Int']>;
  available_intern_positions?: InputMaybe<Scalars['Int']>;
  cord_apic_interview?: InputMaybe<Scalars['Boolean']>;
  critical_care_weeks?: InputMaybe<Scalars['Int']>;
  elective_weeks?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_person_second_looks?: InputMaybe<Scalars['Boolean']>;
  military_branch?: InputMaybe<Scalars['String']>;
  moonlighting?: InputMaybe<Scalars['Boolean']>;
  nrmp_id?: InputMaybe<Scalars['String']>;
  percent_img?: InputMaybe<Scalars['String']>;
  percent_osteopath?: InputMaybe<Scalars['String']>;
  pgy_1_percent_off_service?: InputMaybe<Scalars['Int']>;
  primary_training_site?: InputMaybe<Scalars['String']>;
  program_length?: InputMaybe<Scalars['Int']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  secondary_training_site?: InputMaybe<Scalars['String']>;
  shift_length?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['String']>;
  sloes_for_interview?: InputMaybe<Scalars['Int']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  step_1_cutoff?: InputMaybe<Scalars['String']>;
  step_1_failures?: InputMaybe<Scalars['Boolean']>;
  usmle_comlex_1_preference?: InputMaybe<Scalars['String']>;
  usmle_comlex_2_preference?: InputMaybe<Scalars['String']>;
  visa_sponsorship?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Residency_Survey_Stddev_Fields = {
  __typename?: 'residency_survey_stddev_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "residency_survey" */
export type Residency_Survey_Stddev_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Residency_Survey_Stddev_Pop_Fields = {
  __typename?: 'residency_survey_stddev_pop_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "residency_survey" */
export type Residency_Survey_Stddev_Pop_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Residency_Survey_Stddev_Samp_Fields = {
  __typename?: 'residency_survey_stddev_samp_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "residency_survey" */
export type Residency_Survey_Stddev_Samp_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "residency_survey" */
export type Residency_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Residency_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Residency_Survey_Stream_Cursor_Value_Input = {
  acgme_id?: InputMaybe<Scalars['String']>;
  applications_received?: InputMaybe<Scalars['Int']>;
  available_intern_positions?: InputMaybe<Scalars['Int']>;
  cord_apic_interview?: InputMaybe<Scalars['Boolean']>;
  critical_care_weeks?: InputMaybe<Scalars['Int']>;
  elective_weeks?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  in_person_second_looks?: InputMaybe<Scalars['Boolean']>;
  military_branch?: InputMaybe<Scalars['String']>;
  moonlighting?: InputMaybe<Scalars['Boolean']>;
  nrmp_id?: InputMaybe<Scalars['String']>;
  percent_img?: InputMaybe<Scalars['String']>;
  percent_osteopath?: InputMaybe<Scalars['String']>;
  pgy_1_percent_off_service?: InputMaybe<Scalars['Int']>;
  primary_training_site?: InputMaybe<Scalars['String']>;
  program_length?: InputMaybe<Scalars['Int']>;
  residency_id?: InputMaybe<Scalars['uuid']>;
  secondary_training_site?: InputMaybe<Scalars['String']>;
  shift_length?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['String']>;
  sloes_for_interview?: InputMaybe<Scalars['Int']>;
  specialty?: InputMaybe<Array<Scalars['String']>>;
  step_1_cutoff?: InputMaybe<Scalars['String']>;
  step_1_failures?: InputMaybe<Scalars['Boolean']>;
  usmle_comlex_1_preference?: InputMaybe<Scalars['String']>;
  usmle_comlex_2_preference?: InputMaybe<Scalars['String']>;
  visa_sponsorship?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Residency_Survey_Sum_Fields = {
  __typename?: 'residency_survey_sum_fields';
  applications_received: Maybe<Scalars['Int']>;
  available_intern_positions: Maybe<Scalars['Int']>;
  critical_care_weeks: Maybe<Scalars['Int']>;
  elective_weeks: Maybe<Scalars['Int']>;
  pgy_1_percent_off_service: Maybe<Scalars['Int']>;
  program_length: Maybe<Scalars['Int']>;
  sloes_for_interview: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "residency_survey" */
export type Residency_Survey_Sum_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** update columns of table "residency_survey" */
export enum Residency_Survey_Update_Column {
  /** column name */
  AcgmeId = 'acgme_id',
  /** column name */
  ApplicationsReceived = 'applications_received',
  /** column name */
  AvailableInternPositions = 'available_intern_positions',
  /** column name */
  CordApicInterview = 'cord_apic_interview',
  /** column name */
  CriticalCareWeeks = 'critical_care_weeks',
  /** column name */
  ElectiveWeeks = 'elective_weeks',
  /** column name */
  Id = 'id',
  /** column name */
  InPersonSecondLooks = 'in_person_second_looks',
  /** column name */
  MilitaryBranch = 'military_branch',
  /** column name */
  Moonlighting = 'moonlighting',
  /** column name */
  NrmpId = 'nrmp_id',
  /** column name */
  PercentImg = 'percent_img',
  /** column name */
  PercentOsteopath = 'percent_osteopath',
  /** column name */
  Pgy_1PercentOffService = 'pgy_1_percent_off_service',
  /** column name */
  PrimaryTrainingSite = 'primary_training_site',
  /** column name */
  ProgramLength = 'program_length',
  /** column name */
  ResidencyId = 'residency_id',
  /** column name */
  SecondaryTrainingSite = 'secondary_training_site',
  /** column name */
  ShiftLength = 'shift_length',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  SloesForInterview = 'sloes_for_interview',
  /** column name */
  Specialty = 'specialty',
  /** column name */
  Step_1Cutoff = 'step_1_cutoff',
  /** column name */
  Step_1Failures = 'step_1_failures',
  /** column name */
  UsmleComlex_1Preference = 'usmle_comlex_1_preference',
  /** column name */
  UsmleComlex_2Preference = 'usmle_comlex_2_preference',
  /** column name */
  VisaSponsorship = 'visa_sponsorship'
}

export type Residency_Survey_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Residency_Survey_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Residency_Survey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Residency_Survey_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Residency_Survey_Var_Pop_Fields = {
  __typename?: 'residency_survey_var_pop_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "residency_survey" */
export type Residency_Survey_Var_Pop_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Residency_Survey_Var_Samp_Fields = {
  __typename?: 'residency_survey_var_samp_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "residency_survey" */
export type Residency_Survey_Var_Samp_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Residency_Survey_Variance_Fields = {
  __typename?: 'residency_survey_variance_fields';
  applications_received: Maybe<Scalars['Float']>;
  available_intern_positions: Maybe<Scalars['Float']>;
  critical_care_weeks: Maybe<Scalars['Float']>;
  elective_weeks: Maybe<Scalars['Float']>;
  pgy_1_percent_off_service: Maybe<Scalars['Float']>;
  program_length: Maybe<Scalars['Float']>;
  sloes_for_interview: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "residency_survey" */
export type Residency_Survey_Variance_Order_By = {
  applications_received?: InputMaybe<Order_By>;
  available_intern_positions?: InputMaybe<Order_By>;
  critical_care_weeks?: InputMaybe<Order_By>;
  elective_weeks?: InputMaybe<Order_By>;
  pgy_1_percent_off_service?: InputMaybe<Order_By>;
  program_length?: InputMaybe<Order_By>;
  sloes_for_interview?: InputMaybe<Order_By>;
};

/** update columns of table "residency" */
export enum Residency_Update_Column {
  /** column name */
  Emrafied = 'emrafied',
  /** column name */
  Id = 'id',
  /** column name */
  PdInterview = 'pd_interview'
}

export type Residency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Residency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Residency_Bool_Exp;
};

/** columns and relationships of "review" */
export type Review = {
  __typename?: 'review';
  active: Scalars['Boolean'];
  /** An object relationship */
  clinician: Clinician;
  created_at: Scalars['timestamp'];
  currently_working: Scalars['Boolean'];
  employment_date: Scalars['timestamp'];
  /** An object relationship */
  facility: Facility;
  facility_id: Scalars['uuid'];
  /** A computed field, executes function "review_has_active_contract" */
  has_active_contract: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  is_anonymous: Scalars['Boolean'];
  last_worked_date: Maybe<Scalars['date']>;
  moderation_status: Scalars['moderationstatus'];
  /** A computed field, executes function "review_most_helpful" */
  most_helpful: Maybe<Scalars['Boolean']>;
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organization;
  rating_facility: Scalars['Int'];
  rating_job: Scalars['Int'];
  rating_org: Scalars['Int'];
  /** An array relationship */
  replies: Array<Review_Reply>;
  /** An aggregate relationship */
  replies_aggregate: Review_Reply_Aggregate;
  reporter_id: Scalars['uuid'];
  /** A computed field, executes function "review_reporter_name" */
  reporter_name: Maybe<Scalars['String']>;
  review_facility_content: Scalars['String'];
  review_org_content: Scalars['String'];
  /** A computed field, executes function "review_self_review" */
  self_review: Maybe<Scalars['Boolean']>;
  status: Scalars['moderationstatus'];
  visible: Scalars['Boolean'];
  /** An array relationship */
  votes: Array<Review_Vote>;
  /** An aggregate relationship */
  votes_aggregate: Review_Vote_Aggregate;
};


/** columns and relationships of "review" */
export type ReviewMost_HelpfulArgs = {
  args?: InputMaybe<Most_Helpful_Review_Args>;
};


/** columns and relationships of "review" */
export type ReviewRepliesArgs = {
  distinct_on?: InputMaybe<Array<Review_Reply_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Reply_Order_By>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


/** columns and relationships of "review" */
export type ReviewReplies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Reply_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Reply_Order_By>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


/** columns and relationships of "review" */
export type ReviewVotesArgs = {
  distinct_on?: InputMaybe<Array<Review_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Vote_Order_By>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};


/** columns and relationships of "review" */
export type ReviewVotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Vote_Order_By>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};

/** aggregated selection of "review" */
export type Review_Aggregate = {
  __typename?: 'review_aggregate';
  aggregate: Maybe<Review_Aggregate_Fields>;
  nodes: Array<Review>;
};

export type Review_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Review_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Review_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Review_Aggregate_Bool_Exp_Count>;
};

export type Review_Aggregate_Bool_Exp_Bool_And = {
  arguments: Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Review_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Review_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Review_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "review" */
export type Review_Aggregate_Fields = {
  __typename?: 'review_aggregate_fields';
  avg: Maybe<Review_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Review_Max_Fields>;
  min: Maybe<Review_Min_Fields>;
  stddev: Maybe<Review_Stddev_Fields>;
  stddev_pop: Maybe<Review_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Review_Stddev_Samp_Fields>;
  sum: Maybe<Review_Sum_Fields>;
  var_pop: Maybe<Review_Var_Pop_Fields>;
  var_samp: Maybe<Review_Var_Samp_Fields>;
  variance: Maybe<Review_Variance_Fields>;
};


/** aggregate fields of "review" */
export type Review_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review" */
export type Review_Aggregate_Order_By = {
  avg?: InputMaybe<Review_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Max_Order_By>;
  min?: InputMaybe<Review_Min_Order_By>;
  stddev?: InputMaybe<Review_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Review_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Review_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Review_Sum_Order_By>;
  var_pop?: InputMaybe<Review_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Review_Var_Samp_Order_By>;
  variance?: InputMaybe<Review_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "review" */
export type Review_Arr_Rel_Insert_Input = {
  data: Array<Review_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_On_Conflict>;
};

/** aggregate avg on columns */
export type Review_Avg_Fields = {
  __typename?: 'review_avg_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "review" */
export type Review_Avg_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "review". All fields are combined with a logical 'AND'. */
export type Review_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Bool_Exp>>;
  _not?: InputMaybe<Review_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  currently_working?: InputMaybe<Boolean_Comparison_Exp>;
  employment_date?: InputMaybe<Timestamp_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_active_contract?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_anonymous?: InputMaybe<Boolean_Comparison_Exp>;
  last_worked_date?: InputMaybe<Date_Comparison_Exp>;
  moderation_status?: InputMaybe<Moderationstatus_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  rating_facility?: InputMaybe<Int_Comparison_Exp>;
  rating_job?: InputMaybe<Int_Comparison_Exp>;
  rating_org?: InputMaybe<Int_Comparison_Exp>;
  replies?: InputMaybe<Review_Reply_Bool_Exp>;
  replies_aggregate?: InputMaybe<Review_Reply_Aggregate_Bool_Exp>;
  reporter_id?: InputMaybe<Uuid_Comparison_Exp>;
  reporter_name?: InputMaybe<String_Comparison_Exp>;
  review_facility_content?: InputMaybe<String_Comparison_Exp>;
  review_org_content?: InputMaybe<String_Comparison_Exp>;
  self_review?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<Moderationstatus_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
  votes?: InputMaybe<Review_Vote_Bool_Exp>;
  votes_aggregate?: InputMaybe<Review_Vote_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "review" */
export enum Review_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkReview = 'pk_review'
}

/** input type for incrementing numeric columns in table "review" */
export type Review_Inc_Input = {
  rating_facility?: InputMaybe<Scalars['Int']>;
  rating_job?: InputMaybe<Scalars['Int']>;
  rating_org?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "review" */
export type Review_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  currently_working?: InputMaybe<Scalars['Boolean']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  last_worked_date?: InputMaybe<Scalars['date']>;
  moderation_status?: InputMaybe<Scalars['moderationstatus']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  rating_facility?: InputMaybe<Scalars['Int']>;
  rating_job?: InputMaybe<Scalars['Int']>;
  rating_org?: InputMaybe<Scalars['Int']>;
  replies?: InputMaybe<Review_Reply_Arr_Rel_Insert_Input>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  review_facility_content?: InputMaybe<Scalars['String']>;
  review_org_content?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['moderationstatus']>;
  votes?: InputMaybe<Review_Vote_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Review_Max_Fields = {
  __typename?: 'review_max_fields';
  created_at: Maybe<Scalars['timestamp']>;
  employment_date: Maybe<Scalars['timestamp']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  last_worked_date: Maybe<Scalars['date']>;
  moderation_status: Maybe<Scalars['moderationstatus']>;
  org_id: Maybe<Scalars['uuid']>;
  rating_facility: Maybe<Scalars['Int']>;
  rating_job: Maybe<Scalars['Int']>;
  rating_org: Maybe<Scalars['Int']>;
  reporter_id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "review_reporter_name" */
  reporter_name: Maybe<Scalars['String']>;
  review_facility_content: Maybe<Scalars['String']>;
  review_org_content: Maybe<Scalars['String']>;
  status: Maybe<Scalars['moderationstatus']>;
};

/** order by max() on columns of table "review" */
export type Review_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  employment_date?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_worked_date?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  review_facility_content?: InputMaybe<Order_By>;
  review_org_content?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Review_Min_Fields = {
  __typename?: 'review_min_fields';
  created_at: Maybe<Scalars['timestamp']>;
  employment_date: Maybe<Scalars['timestamp']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  last_worked_date: Maybe<Scalars['date']>;
  moderation_status: Maybe<Scalars['moderationstatus']>;
  org_id: Maybe<Scalars['uuid']>;
  rating_facility: Maybe<Scalars['Int']>;
  rating_job: Maybe<Scalars['Int']>;
  rating_org: Maybe<Scalars['Int']>;
  reporter_id: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "review_reporter_name" */
  reporter_name: Maybe<Scalars['String']>;
  review_facility_content: Maybe<Scalars['String']>;
  review_org_content: Maybe<Scalars['String']>;
  status: Maybe<Scalars['moderationstatus']>;
};

/** order by min() on columns of table "review" */
export type Review_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  employment_date?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_worked_date?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  review_facility_content?: InputMaybe<Order_By>;
  review_org_content?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review" */
export type Review_Mutation_Response = {
  __typename?: 'review_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review>;
};

/** input type for inserting object relation for remote table "review" */
export type Review_Obj_Rel_Insert_Input = {
  data: Review_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_On_Conflict>;
};

/** on_conflict condition type for table "review" */
export type Review_On_Conflict = {
  constraint: Review_Constraint;
  update_columns?: Array<Review_Update_Column>;
  where?: InputMaybe<Review_Bool_Exp>;
};

/** Ordering options when selecting data from "review". */
export type Review_Order_By = {
  active?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Clinician_Order_By>;
  created_at?: InputMaybe<Order_By>;
  currently_working?: InputMaybe<Order_By>;
  employment_date?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  has_active_contract?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_anonymous?: InputMaybe<Order_By>;
  last_worked_date?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
  replies_aggregate?: InputMaybe<Review_Reply_Aggregate_Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  reporter_name?: InputMaybe<Order_By>;
  review_facility_content?: InputMaybe<Order_By>;
  review_org_content?: InputMaybe<Order_By>;
  self_review?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
  votes_aggregate?: InputMaybe<Review_Vote_Aggregate_Order_By>;
};

/** primary key columns input for table: review */
export type Review_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "review_reply" */
export type Review_Reply = {
  __typename?: 'review_reply';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid'];
  active: Scalars['Boolean'];
  content: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  is_anonymous: Scalars['Boolean'];
  /** A computed field, executes function "reply_is_org_response" */
  is_org_response: Maybe<Scalars['Boolean']>;
  moderation_status: Scalars['moderationstatus'];
  /** A computed field, executes function "reply_reporter_name" */
  reporter_name: Maybe<Scalars['String']>;
  /** An object relationship */
  review: Review;
  review_id: Scalars['uuid'];
  /** A computed field, executes function "reply_self_reply" */
  self_reply: Maybe<Scalars['Boolean']>;
  visible: Scalars['Boolean'];
};

/** aggregated selection of "review_reply" */
export type Review_Reply_Aggregate = {
  __typename?: 'review_reply_aggregate';
  aggregate: Maybe<Review_Reply_Aggregate_Fields>;
  nodes: Array<Review_Reply>;
};

export type Review_Reply_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Review_Reply_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Review_Reply_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Review_Reply_Aggregate_Bool_Exp_Count>;
};

export type Review_Reply_Aggregate_Bool_Exp_Bool_And = {
  arguments: Review_Reply_Select_Column_Review_Reply_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Reply_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Review_Reply_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Review_Reply_Select_Column_Review_Reply_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Reply_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Review_Reply_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Review_Reply_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Reply_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "review_reply" */
export type Review_Reply_Aggregate_Fields = {
  __typename?: 'review_reply_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Review_Reply_Max_Fields>;
  min: Maybe<Review_Reply_Min_Fields>;
};


/** aggregate fields of "review_reply" */
export type Review_Reply_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Reply_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review_reply" */
export type Review_Reply_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Reply_Max_Order_By>;
  min?: InputMaybe<Review_Reply_Min_Order_By>;
};

/** input type for inserting array relation for remote table "review_reply" */
export type Review_Reply_Arr_Rel_Insert_Input = {
  data: Array<Review_Reply_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_Reply_On_Conflict>;
};

/** Boolean expression to filter rows from the table "review_reply". All fields are combined with a logical 'AND'. */
export type Review_Reply_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Reply_Bool_Exp>>;
  _not?: InputMaybe<Review_Reply_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Reply_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_anonymous?: InputMaybe<Boolean_Comparison_Exp>;
  is_org_response?: InputMaybe<Boolean_Comparison_Exp>;
  moderation_status?: InputMaybe<Moderationstatus_Comparison_Exp>;
  reporter_name?: InputMaybe<String_Comparison_Exp>;
  review?: InputMaybe<Review_Bool_Exp>;
  review_id?: InputMaybe<Uuid_Comparison_Exp>;
  self_reply?: InputMaybe<Boolean_Comparison_Exp>;
  visible?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_reply" */
export enum Review_Reply_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkReviewReply = 'pk_review_reply'
}

/** input type for inserting data into table "review_reply" */
export type Review_Reply_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  active?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  moderation_status?: InputMaybe<Scalars['moderationstatus']>;
  review?: InputMaybe<Review_Obj_Rel_Insert_Input>;
  review_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Review_Reply_Max_Fields = {
  __typename?: 'review_reply_max_fields';
  account_id: Maybe<Scalars['uuid']>;
  content: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  moderation_status: Maybe<Scalars['moderationstatus']>;
  /** A computed field, executes function "reply_reporter_name" */
  reporter_name: Maybe<Scalars['String']>;
  review_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "review_reply" */
export type Review_Reply_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Review_Reply_Min_Fields = {
  __typename?: 'review_reply_min_fields';
  account_id: Maybe<Scalars['uuid']>;
  content: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  moderation_status: Maybe<Scalars['moderationstatus']>;
  /** A computed field, executes function "reply_reporter_name" */
  reporter_name: Maybe<Scalars['String']>;
  review_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "review_reply" */
export type Review_Reply_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review_reply" */
export type Review_Reply_Mutation_Response = {
  __typename?: 'review_reply_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Reply>;
};

/** on_conflict condition type for table "review_reply" */
export type Review_Reply_On_Conflict = {
  constraint: Review_Reply_Constraint;
  update_columns?: Array<Review_Reply_Update_Column>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};

/** Ordering options when selecting data from "review_reply". */
export type Review_Reply_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  active?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_anonymous?: InputMaybe<Order_By>;
  is_org_response?: InputMaybe<Order_By>;
  moderation_status?: InputMaybe<Order_By>;
  reporter_name?: InputMaybe<Order_By>;
  review?: InputMaybe<Review_Order_By>;
  review_id?: InputMaybe<Order_By>;
  self_reply?: InputMaybe<Order_By>;
  visible?: InputMaybe<Order_By>;
};

/** primary key columns input for table: review_reply */
export type Review_Reply_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "review_reply" */
export enum Review_Reply_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  ModerationStatus = 'moderation_status',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Visible = 'visible'
}

/** select "review_reply_aggregate_bool_exp_bool_and_arguments_columns" columns of table "review_reply" */
export enum Review_Reply_Select_Column_Review_Reply_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  Visible = 'visible'
}

/** select "review_reply_aggregate_bool_exp_bool_or_arguments_columns" columns of table "review_reply" */
export enum Review_Reply_Select_Column_Review_Reply_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "review_reply" */
export type Review_Reply_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  active?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  moderation_status?: InputMaybe<Scalars['moderationstatus']>;
  review_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "review_reply" */
export type Review_Reply_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Reply_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Reply_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  active?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  moderation_status?: InputMaybe<Scalars['moderationstatus']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "review_reply" */
export enum Review_Reply_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  ModerationStatus = 'moderation_status',
  /** column name */
  ReviewId = 'review_id'
}

export type Review_Reply_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Reply_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Reply_Bool_Exp;
};

/** columns and relationships of "review_report" */
export type Review_Report = {
  __typename?: 'review_report';
  created_at: Scalars['timestamp'];
  details: Scalars['String'];
  id: Scalars['uuid'];
  problem: Scalars['String'];
  reporter_id: Maybe<Scalars['uuid']>;
  review_id: Maybe<Scalars['uuid']>;
  review_reply_id: Maybe<Scalars['uuid']>;
  type: Scalars['reviewreporttype'];
};

/** aggregated selection of "review_report" */
export type Review_Report_Aggregate = {
  __typename?: 'review_report_aggregate';
  aggregate: Maybe<Review_Report_Aggregate_Fields>;
  nodes: Array<Review_Report>;
};

/** aggregate fields of "review_report" */
export type Review_Report_Aggregate_Fields = {
  __typename?: 'review_report_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Review_Report_Max_Fields>;
  min: Maybe<Review_Report_Min_Fields>;
};


/** aggregate fields of "review_report" */
export type Review_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "review_report". All fields are combined with a logical 'AND'. */
export type Review_Report_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Report_Bool_Exp>>;
  _not?: InputMaybe<Review_Report_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Report_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  details?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  problem?: InputMaybe<String_Comparison_Exp>;
  reporter_id?: InputMaybe<Uuid_Comparison_Exp>;
  review_id?: InputMaybe<Uuid_Comparison_Exp>;
  review_reply_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Reviewreporttype_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_report" */
export enum Review_Report_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkReviewReport = 'pk_review_report'
}

/** input type for inserting data into table "review_report" */
export type Review_Report_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  problem?: InputMaybe<Scalars['String']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  review_reply_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['reviewreporttype']>;
};

/** aggregate max on columns */
export type Review_Report_Max_Fields = {
  __typename?: 'review_report_max_fields';
  created_at: Maybe<Scalars['timestamp']>;
  details: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  problem: Maybe<Scalars['String']>;
  reporter_id: Maybe<Scalars['uuid']>;
  review_id: Maybe<Scalars['uuid']>;
  review_reply_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['reviewreporttype']>;
};

/** aggregate min on columns */
export type Review_Report_Min_Fields = {
  __typename?: 'review_report_min_fields';
  created_at: Maybe<Scalars['timestamp']>;
  details: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  problem: Maybe<Scalars['String']>;
  reporter_id: Maybe<Scalars['uuid']>;
  review_id: Maybe<Scalars['uuid']>;
  review_reply_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['reviewreporttype']>;
};

/** response of any mutation on the table "review_report" */
export type Review_Report_Mutation_Response = {
  __typename?: 'review_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Report>;
};

/** on_conflict condition type for table "review_report" */
export type Review_Report_On_Conflict = {
  constraint: Review_Report_Constraint;
  update_columns?: Array<Review_Report_Update_Column>;
  where?: InputMaybe<Review_Report_Bool_Exp>;
};

/** Ordering options when selecting data from "review_report". */
export type Review_Report_Order_By = {
  created_at?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  problem?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
  review_reply_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: review_report */
export type Review_Report_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "review_report" */
export enum Review_Report_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  Problem = 'problem',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  ReviewReplyId = 'review_reply_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "review_report" */
export type Review_Report_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  problem?: InputMaybe<Scalars['String']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  review_reply_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['reviewreporttype']>;
};

/** Streaming cursor of the table "review_report" */
export type Review_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Report_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  problem?: InputMaybe<Scalars['String']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  review_reply_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['reviewreporttype']>;
};

/** update columns of table "review_report" */
export enum Review_Report_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  Problem = 'problem',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  ReviewReplyId = 'review_reply_id',
  /** column name */
  Type = 'type'
}

export type Review_Report_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Report_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Report_Bool_Exp;
};

/** select columns of table "review" */
export enum Review_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentlyWorking = 'currently_working',
  /** column name */
  EmploymentDate = 'employment_date',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  LastWorkedDate = 'last_worked_date',
  /** column name */
  ModerationStatus = 'moderation_status',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  RatingFacility = 'rating_facility',
  /** column name */
  RatingJob = 'rating_job',
  /** column name */
  RatingOrg = 'rating_org',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  ReviewFacilityContent = 'review_facility_content',
  /** column name */
  ReviewOrgContent = 'review_org_content',
  /** column name */
  Status = 'status',
  /** column name */
  Visible = 'visible'
}

/** select "review_aggregate_bool_exp_bool_and_arguments_columns" columns of table "review" */
export enum Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CurrentlyWorking = 'currently_working',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  Visible = 'visible'
}

/** select "review_aggregate_bool_exp_bool_or_arguments_columns" columns of table "review" */
export enum Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active',
  /** column name */
  CurrentlyWorking = 'currently_working',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  Visible = 'visible'
}

/** input type for updating data in table "review" */
export type Review_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  currently_working?: InputMaybe<Scalars['Boolean']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  last_worked_date?: InputMaybe<Scalars['date']>;
  moderation_status?: InputMaybe<Scalars['moderationstatus']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rating_facility?: InputMaybe<Scalars['Int']>;
  rating_job?: InputMaybe<Scalars['Int']>;
  rating_org?: InputMaybe<Scalars['Int']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  review_facility_content?: InputMaybe<Scalars['String']>;
  review_org_content?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['moderationstatus']>;
};

/** aggregate stddev on columns */
export type Review_Stddev_Fields = {
  __typename?: 'review_stddev_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "review" */
export type Review_Stddev_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Review_Stddev_Pop_Fields = {
  __typename?: 'review_stddev_pop_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "review" */
export type Review_Stddev_Pop_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Review_Stddev_Samp_Fields = {
  __typename?: 'review_stddev_samp_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "review" */
export type Review_Stddev_Samp_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "review" */
export type Review_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  currently_working?: InputMaybe<Scalars['Boolean']>;
  employment_date?: InputMaybe<Scalars['timestamp']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_anonymous?: InputMaybe<Scalars['Boolean']>;
  last_worked_date?: InputMaybe<Scalars['date']>;
  moderation_status?: InputMaybe<Scalars['moderationstatus']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  rating_facility?: InputMaybe<Scalars['Int']>;
  rating_job?: InputMaybe<Scalars['Int']>;
  rating_org?: InputMaybe<Scalars['Int']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  review_facility_content?: InputMaybe<Scalars['String']>;
  review_org_content?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['moderationstatus']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Review_Sum_Fields = {
  __typename?: 'review_sum_fields';
  rating_facility: Maybe<Scalars['Int']>;
  rating_job: Maybe<Scalars['Int']>;
  rating_org: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "review" */
export type Review_Sum_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** update columns of table "review" */
export enum Review_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentlyWorking = 'currently_working',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  LastWorkedDate = 'last_worked_date',
  /** column name */
  ModerationStatus = 'moderation_status',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  RatingFacility = 'rating_facility',
  /** column name */
  RatingJob = 'rating_job',
  /** column name */
  RatingOrg = 'rating_org',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  ReviewFacilityContent = 'review_facility_content',
  /** column name */
  ReviewOrgContent = 'review_org_content',
  /** column name */
  Status = 'status'
}

export type Review_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Review_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Review_Var_Pop_Fields = {
  __typename?: 'review_var_pop_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "review" */
export type Review_Var_Pop_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Review_Var_Samp_Fields = {
  __typename?: 'review_var_samp_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "review" */
export type Review_Var_Samp_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Review_Variance_Fields = {
  __typename?: 'review_variance_fields';
  rating_facility: Maybe<Scalars['Float']>;
  rating_job: Maybe<Scalars['Float']>;
  rating_org: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "review" */
export type Review_Variance_Order_By = {
  rating_facility?: InputMaybe<Order_By>;
  rating_job?: InputMaybe<Order_By>;
  rating_org?: InputMaybe<Order_By>;
};

/** columns and relationships of "review_vote" */
export type Review_Vote = {
  __typename?: 'review_vote';
  /** An object relationship */
  account: Account;
  account_id: Scalars['uuid'];
  created_at: Scalars['timestamp'];
  id: Scalars['uuid'];
  /** An object relationship */
  review: Review;
  review_id: Scalars['uuid'];
  value: Scalars['Int'];
};

/** aggregated selection of "review_vote" */
export type Review_Vote_Aggregate = {
  __typename?: 'review_vote_aggregate';
  aggregate: Maybe<Review_Vote_Aggregate_Fields>;
  nodes: Array<Review_Vote>;
};

export type Review_Vote_Aggregate_Bool_Exp = {
  count?: InputMaybe<Review_Vote_Aggregate_Bool_Exp_Count>;
};

export type Review_Vote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Review_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Vote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "review_vote" */
export type Review_Vote_Aggregate_Fields = {
  __typename?: 'review_vote_aggregate_fields';
  avg: Maybe<Review_Vote_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Review_Vote_Max_Fields>;
  min: Maybe<Review_Vote_Min_Fields>;
  stddev: Maybe<Review_Vote_Stddev_Fields>;
  stddev_pop: Maybe<Review_Vote_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Review_Vote_Stddev_Samp_Fields>;
  sum: Maybe<Review_Vote_Sum_Fields>;
  var_pop: Maybe<Review_Vote_Var_Pop_Fields>;
  var_samp: Maybe<Review_Vote_Var_Samp_Fields>;
  variance: Maybe<Review_Vote_Variance_Fields>;
};


/** aggregate fields of "review_vote" */
export type Review_Vote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Vote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review_vote" */
export type Review_Vote_Aggregate_Order_By = {
  avg?: InputMaybe<Review_Vote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Vote_Max_Order_By>;
  min?: InputMaybe<Review_Vote_Min_Order_By>;
  stddev?: InputMaybe<Review_Vote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Review_Vote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Review_Vote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Review_Vote_Sum_Order_By>;
  var_pop?: InputMaybe<Review_Vote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Review_Vote_Var_Samp_Order_By>;
  variance?: InputMaybe<Review_Vote_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "review_vote" */
export type Review_Vote_Arr_Rel_Insert_Input = {
  data: Array<Review_Vote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_Vote_On_Conflict>;
};

/** aggregate avg on columns */
export type Review_Vote_Avg_Fields = {
  __typename?: 'review_vote_avg_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "review_vote" */
export type Review_Vote_Avg_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "review_vote". All fields are combined with a logical 'AND'. */
export type Review_Vote_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Vote_Bool_Exp>>;
  _not?: InputMaybe<Review_Vote_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Vote_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  account_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  review?: InputMaybe<Review_Bool_Exp>;
  review_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_vote" */
export enum Review_Vote_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkReviewVote = 'pk_review_vote',
  /** unique or primary key constraint on columns "review_id", "account_id" */
  UqReviewVoteReviewIdAccountId = 'uq_review_vote_review_id_account_id'
}

/** input type for incrementing numeric columns in table "review_vote" */
export type Review_Vote_Inc_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "review_vote" */
export type Review_Vote_Insert_Input = {
  account?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  account_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  review?: InputMaybe<Review_Obj_Rel_Insert_Input>;
  review_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Review_Vote_Max_Fields = {
  __typename?: 'review_vote_max_fields';
  account_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  review_id: Maybe<Scalars['uuid']>;
  value: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "review_vote" */
export type Review_Vote_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Review_Vote_Min_Fields = {
  __typename?: 'review_vote_min_fields';
  account_id: Maybe<Scalars['uuid']>;
  created_at: Maybe<Scalars['timestamp']>;
  id: Maybe<Scalars['uuid']>;
  review_id: Maybe<Scalars['uuid']>;
  value: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "review_vote" */
export type Review_Vote_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review_vote" */
export type Review_Vote_Mutation_Response = {
  __typename?: 'review_vote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Vote>;
};

/** on_conflict condition type for table "review_vote" */
export type Review_Vote_On_Conflict = {
  constraint: Review_Vote_Constraint;
  update_columns?: Array<Review_Vote_Update_Column>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};

/** Ordering options when selecting data from "review_vote". */
export type Review_Vote_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  account_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review?: InputMaybe<Review_Order_By>;
  review_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: review_vote */
export type Review_Vote_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "review_vote" */
export enum Review_Vote_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "review_vote" */
export type Review_Vote_Set_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Review_Vote_Stddev_Fields = {
  __typename?: 'review_vote_stddev_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "review_vote" */
export type Review_Vote_Stddev_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Review_Vote_Stddev_Pop_Fields = {
  __typename?: 'review_vote_stddev_pop_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "review_vote" */
export type Review_Vote_Stddev_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Review_Vote_Stddev_Samp_Fields = {
  __typename?: 'review_vote_stddev_samp_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "review_vote" */
export type Review_Vote_Stddev_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "review_vote" */
export type Review_Vote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Vote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Vote_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  review_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Review_Vote_Sum_Fields = {
  __typename?: 'review_vote_sum_fields';
  value: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "review_vote" */
export type Review_Vote_Sum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** update columns of table "review_vote" */
export enum Review_Vote_Update_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Value = 'value'
}

export type Review_Vote_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Review_Vote_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Vote_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Vote_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Review_Vote_Var_Pop_Fields = {
  __typename?: 'review_vote_var_pop_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "review_vote" */
export type Review_Vote_Var_Pop_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Review_Vote_Var_Samp_Fields = {
  __typename?: 'review_vote_var_samp_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "review_vote" */
export type Review_Vote_Var_Samp_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Review_Vote_Variance_Fields = {
  __typename?: 'review_vote_variance_fields';
  value: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "review_vote" */
export type Review_Vote_Variance_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "reviewreporttype". All fields are combined with logical 'AND'. */
export type Reviewreporttype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['reviewreporttype']>;
  _gt?: InputMaybe<Scalars['reviewreporttype']>;
  _gte?: InputMaybe<Scalars['reviewreporttype']>;
  _in?: InputMaybe<Array<Scalars['reviewreporttype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['reviewreporttype']>;
  _lte?: InputMaybe<Scalars['reviewreporttype']>;
  _neq?: InputMaybe<Scalars['reviewreporttype']>;
  _nin?: InputMaybe<Array<Scalars['reviewreporttype']>>;
};

/** Boolean expression to compare columns of type "role". All fields are combined with logical 'AND'. */
export type Role_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['role']>;
  _gt?: InputMaybe<Scalars['role']>;
  _gte?: InputMaybe<Scalars['role']>;
  _in?: InputMaybe<Array<Scalars['role']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['role']>;
  _lte?: InputMaybe<Scalars['role']>;
  _neq?: InputMaybe<Scalars['role']>;
  _nin?: InputMaybe<Array<Scalars['role']>>;
};

/** columns and relationships of "salary_report" */
export type Salary_Report = {
  __typename?: 'salary_report';
  admin: Scalars['Boolean'];
  base_amt: Scalars['Int'];
  base_period: Scalars['paymentrateperiod'];
  bonus: Scalars['Boolean'];
  bonus_amt: Maybe<Scalars['String']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  /** An object relationship */
  clinician: Maybe<Clinician>;
  cme: Scalars['Boolean'];
  cme_amt: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamp'];
  experience: Maybe<Scalars['Int']>;
  /** An object relationship */
  facility: Facility;
  facility_id: Scalars['uuid'];
  hrs_per_shift: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  last_modified: Scalars['timestamp'];
  locums: Scalars['Boolean'];
  night_diff: Scalars['Boolean'];
  night_diff_amt: Maybe<Scalars['Int']>;
  nocturnal: Scalars['Boolean'];
  org_id: Maybe<Scalars['uuid']>;
  org_other: Scalars['String'];
  /** An object relationship */
  organization: Maybe<Organization>;
  partner: Scalars['Boolean'];
  partnership_track: Scalars['Boolean'];
  profession: Scalars['profession'];
  reporter_id: Maybe<Scalars['uuid']>;
  retirement: Scalars['Boolean'];
  retirement_amt: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan: Scalars['Boolean'];
  student_loan_amt: Maybe<Scalars['Int']>;
  traveler: Scalars['Boolean'];
  visa_sponsorship: Scalars['Boolean'];
  weekend_diff: Scalars['Boolean'];
  weekend_diff_amt: Maybe<Scalars['Int']>;
  weekends_only: Scalars['Boolean'];
  worker: Scalars['workerclassification'];
};

/** aggregated selection of "salary_report" */
export type Salary_Report_Aggregate = {
  __typename?: 'salary_report_aggregate';
  aggregate: Maybe<Salary_Report_Aggregate_Fields>;
  nodes: Array<Salary_Report>;
};

export type Salary_Report_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Salary_Report_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Salary_Report_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Salary_Report_Aggregate_Bool_Exp_Count>;
};

export type Salary_Report_Aggregate_Bool_Exp_Bool_And = {
  arguments: Salary_Report_Select_Column_Salary_Report_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Salary_Report_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Salary_Report_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Salary_Report_Select_Column_Salary_Report_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Salary_Report_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Salary_Report_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Salary_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Salary_Report_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "salary_report" */
export type Salary_Report_Aggregate_Fields = {
  __typename?: 'salary_report_aggregate_fields';
  avg: Maybe<Salary_Report_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Salary_Report_Max_Fields>;
  min: Maybe<Salary_Report_Min_Fields>;
  stddev: Maybe<Salary_Report_Stddev_Fields>;
  stddev_pop: Maybe<Salary_Report_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Salary_Report_Stddev_Samp_Fields>;
  sum: Maybe<Salary_Report_Sum_Fields>;
  var_pop: Maybe<Salary_Report_Var_Pop_Fields>;
  var_samp: Maybe<Salary_Report_Var_Samp_Fields>;
  variance: Maybe<Salary_Report_Variance_Fields>;
};


/** aggregate fields of "salary_report" */
export type Salary_Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Salary_Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "salary_report" */
export type Salary_Report_Aggregate_Order_By = {
  avg?: InputMaybe<Salary_Report_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Salary_Report_Max_Order_By>;
  min?: InputMaybe<Salary_Report_Min_Order_By>;
  stddev?: InputMaybe<Salary_Report_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Salary_Report_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Salary_Report_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Salary_Report_Sum_Order_By>;
  var_pop?: InputMaybe<Salary_Report_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Salary_Report_Var_Samp_Order_By>;
  variance?: InputMaybe<Salary_Report_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "salary_report" */
export type Salary_Report_Arr_Rel_Insert_Input = {
  data: Array<Salary_Report_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Salary_Report_On_Conflict>;
};

/** aggregate avg on columns */
export type Salary_Report_Avg_Fields = {
  __typename?: 'salary_report_avg_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "salary_report" */
export type Salary_Report_Avg_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "salary_report". All fields are combined with a logical 'AND'. */
export type Salary_Report_Bool_Exp = {
  _and?: InputMaybe<Array<Salary_Report_Bool_Exp>>;
  _not?: InputMaybe<Salary_Report_Bool_Exp>;
  _or?: InputMaybe<Array<Salary_Report_Bool_Exp>>;
  admin?: InputMaybe<Boolean_Comparison_Exp>;
  base_amt?: InputMaybe<Int_Comparison_Exp>;
  base_period?: InputMaybe<Paymentrateperiod_Comparison_Exp>;
  bonus?: InputMaybe<Boolean_Comparison_Exp>;
  bonus_amt?: InputMaybe<String_Comparison_Exp>;
  clinical_hrs?: InputMaybe<Int_Comparison_Exp>;
  clinician?: InputMaybe<Clinician_Bool_Exp>;
  cme?: InputMaybe<Boolean_Comparison_Exp>;
  cme_amt?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  experience?: InputMaybe<Int_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  hrs_per_shift?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  locums?: InputMaybe<Boolean_Comparison_Exp>;
  night_diff?: InputMaybe<Boolean_Comparison_Exp>;
  night_diff_amt?: InputMaybe<Int_Comparison_Exp>;
  nocturnal?: InputMaybe<Boolean_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  org_other?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  partner?: InputMaybe<Boolean_Comparison_Exp>;
  partnership_track?: InputMaybe<Boolean_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
  reporter_id?: InputMaybe<Uuid_Comparison_Exp>;
  retirement?: InputMaybe<Boolean_Comparison_Exp>;
  retirement_amt?: InputMaybe<String_Comparison_Exp>;
  shifts_per_month?: InputMaybe<Int_Comparison_Exp>;
  student_loan?: InputMaybe<Boolean_Comparison_Exp>;
  student_loan_amt?: InputMaybe<Int_Comparison_Exp>;
  traveler?: InputMaybe<Boolean_Comparison_Exp>;
  visa_sponsorship?: InputMaybe<Boolean_Comparison_Exp>;
  weekend_diff?: InputMaybe<Boolean_Comparison_Exp>;
  weekend_diff_amt?: InputMaybe<Int_Comparison_Exp>;
  weekends_only?: InputMaybe<Boolean_Comparison_Exp>;
  worker?: InputMaybe<Workerclassification_Comparison_Exp>;
};

/** unique or primary key constraints on table "salary_report" */
export enum Salary_Report_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSalaryReport = 'pk_salary_report'
}

/** columns and relationships of "salary_report_fmt" */
export type Salary_Report_Fmt = {
  __typename?: 'salary_report_fmt';
  admin: Maybe<Scalars['Boolean']>;
  base_amt: Maybe<Scalars['Int']>;
  base_amt_fmt: Maybe<Scalars['Int']>;
  base_period: Maybe<Scalars['paymentrateperiod']>;
  bonus: Maybe<Scalars['Boolean']>;
  bonus_amt: Maybe<Scalars['String']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme: Maybe<Scalars['Boolean']>;
  cme_amt: Maybe<Scalars['Int']>;
  cme_amt_fmt: Maybe<Scalars['Int']>;
  created_at: Maybe<Scalars['timestamp']>;
  experience: Maybe<Scalars['Int']>;
  /** An object relationship */
  facility: Maybe<Facility>;
  facility_id: Maybe<Scalars['uuid']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  locums: Maybe<Scalars['Boolean']>;
  night_diff: Maybe<Scalars['Boolean']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  night_diff_amt_fmt: Maybe<Scalars['Int']>;
  nocturnal: Maybe<Scalars['Boolean']>;
  org_id: Maybe<Scalars['uuid']>;
  org_other: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Maybe<Organization>;
  partner: Maybe<Scalars['Boolean']>;
  partnership_track: Maybe<Scalars['Boolean']>;
  profession: Maybe<Scalars['profession']>;
  reporter_id: Maybe<Scalars['uuid']>;
  retirement: Maybe<Scalars['Boolean']>;
  retirement_amt: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan: Maybe<Scalars['Boolean']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  student_loan_amt_fmt: Maybe<Scalars['Int']>;
  traveler: Maybe<Scalars['Boolean']>;
  visa_sponsorship: Maybe<Scalars['Boolean']>;
  weekend_diff: Maybe<Scalars['Boolean']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Int']>;
  weekends_only: Maybe<Scalars['Boolean']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** aggregated selection of "salary_report_fmt" */
export type Salary_Report_Fmt_Aggregate = {
  __typename?: 'salary_report_fmt_aggregate';
  aggregate: Maybe<Salary_Report_Fmt_Aggregate_Fields>;
  nodes: Array<Salary_Report_Fmt>;
};

export type Salary_Report_Fmt_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Salary_Report_Fmt_Aggregate_Bool_Exp_Count>;
};

export type Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_And = {
  arguments: Salary_Report_Fmt_Select_Column_Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Salary_Report_Fmt_Select_Column_Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Salary_Report_Fmt_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "salary_report_fmt" */
export type Salary_Report_Fmt_Aggregate_Fields = {
  __typename?: 'salary_report_fmt_aggregate_fields';
  avg: Maybe<Salary_Report_Fmt_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Salary_Report_Fmt_Max_Fields>;
  min: Maybe<Salary_Report_Fmt_Min_Fields>;
  stddev: Maybe<Salary_Report_Fmt_Stddev_Fields>;
  stddev_pop: Maybe<Salary_Report_Fmt_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Salary_Report_Fmt_Stddev_Samp_Fields>;
  sum: Maybe<Salary_Report_Fmt_Sum_Fields>;
  var_pop: Maybe<Salary_Report_Fmt_Var_Pop_Fields>;
  var_samp: Maybe<Salary_Report_Fmt_Var_Samp_Fields>;
  variance: Maybe<Salary_Report_Fmt_Variance_Fields>;
};


/** aggregate fields of "salary_report_fmt" */
export type Salary_Report_Fmt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "salary_report_fmt" */
export type Salary_Report_Fmt_Aggregate_Order_By = {
  avg?: InputMaybe<Salary_Report_Fmt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Salary_Report_Fmt_Max_Order_By>;
  min?: InputMaybe<Salary_Report_Fmt_Min_Order_By>;
  stddev?: InputMaybe<Salary_Report_Fmt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Salary_Report_Fmt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Salary_Report_Fmt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Salary_Report_Fmt_Sum_Order_By>;
  var_pop?: InputMaybe<Salary_Report_Fmt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Salary_Report_Fmt_Var_Samp_Order_By>;
  variance?: InputMaybe<Salary_Report_Fmt_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "salary_report_fmt" */
export type Salary_Report_Fmt_Arr_Rel_Insert_Input = {
  data: Array<Salary_Report_Fmt_Insert_Input>;
};

/** aggregate avg on columns */
export type Salary_Report_Fmt_Avg_Fields = {
  __typename?: 'salary_report_fmt_avg_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Avg_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "salary_report_fmt". All fields are combined with a logical 'AND'. */
export type Salary_Report_Fmt_Bool_Exp = {
  _and?: InputMaybe<Array<Salary_Report_Fmt_Bool_Exp>>;
  _not?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
  _or?: InputMaybe<Array<Salary_Report_Fmt_Bool_Exp>>;
  admin?: InputMaybe<Boolean_Comparison_Exp>;
  base_amt?: InputMaybe<Int_Comparison_Exp>;
  base_amt_fmt?: InputMaybe<Int_Comparison_Exp>;
  base_period?: InputMaybe<Paymentrateperiod_Comparison_Exp>;
  bonus?: InputMaybe<Boolean_Comparison_Exp>;
  bonus_amt?: InputMaybe<String_Comparison_Exp>;
  clinical_hrs?: InputMaybe<Int_Comparison_Exp>;
  cme?: InputMaybe<Boolean_Comparison_Exp>;
  cme_amt?: InputMaybe<Int_Comparison_Exp>;
  cme_amt_fmt?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  experience?: InputMaybe<Int_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  hrs_per_shift?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified?: InputMaybe<Timestamp_Comparison_Exp>;
  locums?: InputMaybe<Boolean_Comparison_Exp>;
  night_diff?: InputMaybe<Boolean_Comparison_Exp>;
  night_diff_amt?: InputMaybe<Int_Comparison_Exp>;
  night_diff_amt_fmt?: InputMaybe<Int_Comparison_Exp>;
  nocturnal?: InputMaybe<Boolean_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  org_other?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  partner?: InputMaybe<Boolean_Comparison_Exp>;
  partnership_track?: InputMaybe<Boolean_Comparison_Exp>;
  profession?: InputMaybe<Profession_Comparison_Exp>;
  reporter_id?: InputMaybe<Uuid_Comparison_Exp>;
  retirement?: InputMaybe<Boolean_Comparison_Exp>;
  retirement_amt?: InputMaybe<String_Comparison_Exp>;
  shifts_per_month?: InputMaybe<Int_Comparison_Exp>;
  student_loan?: InputMaybe<Boolean_Comparison_Exp>;
  student_loan_amt?: InputMaybe<Int_Comparison_Exp>;
  student_loan_amt_fmt?: InputMaybe<Int_Comparison_Exp>;
  traveler?: InputMaybe<Boolean_Comparison_Exp>;
  visa_sponsorship?: InputMaybe<Boolean_Comparison_Exp>;
  weekend_diff?: InputMaybe<Boolean_Comparison_Exp>;
  weekend_diff_amt?: InputMaybe<Int_Comparison_Exp>;
  weekend_diff_amt_fmt?: InputMaybe<Int_Comparison_Exp>;
  weekends_only?: InputMaybe<Boolean_Comparison_Exp>;
  worker?: InputMaybe<Workerclassification_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "salary_report_fmt" */
export type Salary_Report_Fmt_Inc_Input = {
  base_amt?: InputMaybe<Scalars['Int']>;
  base_amt_fmt?: InputMaybe<Scalars['Int']>;
  clinical_hrs?: InputMaybe<Scalars['Int']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  cme_amt_fmt?: InputMaybe<Scalars['Int']>;
  experience?: InputMaybe<Scalars['Int']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  night_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  student_loan_amt_fmt?: InputMaybe<Scalars['Int']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekend_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "salary_report_fmt" */
export type Salary_Report_Fmt_Insert_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  base_amt?: InputMaybe<Scalars['Int']>;
  base_amt_fmt?: InputMaybe<Scalars['Int']>;
  base_period?: InputMaybe<Scalars['paymentrateperiod']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
  bonus_amt?: InputMaybe<Scalars['String']>;
  clinical_hrs?: InputMaybe<Scalars['Int']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  cme_amt_fmt?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  experience?: InputMaybe<Scalars['Int']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  locums?: InputMaybe<Scalars['Boolean']>;
  night_diff?: InputMaybe<Scalars['Boolean']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  night_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  nocturnal?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_other?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  partner?: InputMaybe<Scalars['Boolean']>;
  partnership_track?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  retirement?: InputMaybe<Scalars['Boolean']>;
  retirement_amt?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  student_loan_amt_fmt?: InputMaybe<Scalars['Int']>;
  traveler?: InputMaybe<Scalars['Boolean']>;
  visa_sponsorship?: InputMaybe<Scalars['Boolean']>;
  weekend_diff?: InputMaybe<Scalars['Boolean']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekend_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  weekends_only?: InputMaybe<Scalars['Boolean']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate max on columns */
export type Salary_Report_Fmt_Max_Fields = {
  __typename?: 'salary_report_fmt_max_fields';
  base_amt: Maybe<Scalars['Int']>;
  base_amt_fmt: Maybe<Scalars['Int']>;
  base_period: Maybe<Scalars['paymentrateperiod']>;
  bonus_amt: Maybe<Scalars['String']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme_amt: Maybe<Scalars['Int']>;
  cme_amt_fmt: Maybe<Scalars['Int']>;
  created_at: Maybe<Scalars['timestamp']>;
  experience: Maybe<Scalars['Int']>;
  facility_id: Maybe<Scalars['uuid']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  night_diff_amt_fmt: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['uuid']>;
  org_other: Maybe<Scalars['String']>;
  profession: Maybe<Scalars['profession']>;
  reporter_id: Maybe<Scalars['uuid']>;
  retirement_amt: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  student_loan_amt_fmt: Maybe<Scalars['Int']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Int']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** order by max() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Max_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  base_period?: InputMaybe<Order_By>;
  bonus_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_other?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  retirement_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Salary_Report_Fmt_Min_Fields = {
  __typename?: 'salary_report_fmt_min_fields';
  base_amt: Maybe<Scalars['Int']>;
  base_amt_fmt: Maybe<Scalars['Int']>;
  base_period: Maybe<Scalars['paymentrateperiod']>;
  bonus_amt: Maybe<Scalars['String']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme_amt: Maybe<Scalars['Int']>;
  cme_amt_fmt: Maybe<Scalars['Int']>;
  created_at: Maybe<Scalars['timestamp']>;
  experience: Maybe<Scalars['Int']>;
  facility_id: Maybe<Scalars['uuid']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  night_diff_amt_fmt: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['uuid']>;
  org_other: Maybe<Scalars['String']>;
  profession: Maybe<Scalars['profession']>;
  reporter_id: Maybe<Scalars['uuid']>;
  retirement_amt: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  student_loan_amt_fmt: Maybe<Scalars['Int']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Int']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** order by min() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Min_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  base_period?: InputMaybe<Order_By>;
  bonus_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_other?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  retirement_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "salary_report_fmt" */
export type Salary_Report_Fmt_Mutation_Response = {
  __typename?: 'salary_report_fmt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_Report_Fmt>;
};

/** input type for inserting object relation for remote table "salary_report_fmt" */
export type Salary_Report_Fmt_Obj_Rel_Insert_Input = {
  data: Salary_Report_Fmt_Insert_Input;
};

/** Ordering options when selecting data from "salary_report_fmt". */
export type Salary_Report_Fmt_Order_By = {
  admin?: InputMaybe<Order_By>;
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  base_period?: InputMaybe<Order_By>;
  bonus?: InputMaybe<Order_By>;
  bonus_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  locums?: InputMaybe<Order_By>;
  night_diff?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  nocturnal?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_other?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  partner?: InputMaybe<Order_By>;
  partnership_track?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  retirement?: InputMaybe<Order_By>;
  retirement_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  traveler?: InputMaybe<Order_By>;
  visa_sponsorship?: InputMaybe<Order_By>;
  weekend_diff?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
  weekends_only?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** select columns of table "salary_report_fmt" */
export enum Salary_Report_Fmt_Select_Column {
  /** column name */
  Admin = 'admin',
  /** column name */
  BaseAmt = 'base_amt',
  /** column name */
  BaseAmtFmt = 'base_amt_fmt',
  /** column name */
  BasePeriod = 'base_period',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  BonusAmt = 'bonus_amt',
  /** column name */
  ClinicalHrs = 'clinical_hrs',
  /** column name */
  Cme = 'cme',
  /** column name */
  CmeAmt = 'cme_amt',
  /** column name */
  CmeAmtFmt = 'cme_amt_fmt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Experience = 'experience',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  HrsPerShift = 'hrs_per_shift',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  NightDiffAmt = 'night_diff_amt',
  /** column name */
  NightDiffAmtFmt = 'night_diff_amt_fmt',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgOther = 'org_other',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Profession = 'profession',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  RetirementAmt = 'retirement_amt',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  StudentLoanAmt = 'student_loan_amt',
  /** column name */
  StudentLoanAmtFmt = 'student_loan_amt_fmt',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendDiffAmt = 'weekend_diff_amt',
  /** column name */
  WeekendDiffAmtFmt = 'weekend_diff_amt_fmt',
  /** column name */
  WeekendsOnly = 'weekends_only',
  /** column name */
  Worker = 'worker'
}

/** select "salary_report_fmt_aggregate_bool_exp_bool_and_arguments_columns" columns of table "salary_report_fmt" */
export enum Salary_Report_Fmt_Select_Column_Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Admin = 'admin',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  Cme = 'cme',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendsOnly = 'weekends_only'
}

/** select "salary_report_fmt_aggregate_bool_exp_bool_or_arguments_columns" columns of table "salary_report_fmt" */
export enum Salary_Report_Fmt_Select_Column_Salary_Report_Fmt_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Admin = 'admin',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  Cme = 'cme',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendsOnly = 'weekends_only'
}

/** input type for updating data in table "salary_report_fmt" */
export type Salary_Report_Fmt_Set_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  base_amt?: InputMaybe<Scalars['Int']>;
  base_amt_fmt?: InputMaybe<Scalars['Int']>;
  base_period?: InputMaybe<Scalars['paymentrateperiod']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
  bonus_amt?: InputMaybe<Scalars['String']>;
  clinical_hrs?: InputMaybe<Scalars['Int']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  cme_amt_fmt?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  experience?: InputMaybe<Scalars['Int']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  locums?: InputMaybe<Scalars['Boolean']>;
  night_diff?: InputMaybe<Scalars['Boolean']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  night_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  nocturnal?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_other?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Boolean']>;
  partnership_track?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  retirement?: InputMaybe<Scalars['Boolean']>;
  retirement_amt?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  student_loan_amt_fmt?: InputMaybe<Scalars['Int']>;
  traveler?: InputMaybe<Scalars['Boolean']>;
  visa_sponsorship?: InputMaybe<Scalars['Boolean']>;
  weekend_diff?: InputMaybe<Scalars['Boolean']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekend_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  weekends_only?: InputMaybe<Scalars['Boolean']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate stddev on columns */
export type Salary_Report_Fmt_Stddev_Fields = {
  __typename?: 'salary_report_fmt_stddev_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Stddev_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Salary_Report_Fmt_Stddev_Pop_Fields = {
  __typename?: 'salary_report_fmt_stddev_pop_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Stddev_Pop_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Salary_Report_Fmt_Stddev_Samp_Fields = {
  __typename?: 'salary_report_fmt_stddev_samp_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Stddev_Samp_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "salary_report_fmt" */
export type Salary_Report_Fmt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_Report_Fmt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_Report_Fmt_Stream_Cursor_Value_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  base_amt?: InputMaybe<Scalars['Int']>;
  base_amt_fmt?: InputMaybe<Scalars['Int']>;
  base_period?: InputMaybe<Scalars['paymentrateperiod']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
  bonus_amt?: InputMaybe<Scalars['String']>;
  clinical_hrs?: InputMaybe<Scalars['Int']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  cme_amt_fmt?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  experience?: InputMaybe<Scalars['Int']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  locums?: InputMaybe<Scalars['Boolean']>;
  night_diff?: InputMaybe<Scalars['Boolean']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  night_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  nocturnal?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_other?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Boolean']>;
  partnership_track?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  retirement?: InputMaybe<Scalars['Boolean']>;
  retirement_amt?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  student_loan_amt_fmt?: InputMaybe<Scalars['Int']>;
  traveler?: InputMaybe<Scalars['Boolean']>;
  visa_sponsorship?: InputMaybe<Scalars['Boolean']>;
  weekend_diff?: InputMaybe<Scalars['Boolean']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekend_diff_amt_fmt?: InputMaybe<Scalars['Int']>;
  weekends_only?: InputMaybe<Scalars['Boolean']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate sum on columns */
export type Salary_Report_Fmt_Sum_Fields = {
  __typename?: 'salary_report_fmt_sum_fields';
  base_amt: Maybe<Scalars['Int']>;
  base_amt_fmt: Maybe<Scalars['Int']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme_amt: Maybe<Scalars['Int']>;
  cme_amt_fmt: Maybe<Scalars['Int']>;
  experience: Maybe<Scalars['Int']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  night_diff_amt_fmt: Maybe<Scalars['Int']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  student_loan_amt_fmt: Maybe<Scalars['Int']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Sum_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

export type Salary_Report_Fmt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Salary_Report_Fmt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Salary_Report_Fmt_Set_Input>;
  /** filter the rows which have to be updated */
  where: Salary_Report_Fmt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_Report_Fmt_Var_Pop_Fields = {
  __typename?: 'salary_report_fmt_var_pop_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Var_Pop_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Salary_Report_Fmt_Var_Samp_Fields = {
  __typename?: 'salary_report_fmt_var_samp_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Var_Samp_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Salary_Report_Fmt_Variance_Fields = {
  __typename?: 'salary_report_fmt_variance_fields';
  base_amt: Maybe<Scalars['Float']>;
  base_amt_fmt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  cme_amt_fmt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  night_diff_amt_fmt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  student_loan_amt_fmt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt_fmt: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "salary_report_fmt" */
export type Salary_Report_Fmt_Variance_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_amt_fmt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  cme_amt_fmt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  night_diff_amt_fmt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  student_loan_amt_fmt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekend_diff_amt_fmt?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "salary_report" */
export type Salary_Report_Inc_Input = {
  base_amt?: InputMaybe<Scalars['Int']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  experience?: InputMaybe<Scalars['Int']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "salary_report" */
export type Salary_Report_Insert_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  base_amt?: InputMaybe<Scalars['Int']>;
  base_period?: InputMaybe<Scalars['paymentrateperiod']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
  bonus_amt?: InputMaybe<Scalars['String']>;
  clinician?: InputMaybe<Clinician_Obj_Rel_Insert_Input>;
  cme?: InputMaybe<Scalars['Boolean']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  experience?: InputMaybe<Scalars['Int']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  locums?: InputMaybe<Scalars['Boolean']>;
  night_diff?: InputMaybe<Scalars['Boolean']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  nocturnal?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_other?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  partner?: InputMaybe<Scalars['Boolean']>;
  partnership_track?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  retirement?: InputMaybe<Scalars['Boolean']>;
  retirement_amt?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  traveler?: InputMaybe<Scalars['Boolean']>;
  visa_sponsorship?: InputMaybe<Scalars['Boolean']>;
  weekend_diff?: InputMaybe<Scalars['Boolean']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekends_only?: InputMaybe<Scalars['Boolean']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate max on columns */
export type Salary_Report_Max_Fields = {
  __typename?: 'salary_report_max_fields';
  base_amt: Maybe<Scalars['Int']>;
  base_period: Maybe<Scalars['paymentrateperiod']>;
  bonus_amt: Maybe<Scalars['String']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme_amt: Maybe<Scalars['Int']>;
  created_at: Maybe<Scalars['timestamp']>;
  experience: Maybe<Scalars['Int']>;
  facility_id: Maybe<Scalars['uuid']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['uuid']>;
  org_other: Maybe<Scalars['String']>;
  profession: Maybe<Scalars['profession']>;
  reporter_id: Maybe<Scalars['uuid']>;
  retirement_amt: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** order by max() on columns of table "salary_report" */
export type Salary_Report_Max_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_period?: InputMaybe<Order_By>;
  bonus_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_other?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  retirement_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Salary_Report_Min_Fields = {
  __typename?: 'salary_report_min_fields';
  base_amt: Maybe<Scalars['Int']>;
  base_period: Maybe<Scalars['paymentrateperiod']>;
  bonus_amt: Maybe<Scalars['String']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme_amt: Maybe<Scalars['Int']>;
  created_at: Maybe<Scalars['timestamp']>;
  experience: Maybe<Scalars['Int']>;
  facility_id: Maybe<Scalars['uuid']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  id: Maybe<Scalars['uuid']>;
  last_modified: Maybe<Scalars['timestamp']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['uuid']>;
  org_other: Maybe<Scalars['String']>;
  profession: Maybe<Scalars['profession']>;
  reporter_id: Maybe<Scalars['uuid']>;
  retirement_amt: Maybe<Scalars['String']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
  worker: Maybe<Scalars['workerclassification']>;
};

/** order by min() on columns of table "salary_report" */
export type Salary_Report_Min_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  base_period?: InputMaybe<Order_By>;
  bonus_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_other?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  retirement_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "salary_report" */
export type Salary_Report_Mutation_Response = {
  __typename?: 'salary_report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Salary_Report>;
};

/** on_conflict condition type for table "salary_report" */
export type Salary_Report_On_Conflict = {
  constraint: Salary_Report_Constraint;
  update_columns?: Array<Salary_Report_Update_Column>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};

/** Ordering options when selecting data from "salary_report". */
export type Salary_Report_Order_By = {
  admin?: InputMaybe<Order_By>;
  base_amt?: InputMaybe<Order_By>;
  base_period?: InputMaybe<Order_By>;
  bonus?: InputMaybe<Order_By>;
  bonus_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  clinician?: InputMaybe<Clinician_Order_By>;
  cme?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified?: InputMaybe<Order_By>;
  locums?: InputMaybe<Order_By>;
  night_diff?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  nocturnal?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_other?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  partner?: InputMaybe<Order_By>;
  partnership_track?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  reporter_id?: InputMaybe<Order_By>;
  retirement?: InputMaybe<Order_By>;
  retirement_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  traveler?: InputMaybe<Order_By>;
  visa_sponsorship?: InputMaybe<Order_By>;
  weekend_diff?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
  weekends_only?: InputMaybe<Order_By>;
  worker?: InputMaybe<Order_By>;
};

/** primary key columns input for table: salary_report */
export type Salary_Report_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "salary_report" */
export enum Salary_Report_Select_Column {
  /** column name */
  Admin = 'admin',
  /** column name */
  BaseAmt = 'base_amt',
  /** column name */
  BasePeriod = 'base_period',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  BonusAmt = 'bonus_amt',
  /** column name */
  ClinicalHrs = 'clinical_hrs',
  /** column name */
  Cme = 'cme',
  /** column name */
  CmeAmt = 'cme_amt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Experience = 'experience',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  HrsPerShift = 'hrs_per_shift',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  NightDiffAmt = 'night_diff_amt',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgOther = 'org_other',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Profession = 'profession',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  RetirementAmt = 'retirement_amt',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  StudentLoanAmt = 'student_loan_amt',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendDiffAmt = 'weekend_diff_amt',
  /** column name */
  WeekendsOnly = 'weekends_only',
  /** column name */
  Worker = 'worker'
}

/** select "salary_report_aggregate_bool_exp_bool_and_arguments_columns" columns of table "salary_report" */
export enum Salary_Report_Select_Column_Salary_Report_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Admin = 'admin',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  Cme = 'cme',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendsOnly = 'weekends_only'
}

/** select "salary_report_aggregate_bool_exp_bool_or_arguments_columns" columns of table "salary_report" */
export enum Salary_Report_Select_Column_Salary_Report_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Admin = 'admin',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  Cme = 'cme',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendsOnly = 'weekends_only'
}

/** input type for updating data in table "salary_report" */
export type Salary_Report_Set_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  base_amt?: InputMaybe<Scalars['Int']>;
  base_period?: InputMaybe<Scalars['paymentrateperiod']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
  bonus_amt?: InputMaybe<Scalars['String']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  experience?: InputMaybe<Scalars['Int']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  locums?: InputMaybe<Scalars['Boolean']>;
  night_diff?: InputMaybe<Scalars['Boolean']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  nocturnal?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_other?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Boolean']>;
  partnership_track?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  retirement?: InputMaybe<Scalars['Boolean']>;
  retirement_amt?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  traveler?: InputMaybe<Scalars['Boolean']>;
  visa_sponsorship?: InputMaybe<Scalars['Boolean']>;
  weekend_diff?: InputMaybe<Scalars['Boolean']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekends_only?: InputMaybe<Scalars['Boolean']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate stddev on columns */
export type Salary_Report_Stddev_Fields = {
  __typename?: 'salary_report_stddev_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "salary_report" */
export type Salary_Report_Stddev_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Salary_Report_Stddev_Pop_Fields = {
  __typename?: 'salary_report_stddev_pop_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "salary_report" */
export type Salary_Report_Stddev_Pop_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Salary_Report_Stddev_Samp_Fields = {
  __typename?: 'salary_report_stddev_samp_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "salary_report" */
export type Salary_Report_Stddev_Samp_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "salary_report" */
export type Salary_Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Salary_Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Salary_Report_Stream_Cursor_Value_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  base_amt?: InputMaybe<Scalars['Int']>;
  base_period?: InputMaybe<Scalars['paymentrateperiod']>;
  bonus?: InputMaybe<Scalars['Boolean']>;
  bonus_amt?: InputMaybe<Scalars['String']>;
  clinical_hrs?: InputMaybe<Scalars['Int']>;
  cme?: InputMaybe<Scalars['Boolean']>;
  cme_amt?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  experience?: InputMaybe<Scalars['Int']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  hrs_per_shift?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified?: InputMaybe<Scalars['timestamp']>;
  locums?: InputMaybe<Scalars['Boolean']>;
  night_diff?: InputMaybe<Scalars['Boolean']>;
  night_diff_amt?: InputMaybe<Scalars['Int']>;
  nocturnal?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_other?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Boolean']>;
  partnership_track?: InputMaybe<Scalars['Boolean']>;
  profession?: InputMaybe<Scalars['profession']>;
  reporter_id?: InputMaybe<Scalars['uuid']>;
  retirement?: InputMaybe<Scalars['Boolean']>;
  retirement_amt?: InputMaybe<Scalars['String']>;
  shifts_per_month?: InputMaybe<Scalars['Int']>;
  student_loan?: InputMaybe<Scalars['Boolean']>;
  student_loan_amt?: InputMaybe<Scalars['Int']>;
  traveler?: InputMaybe<Scalars['Boolean']>;
  visa_sponsorship?: InputMaybe<Scalars['Boolean']>;
  weekend_diff?: InputMaybe<Scalars['Boolean']>;
  weekend_diff_amt?: InputMaybe<Scalars['Int']>;
  weekends_only?: InputMaybe<Scalars['Boolean']>;
  worker?: InputMaybe<Scalars['workerclassification']>;
};

/** aggregate sum on columns */
export type Salary_Report_Sum_Fields = {
  __typename?: 'salary_report_sum_fields';
  base_amt: Maybe<Scalars['Int']>;
  clinical_hrs: Maybe<Scalars['Int']>;
  cme_amt: Maybe<Scalars['Int']>;
  experience: Maybe<Scalars['Int']>;
  hrs_per_shift: Maybe<Scalars['Int']>;
  night_diff_amt: Maybe<Scalars['Int']>;
  shifts_per_month: Maybe<Scalars['Int']>;
  student_loan_amt: Maybe<Scalars['Int']>;
  weekend_diff_amt: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "salary_report" */
export type Salary_Report_Sum_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** update columns of table "salary_report" */
export enum Salary_Report_Update_Column {
  /** column name */
  Admin = 'admin',
  /** column name */
  BaseAmt = 'base_amt',
  /** column name */
  BasePeriod = 'base_period',
  /** column name */
  Bonus = 'bonus',
  /** column name */
  BonusAmt = 'bonus_amt',
  /** column name */
  Cme = 'cme',
  /** column name */
  CmeAmt = 'cme_amt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Experience = 'experience',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  HrsPerShift = 'hrs_per_shift',
  /** column name */
  Id = 'id',
  /** column name */
  LastModified = 'last_modified',
  /** column name */
  Locums = 'locums',
  /** column name */
  NightDiff = 'night_diff',
  /** column name */
  NightDiffAmt = 'night_diff_amt',
  /** column name */
  Nocturnal = 'nocturnal',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgOther = 'org_other',
  /** column name */
  Partner = 'partner',
  /** column name */
  PartnershipTrack = 'partnership_track',
  /** column name */
  Profession = 'profession',
  /** column name */
  ReporterId = 'reporter_id',
  /** column name */
  Retirement = 'retirement',
  /** column name */
  RetirementAmt = 'retirement_amt',
  /** column name */
  ShiftsPerMonth = 'shifts_per_month',
  /** column name */
  StudentLoan = 'student_loan',
  /** column name */
  StudentLoanAmt = 'student_loan_amt',
  /** column name */
  Traveler = 'traveler',
  /** column name */
  VisaSponsorship = 'visa_sponsorship',
  /** column name */
  WeekendDiff = 'weekend_diff',
  /** column name */
  WeekendDiffAmt = 'weekend_diff_amt',
  /** column name */
  WeekendsOnly = 'weekends_only',
  /** column name */
  Worker = 'worker'
}

export type Salary_Report_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Salary_Report_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Salary_Report_Set_Input>;
  /** filter the rows which have to be updated */
  where: Salary_Report_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Salary_Report_Var_Pop_Fields = {
  __typename?: 'salary_report_var_pop_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "salary_report" */
export type Salary_Report_Var_Pop_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Salary_Report_Var_Samp_Fields = {
  __typename?: 'salary_report_var_samp_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "salary_report" */
export type Salary_Report_Var_Samp_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Salary_Report_Variance_Fields = {
  __typename?: 'salary_report_variance_fields';
  base_amt: Maybe<Scalars['Float']>;
  clinical_hrs: Maybe<Scalars['Float']>;
  cme_amt: Maybe<Scalars['Float']>;
  experience: Maybe<Scalars['Float']>;
  hrs_per_shift: Maybe<Scalars['Float']>;
  night_diff_amt: Maybe<Scalars['Float']>;
  shifts_per_month: Maybe<Scalars['Float']>;
  student_loan_amt: Maybe<Scalars['Float']>;
  weekend_diff_amt: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "salary_report" */
export type Salary_Report_Variance_Order_By = {
  base_amt?: InputMaybe<Order_By>;
  clinical_hrs?: InputMaybe<Order_By>;
  cme_amt?: InputMaybe<Order_By>;
  experience?: InputMaybe<Order_By>;
  hrs_per_shift?: InputMaybe<Order_By>;
  night_diff_amt?: InputMaybe<Order_By>;
  shifts_per_month?: InputMaybe<Order_By>;
  student_loan_amt?: InputMaybe<Order_By>;
  weekend_diff_amt?: InputMaybe<Order_By>;
};

/** columns and relationships of "school" */
export type School = {
  __typename?: 'school';
  id: Scalars['uuid'];
  name: Scalars['String'];
  prof_degree: Scalars['professionaldegree'];
};

/** aggregated selection of "school" */
export type School_Aggregate = {
  __typename?: 'school_aggregate';
  aggregate: Maybe<School_Aggregate_Fields>;
  nodes: Array<School>;
};

/** aggregate fields of "school" */
export type School_Aggregate_Fields = {
  __typename?: 'school_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<School_Max_Fields>;
  min: Maybe<School_Min_Fields>;
};


/** aggregate fields of "school" */
export type School_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<School_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "school". All fields are combined with a logical 'AND'. */
export type School_Bool_Exp = {
  _and?: InputMaybe<Array<School_Bool_Exp>>;
  _not?: InputMaybe<School_Bool_Exp>;
  _or?: InputMaybe<Array<School_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  prof_degree?: InputMaybe<Professionaldegree_Comparison_Exp>;
};

/** unique or primary key constraints on table "school" */
export enum School_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSchool = 'pk_school',
  /** unique or primary key constraint on columns "prof_degree", "name" */
  UqSchoolProfDegreeName = 'uq_school_prof_degree_name'
}

/** input type for inserting data into table "school" */
export type School_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prof_degree?: InputMaybe<Scalars['professionaldegree']>;
};

/** aggregate max on columns */
export type School_Max_Fields = {
  __typename?: 'school_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  prof_degree: Maybe<Scalars['professionaldegree']>;
};

/** aggregate min on columns */
export type School_Min_Fields = {
  __typename?: 'school_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  prof_degree: Maybe<Scalars['professionaldegree']>;
};

/** response of any mutation on the table "school" */
export type School_Mutation_Response = {
  __typename?: 'school_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<School>;
};

/** on_conflict condition type for table "school" */
export type School_On_Conflict = {
  constraint: School_Constraint;
  update_columns?: Array<School_Update_Column>;
  where?: InputMaybe<School_Bool_Exp>;
};

/** Ordering options when selecting data from "school". */
export type School_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  prof_degree?: InputMaybe<Order_By>;
};

/** primary key columns input for table: school */
export type School_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "school" */
export enum School_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfDegree = 'prof_degree'
}

/** input type for updating data in table "school" */
export type School_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prof_degree?: InputMaybe<Scalars['professionaldegree']>;
};

/** Streaming cursor of the table "school" */
export type School_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: School_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type School_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prof_degree?: InputMaybe<Scalars['professionaldegree']>;
};

/** update columns of table "school" */
export enum School_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfDegree = 'prof_degree'
}

export type School_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<School_Set_Input>;
  /** filter the rows which have to be updated */
  where: School_Bool_Exp;
};

export type Search_Candidate_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "search_candidate_result" */
export type Search_Candidate_Result = {
  __typename?: 'search_candidate_result';
  /** An object relationship */
  candidate: Maybe<Candidate>;
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

export type Search_Candidate_Result_Aggregate = {
  __typename?: 'search_candidate_result_aggregate';
  aggregate: Maybe<Search_Candidate_Result_Aggregate_Fields>;
  nodes: Array<Search_Candidate_Result>;
};

/** aggregate fields of "search_candidate_result" */
export type Search_Candidate_Result_Aggregate_Fields = {
  __typename?: 'search_candidate_result_aggregate_fields';
  avg: Maybe<Search_Candidate_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Candidate_Result_Max_Fields>;
  min: Maybe<Search_Candidate_Result_Min_Fields>;
  stddev: Maybe<Search_Candidate_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Candidate_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Candidate_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Candidate_Result_Sum_Fields>;
  var_pop: Maybe<Search_Candidate_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Candidate_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Candidate_Result_Variance_Fields>;
};


/** aggregate fields of "search_candidate_result" */
export type Search_Candidate_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Candidate_Result_Avg_Fields = {
  __typename?: 'search_candidate_result_avg_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_candidate_result". All fields are combined with a logical 'AND'. */
export type Search_Candidate_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Candidate_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Candidate_Result_Bool_Exp>>;
  candidate?: InputMaybe<Candidate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  relevance?: InputMaybe<Float_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_candidate_result" */
export type Search_Candidate_Result_Inc_Input = {
  relevance?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "search_candidate_result" */
export type Search_Candidate_Result_Insert_Input = {
  candidate?: InputMaybe<Candidate_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Search_Candidate_Result_Max_Fields = {
  __typename?: 'search_candidate_result_max_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Search_Candidate_Result_Min_Fields = {
  __typename?: 'search_candidate_result_min_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "search_candidate_result" */
export type Search_Candidate_Result_Mutation_Response = {
  __typename?: 'search_candidate_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Candidate_Result>;
};

/** Ordering options when selecting data from "search_candidate_result". */
export type Search_Candidate_Result_Order_By = {
  candidate?: InputMaybe<Candidate_Order_By>;
  id?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
};

/** select columns of table "search_candidate_result" */
export enum Search_Candidate_Result_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Relevance = 'relevance'
}

/** input type for updating data in table "search_candidate_result" */
export type Search_Candidate_Result_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Search_Candidate_Result_Stddev_Fields = {
  __typename?: 'search_candidate_result_stddev_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Candidate_Result_Stddev_Pop_Fields = {
  __typename?: 'search_candidate_result_stddev_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Candidate_Result_Stddev_Samp_Fields = {
  __typename?: 'search_candidate_result_stddev_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_candidate_result" */
export type Search_Candidate_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Candidate_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Candidate_Result_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Search_Candidate_Result_Sum_Fields = {
  __typename?: 'search_candidate_result_sum_fields';
  relevance: Maybe<Scalars['Float']>;
};

export type Search_Candidate_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Candidate_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Candidate_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Candidate_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Candidate_Result_Var_Pop_Fields = {
  __typename?: 'search_candidate_result_var_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Candidate_Result_Var_Samp_Fields = {
  __typename?: 'search_candidate_result_var_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Candidate_Result_Variance_Fields = {
  __typename?: 'search_candidate_result_variance_fields';
  relevance: Maybe<Scalars['Float']>;
};

export type Search_Clerkship_By_Geography_Args = {
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result = {
  __typename?: 'search_clerkship_by_geography_result';
  /** An object relationship */
  clerkship: Maybe<Clerkship>;
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

export type Search_Clerkship_By_Geography_Result_Aggregate = {
  __typename?: 'search_clerkship_by_geography_result_aggregate';
  aggregate: Maybe<Search_Clerkship_By_Geography_Result_Aggregate_Fields>;
  nodes: Array<Search_Clerkship_By_Geography_Result>;
};

/** aggregate fields of "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Aggregate_Fields = {
  __typename?: 'search_clerkship_by_geography_result_aggregate_fields';
  avg: Maybe<Search_Clerkship_By_Geography_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Clerkship_By_Geography_Result_Max_Fields>;
  min: Maybe<Search_Clerkship_By_Geography_Result_Min_Fields>;
  stddev: Maybe<Search_Clerkship_By_Geography_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Clerkship_By_Geography_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Clerkship_By_Geography_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Clerkship_By_Geography_Result_Sum_Fields>;
  var_pop: Maybe<Search_Clerkship_By_Geography_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Clerkship_By_Geography_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Clerkship_By_Geography_Result_Variance_Fields>;
};


/** aggregate fields of "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Clerkship_By_Geography_Result_Avg_Fields = {
  __typename?: 'search_clerkship_by_geography_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_clerkship_by_geography_result". All fields are combined with a logical 'AND'. */
export type Search_Clerkship_By_Geography_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Bool_Exp>>;
  clerkship?: InputMaybe<Clerkship_Bool_Exp>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Insert_Input = {
  clerkship?: InputMaybe<Clerkship_Obj_Rel_Insert_Input>;
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Search_Clerkship_By_Geography_Result_Max_Fields = {
  __typename?: 'search_clerkship_by_geography_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Search_Clerkship_By_Geography_Result_Min_Fields = {
  __typename?: 'search_clerkship_by_geography_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Mutation_Response = {
  __typename?: 'search_clerkship_by_geography_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Clerkship_By_Geography_Result>;
};

/** Ordering options when selecting data from "search_clerkship_by_geography_result". */
export type Search_Clerkship_By_Geography_Result_Order_By = {
  clerkship?: InputMaybe<Clerkship_Order_By>;
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "search_clerkship_by_geography_result" */
export enum Search_Clerkship_By_Geography_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Search_Clerkship_By_Geography_Result_Stddev_Fields = {
  __typename?: 'search_clerkship_by_geography_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Clerkship_By_Geography_Result_Stddev_Pop_Fields = {
  __typename?: 'search_clerkship_by_geography_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Clerkship_By_Geography_Result_Stddev_Samp_Fields = {
  __typename?: 'search_clerkship_by_geography_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_clerkship_by_geography_result" */
export type Search_Clerkship_By_Geography_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Clerkship_By_Geography_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Clerkship_By_Geography_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Search_Clerkship_By_Geography_Result_Sum_Fields = {
  __typename?: 'search_clerkship_by_geography_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Search_Clerkship_By_Geography_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Clerkship_By_Geography_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Clerkship_By_Geography_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Clerkship_By_Geography_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Clerkship_By_Geography_Result_Var_Pop_Fields = {
  __typename?: 'search_clerkship_by_geography_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Clerkship_By_Geography_Result_Var_Samp_Fields = {
  __typename?: 'search_clerkship_by_geography_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Clerkship_By_Geography_Result_Variance_Fields = {
  __typename?: 'search_clerkship_by_geography_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Search_Facility_By_Prefix_Args = {
  preload_empty_search?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result = {
  __typename?: 'search_facility_by_prefix_result';
  /** An object relationship */
  facility: Maybe<Facility>;
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

export type Search_Facility_By_Prefix_Result_Aggregate = {
  __typename?: 'search_facility_by_prefix_result_aggregate';
  aggregate: Maybe<Search_Facility_By_Prefix_Result_Aggregate_Fields>;
  nodes: Array<Search_Facility_By_Prefix_Result>;
};

/** aggregate fields of "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Aggregate_Fields = {
  __typename?: 'search_facility_by_prefix_result_aggregate_fields';
  avg: Maybe<Search_Facility_By_Prefix_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Facility_By_Prefix_Result_Max_Fields>;
  min: Maybe<Search_Facility_By_Prefix_Result_Min_Fields>;
  stddev: Maybe<Search_Facility_By_Prefix_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Facility_By_Prefix_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Facility_By_Prefix_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Facility_By_Prefix_Result_Sum_Fields>;
  var_pop: Maybe<Search_Facility_By_Prefix_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Facility_By_Prefix_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Facility_By_Prefix_Result_Variance_Fields>;
};


/** aggregate fields of "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Facility_By_Prefix_Result_Avg_Fields = {
  __typename?: 'search_facility_by_prefix_result_avg_fields';
  rank: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_facility_by_prefix_result". All fields are combined with a logical 'AND'. */
export type Search_Facility_By_Prefix_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Bool_Exp>>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rank?: InputMaybe<Float_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Inc_Input = {
  rank?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Insert_Input = {
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Search_Facility_By_Prefix_Result_Max_Fields = {
  __typename?: 'search_facility_by_prefix_result_max_fields';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Search_Facility_By_Prefix_Result_Min_Fields = {
  __typename?: 'search_facility_by_prefix_result_min_fields';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Mutation_Response = {
  __typename?: 'search_facility_by_prefix_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Facility_By_Prefix_Result>;
};

/** Ordering options when selecting data from "search_facility_by_prefix_result". */
export type Search_Facility_By_Prefix_Result_Order_By = {
  facility?: InputMaybe<Facility_Order_By>;
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** select columns of table "search_facility_by_prefix_result" */
export enum Search_Facility_By_Prefix_Result_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank'
}

/** input type for updating data in table "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Search_Facility_By_Prefix_Result_Stddev_Fields = {
  __typename?: 'search_facility_by_prefix_result_stddev_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Facility_By_Prefix_Result_Stddev_Pop_Fields = {
  __typename?: 'search_facility_by_prefix_result_stddev_pop_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Facility_By_Prefix_Result_Stddev_Samp_Fields = {
  __typename?: 'search_facility_by_prefix_result_stddev_samp_fields';
  rank: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_facility_by_prefix_result" */
export type Search_Facility_By_Prefix_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Facility_By_Prefix_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Facility_By_Prefix_Result_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Search_Facility_By_Prefix_Result_Sum_Fields = {
  __typename?: 'search_facility_by_prefix_result_sum_fields';
  rank: Maybe<Scalars['Float']>;
};

export type Search_Facility_By_Prefix_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Facility_By_Prefix_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Facility_By_Prefix_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Facility_By_Prefix_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Facility_By_Prefix_Result_Var_Pop_Fields = {
  __typename?: 'search_facility_by_prefix_result_var_pop_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Facility_By_Prefix_Result_Var_Samp_Fields = {
  __typename?: 'search_facility_by_prefix_result_var_samp_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Facility_By_Prefix_Result_Variance_Fields = {
  __typename?: 'search_facility_by_prefix_result_variance_fields';
  rank: Maybe<Scalars['Float']>;
};

export type Search_Fellowship_By_Geography_Args = {
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result = {
  __typename?: 'search_fellowship_by_geography_result';
  distance: Maybe<Scalars['float8']>;
  /** An object relationship */
  fellowship: Maybe<Fellowship>;
  id: Maybe<Scalars['uuid']>;
};

export type Search_Fellowship_By_Geography_Result_Aggregate = {
  __typename?: 'search_fellowship_by_geography_result_aggregate';
  aggregate: Maybe<Search_Fellowship_By_Geography_Result_Aggregate_Fields>;
  nodes: Array<Search_Fellowship_By_Geography_Result>;
};

/** aggregate fields of "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Aggregate_Fields = {
  __typename?: 'search_fellowship_by_geography_result_aggregate_fields';
  avg: Maybe<Search_Fellowship_By_Geography_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Fellowship_By_Geography_Result_Max_Fields>;
  min: Maybe<Search_Fellowship_By_Geography_Result_Min_Fields>;
  stddev: Maybe<Search_Fellowship_By_Geography_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Fellowship_By_Geography_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Fellowship_By_Geography_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Fellowship_By_Geography_Result_Sum_Fields>;
  var_pop: Maybe<Search_Fellowship_By_Geography_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Fellowship_By_Geography_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Fellowship_By_Geography_Result_Variance_Fields>;
};


/** aggregate fields of "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Fellowship_By_Geography_Result_Avg_Fields = {
  __typename?: 'search_fellowship_by_geography_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_fellowship_by_geography_result". All fields are combined with a logical 'AND'. */
export type Search_Fellowship_By_Geography_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  fellowship?: InputMaybe<Fellowship_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  fellowship?: InputMaybe<Fellowship_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Search_Fellowship_By_Geography_Result_Max_Fields = {
  __typename?: 'search_fellowship_by_geography_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Search_Fellowship_By_Geography_Result_Min_Fields = {
  __typename?: 'search_fellowship_by_geography_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Mutation_Response = {
  __typename?: 'search_fellowship_by_geography_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Fellowship_By_Geography_Result>;
};

/** Ordering options when selecting data from "search_fellowship_by_geography_result". */
export type Search_Fellowship_By_Geography_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  fellowship?: InputMaybe<Fellowship_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "search_fellowship_by_geography_result" */
export enum Search_Fellowship_By_Geography_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Search_Fellowship_By_Geography_Result_Stddev_Fields = {
  __typename?: 'search_fellowship_by_geography_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Fellowship_By_Geography_Result_Stddev_Pop_Fields = {
  __typename?: 'search_fellowship_by_geography_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Fellowship_By_Geography_Result_Stddev_Samp_Fields = {
  __typename?: 'search_fellowship_by_geography_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_fellowship_by_geography_result" */
export type Search_Fellowship_By_Geography_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Fellowship_By_Geography_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Fellowship_By_Geography_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Search_Fellowship_By_Geography_Result_Sum_Fields = {
  __typename?: 'search_fellowship_by_geography_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Search_Fellowship_By_Geography_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Fellowship_By_Geography_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Fellowship_By_Geography_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Fellowship_By_Geography_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Fellowship_By_Geography_Result_Var_Pop_Fields = {
  __typename?: 'search_fellowship_by_geography_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Fellowship_By_Geography_Result_Var_Samp_Fields = {
  __typename?: 'search_fellowship_by_geography_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Fellowship_By_Geography_Result_Variance_Fields = {
  __typename?: 'search_fellowship_by_geography_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Search_Fsmb_Bio_Args = {
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  npi?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result = {
  __typename?: 'search_fsmb_bio_result';
  fid: Maybe<Scalars['String']>;
  /** An object relationship */
  fsmb_bio: Maybe<Fsmb_Bio>;
  graduation_year: Maybe<Scalars['Int']>;
  lev_first: Maybe<Scalars['Int']>;
  lev_last: Maybe<Scalars['Int']>;
};

export type Search_Fsmb_Bio_Result_Aggregate = {
  __typename?: 'search_fsmb_bio_result_aggregate';
  aggregate: Maybe<Search_Fsmb_Bio_Result_Aggregate_Fields>;
  nodes: Array<Search_Fsmb_Bio_Result>;
};

/** aggregate fields of "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Aggregate_Fields = {
  __typename?: 'search_fsmb_bio_result_aggregate_fields';
  avg: Maybe<Search_Fsmb_Bio_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Fsmb_Bio_Result_Max_Fields>;
  min: Maybe<Search_Fsmb_Bio_Result_Min_Fields>;
  stddev: Maybe<Search_Fsmb_Bio_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Fsmb_Bio_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Fsmb_Bio_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Fsmb_Bio_Result_Sum_Fields>;
  var_pop: Maybe<Search_Fsmb_Bio_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Fsmb_Bio_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Fsmb_Bio_Result_Variance_Fields>;
};


/** aggregate fields of "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Fsmb_Bio_Result_Avg_Fields = {
  __typename?: 'search_fsmb_bio_result_avg_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_fsmb_bio_result". All fields are combined with a logical 'AND'. */
export type Search_Fsmb_Bio_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Fsmb_Bio_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Fsmb_Bio_Result_Bool_Exp>>;
  fid?: InputMaybe<String_Comparison_Exp>;
  fsmb_bio?: InputMaybe<Fsmb_Bio_Bool_Exp>;
  graduation_year?: InputMaybe<Int_Comparison_Exp>;
  lev_first?: InputMaybe<Int_Comparison_Exp>;
  lev_last?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Inc_Input = {
  graduation_year?: InputMaybe<Scalars['Int']>;
  lev_first?: InputMaybe<Scalars['Int']>;
  lev_last?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Insert_Input = {
  fid?: InputMaybe<Scalars['String']>;
  fsmb_bio?: InputMaybe<Fsmb_Bio_Obj_Rel_Insert_Input>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  lev_first?: InputMaybe<Scalars['Int']>;
  lev_last?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Search_Fsmb_Bio_Result_Max_Fields = {
  __typename?: 'search_fsmb_bio_result_max_fields';
  fid: Maybe<Scalars['String']>;
  graduation_year: Maybe<Scalars['Int']>;
  lev_first: Maybe<Scalars['Int']>;
  lev_last: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Search_Fsmb_Bio_Result_Min_Fields = {
  __typename?: 'search_fsmb_bio_result_min_fields';
  fid: Maybe<Scalars['String']>;
  graduation_year: Maybe<Scalars['Int']>;
  lev_first: Maybe<Scalars['Int']>;
  lev_last: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Mutation_Response = {
  __typename?: 'search_fsmb_bio_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Fsmb_Bio_Result>;
};

/** Ordering options when selecting data from "search_fsmb_bio_result". */
export type Search_Fsmb_Bio_Result_Order_By = {
  fid?: InputMaybe<Order_By>;
  fsmb_bio?: InputMaybe<Fsmb_Bio_Order_By>;
  graduation_year?: InputMaybe<Order_By>;
  lev_first?: InputMaybe<Order_By>;
  lev_last?: InputMaybe<Order_By>;
};

/** select columns of table "search_fsmb_bio_result" */
export enum Search_Fsmb_Bio_Result_Select_Column {
  /** column name */
  Fid = 'fid',
  /** column name */
  GraduationYear = 'graduation_year',
  /** column name */
  LevFirst = 'lev_first',
  /** column name */
  LevLast = 'lev_last'
}

/** input type for updating data in table "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Set_Input = {
  fid?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  lev_first?: InputMaybe<Scalars['Int']>;
  lev_last?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Search_Fsmb_Bio_Result_Stddev_Fields = {
  __typename?: 'search_fsmb_bio_result_stddev_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Fsmb_Bio_Result_Stddev_Pop_Fields = {
  __typename?: 'search_fsmb_bio_result_stddev_pop_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Fsmb_Bio_Result_Stddev_Samp_Fields = {
  __typename?: 'search_fsmb_bio_result_stddev_samp_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_fsmb_bio_result" */
export type Search_Fsmb_Bio_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Fsmb_Bio_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Fsmb_Bio_Result_Stream_Cursor_Value_Input = {
  fid?: InputMaybe<Scalars['String']>;
  graduation_year?: InputMaybe<Scalars['Int']>;
  lev_first?: InputMaybe<Scalars['Int']>;
  lev_last?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Search_Fsmb_Bio_Result_Sum_Fields = {
  __typename?: 'search_fsmb_bio_result_sum_fields';
  graduation_year: Maybe<Scalars['Int']>;
  lev_first: Maybe<Scalars['Int']>;
  lev_last: Maybe<Scalars['Int']>;
};

export type Search_Fsmb_Bio_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Fsmb_Bio_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Fsmb_Bio_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Fsmb_Bio_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Fsmb_Bio_Result_Var_Pop_Fields = {
  __typename?: 'search_fsmb_bio_result_var_pop_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Fsmb_Bio_Result_Var_Samp_Fields = {
  __typename?: 'search_fsmb_bio_result_var_samp_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Fsmb_Bio_Result_Variance_Fields = {
  __typename?: 'search_fsmb_bio_result_variance_fields';
  graduation_year: Maybe<Scalars['Float']>;
  lev_first: Maybe<Scalars['Float']>;
  lev_last: Maybe<Scalars['Float']>;
};

export type Search_Job_Postings_By_Geography_Args = {
  place_id?: InputMaybe<Scalars['String']>;
  prof?: InputMaybe<Scalars['profession']>;
  state?: InputMaybe<Scalars['String']>;
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result = {
  __typename?: 'search_job_postings_by_geography_result';
  distance: Scalars['float8'];
  id: Scalars['uuid'];
  /** An object relationship */
  posting: Maybe<Job_Posting>;
};

export type Search_Job_Postings_By_Geography_Result_Aggregate = {
  __typename?: 'search_job_postings_by_geography_result_aggregate';
  aggregate: Maybe<Search_Job_Postings_By_Geography_Result_Aggregate_Fields>;
  nodes: Array<Search_Job_Postings_By_Geography_Result>;
};

/** aggregate fields of "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Aggregate_Fields = {
  __typename?: 'search_job_postings_by_geography_result_aggregate_fields';
  avg: Maybe<Search_Job_Postings_By_Geography_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Job_Postings_By_Geography_Result_Max_Fields>;
  min: Maybe<Search_Job_Postings_By_Geography_Result_Min_Fields>;
  stddev: Maybe<Search_Job_Postings_By_Geography_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Job_Postings_By_Geography_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Job_Postings_By_Geography_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Job_Postings_By_Geography_Result_Sum_Fields>;
  var_pop: Maybe<Search_Job_Postings_By_Geography_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Job_Postings_By_Geography_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Job_Postings_By_Geography_Result_Variance_Fields>;
};


/** aggregate fields of "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Job_Postings_By_Geography_Result_Avg_Fields = {
  __typename?: 'search_job_postings_by_geography_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_job_postings_by_geography_result". All fields are combined with a logical 'AND'. */
export type Search_Job_Postings_By_Geography_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  posting?: InputMaybe<Job_Posting_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  posting?: InputMaybe<Job_Posting_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Search_Job_Postings_By_Geography_Result_Max_Fields = {
  __typename?: 'search_job_postings_by_geography_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Search_Job_Postings_By_Geography_Result_Min_Fields = {
  __typename?: 'search_job_postings_by_geography_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Mutation_Response = {
  __typename?: 'search_job_postings_by_geography_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Job_Postings_By_Geography_Result>;
};

/** Ordering options when selecting data from "search_job_postings_by_geography_result". */
export type Search_Job_Postings_By_Geography_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  posting?: InputMaybe<Job_Posting_Order_By>;
};

/** select columns of table "search_job_postings_by_geography_result" */
export enum Search_Job_Postings_By_Geography_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Search_Job_Postings_By_Geography_Result_Stddev_Fields = {
  __typename?: 'search_job_postings_by_geography_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Job_Postings_By_Geography_Result_Stddev_Pop_Fields = {
  __typename?: 'search_job_postings_by_geography_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Job_Postings_By_Geography_Result_Stddev_Samp_Fields = {
  __typename?: 'search_job_postings_by_geography_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_job_postings_by_geography_result" */
export type Search_Job_Postings_By_Geography_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Job_Postings_By_Geography_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Job_Postings_By_Geography_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Search_Job_Postings_By_Geography_Result_Sum_Fields = {
  __typename?: 'search_job_postings_by_geography_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Search_Job_Postings_By_Geography_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Job_Postings_By_Geography_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Job_Postings_By_Geography_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Job_Postings_By_Geography_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Job_Postings_By_Geography_Result_Var_Pop_Fields = {
  __typename?: 'search_job_postings_by_geography_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Job_Postings_By_Geography_Result_Var_Samp_Fields = {
  __typename?: 'search_job_postings_by_geography_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Job_Postings_By_Geography_Result_Variance_Fields = {
  __typename?: 'search_job_postings_by_geography_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Search_Org_Market_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "search_org_market_result" */
export type Search_Org_Market_Result = {
  __typename?: 'search_org_market_result';
  id: Scalars['uuid'];
  /** An object relationship */
  org_market: Maybe<Org_Market>;
  relevance: Maybe<Scalars['Float']>;
};

export type Search_Org_Market_Result_Aggregate = {
  __typename?: 'search_org_market_result_aggregate';
  aggregate: Maybe<Search_Org_Market_Result_Aggregate_Fields>;
  nodes: Array<Search_Org_Market_Result>;
};

/** aggregate fields of "search_org_market_result" */
export type Search_Org_Market_Result_Aggregate_Fields = {
  __typename?: 'search_org_market_result_aggregate_fields';
  avg: Maybe<Search_Org_Market_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Org_Market_Result_Max_Fields>;
  min: Maybe<Search_Org_Market_Result_Min_Fields>;
  stddev: Maybe<Search_Org_Market_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Org_Market_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Org_Market_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Org_Market_Result_Sum_Fields>;
  var_pop: Maybe<Search_Org_Market_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Org_Market_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Org_Market_Result_Variance_Fields>;
};


/** aggregate fields of "search_org_market_result" */
export type Search_Org_Market_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Org_Market_Result_Avg_Fields = {
  __typename?: 'search_org_market_result_avg_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_org_market_result". All fields are combined with a logical 'AND'. */
export type Search_Org_Market_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Org_Market_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Org_Market_Result_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_market?: InputMaybe<Org_Market_Bool_Exp>;
  relevance?: InputMaybe<Float_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_org_market_result" */
export type Search_Org_Market_Result_Inc_Input = {
  relevance?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "search_org_market_result" */
export type Search_Org_Market_Result_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  org_market?: InputMaybe<Org_Market_Obj_Rel_Insert_Input>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Search_Org_Market_Result_Max_Fields = {
  __typename?: 'search_org_market_result_max_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Search_Org_Market_Result_Min_Fields = {
  __typename?: 'search_org_market_result_min_fields';
  id: Maybe<Scalars['uuid']>;
  relevance: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "search_org_market_result" */
export type Search_Org_Market_Result_Mutation_Response = {
  __typename?: 'search_org_market_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Org_Market_Result>;
};

/** Ordering options when selecting data from "search_org_market_result". */
export type Search_Org_Market_Result_Order_By = {
  id?: InputMaybe<Order_By>;
  org_market?: InputMaybe<Org_Market_Order_By>;
  relevance?: InputMaybe<Order_By>;
};

/** select columns of table "search_org_market_result" */
export enum Search_Org_Market_Result_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Relevance = 'relevance'
}

/** input type for updating data in table "search_org_market_result" */
export type Search_Org_Market_Result_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Search_Org_Market_Result_Stddev_Fields = {
  __typename?: 'search_org_market_result_stddev_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Org_Market_Result_Stddev_Pop_Fields = {
  __typename?: 'search_org_market_result_stddev_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Org_Market_Result_Stddev_Samp_Fields = {
  __typename?: 'search_org_market_result_stddev_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_org_market_result" */
export type Search_Org_Market_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Org_Market_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Org_Market_Result_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  relevance?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Search_Org_Market_Result_Sum_Fields = {
  __typename?: 'search_org_market_result_sum_fields';
  relevance: Maybe<Scalars['Float']>;
};

export type Search_Org_Market_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Org_Market_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Org_Market_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Org_Market_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Org_Market_Result_Var_Pop_Fields = {
  __typename?: 'search_org_market_result_var_pop_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Org_Market_Result_Var_Samp_Fields = {
  __typename?: 'search_org_market_result_var_samp_fields';
  relevance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Org_Market_Result_Variance_Fields = {
  __typename?: 'search_org_market_result_variance_fields';
  relevance: Maybe<Scalars['Float']>;
};

export type Search_Organization_By_Prefix_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result = {
  __typename?: 'search_organization_by_prefix_result';
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  org: Maybe<Organization>;
  rank: Maybe<Scalars['Float']>;
};

export type Search_Organization_By_Prefix_Result_Aggregate = {
  __typename?: 'search_organization_by_prefix_result_aggregate';
  aggregate: Maybe<Search_Organization_By_Prefix_Result_Aggregate_Fields>;
  nodes: Array<Search_Organization_By_Prefix_Result>;
};

/** aggregate fields of "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Aggregate_Fields = {
  __typename?: 'search_organization_by_prefix_result_aggregate_fields';
  avg: Maybe<Search_Organization_By_Prefix_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Organization_By_Prefix_Result_Max_Fields>;
  min: Maybe<Search_Organization_By_Prefix_Result_Min_Fields>;
  stddev: Maybe<Search_Organization_By_Prefix_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Organization_By_Prefix_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Organization_By_Prefix_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Organization_By_Prefix_Result_Sum_Fields>;
  var_pop: Maybe<Search_Organization_By_Prefix_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Organization_By_Prefix_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Organization_By_Prefix_Result_Variance_Fields>;
};


/** aggregate fields of "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Organization_By_Prefix_Result_Avg_Fields = {
  __typename?: 'search_organization_by_prefix_result_avg_fields';
  rank: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_organization_by_prefix_result". All fields are combined with a logical 'AND'. */
export type Search_Organization_By_Prefix_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org?: InputMaybe<Organization_Bool_Exp>;
  rank?: InputMaybe<Float_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Inc_Input = {
  rank?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  org?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Search_Organization_By_Prefix_Result_Max_Fields = {
  __typename?: 'search_organization_by_prefix_result_max_fields';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Search_Organization_By_Prefix_Result_Min_Fields = {
  __typename?: 'search_organization_by_prefix_result_min_fields';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Mutation_Response = {
  __typename?: 'search_organization_by_prefix_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Organization_By_Prefix_Result>;
};

/** Ordering options when selecting data from "search_organization_by_prefix_result". */
export type Search_Organization_By_Prefix_Result_Order_By = {
  id?: InputMaybe<Order_By>;
  org?: InputMaybe<Organization_Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** select columns of table "search_organization_by_prefix_result" */
export enum Search_Organization_By_Prefix_Result_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank'
}

/** input type for updating data in table "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Search_Organization_By_Prefix_Result_Stddev_Fields = {
  __typename?: 'search_organization_by_prefix_result_stddev_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Organization_By_Prefix_Result_Stddev_Pop_Fields = {
  __typename?: 'search_organization_by_prefix_result_stddev_pop_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Organization_By_Prefix_Result_Stddev_Samp_Fields = {
  __typename?: 'search_organization_by_prefix_result_stddev_samp_fields';
  rank: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_organization_by_prefix_result" */
export type Search_Organization_By_Prefix_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Organization_By_Prefix_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Organization_By_Prefix_Result_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Search_Organization_By_Prefix_Result_Sum_Fields = {
  __typename?: 'search_organization_by_prefix_result_sum_fields';
  rank: Maybe<Scalars['Float']>;
};

export type Search_Organization_By_Prefix_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Organization_By_Prefix_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Organization_By_Prefix_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Organization_By_Prefix_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Organization_By_Prefix_Result_Var_Pop_Fields = {
  __typename?: 'search_organization_by_prefix_result_var_pop_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Organization_By_Prefix_Result_Var_Samp_Fields = {
  __typename?: 'search_organization_by_prefix_result_var_samp_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Organization_By_Prefix_Result_Variance_Fields = {
  __typename?: 'search_organization_by_prefix_result_variance_fields';
  rank: Maybe<Scalars['Float']>;
};

export type Search_Ranked_Facilities_By_Geography_Args = {
  place_id?: InputMaybe<Scalars['String']>;
  prof?: InputMaybe<Scalars['profession']>;
  state?: InputMaybe<Scalars['String']>;
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

export type Search_Relevant_Job_Posting_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Relevant_Salary_Report_Args = {
  search?: InputMaybe<Scalars['String']>;
};

export type Search_Residency_By_Geography_Args = {
  x_max?: InputMaybe<Scalars['float8']>;
  x_min?: InputMaybe<Scalars['float8']>;
  y_max?: InputMaybe<Scalars['float8']>;
  y_min?: InputMaybe<Scalars['float8']>;
};

/** columns and relationships of "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result = {
  __typename?: 'search_residency_by_geography_result';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  residency: Maybe<Residency>;
};

export type Search_Residency_By_Geography_Result_Aggregate = {
  __typename?: 'search_residency_by_geography_result_aggregate';
  aggregate: Maybe<Search_Residency_By_Geography_Result_Aggregate_Fields>;
  nodes: Array<Search_Residency_By_Geography_Result>;
};

/** aggregate fields of "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Aggregate_Fields = {
  __typename?: 'search_residency_by_geography_result_aggregate_fields';
  avg: Maybe<Search_Residency_By_Geography_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Residency_By_Geography_Result_Max_Fields>;
  min: Maybe<Search_Residency_By_Geography_Result_Min_Fields>;
  stddev: Maybe<Search_Residency_By_Geography_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Residency_By_Geography_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Residency_By_Geography_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Residency_By_Geography_Result_Sum_Fields>;
  var_pop: Maybe<Search_Residency_By_Geography_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Residency_By_Geography_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Residency_By_Geography_Result_Variance_Fields>;
};


/** aggregate fields of "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Residency_By_Geography_Result_Avg_Fields = {
  __typename?: 'search_residency_by_geography_result_avg_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_residency_by_geography_result". All fields are combined with a logical 'AND'. */
export type Search_Residency_By_Geography_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Residency_By_Geography_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Residency_By_Geography_Result_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Inc_Input = {
  distance?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Insert_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Search_Residency_By_Geography_Result_Max_Fields = {
  __typename?: 'search_residency_by_geography_result_max_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Search_Residency_By_Geography_Result_Min_Fields = {
  __typename?: 'search_residency_by_geography_result_min_fields';
  distance: Maybe<Scalars['float8']>;
  id: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Mutation_Response = {
  __typename?: 'search_residency_by_geography_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Residency_By_Geography_Result>;
};

/** Ordering options when selecting data from "search_residency_by_geography_result". */
export type Search_Residency_By_Geography_Result_Order_By = {
  distance?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
};

/** select columns of table "search_residency_by_geography_result" */
export enum Search_Residency_By_Geography_Result_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Set_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Search_Residency_By_Geography_Result_Stddev_Fields = {
  __typename?: 'search_residency_by_geography_result_stddev_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Residency_By_Geography_Result_Stddev_Pop_Fields = {
  __typename?: 'search_residency_by_geography_result_stddev_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Residency_By_Geography_Result_Stddev_Samp_Fields = {
  __typename?: 'search_residency_by_geography_result_stddev_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_residency_by_geography_result" */
export type Search_Residency_By_Geography_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Residency_By_Geography_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Residency_By_Geography_Result_Stream_Cursor_Value_Input = {
  distance?: InputMaybe<Scalars['float8']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Search_Residency_By_Geography_Result_Sum_Fields = {
  __typename?: 'search_residency_by_geography_result_sum_fields';
  distance: Maybe<Scalars['float8']>;
};

export type Search_Residency_By_Geography_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Residency_By_Geography_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Residency_By_Geography_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Residency_By_Geography_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Residency_By_Geography_Result_Var_Pop_Fields = {
  __typename?: 'search_residency_by_geography_result_var_pop_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Residency_By_Geography_Result_Var_Samp_Fields = {
  __typename?: 'search_residency_by_geography_result_var_samp_fields';
  distance: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Residency_By_Geography_Result_Variance_Fields = {
  __typename?: 'search_residency_by_geography_result_variance_fields';
  distance: Maybe<Scalars['Float']>;
};

export type Search_Training_By_Prefix_Args = {
  search?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result = {
  __typename?: 'search_training_by_prefix_result';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
  /** An object relationship */
  training: Maybe<Training>;
};

export type Search_Training_By_Prefix_Result_Aggregate = {
  __typename?: 'search_training_by_prefix_result_aggregate';
  aggregate: Maybe<Search_Training_By_Prefix_Result_Aggregate_Fields>;
  nodes: Array<Search_Training_By_Prefix_Result>;
};

/** aggregate fields of "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Aggregate_Fields = {
  __typename?: 'search_training_by_prefix_result_aggregate_fields';
  avg: Maybe<Search_Training_By_Prefix_Result_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Search_Training_By_Prefix_Result_Max_Fields>;
  min: Maybe<Search_Training_By_Prefix_Result_Min_Fields>;
  stddev: Maybe<Search_Training_By_Prefix_Result_Stddev_Fields>;
  stddev_pop: Maybe<Search_Training_By_Prefix_Result_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Search_Training_By_Prefix_Result_Stddev_Samp_Fields>;
  sum: Maybe<Search_Training_By_Prefix_Result_Sum_Fields>;
  var_pop: Maybe<Search_Training_By_Prefix_Result_Var_Pop_Fields>;
  var_samp: Maybe<Search_Training_By_Prefix_Result_Var_Samp_Fields>;
  variance: Maybe<Search_Training_By_Prefix_Result_Variance_Fields>;
};


/** aggregate fields of "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Search_Training_By_Prefix_Result_Avg_Fields = {
  __typename?: 'search_training_by_prefix_result_avg_fields';
  rank: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "search_training_by_prefix_result". All fields are combined with a logical 'AND'. */
export type Search_Training_By_Prefix_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Training_By_Prefix_Result_Bool_Exp>>;
  _not?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Training_By_Prefix_Result_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  rank?: InputMaybe<Float_Comparison_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Inc_Input = {
  rank?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
  training?: InputMaybe<Training_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Search_Training_By_Prefix_Result_Max_Fields = {
  __typename?: 'search_training_by_prefix_result_max_fields';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Search_Training_By_Prefix_Result_Min_Fields = {
  __typename?: 'search_training_by_prefix_result_min_fields';
  id: Maybe<Scalars['uuid']>;
  rank: Maybe<Scalars['Float']>;
};

/** response of any mutation on the table "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Mutation_Response = {
  __typename?: 'search_training_by_prefix_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Training_By_Prefix_Result>;
};

/** Ordering options when selecting data from "search_training_by_prefix_result". */
export type Search_Training_By_Prefix_Result_Order_By = {
  id?: InputMaybe<Order_By>;
  rank?: InputMaybe<Order_By>;
  training?: InputMaybe<Training_Order_By>;
};

/** select columns of table "search_training_by_prefix_result" */
export enum Search_Training_By_Prefix_Result_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Rank = 'rank'
}

/** input type for updating data in table "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Search_Training_By_Prefix_Result_Stddev_Fields = {
  __typename?: 'search_training_by_prefix_result_stddev_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Search_Training_By_Prefix_Result_Stddev_Pop_Fields = {
  __typename?: 'search_training_by_prefix_result_stddev_pop_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Search_Training_By_Prefix_Result_Stddev_Samp_Fields = {
  __typename?: 'search_training_by_prefix_result_stddev_samp_fields';
  rank: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "search_training_by_prefix_result" */
export type Search_Training_By_Prefix_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Training_By_Prefix_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Training_By_Prefix_Result_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  rank?: InputMaybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Search_Training_By_Prefix_Result_Sum_Fields = {
  __typename?: 'search_training_by_prefix_result_sum_fields';
  rank: Maybe<Scalars['Float']>;
};

export type Search_Training_By_Prefix_Result_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Search_Training_By_Prefix_Result_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Training_By_Prefix_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Search_Training_By_Prefix_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Search_Training_By_Prefix_Result_Var_Pop_Fields = {
  __typename?: 'search_training_by_prefix_result_var_pop_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Search_Training_By_Prefix_Result_Var_Samp_Fields = {
  __typename?: 'search_training_by_prefix_result_var_samp_fields';
  rank: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Search_Training_By_Prefix_Result_Variance_Fields = {
  __typename?: 'search_training_by_prefix_result_variance_fields';
  rank: Maybe<Scalars['Float']>;
};

/** columns and relationships of "site" */
export type Site = {
  __typename?: 'site';
  emra_featured_training_type: Maybe<Scalars['trainingtype']>;
  id: Scalars['uuid'];
  platform: Scalars['platform'];
};

/** aggregated selection of "site" */
export type Site_Aggregate = {
  __typename?: 'site_aggregate';
  aggregate: Maybe<Site_Aggregate_Fields>;
  nodes: Array<Site>;
};

/** aggregate fields of "site" */
export type Site_Aggregate_Fields = {
  __typename?: 'site_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Site_Max_Fields>;
  min: Maybe<Site_Min_Fields>;
};


/** aggregate fields of "site" */
export type Site_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Site_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "site". All fields are combined with a logical 'AND'. */
export type Site_Bool_Exp = {
  _and?: InputMaybe<Array<Site_Bool_Exp>>;
  _not?: InputMaybe<Site_Bool_Exp>;
  _or?: InputMaybe<Array<Site_Bool_Exp>>;
  emra_featured_training_type?: InputMaybe<Trainingtype_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<Platform_Comparison_Exp>;
};

/** unique or primary key constraints on table "site" */
export enum Site_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkSite = 'pk_site',
  /** unique or primary key constraint on columns "platform" */
  UqSitePlatform = 'uq_site_platform'
}

/** input type for inserting data into table "site" */
export type Site_Insert_Input = {
  emra_featured_training_type?: InputMaybe<Scalars['trainingtype']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
};

/** aggregate max on columns */
export type Site_Max_Fields = {
  __typename?: 'site_max_fields';
  emra_featured_training_type: Maybe<Scalars['trainingtype']>;
  id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
};

/** aggregate min on columns */
export type Site_Min_Fields = {
  __typename?: 'site_min_fields';
  emra_featured_training_type: Maybe<Scalars['trainingtype']>;
  id: Maybe<Scalars['uuid']>;
  platform: Maybe<Scalars['platform']>;
};

/** response of any mutation on the table "site" */
export type Site_Mutation_Response = {
  __typename?: 'site_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Site>;
};

/** on_conflict condition type for table "site" */
export type Site_On_Conflict = {
  constraint: Site_Constraint;
  update_columns?: Array<Site_Update_Column>;
  where?: InputMaybe<Site_Bool_Exp>;
};

/** Ordering options when selecting data from "site". */
export type Site_Order_By = {
  emra_featured_training_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
};

/** primary key columns input for table: site */
export type Site_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "site" */
export enum Site_Select_Column {
  /** column name */
  EmraFeaturedTrainingType = 'emra_featured_training_type',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform'
}

/** input type for updating data in table "site" */
export type Site_Set_Input = {
  emra_featured_training_type?: InputMaybe<Scalars['trainingtype']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
};

/** Streaming cursor of the table "site" */
export type Site_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Site_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Site_Stream_Cursor_Value_Input = {
  emra_featured_training_type?: InputMaybe<Scalars['trainingtype']>;
  id?: InputMaybe<Scalars['uuid']>;
  platform?: InputMaybe<Scalars['platform']>;
};

/** update columns of table "site" */
export enum Site_Update_Column {
  /** column name */
  EmraFeaturedTrainingType = 'emra_featured_training_type',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform'
}

export type Site_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Site_Set_Input>;
  /** filter the rows which have to be updated */
  where: Site_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/** columns and relationships of "stroke_cert" */
export type Stroke_Cert = {
  __typename?: 'stroke_cert';
  effective_date: Maybe<Scalars['date']>;
  /** An object relationship */
  facility: Facility;
  facility_id: Scalars['uuid'];
  id: Scalars['uuid'];
  jc_org_id: Maybe<Scalars['String']>;
  level: Scalars['strokecertlevel'];
};

/** aggregated selection of "stroke_cert" */
export type Stroke_Cert_Aggregate = {
  __typename?: 'stroke_cert_aggregate';
  aggregate: Maybe<Stroke_Cert_Aggregate_Fields>;
  nodes: Array<Stroke_Cert>;
};

export type Stroke_Cert_Aggregate_Bool_Exp = {
  count?: InputMaybe<Stroke_Cert_Aggregate_Bool_Exp_Count>;
};

export type Stroke_Cert_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Stroke_Cert_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "stroke_cert" */
export type Stroke_Cert_Aggregate_Fields = {
  __typename?: 'stroke_cert_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Stroke_Cert_Max_Fields>;
  min: Maybe<Stroke_Cert_Min_Fields>;
};


/** aggregate fields of "stroke_cert" */
export type Stroke_Cert_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "stroke_cert" */
export type Stroke_Cert_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Stroke_Cert_Max_Order_By>;
  min?: InputMaybe<Stroke_Cert_Min_Order_By>;
};

/** input type for inserting array relation for remote table "stroke_cert" */
export type Stroke_Cert_Arr_Rel_Insert_Input = {
  data: Array<Stroke_Cert_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Stroke_Cert_On_Conflict>;
};

/** Boolean expression to filter rows from the table "stroke_cert". All fields are combined with a logical 'AND'. */
export type Stroke_Cert_Bool_Exp = {
  _and?: InputMaybe<Array<Stroke_Cert_Bool_Exp>>;
  _not?: InputMaybe<Stroke_Cert_Bool_Exp>;
  _or?: InputMaybe<Array<Stroke_Cert_Bool_Exp>>;
  effective_date?: InputMaybe<Date_Comparison_Exp>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jc_org_id?: InputMaybe<String_Comparison_Exp>;
  level?: InputMaybe<Strokecertlevel_Comparison_Exp>;
};

/** unique or primary key constraints on table "stroke_cert" */
export enum Stroke_Cert_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkStrokeCert = 'pk_stroke_cert',
  /** unique or primary key constraint on columns "level", "facility_id" */
  UqStrokeCertFacilityIdLevel = 'uq_stroke_cert_facility_id_level'
}

/** input type for inserting data into table "stroke_cert" */
export type Stroke_Cert_Insert_Input = {
  effective_date?: InputMaybe<Scalars['date']>;
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  jc_org_id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['strokecertlevel']>;
};

/** aggregate max on columns */
export type Stroke_Cert_Max_Fields = {
  __typename?: 'stroke_cert_max_fields';
  effective_date: Maybe<Scalars['date']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  jc_org_id: Maybe<Scalars['String']>;
  level: Maybe<Scalars['strokecertlevel']>;
};

/** order by max() on columns of table "stroke_cert" */
export type Stroke_Cert_Max_Order_By = {
  effective_date?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jc_org_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Stroke_Cert_Min_Fields = {
  __typename?: 'stroke_cert_min_fields';
  effective_date: Maybe<Scalars['date']>;
  facility_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  jc_org_id: Maybe<Scalars['String']>;
  level: Maybe<Scalars['strokecertlevel']>;
};

/** order by min() on columns of table "stroke_cert" */
export type Stroke_Cert_Min_Order_By = {
  effective_date?: InputMaybe<Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jc_org_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "stroke_cert" */
export type Stroke_Cert_Mutation_Response = {
  __typename?: 'stroke_cert_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Stroke_Cert>;
};

/** on_conflict condition type for table "stroke_cert" */
export type Stroke_Cert_On_Conflict = {
  constraint: Stroke_Cert_Constraint;
  update_columns?: Array<Stroke_Cert_Update_Column>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};

/** Ordering options when selecting data from "stroke_cert". */
export type Stroke_Cert_Order_By = {
  effective_date?: InputMaybe<Order_By>;
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jc_org_id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
};

/** primary key columns input for table: stroke_cert */
export type Stroke_Cert_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "stroke_cert" */
export enum Stroke_Cert_Select_Column {
  /** column name */
  EffectiveDate = 'effective_date',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  JcOrgId = 'jc_org_id',
  /** column name */
  Level = 'level'
}

/** input type for updating data in table "stroke_cert" */
export type Stroke_Cert_Set_Input = {
  effective_date?: InputMaybe<Scalars['date']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  jc_org_id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['strokecertlevel']>;
};

/** Streaming cursor of the table "stroke_cert" */
export type Stroke_Cert_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Stroke_Cert_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Stroke_Cert_Stream_Cursor_Value_Input = {
  effective_date?: InputMaybe<Scalars['date']>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  jc_org_id?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Scalars['strokecertlevel']>;
};

/** update columns of table "stroke_cert" */
export enum Stroke_Cert_Update_Column {
  /** column name */
  EffectiveDate = 'effective_date',
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  Id = 'id',
  /** column name */
  JcOrgId = 'jc_org_id',
  /** column name */
  Level = 'level'
}

export type Stroke_Cert_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Stroke_Cert_Set_Input>;
  /** filter the rows which have to be updated */
  where: Stroke_Cert_Bool_Exp;
};

/** Boolean expression to compare columns of type "strokecertlevel". All fields are combined with logical 'AND'. */
export type Strokecertlevel_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['strokecertlevel']>;
  _gt?: InputMaybe<Scalars['strokecertlevel']>;
  _gte?: InputMaybe<Scalars['strokecertlevel']>;
  _in?: InputMaybe<Array<Scalars['strokecertlevel']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['strokecertlevel']>;
  _lte?: InputMaybe<Scalars['strokecertlevel']>;
  _neq?: InputMaybe<Scalars['strokecertlevel']>;
  _nin?: InputMaybe<Array<Scalars['strokecertlevel']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "AS20DEM" */
  AS20DEM: Array<As20Dem>;
  /** fetch aggregated fields from the table: "AS20DEM" */
  AS20DEM_aggregate: As20Dem_Aggregate;
  /** fetch data from the table: "AS20DEM" using primary key columns */
  AS20DEM_by_pk: Maybe<As20Dem>;
  /** fetch data from the table in a streaming manner: "AS20DEM" */
  AS20DEM_stream: Array<As20Dem>;
  /** fetch data from the table: "AS20SVC1" */
  AS20SVC1: Array<As20Svc1>;
  /** fetch aggregated fields from the table: "AS20SVC1" */
  AS20SVC1_aggregate: As20Svc1_Aggregate;
  /** fetch data from the table: "AS20SVC1" using primary key columns */
  AS20SVC1_by_pk: Maybe<As20Svc1>;
  /** fetch data from the table in a streaming manner: "AS20SVC1" */
  AS20SVC1_stream: Array<As20Svc1>;
  /** fetch data from the table: "AS20SVC2" */
  AS20SVC2: Array<As20Svc2>;
  /** fetch aggregated fields from the table: "AS20SVC2" */
  AS20SVC2_aggregate: As20Svc2_Aggregate;
  /** fetch data from the table: "AS20SVC2" using primary key columns */
  AS20SVC2_by_pk: Maybe<As20Svc2>;
  /** fetch data from the table in a streaming manner: "AS20SVC2" */
  AS20SVC2_stream: Array<As20Svc2>;
  /** fetch data from the table: "AS20SVC3" */
  AS20SVC3: Array<As20Svc3>;
  /** fetch aggregated fields from the table: "AS20SVC3" */
  AS20SVC3_aggregate: As20Svc3_Aggregate;
  /** fetch data from the table: "AS20SVC3" using primary key columns */
  AS20SVC3_by_pk: Maybe<As20Svc3>;
  /** fetch data from the table in a streaming manner: "AS20SVC3" */
  AS20SVC3_stream: Array<As20Svc3>;
  /** fetch data from the table: "AS20UTIL1" */
  AS20UTIL1: Array<As20Util1>;
  /** fetch aggregated fields from the table: "AS20UTIL1" */
  AS20UTIL1_aggregate: As20Util1_Aggregate;
  /** fetch data from the table: "AS20UTIL1" using primary key columns */
  AS20UTIL1_by_pk: Maybe<As20Util1>;
  /** fetch data from the table in a streaming manner: "AS20UTIL1" */
  AS20UTIL1_stream: Array<As20Util1>;
  /** fetch data from the table: "AS20UTIL2" */
  AS20UTIL2: Array<As20Util2>;
  /** fetch aggregated fields from the table: "AS20UTIL2" */
  AS20UTIL2_aggregate: As20Util2_Aggregate;
  /** fetch data from the table: "AS20UTIL2" using primary key columns */
  AS20UTIL2_by_pk: Maybe<As20Util2>;
  /** fetch data from the table in a streaming manner: "AS20UTIL2" */
  AS20UTIL2_stream: Array<As20Util2>;
  /** fetch data from the table: "AS21DEM" */
  AS21DEM: Array<As21Dem>;
  /** fetch aggregated fields from the table: "AS21DEM" */
  AS21DEM_aggregate: As21Dem_Aggregate;
  /** fetch data from the table: "AS21DEM" using primary key columns */
  AS21DEM_by_pk: Maybe<As21Dem>;
  /** fetch data from the table in a streaming manner: "AS21DEM" */
  AS21DEM_stream: Array<As21Dem>;
  /** fetch data from the table: "AS21SVC1" */
  AS21SVC1: Array<As21Svc1>;
  /** fetch aggregated fields from the table: "AS21SVC1" */
  AS21SVC1_aggregate: As21Svc1_Aggregate;
  /** fetch data from the table: "AS21SVC1" using primary key columns */
  AS21SVC1_by_pk: Maybe<As21Svc1>;
  /** fetch data from the table in a streaming manner: "AS21SVC1" */
  AS21SVC1_stream: Array<As21Svc1>;
  /** fetch data from the table: "AS21SVC2" */
  AS21SVC2: Array<As21Svc2>;
  /** fetch aggregated fields from the table: "AS21SVC2" */
  AS21SVC2_aggregate: As21Svc2_Aggregate;
  /** fetch data from the table: "AS21SVC2" using primary key columns */
  AS21SVC2_by_pk: Maybe<As21Svc2>;
  /** fetch data from the table in a streaming manner: "AS21SVC2" */
  AS21SVC2_stream: Array<As21Svc2>;
  /** fetch data from the table: "AS21SVC3" */
  AS21SVC3: Array<As21Svc3>;
  /** fetch aggregated fields from the table: "AS21SVC3" */
  AS21SVC3_aggregate: As21Svc3_Aggregate;
  /** fetch data from the table: "AS21SVC3" using primary key columns */
  AS21SVC3_by_pk: Maybe<As21Svc3>;
  /** fetch data from the table in a streaming manner: "AS21SVC3" */
  AS21SVC3_stream: Array<As21Svc3>;
  /** fetch data from the table: "AS21UNIT" */
  AS21UNIT: Array<As21Unit>;
  /** fetch aggregated fields from the table: "AS21UNIT" */
  AS21UNIT_aggregate: As21Unit_Aggregate;
  /** fetch data from the table: "AS21UNIT" using primary key columns */
  AS21UNIT_by_pk: Maybe<As21Unit>;
  /** fetch data from the table in a streaming manner: "AS21UNIT" */
  AS21UNIT_stream: Array<As21Unit>;
  /** fetch data from the table: "AS21UTIL" */
  AS21UTIL: Array<As21Util>;
  /** fetch data from the table: "AS21UTIL2" */
  AS21UTIL2: Array<As21Util2>;
  /** fetch aggregated fields from the table: "AS21UTIL2" */
  AS21UTIL2_aggregate: As21Util2_Aggregate;
  /** fetch data from the table: "AS21UTIL2" using primary key columns */
  AS21UTIL2_by_pk: Maybe<As21Util2>;
  /** fetch data from the table in a streaming manner: "AS21UTIL2" */
  AS21UTIL2_stream: Array<As21Util2>;
  /** fetch aggregated fields from the table: "AS21UTIL" */
  AS21UTIL_aggregate: As21Util_Aggregate;
  /** fetch data from the table: "AS21UTIL" using primary key columns */
  AS21UTIL_by_pk: Maybe<As21Util>;
  /** fetch data from the table in a streaming manner: "AS21UTIL" */
  AS21UTIL_stream: Array<As21Util>;
  /** fetch data from the table: "AS22DEM" */
  AS22DEM: Array<As22Dem>;
  /** fetch aggregated fields from the table: "AS22DEM" */
  AS22DEM_aggregate: As22Dem_Aggregate;
  /** fetch data from the table: "AS22DEM" using primary key columns */
  AS22DEM_by_pk: Maybe<As22Dem>;
  /** fetch data from the table in a streaming manner: "AS22DEM" */
  AS22DEM_stream: Array<As22Dem>;
  /** fetch data from the table: "AS22SVC1" */
  AS22SVC1: Array<As22Svc1>;
  /** fetch aggregated fields from the table: "AS22SVC1" */
  AS22SVC1_aggregate: As22Svc1_Aggregate;
  /** fetch data from the table: "AS22SVC1" using primary key columns */
  AS22SVC1_by_pk: Maybe<As22Svc1>;
  /** fetch data from the table in a streaming manner: "AS22SVC1" */
  AS22SVC1_stream: Array<As22Svc1>;
  /** fetch data from the table: "AS22SVC2" */
  AS22SVC2: Array<As22Svc2>;
  /** fetch aggregated fields from the table: "AS22SVC2" */
  AS22SVC2_aggregate: As22Svc2_Aggregate;
  /** fetch data from the table: "AS22SVC2" using primary key columns */
  AS22SVC2_by_pk: Maybe<As22Svc2>;
  /** fetch data from the table in a streaming manner: "AS22SVC2" */
  AS22SVC2_stream: Array<As22Svc2>;
  /** fetch data from the table: "AS22SVC3" */
  AS22SVC3: Array<As22Svc3>;
  /** fetch aggregated fields from the table: "AS22SVC3" */
  AS22SVC3_aggregate: As22Svc3_Aggregate;
  /** fetch data from the table: "AS22SVC3" using primary key columns */
  AS22SVC3_by_pk: Maybe<As22Svc3>;
  /** fetch data from the table in a streaming manner: "AS22SVC3" */
  AS22SVC3_stream: Array<As22Svc3>;
  /** fetch data from the table: "AS22UNIT" */
  AS22UNIT: Array<As22Unit>;
  /** fetch aggregated fields from the table: "AS22UNIT" */
  AS22UNIT_aggregate: As22Unit_Aggregate;
  /** fetch data from the table: "AS22UNIT" using primary key columns */
  AS22UNIT_by_pk: Maybe<As22Unit>;
  /** fetch data from the table in a streaming manner: "AS22UNIT" */
  AS22UNIT_stream: Array<As22Unit>;
  /** fetch data from the table: "AS22UTIL" */
  AS22UTIL: Array<As22Util>;
  /** fetch data from the table: "AS22UTIL2" */
  AS22UTIL2: Array<As22Util2>;
  /** fetch aggregated fields from the table: "AS22UTIL2" */
  AS22UTIL2_aggregate: As22Util2_Aggregate;
  /** fetch data from the table: "AS22UTIL2" using primary key columns */
  AS22UTIL2_by_pk: Maybe<As22Util2>;
  /** fetch data from the table in a streaming manner: "AS22UTIL2" */
  AS22UTIL2_stream: Array<As22Util2>;
  /** fetch aggregated fields from the table: "AS22UTIL" */
  AS22UTIL_aggregate: As22Util_Aggregate;
  /** fetch data from the table: "AS22UTIL" using primary key columns */
  AS22UTIL_by_pk: Maybe<As22Util>;
  /** fetch data from the table in a streaming manner: "AS22UTIL" */
  AS22UTIL_stream: Array<As22Util>;
  /** fetch data from the table: "ab_test" */
  ab_test: Array<Ab_Test>;
  /** fetch aggregated fields from the table: "ab_test" */
  ab_test_aggregate: Ab_Test_Aggregate;
  /** fetch data from the table: "ab_test" using primary key columns */
  ab_test_by_pk: Maybe<Ab_Test>;
  /** fetch data from the table in a streaming manner: "ab_test" */
  ab_test_stream: Array<Ab_Test>;
  /** fetch data from the table: "access_info" */
  access_info: Array<Access_Info>;
  /** fetch aggregated fields from the table: "access_info" */
  access_info_aggregate: Access_Info_Aggregate;
  /** fetch data from the table in a streaming manner: "access_info" */
  access_info_stream: Array<Access_Info>;
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  account_aggregate: Account_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  account_by_pk: Maybe<Account>;
  /** fetch data from the table: "account_role" */
  account_role: Array<Account_Role>;
  /** fetch aggregated fields from the table: "account_role" */
  account_role_aggregate: Account_Role_Aggregate;
  /** fetch data from the table: "account_role" using primary key columns */
  account_role_by_pk: Maybe<Account_Role>;
  /** fetch data from the table in a streaming manner: "account_role" */
  account_role_stream: Array<Account_Role>;
  /** fetch data from the table in a streaming manner: "account" */
  account_stream: Array<Account>;
  /** fetch data from the table: "acep_org_survey" */
  acep_org_survey: Array<Acep_Org_Survey>;
  /** fetch aggregated fields from the table: "acep_org_survey" */
  acep_org_survey_aggregate: Acep_Org_Survey_Aggregate;
  /** fetch data from the table: "acep_org_survey" using primary key columns */
  acep_org_survey_by_pk: Maybe<Acep_Org_Survey>;
  /** fetch data from the table in a streaming manner: "acep_org_survey" */
  acep_org_survey_stream: Array<Acep_Org_Survey>;
  /** fetch data from the table: "board" */
  board: Array<Board>;
  /** fetch aggregated fields from the table: "board" */
  board_aggregate: Board_Aggregate;
  /** fetch data from the table: "board" using primary key columns */
  board_by_pk: Maybe<Board>;
  /** fetch data from the table: "board_cert" */
  board_cert: Array<Board_Cert>;
  /** fetch aggregated fields from the table: "board_cert" */
  board_cert_aggregate: Board_Cert_Aggregate;
  /** fetch data from the table: "board_cert" using primary key columns */
  board_cert_by_pk: Maybe<Board_Cert>;
  /** fetch data from the table in a streaming manner: "board_cert" */
  board_cert_stream: Array<Board_Cert>;
  /** fetch data from the table in a streaming manner: "board" */
  board_stream: Array<Board>;
  bq: Maybe<Bqbq_Subscription>;
  /** fetch data from the table: "candidate" */
  candidate: Array<Candidate>;
  /** fetch aggregated fields from the table: "candidate" */
  candidate_aggregate: Candidate_Aggregate;
  /** fetch data from the table: "candidate" using primary key columns */
  candidate_by_pk: Maybe<Candidate>;
  /** fetch data from the table in a streaming manner: "candidate" */
  candidate_stream: Array<Candidate>;
  /** fetch data from the table: "cert_org" */
  cert_org: Array<Cert_Org>;
  /** fetch aggregated fields from the table: "cert_org" */
  cert_org_aggregate: Cert_Org_Aggregate;
  /** fetch data from the table: "cert_org" using primary key columns */
  cert_org_by_pk: Maybe<Cert_Org>;
  /** fetch data from the table in a streaming manner: "cert_org" */
  cert_org_stream: Array<Cert_Org>;
  /** fetch data from the table: "clerkship" */
  clerkship: Array<Clerkship>;
  /** fetch aggregated fields from the table: "clerkship" */
  clerkship_aggregate: Clerkship_Aggregate;
  /** fetch data from the table: "clerkship" using primary key columns */
  clerkship_by_pk: Maybe<Clerkship>;
  /** fetch data from the table in a streaming manner: "clerkship" */
  clerkship_stream: Array<Clerkship>;
  /** fetch data from the table: "clerkship_survey" */
  clerkship_survey: Array<Clerkship_Survey>;
  /** fetch aggregated fields from the table: "clerkship_survey" */
  clerkship_survey_aggregate: Clerkship_Survey_Aggregate;
  /** fetch data from the table: "clerkship_survey" using primary key columns */
  clerkship_survey_by_pk: Maybe<Clerkship_Survey>;
  /** fetch data from the table in a streaming manner: "clerkship_survey" */
  clerkship_survey_stream: Array<Clerkship_Survey>;
  /** fetch data from the table: "clinician" */
  clinician: Array<Clinician>;
  /** fetch aggregated fields from the table: "clinician" */
  clinician_aggregate: Clinician_Aggregate;
  /** fetch data from the table: "clinician_app_cert" */
  clinician_app_cert: Array<Clinician_App_Cert>;
  /** fetch aggregated fields from the table: "clinician_app_cert" */
  clinician_app_cert_aggregate: Clinician_App_Cert_Aggregate;
  /** fetch data from the table: "clinician_app_cert" using primary key columns */
  clinician_app_cert_by_pk: Maybe<Clinician_App_Cert>;
  /** fetch data from the table in a streaming manner: "clinician_app_cert" */
  clinician_app_cert_stream: Array<Clinician_App_Cert>;
  /** fetch data from the table: "clinician_board_cert" */
  clinician_board_cert: Array<Clinician_Board_Cert>;
  /** fetch aggregated fields from the table: "clinician_board_cert" */
  clinician_board_cert_aggregate: Clinician_Board_Cert_Aggregate;
  /** fetch data from the table: "clinician_board_cert" using primary key columns */
  clinician_board_cert_by_pk: Maybe<Clinician_Board_Cert>;
  /** fetch data from the table in a streaming manner: "clinician_board_cert" */
  clinician_board_cert_stream: Array<Clinician_Board_Cert>;
  /** fetch data from the table: "clinician" using primary key columns */
  clinician_by_pk: Maybe<Clinician>;
  /** fetch data from the table: "clinician_license" */
  clinician_license: Array<Clinician_License>;
  /** fetch aggregated fields from the table: "clinician_license" */
  clinician_license_aggregate: Clinician_License_Aggregate;
  /** fetch data from the table: "clinician_license" using primary key columns */
  clinician_license_by_pk: Maybe<Clinician_License>;
  /** fetch data from the table in a streaming manner: "clinician_license" */
  clinician_license_stream: Array<Clinician_License>;
  /** fetch data from the table: "clinician_sp_exp" */
  clinician_sp_exp: Array<Clinician_Sp_Exp>;
  /** fetch aggregated fields from the table: "clinician_sp_exp" */
  clinician_sp_exp_aggregate: Clinician_Sp_Exp_Aggregate;
  /** fetch data from the table: "clinician_sp_exp" using primary key columns */
  clinician_sp_exp_by_pk: Maybe<Clinician_Sp_Exp>;
  /** fetch data from the table in a streaming manner: "clinician_sp_exp" */
  clinician_sp_exp_stream: Array<Clinician_Sp_Exp>;
  /** fetch data from the table: "clinician_specialty" */
  clinician_specialty: Array<Clinician_Specialty>;
  /** fetch aggregated fields from the table: "clinician_specialty" */
  clinician_specialty_aggregate: Clinician_Specialty_Aggregate;
  /** fetch data from the table: "clinician_specialty" using primary key columns */
  clinician_specialty_by_pk: Maybe<Clinician_Specialty>;
  /** fetch data from the table in a streaming manner: "clinician_specialty" */
  clinician_specialty_stream: Array<Clinician_Specialty>;
  /** fetch data from the table in a streaming manner: "clinician" */
  clinician_stream: Array<Clinician>;
  /** fetch data from the table: "clinician_training" */
  clinician_training: Array<Clinician_Training>;
  /** fetch aggregated fields from the table: "clinician_training" */
  clinician_training_aggregate: Clinician_Training_Aggregate;
  /** fetch data from the table: "clinician_training" using primary key columns */
  clinician_training_by_pk: Maybe<Clinician_Training>;
  /** fetch data from the table in a streaming manner: "clinician_training" */
  clinician_training_stream: Array<Clinician_Training>;
  /** fetch data from the table: "cms_facility" */
  cms_facility: Array<Cms_Facility>;
  /** fetch aggregated fields from the table: "cms_facility" */
  cms_facility_aggregate: Cms_Facility_Aggregate;
  /** fetch data from the table: "cms_facility" using primary key columns */
  cms_facility_by_pk: Maybe<Cms_Facility>;
  /** fetch data from the table: "cms_facility_enrollment" */
  cms_facility_enrollment: Array<Cms_Facility_Enrollment>;
  /** fetch aggregated fields from the table: "cms_facility_enrollment" */
  cms_facility_enrollment_aggregate: Cms_Facility_Enrollment_Aggregate;
  /** fetch data from the table: "cms_facility_enrollment" using primary key columns */
  cms_facility_enrollment_by_pk: Maybe<Cms_Facility_Enrollment>;
  /** fetch data from the table in a streaming manner: "cms_facility_enrollment" */
  cms_facility_enrollment_stream: Array<Cms_Facility_Enrollment>;
  /** fetch data from the table: "cms_facility_metric" */
  cms_facility_metric: Array<Cms_Facility_Metric>;
  /** fetch aggregated fields from the table: "cms_facility_metric" */
  cms_facility_metric_aggregate: Cms_Facility_Metric_Aggregate;
  /** fetch data from the table: "cms_facility_metric" using primary key columns */
  cms_facility_metric_by_pk: Maybe<Cms_Facility_Metric>;
  /** fetch data from the table in a streaming manner: "cms_facility_metric" */
  cms_facility_metric_stream: Array<Cms_Facility_Metric>;
  /** fetch data from the table: "cms_facility_pos" */
  cms_facility_pos: Array<Cms_Facility_Pos>;
  /** fetch aggregated fields from the table: "cms_facility_pos" */
  cms_facility_pos_aggregate: Cms_Facility_Pos_Aggregate;
  /** fetch data from the table: "cms_facility_pos" using primary key columns */
  cms_facility_pos_by_pk: Maybe<Cms_Facility_Pos>;
  /** fetch data from the table in a streaming manner: "cms_facility_pos" */
  cms_facility_pos_stream: Array<Cms_Facility_Pos>;
  /** fetch data from the table in a streaming manner: "cms_facility" */
  cms_facility_stream: Array<Cms_Facility>;
  /** fetch data from the table: "cms_specialty" */
  cms_specialty: Array<Cms_Specialty>;
  /** fetch aggregated fields from the table: "cms_specialty" */
  cms_specialty_aggregate: Cms_Specialty_Aggregate;
  /** fetch data from the table: "cms_specialty" using primary key columns */
  cms_specialty_by_pk: Maybe<Cms_Specialty>;
  /** fetch data from the table in a streaming manner: "cms_specialty" */
  cms_specialty_stream: Array<Cms_Specialty>;
  /** fetch data from the table: "contact_info" */
  contact_info: Array<Contact_Info>;
  /** fetch aggregated fields from the table: "contact_info" */
  contact_info_aggregate: Contact_Info_Aggregate;
  /** fetch data from the table in a streaming manner: "contact_info" */
  contact_info_stream: Array<Contact_Info>;
  /** fetch data from the table: "current_account" */
  current_account: Array<Current_Account>;
  /** fetch aggregated fields from the table: "current_account" */
  current_account_aggregate: Current_Account_Aggregate;
  /** fetch data from the table in a streaming manner: "current_account" */
  current_account_stream: Array<Current_Account>;
  /** fetch data from the table: "email_contact" */
  email_contact: Array<Email_Contact>;
  /** fetch aggregated fields from the table: "email_contact" */
  email_contact_aggregate: Email_Contact_Aggregate;
  /** fetch data from the table: "email_contact" using primary key columns */
  email_contact_by_pk: Maybe<Email_Contact>;
  /** fetch data from the table in a streaming manner: "email_contact" */
  email_contact_stream: Array<Email_Contact>;
  /** fetch data from the table: "email_envelope" */
  email_envelope: Array<Email_Envelope>;
  /** fetch aggregated fields from the table: "email_envelope" */
  email_envelope_aggregate: Email_Envelope_Aggregate;
  /** fetch data from the table: "email_envelope" using primary key columns */
  email_envelope_by_pk: Maybe<Email_Envelope>;
  /** fetch data from the table in a streaming manner: "email_envelope" */
  email_envelope_stream: Array<Email_Envelope>;
  /** fetch data from the table: "email_event" */
  email_event: Array<Email_Event>;
  /** fetch aggregated fields from the table: "email_event" */
  email_event_aggregate: Email_Event_Aggregate;
  /** fetch data from the table: "email_event" using primary key columns */
  email_event_by_pk: Maybe<Email_Event>;
  /** fetch data from the table in a streaming manner: "email_event" */
  email_event_stream: Array<Email_Event>;
  /** fetch data from the table: "email_message" */
  email_message: Array<Email_Message>;
  /** fetch aggregated fields from the table: "email_message" */
  email_message_aggregate: Email_Message_Aggregate;
  /** fetch data from the table: "email_message" using primary key columns */
  email_message_by_pk: Maybe<Email_Message>;
  /** fetch data from the table in a streaming manner: "email_message" */
  email_message_stream: Array<Email_Message>;
  /** fetch data from the table: "email_pointer" */
  email_pointer: Array<Email_Pointer>;
  /** fetch aggregated fields from the table: "email_pointer" */
  email_pointer_aggregate: Email_Pointer_Aggregate;
  /** fetch data from the table: "email_pointer" using primary key columns */
  email_pointer_by_pk: Maybe<Email_Pointer>;
  /** fetch data from the table in a streaming manner: "email_pointer" */
  email_pointer_stream: Array<Email_Pointer>;
  /** fetch data from the table: "ext_job_posting" */
  ext_job_posting: Array<Ext_Job_Posting>;
  /** fetch aggregated fields from the table: "ext_job_posting" */
  ext_job_posting_aggregate: Ext_Job_Posting_Aggregate;
  /** fetch data from the table: "ext_job_posting" using primary key columns */
  ext_job_posting_by_pk: Maybe<Ext_Job_Posting>;
  /** fetch data from the table in a streaming manner: "ext_job_posting" */
  ext_job_posting_stream: Array<Ext_Job_Posting>;
  /** fetch data from the table: "ext_job_scrape" */
  ext_job_scrape: Array<Ext_Job_Scrape>;
  /** fetch aggregated fields from the table: "ext_job_scrape" */
  ext_job_scrape_aggregate: Ext_Job_Scrape_Aggregate;
  /** fetch data from the table: "ext_job_scrape" using primary key columns */
  ext_job_scrape_by_pk: Maybe<Ext_Job_Scrape>;
  /** fetch data from the table in a streaming manner: "ext_job_scrape" */
  ext_job_scrape_stream: Array<Ext_Job_Scrape>;
  /** fetch data from the table: "ext_posting_error" */
  ext_posting_error: Array<Ext_Posting_Error>;
  /** fetch aggregated fields from the table: "ext_posting_error" */
  ext_posting_error_aggregate: Ext_Posting_Error_Aggregate;
  /** fetch data from the table: "ext_posting_error" using primary key columns */
  ext_posting_error_by_pk: Maybe<Ext_Posting_Error>;
  /** fetch data from the table in a streaming manner: "ext_posting_error" */
  ext_posting_error_stream: Array<Ext_Posting_Error>;
  /** fetch data from the table: "ext_posting_profession" */
  ext_posting_profession: Array<Ext_Posting_Profession>;
  /** fetch aggregated fields from the table: "ext_posting_profession" */
  ext_posting_profession_aggregate: Ext_Posting_Profession_Aggregate;
  /** fetch data from the table: "ext_posting_profession" using primary key columns */
  ext_posting_profession_by_pk: Maybe<Ext_Posting_Profession>;
  /** fetch data from the table in a streaming manner: "ext_posting_profession" */
  ext_posting_profession_stream: Array<Ext_Posting_Profession>;
  /** fetch data from the table: "facility" */
  facility: Array<Facility>;
  /** fetch data from the table: "facility_accreditation" */
  facility_accreditation: Array<Facility_Accreditation>;
  /** fetch aggregated fields from the table: "facility_accreditation" */
  facility_accreditation_aggregate: Facility_Accreditation_Aggregate;
  /** fetch data from the table: "facility_accreditation" using primary key columns */
  facility_accreditation_by_pk: Maybe<Facility_Accreditation>;
  /** fetch data from the table in a streaming manner: "facility_accreditation" */
  facility_accreditation_stream: Array<Facility_Accreditation>;
  /** fetch aggregated fields from the table: "facility" */
  facility_aggregate: Facility_Aggregate;
  /** fetch data from the table: "facility" using primary key columns */
  facility_by_pk: Maybe<Facility>;
  /** fetch data from the table: "facility_contract" */
  facility_contract: Array<Facility_Contract>;
  /** fetch aggregated fields from the table: "facility_contract" */
  facility_contract_aggregate: Facility_Contract_Aggregate;
  /** fetch data from the table: "facility_contract" using primary key columns */
  facility_contract_by_pk: Maybe<Facility_Contract>;
  /** fetch data from the table: "facility_contract_featured" */
  facility_contract_featured: Array<Facility_Contract_Featured>;
  /** fetch aggregated fields from the table: "facility_contract_featured" */
  facility_contract_featured_aggregate: Facility_Contract_Featured_Aggregate;
  /** fetch data from the table: "facility_contract_featured" using primary key columns */
  facility_contract_featured_by_pk: Maybe<Facility_Contract_Featured>;
  /** fetch data from the table in a streaming manner: "facility_contract_featured" */
  facility_contract_featured_stream: Array<Facility_Contract_Featured>;
  /** fetch data from the table in a streaming manner: "facility_contract" */
  facility_contract_stream: Array<Facility_Contract>;
  /** fetch data from the table: "facility_correction" */
  facility_correction: Array<Facility_Correction>;
  /** fetch aggregated fields from the table: "facility_correction" */
  facility_correction_aggregate: Facility_Correction_Aggregate;
  /** fetch data from the table: "facility_correction" using primary key columns */
  facility_correction_by_pk: Maybe<Facility_Correction>;
  /** fetch data from the table in a streaming manner: "facility_correction" */
  facility_correction_stream: Array<Facility_Correction>;
  /** execute function "facility_dist" which returns "facility_dist_result" */
  facility_dist: Array<Facility_Dist_Result>;
  /** execute function "facility_dist" and query aggregates on result of table type "facility_dist_result" */
  facility_dist_aggregate: Facility_Dist_Result_Aggregate;
  /** fetch data from the table: "facility_dist_result" */
  facility_dist_result: Array<Facility_Dist_Result>;
  /** fetch aggregated fields from the table: "facility_dist_result" */
  facility_dist_result_aggregate: Facility_Dist_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "facility_dist_result" */
  facility_dist_result_stream: Array<Facility_Dist_Result>;
  /** fetch data from the table: "facility_ehr" */
  facility_ehr: Array<Facility_Ehr>;
  /** fetch aggregated fields from the table: "facility_ehr" */
  facility_ehr_aggregate: Facility_Ehr_Aggregate;
  /** fetch data from the table: "facility_ehr" using primary key columns */
  facility_ehr_by_pk: Maybe<Facility_Ehr>;
  /** fetch data from the table in a streaming manner: "facility_ehr" */
  facility_ehr_stream: Array<Facility_Ehr>;
  /** fetch data from the table: "facility_rating" */
  facility_rating: Array<Facility_Rating>;
  /** fetch aggregated fields from the table: "facility_rating" */
  facility_rating_aggregate: Facility_Rating_Aggregate;
  /** fetch data from the table in a streaming manner: "facility_rating" */
  facility_rating_stream: Array<Facility_Rating>;
  /** fetch data from the table in a streaming manner: "facility" */
  facility_stream: Array<Facility>;
  /** fetch data from the table: "favorite" */
  favorite: Array<Favorite>;
  /** fetch aggregated fields from the table: "favorite" */
  favorite_aggregate: Favorite_Aggregate;
  /** fetch data from the table: "favorite" using primary key columns */
  favorite_by_pk: Maybe<Favorite>;
  /** fetch data from the table in a streaming manner: "favorite" */
  favorite_stream: Array<Favorite>;
  /** execute function "featured_clerkship_dist" which returns "featured_clerkship_dist_result" */
  featured_clerkship_dist: Array<Featured_Clerkship_Dist_Result>;
  /** execute function "featured_clerkship_dist" and query aggregates on result of table type "featured_clerkship_dist_result" */
  featured_clerkship_dist_aggregate: Featured_Clerkship_Dist_Result_Aggregate;
  /** fetch data from the table: "featured_clerkship_dist_result" */
  featured_clerkship_dist_result: Array<Featured_Clerkship_Dist_Result>;
  /** fetch aggregated fields from the table: "featured_clerkship_dist_result" */
  featured_clerkship_dist_result_aggregate: Featured_Clerkship_Dist_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "featured_clerkship_dist_result" */
  featured_clerkship_dist_result_stream: Array<Featured_Clerkship_Dist_Result>;
  /** execute function "featured_fellowship_dist" which returns "featured_fellowship_dist_result" */
  featured_fellowship_dist: Array<Featured_Fellowship_Dist_Result>;
  /** execute function "featured_fellowship_dist" and query aggregates on result of table type "featured_fellowship_dist_result" */
  featured_fellowship_dist_aggregate: Featured_Fellowship_Dist_Result_Aggregate;
  /** fetch data from the table: "featured_fellowship_dist_result" */
  featured_fellowship_dist_result: Array<Featured_Fellowship_Dist_Result>;
  /** fetch aggregated fields from the table: "featured_fellowship_dist_result" */
  featured_fellowship_dist_result_aggregate: Featured_Fellowship_Dist_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "featured_fellowship_dist_result" */
  featured_fellowship_dist_result_stream: Array<Featured_Fellowship_Dist_Result>;
  /** execute function "featured_residency_dist" which returns "featured_residency_dist_result" */
  featured_residency_dist: Array<Featured_Residency_Dist_Result>;
  /** execute function "featured_residency_dist" and query aggregates on result of table type "featured_residency_dist_result" */
  featured_residency_dist_aggregate: Featured_Residency_Dist_Result_Aggregate;
  /** fetch data from the table: "featured_residency_dist_result" */
  featured_residency_dist_result: Array<Featured_Residency_Dist_Result>;
  /** fetch aggregated fields from the table: "featured_residency_dist_result" */
  featured_residency_dist_result_aggregate: Featured_Residency_Dist_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "featured_residency_dist_result" */
  featured_residency_dist_result_stream: Array<Featured_Residency_Dist_Result>;
  /** fetch data from the table: "fellowship" */
  fellowship: Array<Fellowship>;
  /** fetch aggregated fields from the table: "fellowship" */
  fellowship_aggregate: Fellowship_Aggregate;
  /** fetch data from the table: "fellowship" using primary key columns */
  fellowship_by_pk: Maybe<Fellowship>;
  /** fetch data from the table in a streaming manner: "fellowship" */
  fellowship_stream: Array<Fellowship>;
  /** fetch data from the table: "fellowship_survey" */
  fellowship_survey: Array<Fellowship_Survey>;
  /** fetch aggregated fields from the table: "fellowship_survey" */
  fellowship_survey_aggregate: Fellowship_Survey_Aggregate;
  /** fetch data from the table: "fellowship_survey" using primary key columns */
  fellowship_survey_by_pk: Maybe<Fellowship_Survey>;
  /** fetch data from the table in a streaming manner: "fellowship_survey" */
  fellowship_survey_stream: Array<Fellowship_Survey>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk: Maybe<File>;
  /** fetch data from the table in a streaming manner: "file" */
  file_stream: Array<File>;
  /** fetch data from the table: "fsmb_bio" */
  fsmb_bio: Array<Fsmb_Bio>;
  /** fetch aggregated fields from the table: "fsmb_bio" */
  fsmb_bio_aggregate: Fsmb_Bio_Aggregate;
  /** fetch data from the table: "fsmb_bio" using primary key columns */
  fsmb_bio_by_pk: Maybe<Fsmb_Bio>;
  /** fetch data from the table in a streaming manner: "fsmb_bio" */
  fsmb_bio_stream: Array<Fsmb_Bio>;
  /** fetch data from the table: "fsmb_licensure" */
  fsmb_licensure: Array<Fsmb_Licensure>;
  /** fetch aggregated fields from the table: "fsmb_licensure" */
  fsmb_licensure_aggregate: Fsmb_Licensure_Aggregate;
  /** fetch data from the table: "fsmb_licensure" using primary key columns */
  fsmb_licensure_by_pk: Maybe<Fsmb_Licensure>;
  /** fetch data from the table in a streaming manner: "fsmb_licensure" */
  fsmb_licensure_stream: Array<Fsmb_Licensure>;
  /** fetch data from the table: "gmaps_link" */
  gmaps_link: Array<Gmaps_Link>;
  /** fetch aggregated fields from the table: "gmaps_link" */
  gmaps_link_aggregate: Gmaps_Link_Aggregate;
  /** fetch data from the table: "gmaps_link" using primary key columns */
  gmaps_link_by_pk: Maybe<Gmaps_Link>;
  /** fetch data from the table in a streaming manner: "gmaps_link" */
  gmaps_link_stream: Array<Gmaps_Link>;
  /** fetch data from the table: "gmaps_link_type" */
  gmaps_link_type: Array<Gmaps_Link_Type>;
  /** fetch aggregated fields from the table: "gmaps_link_type" */
  gmaps_link_type_aggregate: Gmaps_Link_Type_Aggregate;
  /** fetch data from the table: "gmaps_link_type" using primary key columns */
  gmaps_link_type_by_pk: Maybe<Gmaps_Link_Type>;
  /** fetch data from the table in a streaming manner: "gmaps_link_type" */
  gmaps_link_type_stream: Array<Gmaps_Link_Type>;
  /** fetch data from the table: "gmaps_place" */
  gmaps_place: Array<Gmaps_Place>;
  /** fetch aggregated fields from the table: "gmaps_place" */
  gmaps_place_aggregate: Gmaps_Place_Aggregate;
  /** fetch data from the table: "gmaps_place" using primary key columns */
  gmaps_place_by_pk: Maybe<Gmaps_Place>;
  /** fetch data from the table in a streaming manner: "gmaps_place" */
  gmaps_place_stream: Array<Gmaps_Place>;
  hello: Scalars['String'];
  /** fetch data from the table: "identity_provider" */
  identity_provider: Array<Identity_Provider>;
  /** fetch aggregated fields from the table: "identity_provider" */
  identity_provider_aggregate: Identity_Provider_Aggregate;
  /** fetch data from the table: "identity_provider" using primary key columns */
  identity_provider_by_pk: Maybe<Identity_Provider>;
  /** fetch data from the table in a streaming manner: "identity_provider" */
  identity_provider_stream: Array<Identity_Provider>;
  /** fetch data from the table: "job_application" */
  job_application: Array<Job_Application>;
  /** fetch aggregated fields from the table: "job_application" */
  job_application_aggregate: Job_Application_Aggregate;
  /** fetch data from the table: "job_application_batch" */
  job_application_batch: Array<Job_Application_Batch>;
  /** fetch aggregated fields from the table: "job_application_batch" */
  job_application_batch_aggregate: Job_Application_Batch_Aggregate;
  /** fetch data from the table: "job_application_batch" using primary key columns */
  job_application_batch_by_pk: Maybe<Job_Application_Batch>;
  /** fetch data from the table in a streaming manner: "job_application_batch" */
  job_application_batch_stream: Array<Job_Application_Batch>;
  /** fetch data from the table: "job_application" using primary key columns */
  job_application_by_pk: Maybe<Job_Application>;
  /** fetch data from the table: "job_application_posting" */
  job_application_posting: Array<Job_Application_Posting>;
  /** fetch aggregated fields from the table: "job_application_posting" */
  job_application_posting_aggregate: Job_Application_Posting_Aggregate;
  /** fetch data from the table: "job_application_posting" using primary key columns */
  job_application_posting_by_pk: Maybe<Job_Application_Posting>;
  /** fetch data from the table in a streaming manner: "job_application_posting" */
  job_application_posting_stream: Array<Job_Application_Posting>;
  /** fetch data from the table in a streaming manner: "job_application" */
  job_application_stream: Array<Job_Application>;
  /** fetch data from the table: "job_posting" */
  job_posting: Array<Job_Posting>;
  /** fetch aggregated fields from the table: "job_posting" */
  job_posting_aggregate: Job_Posting_Aggregate;
  /** fetch data from the table: "job_posting" using primary key columns */
  job_posting_by_pk: Maybe<Job_Posting>;
  /** fetch data from the table in a streaming manner: "job_posting" */
  job_posting_stream: Array<Job_Posting>;
  /** fetch data from the table: "latest_clerkship_survey" */
  latest_clerkship_survey: Array<Latest_Clerkship_Survey>;
  /** fetch aggregated fields from the table: "latest_clerkship_survey" */
  latest_clerkship_survey_aggregate: Latest_Clerkship_Survey_Aggregate;
  /** fetch data from the table in a streaming manner: "latest_clerkship_survey" */
  latest_clerkship_survey_stream: Array<Latest_Clerkship_Survey>;
  /** fetch data from the table: "latest_fellowship_survey" */
  latest_fellowship_survey: Array<Latest_Fellowship_Survey>;
  /** fetch aggregated fields from the table: "latest_fellowship_survey" */
  latest_fellowship_survey_aggregate: Latest_Fellowship_Survey_Aggregate;
  /** fetch data from the table in a streaming manner: "latest_fellowship_survey" */
  latest_fellowship_survey_stream: Array<Latest_Fellowship_Survey>;
  /** fetch data from the table: "latest_residency_survey" */
  latest_residency_survey: Array<Latest_Residency_Survey>;
  /** fetch aggregated fields from the table: "latest_residency_survey" */
  latest_residency_survey_aggregate: Latest_Residency_Survey_Aggregate;
  /** fetch data from the table in a streaming manner: "latest_residency_survey" */
  latest_residency_survey_stream: Array<Latest_Residency_Survey>;
  /** execute function "nearby_facilities_by_geography" which returns "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography: Array<Nearby_Facilities_By_Geography_Result>;
  /** execute function "nearby_facilities_by_geography" and query aggregates on result of table type "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_aggregate: Nearby_Facilities_By_Geography_Result_Aggregate;
  /** fetch data from the table: "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_result: Array<Nearby_Facilities_By_Geography_Result>;
  /** fetch aggregated fields from the table: "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_result_aggregate: Nearby_Facilities_By_Geography_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "nearby_facilities_by_geography_result" */
  nearby_facilities_by_geography_result_stream: Array<Nearby_Facilities_By_Geography_Result>;
  /** execute function "org_dist" which returns "org_dist_result" */
  org_dist: Array<Org_Dist_Result>;
  /** execute function "org_dist" and query aggregates on result of table type "org_dist_result" */
  org_dist_aggregate: Org_Dist_Result_Aggregate;
  /** fetch data from the table: "org_dist_result" */
  org_dist_result: Array<Org_Dist_Result>;
  /** fetch aggregated fields from the table: "org_dist_result" */
  org_dist_result_aggregate: Org_Dist_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "org_dist_result" */
  org_dist_result_stream: Array<Org_Dist_Result>;
  /** fetch data from the table: "org_domain" */
  org_domain: Array<Org_Domain>;
  /** fetch aggregated fields from the table: "org_domain" */
  org_domain_aggregate: Org_Domain_Aggregate;
  /** fetch data from the table: "org_domain" using primary key columns */
  org_domain_by_pk: Maybe<Org_Domain>;
  /** fetch data from the table in a streaming manner: "org_domain" */
  org_domain_stream: Array<Org_Domain>;
  /** fetch data from the table: "org_market" */
  org_market: Array<Org_Market>;
  /** fetch aggregated fields from the table: "org_market" */
  org_market_aggregate: Org_Market_Aggregate;
  /** fetch data from the table in a streaming manner: "org_market" */
  org_market_stream: Array<Org_Market>;
  /** fetch data from the table: "org_rating" */
  org_rating: Array<Org_Rating>;
  /** fetch aggregated fields from the table: "org_rating" */
  org_rating_aggregate: Org_Rating_Aggregate;
  /** fetch data from the table in a streaming manner: "org_rating" */
  org_rating_stream: Array<Org_Rating>;
  /** fetch data from the table: "org_user" */
  org_user: Array<Org_User>;
  /** fetch aggregated fields from the table: "org_user" */
  org_user_aggregate: Org_User_Aggregate;
  /** fetch data from the table: "org_user" using primary key columns */
  org_user_by_pk: Maybe<Org_User>;
  /** fetch data from the table in a streaming manner: "org_user" */
  org_user_stream: Array<Org_User>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization_bounds" */
  organization_bounds: Array<Organization_Bounds>;
  /** fetch aggregated fields from the table: "organization_bounds" */
  organization_bounds_aggregate: Organization_Bounds_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_bounds" */
  organization_bounds_stream: Array<Organization_Bounds>;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk: Maybe<Organization>;
  /** fetch data from the table: "organization_job_posting" */
  organization_job_posting: Array<Organization_Job_Posting>;
  /** fetch aggregated fields from the table: "organization_job_posting" */
  organization_job_posting_aggregate: Organization_Job_Posting_Aggregate;
  /** fetch data from the table in a streaming manner: "organization_job_posting" */
  organization_job_posting_stream: Array<Organization_Job_Posting>;
  /** fetch data from the table in a streaming manner: "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "personal_info" */
  personal_info: Array<Personal_Info>;
  /** fetch aggregated fields from the table: "personal_info" */
  personal_info_aggregate: Personal_Info_Aggregate;
  /** fetch data from the table in a streaming manner: "personal_info" */
  personal_info_stream: Array<Personal_Info>;
  /** fetch data from the table: "place_boundary" */
  place_boundary: Array<Place_Boundary>;
  /** fetch aggregated fields from the table: "place_boundary" */
  place_boundary_aggregate: Place_Boundary_Aggregate;
  /** fetch data from the table: "place_boundary" using primary key columns */
  place_boundary_by_pk: Maybe<Place_Boundary>;
  /** fetch data from the table in a streaming manner: "place_boundary" */
  place_boundary_stream: Array<Place_Boundary>;
  /** fetch data from the table: "posting_app_cert" */
  posting_app_cert: Array<Posting_App_Cert>;
  /** fetch aggregated fields from the table: "posting_app_cert" */
  posting_app_cert_aggregate: Posting_App_Cert_Aggregate;
  /** fetch data from the table: "posting_app_cert" using primary key columns */
  posting_app_cert_by_pk: Maybe<Posting_App_Cert>;
  /** fetch data from the table in a streaming manner: "posting_app_cert" */
  posting_app_cert_stream: Array<Posting_App_Cert>;
  /** fetch data from the table: "posting_board_cert" */
  posting_board_cert: Array<Posting_Board_Cert>;
  /** fetch aggregated fields from the table: "posting_board_cert" */
  posting_board_cert_aggregate: Posting_Board_Cert_Aggregate;
  /** fetch data from the table: "posting_board_cert" using primary key columns */
  posting_board_cert_by_pk: Maybe<Posting_Board_Cert>;
  /** fetch data from the table in a streaming manner: "posting_board_cert" */
  posting_board_cert_stream: Array<Posting_Board_Cert>;
  /** fetch data from the table: "posting_latest_publication" */
  posting_latest_publication: Array<Posting_Latest_Publication>;
  /** fetch aggregated fields from the table: "posting_latest_publication" */
  posting_latest_publication_aggregate: Posting_Latest_Publication_Aggregate;
  /** fetch data from the table in a streaming manner: "posting_latest_publication" */
  posting_latest_publication_stream: Array<Posting_Latest_Publication>;
  /** fetch data from the table: "posting_profession" */
  posting_profession: Array<Posting_Profession>;
  /** fetch aggregated fields from the table: "posting_profession" */
  posting_profession_aggregate: Posting_Profession_Aggregate;
  /** fetch data from the table: "posting_profession" using primary key columns */
  posting_profession_by_pk: Maybe<Posting_Profession>;
  /** fetch data from the table in a streaming manner: "posting_profession" */
  posting_profession_stream: Array<Posting_Profession>;
  /** fetch data from the table: "posting_worker_classification" */
  posting_worker_classification: Array<Posting_Worker_Classification>;
  /** fetch aggregated fields from the table: "posting_worker_classification" */
  posting_worker_classification_aggregate: Posting_Worker_Classification_Aggregate;
  /** fetch data from the table: "posting_worker_classification" using primary key columns */
  posting_worker_classification_by_pk: Maybe<Posting_Worker_Classification>;
  /** fetch data from the table in a streaming manner: "posting_worker_classification" */
  posting_worker_classification_stream: Array<Posting_Worker_Classification>;
  /** fetch data from the table: "ranked_facility" */
  ranked_facility: Array<Ranked_Facility>;
  /** fetch aggregated fields from the table: "ranked_facility" */
  ranked_facility_aggregate: Ranked_Facility_Aggregate;
  /** execute function "ranked_facility_dist" which returns "ranked_facility" */
  ranked_facility_dist: Array<Ranked_Facility>;
  /** execute function "ranked_facility_dist" and query aggregates on result of table type "ranked_facility" */
  ranked_facility_dist_aggregate: Ranked_Facility_Aggregate;
  /** fetch data from the table in a streaming manner: "ranked_facility" */
  ranked_facility_stream: Array<Ranked_Facility>;
  /** fetch data from the table: "relevant_job_posting" */
  relevant_job_posting: Array<Relevant_Job_Posting>;
  /** fetch aggregated fields from the table: "relevant_job_posting" */
  relevant_job_posting_aggregate: Relevant_Job_Posting_Aggregate;
  /** fetch data from the table in a streaming manner: "relevant_job_posting" */
  relevant_job_posting_stream: Array<Relevant_Job_Posting>;
  /** fetch data from the table: "relevant_salary_report" */
  relevant_salary_report: Array<Relevant_Salary_Report>;
  /** fetch aggregated fields from the table: "relevant_salary_report" */
  relevant_salary_report_aggregate: Relevant_Salary_Report_Aggregate;
  /** fetch data from the table in a streaming manner: "relevant_salary_report" */
  relevant_salary_report_stream: Array<Relevant_Salary_Report>;
  /** fetch data from the table: "residency" */
  residency: Array<Residency>;
  /** fetch aggregated fields from the table: "residency" */
  residency_aggregate: Residency_Aggregate;
  /** fetch data from the table: "residency" using primary key columns */
  residency_by_pk: Maybe<Residency>;
  /** fetch data from the table in a streaming manner: "residency" */
  residency_stream: Array<Residency>;
  /** fetch data from the table: "residency_survey" */
  residency_survey: Array<Residency_Survey>;
  /** fetch aggregated fields from the table: "residency_survey" */
  residency_survey_aggregate: Residency_Survey_Aggregate;
  /** fetch data from the table: "residency_survey" using primary key columns */
  residency_survey_by_pk: Maybe<Residency_Survey>;
  /** fetch data from the table in a streaming manner: "residency_survey" */
  residency_survey_stream: Array<Residency_Survey>;
  /** fetch data from the table: "review" */
  review: Array<Review>;
  /** fetch aggregated fields from the table: "review" */
  review_aggregate: Review_Aggregate;
  /** fetch data from the table: "review" using primary key columns */
  review_by_pk: Maybe<Review>;
  /** fetch data from the table: "review_reply" */
  review_reply: Array<Review_Reply>;
  /** fetch aggregated fields from the table: "review_reply" */
  review_reply_aggregate: Review_Reply_Aggregate;
  /** fetch data from the table: "review_reply" using primary key columns */
  review_reply_by_pk: Maybe<Review_Reply>;
  /** fetch data from the table in a streaming manner: "review_reply" */
  review_reply_stream: Array<Review_Reply>;
  /** fetch data from the table: "review_report" */
  review_report: Array<Review_Report>;
  /** fetch aggregated fields from the table: "review_report" */
  review_report_aggregate: Review_Report_Aggregate;
  /** fetch data from the table: "review_report" using primary key columns */
  review_report_by_pk: Maybe<Review_Report>;
  /** fetch data from the table in a streaming manner: "review_report" */
  review_report_stream: Array<Review_Report>;
  /** fetch data from the table in a streaming manner: "review" */
  review_stream: Array<Review>;
  /** fetch data from the table: "review_vote" */
  review_vote: Array<Review_Vote>;
  /** fetch aggregated fields from the table: "review_vote" */
  review_vote_aggregate: Review_Vote_Aggregate;
  /** fetch data from the table: "review_vote" using primary key columns */
  review_vote_by_pk: Maybe<Review_Vote>;
  /** fetch data from the table in a streaming manner: "review_vote" */
  review_vote_stream: Array<Review_Vote>;
  /** fetch data from the table: "salary_report" */
  salary_report: Array<Salary_Report>;
  /** fetch aggregated fields from the table: "salary_report" */
  salary_report_aggregate: Salary_Report_Aggregate;
  /** fetch data from the table: "salary_report" using primary key columns */
  salary_report_by_pk: Maybe<Salary_Report>;
  /** fetch data from the table: "salary_report_fmt" */
  salary_report_fmt: Array<Salary_Report_Fmt>;
  /** fetch aggregated fields from the table: "salary_report_fmt" */
  salary_report_fmt_aggregate: Salary_Report_Fmt_Aggregate;
  /** fetch data from the table in a streaming manner: "salary_report_fmt" */
  salary_report_fmt_stream: Array<Salary_Report_Fmt>;
  /** fetch data from the table in a streaming manner: "salary_report" */
  salary_report_stream: Array<Salary_Report>;
  /** fetch data from the table: "school" */
  school: Array<School>;
  /** fetch aggregated fields from the table: "school" */
  school_aggregate: School_Aggregate;
  /** fetch data from the table: "school" using primary key columns */
  school_by_pk: Maybe<School>;
  /** fetch data from the table in a streaming manner: "school" */
  school_stream: Array<School>;
  /** execute function "search_candidate" which returns "search_candidate_result" */
  search_candidate: Array<Search_Candidate_Result>;
  /** execute function "search_candidate" and query aggregates on result of table type "search_candidate_result" */
  search_candidate_aggregate: Search_Candidate_Result_Aggregate;
  /** fetch data from the table: "search_candidate_result" */
  search_candidate_result: Array<Search_Candidate_Result>;
  /** fetch aggregated fields from the table: "search_candidate_result" */
  search_candidate_result_aggregate: Search_Candidate_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_candidate_result" */
  search_candidate_result_stream: Array<Search_Candidate_Result>;
  /** execute function "search_clerkship_by_geography" which returns "search_clerkship_by_geography_result" */
  search_clerkship_by_geography: Array<Search_Clerkship_By_Geography_Result>;
  /** execute function "search_clerkship_by_geography" and query aggregates on result of table type "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_aggregate: Search_Clerkship_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_result: Array<Search_Clerkship_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_result_aggregate: Search_Clerkship_By_Geography_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_clerkship_by_geography_result" */
  search_clerkship_by_geography_result_stream: Array<Search_Clerkship_By_Geography_Result>;
  /** execute function "search_facility_by_prefix" which returns "search_facility_by_prefix_result" */
  search_facility_by_prefix: Array<Search_Facility_By_Prefix_Result>;
  /** execute function "search_facility_by_prefix" and query aggregates on result of table type "search_facility_by_prefix_result" */
  search_facility_by_prefix_aggregate: Search_Facility_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "search_facility_by_prefix_result" */
  search_facility_by_prefix_result: Array<Search_Facility_By_Prefix_Result>;
  /** fetch aggregated fields from the table: "search_facility_by_prefix_result" */
  search_facility_by_prefix_result_aggregate: Search_Facility_By_Prefix_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_facility_by_prefix_result" */
  search_facility_by_prefix_result_stream: Array<Search_Facility_By_Prefix_Result>;
  /** execute function "search_fellowship_by_geography" which returns "search_fellowship_by_geography_result" */
  search_fellowship_by_geography: Array<Search_Fellowship_By_Geography_Result>;
  /** execute function "search_fellowship_by_geography" and query aggregates on result of table type "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_aggregate: Search_Fellowship_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_result: Array<Search_Fellowship_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_result_aggregate: Search_Fellowship_By_Geography_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_fellowship_by_geography_result" */
  search_fellowship_by_geography_result_stream: Array<Search_Fellowship_By_Geography_Result>;
  /** execute function "search_fsmb_bio" which returns "search_fsmb_bio_result" */
  search_fsmb_bio: Array<Search_Fsmb_Bio_Result>;
  /** execute function "search_fsmb_bio" and query aggregates on result of table type "search_fsmb_bio_result" */
  search_fsmb_bio_aggregate: Search_Fsmb_Bio_Result_Aggregate;
  /** fetch data from the table: "search_fsmb_bio_result" */
  search_fsmb_bio_result: Array<Search_Fsmb_Bio_Result>;
  /** fetch aggregated fields from the table: "search_fsmb_bio_result" */
  search_fsmb_bio_result_aggregate: Search_Fsmb_Bio_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_fsmb_bio_result" */
  search_fsmb_bio_result_stream: Array<Search_Fsmb_Bio_Result>;
  /** execute function "search_job_postings_by_geography" which returns "search_job_postings_by_geography_result" */
  search_job_postings_by_geography: Array<Search_Job_Postings_By_Geography_Result>;
  /** execute function "search_job_postings_by_geography" and query aggregates on result of table type "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_aggregate: Search_Job_Postings_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_result: Array<Search_Job_Postings_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_result_aggregate: Search_Job_Postings_By_Geography_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_job_postings_by_geography_result" */
  search_job_postings_by_geography_result_stream: Array<Search_Job_Postings_By_Geography_Result>;
  /** execute function "search_org_market" which returns "search_org_market_result" */
  search_org_market: Array<Search_Org_Market_Result>;
  /** execute function "search_org_market" and query aggregates on result of table type "search_org_market_result" */
  search_org_market_aggregate: Search_Org_Market_Result_Aggregate;
  /** fetch data from the table: "search_org_market_result" */
  search_org_market_result: Array<Search_Org_Market_Result>;
  /** fetch aggregated fields from the table: "search_org_market_result" */
  search_org_market_result_aggregate: Search_Org_Market_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_org_market_result" */
  search_org_market_result_stream: Array<Search_Org_Market_Result>;
  /** execute function "search_organization_by_prefix" which returns "search_organization_by_prefix_result" */
  search_organization_by_prefix: Array<Search_Organization_By_Prefix_Result>;
  /** execute function "search_organization_by_prefix" and query aggregates on result of table type "search_organization_by_prefix_result" */
  search_organization_by_prefix_aggregate: Search_Organization_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "search_organization_by_prefix_result" */
  search_organization_by_prefix_result: Array<Search_Organization_By_Prefix_Result>;
  /** fetch aggregated fields from the table: "search_organization_by_prefix_result" */
  search_organization_by_prefix_result_aggregate: Search_Organization_By_Prefix_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_organization_by_prefix_result" */
  search_organization_by_prefix_result_stream: Array<Search_Organization_By_Prefix_Result>;
  /** execute function "search_ranked_facilities_by_geography" which returns "ranked_facility" */
  search_ranked_facilities_by_geography: Array<Ranked_Facility>;
  /** execute function "search_ranked_facilities_by_geography" and query aggregates on result of table type "ranked_facility" */
  search_ranked_facilities_by_geography_aggregate: Ranked_Facility_Aggregate;
  /** execute function "search_relevant_job_posting" which returns "relevant_job_posting" */
  search_relevant_job_posting: Array<Relevant_Job_Posting>;
  /** execute function "search_relevant_job_posting" and query aggregates on result of table type "relevant_job_posting" */
  search_relevant_job_posting_aggregate: Relevant_Job_Posting_Aggregate;
  /** execute function "search_relevant_salary_report" which returns "relevant_salary_report" */
  search_relevant_salary_report: Array<Relevant_Salary_Report>;
  /** execute function "search_relevant_salary_report" and query aggregates on result of table type "relevant_salary_report" */
  search_relevant_salary_report_aggregate: Relevant_Salary_Report_Aggregate;
  /** execute function "search_residency_by_geography" which returns "search_residency_by_geography_result" */
  search_residency_by_geography: Array<Search_Residency_By_Geography_Result>;
  /** execute function "search_residency_by_geography" and query aggregates on result of table type "search_residency_by_geography_result" */
  search_residency_by_geography_aggregate: Search_Residency_By_Geography_Result_Aggregate;
  /** fetch data from the table: "search_residency_by_geography_result" */
  search_residency_by_geography_result: Array<Search_Residency_By_Geography_Result>;
  /** fetch aggregated fields from the table: "search_residency_by_geography_result" */
  search_residency_by_geography_result_aggregate: Search_Residency_By_Geography_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_residency_by_geography_result" */
  search_residency_by_geography_result_stream: Array<Search_Residency_By_Geography_Result>;
  /** execute function "search_training_by_prefix" which returns "search_training_by_prefix_result" */
  search_training_by_prefix: Array<Search_Training_By_Prefix_Result>;
  /** execute function "search_training_by_prefix" and query aggregates on result of table type "search_training_by_prefix_result" */
  search_training_by_prefix_aggregate: Search_Training_By_Prefix_Result_Aggregate;
  /** fetch data from the table: "search_training_by_prefix_result" */
  search_training_by_prefix_result: Array<Search_Training_By_Prefix_Result>;
  /** fetch aggregated fields from the table: "search_training_by_prefix_result" */
  search_training_by_prefix_result_aggregate: Search_Training_By_Prefix_Result_Aggregate;
  /** fetch data from the table in a streaming manner: "search_training_by_prefix_result" */
  search_training_by_prefix_result_stream: Array<Search_Training_By_Prefix_Result>;
  /** fetch data from the table: "site" */
  site: Array<Site>;
  /** fetch aggregated fields from the table: "site" */
  site_aggregate: Site_Aggregate;
  /** fetch data from the table: "site" using primary key columns */
  site_by_pk: Maybe<Site>;
  /** fetch data from the table in a streaming manner: "site" */
  site_stream: Array<Site>;
  /** fetch data from the table: "stroke_cert" */
  stroke_cert: Array<Stroke_Cert>;
  /** fetch aggregated fields from the table: "stroke_cert" */
  stroke_cert_aggregate: Stroke_Cert_Aggregate;
  /** fetch data from the table: "stroke_cert" using primary key columns */
  stroke_cert_by_pk: Maybe<Stroke_Cert>;
  /** fetch data from the table in a streaming manner: "stroke_cert" */
  stroke_cert_stream: Array<Stroke_Cert>;
  /** execute function "suggest_ranked_facilities" which returns "ranked_facility" */
  suggest_ranked_facilities: Array<Ranked_Facility>;
  /** execute function "suggest_ranked_facilities" and query aggregates on result of table type "ranked_facility" */
  suggest_ranked_facilities_aggregate: Ranked_Facility_Aggregate;
  /** fetch data from the table: "training" */
  training: Array<Training>;
  /** fetch aggregated fields from the table: "training" */
  training_aggregate: Training_Aggregate;
  /** fetch data from the table: "training" using primary key columns */
  training_by_pk: Maybe<Training>;
  /** fetch data from the table: "training_event" */
  training_event: Array<Training_Event>;
  /** fetch aggregated fields from the table: "training_event" */
  training_event_aggregate: Training_Event_Aggregate;
  /** fetch data from the table: "training_event" using primary key columns */
  training_event_by_pk: Maybe<Training_Event>;
  /** fetch data from the table in a streaming manner: "training_event" */
  training_event_stream: Array<Training_Event>;
  /** fetch data from the table: "training_field" */
  training_field: Array<Training_Field>;
  /** fetch aggregated fields from the table: "training_field" */
  training_field_aggregate: Training_Field_Aggregate;
  /** fetch data from the table: "training_field" using primary key columns */
  training_field_by_pk: Maybe<Training_Field>;
  /** fetch data from the table in a streaming manner: "training_field" */
  training_field_stream: Array<Training_Field>;
  /** fetch data from the table: "training_program" */
  training_program: Array<Training_Program>;
  /** fetch aggregated fields from the table: "training_program" */
  training_program_aggregate: Training_Program_Aggregate;
  /** fetch data from the table: "training_program" using primary key columns */
  training_program_by_pk: Maybe<Training_Program>;
  /** fetch data from the table in a streaming manner: "training_program" */
  training_program_stream: Array<Training_Program>;
  /** fetch data from the table in a streaming manner: "training" */
  training_stream: Array<Training>;
  /** fetch data from the table: "training_survey" */
  training_survey: Array<Training_Survey>;
  /** fetch aggregated fields from the table: "training_survey" */
  training_survey_aggregate: Training_Survey_Aggregate;
  /** fetch data from the table: "training_survey" using primary key columns */
  training_survey_by_pk: Maybe<Training_Survey>;
  /** fetch data from the table: "training_survey_picture" */
  training_survey_picture: Array<Training_Survey_Picture>;
  /** fetch aggregated fields from the table: "training_survey_picture" */
  training_survey_picture_aggregate: Training_Survey_Picture_Aggregate;
  /** fetch data from the table: "training_survey_picture" using primary key columns */
  training_survey_picture_by_pk: Maybe<Training_Survey_Picture>;
  /** fetch data from the table in a streaming manner: "training_survey_picture" */
  training_survey_picture_stream: Array<Training_Survey_Picture>;
  /** fetch data from the table: "training_survey_site" */
  training_survey_site: Array<Training_Survey_Site>;
  /** fetch aggregated fields from the table: "training_survey_site" */
  training_survey_site_aggregate: Training_Survey_Site_Aggregate;
  /** fetch data from the table: "training_survey_site" using primary key columns */
  training_survey_site_by_pk: Maybe<Training_Survey_Site>;
  /** fetch data from the table in a streaming manner: "training_survey_site" */
  training_survey_site_stream: Array<Training_Survey_Site>;
  /** fetch data from the table in a streaming manner: "training_survey" */
  training_survey_stream: Array<Training_Survey>;
};


export type Subscription_RootAs20DemArgs = {
  distinct_on?: InputMaybe<Array<As20Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Dem_Order_By>>;
  where?: InputMaybe<As20Dem_Bool_Exp>;
};


export type Subscription_RootAs20Dem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Dem_Order_By>>;
  where?: InputMaybe<As20Dem_Bool_Exp>;
};


export type Subscription_RootAs20Dem_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs20Dem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As20Dem_Stream_Cursor_Input>>;
  where?: InputMaybe<As20Dem_Bool_Exp>;
};


export type Subscription_RootAs20Svc1Args = {
  distinct_on?: InputMaybe<Array<As20Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc1_Order_By>>;
  where?: InputMaybe<As20Svc1_Bool_Exp>;
};


export type Subscription_RootAs20Svc1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc1_Order_By>>;
  where?: InputMaybe<As20Svc1_Bool_Exp>;
};


export type Subscription_RootAs20Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs20Svc1_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As20Svc1_Stream_Cursor_Input>>;
  where?: InputMaybe<As20Svc1_Bool_Exp>;
};


export type Subscription_RootAs20Svc2Args = {
  distinct_on?: InputMaybe<Array<As20Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc2_Order_By>>;
  where?: InputMaybe<As20Svc2_Bool_Exp>;
};


export type Subscription_RootAs20Svc2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc2_Order_By>>;
  where?: InputMaybe<As20Svc2_Bool_Exp>;
};


export type Subscription_RootAs20Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs20Svc2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As20Svc2_Stream_Cursor_Input>>;
  where?: InputMaybe<As20Svc2_Bool_Exp>;
};


export type Subscription_RootAs20Svc3Args = {
  distinct_on?: InputMaybe<Array<As20Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc3_Order_By>>;
  where?: InputMaybe<As20Svc3_Bool_Exp>;
};


export type Subscription_RootAs20Svc3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Svc3_Order_By>>;
  where?: InputMaybe<As20Svc3_Bool_Exp>;
};


export type Subscription_RootAs20Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs20Svc3_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As20Svc3_Stream_Cursor_Input>>;
  where?: InputMaybe<As20Svc3_Bool_Exp>;
};


export type Subscription_RootAs20Util1Args = {
  distinct_on?: InputMaybe<Array<As20Util1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util1_Order_By>>;
  where?: InputMaybe<As20Util1_Bool_Exp>;
};


export type Subscription_RootAs20Util1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Util1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util1_Order_By>>;
  where?: InputMaybe<As20Util1_Bool_Exp>;
};


export type Subscription_RootAs20Util1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs20Util1_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As20Util1_Stream_Cursor_Input>>;
  where?: InputMaybe<As20Util1_Bool_Exp>;
};


export type Subscription_RootAs20Util2Args = {
  distinct_on?: InputMaybe<Array<As20Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util2_Order_By>>;
  where?: InputMaybe<As20Util2_Bool_Exp>;
};


export type Subscription_RootAs20Util2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As20Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As20Util2_Order_By>>;
  where?: InputMaybe<As20Util2_Bool_Exp>;
};


export type Subscription_RootAs20Util2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs20Util2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As20Util2_Stream_Cursor_Input>>;
  where?: InputMaybe<As20Util2_Bool_Exp>;
};


export type Subscription_RootAs21DemArgs = {
  distinct_on?: InputMaybe<Array<As21Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Dem_Order_By>>;
  where?: InputMaybe<As21Dem_Bool_Exp>;
};


export type Subscription_RootAs21Dem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Dem_Order_By>>;
  where?: InputMaybe<As21Dem_Bool_Exp>;
};


export type Subscription_RootAs21Dem_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Dem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Dem_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Dem_Bool_Exp>;
};


export type Subscription_RootAs21Svc1Args = {
  distinct_on?: InputMaybe<Array<As21Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc1_Order_By>>;
  where?: InputMaybe<As21Svc1_Bool_Exp>;
};


export type Subscription_RootAs21Svc1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc1_Order_By>>;
  where?: InputMaybe<As21Svc1_Bool_Exp>;
};


export type Subscription_RootAs21Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Svc1_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Svc1_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Svc1_Bool_Exp>;
};


export type Subscription_RootAs21Svc2Args = {
  distinct_on?: InputMaybe<Array<As21Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc2_Order_By>>;
  where?: InputMaybe<As21Svc2_Bool_Exp>;
};


export type Subscription_RootAs21Svc2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc2_Order_By>>;
  where?: InputMaybe<As21Svc2_Bool_Exp>;
};


export type Subscription_RootAs21Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Svc2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Svc2_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Svc2_Bool_Exp>;
};


export type Subscription_RootAs21Svc3Args = {
  distinct_on?: InputMaybe<Array<As21Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc3_Order_By>>;
  where?: InputMaybe<As21Svc3_Bool_Exp>;
};


export type Subscription_RootAs21Svc3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Svc3_Order_By>>;
  where?: InputMaybe<As21Svc3_Bool_Exp>;
};


export type Subscription_RootAs21Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Svc3_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Svc3_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Svc3_Bool_Exp>;
};


export type Subscription_RootAs21UnitArgs = {
  distinct_on?: InputMaybe<Array<As21Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Unit_Order_By>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};


export type Subscription_RootAs21Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Unit_Order_By>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};


export type Subscription_RootAs21Unit_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Unit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Unit_Bool_Exp>;
};


export type Subscription_RootAs21UtilArgs = {
  distinct_on?: InputMaybe<Array<As21Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util_Order_By>>;
  where?: InputMaybe<As21Util_Bool_Exp>;
};


export type Subscription_RootAs21Util2Args = {
  distinct_on?: InputMaybe<Array<As21Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util2_Order_By>>;
  where?: InputMaybe<As21Util2_Bool_Exp>;
};


export type Subscription_RootAs21Util2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util2_Order_By>>;
  where?: InputMaybe<As21Util2_Bool_Exp>;
};


export type Subscription_RootAs21Util2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Util2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Util2_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Util2_Bool_Exp>;
};


export type Subscription_RootAs21Util_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As21Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As21Util_Order_By>>;
  where?: InputMaybe<As21Util_Bool_Exp>;
};


export type Subscription_RootAs21Util_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs21Util_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As21Util_Stream_Cursor_Input>>;
  where?: InputMaybe<As21Util_Bool_Exp>;
};


export type Subscription_RootAs22DemArgs = {
  distinct_on?: InputMaybe<Array<As22Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Dem_Order_By>>;
  where?: InputMaybe<As22Dem_Bool_Exp>;
};


export type Subscription_RootAs22Dem_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Dem_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Dem_Order_By>>;
  where?: InputMaybe<As22Dem_Bool_Exp>;
};


export type Subscription_RootAs22Dem_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Dem_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Dem_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Dem_Bool_Exp>;
};


export type Subscription_RootAs22Svc1Args = {
  distinct_on?: InputMaybe<Array<As22Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc1_Order_By>>;
  where?: InputMaybe<As22Svc1_Bool_Exp>;
};


export type Subscription_RootAs22Svc1_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Svc1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc1_Order_By>>;
  where?: InputMaybe<As22Svc1_Bool_Exp>;
};


export type Subscription_RootAs22Svc1_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Svc1_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Svc1_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Svc1_Bool_Exp>;
};


export type Subscription_RootAs22Svc2Args = {
  distinct_on?: InputMaybe<Array<As22Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc2_Order_By>>;
  where?: InputMaybe<As22Svc2_Bool_Exp>;
};


export type Subscription_RootAs22Svc2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Svc2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc2_Order_By>>;
  where?: InputMaybe<As22Svc2_Bool_Exp>;
};


export type Subscription_RootAs22Svc2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Svc2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Svc2_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Svc2_Bool_Exp>;
};


export type Subscription_RootAs22Svc3Args = {
  distinct_on?: InputMaybe<Array<As22Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc3_Order_By>>;
  where?: InputMaybe<As22Svc3_Bool_Exp>;
};


export type Subscription_RootAs22Svc3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Svc3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Svc3_Order_By>>;
  where?: InputMaybe<As22Svc3_Bool_Exp>;
};


export type Subscription_RootAs22Svc3_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Svc3_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Svc3_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Svc3_Bool_Exp>;
};


export type Subscription_RootAs22UnitArgs = {
  distinct_on?: InputMaybe<Array<As22Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Unit_Order_By>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};


export type Subscription_RootAs22Unit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Unit_Order_By>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};


export type Subscription_RootAs22Unit_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Unit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Unit_Bool_Exp>;
};


export type Subscription_RootAs22UtilArgs = {
  distinct_on?: InputMaybe<Array<As22Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util_Order_By>>;
  where?: InputMaybe<As22Util_Bool_Exp>;
};


export type Subscription_RootAs22Util2Args = {
  distinct_on?: InputMaybe<Array<As22Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util2_Order_By>>;
  where?: InputMaybe<As22Util2_Bool_Exp>;
};


export type Subscription_RootAs22Util2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Util2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util2_Order_By>>;
  where?: InputMaybe<As22Util2_Bool_Exp>;
};


export type Subscription_RootAs22Util2_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Util2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Util2_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Util2_Bool_Exp>;
};


export type Subscription_RootAs22Util_AggregateArgs = {
  distinct_on?: InputMaybe<Array<As22Util_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<As22Util_Order_By>>;
  where?: InputMaybe<As22Util_Bool_Exp>;
};


export type Subscription_RootAs22Util_By_PkArgs = {
  ID: Scalars['String'];
};


export type Subscription_RootAs22Util_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<As22Util_Stream_Cursor_Input>>;
  where?: InputMaybe<As22Util_Bool_Exp>;
};


export type Subscription_RootAb_TestArgs = {
  distinct_on?: InputMaybe<Array<Ab_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ab_Test_Order_By>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


export type Subscription_RootAb_Test_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ab_Test_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ab_Test_Order_By>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


export type Subscription_RootAb_Test_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAb_Test_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ab_Test_Stream_Cursor_Input>>;
  where?: InputMaybe<Ab_Test_Bool_Exp>;
};


export type Subscription_RootAccess_InfoArgs = {
  distinct_on?: InputMaybe<Array<Access_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Access_Info_Order_By>>;
  where?: InputMaybe<Access_Info_Bool_Exp>;
};


export type Subscription_RootAccess_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Access_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Access_Info_Order_By>>;
  where?: InputMaybe<Access_Info_Bool_Exp>;
};


export type Subscription_RootAccess_Info_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Access_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Access_Info_Bool_Exp>;
};


export type Subscription_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAccount_RoleArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


export type Subscription_RootAccount_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Role_Order_By>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


export type Subscription_RootAccount_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAccount_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Account_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Role_Bool_Exp>;
};


export type Subscription_RootAccount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAcep_Org_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acep_Org_Survey_Order_By>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


export type Subscription_RootAcep_Org_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Acep_Org_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Acep_Org_Survey_Order_By>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


export type Subscription_RootAcep_Org_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAcep_Org_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Acep_Org_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Acep_Org_Survey_Bool_Exp>;
};


export type Subscription_RootBoardArgs = {
  distinct_on?: InputMaybe<Array<Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Order_By>>;
  where?: InputMaybe<Board_Bool_Exp>;
};


export type Subscription_RootBoard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Order_By>>;
  where?: InputMaybe<Board_Bool_Exp>;
};


export type Subscription_RootBoard_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBoard_CertArgs = {
  distinct_on?: InputMaybe<Array<Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Cert_Order_By>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};


export type Subscription_RootBoard_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Board_Cert_Order_By>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};


export type Subscription_RootBoard_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBoard_Cert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Board_Cert_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Cert_Bool_Exp>;
};


export type Subscription_RootBoard_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Board_Stream_Cursor_Input>>;
  where?: InputMaybe<Board_Bool_Exp>;
};


export type Subscription_RootCandidateArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


export type Subscription_RootCandidate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Candidate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Candidate_Order_By>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


export type Subscription_RootCandidate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCandidate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Candidate_Stream_Cursor_Input>>;
  where?: InputMaybe<Candidate_Bool_Exp>;
};


export type Subscription_RootCert_OrgArgs = {
  distinct_on?: InputMaybe<Array<Cert_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cert_Org_Order_By>>;
  where?: InputMaybe<Cert_Org_Bool_Exp>;
};


export type Subscription_RootCert_Org_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cert_Org_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cert_Org_Order_By>>;
  where?: InputMaybe<Cert_Org_Bool_Exp>;
};


export type Subscription_RootCert_Org_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCert_Org_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cert_Org_Stream_Cursor_Input>>;
  where?: InputMaybe<Cert_Org_Bool_Exp>;
};


export type Subscription_RootClerkshipArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Order_By>>;
  where?: InputMaybe<Clerkship_Bool_Exp>;
};


export type Subscription_RootClerkship_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Order_By>>;
  where?: InputMaybe<Clerkship_Bool_Exp>;
};


export type Subscription_RootClerkship_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClerkship_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clerkship_Stream_Cursor_Input>>;
  where?: InputMaybe<Clerkship_Bool_Exp>;
};


export type Subscription_RootClerkship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


export type Subscription_RootClerkship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


export type Subscription_RootClerkship_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClerkship_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clerkship_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Clerkship_Survey_Bool_Exp>;
};


export type Subscription_RootClinicianArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Order_By>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


export type Subscription_RootClinician_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Order_By>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


export type Subscription_RootClinician_App_CertArgs = {
  distinct_on?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_App_Cert_Order_By>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


export type Subscription_RootClinician_App_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_App_Cert_Order_By>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


export type Subscription_RootClinician_App_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_App_Cert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_App_Cert_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_App_Cert_Bool_Exp>;
};


export type Subscription_RootClinician_Board_CertArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Board_Cert_Order_By>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


export type Subscription_RootClinician_Board_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Board_Cert_Order_By>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


export type Subscription_RootClinician_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_Board_Cert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_Board_Cert_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_Board_Cert_Bool_Exp>;
};


export type Subscription_RootClinician_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_LicenseArgs = {
  distinct_on?: InputMaybe<Array<Clinician_License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_License_Order_By>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


export type Subscription_RootClinician_License_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_License_Order_By>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


export type Subscription_RootClinician_License_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_License_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_License_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_License_Bool_Exp>;
};


export type Subscription_RootClinician_Sp_ExpArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Sp_Exp_Order_By>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


export type Subscription_RootClinician_Sp_Exp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Sp_Exp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Sp_Exp_Order_By>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


export type Subscription_RootClinician_Sp_Exp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_Sp_Exp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_Sp_Exp_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_Sp_Exp_Bool_Exp>;
};


export type Subscription_RootClinician_SpecialtyArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Specialty_Order_By>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


export type Subscription_RootClinician_Specialty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Specialty_Order_By>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


export type Subscription_RootClinician_Specialty_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_Specialty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_Specialty_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_Specialty_Bool_Exp>;
};


export type Subscription_RootClinician_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_Bool_Exp>;
};


export type Subscription_RootClinician_TrainingArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Training_Order_By>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};


export type Subscription_RootClinician_Training_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Clinician_Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clinician_Training_Order_By>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};


export type Subscription_RootClinician_Training_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootClinician_Training_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clinician_Training_Stream_Cursor_Input>>;
  where?: InputMaybe<Clinician_Training_Bool_Exp>;
};


export type Subscription_RootCms_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Order_By>>;
  where?: InputMaybe<Cms_Facility_Bool_Exp>;
};


export type Subscription_RootCms_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Order_By>>;
  where?: InputMaybe<Cms_Facility_Bool_Exp>;
};


export type Subscription_RootCms_Facility_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCms_Facility_EnrollmentArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Enrollment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Enrollment_Order_By>>;
  where?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
};


export type Subscription_RootCms_Facility_Enrollment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Enrollment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Enrollment_Order_By>>;
  where?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
};


export type Subscription_RootCms_Facility_Enrollment_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCms_Facility_Enrollment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cms_Facility_Enrollment_Stream_Cursor_Input>>;
  where?: InputMaybe<Cms_Facility_Enrollment_Bool_Exp>;
};


export type Subscription_RootCms_Facility_MetricArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Metric_Order_By>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};


export type Subscription_RootCms_Facility_Metric_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Metric_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Metric_Order_By>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};


export type Subscription_RootCms_Facility_Metric_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCms_Facility_Metric_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cms_Facility_Metric_Stream_Cursor_Input>>;
  where?: InputMaybe<Cms_Facility_Metric_Bool_Exp>;
};


export type Subscription_RootCms_Facility_PosArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Pos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Pos_Order_By>>;
  where?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
};


export type Subscription_RootCms_Facility_Pos_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Facility_Pos_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Facility_Pos_Order_By>>;
  where?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
};


export type Subscription_RootCms_Facility_Pos_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCms_Facility_Pos_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cms_Facility_Pos_Stream_Cursor_Input>>;
  where?: InputMaybe<Cms_Facility_Pos_Bool_Exp>;
};


export type Subscription_RootCms_Facility_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cms_Facility_Stream_Cursor_Input>>;
  where?: InputMaybe<Cms_Facility_Bool_Exp>;
};


export type Subscription_RootCms_SpecialtyArgs = {
  distinct_on?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Specialty_Order_By>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


export type Subscription_RootCms_Specialty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cms_Specialty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cms_Specialty_Order_By>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


export type Subscription_RootCms_Specialty_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCms_Specialty_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cms_Specialty_Stream_Cursor_Input>>;
  where?: InputMaybe<Cms_Specialty_Bool_Exp>;
};


export type Subscription_RootContact_InfoArgs = {
  distinct_on?: InputMaybe<Array<Contact_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Info_Order_By>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


export type Subscription_RootContact_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Info_Order_By>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


export type Subscription_RootContact_Info_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contact_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Info_Bool_Exp>;
};


export type Subscription_RootCurrent_AccountArgs = {
  distinct_on?: InputMaybe<Array<Current_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Current_Account_Order_By>>;
  where?: InputMaybe<Current_Account_Bool_Exp>;
};


export type Subscription_RootCurrent_Account_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Current_Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Current_Account_Order_By>>;
  where?: InputMaybe<Current_Account_Bool_Exp>;
};


export type Subscription_RootCurrent_Account_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Current_Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Current_Account_Bool_Exp>;
};


export type Subscription_RootEmail_ContactArgs = {
  distinct_on?: InputMaybe<Array<Email_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Contact_Order_By>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


export type Subscription_RootEmail_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Contact_Order_By>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


export type Subscription_RootEmail_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Contact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Contact_Bool_Exp>;
};


export type Subscription_RootEmail_EnvelopeArgs = {
  distinct_on?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Envelope_Order_By>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


export type Subscription_RootEmail_Envelope_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Envelope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Envelope_Order_By>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


export type Subscription_RootEmail_Envelope_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Envelope_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Envelope_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Envelope_Bool_Exp>;
};


export type Subscription_RootEmail_EventArgs = {
  distinct_on?: InputMaybe<Array<Email_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Event_Order_By>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


export type Subscription_RootEmail_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Event_Order_By>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


export type Subscription_RootEmail_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Event_Bool_Exp>;
};


export type Subscription_RootEmail_MessageArgs = {
  distinct_on?: InputMaybe<Array<Email_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Message_Order_By>>;
  where?: InputMaybe<Email_Message_Bool_Exp>;
};


export type Subscription_RootEmail_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Message_Order_By>>;
  where?: InputMaybe<Email_Message_Bool_Exp>;
};


export type Subscription_RootEmail_Message_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Message_Bool_Exp>;
};


export type Subscription_RootEmail_PointerArgs = {
  distinct_on?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Pointer_Order_By>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};


export type Subscription_RootEmail_Pointer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Pointer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Pointer_Order_By>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};


export type Subscription_RootEmail_Pointer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Pointer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Pointer_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Pointer_Bool_Exp>;
};


export type Subscription_RootExt_Job_PostingArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


export type Subscription_RootExt_Job_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Posting_Order_By>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


export type Subscription_RootExt_Job_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExt_Job_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ext_Job_Posting_Stream_Cursor_Input>>;
  where?: InputMaybe<Ext_Job_Posting_Bool_Exp>;
};


export type Subscription_RootExt_Job_ScrapeArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Scrape_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Scrape_Order_By>>;
  where?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
};


export type Subscription_RootExt_Job_Scrape_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Job_Scrape_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Job_Scrape_Order_By>>;
  where?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
};


export type Subscription_RootExt_Job_Scrape_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExt_Job_Scrape_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ext_Job_Scrape_Stream_Cursor_Input>>;
  where?: InputMaybe<Ext_Job_Scrape_Bool_Exp>;
};


export type Subscription_RootExt_Posting_ErrorArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Error_Order_By>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


export type Subscription_RootExt_Posting_Error_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Error_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Error_Order_By>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


export type Subscription_RootExt_Posting_Error_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExt_Posting_Error_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ext_Posting_Error_Stream_Cursor_Input>>;
  where?: InputMaybe<Ext_Posting_Error_Bool_Exp>;
};


export type Subscription_RootExt_Posting_ProfessionArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Profession_Order_By>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};


export type Subscription_RootExt_Posting_Profession_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ext_Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ext_Posting_Profession_Order_By>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};


export type Subscription_RootExt_Posting_Profession_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExt_Posting_Profession_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ext_Posting_Profession_Stream_Cursor_Input>>;
  where?: InputMaybe<Ext_Posting_Profession_Bool_Exp>;
};


export type Subscription_RootFacilityArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


export type Subscription_RootFacility_AccreditationArgs = {
  distinct_on?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Accreditation_Order_By>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


export type Subscription_RootFacility_Accreditation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Accreditation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Accreditation_Order_By>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


export type Subscription_RootFacility_Accreditation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFacility_Accreditation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Accreditation_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Accreditation_Bool_Exp>;
};


export type Subscription_RootFacility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Order_By>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


export type Subscription_RootFacility_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFacility_ContractArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


export type Subscription_RootFacility_Contract_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Order_By>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


export type Subscription_RootFacility_Contract_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFacility_Contract_FeaturedArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Featured_Order_By>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


export type Subscription_RootFacility_Contract_Featured_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Contract_Featured_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Contract_Featured_Order_By>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


export type Subscription_RootFacility_Contract_Featured_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFacility_Contract_Featured_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Contract_Featured_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Contract_Featured_Bool_Exp>;
};


export type Subscription_RootFacility_Contract_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Contract_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Contract_Bool_Exp>;
};


export type Subscription_RootFacility_CorrectionArgs = {
  distinct_on?: InputMaybe<Array<Facility_Correction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Correction_Order_By>>;
  where?: InputMaybe<Facility_Correction_Bool_Exp>;
};


export type Subscription_RootFacility_Correction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Correction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Correction_Order_By>>;
  where?: InputMaybe<Facility_Correction_Bool_Exp>;
};


export type Subscription_RootFacility_Correction_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFacility_Correction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Correction_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Correction_Bool_Exp>;
};


export type Subscription_RootFacility_DistArgs = {
  args: Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFacility_Dist_AggregateArgs = {
  args: Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFacility_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFacility_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Dist_Result_Order_By>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFacility_Dist_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Dist_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFacility_EhrArgs = {
  distinct_on?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Ehr_Order_By>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


export type Subscription_RootFacility_Ehr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Ehr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Ehr_Order_By>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


export type Subscription_RootFacility_Ehr_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFacility_Ehr_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Ehr_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Ehr_Bool_Exp>;
};


export type Subscription_RootFacility_RatingArgs = {
  distinct_on?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Rating_Order_By>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


export type Subscription_RootFacility_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Facility_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Facility_Rating_Order_By>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


export type Subscription_RootFacility_Rating_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Rating_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Rating_Bool_Exp>;
};


export type Subscription_RootFacility_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Facility_Stream_Cursor_Input>>;
  where?: InputMaybe<Facility_Bool_Exp>;
};


export type Subscription_RootFavoriteArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Favorite_Order_By>>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};


export type Subscription_RootFavorite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Favorite_Order_By>>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};


export type Subscription_RootFavorite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFavorite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Favorite_Stream_Cursor_Input>>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};


export type Subscription_RootFeatured_Clerkship_DistArgs = {
  args: Featured_Clerkship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Clerkship_Dist_AggregateArgs = {
  args: Featured_Clerkship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Clerkship_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Clerkship_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Clerkship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Clerkship_Dist_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Featured_Clerkship_Dist_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Featured_Clerkship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Fellowship_DistArgs = {
  args: Featured_Fellowship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Fellowship_Dist_AggregateArgs = {
  args: Featured_Fellowship_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Fellowship_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Fellowship_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Fellowship_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Fellowship_Dist_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Featured_Fellowship_Dist_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Featured_Fellowship_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Residency_DistArgs = {
  args: Featured_Residency_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Residency_Dist_AggregateArgs = {
  args: Featured_Residency_Dist_Args;
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Residency_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Residency_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Featured_Residency_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Featured_Residency_Dist_Result_Order_By>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFeatured_Residency_Dist_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Featured_Residency_Dist_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Featured_Residency_Dist_Result_Bool_Exp>;
};


export type Subscription_RootFellowshipArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Order_By>>;
  where?: InputMaybe<Fellowship_Bool_Exp>;
};


export type Subscription_RootFellowship_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Order_By>>;
  where?: InputMaybe<Fellowship_Bool_Exp>;
};


export type Subscription_RootFellowship_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFellowship_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fellowship_Stream_Cursor_Input>>;
  where?: InputMaybe<Fellowship_Bool_Exp>;
};


export type Subscription_RootFellowship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


export type Subscription_RootFellowship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


export type Subscription_RootFellowship_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFellowship_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fellowship_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Fellowship_Survey_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFsmb_BioArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Bio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Bio_Order_By>>;
  where?: InputMaybe<Fsmb_Bio_Bool_Exp>;
};


export type Subscription_RootFsmb_Bio_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Bio_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Bio_Order_By>>;
  where?: InputMaybe<Fsmb_Bio_Bool_Exp>;
};


export type Subscription_RootFsmb_Bio_By_PkArgs = {
  fid: Scalars['String'];
};


export type Subscription_RootFsmb_Bio_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fsmb_Bio_Stream_Cursor_Input>>;
  where?: InputMaybe<Fsmb_Bio_Bool_Exp>;
};


export type Subscription_RootFsmb_LicensureArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Licensure_Order_By>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};


export type Subscription_RootFsmb_Licensure_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fsmb_Licensure_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fsmb_Licensure_Order_By>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};


export type Subscription_RootFsmb_Licensure_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFsmb_Licensure_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fsmb_Licensure_Stream_Cursor_Input>>;
  where?: InputMaybe<Fsmb_Licensure_Bool_Exp>;
};


export type Subscription_RootGmaps_LinkArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Bool_Exp>;
};


export type Subscription_RootGmaps_Link_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Bool_Exp>;
};


export type Subscription_RootGmaps_Link_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGmaps_Link_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gmaps_Link_Stream_Cursor_Input>>;
  where?: InputMaybe<Gmaps_Link_Bool_Exp>;
};


export type Subscription_RootGmaps_Link_TypeArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Type_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};


export type Subscription_RootGmaps_Link_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Link_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Link_Type_Order_By>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};


export type Subscription_RootGmaps_Link_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGmaps_Link_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gmaps_Link_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Gmaps_Link_Type_Bool_Exp>;
};


export type Subscription_RootGmaps_PlaceArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Place_Order_By>>;
  where?: InputMaybe<Gmaps_Place_Bool_Exp>;
};


export type Subscription_RootGmaps_Place_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gmaps_Place_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gmaps_Place_Order_By>>;
  where?: InputMaybe<Gmaps_Place_Bool_Exp>;
};


export type Subscription_RootGmaps_Place_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootGmaps_Place_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gmaps_Place_Stream_Cursor_Input>>;
  where?: InputMaybe<Gmaps_Place_Bool_Exp>;
};


export type Subscription_RootIdentity_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Identity_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Provider_Order_By>>;
  where?: InputMaybe<Identity_Provider_Bool_Exp>;
};


export type Subscription_RootIdentity_Provider_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Provider_Order_By>>;
  where?: InputMaybe<Identity_Provider_Bool_Exp>;
};


export type Subscription_RootIdentity_Provider_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIdentity_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Identity_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Identity_Provider_Bool_Exp>;
};


export type Subscription_RootJob_ApplicationArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


export type Subscription_RootJob_Application_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Order_By>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


export type Subscription_RootJob_Application_BatchArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Batch_Order_By>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};


export type Subscription_RootJob_Application_Batch_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Batch_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Batch_Order_By>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};


export type Subscription_RootJob_Application_Batch_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootJob_Application_Batch_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Application_Batch_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Application_Batch_Bool_Exp>;
};


export type Subscription_RootJob_Application_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootJob_Application_PostingArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


export type Subscription_RootJob_Application_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Application_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Application_Posting_Order_By>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


export type Subscription_RootJob_Application_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootJob_Application_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Application_Posting_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Application_Posting_Bool_Exp>;
};


export type Subscription_RootJob_Application_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Application_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Application_Bool_Exp>;
};


export type Subscription_RootJob_PostingArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


export type Subscription_RootJob_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Posting_Order_By>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


export type Subscription_RootJob_Posting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootJob_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Posting_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Posting_Bool_Exp>;
};


export type Subscription_RootLatest_Clerkship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Latest_Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Clerkship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Clerkship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Clerkship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Clerkship_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Latest_Clerkship_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Latest_Clerkship_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Fellowship_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Latest_Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Fellowship_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Fellowship_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Fellowship_Survey_Order_By>>;
  where?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Fellowship_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Latest_Fellowship_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Latest_Fellowship_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Residency_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Latest_Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Residency_Survey_Order_By>>;
  where?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Residency_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Latest_Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Latest_Residency_Survey_Order_By>>;
  where?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
};


export type Subscription_RootLatest_Residency_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Latest_Residency_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Latest_Residency_Survey_Bool_Exp>;
};


export type Subscription_RootNearby_Facilities_By_GeographyArgs = {
  args: Nearby_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootNearby_Facilities_By_Geography_AggregateArgs = {
  args: Nearby_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootNearby_Facilities_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootNearby_Facilities_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Nearby_Facilities_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootNearby_Facilities_By_Geography_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Nearby_Facilities_By_Geography_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Nearby_Facilities_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootOrg_DistArgs = {
  args: Org_Dist_Args;
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Subscription_RootOrg_Dist_AggregateArgs = {
  args: Org_Dist_Args;
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Subscription_RootOrg_Dist_ResultArgs = {
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Subscription_RootOrg_Dist_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Dist_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Dist_Result_Order_By>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Subscription_RootOrg_Dist_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Dist_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Dist_Result_Bool_Exp>;
};


export type Subscription_RootOrg_DomainArgs = {
  distinct_on?: InputMaybe<Array<Org_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Domain_Order_By>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


export type Subscription_RootOrg_Domain_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Domain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Domain_Order_By>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


export type Subscription_RootOrg_Domain_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Domain_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Domain_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Domain_Bool_Exp>;
};


export type Subscription_RootOrg_MarketArgs = {
  distinct_on?: InputMaybe<Array<Org_Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Market_Order_By>>;
  where?: InputMaybe<Org_Market_Bool_Exp>;
};


export type Subscription_RootOrg_Market_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Market_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Market_Order_By>>;
  where?: InputMaybe<Org_Market_Bool_Exp>;
};


export type Subscription_RootOrg_Market_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Market_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Market_Bool_Exp>;
};


export type Subscription_RootOrg_RatingArgs = {
  distinct_on?: InputMaybe<Array<Org_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Rating_Order_By>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


export type Subscription_RootOrg_Rating_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Rating_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Rating_Order_By>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


export type Subscription_RootOrg_Rating_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Rating_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Rating_Bool_Exp>;
};


export type Subscription_RootOrg_UserArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Order_By>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


export type Subscription_RootOrg_User_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_User_Order_By>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


export type Subscription_RootOrg_User_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_User_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_User_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_User_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_BoundsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Bounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Bounds_Order_By>>;
  where?: InputMaybe<Organization_Bounds_Bool_Exp>;
};


export type Subscription_RootOrganization_Bounds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Bounds_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Bounds_Order_By>>;
  where?: InputMaybe<Organization_Bounds_Bool_Exp>;
};


export type Subscription_RootOrganization_Bounds_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Bounds_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bounds_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_Job_PostingArgs = {
  distinct_on?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Job_Posting_Order_By>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


export type Subscription_RootOrganization_Job_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Job_Posting_Order_By>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


export type Subscription_RootOrganization_Job_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Job_Posting_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Job_Posting_Bool_Exp>;
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootPersonal_InfoArgs = {
  distinct_on?: InputMaybe<Array<Personal_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Personal_Info_Order_By>>;
  where?: InputMaybe<Personal_Info_Bool_Exp>;
};


export type Subscription_RootPersonal_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Personal_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Personal_Info_Order_By>>;
  where?: InputMaybe<Personal_Info_Bool_Exp>;
};


export type Subscription_RootPersonal_Info_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Personal_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Personal_Info_Bool_Exp>;
};


export type Subscription_RootPlace_BoundaryArgs = {
  distinct_on?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Place_Boundary_Order_By>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


export type Subscription_RootPlace_Boundary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Place_Boundary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Place_Boundary_Order_By>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


export type Subscription_RootPlace_Boundary_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlace_Boundary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Place_Boundary_Stream_Cursor_Input>>;
  where?: InputMaybe<Place_Boundary_Bool_Exp>;
};


export type Subscription_RootPosting_App_CertArgs = {
  distinct_on?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_App_Cert_Order_By>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


export type Subscription_RootPosting_App_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_App_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_App_Cert_Order_By>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


export type Subscription_RootPosting_App_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_App_Cert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Posting_App_Cert_Stream_Cursor_Input>>;
  where?: InputMaybe<Posting_App_Cert_Bool_Exp>;
};


export type Subscription_RootPosting_Board_CertArgs = {
  distinct_on?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Board_Cert_Order_By>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


export type Subscription_RootPosting_Board_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Board_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Board_Cert_Order_By>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


export type Subscription_RootPosting_Board_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_Board_Cert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Posting_Board_Cert_Stream_Cursor_Input>>;
  where?: InputMaybe<Posting_Board_Cert_Bool_Exp>;
};


export type Subscription_RootPosting_Latest_PublicationArgs = {
  distinct_on?: InputMaybe<Array<Posting_Latest_Publication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Latest_Publication_Order_By>>;
  where?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
};


export type Subscription_RootPosting_Latest_Publication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Latest_Publication_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Latest_Publication_Order_By>>;
  where?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
};


export type Subscription_RootPosting_Latest_Publication_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Posting_Latest_Publication_Stream_Cursor_Input>>;
  where?: InputMaybe<Posting_Latest_Publication_Bool_Exp>;
};


export type Subscription_RootPosting_ProfessionArgs = {
  distinct_on?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Profession_Order_By>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


export type Subscription_RootPosting_Profession_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Profession_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Profession_Order_By>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


export type Subscription_RootPosting_Profession_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_Profession_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Posting_Profession_Stream_Cursor_Input>>;
  where?: InputMaybe<Posting_Profession_Bool_Exp>;
};


export type Subscription_RootPosting_Worker_ClassificationArgs = {
  distinct_on?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Worker_Classification_Order_By>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};


export type Subscription_RootPosting_Worker_Classification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Posting_Worker_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Posting_Worker_Classification_Order_By>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};


export type Subscription_RootPosting_Worker_Classification_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPosting_Worker_Classification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Posting_Worker_Classification_Stream_Cursor_Input>>;
  where?: InputMaybe<Posting_Worker_Classification_Bool_Exp>;
};


export type Subscription_RootRanked_FacilityArgs = {
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootRanked_Facility_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootRanked_Facility_DistArgs = {
  args: Ranked_Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootRanked_Facility_Dist_AggregateArgs = {
  args: Ranked_Facility_Dist_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootRanked_Facility_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ranked_Facility_Stream_Cursor_Input>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootRelevant_Job_PostingArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Subscription_RootRelevant_Job_Posting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Subscription_RootRelevant_Job_Posting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Relevant_Job_Posting_Stream_Cursor_Input>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Subscription_RootRelevant_Salary_ReportArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Subscription_RootRelevant_Salary_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Subscription_RootRelevant_Salary_Report_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Relevant_Salary_Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Subscription_RootResidencyArgs = {
  distinct_on?: InputMaybe<Array<Residency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Order_By>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


export type Subscription_RootResidency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Residency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Order_By>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


export type Subscription_RootResidency_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootResidency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Residency_Stream_Cursor_Input>>;
  where?: InputMaybe<Residency_Bool_Exp>;
};


export type Subscription_RootResidency_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Survey_Order_By>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};


export type Subscription_RootResidency_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Residency_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Residency_Survey_Order_By>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};


export type Subscription_RootResidency_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootResidency_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Residency_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Residency_Survey_Bool_Exp>;
};


export type Subscription_RootReviewArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Subscription_RootReview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Subscription_RootReview_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReview_ReplyArgs = {
  distinct_on?: InputMaybe<Array<Review_Reply_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Reply_Order_By>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


export type Subscription_RootReview_Reply_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Reply_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Reply_Order_By>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


export type Subscription_RootReview_Reply_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReview_Reply_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Reply_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Reply_Bool_Exp>;
};


export type Subscription_RootReview_ReportArgs = {
  distinct_on?: InputMaybe<Array<Review_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Report_Order_By>>;
  where?: InputMaybe<Review_Report_Bool_Exp>;
};


export type Subscription_RootReview_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Report_Order_By>>;
  where?: InputMaybe<Review_Report_Bool_Exp>;
};


export type Subscription_RootReview_Report_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReview_Report_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Report_Bool_Exp>;
};


export type Subscription_RootReview_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Subscription_RootReview_VoteArgs = {
  distinct_on?: InputMaybe<Array<Review_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Vote_Order_By>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};


export type Subscription_RootReview_Vote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Vote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Vote_Order_By>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};


export type Subscription_RootReview_Vote_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReview_Vote_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Vote_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Vote_Bool_Exp>;
};


export type Subscription_RootSalary_ReportArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


export type Subscription_RootSalary_Report_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Order_By>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


export type Subscription_RootSalary_Report_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSalary_Report_FmtArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


export type Subscription_RootSalary_Report_Fmt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Salary_Report_Fmt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Salary_Report_Fmt_Order_By>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


export type Subscription_RootSalary_Report_Fmt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Salary_Report_Fmt_Stream_Cursor_Input>>;
  where?: InputMaybe<Salary_Report_Fmt_Bool_Exp>;
};


export type Subscription_RootSalary_Report_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Salary_Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Salary_Report_Bool_Exp>;
};


export type Subscription_RootSchoolArgs = {
  distinct_on?: InputMaybe<Array<School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Order_By>>;
  where?: InputMaybe<School_Bool_Exp>;
};


export type Subscription_RootSchool_AggregateArgs = {
  distinct_on?: InputMaybe<Array<School_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<School_Order_By>>;
  where?: InputMaybe<School_Bool_Exp>;
};


export type Subscription_RootSchool_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSchool_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<School_Stream_Cursor_Input>>;
  where?: InputMaybe<School_Bool_Exp>;
};


export type Subscription_RootSearch_CandidateArgs = {
  args: Search_Candidate_Args;
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Candidate_AggregateArgs = {
  args: Search_Candidate_Args;
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Candidate_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Candidate_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Candidate_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Candidate_Result_Order_By>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Candidate_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Candidate_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Candidate_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Clerkship_By_GeographyArgs = {
  args: Search_Clerkship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Clerkship_By_Geography_AggregateArgs = {
  args: Search_Clerkship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Clerkship_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Clerkship_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Clerkship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Clerkship_By_Geography_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Clerkship_By_Geography_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Clerkship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Facility_By_PrefixArgs = {
  args: Search_Facility_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Facility_By_Prefix_AggregateArgs = {
  args: Search_Facility_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Facility_By_Prefix_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Facility_By_Prefix_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Facility_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Facility_By_Prefix_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Facility_By_Prefix_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fellowship_By_GeographyArgs = {
  args: Search_Fellowship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fellowship_By_Geography_AggregateArgs = {
  args: Search_Fellowship_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fellowship_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fellowship_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fellowship_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fellowship_By_Geography_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Fellowship_By_Geography_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Fellowship_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fsmb_BioArgs = {
  args: Search_Fsmb_Bio_Args;
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fsmb_Bio_AggregateArgs = {
  args: Search_Fsmb_Bio_Args;
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fsmb_Bio_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fsmb_Bio_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Fsmb_Bio_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Fsmb_Bio_Result_Order_By>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Fsmb_Bio_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Fsmb_Bio_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Fsmb_Bio_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Job_Postings_By_GeographyArgs = {
  args: Search_Job_Postings_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Job_Postings_By_Geography_AggregateArgs = {
  args: Search_Job_Postings_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Job_Postings_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Job_Postings_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Job_Postings_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Job_Postings_By_Geography_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Job_Postings_By_Geography_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Job_Postings_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Org_MarketArgs = {
  args: Search_Org_Market_Args;
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Org_Market_AggregateArgs = {
  args: Search_Org_Market_Args;
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Org_Market_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Org_Market_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Org_Market_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Org_Market_Result_Order_By>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Org_Market_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Org_Market_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Org_Market_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Organization_By_PrefixArgs = {
  args: Search_Organization_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Organization_By_Prefix_AggregateArgs = {
  args: Search_Organization_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Organization_By_Prefix_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Organization_By_Prefix_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Organization_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Organization_By_Prefix_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Organization_By_Prefix_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Organization_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Ranked_Facilities_By_GeographyArgs = {
  args: Search_Ranked_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootSearch_Ranked_Facilities_By_Geography_AggregateArgs = {
  args: Search_Ranked_Facilities_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootSearch_Relevant_Job_PostingArgs = {
  args?: InputMaybe<Search_Relevant_Job_Posting_Args>;
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Subscription_RootSearch_Relevant_Job_Posting_AggregateArgs = {
  args?: InputMaybe<Search_Relevant_Job_Posting_Args>;
  distinct_on?: InputMaybe<Array<Relevant_Job_Posting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Job_Posting_Order_By>>;
  where?: InputMaybe<Relevant_Job_Posting_Bool_Exp>;
};


export type Subscription_RootSearch_Relevant_Salary_ReportArgs = {
  args: Search_Relevant_Salary_Report_Args;
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Subscription_RootSearch_Relevant_Salary_Report_AggregateArgs = {
  args: Search_Relevant_Salary_Report_Args;
  distinct_on?: InputMaybe<Array<Relevant_Salary_Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relevant_Salary_Report_Order_By>>;
  where?: InputMaybe<Relevant_Salary_Report_Bool_Exp>;
};


export type Subscription_RootSearch_Residency_By_GeographyArgs = {
  args: Search_Residency_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Residency_By_Geography_AggregateArgs = {
  args: Search_Residency_By_Geography_Args;
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Residency_By_Geography_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Residency_By_Geography_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Residency_By_Geography_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Residency_By_Geography_Result_Order_By>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Residency_By_Geography_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Residency_By_Geography_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Residency_By_Geography_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Training_By_PrefixArgs = {
  args: Search_Training_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Training_By_Prefix_AggregateArgs = {
  args: Search_Training_By_Prefix_Args;
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Training_By_Prefix_ResultArgs = {
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Training_By_Prefix_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Training_By_Prefix_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Training_By_Prefix_Result_Order_By>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSearch_Training_By_Prefix_Result_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Training_By_Prefix_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Training_By_Prefix_Result_Bool_Exp>;
};


export type Subscription_RootSiteArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Subscription_RootSite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Site_Order_By>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Subscription_RootSite_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Site_Stream_Cursor_Input>>;
  where?: InputMaybe<Site_Bool_Exp>;
};


export type Subscription_RootStroke_CertArgs = {
  distinct_on?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stroke_Cert_Order_By>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};


export type Subscription_RootStroke_Cert_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Stroke_Cert_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Stroke_Cert_Order_By>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};


export type Subscription_RootStroke_Cert_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootStroke_Cert_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Stroke_Cert_Stream_Cursor_Input>>;
  where?: InputMaybe<Stroke_Cert_Bool_Exp>;
};


export type Subscription_RootSuggest_Ranked_FacilitiesArgs = {
  args: Suggest_Ranked_Facilities_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootSuggest_Ranked_Facilities_AggregateArgs = {
  args: Suggest_Ranked_Facilities_Args;
  distinct_on?: InputMaybe<Array<Ranked_Facility_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ranked_Facility_Order_By>>;
  where?: InputMaybe<Ranked_Facility_Bool_Exp>;
};


export type Subscription_RootTrainingArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootTraining_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Order_By>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootTraining_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_EventArgs = {
  distinct_on?: InputMaybe<Array<Training_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Event_Order_By>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


export type Subscription_RootTraining_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Event_Order_By>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


export type Subscription_RootTraining_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


export type Subscription_RootTraining_FieldArgs = {
  distinct_on?: InputMaybe<Array<Training_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Field_Order_By>>;
  where?: InputMaybe<Training_Field_Bool_Exp>;
};


export type Subscription_RootTraining_Field_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Field_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Field_Order_By>>;
  where?: InputMaybe<Training_Field_Bool_Exp>;
};


export type Subscription_RootTraining_Field_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_Field_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Field_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Field_Bool_Exp>;
};


export type Subscription_RootTraining_ProgramArgs = {
  distinct_on?: InputMaybe<Array<Training_Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Program_Order_By>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};


export type Subscription_RootTraining_Program_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Program_Order_By>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};


export type Subscription_RootTraining_Program_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_Program_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Program_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};


export type Subscription_RootTraining_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Bool_Exp>;
};


export type Subscription_RootTraining_SurveyArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Order_By>>;
  where?: InputMaybe<Training_Survey_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Order_By>>;
  where?: InputMaybe<Training_Survey_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_Survey_PictureArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_Picture_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_Picture_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_Survey_Picture_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Survey_Picture_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_SiteArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Site_Order_By>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_Site_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Site_Order_By>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_Site_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTraining_Survey_Site_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Survey_Site_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};


export type Subscription_RootTraining_Survey_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Training_Survey_Stream_Cursor_Input>>;
  where?: InputMaybe<Training_Survey_Bool_Exp>;
};

export type Suggest_Ranked_Facilities_Args = {
  fid?: InputMaybe<Scalars['uuid']>;
  prof?: InputMaybe<Scalars['profession']>;
  radius_m?: InputMaybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** columns and relationships of "training" */
export type Training = {
  __typename?: 'training';
  active: Scalars['Boolean'];
  /** An object relationship */
  clerkship: Maybe<Clerkship>;
  emra_account_no: Maybe<Scalars['String']>;
  /** An array relationship */
  events: Array<Training_Event>;
  /** An aggregate relationship */
  events_aggregate: Training_Event_Aggregate;
  /** A computed field, executes function "training_favorites" */
  favorites: Maybe<Array<Favorite>>;
  featured: Scalars['Boolean'];
  /** An object relationship */
  fellowship: Maybe<Fellowship>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  residency: Maybe<Residency>;
  search_vec: Scalars['tsvector'];
  slug: Scalars['String'];
  type: Scalars['trainingtype'];
};


/** columns and relationships of "training" */
export type TrainingEventsArgs = {
  distinct_on?: InputMaybe<Array<Training_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Event_Order_By>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


/** columns and relationships of "training" */
export type TrainingEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Event_Order_By>>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};


/** columns and relationships of "training" */
export type TrainingFavoritesArgs = {
  distinct_on?: InputMaybe<Array<Favorite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Favorite_Order_By>>;
  where?: InputMaybe<Favorite_Bool_Exp>;
};

/** aggregated selection of "training" */
export type Training_Aggregate = {
  __typename?: 'training_aggregate';
  aggregate: Maybe<Training_Aggregate_Fields>;
  nodes: Array<Training>;
};

/** aggregate fields of "training" */
export type Training_Aggregate_Fields = {
  __typename?: 'training_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Training_Max_Fields>;
  min: Maybe<Training_Min_Fields>;
};


/** aggregate fields of "training" */
export type Training_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "training". All fields are combined with a logical 'AND'. */
export type Training_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Bool_Exp>>;
  _not?: InputMaybe<Training_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  clerkship?: InputMaybe<Clerkship_Bool_Exp>;
  emra_account_no?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Training_Event_Bool_Exp>;
  events_aggregate?: InputMaybe<Training_Event_Aggregate_Bool_Exp>;
  favorites?: InputMaybe<Favorite_Bool_Exp>;
  featured?: InputMaybe<Boolean_Comparison_Exp>;
  fellowship?: InputMaybe<Fellowship_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  residency?: InputMaybe<Residency_Bool_Exp>;
  search_vec?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Trainingtype_Comparison_Exp>;
};

/** unique or primary key constraints on table "training" */
export enum Training_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTraining = 'pk_training',
  /** unique or primary key constraint on columns "emra_account_no" */
  UqTrainingEmraAccountNo = 'uq_training_emra_account_no'
}

/** columns and relationships of "training_event" */
export type Training_Event = {
  __typename?: 'training_event';
  created_at: Scalars['timestamp'];
  event_date: Scalars['date'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  training: Training;
  training_id: Scalars['uuid'];
  url: Scalars['String'];
};

/** aggregated selection of "training_event" */
export type Training_Event_Aggregate = {
  __typename?: 'training_event_aggregate';
  aggregate: Maybe<Training_Event_Aggregate_Fields>;
  nodes: Array<Training_Event>;
};

export type Training_Event_Aggregate_Bool_Exp = {
  count?: InputMaybe<Training_Event_Aggregate_Bool_Exp_Count>;
};

export type Training_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Training_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "training_event" */
export type Training_Event_Aggregate_Fields = {
  __typename?: 'training_event_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Training_Event_Max_Fields>;
  min: Maybe<Training_Event_Min_Fields>;
};


/** aggregate fields of "training_event" */
export type Training_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "training_event" */
export type Training_Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Training_Event_Max_Order_By>;
  min?: InputMaybe<Training_Event_Min_Order_By>;
};

/** input type for inserting array relation for remote table "training_event" */
export type Training_Event_Arr_Rel_Insert_Input = {
  data: Array<Training_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "training_event". All fields are combined with a logical 'AND'. */
export type Training_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Event_Bool_Exp>>;
  _not?: InputMaybe<Training_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  event_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  training?: InputMaybe<Training_Bool_Exp>;
  training_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "training_event" */
export enum Training_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTrainingEvent = 'pk_training_event'
}

/** input type for inserting data into table "training_event" */
export type Training_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  event_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  training?: InputMaybe<Training_Obj_Rel_Insert_Input>;
  training_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Training_Event_Max_Fields = {
  __typename?: 'training_event_max_fields';
  created_at: Maybe<Scalars['timestamp']>;
  event_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  training_id: Maybe<Scalars['uuid']>;
  url: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "training_event" */
export type Training_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  training_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Training_Event_Min_Fields = {
  __typename?: 'training_event_min_fields';
  created_at: Maybe<Scalars['timestamp']>;
  event_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  training_id: Maybe<Scalars['uuid']>;
  url: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "training_event" */
export type Training_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  training_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "training_event" */
export type Training_Event_Mutation_Response = {
  __typename?: 'training_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training_Event>;
};

/** on_conflict condition type for table "training_event" */
export type Training_Event_On_Conflict = {
  constraint: Training_Event_Constraint;
  update_columns?: Array<Training_Event_Update_Column>;
  where?: InputMaybe<Training_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "training_event". */
export type Training_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  training?: InputMaybe<Training_Order_By>;
  training_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training_event */
export type Training_Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "training_event" */
export enum Training_Event_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventDate = 'event_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TrainingId = 'training_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "training_event" */
export type Training_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  event_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  training_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "training_event" */
export type Training_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  event_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  training_id?: InputMaybe<Scalars['uuid']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "training_event" */
export enum Training_Event_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventDate = 'event_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TrainingId = 'training_id',
  /** column name */
  Url = 'url'
}

export type Training_Event_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Event_Bool_Exp;
};

/** columns and relationships of "training_field" */
export type Training_Field = {
  __typename?: 'training_field';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  programs: Array<Training_Program>;
  /** An aggregate relationship */
  programs_aggregate: Training_Program_Aggregate;
  training_type: Scalars['trainingtype'];
};


/** columns and relationships of "training_field" */
export type Training_FieldProgramsArgs = {
  distinct_on?: InputMaybe<Array<Training_Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Program_Order_By>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};


/** columns and relationships of "training_field" */
export type Training_FieldPrograms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Program_Order_By>>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};

/** aggregated selection of "training_field" */
export type Training_Field_Aggregate = {
  __typename?: 'training_field_aggregate';
  aggregate: Maybe<Training_Field_Aggregate_Fields>;
  nodes: Array<Training_Field>;
};

/** aggregate fields of "training_field" */
export type Training_Field_Aggregate_Fields = {
  __typename?: 'training_field_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Training_Field_Max_Fields>;
  min: Maybe<Training_Field_Min_Fields>;
};


/** aggregate fields of "training_field" */
export type Training_Field_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Field_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "training_field". All fields are combined with a logical 'AND'. */
export type Training_Field_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Field_Bool_Exp>>;
  _not?: InputMaybe<Training_Field_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Field_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  programs?: InputMaybe<Training_Program_Bool_Exp>;
  programs_aggregate?: InputMaybe<Training_Program_Aggregate_Bool_Exp>;
  training_type?: InputMaybe<Trainingtype_Comparison_Exp>;
};

/** unique or primary key constraints on table "training_field" */
export enum Training_Field_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTrainingField = 'pk_training_field',
  /** unique or primary key constraint on columns "training_type", "name" */
  UqTrainingFieldTrainingTypeName = 'uq_training_field_training_type_name'
}

/** input type for inserting data into table "training_field" */
export type Training_Field_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  programs?: InputMaybe<Training_Program_Arr_Rel_Insert_Input>;
  training_type?: InputMaybe<Scalars['trainingtype']>;
};

/** aggregate max on columns */
export type Training_Field_Max_Fields = {
  __typename?: 'training_field_max_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  training_type: Maybe<Scalars['trainingtype']>;
};

/** aggregate min on columns */
export type Training_Field_Min_Fields = {
  __typename?: 'training_field_min_fields';
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  training_type: Maybe<Scalars['trainingtype']>;
};

/** response of any mutation on the table "training_field" */
export type Training_Field_Mutation_Response = {
  __typename?: 'training_field_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training_Field>;
};

/** input type for inserting object relation for remote table "training_field" */
export type Training_Field_Obj_Rel_Insert_Input = {
  data: Training_Field_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_Field_On_Conflict>;
};

/** on_conflict condition type for table "training_field" */
export type Training_Field_On_Conflict = {
  constraint: Training_Field_Constraint;
  update_columns?: Array<Training_Field_Update_Column>;
  where?: InputMaybe<Training_Field_Bool_Exp>;
};

/** Ordering options when selecting data from "training_field". */
export type Training_Field_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  programs_aggregate?: InputMaybe<Training_Program_Aggregate_Order_By>;
  training_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training_field */
export type Training_Field_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "training_field" */
export enum Training_Field_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TrainingType = 'training_type'
}

/** input type for updating data in table "training_field" */
export type Training_Field_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  training_type?: InputMaybe<Scalars['trainingtype']>;
};

/** Streaming cursor of the table "training_field" */
export type Training_Field_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Field_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Field_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  training_type?: InputMaybe<Scalars['trainingtype']>;
};

/** update columns of table "training_field" */
export enum Training_Field_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TrainingType = 'training_type'
}

export type Training_Field_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Field_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Field_Bool_Exp;
};

/** input type for inserting data into table "training" */
export type Training_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  clerkship?: InputMaybe<Clerkship_Obj_Rel_Insert_Input>;
  emra_account_no?: InputMaybe<Scalars['String']>;
  events?: InputMaybe<Training_Event_Arr_Rel_Insert_Input>;
  featured?: InputMaybe<Scalars['Boolean']>;
  fellowship?: InputMaybe<Fellowship_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  residency?: InputMaybe<Residency_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['trainingtype']>;
};

/** aggregate max on columns */
export type Training_Max_Fields = {
  __typename?: 'training_max_fields';
  emra_account_no: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  type: Maybe<Scalars['trainingtype']>;
};

/** aggregate min on columns */
export type Training_Min_Fields = {
  __typename?: 'training_min_fields';
  emra_account_no: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  slug: Maybe<Scalars['String']>;
  type: Maybe<Scalars['trainingtype']>;
};

/** response of any mutation on the table "training" */
export type Training_Mutation_Response = {
  __typename?: 'training_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training>;
};

/** input type for inserting object relation for remote table "training" */
export type Training_Obj_Rel_Insert_Input = {
  data: Training_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_On_Conflict>;
};

/** on_conflict condition type for table "training" */
export type Training_On_Conflict = {
  constraint: Training_Constraint;
  update_columns?: Array<Training_Update_Column>;
  where?: InputMaybe<Training_Bool_Exp>;
};

/** Ordering options when selecting data from "training". */
export type Training_Order_By = {
  active?: InputMaybe<Order_By>;
  clerkship?: InputMaybe<Clerkship_Order_By>;
  emra_account_no?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Training_Event_Aggregate_Order_By>;
  favorites_aggregate?: InputMaybe<Favorite_Aggregate_Order_By>;
  featured?: InputMaybe<Order_By>;
  fellowship?: InputMaybe<Fellowship_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  residency?: InputMaybe<Residency_Order_By>;
  search_vec?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training */
export type Training_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "training_program" */
export type Training_Program = {
  __typename?: 'training_program';
  city: Scalars['String'];
  /** An object relationship */
  field: Training_Field;
  field_id: Scalars['uuid'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  state: Scalars['String'];
};

/** aggregated selection of "training_program" */
export type Training_Program_Aggregate = {
  __typename?: 'training_program_aggregate';
  aggregate: Maybe<Training_Program_Aggregate_Fields>;
  nodes: Array<Training_Program>;
};

export type Training_Program_Aggregate_Bool_Exp = {
  count?: InputMaybe<Training_Program_Aggregate_Bool_Exp_Count>;
};

export type Training_Program_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Training_Program_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Program_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "training_program" */
export type Training_Program_Aggregate_Fields = {
  __typename?: 'training_program_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Training_Program_Max_Fields>;
  min: Maybe<Training_Program_Min_Fields>;
};


/** aggregate fields of "training_program" */
export type Training_Program_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Program_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "training_program" */
export type Training_Program_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Training_Program_Max_Order_By>;
  min?: InputMaybe<Training_Program_Min_Order_By>;
};

/** input type for inserting array relation for remote table "training_program" */
export type Training_Program_Arr_Rel_Insert_Input = {
  data: Array<Training_Program_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_Program_On_Conflict>;
};

/** Boolean expression to filter rows from the table "training_program". All fields are combined with a logical 'AND'. */
export type Training_Program_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Program_Bool_Exp>>;
  _not?: InputMaybe<Training_Program_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Program_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  field?: InputMaybe<Training_Field_Bool_Exp>;
  field_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "training_program" */
export enum Training_Program_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTrainingProgram = 'pk_training_program'
}

/** input type for inserting data into table "training_program" */
export type Training_Program_Insert_Input = {
  city?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Training_Field_Obj_Rel_Insert_Input>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Training_Program_Max_Fields = {
  __typename?: 'training_program_max_fields';
  city: Maybe<Scalars['String']>;
  field_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "training_program" */
export type Training_Program_Max_Order_By = {
  city?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Training_Program_Min_Fields = {
  __typename?: 'training_program_min_fields';
  city: Maybe<Scalars['String']>;
  field_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "training_program" */
export type Training_Program_Min_Order_By = {
  city?: InputMaybe<Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "training_program" */
export type Training_Program_Mutation_Response = {
  __typename?: 'training_program_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training_Program>;
};

/** on_conflict condition type for table "training_program" */
export type Training_Program_On_Conflict = {
  constraint: Training_Program_Constraint;
  update_columns?: Array<Training_Program_Update_Column>;
  where?: InputMaybe<Training_Program_Bool_Exp>;
};

/** Ordering options when selecting data from "training_program". */
export type Training_Program_Order_By = {
  city?: InputMaybe<Order_By>;
  field?: InputMaybe<Training_Field_Order_By>;
  field_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training_program */
export type Training_Program_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "training_program" */
export enum Training_Program_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state'
}

/** input type for updating data in table "training_program" */
export type Training_Program_Set_Input = {
  city?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "training_program" */
export type Training_Program_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Program_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Program_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

/** update columns of table "training_program" */
export enum Training_Program_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  FieldId = 'field_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state'
}

export type Training_Program_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Program_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Program_Bool_Exp;
};

/** select columns of table "training" */
export enum Training_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  EmraAccountNo = 'emra_account_no',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SearchVec = 'search_vec',
  /** column name */
  Slug = 'slug',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "training" */
export type Training_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  emra_account_no?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['trainingtype']>;
};

/** Streaming cursor of the table "training" */
export type Training_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  emra_account_no?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  search_vec?: InputMaybe<Scalars['tsvector']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['trainingtype']>;
};

/** columns and relationships of "training_survey" */
export type Training_Survey = {
  __typename?: 'training_survey';
  admin_id: Maybe<Scalars['uuid']>;
  city: Scalars['String'];
  /** An object relationship */
  clerkship_survey: Maybe<Clerkship_Survey>;
  coordinator_email: Scalars['String'];
  coordinator_name: Scalars['String'];
  created_at: Scalars['timestamp'];
  description: Scalars['String'];
  director_email: Scalars['String'];
  director_name: Scalars['String'];
  facebook: Scalars['String'];
  /** An object relationship */
  fellowship_survey: Maybe<Fellowship_Survey>;
  id: Scalars['uuid'];
  instagram: Scalars['String'];
  location: Maybe<Scalars['geography']>;
  multimedia_urls: Array<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  pictures: Array<Training_Survey_Picture>;
  /** An aggregate relationship */
  pictures_aggregate: Training_Survey_Picture_Aggregate;
  /** An object relationship */
  residency_survey: Maybe<Residency_Survey>;
  state: Scalars['String'];
  status: Maybe<Scalars['trainingsurveystatus']>;
  status_changed_at: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  status_changed_by: Maybe<Account>;
  status_changed_by_id: Maybe<Scalars['uuid']>;
  street_address_1: Scalars['String'];
  street_address_2: Scalars['String'];
  submitter_email: Scalars['String'];
  submitter_name: Scalars['String'];
  submitter_phone: Scalars['String'];
  /** An array relationship */
  training_sites: Array<Training_Survey_Site>;
  /** An aggregate relationship */
  training_sites_aggregate: Training_Survey_Site_Aggregate;
  twitter: Scalars['String'];
  type: Scalars['trainingtype'];
  vimeo: Scalars['String'];
  website: Scalars['String'];
  youtube: Scalars['String'];
  zipcode: Scalars['String'];
};


/** columns and relationships of "training_survey" */
export type Training_SurveyPicturesArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


/** columns and relationships of "training_survey" */
export type Training_SurveyPictures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Picture_Order_By>>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};


/** columns and relationships of "training_survey" */
export type Training_SurveyTraining_SitesArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Site_Order_By>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};


/** columns and relationships of "training_survey" */
export type Training_SurveyTraining_Sites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Training_Survey_Site_Order_By>>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};

/** aggregated selection of "training_survey" */
export type Training_Survey_Aggregate = {
  __typename?: 'training_survey_aggregate';
  aggregate: Maybe<Training_Survey_Aggregate_Fields>;
  nodes: Array<Training_Survey>;
};

/** aggregate fields of "training_survey" */
export type Training_Survey_Aggregate_Fields = {
  __typename?: 'training_survey_aggregate_fields';
  count: Scalars['Int'];
  max: Maybe<Training_Survey_Max_Fields>;
  min: Maybe<Training_Survey_Min_Fields>;
};


/** aggregate fields of "training_survey" */
export type Training_Survey_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Survey_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "training_survey". All fields are combined with a logical 'AND'. */
export type Training_Survey_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Survey_Bool_Exp>>;
  _not?: InputMaybe<Training_Survey_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Survey_Bool_Exp>>;
  admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  clerkship_survey?: InputMaybe<Clerkship_Survey_Bool_Exp>;
  coordinator_email?: InputMaybe<String_Comparison_Exp>;
  coordinator_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  director_email?: InputMaybe<String_Comparison_Exp>;
  director_name?: InputMaybe<String_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  fellowship_survey?: InputMaybe<Fellowship_Survey_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Geography_Comparison_Exp>;
  multimedia_urls?: InputMaybe<String_Array_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  pictures?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
  pictures_aggregate?: InputMaybe<Training_Survey_Picture_Aggregate_Bool_Exp>;
  residency_survey?: InputMaybe<Residency_Survey_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Trainingsurveystatus_Comparison_Exp>;
  status_changed_at?: InputMaybe<Timestamp_Comparison_Exp>;
  status_changed_by?: InputMaybe<Account_Bool_Exp>;
  status_changed_by_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_address_1?: InputMaybe<String_Comparison_Exp>;
  street_address_2?: InputMaybe<String_Comparison_Exp>;
  submitter_email?: InputMaybe<String_Comparison_Exp>;
  submitter_name?: InputMaybe<String_Comparison_Exp>;
  submitter_phone?: InputMaybe<String_Comparison_Exp>;
  training_sites?: InputMaybe<Training_Survey_Site_Bool_Exp>;
  training_sites_aggregate?: InputMaybe<Training_Survey_Site_Aggregate_Bool_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Trainingtype_Comparison_Exp>;
  vimeo?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
  youtube?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "training_survey" */
export enum Training_Survey_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTrainingSurvey = 'pk_training_survey'
}

/** input type for inserting data into table "training_survey" */
export type Training_Survey_Insert_Input = {
  admin_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  clerkship_survey?: InputMaybe<Clerkship_Survey_Obj_Rel_Insert_Input>;
  coordinator_email?: InputMaybe<Scalars['String']>;
  coordinator_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  director_email?: InputMaybe<Scalars['String']>;
  director_name?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  fellowship_survey?: InputMaybe<Fellowship_Survey_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  multimedia_urls?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  pictures?: InputMaybe<Training_Survey_Picture_Arr_Rel_Insert_Input>;
  residency_survey?: InputMaybe<Residency_Survey_Obj_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['trainingsurveystatus']>;
  status_changed_at?: InputMaybe<Scalars['timestamp']>;
  status_changed_by?: InputMaybe<Account_Obj_Rel_Insert_Input>;
  status_changed_by_id?: InputMaybe<Scalars['uuid']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  submitter_email?: InputMaybe<Scalars['String']>;
  submitter_name?: InputMaybe<Scalars['String']>;
  submitter_phone?: InputMaybe<Scalars['String']>;
  training_sites?: InputMaybe<Training_Survey_Site_Arr_Rel_Insert_Input>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['trainingtype']>;
  vimeo?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Training_Survey_Max_Fields = {
  __typename?: 'training_survey_max_fields';
  admin_id: Maybe<Scalars['uuid']>;
  city: Maybe<Scalars['String']>;
  coordinator_email: Maybe<Scalars['String']>;
  coordinator_name: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  description: Maybe<Scalars['String']>;
  director_email: Maybe<Scalars['String']>;
  director_name: Maybe<Scalars['String']>;
  facebook: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  instagram: Maybe<Scalars['String']>;
  multimedia_urls: Maybe<Array<Scalars['String']>>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  status: Maybe<Scalars['trainingsurveystatus']>;
  status_changed_at: Maybe<Scalars['timestamp']>;
  status_changed_by_id: Maybe<Scalars['uuid']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  submitter_email: Maybe<Scalars['String']>;
  submitter_name: Maybe<Scalars['String']>;
  submitter_phone: Maybe<Scalars['String']>;
  twitter: Maybe<Scalars['String']>;
  type: Maybe<Scalars['trainingtype']>;
  vimeo: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  youtube: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Training_Survey_Min_Fields = {
  __typename?: 'training_survey_min_fields';
  admin_id: Maybe<Scalars['uuid']>;
  city: Maybe<Scalars['String']>;
  coordinator_email: Maybe<Scalars['String']>;
  coordinator_name: Maybe<Scalars['String']>;
  created_at: Maybe<Scalars['timestamp']>;
  description: Maybe<Scalars['String']>;
  director_email: Maybe<Scalars['String']>;
  director_name: Maybe<Scalars['String']>;
  facebook: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  instagram: Maybe<Scalars['String']>;
  multimedia_urls: Maybe<Array<Scalars['String']>>;
  name: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  status: Maybe<Scalars['trainingsurveystatus']>;
  status_changed_at: Maybe<Scalars['timestamp']>;
  status_changed_by_id: Maybe<Scalars['uuid']>;
  street_address_1: Maybe<Scalars['String']>;
  street_address_2: Maybe<Scalars['String']>;
  submitter_email: Maybe<Scalars['String']>;
  submitter_name: Maybe<Scalars['String']>;
  submitter_phone: Maybe<Scalars['String']>;
  twitter: Maybe<Scalars['String']>;
  type: Maybe<Scalars['trainingtype']>;
  vimeo: Maybe<Scalars['String']>;
  website: Maybe<Scalars['String']>;
  youtube: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "training_survey" */
export type Training_Survey_Mutation_Response = {
  __typename?: 'training_survey_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training_Survey>;
};

/** input type for inserting object relation for remote table "training_survey" */
export type Training_Survey_Obj_Rel_Insert_Input = {
  data: Training_Survey_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_Survey_On_Conflict>;
};

/** on_conflict condition type for table "training_survey" */
export type Training_Survey_On_Conflict = {
  constraint: Training_Survey_Constraint;
  update_columns?: Array<Training_Survey_Update_Column>;
  where?: InputMaybe<Training_Survey_Bool_Exp>;
};

/** Ordering options when selecting data from "training_survey". */
export type Training_Survey_Order_By = {
  admin_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  clerkship_survey?: InputMaybe<Clerkship_Survey_Order_By>;
  coordinator_email?: InputMaybe<Order_By>;
  coordinator_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  director_email?: InputMaybe<Order_By>;
  director_name?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  fellowship_survey?: InputMaybe<Fellowship_Survey_Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  multimedia_urls?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  pictures_aggregate?: InputMaybe<Training_Survey_Picture_Aggregate_Order_By>;
  residency_survey?: InputMaybe<Residency_Survey_Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_changed_at?: InputMaybe<Order_By>;
  status_changed_by?: InputMaybe<Account_Order_By>;
  status_changed_by_id?: InputMaybe<Order_By>;
  street_address_1?: InputMaybe<Order_By>;
  street_address_2?: InputMaybe<Order_By>;
  submitter_email?: InputMaybe<Order_By>;
  submitter_name?: InputMaybe<Order_By>;
  submitter_phone?: InputMaybe<Order_By>;
  training_sites_aggregate?: InputMaybe<Training_Survey_Site_Aggregate_Order_By>;
  twitter?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vimeo?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  youtube?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** columns and relationships of "training_survey_picture" */
export type Training_Survey_Picture = {
  __typename?: 'training_survey_picture';
  id: Scalars['uuid'];
  order: Scalars['Int'];
  /** An object relationship */
  picture: File;
  picture_id: Scalars['uuid'];
  /** An object relationship */
  training_survey: Training_Survey;
  training_survey_id: Scalars['uuid'];
};

/** aggregated selection of "training_survey_picture" */
export type Training_Survey_Picture_Aggregate = {
  __typename?: 'training_survey_picture_aggregate';
  aggregate: Maybe<Training_Survey_Picture_Aggregate_Fields>;
  nodes: Array<Training_Survey_Picture>;
};

export type Training_Survey_Picture_Aggregate_Bool_Exp = {
  count?: InputMaybe<Training_Survey_Picture_Aggregate_Bool_Exp_Count>;
};

export type Training_Survey_Picture_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "training_survey_picture" */
export type Training_Survey_Picture_Aggregate_Fields = {
  __typename?: 'training_survey_picture_aggregate_fields';
  avg: Maybe<Training_Survey_Picture_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Training_Survey_Picture_Max_Fields>;
  min: Maybe<Training_Survey_Picture_Min_Fields>;
  stddev: Maybe<Training_Survey_Picture_Stddev_Fields>;
  stddev_pop: Maybe<Training_Survey_Picture_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Training_Survey_Picture_Stddev_Samp_Fields>;
  sum: Maybe<Training_Survey_Picture_Sum_Fields>;
  var_pop: Maybe<Training_Survey_Picture_Var_Pop_Fields>;
  var_samp: Maybe<Training_Survey_Picture_Var_Samp_Fields>;
  variance: Maybe<Training_Survey_Picture_Variance_Fields>;
};


/** aggregate fields of "training_survey_picture" */
export type Training_Survey_Picture_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Survey_Picture_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "training_survey_picture" */
export type Training_Survey_Picture_Aggregate_Order_By = {
  avg?: InputMaybe<Training_Survey_Picture_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Training_Survey_Picture_Max_Order_By>;
  min?: InputMaybe<Training_Survey_Picture_Min_Order_By>;
  stddev?: InputMaybe<Training_Survey_Picture_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Training_Survey_Picture_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Training_Survey_Picture_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Training_Survey_Picture_Sum_Order_By>;
  var_pop?: InputMaybe<Training_Survey_Picture_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Training_Survey_Picture_Var_Samp_Order_By>;
  variance?: InputMaybe<Training_Survey_Picture_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "training_survey_picture" */
export type Training_Survey_Picture_Arr_Rel_Insert_Input = {
  data: Array<Training_Survey_Picture_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_Survey_Picture_On_Conflict>;
};

/** aggregate avg on columns */
export type Training_Survey_Picture_Avg_Fields = {
  __typename?: 'training_survey_picture_avg_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "training_survey_picture". All fields are combined with a logical 'AND'. */
export type Training_Survey_Picture_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Survey_Picture_Bool_Exp>>;
  _not?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Survey_Picture_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  picture?: InputMaybe<File_Bool_Exp>;
  picture_id?: InputMaybe<Uuid_Comparison_Exp>;
  training_survey?: InputMaybe<Training_Survey_Bool_Exp>;
  training_survey_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "training_survey_picture" */
export enum Training_Survey_Picture_Constraint {
  /** unique or primary key constraint on columns "id" */
  PkTrainingSurveyPicture = 'pk_training_survey_picture',
  /** unique or primary key constraint on columns "order", "training_survey_id" */
  UqTrainingSurveyPictureTrainingSurveyIdOrder = 'uq_training_survey_picture_training_survey_id_order',
  /** unique or primary key constraint on columns "picture_id", "training_survey_id" */
  UqTrainingSurveyPictureTrainingSurveyIdPictureId = 'uq_training_survey_picture_training_survey_id_picture_id'
}

/** input type for incrementing numeric columns in table "training_survey_picture" */
export type Training_Survey_Picture_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "training_survey_picture" */
export type Training_Survey_Picture_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  picture?: InputMaybe<File_Obj_Rel_Insert_Input>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  training_survey?: InputMaybe<Training_Survey_Obj_Rel_Insert_Input>;
  training_survey_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Training_Survey_Picture_Max_Fields = {
  __typename?: 'training_survey_picture_max_fields';
  id: Maybe<Scalars['uuid']>;
  order: Maybe<Scalars['Int']>;
  picture_id: Maybe<Scalars['uuid']>;
  training_survey_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  picture_id?: InputMaybe<Order_By>;
  training_survey_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Training_Survey_Picture_Min_Fields = {
  __typename?: 'training_survey_picture_min_fields';
  id: Maybe<Scalars['uuid']>;
  order: Maybe<Scalars['Int']>;
  picture_id: Maybe<Scalars['uuid']>;
  training_survey_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  picture_id?: InputMaybe<Order_By>;
  training_survey_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "training_survey_picture" */
export type Training_Survey_Picture_Mutation_Response = {
  __typename?: 'training_survey_picture_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training_Survey_Picture>;
};

/** on_conflict condition type for table "training_survey_picture" */
export type Training_Survey_Picture_On_Conflict = {
  constraint: Training_Survey_Picture_Constraint;
  update_columns?: Array<Training_Survey_Picture_Update_Column>;
  where?: InputMaybe<Training_Survey_Picture_Bool_Exp>;
};

/** Ordering options when selecting data from "training_survey_picture". */
export type Training_Survey_Picture_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  picture?: InputMaybe<File_Order_By>;
  picture_id?: InputMaybe<Order_By>;
  training_survey?: InputMaybe<Training_Survey_Order_By>;
  training_survey_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training_survey_picture */
export type Training_Survey_Picture_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "training_survey_picture" */
export enum Training_Survey_Picture_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  TrainingSurveyId = 'training_survey_id'
}

/** input type for updating data in table "training_survey_picture" */
export type Training_Survey_Picture_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  training_survey_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Training_Survey_Picture_Stddev_Fields = {
  __typename?: 'training_survey_picture_stddev_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Training_Survey_Picture_Stddev_Pop_Fields = {
  __typename?: 'training_survey_picture_stddev_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Training_Survey_Picture_Stddev_Samp_Fields = {
  __typename?: 'training_survey_picture_stddev_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "training_survey_picture" */
export type Training_Survey_Picture_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Survey_Picture_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Survey_Picture_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  picture_id?: InputMaybe<Scalars['uuid']>;
  training_survey_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Training_Survey_Picture_Sum_Fields = {
  __typename?: 'training_survey_picture_sum_fields';
  order: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "training_survey_picture" */
export enum Training_Survey_Picture_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PictureId = 'picture_id',
  /** column name */
  TrainingSurveyId = 'training_survey_id'
}

export type Training_Survey_Picture_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Training_Survey_Picture_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Survey_Picture_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Survey_Picture_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Training_Survey_Picture_Var_Pop_Fields = {
  __typename?: 'training_survey_picture_var_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Training_Survey_Picture_Var_Samp_Fields = {
  __typename?: 'training_survey_picture_var_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Training_Survey_Picture_Variance_Fields = {
  __typename?: 'training_survey_picture_variance_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "training_survey_picture" */
export type Training_Survey_Picture_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training_survey */
export type Training_Survey_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "training_survey" */
export enum Training_Survey_Select_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  City = 'city',
  /** column name */
  CoordinatorEmail = 'coordinator_email',
  /** column name */
  CoordinatorName = 'coordinator_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DirectorEmail = 'director_email',
  /** column name */
  DirectorName = 'director_name',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Location = 'location',
  /** column name */
  MultimediaUrls = 'multimedia_urls',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'status_changed_at',
  /** column name */
  StatusChangedById = 'status_changed_by_id',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  SubmitterEmail = 'submitter_email',
  /** column name */
  SubmitterName = 'submitter_name',
  /** column name */
  SubmitterPhone = 'submitter_phone',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  Type = 'type',
  /** column name */
  Vimeo = 'vimeo',
  /** column name */
  Website = 'website',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "training_survey" */
export type Training_Survey_Set_Input = {
  admin_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  coordinator_email?: InputMaybe<Scalars['String']>;
  coordinator_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  director_email?: InputMaybe<Scalars['String']>;
  director_name?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  multimedia_urls?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['trainingsurveystatus']>;
  status_changed_at?: InputMaybe<Scalars['timestamp']>;
  status_changed_by_id?: InputMaybe<Scalars['uuid']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  submitter_email?: InputMaybe<Scalars['String']>;
  submitter_name?: InputMaybe<Scalars['String']>;
  submitter_phone?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['trainingtype']>;
  vimeo?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "training_survey_site" */
export type Training_Survey_Site = {
  __typename?: 'training_survey_site';
  /** An object relationship */
  facility: Maybe<Facility>;
  facility_id: Maybe<Scalars['uuid']>;
  facility_other: Scalars['String'];
  id: Scalars['uuid'];
  order: Scalars['Int'];
  primary: Scalars['Boolean'];
  /** An object relationship */
  survey: Training_Survey;
  training_survey_id: Scalars['uuid'];
};

/** aggregated selection of "training_survey_site" */
export type Training_Survey_Site_Aggregate = {
  __typename?: 'training_survey_site_aggregate';
  aggregate: Maybe<Training_Survey_Site_Aggregate_Fields>;
  nodes: Array<Training_Survey_Site>;
};

export type Training_Survey_Site_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Training_Survey_Site_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Training_Survey_Site_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Training_Survey_Site_Aggregate_Bool_Exp_Count>;
};

export type Training_Survey_Site_Aggregate_Bool_Exp_Bool_And = {
  arguments: Training_Survey_Site_Select_Column_Training_Survey_Site_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Survey_Site_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Training_Survey_Site_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Training_Survey_Site_Select_Column_Training_Survey_Site_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Survey_Site_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Training_Survey_Site_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Training_Survey_Site_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "training_survey_site" */
export type Training_Survey_Site_Aggregate_Fields = {
  __typename?: 'training_survey_site_aggregate_fields';
  avg: Maybe<Training_Survey_Site_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Training_Survey_Site_Max_Fields>;
  min: Maybe<Training_Survey_Site_Min_Fields>;
  stddev: Maybe<Training_Survey_Site_Stddev_Fields>;
  stddev_pop: Maybe<Training_Survey_Site_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Training_Survey_Site_Stddev_Samp_Fields>;
  sum: Maybe<Training_Survey_Site_Sum_Fields>;
  var_pop: Maybe<Training_Survey_Site_Var_Pop_Fields>;
  var_samp: Maybe<Training_Survey_Site_Var_Samp_Fields>;
  variance: Maybe<Training_Survey_Site_Variance_Fields>;
};


/** aggregate fields of "training_survey_site" */
export type Training_Survey_Site_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Training_Survey_Site_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "training_survey_site" */
export type Training_Survey_Site_Aggregate_Order_By = {
  avg?: InputMaybe<Training_Survey_Site_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Training_Survey_Site_Max_Order_By>;
  min?: InputMaybe<Training_Survey_Site_Min_Order_By>;
  stddev?: InputMaybe<Training_Survey_Site_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Training_Survey_Site_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Training_Survey_Site_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Training_Survey_Site_Sum_Order_By>;
  var_pop?: InputMaybe<Training_Survey_Site_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Training_Survey_Site_Var_Samp_Order_By>;
  variance?: InputMaybe<Training_Survey_Site_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "training_survey_site" */
export type Training_Survey_Site_Arr_Rel_Insert_Input = {
  data: Array<Training_Survey_Site_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Training_Survey_Site_On_Conflict>;
};

/** aggregate avg on columns */
export type Training_Survey_Site_Avg_Fields = {
  __typename?: 'training_survey_site_avg_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "training_survey_site" */
export type Training_Survey_Site_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "training_survey_site". All fields are combined with a logical 'AND'. */
export type Training_Survey_Site_Bool_Exp = {
  _and?: InputMaybe<Array<Training_Survey_Site_Bool_Exp>>;
  _not?: InputMaybe<Training_Survey_Site_Bool_Exp>;
  _or?: InputMaybe<Array<Training_Survey_Site_Bool_Exp>>;
  facility?: InputMaybe<Facility_Bool_Exp>;
  facility_id?: InputMaybe<Uuid_Comparison_Exp>;
  facility_other?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  survey?: InputMaybe<Training_Survey_Bool_Exp>;
  training_survey_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "training_survey_site" */
export enum Training_Survey_Site_Constraint {
  /** unique or primary key constraint on columns "facility_id", "training_survey_id" */
  IxTrainingSurveySiteTrainingSurveyIdFacilityId = 'ix_training_survey_site_training_survey_id_facility_id',
  /** unique or primary key constraint on columns "order", "training_survey_id" */
  IxTrainingSurveySiteTrainingSurveyIdOrder = 'ix_training_survey_site_training_survey_id_order',
  /** unique or primary key constraint on columns "id" */
  PkTrainingSurveySite = 'pk_training_survey_site',
  /** unique or primary key constraint on columns "facility_id", "training_survey_id" */
  UqTrainingSurveySiteTrainingSurveyIdFacilityId = 'uq_training_survey_site_training_survey_id_facility_id'
}

/** input type for incrementing numeric columns in table "training_survey_site" */
export type Training_Survey_Site_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "training_survey_site" */
export type Training_Survey_Site_Insert_Input = {
  facility?: InputMaybe<Facility_Obj_Rel_Insert_Input>;
  facility_id?: InputMaybe<Scalars['uuid']>;
  facility_other?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  survey?: InputMaybe<Training_Survey_Obj_Rel_Insert_Input>;
  training_survey_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Training_Survey_Site_Max_Fields = {
  __typename?: 'training_survey_site_max_fields';
  facility_id: Maybe<Scalars['uuid']>;
  facility_other: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  order: Maybe<Scalars['Int']>;
  training_survey_id: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "training_survey_site" */
export type Training_Survey_Site_Max_Order_By = {
  facility_id?: InputMaybe<Order_By>;
  facility_other?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  training_survey_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Training_Survey_Site_Min_Fields = {
  __typename?: 'training_survey_site_min_fields';
  facility_id: Maybe<Scalars['uuid']>;
  facility_other: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  order: Maybe<Scalars['Int']>;
  training_survey_id: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "training_survey_site" */
export type Training_Survey_Site_Min_Order_By = {
  facility_id?: InputMaybe<Order_By>;
  facility_other?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  training_survey_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "training_survey_site" */
export type Training_Survey_Site_Mutation_Response = {
  __typename?: 'training_survey_site_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Training_Survey_Site>;
};

/** on_conflict condition type for table "training_survey_site" */
export type Training_Survey_Site_On_Conflict = {
  constraint: Training_Survey_Site_Constraint;
  update_columns?: Array<Training_Survey_Site_Update_Column>;
  where?: InputMaybe<Training_Survey_Site_Bool_Exp>;
};

/** Ordering options when selecting data from "training_survey_site". */
export type Training_Survey_Site_Order_By = {
  facility?: InputMaybe<Facility_Order_By>;
  facility_id?: InputMaybe<Order_By>;
  facility_other?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  survey?: InputMaybe<Training_Survey_Order_By>;
  training_survey_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: training_survey_site */
export type Training_Survey_Site_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "training_survey_site" */
export enum Training_Survey_Site_Select_Column {
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FacilityOther = 'facility_other',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Primary = 'primary',
  /** column name */
  TrainingSurveyId = 'training_survey_id'
}

/** select "training_survey_site_aggregate_bool_exp_bool_and_arguments_columns" columns of table "training_survey_site" */
export enum Training_Survey_Site_Select_Column_Training_Survey_Site_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** select "training_survey_site_aggregate_bool_exp_bool_or_arguments_columns" columns of table "training_survey_site" */
export enum Training_Survey_Site_Select_Column_Training_Survey_Site_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Primary = 'primary'
}

/** input type for updating data in table "training_survey_site" */
export type Training_Survey_Site_Set_Input = {
  facility_id?: InputMaybe<Scalars['uuid']>;
  facility_other?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  training_survey_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Training_Survey_Site_Stddev_Fields = {
  __typename?: 'training_survey_site_stddev_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "training_survey_site" */
export type Training_Survey_Site_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Training_Survey_Site_Stddev_Pop_Fields = {
  __typename?: 'training_survey_site_stddev_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "training_survey_site" */
export type Training_Survey_Site_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Training_Survey_Site_Stddev_Samp_Fields = {
  __typename?: 'training_survey_site_stddev_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "training_survey_site" */
export type Training_Survey_Site_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "training_survey_site" */
export type Training_Survey_Site_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Survey_Site_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Survey_Site_Stream_Cursor_Value_Input = {
  facility_id?: InputMaybe<Scalars['uuid']>;
  facility_other?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  primary?: InputMaybe<Scalars['Boolean']>;
  training_survey_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Training_Survey_Site_Sum_Fields = {
  __typename?: 'training_survey_site_sum_fields';
  order: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "training_survey_site" */
export type Training_Survey_Site_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "training_survey_site" */
export enum Training_Survey_Site_Update_Column {
  /** column name */
  FacilityId = 'facility_id',
  /** column name */
  FacilityOther = 'facility_other',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  Primary = 'primary',
  /** column name */
  TrainingSurveyId = 'training_survey_id'
}

export type Training_Survey_Site_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Training_Survey_Site_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Survey_Site_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Survey_Site_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Training_Survey_Site_Var_Pop_Fields = {
  __typename?: 'training_survey_site_var_pop_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "training_survey_site" */
export type Training_Survey_Site_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Training_Survey_Site_Var_Samp_Fields = {
  __typename?: 'training_survey_site_var_samp_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "training_survey_site" */
export type Training_Survey_Site_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Training_Survey_Site_Variance_Fields = {
  __typename?: 'training_survey_site_variance_fields';
  order: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "training_survey_site" */
export type Training_Survey_Site_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "training_survey" */
export type Training_Survey_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Training_Survey_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Training_Survey_Stream_Cursor_Value_Input = {
  admin_id?: InputMaybe<Scalars['uuid']>;
  city?: InputMaybe<Scalars['String']>;
  coordinator_email?: InputMaybe<Scalars['String']>;
  coordinator_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  director_email?: InputMaybe<Scalars['String']>;
  director_name?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['geography']>;
  multimedia_urls?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['trainingsurveystatus']>;
  status_changed_at?: InputMaybe<Scalars['timestamp']>;
  status_changed_by_id?: InputMaybe<Scalars['uuid']>;
  street_address_1?: InputMaybe<Scalars['String']>;
  street_address_2?: InputMaybe<Scalars['String']>;
  submitter_email?: InputMaybe<Scalars['String']>;
  submitter_name?: InputMaybe<Scalars['String']>;
  submitter_phone?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['trainingtype']>;
  vimeo?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtube?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** update columns of table "training_survey" */
export enum Training_Survey_Update_Column {
  /** column name */
  AdminId = 'admin_id',
  /** column name */
  City = 'city',
  /** column name */
  CoordinatorEmail = 'coordinator_email',
  /** column name */
  CoordinatorName = 'coordinator_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DirectorEmail = 'director_email',
  /** column name */
  DirectorName = 'director_name',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  Location = 'location',
  /** column name */
  MultimediaUrls = 'multimedia_urls',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangedAt = 'status_changed_at',
  /** column name */
  StatusChangedById = 'status_changed_by_id',
  /** column name */
  StreetAddress_1 = 'street_address_1',
  /** column name */
  StreetAddress_2 = 'street_address_2',
  /** column name */
  SubmitterEmail = 'submitter_email',
  /** column name */
  SubmitterName = 'submitter_name',
  /** column name */
  SubmitterPhone = 'submitter_phone',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  Type = 'type',
  /** column name */
  Vimeo = 'vimeo',
  /** column name */
  Website = 'website',
  /** column name */
  Youtube = 'youtube',
  /** column name */
  Zipcode = 'zipcode'
}

export type Training_Survey_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Survey_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Survey_Bool_Exp;
};

/** update columns of table "training" */
export enum Training_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  EmraAccountNo = 'emra_account_no',
  /** column name */
  Featured = 'featured',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type'
}

export type Training_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Training_Set_Input>;
  /** filter the rows which have to be updated */
  where: Training_Bool_Exp;
};

/** Boolean expression to compare columns of type "trainingsurveystatus". All fields are combined with logical 'AND'. */
export type Trainingsurveystatus_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['trainingsurveystatus']>;
  _gt?: InputMaybe<Scalars['trainingsurveystatus']>;
  _gte?: InputMaybe<Scalars['trainingsurveystatus']>;
  _in?: InputMaybe<Array<Scalars['trainingsurveystatus']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['trainingsurveystatus']>;
  _lte?: InputMaybe<Scalars['trainingsurveystatus']>;
  _neq?: InputMaybe<Scalars['trainingsurveystatus']>;
  _nin?: InputMaybe<Array<Scalars['trainingsurveystatus']>>;
};

/** Boolean expression to compare columns of type "trainingtype". All fields are combined with logical 'AND'. */
export type Trainingtype_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['trainingtype']>;
  _gt?: InputMaybe<Scalars['trainingtype']>;
  _gte?: InputMaybe<Scalars['trainingtype']>;
  _in?: InputMaybe<Array<Scalars['trainingtype']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['trainingtype']>;
  _lte?: InputMaybe<Scalars['trainingtype']>;
  _neq?: InputMaybe<Scalars['trainingtype']>;
  _nin?: InputMaybe<Array<Scalars['trainingtype']>>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** Boolean expression to compare columns of type "workerclassification". All fields are combined with logical 'AND'. */
export type Workerclassification_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['workerclassification']>;
  _gt?: InputMaybe<Scalars['workerclassification']>;
  _gte?: InputMaybe<Scalars['workerclassification']>;
  _in?: InputMaybe<Array<Scalars['workerclassification']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['workerclassification']>;
  _lte?: InputMaybe<Scalars['workerclassification']>;
  _neq?: InputMaybe<Scalars['workerclassification']>;
  _nin?: InputMaybe<Array<Scalars['workerclassification']>>;
};

/** Boolean expression to compare columns of type "workschedule". All fields are combined with logical 'AND'. */
export type Workschedule_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['workschedule']>;
  _gt?: InputMaybe<Scalars['workschedule']>;
  _gte?: InputMaybe<Scalars['workschedule']>;
  _in?: InputMaybe<Array<Scalars['workschedule']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['workschedule']>;
  _lte?: InputMaybe<Scalars['workschedule']>;
  _neq?: InputMaybe<Scalars['workschedule']>;
  _nin?: InputMaybe<Array<Scalars['workschedule']>>;
};

/** Boolean expression to compare columns of type "workterm". All fields are combined with logical 'AND'. */
export type Workterm_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['workterm']>;
  _gt?: InputMaybe<Scalars['workterm']>;
  _gte?: InputMaybe<Scalars['workterm']>;
  _in?: InputMaybe<Array<Scalars['workterm']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['workterm']>;
  _lte?: InputMaybe<Scalars['workterm']>;
  _neq?: InputMaybe<Scalars['workterm']>;
  _nin?: InputMaybe<Array<Scalars['workterm']>>;
};

export type ClinicianAvatar_ClinicianFragment = { __typename?: 'clinician', id: any, account: { __typename?: 'account', pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null } | null, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } } & { ' $fragmentName'?: 'ClinicianAvatar_ClinicianFragment' };

export type AccountAvatar_AccountFragment = { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null } | null, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } & { ' $fragmentName'?: 'AccountAvatar_AccountFragment' };

export type CurrentAccountAvatar_CurrentAccountFragment = { __typename?: 'current_account', id: any | null, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null } | null, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } & { ' $fragmentName'?: 'CurrentAccountAvatar_CurrentAccountFragment' };

export type CheckoutForm_CreateSubscriptionMutationVariables = Exact<{
  interval: Scalars['String'];
  slots: Scalars['Int'];
  customerDetails: CustomerDetailsInput;
  paymentId?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
}>;


export type CheckoutForm_CreateSubscriptionMutation = { __typename?: 'mutation_root', paymentIntent: { __typename?: 'PaymentIntentGQL', clientSecret: string | null, amountDue: number, setupFutureUsage: string | null } };

export type CheckoutForm_UpdateSubscriptionMutationVariables = Exact<{
  interval: Scalars['String'];
  slots: Scalars['Int'];
  customerDetails: CustomerDetailsInput;
  paymentId?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
}>;


export type CheckoutForm_UpdateSubscriptionMutation = { __typename?: 'mutation_root', paymentIntent: { __typename?: 'PaymentIntentGQL', clientSecret: string | null, amountDue: number, setupFutureUsage: string | null } };

export type CheckoutForm_PayOutstandingMutationVariables = Exact<{
  paymentId?: InputMaybe<Scalars['String']>;
}>;


export type CheckoutForm_PayOutstandingMutation = { __typename?: 'mutation_root', paymentIntent: { __typename?: 'PaymentIntentGQL', id: string | null, clientSecret: string | null, amountDue: number, setupFutureUsage: string | null } };

export type CheckoutSummary_SubscriptionInvoicePreviewQueryVariables = Exact<{
  interval: Scalars['String'];
  quantity: Scalars['Int'];
  address: CustomerAddressInput;
  promo?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
}>;


export type CheckoutSummary_SubscriptionInvoicePreviewQuery = { __typename?: 'query_root', subscriptionInvoicePreview: { __typename?: 'SubscriptionInvoicePreviewGQL', subtotal: number, total: number, tax: number | null } };

export type EditEmployerProfileForm_OrganizationFragment = { __typename?: 'organization', id: any, name: string, website: string, description: string, phone: string, city: string, state: string, zipcode: string, nameChange: string, streetAddress1: string, streetAddress2: string, logo: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } & { ' $fragmentName'?: 'EditEmployerProfileForm_OrganizationFragment' };

export type EditEmployerProfileForm_UpdateProfileMutationVariables = Exact<{
  orgId: Scalars['uuid'];
  updates: Organization_Set_Input;
}>;


export type EditEmployerProfileForm_UpdateProfileMutation = { __typename?: 'mutation_root', update_organization_by_pk: { __typename?: 'organization', id: any } | null };

export type FacilityOverviewForm_UpdateOverviewMutationVariables = Exact<{
  facilityId: Scalars['uuid'];
  pictureId: Scalars['uuid'];
}>;


export type FacilityOverviewForm_UpdateOverviewMutation = { __typename?: 'mutation_root', change_facility_picture: Array<{ __typename?: 'facility', id: any }> };

export type FacilityRecruiterForm_RecruiterFragment = { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null } } & { ' $fragmentName'?: 'FacilityRecruiterForm_RecruiterFragment' };

export type FacilityRecruiterForm_OrgUsersQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type FacilityRecruiterForm_OrgUsersQuery = { __typename?: 'query_root', orgUsers: Array<(
    { __typename?: 'org_user' }
    & { ' $fragmentRefs'?: { 'FacilityRecruiterForm_RecruiterFragment': FacilityRecruiterForm_RecruiterFragment } }
  )> };

export type JobPostingFormAdditional_PostingFragment = { __typename?: 'job_posting', id: any, description: string, descriptionHtml: string, creator: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, fullName: string | null } | null } } | null } & { ' $fragmentName'?: 'JobPostingFormAdditional_PostingFragment' };

export type JobPostingFormCompensation_PostingFragment = { __typename?: 'job_posting', id: any, cme: boolean, equity: boolean, hasRate: boolean, ratePeriod: any | null, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, hasSigningBonus: boolean, hasRelocationAssist: boolean, hasPerfBonus: boolean, healthInsurance: boolean, dentalInsurance: boolean, visionInsurance: boolean, healthAccount: boolean, disabilityInsurance: boolean, lifeInsurance: boolean, retirement: boolean, paidVacation: boolean, paidParental: boolean, studentLoan: boolean, malpracticeInsurance: boolean, tailCoverage: boolean } & { ' $fragmentName'?: 'JobPostingFormCompensation_PostingFragment' };

export type JobPostingFormGeneralInfo_ContractFragment = (
  { __typename?: 'facility_contract', id: any, facility: (
    { __typename?: 'facility', id: any }
    & { ' $fragmentRefs'?: { 'FacilitySelect_FacilityFragment': FacilitySelect_FacilityFragment } }
  ), recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, fullName: string | null } | null } } }
  & { ' $fragmentRefs'?: { 'EditRecruiterPopup_ContractFragment': EditRecruiterPopup_ContractFragment } }
) & { ' $fragmentName'?: 'JobPostingFormGeneralInfo_ContractFragment' };

export type JobPostingFormGeneralInfo_PostingFragment = { __typename?: 'job_posting', id: any, title: string, schedule: any | null, term: any | null, startOrTodayDate: any | null, hasStartDate: boolean | null, startDate: any | null, j1Visa: boolean | null, h1bVisa: boolean | null, contract: (
    { __typename?: 'facility_contract', id: any }
    & { ' $fragmentRefs'?: { 'JobPostingFormGeneralInfo_ContractFragment': JobPostingFormGeneralInfo_ContractFragment } }
  ), professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, workerClassifications: Array<{ __typename?: 'posting_worker_classification', id: any, worker: any }> } & { ' $fragmentName'?: 'JobPostingFormGeneralInfo_PostingFragment' };

export type JobPostingFormGeneralInfo_SelectFacilityContractQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
  orgId: Scalars['uuid'];
}>;


export type JobPostingFormGeneralInfo_SelectFacilityContractQuery = { __typename?: 'query_root', contracts: Array<(
    { __typename?: 'facility_contract', id: any }
    & { ' $fragmentRefs'?: { 'JobPostingFormGeneralInfo_ContractFragment': JobPostingFormGeneralInfo_ContractFragment } }
  )> };

export type JobPostingFormGeneralInfo_FetchNewContractQueryVariables = Exact<{
  contractId: Scalars['uuid'];
}>;


export type JobPostingFormGeneralInfo_FetchNewContractQuery = { __typename?: 'query_root', contract: (
    { __typename?: 'facility_contract', id: any }
    & { ' $fragmentRefs'?: { 'JobPostingFormGeneralInfo_ContractFragment': JobPostingFormGeneralInfo_ContractFragment } }
  ) | null };

export type JobPostingForm_PostingFragment = (
  { __typename?: 'job_posting', id: any, workerClassifications: Array<{ __typename?: 'posting_worker_classification', id: any, worker: any }>, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }> }
  & { ' $fragmentRefs'?: { 'JobPostingFormGeneralInfo_PostingFragment': JobPostingFormGeneralInfo_PostingFragment;'JobPostingFormCompensation_PostingFragment': JobPostingFormCompensation_PostingFragment;'JobPostingFormQualifications_PostingFragment': JobPostingFormQualifications_PostingFragment;'JobPostingFormAdditional_PostingFragment': JobPostingFormAdditional_PostingFragment } }
) & { ' $fragmentName'?: 'JobPostingForm_PostingFragment' };

export type JobPostingFormQualifications_PostingFragment = { __typename?: 'job_posting', id: any, bcbe: boolean | null, experience: number | null, currentLicense: boolean | null, expReq: boolean | null, boardCerts: Array<{ __typename?: 'posting_board_cert', id: any, cert: { __typename?: 'board_cert', id: any, field: string, fieldType: any, board: { __typename?: 'board', id: any, name: string } } }>, appCerts: Array<{ __typename?: 'posting_app_cert', id: any, name: string }> } & { ' $fragmentName'?: 'JobPostingFormQualifications_PostingFragment' };

export type ClinicianSignupStep_RegisterClinicianMutationVariables = Exact<{
  input: RegisterClinicianInput;
}>;


export type ClinicianSignupStep_RegisterClinicianMutation = { __typename?: 'mutation_root', signup: { __typename?: 'RegisterClinicianResult', access: string, refresh: string } };

export type OrgSignupForm_SearchOrgsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type OrgSignupForm_SearchOrgsQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: { __typename?: 'organization', id: any, name: string, domainSignups: boolean, domains: Array<{ __typename?: 'org_domain', id: any, name: string }> } | null }> };

export type OrgSignupForm_SelectedOrgQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type OrgSignupForm_SelectedOrgQuery = { __typename?: 'query_root', org: { __typename?: 'organization', id: any, name: string } | null };

export type OrganizationSignupStep_SignUpOrgUserMutationVariables = Exact<{
  input: SignUpOrgUserInput;
}>;


export type OrganizationSignupStep_SignUpOrgUserMutation = { __typename?: 'mutation_root', registration: { __typename?: 'SuccessResult', success: boolean } };

export type AppCerts_GetAppCertificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppCerts_GetAppCertificationsQuery = { __typename?: 'query_root', appCerts: Array<{ __typename?: 'AppCert', name: string, degrees: Array<string> }> };

export type BoardCerts_GetBoardCertificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type BoardCerts_GetBoardCertificationsQuery = { __typename?: 'query_root', boardCerts: Array<{ __typename?: 'board_cert', id: any, field: string, fieldType: any, board: { __typename?: 'board', id: any, name: string } }> };

export type ClinicianSearch_ImportCredentialsMutationVariables = Exact<{
  fid: Scalars['String'];
}>;


export type ClinicianSearch_ImportCredentialsMutation = { __typename?: 'mutation_root', importCreds: { __typename?: 'ImportCredentialsResult', clinician: (
      { __typename?: 'clinician', id: any }
      & { ' $fragmentRefs'?: { 'ProfileCompleteForm_ClinicianFragment': ProfileCompleteForm_ClinicianFragment } }
    ) | null } };

export type ClinicianSearch_UnlinkCredentialsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClinicianSearch_UnlinkCredentialsMutation = { __typename?: 'mutation_root', unlinkCreds: { __typename?: 'UnlinkCredentialsResult', clinician: { __typename?: 'clinician', id: any, fsmbBio: { __typename?: 'fsmb_bio', fid: string } | null } | null } };

export type ClinicianSearch_FsmbBioFragment = { __typename?: 'fsmb_bio', fid: string, npi: string, city: string, state: string, firstName: string, middleName: string, lastName: string, cred: string, school: string, gradYr: number | null, cmsSpecialties: Array<{ __typename?: 'cms_specialty', id: any, specialty: string, primary: boolean }>, licenses: Array<{ __typename?: 'fsmb_licensure', id: any, state: string }> } & { ' $fragmentName'?: 'ClinicianSearch_FsmbBioFragment' };

export type ClinicianSearch_SearchFsmbQueryVariables = Exact<{
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  profDegree: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ClinicianSearch_SearchFsmbQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_fsmb_bio_result', fid: string | null, fsmbBio: (
      { __typename?: 'fsmb_bio', fid: string }
      & { ' $fragmentRefs'?: { 'ClinicianSearch_FsmbBioFragment': ClinicianSearch_FsmbBioFragment } }
    ) | null }>, agg: { __typename?: 'search_fsmb_bio_result_aggregate', aggregate: { __typename?: 'search_fsmb_bio_result_aggregate_fields', count: number } | null } };

export type Experience_GetSpecialtiesQueryVariables = Exact<{ [key: string]: never; }>;


export type Experience_GetSpecialtiesQuery = { __typename?: 'query_root', specialties: Array<{ __typename?: 'MedicareSpecialty', name: string }> };

export type Residency_SearchTrainingProgramsQueryVariables = Exact<{
  search: Scalars['String'];
  training: Scalars['trainingtype'];
  fieldName: Scalars['String'];
}>;


export type Residency_SearchTrainingProgramsQuery = { __typename?: 'query_root', programs: Array<{ __typename?: 'training_program', id: any, name: string, city: string, state: string }> };

export type Residency_GetTrainingSpecialtiesQueryVariables = Exact<{ [key: string]: never; }>;


export type Residency_GetTrainingSpecialtiesQuery = { __typename?: 'query_root', specialties: Array<{ __typename?: 'TrainingSpecialty', name: string, training: string }>, fields: Array<{ __typename?: 'training_field', id: any, name: string, training: any }> };

export type School_SearchSchoolsQueryVariables = Exact<{
  search: Scalars['String'];
  profDegree: Scalars['professionaldegree'];
}>;


export type School_SearchSchoolsQuery = { __typename?: 'query_root', schools: Array<{ __typename?: 'school', id: any, name: string, prof_degree: any }> };

export type Specialty_GetSpecialtiesQueryVariables = Exact<{ [key: string]: never; }>;


export type Specialty_GetSpecialtiesQuery = { __typename?: 'query_root', specialties: Array<{ __typename?: 'MedicareSpecialty', name: string }> };

export type SkillsStep_ClinicianSkillsFragment = { __typename?: 'clinician', id: any, skillEkgInterpret: boolean, skillEkgStemi: boolean, skillEyeFb: boolean, skillEarFb: boolean, skillWoundRepair: boolean, skillOral: boolean, skillPeds: boolean, skillFractureBlocks: boolean, skillJointReduction: boolean, skillNeonates: boolean, skillObgyn: boolean, skillIntubation: boolean, skillChestTube: boolean, skillChestNeedle: boolean, skillVenous: boolean, skillIOAccess: boolean, skillLumbar: boolean, skillSedation: boolean, skillUSDiagnostics: boolean, skillUSProcedures: boolean } & { ' $fragmentName'?: 'SkillsStep_ClinicianSkillsFragment' };

export type ProfileCompleteForm_ClinicianFragment = { __typename?: 'clinician', id: any, fid: string | null, creds: string, isAPP: boolean, profileComplete: boolean, profDegree: any, schoolName: string, gradYr: number | null, currStudent: boolean, skillEkgInterpret: boolean, skillEkgStemi: boolean, skillEyeFb: boolean, skillEarFb: boolean, skillWoundRepair: boolean, skillOral: boolean, skillPeds: boolean, skillFractureBlocks: boolean, skillJointReduction: boolean, skillNeonates: boolean, skillObgyn: boolean, skillIntubation: boolean, skillChestTube: boolean, skillChestNeedle: boolean, skillVenous: boolean, skillIOAccess: boolean, skillLumbar: boolean, skillSedation: boolean, skillUSDiagnostics: boolean, skillUSProcedures: boolean, cv: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null, specialties: Array<{ __typename?: 'clinician_specialty', id: any, primary: boolean, name: string }>, licenses: Array<{ __typename?: 'clinician_license', id: any, state: string }>, fsmbBio: (
    { __typename?: 'fsmb_bio' }
    & { ' $fragmentRefs'?: { 'ClinicianSearch_FsmbBioFragment': ClinicianSearch_FsmbBioFragment } }
  ) | null, training: Array<{ __typename?: 'clinician_training', id: any, program: string, field: string, present: boolean, type: any, startYear: number, endYear: number | null }>, appCerts: Array<{ __typename?: 'clinician_app_cert', id: any, name: string }>, boardCerts: Array<{ __typename?: 'clinician_board_cert', id: any, eligible: boolean, cert: { __typename?: 'board_cert', id: any, field: string, board: { __typename?: 'board', id: any, name: string } } }>, spExp: Array<{ __typename?: 'clinician_sp_exp', id: any, field: string, level: any }>, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } } & { ' $fragmentName'?: 'ProfileCompleteForm_ClinicianFragment' };

export type ProfileCompleteForm_UpdateProfileSkillsMutationVariables = Exact<{
  clinicianId: Scalars['uuid'];
  input: Clinician_Set_Input;
}>;


export type ProfileCompleteForm_UpdateProfileSkillsMutation = { __typename?: 'mutation_root', update_clinician_by_pk: { __typename?: 'clinician', id: any } | null };

export type ProfileCompleteForm_UpdateProfileMutationVariables = Exact<{
  clinicianId: Scalars['uuid'];
  specialties: Array<Clinician_Specialty_Insert_Input> | Clinician_Specialty_Insert_Input;
  creds: Scalars['String'];
  cvId: Scalars['uuid'];
  pictureId: Scalars['uuid'];
  appCerts: Array<Clinician_App_Cert_Insert_Input> | Clinician_App_Cert_Insert_Input;
  spExp: Array<Clinician_Sp_Exp_Insert_Input> | Clinician_Sp_Exp_Insert_Input;
  boardCerts: Array<Clinician_Board_Cert_Insert_Input> | Clinician_Board_Cert_Insert_Input;
  licenses: Array<Clinician_License_Insert_Input> | Clinician_License_Insert_Input;
  training: Array<Clinician_Training_Insert_Input> | Clinician_Training_Insert_Input;
  schoolName: Scalars['String'];
  gradYr?: InputMaybe<Scalars['Int']>;
}>;


export type ProfileCompleteForm_UpdateProfileMutation = { __typename?: 'mutation_root', delete_clinician_specialty: { __typename?: 'clinician_specialty_mutation_response', returning: Array<{ __typename?: 'clinician_specialty', id: any }> } | null, insert_clinician_specialty: { __typename?: 'clinician_specialty_mutation_response', returning: Array<{ __typename?: 'clinician_specialty', id: any }> } | null, delete_clinician_app_cert: { __typename?: 'clinician_app_cert_mutation_response', returning: Array<{ __typename?: 'clinician_app_cert', id: any }> } | null, insert_clinician_app_cert: { __typename?: 'clinician_app_cert_mutation_response', returning: Array<{ __typename?: 'clinician_app_cert', id: any }> } | null, delete_clinician_sp_exp: { __typename?: 'clinician_sp_exp_mutation_response', returning: Array<{ __typename?: 'clinician_sp_exp', id: any }> } | null, insert_clinician_sp_exp: { __typename?: 'clinician_sp_exp_mutation_response', returning: Array<{ __typename?: 'clinician_sp_exp', id: any }> } | null, delete_clinician_board_cert: { __typename?: 'clinician_board_cert_mutation_response', returning: Array<{ __typename?: 'clinician_board_cert', id: any }> } | null, insert_clinician_board_cert: { __typename?: 'clinician_board_cert_mutation_response', returning: Array<{ __typename?: 'clinician_board_cert', id: any }> } | null, delete_clinician_license: { __typename?: 'clinician_license_mutation_response', returning: Array<{ __typename?: 'clinician_license', id: any }> } | null, insert_clinician_license: { __typename?: 'clinician_license_mutation_response', returning: Array<{ __typename?: 'clinician_license', id: any }> } | null, delete_clinician_training: { __typename?: 'clinician_training_mutation_response', returning: Array<{ __typename?: 'clinician_training', id: any }> } | null, insert_clinician_training: { __typename?: 'clinician_training_mutation_response', returning: Array<{ __typename?: 'clinician_training', id: any }> } | null, update_clinician_by_pk: { __typename?: 'clinician', id: any, profileComplete: boolean } | null, update_current_account: { __typename?: 'current_account_mutation_response', returning: Array<{ __typename?: 'current_account', id: any | null }> } | null };

export type Employer_SearchOrganizationQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type Employer_SearchOrganizationQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: { __typename?: 'organization', id: any, name: string } | null }> };

export type ReviewForm_CreateReviewMutationVariables = Exact<{
  input: Review_Insert_Input;
}>;


export type ReviewForm_CreateReviewMutation = { __typename?: 'mutation_root', insert_review_one: { __typename?: 'review', id: any } | null };

export type SalaryReportFormGeneralStep_FacilityFragment = { __typename?: 'facility', id: any, name: string } & { ' $fragmentName'?: 'SalaryReportFormGeneralStep_FacilityFragment' };

export type SalaryReportFormGeneralStep_OrganizationFragment = { __typename?: 'organization', id: any, name: string } & { ' $fragmentName'?: 'SalaryReportFormGeneralStep_OrganizationFragment' };

export type SalaryReportFormGeneralStep_SearchOrgsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SalaryReportFormGeneralStep_SearchOrgsQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: (
      { __typename?: 'organization', id: any }
      & { ' $fragmentRefs'?: { 'SalaryReportFormGeneralStep_OrganizationFragment': SalaryReportFormGeneralStep_OrganizationFragment } }
    ) | null }> };

export type FacilitySelect_FacilityFragment = { __typename?: 'facility', id: any, name: string, city: string, state: string } & { ' $fragmentName'?: 'FacilitySelect_FacilityFragment' };

export type FacilitySelect_SearchFacilityQueryVariables = Exact<{
  search: Scalars['String'];
  preload?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Search_Facility_By_Prefix_Result_Bool_Exp>;
}>;


export type FacilitySelect_SearchFacilityQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_facility_by_prefix_result', id: any | null, facility: (
      { __typename?: 'facility', id: any }
      & { ' $fragmentRefs'?: { 'FacilitySelect_FacilityFragment': FacilitySelect_FacilityFragment } }
    ) | null }> };

export type FileUpload_FileFragment = { __typename?: 'file', id: any, filename: string, publicUrl: string } & { ' $fragmentName'?: 'FileUpload_FileFragment' };

export type FileUpload_CreateFileMutationVariables = Exact<{
  filename: Scalars['String'];
  contentType: Scalars['String'];
  origin: Scalars['String'];
}>;


export type FileUpload_CreateFileMutation = { __typename?: 'mutation_root', created: { __typename?: 'CreateFileResult', id: string, uploadUrl: string, file: (
      { __typename?: 'file', id: any }
      & { ' $fragmentRefs'?: { 'FileUpload_FileFragment': FileUpload_FileFragment } }
    ) | null } };

export type FileUpload_FinalizeFileMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type FileUpload_FinalizeFileMutation = { __typename?: 'mutation_root', finalized: { __typename?: 'FinalizeFileResult', id: string, file: (
      { __typename?: 'file', id: any }
      & { ' $fragmentRefs'?: { 'FileUpload_FileFragment': FileUpload_FileFragment } }
    ) | null } };

export type ReviewCard_ReviewFragment = { __typename?: 'review', id: any, active: boolean, visible: boolean, createdAt: any, currentlyWorking: boolean, ratingFacility: number, ratingJob: number, ratingOrg: number, mostHelpful: boolean | null, lastWorkedDate: any | null, employmentDate: any, selfReview: boolean | null, hasActiveContract: boolean | null, reporterName: string | null, facilityContent: string, orgContent: string, facility: { __typename?: 'facility', id: any, slug: string, name: string }, org: { __typename?: 'organization', id: any, name: string, slug: string }, replies: Array<{ __typename?: 'review_reply', id: any, content: string, createdAt: any, isOrgResponse: boolean | null, reporterName: string | null, selfReply: boolean | null }>, votes?: Array<{ __typename?: 'review_vote', id: any, value: number }>, votes_agg: { __typename?: 'review_vote_aggregate', aggregate: { __typename?: 'review_vote_aggregate_fields', count: number, sum: { __typename?: 'review_vote_sum_fields', value: number | null } | null } | null }, replies_agg: { __typename?: 'review_reply_aggregate', aggregate: { __typename?: 'review_reply_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'ReviewCard_ReviewFragment' };

export type AddFacilityPopup_InviteNewRecruiterMutationVariables = Exact<{
  input: InviteOrgUserInput;
}>;


export type AddFacilityPopup_InviteNewRecruiterMutation = { __typename?: 'mutation_root', invite: { __typename?: 'InviteOrgUserResult', success: boolean, accountId: string } };

export type AddFacilityPopup_RequestFacilityMutationVariables = Exact<{
  facilityId: Scalars['uuid'];
  recruiterId: Scalars['uuid'];
  orgId: Scalars['uuid'];
}>;


export type AddFacilityPopup_RequestFacilityMutation = { __typename?: 'mutation_root', update: { __typename?: 'facility_contract_mutation_response', returning: Array<{ __typename?: 'facility_contract', id: any, change_request: any | null, recruiter_id: any }> } | null, insert: { __typename?: 'facility_contract', id: any, facility_id: any, recruiter_id: any, change_request: any | null, active: boolean, org_id: any } | null };

export type AddFacilityPopup_RecruiterFragment = (
  { __typename?: 'org_user' }
  & { ' $fragmentRefs'?: { 'FacilityRecruiterForm_RecruiterFragment': FacilityRecruiterForm_RecruiterFragment } }
) & { ' $fragmentName'?: 'AddFacilityPopup_RecruiterFragment' };

export type AddFacilityPopup_OrganizationFragment = { __typename?: 'organization', id: any, defaultRecruiter: (
    { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, fullName: string | null } | null } }
    & { ' $fragmentRefs'?: { 'FacilityRecruiterForm_RecruiterFragment': FacilityRecruiterForm_RecruiterFragment } }
  ) | null } & { ' $fragmentName'?: 'AddFacilityPopup_OrganizationFragment' };

export type AddFacilityPopup_GetOrgAndRecruiterQueryVariables = Exact<{
  accountId: Scalars['uuid'];
  orgId: Scalars['uuid'];
}>;


export type AddFacilityPopup_GetOrgAndRecruiterQuery = { __typename?: 'query_root', org: (
    { __typename?: 'organization', id: any }
    & { ' $fragmentRefs'?: { 'AddFacilityPopup_OrganizationFragment': AddFacilityPopup_OrganizationFragment } }
  ) | null, recruiter: (
    { __typename?: 'org_user', id: any }
    & { ' $fragmentRefs'?: { 'AddFacilityPopup_RecruiterFragment': AddFacilityPopup_RecruiterFragment } }
  ) | null };

export type FindFacility_SearchQueryVariables = Exact<{
  search: Scalars['String'];
  orgId: Scalars['uuid'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FindFacility_SearchQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_facility_by_prefix_result', id: any | null, facility: { __typename?: 'facility', id: any, name: string, city: string, state: string, contracts: Array<{ __typename?: 'facility_contract', id: any, active: boolean, pendingOrActive: boolean, changeRequest: any | null }> } | null }>, agg: { __typename?: 'search_facility_by_prefix_result_aggregate', aggregate: { __typename?: 'search_facility_by_prefix_result_aggregate_fields', count: number } | null } };

export type AddOrgUserPopup_InviteOrgUserMutationVariables = Exact<{
  input: InviteOrgUserInput;
}>;


export type AddOrgUserPopup_InviteOrgUserMutation = { __typename?: 'mutation_root', invite_org_user: { __typename?: 'InviteOrgUserResult', success: boolean } };

export type ApplyToJobButton_ContractFragment = (
  { __typename?: 'facility_contract', id: any, active: boolean, lastAppliedDate: any | null, lastApplied: any | null, org: { __typename?: 'organization', id: any, active: boolean } }
  & { ' $fragmentRefs'?: { 'ApplyToJobPopup_ContractFragment': ApplyToJobPopup_ContractFragment } }
) & { ' $fragmentName'?: 'ApplyToJobButton_ContractFragment' };

export type AllAddOnsPopup_ApplyMutationVariables = Exact<{
  contractIds: Array<Scalars['String']> | Scalars['String'];
  postingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AllAddOnsPopup_ApplyMutation = { __typename?: 'mutation_root', apply_to_jobs: { __typename?: 'SuccessResult', success: boolean } };

export type ApplyToJobPopup_ExistingBatchesAndCvQueryVariables = Exact<{
  accountId: Scalars['uuid'];
  recruiterIds: Array<Scalars['uuid']> | Scalars['uuid'];
  cutoff: Scalars['timestamp'];
}>;


export type ApplyToJobPopup_ExistingBatchesAndCvQuery = { __typename?: 'query_root', jobAppBatches: Array<{ __typename?: 'job_application_batch', id: any, recruiterId: any }>, clinician: { __typename?: 'clinician', id: any, cv: (
      { __typename?: 'file', id: any }
      & { ' $fragmentRefs'?: { 'FileUpload_FileFragment': FileUpload_FileFragment } }
    ) | null } | null, prevBatch: Array<{ __typename?: 'job_application_batch', id: any, intro: string }> };

export type ApplyToJobPopup_ContractFragment = { __typename?: 'facility_contract', id: any, facility: { __typename?: 'facility', id: any, name: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, org: { __typename?: 'organization', id: any, name: string }, recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null } } } & { ' $fragmentName'?: 'ApplyToJobPopup_ContractFragment' };

export type ApplyToJobPopup_PostingFragment = { __typename?: 'job_posting', id: any } & { ' $fragmentName'?: 'ApplyToJobPopup_PostingFragment' };

export type ApplyToJobPopup_ApplyMutationVariables = Exact<{
  contractIds: Array<Scalars['String']> | Scalars['String'];
  postingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  intro?: InputMaybe<Scalars['String']>;
}>;


export type ApplyToJobPopup_ApplyMutation = { __typename?: 'mutation_root', apply_to_jobs: { __typename?: 'SuccessResult', success: boolean } };

export type ApplyToJobPopup_UploadCvMutationVariables = Exact<{
  clinicianId: Scalars['uuid'];
  cvId: Scalars['uuid'];
}>;


export type ApplyToJobPopup_UploadCvMutation = { __typename?: 'mutation_root', update_clinician_by_pk: { __typename?: 'clinician', id: any, cv: (
      { __typename?: 'file', id: any }
      & { ' $fragmentRefs'?: { 'FileUpload_FileFragment': FileUpload_FileFragment } }
    ) | null } | null };

export type ChangePostingStatusPopup_PostingFragment = { __typename?: 'job_posting', id: any, active: boolean } & { ' $fragmentName'?: 'ChangePostingStatusPopup_PostingFragment' };

export type ChangePostingStatusPopup_UpdateStatusMutationVariables = Exact<{
  postingId: Scalars['uuid'];
  active: Scalars['Boolean'];
  expirationDate?: InputMaybe<Scalars['date']>;
}>;


export type ChangePostingStatusPopup_UpdateStatusMutation = { __typename?: 'mutation_root', update_job_posting_by_pk: (
    { __typename?: 'job_posting', id: any }
    & { ' $fragmentRefs'?: { 'ChangePostingStatusPopup_PostingFragment': ChangePostingStatusPopup_PostingFragment } }
  ) | null };

export type ClinicianProfile_ClinicianFragment = (
  { __typename?: 'clinician', id: any, fid: string | null, npi: string, creds: string, isAPP: boolean, profileComplete: boolean, profDegree: any, schoolName: string, gradYr: number | null, currStudent: boolean, cv: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null, specialties: Array<{ __typename?: 'clinician_specialty', id: any, primary: boolean, name: string }>, licenses: Array<{ __typename?: 'clinician_license', id: any, state: string }>, fsmb: { __typename?: 'fsmb_bio', fid: string, boardAction: boolean, licenses: Array<{ __typename?: 'fsmb_licensure', id: any, state: string, entity: string, issue: any | null, expiry: any | null, licenseNo: string }> } | null, training: Array<{ __typename?: 'clinician_training', id: any, program: string, field: string, present: boolean, type: any, startYear: number, endYear: number | null }>, appCerts: Array<{ __typename?: 'clinician_app_cert', id: any, name: string }>, boardCerts: Array<{ __typename?: 'clinician_board_cert', id: any, eligible: boolean, cert: { __typename?: 'board_cert', id: any, field: string, board: { __typename?: 'board', id: any, name: string } } }>, spExp: Array<{ __typename?: 'clinician_sp_exp', id: any, field: string, level: any }>, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } }
  & { ' $fragmentRefs'?: { 'SkillsStep_ClinicianSkillsFragment': SkillsStep_ClinicianSkillsFragment;'ClinicianAvatar_ClinicianFragment': ClinicianAvatar_ClinicianFragment } }
) & { ' $fragmentName'?: 'ClinicianProfile_ClinicianFragment' };

export type ClinicianProfile_JobApplicationFragment = { __typename?: 'job_application', id: any, createdAtDate: any, createdAt: any, contract: { __typename?: 'facility_contract', id: any, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null } } } & { ' $fragmentName'?: 'ClinicianProfile_JobApplicationFragment' };

export type ConfirmEmailPopup_ConfirmedEmailSubscriptionVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type ConfirmEmailPopup_ConfirmedEmailSubscription = { __typename?: 'subscription_root', accounts: Array<{ __typename?: 'current_account', id: any | null, ci: { __typename?: 'contact_info', id: any | null, confirmedEmail: boolean | null, confirmationSentAt: any | null } | null }> };

export type ConfirmEmailPopup_ResendVerificationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ConfirmEmailPopup_ResendVerificationMutation = { __typename?: 'mutation_root', resend: { __typename?: 'SuccessResult', success: boolean } };

export type ResendVerification_ResendMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendVerification_ResendMutation = { __typename?: 'mutation_root', resend: { __typename?: 'SuccessResult', success: boolean } };

export type DeactivateOrgUserPopup_OrgUserFragment = { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, fullName: string | null } | null } } & { ' $fragmentName'?: 'DeactivateOrgUserPopup_OrgUserFragment' };

export type DeactivateOrgUserPopup_RecruiterContractsQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type DeactivateOrgUserPopup_RecruiterContractsQuery = { __typename?: 'query_root', aggPendingOrActive: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null }, aggPendingRemoval: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null } };

export type DeactivateOrgUserPopup_DeactivateMutationVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type DeactivateOrgUserPopup_DeactivateMutation = { __typename?: 'mutation_root', update_access_info: { __typename?: 'access_info_mutation_response', returning: Array<{ __typename?: 'access_info', id: any | null, active: boolean | null }> } | null };

export type EditEmployerProfilePopup_OrganizationProfileQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type EditEmployerProfilePopup_OrganizationProfileQuery = { __typename?: 'query_root', org: (
    { __typename?: 'organization', id: any }
    & { ' $fragmentRefs'?: { 'EditEmployerProfileForm_OrganizationFragment': EditEmployerProfileForm_OrganizationFragment } }
  ) | null };

export type EditOrgUserPopup_OrgUserFragment = { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null } | null, roles: Array<{ __typename?: 'account_role', id: any, role: any }> } } & { ' $fragmentName'?: 'EditOrgUserPopup_OrgUserFragment' };

export type EditOrgUserPopup_UpdateOrgUserMutationVariables = Exact<{
  orgUserId: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type EditOrgUserPopup_UpdateOrgUserMutation = { __typename?: 'mutation_root', update_personal_info: { __typename?: 'personal_info_mutation_response', returning: Array<{ __typename?: 'personal_info', id: any | null, first_name: string | null, last_name: string | null }> } | null };

export type UpdateOrgUserPopup_AddOrgAdminOrgUserMutationVariables = Exact<{
  role: Scalars['role'];
  orgUserId: Scalars['uuid'];
}>;


export type UpdateOrgUserPopup_AddOrgAdminOrgUserMutation = { __typename?: 'mutation_root', insert_account_role_one: { __typename?: 'account_role', id: any } | null };

export type UpdateOrgUserPopup_RemoveOrgAdminOrgUserMutationVariables = Exact<{
  orgUserId: Scalars['uuid'];
}>;


export type UpdateOrgUserPopup_RemoveOrgAdminOrgUserMutation = { __typename?: 'mutation_root', delete_account_role: { __typename?: 'account_role_mutation_response', returning: Array<{ __typename?: 'account_role', id: any }> } | null };

export type EditRecruiterPopup_ContractFragment = { __typename?: 'facility_contract', id: any, recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null } }, org: { __typename?: 'organization', id: any, defaultRecruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, fullName: string | null } | null } } | null } } & { ' $fragmentName'?: 'EditRecruiterPopup_ContractFragment' };

export type EditRecruiterPopup_InviteNewRecruiterMutationVariables = Exact<{
  input: InviteOrgUserInput;
}>;


export type EditRecruiterPopup_InviteNewRecruiterMutation = { __typename?: 'mutation_root', invite: { __typename?: 'InviteOrgUserResult', success: boolean, accountId: string } };

export type EditRecruiterPopup_UpdateBatchRecruiterMutationVariables = Exact<{
  contractIds: Array<Scalars['uuid']> | Scalars['uuid'];
  recruiterId: Scalars['uuid'];
}>;


export type EditRecruiterPopup_UpdateBatchRecruiterMutation = { __typename?: 'mutation_root', contracts: { __typename?: 'facility_contract_mutation_response', returning: Array<{ __typename?: 'facility_contract', id: any, recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null } | null } } }> } | null };

export type EmployerInfo_ContractFragment = (
  { __typename?: 'facility_contract', id: any, active: boolean, isOwner: boolean | null, org: { __typename?: 'organization', id: any, name: string, ownershipStructure: any | null }, recruiter: { __typename?: 'org_user', id: any, account: (
      { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null }
      & { ' $fragmentRefs'?: { 'AccountAvatar_AccountFragment': AccountAvatar_AccountFragment } }
    ) } }
  & { ' $fragmentRefs'?: { 'EditRecruiterPopup_ContractFragment': EditRecruiterPopup_ContractFragment;'ApplyToJobButton_ContractFragment': ApplyToJobButton_ContractFragment } }
) & { ' $fragmentName'?: 'EmployerInfo_ContractFragment' };

export type EmployerCard_EmployerInfoFragment = { __typename?: 'org_market', id: any | null, numEDs: any | null, numFreestandingEDs: any | null, numResidencyEDs: any | null, edCoverage: any | null, org: { __typename?: 'organization', id: any, name: string, slug: string, ownershipStructure: any | null, logo: { __typename?: 'file', id: any, publicUrl: string } | null } | null } & { ' $fragmentName'?: 'EmployerCard_EmployerInfoFragment' };

export type EmployerList_SearchEmployersQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<Search_Org_Market_Result_Order_By> | Search_Org_Market_Result_Order_By>;
  search: Scalars['String'];
}>;


export type EmployerList_SearchEmployersQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_org_market_result', id: any, market: (
      { __typename?: 'org_market', id: any | null, org: { __typename?: 'organization', id: any, slug: string } | null }
      & { ' $fragmentRefs'?: { 'EmployerCard_EmployerInfoFragment': EmployerCard_EmployerInfoFragment;'EmployerTable_EmployerInfoFragment': EmployerTable_EmployerInfoFragment } }
    ) | null }>, agg: { __typename?: 'search_org_market_result_aggregate', aggregate: { __typename?: 'search_org_market_result_aggregate_fields', count: number } | null } };

export type EmployerTable_EmployerInfoFragment = { __typename?: 'org_market', id: any | null, numEDs: any | null, numFreestandingEDs: any | null, numResidencyEDs: any | null, edCoverage: any | null, org: { __typename?: 'organization', id: any, name: string, slug: string, ownershipStructure: any | null, logo: { __typename?: 'file', id: any, publicUrl: string } | null } | null } & { ' $fragmentName'?: 'EmployerTable_EmployerInfoFragment' };

export type FacilityCard_FacilityFragment = { __typename?: 'facility', id: any, name: string, slug: string, facilityType: string, location: any | null, city: string, state: string, immediateNeeds: boolean, adultTraumaLvl: number | null, freestandingEr: boolean, numPostings: number | null, featured: boolean | null, picture: { __typename?: 'file', publicUrl: string } | null, residencies: Array<{ __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string } }> | null, cmsFacilityPos: { __typename?: 'cms_facility_pos', id: string, providerSubtype: string } | null, cmsFacilityEnrollment: { __typename?: 'cms_facility_enrollment', id: string, providerTypeCode: string } | null, cmsFacility: { __typename?: 'cms_facility', id: string, hospitalType: string, metrics: Array<{ __typename?: 'cms_facility_metric', id: any, score: string | null, measureId: string }>, facilities: Array<{ __typename?: 'facility', id: any, name: string }> } | null, ahaFacility: { __typename?: 'AS22DEM', rollups: Array<string>, id: string, units: Array<{ __typename?: 'AS22UNIT', id: string, name: string, par: { __typename?: 'AS22DEM', id: string, name: string | null } }> } | null, maxRatePosting: Array<{ __typename?: 'job_posting', id: any, slug: string, title: string, wageTrunc: string, hasRate: boolean, ratePeriod: any | null, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, normRate: number | null }> | null, contracts: Array<{ __typename?: 'facility_contract', id: any, org: { __typename?: 'organization', id: any, name: string } }>, reviewAgg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', rating: number | null } | null } | null } } & { ' $fragmentName'?: 'FacilityCard_FacilityFragment' };

export type FacilitySearchInput_SearchQueryVariables = Exact<{
  search: Scalars['String'];
  limit: Scalars['Int'];
  includeFacilities: Scalars['Boolean'];
  includeOrgs: Scalars['Boolean'];
  includeResidencies: Scalars['Boolean'];
  includeClerkships: Scalars['Boolean'];
  includeFellowships: Scalars['Boolean'];
}>;


export type FacilitySearchInput_SearchQuery = { __typename?: 'query_root', facilities: Array<{ __typename?: 'search_facility_by_prefix_result', id: any | null, facility: { __typename?: 'facility', id: any, slug: string, name: string, city: string, state: string } | null }>, orgs: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: { __typename?: 'organization', id: any, name: string, slug: string } | null }>, residencies: Array<{ __typename?: 'search_training_by_prefix_result', id: any | null, training: { __typename?: 'training', id: any, name: string, slug: string, residency: { __typename?: 'residency', latestSurvey: { __typename?: 'latest_residency_survey', survey: { __typename?: 'residency_survey', trainingSurvey: { __typename?: 'training_survey', city: string, state: string } } | null } | null } | null } | null }>, clerkships: Array<{ __typename?: 'search_training_by_prefix_result', id: any | null, training: { __typename?: 'training', id: any, name: string, slug: string, clerkship: { __typename?: 'clerkship', latestSurvey: { __typename?: 'latest_clerkship_survey', survey: { __typename?: 'clerkship_survey', trainingSurvey: { __typename?: 'training_survey', city: string, state: string } } | null } | null } | null } | null }>, fellowships: Array<{ __typename?: 'search_training_by_prefix_result', id: any | null, training: { __typename?: 'training', id: any, name: string, slug: string, fellowship: { __typename?: 'fellowship', latestSurvey: { __typename?: 'latest_fellowship_survey', survey: { __typename?: 'fellowship_survey', trainingSurvey: { __typename?: 'training_survey', city: string, state: string } } | null } | null } | null } | null }> };

export type FacilitySearchInput_GmapLinkQueryVariables = Exact<{
  placeId: Scalars['String'];
}>;


export type FacilitySearchInput_GmapLinkQuery = { __typename?: 'query_root', gmapsLink: Array<{ __typename?: 'gmaps_link', id: any, slug: string, viewport: any, label: string, center: any, gmapsPlace: { __typename?: 'gmaps_place', id: string, geocodePublic: any | null, geocodeShortName: string | null, boundaries: Array<{ __typename?: 'place_boundary', id: any }> } }> };

export type FacilitySuggestions_RankedFacilityFragment = { __typename?: 'ranked_facility', id: any | null, distance: any | null, facility: (
    { __typename?: 'facility' }
    & { ' $fragmentRefs'?: { 'FacilityCard_FacilityFragment': FacilityCard_FacilityFragment } }
  ) | null } & { ' $fragmentName'?: 'FacilitySuggestions_RankedFacilityFragment' };

export type BaseMap_BoundaryQueryVariables = Exact<{
  boundaryId: Scalars['uuid'];
}>;


export type BaseMap_BoundaryQuery = { __typename?: 'query_root', boundary: { __typename?: 'place_boundary', id: any, boundaryGeoJson: string | null } | null };

export type Map_GmapLinkQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type Map_GmapLinkQuery = { __typename?: 'query_root', gmapsLink: Array<{ __typename?: 'gmaps_link', id: any, center: any, label: string, slug: string, viewport: any, gmapsPlaceId: string, gmapsPlace: { __typename?: 'gmaps_place', id: string, geocodePublic: any | null, geocodeShortName: string | null, boundaries: Array<{ __typename?: 'place_boundary', id: any }> } }> };

export type SearchInstructions_HideMutationVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type SearchInstructions_HideMutation = { __typename?: 'mutation_root', update_current_account: { __typename?: 'current_account_mutation_response', returning: Array<{ __typename?: 'current_account', id: any | null, hide_search_instructions: boolean | null }> } | null };

export type OnboardingPopup_CheckOrgSignupStatusMutationVariables = Exact<{
  email: Scalars['String'];
  orgId: Scalars['String'];
  sendVerification: Scalars['Boolean'];
}>;


export type OnboardingPopup_CheckOrgSignupStatusMutation = { __typename?: 'mutation_root', signupStatus: { __typename?: 'CheckOrgUserSignupStatusResult', status: string, description: string, firstName: string | null, lastName: string | null } };

export type ProfileCompletePopup_ClinicianProfileQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type ProfileCompletePopup_ClinicianProfileQuery = { __typename?: 'query_root', clinician: (
    { __typename?: 'clinician', id: any }
    & { ' $fragmentRefs'?: { 'ProfileCompleteForm_ClinicianFragment': ProfileCompleteForm_ClinicianFragment } }
  ) | null };

export type RemoveFacilityPopup_RequestContractDeactivationMutationVariables = Exact<{
  contractIds: Array<Scalars['uuid']> | Scalars['uuid'];
  accountId: Scalars['uuid'];
}>;


export type RemoveFacilityPopup_RequestContractDeactivationMutation = { __typename?: 'mutation_root', updatePending: { __typename?: 'facility_contract_mutation_response', returning: Array<{ __typename?: 'facility_contract', id: any, change_request: any | null }> } | null, updateActive: { __typename?: 'facility_contract_mutation_response', returning: Array<{ __typename?: 'facility_contract', id: any, change_request: any | null }> } | null };

export type ReviewList_CreateReviewReportMutationVariables = Exact<{
  input: Review_Report_Insert_Input;
}>;


export type ReviewList_CreateReviewReportMutation = { __typename?: 'mutation_root', insert_review_report_one: { __typename?: 'review_report', id: any } | null };

export type ReviewList_SearchReviewQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<Review_Order_By> | Review_Order_By>;
  filters: Review_Bool_Exp;
  accountId?: InputMaybe<Scalars['uuid']>;
  isClinician: Scalars['Boolean'];
}>;


export type ReviewList_SearchReviewQuery = { __typename?: 'query_root', reviews: Array<(
    { __typename?: 'review', id: any, visible: boolean, orgId: any, selfReview: boolean | null }
    & { ' $fragmentRefs'?: { 'ReviewCard_ReviewFragment': ReviewCard_ReviewFragment } }
  )>, agg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number } | null } };

export type ReviewList_UpdateReviewMutationVariables = Exact<{
  reviewId: Scalars['uuid'];
  active: Scalars['Boolean'];
}>;


export type ReviewList_UpdateReviewMutation = { __typename?: 'mutation_root', update_review_by_pk: { __typename?: 'review', id: any, active: boolean } | null };

export type ReviewList_CreateReviewVoteMutationVariables = Exact<{
  reviewId: Scalars['uuid'];
  value?: InputMaybe<Scalars['Int']>;
}>;


export type ReviewList_CreateReviewVoteMutation = { __typename?: 'mutation_root', insert_review_vote_one: { __typename?: 'review_vote', id: any } | null };

export type ReviewList_DeleteReviewVoteMutationVariables = Exact<{
  reviewVoteId: Scalars['uuid'];
}>;


export type ReviewList_DeleteReviewVoteMutation = { __typename?: 'mutation_root', delete_review_vote_by_pk: { __typename?: 'review_vote', id: any } | null };

export type ReviewList_CreateReviewReplyMutationVariables = Exact<{
  input: Review_Reply_Insert_Input;
}>;


export type ReviewList_CreateReviewReplyMutation = { __typename?: 'mutation_root', insert_review_reply_one: { __typename?: 'review_reply', id: any } | null };

export type ReviewList_DeleteReviewReplyMutationVariables = Exact<{
  replyId: Scalars['uuid'];
}>;


export type ReviewList_DeleteReviewReplyMutation = { __typename?: 'mutation_root', delete_review_reply_by_pk: { __typename?: 'review_reply', id: any } | null };

export type ReviewPopup_FacilityFragment = { __typename?: 'facility', id: any, name: string, city: string, state: string } & { ' $fragmentName'?: 'ReviewPopup_FacilityFragment' };

export type ReviewPopup_OrganizationFragment = { __typename?: 'organization', id: any, name: string } & { ' $fragmentName'?: 'ReviewPopup_OrganizationFragment' };

export type ReviewSalaryCta_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, primaryTrainingSites: Array<{ __typename?: 'training_survey_site', id: any, primary: boolean, facility: { __typename?: 'facility', id: any, slug: string } | null }> } & { ' $fragmentName'?: 'ReviewSalaryCta_TrainingSurveyFragment' };

export type ReportDetail_SalaryReportInfoFragment = { __typename?: 'salary_report_fmt', id: any | null, profession: any | null, worker: any | null, experience: number | null, nocturnal: boolean | null, partner: boolean | null, locums: boolean | null, admin: boolean | null, traveler: boolean | null, cme: boolean | null, bonus: boolean | null, retirement: boolean | null, baseAmt: number | null, basePeriod: any | null, nightDiff: boolean | null, nightDiffAmt: number | null, weekendDiff: boolean | null, weekendDiffAmt: number | null, hrsShift: number | null, shftsMonth: number | null, createdAt: any | null, visaSponsorship: boolean | null, weekendsOnly: boolean | null, partnershipTrack: boolean | null, cmeAmt: number | null, bonusAmt: string | null, retirementAmt: string | null, studentLoan: boolean | null, studentLoanAmt: number | null, orgOther: string | null, facility: { __typename?: 'facility', id: any, name: string, slug: string, state: string, city: string } | null, organization: { __typename?: 'organization', id: any, name: string, slug: string } | null } & { ' $fragmentName'?: 'ReportDetail_SalaryReportInfoFragment' };

export type SalaryCard_SalaryReportInfoFragment = { __typename?: 'salary_report_fmt', id: any | null, profession: any | null, worker: any | null, experience: number | null, nocturnal: boolean | null, partner: boolean | null, locums: boolean | null, admin: boolean | null, traveler: boolean | null, cme: boolean | null, bonus: boolean | null, retirement: boolean | null, baseAmt: number | null, basePeriod: any | null, nightDiff: boolean | null, nightDiffAmt: number | null, weekendDiff: boolean | null, weekendDiffAmt: number | null, visaSponsorship: boolean | null, weekendsOnly: boolean | null, partnershipTrack: boolean | null, studentLoan: boolean | null, orgOther: string | null, facility: { __typename?: 'facility', id: any, name: string, slug: string, state: string, city: string, picture: { __typename?: 'file', publicUrl: string } | null } | null, organization: { __typename?: 'organization', id: any, name: string, slug: string } | null } & { ' $fragmentName'?: 'SalaryCard_SalaryReportInfoFragment' };

export type SalaryList_SearchSalaryReportsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<Relevant_Salary_Report_Order_By> | Relevant_Salary_Report_Order_By>;
  search: Scalars['String'];
  reportFilters: Relevant_Salary_Report_Bool_Exp;
}>;


export type SalaryList_SearchSalaryReportsQuery = { __typename?: 'query_root', relevantSalaryReports: Array<{ __typename?: 'relevant_salary_report', id: any | null, salaryReport: (
      { __typename?: 'salary_report_fmt', id: any | null }
      & { ' $fragmentRefs'?: { 'SalaryCard_SalaryReportInfoFragment': SalaryCard_SalaryReportInfoFragment;'SalaryTable_SalaryReportInfoFragment': SalaryTable_SalaryReportInfoFragment;'ReportDetail_SalaryReportInfoFragment': ReportDetail_SalaryReportInfoFragment } }
    ) | null }>, agg: { __typename?: 'relevant_salary_report_aggregate', aggregate: { __typename?: 'relevant_salary_report_aggregate_fields', count: number } | null } };

export type SalaryTable_SalaryReportInfoFragment = { __typename?: 'salary_report_fmt', id: any | null, profession: any | null, worker: any | null, experience: number | null, nocturnal: boolean | null, partner: boolean | null, locums: boolean | null, admin: boolean | null, traveler: boolean | null, cme: boolean | null, bonus: boolean | null, retirement: boolean | null, baseAmt: number | null, basePeriod: any | null, nightDiff: boolean | null, nightDiffAmt: number | null, weekendDiff: boolean | null, weekendDiffAmt: number | null, createdAt: any | null, hrsShift: number | null, shftsMonth: number | null, visaSponsorship: boolean | null, weekendsOnly: boolean | null, partnershipTrack: boolean | null, studentLoan: boolean | null, orgOther: string | null, facility: { __typename?: 'facility', id: any, slug: string, name: string, state: string, city: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null } | null, organization: { __typename?: 'organization', id: any, name: string, slug: string, logo: { __typename?: 'file', id: any, publicUrl: string } | null } | null } & { ' $fragmentName'?: 'SalaryTable_SalaryReportInfoFragment' };

export type SalaryReportPopup_FacilityFragment = (
  { __typename?: 'facility', id: any, name: string, contracts: Array<{ __typename?: 'facility_contract', org: (
      { __typename?: 'organization', id: any }
      & { ' $fragmentRefs'?: { 'SalaryReportFormGeneralStep_OrganizationFragment': SalaryReportFormGeneralStep_OrganizationFragment } }
    ) }> }
  & { ' $fragmentRefs'?: { 'SalaryReportFormGeneralStep_FacilityFragment': SalaryReportFormGeneralStep_FacilityFragment;'FacilitySelect_FacilityFragment': FacilitySelect_FacilityFragment } }
) & { ' $fragmentName'?: 'SalaryReportPopup_FacilityFragment' };

export type SalaryReportPopup_OrganizationFragment = (
  { __typename?: 'organization', id: any, name: string }
  & { ' $fragmentRefs'?: { 'SalaryReportFormGeneralStep_OrganizationFragment': SalaryReportFormGeneralStep_OrganizationFragment } }
) & { ' $fragmentName'?: 'SalaryReportPopup_OrganizationFragment' };

export type SalaryReportPopup_CreatedSalaryReportMutationVariables = Exact<{
  input: Salary_Report_Insert_Input;
}>;


export type SalaryReportPopup_CreatedSalaryReportMutation = { __typename?: 'mutation_root', insert_salary_report_one: { __typename?: 'salary_report', id: any } | null };

export type TrainingFeatured_FeaturedResidencyQueryVariables = Exact<{
  x: Scalars['float8'];
  y: Scalars['float8'];
  limit: Scalars['Int'];
}>;


export type TrainingFeatured_FeaturedResidencyQuery = { __typename?: 'query_root', featuredResidency: Array<{ __typename?: 'featured_residency_dist_result', id: any | null, distance: any | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'TrainingFeatured_TrainingSurveyFragment': TrainingFeatured_TrainingSurveyFragment } }
          ) } | null } | null } | null }> };

export type TrainingFeatured_FeaturedClerkshipQueryVariables = Exact<{
  x: Scalars['float8'];
  y: Scalars['float8'];
  limit: Scalars['Int'];
}>;


export type TrainingFeatured_FeaturedClerkshipQuery = { __typename?: 'query_root', featuredClerkship: Array<{ __typename?: 'featured_clerkship_dist_result', id: any | null, distance: any | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'TrainingFeatured_TrainingSurveyFragment': TrainingFeatured_TrainingSurveyFragment } }
          ) } | null } | null } | null }> };

export type TrainingFeatured_FeaturedFellowshipQueryVariables = Exact<{
  x: Scalars['float8'];
  y: Scalars['float8'];
  limit: Scalars['Int'];
}>;


export type TrainingFeatured_FeaturedFellowshipQuery = { __typename?: 'query_root', featuredFellowship: Array<{ __typename?: 'featured_fellowship_dist_result', id: any | null, distance: any | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'TrainingFeatured_TrainingSurveyFragment': TrainingFeatured_TrainingSurveyFragment } }
          ) } | null } | null } | null }> };

export type TrainingFeatured_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, city: string, state: string, residencySurvey: { __typename?: 'residency_survey', id: any, specialty: Array<string>, programLength: number | null, primaryTrainingSite: string, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string } } | null } | null, clerkshipSurvey: { __typename?: 'clerkship_survey', id: any, comlexRequired: string, rotationTypes: Array<string>, vsloParticipant: boolean | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, fellowshipSurvey: { __typename?: 'fellowship_survey', id: any, subspecialty: string, advancedDegrees: Array<string>, moonlightingAllowed: string, programLength: number | null, shiftsPerMonth: number | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, trainingSites: Array<{ __typename?: 'training_survey_site', facility: { __typename?: 'facility', picture: { __typename?: 'file', publicUrl: string } | null } | null }> } & { ' $fragmentName'?: 'TrainingFeatured_TrainingSurveyFragment' };

export type AbProvider_PickAbTestsMutationVariables = Exact<{
  abTests: Array<Ab_Test_Insert_Input> | Ab_Test_Insert_Input;
}>;


export type AbProvider_PickAbTestsMutation = { __typename?: 'mutation_root', insert_ab_test: { __typename?: 'ab_test_mutation_response', returning: Array<{ __typename?: 'ab_test', id: any, currentAccount: { __typename?: 'current_account', id: any | null, abTests: Array<{ __typename?: 'ab_test', id: any, test: string, group: string }> } | null }> } | null };

export type UseBannerAd_CreateAdAuctionMutationVariables = Exact<{
  input: CreateAdAuctionInput;
}>;


export type UseBannerAd_CreateAdAuctionMutation = { __typename?: 'mutation_root', createAdAuction: { __typename?: 'CreateAdAuctionResult', results: Array<{ __typename?: 'AdAuctionResult', winners: Array<{ __typename?: 'AdAuctionWinner', id: string, resolvedBidId: string, asset: Array<{ __typename?: 'AdAuctionAsset', url: string }> }> }> } };

export type AuthProvider_CurrentAccountRolesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AuthProvider_CurrentAccountRolesSubscription = { __typename?: 'subscription_root', currentAccount: Array<{ __typename?: 'current_account', roles: Array<{ __typename?: 'account_role', id: any, role: any }> }> };

export type AuthProvider_CurrentAccountQueryVariables = Exact<{
  isClinician: Scalars['Boolean'];
  isOrgUser: Scalars['Boolean'];
}>;


export type AuthProvider_CurrentAccountQuery = { __typename?: 'query_root', currentAccount: Array<(
    { __typename?: 'current_account', id: any | null, type: any | null, isClinician: boolean, isOrgUser: boolean, superuser: boolean | null, accessSalary: boolean | null, hideSearchInstructions: boolean | null, ci: { __typename?: 'contact_info', id: any | null, email: string | null, confirmedEmail: boolean | null } | null, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null, orgUser: { __typename?: 'org_user', id: any, org: { __typename?: 'organization', id: any, name: string, slug: string, verified: boolean } } | null, clinician?: { __typename?: 'clinician', id: any, fid: string | null, profession: any, creds: string, isAPP: boolean, profileComplete: boolean, reportedSalary: boolean | null, profDegree: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null } } | null, abTests: Array<{ __typename?: 'ab_test', id: any, test: string, group: string }> }
    & { ' $fragmentRefs'?: { 'CurrentAccountAvatar_CurrentAccountFragment': CurrentAccountAvatar_CurrentAccountFragment } }
  )> };

export type BillingProvider_SubscriptionFragment = { __typename?: 'CustomerSubscriptionGQL', id: string, active: boolean, interval: string, slots: number, status: string, tier: string, discounted: boolean, cancelAt: any | null, usedSlots: number, invoice: { __typename?: 'SubscriptionInvoiceGQL', id: string | null, status: string | null, subtotal: number, total: number, invoiceDate: any | null, paymentIntent: string | null, paymentStatus: string | null } | null } & { ' $fragmentName'?: 'BillingProvider_SubscriptionFragment' };

export type BillingProvider_CustomerFragment = { __typename?: 'CustomerGQL', balance: number | null, city: string | null, email: string | null, id: string, state: string | null, zipcode: string | null, address1: string | null, address2: string | null, defaultPaymentId: string | null, checkoutBankHold: boolean, fullName: string | null, subscription: (
    { __typename?: 'CustomerSubscriptionGQL' }
    & { ' $fragmentRefs'?: { 'BillingProvider_SubscriptionFragment': BillingProvider_SubscriptionFragment } }
  ) | null, paymentMethods: Array<{ __typename?: 'PaymentMethodGQL', id: string, type: string, createdAt: number, usBank: { __typename?: 'BankPaymentMethodGQL', accountType: string | null, bankName: string | null, last4: string | null } | null, card: { __typename?: 'CardPaymentMethodGQL', brand: string, expMonth: number, expYear: number, last4: string } | null }> } & { ' $fragmentName'?: 'BillingProvider_CustomerFragment' };

export type BillingProvider_GetSubscriptionQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type BillingProvider_GetSubscriptionQuery = { __typename?: 'query_root', organization: { __typename?: 'organization', id: any, customer: (
      { __typename?: 'CustomerGQL' }
      & { ' $fragmentRefs'?: { 'BillingProvider_CustomerFragment': BillingProvider_CustomerFragment } }
    ) | null } | null, orgAdmins: { __typename?: 'org_user_aggregate', aggregate: { __typename?: 'org_user_aggregate_fields', count: number } | null } };

export type SettingsModal_UpdateSiteMutationVariables = Exact<{
  platform: Scalars['platform'];
  emraFeaturedTrainingType: Scalars['trainingtype'];
}>;


export type SettingsModal_UpdateSiteMutation = { __typename?: 'mutation_root', update_site: { __typename?: 'site_mutation_response', returning: Array<{ __typename?: 'site', id: any }> } | null };

export type SiteSettingsProvider_SearchSiteQueryVariables = Exact<{
  platform: Scalars['platform'];
}>;


export type SiteSettingsProvider_SearchSiteQuery = { __typename?: 'query_root', site: Array<(
    { __typename?: 'site', id: any }
    & { ' $fragmentRefs'?: { 'SiteSettingsProvider_SiteFragment': SiteSettingsProvider_SiteFragment } }
  )> };

export type SiteSettingsProvider_SiteFragment = { __typename?: 'site', id: any, platform: any, emraFeaturedTrainingType: any | null } & { ' $fragmentName'?: 'SiteSettingsProvider_SiteFragment' };

export type OrgUserOnboardingTourMutationVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type OrgUserOnboardingTourMutation = { __typename?: 'mutation_root', update_account_by_pk: { __typename?: 'account', id: any } | null };

export type RefreshAuthMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshAuthMutation = { __typename?: 'mutation_root', refreshAuth: { __typename?: 'RefreshAuthResult', accessToken: string } };

export type OrgMenu_UnreadItemsSubscriptionVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type OrgMenu_UnreadItemsSubscription = { __typename?: 'subscription_root', orgUser: { __typename?: 'org_user', id: any, numUnseenCandidates: number | null } | null };

export type FavoritesShow_QueryFavoritesQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type FavoritesShow_QueryFavoritesQuery = { __typename?: 'query_root', favorite: Array<(
    { __typename?: 'favorite', id: any, type: any }
    & { ' $fragmentRefs'?: { 'FavoritesShow_FavoriteFragment': FavoritesShow_FavoriteFragment } }
  )> };

export type FavoritesShow_DeleteFavoriteMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type FavoritesShow_DeleteFavoriteMutation = { __typename?: 'mutation_root', delete_favorite_by_pk: { __typename?: 'favorite', id: any } | null };

export type FavoritesShow_FavoriteFragment = { __typename?: 'favorite', id: any, type: any, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, city: string, state: string, trainingSites: Array<{ __typename?: 'training_survey_site', facility: { __typename?: 'facility', picture: { __typename?: 'file', publicUrl: string } | null } | null }> } } | null } | null } | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, city: string, state: string, trainingSites: Array<{ __typename?: 'training_survey_site', facility: { __typename?: 'facility', picture: { __typename?: 'file', publicUrl: string } | null } | null }> } } | null } | null } | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, city: string, state: string, trainingSites: Array<{ __typename?: 'training_survey_site', facility: { __typename?: 'facility', picture: { __typename?: 'file', publicUrl: string } | null } | null }> } } | null } | null } | null } & { ' $fragmentName'?: 'FavoritesShow_FavoriteFragment' };

export type SuppressionList_PreferencesQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type SuppressionList_PreferencesQuery = { __typename?: 'query_root', suppressions: Array<{ __typename?: 'EmailSuppression', id: string, category: string }> };

export type SuppressionList_SavePreferencesMutationVariables = Exact<{
  token: Scalars['String'];
  categories: Array<Scalars['String']> | Scalars['String'];
}>;


export type SuppressionList_SavePreferencesMutation = { __typename?: 'mutation_root', set_email_suppressions: Array<{ __typename?: 'EmailSuppression', id: string }> };

export type AcceptSurveyPopup_SearchOrgsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type AcceptSurveyPopup_SearchOrgsQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: { __typename?: 'organization', id: any, name: string } | null }> };

export type AcceptSurveyPopup_CreateOrgMutationVariables = Exact<{
  name: Scalars['String'];
  website: Scalars['String'];
}>;


export type AcceptSurveyPopup_CreateOrgMutation = { __typename?: 'mutation_root', org: { __typename?: 'organization', id: any, name: string } | null };

export type AcceptSurveyPopup_AcceptMutationVariables = Exact<{
  surveyId: Scalars['String'];
  orgId: Scalars['String'];
}>;


export type AcceptSurveyPopup_AcceptMutation = { __typename?: 'mutation_root', accept_acep_org_survey: { __typename?: 'AcceptAcepOrgSurveyResult', acep_org_survey: { __typename?: 'acep_org_survey', id: any, accepted_at: any | null, org: { __typename?: 'organization', id: any, name: string } | null } | null } };

export type AcceptSurveyPopup_SurveyFragment = { __typename?: 'acep_org_survey', id: any, website: string, orgName: string, org: { __typename?: 'organization', id: any, name: string } | null } & { ' $fragmentName'?: 'AcceptSurveyPopup_SurveyFragment' };

export type AcepOrgSurveyList_SurveyResultFragment = (
  { __typename?: 'acep_org_survey', id: any, city: string, state: string, zipcode: string, phone: string, website: string, dba: string, tin: string, staffing: Array<string>, governance: Array<string>, funding: Array<string>, apps: string, acceptedAt: any | null, createdAt: any, orgName: string, streetAddress1: string, streetAddress2: string, nameAdmin: string, emailAdmin: string, nameCmo: string, emailCmo: string, numEmPhysicians: string, practiceSize: string, geographicDist: string, contractOwner: Array<string>, ceoIsPhysician: string, partnershipsOffered: string, billingDisclosure: string, appsUnsupervised: string, acepPolicies: Array<string>, org: { __typename?: 'organization', id: any, name: string, slug: string } | null }
  & { ' $fragmentRefs'?: { 'AcceptSurveyPopup_SurveyFragment': AcceptSurveyPopup_SurveyFragment } }
) & { ' $fragmentName'?: 'AcepOrgSurveyList_SurveyResultFragment' };

export type AcepOrgSurveyList_SurveyTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AcepOrgSurveyList_SurveyTableDataQuery = { __typename?: 'query_root', results: Array<(
    { __typename?: 'acep_org_survey', id: any }
    & { ' $fragmentRefs'?: { 'AcepOrgSurveyList_SurveyResultFragment': AcepOrgSurveyList_SurveyResultFragment } }
  )> };

export type AcepOrgSurvey_SearchOrgsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type AcepOrgSurvey_SearchOrgsQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: { __typename?: 'organization', id: any, name: string } | null }> };

export type AcepOrgSurvey_SubmitFormMutationVariables = Exact<{
  values: Acep_Org_Survey_Insert_Input;
}>;


export type AcepOrgSurvey_SubmitFormMutation = { __typename?: 'mutation_root', insert_acep_org_survey_one: { __typename?: 'acep_org_survey', id: any } | null };

export type AdminClinicianShow_ClinicianQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type AdminClinicianShow_ClinicianQuery = { __typename?: 'query_root', clinician: (
    { __typename?: 'clinician', id: any }
    & { ' $fragmentRefs'?: { 'ClinicianProfile_ClinicianFragment': ClinicianProfile_ClinicianFragment } }
  ) | null };

export type JobApplicationBatchNotesPopup_JobApplicationBatchFragment = { __typename?: 'job_application_batch', id: any, notes: string } & { ' $fragmentName'?: 'JobApplicationBatchNotesPopup_JobApplicationBatchFragment' };

export type JobApplicationBatchNotesPopup_UpdateNotesMutationVariables = Exact<{
  batchId: Scalars['uuid'];
  notes: Scalars['String'];
}>;


export type JobApplicationBatchNotesPopup_UpdateNotesMutation = { __typename?: 'mutation_root', update_job_application_batch_by_pk: { __typename?: 'job_application_batch', id: any, notes: string } | null };

export type FinalizeSignup_ConfirmEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type FinalizeSignup_ConfirmEmailMutation = { __typename?: 'mutation_root', finalize: { __typename?: 'FinalizeSignupResult', access: string, refresh: string } };

export type CandidateCard_CandidateFragment = { __typename?: 'candidate', id: any, lastAppliedDate: any | null, lastApplied: any | null, clinician: (
    { __typename?: 'clinician', id: any, profDegree: any, currentTrainee: boolean | null, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, licenses: Array<{ __typename?: 'clinician_license', id: any, state: string }>, fsmb: { __typename?: 'fsmb_bio', fid: string, licenses: Array<{ __typename?: 'fsmb_licensure', id: any, state: string }> } | null }
    & { ' $fragmentRefs'?: { 'ClinicianAvatar_ClinicianFragment': ClinicianAvatar_ClinicianFragment } }
  ), jobAppBatches: Array<{ __typename?: 'job_application_batch', id: any, jobApps: Array<{ __typename?: 'job_application', id: any, contract: { __typename?: 'facility_contract', id: any, facility: { __typename?: 'facility', id: any, name: string, city: string, state: string } } }> }> } & { ' $fragmentName'?: 'CandidateCard_CandidateFragment' };

export type CandidateFacilitiesPopover_FacilityFragment = { __typename?: 'facility', id: any, slug: string, name: string, city: string, state: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null } & { ' $fragmentName'?: 'CandidateFacilitiesPopover_FacilityFragment' };

export type CandidateList_SearchCandidatesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Search_Candidate_Result_Order_By> | Search_Candidate_Result_Order_By>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  candidateFilters: Search_Candidate_Result_Bool_Exp;
  search: Scalars['String'];
  orgId: Scalars['uuid'];
  accountId: Scalars['uuid'];
}>;


export type CandidateList_SearchCandidatesQuery = { __typename?: 'query_root', orgUser: { __typename?: 'org_user', id: any, lastViewedCandidatesDate: any | null, lastViewedCandidates: any | null } | null, results: Array<{ __typename?: 'search_candidate_result', id: any | null, candidate: (
      { __typename?: 'candidate', id: any, lastAppliedDate: any | null, lastApplied: any | null }
      & { ' $fragmentRefs'?: { 'CandidateTable_CandidateRowsFragment': CandidateTable_CandidateRowsFragment;'CandidateCard_CandidateFragment': CandidateCard_CandidateFragment } }
    ) | null }>, agg: { __typename?: 'search_candidate_result_aggregate', aggregate: { __typename?: 'search_candidate_result_aggregate_fields', count: number } | null }, facilities: Array<{ __typename?: 'facility', id: any, name: string, city: string, state: string }> };

export type CandidateList_MarkAsViewedMutationVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type CandidateList_MarkAsViewedMutation = { __typename?: 'mutation_root', update_org_user_by_pk: { __typename?: 'org_user', id: any, last_viewed_candidates: any | null } | null };

export type CandidateTable_CandidateRowsFragment = { __typename?: 'candidate', id: any, lastAppliedDate: any | null, lastApplied: any | null, clinician: { __typename?: 'clinician', id: any, profDegree: any, currentTrainee: boolean | null, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, licenses: Array<{ __typename?: 'clinician_license', id: any, state: string }>, fsmb: { __typename?: 'fsmb_bio', fid: string, licenses: Array<{ __typename?: 'fsmb_licensure', id: any, state: string }> } | null }, jobAppBatches: Array<{ __typename?: 'job_application_batch', id: any, jobApps: Array<{ __typename?: 'job_application', id: any, contract: { __typename?: 'facility_contract', id: any, facility: (
          { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string }
          & { ' $fragmentRefs'?: { 'CandidateFacilitiesPopover_FacilityFragment': CandidateFacilitiesPopover_FacilityFragment } }
        ) } }> }> } & { ' $fragmentName'?: 'CandidateTable_CandidateRowsFragment' };

export type CandidateShow_CandidateQDocQueryVariables = Exact<{
  candidateId: Scalars['uuid'];
}>;


export type CandidateShow_CandidateQDocQuery = { __typename?: 'query_root', candidate: { __typename?: 'candidate', id: any, maskedEmail: string | null, clinician: (
      { __typename?: 'clinician', id: any, creds: string, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null } }
      & { ' $fragmentRefs'?: { 'ClinicianProfile_ClinicianFragment': ClinicianProfile_ClinicianFragment } }
    ) } | null, jobApps: Array<(
    { __typename?: 'job_application', id: any }
    & { ' $fragmentRefs'?: { 'ClinicianProfile_JobApplicationFragment': ClinicianProfile_JobApplicationFragment } }
  )> };

export type ConnectionShowRedirect_CandidateQueryVariables = Exact<{
  connectionId: Scalars['uuid'];
}>;


export type ConnectionShowRedirect_CandidateQuery = { __typename?: 'query_root', candidate: Array<{ __typename?: 'candidate', id: any }> };

export type JobApplicationList_JobApplicationsQueryVariables = Exact<{
  accountId: Scalars['uuid'];
}>;


export type JobApplicationList_JobApplicationsQuery = { __typename?: 'query_root', jobApps: Array<(
    { __typename?: 'job_application', id: any }
    & { ' $fragmentRefs'?: { 'JobApplicationListItem_JobApplicationFragment': JobApplicationListItem_JobApplicationFragment } }
  )> };

export type JobApplicationListItem_JobApplicationFragment = { __typename?: 'job_application', id: any, createdAtDate: any, createdAt: any, contract: { __typename?: 'facility_contract', id: any, active: boolean, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, org: { __typename?: 'organization', id: any, name: string } } } & { ' $fragmentName'?: 'JobApplicationListItem_JobApplicationFragment' };

export type EditClinician_ClinicianQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type EditClinician_ClinicianQuery = { __typename?: 'query_root', clinician: (
    { __typename?: 'clinician', id: any }
    & { ' $fragmentRefs'?: { 'ClinicianProfile_ClinicianFragment': ClinicianProfile_ClinicianFragment } }
  ) | null };

export type DataList_ContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type DataList_ContractsQuery = { __typename?: 'query_root', contracts: Array<{ __typename?: 'facility_contract', id: any, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string, zipcode: string, streetAddress1: string, freestandingEr: boolean, cmsFacilityId: string | null, ahaFacilityId: string | null, residencies: Array<{ __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string } }> | null }, org: { __typename?: 'organization', id: any, name: string, ownershipStructure: any | null } }> };

export type EmraProgramFeatures_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, description: string, directorName: string, coordinatorName: string, coordinatorEmail: string, createdAt: any, residencySurvey: { __typename?: 'residency_survey', id: any, moonlighting: boolean | null, nrmpId: string, acgmeId: string, programLength: number | null, primaryTrainingSite: string, secondaryTrainingSite: string, shiftLength: string, shiftsPerMonth: string, pgy1PercentOffService: number | null, step1Failures: boolean | null, step1Cutoff: string, availableInternPositions: number | null, percentOsteopath: string, percentImg: string, electiveWeeks: number | null, criticalCareWeeks: number | null, militaryBranch: string, visaSponsorship: string, sloesForInterview: number | null, usmleComlex1Preference: string, usmleComlex2Preference: string, applicationsReceived: number | null, inPersonSecondLooks: boolean | null, cordApicInterview: boolean | null, specialty: Array<string>, residency: { __typename?: 'residency', id: any, emrafied: boolean, training: { __typename?: 'training', id: any, name: string } } | null } | null, clerkshipSurvey: { __typename?: 'clerkship_survey', id: any, housing: boolean | null, comlexRequired: string, authStudentSloe: string, doStudents: boolean | null, flexibleRotation: boolean | null, imgStudents: boolean | null, interviewPolicy: string, rotationTypes: Array<string>, vehicleRec: string, vsloParticipant: boolean | null, spotAvailability1: boolean | null, spotAvailability2: boolean | null, spotAvailability3: boolean | null, spotAvailability4: boolean | null, spotAvailability5: boolean | null, spotAvailability6: boolean | null, spotAvailability7: boolean | null, spotAvailability8: boolean | null, spotAvailability9: boolean | null, spotAvailability10: boolean | null, spotAvailability11: boolean | null, spotAvailability12: boolean | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, fellowshipSurvey: { __typename?: 'fellowship_survey', id: any, compensation: string, subspecialty: string, advancedDegrees: Array<string>, clinicalExp: string, degreeGrantingInstitution: string, moonlightingAllowed: string, positionsPerYear: number | null, programLength: number | null, researchProject: string, shiftsPerMonth: number | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null } & { ' $fragmentName'?: 'EmraProgramFeatures_TrainingSurveyFragment' };

export type EmraProgramGallery_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, type: any, pictures: Array<{ __typename?: 'training_survey_picture', id: any, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } }> } & { ' $fragmentName'?: 'EmraProgramGallery_TrainingSurveyFragment' };

export type EmraProgramOverview_TrainingQueryVariables = Exact<{
  trainingId: Scalars['uuid'];
  profession: Scalars['profession'];
}>;


export type EmraProgramOverview_TrainingQuery = { __typename?: 'query_root', training: (
    { __typename?: 'training', id: any, type: any, residency: { __typename?: 'residency', id: any, emrafied: boolean, training: { __typename?: 'training', id: any, featured: boolean }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'EmraProgramFeatures_TrainingSurveyFragment': EmraProgramFeatures_TrainingSurveyFragment;'EmraProgramPrimarySite_TrainingSurveyFragment': EmraProgramPrimarySite_TrainingSurveyFragment;'EmraProgramSocials_TrainingSurveyFragment': EmraProgramSocials_TrainingSurveyFragment;'EmraProgramGallery_TrainingSurveyFragment': EmraProgramGallery_TrainingSurveyFragment;'EmraProgramTrainingSites_TrainingSurveyFragment': EmraProgramTrainingSites_TrainingSurveyFragment;'ReviewSalaryCta_TrainingSurveyFragment': ReviewSalaryCta_TrainingSurveyFragment } }
          ) } | null } | null } | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, featured: boolean }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'EmraProgramFeatures_TrainingSurveyFragment': EmraProgramFeatures_TrainingSurveyFragment;'EmraProgramPrimarySite_TrainingSurveyFragment': EmraProgramPrimarySite_TrainingSurveyFragment;'EmraProgramSocials_TrainingSurveyFragment': EmraProgramSocials_TrainingSurveyFragment;'EmraProgramGallery_TrainingSurveyFragment': EmraProgramGallery_TrainingSurveyFragment;'EmraProgramTrainingSites_TrainingSurveyFragment': EmraProgramTrainingSites_TrainingSurveyFragment;'ReviewSalaryCta_TrainingSurveyFragment': ReviewSalaryCta_TrainingSurveyFragment } }
          ) } | null } | null } | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, featured: boolean }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'EmraProgramFeatures_TrainingSurveyFragment': EmraProgramFeatures_TrainingSurveyFragment;'EmraProgramPrimarySite_TrainingSurveyFragment': EmraProgramPrimarySite_TrainingSurveyFragment;'EmraProgramSocials_TrainingSurveyFragment': EmraProgramSocials_TrainingSurveyFragment;'EmraProgramGallery_TrainingSurveyFragment': EmraProgramGallery_TrainingSurveyFragment;'EmraProgramTrainingSites_TrainingSurveyFragment': EmraProgramTrainingSites_TrainingSurveyFragment;'ReviewSalaryCta_TrainingSurveyFragment': ReviewSalaryCta_TrainingSurveyFragment } }
          ) } | null } | null } | null }
    & { ' $fragmentRefs'?: { 'EmraProgramEvents_TrainingFragment': EmraProgramEvents_TrainingFragment } }
  ) | null };

export type EmraProgramPrimarySite_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, type: any, primaryTrainingSites: Array<{ __typename?: 'training_survey_site', id: any, primary: boolean, facilityOther: string, facility: (
      { __typename?: 'facility', id: any }
      & { ' $fragmentRefs'?: { 'FacilityCard_FacilityFragment': FacilityCard_FacilityFragment } }
    ) | null }> } & { ' $fragmentName'?: 'EmraProgramPrimarySite_TrainingSurveyFragment' };

export type EmraProgramShow_TrainingQueryVariables = Exact<{
  isUser: Scalars['Boolean'];
  accountId?: InputMaybe<Scalars['uuid']>;
  trainingId: Scalars['uuid'];
}>;


export type EmraProgramShow_TrainingQuery = { __typename?: 'query_root', training: { __typename?: 'training', id: any, type: any, favorites?: Array<{ __typename?: 'favorite', id: any }> | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string, featured: boolean, active: boolean }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'EmraProgramShow_TrainingSurveyFragment': EmraProgramShow_TrainingSurveyFragment } }
          ) } | null } | null } | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string, featured: boolean, active: boolean }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'EmraProgramShow_TrainingSurveyFragment': EmraProgramShow_TrainingSurveyFragment } }
          ) } | null } | null } | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string, featured: boolean, active: boolean }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'EmraProgramShow_TrainingSurveyFragment': EmraProgramShow_TrainingSurveyFragment } }
          ) } | null } | null } | null } | null };

export type EmraProgramShow_TrainingSurveyFragment = (
  { __typename?: 'training_survey', id: any, city: string, state: string, zipcode: string, website: string, createdAt: any, streetAddress1: string, streetAddress2: string }
  & { ' $fragmentRefs'?: { 'EmraProgramSocials_TrainingSurveyFragment': EmraProgramSocials_TrainingSurveyFragment } }
) & { ' $fragmentName'?: 'EmraProgramShow_TrainingSurveyFragment' };

export type EmraProgramShow_FavoriteProgramMutationVariables = Exact<{
  constraint: Favorite_Constraint;
  favArgs: Array<Favorite_Insert_Input> | Favorite_Insert_Input;
}>;


export type EmraProgramShow_FavoriteProgramMutation = { __typename?: 'mutation_root', insert_favorite: { __typename?: 'favorite_mutation_response', returning: Array<{ __typename?: 'favorite', id: any }> } | null };

export type EmraProgramShow_DeleteFavoriteProgramMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type EmraProgramShow_DeleteFavoriteProgramMutation = { __typename?: 'mutation_root', delete_favorite_by_pk: { __typename?: 'favorite', id: any } | null };

export type EmraProgramSocials_TrainingSurveyFragment = (
  { __typename?: 'training_survey', id: any, vimeo: string, website: string, youtube: string, instagram: string, facebook: string, twitter: string, multimediaURLs: Array<string>, residencySurvey: { __typename?: 'residency_survey', id: any, residency: { __typename?: 'residency', id: any, pdInterview: string } | null } | null }
  & { ' $fragmentRefs'?: { 'ReviewSalaryCta_TrainingSurveyFragment': ReviewSalaryCta_TrainingSurveyFragment } }
) & { ' $fragmentName'?: 'EmraProgramSocials_TrainingSurveyFragment' };

export type EmraProgramTrainingSites_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, type: any, trainingSites: Array<{ __typename?: 'training_survey_site', id: any, primary: boolean, facilityOther: string, facility: { __typename?: 'facility', id: any, name: string, slug: string } | null }>, trainingSitesAgg: { __typename?: 'training_survey_site_aggregate', aggregate: { __typename?: 'training_survey_site_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'EmraProgramTrainingSites_TrainingSurveyFragment' };

export type EmraProgramEvents_TrainingFragment = { __typename?: 'training', id: any, events: Array<{ __typename?: 'training_event', id: any, name: string, url: string, eventDate: any }>, eventsAgg: { __typename?: 'training_event_aggregate', aggregate: { __typename?: 'training_event_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'EmraProgramEvents_TrainingFragment' };

export type Map_GeoSearchClerkshipQueryVariables = Exact<{
  xMin: Scalars['float8'];
  xMax: Scalars['float8'];
  yMin: Scalars['float8'];
  yMax: Scalars['float8'];
  filters: Clerkship_Bool_Exp;
}>;


export type Map_GeoSearchClerkshipQuery = { __typename?: 'query_root', clerkship: Array<{ __typename?: 'search_clerkship_by_geography_result', id: any | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'Map_TrainingSurveyFragment': Map_TrainingSurveyFragment } }
          ) } | null } | null } | null }> };

export type Map_GetClerkshipQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Map_GetClerkshipQuery = { __typename?: 'query_root', clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', id: any, trainingSurvey: (
          { __typename?: 'training_survey', id: any }
          & { ' $fragmentRefs'?: { 'Map_TrainingSurveyFragment': Map_TrainingSurveyFragment } }
        ) } | null } | null } | null };

export type Map_GeoSearchFellowshipQueryVariables = Exact<{
  xMin: Scalars['float8'];
  xMax: Scalars['float8'];
  yMin: Scalars['float8'];
  yMax: Scalars['float8'];
  filters: Fellowship_Bool_Exp;
}>;


export type Map_GeoSearchFellowshipQuery = { __typename?: 'query_root', fellowship: Array<{ __typename?: 'search_fellowship_by_geography_result', id: any | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'Map_TrainingSurveyFragment': Map_TrainingSurveyFragment } }
          ) } | null } | null } | null }> };

export type Map_GetFellowshipQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Map_GetFellowshipQuery = { __typename?: 'query_root', fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', id: any, trainingSurvey: (
          { __typename?: 'training_survey', id: any }
          & { ' $fragmentRefs'?: { 'Map_TrainingSurveyFragment': Map_TrainingSurveyFragment } }
        ) } | null } | null } | null };

export type Map_GeoSearchResidencyQueryVariables = Exact<{
  xMin: Scalars['float8'];
  xMax: Scalars['float8'];
  yMin: Scalars['float8'];
  yMax: Scalars['float8'];
  filters: Residency_Bool_Exp;
}>;


export type Map_GeoSearchResidencyQuery = { __typename?: 'query_root', residency: Array<{ __typename?: 'search_residency_by_geography_result', id: any | null, residency: { __typename?: 'residency', id: any, emrafied: boolean, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', id: any, trainingSurvey: (
            { __typename?: 'training_survey', id: any }
            & { ' $fragmentRefs'?: { 'Map_TrainingSurveyFragment': Map_TrainingSurveyFragment } }
          ) } | null } | null } | null }> };

export type Map_GetResidencyQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Map_GetResidencyQuery = { __typename?: 'query_root', residency: { __typename?: 'residency', id: any, emrafied: boolean, training: { __typename?: 'training', id: any, slug: string }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', id: any, trainingSurvey: (
          { __typename?: 'training_survey', id: any }
          & { ' $fragmentRefs'?: { 'Map_TrainingSurveyFragment': Map_TrainingSurveyFragment } }
        ) } | null } | null } | null };

export type Map_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, location: any | null, city: string, state: string, residencySurvey: { __typename?: 'residency_survey', id: any, specialty: Array<string>, programLength: number | null, primaryTrainingSite: string, secondaryTrainingSite: string, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, featured: boolean } } | null } | null, clerkshipSurvey: { __typename?: 'clerkship_survey', id: any, comlexRequired: string, rotationTypes: Array<string>, vsloParticipant: boolean | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string, featured: boolean } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, fellowshipSurvey: { __typename?: 'fellowship_survey', id: any, subspecialty: string, advancedDegrees: Array<string>, moonlightingAllowed: string, programLength: number | null, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string, featured: boolean } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, trainingSites: Array<{ __typename?: 'training_survey_site', facility: { __typename?: 'facility', picture: { __typename?: 'file', publicUrl: string } | null } | null }> } & { ' $fragmentName'?: 'Map_TrainingSurveyFragment' };

export type EmraAdmin_TabAggQueryVariables = Exact<{ [key: string]: never; }>;


export type EmraAdmin_TabAggQuery = { __typename?: 'query_root', residency: { __typename?: 'residency_aggregate', aggregate: { __typename?: 'residency_aggregate_fields', count: number } | null }, clerkship: { __typename?: 'clerkship_aggregate', aggregate: { __typename?: 'clerkship_aggregate_fields', count: number } | null }, fellowship: { __typename?: 'fellowship_aggregate', aggregate: { __typename?: 'fellowship_aggregate_fields', count: number } | null }, newSurvey: { __typename?: 'training_survey_aggregate', aggregate: { __typename?: 'training_survey_aggregate_fields', count: number } | null } };

export type EmraAdmin_DeactivateTrainingProgramMutationVariables = Exact<{
  trainingId: Scalars['uuid'];
  active: Scalars['Boolean'];
}>;


export type EmraAdmin_DeactivateTrainingProgramMutation = { __typename?: 'mutation_root', update_training_by_pk: { __typename?: 'training', id: any } | null };

export type EmraAdmin_ClerkshipSurveyFragment = { __typename?: 'clerkship_survey', id: any, housing: boolean | null, residencyOther: string, vsloParticipant: boolean | null, flexibleRotation: boolean | null, interviewPolicy: string, authStudentSloe: string, doStudents: boolean | null, imgStudents: boolean | null, comlexRequired: string, vehicleRec: string, rotationTypes: Array<string>, spotAvailability1: boolean | null, spotAvailability2: boolean | null, spotAvailability3: boolean | null, spotAvailability4: boolean | null, spotAvailability5: boolean | null, spotAvailability6: boolean | null, spotAvailability7: boolean | null, spotAvailability8: boolean | null, spotAvailability9: boolean | null, spotAvailability10: boolean | null, spotAvailability11: boolean | null, spotAvailability12: boolean | null, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, slug: string, name: string, featured: boolean, active: boolean, emraAccountNo: string | null, upcomingEvents: Array<{ __typename?: 'training_event', id: any, name: string, url: string, eventDate: any }> } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, slug: string, name: string } } | null } & { ' $fragmentName'?: 'EmraAdmin_ClerkshipSurveyFragment' };

export type EmraAdmin_ClerkshipTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EmraAdmin_ClerkshipTableDataQuery = { __typename?: 'query_root', results: Array<{ __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: (
        { __typename?: 'clerkship_survey', id: any, trainingSurvey: (
          { __typename?: 'training_survey', id: any }
          & { ' $fragmentRefs'?: { 'EmraAdmin_TrainingSurveyFragment': EmraAdmin_TrainingSurveyFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'EmraAdmin_ClerkshipSurveyFragment': EmraAdmin_ClerkshipSurveyFragment } }
      ) | null } | null }> };

export type EmraAdmin_FellowshipSurveyFragment = { __typename?: 'fellowship_survey', id: any, subspecialty: string, compensation: string, residencyOther: string, programLength: number | null, positionsPerYear: number | null, shiftsPerMonth: number | null, moonlightingAllowed: string, advancedDegrees: Array<string>, degreeGrantingInstitution: string, clinicalExp: string, researchProject: string, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, slug: string, name: string, featured: boolean, active: boolean, emraAccountNo: string | null, upcomingEvents: Array<{ __typename?: 'training_event', id: any, name: string, url: string, eventDate: any }> } } | null, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, slug: string, name: string } } | null } & { ' $fragmentName'?: 'EmraAdmin_FellowshipSurveyFragment' };

export type EmraAdmin_FellowshipTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EmraAdmin_FellowshipTableDataQuery = { __typename?: 'query_root', results: Array<{ __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: (
        { __typename?: 'fellowship_survey', id: any, trainingSurvey: (
          { __typename?: 'training_survey', id: any }
          & { ' $fragmentRefs'?: { 'EmraAdmin_TrainingSurveyFragment': EmraAdmin_TrainingSurveyFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'EmraAdmin_FellowshipSurveyFragment': EmraAdmin_FellowshipSurveyFragment } }
      ) | null } | null }> };

export type EmraAdmin_NewSurveyTrainingSurveyFragment = { __typename?: 'training_survey', id: any, type: any, name: string, status: any | null, createdAt: any, submitterName: string, submitterEmail: string, submitterPhone: string, residencySurvey: { __typename?: 'residency_survey', id: any, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, clerkshipSurvey: { __typename?: 'clerkship_survey', id: any, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, fellowshipSurvey: { __typename?: 'fellowship_survey', id: any, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null } & { ' $fragmentName'?: 'EmraAdmin_NewSurveyTrainingSurveyFragment' };

export type EmraAdmin_NewSurveyTrainingSurveyTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EmraAdmin_NewSurveyTrainingSurveyTableDataQuery = { __typename?: 'query_root', results: Array<(
    { __typename?: 'training_survey', id: any }
    & { ' $fragmentRefs'?: { 'EmraAdmin_NewSurveyTrainingSurveyFragment': EmraAdmin_NewSurveyTrainingSurveyFragment } }
  )> };

export type EmraAdmin_UpdateSurveyStatusMutationVariables = Exact<{
  surveyId: Scalars['String'];
  status: TrainingSurveyStatus;
}>;


export type EmraAdmin_UpdateSurveyStatusMutation = { __typename?: 'mutation_root', update_training_survey_status: { __typename?: 'UpdateTrainingSurveyStatusResult', training_survey: { __typename?: 'training_survey', id: any, status: any | null } | null } };

export type EmraAdmin_OldSurveyTrainingSurveyFragment = { __typename?: 'training_survey', id: any, type: any, name: string, status: any | null, createdAt: any, submitterName: string, submitterEmail: string, submitterPhone: string, residencySurvey: { __typename?: 'residency_survey', id: any, residency: { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, clerkshipSurvey: { __typename?: 'clerkship_survey', id: any, clerkship: { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null, fellowshipSurvey: { __typename?: 'fellowship_survey', id: any, fellowship: { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } } | null } | null } & { ' $fragmentName'?: 'EmraAdmin_OldSurveyTrainingSurveyFragment' };

export type EmraAdmin_OldSurveyTrainingSurveyTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EmraAdmin_OldSurveyTrainingSurveyTableDataQuery = { __typename?: 'query_root', results: Array<(
    { __typename?: 'training_survey', id: any }
    & { ' $fragmentRefs'?: { 'EmraAdmin_OldSurveyTrainingSurveyFragment': EmraAdmin_OldSurveyTrainingSurveyFragment } }
  )> };

export type EmraAdmin_ResidencySurveyFragment = { __typename?: 'residency_survey', id: any, moonlighting: boolean | null, nrmpId: string, acgmeId: string, programLength: number | null, primaryTrainingSite: string, secondaryTrainingSite: string, shiftLength: string, shiftsPerMonth: string, pgy1PercentOffService: number | null, step1Failures: boolean | null, step1Cutoff: string, availableInternPositions: number | null, percentOsteopath: string, percentImg: string, electiveWeeks: number | null, criticalCareWeeks: number | null, militaryBranch: string, visaSponsorship: string, sloesForInterview: number | null, usmleComlex1Preference: string, usmleComlex2Preference: string, applicationsReceived: number | null, inPersonSecondLooks: boolean | null, cordApicInterview: boolean | null, specialty: Array<string>, residency: { __typename?: 'residency', id: any, emrafied: boolean, pdInterview: string, training: { __typename?: 'training', id: any, slug: string, name: string, featured: boolean, active: boolean, emraAccountNo: string | null, upcomingEvents: Array<{ __typename?: 'training_event', id: any, name: string, url: string, eventDate: any }> } } | null } & { ' $fragmentName'?: 'EmraAdmin_ResidencySurveyFragment' };

export type EmraAdmin_ResidencyTableDataQueryVariables = Exact<{ [key: string]: never; }>;


export type EmraAdmin_ResidencyTableDataQuery = { __typename?: 'query_root', results: Array<{ __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: (
        { __typename?: 'residency_survey', id: any, trainingSurvey: (
          { __typename?: 'training_survey', id: any }
          & { ' $fragmentRefs'?: { 'EmraAdmin_TrainingSurveyFragment': EmraAdmin_TrainingSurveyFragment } }
        ) }
        & { ' $fragmentRefs'?: { 'EmraAdmin_ResidencySurveyFragment': EmraAdmin_ResidencySurveyFragment } }
      ) | null } | null }> };

export type EmraAdmin_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, city: string, state: string, zipcode: string, description: string, website: string, twitter: string, facebook: string, instagram: string, youtube: string, vimeo: string, createdAt: any, streetAddress1: string, streetAddress2: string, directorName: string, directorEmail: string, coordinatorName: string, coordinatorEmail: string, multimediaUrls: Array<string>, trainingSites: Array<{ __typename?: 'training_survey_site', id: any, primary: boolean, facilityOther: string, facility: { __typename?: 'facility', id: any, name: string, slug: string } | null }>, pictures: Array<{ __typename?: 'training_survey_picture', id: any, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } }> } & { ' $fragmentName'?: 'EmraAdmin_TrainingSurveyFragment' };

export type EmraClerkshipEdit_ClerkshipQueryVariables = Exact<{
  trainingId: Scalars['uuid'];
}>;


export type EmraClerkshipEdit_ClerkshipQuery = { __typename?: 'query_root', program: (
    { __typename?: 'clerkship', id: any, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: (
        { __typename?: 'clerkship_survey', id: any }
        & { ' $fragmentRefs'?: { 'ClerkshipForm_ClerkshipSurveyFragment': ClerkshipForm_ClerkshipSurveyFragment } }
      ) | null } | null }
    & { ' $fragmentRefs'?: { 'ClerkshipForm_ClerkshipFragment': ClerkshipForm_ClerkshipFragment } }
  ) | null };

export type EmraClerkshipSurveyShow_ClerkshipSurveyQueryVariables = Exact<{
  surveyId: Scalars['uuid'];
}>;


export type EmraClerkshipSurveyShow_ClerkshipSurveyQuery = { __typename?: 'query_root', survey: (
    { __typename?: 'clerkship_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, name: string }, clerkship: (
      { __typename?: 'clerkship', id: any, training: { __typename?: 'training', id: any, slug: string, name: string }, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: (
          { __typename?: 'clerkship_survey', id: any }
          & { ' $fragmentRefs'?: { 'ClerkshipForm_ClerkshipSurveyFragment': ClerkshipForm_ClerkshipSurveyFragment } }
        ) | null } | null }
      & { ' $fragmentRefs'?: { 'ClerkshipForm_ClerkshipFragment': ClerkshipForm_ClerkshipFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'ClerkshipForm_ClerkshipSurveyFragment': ClerkshipForm_ClerkshipSurveyFragment } }
  ) | null };

export type ClerkshipForm_ClerkshipSurveyFragment = { __typename?: 'clerkship_survey', id: any, housing: boolean | null, residencyOther: string, vsloParticipant: boolean | null, flexibleRotation: boolean | null, interviewPolicy: string, authStudentSloe: string, doStudents: boolean | null, imgStudents: boolean | null, comlexRequired: string, vehicleRec: string, rotationTypes: Array<string>, spotAvailability1: boolean | null, spotAvailability2: boolean | null, spotAvailability3: boolean | null, spotAvailability4: boolean | null, spotAvailability5: boolean | null, spotAvailability6: boolean | null, spotAvailability7: boolean | null, spotAvailability8: boolean | null, spotAvailability9: boolean | null, spotAvailability10: boolean | null, spotAvailability11: boolean | null, spotAvailability12: boolean | null, trainingSurvey: (
    { __typename?: 'training_survey', id: any, status: any | null }
    & { ' $fragmentRefs'?: { 'TrainingGeneralInfoForm_TrainingSurveyFragment': TrainingGeneralInfoForm_TrainingSurveyFragment } }
  ), residency: { __typename?: 'residency', id: any, training: (
      { __typename?: 'training', id: any }
      & { ' $fragmentRefs'?: { 'TrainingSelect_TrainingFragment': TrainingSelect_TrainingFragment } }
    ) } | null } & { ' $fragmentName'?: 'ClerkshipForm_ClerkshipSurveyFragment' };

export type ClerkshipForm_ClerkshipFragment = { __typename?: 'clerkship', id: any, training: (
    { __typename?: 'training', id: any, name: string, featured: boolean }
    & { ' $fragmentRefs'?: { 'TrainingGeneralInfoForm_TrainingFragment': TrainingGeneralInfoForm_TrainingFragment;'TrainingAdminForm_TrainingFragment': TrainingAdminForm_TrainingFragment } }
  ) } & { ' $fragmentName'?: 'ClerkshipForm_ClerkshipFragment' };

export type ClerkshipForm_SubmitSurveyMutationVariables = Exact<{
  object: Clerkship_Survey_Insert_Input;
}>;


export type ClerkshipForm_SubmitSurveyMutation = { __typename?: 'mutation_root', survey: { __typename?: 'clerkship_survey', id: any } | null };

export type FellowshipForm_FellowshipSurveyFragment = { __typename?: 'fellowship_survey', id: any, subspecialty: string, compensation: string, residencyOther: string, programLength: number | null, positionsPerYear: number | null, shiftsPerMonth: number | null, moonlightingAllowed: string, advancedDegrees: Array<string>, degreeGrantingInstitution: string, clinicalExp: string, researchProject: string, trainingSurvey: (
    { __typename?: 'training_survey', id: any }
    & { ' $fragmentRefs'?: { 'TrainingGeneralInfoForm_TrainingSurveyFragment': TrainingGeneralInfoForm_TrainingSurveyFragment } }
  ), residency: { __typename?: 'residency', id: any, training: (
      { __typename?: 'training', id: any }
      & { ' $fragmentRefs'?: { 'TrainingSelect_TrainingFragment': TrainingSelect_TrainingFragment } }
    ) } | null } & { ' $fragmentName'?: 'FellowshipForm_FellowshipSurveyFragment' };

export type FellowshipForm_FellowshipFragment = { __typename?: 'fellowship', id: any, training: (
    { __typename?: 'training', id: any, name: string, featured: boolean }
    & { ' $fragmentRefs'?: { 'TrainingGeneralInfoForm_TrainingFragment': TrainingGeneralInfoForm_TrainingFragment;'TrainingAdminForm_TrainingFragment': TrainingAdminForm_TrainingFragment } }
  ) } & { ' $fragmentName'?: 'FellowshipForm_FellowshipFragment' };

export type FellowshipForm_SubmitSurveyMutationVariables = Exact<{
  object: Fellowship_Survey_Insert_Input;
}>;


export type FellowshipForm_SubmitSurveyMutation = { __typename?: 'mutation_root', survey: { __typename?: 'fellowship_survey', id: any } | null };

export type ResidencyForm_ResidencySurveyFragment = { __typename?: 'residency_survey', id: any, moonlighting: boolean | null, nrmpId: string, acgmeId: string, programLength: number | null, primaryTrainingSite: string, secondaryTrainingSite: string, shiftLength: string, shiftsPerMonth: string, pgy1PercentOffService: number | null, step1Failures: boolean | null, step1Cutoff: string, availableInternPositions: number | null, percentOsteopath: string, percentImg: string, electiveWeeks: number | null, criticalCareWeeks: number | null, militaryBranch: string, visaSponsorship: string, sloesForInterview: number | null, usmleComlex1Preference: string, usmleComlex2Preference: string, applicationsReceived: number | null, inPersonSecondLooks: boolean | null, cordApicInterview: boolean | null, specialty: Array<string>, trainingSurvey: (
    { __typename?: 'training_survey', id: any }
    & { ' $fragmentRefs'?: { 'TrainingGeneralInfoForm_TrainingSurveyFragment': TrainingGeneralInfoForm_TrainingSurveyFragment } }
  ) } & { ' $fragmentName'?: 'ResidencyForm_ResidencySurveyFragment' };

export type ResidencyForm_ResidencyFragment = { __typename?: 'residency', id: any, emrafied: boolean, pdInterview: string, training: (
    { __typename?: 'training', id: any, name: string, featured: boolean }
    & { ' $fragmentRefs'?: { 'TrainingGeneralInfoForm_TrainingFragment': TrainingGeneralInfoForm_TrainingFragment;'TrainingAdminForm_TrainingFragment': TrainingAdminForm_TrainingFragment } }
  ) } & { ' $fragmentName'?: 'ResidencyForm_ResidencyFragment' };

export type ResidencyForm_SubmitSurveyMutationVariables = Exact<{
  object: Residency_Survey_Insert_Input;
}>;


export type ResidencyForm_SubmitSurveyMutation = { __typename?: 'mutation_root', survey: { __typename?: 'residency_survey', id: any } | null };

export type TrainingAdminForm_TrainingFragment = { __typename?: 'training', id: any, name: string, type: any, featured: boolean, emraAccountNo: string | null, residency: { __typename?: 'residency', id: any, emrafied: boolean, pdInterview: string } | null, upcomingEvents: Array<{ __typename?: 'training_event', id: any, name: string, url: string, eventDate: any }> } & { ' $fragmentName'?: 'TrainingAdminForm_TrainingFragment' };

export type TrainingAdminForm_AcceptSurveyMutationVariables = Exact<{
  surveyId: Scalars['String'];
  featured: Scalars['Boolean'];
  emrafied?: InputMaybe<Scalars['Boolean']>;
  pdInterview?: InputMaybe<Scalars['String']>;
  upcomingEvents?: InputMaybe<Array<UpdateTrainingSurveyStatusEventInput> | UpdateTrainingSurveyStatusEventInput>;
  emraAccountNo?: InputMaybe<Scalars['String']>;
}>;


export type TrainingAdminForm_AcceptSurveyMutation = { __typename?: 'mutation_root', update_training_survey_status: { __typename?: 'UpdateTrainingSurveyStatusResult', trainingSurvey: { __typename?: 'training_survey', id: any, status: any | null } | null } };

export type TrainingGeneralInfoForm_TrainingFragment = { __typename?: 'training', id: any, name: string } & { ' $fragmentName'?: 'TrainingGeneralInfoForm_TrainingFragment' };

export type TrainingGeneralInfoForm_TrainingSurveyFragment = { __typename?: 'training_survey', id: any, name: string, city: string, state: string, zipcode: string, description: string, website: string, twitter: string, facebook: string, instagram: string, youtube: string, vimeo: string, streetAddress1: string, streetAddress2: string, directorName: string, directorEmail: string, coordinatorName: string, coordinatorEmail: string, multimediaUrls: Array<string>, trainingSites: Array<{ __typename?: 'training_survey_site', id: any, primary: boolean, facilityOther: string, facility: (
      { __typename?: 'facility', id: any }
      & { ' $fragmentRefs'?: { 'FacilitySelect_FacilityFragment': FacilitySelect_FacilityFragment } }
    ) | null }>, pictures: Array<{ __typename?: 'training_survey_picture', id: any, picture: (
      { __typename?: 'file', id: any }
      & { ' $fragmentRefs'?: { 'FileUpload_FileFragment': FileUpload_FileFragment } }
    ) }> } & { ' $fragmentName'?: 'TrainingGeneralInfoForm_TrainingSurveyFragment' };

export type TrainingSelect_TrainingFragment = { __typename?: 'training', id: any, name: string, type: any, residency: { __typename?: 'residency', id: any, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: { __typename?: 'residency_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, city: string, state: string } } | null } | null } | null, clerkship: { __typename?: 'clerkship', id: any, latestSurvey: { __typename?: 'latest_clerkship_survey', id: any | null, survey: { __typename?: 'clerkship_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, city: string, state: string } } | null } | null } | null, fellowship: { __typename?: 'fellowship', id: any, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: { __typename?: 'fellowship_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, city: string, state: string } } | null } | null } | null } & { ' $fragmentName'?: 'TrainingSelect_TrainingFragment' };

export type TrainingSelect_SearchTrainingsQueryVariables = Exact<{
  search: Scalars['String'];
  type: Scalars['trainingtype'];
}>;


export type TrainingSelect_SearchTrainingsQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_training_by_prefix_result', id: any | null, training: (
      { __typename?: 'training' }
      & { ' $fragmentRefs'?: { 'TrainingSelect_TrainingFragment': TrainingSelect_TrainingFragment } }
    ) | null }> };

export type EmraFellowshipEdit_FellowshipQueryVariables = Exact<{
  trainingId: Scalars['uuid'];
}>;


export type EmraFellowshipEdit_FellowshipQuery = { __typename?: 'query_root', program: (
    { __typename?: 'fellowship', id: any, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: (
        { __typename?: 'fellowship_survey', id: any }
        & { ' $fragmentRefs'?: { 'FellowshipForm_FellowshipSurveyFragment': FellowshipForm_FellowshipSurveyFragment } }
      ) | null } | null }
    & { ' $fragmentRefs'?: { 'FellowshipForm_FellowshipFragment': FellowshipForm_FellowshipFragment } }
  ) | null };

export type EmraFellowshipSurveyShow_FellowshipSurveyQueryVariables = Exact<{
  surveyId: Scalars['uuid'];
}>;


export type EmraFellowshipSurveyShow_FellowshipSurveyQuery = { __typename?: 'query_root', survey: (
    { __typename?: 'fellowship_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, name: string }, fellowship: (
      { __typename?: 'fellowship', id: any, training: { __typename?: 'training', id: any, slug: string, name: string }, latestSurvey: { __typename?: 'latest_fellowship_survey', id: any | null, survey: (
          { __typename?: 'fellowship_survey', id: any }
          & { ' $fragmentRefs'?: { 'FellowshipForm_FellowshipSurveyFragment': FellowshipForm_FellowshipSurveyFragment } }
        ) | null } | null }
      & { ' $fragmentRefs'?: { 'FellowshipForm_FellowshipFragment': FellowshipForm_FellowshipFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'FellowshipForm_FellowshipSurveyFragment': FellowshipForm_FellowshipSurveyFragment } }
  ) | null };

export type EmraResidencyEdit_ResidencyQueryVariables = Exact<{
  trainingId: Scalars['uuid'];
}>;


export type EmraResidencyEdit_ResidencyQuery = { __typename?: 'query_root', program: (
    { __typename?: 'residency', id: any, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: (
        { __typename?: 'residency_survey', id: any }
        & { ' $fragmentRefs'?: { 'ResidencyForm_ResidencySurveyFragment': ResidencyForm_ResidencySurveyFragment } }
      ) | null } | null }
    & { ' $fragmentRefs'?: { 'ResidencyForm_ResidencyFragment': ResidencyForm_ResidencyFragment } }
  ) | null };

export type EmraResidencySurveyShow_ResidencySurveyQueryVariables = Exact<{
  surveyId: Scalars['uuid'];
}>;


export type EmraResidencySurveyShow_ResidencySurveyQuery = { __typename?: 'query_root', survey: (
    { __typename?: 'residency_survey', id: any, trainingSurvey: { __typename?: 'training_survey', id: any, name: string }, residency: (
      { __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, slug: string, name: string }, latestSurvey: { __typename?: 'latest_residency_survey', id: any | null, survey: (
          { __typename?: 'residency_survey', id: any }
          & { ' $fragmentRefs'?: { 'ResidencyForm_ResidencySurveyFragment': ResidencyForm_ResidencySurveyFragment } }
        ) | null } | null }
      & { ' $fragmentRefs'?: { 'ResidencyForm_ResidencyFragment': ResidencyForm_ResidencyFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'ResidencyForm_ResidencySurveyFragment': ResidencyForm_ResidencySurveyFragment } }
  ) | null };

export type Map_GeoSearchRankedFacilitiesQueryVariables = Exact<{
  xMin: Scalars['float8'];
  xMax: Scalars['float8'];
  yMin: Scalars['float8'];
  yMax: Scalars['float8'];
  placeId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  filters: Facility_Bool_Exp;
  profession: Scalars['profession'];
  includeNearby: Scalars['Boolean'];
}>;


export type Map_GeoSearchRankedFacilitiesQuery = { __typename?: 'query_root', jobs: Array<{ __typename?: 'search_job_postings_by_geography_result', id: any, posting: (
      { __typename?: 'job_posting', id: any }
      & { ' $fragmentRefs'?: { 'Map_PostingFragment': Map_PostingFragment } }
    ) | null }>, rankedFacilities: Array<{ __typename?: 'ranked_facility', id: any | null, facility: (
      { __typename?: 'facility', id: any }
      & { ' $fragmentRefs'?: { 'Map_FacilityFragment': Map_FacilityFragment } }
    ) | null }>, nearbyFacilities: Array<(
    { __typename?: 'nearby_facilities_by_geography_result', id: any | null }
    & { ' $fragmentRefs'?: { 'Map_NearbyFacilityFragment': Map_NearbyFacilityFragment } }
  )> };

export type Map_NearbyFacilityFragment = { __typename?: 'nearby_facilities_by_geography_result', id: any | null, distance: any | null, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string, numPostings: number | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null, maxRatePosting: Array<{ __typename?: 'job_posting', id: any, slug: string, title: string, wageTrunc: string, hasRate: boolean, ratePeriod: any | null, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, normRate: number | null }> | null, contracts: Array<(
      { __typename?: 'facility_contract', id: any }
      & { ' $fragmentRefs'?: { 'Map_ContractFragment': Map_ContractFragment } }
    )> } | null } & { ' $fragmentName'?: 'Map_NearbyFacilityFragment' };

export type Map_GetFacilityQueryVariables = Exact<{
  id: Scalars['uuid'];
  profession: Scalars['profession'];
}>;


export type Map_GetFacilityQuery = { __typename?: 'query_root', facility: (
    { __typename?: 'facility', id: any }
    & { ' $fragmentRefs'?: { 'Map_FacilityFragment': Map_FacilityFragment } }
  ) | null };

export type Map_ContractFragment = (
  { __typename?: 'facility_contract', id: any, lastAppliedDate: any | null, lastApplied: any | null, org: { __typename?: 'organization', id: any, name: string, active: boolean } }
  & { ' $fragmentRefs'?: { 'ApplyToJobPopup_ContractFragment': ApplyToJobPopup_ContractFragment } }
) & { ' $fragmentName'?: 'Map_ContractFragment' };

export type Map_FacilityFragment = { __typename?: 'facility', id: any, name: string, slug: string, facilityType: string, location: any | null, city: string, state: string, immediateNeeds: boolean, adultTraumaLvl: number | null, freestandingEr: boolean, numPostings: number | null, featured: boolean | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null, residencies: Array<{ __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string } }> | null, cmsFacilityPos: { __typename?: 'cms_facility_pos', id: string, providerSubtype: string } | null, cmsFacilityEnrollment: { __typename?: 'cms_facility_enrollment', id: string, providerTypeCode: string } | null, cmsFacility: { __typename?: 'cms_facility', id: string, hospitalType: string, metrics: Array<{ __typename?: 'cms_facility_metric', id: any, score: string | null, measureId: string }>, facilities: Array<{ __typename?: 'facility', id: any, name: string }> } | null, ahaFacility: { __typename?: 'AS22DEM', rollups: Array<string>, id: string, units: Array<{ __typename?: 'AS22UNIT', id: string, name: string, par: { __typename?: 'AS22DEM', id: string, name: string | null } }> } | null, maxRatePosting: Array<{ __typename?: 'job_posting', id: any, slug: string, title: string, wageTrunc: string, hasRate: boolean, ratePeriod: any | null, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, normRate: number | null }> | null, contracts: Array<(
    { __typename?: 'facility_contract', id: any }
    & { ' $fragmentRefs'?: { 'Map_ContractFragment': Map_ContractFragment } }
  )>, reviewAgg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', rating: number | null } | null } | null }, accreditations: Array<{ __typename?: 'facility_accreditation', id: any, accreditation: string, level: string }> } & { ' $fragmentName'?: 'Map_FacilityFragment' };

export type Map_PostingFragment = (
  { __typename?: 'job_posting', id: any, slug: string, title: string, description: string, wageTrunc: string, descriptionHtml: string, hasRate: boolean, ratePeriod: any | null, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, normRate: number | null, contract: (
    { __typename?: 'facility_contract', id: any, facility: (
      { __typename?: 'facility', id: any }
      & { ' $fragmentRefs'?: { 'Map_FacilityFragment': Map_FacilityFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'Map_ContractFragment': Map_ContractFragment } }
  ), workerClassifications: Array<{ __typename?: 'posting_worker_classification', id: any, worker: any }> }
  & { ' $fragmentRefs'?: { 'ApplyToJobPopup_PostingFragment': ApplyToJobPopup_PostingFragment } }
) & { ' $fragmentName'?: 'Map_PostingFragment' };

export type EmployerListPopover_ContractFragment = (
  { __typename?: 'facility_contract', id: any, org: { __typename?: 'organization', id: any, name: string, ownershipStructure: any | null } }
  & { ' $fragmentRefs'?: { 'ApplyToJobButton_ContractFragment': ApplyToJobButton_ContractFragment } }
) & { ' $fragmentName'?: 'EmployerListPopover_ContractFragment' };

export type FacilityJobs_FacilityQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
}>;


export type FacilityJobs_FacilityQuery = { __typename?: 'query_root', facility: (
    { __typename?: 'facility', id: any, contracts: Array<(
      { __typename?: 'facility_contract', id: any, isOwner: boolean | null }
      & { ' $fragmentRefs'?: { 'ApplyToJobButton_ContractFragment': ApplyToJobButton_ContractFragment } }
    )>, postings: Array<{ __typename?: 'job_posting', id: any }> | null }
    & { ' $fragmentRefs'?: { 'FacilityJobs_FacilityFragment': FacilityJobs_FacilityFragment } }
  ) | null };

export type FacilityJobs_FacilityFragment = { __typename?: 'facility', id: any, postings: Array<{ __typename?: 'job_posting', id: any, slug: string, lastModifiedDate: any | null, title: string, wageTrunc: string, schedule: any | null, lastModified: any, hasRate: boolean, ratePeriod: any | null, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }> }> | null, contracts: Array<(
    { __typename?: 'facility_contract', id: any, isOwner: boolean | null }
    & { ' $fragmentRefs'?: { 'ApplyToJobButton_ContractFragment': ApplyToJobButton_ContractFragment } }
  )> } & { ' $fragmentName'?: 'FacilityJobs_FacilityFragment' };

export type CorrectionToast_FacilityFragment = (
  { __typename?: 'facility', id: any }
  & { ' $fragmentRefs'?: { 'ReportCorrection_FacilityFragment': ReportCorrection_FacilityFragment } }
) & { ' $fragmentName'?: 'CorrectionToast_FacilityFragment' };

export type FacilityDescription_FacilityFragment = { __typename?: 'facility', id: any, description: string } & { ' $fragmentName'?: 'FacilityDescription_FacilityFragment' };

export type FacilityFeatures_FacilityFragment = (
  { __typename?: 'facility', id: any, name: string, state: string, facilityType: string, adultTraumaLvl: number | null, freestandingEr: boolean, residencies: Array<{ __typename?: 'residency', id: any, training: { __typename?: 'training', id: any, name: string, slug: string } }> | null, strokeCerts: Array<{ __typename?: 'stroke_cert', id: any, level: any }>, ehrs: Array<{ __typename?: 'facility_ehr', id: any, name: string }>, cmsFacility: { __typename?: 'cms_facility', id: string, overallRating: number | null, hospitalType: string, metrics: Array<{ __typename?: 'cms_facility_metric', id: any, score: string | null, measureId: string }>, facilities: Array<{ __typename?: 'facility', id: any, name: string }> } | null, cmsFacilityPos: { __typename?: 'cms_facility_pos', id: string, providerSubtype: string } | null, cmsFacilityEnrollment: { __typename?: 'cms_facility_enrollment', id: string, providerTypeCode: string } | null, ahaFacility: { __typename?: 'AS22DEM', rollups: Array<string>, id: string, medSchool: string | null, healthSystem: string | null, svc1: { __typename?: 'AS22SVC1', id: string, cathLab: string | null, hospBeds: any | null, genBeds: any | null, genPedBeds: any | null, msicBeds: any | null, pedicBeds: any | null, burnBeds: any | null, psychBeds: any | null } | null, svc2: { __typename?: 'AS22SVC2', id: string, psychOutpatientServices: string | null, pscyhEmergencyServices: string | null, psychPedBeds: any | null, psychGerBeds: any | null } | null, units: Array<{ __typename?: 'AS22UNIT', id: string, name: string, par: { __typename?: 'AS22DEM', id: string, name: string | null } }> } | null, contracts: Array<{ __typename?: 'facility_contract', id: any, org: { __typename?: 'organization', id: any, ownershipStructure: any | null } }>, accreditations: Array<{ __typename?: 'facility_accreditation', id: any, accreditation: string, level: string }> }
  & { ' $fragmentRefs'?: { 'ReportCorrection_FacilityFragment': ReportCorrection_FacilityFragment } }
) & { ' $fragmentName'?: 'FacilityFeatures_FacilityFragment' };

export type FacilityGallery_FacilityFragment = { __typename?: 'facility', picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null } & { ' $fragmentName'?: 'FacilityGallery_FacilityFragment' };

export type FacilityNearby_RankedFacilitiesQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
  profession: Scalars['profession'];
  radius: Scalars['Int'];
}>;


export type FacilityNearby_RankedFacilitiesQuery = { __typename?: 'query_root', rankedFacilities: Array<(
    { __typename?: 'ranked_facility' }
    & { ' $fragmentRefs'?: { 'FacilitySuggestions_RankedFacilityFragment': FacilitySuggestions_RankedFacilityFragment } }
  )> };

export type FacilityNearby_FacilityFragment = { __typename?: 'facility', id: any } & { ' $fragmentName'?: 'FacilityNearby_FacilityFragment' };

export type FacilityProfile_FacilityQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
  isOrgUser: Scalars['Boolean'];
}>;


export type FacilityProfile_FacilityQuery = { __typename?: 'query_root', facility: (
    { __typename?: 'facility', id: any, description: string, contracts: Array<(
      { __typename?: 'facility_contract', id: any, lastAppliedDate: any | null, isOwner: boolean | null, lastApplied: any | null }
      & { ' $fragmentRefs'?: { 'EmployerInfo_ContractFragment': EmployerInfo_ContractFragment;'EmployerListPopover_ContractFragment': EmployerListPopover_ContractFragment } }
    )>, contractChanges: Array<{ __typename?: 'facility_contract', id: any, active: boolean, changeRequest: any | null }>, postings: Array<{ __typename?: 'job_posting', id: any }> | null }
    & { ' $fragmentRefs'?: { 'FacilityNearby_FacilityFragment': FacilityNearby_FacilityFragment;'FacilityFeatures_FacilityFragment': FacilityFeatures_FacilityFragment;'FacilityDescription_FacilityFragment': FacilityDescription_FacilityFragment;'FacilityGallery_FacilityFragment': FacilityGallery_FacilityFragment;'CorrectionToast_FacilityFragment': CorrectionToast_FacilityFragment } }
  ) | null };

export type ReportCorrection_SearchOrgsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type ReportCorrection_SearchOrgsQuery = { __typename?: 'query_root', search: Array<{ __typename?: 'search_organization_by_prefix_result', id: any | null, org: { __typename?: 'organization', id: any, name: string } | null }> };

export type ReportCorrection_SubmitCorrectionMutationVariables = Exact<{
  input: Facility_Correction_Insert_Input;
}>;


export type ReportCorrection_SubmitCorrectionMutation = { __typename?: 'mutation_root', insert_facility_correction_one: { __typename?: 'facility_correction', id: any } | null };

export type ReportCorrection_FacilityFragment = { __typename?: 'facility', id: any, name: string } & { ' $fragmentName'?: 'ReportCorrection_FacilityFragment' };

export type FacilityEditForms_UpdateDescriptionMutationVariables = Exact<{
  facilityId: Scalars['uuid'];
  description: Scalars['String'];
}>;


export type FacilityEditForms_UpdateDescriptionMutation = { __typename?: 'mutation_root', update_facility_by_pk: { __typename?: 'facility', id: any } | null };

export type FacilityGalleryForm_UpdateGalleryMutationVariables = Exact<{
  facilityId: Scalars['uuid'];
  pictureId: Scalars['uuid'];
}>;


export type FacilityGalleryForm_UpdateGalleryMutation = { __typename?: 'mutation_root', change_facility_picture: Array<{ __typename?: 'facility', id: any }> };

export type FacilityReviews_FacilityQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
}>;


export type FacilityReviews_FacilityQuery = { __typename?: 'query_root', facility: { __typename?: 'facility', id: any, agg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', rating: number | null } | null } | null }, ratings: Array<{ __typename?: 'facility_rating', count: any | null, value: number | null }>, contracts: Array<{ __typename?: 'facility_contract', id: any, isOwner: boolean | null }> } | null };

export type FacilitySalary_FacilityQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
}>;


export type FacilitySalary_FacilityQuery = { __typename?: 'query_root', facility: { __typename?: 'facility', id: any, name: string } | null };

export type FacilityShow_FacilityQueryVariables = Exact<{
  facilityId: Scalars['uuid'];
}>;


export type FacilityShow_FacilityQuery = { __typename?: 'query_root', facility: (
    { __typename?: 'facility', id: any, slug: string, name: string, city: string, state: string, streetAddr1: string, streetAddr2: string, picture: { __typename?: 'file', id: any, filename: string, publicUrl: string } | null, contracts: Array<(
      { __typename?: 'facility_contract', id: any, lastAppliedDate: any | null, lastApplied: any | null, isOwner: boolean | null, org: (
        { __typename?: 'organization', id: any, name: string, slug: string }
        & { ' $fragmentRefs'?: { 'ReviewPopup_OrganizationFragment': ReviewPopup_OrganizationFragment } }
      ) }
      & { ' $fragmentRefs'?: { 'EmployerListPopover_ContractFragment': EmployerListPopover_ContractFragment;'ApplyToJobButton_ContractFragment': ApplyToJobButton_ContractFragment } }
    )>, reviewsAgg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', rating: number | null } | null } | null }, postings: Array<{ __typename?: 'job_posting', id: any, professionsCt: { __typename?: 'posting_profession_aggregate', aggregate: { __typename?: 'posting_profession_aggregate_fields', count: number } | null } }> | null, salaryAgg: { __typename?: 'salary_report_fmt_aggregate', aggregate: { __typename?: 'salary_report_fmt_aggregate_fields', count: number } | null } }
    & { ' $fragmentRefs'?: { 'SalaryReportPopup_FacilityFragment': SalaryReportPopup_FacilityFragment;'ReviewPopup_FacilityFragment': ReviewPopup_FacilityFragment } }
  ) | null };

export type JobPostingCreate_ResolveContractQueryVariables = Exact<{
  contractId: Scalars['uuid'];
}>;


export type JobPostingCreate_ResolveContractQuery = { __typename?: 'query_root', contract: (
    { __typename?: 'facility_contract', id: any }
    & { ' $fragmentRefs'?: { 'JobPostingFormGeneralInfo_ContractFragment': JobPostingFormGeneralInfo_ContractFragment } }
  ) | null };

export type JobPostingCreate_CreateMutationVariables = Exact<{
  data: Job_Posting_Insert_Input;
}>;


export type JobPostingCreate_CreateMutation = { __typename?: 'mutation_root', posting: { __typename?: 'job_posting', id: any, slug: string } | null };

export type JobPostingEdit_GetPostingQueryVariables = Exact<{
  postingId: Scalars['uuid'];
}>;


export type JobPostingEdit_GetPostingQuery = { __typename?: 'query_root', posting: (
    { __typename?: 'job_posting', id: any }
    & { ' $fragmentRefs'?: { 'JobPostingForm_PostingFragment': JobPostingForm_PostingFragment } }
  ) | null };

export type JobPostingEdit_UpdatePostingMutationVariables = Exact<{
  postingId: Scalars['uuid'];
  posting: Job_Posting_Set_Input;
  workerClassifications: Array<Posting_Worker_Classification_Insert_Input> | Posting_Worker_Classification_Insert_Input;
  professions: Array<Posting_Profession_Insert_Input> | Posting_Profession_Insert_Input;
  appCerts: Array<Posting_App_Cert_Insert_Input> | Posting_App_Cert_Insert_Input;
  boardCerts: Array<Posting_Board_Cert_Insert_Input> | Posting_Board_Cert_Insert_Input;
}>;


export type JobPostingEdit_UpdatePostingMutation = { __typename?: 'mutation_root', posting: { __typename?: 'job_posting', id: any, slug: string } | null, delete_posting_profession: { __typename?: 'posting_profession_mutation_response', returning: Array<{ __typename?: 'posting_profession', id: any }> } | null, delete_posting_app_cert: { __typename?: 'posting_app_cert_mutation_response', returning: Array<{ __typename?: 'posting_app_cert', id: any }> } | null, delete_posting_board_cert: { __typename?: 'posting_board_cert_mutation_response', returning: Array<{ __typename?: 'posting_board_cert', id: any }> } | null, delete_posting_worker_classification: { __typename?: 'posting_worker_classification_mutation_response', returning: Array<{ __typename?: 'posting_worker_classification', id: any }> } | null, insert_posting_profession: { __typename?: 'posting_profession_mutation_response', returning: Array<{ __typename?: 'posting_profession', id: any }> } | null, insert_posting_app_cert: { __typename?: 'posting_app_cert_mutation_response', returning: Array<{ __typename?: 'posting_app_cert', id: any }> } | null, insert_posting_board_cert: { __typename?: 'posting_board_cert_mutation_response', returning: Array<{ __typename?: 'posting_board_cert', id: any }> } | null, insert_posting_worker_classification: { __typename?: 'posting_worker_classification_mutation_response', returning: Array<{ __typename?: 'posting_worker_classification', id: any }> } | null };

export type JobPostingDescription_PostingFragment = { __typename?: 'job_posting', id: any, description: string, descriptionHtml: string } & { ' $fragmentName'?: 'JobPostingDescription_PostingFragment' };

export type JobPostingDetails_PostingFragment = { __typename?: 'job_posting', id: any, cme: boolean, hasSigningBonus: boolean, hasRelocationAssist: boolean, hasPerfBonus: boolean, malpracticeInsurance: boolean, tailCoverage: boolean, equity: boolean, healthInsurance: boolean, dentalInsurance: boolean, visionInsurance: boolean, healthAccount: boolean, disabilityInsurance: boolean, lifeInsurance: boolean, retirement: boolean, paidVacation: boolean, paidParental: boolean, studentLoan: boolean } & { ' $fragmentName'?: 'JobPostingDetails_PostingFragment' };

export type JobPostingEmployer_PostingFragment = { __typename?: 'job_posting', id: any, contract: (
    { __typename?: 'facility_contract', id: any }
    & { ' $fragmentRefs'?: { 'EmployerInfo_ContractFragment': EmployerInfo_ContractFragment } }
  ) } & { ' $fragmentName'?: 'JobPostingEmployer_PostingFragment' };

export type JobPostingFacility_PostingFragment = { __typename?: 'job_posting', id: any, contract: { __typename?: 'facility_contract', id: any, facility: (
      { __typename?: 'facility' }
      & { ' $fragmentRefs'?: { 'FacilityCard_FacilityFragment': FacilityCard_FacilityFragment } }
    ) } } & { ' $fragmentName'?: 'JobPostingFacility_PostingFragment' };

export type JobPostingOverview_PostingFragment = { __typename?: 'job_posting', id: any, schedule: any | null, term: any | null, startOrTodayDate: any | null, startDate: any | null, hasRate: boolean, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, ratePeriod: any | null, j1Visa: boolean | null, h1bVisa: boolean | null, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, workerClassifications: Array<{ __typename?: 'posting_worker_classification', id: any, worker: any }> } & { ' $fragmentName'?: 'JobPostingOverview_PostingFragment' };

export type JobPostingQualifications_PostingFragment = { __typename?: 'job_posting', id: any, bcbe: boolean | null, experience: number | null, currentLicense: boolean | null, expReq: boolean | null, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, boardCerts: Array<{ __typename?: 'posting_board_cert', id: any, cert: { __typename?: 'board_cert', id: any, field: string, board: { __typename?: 'board', id: any, name: string } } }>, appCerts: Array<{ __typename?: 'posting_app_cert', id: any, name: string }> } & { ' $fragmentName'?: 'JobPostingQualifications_PostingFragment' };

export type JobPostingShow_ViewJobPostingQueryVariables = Exact<{
  postingId: Scalars['uuid'];
  profession?: InputMaybe<Scalars['profession']>;
  isOrgUser: Scalars['Boolean'];
}>;


export type JobPostingShow_ViewJobPostingQuery = { __typename?: 'query_root', posting: (
    { __typename?: 'job_posting', id: any, slug: string, title: string, active: boolean, expirationDate: any | null, lastModified: any, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, creator: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null } } | null, modifier: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null } } | null, contract: (
      { __typename?: 'facility_contract', id: any, active: boolean, lastAppliedDate: any | null, isOwner: boolean | null, lastApplied: any | null, changeRequest: any | null, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, org: { __typename?: 'organization', id: any, name: string, slug: string } }
      & { ' $fragmentRefs'?: { 'ApplyToJobButton_ContractFragment': ApplyToJobButton_ContractFragment } }
    ) }
    & { ' $fragmentRefs'?: { 'JobPostingStructuredData_PostingFragment': JobPostingStructuredData_PostingFragment;'JobPostingQualifications_PostingFragment': JobPostingQualifications_PostingFragment;'JobPostingDetails_PostingFragment': JobPostingDetails_PostingFragment;'JobPostingDescription_PostingFragment': JobPostingDescription_PostingFragment;'ApplyToJobPopup_PostingFragment': ApplyToJobPopup_PostingFragment;'JobPostingEmployer_PostingFragment': JobPostingEmployer_PostingFragment;'JobPostingFacility_PostingFragment': JobPostingFacility_PostingFragment;'JobPostingOverview_PostingFragment': JobPostingOverview_PostingFragment;'ChangePostingStatusPopup_PostingFragment': ChangePostingStatusPopup_PostingFragment } }
  ) | null };

export type JobPostingStructuredData_PostingFragment = { __typename?: 'job_posting', id: any, slug: string, title: string, description: string, createdAtDate: any, schedule: any | null, term: any | null, descriptionHtml: string, createdAt: any, hasRate: boolean, isExactRate: boolean | null, exactRate: number | null, minRate: number | null, maxRate: number | null, ratePeriod: any | null, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, workerClassifications: Array<{ __typename?: 'posting_worker_classification', id: any, worker: any }>, boardCerts: Array<{ __typename?: 'posting_board_cert', id: any, cert: { __typename?: 'board_cert', id: any, field: string, board: { __typename?: 'board', id: any, name: string } } }>, appCerts: Array<{ __typename?: 'posting_app_cert', id: any, name: string }>, contract: { __typename?: 'facility_contract', id: any, org: { __typename?: 'organization', id: any, name: string, website: string }, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string, zipcode: string, streetAddr1: string, streetAddr2: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null } } } & { ' $fragmentName'?: 'JobPostingStructuredData_PostingFragment' };

export type JobPostingCard_JobPostingInfoFragment = { __typename?: 'job_posting', id: any, slug: string, active: boolean, title: string, lastModifiedDate: any | null, lastModified: any, expirationDate: any | null, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, contract: { __typename?: 'facility_contract', id: any, active: boolean, changeRequest: any | null, facility: { __typename?: 'facility', id: any, slug: string, name: string, state: string, city: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null } } }, latestPublication: { __typename?: 'posting_latest_publication', publishedAt: any | null } | null, creator: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null } } | null, modifier: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null } } | null, impressions: { __typename?: 'bqanalytics_job_posting_impressions', count: number | null } | null } & { ' $fragmentName'?: 'JobPostingCard_JobPostingInfoFragment' };

export type JobPostingList_SearchJobPostingsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  orderBy?: InputMaybe<Array<Relevant_Job_Posting_Order_By> | Relevant_Job_Posting_Order_By>;
  search: Scalars['String'];
  filters: Relevant_Job_Posting_Bool_Exp;
  dateInPast: Scalars['timestamp'];
  orgId: Scalars['uuid'];
  expirationDate: Scalars['date'];
}>;


export type JobPostingList_SearchJobPostingsQuery = { __typename?: 'query_root', relevantJobPostings: Array<{ __typename?: 'relevant_job_posting', id: any | null, jobPosting: (
      { __typename?: 'job_posting', id: any }
      & { ' $fragmentRefs'?: { 'JobPostingCard_JobPostingInfoFragment': JobPostingCard_JobPostingInfoFragment;'JobPostingTable_JobPostingInfoFragment': JobPostingTable_JobPostingInfoFragment } }
    ) | null }>, agg: { __typename?: 'relevant_job_posting_aggregate', aggregate: { __typename?: 'relevant_job_posting_aggregate_fields', count: number } | null }, aggActive: { __typename?: 'relevant_job_posting_aggregate', aggregate: { __typename?: 'relevant_job_posting_aggregate_fields', count: number } | null }, aggExpiringSoon: { __typename?: 'relevant_job_posting_aggregate', aggregate: { __typename?: 'relevant_job_posting_aggregate_fields', count: number } | null }, aggInactive: { __typename?: 'relevant_job_posting_aggregate', aggregate: { __typename?: 'relevant_job_posting_aggregate_fields', count: number } | null } };

export type JobPostingList_BulkUpdateJobPostingMutationVariables = Exact<{
  jobPostingIds: Array<Scalars['uuid']> | Scalars['uuid'];
  active: Scalars['Boolean'];
  expirationDate?: InputMaybe<Scalars['date']>;
}>;


export type JobPostingList_BulkUpdateJobPostingMutation = { __typename?: 'mutation_root', update_job_posting: { __typename?: 'job_posting_mutation_response', returning: Array<{ __typename?: 'job_posting', id: any }> } | null };

export type JobPostingTable_JobPostingInfoFragment = { __typename?: 'job_posting', id: any, slug: string, active: boolean, title: string, lastModifiedDate: any | null, lastModified: any, expirationDate: any | null, professions: Array<{ __typename?: 'posting_profession', id: any, profession: any }>, contract: { __typename?: 'facility_contract', id: any, active: boolean, changeRequest: any | null, facility: { __typename?: 'facility', id: any, slug: string, name: string, state: string, city: string, picture: { __typename?: 'file', id: any, publicUrl: string } | null }, recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null } } }, latestPublication: { __typename?: 'posting_latest_publication', publishedAt: any | null } | null, creator: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null } } | null, modifier: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', firstName: string | null, lastName: string | null, fullName: string | null } | null } } | null, impressions: { __typename?: 'bqanalytics_job_posting_impressions', count: number | null } | null } & { ' $fragmentName'?: 'JobPostingTable_JobPostingInfoFragment' };

export type FeaturedJobs_RankedFacilitiesQueryVariables = Exact<{
  x: Scalars['float8'];
  y: Scalars['float8'];
  profession: Scalars['profession'];
  limit: Scalars['Int'];
}>;


export type FeaturedJobs_RankedFacilitiesQuery = { __typename?: 'query_root', rankedFacilities: Array<(
    { __typename?: 'ranked_facility' }
    & { ' $fragmentRefs'?: { 'FacilitySuggestions_RankedFacilityFragment': FacilitySuggestions_RankedFacilityFragment } }
  )> };

export type ForClinicians_FacilityCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ForClinicians_FacilityCountQuery = { __typename?: 'query_root', fac: { __typename?: 'facility_aggregate', aggregate: { __typename?: 'facility_aggregate_fields', count: number } | null }, org: { __typename?: 'organization_aggregate', aggregate: { __typename?: 'organization_aggregate_fields', count: number } | null }, salary: { __typename?: 'relevant_salary_report_aggregate', aggregate: { __typename?: 'relevant_salary_report_aggregate_fields', count: number } | null } };

export type ForEmployers_FacilityCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ForEmployers_FacilityCountQuery = { __typename?: 'query_root', fac: { __typename?: 'facility_aggregate', aggregate: { __typename?: 'facility_aggregate_fields', count: number } | null }, org: { __typename?: 'organization_aggregate', aggregate: { __typename?: 'organization_aggregate_fields', count: number } | null }, jobPostingPrices: Array<{ __typename?: 'ProductPriceGQL', id: string, interval: string, tiers: Array<{ __typename?: 'PriceTierGQL', amount: number, limit: number | null }> }> };

export type StateImpressions_StateBoundaryQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type StateImpressions_StateBoundaryQuery = { __typename?: 'query_root', boundary: Array<{ __typename?: 'place_boundary', id: any, name: string, boundary: any, precision: any, type: any, impressions: { __typename?: 'bqanalytics_facility_map_state_impressions_90', id: string | null, count: number | null } | null }>, bq: { __typename?: 'bqbq_query', info: Array<{ __typename?: 'bqanalytics_facility_map_perf_90', visitors: number | null, impressions: number | null }> } | null };

export type FeauredList_FacilityFragment = { __typename?: 'facility', id: any, name: string, slug: string, ranking_review: number | null, facilityType: string, adultTraumaLvl: number | null, freestandingEr: boolean, cmsFacilityPos: { __typename?: 'cms_facility_pos', id: string, providerSubtype: string } | null, cmsFacilityEnrollment: { __typename?: 'cms_facility_enrollment', id: string, providerTypeCode: string } | null, cmsFacility: { __typename?: 'cms_facility', id: string, hospitalType: string } | null, ahaFacility: { __typename?: 'AS22DEM', id: string } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null, contracts: Array<{ __typename?: 'facility_contract', id: any, org: { __typename?: 'organization', id: any, name: string, slug: string, ownershipStructure: any | null } }>, reviewsAgg: { __typename?: 'review_aggregate', agg: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', ratingJob: number | null } | null } | null } } & { ' $fragmentName'?: 'FeauredList_FacilityFragment' };

export type FeauredList_OrganizationFragment = { __typename?: 'organization', id: any, name: string, slug: string, ranking_review: number | null, ownershipStructure: any | null, logo: { __typename?: 'file', id: any, publicUrl: string } | null, coverPhoto: { __typename?: 'file', id: any, publicUrl: string } | null, contractsAgg: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null }, reviewsAgg: { __typename?: 'review_aggregate', agg: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', ratingOrg: number | null } | null } | null } } & { ' $fragmentName'?: 'FeauredList_OrganizationFragment' };

export type NearbyList_ProxDistanceQueryVariables = Exact<{
  x: Scalars['float8'];
  y: Scalars['float8'];
  limit: Scalars['Int'];
}>;


export type NearbyList_ProxDistanceQuery = { __typename?: 'query_root', facRes: Array<(
    { __typename?: 'facility_dist_result' }
    & { ' $fragmentRefs'?: { 'NearbyList_FacilityDistanceResultFragment': NearbyList_FacilityDistanceResultFragment } }
  )>, orgRes: Array<(
    { __typename?: 'org_dist_result' }
    & { ' $fragmentRefs'?: { 'NearbyList_OrganizationDistanceResultFragment': NearbyList_OrganizationDistanceResultFragment } }
  )> };

export type NearbyList_FacilityDistanceResultFragment = { __typename?: 'facility_dist_result', id: any | null, distance: any | null, facility: { __typename?: 'facility', id: any, name: string, slug: string, ranking_review: number | null, facilityType: string, adultTraumaLvl: number | null, freestandingEr: boolean, cmsFacilityPos: { __typename?: 'cms_facility_pos', id: string, providerSubtype: string } | null, cmsFacilityEnrollment: { __typename?: 'cms_facility_enrollment', id: string, providerTypeCode: string } | null, cmsFacility: { __typename?: 'cms_facility', id: string, hospitalType: string } | null, picture: { __typename?: 'file', id: any, publicUrl: string } | null, contracts: Array<{ __typename?: 'facility_contract', id: any, org: { __typename?: 'organization', id: any, name: string, ownershipStructure: any | null } }>, reviewsAgg: { __typename?: 'review_aggregate', agg: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', ratingJob: number | null } | null } | null } } | null } & { ' $fragmentName'?: 'NearbyList_FacilityDistanceResultFragment' };

export type NearbyList_OrganizationDistanceResultFragment = { __typename?: 'org_dist_result', id: any | null, distance: any | null, organization: { __typename?: 'organization', id: any, slug: string, name: string, ranking_review: number | null, ownershipStructure: any | null, logo: { __typename?: 'file', id: any, publicUrl: string } | null, coverPhoto: { __typename?: 'file', id: any, publicUrl: string } | null, contractsAgg: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null }, reviewsAgg: { __typename?: 'review_aggregate', agg: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', ratingOrg: number | null } | null } | null } } | null } & { ' $fragmentName'?: 'NearbyList_OrganizationDistanceResultFragment' };

export type Review_ReviewQueryVariables = Exact<{ [key: string]: never; }>;


export type Review_ReviewQuery = { __typename?: 'query_root', featuredFacilities: Array<(
    { __typename?: 'facility', id: any }
    & { ' $fragmentRefs'?: { 'FeauredList_FacilityFragment': FeauredList_FacilityFragment } }
  )>, featuredOrgs: Array<(
    { __typename?: 'organization', id: any }
    & { ' $fragmentRefs'?: { 'FeauredList_OrganizationFragment': FeauredList_OrganizationFragment } }
  )>, salaryAgg: { __typename?: 'salary_report_fmt_aggregate', aggregate: { __typename?: 'salary_report_fmt_aggregate_fields', count: number } | null } };

export type CheckoutFlow_InfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutFlow_InfoQuery = { __typename?: 'query_root', jobPostingPrices: Array<{ __typename?: 'ProductPriceGQL', id: string, interval: string, tiers: Array<{ __typename?: 'PriceTierGQL', amount: number, limit: number | null }> }> };

export type CheckoutFlow_GetActiveJobPostingsCountQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type CheckoutFlow_GetActiveJobPostingsCountQuery = { __typename?: 'query_root', jobPosting: Array<{ __typename?: 'job_posting', id: any }> };

export type FacilityTab_ManageContractsQueryVariables = Exact<{
  accountId: Scalars['uuid'];
  orgId: Scalars['uuid'];
}>;


export type FacilityTab_ManageContractsQuery = { __typename?: 'query_root', contracts: Array<(
    { __typename?: 'facility_contract', id: any, active: boolean, changeRequest: any | null, facility: { __typename?: 'facility', id: any, name: string, slug: string, city: string, state: string }, recruiter: { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null } }, postings: Array<{ __typename?: 'job_posting', id: any, slug: string, title: string }>, postingsAgg: { __typename?: 'job_posting_aggregate', aggregate: { __typename?: 'job_posting_aggregate_fields', count: number } | null } }
    & { ' $fragmentRefs'?: { 'EditRecruiterPopup_ContractFragment': EditRecruiterPopup_ContractFragment } }
  )>, orgUser: (
    { __typename?: 'org_user', id: any }
    & { ' $fragmentRefs'?: { 'AddFacilityPopup_RecruiterFragment': AddFacilityPopup_RecruiterFragment } }
  ) | null, org: (
    { __typename?: 'organization', id: any }
    & { ' $fragmentRefs'?: { 'AddFacilityPopup_OrganizationFragment': AddFacilityPopup_OrganizationFragment } }
  ) | null };

export type BillingView_UpsertCustomerMutationVariables = Exact<{
  customerDetails: CustomerDetailsInput;
}>;


export type BillingView_UpsertCustomerMutation = { __typename?: 'mutation_root', upsertCustomer: { __typename?: 'CustomerGQL', id: string } };

export type InvoicesView_InvoicesDataFragment = { __typename?: 'InvoicesDataGQL', hasMore: boolean, data: Array<{ __typename?: 'InvoiceGQL', date: number | null, id: string | null, link: string | null, status: string | null, downloadLink: string | null }> } & { ' $fragmentName'?: 'InvoicesView_InvoicesDataFragment' };

export type InvoicesView_GetInvoicesQueryVariables = Exact<{
  orgId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  start_after?: InputMaybe<Scalars['String']>;
}>;


export type InvoicesView_GetInvoicesQuery = { __typename?: 'query_root', organization: { __typename?: 'organization', customer: { __typename?: 'CustomerGQL', invoices: { __typename?: 'InvoiceCollectionGQL', open: (
          { __typename?: 'InvoicesDataGQL', hasMore: boolean, data: Array<{ __typename?: 'InvoiceGQL', date: number | null, id: string | null, link: string | null, status: string | null, downloadLink: string | null }> }
          & { ' $fragmentRefs'?: { 'InvoicesView_InvoicesDataFragment': InvoicesView_InvoicesDataFragment } }
        ), paid: (
          { __typename?: 'InvoicesDataGQL', hasMore: boolean, data: Array<{ __typename?: 'InvoiceGQL', date: number | null, id: string | null, link: string | null, status: string | null, downloadLink: string | null }> }
          & { ' $fragmentRefs'?: { 'InvoicesView_InvoicesDataFragment': InvoicesView_InvoicesDataFragment } }
        ) } } | null } | null };

export type PaymentView_CreateCustomerPaymentIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type PaymentView_CreateCustomerPaymentIntentMutation = { __typename?: 'mutation_root', intent: { __typename?: 'SetupIntentGQL', id: string, clientSecret: string | null, setupFutureUsage: string | null } | null };

export type PaymentView_UpdateDefaultPaymentMethodMutationVariables = Exact<{
  paymentId: Scalars['String'];
}>;


export type PaymentView_UpdateDefaultPaymentMethodMutation = { __typename?: 'mutation_root', updateDefaultPayment: { __typename?: 'SuccessResult', success: boolean } };

export type PaymentView_DeletePaymentMethodMutationVariables = Exact<{
  paymentId: Scalars['String'];
  defaultPaymentId?: InputMaybe<Scalars['String']>;
}>;


export type PaymentView_DeletePaymentMethodMutation = { __typename?: 'mutation_root', deletePayment: { __typename?: 'SuccessResult', success: boolean } };

export type PlanView_CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type PlanView_CancelSubscriptionMutation = { __typename?: 'mutation_root', cancelSubscription: { __typename?: 'CustomerSubscriptionGQL', id: string } };

export type PlanView_DeleteSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type PlanView_DeleteSubscriptionMutation = { __typename?: 'mutation_root', deleteSubscription: { __typename?: 'SuccessResult', success: boolean } };

export type PlanView_ReactivateSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type PlanView_ReactivateSubscriptionMutation = { __typename?: 'mutation_root', reactivateSubscription: { __typename?: 'CustomerSubscriptionGQL', id: string } };

export type TeamTab_ListOrgUsersQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type TeamTab_ListOrgUsersQuery = { __typename?: 'query_root', orgUsers: Array<(
    { __typename?: 'org_user', id: any, account: { __typename?: 'account', id: any, ci: { __typename?: 'contact_info', id: any | null, email: string | null } | null, pi: { __typename?: 'personal_info', id: any | null, firstName: string | null, lastName: string | null, fullName: string | null } | null, ai: { __typename?: 'access_info', id: any | null, lastAccessDate: any | null, lastAccess: any | null } | null } }
    & { ' $fragmentRefs'?: { 'DeactivateOrgUserPopup_OrgUserFragment': DeactivateOrgUserPopup_OrgUserFragment;'EditOrgUserPopup_OrgUserFragment': EditOrgUserPopup_OrgUserFragment } }
  )> };

export type OrgFacilityList_OrgQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type OrgFacilityList_OrgQuery = { __typename?: 'query_root', org: { __typename?: 'organization', id: any, name: string, bounds: { __typename?: 'organization_bounds', id: any | null, xMin: any | null, xMax: any | null, yMin: any | null, yMax: any | null } | null } | null };

export type AcepCharacteristics_OrgFragment = { __typename?: 'organization', id: any, surveys: Array<{ __typename?: 'acep_org_survey', id: any, staffing: Array<string>, governance: Array<string>, funding: Array<string>, numEmPhysicians: string, practiceSize: string, geographicDist: string, contractOwner: Array<string>, ceoIsPhysician: string }> } & { ' $fragmentName'?: 'AcepCharacteristics_OrgFragment' };

export type AcepInfo_OrgFragment = { __typename?: 'organization', id: any, surveys: Array<{ __typename?: 'acep_org_survey', id: any, dba: string, nameCmo: string }> } & { ' $fragmentName'?: 'AcepInfo_OrgFragment' };

export type AcepOperations_OrgFragment = { __typename?: 'organization', id: any, surveys: Array<{ __typename?: 'acep_org_survey', apps: string, partnershipsOffered: string, billingDisclosure: string, appsUnsupervised: string }> } & { ' $fragmentName'?: 'AcepOperations_OrgFragment' };

export type AcepPolicies_OrgFragment = { __typename?: 'organization', id: any, surveys: Array<{ __typename?: 'acep_org_survey', id: any, acepPolicies: Array<string> }> } & { ' $fragmentName'?: 'AcepPolicies_OrgFragment' };

export type OrgAbout_OrgFragment = { __typename?: 'organization', id: any, description: string, ownershipStructure: any | null, contractsAgg: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'OrgAbout_OrgFragment' };

export type OrgAtAGlance_OrgFragment = { __typename?: 'organization', id: any, ownershipStructure: any | null, contractsAgg: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'OrgAtAGlance_OrgFragment' };

export type OrgFacilities_OrgFragment = { __typename?: 'organization', id: any, slug: string, contracts: Array<{ __typename?: 'facility_contract', id: any, facility: { __typename?: 'facility', id: any, name: string, slug: string } }>, contractsAgg: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'OrgFacilities_OrgFragment' };

export type OrgJobs_OrgFragment = { __typename?: 'organization', id: any, slug: string, jobs: Array<{ __typename?: 'organization_job_posting', id: any | null, posting: { __typename?: 'job_posting', id: any, slug: string, title: string } | null }>, jobsAgg: { __typename?: 'organization_job_posting_aggregate', aggregate: { __typename?: 'organization_job_posting_aggregate_fields', count: number } | null } } & { ' $fragmentName'?: 'OrgJobs_OrgFragment' };

export type OrgProfile_OrgQueryVariables = Exact<{
  orgId: Scalars['uuid'];
  professionsFilter: Profession_Comparison_Exp;
}>;


export type OrgProfile_OrgQuery = { __typename?: 'query_root', org: (
    { __typename?: 'organization', id: any, surveys: Array<{ __typename?: 'acep_org_survey', id: any }> }
    & { ' $fragmentRefs'?: { 'OrgWhitelabelCta_OrgFragment': OrgWhitelabelCta_OrgFragment;'OrgAtAGlance_OrgFragment': OrgAtAGlance_OrgFragment;'OrgAbout_OrgFragment': OrgAbout_OrgFragment;'OrgFacilities_OrgFragment': OrgFacilities_OrgFragment;'OrgJobs_OrgFragment': OrgJobs_OrgFragment;'AcepInfo_OrgFragment': AcepInfo_OrgFragment;'AcepCharacteristics_OrgFragment': AcepCharacteristics_OrgFragment;'AcepOperations_OrgFragment': AcepOperations_OrgFragment;'AcepPolicies_OrgFragment': AcepPolicies_OrgFragment } }
  ) | null };

export type OrgWhitelabelCta_OrgFragment = { __typename?: 'organization', id: any, slug: string } & { ' $fragmentName'?: 'OrgWhitelabelCta_OrgFragment' };

export type OrgReviews_OrgQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type OrgReviews_OrgQuery = { __typename?: 'query_root', org: { __typename?: 'organization', id: any, agg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', rating: number | null } | null } | null }, ratings: Array<{ __typename?: 'org_rating', count: any | null, value: number | null }> } | null };

export type OrgSalary_OrgQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type OrgSalary_OrgQuery = { __typename?: 'query_root', org: { __typename?: 'organization', id: any, name: string } | null };

export type OrgShow_OrgQueryVariables = Exact<{
  orgId: Scalars['uuid'];
}>;


export type OrgShow_OrgQuery = { __typename?: 'query_root', org: (
    { __typename?: 'organization', id: any, description: string, name: string, city: string, state: string, zipcode: string, phone: string, website: string, slug: string, streetAddress1: string, streetAddress2: string, logo: { __typename?: 'file', id: any, publicUrl: string } | null, contractsAgg: { __typename?: 'facility_contract_aggregate', aggregate: { __typename?: 'facility_contract_aggregate_fields', count: number } | null }, surveys: Array<{ __typename?: 'acep_org_survey', id: any, orgName: string }>, reviewsAgg: { __typename?: 'review_aggregate', aggregate: { __typename?: 'review_aggregate_fields', count: number, avg: { __typename?: 'review_avg_fields', rating: number | null } | null } | null }, salaryAgg: { __typename?: 'salary_report_fmt_aggregate', aggregate: { __typename?: 'salary_report_fmt_aggregate_fields', count: number } | null } }
    & { ' $fragmentRefs'?: { 'SalaryReportPopup_OrganizationFragment': SalaryReportPopup_OrganizationFragment;'ReviewPopup_OrganizationFragment': ReviewPopup_OrganizationFragment } }
  ) | null };

export type SitemapShow_GmapsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filters: Gmaps_Link_Bool_Exp;
}>;


export type SitemapShow_GmapsQuery = { __typename?: 'query_root', gmaps_link: Array<{ __typename?: 'gmaps_link', id: any, slug: string, label: string }>, agg: { __typename?: 'gmaps_link_aggregate', aggregate: { __typename?: 'gmaps_link_aggregate_fields', count: number } | null } };

export const CurrentAccountAvatar_CurrentAccountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentAccountAvatar_CurrentAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"current_account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<CurrentAccountAvatar_CurrentAccountFragment, unknown>;
export const EditEmployerProfileForm_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditEmployerProfileForm_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"nameChange"},"name":{"kind":"Name","value":"name_change"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}}]}}]} as unknown as DocumentNode<EditEmployerProfileForm_OrganizationFragment, unknown>;
export const FacilitySelect_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilitySelect_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]} as unknown as DocumentNode<FacilitySelect_FacilityFragment, unknown>;
export const EditRecruiterPopup_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditRecruiterPopup_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"defaultRecruiter"},"name":{"kind":"Name","value":"default_recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditRecruiterPopup_ContractFragment, unknown>;
export const JobPostingFormGeneralInfo_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilitySelect_Facility"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditRecruiterPopup_Contract"}}]}}]} as unknown as DocumentNode<JobPostingFormGeneralInfo_ContractFragment, unknown>;
export const JobPostingFormGeneralInfo_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Contract"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"workerClassifications"},"name":{"kind":"Name","value":"worker_classifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"term"}},{"kind":"Field","alias":{"kind":"Name","value":"hasStartDate"},"name":{"kind":"Name","value":"has_start_date"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"startOrTodayDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","alias":{"kind":"Name","value":"j1Visa"},"name":{"kind":"Name","value":"j1_visa"}},{"kind":"Field","alias":{"kind":"Name","value":"h1bVisa"},"name":{"kind":"Name","value":"h1b_visa"}}]}}]} as unknown as DocumentNode<JobPostingFormGeneralInfo_PostingFragment, unknown>;
export const JobPostingFormCompensation_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingFormCompensation_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"hasSigningBonus"},"name":{"kind":"Name","value":"has_signing_bonus"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRelocationAssist"},"name":{"kind":"Name","value":"has_relocation_assist"}},{"kind":"Field","alias":{"kind":"Name","value":"hasPerfBonus"},"name":{"kind":"Name","value":"has_perf_bonus"}},{"kind":"Field","alias":{"kind":"Name","value":"healthInsurance"},"name":{"kind":"Name","value":"health_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"dentalInsurance"},"name":{"kind":"Name","value":"dental_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"visionInsurance"},"name":{"kind":"Name","value":"vision_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"healthAccount"},"name":{"kind":"Name","value":"health_account"}},{"kind":"Field","alias":{"kind":"Name","value":"disabilityInsurance"},"name":{"kind":"Name","value":"disability_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"lifeInsurance"},"name":{"kind":"Name","value":"life_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"retirement"},"name":{"kind":"Name","value":"retirement_account"}},{"kind":"Field","alias":{"kind":"Name","value":"paidVacation"},"name":{"kind":"Name","value":"paid_vacation"}},{"kind":"Field","alias":{"kind":"Name","value":"paidParental"},"name":{"kind":"Name","value":"paid_parental"}},{"kind":"Field","alias":{"kind":"Name","value":"studentLoan"},"name":{"kind":"Name","value":"student_loan"}},{"kind":"Field","name":{"kind":"Name","value":"cme"}},{"kind":"Field","alias":{"kind":"Name","value":"malpracticeInsurance"},"name":{"kind":"Name","value":"malpractice_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"tailCoverage"},"name":{"kind":"Name","value":"tail_coverage"}},{"kind":"Field","name":{"kind":"Name","value":"equity"}}]}}]} as unknown as DocumentNode<JobPostingFormCompensation_PostingFragment, unknown>;
export const JobPostingFormQualifications_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingFormQualifications_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"currentLicense"},"name":{"kind":"Name","value":"current_license"}},{"kind":"Field","name":{"kind":"Name","value":"bcbe"}},{"kind":"Field","alias":{"kind":"Name","value":"boardCerts"},"name":{"kind":"Name","value":"board_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","alias":{"kind":"Name","value":"fieldType"},"name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"expReq"},"name":{"kind":"Name","value":"exp_req"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","alias":{"kind":"Name","value":"appCerts"},"name":{"kind":"Name","value":"app_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<JobPostingFormQualifications_PostingFragment, unknown>;
export const JobPostingFormAdditional_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingFormAdditional_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"descriptionHtml"},"name":{"kind":"Name","value":"description_html"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobPostingFormAdditional_PostingFragment, unknown>;
export const JobPostingForm_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingForm_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"workerClassifications"},"name":{"kind":"Name","value":"worker_classifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}}]}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormCompensation_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormQualifications_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormAdditional_Posting"}}]}}]} as unknown as DocumentNode<JobPostingForm_PostingFragment, unknown>;
export const ClinicianSearch_FsmbBioFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClinicianSearch_FsmbBio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fsmb_bio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"middleName"},"name":{"kind":"Name","value":"middle_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"cred"},"name":{"kind":"Name","value":"practitioner_type"}},{"kind":"Field","alias":{"kind":"Name","value":"school"},"name":{"kind":"Name","value":"medical_school_name"}},{"kind":"Field","alias":{"kind":"Name","value":"gradYr"},"name":{"kind":"Name","value":"graduation_year"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"cmsSpecialties"},"name":{"kind":"Name","value":"cms_specialties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"specialty"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiry_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<ClinicianSearch_FsmbBioFragment, unknown>;
export const ProfileCompleteForm_ClinicianFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileCompleteForm_Clinician"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clinician"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"profileComplete"},"name":{"kind":"Name","value":"profile_complete"}},{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","alias":{"kind":"Name","value":"profDegree"},"name":{"kind":"Name","value":"prof_degree"}},{"kind":"Field","name":{"kind":"Name","value":"creds"}},{"kind":"Field","name":{"kind":"Name","value":"isAPP"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"cv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"schoolName"},"name":{"kind":"Name","value":"school_name"}},{"kind":"Field","alias":{"kind":"Name","value":"gradYr"},"name":{"kind":"Name","value":"grad_yr"}},{"kind":"Field","alias":{"kind":"Name","value":"currStudent"},"name":{"kind":"Name","value":"current_student"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEkgInterpret"},"name":{"kind":"Name","value":"skill_ekg_interpret"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEkgStemi"},"name":{"kind":"Name","value":"skill_ekg_stemi"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEyeFb"},"name":{"kind":"Name","value":"skill_eye_fb"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEarFb"},"name":{"kind":"Name","value":"skill_ear_fb"}},{"kind":"Field","alias":{"kind":"Name","value":"skillWoundRepair"},"name":{"kind":"Name","value":"skill_wound_repair"}},{"kind":"Field","alias":{"kind":"Name","value":"skillOral"},"name":{"kind":"Name","value":"skill_oral"}},{"kind":"Field","alias":{"kind":"Name","value":"skillPeds"},"name":{"kind":"Name","value":"skill_peds"}},{"kind":"Field","alias":{"kind":"Name","value":"skillFractureBlocks"},"name":{"kind":"Name","value":"skill_fracture_blocks"}},{"kind":"Field","alias":{"kind":"Name","value":"skillJointReduction"},"name":{"kind":"Name","value":"skill_joint_reduction"}},{"kind":"Field","alias":{"kind":"Name","value":"skillNeonates"},"name":{"kind":"Name","value":"skill_neonates"}},{"kind":"Field","alias":{"kind":"Name","value":"skillObgyn"},"name":{"kind":"Name","value":"skill_obgyn"}},{"kind":"Field","alias":{"kind":"Name","value":"skillIntubation"},"name":{"kind":"Name","value":"skill_endotracheal_intubation"}},{"kind":"Field","alias":{"kind":"Name","value":"skillChestTube"},"name":{"kind":"Name","value":"skill_chest_tube_placement"}},{"kind":"Field","alias":{"kind":"Name","value":"skillChestNeedle"},"name":{"kind":"Name","value":"skill_chest_needle"}},{"kind":"Field","alias":{"kind":"Name","value":"skillVenous"},"name":{"kind":"Name","value":"skill_central_venous_line_placement"}},{"kind":"Field","alias":{"kind":"Name","value":"skillIOAccess"},"name":{"kind":"Name","value":"skill_io_access"}},{"kind":"Field","alias":{"kind":"Name","value":"skillLumbar"},"name":{"kind":"Name","value":"skill_lumbar_puncture"}},{"kind":"Field","alias":{"kind":"Name","value":"skillSedation"},"name":{"kind":"Name","value":"skill_procedural_sedation"}},{"kind":"Field","alias":{"kind":"Name","value":"skillUSDiagnostics"},"name":{"kind":"Name","value":"skill_us_diagnostics"}},{"kind":"Field","alias":{"kind":"Name","value":"skillUSProcedures"},"name":{"kind":"Name","value":"skill_us_procedures"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fsmbBio"},"name":{"kind":"Name","value":"fsmb_bio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianSearch_FsmbBio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","alias":{"kind":"Name","value":"startYear"},"name":{"kind":"Name","value":"start_yr"}},{"kind":"Field","alias":{"kind":"Name","value":"endYear"},"name":{"kind":"Name","value":"end_yr"}},{"kind":"Field","name":{"kind":"Name","value":"present"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appCerts"},"name":{"kind":"Name","value":"app_certs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boardCerts"},"name":{"kind":"Name","value":"board_certs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cert"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"cert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"spExp"},"name":{"kind":"Name","value":"sp_exp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileCompleteForm_ClinicianFragment, unknown>;
export const ReviewCard_ReviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewCard_Review"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"review"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"currentlyWorking"},"name":{"kind":"Name","value":"currently_working"}},{"kind":"Field","alias":{"kind":"Name","value":"ratingFacility"},"name":{"kind":"Name","value":"rating_facility"}},{"kind":"Field","alias":{"kind":"Name","value":"ratingJob"},"name":{"kind":"Name","value":"rating_job"}},{"kind":"Field","alias":{"kind":"Name","value":"ratingOrg"},"name":{"kind":"Name","value":"rating_org"}},{"kind":"Field","alias":{"kind":"Name","value":"mostHelpful"},"name":{"kind":"Name","value":"most_helpful"}},{"kind":"Field","alias":{"kind":"Name","value":"lastWorkedDate"},"name":{"kind":"Name","value":"last_worked_date"}},{"kind":"Field","alias":{"kind":"Name","value":"employmentDate"},"name":{"kind":"Name","value":"employment_date"}},{"kind":"Field","alias":{"kind":"Name","value":"selfReview"},"name":{"kind":"Name","value":"self_review"}},{"kind":"Field","alias":{"kind":"Name","value":"hasActiveContract"},"name":{"kind":"Name","value":"has_active_contract"}},{"kind":"Field","alias":{"kind":"Name","value":"reporterName"},"name":{"kind":"Name","value":"reporter_name"}},{"kind":"Field","alias":{"kind":"Name","value":"facilityContent"},"name":{"kind":"Name","value":"review_facility_content"}},{"kind":"Field","alias":{"kind":"Name","value":"orgContent"},"name":{"kind":"Name","value":"review_org_content"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"replies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"self_reply"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"isOrgResponse"},"name":{"kind":"Name","value":"is_org_response"}},{"kind":"Field","alias":{"kind":"Name","value":"reporterName"},"name":{"kind":"Name","value":"reporter_name"}},{"kind":"Field","alias":{"kind":"Name","value":"selfReply"},"name":{"kind":"Name","value":"self_reply"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"votes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isClinician"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"votes_agg"},"name":{"kind":"Name","value":"votes_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"replies_agg"},"name":{"kind":"Name","value":"replies_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"self_reply"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ReviewCard_ReviewFragment, unknown>;
export const FacilityRecruiterForm_RecruiterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityRecruiterForm_Recruiter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<FacilityRecruiterForm_RecruiterFragment, unknown>;
export const AddFacilityPopup_RecruiterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddFacilityPopup_Recruiter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityRecruiterForm_Recruiter"}}]}}]} as unknown as DocumentNode<AddFacilityPopup_RecruiterFragment, unknown>;
export const AddFacilityPopup_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddFacilityPopup_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"defaultRecruiter"},"name":{"kind":"Name","value":"default_recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityRecruiterForm_Recruiter"}}]}}]}}]} as unknown as DocumentNode<AddFacilityPopup_OrganizationFragment, unknown>;
export const ChangePostingStatusPopup_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangePostingStatusPopup_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]} as unknown as DocumentNode<ChangePostingStatusPopup_PostingFragment, unknown>;
export const SkillsStep_ClinicianSkillsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SkillsStep_ClinicianSkills"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clinician"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEkgInterpret"},"name":{"kind":"Name","value":"skill_ekg_interpret"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEkgStemi"},"name":{"kind":"Name","value":"skill_ekg_stemi"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEyeFb"},"name":{"kind":"Name","value":"skill_eye_fb"}},{"kind":"Field","alias":{"kind":"Name","value":"skillEarFb"},"name":{"kind":"Name","value":"skill_ear_fb"}},{"kind":"Field","alias":{"kind":"Name","value":"skillWoundRepair"},"name":{"kind":"Name","value":"skill_wound_repair"}},{"kind":"Field","alias":{"kind":"Name","value":"skillOral"},"name":{"kind":"Name","value":"skill_oral"}},{"kind":"Field","alias":{"kind":"Name","value":"skillPeds"},"name":{"kind":"Name","value":"skill_peds"}},{"kind":"Field","alias":{"kind":"Name","value":"skillFractureBlocks"},"name":{"kind":"Name","value":"skill_fracture_blocks"}},{"kind":"Field","alias":{"kind":"Name","value":"skillJointReduction"},"name":{"kind":"Name","value":"skill_joint_reduction"}},{"kind":"Field","alias":{"kind":"Name","value":"skillNeonates"},"name":{"kind":"Name","value":"skill_neonates"}},{"kind":"Field","alias":{"kind":"Name","value":"skillObgyn"},"name":{"kind":"Name","value":"skill_obgyn"}},{"kind":"Field","alias":{"kind":"Name","value":"skillIntubation"},"name":{"kind":"Name","value":"skill_endotracheal_intubation"}},{"kind":"Field","alias":{"kind":"Name","value":"skillChestTube"},"name":{"kind":"Name","value":"skill_chest_tube_placement"}},{"kind":"Field","alias":{"kind":"Name","value":"skillChestNeedle"},"name":{"kind":"Name","value":"skill_chest_needle"}},{"kind":"Field","alias":{"kind":"Name","value":"skillVenous"},"name":{"kind":"Name","value":"skill_central_venous_line_placement"}},{"kind":"Field","alias":{"kind":"Name","value":"skillIOAccess"},"name":{"kind":"Name","value":"skill_io_access"}},{"kind":"Field","alias":{"kind":"Name","value":"skillLumbar"},"name":{"kind":"Name","value":"skill_lumbar_puncture"}},{"kind":"Field","alias":{"kind":"Name","value":"skillSedation"},"name":{"kind":"Name","value":"skill_procedural_sedation"}},{"kind":"Field","alias":{"kind":"Name","value":"skillUSDiagnostics"},"name":{"kind":"Name","value":"skill_us_diagnostics"}},{"kind":"Field","alias":{"kind":"Name","value":"skillUSProcedures"},"name":{"kind":"Name","value":"skill_us_procedures"}}]}}]} as unknown as DocumentNode<SkillsStep_ClinicianSkillsFragment, unknown>;
export const ClinicianAvatar_ClinicianFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClinicianAvatar_Clinician"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clinician"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<ClinicianAvatar_ClinicianFragment, unknown>;
export const ClinicianProfile_ClinicianFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClinicianProfile_Clinician"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clinician"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"profileComplete"},"name":{"kind":"Name","value":"profile_complete"}},{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","alias":{"kind":"Name","value":"profDegree"},"name":{"kind":"Name","value":"prof_degree"}},{"kind":"Field","name":{"kind":"Name","value":"creds"}},{"kind":"Field","name":{"kind":"Name","value":"isAPP"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"cv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"schoolName"},"name":{"kind":"Name","value":"school_name"}},{"kind":"Field","alias":{"kind":"Name","value":"gradYr"},"name":{"kind":"Name","value":"grad_yr"}},{"kind":"Field","alias":{"kind":"Name","value":"currStudent"},"name":{"kind":"Name","value":"current_student"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SkillsStep_ClinicianSkills"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianAvatar_Clinician"}},{"kind":"Field","name":{"kind":"Name","value":"specialties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fsmb"},"name":{"kind":"Name","value":"fsmb_bio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","alias":{"kind":"Name","value":"boardAction"},"name":{"kind":"Name","value":"board_action_flag"}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiry_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"entity"}},{"kind":"Field","alias":{"kind":"Name","value":"issue"},"name":{"kind":"Name","value":"issue_date"}},{"kind":"Field","alias":{"kind":"Name","value":"expiry"},"name":{"kind":"Name","value":"expiry_date"}},{"kind":"Field","alias":{"kind":"Name","value":"licenseNo"},"name":{"kind":"Name","value":"license_no"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"program"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","alias":{"kind":"Name","value":"startYear"},"name":{"kind":"Name","value":"start_yr"}},{"kind":"Field","alias":{"kind":"Name","value":"endYear"},"name":{"kind":"Name","value":"end_yr"}},{"kind":"Field","name":{"kind":"Name","value":"present"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appCerts"},"name":{"kind":"Name","value":"app_certs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boardCerts"},"name":{"kind":"Name","value":"board_certs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cert"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"cert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"spExp"},"name":{"kind":"Name","value":"sp_exp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<ClinicianProfile_ClinicianFragment, unknown>;
export const ClinicianProfile_JobApplicationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClinicianProfile_JobApplication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_application"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClinicianProfile_JobApplicationFragment, unknown>;
export const DeactivateOrgUserPopup_OrgUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DeactivateOrgUserPopup_OrgUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateOrgUserPopup_OrgUserFragment, unknown>;
export const EditOrgUserPopup_OrgUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EditOrgUserPopup_OrgUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_user"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<EditOrgUserPopup_OrgUserFragment, unknown>;
export const EmployerCard_EmployerInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployerCard_EmployerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_market"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"numEDs"},"name":{"kind":"Name","value":"num_eds"}},{"kind":"Field","alias":{"kind":"Name","value":"numFreestandingEDs"},"name":{"kind":"Name","value":"num_freestanding_eds"}},{"kind":"Field","alias":{"kind":"Name","value":"numResidencyEDs"},"name":{"kind":"Name","value":"num_residency_eds"}},{"kind":"Field","alias":{"kind":"Name","value":"edCoverage"},"name":{"kind":"Name","value":"ed_coverage"}}]}}]} as unknown as DocumentNode<EmployerCard_EmployerInfoFragment, unknown>;
export const EmployerTable_EmployerInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployerTable_EmployerInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_market"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"numEDs"},"name":{"kind":"Name","value":"num_eds"}},{"kind":"Field","alias":{"kind":"Name","value":"numFreestandingEDs"},"name":{"kind":"Name","value":"num_freestanding_eds"}},{"kind":"Field","alias":{"kind":"Name","value":"numResidencyEDs"},"name":{"kind":"Name","value":"num_residency_eds"}},{"kind":"Field","alias":{"kind":"Name","value":"edCoverage"},"name":{"kind":"Name","value":"ed_coverage"}}]}}]} as unknown as DocumentNode<EmployerTable_EmployerInfoFragment, unknown>;
export const FacilityCard_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityCard_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"adultTraumaLvl"},"name":{"kind":"Name","value":"adult_trauma_lvl"}},{"kind":"Field","alias":{"kind":"Name","value":"freestandingEr"},"name":{"kind":"Name","value":"freestanding_er"}},{"kind":"Field","name":{"kind":"Name","value":"facilityType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"residencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityPos"},"name":{"kind":"Name","value":"cms_facility_pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerSubtype"},"name":{"kind":"Name","value":"provider_subtype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityEnrollment"},"name":{"kind":"Name","value":"cms_facility_enrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerTypeCode"},"name":{"kind":"Name","value":"provider_type_code"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacility"},"name":{"kind":"Name","value":"cms_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"hospitalType"},"name":{"kind":"Name","value":"hospital_type"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"measure_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"EDV","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"measureId"},"name":{"kind":"Name","value":"measure_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ahaFacility"},"name":{"kind":"Name","value":"aha_facility_22"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"UNAME"}},{"kind":"Field","alias":{"kind":"Name","value":"par"},"name":{"kind":"Name","value":"parent_aha_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"MNAME"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rollups"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"maxRatePosting"},"name":{"kind":"Name","value":"max_postings_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"normRate"},"name":{"kind":"Name","value":"normalized_rate"}},{"kind":"Field","name":{"kind":"Name","value":"wageTrunc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"numPostings"},"name":{"kind":"Name","value":"num_postings_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"featured"},"name":{"kind":"Name","value":"featured_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"immediateNeeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_active_contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rating"},"name":{"kind":"Name","value":"rating_job"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FacilityCard_FacilityFragment, unknown>;
export const FacilitySuggestions_RankedFacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilitySuggestions_RankedFacility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ranked_facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityCard_Facility"}}]}}]}}]} as unknown as DocumentNode<FacilitySuggestions_RankedFacilityFragment, unknown>;
export const ReviewPopup_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewPopup_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]} as unknown as DocumentNode<ReviewPopup_FacilityFragment, unknown>;
export const ReviewPopup_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewPopup_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ReviewPopup_OrganizationFragment, unknown>;
export const ReportDetail_SalaryReportInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportDetail_SalaryReportInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"salary_report_fmt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"baseAmt"},"name":{"kind":"Name","value":"base_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"basePeriod"},"name":{"kind":"Name","value":"base_period"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}},{"kind":"Field","alias":{"kind":"Name","value":"nightDiff"},"name":{"kind":"Name","value":"night_diff"}},{"kind":"Field","alias":{"kind":"Name","value":"nightDiffAmt"},"name":{"kind":"Name","value":"night_diff_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendDiff"},"name":{"kind":"Name","value":"weekend_diff"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendDiffAmt"},"name":{"kind":"Name","value":"weekend_diff_amt_fmt"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","alias":{"kind":"Name","value":"hrsShift"},"name":{"kind":"Name","value":"hrs_per_shift"}},{"kind":"Field","alias":{"kind":"Name","value":"shftsMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"visaSponsorship"},"name":{"kind":"Name","value":"visa_sponsorship"}},{"kind":"Field","name":{"kind":"Name","value":"nocturnal"}},{"kind":"Field","name":{"kind":"Name","value":"partner"}},{"kind":"Field","name":{"kind":"Name","value":"locums"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendsOnly"},"name":{"kind":"Name","value":"weekends_only"}},{"kind":"Field","alias":{"kind":"Name","value":"partnershipTrack"},"name":{"kind":"Name","value":"partnership_track"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"traveler"}},{"kind":"Field","name":{"kind":"Name","value":"cme"}},{"kind":"Field","alias":{"kind":"Name","value":"cmeAmt"},"name":{"kind":"Name","value":"cme_amt_fmt"}},{"kind":"Field","name":{"kind":"Name","value":"bonus"}},{"kind":"Field","alias":{"kind":"Name","value":"bonusAmt"},"name":{"kind":"Name","value":"bonus_amt"}},{"kind":"Field","name":{"kind":"Name","value":"retirement"}},{"kind":"Field","alias":{"kind":"Name","value":"retirementAmt"},"name":{"kind":"Name","value":"retirement_amt"}},{"kind":"Field","alias":{"kind":"Name","value":"studentLoan"},"name":{"kind":"Name","value":"student_loan"}},{"kind":"Field","alias":{"kind":"Name","value":"studentLoanAmt"},"name":{"kind":"Name","value":"student_loan_amt_fmt"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgOther"},"name":{"kind":"Name","value":"org_other"}}]}}]} as unknown as DocumentNode<ReportDetail_SalaryReportInfoFragment, unknown>;
export const SalaryCard_SalaryReportInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalaryCard_SalaryReportInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"salary_report_fmt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"baseAmt"},"name":{"kind":"Name","value":"base_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"basePeriod"},"name":{"kind":"Name","value":"base_period"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}},{"kind":"Field","alias":{"kind":"Name","value":"nightDiff"},"name":{"kind":"Name","value":"night_diff"}},{"kind":"Field","alias":{"kind":"Name","value":"nightDiffAmt"},"name":{"kind":"Name","value":"night_diff_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendDiff"},"name":{"kind":"Name","value":"weekend_diff"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendDiffAmt"},"name":{"kind":"Name","value":"weekend_diff_amt_fmt"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","alias":{"kind":"Name","value":"visaSponsorship"},"name":{"kind":"Name","value":"visa_sponsorship"}},{"kind":"Field","name":{"kind":"Name","value":"nocturnal"}},{"kind":"Field","name":{"kind":"Name","value":"partner"}},{"kind":"Field","name":{"kind":"Name","value":"locums"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendsOnly"},"name":{"kind":"Name","value":"weekends_only"}},{"kind":"Field","alias":{"kind":"Name","value":"partnershipTrack"},"name":{"kind":"Name","value":"partnership_track"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"traveler"}},{"kind":"Field","name":{"kind":"Name","value":"cme"}},{"kind":"Field","name":{"kind":"Name","value":"bonus"}},{"kind":"Field","name":{"kind":"Name","value":"retirement"}},{"kind":"Field","alias":{"kind":"Name","value":"studentLoan"},"name":{"kind":"Name","value":"student_loan"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgOther"},"name":{"kind":"Name","value":"org_other"}}]}}]} as unknown as DocumentNode<SalaryCard_SalaryReportInfoFragment, unknown>;
export const SalaryTable_SalaryReportInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalaryTable_SalaryReportInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"salary_report_fmt"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"baseAmt"},"name":{"kind":"Name","value":"base_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"basePeriod"},"name":{"kind":"Name","value":"base_period"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}},{"kind":"Field","alias":{"kind":"Name","value":"nightDiff"},"name":{"kind":"Name","value":"night_diff"}},{"kind":"Field","alias":{"kind":"Name","value":"nightDiffAmt"},"name":{"kind":"Name","value":"night_diff_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendDiff"},"name":{"kind":"Name","value":"weekend_diff"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendDiffAmt"},"name":{"kind":"Name","value":"weekend_diff_amt_fmt"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","alias":{"kind":"Name","value":"hrsShift"},"name":{"kind":"Name","value":"hrs_per_shift"}},{"kind":"Field","alias":{"kind":"Name","value":"shftsMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"visaSponsorship"},"name":{"kind":"Name","value":"visa_sponsorship"}},{"kind":"Field","name":{"kind":"Name","value":"nocturnal"}},{"kind":"Field","name":{"kind":"Name","value":"partner"}},{"kind":"Field","name":{"kind":"Name","value":"locums"}},{"kind":"Field","alias":{"kind":"Name","value":"weekendsOnly"},"name":{"kind":"Name","value":"weekends_only"}},{"kind":"Field","alias":{"kind":"Name","value":"partnershipTrack"},"name":{"kind":"Name","value":"partnership_track"}},{"kind":"Field","name":{"kind":"Name","value":"admin"}},{"kind":"Field","name":{"kind":"Name","value":"traveler"}},{"kind":"Field","name":{"kind":"Name","value":"cme"}},{"kind":"Field","name":{"kind":"Name","value":"bonus"}},{"kind":"Field","name":{"kind":"Name","value":"retirement"}},{"kind":"Field","alias":{"kind":"Name","value":"studentLoan"},"name":{"kind":"Name","value":"student_loan"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgOther"},"name":{"kind":"Name","value":"org_other"}}]}}]} as unknown as DocumentNode<SalaryTable_SalaryReportInfoFragment, unknown>;
export const SalaryReportFormGeneralStep_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SalaryReportFormGeneralStep_FacilityFragment, unknown>;
export const SalaryReportFormGeneralStep_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SalaryReportFormGeneralStep_OrganizationFragment, unknown>;
export const SalaryReportPopup_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalaryReportPopup_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_Facility"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilitySelect_Facility"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_Organization"}}]}}]}}]}}]} as unknown as DocumentNode<SalaryReportPopup_FacilityFragment, unknown>;
export const SalaryReportPopup_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalaryReportPopup_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_Organization"}}]}}]} as unknown as DocumentNode<SalaryReportPopup_OrganizationFragment, unknown>;
export const TrainingFeatured_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainingFeatured_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"residencySurvey"},"name":{"kind":"Name","value":"residency_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSite"},"name":{"kind":"Name","value":"primary_training_site"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkshipSurvey"},"name":{"kind":"Name","value":"clerkship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comlexRequired"},"name":{"kind":"Name","value":"comlex_required"}},{"kind":"Field","alias":{"kind":"Name","value":"rotationTypes"},"name":{"kind":"Name","value":"rotation_types"}},{"kind":"Field","alias":{"kind":"Name","value":"vsloParticipant"},"name":{"kind":"Name","value":"vslo_participant"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowshipSurvey"},"name":{"kind":"Name","value":"fellowship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"advancedDegrees"},"name":{"kind":"Name","value":"advanced_degrees"}},{"kind":"Field","alias":{"kind":"Name","value":"moonlightingAllowed"},"name":{"kind":"Name","value":"moonlighting_allowed"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","name":{"kind":"Name","value":"subspecialty"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrainingFeatured_TrainingSurveyFragment, unknown>;
export const BillingProvider_SubscriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingProvider_Subscription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerSubscriptionGQL"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"cancelAt"},"name":{"kind":"Name","value":"cancel_at"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"slots"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"discounted"}},{"kind":"Field","alias":{"kind":"Name","value":"usedSlots"},"name":{"kind":"Name","value":"used_slots"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"invoiceDate"},"name":{"kind":"Name","value":"invoice_date"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentIntent"},"name":{"kind":"Name","value":"payment_intent"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentStatus"},"name":{"kind":"Name","value":"payment_status"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<BillingProvider_SubscriptionFragment, unknown>;
export const BillingProvider_CustomerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingProvider_Customer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerGQL"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"address1"},"name":{"kind":"Name","value":"address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"address2"},"name":{"kind":"Name","value":"address_2"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","alias":{"kind":"Name","value":"defaultPaymentId"},"name":{"kind":"Name","value":"default_payment_id"}},{"kind":"Field","alias":{"kind":"Name","value":"checkoutBankHold"},"name":{"kind":"Name","value":"checkout_bank_hold"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingProvider_Subscription"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paymentMethods"},"name":{"kind":"Name","value":"payment_methods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"usBank"},"name":{"kind":"Name","value":"us_bank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accountType"},"name":{"kind":"Name","value":"account_type"}},{"kind":"Field","alias":{"kind":"Name","value":"bankName"},"name":{"kind":"Name","value":"bank_name"}},{"kind":"Field","alias":{"kind":"Name","value":"last4"},"name":{"kind":"Name","value":"last_4"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","alias":{"kind":"Name","value":"expMonth"},"name":{"kind":"Name","value":"exp_month"}},{"kind":"Field","alias":{"kind":"Name","value":"expYear"},"name":{"kind":"Name","value":"exp_year"}},{"kind":"Field","alias":{"kind":"Name","value":"last4"},"name":{"kind":"Name","value":"last_4"}}]}}]}}]}}]} as unknown as DocumentNode<BillingProvider_CustomerFragment, unknown>;
export const SiteSettingsProvider_SiteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SiteSettingsProvider_Site"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"site"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","alias":{"kind":"Name","value":"emraFeaturedTrainingType"},"name":{"kind":"Name","value":"emra_featured_training_type"}}]}}]} as unknown as DocumentNode<SiteSettingsProvider_SiteFragment, unknown>;
export const FavoritesShow_FavoriteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoritesShow_Favorite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FavoritesShow_FavoriteFragment, unknown>;
export const AcceptSurveyPopup_SurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcceptSurveyPopup_Survey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acep_org_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"orgName"},"name":{"kind":"Name","value":"org_name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AcceptSurveyPopup_SurveyFragment, unknown>;
export const AcepOrgSurveyList_SurveyResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcepOrgSurveyList_SurveyResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acep_org_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"acceptedAt"},"name":{"kind":"Name","value":"accepted_at"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgName"},"name":{"kind":"Name","value":"org_name"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"dba"}},{"kind":"Field","name":{"kind":"Name","value":"tin"}},{"kind":"Field","alias":{"kind":"Name","value":"nameAdmin"},"name":{"kind":"Name","value":"name_admin"}},{"kind":"Field","alias":{"kind":"Name","value":"emailAdmin"},"name":{"kind":"Name","value":"email_admin"}},{"kind":"Field","alias":{"kind":"Name","value":"nameCmo"},"name":{"kind":"Name","value":"name_cmo"}},{"kind":"Field","alias":{"kind":"Name","value":"emailCmo"},"name":{"kind":"Name","value":"email_cmo"}},{"kind":"Field","name":{"kind":"Name","value":"staffing"}},{"kind":"Field","alias":{"kind":"Name","value":"numEmPhysicians"},"name":{"kind":"Name","value":"num_em_physicians"}},{"kind":"Field","alias":{"kind":"Name","value":"practiceSize"},"name":{"kind":"Name","value":"practice_size"}},{"kind":"Field","alias":{"kind":"Name","value":"geographicDist"},"name":{"kind":"Name","value":"geographic_dist"}},{"kind":"Field","alias":{"kind":"Name","value":"contractOwner"},"name":{"kind":"Name","value":"contract_owner"}},{"kind":"Field","name":{"kind":"Name","value":"governance"}},{"kind":"Field","alias":{"kind":"Name","value":"ceoIsPhysician"},"name":{"kind":"Name","value":"ceo_is_physician"}},{"kind":"Field","name":{"kind":"Name","value":"funding"}},{"kind":"Field","alias":{"kind":"Name","value":"partnershipsOffered"},"name":{"kind":"Name","value":"partnerships_offered"}},{"kind":"Field","alias":{"kind":"Name","value":"billingDisclosure"},"name":{"kind":"Name","value":"billing_disclosure"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","alias":{"kind":"Name","value":"appsUnsupervised"},"name":{"kind":"Name","value":"apps_unsupervised"}},{"kind":"Field","alias":{"kind":"Name","value":"acepPolicies"},"name":{"kind":"Name","value":"acep_policies"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcceptSurveyPopup_Survey"}}]}}]} as unknown as DocumentNode<AcepOrgSurveyList_SurveyResultFragment, unknown>;
export const JobApplicationBatchNotesPopup_JobApplicationBatchFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobApplicationBatchNotesPopup_JobApplicationBatch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_application_batch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]} as unknown as DocumentNode<JobApplicationBatchNotesPopup_JobApplicationBatchFragment, unknown>;
export const CandidateCard_CandidateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CandidateCard_Candidate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"candidate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"profDegree"},"name":{"kind":"Name","value":"prof_degree"}},{"kind":"Field","alias":{"kind":"Name","value":"currentTrainee"},"name":{"kind":"Name","value":"current_trainee"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fsmb"},"name":{"kind":"Name","value":"fsmb_bio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiry_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianAvatar_Clinician"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobAppBatches"},"name":{"kind":"Name","value":"job_application_batches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"jobApps"},"name":{"kind":"Name","value":"job_applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode<CandidateCard_CandidateFragment, unknown>;
export const CandidateFacilitiesPopover_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CandidateFacilitiesPopover_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<CandidateFacilitiesPopover_FacilityFragment, unknown>;
export const CandidateTable_CandidateRowsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CandidateTable_CandidateRows"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"candidate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clinician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profDegree"},"name":{"kind":"Name","value":"prof_degree"}},{"kind":"Field","alias":{"kind":"Name","value":"currentTrainee"},"name":{"kind":"Name","value":"current_trainee"}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fsmb"},"name":{"kind":"Name","value":"fsmb_bio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","name":{"kind":"Name","value":"licenses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"expiry_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue_date"},"value":{"kind":"EnumValue","value":"desc_nulls_first"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobAppBatches"},"name":{"kind":"Name","value":"job_application_batches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"jobApps"},"name":{"kind":"Name","value":"job_applications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CandidateFacilitiesPopover_Facility"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode<CandidateTable_CandidateRowsFragment, unknown>;
export const JobApplicationListItem_JobApplicationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobApplicationListItem_JobApplication"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_application"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<JobApplicationListItem_JobApplicationFragment, unknown>;
export const EmraProgramFeatures_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramFeatures_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"directorName"},"name":{"kind":"Name","value":"director_name"}},{"kind":"Field","alias":{"kind":"Name","value":"coordinatorName"},"name":{"kind":"Name","value":"coordinator_name"}},{"kind":"Field","alias":{"kind":"Name","value":"coordinatorEmail"},"name":{"kind":"Name","value":"coordinator_email"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"residencySurvey"},"name":{"kind":"Name","value":"residency_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nrmpId"},"name":{"kind":"Name","value":"nrmp_id"}},{"kind":"Field","alias":{"kind":"Name","value":"acgmeId"},"name":{"kind":"Name","value":"acgme_id"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSite"},"name":{"kind":"Name","value":"primary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryTrainingSite"},"name":{"kind":"Name","value":"secondary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftLength"},"name":{"kind":"Name","value":"shift_length"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"pgy1PercentOffService"},"name":{"kind":"Name","value":"pgy_1_percent_off_service"}},{"kind":"Field","alias":{"kind":"Name","value":"step1Failures"},"name":{"kind":"Name","value":"step_1_failures"}},{"kind":"Field","alias":{"kind":"Name","value":"step1Cutoff"},"name":{"kind":"Name","value":"step_1_cutoff"}},{"kind":"Field","alias":{"kind":"Name","value":"availableInternPositions"},"name":{"kind":"Name","value":"available_intern_positions"}},{"kind":"Field","alias":{"kind":"Name","value":"percentOsteopath"},"name":{"kind":"Name","value":"percent_osteopath"}},{"kind":"Field","alias":{"kind":"Name","value":"percentImg"},"name":{"kind":"Name","value":"percent_img"}},{"kind":"Field","name":{"kind":"Name","value":"moonlighting"}},{"kind":"Field","alias":{"kind":"Name","value":"electiveWeeks"},"name":{"kind":"Name","value":"elective_weeks"}},{"kind":"Field","alias":{"kind":"Name","value":"criticalCareWeeks"},"name":{"kind":"Name","value":"critical_care_weeks"}},{"kind":"Field","alias":{"kind":"Name","value":"militaryBranch"},"name":{"kind":"Name","value":"military_branch"}},{"kind":"Field","alias":{"kind":"Name","value":"visaSponsorship"},"name":{"kind":"Name","value":"visa_sponsorship"}},{"kind":"Field","alias":{"kind":"Name","value":"sloesForInterview"},"name":{"kind":"Name","value":"sloes_for_interview"}},{"kind":"Field","alias":{"kind":"Name","value":"usmleComlex1Preference"},"name":{"kind":"Name","value":"usmle_comlex_1_preference"}},{"kind":"Field","alias":{"kind":"Name","value":"usmleComlex2Preference"},"name":{"kind":"Name","value":"usmle_comlex_2_preference"}},{"kind":"Field","alias":{"kind":"Name","value":"applicationsReceived"},"name":{"kind":"Name","value":"applications_received"}},{"kind":"Field","alias":{"kind":"Name","value":"inPersonSecondLooks"},"name":{"kind":"Name","value":"in_person_second_looks"}},{"kind":"Field","alias":{"kind":"Name","value":"cordApicInterview"},"name":{"kind":"Name","value":"cord_apic_interview"}},{"kind":"Field","alias":{"kind":"Name","value":"specialty"},"name":{"kind":"Name","value":"specialty"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkshipSurvey"},"name":{"kind":"Name","value":"clerkship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comlexRequired"},"name":{"kind":"Name","value":"comlex_required"}},{"kind":"Field","alias":{"kind":"Name","value":"authStudentSloe"},"name":{"kind":"Name","value":"auth_student_sloe"}},{"kind":"Field","alias":{"kind":"Name","value":"doStudents"},"name":{"kind":"Name","value":"do_students"}},{"kind":"Field","alias":{"kind":"Name","value":"flexibleRotation"},"name":{"kind":"Name","value":"flexible_rotation"}},{"kind":"Field","name":{"kind":"Name","value":"housing"}},{"kind":"Field","alias":{"kind":"Name","value":"imgStudents"},"name":{"kind":"Name","value":"img_students"}},{"kind":"Field","alias":{"kind":"Name","value":"interviewPolicy"},"name":{"kind":"Name","value":"interview_policy"}},{"kind":"Field","alias":{"kind":"Name","value":"rotationTypes"},"name":{"kind":"Name","value":"rotation_types"}},{"kind":"Field","alias":{"kind":"Name","value":"vehicleRec"},"name":{"kind":"Name","value":"vehicle_rec"}},{"kind":"Field","alias":{"kind":"Name","value":"vsloParticipant"},"name":{"kind":"Name","value":"vslo_participant"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability1"},"name":{"kind":"Name","value":"spot_availability_1"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability2"},"name":{"kind":"Name","value":"spot_availability_2"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability3"},"name":{"kind":"Name","value":"spot_availability_3"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability4"},"name":{"kind":"Name","value":"spot_availability_4"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability5"},"name":{"kind":"Name","value":"spot_availability_5"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability6"},"name":{"kind":"Name","value":"spot_availability_6"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability7"},"name":{"kind":"Name","value":"spot_availability_7"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability8"},"name":{"kind":"Name","value":"spot_availability_8"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability9"},"name":{"kind":"Name","value":"spot_availability_9"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability10"},"name":{"kind":"Name","value":"spot_availability_10"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability11"},"name":{"kind":"Name","value":"spot_availability_11"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability12"},"name":{"kind":"Name","value":"spot_availability_12"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowshipSurvey"},"name":{"kind":"Name","value":"fellowship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"advancedDegrees"},"name":{"kind":"Name","value":"advanced_degrees"}},{"kind":"Field","alias":{"kind":"Name","value":"clinicalExp"},"name":{"kind":"Name","value":"clinical_exp"}},{"kind":"Field","name":{"kind":"Name","value":"compensation"}},{"kind":"Field","alias":{"kind":"Name","value":"degreeGrantingInstitution"},"name":{"kind":"Name","value":"degree_granting_institution"}},{"kind":"Field","alias":{"kind":"Name","value":"moonlightingAllowed"},"name":{"kind":"Name","value":"moonlighting_allowed"}},{"kind":"Field","alias":{"kind":"Name","value":"positionsPerYear"},"name":{"kind":"Name","value":"positions_per_year"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"researchProject"},"name":{"kind":"Name","value":"research_project"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","name":{"kind":"Name","value":"subspecialty"}}]}}]}}]} as unknown as DocumentNode<EmraProgramFeatures_TrainingSurveyFragment, unknown>;
export const EmraProgramGallery_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramGallery_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<EmraProgramGallery_TrainingSurveyFragment, unknown>;
export const EmraProgramPrimarySite_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramPrimarySite_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityCard_Facility"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilityOther"},"name":{"kind":"Name","value":"facility_other"}}]}}]}}]} as unknown as DocumentNode<EmraProgramPrimarySite_TrainingSurveyFragment, unknown>;
export const ReviewSalaryCta_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewSalaryCta_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<ReviewSalaryCta_TrainingSurveyFragment, unknown>;
export const EmraProgramSocials_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramSocials_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vimeo"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","alias":{"kind":"Name","value":"multimediaURLs"},"name":{"kind":"Name","value":"multimedia_urls"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","alias":{"kind":"Name","value":"residencySurvey"},"name":{"kind":"Name","value":"residency_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pdInterview"},"name":{"kind":"Name","value":"pd_interview"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewSalaryCta_TrainingSurvey"}}]}}]} as unknown as DocumentNode<EmraProgramSocials_TrainingSurveyFragment, unknown>;
export const EmraProgramShow_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramShow_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramSocials_TrainingSurvey"}}]}}]} as unknown as DocumentNode<EmraProgramShow_TrainingSurveyFragment, unknown>;
export const EmraProgramTrainingSites_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramTrainingSites_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilityOther"},"name":{"kind":"Name","value":"facility_other"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSitesAgg"},"name":{"kind":"Name","value":"training_sites_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<EmraProgramTrainingSites_TrainingSurveyFragment, unknown>;
export const EmraProgramEvents_TrainingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraProgramEvents_Training"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"eventDate"},"name":{"kind":"Name","value":"event_date"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eventsAgg"},"name":{"kind":"Name","value":"events_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<EmraProgramEvents_TrainingFragment, unknown>;
export const Map_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Map_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"residencySurvey"},"name":{"kind":"Name","value":"residency_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSite"},"name":{"kind":"Name","value":"primary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryTrainingSite"},"name":{"kind":"Name","value":"secondary_training_site"}},{"kind":"Field","name":{"kind":"Name","value":"specialty"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkshipSurvey"},"name":{"kind":"Name","value":"clerkship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"comlexRequired"},"name":{"kind":"Name","value":"comlex_required"}},{"kind":"Field","alias":{"kind":"Name","value":"rotationTypes"},"name":{"kind":"Name","value":"rotation_types"}},{"kind":"Field","alias":{"kind":"Name","value":"vsloParticipant"},"name":{"kind":"Name","value":"vslo_participant"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowshipSurvey"},"name":{"kind":"Name","value":"fellowship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"advancedDegrees"},"name":{"kind":"Name","value":"advanced_degrees"}},{"kind":"Field","alias":{"kind":"Name","value":"moonlightingAllowed"},"name":{"kind":"Name","value":"moonlighting_allowed"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","name":{"kind":"Name","value":"subspecialty"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Map_TrainingSurveyFragment, unknown>;
export const EmraAdmin_ClerkshipSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraAdmin_ClerkshipSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clerkship_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"emraAccountNo"},"name":{"kind":"Name","value":"emra_account_no"}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingEvents"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"eventDate"},"name":{"kind":"Name","value":"event_date"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residencyOther"},"name":{"kind":"Name","value":"residency_other"}},{"kind":"Field","alias":{"kind":"Name","value":"vsloParticipant"},"name":{"kind":"Name","value":"vslo_participant"}},{"kind":"Field","alias":{"kind":"Name","value":"flexibleRotation"},"name":{"kind":"Name","value":"flexible_rotation"}},{"kind":"Field","alias":{"kind":"Name","value":"interviewPolicy"},"name":{"kind":"Name","value":"interview_policy"}},{"kind":"Field","alias":{"kind":"Name","value":"authStudentSloe"},"name":{"kind":"Name","value":"auth_student_sloe"}},{"kind":"Field","alias":{"kind":"Name","value":"doStudents"},"name":{"kind":"Name","value":"do_students"}},{"kind":"Field","alias":{"kind":"Name","value":"imgStudents"},"name":{"kind":"Name","value":"img_students"}},{"kind":"Field","alias":{"kind":"Name","value":"comlexRequired"},"name":{"kind":"Name","value":"comlex_required"}},{"kind":"Field","name":{"kind":"Name","value":"housing"}},{"kind":"Field","alias":{"kind":"Name","value":"vehicleRec"},"name":{"kind":"Name","value":"vehicle_rec"}},{"kind":"Field","alias":{"kind":"Name","value":"rotationTypes"},"name":{"kind":"Name","value":"rotation_types"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability1"},"name":{"kind":"Name","value":"spot_availability_1"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability2"},"name":{"kind":"Name","value":"spot_availability_2"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability3"},"name":{"kind":"Name","value":"spot_availability_3"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability4"},"name":{"kind":"Name","value":"spot_availability_4"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability5"},"name":{"kind":"Name","value":"spot_availability_5"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability6"},"name":{"kind":"Name","value":"spot_availability_6"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability7"},"name":{"kind":"Name","value":"spot_availability_7"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability8"},"name":{"kind":"Name","value":"spot_availability_8"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability9"},"name":{"kind":"Name","value":"spot_availability_9"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability10"},"name":{"kind":"Name","value":"spot_availability_10"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability11"},"name":{"kind":"Name","value":"spot_availability_11"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability12"},"name":{"kind":"Name","value":"spot_availability_12"}}]}}]} as unknown as DocumentNode<EmraAdmin_ClerkshipSurveyFragment, unknown>;
export const EmraAdmin_FellowshipSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraAdmin_FellowshipSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fellowship_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"emraAccountNo"},"name":{"kind":"Name","value":"emra_account_no"}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingEvents"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"eventDate"},"name":{"kind":"Name","value":"event_date"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residencyOther"},"name":{"kind":"Name","value":"residency_other"}},{"kind":"Field","name":{"kind":"Name","value":"subspecialty"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"positionsPerYear"},"name":{"kind":"Name","value":"positions_per_year"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"moonlightingAllowed"},"name":{"kind":"Name","value":"moonlighting_allowed"}},{"kind":"Field","alias":{"kind":"Name","value":"advancedDegrees"},"name":{"kind":"Name","value":"advanced_degrees"}},{"kind":"Field","alias":{"kind":"Name","value":"degreeGrantingInstitution"},"name":{"kind":"Name","value":"degree_granting_institution"}},{"kind":"Field","name":{"kind":"Name","value":"compensation"}},{"kind":"Field","alias":{"kind":"Name","value":"clinicalExp"},"name":{"kind":"Name","value":"clinical_exp"}},{"kind":"Field","alias":{"kind":"Name","value":"researchProject"},"name":{"kind":"Name","value":"research_project"}}]}}]} as unknown as DocumentNode<EmraAdmin_FellowshipSurveyFragment, unknown>;
export const EmraAdmin_NewSurveyTrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraAdmin_NewSurveyTrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"submitterName"},"name":{"kind":"Name","value":"submitter_name"}},{"kind":"Field","alias":{"kind":"Name","value":"submitterEmail"},"name":{"kind":"Name","value":"submitter_email"}},{"kind":"Field","alias":{"kind":"Name","value":"submitterPhone"},"name":{"kind":"Name","value":"submitter_phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"residencySurvey"},"name":{"kind":"Name","value":"residency_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkshipSurvey"},"name":{"kind":"Name","value":"clerkship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowshipSurvey"},"name":{"kind":"Name","value":"fellowship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmraAdmin_NewSurveyTrainingSurveyFragment, unknown>;
export const EmraAdmin_OldSurveyTrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraAdmin_OldSurveyTrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"submitterName"},"name":{"kind":"Name","value":"submitter_name"}},{"kind":"Field","alias":{"kind":"Name","value":"submitterEmail"},"name":{"kind":"Name","value":"submitter_email"}},{"kind":"Field","alias":{"kind":"Name","value":"submitterPhone"},"name":{"kind":"Name","value":"submitter_phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","alias":{"kind":"Name","value":"residencySurvey"},"name":{"kind":"Name","value":"residency_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkshipSurvey"},"name":{"kind":"Name","value":"clerkship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowshipSurvey"},"name":{"kind":"Name","value":"fellowship_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmraAdmin_OldSurveyTrainingSurveyFragment, unknown>;
export const EmraAdmin_ResidencySurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraAdmin_ResidencySurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"residency_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","alias":{"kind":"Name","value":"pdInterview"},"name":{"kind":"Name","value":"pd_interview"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"emraAccountNo"},"name":{"kind":"Name","value":"emra_account_no"}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingEvents"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"eventDate"},"name":{"kind":"Name","value":"event_date"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nrmpId"},"name":{"kind":"Name","value":"nrmp_id"}},{"kind":"Field","alias":{"kind":"Name","value":"acgmeId"},"name":{"kind":"Name","value":"acgme_id"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSite"},"name":{"kind":"Name","value":"primary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryTrainingSite"},"name":{"kind":"Name","value":"secondary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftLength"},"name":{"kind":"Name","value":"shift_length"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"pgy1PercentOffService"},"name":{"kind":"Name","value":"pgy_1_percent_off_service"}},{"kind":"Field","alias":{"kind":"Name","value":"step1Failures"},"name":{"kind":"Name","value":"step_1_failures"}},{"kind":"Field","alias":{"kind":"Name","value":"step1Cutoff"},"name":{"kind":"Name","value":"step_1_cutoff"}},{"kind":"Field","alias":{"kind":"Name","value":"availableInternPositions"},"name":{"kind":"Name","value":"available_intern_positions"}},{"kind":"Field","alias":{"kind":"Name","value":"percentOsteopath"},"name":{"kind":"Name","value":"percent_osteopath"}},{"kind":"Field","alias":{"kind":"Name","value":"percentImg"},"name":{"kind":"Name","value":"percent_img"}},{"kind":"Field","name":{"kind":"Name","value":"moonlighting"}},{"kind":"Field","alias":{"kind":"Name","value":"electiveWeeks"},"name":{"kind":"Name","value":"elective_weeks"}},{"kind":"Field","alias":{"kind":"Name","value":"criticalCareWeeks"},"name":{"kind":"Name","value":"critical_care_weeks"}},{"kind":"Field","alias":{"kind":"Name","value":"militaryBranch"},"name":{"kind":"Name","value":"military_branch"}},{"kind":"Field","alias":{"kind":"Name","value":"visaSponsorship"},"name":{"kind":"Name","value":"visa_sponsorship"}},{"kind":"Field","alias":{"kind":"Name","value":"sloesForInterview"},"name":{"kind":"Name","value":"sloes_for_interview"}},{"kind":"Field","alias":{"kind":"Name","value":"usmleComlex1Preference"},"name":{"kind":"Name","value":"usmle_comlex_1_preference"}},{"kind":"Field","alias":{"kind":"Name","value":"usmleComlex2Preference"},"name":{"kind":"Name","value":"usmle_comlex_2_preference"}},{"kind":"Field","alias":{"kind":"Name","value":"applicationsReceived"},"name":{"kind":"Name","value":"applications_received"}},{"kind":"Field","alias":{"kind":"Name","value":"inPersonSecondLooks"},"name":{"kind":"Name","value":"in_person_second_looks"}},{"kind":"Field","alias":{"kind":"Name","value":"cordApicInterview"},"name":{"kind":"Name","value":"cord_apic_interview"}},{"kind":"Field","alias":{"kind":"Name","value":"specialty"},"name":{"kind":"Name","value":"specialty"}}]}}]} as unknown as DocumentNode<EmraAdmin_ResidencySurveyFragment, unknown>;
export const EmraAdmin_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmraAdmin_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"directorName"},"name":{"kind":"Name","value":"director_name"}},{"kind":"Field","alias":{"kind":"Name","value":"directorEmail"},"name":{"kind":"Name","value":"director_email"}},{"kind":"Field","alias":{"kind":"Name","value":"coordinatorName"},"name":{"kind":"Name","value":"coordinator_name"}},{"kind":"Field","alias":{"kind":"Name","value":"coordinatorEmail"},"name":{"kind":"Name","value":"coordinator_email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"vimeo"}},{"kind":"Field","alias":{"kind":"Name","value":"multimediaUrls"},"name":{"kind":"Name","value":"multimedia_urls"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","alias":{"kind":"Name","value":"facilityOther"},"name":{"kind":"Name","value":"facility_other"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]} as unknown as DocumentNode<EmraAdmin_TrainingSurveyFragment, unknown>;
export const FileUpload_FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FileUpload_File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"file"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]} as unknown as DocumentNode<FileUpload_FileFragment, unknown>;
export const TrainingGeneralInfoForm_TrainingSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainingGeneralInfoForm_TrainingSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"directorName"},"name":{"kind":"Name","value":"director_name"}},{"kind":"Field","alias":{"kind":"Name","value":"directorEmail"},"name":{"kind":"Name","value":"director_email"}},{"kind":"Field","alias":{"kind":"Name","value":"coordinatorName"},"name":{"kind":"Name","value":"coordinator_name"}},{"kind":"Field","alias":{"kind":"Name","value":"coordinatorEmail"},"name":{"kind":"Name","value":"coordinator_email"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}},{"kind":"Field","name":{"kind":"Name","value":"vimeo"}},{"kind":"Field","alias":{"kind":"Name","value":"multimediaUrls"},"name":{"kind":"Name","value":"multimedia_urls"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSites"},"name":{"kind":"Name","value":"training_sites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","alias":{"kind":"Name","value":"facilityOther"},"name":{"kind":"Name","value":"facility_other"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilitySelect_Facility"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pictures"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileUpload_File"}}]}}]}}]}}]} as unknown as DocumentNode<TrainingGeneralInfoForm_TrainingSurveyFragment, unknown>;
export const TrainingSelect_TrainingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainingSelect_Training"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TrainingSelect_TrainingFragment, unknown>;
export const ClerkshipForm_ClerkshipSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClerkshipForm_ClerkshipSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clerkship_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingGeneralInfoForm_TrainingSurvey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingSelect_Training"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residencyOther"},"name":{"kind":"Name","value":"residency_other"}},{"kind":"Field","alias":{"kind":"Name","value":"vsloParticipant"},"name":{"kind":"Name","value":"vslo_participant"}},{"kind":"Field","alias":{"kind":"Name","value":"flexibleRotation"},"name":{"kind":"Name","value":"flexible_rotation"}},{"kind":"Field","alias":{"kind":"Name","value":"interviewPolicy"},"name":{"kind":"Name","value":"interview_policy"}},{"kind":"Field","alias":{"kind":"Name","value":"authStudentSloe"},"name":{"kind":"Name","value":"auth_student_sloe"}},{"kind":"Field","alias":{"kind":"Name","value":"doStudents"},"name":{"kind":"Name","value":"do_students"}},{"kind":"Field","alias":{"kind":"Name","value":"imgStudents"},"name":{"kind":"Name","value":"img_students"}},{"kind":"Field","alias":{"kind":"Name","value":"comlexRequired"},"name":{"kind":"Name","value":"comlex_required"}},{"kind":"Field","name":{"kind":"Name","value":"housing"}},{"kind":"Field","alias":{"kind":"Name","value":"vehicleRec"},"name":{"kind":"Name","value":"vehicle_rec"}},{"kind":"Field","alias":{"kind":"Name","value":"rotationTypes"},"name":{"kind":"Name","value":"rotation_types"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability1"},"name":{"kind":"Name","value":"spot_availability_1"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability2"},"name":{"kind":"Name","value":"spot_availability_2"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability3"},"name":{"kind":"Name","value":"spot_availability_3"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability4"},"name":{"kind":"Name","value":"spot_availability_4"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability5"},"name":{"kind":"Name","value":"spot_availability_5"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability6"},"name":{"kind":"Name","value":"spot_availability_6"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability7"},"name":{"kind":"Name","value":"spot_availability_7"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability8"},"name":{"kind":"Name","value":"spot_availability_8"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability9"},"name":{"kind":"Name","value":"spot_availability_9"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability10"},"name":{"kind":"Name","value":"spot_availability_10"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability11"},"name":{"kind":"Name","value":"spot_availability_11"}},{"kind":"Field","alias":{"kind":"Name","value":"spotAvailability12"},"name":{"kind":"Name","value":"spot_availability_12"}}]}}]} as unknown as DocumentNode<ClerkshipForm_ClerkshipSurveyFragment, unknown>;
export const TrainingGeneralInfoForm_TrainingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainingGeneralInfoForm_Training"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<TrainingGeneralInfoForm_TrainingFragment, unknown>;
export const TrainingAdminForm_TrainingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TrainingAdminForm_Training"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"training"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"emraAccountNo"},"name":{"kind":"Name","value":"emra_account_no"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","alias":{"kind":"Name","value":"pdInterview"},"name":{"kind":"Name","value":"pd_interview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingEvents"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"event_date"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"eventDate"},"name":{"kind":"Name","value":"event_date"}}]}}]}}]} as unknown as DocumentNode<TrainingAdminForm_TrainingFragment, unknown>;
export const ClerkshipForm_ClerkshipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClerkshipForm_Clerkship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"clerkship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingGeneralInfoForm_Training"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingAdminForm_Training"}}]}}]}}]} as unknown as DocumentNode<ClerkshipForm_ClerkshipFragment, unknown>;
export const FellowshipForm_FellowshipSurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FellowshipForm_FellowshipSurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fellowship_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingGeneralInfoForm_TrainingSurvey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingSelect_Training"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residencyOther"},"name":{"kind":"Name","value":"residency_other"}},{"kind":"Field","name":{"kind":"Name","value":"subspecialty"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"positionsPerYear"},"name":{"kind":"Name","value":"positions_per_year"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"moonlightingAllowed"},"name":{"kind":"Name","value":"moonlighting_allowed"}},{"kind":"Field","alias":{"kind":"Name","value":"advancedDegrees"},"name":{"kind":"Name","value":"advanced_degrees"}},{"kind":"Field","alias":{"kind":"Name","value":"degreeGrantingInstitution"},"name":{"kind":"Name","value":"degree_granting_institution"}},{"kind":"Field","name":{"kind":"Name","value":"compensation"}},{"kind":"Field","alias":{"kind":"Name","value":"clinicalExp"},"name":{"kind":"Name","value":"clinical_exp"}},{"kind":"Field","alias":{"kind":"Name","value":"researchProject"},"name":{"kind":"Name","value":"research_project"}}]}}]} as unknown as DocumentNode<FellowshipForm_FellowshipSurveyFragment, unknown>;
export const FellowshipForm_FellowshipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FellowshipForm_Fellowship"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fellowship"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingGeneralInfoForm_Training"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingAdminForm_Training"}}]}}]}}]} as unknown as DocumentNode<FellowshipForm_FellowshipFragment, unknown>;
export const ResidencyForm_ResidencySurveyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResidencyForm_ResidencySurvey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"residency_survey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingGeneralInfoForm_TrainingSurvey"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nrmpId"},"name":{"kind":"Name","value":"nrmp_id"}},{"kind":"Field","alias":{"kind":"Name","value":"acgmeId"},"name":{"kind":"Name","value":"acgme_id"}},{"kind":"Field","alias":{"kind":"Name","value":"programLength"},"name":{"kind":"Name","value":"program_length"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryTrainingSite"},"name":{"kind":"Name","value":"primary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"secondaryTrainingSite"},"name":{"kind":"Name","value":"secondary_training_site"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftLength"},"name":{"kind":"Name","value":"shift_length"}},{"kind":"Field","alias":{"kind":"Name","value":"shiftsPerMonth"},"name":{"kind":"Name","value":"shifts_per_month"}},{"kind":"Field","alias":{"kind":"Name","value":"pgy1PercentOffService"},"name":{"kind":"Name","value":"pgy_1_percent_off_service"}},{"kind":"Field","alias":{"kind":"Name","value":"step1Failures"},"name":{"kind":"Name","value":"step_1_failures"}},{"kind":"Field","alias":{"kind":"Name","value":"step1Cutoff"},"name":{"kind":"Name","value":"step_1_cutoff"}},{"kind":"Field","alias":{"kind":"Name","value":"availableInternPositions"},"name":{"kind":"Name","value":"available_intern_positions"}},{"kind":"Field","alias":{"kind":"Name","value":"percentOsteopath"},"name":{"kind":"Name","value":"percent_osteopath"}},{"kind":"Field","alias":{"kind":"Name","value":"percentImg"},"name":{"kind":"Name","value":"percent_img"}},{"kind":"Field","name":{"kind":"Name","value":"moonlighting"}},{"kind":"Field","alias":{"kind":"Name","value":"electiveWeeks"},"name":{"kind":"Name","value":"elective_weeks"}},{"kind":"Field","alias":{"kind":"Name","value":"criticalCareWeeks"},"name":{"kind":"Name","value":"critical_care_weeks"}},{"kind":"Field","alias":{"kind":"Name","value":"militaryBranch"},"name":{"kind":"Name","value":"military_branch"}},{"kind":"Field","alias":{"kind":"Name","value":"visaSponsorship"},"name":{"kind":"Name","value":"visa_sponsorship"}},{"kind":"Field","alias":{"kind":"Name","value":"sloesForInterview"},"name":{"kind":"Name","value":"sloes_for_interview"}},{"kind":"Field","alias":{"kind":"Name","value":"usmleComlex1Preference"},"name":{"kind":"Name","value":"usmle_comlex_1_preference"}},{"kind":"Field","alias":{"kind":"Name","value":"usmleComlex2Preference"},"name":{"kind":"Name","value":"usmle_comlex_2_preference"}},{"kind":"Field","alias":{"kind":"Name","value":"applicationsReceived"},"name":{"kind":"Name","value":"applications_received"}},{"kind":"Field","alias":{"kind":"Name","value":"inPersonSecondLooks"},"name":{"kind":"Name","value":"in_person_second_looks"}},{"kind":"Field","alias":{"kind":"Name","value":"cordApicInterview"},"name":{"kind":"Name","value":"cord_apic_interview"}},{"kind":"Field","alias":{"kind":"Name","value":"specialty"},"name":{"kind":"Name","value":"specialty"}}]}}]} as unknown as DocumentNode<ResidencyForm_ResidencySurveyFragment, unknown>;
export const ResidencyForm_ResidencyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResidencyForm_Residency"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"residency"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","alias":{"kind":"Name","value":"pdInterview"},"name":{"kind":"Name","value":"pd_interview"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingGeneralInfoForm_Training"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingAdminForm_Training"}}]}}]}}]} as unknown as DocumentNode<ResidencyForm_ResidencyFragment, unknown>;
export const ApplyToJobPopup_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplyToJobPopup_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ApplyToJobPopup_ContractFragment, unknown>;
export const Map_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Map_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobPopup_Contract"}}]}}]} as unknown as DocumentNode<Map_ContractFragment, unknown>;
export const Map_NearbyFacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Map_NearbyFacility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"nearby_facilities_by_geography_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRatePosting"},"name":{"kind":"Name","value":"max_postings_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"normRate"},"name":{"kind":"Name","value":"normalized_rate"}},{"kind":"Field","name":{"kind":"Name","value":"wageTrunc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"numPostings"},"name":{"kind":"Name","value":"num_postings_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Contract"}}]}}]}}]}}]} as unknown as DocumentNode<Map_NearbyFacilityFragment, unknown>;
export const ApplyToJobPopup_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplyToJobPopup_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<ApplyToJobPopup_PostingFragment, unknown>;
export const Map_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Map_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"adultTraumaLvl"},"name":{"kind":"Name","value":"adult_trauma_lvl"}},{"kind":"Field","alias":{"kind":"Name","value":"freestandingEr"},"name":{"kind":"Name","value":"freestanding_er"}},{"kind":"Field","name":{"kind":"Name","value":"facilityType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"residencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityPos"},"name":{"kind":"Name","value":"cms_facility_pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerSubtype"},"name":{"kind":"Name","value":"provider_subtype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityEnrollment"},"name":{"kind":"Name","value":"cms_facility_enrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerTypeCode"},"name":{"kind":"Name","value":"provider_type_code"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacility"},"name":{"kind":"Name","value":"cms_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"hospitalType"},"name":{"kind":"Name","value":"hospital_type"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"measure_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"EDV","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"measureId"},"name":{"kind":"Name","value":"measure_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ahaFacility"},"name":{"kind":"Name","value":"aha_facility_22"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"UNAME"}},{"kind":"Field","alias":{"kind":"Name","value":"par"},"name":{"kind":"Name","value":"parent_aha_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"MNAME"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rollups"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"maxRatePosting"},"name":{"kind":"Name","value":"max_postings_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"normRate"},"name":{"kind":"Name","value":"normalized_rate"}},{"kind":"Field","name":{"kind":"Name","value":"wageTrunc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"numPostings"},"name":{"kind":"Name","value":"num_postings_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"featured"},"name":{"kind":"Name","value":"featured_for_prof"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"immediateNeeds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Contract"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_active_contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rating"},"name":{"kind":"Name","value":"rating_job"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accreditations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accreditation"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]} as unknown as DocumentNode<Map_FacilityFragment, unknown>;
export const Map_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Map_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"descriptionHtml"},"name":{"kind":"Name","value":"description_html"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"normRate"},"name":{"kind":"Name","value":"normalized_rate"}},{"kind":"Field","name":{"kind":"Name","value":"wageTrunc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobPopup_Posting"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Contract"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Facility"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"workerClassifications"},"name":{"kind":"Name","value":"worker_classifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}}]}}]}}]} as unknown as DocumentNode<Map_PostingFragment, unknown>;
export const ApplyToJobButton_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ApplyToJobButton_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobPopup_Contract"}}]}}]} as unknown as DocumentNode<ApplyToJobButton_ContractFragment, unknown>;
export const EmployerListPopover_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployerListPopover_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobButton_Contract"}}]}}]} as unknown as DocumentNode<EmployerListPopover_ContractFragment, unknown>;
export const FacilityJobs_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityJobs_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"lastModified"},"name":{"kind":"Name","value":"last_modified"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","name":{"kind":"Name","value":"wageTrunc"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobButton_Contract"}}]}}]}}]} as unknown as DocumentNode<FacilityJobs_FacilityFragment, unknown>;
export const ReportCorrection_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportCorrection_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ReportCorrection_FacilityFragment, unknown>;
export const CorrectionToast_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CorrectionToast_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportCorrection_Facility"}}]}}]} as unknown as DocumentNode<CorrectionToast_FacilityFragment, unknown>;
export const FacilityDescription_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityDescription_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<FacilityDescription_FacilityFragment, unknown>;
export const FacilityFeatures_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityFeatures_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","alias":{"kind":"Name","value":"adultTraumaLvl"},"name":{"kind":"Name","value":"adult_trauma_lvl"}},{"kind":"Field","alias":{"kind":"Name","value":"freestandingEr"},"name":{"kind":"Name","value":"freestanding_er"}},{"kind":"Field","name":{"kind":"Name","value":"residencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"strokeCerts"},"name":{"kind":"Name","value":"stroke_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ehrs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacility"},"name":{"kind":"Name","value":"cms_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"overallRating"},"name":{"kind":"Name","value":"overall_rating"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"measure_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"OP_18b","block":false},{"kind":"StringValue","value":"OP_22","block":false},{"kind":"StringValue","value":"SEP_1","block":false},{"kind":"StringValue","value":"MORT_30_AMI","block":false},{"kind":"StringValue","value":"MORT_30_COPD","block":false},{"kind":"StringValue","value":"MORT_30_STK","block":false},{"kind":"StringValue","value":"EDV","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"measureId"},"name":{"kind":"Name","value":"measure_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hospitalType"},"name":{"kind":"Name","value":"hospital_type"}},{"kind":"Field","name":{"kind":"Name","value":"facilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityPos"},"name":{"kind":"Name","value":"cms_facility_pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerSubtype"},"name":{"kind":"Name","value":"provider_subtype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityEnrollment"},"name":{"kind":"Name","value":"cms_facility_enrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerTypeCode"},"name":{"kind":"Name","value":"provider_type_code"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ahaFacility"},"name":{"kind":"Name","value":"aha_facility_22"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"medSchool"},"name":{"kind":"Name","value":"MAPP5"}},{"kind":"Field","alias":{"kind":"Name","value":"healthSystem"},"name":{"kind":"Name","value":"SYSNAME"}},{"kind":"Field","name":{"kind":"Name","value":"svc1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"cathLab"},"name":{"kind":"Name","value":"ICLABHOS"}},{"kind":"Field","alias":{"kind":"Name","value":"hospBeds"},"name":{"kind":"Name","value":"HOSPBD"}},{"kind":"Field","alias":{"kind":"Name","value":"genBeds"},"name":{"kind":"Name","value":"GENBD"}},{"kind":"Field","alias":{"kind":"Name","value":"genPedBeds"},"name":{"kind":"Name","value":"PEDBD"}},{"kind":"Field","alias":{"kind":"Name","value":"msicBeds"},"name":{"kind":"Name","value":"MSICBD"}},{"kind":"Field","alias":{"kind":"Name","value":"pedicBeds"},"name":{"kind":"Name","value":"PEDICBD"}},{"kind":"Field","alias":{"kind":"Name","value":"burnBeds"},"name":{"kind":"Name","value":"BRNBD"}},{"kind":"Field","alias":{"kind":"Name","value":"psychBeds"},"name":{"kind":"Name","value":"PSYBD"}}]}},{"kind":"Field","name":{"kind":"Name","value":"svc2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"psychOutpatientServices"},"name":{"kind":"Name","value":"PSYOPHOS"}},{"kind":"Field","alias":{"kind":"Name","value":"pscyhEmergencyServices"},"name":{"kind":"Name","value":"PSYEMHOS"}},{"kind":"Field","alias":{"kind":"Name","value":"psychPedBeds"},"name":{"kind":"Name","value":"PSCBD"}},{"kind":"Field","alias":{"kind":"Name","value":"psychGerBeds"},"name":{"kind":"Name","value":"PSGBD"}}]}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"UNAME"}},{"kind":"Field","alias":{"kind":"Name","value":"par"},"name":{"kind":"Name","value":"parent_aha_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}},{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"MNAME"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rollups"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"facilityType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accreditations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accreditation"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportCorrection_Facility"}}]}}]} as unknown as DocumentNode<FacilityFeatures_FacilityFragment, unknown>;
export const FacilityGallery_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityGallery_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<FacilityGallery_FacilityFragment, unknown>;
export const FacilityNearby_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FacilityNearby_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<FacilityNearby_FacilityFragment, unknown>;
export const JobPostingDescription_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingDescription_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"descriptionHtml"},"name":{"kind":"Name","value":"description_html"}}]}}]} as unknown as DocumentNode<JobPostingDescription_PostingFragment, unknown>;
export const JobPostingDetails_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingDetails_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"hasSigningBonus"},"name":{"kind":"Name","value":"has_signing_bonus"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRelocationAssist"},"name":{"kind":"Name","value":"has_relocation_assist"}},{"kind":"Field","alias":{"kind":"Name","value":"hasPerfBonus"},"name":{"kind":"Name","value":"has_perf_bonus"}},{"kind":"Field","alias":{"kind":"Name","value":"malpracticeInsurance"},"name":{"kind":"Name","value":"malpractice_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"tailCoverage"},"name":{"kind":"Name","value":"tail_coverage"}},{"kind":"Field","alias":{"kind":"Name","value":"equity"},"name":{"kind":"Name","value":"equity"}},{"kind":"Field","alias":{"kind":"Name","value":"healthInsurance"},"name":{"kind":"Name","value":"health_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"dentalInsurance"},"name":{"kind":"Name","value":"dental_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"visionInsurance"},"name":{"kind":"Name","value":"vision_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"healthAccount"},"name":{"kind":"Name","value":"health_account"}},{"kind":"Field","alias":{"kind":"Name","value":"disabilityInsurance"},"name":{"kind":"Name","value":"disability_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"lifeInsurance"},"name":{"kind":"Name","value":"life_insurance"}},{"kind":"Field","alias":{"kind":"Name","value":"retirement"},"name":{"kind":"Name","value":"retirement_account"}},{"kind":"Field","alias":{"kind":"Name","value":"paidVacation"},"name":{"kind":"Name","value":"paid_vacation"}},{"kind":"Field","alias":{"kind":"Name","value":"paidParental"},"name":{"kind":"Name","value":"paid_parental"}},{"kind":"Field","alias":{"kind":"Name","value":"studentLoan"},"name":{"kind":"Name","value":"student_loan"}},{"kind":"Field","name":{"kind":"Name","value":"cme"}}]}}]} as unknown as DocumentNode<JobPostingDetails_PostingFragment, unknown>;
export const AccountAvatar_AccountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountAvatar_Account"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]} as unknown as DocumentNode<AccountAvatar_AccountFragment, unknown>;
export const EmployerInfo_ContractFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmployerInfo_Contract"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_contract"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountAvatar_Account"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditRecruiterPopup_Contract"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobButton_Contract"}}]}}]} as unknown as DocumentNode<EmployerInfo_ContractFragment, unknown>;
export const JobPostingEmployer_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingEmployer_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployerInfo_Contract"}}]}}]}}]} as unknown as DocumentNode<JobPostingEmployer_PostingFragment, unknown>;
export const JobPostingFacility_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingFacility_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityCard_Facility"}}]}}]}}]}}]} as unknown as DocumentNode<JobPostingFacility_PostingFragment, unknown>;
export const JobPostingOverview_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingOverview_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"term"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"startOrTodayDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","alias":{"kind":"Name","value":"j1Visa"},"name":{"kind":"Name","value":"j1_visa"}},{"kind":"Field","alias":{"kind":"Name","value":"h1bVisa"},"name":{"kind":"Name","value":"h1b_visa"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"workerClassifications"},"name":{"kind":"Name","value":"worker_classifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}}]}}]}}]} as unknown as DocumentNode<JobPostingOverview_PostingFragment, unknown>;
export const JobPostingQualifications_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingQualifications_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"currentLicense"},"name":{"kind":"Name","value":"current_license"}},{"kind":"Field","name":{"kind":"Name","value":"bcbe"}},{"kind":"Field","alias":{"kind":"Name","value":"expReq"},"name":{"kind":"Name","value":"exp_req"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boardCerts"},"name":{"kind":"Name","value":"board_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appCerts"},"name":{"kind":"Name","value":"app_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<JobPostingQualifications_PostingFragment, unknown>;
export const JobPostingStructuredData_PostingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingStructuredData_Posting"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"descriptionHtml"},"name":{"kind":"Name","value":"description_html"}},{"kind":"Field","alias":{"kind":"Name","value":"createdAt"},"name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"createdAtDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"schedule"}},{"kind":"Field","name":{"kind":"Name","value":"term"}},{"kind":"Field","alias":{"kind":"Name","value":"hasRate"},"name":{"kind":"Name","value":"has_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"isExactRate"},"name":{"kind":"Name","value":"is_exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"exactRate"},"name":{"kind":"Name","value":"exact_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"minRate"},"name":{"kind":"Name","value":"min_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"maxRate"},"name":{"kind":"Name","value":"max_rate"}},{"kind":"Field","alias":{"kind":"Name","value":"ratePeriod"},"name":{"kind":"Name","value":"rate_period"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"workerClassifications"},"name":{"kind":"Name","value":"worker_classifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"worker"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"boardCerts"},"name":{"kind":"Name","value":"board_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cert"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appCerts"},"name":{"kind":"Name","value":"app_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddr1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddr2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<JobPostingStructuredData_PostingFragment, unknown>;
export const JobPostingCard_JobPostingInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingCard_JobPostingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"lastModified"},"name":{"kind":"Name","value":"last_modified"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"changeRequest"},"name":{"kind":"Name","value":"change_request"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"expirationDate"},"name":{"kind":"Name","value":"expiration_date"}},{"kind":"Field","alias":{"kind":"Name","value":"latestPublication"},"name":{"kind":"Name","value":"latest_publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publishedAt"},"name":{"kind":"Name","value":"published_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<JobPostingCard_JobPostingInfoFragment, unknown>;
export const JobPostingTable_JobPostingInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobPostingTable_JobPostingInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"lastModified"},"name":{"kind":"Name","value":"last_modified"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"changeRequest"},"name":{"kind":"Name","value":"change_request"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestPublication"},"name":{"kind":"Name","value":"latest_publication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"publishedAt"},"name":{"kind":"Name","value":"published_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"expirationDate"},"name":{"kind":"Name","value":"expiration_date"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<JobPostingTable_JobPostingInfoFragment, unknown>;
export const FeauredList_FacilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeauredList_Facility"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"ranking_review"}},{"kind":"Field","alias":{"kind":"Name","value":"adultTraumaLvl"},"name":{"kind":"Name","value":"adult_trauma_lvl"}},{"kind":"Field","alias":{"kind":"Name","value":"freestandingEr"},"name":{"kind":"Name","value":"freestanding_er"}},{"kind":"Field","name":{"kind":"Name","value":"facilityType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityPos"},"name":{"kind":"Name","value":"cms_facility_pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerSubtype"},"name":{"kind":"Name","value":"provider_subtype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityEnrollment"},"name":{"kind":"Name","value":"cms_facility_enrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerTypeCode"},"name":{"kind":"Name","value":"provider_type_code"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacility"},"name":{"kind":"Name","value":"cms_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"hospitalType"},"name":{"kind":"Name","value":"hospital_type"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ahaFacility"},"name":{"kind":"Name","value":"aha_facility_22"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"ID"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewsAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_active_contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ratingJob"},"name":{"kind":"Name","value":"rating_job"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FeauredList_FacilityFragment, unknown>;
export const FeauredList_OrganizationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FeauredList_Organization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"ranking_review"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"coverPhoto"},"name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","alias":{"kind":"Name","value":"contractsAgg"},"name":{"kind":"Name","value":"contracts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewsAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ratingOrg"},"name":{"kind":"Name","value":"rating_org"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FeauredList_OrganizationFragment, unknown>;
export const NearbyList_FacilityDistanceResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NearbyList_FacilityDistanceResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"facility_dist_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"ranking_review"}},{"kind":"Field","alias":{"kind":"Name","value":"adultTraumaLvl"},"name":{"kind":"Name","value":"adult_trauma_lvl"}},{"kind":"Field","alias":{"kind":"Name","value":"freestandingEr"},"name":{"kind":"Name","value":"freestanding_er"}},{"kind":"Field","name":{"kind":"Name","value":"facilityType"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityPos"},"name":{"kind":"Name","value":"cms_facility_pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerSubtype"},"name":{"kind":"Name","value":"provider_subtype"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityEnrollment"},"name":{"kind":"Name","value":"cms_facility_enrollment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"providerTypeCode"},"name":{"kind":"Name","value":"provider_type_code"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacility"},"name":{"kind":"Name","value":"cms_facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"hospitalType"},"name":{"kind":"Name","value":"hospital_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewsAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_active_contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ratingJob"},"name":{"kind":"Name","value":"rating_job"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NearbyList_FacilityDistanceResultFragment, unknown>;
export const NearbyList_OrganizationDistanceResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NearbyList_OrganizationDistanceResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"org_dist_result"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ranking_review"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"coverPhoto"},"name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","alias":{"kind":"Name","value":"contractsAgg"},"name":{"kind":"Name","value":"contracts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewsAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ratingOrg"},"name":{"kind":"Name","value":"rating_org"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NearbyList_OrganizationDistanceResultFragment, unknown>;
export const InvoicesView_InvoicesDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoicesView_InvoicesData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicesDataGQL"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","alias":{"kind":"Name","value":"downloadLink"},"name":{"kind":"Name","value":"download_link"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hasMore"},"name":{"kind":"Name","value":"has_more"}}]}}]} as unknown as DocumentNode<InvoicesView_InvoicesDataFragment, unknown>;
export const AcepCharacteristics_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcepCharacteristics_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"surveys"},"name":{"kind":"Name","value":"acep_org_surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"staffing"}},{"kind":"Field","alias":{"kind":"Name","value":"numEmPhysicians"},"name":{"kind":"Name","value":"num_em_physicians"}},{"kind":"Field","alias":{"kind":"Name","value":"practiceSize"},"name":{"kind":"Name","value":"practice_size"}},{"kind":"Field","alias":{"kind":"Name","value":"geographicDist"},"name":{"kind":"Name","value":"geographic_dist"}},{"kind":"Field","alias":{"kind":"Name","value":"contractOwner"},"name":{"kind":"Name","value":"contract_owner"}},{"kind":"Field","name":{"kind":"Name","value":"governance"}},{"kind":"Field","alias":{"kind":"Name","value":"ceoIsPhysician"},"name":{"kind":"Name","value":"ceo_is_physician"}},{"kind":"Field","name":{"kind":"Name","value":"funding"}}]}}]}}]} as unknown as DocumentNode<AcepCharacteristics_OrgFragment, unknown>;
export const AcepInfo_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcepInfo_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"surveys"},"name":{"kind":"Name","value":"acep_org_surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dba"}},{"kind":"Field","alias":{"kind":"Name","value":"nameCmo"},"name":{"kind":"Name","value":"name_cmo"}}]}}]}}]} as unknown as DocumentNode<AcepInfo_OrgFragment, unknown>;
export const AcepOperations_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcepOperations_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"surveys"},"name":{"kind":"Name","value":"acep_org_surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"partnershipsOffered"},"name":{"kind":"Name","value":"partnerships_offered"}},{"kind":"Field","alias":{"kind":"Name","value":"billingDisclosure"},"name":{"kind":"Name","value":"billing_disclosure"}},{"kind":"Field","name":{"kind":"Name","value":"apps"}},{"kind":"Field","alias":{"kind":"Name","value":"appsUnsupervised"},"name":{"kind":"Name","value":"apps_unsupervised"}}]}}]}}]} as unknown as DocumentNode<AcepOperations_OrgFragment, unknown>;
export const AcepPolicies_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AcepPolicies_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"surveys"},"name":{"kind":"Name","value":"acep_org_surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"acepPolicies"},"name":{"kind":"Name","value":"acep_policies"}}]}}]}}]} as unknown as DocumentNode<AcepPolicies_OrgFragment, unknown>;
export const OrgAbout_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgAbout_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","alias":{"kind":"Name","value":"contractsAgg"},"name":{"kind":"Name","value":"contracts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrgAbout_OrgFragment, unknown>;
export const OrgAtAGlance_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgAtAGlance_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}},{"kind":"Field","alias":{"kind":"Name","value":"contractsAgg"},"name":{"kind":"Name","value":"contracts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrgAtAGlance_OrgFragment, unknown>;
export const OrgFacilities_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgFacilities_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contractsAgg"},"name":{"kind":"Name","value":"contracts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrgFacilities_OrgFragment, unknown>;
export const OrgJobs_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgJobs_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"jobs"},"name":{"kind":"Name","value":"job_postings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"professions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionsFilter"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"posting"},"name":{"kind":"Name","value":"job_posting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobsAgg"},"name":{"kind":"Name","value":"job_postings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"professions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionsFilter"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrgJobs_OrgFragment, unknown>;
export const OrgWhitelabelCta_OrgFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgWhitelabelCta_Org"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<OrgWhitelabelCta_OrgFragment, unknown>;
export const CheckoutForm_CreateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutForm_CreateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slots"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentIntent"},"name":{"kind":"Name","value":"create_customer_subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slots"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"payment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"promo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSecret"},"name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","alias":{"kind":"Name","value":"amountDue"},"name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","alias":{"kind":"Name","value":"setupFutureUsage"},"name":{"kind":"Name","value":"setup_future_usage"}}]}}]}}]} as unknown as DocumentNode<CheckoutForm_CreateSubscriptionMutation, CheckoutForm_CreateSubscriptionMutationVariables>;
export const CheckoutForm_UpdateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutForm_UpdateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slots"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerDetailsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentIntent"},"name":{"kind":"Name","value":"update_customer_subscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slots"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerDetails"}}},{"kind":"Argument","name":{"kind":"Name","value":"payment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"promo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clientSecret"},"name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","alias":{"kind":"Name","value":"amountDue"},"name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","alias":{"kind":"Name","value":"setupFutureUsage"},"name":{"kind":"Name","value":"setup_future_usage"}}]}}]}}]} as unknown as DocumentNode<CheckoutForm_UpdateSubscriptionMutation, CheckoutForm_UpdateSubscriptionMutationVariables>;
export const CheckoutForm_PayOutstandingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckoutForm_PayOutstanding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentIntent"},"name":{"kind":"Name","value":"pay_outstanding_balance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"clientSecret"},"name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","alias":{"kind":"Name","value":"amountDue"},"name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","alias":{"kind":"Name","value":"setupFutureUsage"},"name":{"kind":"Name","value":"setup_future_usage"}}]}}]}}]} as unknown as DocumentNode<CheckoutForm_PayOutstandingMutation, CheckoutForm_PayOutstandingMutationVariables>;
export const CheckoutSummary_SubscriptionInvoicePreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckoutSummary_SubscriptionInvoicePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"interval"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerAddressInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"promo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"subscriptionInvoicePreview"},"name":{"kind":"Name","value":"get_subscription_invoice_preview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"interval"},"value":{"kind":"Variable","name":{"kind":"Name","value":"interval"}}},{"kind":"Argument","name":{"kind":"Name","value":"quantity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"quantity"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"promo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"promo"}}},{"kind":"Argument","name":{"kind":"Name","value":"org_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subtotal"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"tax"}}]}}]}}]} as unknown as DocumentNode<CheckoutSummary_SubscriptionInvoicePreviewQuery, CheckoutSummary_SubscriptionInvoicePreviewQueryVariables>;
export const EditEmployerProfileForm_UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditEmployerProfileForm_UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organization_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EditEmployerProfileForm_UpdateProfileMutation, EditEmployerProfileForm_UpdateProfileMutationVariables>;
export const FacilityOverviewForm_UpdateOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FacilityOverviewForm_UpdateOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_facility_picture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FacilityOverviewForm_UpdateOverviewMutation, FacilityOverviewForm_UpdateOverviewMutationVariables>;
export const FacilityRecruiterForm_OrgUsersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityRecruiterForm_OrgUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orgUsers"},"name":{"kind":"Name","value":"org_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"access_info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personal_info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityRecruiterForm_Recruiter"}}]}}]}},...FacilityRecruiterForm_RecruiterFragmentDoc.definitions]} as unknown as DocumentNode<FacilityRecruiterForm_OrgUsersQuery, FacilityRecruiterForm_OrgUsersQueryVariables>;
export const JobPostingFormGeneralInfo_SelectFacilityContractDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_SelectFacilityContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contracts"},"name":{"kind":"Name","value":"facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending_or_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Contract"}}]}}]}},...JobPostingFormGeneralInfo_ContractFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...EditRecruiterPopup_ContractFragmentDoc.definitions]} as unknown as DocumentNode<JobPostingFormGeneralInfo_SelectFacilityContractQuery, JobPostingFormGeneralInfo_SelectFacilityContractQueryVariables>;
export const JobPostingFormGeneralInfo_FetchNewContractDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_FetchNewContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contract"},"name":{"kind":"Name","value":"facility_contract_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Contract"}}]}}]}},...JobPostingFormGeneralInfo_ContractFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...EditRecruiterPopup_ContractFragmentDoc.definitions]} as unknown as DocumentNode<JobPostingFormGeneralInfo_FetchNewContractQuery, JobPostingFormGeneralInfo_FetchNewContractQueryVariables>;
export const ClinicianSignupStep_RegisterClinicianDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClinicianSignupStep_RegisterClinician"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterClinicianInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signup"},"name":{"kind":"Name","value":"register_clinician"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"access"},"name":{"kind":"Name","value":"access_token"}},{"kind":"Field","alias":{"kind":"Name","value":"refresh"},"name":{"kind":"Name","value":"refresh_token"}}]}}]}}]} as unknown as DocumentNode<ClinicianSignupStep_RegisterClinicianMutation, ClinicianSignupStep_RegisterClinicianMutationVariables>;
export const OrgSignupForm_SearchOrgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgSignupForm_SearchOrgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"domainSignups"},"name":{"kind":"Name","value":"domain_signups"}},{"kind":"Field","name":{"kind":"Name","value":"domains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrgSignupForm_SearchOrgsQuery, OrgSignupForm_SearchOrgsQueryVariables>;
export const OrgSignupForm_SelectedOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgSignupForm_SelectedOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrgSignupForm_SelectedOrgQuery, OrgSignupForm_SelectedOrgQueryVariables>;
export const OrganizationSignupStep_SignUpOrgUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrganizationSignupStep_SignUpOrgUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignUpOrgUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"registration"},"name":{"kind":"Name","value":"sign_up_org_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<OrganizationSignupStep_SignUpOrgUserMutation, OrganizationSignupStep_SignUpOrgUserMutationVariables>;
export const AppCerts_GetAppCertificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"APPCerts_GetAPPCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appCerts"},"name":{"kind":"Name","value":"app_certs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"degrees"}}]}}]}}]} as unknown as DocumentNode<AppCerts_GetAppCertificationsQuery, AppCerts_GetAppCertificationsQueryVariables>;
export const BoardCerts_GetBoardCertificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardCerts_GetBoardCertifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boardCerts"},"name":{"kind":"Name","value":"board_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","alias":{"kind":"Name","value":"fieldType"},"name":{"kind":"Name","value":"field_type"}},{"kind":"Field","name":{"kind":"Name","value":"board"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BoardCerts_GetBoardCertificationsQuery, BoardCerts_GetBoardCertificationsQueryVariables>;
export const ClinicianSearch_ImportCredentialsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClinicianSearch_ImportCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"importCreds"},"name":{"kind":"Name","value":"import_credentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileCompleteForm_Clinician"}}]}}]}}]}},...ProfileCompleteForm_ClinicianFragmentDoc.definitions,...ClinicianSearch_FsmbBioFragmentDoc.definitions]} as unknown as DocumentNode<ClinicianSearch_ImportCredentialsMutation, ClinicianSearch_ImportCredentialsMutationVariables>;
export const ClinicianSearch_UnlinkCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClinicianSearch_UnlinkCredentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unlinkCreds"},"name":{"kind":"Name","value":"unlink_credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clinician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fsmbBio"},"name":{"kind":"Name","value":"fsmb_bio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClinicianSearch_UnlinkCredentialsMutation, ClinicianSearch_UnlinkCredentialsMutationVariables>;
export const ClinicianSearch_SearchFsmbDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClinicianSearch_SearchFSMB"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profDegree"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_fsmb_bio"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"npi"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fsmb_bio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"practitioner_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profDegree"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"practitioner_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lev_last"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lev_first"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"graduation_year"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fid"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","alias":{"kind":"Name","value":"fsmbBio"},"name":{"kind":"Name","value":"fsmb_bio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianSearch_FsmbBio"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"search_fsmb_bio_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"npi"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fsmb_bio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"practitioner_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profDegree"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"practitioner_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...ClinicianSearch_FsmbBioFragmentDoc.definitions]} as unknown as DocumentNode<ClinicianSearch_SearchFsmbQuery, ClinicianSearch_SearchFsmbQueryVariables>;
export const Experience_GetSpecialtiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Experience_GetSpecialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"medicare_specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Experience_GetSpecialtiesQuery, Experience_GetSpecialtiesQueryVariables>;
export const Residency_SearchTrainingProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Residency_SearchTrainingPrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"training"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"trainingtype"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"programs"},"name":{"kind":"Name","value":"training_program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldName"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"training_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"training"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<Residency_SearchTrainingProgramsQuery, Residency_SearchTrainingProgramsQueryVariables>;
export const Residency_GetTrainingSpecialtiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Residency_GetTrainingSpecialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"training_specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"training"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fields"},"name":{"kind":"Name","value":"training_field"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"training"},"name":{"kind":"Name","value":"training_type"}}]}}]}}]} as unknown as DocumentNode<Residency_GetTrainingSpecialtiesQuery, Residency_GetTrainingSpecialtiesQueryVariables>;
export const School_SearchSchoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"School_SearchSchools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profDegree"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"professionaldegree"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"schools"},"name":{"kind":"Name","value":"school"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"prof_degree"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profDegree"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prof_degree"}}]}}]}}]} as unknown as DocumentNode<School_SearchSchoolsQuery, School_SearchSchoolsQueryVariables>;
export const Specialty_GetSpecialtiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Specialty_GetSpecialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"medicare_specialties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<Specialty_GetSpecialtiesQuery, Specialty_GetSpecialtiesQueryVariables>;
export const ProfileCompleteForm_UpdateProfileSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfileCompleteForm_UpdateProfileSkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProfileCompleteForm_UpdateProfileSkillsMutation, ProfileCompleteForm_UpdateProfileSkillsMutationVariables>;
export const ProfileCompleteForm_UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfileCompleteForm_UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"specialties"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_specialty_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appCerts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_app_cert_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spExp"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_sp_exp_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardCerts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_board_cert_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licenses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_license_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"training"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clinician_training_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schoolName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gradYr"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_clinician_specialty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_clinician_specialty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"specialties"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_clinician_app_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_clinician_app_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appCerts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_clinician_sp_exp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_clinician_sp_exp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spExp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_clinician_board_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_clinician_board_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardCerts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_clinician_license"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_clinician_license"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licenses"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_clinician_training"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_clinician_training"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"training"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"school_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schoolName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"grad_yr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gradYr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"creds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cv_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"profile_complete"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"profileComplete"},"name":{"kind":"Name","value":"profile_complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_current_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"picture_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProfileCompleteForm_UpdateProfileMutation, ProfileCompleteForm_UpdateProfileMutationVariables>;
export const Employer_SearchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Employer_SearchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<Employer_SearchOrganizationQuery, Employer_SearchOrganizationQueryVariables>;
export const ReviewForm_CreateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewForm_CreateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_review_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReviewForm_CreateReviewMutation, ReviewForm_CreateReviewMutationVariables>;
export const SalaryReportFormGeneralStep_SearchOrgsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_SearchOrgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryReportFormGeneralStep_Organization"}}]}}]}}]}},...SalaryReportFormGeneralStep_OrganizationFragmentDoc.definitions]} as unknown as DocumentNode<SalaryReportFormGeneralStep_SearchOrgsQuery, SalaryReportFormGeneralStep_SearchOrgsQueryVariables>;
export const FacilitySelect_SearchFacilityDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilitySelect_SearchFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preload"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"search_facility_by_prefix_result_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_facility_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preload_empty_search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preload"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilitySelect_Facility"}}]}}]}}]}},...FacilitySelect_FacilityFragmentDoc.definitions]} as unknown as DocumentNode<FacilitySelect_SearchFacilityQuery, FacilitySelect_SearchFacilityQueryVariables>;
export const FileUpload_CreateFileDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FileUpload_CreateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"created"},"name":{"kind":"Name","value":"create_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}},{"kind":"Argument","name":{"kind":"Name","value":"content_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origin"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"uploadUrl"},"name":{"kind":"Name","value":"upload_url"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileUpload_File"}}]}}]}}]}},...FileUpload_FileFragmentDoc.definitions]} as unknown as DocumentNode<FileUpload_CreateFileMutation, FileUpload_CreateFileMutationVariables>;
export const FileUpload_FinalizeFileDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FileUpload_FinalizeFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"finalized"},"name":{"kind":"Name","value":"finalize_file"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileUpload_File"}}]}}]}}]}},...FileUpload_FileFragmentDoc.definitions]} as unknown as DocumentNode<FileUpload_FinalizeFileMutation, FileUpload_FinalizeFileMutationVariables>;
export const AddFacilityPopup_InviteNewRecruiterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddFacilityPopup_InviteNewRecruiter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteOrgUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invite"},"name":{"kind":"Name","value":"invite_org_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","alias":{"kind":"Name","value":"accountId"},"name":{"kind":"Name","value":"account_id"}}]}}]}}]} as unknown as DocumentNode<AddFacilityPopup_InviteNewRecruiterMutation, AddFacilityPopup_InviteNewRecruiterMutationVariables>;
export const AddFacilityPopup_RequestFacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddFacilityPopup_RequestFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recruiterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update"},"name":{"kind":"Name","value":"update_facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"change_request"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_at"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_by_id"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"recruiter_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recruiterId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"change_request"}},{"kind":"Field","name":{"kind":"Name","value":"recruiter_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"insert"},"name":{"kind":"Name","value":"insert_facility_contract_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recruiter_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recruiterId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"uq_facility_contract_facility_id_org_id"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"recruiter_id"},{"kind":"EnumValue","value":"change_request"},{"kind":"EnumValue","value":"change_requested_at"},{"kind":"EnumValue","value":"change_requested_by_id"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility_id"}},{"kind":"Field","name":{"kind":"Name","value":"recruiter_id"}},{"kind":"Field","name":{"kind":"Name","value":"change_request"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"org_id"}}]}}]}}]} as unknown as DocumentNode<AddFacilityPopup_RequestFacilityMutation, AddFacilityPopup_RequestFacilityMutationVariables>;
export const AddFacilityPopup_GetOrgAndRecruiterDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddFacilityPopup_GetOrgAndRecruiter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddFacilityPopup_Organization"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recruiter"},"name":{"kind":"Name","value":"org_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddFacilityPopup_Recruiter"}}]}}]}},...AddFacilityPopup_OrganizationFragmentDoc.definitions,...FacilityRecruiterForm_RecruiterFragmentDoc.definitions,...AddFacilityPopup_RecruiterFragmentDoc.definitions]} as unknown as DocumentNode<AddFacilityPopup_GetOrgAndRecruiterQuery, AddFacilityPopup_GetOrgAndRecruiterQueryVariables>;
export const FindFacility_SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindFacility_Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_facility_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending_or_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"pendingOrActive"},"name":{"kind":"Name","value":"pending_or_active"}},{"kind":"Field","alias":{"kind":"Name","value":"changeRequest"},"name":{"kind":"Name","value":"change_request"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"search_facility_by_prefix_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<FindFacility_SearchQuery, FindFacility_SearchQueryVariables>;
export const AddOrgUserPopup_InviteOrgUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddOrgUserPopup_InviteOrgUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteOrgUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invite_org_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AddOrgUserPopup_InviteOrgUserMutation, AddOrgUserPopup_InviteOrgUserMutationVariables>;
export const AllAddOnsPopup_ApplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AllAddOnsPopup_Apply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apply_to_jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"posting_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<AllAddOnsPopup_ApplyMutation, AllAddOnsPopup_ApplyMutationVariables>;
export const ApplyToJobPopup_ExistingBatchesAndCvDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApplyToJobPopup_ExistingBatchesAndCv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recruiterIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"jobAppBatches"},"name":{"kind":"Name","value":"job_application_batch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"candidate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"recruiter_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recruiterIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"recruiterId"},"name":{"kind":"Name","value":"recruiter_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clinician"},"name":{"kind":"Name","value":"clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileUpload_File"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"prevBatch"},"name":{"kind":"Name","value":"job_application_batch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"candidate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intro"}}]}}]}},...FileUpload_FileFragmentDoc.definitions]} as unknown as DocumentNode<ApplyToJobPopup_ExistingBatchesAndCvQuery, ApplyToJobPopup_ExistingBatchesAndCvQueryVariables>;
export const ApplyToJobPopup_ApplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyToJobPopup_Apply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intro"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apply_to_jobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"posting_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intro"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intro"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ApplyToJobPopup_ApplyMutation, ApplyToJobPopup_ApplyMutationVariables>;
export const ApplyToJobPopup_UploadCvDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyToJobPopup_UploadCv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cvId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clinicianId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cv_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cvId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cv"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FileUpload_File"}}]}}]}}]}},...FileUpload_FileFragmentDoc.definitions]} as unknown as DocumentNode<ApplyToJobPopup_UploadCvMutation, ApplyToJobPopup_UploadCvMutationVariables>;
export const ChangePostingStatusPopup_UpdateStatusDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePostingStatusPopup_UpdateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expirationDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_job_posting_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_modified"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expirationDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangePostingStatusPopup_Posting"}}]}}]}},...ChangePostingStatusPopup_PostingFragmentDoc.definitions]} as unknown as DocumentNode<ChangePostingStatusPopup_UpdateStatusMutation, ChangePostingStatusPopup_UpdateStatusMutationVariables>;
export const ConfirmEmailPopup_ConfirmedEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ConfirmEmailPopup_ConfirmedEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"current_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ci"},"name":{"kind":"Name","value":"contact_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedEmail"},"name":{"kind":"Name","value":"confirmed_email"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmationSentAt"},"name":{"kind":"Name","value":"confirmation_sent_at"}}]}}]}}]}}]} as unknown as DocumentNode<ConfirmEmailPopup_ConfirmedEmailSubscription, ConfirmEmailPopup_ConfirmedEmailSubscriptionVariables>;
export const ConfirmEmailPopup_ResendVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmEmailPopup_ResendVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"resend"},"name":{"kind":"Name","value":"resend_verification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ConfirmEmailPopup_ResendVerificationMutation, ConfirmEmailPopup_ResendVerificationMutationVariables>;
export const ResendVerification_ResendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerification_Resend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"resend"},"name":{"kind":"Name","value":"resend_verification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResendVerification_ResendMutation, ResendVerification_ResendMutationVariables>;
export const DeactivateOrgUserPopup_RecruiterContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeactivateOrgUserPopup_RecruiterContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"aggPendingOrActive"},"name":{"kind":"Name","value":"facility_contract_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"recruiter_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending_or_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggPendingRemoval"},"name":{"kind":"Name","value":"facility_contract_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"recruiter_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"change_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"REMOVAL","block":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateOrgUserPopup_RecruiterContractsQuery, DeactivateOrgUserPopup_RecruiterContractsQueryVariables>;
export const DeactivateOrgUserPopup_DeactivateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateOrgUserPopup_Deactivate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_access_info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<DeactivateOrgUserPopup_DeactivateMutation, DeactivateOrgUserPopup_DeactivateMutationVariables>;
export const EditEmployerProfilePopup_OrganizationProfileDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditEmployerProfilePopup_OrganizationProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditEmployerProfileForm_Organization"}}]}}]}},...EditEmployerProfileForm_OrganizationFragmentDoc.definitions]} as unknown as DocumentNode<EditEmployerProfilePopup_OrganizationProfileQuery, EditEmployerProfilePopup_OrganizationProfileQueryVariables>;
export const EditOrgUserPopup_UpdateOrgUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditOrgUserPopup_UpdateOrgUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_personal_info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<EditOrgUserPopup_UpdateOrgUserMutation, EditOrgUserPopup_UpdateOrgUserMutationVariables>;
export const UpdateOrgUserPopup_AddOrgAdminOrgUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrgUserPopup_AddOrgAdminOrgUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"role"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_account_role_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"account_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrgUserPopup_AddOrgAdminOrgUserMutation, UpdateOrgUserPopup_AddOrgAdminOrgUserMutationVariables>;
export const UpdateOrgUserPopup_RemoveOrgAdminOrgUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrgUserPopup_RemoveOrgAdminOrgUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_account_role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgUserId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ORG_ADMIN","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrgUserPopup_RemoveOrgAdminOrgUserMutation, UpdateOrgUserPopup_RemoveOrgAdminOrgUserMutationVariables>;
export const EditRecruiterPopup_InviteNewRecruiterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditRecruiterPopup_InviteNewRecruiter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteOrgUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invite"},"name":{"kind":"Name","value":"invite_org_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","alias":{"kind":"Name","value":"accountId"},"name":{"kind":"Name","value":"account_id"}}]}}]}}]} as unknown as DocumentNode<EditRecruiterPopup_InviteNewRecruiterMutation, EditRecruiterPopup_InviteNewRecruiterMutationVariables>;
export const EditRecruiterPopup_UpdateBatchRecruiterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditRecruiterPopup_UpdateBatchRecruiter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recruiterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contracts"},"name":{"kind":"Name","value":"update_facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"recruiter_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recruiterId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EditRecruiterPopup_UpdateBatchRecruiterMutation, EditRecruiterPopup_UpdateBatchRecruiterMutationVariables>;
export const EmployerList_SearchEmployersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmployerList_SearchEmployers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"search_org_market_result_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_org_market"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"market"},"name":{"kind":"Name","value":"org_market"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployerCard_EmployerInfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployerTable_EmployerInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"search_org_market_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...EmployerCard_EmployerInfoFragmentDoc.definitions,...EmployerTable_EmployerInfoFragmentDoc.definitions]} as unknown as DocumentNode<EmployerList_SearchEmployersQuery, EmployerList_SearchEmployersQueryVariables>;
export const FacilitySearchInput_SearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilitySearchInput_Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFacilities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOrgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeResidencies"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeClerkships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFellowships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facilities"},"name":{"kind":"Name","value":"search_facility_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFacilities"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgs"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOrgs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"residencies"},"name":{"kind":"Name","value":"search_training_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"RESIDENCY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeResidencies"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkships"},"name":{"kind":"Name","value":"search_training_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CLERKSHIP","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeClerkships"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowships"},"name":{"kind":"Name","value":"search_training_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"FELLOWSHIP","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFellowships"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FacilitySearchInput_SearchQuery, FacilitySearchInput_SearchQueryVariables>;
export const FacilitySearchInput_GmapLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilitySearchInput_GmapLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gmapsLink"},"name":{"kind":"Name","value":"gmaps_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gmaps_place_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"viewport"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"center"}},{"kind":"Field","alias":{"kind":"Name","value":"gmapsPlace"},"name":{"kind":"Name","value":"gmaps_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"geocodePublic"},"name":{"kind":"Name","value":"geocode_public"}},{"kind":"Field","alias":{"kind":"Name","value":"geocodeShortName"},"name":{"kind":"Name","value":"geocode_short_name"}},{"kind":"Field","name":{"kind":"Name","value":"boundaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"precision"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"LOW","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"gmaps_place"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geocode_public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"administrative_area_level_1","block":false}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FacilitySearchInput_GmapLinkQuery, FacilitySearchInput_GmapLinkQueryVariables>;
export const BaseMap_BoundaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BaseMap_Boundary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boundaryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boundary"},"name":{"kind":"Name","value":"place_boundary_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boundaryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"boundaryGeoJson"},"name":{"kind":"Name","value":"boundary_geojson"}}]}}]}}]} as unknown as DocumentNode<BaseMap_BoundaryQuery, BaseMap_BoundaryQueryVariables>;
export const Map_GmapLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GmapLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"gmapsLink"},"name":{"kind":"Name","value":"gmaps_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"gmapsPlaceId"},"name":{"kind":"Name","value":"gmaps_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"center"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"viewport"}},{"kind":"Field","alias":{"kind":"Name","value":"gmapsPlace"},"name":{"kind":"Name","value":"gmaps_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"geocodePublic"},"name":{"kind":"Name","value":"geocode_public"}},{"kind":"Field","alias":{"kind":"Name","value":"geocodeShortName"},"name":{"kind":"Name","value":"geocode_short_name"}},{"kind":"Field","name":{"kind":"Name","value":"boundaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"precision"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"LOW","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"gmaps_place"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geocode_public"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"administrative_area_level_1","block":false}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Map_GmapLinkQuery, Map_GmapLinkQueryVariables>;
export const SearchInstructions_HideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SearchInstructions_Hide"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_current_account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hide_search_instructions"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hide_search_instructions"}}]}}]}}]}}]} as unknown as DocumentNode<SearchInstructions_HideMutation, SearchInstructions_HideMutationVariables>;
export const OnboardingPopup_CheckOrgSignupStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnboardingPopup_CheckOrgSignupStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sendVerification"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signupStatus"},"name":{"kind":"Name","value":"check_org_user_signup_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"org_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}},{"kind":"Argument","name":{"kind":"Name","value":"send_verification"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sendVerification"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}}]}}]}}]} as unknown as DocumentNode<OnboardingPopup_CheckOrgSignupStatusMutation, OnboardingPopup_CheckOrgSignupStatusMutationVariables>;
export const ProfileCompletePopup_ClinicianProfileDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileCompletePopup_ClinicianProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clinician"},"name":{"kind":"Name","value":"clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileCompleteForm_Clinician"}}]}}]}},...ProfileCompleteForm_ClinicianFragmentDoc.definitions,...ClinicianSearch_FsmbBioFragmentDoc.definitions]} as unknown as DocumentNode<ProfileCompletePopup_ClinicianProfileQuery, ProfileCompletePopup_ClinicianProfileQueryVariables>;
export const RemoveFacilityPopup_RequestContractDeactivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveFacilityPopup_RequestContractDeactivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updatePending"},"name":{"kind":"Name","value":"update_facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ADDITION","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"change_request"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_at"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_by_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"change_request"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"updateActive"},"name":{"kind":"Name","value":"update_facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"change_request"},"value":{"kind":"StringValue","value":"REMOVAL","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_by_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"change_request"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveFacilityPopup_RequestContractDeactivationMutation, RemoveFacilityPopup_RequestContractDeactivationMutationVariables>;
export const ReviewList_CreateReviewReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewList_CreateReviewReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_report_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_review_report_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReviewList_CreateReviewReportMutation, ReviewList_CreateReviewReportMutationVariables>;
export const ReviewList_SearchReviewDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReviewList_SearchReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isClinician"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reviews"},"name":{"kind":"Name","value":"review"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"orgId"},"name":{"kind":"Name","value":"org_id"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}},{"kind":"Field","alias":{"kind":"Name","value":"selfReview"},"name":{"kind":"Name","value":"self_review"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewCard_Review"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"review_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...ReviewCard_ReviewFragmentDoc.definitions]} as unknown as DocumentNode<ReviewList_SearchReviewQuery, ReviewList_SearchReviewQueryVariables>;
export const ReviewList_UpdateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewList_UpdateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_review_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<ReviewList_UpdateReviewMutation, ReviewList_UpdateReviewMutationVariables>;
export const ReviewList_CreateReviewVoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewList_CreateReviewVote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_review_vote_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"uq_review_vote_review_id_account_id"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"value"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReviewList_CreateReviewVoteMutation, ReviewList_CreateReviewVoteMutationVariables>;
export const ReviewList_DeleteReviewVoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewList_DeleteReviewVote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewVoteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_review_vote_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewVoteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReviewList_DeleteReviewVoteMutation, ReviewList_DeleteReviewVoteMutationVariables>;
export const ReviewList_CreateReviewReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewList_CreateReviewReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_reply_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_review_reply_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReviewList_CreateReviewReplyMutation, ReviewList_CreateReviewReplyMutationVariables>;
export const ReviewList_DeleteReviewReplyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReviewList_DeleteReviewReply"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_review_reply_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReviewList_DeleteReviewReplyMutation, ReviewList_DeleteReviewReplyMutationVariables>;
export const SalaryList_SearchSalaryReportsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SalaryList_SearchSalaryReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"relevant_salary_report_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"relevant_salary_report_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"relevantSalaryReports"},"name":{"kind":"Name","value":"search_relevant_salary_report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"salaryReport"},"name":{"kind":"Name","value":"salary_report_fmt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryCard_SalaryReportInfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryTable_SalaryReportInfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportDetail_SalaryReportInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"search_relevant_salary_report_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...SalaryCard_SalaryReportInfoFragmentDoc.definitions,...SalaryTable_SalaryReportInfoFragmentDoc.definitions,...ReportDetail_SalaryReportInfoFragmentDoc.definitions]} as unknown as DocumentNode<SalaryList_SearchSalaryReportsQuery, SalaryList_SearchSalaryReportsQueryVariables>;
export const SalaryReportPopup_CreatedSalaryReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SalaryReportPopup_CreatedSalaryReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"salary_report_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_salary_report_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SalaryReportPopup_CreatedSalaryReportMutation, SalaryReportPopup_CreatedSalaryReportMutationVariables>;
export const TrainingFeatured_FeaturedResidencyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingFeatured_FeaturedResidency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredResidency"},"name":{"kind":"Name","value":"featured_residency_dist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingFeatured_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...TrainingFeatured_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<TrainingFeatured_FeaturedResidencyQuery, TrainingFeatured_FeaturedResidencyQueryVariables>;
export const TrainingFeatured_FeaturedClerkshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingFeatured_FeaturedClerkship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredClerkship"},"name":{"kind":"Name","value":"featured_clerkship_dist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingFeatured_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...TrainingFeatured_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<TrainingFeatured_FeaturedClerkshipQuery, TrainingFeatured_FeaturedClerkshipQueryVariables>;
export const TrainingFeatured_FeaturedFellowshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingFeatured_FeaturedFellowship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredFellowship"},"name":{"kind":"Name","value":"featured_fellowship_dist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingFeatured_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...TrainingFeatured_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<TrainingFeatured_FeaturedFellowshipQuery, TrainingFeatured_FeaturedFellowshipQueryVariables>;
export const AbProvider_PickAbTestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ABProvider_PickABTests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"abTests"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ab_test_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_ab_test"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"abTests"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"uq_ab_test_account_id_test"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"group"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"currentAccount"},"name":{"kind":"Name","value":"current_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"abTests"},"name":{"kind":"Name","value":"ab_tests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"test"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AbProvider_PickAbTestsMutation, AbProvider_PickAbTestsMutationVariables>;
export const UseBannerAd_CreateAdAuctionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UseBannerAd_CreateAdAuction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAdAuctionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAdAuction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"winners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedBidId"}},{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UseBannerAd_CreateAdAuctionMutation, UseBannerAd_CreateAdAuctionMutationVariables>;
export const AuthProvider_CurrentAccountRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AuthProvider_CurrentAccountRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentAccount"},"name":{"kind":"Name","value":"current_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<AuthProvider_CurrentAccountRolesSubscription, AuthProvider_CurrentAccountRolesSubscriptionVariables>;
export const AuthProvider_CurrentAccountDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthProvider_CurrentAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isClinician"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOrgUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentAccount"},"name":{"kind":"Name","value":"current_account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"accessSalary"},"name":{"kind":"Name","value":"access_salary"}},{"kind":"Field","alias":{"kind":"Name","value":"ci"},"name":{"kind":"Name","value":"contact_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","alias":{"kind":"Name","value":"confirmedEmail"},"name":{"kind":"Name","value":"confirmed_email"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentAccountAvatar_CurrentAccount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgUser"},"name":{"kind":"Name","value":"org_user"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOrgUser"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clinician"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isClinician"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fid"}},{"kind":"Field","alias":{"kind":"Name","value":"profileComplete"},"name":{"kind":"Name","value":"profile_complete"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reportedSalary"},"name":{"kind":"Name","value":"reported_salary"}},{"kind":"Field","alias":{"kind":"Name","value":"profDegree"},"name":{"kind":"Name","value":"prof_degree"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}},{"kind":"Field","name":{"kind":"Name","value":"creds"}},{"kind":"Field","name":{"kind":"Name","value":"isAPP"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"isClinician"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"isOrgUser"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"superuser"}},{"kind":"Field","alias":{"kind":"Name","value":"hideSearchInstructions"},"name":{"kind":"Name","value":"hide_search_instructions"}},{"kind":"Field","alias":{"kind":"Name","value":"abTests"},"name":{"kind":"Name","value":"ab_tests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"test"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}},...CurrentAccountAvatar_CurrentAccountFragmentDoc.definitions]} as unknown as DocumentNode<AuthProvider_CurrentAccountQuery, AuthProvider_CurrentAccountQueryVariables>;
export const BillingProvider_GetSubscriptionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingProvider_GetSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"organization"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingProvider_Customer"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgAdmins"},"name":{"kind":"Name","value":"org_user_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"access_info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"roles"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ORG_ADMIN","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...BillingProvider_CustomerFragmentDoc.definitions,...BillingProvider_SubscriptionFragmentDoc.definitions]} as unknown as DocumentNode<BillingProvider_GetSubscriptionQuery, BillingProvider_GetSubscriptionQueryVariables>;
export const SettingsModal_UpdateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"settingsModal_UpdateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"platform"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emraFeaturedTrainingType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"trainingtype"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"platform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emra_featured_training_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emraFeaturedTrainingType"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SettingsModal_UpdateSiteMutation, SettingsModal_UpdateSiteMutationVariables>;
export const SiteSettingsProvider_SearchSiteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SiteSettingsProvider_SearchSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"platform"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"platform"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SiteSettingsProvider_Site"}}]}}]}},...SiteSettingsProvider_SiteFragmentDoc.definitions]} as unknown as DocumentNode<SiteSettingsProvider_SearchSiteQuery, SiteSettingsProvider_SearchSiteQueryVariables>;
export const OrgUserOnboardingTourDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OrgUserOnboardingTour"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_account_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_tour_completed"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OrgUserOnboardingTourMutation, OrgUserOnboardingTourMutationVariables>;
export const RefreshAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"refreshAuth"},"name":{"kind":"Name","value":"refresh_auth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"refresh_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accessToken"},"name":{"kind":"Name","value":"access_token"}}]}}]}}]} as unknown as DocumentNode<RefreshAuthMutation, RefreshAuthMutationVariables>;
export const OrgMenu_UnreadItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrgMenu_UnreadItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orgUser"},"name":{"kind":"Name","value":"org_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"numUnseenCandidates"},"name":{"kind":"Name","value":"num_unseen_candidates"}}]}}]}}]} as unknown as DocumentNode<OrgMenu_UnreadItemsSubscription, OrgMenu_UnreadItemsSubscriptionVariables>;
export const FavoritesShow_QueryFavoritesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavoritesShow_QueryFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"RESIDENCY","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"residency"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"FELLOWSHIP","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fellowship"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CLERKSHIP","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"clerkship"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoritesShow_Favorite"}}]}}]}},...FavoritesShow_FavoriteFragmentDoc.definitions]} as unknown as DocumentNode<FavoritesShow_QueryFavoritesQuery, FavoritesShow_QueryFavoritesQueryVariables>;
export const FavoritesShow_DeleteFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FavoritesShow_DeleteFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_favorite_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FavoritesShow_DeleteFavoriteMutation, FavoritesShow_DeleteFavoriteMutationVariables>;
export const SuppressionList_PreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuppressionList_Preferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"suppressions"},"name":{"kind":"Name","value":"email_suppressions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]} as unknown as DocumentNode<SuppressionList_PreferencesQuery, SuppressionList_PreferencesQueryVariables>;
export const SuppressionList_SavePreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SuppressionList_SavePreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_email_suppressions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SuppressionList_SavePreferencesMutation, SuppressionList_SavePreferencesMutationVariables>;
export const AcceptSurveyPopup_SearchOrgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AcceptSurveyPopup_SearchOrgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AcceptSurveyPopup_SearchOrgsQuery, AcceptSurveyPopup_SearchOrgsQueryVariables>;
export const AcceptSurveyPopup_CreateOrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptSurveyPopup_CreateOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"website"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"insert_organization_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"website"},"value":{"kind":"Variable","name":{"kind":"Name","value":"website"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AcceptSurveyPopup_CreateOrgMutation, AcceptSurveyPopup_CreateOrgMutationVariables>;
export const AcceptSurveyPopup_AcceptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptSurveyPopup_Accept"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accept_acep_org_survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"acep_org_survey_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"org_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acep_org_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accepted_at"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AcceptSurveyPopup_AcceptMutation, AcceptSurveyPopup_AcceptMutationVariables>;
export const AcepOrgSurveyList_SurveyTableDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AcepOrgSurveyList_SurveyTableData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"acep_org_survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcepOrgSurveyList_SurveyResult"}}]}}]}},...AcepOrgSurveyList_SurveyResultFragmentDoc.definitions,...AcceptSurveyPopup_SurveyFragmentDoc.definitions]} as unknown as DocumentNode<AcepOrgSurveyList_SurveyTableDataQuery, AcepOrgSurveyList_SurveyTableDataQueryVariables>;
export const AcepOrgSurvey_SearchOrgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ACEPOrgSurvey_SearchOrgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AcepOrgSurvey_SearchOrgsQuery, AcepOrgSurvey_SearchOrgsQueryVariables>;
export const AcepOrgSurvey_SubmitFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ACEPOrgSurvey_SubmitForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"acep_org_survey_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_acep_org_survey_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AcepOrgSurvey_SubmitFormMutation, AcepOrgSurvey_SubmitFormMutationVariables>;
export const AdminClinicianShow_ClinicianDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminClinicianShow_Clinician"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clinician"},"name":{"kind":"Name","value":"clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianProfile_Clinician"}}]}}]}},...ClinicianProfile_ClinicianFragmentDoc.definitions,...SkillsStep_ClinicianSkillsFragmentDoc.definitions,...ClinicianAvatar_ClinicianFragmentDoc.definitions]} as unknown as DocumentNode<AdminClinicianShow_ClinicianQuery, AdminClinicianShow_ClinicianQueryVariables>;
export const JobApplicationBatchNotesPopup_UpdateNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobApplicationBatchNotesPopup_UpdateNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"batchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_job_application_batch_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"batchId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<JobApplicationBatchNotesPopup_UpdateNotesMutation, JobApplicationBatchNotesPopup_UpdateNotesMutationVariables>;
export const FinalizeSignup_ConfirmEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeSignup_ConfirmEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"finalize"},"name":{"kind":"Name","value":"finalize_signup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"access"},"name":{"kind":"Name","value":"access_token"}},{"kind":"Field","alias":{"kind":"Name","value":"refresh"},"name":{"kind":"Name","value":"refresh_token"}}]}}]}}]} as unknown as DocumentNode<FinalizeSignup_ConfirmEmailMutation, FinalizeSignup_ConfirmEmailMutationVariables>;
export const CandidateList_SearchCandidatesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CandidateList_SearchCandidates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"search_candidate_result_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidateFilters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"search_candidate_result_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orgUser"},"name":{"kind":"Name","value":"org_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"lastViewedCandidates"},"name":{"kind":"Name","value":"last_viewed_candidates"}},{"kind":"Field","name":{"kind":"Name","value":"lastViewedCandidatesDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"search_candidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"candidate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CandidateTable_CandidateRows"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CandidateCard_Candidate"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"search_candidate_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"facilities"},"name":{"kind":"Name","value":"facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending_or_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},...CandidateTable_CandidateRowsFragmentDoc.definitions,...CandidateFacilitiesPopover_FacilityFragmentDoc.definitions,...CandidateCard_CandidateFragmentDoc.definitions,...ClinicianAvatar_ClinicianFragmentDoc.definitions]} as unknown as DocumentNode<CandidateList_SearchCandidatesQuery, CandidateList_SearchCandidatesQueryVariables>;
export const CandidateList_MarkAsViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CandidateList_MarkAsViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_org_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_viewed_candidates"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_viewed_candidates"}}]}}]}}]} as unknown as DocumentNode<CandidateList_MarkAsViewedMutation, CandidateList_MarkAsViewedMutationVariables>;
export const CandidateShow_CandidateQDocDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CandidateShow_CandidateQDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"candidateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"candidate"},"name":{"kind":"Name","value":"candidate_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"maskedEmail"},"name":{"kind":"Name","value":"masked_email"}},{"kind":"Field","name":{"kind":"Name","value":"clinician"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianProfile_Clinician"}},{"kind":"Field","name":{"kind":"Name","value":"creds"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobApps"},"name":{"kind":"Name","value":"job_application"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"batch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"candidate_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"candidateId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianProfile_JobApplication"}}]}}]}},...ClinicianProfile_ClinicianFragmentDoc.definitions,...SkillsStep_ClinicianSkillsFragmentDoc.definitions,...ClinicianAvatar_ClinicianFragmentDoc.definitions,...ClinicianProfile_JobApplicationFragmentDoc.definitions]} as unknown as DocumentNode<CandidateShow_CandidateQDocQuery, CandidateShow_CandidateQDocQueryVariables>;
export const ConnectionShowRedirect_CandidateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectionShowRedirect_Candidate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candidate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_application_batches"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectionId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ConnectionShowRedirect_CandidateQuery, ConnectionShowRedirect_CandidateQueryVariables>;
export const JobApplicationList_JobApplicationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobApplicationList_JobApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"jobApps"},"name":{"kind":"Name","value":"job_application"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"batch"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"candidate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clinician_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobApplicationListItem_JobApplication"}}]}}]}},...JobApplicationListItem_JobApplicationFragmentDoc.definitions]} as unknown as DocumentNode<JobApplicationList_JobApplicationsQuery, JobApplicationList_JobApplicationsQueryVariables>;
export const EditClinician_ClinicianDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditClinician_Clinician"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clinician"},"name":{"kind":"Name","value":"clinician_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClinicianProfile_Clinician"}}]}}]}},...ClinicianProfile_ClinicianFragmentDoc.definitions,...SkillsStep_ClinicianSkillsFragmentDoc.definitions,...ClinicianAvatar_ClinicianFragmentDoc.definitions]} as unknown as DocumentNode<EditClinician_ClinicianQuery, EditClinician_ClinicianQueryVariables>;
export const DataList_ContractsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataList_Contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contracts"},"name":{"kind":"Name","value":"facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","alias":{"kind":"Name","value":"freestandingEr"},"name":{"kind":"Name","value":"freestanding_er"}},{"kind":"Field","name":{"kind":"Name","value":"residencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cmsFacilityId"},"name":{"kind":"Name","value":"cms_facility_id"}},{"kind":"Field","alias":{"kind":"Name","value":"ahaFacilityId"},"name":{"kind":"Name","value":"aha_facility_22_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"ownershipStructure"},"name":{"kind":"Name","value":"ownership_structure"}}]}}]}}]}}]} as unknown as DocumentNode<DataList_ContractsQuery, DataList_ContractsQueryVariables>;
export const EmraProgramOverview_TrainingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraProgramOverview_Training"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"profession"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"training"},"name":{"kind":"Name","value":"training_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramFeatures_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramPrimarySite_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramSocials_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramGallery_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramTrainingSites_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewSalaryCta_TrainingSurvey"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramFeatures_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramPrimarySite_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramSocials_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramGallery_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramTrainingSites_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewSalaryCta_TrainingSurvey"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramFeatures_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramPrimarySite_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramSocials_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramGallery_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramTrainingSites_TrainingSurvey"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewSalaryCta_TrainingSurvey"}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramEvents_Training"}}]}}]}},...EmraProgramFeatures_TrainingSurveyFragmentDoc.definitions,...EmraProgramPrimarySite_TrainingSurveyFragmentDoc.definitions,...FacilityCard_FacilityFragmentDoc.definitions,...EmraProgramSocials_TrainingSurveyFragmentDoc.definitions,...ReviewSalaryCta_TrainingSurveyFragmentDoc.definitions,...EmraProgramGallery_TrainingSurveyFragmentDoc.definitions,...EmraProgramTrainingSites_TrainingSurveyFragmentDoc.definitions,...EmraProgramEvents_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<EmraProgramOverview_TrainingQuery, EmraProgramOverview_TrainingQueryVariables>;
export const EmraProgramShow_TrainingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraProgramShow_Training"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"training"},"name":{"kind":"Name","value":"training_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isUser"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramShow_TrainingSurvey"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramShow_TrainingSurvey"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"featured"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraProgramShow_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...EmraProgramShow_TrainingSurveyFragmentDoc.definitions,...EmraProgramSocials_TrainingSurveyFragmentDoc.definitions,...ReviewSalaryCta_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<EmraProgramShow_TrainingQuery, EmraProgramShow_TrainingQueryVariables>;
export const EmraProgramShow_FavoriteProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmraProgramShow_FavoriteProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"constraint"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"favorite_constraint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favArgs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"favorite_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_favorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favArgs"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"Variable","name":{"kind":"Name","value":"constraint"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EmraProgramShow_FavoriteProgramMutation, EmraProgramShow_FavoriteProgramMutationVariables>;
export const EmraProgramShow_DeleteFavoriteProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmraProgramShow_DeleteFavoriteProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_favorite_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EmraProgramShow_DeleteFavoriteProgramMutation, EmraProgramShow_DeleteFavoriteProgramMutationVariables>;
export const Map_GeoSearchClerkshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GeoSearchClerkship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clerkship_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clerkship"},"name":{"kind":"Name","value":"search_clerkship_by_geography"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"x_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clerkship"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clerkship"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"featured"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...Map_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<Map_GeoSearchClerkshipQuery, Map_GeoSearchClerkshipQueryVariables>;
export const Map_GetClerkshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GetClerkship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clerkship"},"name":{"kind":"Name","value":"clerkship_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_TrainingSurvey"}}]}}]}}]}}]}}]}},...Map_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<Map_GetClerkshipQuery, Map_GetClerkshipQueryVariables>;
export const Map_GeoSearchFellowshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GeoSearchFellowship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fellowship_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fellowship"},"name":{"kind":"Name","value":"search_fellowship_by_geography"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"x_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fellowship"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fellowship"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"featured"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...Map_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<Map_GeoSearchFellowshipQuery, Map_GeoSearchFellowshipQueryVariables>;
export const Map_GetFellowshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GetFellowship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fellowship"},"name":{"kind":"Name","value":"fellowship_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_TrainingSurvey"}}]}}]}}]}}]}}]}},...Map_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<Map_GetFellowshipQuery, Map_GetFellowshipQueryVariables>;
export const Map_GeoSearchResidencyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GeoSearchResidency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"residency_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"residency"},"name":{"kind":"Name","value":"search_residency_by_geography"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"x_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"residency"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"residency"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"featured"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_TrainingSurvey"}}]}}]}}]}}]}}]}}]}},...Map_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<Map_GeoSearchResidencyQuery, Map_GeoSearchResidencyQueryVariables>;
export const Map_GetResidencyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GetResidency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"residency"},"name":{"kind":"Name","value":"residency_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emrafied"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_TrainingSurvey"}}]}}]}}]}}]}}]}},...Map_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<Map_GetResidencyQuery, Map_GetResidencyQueryVariables>;
export const EmraAdmin_TabAggDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraAdmin_TabAgg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"residency"},"name":{"kind":"Name","value":"residency_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clerkship"},"name":{"kind":"Name","value":"clerkship_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fellowship"},"name":{"kind":"Name","value":"fellowship_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"newSurvey"},"name":{"kind":"Name","value":"training_survey_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<EmraAdmin_TabAggQuery, EmraAdmin_TabAggQueryVariables>;
export const EmraAdmin_DeactivateTrainingProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmraAdmin_DeactivateTrainingProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_training_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EmraAdmin_DeactivateTrainingProgramMutation, EmraAdmin_DeactivateTrainingProgramMutationVariables>;
export const EmraAdmin_ClerkshipTableDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraAdmin_ClerkshipTableData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"clerkship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_ClerkshipSurvey"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_TrainingSurvey"}}]}}]}}]}}]}}]}},...EmraAdmin_ClerkshipSurveyFragmentDoc.definitions,...EmraAdmin_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<EmraAdmin_ClerkshipTableDataQuery, EmraAdmin_ClerkshipTableDataQueryVariables>;
export const EmraAdmin_FellowshipTableDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraAdmin_FellowshipTableData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"fellowship"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_FellowshipSurvey"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_TrainingSurvey"}}]}}]}}]}}]}}]}},...EmraAdmin_FellowshipSurveyFragmentDoc.definitions,...EmraAdmin_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<EmraAdmin_FellowshipTableDataQuery, EmraAdmin_FellowshipTableDataQueryVariables>;
export const EmraAdmin_NewSurveyTrainingSurveyTableDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraAdmin_NewSurveyTrainingSurveyTableData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"training_survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_NewSurveyTrainingSurvey"}}]}}]}},...EmraAdmin_NewSurveyTrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<EmraAdmin_NewSurveyTrainingSurveyTableDataQuery, EmraAdmin_NewSurveyTrainingSurveyTableDataQueryVariables>;
export const EmraAdmin_UpdateSurveyStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EmraAdmin_UpdateSurveyStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrainingSurveyStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_training_survey_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"training_survey_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<EmraAdmin_UpdateSurveyStatusMutation, EmraAdmin_UpdateSurveyStatusMutationVariables>;
export const EmraAdmin_OldSurveyTrainingSurveyTableDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraAdmin_OldSurveyTrainingSurveyTableData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"training_survey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_OldSurveyTrainingSurvey"}}]}}]}},...EmraAdmin_OldSurveyTrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<EmraAdmin_OldSurveyTrainingSurveyTableDataQuery, EmraAdmin_OldSurveyTrainingSurveyTableDataQueryVariables>;
export const EmraAdmin_ResidencyTableDataDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraAdmin_ResidencyTableData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"residency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_ResidencySurvey"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmraAdmin_TrainingSurvey"}}]}}]}}]}}]}}]}},...EmraAdmin_ResidencySurveyFragmentDoc.definitions,...EmraAdmin_TrainingSurveyFragmentDoc.definitions]} as unknown as DocumentNode<EmraAdmin_ResidencyTableDataQuery, EmraAdmin_ResidencyTableDataQueryVariables>;
export const EmraClerkshipEdit_ClerkshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraClerkshipEdit_Clerkship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"program"},"name":{"kind":"Name","value":"clerkship_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClerkshipForm_Clerkship"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClerkshipForm_ClerkshipSurvey"}}]}}]}}]}}]}},...ClerkshipForm_ClerkshipFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingFragmentDoc.definitions,...TrainingAdminForm_TrainingFragmentDoc.definitions,...ClerkshipForm_ClerkshipSurveyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingSurveyFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...FileUpload_FileFragmentDoc.definitions,...TrainingSelect_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<EmraClerkshipEdit_ClerkshipQuery, EmraClerkshipEdit_ClerkshipQueryVariables>;
export const EmraClerkshipSurveyShow_ClerkshipSurveyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraClerkshipSurveyShow_ClerkshipSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"survey"},"name":{"kind":"Name","value":"clerkship_survey_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClerkshipForm_ClerkshipSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"clerkship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClerkshipForm_ClerkshipSurvey"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClerkshipForm_Clerkship"}}]}}]}}]}},...ClerkshipForm_ClerkshipSurveyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingSurveyFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...FileUpload_FileFragmentDoc.definitions,...TrainingSelect_TrainingFragmentDoc.definitions,...ClerkshipForm_ClerkshipFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingFragmentDoc.definitions,...TrainingAdminForm_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<EmraClerkshipSurveyShow_ClerkshipSurveyQuery, EmraClerkshipSurveyShow_ClerkshipSurveyQueryVariables>;
export const ClerkshipForm_SubmitSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClerkshipForm_SubmitSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"clerkship_survey_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"survey"},"name":{"kind":"Name","value":"insert_clerkship_survey_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClerkshipForm_SubmitSurveyMutation, ClerkshipForm_SubmitSurveyMutationVariables>;
export const FellowshipForm_SubmitSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FellowshipForm_SubmitSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fellowship_survey_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"survey"},"name":{"kind":"Name","value":"insert_fellowship_survey_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FellowshipForm_SubmitSurveyMutation, FellowshipForm_SubmitSurveyMutationVariables>;
export const ResidencyForm_SubmitSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResidencyForm_SubmitSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"residency_survey_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"survey"},"name":{"kind":"Name","value":"insert_residency_survey_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ResidencyForm_SubmitSurveyMutation, ResidencyForm_SubmitSurveyMutationVariables>;
export const TrainingAdminForm_AcceptSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrainingAdminForm_AcceptSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"featured"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emrafied"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pdInterview"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"upcomingEvents"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTrainingSurveyStatusEventInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emraAccountNo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_training_survey_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"training_survey_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACCEPTED"}},{"kind":"Argument","name":{"kind":"Name","value":"featured"},"value":{"kind":"Variable","name":{"kind":"Name","value":"featured"}}},{"kind":"Argument","name":{"kind":"Name","value":"emrafied"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emrafied"}}},{"kind":"Argument","name":{"kind":"Name","value":"pd_interview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pdInterview"}}},{"kind":"Argument","name":{"kind":"Name","value":"upcoming_events"},"value":{"kind":"Variable","name":{"kind":"Name","value":"upcomingEvents"}}},{"kind":"Argument","name":{"kind":"Name","value":"emra_account_no"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emraAccountNo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TrainingAdminForm_AcceptSurveyMutation, TrainingAdminForm_AcceptSurveyMutationVariables>;
export const TrainingSelect_SearchTrainingsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrainingSelect_SearchTrainings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"trainingtype"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_training_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"training"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TrainingSelect_Training"}}]}}]}}]}},...TrainingSelect_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<TrainingSelect_SearchTrainingsQuery, TrainingSelect_SearchTrainingsQueryVariables>;
export const EmraFellowshipEdit_FellowshipDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraFellowshipEdit_Fellowship"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"program"},"name":{"kind":"Name","value":"fellowship_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FellowshipForm_Fellowship"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FellowshipForm_FellowshipSurvey"}}]}}]}}]}}]}},...FellowshipForm_FellowshipFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingFragmentDoc.definitions,...TrainingAdminForm_TrainingFragmentDoc.definitions,...FellowshipForm_FellowshipSurveyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingSurveyFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...FileUpload_FileFragmentDoc.definitions,...TrainingSelect_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<EmraFellowshipEdit_FellowshipQuery, EmraFellowshipEdit_FellowshipQueryVariables>;
export const EmraFellowshipSurveyShow_FellowshipSurveyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraFellowshipSurveyShow_FellowshipSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"survey"},"name":{"kind":"Name","value":"fellowship_survey_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FellowshipForm_FellowshipSurvey"}},{"kind":"Field","name":{"kind":"Name","value":"fellowship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FellowshipForm_FellowshipSurvey"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FellowshipForm_Fellowship"}}]}}]}}]}},...FellowshipForm_FellowshipSurveyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingSurveyFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...FileUpload_FileFragmentDoc.definitions,...TrainingSelect_TrainingFragmentDoc.definitions,...FellowshipForm_FellowshipFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingFragmentDoc.definitions,...TrainingAdminForm_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<EmraFellowshipSurveyShow_FellowshipSurveyQuery, EmraFellowshipSurveyShow_FellowshipSurveyQueryVariables>;
export const EmraResidencyEdit_ResidencyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraResidencyEdit_Residency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"program"},"name":{"kind":"Name","value":"residency_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trainingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResidencyForm_Residency"}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResidencyForm_ResidencySurvey"}}]}}]}}]}}]}},...ResidencyForm_ResidencyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingFragmentDoc.definitions,...TrainingAdminForm_TrainingFragmentDoc.definitions,...ResidencyForm_ResidencySurveyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingSurveyFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...FileUpload_FileFragmentDoc.definitions]} as unknown as DocumentNode<EmraResidencyEdit_ResidencyQuery, EmraResidencyEdit_ResidencyQueryVariables>;
export const EmraResidencySurveyShow_ResidencySurveyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmraResidencySurveyShow_ResidencySurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"survey"},"name":{"kind":"Name","value":"residency_survey_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"trainingSurvey"},"name":{"kind":"Name","value":"training_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResidencyForm_ResidencySurvey"}},{"kind":"Field","name":{"kind":"Name","value":"residency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"training"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestSurvey"},"name":{"kind":"Name","value":"latest_survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResidencyForm_ResidencySurvey"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResidencyForm_Residency"}}]}}]}}]}},...ResidencyForm_ResidencySurveyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingSurveyFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...FileUpload_FileFragmentDoc.definitions,...ResidencyForm_ResidencyFragmentDoc.definitions,...TrainingGeneralInfoForm_TrainingFragmentDoc.definitions,...TrainingAdminForm_TrainingFragmentDoc.definitions]} as unknown as DocumentNode<EmraResidencySurveyShow_ResidencySurveyQuery, EmraResidencySurveyShow_ResidencySurveyQueryVariables>;
export const Map_GeoSearchRankedFacilitiesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GeoSearchRankedFacilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"facility_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"profession"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeNearby"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"jobs"},"name":{"kind":"Name","value":"search_job_postings_by_geography"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"x_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"normalized_rate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"posting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Posting"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rankedFacilities"},"name":{"kind":"Name","value":"search_ranked_facilities_by_geography"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"x_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_active"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max_norm_rate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"has_posting"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"featured"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Facility"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nearbyFacilities"},"name":{"kind":"Name","value":"nearby_facilities_by_geography"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"x_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"xMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMin"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"yMax"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"radius"},"value":{"kind":"IntValue","value":"321868"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeNearby"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_NearbyFacility"}}]}}]}},...Map_PostingFragmentDoc.definitions,...ApplyToJobPopup_PostingFragmentDoc.definitions,...Map_ContractFragmentDoc.definitions,...ApplyToJobPopup_ContractFragmentDoc.definitions,...Map_FacilityFragmentDoc.definitions,...Map_NearbyFacilityFragmentDoc.definitions]} as unknown as DocumentNode<Map_GeoSearchRankedFacilitiesQuery, Map_GeoSearchRankedFacilitiesQueryVariables>;
export const Map_GetFacilityDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Map_GetFacility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"profession"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facility"},"name":{"kind":"Name","value":"facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map_Facility"}}]}}]}},...Map_FacilityFragmentDoc.definitions,...Map_ContractFragmentDoc.definitions,...ApplyToJobPopup_ContractFragmentDoc.definitions]} as unknown as DocumentNode<Map_GetFacilityQuery, Map_GetFacilityQueryVariables>;
export const FacilityJobs_FacilityDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityJobs_Facility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facility"},"name":{"kind":"Name","value":"facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobButton_Contract"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityJobs_Facility"}}]}}]}},...ApplyToJobButton_ContractFragmentDoc.definitions,...ApplyToJobPopup_ContractFragmentDoc.definitions,...FacilityJobs_FacilityFragmentDoc.definitions]} as unknown as DocumentNode<FacilityJobs_FacilityQuery, FacilityJobs_FacilityQueryVariables>;
export const FacilityNearby_RankedFacilitiesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityNearby_RankedFacilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"profession"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"radius"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rankedFacilities"},"name":{"kind":"Name","value":"suggest_ranked_facilities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"prof"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"radius_m"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radius"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max_norm_rate"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"has_posting"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"featured"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilitySuggestions_RankedFacility"}}]}}]}},...FacilitySuggestions_RankedFacilityFragmentDoc.definitions,...FacilityCard_FacilityFragmentDoc.definitions]} as unknown as DocumentNode<FacilityNearby_RankedFacilitiesQuery, FacilityNearby_RankedFacilitiesQueryVariables>;
export const FacilityProfile_FacilityDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityProfile_Facility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOrgUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facility"},"name":{"kind":"Name","value":"facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployerInfo_Contract"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployerListPopover_Contract"}},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}},{"kind":"Field","alias":{"kind":"Name","value":"contractChanges"},"name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"change_request"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_contract_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"change_requested_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOrgUser"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"changeRequest"},"name":{"kind":"Name","value":"change_request"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityNearby_Facility"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityFeatures_Facility"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityDescription_Facility"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilityGallery_Facility"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CorrectionToast_Facility"}}]}}]}},...EmployerInfo_ContractFragmentDoc.definitions,...AccountAvatar_AccountFragmentDoc.definitions,...EditRecruiterPopup_ContractFragmentDoc.definitions,...ApplyToJobButton_ContractFragmentDoc.definitions,...ApplyToJobPopup_ContractFragmentDoc.definitions,...EmployerListPopover_ContractFragmentDoc.definitions,...FacilityNearby_FacilityFragmentDoc.definitions,...FacilityFeatures_FacilityFragmentDoc.definitions,...ReportCorrection_FacilityFragmentDoc.definitions,...FacilityDescription_FacilityFragmentDoc.definitions,...FacilityGallery_FacilityFragmentDoc.definitions,...CorrectionToast_FacilityFragmentDoc.definitions]} as unknown as DocumentNode<FacilityProfile_FacilityQuery, FacilityProfile_FacilityQueryVariables>;
export const ReportCorrection_SearchOrgsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportCorrection_SearchOrgs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"search"},"name":{"kind":"Name","value":"search_organization_by_prefix"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rank"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ReportCorrection_SearchOrgsQuery, ReportCorrection_SearchOrgsQueryVariables>;
export const ReportCorrection_SubmitCorrectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportCorrection_SubmitCorrection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"facility_correction_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_facility_correction_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReportCorrection_SubmitCorrectionMutation, ReportCorrection_SubmitCorrectionMutationVariables>;
export const FacilityEditForms_UpdateDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FacilityEditForms_UpdateDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FacilityEditForms_UpdateDescriptionMutation, FacilityEditForms_UpdateDescriptionMutationVariables>;
export const FacilityGalleryForm_UpdateGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FacilityGalleryForm_UpdateGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"change_facility_picture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pictureId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FacilityGalleryForm_UpdateGalleryMutation, FacilityGalleryForm_UpdateGalleryMutationVariables>;
export const FacilityReviews_FacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityReviews_Facility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facility"},"name":{"kind":"Name","value":"facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_active_contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rating"},"name":{"kind":"Name","value":"rating_job"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ratings"},"name":{"kind":"Name","value":"facility_ratings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"rating_job"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}}]}}]}}]}}]} as unknown as DocumentNode<FacilityReviews_FacilityQuery, FacilityReviews_FacilityQueryVariables>;
export const FacilitySalary_FacilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilitySalary_Facility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facility"},"name":{"kind":"Name","value":"facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FacilitySalary_FacilityQuery, FacilitySalary_FacilityQueryVariables>;
export const FacilityShow_FacilityDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityShow_Facility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facility"},"name":{"kind":"Name","value":"facility_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facilityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddr1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddr2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmployerListPopover_Contract"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobButton_Contract"}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewPopup_Organization"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewsAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_active_contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rating"},"name":{"kind":"Name","value":"rating_job"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"postings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"professionsCt"},"name":{"kind":"Name","value":"professions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"salaryAgg"},"name":{"kind":"Name","value":"salary_reports_fmt_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryReportPopup_Facility"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewPopup_Facility"}}]}}]}},...EmployerListPopover_ContractFragmentDoc.definitions,...ApplyToJobButton_ContractFragmentDoc.definitions,...ApplyToJobPopup_ContractFragmentDoc.definitions,...ReviewPopup_OrganizationFragmentDoc.definitions,...SalaryReportPopup_FacilityFragmentDoc.definitions,...SalaryReportFormGeneralStep_FacilityFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...SalaryReportFormGeneralStep_OrganizationFragmentDoc.definitions,...ReviewPopup_FacilityFragmentDoc.definitions]} as unknown as DocumentNode<FacilityShow_FacilityQuery, FacilityShow_FacilityQueryVariables>;
export const JobPostingCreate_ResolveContractDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPostingCreate_ResolveContract"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contract"},"name":{"kind":"Name","value":"facility_contract_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFormGeneralInfo_Contract"}}]}}]}},...JobPostingFormGeneralInfo_ContractFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...EditRecruiterPopup_ContractFragmentDoc.definitions]} as unknown as DocumentNode<JobPostingCreate_ResolveContractQuery, JobPostingCreate_ResolveContractQueryVariables>;
export const JobPostingCreate_CreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobPostingCreate_Create"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"posting"},"name":{"kind":"Name","value":"insert_job_posting_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<JobPostingCreate_CreateMutation, JobPostingCreate_CreateMutationVariables>;
export const JobPostingEdit_GetPostingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPostingEdit_GetPosting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"posting"},"name":{"kind":"Name","value":"job_posting_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingForm_Posting"}}]}}]}},...JobPostingForm_PostingFragmentDoc.definitions,...JobPostingFormGeneralInfo_PostingFragmentDoc.definitions,...JobPostingFormGeneralInfo_ContractFragmentDoc.definitions,...FacilitySelect_FacilityFragmentDoc.definitions,...EditRecruiterPopup_ContractFragmentDoc.definitions,...JobPostingFormCompensation_PostingFragmentDoc.definitions,...JobPostingFormQualifications_PostingFragmentDoc.definitions,...JobPostingFormAdditional_PostingFragmentDoc.definitions]} as unknown as DocumentNode<JobPostingEdit_GetPostingQuery, JobPostingEdit_GetPostingQueryVariables>;
export const JobPostingEdit_UpdatePostingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobPostingEdit_UpdatePosting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"posting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"job_posting_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workerClassifications"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"posting_worker_classification_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"posting_profession_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appCerts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"posting_app_cert_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardCerts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"posting_board_cert_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"posting"},"name":{"kind":"Name","value":"update_job_posting_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"posting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_posting_profession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"posting_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_posting_app_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"posting_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_posting_board_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"posting_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_posting_worker_classification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"posting_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_posting_profession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_posting_app_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appCerts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_posting_board_cert"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardCerts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_posting_worker_classification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workerClassifications"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<JobPostingEdit_UpdatePostingMutation, JobPostingEdit_UpdatePostingMutationVariables>;
export const JobPostingShow_ViewJobPostingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPostingShow_ViewJobPosting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profession"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"profession"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isOrgUser"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"posting"},"name":{"kind":"Name","value":"job_posting_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"expirationDate"},"name":{"kind":"Name","value":"expiration_date"}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profession"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"modifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastModified"},"name":{"kind":"Name","value":"last_modified"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"isOwner"},"name":{"kind":"Name","value":"is_contract_owner"}},{"kind":"Field","alias":{"kind":"Name","value":"lastApplied"},"name":{"kind":"Name","value":"last_applied"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppliedDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","alias":{"kind":"Name","value":"changeRequest"},"name":{"kind":"Name","value":"change_request"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isOrgUser"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"org"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobButton_Contract"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingStructuredData_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingQualifications_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingDetails_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingDescription_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ApplyToJobPopup_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingEmployer_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingFacility_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingOverview_Posting"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangePostingStatusPopup_Posting"}}]}}]}},...ApplyToJobButton_ContractFragmentDoc.definitions,...ApplyToJobPopup_ContractFragmentDoc.definitions,...JobPostingStructuredData_PostingFragmentDoc.definitions,...JobPostingQualifications_PostingFragmentDoc.definitions,...JobPostingDetails_PostingFragmentDoc.definitions,...JobPostingDescription_PostingFragmentDoc.definitions,...ApplyToJobPopup_PostingFragmentDoc.definitions,...JobPostingEmployer_PostingFragmentDoc.definitions,...EmployerInfo_ContractFragmentDoc.definitions,...AccountAvatar_AccountFragmentDoc.definitions,...EditRecruiterPopup_ContractFragmentDoc.definitions,...JobPostingFacility_PostingFragmentDoc.definitions,...FacilityCard_FacilityFragmentDoc.definitions,...JobPostingOverview_PostingFragmentDoc.definitions,...ChangePostingStatusPopup_PostingFragmentDoc.definitions]} as unknown as DocumentNode<JobPostingShow_ViewJobPostingQuery, JobPostingShow_ViewJobPostingQueryVariables>;
export const JobPostingList_SearchJobPostingsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JobPostingList_SearchJobPostings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"relevant_job_posting_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"relevant_job_posting_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateInPast"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expirationDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"relevantJobPostings"},"name":{"kind":"Name","value":"search_relevant_job_posting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"jobPosting"},"name":{"kind":"Name","value":"job_posting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingCard_JobPostingInfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"JobPostingTable_JobPostingInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"search_relevant_job_posting_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggActive"},"name":{"kind":"Name","value":"search_relevant_job_posting_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"StringValue","value":"","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggExpiringSoon"},"name":{"kind":"Name","value":"search_relevant_job_posting_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expirationDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"StringValue","value":"","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggInactive"},"name":{"kind":"Name","value":"search_relevant_job_posting_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"job_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"latest_publication"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unpublished_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateInPast"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"StringValue","value":"","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...JobPostingCard_JobPostingInfoFragmentDoc.definitions,...JobPostingTable_JobPostingInfoFragmentDoc.definitions]} as unknown as DocumentNode<JobPostingList_SearchJobPostingsQuery, JobPostingList_SearchJobPostingsQueryVariables>;
export const JobPostingList_BulkUpdateJobPostingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JobPostingList_BulkUpdateJobPosting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobPostingIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expirationDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_job_posting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobPostingIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_modified"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiration_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expirationDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<JobPostingList_BulkUpdateJobPostingMutation, JobPostingList_BulkUpdateJobPostingMutationVariables>;
export const FeaturedJobs_RankedFacilitiesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeaturedJobs_RankedFacilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profession"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"profession"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rankedFacilities"},"name":{"kind":"Name","value":"ranked_facility_dist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profession"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profession"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"has_posting"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FacilitySuggestions_RankedFacility"}}]}}]}},...FacilitySuggestions_RankedFacilityFragmentDoc.definitions,...FacilityCard_FacilityFragmentDoc.definitions]} as unknown as DocumentNode<FeaturedJobs_RankedFacilitiesQuery, FeaturedJobs_RankedFacilitiesQueryVariables>;
export const ForClinicians_FacilityCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForClinicians_FacilityCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fac"},"name":{"kind":"Name","value":"facility_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"salary"},"name":{"kind":"Name","value":"search_relevant_salary_report_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ForClinicians_FacilityCountQuery, ForClinicians_FacilityCountQueryVariables>;
export const ForEmployers_FacilityCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForEmployers_FacilityCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fac"},"name":{"kind":"Name","value":"facility_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"jobPostingPrices"},"name":{"kind":"Name","value":"get_payment_prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"tiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]} as unknown as DocumentNode<ForEmployers_FacilityCountQuery, ForEmployers_FacilityCountQueryVariables>;
export const StateImpressions_StateBoundaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StateImpressions_StateBoundary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boundary"},"name":{"kind":"Name","value":"place_boundary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"precision"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"LOW","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"boundary"}},{"kind":"Field","name":{"kind":"Name","value":"precision"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bq"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"info"},"name":{"kind":"Name","value":"analytics_facility_map_perf_90"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitors"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}}]}}]}}]}}]} as unknown as DocumentNode<StateImpressions_StateBoundaryQuery, StateImpressions_StateBoundaryQueryVariables>;
export const NearbyList_ProxDistanceDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NearbyList_ProxDistance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facRes"},"name":{"kind":"Name","value":"facility_dist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NearbyList_FacilityDistanceResult"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgRes"},"name":{"kind":"Name","value":"org_dist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NearbyList_OrganizationDistanceResult"}}]}}]}},...NearbyList_FacilityDistanceResultFragmentDoc.definitions,...NearbyList_OrganizationDistanceResultFragmentDoc.definitions]} as unknown as DocumentNode<NearbyList_ProxDistanceQuery, NearbyList_ProxDistanceQueryVariables>;
export const Review_ReviewDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Review_Review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredFacilities"},"name":{"kind":"Name","value":"facility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ranking_review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ranking_review"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeauredList_Facility"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredOrgs"},"name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ranking_review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ranking_review"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FeauredList_Organization"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"salaryAgg"},"name":{"kind":"Name","value":"salary_report_fmt_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},...FeauredList_FacilityFragmentDoc.definitions,...FeauredList_OrganizationFragmentDoc.definitions]} as unknown as DocumentNode<Review_ReviewQuery, Review_ReviewQueryVariables>;
export const CheckoutFlow_InfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckoutFlow_Info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"jobPostingPrices"},"name":{"kind":"Name","value":"get_payment_prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"tiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]} as unknown as DocumentNode<CheckoutFlow_InfoQuery, CheckoutFlow_InfoQueryVariables>;
export const CheckoutFlow_GetActiveJobPostingsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckoutFlow_GetActiveJobPostingsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"jobPosting"},"name":{"kind":"Name","value":"job_posting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"contract"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CheckoutFlow_GetActiveJobPostingsCountQuery, CheckoutFlow_GetActiveJobPostingsCountQueryVariables>;
export const FacilityTab_ManageContractsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FacilityTab_ManageContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"contracts"},"name":{"kind":"Name","value":"facility_contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pending_or_active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"city"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"facility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","alias":{"kind":"Name","value":"changeRequest"},"name":{"kind":"Name","value":"change_request"}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recruiter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"postings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_modified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"postingsAgg"},"name":{"kind":"Name","value":"postings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditRecruiterPopup_Contract"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"orgUser"},"name":{"kind":"Name","value":"org_user_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddFacilityPopup_Recruiter"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddFacilityPopup_Organization"}}]}}]}},...EditRecruiterPopup_ContractFragmentDoc.definitions,...AddFacilityPopup_RecruiterFragmentDoc.definitions,...FacilityRecruiterForm_RecruiterFragmentDoc.definitions,...AddFacilityPopup_OrganizationFragmentDoc.definitions]} as unknown as DocumentNode<FacilityTab_ManageContractsQuery, FacilityTab_ManageContractsQueryVariables>;
export const BillingView_UpsertCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BillingView_UpsertCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"upsertCustomer"},"name":{"kind":"Name","value":"upsert_customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customer_details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerDetails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BillingView_UpsertCustomerMutation, BillingView_UpsertCustomerMutationVariables>;
export const InvoicesView_GetInvoicesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoicesView_GetInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"organization"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"open"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","alias":{"kind":"Name","value":"downloadLink"},"name":{"kind":"Name","value":"download_link"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hasMore"},"name":{"kind":"Name","value":"has_more"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoicesView_InvoicesData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","alias":{"kind":"Name","value":"downloadLink"},"name":{"kind":"Name","value":"download_link"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"hasMore"},"name":{"kind":"Name","value":"has_more"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoicesView_InvoicesData"}}]}}]}}]}}]}}]}},...InvoicesView_InvoicesDataFragmentDoc.definitions]} as unknown as DocumentNode<InvoicesView_GetInvoicesQuery, InvoicesView_GetInvoicesQueryVariables>;
export const PaymentView_CreateCustomerPaymentIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaymentView_CreateCustomerPaymentIntent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"intent"},"name":{"kind":"Name","value":"create_customer_payment_method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"clientSecret"},"name":{"kind":"Name","value":"client_secret"}},{"kind":"Field","alias":{"kind":"Name","value":"setupFutureUsage"},"name":{"kind":"Name","value":"setup_future_usage"}}]}}]}}]} as unknown as DocumentNode<PaymentView_CreateCustomerPaymentIntentMutation, PaymentView_CreateCustomerPaymentIntentMutationVariables>;
export const PaymentView_UpdateDefaultPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaymentView_UpdateDefaultPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateDefaultPayment"},"name":{"kind":"Name","value":"update_customer_default_payment_method"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PaymentView_UpdateDefaultPaymentMethodMutation, PaymentView_UpdateDefaultPaymentMethodMutationVariables>;
export const PaymentView_DeletePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PaymentView_DeletePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultPaymentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deletePayment"},"name":{"kind":"Name","value":"delete_customer_payment_method"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"payment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"default_payment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultPaymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PaymentView_DeletePaymentMethodMutation, PaymentView_DeletePaymentMethodMutationVariables>;
export const PlanView_CancelSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlanView_CancelSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"cancelSubscription"},"name":{"kind":"Name","value":"cancel_customer_subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PlanView_CancelSubscriptionMutation, PlanView_CancelSubscriptionMutationVariables>;
export const PlanView_DeleteSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlanView_DeleteSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deleteSubscription"},"name":{"kind":"Name","value":"delete_customer_subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PlanView_DeleteSubscriptionMutation, PlanView_DeleteSubscriptionMutationVariables>;
export const PlanView_ReactivateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlanView_ReactivateSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reactivateSubscription"},"name":{"kind":"Name","value":"reactivate_customer_subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PlanView_ReactivateSubscriptionMutation, PlanView_ReactivateSubscriptionMutationVariables>;
export const TeamTab_ListOrgUsersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamTab_ListOrgUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"orgUsers"},"name":{"kind":"Name","value":"org_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"org_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"access_info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personal_info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"account"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"personal_info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"ci"},"name":{"kind":"Name","value":"contact_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pi"},"name":{"kind":"Name","value":"personal_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"firstName"},"name":{"kind":"Name","value":"first_name"}},{"kind":"Field","alias":{"kind":"Name","value":"lastName"},"name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"fullName"},"name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ai"},"name":{"kind":"Name","value":"access_info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"lastAccess"},"name":{"kind":"Name","value":"last_access"}},{"kind":"Field","name":{"kind":"Name","value":"lastAccessDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DeactivateOrgUserPopup_OrgUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditOrgUserPopup_OrgUser"}}]}}]}},...DeactivateOrgUserPopup_OrgUserFragmentDoc.definitions,...EditOrgUserPopup_OrgUserFragmentDoc.definitions]} as unknown as DocumentNode<TeamTab_ListOrgUsersQuery, TeamTab_ListOrgUsersQueryVariables>;
export const OrgFacilityList_OrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgFacilityList_Org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bounds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"xMin"},"name":{"kind":"Name","value":"x_min"}},{"kind":"Field","alias":{"kind":"Name","value":"xMax"},"name":{"kind":"Name","value":"x_max"}},{"kind":"Field","alias":{"kind":"Name","value":"yMin"},"name":{"kind":"Name","value":"y_min"}},{"kind":"Field","alias":{"kind":"Name","value":"yMax"},"name":{"kind":"Name","value":"y_max"}}]}}]}}]}}]} as unknown as DocumentNode<OrgFacilityList_OrgQuery, OrgFacilityList_OrgQueryVariables>;
export const OrgProfile_OrgDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgProfile_Org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"professionsFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"profession_comparison_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgWhitelabelCta_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgAtAGlance_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgAbout_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgFacilities_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgJobs_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcepInfo_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcepCharacteristics_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcepOperations_Org"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcepPolicies_Org"}},{"kind":"Field","alias":{"kind":"Name","value":"surveys"},"name":{"kind":"Name","value":"acep_org_surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},...OrgWhitelabelCta_OrgFragmentDoc.definitions,...OrgAtAGlance_OrgFragmentDoc.definitions,...OrgAbout_OrgFragmentDoc.definitions,...OrgFacilities_OrgFragmentDoc.definitions,...OrgJobs_OrgFragmentDoc.definitions,...AcepInfo_OrgFragmentDoc.definitions,...AcepCharacteristics_OrgFragmentDoc.definitions,...AcepOperations_OrgFragmentDoc.definitions,...AcepPolicies_OrgFragmentDoc.definitions]} as unknown as DocumentNode<OrgProfile_OrgQuery, OrgProfile_OrgQueryVariables>;
export const OrgReviews_OrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgReviews_Org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rating"},"name":{"kind":"Name","value":"rating_org"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ratings"},"name":{"kind":"Name","value":"org_ratings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"rating_org"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrgReviews_OrgQuery, OrgReviews_OrgQueryVariables>;
export const OrgSalary_OrgDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgSalary_Org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OrgSalary_OrgQuery, OrgSalary_OrgQueryVariables>;
export const OrgShow_OrgDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrgShow_Org"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"org"},"name":{"kind":"Name","value":"organization_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicUrl"},"name":{"kind":"Name","value":"public_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress1"},"name":{"kind":"Name","value":"street_address_1"}},{"kind":"Field","alias":{"kind":"Name","value":"streetAddress2"},"name":{"kind":"Name","value":"street_address_2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","alias":{"kind":"Name","value":"contractsAgg"},"name":{"kind":"Name","value":"contracts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"surveys"},"name":{"kind":"Name","value":"acep_org_surveys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"orgName"},"name":{"kind":"Name","value":"org_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewsAgg"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"visible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rating"},"name":{"kind":"Name","value":"rating_org"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"salaryAgg"},"name":{"kind":"Name","value":"salary_reports_fmt_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalaryReportPopup_Organization"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewPopup_Organization"}}]}}]}},...SalaryReportPopup_OrganizationFragmentDoc.definitions,...SalaryReportFormGeneralStep_OrganizationFragmentDoc.definitions,...ReviewPopup_OrganizationFragmentDoc.definitions]} as unknown as DocumentNode<OrgShow_OrgQuery, OrgShow_OrgQueryVariables>;
export const SitemapShow_GmapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SitemapShow_Gmaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"gmaps_link_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gmaps_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"gmaps_link_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SitemapShow_GmapsQuery, SitemapShow_GmapsQueryVariables>;